
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire3c7f"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire3c7f"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("815Xb", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5d6308ff5c29fed1$export$2e2bcd8739ae039; });
function $5d6308ff5c29fed1$export$2e2bcd8739ae039() {
    $5d6308ff5c29fed1$export$2e2bcd8739ae039 = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $5d6308ff5c29fed1$export$2e2bcd8739ae039.apply(this, arguments);
}

});

parcelRegister("cQNHH", function(module, exports) {
"use strict";

module.exports = (parcelRequire("aYoms"));

});
parcelRegister("aYoms", function(module, exports) {

$parcel$export(module.exports, "Children", function () { return $7fd2679aed54cb23$export$dca3b0875bd9a954; }, function (v) { return $7fd2679aed54cb23$export$dca3b0875bd9a954 = v; });
$parcel$export(module.exports, "Component", function () { return $7fd2679aed54cb23$export$16fa2f45be04daa8; }, function (v) { return $7fd2679aed54cb23$export$16fa2f45be04daa8 = v; });
$parcel$export(module.exports, "Fragment", function () { return $7fd2679aed54cb23$export$ffb0004e005737fa; }, function (v) { return $7fd2679aed54cb23$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "Profiler", function () { return $7fd2679aed54cb23$export$e2c29f18771995cb; }, function (v) { return $7fd2679aed54cb23$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "PureComponent", function () { return $7fd2679aed54cb23$export$221d75b3f55bb0bd; }, function (v) { return $7fd2679aed54cb23$export$221d75b3f55bb0bd = v; });
$parcel$export(module.exports, "StrictMode", function () { return $7fd2679aed54cb23$export$5f8d39834fd61797; }, function (v) { return $7fd2679aed54cb23$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Suspense", function () { return $7fd2679aed54cb23$export$74bf444e3cd11ea5; }, function (v) { return $7fd2679aed54cb23$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", function () { return $7fd2679aed54cb23$export$ae55be85d98224ed; }, function (v) { return $7fd2679aed54cb23$export$ae55be85d98224ed = v; });
$parcel$export(module.exports, "cloneElement", function () { return $7fd2679aed54cb23$export$e530037191fcd5d7; }, function (v) { return $7fd2679aed54cb23$export$e530037191fcd5d7 = v; });
$parcel$export(module.exports, "createContext", function () { return $7fd2679aed54cb23$export$fd42f52fd3ae1109; }, function (v) { return $7fd2679aed54cb23$export$fd42f52fd3ae1109 = v; });
$parcel$export(module.exports, "createElement", function () { return $7fd2679aed54cb23$export$c8a8987d4410bf2d; }, function (v) { return $7fd2679aed54cb23$export$c8a8987d4410bf2d = v; });
$parcel$export(module.exports, "createFactory", function () { return $7fd2679aed54cb23$export$d38cd72104c1f0e9; }, function (v) { return $7fd2679aed54cb23$export$d38cd72104c1f0e9 = v; });
$parcel$export(module.exports, "createRef", function () { return $7fd2679aed54cb23$export$7d1e3a5e95ceca43; }, function (v) { return $7fd2679aed54cb23$export$7d1e3a5e95ceca43 = v; });
$parcel$export(module.exports, "forwardRef", function () { return $7fd2679aed54cb23$export$257a8862b851cb5b; }, function (v) { return $7fd2679aed54cb23$export$257a8862b851cb5b = v; });
$parcel$export(module.exports, "isValidElement", function () { return $7fd2679aed54cb23$export$a8257692ac88316c; }, function (v) { return $7fd2679aed54cb23$export$a8257692ac88316c = v; });
$parcel$export(module.exports, "lazy", function () { return $7fd2679aed54cb23$export$488013bae63b21da; }, function (v) { return $7fd2679aed54cb23$export$488013bae63b21da = v; });
$parcel$export(module.exports, "memo", function () { return $7fd2679aed54cb23$export$7c73462e0d25e514; }, function (v) { return $7fd2679aed54cb23$export$7c73462e0d25e514 = v; });
$parcel$export(module.exports, "useCallback", function () { return $7fd2679aed54cb23$export$35808ee640e87ca7; }, function (v) { return $7fd2679aed54cb23$export$35808ee640e87ca7 = v; });
$parcel$export(module.exports, "useContext", function () { return $7fd2679aed54cb23$export$fae74005e78b1a27; }, function (v) { return $7fd2679aed54cb23$export$fae74005e78b1a27 = v; });
$parcel$export(module.exports, "useDebugValue", function () { return $7fd2679aed54cb23$export$dc8fbce3eb94dc1e; }, function (v) { return $7fd2679aed54cb23$export$dc8fbce3eb94dc1e = v; });
$parcel$export(module.exports, "useEffect", function () { return $7fd2679aed54cb23$export$6d9c69b0de29b591; }, function (v) { return $7fd2679aed54cb23$export$6d9c69b0de29b591 = v; });
$parcel$export(module.exports, "useImperativeHandle", function () { return $7fd2679aed54cb23$export$d5a552a76deda3c2; }, function (v) { return $7fd2679aed54cb23$export$d5a552a76deda3c2 = v; });
$parcel$export(module.exports, "useLayoutEffect", function () { return $7fd2679aed54cb23$export$e5c5a5f917a5871c; }, function (v) { return $7fd2679aed54cb23$export$e5c5a5f917a5871c = v; });
$parcel$export(module.exports, "useMemo", function () { return $7fd2679aed54cb23$export$1538c33de8887b59; }, function (v) { return $7fd2679aed54cb23$export$1538c33de8887b59 = v; });
$parcel$export(module.exports, "useReducer", function () { return $7fd2679aed54cb23$export$13e3392192263954; }, function (v) { return $7fd2679aed54cb23$export$13e3392192263954 = v; });
$parcel$export(module.exports, "useRef", function () { return $7fd2679aed54cb23$export$b8f5890fc79d6aca; }, function (v) { return $7fd2679aed54cb23$export$b8f5890fc79d6aca = v; });
$parcel$export(module.exports, "useState", function () { return $7fd2679aed54cb23$export$60241385465d0a34; }, function (v) { return $7fd2679aed54cb23$export$60241385465d0a34 = v; });
$parcel$export(module.exports, "version", function () { return $7fd2679aed54cb23$export$83d89fbfd8236492; }, function (v) { return $7fd2679aed54cb23$export$83d89fbfd8236492 = v; });
/** @license React v16.13.1
 * react.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $7fd2679aed54cb23$export$dca3b0875bd9a954;
var $7fd2679aed54cb23$export$16fa2f45be04daa8;
var $7fd2679aed54cb23$export$ffb0004e005737fa;
var $7fd2679aed54cb23$export$e2c29f18771995cb;
var $7fd2679aed54cb23$export$221d75b3f55bb0bd;
var $7fd2679aed54cb23$export$5f8d39834fd61797;
var $7fd2679aed54cb23$export$74bf444e3cd11ea5;
var $7fd2679aed54cb23$export$ae55be85d98224ed;
var $7fd2679aed54cb23$export$e530037191fcd5d7;
var $7fd2679aed54cb23$export$fd42f52fd3ae1109;
var $7fd2679aed54cb23$export$c8a8987d4410bf2d;
var $7fd2679aed54cb23$export$d38cd72104c1f0e9;
var $7fd2679aed54cb23$export$7d1e3a5e95ceca43;
var $7fd2679aed54cb23$export$257a8862b851cb5b;
var $7fd2679aed54cb23$export$a8257692ac88316c;
var $7fd2679aed54cb23$export$488013bae63b21da;
var $7fd2679aed54cb23$export$7c73462e0d25e514;
var $7fd2679aed54cb23$export$35808ee640e87ca7;
var $7fd2679aed54cb23$export$fae74005e78b1a27;
var $7fd2679aed54cb23$export$dc8fbce3eb94dc1e;
var $7fd2679aed54cb23$export$6d9c69b0de29b591;
var $7fd2679aed54cb23$export$d5a552a76deda3c2;
var $7fd2679aed54cb23$export$e5c5a5f917a5871c;
var $7fd2679aed54cb23$export$1538c33de8887b59;
var $7fd2679aed54cb23$export$13e3392192263954;
var $7fd2679aed54cb23$export$b8f5890fc79d6aca;
var $7fd2679aed54cb23$export$60241385465d0a34;
var $7fd2679aed54cb23$export$83d89fbfd8236492;
"use strict";


(function() {
    "use strict";
    var _assign = (parcelRequire("bDppX"));
    var checkPropTypes = (parcelRequire("kJsDy"));
    var ReactVersion = "16.13.1";
    // The Symbol used to tag the ReactElement-like types. If there is no native Symbol
    // nor polyfill, then a plain number is used for performance.
    var hasSymbol = typeof Symbol === "function" && Symbol.for;
    var REACT_ELEMENT_TYPE = hasSymbol ? Symbol.for("react.element") : 0xeac7;
    var REACT_PORTAL_TYPE = hasSymbol ? Symbol.for("react.portal") : 0xeaca;
    var REACT_FRAGMENT_TYPE = hasSymbol ? Symbol.for("react.fragment") : 0xeacb;
    var REACT_STRICT_MODE_TYPE = hasSymbol ? Symbol.for("react.strict_mode") : 0xeacc;
    var REACT_PROFILER_TYPE = hasSymbol ? Symbol.for("react.profiler") : 0xead2;
    var REACT_PROVIDER_TYPE = hasSymbol ? Symbol.for("react.provider") : 0xeacd;
    var REACT_CONTEXT_TYPE = hasSymbol ? Symbol.for("react.context") : 0xeace; // TODO: We don't use AsyncMode or ConcurrentMode anymore. They were temporary
    var REACT_CONCURRENT_MODE_TYPE = hasSymbol ? Symbol.for("react.concurrent_mode") : 0xeacf;
    var REACT_FORWARD_REF_TYPE = hasSymbol ? Symbol.for("react.forward_ref") : 0xead0;
    var REACT_SUSPENSE_TYPE = hasSymbol ? Symbol.for("react.suspense") : 0xead1;
    var REACT_SUSPENSE_LIST_TYPE = hasSymbol ? Symbol.for("react.suspense_list") : 0xead8;
    var REACT_MEMO_TYPE = hasSymbol ? Symbol.for("react.memo") : 0xead3;
    var REACT_LAZY_TYPE = hasSymbol ? Symbol.for("react.lazy") : 0xead4;
    var REACT_BLOCK_TYPE = hasSymbol ? Symbol.for("react.block") : 0xead9;
    var REACT_FUNDAMENTAL_TYPE = hasSymbol ? Symbol.for("react.fundamental") : 0xead5;
    var REACT_RESPONDER_TYPE = hasSymbol ? Symbol.for("react.responder") : 0xead6;
    var REACT_SCOPE_TYPE = hasSymbol ? Symbol.for("react.scope") : 0xead7;
    var MAYBE_ITERATOR_SYMBOL = typeof Symbol === "function" && Symbol.iterator;
    var FAUX_ITERATOR_SYMBOL = "@@iterator";
    function getIteratorFn(maybeIterable) {
        if (maybeIterable === null || typeof maybeIterable !== "object") return null;
        var maybeIterator = MAYBE_ITERATOR_SYMBOL && maybeIterable[MAYBE_ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL];
        if (typeof maybeIterator === "function") return maybeIterator;
        return null;
    }
    /**
 * Keeps track of the current dispatcher.
 */ var ReactCurrentDispatcher = {
        /**
   * @internal
   * @type {ReactComponent}
   */ current: null
    };
    /**
 * Keeps track of the current batch's configuration such as how long an update
 * should suspend for if it needs to.
 */ var ReactCurrentBatchConfig = {
        suspense: null
    };
    /**
 * Keeps track of the current owner.
 *
 * The current owner is the component who should own any components that are
 * currently being constructed.
 */ var ReactCurrentOwner = {
        /**
   * @internal
   * @type {ReactComponent}
   */ current: null
    };
    var BEFORE_SLASH_RE = /^(.*)[\\\/]/;
    function describeComponentFrame(name, source, ownerName) {
        var sourceInfo = "";
        if (source) {
            var path = source.fileName;
            var fileName = path.replace(BEFORE_SLASH_RE, "");
            // In DEV, include code for a common special case:
            // prefer "folder/index.js" instead of just "index.js".
            if (/^index\./.test(fileName)) {
                var match = path.match(BEFORE_SLASH_RE);
                if (match) {
                    var pathBeforeSlash = match[1];
                    if (pathBeforeSlash) {
                        var folderName = pathBeforeSlash.replace(BEFORE_SLASH_RE, "");
                        fileName = folderName + "/" + fileName;
                    }
                }
            }
            sourceInfo = " (at " + fileName + ":" + source.lineNumber + ")";
        } else if (ownerName) sourceInfo = " (created by " + ownerName + ")";
        return "\n    in " + (name || "Unknown") + sourceInfo;
    }
    var Resolved = 1;
    function refineResolvedLazyComponent(lazyComponent) {
        return lazyComponent._status === Resolved ? lazyComponent._result : null;
    }
    function getWrappedName(outerType, innerType, wrapperName) {
        var functionName = innerType.displayName || innerType.name || "";
        return outerType.displayName || (functionName !== "" ? wrapperName + "(" + functionName + ")" : wrapperName);
    }
    function getComponentName(type) {
        if (type == null) // Host root, text node or just invalid type.
        return null;
        if (typeof type.tag === "number") error("Received an unexpected object in getComponentName(). This is likely a bug in React. Please file an issue.");
        if (typeof type === "function") return type.displayName || type.name || null;
        if (typeof type === "string") return type;
        switch(type){
            case REACT_FRAGMENT_TYPE:
                return "Fragment";
            case REACT_PORTAL_TYPE:
                return "Portal";
            case REACT_PROFILER_TYPE:
                return "Profiler";
            case REACT_STRICT_MODE_TYPE:
                return "StrictMode";
            case REACT_SUSPENSE_TYPE:
                return "Suspense";
            case REACT_SUSPENSE_LIST_TYPE:
                return "SuspenseList";
        }
        if (typeof type === "object") switch(type.$$typeof){
            case REACT_CONTEXT_TYPE:
                return "Context.Consumer";
            case REACT_PROVIDER_TYPE:
                return "Context.Provider";
            case REACT_FORWARD_REF_TYPE:
                return getWrappedName(type, type.render, "ForwardRef");
            case REACT_MEMO_TYPE:
                return getComponentName(type.type);
            case REACT_BLOCK_TYPE:
                return getComponentName(type.render);
            case REACT_LAZY_TYPE:
                var thenable = type;
                var resolvedThenable = refineResolvedLazyComponent(thenable);
                if (resolvedThenable) return getComponentName(resolvedThenable);
                break;
        }
        return null;
    }
    var ReactDebugCurrentFrame = {};
    var currentlyValidatingElement = null;
    function setCurrentlyValidatingElement(element) {
        currentlyValidatingElement = element;
    }
    // Stack implementation injected by the current renderer.
    ReactDebugCurrentFrame.getCurrentStack = null;
    ReactDebugCurrentFrame.getStackAddendum = function() {
        var stack = ""; // Add an extra top frame while an element is being validated
        if (currentlyValidatingElement) {
            var name = getComponentName(currentlyValidatingElement.type);
            var owner = currentlyValidatingElement._owner;
            stack += describeComponentFrame(name, currentlyValidatingElement._source, owner && getComponentName(owner.type));
        } // Delegate to the injected renderer-specific implementation
        var impl = ReactDebugCurrentFrame.getCurrentStack;
        if (impl) stack += impl() || "";
        return stack;
    };
    /**
 * Used by act() to track whether you're inside an act() scope.
 */ var IsSomeRendererActing = {
        current: false
    };
    var ReactSharedInternals = {
        ReactCurrentDispatcher: ReactCurrentDispatcher,
        ReactCurrentBatchConfig: ReactCurrentBatchConfig,
        ReactCurrentOwner: ReactCurrentOwner,
        IsSomeRendererActing: IsSomeRendererActing,
        // Used by renderers to avoid bundling object-assign twice in UMD bundles:
        assign: _assign
    };
    _assign(ReactSharedInternals, {
        // These should not be included in production.
        ReactDebugCurrentFrame: ReactDebugCurrentFrame,
        // Shim for React DOM 16.0.0 which still destructured (but not used) this.
        // TODO: remove in React 17.0.
        ReactComponentTreeHook: {}
    });
    // by calls to these methods by a Babel plugin.
    //
    // In PROD (or in packages without access to React internals),
    // they are left as they are instead.
    function warn(format) {
        for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
        printWarning("warn", format, args);
    }
    function error(format) {
        for(var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++)args[_key2 - 1] = arguments[_key2];
        printWarning("error", format, args);
    }
    function printWarning(level, format, args) {
        var hasExistingStack = args.length > 0 && typeof args[args.length - 1] === "string" && args[args.length - 1].indexOf("\n    in") === 0;
        if (!hasExistingStack) {
            var ReactDebugCurrentFrame = ReactSharedInternals.ReactDebugCurrentFrame;
            var stack = ReactDebugCurrentFrame.getStackAddendum();
            if (stack !== "") {
                format += "%s";
                args = args.concat([
                    stack
                ]);
            }
        }
        var argsWithFormat = args.map(function(item) {
            return "" + item;
        }); // Careful: RN currently depends on this prefix
        argsWithFormat.unshift("Warning: " + format); // We intentionally don't use spread (or .apply) directly because it
        // breaks IE9: https://github.com/facebook/react/issues/13610
        // eslint-disable-next-line react-internal/no-production-logging
        Function.prototype.apply.call(console[level], console, argsWithFormat);
        try {
            // --- Welcome to debugging React ---
            // This error was thrown as a convenience so that you can use this stack
            // to find the callsite that caused this warning to fire.
            var argIndex = 0;
            var message = "Warning: " + format.replace(/%s/g, function() {
                return args[argIndex++];
            });
            throw new Error(message);
        } catch (x) {}
    }
    var didWarnStateUpdateForUnmountedComponent = {};
    function warnNoop(publicInstance, callerName) {
        var _constructor = publicInstance.constructor;
        var componentName = _constructor && (_constructor.displayName || _constructor.name) || "ReactClass";
        var warningKey = componentName + "." + callerName;
        if (didWarnStateUpdateForUnmountedComponent[warningKey]) return;
        error("Can't call %s on a component that is not yet mounted. This is a no-op, but it might indicate a bug in your application. Instead, assign to `this.state` directly or define a `state = {};` class property with the desired state in the %s component.", callerName, componentName);
        didWarnStateUpdateForUnmountedComponent[warningKey] = true;
    }
    /**
 * This is the abstract API for an update queue.
 */ var ReactNoopUpdateQueue = {
        /**
   * Checks whether or not this composite component is mounted.
   * @param {ReactClass} publicInstance The instance we want to test.
   * @return {boolean} True if mounted, false otherwise.
   * @protected
   * @final
   */ isMounted: function(publicInstance) {
            return false;
        },
        /**
   * Forces an update. This should only be invoked when it is known with
   * certainty that we are **not** in a DOM transaction.
   *
   * You may want to call this when you know that some deeper aspect of the
   * component's state has changed but `setState` was not called.
   *
   * This will not invoke `shouldComponentUpdate`, but it will invoke
   * `componentWillUpdate` and `componentDidUpdate`.
   *
   * @param {ReactClass} publicInstance The instance that should rerender.
   * @param {?function} callback Called after component is updated.
   * @param {?string} callerName name of the calling function in the public API.
   * @internal
   */ enqueueForceUpdate: function(publicInstance, callback, callerName) {
            warnNoop(publicInstance, "forceUpdate");
        },
        /**
   * Replaces all of the state. Always use this or `setState` to mutate state.
   * You should treat `this.state` as immutable.
   *
   * There is no guarantee that `this.state` will be immediately updated, so
   * accessing `this.state` after calling this method may return the old value.
   *
   * @param {ReactClass} publicInstance The instance that should rerender.
   * @param {object} completeState Next state.
   * @param {?function} callback Called after component is updated.
   * @param {?string} callerName name of the calling function in the public API.
   * @internal
   */ enqueueReplaceState: function(publicInstance, completeState, callback, callerName) {
            warnNoop(publicInstance, "replaceState");
        },
        /**
   * Sets a subset of the state. This only exists because _pendingState is
   * internal. This provides a merging strategy that is not available to deep
   * properties which is confusing. TODO: Expose pendingState or don't use it
   * during the merge.
   *
   * @param {ReactClass} publicInstance The instance that should rerender.
   * @param {object} partialState Next partial state to be merged with state.
   * @param {?function} callback Called after component is updated.
   * @param {?string} Name of the calling function in the public API.
   * @internal
   */ enqueueSetState: function(publicInstance, partialState, callback, callerName) {
            warnNoop(publicInstance, "setState");
        }
    };
    var emptyObject = {};
    Object.freeze(emptyObject);
    /**
 * Base class helpers for the updating state of a component.
 */ function Component(props, context, updater) {
        this.props = props;
        this.context = context; // If a component has string refs, we will assign a different object later.
        this.refs = emptyObject; // We initialize the default updater but the real one gets injected by the
        // renderer.
        this.updater = updater || ReactNoopUpdateQueue;
    }
    Component.prototype.isReactComponent = {};
    /**
 * Sets a subset of the state. Always use this to mutate
 * state. You should treat `this.state` as immutable.
 *
 * There is no guarantee that `this.state` will be immediately updated, so
 * accessing `this.state` after calling this method may return the old value.
 *
 * There is no guarantee that calls to `setState` will run synchronously,
 * as they may eventually be batched together.  You can provide an optional
 * callback that will be executed when the call to setState is actually
 * completed.
 *
 * When a function is provided to setState, it will be called at some point in
 * the future (not synchronously). It will be called with the up to date
 * component arguments (state, props, context). These values can be different
 * from this.* because your function may be called after receiveProps but before
 * shouldComponentUpdate, and this new state, props, and context will not yet be
 * assigned to this.
 *
 * @param {object|function} partialState Next partial state or function to
 *        produce next partial state to be merged with current state.
 * @param {?function} callback Called after state is updated.
 * @final
 * @protected
 */ Component.prototype.setState = function(partialState, callback) {
        if (!(typeof partialState === "object" || typeof partialState === "function" || partialState == null)) throw Error("setState(...): takes an object of state variables to update or a function which returns an object of state variables.");
        this.updater.enqueueSetState(this, partialState, callback, "setState");
    };
    /**
 * Forces an update. This should only be invoked when it is known with
 * certainty that we are **not** in a DOM transaction.
 *
 * You may want to call this when you know that some deeper aspect of the
 * component's state has changed but `setState` was not called.
 *
 * This will not invoke `shouldComponentUpdate`, but it will invoke
 * `componentWillUpdate` and `componentDidUpdate`.
 *
 * @param {?function} callback Called after update is complete.
 * @final
 * @protected
 */ Component.prototype.forceUpdate = function(callback) {
        this.updater.enqueueForceUpdate(this, callback, "forceUpdate");
    };
    var deprecatedAPIs = {
        isMounted: [
            "isMounted",
            "Instead, make sure to clean up subscriptions and pending requests in componentWillUnmount to prevent memory leaks."
        ],
        replaceState: [
            "replaceState",
            "Refactor your code to use setState instead (see https://github.com/facebook/react/issues/3236)."
        ]
    };
    var defineDeprecationWarning = function(methodName, info) {
        Object.defineProperty(Component.prototype, methodName, {
            get: function() {
                warn("%s(...) is deprecated in plain JavaScript React classes. %s", info[0], info[1]);
                return undefined;
            }
        });
    };
    for(var fnName in deprecatedAPIs)if (deprecatedAPIs.hasOwnProperty(fnName)) defineDeprecationWarning(fnName, deprecatedAPIs[fnName]);
    function ComponentDummy() {}
    ComponentDummy.prototype = Component.prototype;
    /**
 * Convenience component with default shallow equality check for sCU.
 */ function PureComponent(props, context, updater) {
        this.props = props;
        this.context = context; // If a component has string refs, we will assign a different object later.
        this.refs = emptyObject;
        this.updater = updater || ReactNoopUpdateQueue;
    }
    var pureComponentPrototype = PureComponent.prototype = new ComponentDummy();
    pureComponentPrototype.constructor = PureComponent; // Avoid an extra prototype jump for these methods.
    _assign(pureComponentPrototype, Component.prototype);
    pureComponentPrototype.isPureReactComponent = true;
    // an immutable object with a single mutable value
    function createRef() {
        var refObject = {
            current: null
        };
        Object.seal(refObject);
        return refObject;
    }
    var hasOwnProperty = Object.prototype.hasOwnProperty;
    var RESERVED_PROPS = {
        key: true,
        ref: true,
        __self: true,
        __source: true
    };
    var specialPropKeyWarningShown, specialPropRefWarningShown, didWarnAboutStringRefs;
    didWarnAboutStringRefs = {};
    function hasValidRef(config) {
        if (hasOwnProperty.call(config, "ref")) {
            var getter = Object.getOwnPropertyDescriptor(config, "ref").get;
            if (getter && getter.isReactWarning) return false;
        }
        return config.ref !== undefined;
    }
    function hasValidKey(config) {
        if (hasOwnProperty.call(config, "key")) {
            var getter = Object.getOwnPropertyDescriptor(config, "key").get;
            if (getter && getter.isReactWarning) return false;
        }
        return config.key !== undefined;
    }
    function defineKeyPropWarningGetter(props, displayName) {
        var warnAboutAccessingKey = function() {
            if (!specialPropKeyWarningShown) {
                specialPropKeyWarningShown = true;
                error("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://fb.me/react-special-props)", displayName);
            }
        };
        warnAboutAccessingKey.isReactWarning = true;
        Object.defineProperty(props, "key", {
            get: warnAboutAccessingKey,
            configurable: true
        });
    }
    function defineRefPropWarningGetter(props, displayName) {
        var warnAboutAccessingRef = function() {
            if (!specialPropRefWarningShown) {
                specialPropRefWarningShown = true;
                error("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://fb.me/react-special-props)", displayName);
            }
        };
        warnAboutAccessingRef.isReactWarning = true;
        Object.defineProperty(props, "ref", {
            get: warnAboutAccessingRef,
            configurable: true
        });
    }
    function warnIfStringRefCannotBeAutoConverted(config) {
        if (typeof config.ref === "string" && ReactCurrentOwner.current && config.__self && ReactCurrentOwner.current.stateNode !== config.__self) {
            var componentName = getComponentName(ReactCurrentOwner.current.type);
            if (!didWarnAboutStringRefs[componentName]) {
                error('Component "%s" contains the string ref "%s". Support for string refs will be removed in a future major release. This case cannot be automatically converted to an arrow function. We ask you to manually fix this case by using useRef() or createRef() instead. Learn more about using refs safely here: https://fb.me/react-strict-mode-string-ref', getComponentName(ReactCurrentOwner.current.type), config.ref);
                didWarnAboutStringRefs[componentName] = true;
            }
        }
    }
    /**
 * Factory method to create a new React element. This no longer adheres to
 * the class pattern, so do not use new to call it. Also, instanceof check
 * will not work. Instead test $$typeof field against Symbol.for('react.element') to check
 * if something is a React Element.
 *
 * @param {*} type
 * @param {*} props
 * @param {*} key
 * @param {string|object} ref
 * @param {*} owner
 * @param {*} self A *temporary* helper to detect places where `this` is
 * different from the `owner` when React.createElement is called, so that we
 * can warn. We want to get rid of owner and replace string `ref`s with arrow
 * functions, and as long as `this` and owner are the same, there will be no
 * change in behavior.
 * @param {*} source An annotation object (added by a transpiler or otherwise)
 * indicating filename, line number, and/or other information.
 * @internal
 */ var ReactElement = function(type, key, ref, self, source, owner, props) {
        var element = {
            // This tag allows us to uniquely identify this as a React Element
            $$typeof: REACT_ELEMENT_TYPE,
            // Built-in properties that belong on the element
            type: type,
            key: key,
            ref: ref,
            props: props,
            // Record the component responsible for creating this element.
            _owner: owner
        };
        // The validation flag is currently mutative. We put it on
        // an external backing store so that we can freeze the whole object.
        // This can be replaced with a WeakMap once they are implemented in
        // commonly used development environments.
        element._store = {}; // To make comparing ReactElements easier for testing purposes, we make
        // the validation flag non-enumerable (where possible, which should
        // include every environment we run tests in), so the test framework
        // ignores it.
        Object.defineProperty(element._store, "validated", {
            configurable: false,
            enumerable: false,
            writable: true,
            value: false
        }); // self and source are DEV only properties.
        Object.defineProperty(element, "_self", {
            configurable: false,
            enumerable: false,
            writable: false,
            value: self
        }); // Two elements created in two different places should be considered
        // equal for testing purposes and therefore we hide it from enumeration.
        Object.defineProperty(element, "_source", {
            configurable: false,
            enumerable: false,
            writable: false,
            value: source
        });
        if (Object.freeze) {
            Object.freeze(element.props);
            Object.freeze(element);
        }
        return element;
    };
    /**
 * Create and return a new ReactElement of the given type.
 * See https://reactjs.org/docs/react-api.html#createelement
 */ function createElement(type, config, children) {
        var propName; // Reserved names are extracted
        var props = {};
        var key = null;
        var ref = null;
        var self = null;
        var source = null;
        if (config != null) {
            if (hasValidRef(config)) {
                ref = config.ref;
                warnIfStringRefCannotBeAutoConverted(config);
            }
            if (hasValidKey(config)) key = "" + config.key;
            self = config.__self === undefined ? null : config.__self;
            source = config.__source === undefined ? null : config.__source; // Remaining properties are added to a new props object
            for(propName in config)if (hasOwnProperty.call(config, propName) && !RESERVED_PROPS.hasOwnProperty(propName)) props[propName] = config[propName];
        } // Children can be more than one argument, and those are transferred onto
        // the newly allocated props object.
        var childrenLength = arguments.length - 2;
        if (childrenLength === 1) props.children = children;
        else if (childrenLength > 1) {
            var childArray = Array(childrenLength);
            for(var i = 0; i < childrenLength; i++)childArray[i] = arguments[i + 2];
            if (Object.freeze) Object.freeze(childArray);
            props.children = childArray;
        } // Resolve default props
        if (type && type.defaultProps) {
            var defaultProps = type.defaultProps;
            for(propName in defaultProps)if (props[propName] === undefined) props[propName] = defaultProps[propName];
        }
        if (key || ref) {
            var displayName = typeof type === "function" ? type.displayName || type.name || "Unknown" : type;
            if (key) defineKeyPropWarningGetter(props, displayName);
            if (ref) defineRefPropWarningGetter(props, displayName);
        }
        return ReactElement(type, key, ref, self, source, ReactCurrentOwner.current, props);
    }
    function cloneAndReplaceKey(oldElement, newKey) {
        var newElement = ReactElement(oldElement.type, newKey, oldElement.ref, oldElement._self, oldElement._source, oldElement._owner, oldElement.props);
        return newElement;
    }
    /**
 * Clone and return a new ReactElement using element as the starting point.
 * See https://reactjs.org/docs/react-api.html#cloneelement
 */ function cloneElement(element, config, children) {
        if (!!(element === null || element === undefined)) throw Error("React.cloneElement(...): The argument must be a React element, but you passed " + element + ".");
        var propName; // Original props are copied
        var props = _assign({}, element.props); // Reserved names are extracted
        var key = element.key;
        var ref = element.ref; // Self is preserved since the owner is preserved.
        var self = element._self; // Source is preserved since cloneElement is unlikely to be targeted by a
        // transpiler, and the original source is probably a better indicator of the
        // true owner.
        var source = element._source; // Owner will be preserved, unless ref is overridden
        var owner = element._owner;
        if (config != null) {
            if (hasValidRef(config)) {
                // Silently steal the ref from the parent.
                ref = config.ref;
                owner = ReactCurrentOwner.current;
            }
            if (hasValidKey(config)) key = "" + config.key;
             // Remaining properties override existing props
            var defaultProps;
            if (element.type && element.type.defaultProps) defaultProps = element.type.defaultProps;
            for(propName in config)if (hasOwnProperty.call(config, propName) && !RESERVED_PROPS.hasOwnProperty(propName)) {
                if (config[propName] === undefined && defaultProps !== undefined) // Resolve default props
                props[propName] = defaultProps[propName];
                else props[propName] = config[propName];
            }
        } // Children can be more than one argument, and those are transferred onto
        // the newly allocated props object.
        var childrenLength = arguments.length - 2;
        if (childrenLength === 1) props.children = children;
        else if (childrenLength > 1) {
            var childArray = Array(childrenLength);
            for(var i = 0; i < childrenLength; i++)childArray[i] = arguments[i + 2];
            props.children = childArray;
        }
        return ReactElement(element.type, key, ref, self, source, owner, props);
    }
    /**
 * Verifies the object is a ReactElement.
 * See https://reactjs.org/docs/react-api.html#isvalidelement
 * @param {?object} object
 * @return {boolean} True if `object` is a ReactElement.
 * @final
 */ function isValidElement(object) {
        return typeof object === "object" && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
    }
    var SEPARATOR = ".";
    var SUBSEPARATOR = ":";
    /**
 * Escape and wrap key so it is safe to use as a reactid
 *
 * @param {string} key to be escaped.
 * @return {string} the escaped key.
 */ function escape(key) {
        var escapeRegex = /[=:]/g;
        var escaperLookup = {
            "=": "=0",
            ":": "=2"
        };
        var escapedString = ("" + key).replace(escapeRegex, function(match) {
            return escaperLookup[match];
        });
        return "$" + escapedString;
    }
    /**
 * TODO: Test that a single child and an array with one item have the same key
 * pattern.
 */ var didWarnAboutMaps = false;
    var userProvidedKeyEscapeRegex = /\/+/g;
    function escapeUserProvidedKey(text) {
        return ("" + text).replace(userProvidedKeyEscapeRegex, "$&/");
    }
    var POOL_SIZE = 10;
    var traverseContextPool = [];
    function getPooledTraverseContext(mapResult, keyPrefix, mapFunction, mapContext) {
        if (traverseContextPool.length) {
            var traverseContext = traverseContextPool.pop();
            traverseContext.result = mapResult;
            traverseContext.keyPrefix = keyPrefix;
            traverseContext.func = mapFunction;
            traverseContext.context = mapContext;
            traverseContext.count = 0;
            return traverseContext;
        } else return {
            result: mapResult,
            keyPrefix: keyPrefix,
            func: mapFunction,
            context: mapContext,
            count: 0
        };
    }
    function releaseTraverseContext(traverseContext) {
        traverseContext.result = null;
        traverseContext.keyPrefix = null;
        traverseContext.func = null;
        traverseContext.context = null;
        traverseContext.count = 0;
        if (traverseContextPool.length < POOL_SIZE) traverseContextPool.push(traverseContext);
    }
    /**
 * @param {?*} children Children tree container.
 * @param {!string} nameSoFar Name of the key path so far.
 * @param {!function} callback Callback to invoke with each child found.
 * @param {?*} traverseContext Used to pass information throughout the traversal
 * process.
 * @return {!number} The number of children in this subtree.
 */ function traverseAllChildrenImpl(children, nameSoFar, callback, traverseContext) {
        var type = typeof children;
        if (type === "undefined" || type === "boolean") // All of the above are perceived as null.
        children = null;
        var invokeCallback = false;
        if (children === null) invokeCallback = true;
        else switch(type){
            case "string":
            case "number":
                invokeCallback = true;
                break;
            case "object":
                switch(children.$$typeof){
                    case REACT_ELEMENT_TYPE:
                    case REACT_PORTAL_TYPE:
                        invokeCallback = true;
                }
        }
        if (invokeCallback) {
            callback(traverseContext, children, // so that it's consistent if the number of children grows.
            nameSoFar === "" ? SEPARATOR + getComponentKey(children, 0) : nameSoFar);
            return 1;
        }
        var child;
        var nextName;
        var subtreeCount = 0; // Count of children found in the current subtree.
        var nextNamePrefix = nameSoFar === "" ? SEPARATOR : nameSoFar + SUBSEPARATOR;
        if (Array.isArray(children)) for(var i = 0; i < children.length; i++){
            child = children[i];
            nextName = nextNamePrefix + getComponentKey(child, i);
            subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
        }
        else {
            var iteratorFn = getIteratorFn(children);
            if (typeof iteratorFn === "function") {
                // Warn about using Maps as children
                if (iteratorFn === children.entries) {
                    if (!didWarnAboutMaps) warn("Using Maps as children is deprecated and will be removed in a future major release. Consider converting children to an array of keyed ReactElements instead.");
                    didWarnAboutMaps = true;
                }
                var iterator = iteratorFn.call(children);
                var step;
                var ii = 0;
                while(!(step = iterator.next()).done){
                    child = step.value;
                    nextName = nextNamePrefix + getComponentKey(child, ii++);
                    subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
                }
            } else if (type === "object") {
                var addendum = "";
                addendum = " If you meant to render a collection of children, use an array instead." + ReactDebugCurrentFrame.getStackAddendum();
                var childrenString = "" + children;
                throw Error("Objects are not valid as a React child (found: " + (childrenString === "[object Object]" ? "object with keys {" + Object.keys(children).join(", ") + "}" : childrenString) + ")." + addendum);
            }
        }
        return subtreeCount;
    }
    /**
 * Traverses children that are typically specified as `props.children`, but
 * might also be specified through attributes:
 *
 * - `traverseAllChildren(this.props.children, ...)`
 * - `traverseAllChildren(this.props.leftPanelChildren, ...)`
 *
 * The `traverseContext` is an optional argument that is passed through the
 * entire traversal. It can be used to store accumulations or anything else that
 * the callback might find relevant.
 *
 * @param {?*} children Children tree object.
 * @param {!function} callback To invoke upon traversing each child.
 * @param {?*} traverseContext Context for traversal.
 * @return {!number} The number of children in this subtree.
 */ function traverseAllChildren(children, callback, traverseContext) {
        if (children == null) return 0;
        return traverseAllChildrenImpl(children, "", callback, traverseContext);
    }
    /**
 * Generate a key string that identifies a component within a set.
 *
 * @param {*} component A component that could contain a manual key.
 * @param {number} index Index that is used if a manual key is not provided.
 * @return {string}
 */ function getComponentKey(component, index) {
        // Do some typechecking here since we call this blindly. We want to ensure
        // that we don't block potential future ES APIs.
        if (typeof component === "object" && component !== null && component.key != null) // Explicit key
        return escape(component.key);
         // Implicit key determined by the index in the set
        return index.toString(36);
    }
    function forEachSingleChild(bookKeeping, child, name) {
        var func = bookKeeping.func, context = bookKeeping.context;
        func.call(context, child, bookKeeping.count++);
    }
    /**
 * Iterates through children that are typically specified as `props.children`.
 *
 * See https://reactjs.org/docs/react-api.html#reactchildrenforeach
 *
 * The provided forEachFunc(child, index) will be called for each
 * leaf child.
 *
 * @param {?*} children Children tree container.
 * @param {function(*, int)} forEachFunc
 * @param {*} forEachContext Context for forEachContext.
 */ function forEachChildren(children, forEachFunc, forEachContext) {
        if (children == null) return children;
        var traverseContext = getPooledTraverseContext(null, null, forEachFunc, forEachContext);
        traverseAllChildren(children, forEachSingleChild, traverseContext);
        releaseTraverseContext(traverseContext);
    }
    function mapSingleChildIntoContext(bookKeeping, child, childKey) {
        var result = bookKeeping.result, keyPrefix = bookKeeping.keyPrefix, func = bookKeeping.func, context = bookKeeping.context;
        var mappedChild = func.call(context, child, bookKeeping.count++);
        if (Array.isArray(mappedChild)) mapIntoWithKeyPrefixInternal(mappedChild, result, childKey, function(c) {
            return c;
        });
        else if (mappedChild != null) {
            if (isValidElement(mappedChild)) mappedChild = cloneAndReplaceKey(mappedChild, // traverseAllChildren used to do for objects as children
            keyPrefix + (mappedChild.key && (!child || child.key !== mappedChild.key) ? escapeUserProvidedKey(mappedChild.key) + "/" : "") + childKey);
            result.push(mappedChild);
        }
    }
    function mapIntoWithKeyPrefixInternal(children, array, prefix, func, context) {
        var escapedPrefix = "";
        if (prefix != null) escapedPrefix = escapeUserProvidedKey(prefix) + "/";
        var traverseContext = getPooledTraverseContext(array, escapedPrefix, func, context);
        traverseAllChildren(children, mapSingleChildIntoContext, traverseContext);
        releaseTraverseContext(traverseContext);
    }
    /**
 * Maps children that are typically specified as `props.children`.
 *
 * See https://reactjs.org/docs/react-api.html#reactchildrenmap
 *
 * The provided mapFunction(child, key, index) will be called for each
 * leaf child.
 *
 * @param {?*} children Children tree container.
 * @param {function(*, int)} func The map function.
 * @param {*} context Context for mapFunction.
 * @return {object} Object containing the ordered map of results.
 */ function mapChildren(children, func, context) {
        if (children == null) return children;
        var result = [];
        mapIntoWithKeyPrefixInternal(children, result, null, func, context);
        return result;
    }
    /**
 * Count the number of children that are typically specified as
 * `props.children`.
 *
 * See https://reactjs.org/docs/react-api.html#reactchildrencount
 *
 * @param {?*} children Children tree container.
 * @return {number} The number of children.
 */ function countChildren(children) {
        return traverseAllChildren(children, function() {
            return null;
        }, null);
    }
    /**
 * Flatten a children object (typically specified as `props.children`) and
 * return an array with appropriately re-keyed children.
 *
 * See https://reactjs.org/docs/react-api.html#reactchildrentoarray
 */ function toArray(children) {
        var result = [];
        mapIntoWithKeyPrefixInternal(children, result, null, function(child) {
            return child;
        });
        return result;
    }
    /**
 * Returns the first child in a collection of children and verifies that there
 * is only one child in the collection.
 *
 * See https://reactjs.org/docs/react-api.html#reactchildrenonly
 *
 * The current implementation of this function assumes that a single child gets
 * passed without a wrapper, but the purpose of this helper function is to
 * abstract away the particular structure of children.
 *
 * @param {?object} children Child collection structure.
 * @return {ReactElement} The first and only `ReactElement` contained in the
 * structure.
 */ function onlyChild(children) {
        if (!isValidElement(children)) throw Error("React.Children.only expected to receive a single React element child.");
        return children;
    }
    function createContext(defaultValue, calculateChangedBits) {
        if (calculateChangedBits === undefined) calculateChangedBits = null;
        else if (calculateChangedBits !== null && typeof calculateChangedBits !== "function") error("createContext: Expected the optional second argument to be a function. Instead received: %s", calculateChangedBits);
        var context = {
            $$typeof: REACT_CONTEXT_TYPE,
            _calculateChangedBits: calculateChangedBits,
            // As a workaround to support multiple concurrent renderers, we categorize
            // some renderers as primary and others as secondary. We only expect
            // there to be two concurrent renderers at most: React Native (primary) and
            // Fabric (secondary); React DOM (primary) and React ART (secondary).
            // Secondary renderers store their context values on separate fields.
            _currentValue: defaultValue,
            _currentValue2: defaultValue,
            // Used to track how many concurrent renderers this context currently
            // supports within in a single renderer. Such as parallel server rendering.
            _threadCount: 0,
            // These are circular
            Provider: null,
            Consumer: null
        };
        context.Provider = {
            $$typeof: REACT_PROVIDER_TYPE,
            _context: context
        };
        var hasWarnedAboutUsingNestedContextConsumers = false;
        var hasWarnedAboutUsingConsumerProvider = false;
        // A separate object, but proxies back to the original context object for
        // backwards compatibility. It has a different $$typeof, so we can properly
        // warn for the incorrect usage of Context as a Consumer.
        var Consumer = {
            $$typeof: REACT_CONTEXT_TYPE,
            _context: context,
            _calculateChangedBits: context._calculateChangedBits
        }; // $FlowFixMe: Flow complains about not setting a value, which is intentional here
        Object.defineProperties(Consumer, {
            Provider: {
                get: function() {
                    if (!hasWarnedAboutUsingConsumerProvider) {
                        hasWarnedAboutUsingConsumerProvider = true;
                        error("Rendering <Context.Consumer.Provider> is not supported and will be removed in a future major release. Did you mean to render <Context.Provider> instead?");
                    }
                    return context.Provider;
                },
                set: function(_Provider) {
                    context.Provider = _Provider;
                }
            },
            _currentValue: {
                get: function() {
                    return context._currentValue;
                },
                set: function(_currentValue) {
                    context._currentValue = _currentValue;
                }
            },
            _currentValue2: {
                get: function() {
                    return context._currentValue2;
                },
                set: function(_currentValue2) {
                    context._currentValue2 = _currentValue2;
                }
            },
            _threadCount: {
                get: function() {
                    return context._threadCount;
                },
                set: function(_threadCount) {
                    context._threadCount = _threadCount;
                }
            },
            Consumer: {
                get: function() {
                    if (!hasWarnedAboutUsingNestedContextConsumers) {
                        hasWarnedAboutUsingNestedContextConsumers = true;
                        error("Rendering <Context.Consumer.Consumer> is not supported and will be removed in a future major release. Did you mean to render <Context.Consumer> instead?");
                    }
                    return context.Consumer;
                }
            }
        }); // $FlowFixMe: Flow complains about missing properties because it doesn't understand defineProperty
        context.Consumer = Consumer;
        context._currentRenderer = null;
        context._currentRenderer2 = null;
        return context;
    }
    function lazy(ctor) {
        var lazyType = {
            $$typeof: REACT_LAZY_TYPE,
            _ctor: ctor,
            // React uses these fields to store the result.
            _status: -1,
            _result: null
        };
        // In production, this would just set it on the object.
        var defaultProps;
        var propTypes;
        Object.defineProperties(lazyType, {
            defaultProps: {
                configurable: true,
                get: function() {
                    return defaultProps;
                },
                set: function(newDefaultProps) {
                    error("React.lazy(...): It is not supported to assign `defaultProps` to a lazy component import. Either specify them where the component is defined, or create a wrapping component around it.");
                    defaultProps = newDefaultProps; // Match production behavior more closely:
                    Object.defineProperty(lazyType, "defaultProps", {
                        enumerable: true
                    });
                }
            },
            propTypes: {
                configurable: true,
                get: function() {
                    return propTypes;
                },
                set: function(newPropTypes) {
                    error("React.lazy(...): It is not supported to assign `propTypes` to a lazy component import. Either specify them where the component is defined, or create a wrapping component around it.");
                    propTypes = newPropTypes; // Match production behavior more closely:
                    Object.defineProperty(lazyType, "propTypes", {
                        enumerable: true
                    });
                }
            }
        });
        return lazyType;
    }
    function forwardRef(render) {
        if (render != null && render.$$typeof === REACT_MEMO_TYPE) error("forwardRef requires a render function but received a `memo` component. Instead of forwardRef(memo(...)), use memo(forwardRef(...)).");
        else if (typeof render !== "function") error("forwardRef requires a render function but was given %s.", render === null ? "null" : typeof render);
        else if (render.length !== 0 && render.length !== 2) error("forwardRef render functions accept exactly two parameters: props and ref. %s", render.length === 1 ? "Did you forget to use the ref parameter?" : "Any additional parameter will be undefined.");
        if (render != null) {
            if (render.defaultProps != null || render.propTypes != null) error("forwardRef render functions do not support propTypes or defaultProps. Did you accidentally pass a React component?");
        }
        return {
            $$typeof: REACT_FORWARD_REF_TYPE,
            render: render
        };
    }
    function isValidElementType(type) {
        return typeof type === "string" || typeof type === "function" || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
        type === REACT_FRAGMENT_TYPE || type === REACT_CONCURRENT_MODE_TYPE || type === REACT_PROFILER_TYPE || type === REACT_STRICT_MODE_TYPE || type === REACT_SUSPENSE_TYPE || type === REACT_SUSPENSE_LIST_TYPE || typeof type === "object" && type !== null && (type.$$typeof === REACT_LAZY_TYPE || type.$$typeof === REACT_MEMO_TYPE || type.$$typeof === REACT_PROVIDER_TYPE || type.$$typeof === REACT_CONTEXT_TYPE || type.$$typeof === REACT_FORWARD_REF_TYPE || type.$$typeof === REACT_FUNDAMENTAL_TYPE || type.$$typeof === REACT_RESPONDER_TYPE || type.$$typeof === REACT_SCOPE_TYPE || type.$$typeof === REACT_BLOCK_TYPE);
    }
    function memo(type, compare) {
        if (!isValidElementType(type)) error("memo: The first argument must be a component. Instead received: %s", type === null ? "null" : typeof type);
        return {
            $$typeof: REACT_MEMO_TYPE,
            type: type,
            compare: compare === undefined ? null : compare
        };
    }
    function resolveDispatcher() {
        var dispatcher = ReactCurrentDispatcher.current;
        if (!(dispatcher !== null)) throw Error("Invalid hook call. Hooks can only be called inside of the body of a function component. This could happen for one of the following reasons:\n1. You might have mismatching versions of React and the renderer (such as React DOM)\n2. You might be breaking the Rules of Hooks\n3. You might have more than one copy of React in the same app\nSee https://fb.me/react-invalid-hook-call for tips about how to debug and fix this problem.");
        return dispatcher;
    }
    function useContext(Context, unstable_observedBits) {
        var dispatcher = resolveDispatcher();
        if (unstable_observedBits !== undefined) error("useContext() second argument is reserved for future use in React. Passing it is not supported. You passed: %s.%s", unstable_observedBits, typeof unstable_observedBits === "number" && Array.isArray(arguments[2]) ? "\n\nDid you call array.map(useContext)? Calling Hooks inside a loop is not supported. Learn more at https://fb.me/rules-of-hooks" : "");
         // TODO: add a more generic warning for invalid values.
        if (Context._context !== undefined) {
            var realContext = Context._context; // Don't deduplicate because this legitimately causes bugs
            // and nobody should be using this in existing code.
            if (realContext.Consumer === Context) error("Calling useContext(Context.Consumer) is not supported, may cause bugs, and will be removed in a future major release. Did you mean to call useContext(Context) instead?");
            else if (realContext.Provider === Context) error("Calling useContext(Context.Provider) is not supported. Did you mean to call useContext(Context) instead?");
        }
        return dispatcher.useContext(Context, unstable_observedBits);
    }
    function useState(initialState) {
        var dispatcher = resolveDispatcher();
        return dispatcher.useState(initialState);
    }
    function useReducer(reducer, initialArg, init) {
        var dispatcher = resolveDispatcher();
        return dispatcher.useReducer(reducer, initialArg, init);
    }
    function useRef(initialValue) {
        var dispatcher = resolveDispatcher();
        return dispatcher.useRef(initialValue);
    }
    function useEffect(create, deps) {
        var dispatcher = resolveDispatcher();
        return dispatcher.useEffect(create, deps);
    }
    function useLayoutEffect(create, deps) {
        var dispatcher = resolveDispatcher();
        return dispatcher.useLayoutEffect(create, deps);
    }
    function useCallback(callback, deps) {
        var dispatcher = resolveDispatcher();
        return dispatcher.useCallback(callback, deps);
    }
    function useMemo(create, deps) {
        var dispatcher = resolveDispatcher();
        return dispatcher.useMemo(create, deps);
    }
    function useImperativeHandle(ref, create, deps) {
        var dispatcher = resolveDispatcher();
        return dispatcher.useImperativeHandle(ref, create, deps);
    }
    function useDebugValue(value, formatterFn) {
        var dispatcher = resolveDispatcher();
        return dispatcher.useDebugValue(value, formatterFn);
    }
    var propTypesMisspellWarningShown;
    propTypesMisspellWarningShown = false;
    function getDeclarationErrorAddendum() {
        if (ReactCurrentOwner.current) {
            var name = getComponentName(ReactCurrentOwner.current.type);
            if (name) return "\n\nCheck the render method of `" + name + "`.";
        }
        return "";
    }
    function getSourceInfoErrorAddendum(source) {
        if (source !== undefined) {
            var fileName = source.fileName.replace(/^.*[\\\/]/, "");
            var lineNumber = source.lineNumber;
            return "\n\nCheck your code at " + fileName + ":" + lineNumber + ".";
        }
        return "";
    }
    function getSourceInfoErrorAddendumForProps(elementProps) {
        if (elementProps !== null && elementProps !== undefined) return getSourceInfoErrorAddendum(elementProps.__source);
        return "";
    }
    /**
 * Warn if there's no key explicitly set on dynamic arrays of children or
 * object keys are not valid. This allows us to keep track of children between
 * updates.
 */ var ownerHasKeyUseWarning = {};
    function getCurrentComponentErrorInfo(parentType) {
        var info = getDeclarationErrorAddendum();
        if (!info) {
            var parentName = typeof parentType === "string" ? parentType : parentType.displayName || parentType.name;
            if (parentName) info = "\n\nCheck the top-level render call using <" + parentName + ">.";
        }
        return info;
    }
    /**
 * Warn if the element doesn't have an explicit key assigned to it.
 * This element is in an array. The array could grow and shrink or be
 * reordered. All children that haven't already been validated are required to
 * have a "key" property assigned to it. Error statuses are cached so a warning
 * will only be shown once.
 *
 * @internal
 * @param {ReactElement} element Element that requires a key.
 * @param {*} parentType element's parent's type.
 */ function validateExplicitKey(element, parentType) {
        if (!element._store || element._store.validated || element.key != null) return;
        element._store.validated = true;
        var currentComponentErrorInfo = getCurrentComponentErrorInfo(parentType);
        if (ownerHasKeyUseWarning[currentComponentErrorInfo]) return;
        ownerHasKeyUseWarning[currentComponentErrorInfo] = true; // Usually the current owner is the offender, but if it accepts children as a
        // property, it may be the creator of the child that's responsible for
        // assigning it a key.
        var childOwner = "";
        if (element && element._owner && element._owner !== ReactCurrentOwner.current) // Give the component that originally created this child.
        childOwner = " It was passed a child from " + getComponentName(element._owner.type) + ".";
        setCurrentlyValidatingElement(element);
        error('Each child in a list should have a unique "key" prop.%s%s See https://fb.me/react-warning-keys for more information.', currentComponentErrorInfo, childOwner);
        setCurrentlyValidatingElement(null);
    }
    /**
 * Ensure that every element either is passed in a static location, in an
 * array with an explicit keys property defined, or in an object literal
 * with valid key property.
 *
 * @internal
 * @param {ReactNode} node Statically passed child of any type.
 * @param {*} parentType node's parent's type.
 */ function validateChildKeys(node, parentType) {
        if (typeof node !== "object") return;
        if (Array.isArray(node)) for(var i = 0; i < node.length; i++){
            var child = node[i];
            if (isValidElement(child)) validateExplicitKey(child, parentType);
        }
        else if (isValidElement(node)) // This element was passed in a valid location.
        {
            if (node._store) node._store.validated = true;
        } else if (node) {
            var iteratorFn = getIteratorFn(node);
            if (typeof iteratorFn === "function") // Entry iterators used to provide implicit keys,
            // but now we print a separate warning for them later.
            {
                if (iteratorFn !== node.entries) {
                    var iterator = iteratorFn.call(node);
                    var step;
                    while(!(step = iterator.next()).done)if (isValidElement(step.value)) validateExplicitKey(step.value, parentType);
                }
            }
        }
    }
    /**
 * Given an element, validate that its props follow the propTypes definition,
 * provided by the type.
 *
 * @param {ReactElement} element
 */ function validatePropTypes(element) {
        var type = element.type;
        if (type === null || type === undefined || typeof type === "string") return;
        var name = getComponentName(type);
        var propTypes;
        if (typeof type === "function") propTypes = type.propTypes;
        else if (typeof type === "object" && (type.$$typeof === REACT_FORWARD_REF_TYPE || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        type.$$typeof === REACT_MEMO_TYPE)) propTypes = type.propTypes;
        else return;
        if (propTypes) {
            setCurrentlyValidatingElement(element);
            checkPropTypes(propTypes, element.props, "prop", name, ReactDebugCurrentFrame.getStackAddendum);
            setCurrentlyValidatingElement(null);
        } else if (type.PropTypes !== undefined && !propTypesMisspellWarningShown) {
            propTypesMisspellWarningShown = true;
            error("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", name || "Unknown");
        }
        if (typeof type.getDefaultProps === "function" && !type.getDefaultProps.isReactClassApproved) error("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
    }
    /**
 * Given a fragment, validate that it can only be provided with fragment props
 * @param {ReactElement} fragment
 */ function validateFragmentProps(fragment) {
        setCurrentlyValidatingElement(fragment);
        var keys = Object.keys(fragment.props);
        for(var i = 0; i < keys.length; i++){
            var key = keys[i];
            if (key !== "children" && key !== "key") {
                error("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", key);
                break;
            }
        }
        if (fragment.ref !== null) error("Invalid attribute `ref` supplied to `React.Fragment`.");
        setCurrentlyValidatingElement(null);
    }
    function createElementWithValidation(type, props, children) {
        var validType = isValidElementType(type); // We warn in this case but don't throw. We expect the element creation to
        // succeed and there will likely be errors in render.
        if (!validType) {
            var info = "";
            if (type === undefined || typeof type === "object" && type !== null && Object.keys(type).length === 0) info += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.";
            var sourceInfo = getSourceInfoErrorAddendumForProps(props);
            if (sourceInfo) info += sourceInfo;
            else info += getDeclarationErrorAddendum();
            var typeString;
            if (type === null) typeString = "null";
            else if (Array.isArray(type)) typeString = "array";
            else if (type !== undefined && type.$$typeof === REACT_ELEMENT_TYPE) {
                typeString = "<" + (getComponentName(type.type) || "Unknown") + " />";
                info = " Did you accidentally export a JSX literal instead of a component?";
            } else typeString = typeof type;
            error("React.createElement: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", typeString, info);
        }
        var element = createElement.apply(this, arguments); // The result can be nullish if a mock or a custom function is used.
        // TODO: Drop this when these are no longer allowed as the type argument.
        if (element == null) return element;
         // Skip key warning if the type isn't valid since our key validation logic
        // doesn't expect a non-string/function type and can throw confusing errors.
        // We don't want exception behavior to differ between dev and prod.
        // (Rendering will throw with a helpful message and as soon as the type is
        // fixed, the key warnings will appear.)
        if (validType) for(var i = 2; i < arguments.length; i++)validateChildKeys(arguments[i], type);
        if (type === REACT_FRAGMENT_TYPE) validateFragmentProps(element);
        else validatePropTypes(element);
        return element;
    }
    var didWarnAboutDeprecatedCreateFactory = false;
    function createFactoryWithValidation(type) {
        var validatedFactory = createElementWithValidation.bind(null, type);
        validatedFactory.type = type;
        if (!didWarnAboutDeprecatedCreateFactory) {
            didWarnAboutDeprecatedCreateFactory = true;
            warn("React.createFactory() is deprecated and will be removed in a future major release. Consider using JSX or use React.createElement() directly instead.");
        } // Legacy hook: remove it
        Object.defineProperty(validatedFactory, "type", {
            enumerable: false,
            get: function() {
                warn("Factory.type is deprecated. Access the class directly before passing it to createFactory.");
                Object.defineProperty(this, "type", {
                    value: type
                });
                return type;
            }
        });
        return validatedFactory;
    }
    function cloneElementWithValidation(element, props, children) {
        var newElement = cloneElement.apply(this, arguments);
        for(var i = 2; i < arguments.length; i++)validateChildKeys(arguments[i], newElement.type);
        validatePropTypes(newElement);
        return newElement;
    }
    try {
        var frozenObject = Object.freeze({});
        var testMap = new Map([
            [
                frozenObject,
                null
            ]
        ]);
        var testSet = new Set([
            frozenObject
        ]); // This is necessary for Rollup to not consider these unused.
        // https://github.com/rollup/rollup/issues/1771
        // TODO: we can remove these if Rollup fixes the bug.
        testMap.set(0, 0);
        testSet.add(0);
    } catch (e) {}
    var createElement$1 = createElementWithValidation;
    var cloneElement$1 = cloneElementWithValidation;
    var createFactory = createFactoryWithValidation;
    var Children = {
        map: mapChildren,
        forEach: forEachChildren,
        count: countChildren,
        toArray: toArray,
        only: onlyChild
    };
    $7fd2679aed54cb23$export$dca3b0875bd9a954 = Children;
    $7fd2679aed54cb23$export$16fa2f45be04daa8 = Component;
    $7fd2679aed54cb23$export$ffb0004e005737fa = REACT_FRAGMENT_TYPE;
    $7fd2679aed54cb23$export$e2c29f18771995cb = REACT_PROFILER_TYPE;
    $7fd2679aed54cb23$export$221d75b3f55bb0bd = PureComponent;
    $7fd2679aed54cb23$export$5f8d39834fd61797 = REACT_STRICT_MODE_TYPE;
    $7fd2679aed54cb23$export$74bf444e3cd11ea5 = REACT_SUSPENSE_TYPE;
    $7fd2679aed54cb23$export$ae55be85d98224ed = ReactSharedInternals;
    $7fd2679aed54cb23$export$e530037191fcd5d7 = cloneElement$1;
    $7fd2679aed54cb23$export$fd42f52fd3ae1109 = createContext;
    $7fd2679aed54cb23$export$c8a8987d4410bf2d = createElement$1;
    $7fd2679aed54cb23$export$d38cd72104c1f0e9 = createFactory;
    $7fd2679aed54cb23$export$7d1e3a5e95ceca43 = createRef;
    $7fd2679aed54cb23$export$257a8862b851cb5b = forwardRef;
    $7fd2679aed54cb23$export$a8257692ac88316c = isValidElement;
    $7fd2679aed54cb23$export$488013bae63b21da = lazy;
    $7fd2679aed54cb23$export$7c73462e0d25e514 = memo;
    $7fd2679aed54cb23$export$35808ee640e87ca7 = useCallback;
    $7fd2679aed54cb23$export$fae74005e78b1a27 = useContext;
    $7fd2679aed54cb23$export$dc8fbce3eb94dc1e = useDebugValue;
    $7fd2679aed54cb23$export$6d9c69b0de29b591 = useEffect;
    $7fd2679aed54cb23$export$d5a552a76deda3c2 = useImperativeHandle;
    $7fd2679aed54cb23$export$e5c5a5f917a5871c = useLayoutEffect;
    $7fd2679aed54cb23$export$1538c33de8887b59 = useMemo;
    $7fd2679aed54cb23$export$13e3392192263954 = useReducer;
    $7fd2679aed54cb23$export$b8f5890fc79d6aca = useRef;
    $7fd2679aed54cb23$export$60241385465d0a34 = useState;
    $7fd2679aed54cb23$export$83d89fbfd8236492 = ReactVersion;
})();

});
parcelRegister("bDppX", function(module, exports) {
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/ "use strict";
/* eslint-disable no-unused-vars */ var $87870da89e628224$var$getOwnPropertySymbols = Object.getOwnPropertySymbols;
var $87870da89e628224$var$hasOwnProperty = Object.prototype.hasOwnProperty;
var $87870da89e628224$var$propIsEnumerable = Object.prototype.propertyIsEnumerable;
function $87870da89e628224$var$toObject(val) {
    if (val === null || val === undefined) throw new TypeError("Object.assign cannot be called with null or undefined");
    return Object(val);
}
function $87870da89e628224$var$shouldUseNative() {
    try {
        if (!Object.assign) return false;
        // Detect buggy property enumeration order in older V8 versions.
        // https://bugs.chromium.org/p/v8/issues/detail?id=4118
        var test1 = new String("abc"); // eslint-disable-line no-new-wrappers
        test1[5] = "de";
        if (Object.getOwnPropertyNames(test1)[0] === "5") return false;
        // https://bugs.chromium.org/p/v8/issues/detail?id=3056
        var test2 = {};
        for(var i = 0; i < 10; i++)test2["_" + String.fromCharCode(i)] = i;
        var order2 = Object.getOwnPropertyNames(test2).map(function(n) {
            return test2[n];
        });
        if (order2.join("") !== "0123456789") return false;
        // https://bugs.chromium.org/p/v8/issues/detail?id=3056
        var test3 = {};
        "abcdefghijklmnopqrst".split("").forEach(function(letter) {
            test3[letter] = letter;
        });
        if (Object.keys(Object.assign({}, test3)).join("") !== "abcdefghijklmnopqrst") return false;
        return true;
    } catch (err) {
        // We don't expect any of the above to throw, but better to be safe.
        return false;
    }
}
module.exports = $87870da89e628224$var$shouldUseNative() ? Object.assign : function(target, source) {
    var from;
    var to = $87870da89e628224$var$toObject(target);
    var symbols;
    for(var s = 1; s < arguments.length; s++){
        from = Object(arguments[s]);
        for(var key in from)if ($87870da89e628224$var$hasOwnProperty.call(from, key)) to[key] = from[key];
        if ($87870da89e628224$var$getOwnPropertySymbols) {
            symbols = $87870da89e628224$var$getOwnPropertySymbols(from);
            for(var i = 0; i < symbols.length; i++)if ($87870da89e628224$var$propIsEnumerable.call(from, symbols[i])) to[symbols[i]] = from[symbols[i]];
        }
    }
    return to;
};

});

parcelRegister("kJsDy", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";
var $f17e39526317790e$var$printWarning = function() {};

var $8j5uN = parcelRequire("8j5uN");
var $f17e39526317790e$var$loggedTypeFailures = {};
var $f17e39526317790e$var$has = Function.call.bind(Object.prototype.hasOwnProperty);
$f17e39526317790e$var$printWarning = function(text) {
    var message = "Warning: " + text;
    if (typeof console !== "undefined") console.error(message);
    try {
        // --- Welcome to debugging React ---
        // This error was thrown as a convenience so that you can use this stack
        // to find the callsite that caused this warning to fire.
        throw new Error(message);
    } catch (x) {}
};
/**
 * Assert that the values match with the type specs.
 * Error messages are memorized and will only be shown once.
 *
 * @param {object} typeSpecs Map of name to a ReactPropType
 * @param {object} values Runtime values that need to be type-checked
 * @param {string} location e.g. "prop", "context", "child context"
 * @param {string} componentName Name of the component for error messages.
 * @param {?Function} getStack Returns the component stack.
 * @private
 */ function $f17e39526317790e$var$checkPropTypes(typeSpecs, values, location, componentName, getStack) {
    for(var typeSpecName in typeSpecs)if ($f17e39526317790e$var$has(typeSpecs, typeSpecName)) {
        var error;
        // Prop type validation may throw. In case they do, we don't want to
        // fail the render phase where it didn't fail before. So we log it.
        // After these have been cleaned up, we'll let them throw.
        try {
            // This is intentionally an invariant that gets caught. It's the same
            // behavior as without this statement except with a better message.
            if (typeof typeSpecs[typeSpecName] !== "function") {
                var err = Error((componentName || "React class") + ": " + location + " type `" + typeSpecName + "` is invalid; " + "it must be a function, usually from the `prop-types` package, but received `" + typeof typeSpecs[typeSpecName] + "`.");
                err.name = "Invariant Violation";
                throw err;
            }
            error = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, $8j5uN);
        } catch (ex) {
            error = ex;
        }
        if (error && !(error instanceof Error)) $f17e39526317790e$var$printWarning((componentName || "React class") + ": type specification of " + location + " `" + typeSpecName + "` is invalid; the type checker " + "function must return `null` or an `Error` but returned a " + typeof error + ". " + "You may have forgotten to pass an argument to the type checker " + "creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and " + "shape all require an argument).");
        if (error instanceof Error && !(error.message in $f17e39526317790e$var$loggedTypeFailures)) {
            // Only monitor this failure once because there tends to be a lot of the
            // same error.
            $f17e39526317790e$var$loggedTypeFailures[error.message] = true;
            var stack = getStack ? getStack() : "";
            $f17e39526317790e$var$printWarning("Failed " + location + " type: " + error.message + (stack != null ? stack : ""));
        }
    }
}
/**
 * Resets warning cache when testing.
 *
 * @private
 */ $f17e39526317790e$var$checkPropTypes.resetWarningCache = function() {
    $f17e39526317790e$var$loggedTypeFailures = {};
};
module.exports = $f17e39526317790e$var$checkPropTypes;

});
parcelRegister("8j5uN", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";
var $60c45c6b0cb44b91$var$ReactPropTypesSecret = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
module.exports = $60c45c6b0cb44b91$var$ReactPropTypesSecret;

});




parcelRegister("1xEYC", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 
var $4EmWC = parcelRequire("4EmWC");
// By explicitly using `prop-types` you are opting into new development behavior.
// http://fb.me/prop-types-in-prod
var $11f8a89d85a36f13$var$throwOnDirectAccess = true;

module.exports = (parcelRequire("ahLlC"))($4EmWC.isElement, $11f8a89d85a36f13$var$throwOnDirectAccess);

});
parcelRegister("4EmWC", function(module, exports) {
"use strict";

module.exports = (parcelRequire("fWRr7"));

});
parcelRegister("fWRr7", function(module, exports) {

$parcel$export(module.exports, "AsyncMode", function () { return $b9c5b923b4ffc3bd$export$2b8d127b894957b9; }, function (v) { return $b9c5b923b4ffc3bd$export$2b8d127b894957b9 = v; });
$parcel$export(module.exports, "ConcurrentMode", function () { return $b9c5b923b4ffc3bd$export$cea3a54a6425200c; }, function (v) { return $b9c5b923b4ffc3bd$export$cea3a54a6425200c = v; });
$parcel$export(module.exports, "ContextConsumer", function () { return $b9c5b923b4ffc3bd$export$a7c73072b1a182ae; }, function (v) { return $b9c5b923b4ffc3bd$export$a7c73072b1a182ae = v; });
$parcel$export(module.exports, "ContextProvider", function () { return $b9c5b923b4ffc3bd$export$9f27bc3417b4524d; }, function (v) { return $b9c5b923b4ffc3bd$export$9f27bc3417b4524d = v; });
$parcel$export(module.exports, "Element", function () { return $b9c5b923b4ffc3bd$export$db77ccec0bb4ccac; }, function (v) { return $b9c5b923b4ffc3bd$export$db77ccec0bb4ccac = v; });
$parcel$export(module.exports, "ForwardRef", function () { return $b9c5b923b4ffc3bd$export$8392c0c9d3dcbd35; }, function (v) { return $b9c5b923b4ffc3bd$export$8392c0c9d3dcbd35 = v; });
$parcel$export(module.exports, "Fragment", function () { return $b9c5b923b4ffc3bd$export$ffb0004e005737fa; }, function (v) { return $b9c5b923b4ffc3bd$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "Lazy", function () { return $b9c5b923b4ffc3bd$export$b624eff549462981; }, function (v) { return $b9c5b923b4ffc3bd$export$b624eff549462981 = v; });
$parcel$export(module.exports, "Memo", function () { return $b9c5b923b4ffc3bd$export$7897aa7841a5380c; }, function (v) { return $b9c5b923b4ffc3bd$export$7897aa7841a5380c = v; });
$parcel$export(module.exports, "Portal", function () { return $b9c5b923b4ffc3bd$export$602eac185826482c; }, function (v) { return $b9c5b923b4ffc3bd$export$602eac185826482c = v; });
$parcel$export(module.exports, "Profiler", function () { return $b9c5b923b4ffc3bd$export$e2c29f18771995cb; }, function (v) { return $b9c5b923b4ffc3bd$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "StrictMode", function () { return $b9c5b923b4ffc3bd$export$5f8d39834fd61797; }, function (v) { return $b9c5b923b4ffc3bd$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Suspense", function () { return $b9c5b923b4ffc3bd$export$74bf444e3cd11ea5; }, function (v) { return $b9c5b923b4ffc3bd$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "isAsyncMode", function () { return $b9c5b923b4ffc3bd$export$92387174baf9b227; }, function (v) { return $b9c5b923b4ffc3bd$export$92387174baf9b227 = v; });
$parcel$export(module.exports, "isConcurrentMode", function () { return $b9c5b923b4ffc3bd$export$ec112efeb987d9c6; }, function (v) { return $b9c5b923b4ffc3bd$export$ec112efeb987d9c6 = v; });
$parcel$export(module.exports, "isContextConsumer", function () { return $b9c5b923b4ffc3bd$export$b706b080d889d2c9; }, function (v) { return $b9c5b923b4ffc3bd$export$b706b080d889d2c9 = v; });
$parcel$export(module.exports, "isContextProvider", function () { return $b9c5b923b4ffc3bd$export$5be5a87408f70ddc; }, function (v) { return $b9c5b923b4ffc3bd$export$5be5a87408f70ddc = v; });
$parcel$export(module.exports, "isElement", function () { return $b9c5b923b4ffc3bd$export$45a5e7f76e0caa8d; }, function (v) { return $b9c5b923b4ffc3bd$export$45a5e7f76e0caa8d = v; });
$parcel$export(module.exports, "isForwardRef", function () { return $b9c5b923b4ffc3bd$export$455c2e768291efa6; }, function (v) { return $b9c5b923b4ffc3bd$export$455c2e768291efa6 = v; });
$parcel$export(module.exports, "isFragment", function () { return $b9c5b923b4ffc3bd$export$9522e17588c12572; }, function (v) { return $b9c5b923b4ffc3bd$export$9522e17588c12572 = v; });
$parcel$export(module.exports, "isLazy", function () { return $b9c5b923b4ffc3bd$export$2110ac352bb060b9; }, function (v) { return $b9c5b923b4ffc3bd$export$2110ac352bb060b9 = v; });
$parcel$export(module.exports, "isMemo", function () { return $b9c5b923b4ffc3bd$export$56885ab8b9c456ab; }, function (v) { return $b9c5b923b4ffc3bd$export$56885ab8b9c456ab = v; });
$parcel$export(module.exports, "isPortal", function () { return $b9c5b923b4ffc3bd$export$d927fcb6adf8f9de; }, function (v) { return $b9c5b923b4ffc3bd$export$d927fcb6adf8f9de = v; });
$parcel$export(module.exports, "isProfiler", function () { return $b9c5b923b4ffc3bd$export$b82d16f27459e05a; }, function (v) { return $b9c5b923b4ffc3bd$export$b82d16f27459e05a = v; });
$parcel$export(module.exports, "isStrictMode", function () { return $b9c5b923b4ffc3bd$export$522c17b4f5e123e8; }, function (v) { return $b9c5b923b4ffc3bd$export$522c17b4f5e123e8 = v; });
$parcel$export(module.exports, "isSuspense", function () { return $b9c5b923b4ffc3bd$export$1aabd8a0274ecfd6; }, function (v) { return $b9c5b923b4ffc3bd$export$1aabd8a0274ecfd6 = v; });
$parcel$export(module.exports, "isValidElementType", function () { return $b9c5b923b4ffc3bd$export$9b621391a187a31a; }, function (v) { return $b9c5b923b4ffc3bd$export$9b621391a187a31a = v; });
$parcel$export(module.exports, "typeOf", function () { return $b9c5b923b4ffc3bd$export$f5bbd400c2f4426f; }, function (v) { return $b9c5b923b4ffc3bd$export$f5bbd400c2f4426f = v; });
/** @license React v16.13.1
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $b9c5b923b4ffc3bd$export$2b8d127b894957b9;
var $b9c5b923b4ffc3bd$export$cea3a54a6425200c;
var $b9c5b923b4ffc3bd$export$a7c73072b1a182ae;
var $b9c5b923b4ffc3bd$export$9f27bc3417b4524d;
var $b9c5b923b4ffc3bd$export$db77ccec0bb4ccac;
var $b9c5b923b4ffc3bd$export$8392c0c9d3dcbd35;
var $b9c5b923b4ffc3bd$export$ffb0004e005737fa;
var $b9c5b923b4ffc3bd$export$b624eff549462981;
var $b9c5b923b4ffc3bd$export$7897aa7841a5380c;
var $b9c5b923b4ffc3bd$export$602eac185826482c;
var $b9c5b923b4ffc3bd$export$e2c29f18771995cb;
var $b9c5b923b4ffc3bd$export$5f8d39834fd61797;
var $b9c5b923b4ffc3bd$export$74bf444e3cd11ea5;
var $b9c5b923b4ffc3bd$export$92387174baf9b227;
var $b9c5b923b4ffc3bd$export$ec112efeb987d9c6;
var $b9c5b923b4ffc3bd$export$b706b080d889d2c9;
var $b9c5b923b4ffc3bd$export$5be5a87408f70ddc;
var $b9c5b923b4ffc3bd$export$45a5e7f76e0caa8d;
var $b9c5b923b4ffc3bd$export$455c2e768291efa6;
var $b9c5b923b4ffc3bd$export$9522e17588c12572;
var $b9c5b923b4ffc3bd$export$2110ac352bb060b9;
var $b9c5b923b4ffc3bd$export$56885ab8b9c456ab;
var $b9c5b923b4ffc3bd$export$d927fcb6adf8f9de;
var $b9c5b923b4ffc3bd$export$b82d16f27459e05a;
var $b9c5b923b4ffc3bd$export$522c17b4f5e123e8;
var $b9c5b923b4ffc3bd$export$1aabd8a0274ecfd6;
var $b9c5b923b4ffc3bd$export$9b621391a187a31a;
var $b9c5b923b4ffc3bd$export$f5bbd400c2f4426f;
"use strict";
(function() {
    "use strict";
    // The Symbol used to tag the ReactElement-like types. If there is no native Symbol
    // nor polyfill, then a plain number is used for performance.
    var hasSymbol = typeof Symbol === "function" && Symbol.for;
    var REACT_ELEMENT_TYPE = hasSymbol ? Symbol.for("react.element") : 0xeac7;
    var REACT_PORTAL_TYPE = hasSymbol ? Symbol.for("react.portal") : 0xeaca;
    var REACT_FRAGMENT_TYPE = hasSymbol ? Symbol.for("react.fragment") : 0xeacb;
    var REACT_STRICT_MODE_TYPE = hasSymbol ? Symbol.for("react.strict_mode") : 0xeacc;
    var REACT_PROFILER_TYPE = hasSymbol ? Symbol.for("react.profiler") : 0xead2;
    var REACT_PROVIDER_TYPE = hasSymbol ? Symbol.for("react.provider") : 0xeacd;
    var REACT_CONTEXT_TYPE = hasSymbol ? Symbol.for("react.context") : 0xeace; // TODO: We don't use AsyncMode or ConcurrentMode anymore. They were temporary
    // (unstable) APIs that have been removed. Can we remove the symbols?
    var REACT_ASYNC_MODE_TYPE = hasSymbol ? Symbol.for("react.async_mode") : 0xeacf;
    var REACT_CONCURRENT_MODE_TYPE = hasSymbol ? Symbol.for("react.concurrent_mode") : 0xeacf;
    var REACT_FORWARD_REF_TYPE = hasSymbol ? Symbol.for("react.forward_ref") : 0xead0;
    var REACT_SUSPENSE_TYPE = hasSymbol ? Symbol.for("react.suspense") : 0xead1;
    var REACT_SUSPENSE_LIST_TYPE = hasSymbol ? Symbol.for("react.suspense_list") : 0xead8;
    var REACT_MEMO_TYPE = hasSymbol ? Symbol.for("react.memo") : 0xead3;
    var REACT_LAZY_TYPE = hasSymbol ? Symbol.for("react.lazy") : 0xead4;
    var REACT_BLOCK_TYPE = hasSymbol ? Symbol.for("react.block") : 0xead9;
    var REACT_FUNDAMENTAL_TYPE = hasSymbol ? Symbol.for("react.fundamental") : 0xead5;
    var REACT_RESPONDER_TYPE = hasSymbol ? Symbol.for("react.responder") : 0xead6;
    var REACT_SCOPE_TYPE = hasSymbol ? Symbol.for("react.scope") : 0xead7;
    function isValidElementType(type) {
        return typeof type === "string" || typeof type === "function" || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
        type === REACT_FRAGMENT_TYPE || type === REACT_CONCURRENT_MODE_TYPE || type === REACT_PROFILER_TYPE || type === REACT_STRICT_MODE_TYPE || type === REACT_SUSPENSE_TYPE || type === REACT_SUSPENSE_LIST_TYPE || typeof type === "object" && type !== null && (type.$$typeof === REACT_LAZY_TYPE || type.$$typeof === REACT_MEMO_TYPE || type.$$typeof === REACT_PROVIDER_TYPE || type.$$typeof === REACT_CONTEXT_TYPE || type.$$typeof === REACT_FORWARD_REF_TYPE || type.$$typeof === REACT_FUNDAMENTAL_TYPE || type.$$typeof === REACT_RESPONDER_TYPE || type.$$typeof === REACT_SCOPE_TYPE || type.$$typeof === REACT_BLOCK_TYPE);
    }
    function typeOf(object) {
        if (typeof object === "object" && object !== null) {
            var $$typeof = object.$$typeof;
            switch($$typeof){
                case REACT_ELEMENT_TYPE:
                    var type = object.type;
                    switch(type){
                        case REACT_ASYNC_MODE_TYPE:
                        case REACT_CONCURRENT_MODE_TYPE:
                        case REACT_FRAGMENT_TYPE:
                        case REACT_PROFILER_TYPE:
                        case REACT_STRICT_MODE_TYPE:
                        case REACT_SUSPENSE_TYPE:
                            return type;
                        default:
                            var $$typeofType = type && type.$$typeof;
                            switch($$typeofType){
                                case REACT_CONTEXT_TYPE:
                                case REACT_FORWARD_REF_TYPE:
                                case REACT_LAZY_TYPE:
                                case REACT_MEMO_TYPE:
                                case REACT_PROVIDER_TYPE:
                                    return $$typeofType;
                                default:
                                    return $$typeof;
                            }
                    }
                case REACT_PORTAL_TYPE:
                    return $$typeof;
            }
        }
        return undefined;
    } // AsyncMode is deprecated along with isAsyncMode
    var AsyncMode = REACT_ASYNC_MODE_TYPE;
    var ConcurrentMode = REACT_CONCURRENT_MODE_TYPE;
    var ContextConsumer = REACT_CONTEXT_TYPE;
    var ContextProvider = REACT_PROVIDER_TYPE;
    var Element = REACT_ELEMENT_TYPE;
    var ForwardRef = REACT_FORWARD_REF_TYPE;
    var Fragment = REACT_FRAGMENT_TYPE;
    var Lazy = REACT_LAZY_TYPE;
    var Memo = REACT_MEMO_TYPE;
    var Portal = REACT_PORTAL_TYPE;
    var Profiler = REACT_PROFILER_TYPE;
    var StrictMode = REACT_STRICT_MODE_TYPE;
    var Suspense = REACT_SUSPENSE_TYPE;
    var hasWarnedAboutDeprecatedIsAsyncMode = false; // AsyncMode should be deprecated
    function isAsyncMode(object) {
        if (!hasWarnedAboutDeprecatedIsAsyncMode) {
            hasWarnedAboutDeprecatedIsAsyncMode = true; // Using console['warn'] to evade Babel and ESLint
            console["warn"]("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.");
        }
        return isConcurrentMode(object) || typeOf(object) === REACT_ASYNC_MODE_TYPE;
    }
    function isConcurrentMode(object) {
        return typeOf(object) === REACT_CONCURRENT_MODE_TYPE;
    }
    function isContextConsumer(object) {
        return typeOf(object) === REACT_CONTEXT_TYPE;
    }
    function isContextProvider(object) {
        return typeOf(object) === REACT_PROVIDER_TYPE;
    }
    function isElement(object) {
        return typeof object === "object" && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
    }
    function isForwardRef(object) {
        return typeOf(object) === REACT_FORWARD_REF_TYPE;
    }
    function isFragment(object) {
        return typeOf(object) === REACT_FRAGMENT_TYPE;
    }
    function isLazy(object) {
        return typeOf(object) === REACT_LAZY_TYPE;
    }
    function isMemo(object) {
        return typeOf(object) === REACT_MEMO_TYPE;
    }
    function isPortal(object) {
        return typeOf(object) === REACT_PORTAL_TYPE;
    }
    function isProfiler(object) {
        return typeOf(object) === REACT_PROFILER_TYPE;
    }
    function isStrictMode(object) {
        return typeOf(object) === REACT_STRICT_MODE_TYPE;
    }
    function isSuspense(object) {
        return typeOf(object) === REACT_SUSPENSE_TYPE;
    }
    $b9c5b923b4ffc3bd$export$2b8d127b894957b9 = AsyncMode;
    $b9c5b923b4ffc3bd$export$cea3a54a6425200c = ConcurrentMode;
    $b9c5b923b4ffc3bd$export$a7c73072b1a182ae = ContextConsumer;
    $b9c5b923b4ffc3bd$export$9f27bc3417b4524d = ContextProvider;
    $b9c5b923b4ffc3bd$export$db77ccec0bb4ccac = Element;
    $b9c5b923b4ffc3bd$export$8392c0c9d3dcbd35 = ForwardRef;
    $b9c5b923b4ffc3bd$export$ffb0004e005737fa = Fragment;
    $b9c5b923b4ffc3bd$export$b624eff549462981 = Lazy;
    $b9c5b923b4ffc3bd$export$7897aa7841a5380c = Memo;
    $b9c5b923b4ffc3bd$export$602eac185826482c = Portal;
    $b9c5b923b4ffc3bd$export$e2c29f18771995cb = Profiler;
    $b9c5b923b4ffc3bd$export$5f8d39834fd61797 = StrictMode;
    $b9c5b923b4ffc3bd$export$74bf444e3cd11ea5 = Suspense;
    $b9c5b923b4ffc3bd$export$92387174baf9b227 = isAsyncMode;
    $b9c5b923b4ffc3bd$export$ec112efeb987d9c6 = isConcurrentMode;
    $b9c5b923b4ffc3bd$export$b706b080d889d2c9 = isContextConsumer;
    $b9c5b923b4ffc3bd$export$5be5a87408f70ddc = isContextProvider;
    $b9c5b923b4ffc3bd$export$45a5e7f76e0caa8d = isElement;
    $b9c5b923b4ffc3bd$export$455c2e768291efa6 = isForwardRef;
    $b9c5b923b4ffc3bd$export$9522e17588c12572 = isFragment;
    $b9c5b923b4ffc3bd$export$2110ac352bb060b9 = isLazy;
    $b9c5b923b4ffc3bd$export$56885ab8b9c456ab = isMemo;
    $b9c5b923b4ffc3bd$export$d927fcb6adf8f9de = isPortal;
    $b9c5b923b4ffc3bd$export$b82d16f27459e05a = isProfiler;
    $b9c5b923b4ffc3bd$export$522c17b4f5e123e8 = isStrictMode;
    $b9c5b923b4ffc3bd$export$1aabd8a0274ecfd6 = isSuspense;
    $b9c5b923b4ffc3bd$export$9b621391a187a31a = isValidElementType;
    $b9c5b923b4ffc3bd$export$f5bbd400c2f4426f = typeOf;
})();

});


parcelRegister("ahLlC", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";

var $4EmWC = parcelRequire("4EmWC");

var $bDppX = parcelRequire("bDppX");

var $8j5uN = parcelRequire("8j5uN");

var $kJsDy = parcelRequire("kJsDy");
var $77d0382bd24d41ae$var$has = Function.call.bind(Object.prototype.hasOwnProperty);
var $77d0382bd24d41ae$var$printWarning = function() {};
$77d0382bd24d41ae$var$printWarning = function(text) {
    var message = "Warning: " + text;
    if (typeof console !== "undefined") console.error(message);
    try {
        // --- Welcome to debugging React ---
        // This error was thrown as a convenience so that you can use this stack
        // to find the callsite that caused this warning to fire.
        throw new Error(message);
    } catch (x) {}
};
function $77d0382bd24d41ae$var$emptyFunctionThatReturnsNull() {
    return null;
}
module.exports = function(isValidElement, throwOnDirectAccess) {
    /* global Symbol */ var ITERATOR_SYMBOL = typeof Symbol === "function" && Symbol.iterator;
    var FAUX_ITERATOR_SYMBOL = "@@iterator"; // Before Symbol spec.
    /**
   * Returns the iterator method function contained on the iterable object.
   *
   * Be sure to invoke the function with the iterable as context:
   *
   *     var iteratorFn = getIteratorFn(myIterable);
   *     if (iteratorFn) {
   *       var iterator = iteratorFn.call(myIterable);
   *       ...
   *     }
   *
   * @param {?object} maybeIterable
   * @return {?function}
   */ function getIteratorFn(maybeIterable) {
        var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
        if (typeof iteratorFn === "function") return iteratorFn;
    }
    /**
   * Collection of methods that allow declaration and validation of props that are
   * supplied to React components. Example usage:
   *
   *   var Props = require('ReactPropTypes');
   *   var MyArticle = React.createClass({
   *     propTypes: {
   *       // An optional string prop named "description".
   *       description: Props.string,
   *
   *       // A required enum prop named "category".
   *       category: Props.oneOf(['News','Photos']).isRequired,
   *
   *       // A prop named "dialog" that requires an instance of Dialog.
   *       dialog: Props.instanceOf(Dialog).isRequired
   *     },
   *     render: function() { ... }
   *   });
   *
   * A more formal specification of how these methods are used:
   *
   *   type := array|bool|func|object|number|string|oneOf([...])|instanceOf(...)
   *   decl := ReactPropTypes.{type}(.isRequired)?
   *
   * Each and every declaration produces a function with the same signature. This
   * allows the creation of custom validation functions. For example:
   *
   *  var MyLink = React.createClass({
   *    propTypes: {
   *      // An optional string or URI prop named "href".
   *      href: function(props, propName, componentName) {
   *        var propValue = props[propName];
   *        if (propValue != null && typeof propValue !== 'string' &&
   *            !(propValue instanceof URI)) {
   *          return new Error(
   *            'Expected a string or an URI for ' + propName + ' in ' +
   *            componentName
   *          );
   *        }
   *      }
   *    },
   *    render: function() {...}
   *  });
   *
   * @internal
   */ var ANONYMOUS = "<<anonymous>>";
    // Important!
    // Keep this list in sync with production version in `./factoryWithThrowingShims.js`.
    var ReactPropTypes = {
        array: createPrimitiveTypeChecker("array"),
        bool: createPrimitiveTypeChecker("boolean"),
        func: createPrimitiveTypeChecker("function"),
        number: createPrimitiveTypeChecker("number"),
        object: createPrimitiveTypeChecker("object"),
        string: createPrimitiveTypeChecker("string"),
        symbol: createPrimitiveTypeChecker("symbol"),
        any: createAnyTypeChecker(),
        arrayOf: createArrayOfTypeChecker,
        element: createElementTypeChecker(),
        elementType: createElementTypeTypeChecker(),
        instanceOf: createInstanceTypeChecker,
        node: createNodeChecker(),
        objectOf: createObjectOfTypeChecker,
        oneOf: createEnumTypeChecker,
        oneOfType: createUnionTypeChecker,
        shape: createShapeTypeChecker,
        exact: createStrictShapeTypeChecker
    };
    /**
   * inlined Object.is polyfill to avoid requiring consumers ship their own
   * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
   */ /*eslint-disable no-self-compare*/ function is(x, y) {
        // SameValue algorithm
        if (x === y) // Steps 1-5, 7-10
        // Steps 6.b-6.e: +0 != -0
        return x !== 0 || 1 / x === 1 / y;
        else // Step 6.a: NaN == NaN
        return x !== x && y !== y;
    }
    /*eslint-enable no-self-compare*/ /**
   * We use an Error-like object for backward compatibility as people may call
   * PropTypes directly and inspect their output. However, we don't use real
   * Errors anymore. We don't inspect their stack anyway, and creating them
   * is prohibitively expensive if they are created too often, such as what
   * happens in oneOfType() for any type before the one that matched.
   */ function PropTypeError(message) {
        this.message = message;
        this.stack = "";
    }
    // Make `instanceof Error` still work for returned errors.
    PropTypeError.prototype = Error.prototype;
    function createChainableTypeChecker(validate) {
        var manualPropTypeCallCache = {};
        var manualPropTypeWarningCount = 0;
        function checkType(isRequired, props, propName, componentName, location, propFullName, secret) {
            componentName = componentName || ANONYMOUS;
            propFullName = propFullName || propName;
            if (secret !== $8j5uN) {
                if (throwOnDirectAccess) {
                    // New behavior only for users of `prop-types` package
                    var err = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use `PropTypes.checkPropTypes()` to call them. Read more at http://fb.me/use-check-prop-types");
                    err.name = "Invariant Violation";
                    throw err;
                } else if (typeof console !== "undefined") {
                    // Old behavior for people using React.PropTypes
                    var cacheKey = componentName + ":" + propName;
                    if (!manualPropTypeCallCache[cacheKey] && // Avoid spamming the console because they are often not actionable except for lib authors
                    manualPropTypeWarningCount < 3) {
                        $77d0382bd24d41ae$var$printWarning("You are manually calling a React.PropTypes validation function for the `" + propFullName + "` prop on `" + componentName + "`. This is deprecated " + "and will throw in the standalone `prop-types` package. " + "You may be seeing this warning due to a third-party PropTypes " + "library. See https://fb.me/react-warning-dont-call-proptypes " + "for details.");
                        manualPropTypeCallCache[cacheKey] = true;
                        manualPropTypeWarningCount++;
                    }
                }
            }
            if (props[propName] == null) {
                if (isRequired) {
                    if (props[propName] === null) return new PropTypeError("The " + location + " `" + propFullName + "` is marked as required " + ("in `" + componentName + "`, but its value is `null`."));
                    return new PropTypeError("The " + location + " `" + propFullName + "` is marked as required in " + ("`" + componentName + "`, but its value is `undefined`."));
                }
                return null;
            } else return validate(props, propName, componentName, location, propFullName);
        }
        var chainedCheckType = checkType.bind(null, false);
        chainedCheckType.isRequired = checkType.bind(null, true);
        return chainedCheckType;
    }
    function createPrimitiveTypeChecker(expectedType) {
        function validate(props, propName, componentName, location, propFullName, secret) {
            var propValue = props[propName];
            var propType = getPropType(propValue);
            if (propType !== expectedType) {
                // `propValue` being instance of, say, date/regexp, pass the 'object'
                // check, but we can offer a more precise error message here rather than
                // 'of type `object`'.
                var preciseType = getPreciseType(propValue);
                return new PropTypeError("Invalid " + location + " `" + propFullName + "` of type " + ("`" + preciseType + "` supplied to `" + componentName + "`, expected ") + ("`" + expectedType + "`."));
            }
            return null;
        }
        return createChainableTypeChecker(validate);
    }
    function createAnyTypeChecker() {
        return createChainableTypeChecker($77d0382bd24d41ae$var$emptyFunctionThatReturnsNull);
    }
    function createArrayOfTypeChecker(typeChecker) {
        function validate(props, propName, componentName, location, propFullName) {
            if (typeof typeChecker !== "function") return new PropTypeError("Property `" + propFullName + "` of component `" + componentName + "` has invalid PropType notation inside arrayOf.");
            var propValue = props[propName];
            if (!Array.isArray(propValue)) {
                var propType = getPropType(propValue);
                return new PropTypeError("Invalid " + location + " `" + propFullName + "` of type " + ("`" + propType + "` supplied to `" + componentName + "`, expected an array."));
            }
            for(var i = 0; i < propValue.length; i++){
                var error = typeChecker(propValue, i, componentName, location, propFullName + "[" + i + "]", $8j5uN);
                if (error instanceof Error) return error;
            }
            return null;
        }
        return createChainableTypeChecker(validate);
    }
    function createElementTypeChecker() {
        function validate(props, propName, componentName, location, propFullName) {
            var propValue = props[propName];
            if (!isValidElement(propValue)) {
                var propType = getPropType(propValue);
                return new PropTypeError("Invalid " + location + " `" + propFullName + "` of type " + ("`" + propType + "` supplied to `" + componentName + "`, expected a single ReactElement."));
            }
            return null;
        }
        return createChainableTypeChecker(validate);
    }
    function createElementTypeTypeChecker() {
        function validate(props, propName, componentName, location, propFullName) {
            var propValue = props[propName];
            if (!$4EmWC.isValidElementType(propValue)) {
                var propType = getPropType(propValue);
                return new PropTypeError("Invalid " + location + " `" + propFullName + "` of type " + ("`" + propType + "` supplied to `" + componentName + "`, expected a single ReactElement type."));
            }
            return null;
        }
        return createChainableTypeChecker(validate);
    }
    function createInstanceTypeChecker(expectedClass) {
        function validate(props, propName, componentName, location, propFullName) {
            if (!(props[propName] instanceof expectedClass)) {
                var expectedClassName = expectedClass.name || ANONYMOUS;
                var actualClassName = getClassName(props[propName]);
                return new PropTypeError("Invalid " + location + " `" + propFullName + "` of type " + ("`" + actualClassName + "` supplied to `" + componentName + "`, expected ") + ("instance of `" + expectedClassName + "`."));
            }
            return null;
        }
        return createChainableTypeChecker(validate);
    }
    function createEnumTypeChecker(expectedValues) {
        if (!Array.isArray(expectedValues)) {
            {
                if (arguments.length > 1) $77d0382bd24d41ae$var$printWarning("Invalid arguments supplied to oneOf, expected an array, got " + arguments.length + " arguments. " + "A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z]).");
                else $77d0382bd24d41ae$var$printWarning("Invalid argument supplied to oneOf, expected an array.");
            }
            return $77d0382bd24d41ae$var$emptyFunctionThatReturnsNull;
        }
        function validate(props, propName, componentName, location, propFullName) {
            var propValue = props[propName];
            for(var i = 0; i < expectedValues.length; i++){
                if (is(propValue, expectedValues[i])) return null;
            }
            var valuesString = JSON.stringify(expectedValues, function replacer(key, value) {
                var type = getPreciseType(value);
                if (type === "symbol") return String(value);
                return value;
            });
            return new PropTypeError("Invalid " + location + " `" + propFullName + "` of value `" + String(propValue) + "` " + ("supplied to `" + componentName + "`, expected one of " + valuesString + "."));
        }
        return createChainableTypeChecker(validate);
    }
    function createObjectOfTypeChecker(typeChecker) {
        function validate(props, propName, componentName, location, propFullName) {
            if (typeof typeChecker !== "function") return new PropTypeError("Property `" + propFullName + "` of component `" + componentName + "` has invalid PropType notation inside objectOf.");
            var propValue = props[propName];
            var propType = getPropType(propValue);
            if (propType !== "object") return new PropTypeError("Invalid " + location + " `" + propFullName + "` of type " + ("`" + propType + "` supplied to `" + componentName + "`, expected an object."));
            for(var key in propValue)if ($77d0382bd24d41ae$var$has(propValue, key)) {
                var error = typeChecker(propValue, key, componentName, location, propFullName + "." + key, $8j5uN);
                if (error instanceof Error) return error;
            }
            return null;
        }
        return createChainableTypeChecker(validate);
    }
    function createUnionTypeChecker(arrayOfTypeCheckers) {
        if (!Array.isArray(arrayOfTypeCheckers)) {
            $77d0382bd24d41ae$var$printWarning("Invalid argument supplied to oneOfType, expected an instance of array.");
            return $77d0382bd24d41ae$var$emptyFunctionThatReturnsNull;
        }
        for(var i = 0; i < arrayOfTypeCheckers.length; i++){
            var checker = arrayOfTypeCheckers[i];
            if (typeof checker !== "function") {
                $77d0382bd24d41ae$var$printWarning("Invalid argument supplied to oneOfType. Expected an array of check functions, but received " + getPostfixForTypeWarning(checker) + " at index " + i + ".");
                return $77d0382bd24d41ae$var$emptyFunctionThatReturnsNull;
            }
        }
        function validate(props, propName, componentName, location, propFullName) {
            for(var i = 0; i < arrayOfTypeCheckers.length; i++){
                var checker = arrayOfTypeCheckers[i];
                if (checker(props, propName, componentName, location, propFullName, $8j5uN) == null) return null;
            }
            return new PropTypeError("Invalid " + location + " `" + propFullName + "` supplied to " + ("`" + componentName + "`."));
        }
        return createChainableTypeChecker(validate);
    }
    function createNodeChecker() {
        function validate(props, propName, componentName, location, propFullName) {
            if (!isNode(props[propName])) return new PropTypeError("Invalid " + location + " `" + propFullName + "` supplied to " + ("`" + componentName + "`, expected a ReactNode."));
            return null;
        }
        return createChainableTypeChecker(validate);
    }
    function createShapeTypeChecker(shapeTypes) {
        function validate(props, propName, componentName, location, propFullName) {
            var propValue = props[propName];
            var propType = getPropType(propValue);
            if (propType !== "object") return new PropTypeError("Invalid " + location + " `" + propFullName + "` of type `" + propType + "` " + ("supplied to `" + componentName + "`, expected `object`."));
            for(var key in shapeTypes){
                var checker = shapeTypes[key];
                if (!checker) continue;
                var error = checker(propValue, key, componentName, location, propFullName + "." + key, $8j5uN);
                if (error) return error;
            }
            return null;
        }
        return createChainableTypeChecker(validate);
    }
    function createStrictShapeTypeChecker(shapeTypes) {
        function validate(props, propName, componentName, location, propFullName) {
            var propValue = props[propName];
            var propType = getPropType(propValue);
            if (propType !== "object") return new PropTypeError("Invalid " + location + " `" + propFullName + "` of type `" + propType + "` " + ("supplied to `" + componentName + "`, expected `object`."));
            // We need to check all keys in case some are required but missing from
            // props.
            var allKeys = $bDppX({}, props[propName], shapeTypes);
            for(var key in allKeys){
                var checker = shapeTypes[key];
                if (!checker) return new PropTypeError("Invalid " + location + " `" + propFullName + "` key `" + key + "` supplied to `" + componentName + "`." + "\nBad object: " + JSON.stringify(props[propName], null, "  ") + "\nValid keys: " + JSON.stringify(Object.keys(shapeTypes), null, "  "));
                var error = checker(propValue, key, componentName, location, propFullName + "." + key, $8j5uN);
                if (error) return error;
            }
            return null;
        }
        return createChainableTypeChecker(validate);
    }
    function isNode(propValue) {
        switch(typeof propValue){
            case "number":
            case "string":
            case "undefined":
                return true;
            case "boolean":
                return !propValue;
            case "object":
                if (Array.isArray(propValue)) return propValue.every(isNode);
                if (propValue === null || isValidElement(propValue)) return true;
                var iteratorFn = getIteratorFn(propValue);
                if (iteratorFn) {
                    var iterator = iteratorFn.call(propValue);
                    var step;
                    if (iteratorFn !== propValue.entries) while(!(step = iterator.next()).done){
                        if (!isNode(step.value)) return false;
                    }
                    else // Iterator will provide entry [k,v] tuples rather than values.
                    while(!(step = iterator.next()).done){
                        var entry = step.value;
                        if (entry) {
                            if (!isNode(entry[1])) return false;
                        }
                    }
                } else return false;
                return true;
            default:
                return false;
        }
    }
    function isSymbol(propType, propValue) {
        // Native Symbol.
        if (propType === "symbol") return true;
        // falsy value can't be a Symbol
        if (!propValue) return false;
        // 19.4.3.5 Symbol.prototype[@@toStringTag] === 'Symbol'
        if (propValue["@@toStringTag"] === "Symbol") return true;
        // Fallback for non-spec compliant Symbols which are polyfilled.
        if (typeof Symbol === "function" && propValue instanceof Symbol) return true;
        return false;
    }
    // Equivalent of `typeof` but with special handling for array and regexp.
    function getPropType(propValue) {
        var propType = typeof propValue;
        if (Array.isArray(propValue)) return "array";
        if (propValue instanceof RegExp) // Old webkits (at least until Android 4.0) return 'function' rather than
        // 'object' for typeof a RegExp. We'll normalize this here so that /bla/
        // passes PropTypes.object.
        return "object";
        if (isSymbol(propType, propValue)) return "symbol";
        return propType;
    }
    // This handles more types than `getPropType`. Only used for error messages.
    // See `createPrimitiveTypeChecker`.
    function getPreciseType(propValue) {
        if (typeof propValue === "undefined" || propValue === null) return "" + propValue;
        var propType = getPropType(propValue);
        if (propType === "object") {
            if (propValue instanceof Date) return "date";
            else if (propValue instanceof RegExp) return "regexp";
        }
        return propType;
    }
    // Returns a string that is postfixed to a warning about an invalid type.
    // For example, "undefined" or "of type array"
    function getPostfixForTypeWarning(value) {
        var type = getPreciseType(value);
        switch(type){
            case "array":
            case "object":
                return "an " + type;
            case "boolean":
            case "date":
            case "regexp":
                return "a " + type;
            default:
                return type;
        }
    }
    // Returns class name of the object, if any.
    function getClassName(propValue) {
        if (!propValue.constructor || !propValue.constructor.name) return ANONYMOUS;
        return propValue.constructor.name;
    }
    ReactPropTypes.checkPropTypes = $kJsDy;
    ReactPropTypes.resetWarningCache = $kJsDy.resetWarningCache;
    ReactPropTypes.PropTypes = ReactPropTypes;
    return ReactPropTypes;
};

});


parcelRegister("jf4OJ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e02327a008895d3d$export$2e2bcd8739ae039; });

var $13Fe7 = parcelRequire("13Fe7");

var $9CubZ = parcelRequire("9CubZ");
var $e02327a008895d3d$export$779da81cd30caf6c = "exact-prop: \u200B";
function $e02327a008895d3d$export$2e2bcd8739ae039(propTypes) {
    return (0, $9CubZ.default)({}, propTypes, (0, $13Fe7.default)({}, $e02327a008895d3d$export$779da81cd30caf6c, function(props) {
        var unsupportedProps = Object.keys(props).filter(function(prop) {
            return !propTypes.hasOwnProperty(prop);
        });
        if (unsupportedProps.length > 0) return new Error("The following props are not supported: ".concat(unsupportedProps.map(function(prop) {
            return "`".concat(prop, "`");
        }).join(", "), ". Please remove them."));
        return null;
    }));
}

});
parcelRegister("13Fe7", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0c560d08d668961b$export$2e2bcd8739ae039; });
function $0c560d08d668961b$export$2e2bcd8739ae039(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}

});

parcelRegister("9CubZ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $700f1543d9e08bb1$export$2e2bcd8739ae039; });
function $700f1543d9e08bb1$export$2e2bcd8739ae039() {
    $700f1543d9e08bb1$export$2e2bcd8739ae039 = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $700f1543d9e08bb1$export$2e2bcd8739ae039.apply(this, arguments);
}

});


parcelRegister("6WDy5", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $50e6d666cd7a3ddf$export$2e2bcd8739ae039; });

var $cQNHH = parcelRequire("cQNHH");

var $2FoLs = parcelRequire("2FoLs");
function $50e6d666cd7a3ddf$export$2e2bcd8739ae039() {
    var theme = (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).useContext((0, $2FoLs.default));
    // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).useDebugValue(theme);
    return theme;
}

});
parcelRegister("2FoLs", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1f129ed25eb86631$export$2e2bcd8739ae039; });

var $cQNHH = parcelRequire("cQNHH");
var $1f129ed25eb86631$var$ThemeContext = (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createContext(null);
$1f129ed25eb86631$var$ThemeContext.displayName = "ThemeContext";
var $1f129ed25eb86631$export$2e2bcd8739ae039 = $1f129ed25eb86631$var$ThemeContext;

});


parcelRegister("dLwnG", function(module, exports) {
"use strict";
function $a058c85580ba5e0b$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === "undefined" || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== "function") return;
    var err;
    // This branch is unreachable because this function is only called
    // in production, but the condition is true only in development.
    // Therefore if the branch is still here, dead code elimination wasn't
    // properly applied.
    // Don't change the message. React DevTools relies on it. Also make sure
    // this message doesn't occur elsewhere in this function, or it will cause
    // a false positive.
    throw new Error("^_^");
}

module.exports = (parcelRequire("ia7MJ"));

});
parcelRegister("ia7MJ", function(module, exports) {
/** @license React v16.13.1
 * react-dom.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";





(function() {
    "use strict";
    var React = (parcelRequire("cQNHH"));
    var _assign = (parcelRequire("bDppX"));
    var Scheduler = (parcelRequire("1MX31"));
    var checkPropTypes = (parcelRequire("kJsDy"));
    var tracing = (parcelRequire("fGF8G"));
    var ReactSharedInternals = React.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED; // Prevent newer renderers from RTE when used with older react package versions.
    // Current owner and dispatcher used to share the same ref,
    // but PR #14548 split them out to better support the react-debug-tools package.
    if (!ReactSharedInternals.hasOwnProperty("ReactCurrentDispatcher")) ReactSharedInternals.ReactCurrentDispatcher = {
        current: null
    };
    if (!ReactSharedInternals.hasOwnProperty("ReactCurrentBatchConfig")) ReactSharedInternals.ReactCurrentBatchConfig = {
        suspense: null
    };
    // by calls to these methods by a Babel plugin.
    //
    // In PROD (or in packages without access to React internals),
    // they are left as they are instead.
    function warn(format) {
        for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
        printWarning("warn", format, args);
    }
    function error(format) {
        for(var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++)args[_key2 - 1] = arguments[_key2];
        printWarning("error", format, args);
    }
    function printWarning(level, format, args) {
        var hasExistingStack = args.length > 0 && typeof args[args.length - 1] === "string" && args[args.length - 1].indexOf("\n    in") === 0;
        if (!hasExistingStack) {
            var ReactDebugCurrentFrame = ReactSharedInternals.ReactDebugCurrentFrame;
            var stack = ReactDebugCurrentFrame.getStackAddendum();
            if (stack !== "") {
                format += "%s";
                args = args.concat([
                    stack
                ]);
            }
        }
        var argsWithFormat = args.map(function(item) {
            return "" + item;
        }); // Careful: RN currently depends on this prefix
        argsWithFormat.unshift("Warning: " + format); // We intentionally don't use spread (or .apply) directly because it
        // breaks IE9: https://github.com/facebook/react/issues/13610
        // eslint-disable-next-line react-internal/no-production-logging
        Function.prototype.apply.call(console[level], console, argsWithFormat);
        try {
            // --- Welcome to debugging React ---
            // This error was thrown as a convenience so that you can use this stack
            // to find the callsite that caused this warning to fire.
            var argIndex = 0;
            var message = "Warning: " + format.replace(/%s/g, function() {
                return args[argIndex++];
            });
            throw new Error(message);
        } catch (x) {}
    }
    if (!React) throw Error("ReactDOM was loaded before React. Make sure you load the React package before loading ReactDOM.");
    var invokeGuardedCallbackImpl = function(name, func, context, a, b, c, d, e, f) {
        var funcArgs = Array.prototype.slice.call(arguments, 3);
        try {
            func.apply(context, funcArgs);
        } catch (error) {
            this.onError(error);
        }
    };
    // In DEV mode, we swap out invokeGuardedCallback for a special version
    // that plays more nicely with the browser's DevTools. The idea is to preserve
    // "Pause on exceptions" behavior. Because React wraps all user-provided
    // functions in invokeGuardedCallback, and the production version of
    // invokeGuardedCallback uses a try-catch, all user exceptions are treated
    // like caught exceptions, and the DevTools won't pause unless the developer
    // takes the extra step of enabling pause on caught exceptions. This is
    // unintuitive, though, because even though React has caught the error, from
    // the developer's perspective, the error is uncaught.
    //
    // To preserve the expected "Pause on exceptions" behavior, we don't use a
    // try-catch in DEV. Instead, we synchronously dispatch a fake event to a fake
    // DOM node, and call the user-provided callback from inside an event handler
    // for that fake event. If the callback throws, the error is "captured" using
    // a global event handler. But because the error happens in a different
    // event loop context, it does not interrupt the normal program flow.
    // Effectively, this gives us try-catch behavior without actually using
    // try-catch. Neat!
    // Check that the browser supports the APIs we need to implement our special
    // DEV version of invokeGuardedCallback
    if (typeof window !== "undefined" && typeof window.dispatchEvent === "function" && typeof document !== "undefined" && typeof document.createEvent === "function") {
        var fakeNode = document.createElement("react");
        var invokeGuardedCallbackDev = function(name, func, context, a, b, c, d, e, f) {
            // If document doesn't exist we know for sure we will crash in this method
            // when we call document.createEvent(). However this can cause confusing
            // errors: https://github.com/facebookincubator/create-react-app/issues/3482
            // So we preemptively throw with a better message instead.
            if (!(typeof document !== "undefined")) throw Error("The `document` global was defined when React was initialized, but is not defined anymore. This can happen in a test environment if a component schedules an update from an asynchronous callback, but the test has already finished running. To solve this, you can either unmount the component at the end of your test (and ensure that any asynchronous operations get canceled in `componentWillUnmount`), or you can change the test itself to be asynchronous.");
            var evt = document.createEvent("Event"); // Keeps track of whether the user-provided callback threw an error. We
            // set this to true at the beginning, then set it to false right after
            // calling the function. If the function errors, `didError` will never be
            // set to false. This strategy works even if the browser is flaky and
            // fails to call our global error handler, because it doesn't rely on
            // the error event at all.
            var didError = true; // Keeps track of the value of window.event so that we can reset it
            // during the callback to let user code access window.event in the
            // browsers that support it.
            var windowEvent = window.event; // Keeps track of the descriptor of window.event to restore it after event
            // dispatching: https://github.com/facebook/react/issues/13688
            var windowEventDescriptor = Object.getOwnPropertyDescriptor(window, "event"); // Create an event handler for our fake event. We will synchronously
            // dispatch our fake event using `dispatchEvent`. Inside the handler, we
            // call the user-provided callback.
            var funcArgs = Array.prototype.slice.call(arguments, 3);
            function callCallback() {
                // We immediately remove the callback from event listeners so that
                // nested `invokeGuardedCallback` calls do not clash. Otherwise, a
                // nested call would trigger the fake event handlers of any call higher
                // in the stack.
                fakeNode.removeEventListener(evtType, callCallback, false); // We check for window.hasOwnProperty('event') to prevent the
                // window.event assignment in both IE <= 10 as they throw an error
                // "Member not found" in strict mode, and in Firefox which does not
                // support window.event.
                if (typeof window.event !== "undefined" && window.hasOwnProperty("event")) window.event = windowEvent;
                func.apply(context, funcArgs);
                didError = false;
            } // Create a global error event handler. We use this to capture the value
            // that was thrown. It's possible that this error handler will fire more
            // than once; for example, if non-React code also calls `dispatchEvent`
            // and a handler for that event throws. We should be resilient to most of
            // those cases. Even if our error event handler fires more than once, the
            // last error event is always used. If the callback actually does error,
            // we know that the last error event is the correct one, because it's not
            // possible for anything else to have happened in between our callback
            // erroring and the code that follows the `dispatchEvent` call below. If
            // the callback doesn't error, but the error event was fired, we know to
            // ignore it because `didError` will be false, as described above.
            var error; // Use this to track whether the error event is ever called.
            var didSetError = false;
            var isCrossOriginError = false;
            function handleWindowError(event) {
                error = event.error;
                didSetError = true;
                if (error === null && event.colno === 0 && event.lineno === 0) isCrossOriginError = true;
                if (event.defaultPrevented) {
                    // Some other error handler has prevented default.
                    // Browsers silence the error report if this happens.
                    // We'll remember this to later decide whether to log it or not.
                    if (error != null && typeof error === "object") try {
                        error._suppressLogging = true;
                    } catch (inner) {}
                }
            } // Create a fake event type.
            var evtType = "react-" + (name ? name : "invokeguardedcallback"); // Attach our event handlers
            window.addEventListener("error", handleWindowError);
            fakeNode.addEventListener(evtType, callCallback, false); // Synchronously dispatch our fake event. If the user-provided function
            // errors, it will trigger our global error handler.
            evt.initEvent(evtType, false, false);
            fakeNode.dispatchEvent(evt);
            if (windowEventDescriptor) Object.defineProperty(window, "event", windowEventDescriptor);
            if (didError) {
                if (!didSetError) // The callback errored, but the error event never fired.
                error = new Error("An error was thrown inside one of your components, but React doesn't know what it was. This is likely due to browser flakiness. React does its best to preserve the \"Pause on exceptions\" behavior of the DevTools, which requires some DEV-mode only tricks. It's possible that these don't work in your browser. Try triggering the error in production mode, or switching to a modern browser. If you suspect that this is actually an issue with React, please file an issue.");
                else if (isCrossOriginError) error = new Error("A cross-origin error was thrown. React doesn't have access to the actual error object in development. See https://fb.me/react-crossorigin-error for more information.");
                this.onError(error);
            } // Remove our event listeners
            window.removeEventListener("error", handleWindowError);
        };
        invokeGuardedCallbackImpl = invokeGuardedCallbackDev;
    }
    var invokeGuardedCallbackImpl$1 = invokeGuardedCallbackImpl;
    var hasError = false;
    var caughtError = null; // Used by event system to capture/rethrow the first error.
    var hasRethrowError = false;
    var rethrowError = null;
    var reporter = {
        onError: function(error) {
            hasError = true;
            caughtError = error;
        }
    };
    /**
 * Call a function while guarding against errors that happens within it.
 * Returns an error if it throws, otherwise null.
 *
 * In production, this is implemented using a try-catch. The reason we don't
 * use a try-catch directly is so that we can swap out a different
 * implementation in DEV mode.
 *
 * @param {String} name of the guard to use for logging or debugging
 * @param {Function} func The function to invoke
 * @param {*} context The context to use when calling the function
 * @param {...*} args Arguments for function
 */ function invokeGuardedCallback(name, func, context, a, b, c, d, e, f) {
        hasError = false;
        caughtError = null;
        invokeGuardedCallbackImpl$1.apply(reporter, arguments);
    }
    /**
 * Same as invokeGuardedCallback, but instead of returning an error, it stores
 * it in a global so it can be rethrown by `rethrowCaughtError` later.
 * TODO: See if caughtError and rethrowError can be unified.
 *
 * @param {String} name of the guard to use for logging or debugging
 * @param {Function} func The function to invoke
 * @param {*} context The context to use when calling the function
 * @param {...*} args Arguments for function
 */ function invokeGuardedCallbackAndCatchFirstError(name, func, context, a, b, c, d, e, f) {
        invokeGuardedCallback.apply(this, arguments);
        if (hasError) {
            var error = clearCaughtError();
            if (!hasRethrowError) {
                hasRethrowError = true;
                rethrowError = error;
            }
        }
    }
    /**
 * During execution of guarded functions we will capture the first error which
 * we will rethrow to be handled by the top level error handler.
 */ function rethrowCaughtError() {
        if (hasRethrowError) {
            var error = rethrowError;
            hasRethrowError = false;
            rethrowError = null;
            throw error;
        }
    }
    function hasCaughtError() {
        return hasError;
    }
    function clearCaughtError() {
        if (hasError) {
            var error = caughtError;
            hasError = false;
            caughtError = null;
            return error;
        } else throw Error("clearCaughtError was called but no error was captured. This error is likely caused by a bug in React. Please file an issue.");
    }
    var getFiberCurrentPropsFromNode = null;
    var getInstanceFromNode = null;
    var getNodeFromInstance = null;
    function setComponentTree(getFiberCurrentPropsFromNodeImpl, getInstanceFromNodeImpl, getNodeFromInstanceImpl) {
        getFiberCurrentPropsFromNode = getFiberCurrentPropsFromNodeImpl;
        getInstanceFromNode = getInstanceFromNodeImpl;
        getNodeFromInstance = getNodeFromInstanceImpl;
        if (!getNodeFromInstance || !getInstanceFromNode) error("EventPluginUtils.setComponentTree(...): Injected module is missing getNodeFromInstance or getInstanceFromNode.");
    }
    var validateEventDispatches;
    validateEventDispatches = function(event) {
        var dispatchListeners = event._dispatchListeners;
        var dispatchInstances = event._dispatchInstances;
        var listenersIsArr = Array.isArray(dispatchListeners);
        var listenersLen = listenersIsArr ? dispatchListeners.length : dispatchListeners ? 1 : 0;
        var instancesIsArr = Array.isArray(dispatchInstances);
        var instancesLen = instancesIsArr ? dispatchInstances.length : dispatchInstances ? 1 : 0;
        if (instancesIsArr !== listenersIsArr || instancesLen !== listenersLen) error("EventPluginUtils: Invalid `event`.");
    };
    /**
 * Dispatch the event to the listener.
 * @param {SyntheticEvent} event SyntheticEvent to handle
 * @param {function} listener Application-level callback
 * @param {*} inst Internal component instance
 */ function executeDispatch(event, listener, inst) {
        var type = event.type || "unknown-event";
        event.currentTarget = getNodeFromInstance(inst);
        invokeGuardedCallbackAndCatchFirstError(type, listener, undefined, event);
        event.currentTarget = null;
    }
    /**
 * Standard/simple iteration through an event's collected dispatches.
 */ function executeDispatchesInOrder(event) {
        var dispatchListeners = event._dispatchListeners;
        var dispatchInstances = event._dispatchInstances;
        validateEventDispatches(event);
        if (Array.isArray(dispatchListeners)) for(var i = 0; i < dispatchListeners.length; i++){
            if (event.isPropagationStopped()) break;
             // Listeners and Instances are two parallel arrays that are always in sync.
            executeDispatch(event, dispatchListeners[i], dispatchInstances[i]);
        }
        else if (dispatchListeners) executeDispatch(event, dispatchListeners, dispatchInstances);
        event._dispatchListeners = null;
        event._dispatchInstances = null;
    }
    var FunctionComponent = 0;
    var ClassComponent = 1;
    var IndeterminateComponent = 2; // Before we know whether it is function or class
    var HostRoot = 3; // Root of a host tree. Could be nested inside another node.
    var HostPortal = 4; // A subtree. Could be an entry point to a different renderer.
    var HostComponent = 5;
    var HostText = 6;
    var Fragment = 7;
    var Mode = 8;
    var ContextConsumer = 9;
    var ContextProvider = 10;
    var ForwardRef = 11;
    var Profiler = 12;
    var SuspenseComponent = 13;
    var MemoComponent = 14;
    var SimpleMemoComponent = 15;
    var LazyComponent = 16;
    var IncompleteClassComponent = 17;
    var DehydratedFragment = 18;
    var SuspenseListComponent = 19;
    var FundamentalComponent = 20;
    var ScopeComponent = 21;
    var Block = 22;
    /**
 * Injectable ordering of event plugins.
 */ var eventPluginOrder = null;
    /**
 * Injectable mapping from names to event plugin modules.
 */ var namesToPlugins = {};
    /**
 * Recomputes the plugin list using the injected plugins and plugin ordering.
 *
 * @private
 */ function recomputePluginOrdering() {
        if (!eventPluginOrder) // Wait until an `eventPluginOrder` is injected.
        return;
        for(var pluginName in namesToPlugins){
            var pluginModule = namesToPlugins[pluginName];
            var pluginIndex = eventPluginOrder.indexOf(pluginName);
            if (!(pluginIndex > -1)) throw Error("EventPluginRegistry: Cannot inject event plugins that do not exist in the plugin ordering, `" + pluginName + "`.");
            if (plugins[pluginIndex]) continue;
            if (!pluginModule.extractEvents) throw Error("EventPluginRegistry: Event plugins must implement an `extractEvents` method, but `" + pluginName + "` does not.");
            plugins[pluginIndex] = pluginModule;
            var publishedEvents = pluginModule.eventTypes;
            for(var eventName in publishedEvents){
                if (!publishEventForPlugin(publishedEvents[eventName], pluginModule, eventName)) throw Error("EventPluginRegistry: Failed to publish event `" + eventName + "` for plugin `" + pluginName + "`.");
            }
        }
    }
    /**
 * Publishes an event so that it can be dispatched by the supplied plugin.
 *
 * @param {object} dispatchConfig Dispatch configuration for the event.
 * @param {object} PluginModule Plugin publishing the event.
 * @return {boolean} True if the event was successfully published.
 * @private
 */ function publishEventForPlugin(dispatchConfig, pluginModule, eventName) {
        if (!!eventNameDispatchConfigs.hasOwnProperty(eventName)) throw Error("EventPluginRegistry: More than one plugin attempted to publish the same event name, `" + eventName + "`.");
        eventNameDispatchConfigs[eventName] = dispatchConfig;
        var phasedRegistrationNames = dispatchConfig.phasedRegistrationNames;
        if (phasedRegistrationNames) {
            for(var phaseName in phasedRegistrationNames)if (phasedRegistrationNames.hasOwnProperty(phaseName)) {
                var phasedRegistrationName = phasedRegistrationNames[phaseName];
                publishRegistrationName(phasedRegistrationName, pluginModule, eventName);
            }
            return true;
        } else if (dispatchConfig.registrationName) {
            publishRegistrationName(dispatchConfig.registrationName, pluginModule, eventName);
            return true;
        }
        return false;
    }
    /**
 * Publishes a registration name that is used to identify dispatched events.
 *
 * @param {string} registrationName Registration name to add.
 * @param {object} PluginModule Plugin publishing the event.
 * @private
 */ function publishRegistrationName(registrationName, pluginModule, eventName) {
        if (!!registrationNameModules[registrationName]) throw Error("EventPluginRegistry: More than one plugin attempted to publish the same registration name, `" + registrationName + "`.");
        registrationNameModules[registrationName] = pluginModule;
        registrationNameDependencies[registrationName] = pluginModule.eventTypes[eventName].dependencies;
        var lowerCasedName = registrationName.toLowerCase();
        possibleRegistrationNames[lowerCasedName] = registrationName;
        if (registrationName === "onDoubleClick") possibleRegistrationNames.ondblclick = registrationName;
    }
    /**
 * Registers plugins so that they can extract and dispatch events.
 */ /**
 * Ordered list of injected plugins.
 */ var plugins = [];
    /**
 * Mapping from event name to dispatch config
 */ var eventNameDispatchConfigs = {};
    /**
 * Mapping from registration name to plugin module
 */ var registrationNameModules = {};
    /**
 * Mapping from registration name to event name
 */ var registrationNameDependencies = {};
    /**
 * Mapping from lowercase registration names to the properly cased version,
 * used to warn in the case of missing event handlers. Available
 * only in true.
 * @type {Object}
 */ var possibleRegistrationNames = {}; // Trust the developer to only use possibleRegistrationNames in true
    /**
 * Injects an ordering of plugins (by plugin name). This allows the ordering
 * to be decoupled from injection of the actual plugins so that ordering is
 * always deterministic regardless of packaging, on-the-fly injection, etc.
 *
 * @param {array} InjectedEventPluginOrder
 * @internal
 */ function injectEventPluginOrder(injectedEventPluginOrder) {
        if (!!eventPluginOrder) throw Error("EventPluginRegistry: Cannot inject event plugin ordering more than once. You are likely trying to load more than one copy of React.");
         // Clone the ordering so it cannot be dynamically mutated.
        eventPluginOrder = Array.prototype.slice.call(injectedEventPluginOrder);
        recomputePluginOrdering();
    }
    /**
 * Injects plugins to be used by plugin event system. The plugin names must be
 * in the ordering injected by `injectEventPluginOrder`.
 *
 * Plugins can be injected as part of page initialization or on-the-fly.
 *
 * @param {object} injectedNamesToPlugins Map from names to plugin modules.
 * @internal
 */ function injectEventPluginsByName(injectedNamesToPlugins) {
        var isOrderingDirty = false;
        for(var pluginName in injectedNamesToPlugins){
            if (!injectedNamesToPlugins.hasOwnProperty(pluginName)) continue;
            var pluginModule = injectedNamesToPlugins[pluginName];
            if (!namesToPlugins.hasOwnProperty(pluginName) || namesToPlugins[pluginName] !== pluginModule) {
                if (!!namesToPlugins[pluginName]) throw Error("EventPluginRegistry: Cannot inject two different event plugins using the same name, `" + pluginName + "`.");
                namesToPlugins[pluginName] = pluginModule;
                isOrderingDirty = true;
            }
        }
        if (isOrderingDirty) recomputePluginOrdering();
    }
    var canUseDOM = !!(typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined");
    var PLUGIN_EVENT_SYSTEM = 1;
    var IS_REPLAYED = 32;
    var IS_FIRST_ANCESTOR = 64;
    var restoreImpl = null;
    var restoreTarget = null;
    var restoreQueue = null;
    function restoreStateOfTarget(target) {
        // We perform this translation at the end of the event loop so that we
        // always receive the correct fiber here
        var internalInstance = getInstanceFromNode(target);
        if (!internalInstance) // Unmounted
        return;
        if (!(typeof restoreImpl === "function")) throw Error("setRestoreImplementation() needs to be called to handle a target for controlled events. This error is likely caused by a bug in React. Please file an issue.");
        var stateNode = internalInstance.stateNode; // Guard against Fiber being unmounted.
        if (stateNode) {
            var _props = getFiberCurrentPropsFromNode(stateNode);
            restoreImpl(internalInstance.stateNode, internalInstance.type, _props);
        }
    }
    function setRestoreImplementation(impl) {
        restoreImpl = impl;
    }
    function enqueueStateRestore(target) {
        if (restoreTarget) {
            if (restoreQueue) restoreQueue.push(target);
            else restoreQueue = [
                target
            ];
        } else restoreTarget = target;
    }
    function needsStateRestore() {
        return restoreTarget !== null || restoreQueue !== null;
    }
    function restoreStateIfNeeded() {
        if (!restoreTarget) return;
        var target = restoreTarget;
        var queuedTargets = restoreQueue;
        restoreTarget = null;
        restoreQueue = null;
        restoreStateOfTarget(target);
        if (queuedTargets) for(var i = 0; i < queuedTargets.length; i++)restoreStateOfTarget(queuedTargets[i]);
    }
    var enableProfilerTimer = true; // Trace which interactions trigger each commit.
    var enableDeprecatedFlareAPI = false; // Experimental Host Component support.
    var enableFundamentalAPI = false; // Experimental Scope support.
    var warnAboutStringRefs = false;
    // the renderer. Such as when we're dispatching events or if third party
    // libraries need to call batchedUpdates. Eventually, this API will go away when
    // everything is batched by default. We'll then have a similar API to opt-out of
    // scheduled work and instead do synchronous work.
    // Defaults
    var batchedUpdatesImpl = function(fn, bookkeeping) {
        return fn(bookkeeping);
    };
    var discreteUpdatesImpl = function(fn, a, b, c, d) {
        return fn(a, b, c, d);
    };
    var flushDiscreteUpdatesImpl = function() {};
    var batchedEventUpdatesImpl = batchedUpdatesImpl;
    var isInsideEventHandler = false;
    var isBatchingEventUpdates = false;
    function finishEventHandler() {
        // Here we wait until all updates have propagated, which is important
        // when using controlled components within layers:
        // https://github.com/facebook/react/issues/1698
        // Then we restore state of any controlled component.
        var controlledComponentsHavePendingUpdates = needsStateRestore();
        if (controlledComponentsHavePendingUpdates) {
            // If a controlled event was fired, we may need to restore the state of
            // the DOM node back to the controlled value. This is necessary when React
            // bails out of the update without touching the DOM.
            flushDiscreteUpdatesImpl();
            restoreStateIfNeeded();
        }
    }
    function batchedUpdates(fn, bookkeeping) {
        if (isInsideEventHandler) // If we are currently inside another batch, we need to wait until it
        // fully completes before restoring state.
        return fn(bookkeeping);
        isInsideEventHandler = true;
        try {
            return batchedUpdatesImpl(fn, bookkeeping);
        } finally{
            isInsideEventHandler = false;
            finishEventHandler();
        }
    }
    function batchedEventUpdates(fn, a, b) {
        if (isBatchingEventUpdates) // If we are currently inside another batch, we need to wait until it
        // fully completes before restoring state.
        return fn(a, b);
        isBatchingEventUpdates = true;
        try {
            return batchedEventUpdatesImpl(fn, a, b);
        } finally{
            isBatchingEventUpdates = false;
            finishEventHandler();
        }
    } // This is for the React Flare event system
    function discreteUpdates(fn, a, b, c, d) {
        var prevIsInsideEventHandler = isInsideEventHandler;
        isInsideEventHandler = true;
        try {
            return discreteUpdatesImpl(fn, a, b, c, d);
        } finally{
            isInsideEventHandler = prevIsInsideEventHandler;
            if (!isInsideEventHandler) finishEventHandler();
        }
    }
    function flushDiscreteUpdatesIfNeeded(timeStamp) {
        // event.timeStamp isn't overly reliable due to inconsistencies in
        // how different browsers have historically provided the time stamp.
        // Some browsers provide high-resolution time stamps for all events,
        // some provide low-resolution time stamps for all events. FF < 52
        // even mixes both time stamps together. Some browsers even report
        // negative time stamps or time stamps that are 0 (iOS9) in some cases.
        // Given we are only comparing two time stamps with equality (!==),
        // we are safe from the resolution differences. If the time stamp is 0
        // we bail-out of preventing the flush, which can affect semantics,
        // such as if an earlier flush removes or adds event listeners that
        // are fired in the subsequent flush. However, this is the same
        // behaviour as we had before this change, so the risks are low.
        if (!isInsideEventHandler && !enableDeprecatedFlareAPI) flushDiscreteUpdatesImpl();
    }
    function setBatchingImplementation(_batchedUpdatesImpl, _discreteUpdatesImpl, _flushDiscreteUpdatesImpl, _batchedEventUpdatesImpl) {
        batchedUpdatesImpl = _batchedUpdatesImpl;
        discreteUpdatesImpl = _discreteUpdatesImpl;
        flushDiscreteUpdatesImpl = _flushDiscreteUpdatesImpl;
        batchedEventUpdatesImpl = _batchedEventUpdatesImpl;
    }
    var DiscreteEvent = 0;
    var UserBlockingEvent = 1;
    var ContinuousEvent = 2;
    // A reserved attribute.
    // It is handled by React separately and shouldn't be written to the DOM.
    var RESERVED = 0; // A simple string attribute.
    // Attributes that aren't in the whitelist are presumed to have this type.
    var STRING = 1; // A string attribute that accepts booleans in React. In HTML, these are called
    // "enumerated" attributes with "true" and "false" as possible values.
    // When true, it should be set to a "true" string.
    // When false, it should be set to a "false" string.
    var BOOLEANISH_STRING = 2; // A real boolean attribute.
    // When true, it should be present (set either to an empty string or its name).
    // When false, it should be omitted.
    var BOOLEAN = 3; // An attribute that can be used as a flag as well as with a value.
    // When true, it should be present (set either to an empty string or its name).
    // When false, it should be omitted.
    // For any other value, should be present with that value.
    var OVERLOADED_BOOLEAN = 4; // An attribute that must be numeric or parse as a numeric.
    // When falsy, it should be removed.
    var NUMERIC = 5; // An attribute that must be positive numeric or parse as a positive numeric.
    // When falsy, it should be removed.
    var POSITIVE_NUMERIC = 6;
    /* eslint-disable max-len */ var ATTRIBUTE_NAME_START_CHAR = ":A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD";
    /* eslint-enable max-len */ var ATTRIBUTE_NAME_CHAR = ATTRIBUTE_NAME_START_CHAR + "\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040";
    var ROOT_ATTRIBUTE_NAME = "data-reactroot";
    var VALID_ATTRIBUTE_NAME_REGEX = new RegExp("^[" + ATTRIBUTE_NAME_START_CHAR + "][" + ATTRIBUTE_NAME_CHAR + "]*$");
    var hasOwnProperty = Object.prototype.hasOwnProperty;
    var illegalAttributeNameCache = {};
    var validatedAttributeNameCache = {};
    function isAttributeNameSafe(attributeName) {
        if (hasOwnProperty.call(validatedAttributeNameCache, attributeName)) return true;
        if (hasOwnProperty.call(illegalAttributeNameCache, attributeName)) return false;
        if (VALID_ATTRIBUTE_NAME_REGEX.test(attributeName)) {
            validatedAttributeNameCache[attributeName] = true;
            return true;
        }
        illegalAttributeNameCache[attributeName] = true;
        error("Invalid attribute name: `%s`", attributeName);
        return false;
    }
    function shouldIgnoreAttribute(name, propertyInfo, isCustomComponentTag) {
        if (propertyInfo !== null) return propertyInfo.type === RESERVED;
        if (isCustomComponentTag) return false;
        if (name.length > 2 && (name[0] === "o" || name[0] === "O") && (name[1] === "n" || name[1] === "N")) return true;
        return false;
    }
    function shouldRemoveAttributeWithWarning(name, value, propertyInfo, isCustomComponentTag) {
        if (propertyInfo !== null && propertyInfo.type === RESERVED) return false;
        switch(typeof value){
            case "function":
            case "symbol":
                // eslint-disable-line
                return true;
            case "boolean":
                if (isCustomComponentTag) return false;
                if (propertyInfo !== null) return !propertyInfo.acceptsBooleans;
                else {
                    var prefix = name.toLowerCase().slice(0, 5);
                    return prefix !== "data-" && prefix !== "aria-";
                }
            default:
                return false;
        }
    }
    function shouldRemoveAttribute(name, value, propertyInfo, isCustomComponentTag) {
        if (value === null || typeof value === "undefined") return true;
        if (shouldRemoveAttributeWithWarning(name, value, propertyInfo, isCustomComponentTag)) return true;
        if (isCustomComponentTag) return false;
        if (propertyInfo !== null) switch(propertyInfo.type){
            case BOOLEAN:
                return !value;
            case OVERLOADED_BOOLEAN:
                return value === false;
            case NUMERIC:
                return isNaN(value);
            case POSITIVE_NUMERIC:
                return isNaN(value) || value < 1;
        }
        return false;
    }
    function getPropertyInfo(name) {
        return properties.hasOwnProperty(name) ? properties[name] : null;
    }
    function PropertyInfoRecord(name, type, mustUseProperty, attributeName, attributeNamespace, sanitizeURL) {
        this.acceptsBooleans = type === BOOLEANISH_STRING || type === BOOLEAN || type === OVERLOADED_BOOLEAN;
        this.attributeName = attributeName;
        this.attributeNamespace = attributeNamespace;
        this.mustUseProperty = mustUseProperty;
        this.propertyName = name;
        this.type = type;
        this.sanitizeURL = sanitizeURL;
    } // When adding attributes to this list, be sure to also add them to
    // the `possibleStandardNames` module to ensure casing and incorrect
    // name warnings.
    var properties = {}; // These props are reserved by React. They shouldn't be written to the DOM.
    var reservedProps = [
        "children",
        "dangerouslySetInnerHTML",
        // elements (not just inputs). Now that ReactDOMInput assigns to the
        // defaultValue property -- do we need this?
        "defaultValue",
        "defaultChecked",
        "innerHTML",
        "suppressContentEditableWarning",
        "suppressHydrationWarning",
        "style"
    ];
    reservedProps.forEach(function(name) {
        properties[name] = new PropertyInfoRecord(name, RESERVED, false, name, null, false);
    }); // A few React string attributes have a different name.
    // This is a mapping from React prop names to the attribute names.
    [
        [
            "acceptCharset",
            "accept-charset"
        ],
        [
            "className",
            "class"
        ],
        [
            "htmlFor",
            "for"
        ],
        [
            "httpEquiv",
            "http-equiv"
        ]
    ].forEach(function(_ref) {
        var name = _ref[0], attributeName = _ref[1];
        properties[name] = new PropertyInfoRecord(name, STRING, false, attributeName, null, false);
    }); // These are "enumerated" HTML attributes that accept "true" and "false".
    // In React, we let users pass `true` and `false` even though technically
    // these aren't boolean attributes (they are coerced to strings).
    [
        "contentEditable",
        "draggable",
        "spellCheck",
        "value"
    ].forEach(function(name) {
        properties[name] = new PropertyInfoRecord(name, BOOLEANISH_STRING, false, name.toLowerCase(), null, false);
    }); // These are "enumerated" SVG attributes that accept "true" and "false".
    // In React, we let users pass `true` and `false` even though technically
    // these aren't boolean attributes (they are coerced to strings).
    // Since these are SVG attributes, their attribute names are case-sensitive.
    [
        "autoReverse",
        "externalResourcesRequired",
        "focusable",
        "preserveAlpha"
    ].forEach(function(name) {
        properties[name] = new PropertyInfoRecord(name, BOOLEANISH_STRING, false, name, null, false);
    }); // These are HTML boolean attributes.
    [
        "allowFullScreen",
        "async",
        // on the client side because the browsers are inconsistent. Instead we call focus().
        "autoFocus",
        "autoPlay",
        "controls",
        "default",
        "defer",
        "disabled",
        "disablePictureInPicture",
        "formNoValidate",
        "hidden",
        "loop",
        "noModule",
        "noValidate",
        "open",
        "playsInline",
        "readOnly",
        "required",
        "reversed",
        "scoped",
        "seamless",
        "itemScope"
    ].forEach(function(name) {
        properties[name] = new PropertyInfoRecord(name, BOOLEAN, false, name.toLowerCase(), null, false);
    }); // These are the few React props that we set as DOM properties
    // rather than attributes. These are all booleans.
    [
        "checked",
        // disabled with `removeAttribute`. We have special logic for handling this.
        "multiple",
        "muted",
        "selected" // NOTE: if you add a camelCased prop to this list,
    ].forEach(function(name) {
        properties[name] = new PropertyInfoRecord(name, BOOLEAN, true, name, null, false);
    }); // These are HTML attributes that are "overloaded booleans": they behave like
    // booleans, but can also accept a string value.
    [
        "capture",
        "download" // NOTE: if you add a camelCased prop to this list,
    ].forEach(function(name) {
        properties[name] = new PropertyInfoRecord(name, OVERLOADED_BOOLEAN, false, name, null, false);
    }); // These are HTML attributes that must be positive numbers.
    [
        "cols",
        "rows",
        "size",
        "span" // NOTE: if you add a camelCased prop to this list,
    ].forEach(function(name) {
        properties[name] = new PropertyInfoRecord(name, POSITIVE_NUMERIC, false, name, null, false);
    }); // These are HTML attributes that must be numbers.
    [
        "rowSpan",
        "start"
    ].forEach(function(name) {
        properties[name] = new PropertyInfoRecord(name, NUMERIC, false, name.toLowerCase(), null, false);
    });
    var CAMELIZE = /[\-\:]([a-z])/g;
    var capitalize = function(token) {
        return token[1].toUpperCase();
    }; // This is a list of all SVG attributes that need special casing, namespacing,
    // or boolean value assignment. Regular attributes that just accept strings
    // and have the same names are omitted, just like in the HTML whitelist.
    // Some of these attributes can be hard to find. This list was created by
    // scraping the MDN documentation.
    [
        "accent-height",
        "alignment-baseline",
        "arabic-form",
        "baseline-shift",
        "cap-height",
        "clip-path",
        "clip-rule",
        "color-interpolation",
        "color-interpolation-filters",
        "color-profile",
        "color-rendering",
        "dominant-baseline",
        "enable-background",
        "fill-opacity",
        "fill-rule",
        "flood-color",
        "flood-opacity",
        "font-family",
        "font-size",
        "font-size-adjust",
        "font-stretch",
        "font-style",
        "font-variant",
        "font-weight",
        "glyph-name",
        "glyph-orientation-horizontal",
        "glyph-orientation-vertical",
        "horiz-adv-x",
        "horiz-origin-x",
        "image-rendering",
        "letter-spacing",
        "lighting-color",
        "marker-end",
        "marker-mid",
        "marker-start",
        "overline-position",
        "overline-thickness",
        "paint-order",
        "panose-1",
        "pointer-events",
        "rendering-intent",
        "shape-rendering",
        "stop-color",
        "stop-opacity",
        "strikethrough-position",
        "strikethrough-thickness",
        "stroke-dasharray",
        "stroke-dashoffset",
        "stroke-linecap",
        "stroke-linejoin",
        "stroke-miterlimit",
        "stroke-opacity",
        "stroke-width",
        "text-anchor",
        "text-decoration",
        "text-rendering",
        "underline-position",
        "underline-thickness",
        "unicode-bidi",
        "unicode-range",
        "units-per-em",
        "v-alphabetic",
        "v-hanging",
        "v-ideographic",
        "v-mathematical",
        "vector-effect",
        "vert-adv-y",
        "vert-origin-x",
        "vert-origin-y",
        "word-spacing",
        "writing-mode",
        "xmlns:xlink",
        "x-height" // NOTE: if you add a camelCased prop to this list,
    ].forEach(function(attributeName) {
        var name = attributeName.replace(CAMELIZE, capitalize);
        properties[name] = new PropertyInfoRecord(name, STRING, false, attributeName, null, false);
    }); // String SVG attributes with the xlink namespace.
    [
        "xlink:actuate",
        "xlink:arcrole",
        "xlink:role",
        "xlink:show",
        "xlink:title",
        "xlink:type" // NOTE: if you add a camelCased prop to this list,
    ].forEach(function(attributeName) {
        var name = attributeName.replace(CAMELIZE, capitalize);
        properties[name] = new PropertyInfoRecord(name, STRING, false, attributeName, "http://www.w3.org/1999/xlink", false);
    }); // String SVG attributes with the xml namespace.
    [
        "xml:base",
        "xml:lang",
        "xml:space" // NOTE: if you add a camelCased prop to this list,
    ].forEach(function(attributeName) {
        var name = attributeName.replace(CAMELIZE, capitalize);
        properties[name] = new PropertyInfoRecord(name, STRING, false, attributeName, "http://www.w3.org/XML/1998/namespace", false);
    }); // These attribute exists both in HTML and SVG.
    // The attribute name is case-sensitive in SVG so we can't just use
    // the React name like we do for attributes that exist only in HTML.
    [
        "tabIndex",
        "crossOrigin"
    ].forEach(function(attributeName) {
        properties[attributeName] = new PropertyInfoRecord(attributeName, STRING, false, attributeName.toLowerCase(), null, false);
    }); // These attributes accept URLs. These must not allow javascript: URLS.
    // These will also need to accept Trusted Types object in the future.
    var xlinkHref = "xlinkHref";
    properties[xlinkHref] = new PropertyInfoRecord("xlinkHref", STRING, false, "xlink:href", "http://www.w3.org/1999/xlink", true);
    [
        "src",
        "href",
        "action",
        "formAction"
    ].forEach(function(attributeName) {
        properties[attributeName] = new PropertyInfoRecord(attributeName, STRING, false, attributeName.toLowerCase(), null, true);
    });
    var ReactDebugCurrentFrame = null;
    ReactDebugCurrentFrame = ReactSharedInternals.ReactDebugCurrentFrame;
    // and any newline or tab are filtered out as if they're not part of the URL.
    // https://url.spec.whatwg.org/#url-parsing
    // Tab or newline are defined as \r\n\t:
    // https://infra.spec.whatwg.org/#ascii-tab-or-newline
    // A C0 control is a code point in the range \u0000 NULL to \u001F
    // INFORMATION SEPARATOR ONE, inclusive:
    // https://infra.spec.whatwg.org/#c0-control-or-space
    /* eslint-disable max-len */ var isJavaScriptProtocol = /^[\u0000-\u001F ]*j[\r\n\t]*a[\r\n\t]*v[\r\n\t]*a[\r\n\t]*s[\r\n\t]*c[\r\n\t]*r[\r\n\t]*i[\r\n\t]*p[\r\n\t]*t[\r\n\t]*\:/i;
    var didWarn = false;
    function sanitizeURL(url) {
        if (!didWarn && isJavaScriptProtocol.test(url)) {
            didWarn = true;
            error("A future version of React will block javascript: URLs as a security precaution. Use event handlers instead if you can. If you need to generate unsafe HTML try using dangerouslySetInnerHTML instead. React was passed %s.", JSON.stringify(url));
        }
    }
    /**
 * Get the value for a property on a node. Only used in DEV for SSR validation.
 * The "expected" argument is used as a hint of what the expected value is.
 * Some properties have multiple equivalent values.
 */ function getValueForProperty(node, name, expected, propertyInfo) {
        if (propertyInfo.mustUseProperty) {
            var propertyName = propertyInfo.propertyName;
            return node[propertyName];
        } else {
            if (propertyInfo.sanitizeURL) // If we haven't fully disabled javascript: URLs, and if
            // the hydration is successful of a javascript: URL, we
            // still want to warn on the client.
            sanitizeURL("" + expected);
            var attributeName = propertyInfo.attributeName;
            var stringValue = null;
            if (propertyInfo.type === OVERLOADED_BOOLEAN) {
                if (node.hasAttribute(attributeName)) {
                    var value = node.getAttribute(attributeName);
                    if (value === "") return true;
                    if (shouldRemoveAttribute(name, expected, propertyInfo, false)) return value;
                    if (value === "" + expected) return expected;
                    return value;
                }
            } else if (node.hasAttribute(attributeName)) {
                if (shouldRemoveAttribute(name, expected, propertyInfo, false)) // We had an attribute but shouldn't have had one, so read it
                // for the error message.
                return node.getAttribute(attributeName);
                if (propertyInfo.type === BOOLEAN) // If this was a boolean, it doesn't matter what the value is
                // the fact that we have it is the same as the expected.
                return expected;
                 // Even if this property uses a namespace we use getAttribute
                // because we assume its namespaced name is the same as our config.
                // To use getAttributeNS we need the local name which we don't have
                // in our config atm.
                stringValue = node.getAttribute(attributeName);
            }
            if (shouldRemoveAttribute(name, expected, propertyInfo, false)) return stringValue === null ? expected : stringValue;
            else if (stringValue === "" + expected) return expected;
            else return stringValue;
        }
    }
    /**
 * Get the value for a attribute on a node. Only used in DEV for SSR validation.
 * The third argument is used as a hint of what the expected value is. Some
 * attributes have multiple equivalent values.
 */ function getValueForAttribute(node, name, expected) {
        if (!isAttributeNameSafe(name)) return;
        if (!node.hasAttribute(name)) return expected === undefined ? undefined : null;
        var value = node.getAttribute(name);
        if (value === "" + expected) return expected;
        return value;
    }
    /**
 * Sets the value for a property on a node.
 *
 * @param {DOMElement} node
 * @param {string} name
 * @param {*} value
 */ function setValueForProperty(node, name, value, isCustomComponentTag) {
        var propertyInfo = getPropertyInfo(name);
        if (shouldIgnoreAttribute(name, propertyInfo, isCustomComponentTag)) return;
        if (shouldRemoveAttribute(name, value, propertyInfo, isCustomComponentTag)) value = null;
         // If the prop isn't in the special list, treat it as a simple attribute.
        if (isCustomComponentTag || propertyInfo === null) {
            if (isAttributeNameSafe(name)) {
                var _attributeName = name;
                if (value === null) node.removeAttribute(_attributeName);
                else node.setAttribute(_attributeName, "" + value);
            }
            return;
        }
        var mustUseProperty = propertyInfo.mustUseProperty;
        if (mustUseProperty) {
            var propertyName = propertyInfo.propertyName;
            if (value === null) {
                var type = propertyInfo.type;
                node[propertyName] = type === BOOLEAN ? false : "";
            } else // Contrary to `setAttribute`, object properties are properly
            // `toString`ed by IE8/9.
            node[propertyName] = value;
            return;
        } // The rest are treated as attributes with special cases.
        var attributeName = propertyInfo.attributeName, attributeNamespace = propertyInfo.attributeNamespace;
        if (value === null) node.removeAttribute(attributeName);
        else {
            var _type = propertyInfo.type;
            var attributeValue;
            if (_type === BOOLEAN || _type === OVERLOADED_BOOLEAN && value === true) // If attribute type is boolean, we know for sure it won't be an execution sink
            // and we won't require Trusted Type here.
            attributeValue = "";
            else {
                attributeValue = "" + value;
                if (propertyInfo.sanitizeURL) sanitizeURL(attributeValue.toString());
            }
            if (attributeNamespace) node.setAttributeNS(attributeNamespace, attributeName, attributeValue);
            else node.setAttribute(attributeName, attributeValue);
        }
    }
    var BEFORE_SLASH_RE = /^(.*)[\\\/]/;
    function describeComponentFrame(name, source, ownerName) {
        var sourceInfo = "";
        if (source) {
            var path = source.fileName;
            var fileName = path.replace(BEFORE_SLASH_RE, "");
            // In DEV, include code for a common special case:
            // prefer "folder/index.js" instead of just "index.js".
            if (/^index\./.test(fileName)) {
                var match = path.match(BEFORE_SLASH_RE);
                if (match) {
                    var pathBeforeSlash = match[1];
                    if (pathBeforeSlash) {
                        var folderName = pathBeforeSlash.replace(BEFORE_SLASH_RE, "");
                        fileName = folderName + "/" + fileName;
                    }
                }
            }
            sourceInfo = " (at " + fileName + ":" + source.lineNumber + ")";
        } else if (ownerName) sourceInfo = " (created by " + ownerName + ")";
        return "\n    in " + (name || "Unknown") + sourceInfo;
    }
    // The Symbol used to tag the ReactElement-like types. If there is no native Symbol
    // nor polyfill, then a plain number is used for performance.
    var hasSymbol = typeof Symbol === "function" && Symbol.for;
    var REACT_ELEMENT_TYPE = hasSymbol ? Symbol.for("react.element") : 0xeac7;
    var REACT_PORTAL_TYPE = hasSymbol ? Symbol.for("react.portal") : 0xeaca;
    var REACT_FRAGMENT_TYPE = hasSymbol ? Symbol.for("react.fragment") : 0xeacb;
    var REACT_STRICT_MODE_TYPE = hasSymbol ? Symbol.for("react.strict_mode") : 0xeacc;
    var REACT_PROFILER_TYPE = hasSymbol ? Symbol.for("react.profiler") : 0xead2;
    var REACT_PROVIDER_TYPE = hasSymbol ? Symbol.for("react.provider") : 0xeacd;
    var REACT_CONTEXT_TYPE = hasSymbol ? Symbol.for("react.context") : 0xeace; // TODO: We don't use AsyncMode or ConcurrentMode anymore. They were temporary
    var REACT_CONCURRENT_MODE_TYPE = hasSymbol ? Symbol.for("react.concurrent_mode") : 0xeacf;
    var REACT_FORWARD_REF_TYPE = hasSymbol ? Symbol.for("react.forward_ref") : 0xead0;
    var REACT_SUSPENSE_TYPE = hasSymbol ? Symbol.for("react.suspense") : 0xead1;
    var REACT_SUSPENSE_LIST_TYPE = hasSymbol ? Symbol.for("react.suspense_list") : 0xead8;
    var REACT_MEMO_TYPE = hasSymbol ? Symbol.for("react.memo") : 0xead3;
    var REACT_LAZY_TYPE = hasSymbol ? Symbol.for("react.lazy") : 0xead4;
    var REACT_BLOCK_TYPE = hasSymbol ? Symbol.for("react.block") : 0xead9;
    var MAYBE_ITERATOR_SYMBOL = typeof Symbol === "function" && Symbol.iterator;
    var FAUX_ITERATOR_SYMBOL = "@@iterator";
    function getIteratorFn(maybeIterable) {
        if (maybeIterable === null || typeof maybeIterable !== "object") return null;
        var maybeIterator = MAYBE_ITERATOR_SYMBOL && maybeIterable[MAYBE_ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL];
        if (typeof maybeIterator === "function") return maybeIterator;
        return null;
    }
    var Uninitialized = -1;
    var Pending = 0;
    var Resolved = 1;
    var Rejected = 2;
    function refineResolvedLazyComponent(lazyComponent) {
        return lazyComponent._status === Resolved ? lazyComponent._result : null;
    }
    function initializeLazyComponentType(lazyComponent) {
        if (lazyComponent._status === Uninitialized) {
            lazyComponent._status = Pending;
            var ctor = lazyComponent._ctor;
            var thenable = ctor();
            lazyComponent._result = thenable;
            thenable.then(function(moduleObject) {
                if (lazyComponent._status === Pending) {
                    var defaultExport = moduleObject.default;
                    if (defaultExport === undefined) error("lazy: Expected the result of a dynamic import() call. Instead received: %s\n\nYour code should look like: \n  const MyComponent = lazy(() => import('./MyComponent'))", moduleObject);
                    lazyComponent._status = Resolved;
                    lazyComponent._result = defaultExport;
                }
            }, function(error) {
                if (lazyComponent._status === Pending) {
                    lazyComponent._status = Rejected;
                    lazyComponent._result = error;
                }
            });
        }
    }
    function getWrappedName(outerType, innerType, wrapperName) {
        var functionName = innerType.displayName || innerType.name || "";
        return outerType.displayName || (functionName !== "" ? wrapperName + "(" + functionName + ")" : wrapperName);
    }
    function getComponentName(type) {
        if (type == null) // Host root, text node or just invalid type.
        return null;
        if (typeof type.tag === "number") error("Received an unexpected object in getComponentName(). This is likely a bug in React. Please file an issue.");
        if (typeof type === "function") return type.displayName || type.name || null;
        if (typeof type === "string") return type;
        switch(type){
            case REACT_FRAGMENT_TYPE:
                return "Fragment";
            case REACT_PORTAL_TYPE:
                return "Portal";
            case REACT_PROFILER_TYPE:
                return "Profiler";
            case REACT_STRICT_MODE_TYPE:
                return "StrictMode";
            case REACT_SUSPENSE_TYPE:
                return "Suspense";
            case REACT_SUSPENSE_LIST_TYPE:
                return "SuspenseList";
        }
        if (typeof type === "object") switch(type.$$typeof){
            case REACT_CONTEXT_TYPE:
                return "Context.Consumer";
            case REACT_PROVIDER_TYPE:
                return "Context.Provider";
            case REACT_FORWARD_REF_TYPE:
                return getWrappedName(type, type.render, "ForwardRef");
            case REACT_MEMO_TYPE:
                return getComponentName(type.type);
            case REACT_BLOCK_TYPE:
                return getComponentName(type.render);
            case REACT_LAZY_TYPE:
                var thenable = type;
                var resolvedThenable = refineResolvedLazyComponent(thenable);
                if (resolvedThenable) return getComponentName(resolvedThenable);
                break;
        }
        return null;
    }
    var ReactDebugCurrentFrame$1 = ReactSharedInternals.ReactDebugCurrentFrame;
    function describeFiber(fiber) {
        switch(fiber.tag){
            case HostRoot:
            case HostPortal:
            case HostText:
            case Fragment:
            case ContextProvider:
            case ContextConsumer:
                return "";
            default:
                var owner = fiber._debugOwner;
                var source = fiber._debugSource;
                var name = getComponentName(fiber.type);
                var ownerName = null;
                if (owner) ownerName = getComponentName(owner.type);
                return describeComponentFrame(name, source, ownerName);
        }
    }
    function getStackByFiberInDevAndProd(workInProgress) {
        var info = "";
        var node = workInProgress;
        do {
            info += describeFiber(node);
            node = node.return;
        }while (node);
        return info;
    }
    var current = null;
    var isRendering = false;
    function getCurrentFiberOwnerNameInDevOrNull() {
        if (current === null) return null;
        var owner = current._debugOwner;
        if (owner !== null && typeof owner !== "undefined") return getComponentName(owner.type);
        return null;
    }
    function getCurrentFiberStackInDev() {
        if (current === null) return "";
         // Safe because if current fiber exists, we are reconciling,
        // and it is guaranteed to be the work-in-progress version.
        return getStackByFiberInDevAndProd(current);
    }
    function resetCurrentFiber() {
        ReactDebugCurrentFrame$1.getCurrentStack = null;
        current = null;
        isRendering = false;
    }
    function setCurrentFiber(fiber) {
        ReactDebugCurrentFrame$1.getCurrentStack = getCurrentFiberStackInDev;
        current = fiber;
        isRendering = false;
    }
    function setIsRendering(rendering) {
        isRendering = rendering;
    }
    // Flow does not allow string concatenation of most non-string types. To work
    // around this limitation, we use an opaque type that can only be obtained by
    // passing the value through getToStringValue first.
    function toString(value) {
        return "" + value;
    }
    function getToStringValue(value) {
        switch(typeof value){
            case "boolean":
            case "number":
            case "object":
            case "string":
            case "undefined":
                return value;
            default:
                // function, symbol are assigned as empty strings
                return "";
        }
    }
    var ReactDebugCurrentFrame$2 = null;
    var ReactControlledValuePropTypes = {
        checkPropTypes: null
    };
    ReactDebugCurrentFrame$2 = ReactSharedInternals.ReactDebugCurrentFrame;
    var hasReadOnlyValue = {
        button: true,
        checkbox: true,
        image: true,
        hidden: true,
        radio: true,
        reset: true,
        submit: true
    };
    var propTypes = {
        value: function(props, propName, componentName) {
            if (hasReadOnlyValue[props.type] || props.onChange || props.readOnly || props.disabled || props[propName] == null || enableDeprecatedFlareAPI) return null;
            return new Error("You provided a `value` prop to a form field without an `onChange` handler. This will render a read-only field. If the field should be mutable use `defaultValue`. Otherwise, set either `onChange` or `readOnly`.");
        },
        checked: function(props, propName, componentName) {
            if (props.onChange || props.readOnly || props.disabled || props[propName] == null || enableDeprecatedFlareAPI) return null;
            return new Error("You provided a `checked` prop to a form field without an `onChange` handler. This will render a read-only field. If the field should be mutable use `defaultChecked`. Otherwise, set either `onChange` or `readOnly`.");
        }
    };
    /**
   * Provide a linked `value` attribute for controlled forms. You should not use
   * this outside of the ReactDOM controlled form components.
   */ ReactControlledValuePropTypes.checkPropTypes = function(tagName, props) {
        checkPropTypes(propTypes, props, "prop", tagName, ReactDebugCurrentFrame$2.getStackAddendum);
    };
    function isCheckable(elem) {
        var type = elem.type;
        var nodeName = elem.nodeName;
        return nodeName && nodeName.toLowerCase() === "input" && (type === "checkbox" || type === "radio");
    }
    function getTracker(node) {
        return node._valueTracker;
    }
    function detachTracker(node) {
        node._valueTracker = null;
    }
    function getValueFromNode(node) {
        var value = "";
        if (!node) return value;
        if (isCheckable(node)) value = node.checked ? "true" : "false";
        else value = node.value;
        return value;
    }
    function trackValueOnNode(node) {
        var valueField = isCheckable(node) ? "checked" : "value";
        var descriptor = Object.getOwnPropertyDescriptor(node.constructor.prototype, valueField);
        var currentValue = "" + node[valueField]; // if someone has already defined a value or Safari, then bail
        // and don't track value will cause over reporting of changes,
        // but it's better then a hard failure
        // (needed for certain tests that spyOn input values and Safari)
        if (node.hasOwnProperty(valueField) || typeof descriptor === "undefined" || typeof descriptor.get !== "function" || typeof descriptor.set !== "function") return;
        var get = descriptor.get, set = descriptor.set;
        Object.defineProperty(node, valueField, {
            configurable: true,
            get: function() {
                return get.call(this);
            },
            set: function(value) {
                currentValue = "" + value;
                set.call(this, value);
            }
        }); // We could've passed this the first time
        // but it triggers a bug in IE11 and Edge 14/15.
        // Calling defineProperty() again should be equivalent.
        // https://github.com/facebook/react/issues/11768
        Object.defineProperty(node, valueField, {
            enumerable: descriptor.enumerable
        });
        var tracker = {
            getValue: function() {
                return currentValue;
            },
            setValue: function(value) {
                currentValue = "" + value;
            },
            stopTracking: function() {
                detachTracker(node);
                delete node[valueField];
            }
        };
        return tracker;
    }
    function track(node) {
        if (getTracker(node)) return;
         // TODO: Once it's just Fiber we can move this to node._wrapperState
        node._valueTracker = trackValueOnNode(node);
    }
    function updateValueIfChanged(node) {
        if (!node) return false;
        var tracker = getTracker(node); // if there is no tracker at this point it's unlikely
        // that trying again will succeed
        if (!tracker) return true;
        var lastValue = tracker.getValue();
        var nextValue = getValueFromNode(node);
        if (nextValue !== lastValue) {
            tracker.setValue(nextValue);
            return true;
        }
        return false;
    }
    var didWarnValueDefaultValue = false;
    var didWarnCheckedDefaultChecked = false;
    var didWarnControlledToUncontrolled = false;
    var didWarnUncontrolledToControlled = false;
    function isControlled(props) {
        var usesChecked = props.type === "checkbox" || props.type === "radio";
        return usesChecked ? props.checked != null : props.value != null;
    }
    /**
 * Implements an <input> host component that allows setting these optional
 * props: `checked`, `value`, `defaultChecked`, and `defaultValue`.
 *
 * If `checked` or `value` are not supplied (or null/undefined), user actions
 * that affect the checked state or value will trigger updates to the element.
 *
 * If they are supplied (and not null/undefined), the rendered element will not
 * trigger updates to the element. Instead, the props must change in order for
 * the rendered element to be updated.
 *
 * The rendered element will be initialized as unchecked (or `defaultChecked`)
 * with an empty value (or `defaultValue`).
 *
 * See http://www.w3.org/TR/2012/WD-html5-20121025/the-input-element.html
 */ function getHostProps(element, props) {
        var node = element;
        var checked = props.checked;
        var hostProps = _assign({}, props, {
            defaultChecked: undefined,
            defaultValue: undefined,
            value: undefined,
            checked: checked != null ? checked : node._wrapperState.initialChecked
        });
        return hostProps;
    }
    function initWrapperState(element, props) {
        ReactControlledValuePropTypes.checkPropTypes("input", props);
        if (props.checked !== undefined && props.defaultChecked !== undefined && !didWarnCheckedDefaultChecked) {
            error("%s contains an input of type %s with both checked and defaultChecked props. Input elements must be either controlled or uncontrolled (specify either the checked prop, or the defaultChecked prop, but not both). Decide between using a controlled or uncontrolled input element and remove one of these props. More info: https://fb.me/react-controlled-components", getCurrentFiberOwnerNameInDevOrNull() || "A component", props.type);
            didWarnCheckedDefaultChecked = true;
        }
        if (props.value !== undefined && props.defaultValue !== undefined && !didWarnValueDefaultValue) {
            error("%s contains an input of type %s with both value and defaultValue props. Input elements must be either controlled or uncontrolled (specify either the value prop, or the defaultValue prop, but not both). Decide between using a controlled or uncontrolled input element and remove one of these props. More info: https://fb.me/react-controlled-components", getCurrentFiberOwnerNameInDevOrNull() || "A component", props.type);
            didWarnValueDefaultValue = true;
        }
        var node = element;
        var defaultValue = props.defaultValue == null ? "" : props.defaultValue;
        node._wrapperState = {
            initialChecked: props.checked != null ? props.checked : props.defaultChecked,
            initialValue: getToStringValue(props.value != null ? props.value : defaultValue),
            controlled: isControlled(props)
        };
    }
    function updateChecked(element, props) {
        var node = element;
        var checked = props.checked;
        if (checked != null) setValueForProperty(node, "checked", checked, false);
    }
    function updateWrapper(element, props) {
        var node = element;
        var controlled = isControlled(props);
        if (!node._wrapperState.controlled && controlled && !didWarnUncontrolledToControlled) {
            error("A component is changing an uncontrolled input of type %s to be controlled. Input elements should not switch from uncontrolled to controlled (or vice versa). Decide between using a controlled or uncontrolled input element for the lifetime of the component. More info: https://fb.me/react-controlled-components", props.type);
            didWarnUncontrolledToControlled = true;
        }
        if (node._wrapperState.controlled && !controlled && !didWarnControlledToUncontrolled) {
            error("A component is changing a controlled input of type %s to be uncontrolled. Input elements should not switch from controlled to uncontrolled (or vice versa). Decide between using a controlled or uncontrolled input element for the lifetime of the component. More info: https://fb.me/react-controlled-components", props.type);
            didWarnControlledToUncontrolled = true;
        }
        updateChecked(element, props);
        var value = getToStringValue(props.value);
        var type = props.type;
        if (value != null) {
            if (type === "number") {
                if (value === 0 && node.value === "" || // We explicitly want to coerce to number here if possible.
                // eslint-disable-next-line
                node.value != value) node.value = toString(value);
            } else if (node.value !== toString(value)) node.value = toString(value);
        } else if (type === "submit" || type === "reset") {
            // Submit/reset inputs need the attribute removed completely to avoid
            // blank-text buttons.
            node.removeAttribute("value");
            return;
        }
        // When syncing the value attribute, the value comes from a cascade of
        // properties:
        //  1. The value React property
        //  2. The defaultValue React property
        //  3. Otherwise there should be no change
        if (props.hasOwnProperty("value")) setDefaultValue(node, props.type, value);
        else if (props.hasOwnProperty("defaultValue")) setDefaultValue(node, props.type, getToStringValue(props.defaultValue));
        // When syncing the checked attribute, it only changes when it needs
        // to be removed, such as transitioning from a checkbox into a text input
        if (props.checked == null && props.defaultChecked != null) node.defaultChecked = !!props.defaultChecked;
    }
    function postMountWrapper(element, props, isHydrating) {
        var node = element; // Do not assign value if it is already set. This prevents user text input
        // from being lost during SSR hydration.
        if (props.hasOwnProperty("value") || props.hasOwnProperty("defaultValue")) {
            var type = props.type;
            var isButton = type === "submit" || type === "reset"; // Avoid setting value attribute on submit/reset inputs as it overrides the
            // default value provided by the browser. See: #12872
            if (isButton && (props.value === undefined || props.value === null)) return;
            var initialValue = toString(node._wrapperState.initialValue); // Do not assign value if it is already set. This prevents user text input
            // from being lost during SSR hydration.
            if (!isHydrating) // When syncing the value attribute, the value property should use
            // the wrapperState._initialValue property. This uses:
            //
            //   1. The value React property when present
            //   2. The defaultValue React property when present
            //   3. An empty string
            {
                if (initialValue !== node.value) node.value = initialValue;
            }
            // Otherwise, the value attribute is synchronized to the property,
            // so we assign defaultValue to the same thing as the value property
            // assignment step above.
            node.defaultValue = initialValue;
        } // Normally, we'd just do `node.checked = node.checked` upon initial mount, less this bug
        // this is needed to work around a chrome bug where setting defaultChecked
        // will sometimes influence the value of checked (even after detachment).
        // Reference: https://bugs.chromium.org/p/chromium/issues/detail?id=608416
        // We need to temporarily unset name to avoid disrupting radio button groups.
        var name = node.name;
        if (name !== "") node.name = "";
        // When syncing the checked attribute, both the checked property and
        // attribute are assigned at the same time using defaultChecked. This uses:
        //
        //   1. The checked React property when present
        //   2. The defaultChecked React property when present
        //   3. Otherwise, false
        node.defaultChecked = !node.defaultChecked;
        node.defaultChecked = !!node._wrapperState.initialChecked;
        if (name !== "") node.name = name;
    }
    function restoreControlledState(element, props) {
        var node = element;
        updateWrapper(node, props);
        updateNamedCousins(node, props);
    }
    function updateNamedCousins(rootNode, props) {
        var name = props.name;
        if (props.type === "radio" && name != null) {
            var queryRoot = rootNode;
            while(queryRoot.parentNode)queryRoot = queryRoot.parentNode;
             // If `rootNode.form` was non-null, then we could try `form.elements`,
            // but that sometimes behaves strangely in IE8. We could also try using
            // `form.getElementsByName`, but that will only return direct children
            // and won't include inputs that use the HTML5 `form=` attribute. Since
            // the input might not even be in a form. It might not even be in the
            // document. Let's just use the local `querySelectorAll` to ensure we don't
            // miss anything.
            var group = queryRoot.querySelectorAll("input[name=" + JSON.stringify("" + name) + '][type="radio"]');
            for(var i = 0; i < group.length; i++){
                var otherNode = group[i];
                if (otherNode === rootNode || otherNode.form !== rootNode.form) continue;
                 // This will throw if radio buttons rendered by different copies of React
                // and the same name are rendered into the same form (same as #1939).
                // That's probably okay; we don't support it just as we don't support
                // mixing React radio buttons with non-React ones.
                var otherProps = getFiberCurrentPropsFromNode$1(otherNode);
                if (!otherProps) throw Error("ReactDOMInput: Mixing React and non-React radio inputs with the same `name` is not supported.");
                 // We need update the tracked value on the named cousin since the value
                // was changed but the input saw no event or value set
                updateValueIfChanged(otherNode); // If this is a controlled radio button group, forcing the input that
                // was previously checked to update will cause it to be come re-checked
                // as appropriate.
                updateWrapper(otherNode, otherProps);
            }
        }
    } // In Chrome, assigning defaultValue to certain input types triggers input validation.
    // For number inputs, the display value loses trailing decimal points. For email inputs,
    // Chrome raises "The specified value <x> is not a valid email address".
    //
    // Here we check to see if the defaultValue has actually changed, avoiding these problems
    // when the user is inputting text
    //
    // https://github.com/facebook/react/issues/7253
    function setDefaultValue(node, type, value) {
        if (type !== "number" || node.ownerDocument.activeElement !== node) {
            if (value == null) node.defaultValue = toString(node._wrapperState.initialValue);
            else if (node.defaultValue !== toString(value)) node.defaultValue = toString(value);
        }
    }
    var didWarnSelectedSetOnOption = false;
    var didWarnInvalidChild = false;
    function flattenChildren(children) {
        var content = ""; // Flatten children. We'll warn if they are invalid
        // during validateProps() which runs for hydration too.
        // Note that this would throw on non-element objects.
        // Elements are stringified (which is normally irrelevant
        // but matters for <fbt>).
        React.Children.forEach(children, function(child) {
            if (child == null) return;
            content += child; // Note: we don't warn about invalid children here.
        // Instead, this is done separately below so that
        // it happens during the hydration codepath too.
        });
        return content;
    }
    /**
 * Implements an <option> host component that warns when `selected` is set.
 */ function validateProps(element, props) {
        // This mirrors the codepath above, but runs for hydration too.
        // Warn about invalid children here so that client and hydration are consistent.
        // TODO: this seems like it could cause a DEV-only throw for hydration
        // if children contains a non-element object. We should try to avoid that.
        if (typeof props.children === "object" && props.children !== null) React.Children.forEach(props.children, function(child) {
            if (child == null) return;
            if (typeof child === "string" || typeof child === "number") return;
            if (typeof child.type !== "string") return;
            if (!didWarnInvalidChild) {
                didWarnInvalidChild = true;
                error("Only strings and numbers are supported as <option> children.");
            }
        });
         // TODO: Remove support for `selected` in <option>.
        if (props.selected != null && !didWarnSelectedSetOnOption) {
            error("Use the `defaultValue` or `value` props on <select> instead of setting `selected` on <option>.");
            didWarnSelectedSetOnOption = true;
        }
    }
    function postMountWrapper$1(element, props) {
        // value="" should make a value attribute (#6219)
        if (props.value != null) element.setAttribute("value", toString(getToStringValue(props.value)));
    }
    function getHostProps$1(element, props) {
        var hostProps = _assign({
            children: undefined
        }, props);
        var content = flattenChildren(props.children);
        if (content) hostProps.children = content;
        return hostProps;
    }
    var didWarnValueDefaultValue$1;
    didWarnValueDefaultValue$1 = false;
    function getDeclarationErrorAddendum() {
        var ownerName = getCurrentFiberOwnerNameInDevOrNull();
        if (ownerName) return "\n\nCheck the render method of `" + ownerName + "`.";
        return "";
    }
    var valuePropNames = [
        "value",
        "defaultValue"
    ];
    /**
 * Validation function for `value` and `defaultValue`.
 */ function checkSelectPropTypes(props) {
        ReactControlledValuePropTypes.checkPropTypes("select", props);
        for(var i = 0; i < valuePropNames.length; i++){
            var propName = valuePropNames[i];
            if (props[propName] == null) continue;
            var isArray = Array.isArray(props[propName]);
            if (props.multiple && !isArray) error("The `%s` prop supplied to <select> must be an array if `multiple` is true.%s", propName, getDeclarationErrorAddendum());
            else if (!props.multiple && isArray) error("The `%s` prop supplied to <select> must be a scalar value if `multiple` is false.%s", propName, getDeclarationErrorAddendum());
        }
    }
    function updateOptions(node, multiple, propValue, setDefaultSelected) {
        var options = node.options;
        if (multiple) {
            var selectedValues = propValue;
            var selectedValue = {};
            for(var i = 0; i < selectedValues.length; i++)// Prefix to avoid chaos with special keys.
            selectedValue["$" + selectedValues[i]] = true;
            for(var _i = 0; _i < options.length; _i++){
                var selected = selectedValue.hasOwnProperty("$" + options[_i].value);
                if (options[_i].selected !== selected) options[_i].selected = selected;
                if (selected && setDefaultSelected) options[_i].defaultSelected = true;
            }
        } else {
            // Do not set `select.value` as exact behavior isn't consistent across all
            // browsers for all cases.
            var _selectedValue = toString(getToStringValue(propValue));
            var defaultSelected = null;
            for(var _i2 = 0; _i2 < options.length; _i2++){
                if (options[_i2].value === _selectedValue) {
                    options[_i2].selected = true;
                    if (setDefaultSelected) options[_i2].defaultSelected = true;
                    return;
                }
                if (defaultSelected === null && !options[_i2].disabled) defaultSelected = options[_i2];
            }
            if (defaultSelected !== null) defaultSelected.selected = true;
        }
    }
    /**
 * Implements a <select> host component that allows optionally setting the
 * props `value` and `defaultValue`. If `multiple` is false, the prop must be a
 * stringable. If `multiple` is true, the prop must be an array of stringables.
 *
 * If `value` is not supplied (or null/undefined), user actions that change the
 * selected option will trigger updates to the rendered options.
 *
 * If it is supplied (and not null/undefined), the rendered options will not
 * update in response to user actions. Instead, the `value` prop must change in
 * order for the rendered options to update.
 *
 * If `defaultValue` is provided, any options with the supplied values will be
 * selected.
 */ function getHostProps$2(element, props) {
        return _assign({}, props, {
            value: undefined
        });
    }
    function initWrapperState$1(element, props) {
        var node = element;
        checkSelectPropTypes(props);
        node._wrapperState = {
            wasMultiple: !!props.multiple
        };
        if (props.value !== undefined && props.defaultValue !== undefined && !didWarnValueDefaultValue$1) {
            error("Select elements must be either controlled or uncontrolled (specify either the value prop, or the defaultValue prop, but not both). Decide between using a controlled or uncontrolled select element and remove one of these props. More info: https://fb.me/react-controlled-components");
            didWarnValueDefaultValue$1 = true;
        }
    }
    function postMountWrapper$2(element, props) {
        var node = element;
        node.multiple = !!props.multiple;
        var value = props.value;
        if (value != null) updateOptions(node, !!props.multiple, value, false);
        else if (props.defaultValue != null) updateOptions(node, !!props.multiple, props.defaultValue, true);
    }
    function postUpdateWrapper(element, props) {
        var node = element;
        var wasMultiple = node._wrapperState.wasMultiple;
        node._wrapperState.wasMultiple = !!props.multiple;
        var value = props.value;
        if (value != null) updateOptions(node, !!props.multiple, value, false);
        else if (wasMultiple !== !!props.multiple) {
            // For simplicity, reapply `defaultValue` if `multiple` is toggled.
            if (props.defaultValue != null) updateOptions(node, !!props.multiple, props.defaultValue, true);
            else // Revert the select back to its default unselected state.
            updateOptions(node, !!props.multiple, props.multiple ? [] : "", false);
        }
    }
    function restoreControlledState$1(element, props) {
        var node = element;
        var value = props.value;
        if (value != null) updateOptions(node, !!props.multiple, value, false);
    }
    var didWarnValDefaultVal = false;
    /**
 * Implements a <textarea> host component that allows setting `value`, and
 * `defaultValue`. This differs from the traditional DOM API because value is
 * usually set as PCDATA children.
 *
 * If `value` is not supplied (or null/undefined), user actions that affect the
 * value will trigger updates to the element.
 *
 * If `value` is supplied (and not null/undefined), the rendered element will
 * not trigger updates to the element. Instead, the `value` prop must change in
 * order for the rendered element to be updated.
 *
 * The rendered element will be initialized with an empty value, the prop
 * `defaultValue` if specified, or the children content (deprecated).
 */ function getHostProps$3(element, props) {
        var node = element;
        if (!(props.dangerouslySetInnerHTML == null)) throw Error("`dangerouslySetInnerHTML` does not make sense on <textarea>.");
         // Always set children to the same thing. In IE9, the selection range will
        // get reset if `textContent` is mutated.  We could add a check in setTextContent
        // to only set the value if/when the value differs from the node value (which would
        // completely solve this IE9 bug), but Sebastian+Sophie seemed to like this
        // solution. The value can be a boolean or object so that's why it's forced
        // to be a string.
        var hostProps = _assign({}, props, {
            value: undefined,
            defaultValue: undefined,
            children: toString(node._wrapperState.initialValue)
        });
        return hostProps;
    }
    function initWrapperState$2(element, props) {
        var node = element;
        ReactControlledValuePropTypes.checkPropTypes("textarea", props);
        if (props.value !== undefined && props.defaultValue !== undefined && !didWarnValDefaultVal) {
            error("%s contains a textarea with both value and defaultValue props. Textarea elements must be either controlled or uncontrolled (specify either the value prop, or the defaultValue prop, but not both). Decide between using a controlled or uncontrolled textarea and remove one of these props. More info: https://fb.me/react-controlled-components", getCurrentFiberOwnerNameInDevOrNull() || "A component");
            didWarnValDefaultVal = true;
        }
        var initialValue = props.value; // Only bother fetching default value if we're going to use it
        if (initialValue == null) {
            var children = props.children, defaultValue = props.defaultValue;
            if (children != null) {
                error("Use the `defaultValue` or `value` props instead of setting children on <textarea>.");
                if (!(defaultValue == null)) throw Error("If you supply `defaultValue` on a <textarea>, do not pass children.");
                if (Array.isArray(children)) {
                    if (!(children.length <= 1)) throw Error("<textarea> can only have at most one child.");
                    children = children[0];
                }
                defaultValue = children;
            }
            if (defaultValue == null) defaultValue = "";
            initialValue = defaultValue;
        }
        node._wrapperState = {
            initialValue: getToStringValue(initialValue)
        };
    }
    function updateWrapper$1(element, props) {
        var node = element;
        var value = getToStringValue(props.value);
        var defaultValue = getToStringValue(props.defaultValue);
        if (value != null) {
            // Cast `value` to a string to ensure the value is set correctly. While
            // browsers typically do this as necessary, jsdom doesn't.
            var newValue = toString(value); // To avoid side effects (such as losing text selection), only set value if changed
            if (newValue !== node.value) node.value = newValue;
            if (props.defaultValue == null && node.defaultValue !== newValue) node.defaultValue = newValue;
        }
        if (defaultValue != null) node.defaultValue = toString(defaultValue);
    }
    function postMountWrapper$3(element, props) {
        var node = element; // This is in postMount because we need access to the DOM node, which is not
        // available until after the component has mounted.
        var textContent = node.textContent; // Only set node.value if textContent is equal to the expected
        // initial value. In IE10/IE11 there is a bug where the placeholder attribute
        // will populate textContent as well.
        // https://developer.microsoft.com/microsoft-edge/platform/issues/101525/
        if (textContent === node._wrapperState.initialValue) {
            if (textContent !== "" && textContent !== null) node.value = textContent;
        }
    }
    function restoreControlledState$2(element, props) {
        // DOM component is still mounted; update
        updateWrapper$1(element, props);
    }
    var HTML_NAMESPACE = "http://www.w3.org/1999/xhtml";
    var MATH_NAMESPACE = "http://www.w3.org/1998/Math/MathML";
    var SVG_NAMESPACE = "http://www.w3.org/2000/svg";
    var Namespaces = {
        html: HTML_NAMESPACE,
        mathml: MATH_NAMESPACE,
        svg: SVG_NAMESPACE
    }; // Assumes there is no parent namespace.
    function getIntrinsicNamespace(type) {
        switch(type){
            case "svg":
                return SVG_NAMESPACE;
            case "math":
                return MATH_NAMESPACE;
            default:
                return HTML_NAMESPACE;
        }
    }
    function getChildNamespace(parentNamespace, type) {
        if (parentNamespace == null || parentNamespace === HTML_NAMESPACE) // No (or default) parent namespace: potential entry point.
        return getIntrinsicNamespace(type);
        if (parentNamespace === SVG_NAMESPACE && type === "foreignObject") // We're leaving SVG.
        return HTML_NAMESPACE;
         // By default, pass namespace below.
        return parentNamespace;
    }
    /* globals MSApp */ /**
 * Create a function which has 'unsafe' privileges (required by windows8 apps)
 */ var createMicrosoftUnsafeLocalFunction = function(func) {
        if (typeof MSApp !== "undefined" && MSApp.execUnsafeLocalFunction) return function(arg0, arg1, arg2, arg3) {
            MSApp.execUnsafeLocalFunction(function() {
                return func(arg0, arg1, arg2, arg3);
            });
        };
        else return func;
    };
    var reusableSVGContainer;
    /**
 * Set the innerHTML property of a node
 *
 * @param {DOMElement} node
 * @param {string} html
 * @internal
 */ var setInnerHTML = createMicrosoftUnsafeLocalFunction(function(node, html) {
        if (node.namespaceURI === Namespaces.svg) {
            if (!("innerHTML" in node)) {
                // IE does not have innerHTML for SVG nodes, so instead we inject the
                // new markup in a temp node and then move the child nodes across into
                // the target node
                reusableSVGContainer = reusableSVGContainer || document.createElement("div");
                reusableSVGContainer.innerHTML = "<svg>" + html.valueOf().toString() + "</svg>";
                var svgNode = reusableSVGContainer.firstChild;
                while(node.firstChild)node.removeChild(node.firstChild);
                while(svgNode.firstChild)node.appendChild(svgNode.firstChild);
                return;
            }
        }
        node.innerHTML = html;
    });
    /**
 * HTML nodeType values that represent the type of the node
 */ var ELEMENT_NODE = 1;
    var TEXT_NODE = 3;
    var COMMENT_NODE = 8;
    var DOCUMENT_NODE = 9;
    var DOCUMENT_FRAGMENT_NODE = 11;
    /**
 * Set the textContent property of a node. For text updates, it's faster
 * to set the `nodeValue` of the Text node directly instead of using
 * `.textContent` which will remove the existing node and create a new one.
 *
 * @param {DOMElement} node
 * @param {string} text
 * @internal
 */ var setTextContent = function(node, text) {
        if (text) {
            var firstChild = node.firstChild;
            if (firstChild && firstChild === node.lastChild && firstChild.nodeType === TEXT_NODE) {
                firstChild.nodeValue = text;
                return;
            }
        }
        node.textContent = text;
    };
    // Do not use the below two methods directly!
    // Instead use constants exported from DOMTopLevelEventTypes in ReactDOM.
    // (It is the only module that is allowed to access these methods.)
    function unsafeCastStringToDOMTopLevelType(topLevelType) {
        return topLevelType;
    }
    function unsafeCastDOMTopLevelTypeToString(topLevelType) {
        return topLevelType;
    }
    /**
 * Generate a mapping of standard vendor prefixes using the defined style property and event name.
 *
 * @param {string} styleProp
 * @param {string} eventName
 * @returns {object}
 */ function makePrefixMap(styleProp, eventName) {
        var prefixes = {};
        prefixes[styleProp.toLowerCase()] = eventName.toLowerCase();
        prefixes["Webkit" + styleProp] = "webkit" + eventName;
        prefixes["Moz" + styleProp] = "moz" + eventName;
        return prefixes;
    }
    /**
 * A list of event names to a configurable list of vendor prefixes.
 */ var vendorPrefixes = {
        animationend: makePrefixMap("Animation", "AnimationEnd"),
        animationiteration: makePrefixMap("Animation", "AnimationIteration"),
        animationstart: makePrefixMap("Animation", "AnimationStart"),
        transitionend: makePrefixMap("Transition", "TransitionEnd")
    };
    /**
 * Event names that have already been detected and prefixed (if applicable).
 */ var prefixedEventNames = {};
    /**
 * Element to check for prefixes on.
 */ var style = {};
    /**
 * Bootstrap if a DOM exists.
 */ if (canUseDOM) {
        style = document.createElement("div").style; // On some platforms, in particular some releases of Android 4.x,
        // the un-prefixed "animation" and "transition" properties are defined on the
        // style object but the events that fire will still be prefixed, so we need
        // to check if the un-prefixed events are usable, and if not remove them from the map.
        if (!("AnimationEvent" in window)) {
            delete vendorPrefixes.animationend.animation;
            delete vendorPrefixes.animationiteration.animation;
            delete vendorPrefixes.animationstart.animation;
        } // Same as above
        if (!("TransitionEvent" in window)) delete vendorPrefixes.transitionend.transition;
    }
    /**
 * Attempts to determine the correct vendor prefixed event name.
 *
 * @param {string} eventName
 * @returns {string}
 */ function getVendorPrefixedEventName(eventName) {
        if (prefixedEventNames[eventName]) return prefixedEventNames[eventName];
        else if (!vendorPrefixes[eventName]) return eventName;
        var prefixMap = vendorPrefixes[eventName];
        for(var styleProp in prefixMap){
            if (prefixMap.hasOwnProperty(styleProp) && styleProp in style) return prefixedEventNames[eventName] = prefixMap[styleProp];
        }
        return eventName;
    }
    /**
 * To identify top level events in ReactDOM, we use constants defined by this
 * module. This is the only module that uses the unsafe* methods to express
 * that the constants actually correspond to the browser event names. This lets
 * us save some bundle size by avoiding a top level type -> event name map.
 * The rest of ReactDOM code should import top level types from this file.
 */ var TOP_ABORT = unsafeCastStringToDOMTopLevelType("abort");
    var TOP_ANIMATION_END = unsafeCastStringToDOMTopLevelType(getVendorPrefixedEventName("animationend"));
    var TOP_ANIMATION_ITERATION = unsafeCastStringToDOMTopLevelType(getVendorPrefixedEventName("animationiteration"));
    var TOP_ANIMATION_START = unsafeCastStringToDOMTopLevelType(getVendorPrefixedEventName("animationstart"));
    var TOP_BLUR = unsafeCastStringToDOMTopLevelType("blur");
    var TOP_CAN_PLAY = unsafeCastStringToDOMTopLevelType("canplay");
    var TOP_CAN_PLAY_THROUGH = unsafeCastStringToDOMTopLevelType("canplaythrough");
    var TOP_CANCEL = unsafeCastStringToDOMTopLevelType("cancel");
    var TOP_CHANGE = unsafeCastStringToDOMTopLevelType("change");
    var TOP_CLICK = unsafeCastStringToDOMTopLevelType("click");
    var TOP_CLOSE = unsafeCastStringToDOMTopLevelType("close");
    var TOP_COMPOSITION_END = unsafeCastStringToDOMTopLevelType("compositionend");
    var TOP_COMPOSITION_START = unsafeCastStringToDOMTopLevelType("compositionstart");
    var TOP_COMPOSITION_UPDATE = unsafeCastStringToDOMTopLevelType("compositionupdate");
    var TOP_CONTEXT_MENU = unsafeCastStringToDOMTopLevelType("contextmenu");
    var TOP_COPY = unsafeCastStringToDOMTopLevelType("copy");
    var TOP_CUT = unsafeCastStringToDOMTopLevelType("cut");
    var TOP_DOUBLE_CLICK = unsafeCastStringToDOMTopLevelType("dblclick");
    var TOP_AUX_CLICK = unsafeCastStringToDOMTopLevelType("auxclick");
    var TOP_DRAG = unsafeCastStringToDOMTopLevelType("drag");
    var TOP_DRAG_END = unsafeCastStringToDOMTopLevelType("dragend");
    var TOP_DRAG_ENTER = unsafeCastStringToDOMTopLevelType("dragenter");
    var TOP_DRAG_EXIT = unsafeCastStringToDOMTopLevelType("dragexit");
    var TOP_DRAG_LEAVE = unsafeCastStringToDOMTopLevelType("dragleave");
    var TOP_DRAG_OVER = unsafeCastStringToDOMTopLevelType("dragover");
    var TOP_DRAG_START = unsafeCastStringToDOMTopLevelType("dragstart");
    var TOP_DROP = unsafeCastStringToDOMTopLevelType("drop");
    var TOP_DURATION_CHANGE = unsafeCastStringToDOMTopLevelType("durationchange");
    var TOP_EMPTIED = unsafeCastStringToDOMTopLevelType("emptied");
    var TOP_ENCRYPTED = unsafeCastStringToDOMTopLevelType("encrypted");
    var TOP_ENDED = unsafeCastStringToDOMTopLevelType("ended");
    var TOP_ERROR = unsafeCastStringToDOMTopLevelType("error");
    var TOP_FOCUS = unsafeCastStringToDOMTopLevelType("focus");
    var TOP_GOT_POINTER_CAPTURE = unsafeCastStringToDOMTopLevelType("gotpointercapture");
    var TOP_INPUT = unsafeCastStringToDOMTopLevelType("input");
    var TOP_INVALID = unsafeCastStringToDOMTopLevelType("invalid");
    var TOP_KEY_DOWN = unsafeCastStringToDOMTopLevelType("keydown");
    var TOP_KEY_PRESS = unsafeCastStringToDOMTopLevelType("keypress");
    var TOP_KEY_UP = unsafeCastStringToDOMTopLevelType("keyup");
    var TOP_LOAD = unsafeCastStringToDOMTopLevelType("load");
    var TOP_LOAD_START = unsafeCastStringToDOMTopLevelType("loadstart");
    var TOP_LOADED_DATA = unsafeCastStringToDOMTopLevelType("loadeddata");
    var TOP_LOADED_METADATA = unsafeCastStringToDOMTopLevelType("loadedmetadata");
    var TOP_LOST_POINTER_CAPTURE = unsafeCastStringToDOMTopLevelType("lostpointercapture");
    var TOP_MOUSE_DOWN = unsafeCastStringToDOMTopLevelType("mousedown");
    var TOP_MOUSE_MOVE = unsafeCastStringToDOMTopLevelType("mousemove");
    var TOP_MOUSE_OUT = unsafeCastStringToDOMTopLevelType("mouseout");
    var TOP_MOUSE_OVER = unsafeCastStringToDOMTopLevelType("mouseover");
    var TOP_MOUSE_UP = unsafeCastStringToDOMTopLevelType("mouseup");
    var TOP_PASTE = unsafeCastStringToDOMTopLevelType("paste");
    var TOP_PAUSE = unsafeCastStringToDOMTopLevelType("pause");
    var TOP_PLAY = unsafeCastStringToDOMTopLevelType("play");
    var TOP_PLAYING = unsafeCastStringToDOMTopLevelType("playing");
    var TOP_POINTER_CANCEL = unsafeCastStringToDOMTopLevelType("pointercancel");
    var TOP_POINTER_DOWN = unsafeCastStringToDOMTopLevelType("pointerdown");
    var TOP_POINTER_MOVE = unsafeCastStringToDOMTopLevelType("pointermove");
    var TOP_POINTER_OUT = unsafeCastStringToDOMTopLevelType("pointerout");
    var TOP_POINTER_OVER = unsafeCastStringToDOMTopLevelType("pointerover");
    var TOP_POINTER_UP = unsafeCastStringToDOMTopLevelType("pointerup");
    var TOP_PROGRESS = unsafeCastStringToDOMTopLevelType("progress");
    var TOP_RATE_CHANGE = unsafeCastStringToDOMTopLevelType("ratechange");
    var TOP_RESET = unsafeCastStringToDOMTopLevelType("reset");
    var TOP_SCROLL = unsafeCastStringToDOMTopLevelType("scroll");
    var TOP_SEEKED = unsafeCastStringToDOMTopLevelType("seeked");
    var TOP_SEEKING = unsafeCastStringToDOMTopLevelType("seeking");
    var TOP_SELECTION_CHANGE = unsafeCastStringToDOMTopLevelType("selectionchange");
    var TOP_STALLED = unsafeCastStringToDOMTopLevelType("stalled");
    var TOP_SUBMIT = unsafeCastStringToDOMTopLevelType("submit");
    var TOP_SUSPEND = unsafeCastStringToDOMTopLevelType("suspend");
    var TOP_TEXT_INPUT = unsafeCastStringToDOMTopLevelType("textInput");
    var TOP_TIME_UPDATE = unsafeCastStringToDOMTopLevelType("timeupdate");
    var TOP_TOGGLE = unsafeCastStringToDOMTopLevelType("toggle");
    var TOP_TOUCH_CANCEL = unsafeCastStringToDOMTopLevelType("touchcancel");
    var TOP_TOUCH_END = unsafeCastStringToDOMTopLevelType("touchend");
    var TOP_TOUCH_MOVE = unsafeCastStringToDOMTopLevelType("touchmove");
    var TOP_TOUCH_START = unsafeCastStringToDOMTopLevelType("touchstart");
    var TOP_TRANSITION_END = unsafeCastStringToDOMTopLevelType(getVendorPrefixedEventName("transitionend"));
    var TOP_VOLUME_CHANGE = unsafeCastStringToDOMTopLevelType("volumechange");
    var TOP_WAITING = unsafeCastStringToDOMTopLevelType("waiting");
    var TOP_WHEEL = unsafeCastStringToDOMTopLevelType("wheel"); // List of events that need to be individually attached to media elements.
    // Note that events in this list will *not* be listened to at the top level
    // unless they're explicitly whitelisted in `ReactBrowserEventEmitter.listenTo`.
    var mediaEventTypes = [
        TOP_ABORT,
        TOP_CAN_PLAY,
        TOP_CAN_PLAY_THROUGH,
        TOP_DURATION_CHANGE,
        TOP_EMPTIED,
        TOP_ENCRYPTED,
        TOP_ENDED,
        TOP_ERROR,
        TOP_LOADED_DATA,
        TOP_LOADED_METADATA,
        TOP_LOAD_START,
        TOP_PAUSE,
        TOP_PLAY,
        TOP_PLAYING,
        TOP_PROGRESS,
        TOP_RATE_CHANGE,
        TOP_SEEKED,
        TOP_SEEKING,
        TOP_STALLED,
        TOP_SUSPEND,
        TOP_TIME_UPDATE,
        TOP_VOLUME_CHANGE,
        TOP_WAITING
    ];
    function getRawEventName(topLevelType) {
        return unsafeCastDOMTopLevelTypeToString(topLevelType);
    }
    var PossiblyWeakMap = typeof WeakMap === "function" ? WeakMap : Map; // prettier-ignore
    var elementListenerMap = new PossiblyWeakMap();
    function getListenerMapForElement(element) {
        var listenerMap = elementListenerMap.get(element);
        if (listenerMap === undefined) {
            listenerMap = new Map();
            elementListenerMap.set(element, listenerMap);
        }
        return listenerMap;
    }
    /**
 * `ReactInstanceMap` maintains a mapping from a public facing stateful
 * instance (key) and the internal representation (value). This allows public
 * methods to accept the user facing instance as an argument and map them back
 * to internal methods.
 *
 * Note that this module is currently shared and assumed to be stateless.
 * If this becomes an actual Map, that will break.
 */ function get(key) {
        return key._reactInternalFiber;
    }
    function has(key) {
        return key._reactInternalFiber !== undefined;
    }
    function set(key, value) {
        key._reactInternalFiber = value;
    }
    // Don't change these two values. They're used by React Dev Tools.
    var NoEffect = /*              */ 0;
    var PerformedWork = /*         */ 1; // You can change the rest (and add more).
    var Placement = /*             */ 2;
    var Update = /*                */ 4;
    var PlacementAndUpdate = /*    */ 6;
    var Deletion = /*              */ 8;
    var ContentReset = /*          */ 16;
    var Callback = /*              */ 32;
    var DidCapture = /*            */ 64;
    var Ref = /*                   */ 128;
    var Snapshot = /*              */ 256;
    var Passive = /*               */ 512;
    var Hydrating = /*             */ 1024;
    var HydratingAndUpdate = /*    */ 1028; // Passive & Update & Callback & Ref & Snapshot
    var LifecycleEffectMask = /*   */ 932; // Union of all host effects
    var HostEffectMask = /*        */ 2047;
    var Incomplete = /*            */ 2048;
    var ShouldCapture = /*         */ 4096;
    var ReactCurrentOwner = ReactSharedInternals.ReactCurrentOwner;
    function getNearestMountedFiber(fiber) {
        var node = fiber;
        var nearestMounted = fiber;
        if (!fiber.alternate) {
            // If there is no alternate, this might be a new tree that isn't inserted
            // yet. If it is, then it will have a pending insertion effect on it.
            var nextNode = node;
            do {
                node = nextNode;
                if ((node.effectTag & (Placement | Hydrating)) !== NoEffect) // This is an insertion or in-progress hydration. The nearest possible
                // mounted fiber is the parent but we need to continue to figure out
                // if that one is still mounted.
                nearestMounted = node.return;
                nextNode = node.return;
            }while (nextNode);
        } else while(node.return)node = node.return;
        if (node.tag === HostRoot) // TODO: Check if this was a nested HostRoot when used with
        // renderContainerIntoSubtree.
        return nearestMounted;
         // If we didn't hit the root, that means that we're in an disconnected tree
        // that has been unmounted.
        return null;
    }
    function getSuspenseInstanceFromFiber(fiber) {
        if (fiber.tag === SuspenseComponent) {
            var suspenseState = fiber.memoizedState;
            if (suspenseState === null) {
                var current = fiber.alternate;
                if (current !== null) suspenseState = current.memoizedState;
            }
            if (suspenseState !== null) return suspenseState.dehydrated;
        }
        return null;
    }
    function getContainerFromFiber(fiber) {
        return fiber.tag === HostRoot ? fiber.stateNode.containerInfo : null;
    }
    function isFiberMounted(fiber) {
        return getNearestMountedFiber(fiber) === fiber;
    }
    function isMounted(component) {
        var owner = ReactCurrentOwner.current;
        if (owner !== null && owner.tag === ClassComponent) {
            var ownerFiber = owner;
            var instance = ownerFiber.stateNode;
            if (!instance._warnedAboutRefsInRender) error("%s is accessing isMounted inside its render() function. render() should be a pure function of props and state. It should never access something that requires stale data from the previous render, such as refs. Move this logic to componentDidMount and componentDidUpdate instead.", getComponentName(ownerFiber.type) || "A component");
            instance._warnedAboutRefsInRender = true;
        }
        var fiber = get(component);
        if (!fiber) return false;
        return getNearestMountedFiber(fiber) === fiber;
    }
    function assertIsMounted(fiber) {
        if (!(getNearestMountedFiber(fiber) === fiber)) throw Error("Unable to find node on an unmounted component.");
    }
    function findCurrentFiberUsingSlowPath(fiber) {
        var alternate = fiber.alternate;
        if (!alternate) {
            // If there is no alternate, then we only need to check if it is mounted.
            var nearestMounted = getNearestMountedFiber(fiber);
            if (!(nearestMounted !== null)) throw Error("Unable to find node on an unmounted component.");
            if (nearestMounted !== fiber) return null;
            return fiber;
        } // If we have two possible branches, we'll walk backwards up to the root
        // to see what path the root points to. On the way we may hit one of the
        // special cases and we'll deal with them.
        var a = fiber;
        var b = alternate;
        while(true){
            var parentA = a.return;
            if (parentA === null) break;
            var parentB = parentA.alternate;
            if (parentB === null) {
                // There is no alternate. This is an unusual case. Currently, it only
                // happens when a Suspense component is hidden. An extra fragment fiber
                // is inserted in between the Suspense fiber and its children. Skip
                // over this extra fragment fiber and proceed to the next parent.
                var nextParent = parentA.return;
                if (nextParent !== null) {
                    a = b = nextParent;
                    continue;
                } // If there's no parent, we're at the root.
                break;
            } // If both copies of the parent fiber point to the same child, we can
            // assume that the child is current. This happens when we bailout on low
            // priority: the bailed out fiber's child reuses the current child.
            if (parentA.child === parentB.child) {
                var child = parentA.child;
                while(child){
                    if (child === a) {
                        // We've determined that A is the current branch.
                        assertIsMounted(parentA);
                        return fiber;
                    }
                    if (child === b) {
                        // We've determined that B is the current branch.
                        assertIsMounted(parentA);
                        return alternate;
                    }
                    child = child.sibling;
                } // We should never have an alternate for any mounting node. So the only
                throw Error("Unable to find node on an unmounted component.");
            }
            if (a.return !== b.return) {
                // The return pointer of A and the return pointer of B point to different
                // fibers. We assume that return pointers never criss-cross, so A must
                // belong to the child set of A.return, and B must belong to the child
                // set of B.return.
                a = parentA;
                b = parentB;
            } else {
                // The return pointers point to the same fiber. We'll have to use the
                // default, slow path: scan the child sets of each parent alternate to see
                // which child belongs to which set.
                //
                // Search parent A's child set
                var didFindChild = false;
                var _child = parentA.child;
                while(_child){
                    if (_child === a) {
                        didFindChild = true;
                        a = parentA;
                        b = parentB;
                        break;
                    }
                    if (_child === b) {
                        didFindChild = true;
                        b = parentA;
                        a = parentB;
                        break;
                    }
                    _child = _child.sibling;
                }
                if (!didFindChild) {
                    // Search parent B's child set
                    _child = parentB.child;
                    while(_child){
                        if (_child === a) {
                            didFindChild = true;
                            a = parentB;
                            b = parentA;
                            break;
                        }
                        if (_child === b) {
                            didFindChild = true;
                            b = parentB;
                            a = parentA;
                            break;
                        }
                        _child = _child.sibling;
                    }
                    if (!didFindChild) throw Error("Child was not found in either parent set. This indicates a bug in React related to the return pointer. Please file an issue.");
                }
            }
            if (!(a.alternate === b)) throw Error("Return fibers should always be each others' alternates. This error is likely caused by a bug in React. Please file an issue.");
        } // If the root is not a host container, we're in a disconnected tree. I.e.
        // unmounted.
        if (!(a.tag === HostRoot)) throw Error("Unable to find node on an unmounted component.");
        if (a.stateNode.current === a) // We've determined that A is the current branch.
        return fiber;
         // Otherwise B has to be current branch.
        return alternate;
    }
    function findCurrentHostFiber(parent) {
        var currentParent = findCurrentFiberUsingSlowPath(parent);
        if (!currentParent) return null;
         // Next we'll drill down this component to find the first HostComponent/Text.
        var node = currentParent;
        while(true){
            if (node.tag === HostComponent || node.tag === HostText) return node;
            else if (node.child) {
                node.child.return = node;
                node = node.child;
                continue;
            }
            if (node === currentParent) return null;
            while(!node.sibling){
                if (!node.return || node.return === currentParent) return null;
                node = node.return;
            }
            node.sibling.return = node.return;
            node = node.sibling;
        } // Flow needs the return null here, but ESLint complains about it.
        // eslint-disable-next-line no-unreachable
        return null;
    }
    function findCurrentHostFiberWithNoPortals(parent) {
        var currentParent = findCurrentFiberUsingSlowPath(parent);
        if (!currentParent) return null;
         // Next we'll drill down this component to find the first HostComponent/Text.
        var node = currentParent;
        while(true){
            if (node.tag === HostComponent || node.tag === HostText || enableFundamentalAPI) return node;
            else if (node.child && node.tag !== HostPortal) {
                node.child.return = node;
                node = node.child;
                continue;
            }
            if (node === currentParent) return null;
            while(!node.sibling){
                if (!node.return || node.return === currentParent) return null;
                node = node.return;
            }
            node.sibling.return = node.return;
            node = node.sibling;
        } // Flow needs the return null here, but ESLint complains about it.
        // eslint-disable-next-line no-unreachable
        return null;
    }
    /**
 * Accumulates items that must not be null or undefined into the first one. This
 * is used to conserve memory by avoiding array allocations, and thus sacrifices
 * API cleanness. Since `current` can be null before being passed in and not
 * null after this function, make sure to assign it back to `current`:
 *
 * `a = accumulateInto(a, b);`
 *
 * This API should be sparingly used. Try `accumulate` for something cleaner.
 *
 * @return {*|array<*>} An accumulation of items.
 */ function accumulateInto(current, next) {
        if (!(next != null)) throw Error("accumulateInto(...): Accumulated items must not be null or undefined.");
        if (current == null) return next;
         // Both are not empty. Warning: Never call x.concat(y) when you are not
        // certain that x is an Array (x could be a string with concat method).
        if (Array.isArray(current)) {
            if (Array.isArray(next)) {
                current.push.apply(current, next);
                return current;
            }
            current.push(next);
            return current;
        }
        if (Array.isArray(next)) // A bit too dangerous to mutate `next`.
        return [
            current
        ].concat(next);
        return [
            current,
            next
        ];
    }
    /**
 * @param {array} arr an "accumulation" of items which is either an Array or
 * a single item. Useful when paired with the `accumulate` module. This is a
 * simple utility that allows us to reason about a collection of items, but
 * handling the case when there is exactly one item (and we do not need to
 * allocate an array).
 * @param {function} cb Callback invoked with each element or a collection.
 * @param {?} [scope] Scope used as `this` in a callback.
 */ function forEachAccumulated(arr, cb, scope) {
        if (Array.isArray(arr)) arr.forEach(cb, scope);
        else if (arr) cb.call(scope, arr);
    }
    /**
 * Internal queue of events that have accumulated their dispatches and are
 * waiting to have their dispatches executed.
 */ var eventQueue = null;
    /**
 * Dispatches an event and releases it back into the pool, unless persistent.
 *
 * @param {?object} event Synthetic event to be dispatched.
 * @private
 */ var executeDispatchesAndRelease = function(event) {
        if (event) {
            executeDispatchesInOrder(event);
            if (!event.isPersistent()) event.constructor.release(event);
        }
    };
    var executeDispatchesAndReleaseTopLevel = function(e) {
        return executeDispatchesAndRelease(e);
    };
    function runEventsInBatch(events) {
        if (events !== null) eventQueue = accumulateInto(eventQueue, events);
         // Set `eventQueue` to null before processing it so that we can tell if more
        // events get enqueued while processing.
        var processingEventQueue = eventQueue;
        eventQueue = null;
        if (!processingEventQueue) return;
        forEachAccumulated(processingEventQueue, executeDispatchesAndReleaseTopLevel);
        if (!!eventQueue) throw Error("processEventQueue(): Additional events were enqueued while processing an event queue. Support for this has not yet been implemented.");
         // This would be a good time to rethrow if any of the event handlers threw.
        rethrowCaughtError();
    }
    /**
 * Gets the target node from a native browser event by accounting for
 * inconsistencies in browser DOM APIs.
 *
 * @param {object} nativeEvent Native browser event.
 * @return {DOMEventTarget} Target node.
 */ function getEventTarget(nativeEvent) {
        // Fallback to nativeEvent.srcElement for IE9
        // https://github.com/facebook/react/issues/12506
        var target = nativeEvent.target || nativeEvent.srcElement || window; // Normalize SVG <use> element events #4963
        if (target.correspondingUseElement) target = target.correspondingUseElement;
         // Safari may fire events on text nodes (Node.TEXT_NODE is 3).
        // @see http://www.quirksmode.org/js/events_properties.html
        return target.nodeType === TEXT_NODE ? target.parentNode : target;
    }
    /**
 * Checks if an event is supported in the current execution environment.
 *
 * NOTE: This will not work correctly for non-generic events such as `change`,
 * `reset`, `load`, `error`, and `select`.
 *
 * Borrows from Modernizr.
 *
 * @param {string} eventNameSuffix Event name, e.g. "click".
 * @return {boolean} True if the event is supported.
 * @internal
 * @license Modernizr 3.0.0pre (Custom Build) | MIT
 */ function isEventSupported(eventNameSuffix) {
        if (!canUseDOM) return false;
        var eventName = "on" + eventNameSuffix;
        var isSupported = eventName in document;
        if (!isSupported) {
            var element = document.createElement("div");
            element.setAttribute(eventName, "return;");
            isSupported = typeof element[eventName] === "function";
        }
        return isSupported;
    }
    /**
 * Summary of `DOMEventPluginSystem` event handling:
 *
 *  - Top-level delegation is used to trap most native browser events. This
 *    may only occur in the main thread and is the responsibility of
 *    ReactDOMEventListener, which is injected and can therefore support
 *    pluggable event sources. This is the only work that occurs in the main
 *    thread.
 *
 *  - We normalize and de-duplicate events to account for browser quirks. This
 *    may be done in the worker thread.
 *
 *  - Forward these native events (with the associated top-level type used to
 *    trap it) to `EventPluginRegistry`, which in turn will ask plugins if they want
 *    to extract any synthetic events.
 *
 *  - The `EventPluginRegistry` will then process each event by annotating them with
 *    "dispatches", a sequence of listeners and IDs that care about that event.
 *
 *  - The `EventPluginRegistry` then dispatches the events.
 *
 * Overview of React and the event system:
 *
 * +------------+    .
 * |    DOM     |    .
 * +------------+    .
 *       |           .
 *       v           .
 * +------------+    .
 * | ReactEvent |    .
 * |  Listener  |    .
 * +------------+    .                         +-----------+
 *       |           .               +--------+|SimpleEvent|
 *       |           .               |         |Plugin     |
 * +-----|------+    .               v         +-----------+
 * |     |      |    .    +--------------+                    +------------+
 * |     +-----------.--->|PluginRegistry|                    |    Event   |
 * |            |    .    |              |     +-----------+  | Propagators|
 * | ReactEvent |    .    |              |     |TapEvent   |  |------------|
 * |  Emitter   |    .    |              |<---+|Plugin     |  |other plugin|
 * |            |    .    |              |     +-----------+  |  utilities |
 * |     +-----------.--->|              |                    +------------+
 * |     |      |    .    +--------------+
 * +-----|------+    .                ^        +-----------+
 *       |           .                |        |Enter/Leave|
 *       +           .                +-------+|Plugin     |
 * +-------------+   .                         +-----------+
 * | application |   .
 * |-------------|   .
 * |             |   .
 * |             |   .
 * +-------------+   .
 *                   .
 *    React Core     .  General Purpose Event Plugin System
 */ var CALLBACK_BOOKKEEPING_POOL_SIZE = 10;
    var callbackBookkeepingPool = [];
    function releaseTopLevelCallbackBookKeeping(instance) {
        instance.topLevelType = null;
        instance.nativeEvent = null;
        instance.targetInst = null;
        instance.ancestors.length = 0;
        if (callbackBookkeepingPool.length < CALLBACK_BOOKKEEPING_POOL_SIZE) callbackBookkeepingPool.push(instance);
    } // Used to store ancestor hierarchy in top level callback
    function getTopLevelCallbackBookKeeping(topLevelType, nativeEvent, targetInst, eventSystemFlags) {
        if (callbackBookkeepingPool.length) {
            var instance = callbackBookkeepingPool.pop();
            instance.topLevelType = topLevelType;
            instance.eventSystemFlags = eventSystemFlags;
            instance.nativeEvent = nativeEvent;
            instance.targetInst = targetInst;
            return instance;
        }
        return {
            topLevelType: topLevelType,
            eventSystemFlags: eventSystemFlags,
            nativeEvent: nativeEvent,
            targetInst: targetInst,
            ancestors: []
        };
    }
    /**
 * Find the deepest React component completely containing the root of the
 * passed-in instance (for use when entire React trees are nested within each
 * other). If React trees are not nested, returns null.
 */ function findRootContainerNode(inst) {
        if (inst.tag === HostRoot) return inst.stateNode.containerInfo;
         // TODO: It may be a good idea to cache this to prevent unnecessary DOM
        // traversal, but caching is difficult to do correctly without using a
        // mutation observer to listen for all DOM changes.
        while(inst.return)inst = inst.return;
        if (inst.tag !== HostRoot) // This can happen if we're in a detached tree.
        return null;
        return inst.stateNode.containerInfo;
    }
    /**
 * Allows registered plugins an opportunity to extract events from top-level
 * native browser events.
 *
 * @return {*} An accumulation of synthetic events.
 * @internal
 */ function extractPluginEvents(topLevelType, targetInst, nativeEvent, nativeEventTarget, eventSystemFlags) {
        var events = null;
        for(var i = 0; i < plugins.length; i++){
            // Not every plugin in the ordering may be loaded at runtime.
            var possiblePlugin = plugins[i];
            if (possiblePlugin) {
                var extractedEvents = possiblePlugin.extractEvents(topLevelType, targetInst, nativeEvent, nativeEventTarget, eventSystemFlags);
                if (extractedEvents) events = accumulateInto(events, extractedEvents);
            }
        }
        return events;
    }
    function runExtractedPluginEventsInBatch(topLevelType, targetInst, nativeEvent, nativeEventTarget, eventSystemFlags) {
        var events = extractPluginEvents(topLevelType, targetInst, nativeEvent, nativeEventTarget, eventSystemFlags);
        runEventsInBatch(events);
    }
    function handleTopLevel(bookKeeping) {
        var targetInst = bookKeeping.targetInst; // Loop through the hierarchy, in case there's any nested components.
        // It's important that we build the array of ancestors before calling any
        // event handlers, because event handlers can modify the DOM, leading to
        // inconsistencies with ReactMount's node cache. See #1105.
        var ancestor = targetInst;
        do {
            if (!ancestor) {
                var ancestors = bookKeeping.ancestors;
                ancestors.push(ancestor);
                break;
            }
            var root = findRootContainerNode(ancestor);
            if (!root) break;
            var tag = ancestor.tag;
            if (tag === HostComponent || tag === HostText) bookKeeping.ancestors.push(ancestor);
            ancestor = getClosestInstanceFromNode(root);
        }while (ancestor);
        for(var i = 0; i < bookKeeping.ancestors.length; i++){
            targetInst = bookKeeping.ancestors[i];
            var eventTarget = getEventTarget(bookKeeping.nativeEvent);
            var topLevelType = bookKeeping.topLevelType;
            var nativeEvent = bookKeeping.nativeEvent;
            var eventSystemFlags = bookKeeping.eventSystemFlags; // If this is the first ancestor, we mark it on the system flags
            if (i === 0) eventSystemFlags |= IS_FIRST_ANCESTOR;
            runExtractedPluginEventsInBatch(topLevelType, targetInst, nativeEvent, eventTarget, eventSystemFlags);
        }
    }
    function dispatchEventForLegacyPluginEventSystem(topLevelType, eventSystemFlags, nativeEvent, targetInst) {
        var bookKeeping = getTopLevelCallbackBookKeeping(topLevelType, nativeEvent, targetInst, eventSystemFlags);
        try {
            // Event queue being processed in the same cycle allows
            // `preventDefault`.
            batchedEventUpdates(handleTopLevel, bookKeeping);
        } finally{
            releaseTopLevelCallbackBookKeeping(bookKeeping);
        }
    }
    /**
 * We listen for bubbled touch events on the document object.
 *
 * Firefox v8.01 (and possibly others) exhibited strange behavior when
 * mounting `onmousemove` events at some node that was not the document
 * element. The symptoms were that if your mouse is not moving over something
 * contained within that mount point (for example on the background) the
 * top-level listeners for `onmousemove` won't be called. However, if you
 * register the `mousemove` on the document object, then it will of course
 * catch all `mousemove`s. This along with iOS quirks, justifies restricting
 * top-level listeners to the document object only, at least for these
 * movement types of events and possibly all events.
 *
 * @see http://www.quirksmode.org/blog/archives/2010/09/click_event_del.html
 *
 * Also, `keyup`/`keypress`/`keydown` do not bubble to the window on IE, but
 * they bubble to document.
 *
 * @param {string} registrationName Name of listener (e.g. `onClick`).
 * @param {object} mountAt Container where to mount the listener
 */ function legacyListenToEvent(registrationName, mountAt) {
        var listenerMap = getListenerMapForElement(mountAt);
        var dependencies = registrationNameDependencies[registrationName];
        for(var i = 0; i < dependencies.length; i++){
            var dependency = dependencies[i];
            legacyListenToTopLevelEvent(dependency, mountAt, listenerMap);
        }
    }
    function legacyListenToTopLevelEvent(topLevelType, mountAt, listenerMap) {
        if (!listenerMap.has(topLevelType)) {
            switch(topLevelType){
                case TOP_SCROLL:
                    trapCapturedEvent(TOP_SCROLL, mountAt);
                    break;
                case TOP_FOCUS:
                case TOP_BLUR:
                    trapCapturedEvent(TOP_FOCUS, mountAt);
                    trapCapturedEvent(TOP_BLUR, mountAt); // We set the flag for a single dependency later in this function,
                    // but this ensures we mark both as attached rather than just one.
                    listenerMap.set(TOP_BLUR, null);
                    listenerMap.set(TOP_FOCUS, null);
                    break;
                case TOP_CANCEL:
                case TOP_CLOSE:
                    if (isEventSupported(getRawEventName(topLevelType))) trapCapturedEvent(topLevelType, mountAt);
                    break;
                case TOP_INVALID:
                case TOP_SUBMIT:
                case TOP_RESET:
                    break;
                default:
                    // By default, listen on the top level to all non-media events.
                    // Media events don't bubble so adding the listener wouldn't do anything.
                    var isMediaEvent = mediaEventTypes.indexOf(topLevelType) !== -1;
                    if (!isMediaEvent) trapBubbledEvent(topLevelType, mountAt);
                    break;
            }
            listenerMap.set(topLevelType, null);
        }
    }
    function isListeningToAllDependencies(registrationName, mountAt) {
        var listenerMap = getListenerMapForElement(mountAt);
        var dependencies = registrationNameDependencies[registrationName];
        for(var i = 0; i < dependencies.length; i++){
            var dependency = dependencies[i];
            if (!listenerMap.has(dependency)) return false;
        }
        return true;
    }
    var attemptUserBlockingHydration;
    function setAttemptUserBlockingHydration(fn) {
        attemptUserBlockingHydration = fn;
    }
    var attemptContinuousHydration;
    function setAttemptContinuousHydration(fn) {
        attemptContinuousHydration = fn;
    }
    var attemptHydrationAtCurrentPriority;
    function setAttemptHydrationAtCurrentPriority(fn) {
        attemptHydrationAtCurrentPriority = fn;
    } // TODO: Upgrade this definition once we're on a newer version of Flow that
    var hasScheduledReplayAttempt = false; // The queue of discrete events to be replayed.
    var queuedDiscreteEvents = []; // Indicates if any continuous event targets are non-null for early bailout.
    // if the last target was dehydrated.
    var queuedFocus = null;
    var queuedDrag = null;
    var queuedMouse = null; // For pointer events there can be one latest event per pointerId.
    var queuedPointers = new Map();
    var queuedPointerCaptures = new Map(); // We could consider replaying selectionchange and touchmoves too.
    var queuedExplicitHydrationTargets = [];
    function hasQueuedDiscreteEvents() {
        return queuedDiscreteEvents.length > 0;
    }
    var discreteReplayableEvents = [
        TOP_MOUSE_DOWN,
        TOP_MOUSE_UP,
        TOP_TOUCH_CANCEL,
        TOP_TOUCH_END,
        TOP_TOUCH_START,
        TOP_AUX_CLICK,
        TOP_DOUBLE_CLICK,
        TOP_POINTER_CANCEL,
        TOP_POINTER_DOWN,
        TOP_POINTER_UP,
        TOP_DRAG_END,
        TOP_DRAG_START,
        TOP_DROP,
        TOP_COMPOSITION_END,
        TOP_COMPOSITION_START,
        TOP_KEY_DOWN,
        TOP_KEY_PRESS,
        TOP_KEY_UP,
        TOP_INPUT,
        TOP_TEXT_INPUT,
        TOP_CLOSE,
        TOP_CANCEL,
        TOP_COPY,
        TOP_CUT,
        TOP_PASTE,
        TOP_CLICK,
        TOP_CHANGE,
        TOP_CONTEXT_MENU,
        TOP_RESET,
        TOP_SUBMIT
    ];
    var continuousReplayableEvents = [
        TOP_FOCUS,
        TOP_BLUR,
        TOP_DRAG_ENTER,
        TOP_DRAG_LEAVE,
        TOP_MOUSE_OVER,
        TOP_MOUSE_OUT,
        TOP_POINTER_OVER,
        TOP_POINTER_OUT,
        TOP_GOT_POINTER_CAPTURE,
        TOP_LOST_POINTER_CAPTURE
    ];
    function isReplayableDiscreteEvent(eventType) {
        return discreteReplayableEvents.indexOf(eventType) > -1;
    }
    function trapReplayableEventForDocument(topLevelType, document1, listenerMap) {
        legacyListenToTopLevelEvent(topLevelType, document1, listenerMap);
    }
    function eagerlyTrapReplayableEvents(container, document1) {
        var listenerMapForDoc = getListenerMapForElement(document1); // Discrete
        discreteReplayableEvents.forEach(function(topLevelType) {
            trapReplayableEventForDocument(topLevelType, document1, listenerMapForDoc);
        }); // Continuous
        continuousReplayableEvents.forEach(function(topLevelType) {
            trapReplayableEventForDocument(topLevelType, document1, listenerMapForDoc);
        });
    }
    function createQueuedReplayableEvent(blockedOn, topLevelType, eventSystemFlags, container, nativeEvent) {
        return {
            blockedOn: blockedOn,
            topLevelType: topLevelType,
            eventSystemFlags: eventSystemFlags | IS_REPLAYED,
            nativeEvent: nativeEvent,
            container: container
        };
    }
    function queueDiscreteEvent(blockedOn, topLevelType, eventSystemFlags, container, nativeEvent) {
        var queuedEvent = createQueuedReplayableEvent(blockedOn, topLevelType, eventSystemFlags, container, nativeEvent);
        queuedDiscreteEvents.push(queuedEvent);
    } // Resets the replaying for this type of continuous event to no event.
    function clearIfContinuousEvent(topLevelType, nativeEvent) {
        switch(topLevelType){
            case TOP_FOCUS:
            case TOP_BLUR:
                queuedFocus = null;
                break;
            case TOP_DRAG_ENTER:
            case TOP_DRAG_LEAVE:
                queuedDrag = null;
                break;
            case TOP_MOUSE_OVER:
            case TOP_MOUSE_OUT:
                queuedMouse = null;
                break;
            case TOP_POINTER_OVER:
            case TOP_POINTER_OUT:
                var pointerId = nativeEvent.pointerId;
                queuedPointers.delete(pointerId);
                break;
            case TOP_GOT_POINTER_CAPTURE:
            case TOP_LOST_POINTER_CAPTURE:
                var _pointerId = nativeEvent.pointerId;
                queuedPointerCaptures.delete(_pointerId);
                break;
        }
    }
    function accumulateOrCreateContinuousQueuedReplayableEvent(existingQueuedEvent, blockedOn, topLevelType, eventSystemFlags, container, nativeEvent) {
        if (existingQueuedEvent === null || existingQueuedEvent.nativeEvent !== nativeEvent) {
            var queuedEvent = createQueuedReplayableEvent(blockedOn, topLevelType, eventSystemFlags, container, nativeEvent);
            if (blockedOn !== null) {
                var _fiber2 = getInstanceFromNode$1(blockedOn);
                if (_fiber2 !== null) // Attempt to increase the priority of this target.
                attemptContinuousHydration(_fiber2);
            }
            return queuedEvent;
        } // If we have already queued this exact event, then it's because
        // the different event systems have different DOM event listeners.
        // We can accumulate the flags and store a single event to be
        // replayed.
        existingQueuedEvent.eventSystemFlags |= eventSystemFlags;
        return existingQueuedEvent;
    }
    function queueIfContinuousEvent(blockedOn, topLevelType, eventSystemFlags, container, nativeEvent) {
        // These set relatedTarget to null because the replayed event will be treated as if we
        // moved from outside the window (no target) onto the target once it hydrates.
        // Instead of mutating we could clone the event.
        switch(topLevelType){
            case TOP_FOCUS:
                var focusEvent = nativeEvent;
                queuedFocus = accumulateOrCreateContinuousQueuedReplayableEvent(queuedFocus, blockedOn, topLevelType, eventSystemFlags, container, focusEvent);
                return true;
            case TOP_DRAG_ENTER:
                var dragEvent = nativeEvent;
                queuedDrag = accumulateOrCreateContinuousQueuedReplayableEvent(queuedDrag, blockedOn, topLevelType, eventSystemFlags, container, dragEvent);
                return true;
            case TOP_MOUSE_OVER:
                var mouseEvent = nativeEvent;
                queuedMouse = accumulateOrCreateContinuousQueuedReplayableEvent(queuedMouse, blockedOn, topLevelType, eventSystemFlags, container, mouseEvent);
                return true;
            case TOP_POINTER_OVER:
                var pointerEvent = nativeEvent;
                var pointerId = pointerEvent.pointerId;
                queuedPointers.set(pointerId, accumulateOrCreateContinuousQueuedReplayableEvent(queuedPointers.get(pointerId) || null, blockedOn, topLevelType, eventSystemFlags, container, pointerEvent));
                return true;
            case TOP_GOT_POINTER_CAPTURE:
                var _pointerEvent = nativeEvent;
                var _pointerId2 = _pointerEvent.pointerId;
                queuedPointerCaptures.set(_pointerId2, accumulateOrCreateContinuousQueuedReplayableEvent(queuedPointerCaptures.get(_pointerId2) || null, blockedOn, topLevelType, eventSystemFlags, container, _pointerEvent));
                return true;
        }
        return false;
    } // Check if this target is unblocked. Returns true if it's unblocked.
    function attemptExplicitHydrationTarget(queuedTarget) {
        // TODO: This function shares a lot of logic with attemptToDispatchEvent.
        // Try to unify them. It's a bit tricky since it would require two return
        // values.
        var targetInst = getClosestInstanceFromNode(queuedTarget.target);
        if (targetInst !== null) {
            var nearestMounted = getNearestMountedFiber(targetInst);
            if (nearestMounted !== null) {
                var tag = nearestMounted.tag;
                if (tag === SuspenseComponent) {
                    var instance = getSuspenseInstanceFromFiber(nearestMounted);
                    if (instance !== null) {
                        // We're blocked on hydrating this boundary.
                        // Increase its priority.
                        queuedTarget.blockedOn = instance;
                        Scheduler.unstable_runWithPriority(queuedTarget.priority, function() {
                            attemptHydrationAtCurrentPriority(nearestMounted);
                        });
                        return;
                    }
                } else if (tag === HostRoot) {
                    var root = nearestMounted.stateNode;
                    if (root.hydrate) {
                        queuedTarget.blockedOn = getContainerFromFiber(nearestMounted); // We don't currently have a way to increase the priority of
                        // a root other than sync.
                        return;
                    }
                }
            }
        }
        queuedTarget.blockedOn = null;
    }
    function attemptReplayContinuousQueuedEvent(queuedEvent) {
        if (queuedEvent.blockedOn !== null) return false;
        var nextBlockedOn = attemptToDispatchEvent(queuedEvent.topLevelType, queuedEvent.eventSystemFlags, queuedEvent.container, queuedEvent.nativeEvent);
        if (nextBlockedOn !== null) {
            // We're still blocked. Try again later.
            var _fiber3 = getInstanceFromNode$1(nextBlockedOn);
            if (_fiber3 !== null) attemptContinuousHydration(_fiber3);
            queuedEvent.blockedOn = nextBlockedOn;
            return false;
        }
        return true;
    }
    function attemptReplayContinuousQueuedEventInMap(queuedEvent, key, map) {
        if (attemptReplayContinuousQueuedEvent(queuedEvent)) map.delete(key);
    }
    function replayUnblockedEvents() {
        hasScheduledReplayAttempt = false; // First replay discrete events.
        while(queuedDiscreteEvents.length > 0){
            var nextDiscreteEvent = queuedDiscreteEvents[0];
            if (nextDiscreteEvent.blockedOn !== null) {
                // We're still blocked.
                // Increase the priority of this boundary to unblock
                // the next discrete event.
                var _fiber4 = getInstanceFromNode$1(nextDiscreteEvent.blockedOn);
                if (_fiber4 !== null) attemptUserBlockingHydration(_fiber4);
                break;
            }
            var nextBlockedOn = attemptToDispatchEvent(nextDiscreteEvent.topLevelType, nextDiscreteEvent.eventSystemFlags, nextDiscreteEvent.container, nextDiscreteEvent.nativeEvent);
            if (nextBlockedOn !== null) // We're still blocked. Try again later.
            nextDiscreteEvent.blockedOn = nextBlockedOn;
            else // We've successfully replayed the first event. Let's try the next one.
            queuedDiscreteEvents.shift();
        } // Next replay any continuous events.
        if (queuedFocus !== null && attemptReplayContinuousQueuedEvent(queuedFocus)) queuedFocus = null;
        if (queuedDrag !== null && attemptReplayContinuousQueuedEvent(queuedDrag)) queuedDrag = null;
        if (queuedMouse !== null && attemptReplayContinuousQueuedEvent(queuedMouse)) queuedMouse = null;
        queuedPointers.forEach(attemptReplayContinuousQueuedEventInMap);
        queuedPointerCaptures.forEach(attemptReplayContinuousQueuedEventInMap);
    }
    function scheduleCallbackIfUnblocked(queuedEvent, unblocked) {
        if (queuedEvent.blockedOn === unblocked) {
            queuedEvent.blockedOn = null;
            if (!hasScheduledReplayAttempt) {
                hasScheduledReplayAttempt = true; // Schedule a callback to attempt replaying as many events as are
                // now unblocked. This first might not actually be unblocked yet.
                // We could check it early to avoid scheduling an unnecessary callback.
                Scheduler.unstable_scheduleCallback(Scheduler.unstable_NormalPriority, replayUnblockedEvents);
            }
        }
    }
    function retryIfBlockedOn(unblocked) {
        // Mark anything that was blocked on this as no longer blocked
        // and eligible for a replay.
        if (queuedDiscreteEvents.length > 0) {
            scheduleCallbackIfUnblocked(queuedDiscreteEvents[0], unblocked); // This is a exponential search for each boundary that commits. I think it's
            // worth it because we expect very few discrete events to queue up and once
            // we are actually fully unblocked it will be fast to replay them.
            for(var i = 1; i < queuedDiscreteEvents.length; i++){
                var queuedEvent = queuedDiscreteEvents[i];
                if (queuedEvent.blockedOn === unblocked) queuedEvent.blockedOn = null;
            }
        }
        if (queuedFocus !== null) scheduleCallbackIfUnblocked(queuedFocus, unblocked);
        if (queuedDrag !== null) scheduleCallbackIfUnblocked(queuedDrag, unblocked);
        if (queuedMouse !== null) scheduleCallbackIfUnblocked(queuedMouse, unblocked);
        var unblock = function(queuedEvent) {
            return scheduleCallbackIfUnblocked(queuedEvent, unblocked);
        };
        queuedPointers.forEach(unblock);
        queuedPointerCaptures.forEach(unblock);
        for(var _i = 0; _i < queuedExplicitHydrationTargets.length; _i++){
            var queuedTarget = queuedExplicitHydrationTargets[_i];
            if (queuedTarget.blockedOn === unblocked) queuedTarget.blockedOn = null;
        }
        while(queuedExplicitHydrationTargets.length > 0){
            var nextExplicitTarget = queuedExplicitHydrationTargets[0];
            if (nextExplicitTarget.blockedOn !== null) break;
            else {
                attemptExplicitHydrationTarget(nextExplicitTarget);
                if (nextExplicitTarget.blockedOn === null) // We're unblocked.
                queuedExplicitHydrationTargets.shift();
            }
        }
    }
    function addEventBubbleListener(element, eventType, listener) {
        element.addEventListener(eventType, listener, false);
    }
    function addEventCaptureListener(element, eventType, listener) {
        element.addEventListener(eventType, listener, true);
    }
    // do it in two places, which duplicates logic
    // and increases the bundle size, we do it all
    // here once. If we remove or refactor the
    // SimpleEventPlugin, we should also remove or
    // update the below line.
    var simpleEventPluginEventTypes = {};
    var topLevelEventsToDispatchConfig = new Map();
    var eventPriorities = new Map(); // We store most of the events in this module in pairs of two strings so we can re-use
    // the code required to apply the same logic for event prioritization and that of the
    // SimpleEventPlugin. This complicates things slightly, but the aim is to reduce code
    // duplication (for which there would be quite a bit). For the events that are not needed
    // for the SimpleEventPlugin (otherDiscreteEvents) we process them separately as an
    // array of top level events.
    // Lastly, we ignore prettier so we can keep the formatting sane.
    // prettier-ignore
    var discreteEventPairsForSimpleEventPlugin = [
        TOP_BLUR,
        "blur",
        TOP_CANCEL,
        "cancel",
        TOP_CLICK,
        "click",
        TOP_CLOSE,
        "close",
        TOP_CONTEXT_MENU,
        "contextMenu",
        TOP_COPY,
        "copy",
        TOP_CUT,
        "cut",
        TOP_AUX_CLICK,
        "auxClick",
        TOP_DOUBLE_CLICK,
        "doubleClick",
        TOP_DRAG_END,
        "dragEnd",
        TOP_DRAG_START,
        "dragStart",
        TOP_DROP,
        "drop",
        TOP_FOCUS,
        "focus",
        TOP_INPUT,
        "input",
        TOP_INVALID,
        "invalid",
        TOP_KEY_DOWN,
        "keyDown",
        TOP_KEY_PRESS,
        "keyPress",
        TOP_KEY_UP,
        "keyUp",
        TOP_MOUSE_DOWN,
        "mouseDown",
        TOP_MOUSE_UP,
        "mouseUp",
        TOP_PASTE,
        "paste",
        TOP_PAUSE,
        "pause",
        TOP_PLAY,
        "play",
        TOP_POINTER_CANCEL,
        "pointerCancel",
        TOP_POINTER_DOWN,
        "pointerDown",
        TOP_POINTER_UP,
        "pointerUp",
        TOP_RATE_CHANGE,
        "rateChange",
        TOP_RESET,
        "reset",
        TOP_SEEKED,
        "seeked",
        TOP_SUBMIT,
        "submit",
        TOP_TOUCH_CANCEL,
        "touchCancel",
        TOP_TOUCH_END,
        "touchEnd",
        TOP_TOUCH_START,
        "touchStart",
        TOP_VOLUME_CHANGE,
        "volumeChange"
    ];
    var otherDiscreteEvents = [
        TOP_CHANGE,
        TOP_SELECTION_CHANGE,
        TOP_TEXT_INPUT,
        TOP_COMPOSITION_START,
        TOP_COMPOSITION_END,
        TOP_COMPOSITION_UPDATE
    ]; // prettier-ignore
    var userBlockingPairsForSimpleEventPlugin = [
        TOP_DRAG,
        "drag",
        TOP_DRAG_ENTER,
        "dragEnter",
        TOP_DRAG_EXIT,
        "dragExit",
        TOP_DRAG_LEAVE,
        "dragLeave",
        TOP_DRAG_OVER,
        "dragOver",
        TOP_MOUSE_MOVE,
        "mouseMove",
        TOP_MOUSE_OUT,
        "mouseOut",
        TOP_MOUSE_OVER,
        "mouseOver",
        TOP_POINTER_MOVE,
        "pointerMove",
        TOP_POINTER_OUT,
        "pointerOut",
        TOP_POINTER_OVER,
        "pointerOver",
        TOP_SCROLL,
        "scroll",
        TOP_TOGGLE,
        "toggle",
        TOP_TOUCH_MOVE,
        "touchMove",
        TOP_WHEEL,
        "wheel"
    ]; // prettier-ignore
    var continuousPairsForSimpleEventPlugin = [
        TOP_ABORT,
        "abort",
        TOP_ANIMATION_END,
        "animationEnd",
        TOP_ANIMATION_ITERATION,
        "animationIteration",
        TOP_ANIMATION_START,
        "animationStart",
        TOP_CAN_PLAY,
        "canPlay",
        TOP_CAN_PLAY_THROUGH,
        "canPlayThrough",
        TOP_DURATION_CHANGE,
        "durationChange",
        TOP_EMPTIED,
        "emptied",
        TOP_ENCRYPTED,
        "encrypted",
        TOP_ENDED,
        "ended",
        TOP_ERROR,
        "error",
        TOP_GOT_POINTER_CAPTURE,
        "gotPointerCapture",
        TOP_LOAD,
        "load",
        TOP_LOADED_DATA,
        "loadedData",
        TOP_LOADED_METADATA,
        "loadedMetadata",
        TOP_LOAD_START,
        "loadStart",
        TOP_LOST_POINTER_CAPTURE,
        "lostPointerCapture",
        TOP_PLAYING,
        "playing",
        TOP_PROGRESS,
        "progress",
        TOP_SEEKING,
        "seeking",
        TOP_STALLED,
        "stalled",
        TOP_SUSPEND,
        "suspend",
        TOP_TIME_UPDATE,
        "timeUpdate",
        TOP_TRANSITION_END,
        "transitionEnd",
        TOP_WAITING,
        "waiting"
    ];
    /**
 * Turns
 * ['abort', ...]
 * into
 * eventTypes = {
 *   'abort': {
 *     phasedRegistrationNames: {
 *       bubbled: 'onAbort',
 *       captured: 'onAbortCapture',
 *     },
 *     dependencies: [TOP_ABORT],
 *   },
 *   ...
 * };
 * topLevelEventsToDispatchConfig = new Map([
 *   [TOP_ABORT, { sameConfig }],
 * ]);
 */ function processSimpleEventPluginPairsByPriority(eventTypes, priority) {
        // As the event types are in pairs of two, we need to iterate
        // through in twos. The events are in pairs of two to save code
        // and improve init perf of processing this array, as it will
        // result in far fewer object allocations and property accesses
        // if we only use three arrays to process all the categories of
        // instead of tuples.
        for(var i = 0; i < eventTypes.length; i += 2){
            var topEvent = eventTypes[i];
            var event = eventTypes[i + 1];
            var capitalizedEvent = event[0].toUpperCase() + event.slice(1);
            var onEvent = "on" + capitalizedEvent;
            var config = {
                phasedRegistrationNames: {
                    bubbled: onEvent,
                    captured: onEvent + "Capture"
                },
                dependencies: [
                    topEvent
                ],
                eventPriority: priority
            };
            eventPriorities.set(topEvent, priority);
            topLevelEventsToDispatchConfig.set(topEvent, config);
            simpleEventPluginEventTypes[event] = config;
        }
    }
    function processTopEventPairsByPriority(eventTypes, priority) {
        for(var i = 0; i < eventTypes.length; i++)eventPriorities.set(eventTypes[i], priority);
    } // SimpleEventPlugin
    processSimpleEventPluginPairsByPriority(discreteEventPairsForSimpleEventPlugin, DiscreteEvent);
    processSimpleEventPluginPairsByPriority(userBlockingPairsForSimpleEventPlugin, UserBlockingEvent);
    processSimpleEventPluginPairsByPriority(continuousPairsForSimpleEventPlugin, ContinuousEvent); // Not used by SimpleEventPlugin
    processTopEventPairsByPriority(otherDiscreteEvents, DiscreteEvent);
    function getEventPriorityForPluginSystem(topLevelType) {
        var priority = eventPriorities.get(topLevelType); // Default to a ContinuousEvent. Note: we might
        // want to warn if we can't detect the priority
        // for the event.
        return priority === undefined ? ContinuousEvent : priority;
    }
    // Intentionally not named imports because Rollup would use dynamic dispatch for
    var UserBlockingPriority = Scheduler.unstable_UserBlockingPriority, runWithPriority = Scheduler.unstable_runWithPriority; // TODO: can we stop exporting these?
    var _enabled = true;
    function setEnabled(enabled) {
        _enabled = !!enabled;
    }
    function isEnabled() {
        return _enabled;
    }
    function trapBubbledEvent(topLevelType, element) {
        trapEventForPluginEventSystem(element, topLevelType, false);
    }
    function trapCapturedEvent(topLevelType, element) {
        trapEventForPluginEventSystem(element, topLevelType, true);
    }
    function trapEventForPluginEventSystem(container, topLevelType, capture) {
        var listener;
        switch(getEventPriorityForPluginSystem(topLevelType)){
            case DiscreteEvent:
                listener = dispatchDiscreteEvent.bind(null, topLevelType, PLUGIN_EVENT_SYSTEM, container);
                break;
            case UserBlockingEvent:
                listener = dispatchUserBlockingUpdate.bind(null, topLevelType, PLUGIN_EVENT_SYSTEM, container);
                break;
            case ContinuousEvent:
            default:
                listener = dispatchEvent.bind(null, topLevelType, PLUGIN_EVENT_SYSTEM, container);
                break;
        }
        var rawEventName = getRawEventName(topLevelType);
        if (capture) addEventCaptureListener(container, rawEventName, listener);
        else addEventBubbleListener(container, rawEventName, listener);
    }
    function dispatchDiscreteEvent(topLevelType, eventSystemFlags, container, nativeEvent) {
        flushDiscreteUpdatesIfNeeded(nativeEvent.timeStamp);
        discreteUpdates(dispatchEvent, topLevelType, eventSystemFlags, container, nativeEvent);
    }
    function dispatchUserBlockingUpdate(topLevelType, eventSystemFlags, container, nativeEvent) {
        runWithPriority(UserBlockingPriority, dispatchEvent.bind(null, topLevelType, eventSystemFlags, container, nativeEvent));
    }
    function dispatchEvent(topLevelType, eventSystemFlags, container, nativeEvent) {
        if (!_enabled) return;
        if (hasQueuedDiscreteEvents() && isReplayableDiscreteEvent(topLevelType)) {
            // If we already have a queue of discrete events, and this is another discrete
            // event, then we can't dispatch it regardless of its target, since they
            // need to dispatch in order.
            queueDiscreteEvent(null, topLevelType, eventSystemFlags, container, nativeEvent);
            return;
        }
        var blockedOn = attemptToDispatchEvent(topLevelType, eventSystemFlags, container, nativeEvent);
        if (blockedOn === null) {
            // We successfully dispatched this event.
            clearIfContinuousEvent(topLevelType, nativeEvent);
            return;
        }
        if (isReplayableDiscreteEvent(topLevelType)) {
            // This this to be replayed later once the target is available.
            queueDiscreteEvent(blockedOn, topLevelType, eventSystemFlags, container, nativeEvent);
            return;
        }
        if (queueIfContinuousEvent(blockedOn, topLevelType, eventSystemFlags, container, nativeEvent)) return;
         // We need to clear only if we didn't queue because
        // queueing is accummulative.
        clearIfContinuousEvent(topLevelType, nativeEvent); // This is not replayable so we'll invoke it but without a target,
        dispatchEventForLegacyPluginEventSystem(topLevelType, eventSystemFlags, nativeEvent, null);
    } // Attempt dispatching an event. Returns a SuspenseInstance or Container if it's blocked.
    function attemptToDispatchEvent(topLevelType, eventSystemFlags, container, nativeEvent) {
        // TODO: Warn if _enabled is false.
        var nativeEventTarget = getEventTarget(nativeEvent);
        var targetInst = getClosestInstanceFromNode(nativeEventTarget);
        if (targetInst !== null) {
            var nearestMounted = getNearestMountedFiber(targetInst);
            if (nearestMounted === null) // This tree has been unmounted already. Dispatch without a target.
            targetInst = null;
            else {
                var tag = nearestMounted.tag;
                if (tag === SuspenseComponent) {
                    var instance = getSuspenseInstanceFromFiber(nearestMounted);
                    if (instance !== null) // Queue the event to be replayed later. Abort dispatching since we
                    // don't want this event dispatched twice through the event system.
                    // TODO: If this is the first discrete event in the queue. Schedule an increased
                    // priority for this boundary.
                    return instance;
                     // This shouldn't happen, something went wrong but to avoid blocking
                    // the whole system, dispatch the event without a target.
                    // TODO: Warn.
                    targetInst = null;
                } else if (tag === HostRoot) {
                    var root = nearestMounted.stateNode;
                    if (root.hydrate) // If this happens during a replay something went wrong and it might block
                    // the whole system.
                    return getContainerFromFiber(nearestMounted);
                    targetInst = null;
                } else if (nearestMounted !== targetInst) // If we get an event (ex: img onload) before committing that
                // component's mount, ignore it for now (that is, treat it as if it was an
                // event on a non-React tree). We might also consider queueing events and
                // dispatching them after the mount.
                targetInst = null;
            }
        }
        dispatchEventForLegacyPluginEventSystem(topLevelType, eventSystemFlags, nativeEvent, targetInst);
        return null;
    }
    // List derived from Gecko source code:
    // https://github.com/mozilla/gecko-dev/blob/4e638efc71/layout/style/test/property_database.js
    var shorthandToLonghand = {
        animation: [
            "animationDelay",
            "animationDirection",
            "animationDuration",
            "animationFillMode",
            "animationIterationCount",
            "animationName",
            "animationPlayState",
            "animationTimingFunction"
        ],
        background: [
            "backgroundAttachment",
            "backgroundClip",
            "backgroundColor",
            "backgroundImage",
            "backgroundOrigin",
            "backgroundPositionX",
            "backgroundPositionY",
            "backgroundRepeat",
            "backgroundSize"
        ],
        backgroundPosition: [
            "backgroundPositionX",
            "backgroundPositionY"
        ],
        border: [
            "borderBottomColor",
            "borderBottomStyle",
            "borderBottomWidth",
            "borderImageOutset",
            "borderImageRepeat",
            "borderImageSlice",
            "borderImageSource",
            "borderImageWidth",
            "borderLeftColor",
            "borderLeftStyle",
            "borderLeftWidth",
            "borderRightColor",
            "borderRightStyle",
            "borderRightWidth",
            "borderTopColor",
            "borderTopStyle",
            "borderTopWidth"
        ],
        borderBlockEnd: [
            "borderBlockEndColor",
            "borderBlockEndStyle",
            "borderBlockEndWidth"
        ],
        borderBlockStart: [
            "borderBlockStartColor",
            "borderBlockStartStyle",
            "borderBlockStartWidth"
        ],
        borderBottom: [
            "borderBottomColor",
            "borderBottomStyle",
            "borderBottomWidth"
        ],
        borderColor: [
            "borderBottomColor",
            "borderLeftColor",
            "borderRightColor",
            "borderTopColor"
        ],
        borderImage: [
            "borderImageOutset",
            "borderImageRepeat",
            "borderImageSlice",
            "borderImageSource",
            "borderImageWidth"
        ],
        borderInlineEnd: [
            "borderInlineEndColor",
            "borderInlineEndStyle",
            "borderInlineEndWidth"
        ],
        borderInlineStart: [
            "borderInlineStartColor",
            "borderInlineStartStyle",
            "borderInlineStartWidth"
        ],
        borderLeft: [
            "borderLeftColor",
            "borderLeftStyle",
            "borderLeftWidth"
        ],
        borderRadius: [
            "borderBottomLeftRadius",
            "borderBottomRightRadius",
            "borderTopLeftRadius",
            "borderTopRightRadius"
        ],
        borderRight: [
            "borderRightColor",
            "borderRightStyle",
            "borderRightWidth"
        ],
        borderStyle: [
            "borderBottomStyle",
            "borderLeftStyle",
            "borderRightStyle",
            "borderTopStyle"
        ],
        borderTop: [
            "borderTopColor",
            "borderTopStyle",
            "borderTopWidth"
        ],
        borderWidth: [
            "borderBottomWidth",
            "borderLeftWidth",
            "borderRightWidth",
            "borderTopWidth"
        ],
        columnRule: [
            "columnRuleColor",
            "columnRuleStyle",
            "columnRuleWidth"
        ],
        columns: [
            "columnCount",
            "columnWidth"
        ],
        flex: [
            "flexBasis",
            "flexGrow",
            "flexShrink"
        ],
        flexFlow: [
            "flexDirection",
            "flexWrap"
        ],
        font: [
            "fontFamily",
            "fontFeatureSettings",
            "fontKerning",
            "fontLanguageOverride",
            "fontSize",
            "fontSizeAdjust",
            "fontStretch",
            "fontStyle",
            "fontVariant",
            "fontVariantAlternates",
            "fontVariantCaps",
            "fontVariantEastAsian",
            "fontVariantLigatures",
            "fontVariantNumeric",
            "fontVariantPosition",
            "fontWeight",
            "lineHeight"
        ],
        fontVariant: [
            "fontVariantAlternates",
            "fontVariantCaps",
            "fontVariantEastAsian",
            "fontVariantLigatures",
            "fontVariantNumeric",
            "fontVariantPosition"
        ],
        gap: [
            "columnGap",
            "rowGap"
        ],
        grid: [
            "gridAutoColumns",
            "gridAutoFlow",
            "gridAutoRows",
            "gridTemplateAreas",
            "gridTemplateColumns",
            "gridTemplateRows"
        ],
        gridArea: [
            "gridColumnEnd",
            "gridColumnStart",
            "gridRowEnd",
            "gridRowStart"
        ],
        gridColumn: [
            "gridColumnEnd",
            "gridColumnStart"
        ],
        gridColumnGap: [
            "columnGap"
        ],
        gridGap: [
            "columnGap",
            "rowGap"
        ],
        gridRow: [
            "gridRowEnd",
            "gridRowStart"
        ],
        gridRowGap: [
            "rowGap"
        ],
        gridTemplate: [
            "gridTemplateAreas",
            "gridTemplateColumns",
            "gridTemplateRows"
        ],
        listStyle: [
            "listStyleImage",
            "listStylePosition",
            "listStyleType"
        ],
        margin: [
            "marginBottom",
            "marginLeft",
            "marginRight",
            "marginTop"
        ],
        marker: [
            "markerEnd",
            "markerMid",
            "markerStart"
        ],
        mask: [
            "maskClip",
            "maskComposite",
            "maskImage",
            "maskMode",
            "maskOrigin",
            "maskPositionX",
            "maskPositionY",
            "maskRepeat",
            "maskSize"
        ],
        maskPosition: [
            "maskPositionX",
            "maskPositionY"
        ],
        outline: [
            "outlineColor",
            "outlineStyle",
            "outlineWidth"
        ],
        overflow: [
            "overflowX",
            "overflowY"
        ],
        padding: [
            "paddingBottom",
            "paddingLeft",
            "paddingRight",
            "paddingTop"
        ],
        placeContent: [
            "alignContent",
            "justifyContent"
        ],
        placeItems: [
            "alignItems",
            "justifyItems"
        ],
        placeSelf: [
            "alignSelf",
            "justifySelf"
        ],
        textDecoration: [
            "textDecorationColor",
            "textDecorationLine",
            "textDecorationStyle"
        ],
        textEmphasis: [
            "textEmphasisColor",
            "textEmphasisStyle"
        ],
        transition: [
            "transitionDelay",
            "transitionDuration",
            "transitionProperty",
            "transitionTimingFunction"
        ],
        wordWrap: [
            "overflowWrap"
        ]
    };
    /**
 * CSS properties which accept numbers but are not in units of "px".
 */ var isUnitlessNumber = {
        animationIterationCount: true,
        borderImageOutset: true,
        borderImageSlice: true,
        borderImageWidth: true,
        boxFlex: true,
        boxFlexGroup: true,
        boxOrdinalGroup: true,
        columnCount: true,
        columns: true,
        flex: true,
        flexGrow: true,
        flexPositive: true,
        flexShrink: true,
        flexNegative: true,
        flexOrder: true,
        gridArea: true,
        gridRow: true,
        gridRowEnd: true,
        gridRowSpan: true,
        gridRowStart: true,
        gridColumn: true,
        gridColumnEnd: true,
        gridColumnSpan: true,
        gridColumnStart: true,
        fontWeight: true,
        lineClamp: true,
        lineHeight: true,
        opacity: true,
        order: true,
        orphans: true,
        tabSize: true,
        widows: true,
        zIndex: true,
        zoom: true,
        // SVG-related properties
        fillOpacity: true,
        floodOpacity: true,
        stopOpacity: true,
        strokeDasharray: true,
        strokeDashoffset: true,
        strokeMiterlimit: true,
        strokeOpacity: true,
        strokeWidth: true
    };
    /**
 * @param {string} prefix vendor-specific prefix, eg: Webkit
 * @param {string} key style name, eg: transitionDuration
 * @return {string} style name prefixed with `prefix`, properly camelCased, eg:
 * WebkitTransitionDuration
 */ function prefixKey(prefix, key) {
        return prefix + key.charAt(0).toUpperCase() + key.substring(1);
    }
    /**
 * Support style names that may come passed in prefixed by adding permutations
 * of vendor prefixes.
 */ var prefixes = [
        "Webkit",
        "ms",
        "Moz",
        "O"
    ]; // Using Object.keys here, or else the vanilla for-in loop makes IE8 go into an
    // infinite loop, because it iterates over the newly added props too.
    Object.keys(isUnitlessNumber).forEach(function(prop) {
        prefixes.forEach(function(prefix) {
            isUnitlessNumber[prefixKey(prefix, prop)] = isUnitlessNumber[prop];
        });
    });
    /**
 * Convert a value into the proper css writable value. The style name `name`
 * should be logical (no hyphens), as specified
 * in `CSSProperty.isUnitlessNumber`.
 *
 * @param {string} name CSS property name such as `topMargin`.
 * @param {*} value CSS property value such as `10px`.
 * @return {string} Normalized style value with dimensions applied.
 */ function dangerousStyleValue(name, value, isCustomProperty) {
        // Note that we've removed escapeTextForBrowser() calls here since the
        // whole string will be escaped when the attribute is injected into
        // the markup. If you provide unsafe user data here they can inject
        // arbitrary CSS which may be problematic (I couldn't repro this):
        // https://www.owasp.org/index.php/XSS_Filter_Evasion_Cheat_Sheet
        // http://www.thespanner.co.uk/2007/11/26/ultimate-xss-css-injection/
        // This is not an XSS hole but instead a potential CSS injection issue
        // which has lead to a greater discussion about how we're going to
        // trust URLs moving forward. See #2115901
        var isEmpty = value == null || typeof value === "boolean" || value === "";
        if (isEmpty) return "";
        if (!isCustomProperty && typeof value === "number" && value !== 0 && !(isUnitlessNumber.hasOwnProperty(name) && isUnitlessNumber[name])) return value + "px"; // Presumes implicit 'px' suffix for unitless numbers
        return ("" + value).trim();
    }
    var uppercasePattern = /([A-Z])/g;
    var msPattern = /^ms-/;
    /**
 * Hyphenates a camelcased CSS property name, for example:
 *
 *   > hyphenateStyleName('backgroundColor')
 *   < "background-color"
 *   > hyphenateStyleName('MozTransition')
 *   < "-moz-transition"
 *   > hyphenateStyleName('msTransition')
 *   < "-ms-transition"
 *
 * As Modernizr suggests (http://modernizr.com/docs/#prefixed), an `ms` prefix
 * is converted to `-ms-`.
 */ function hyphenateStyleName(name) {
        return name.replace(uppercasePattern, "-$1").toLowerCase().replace(msPattern, "-ms-");
    }
    var warnValidStyle = function() {};
    // 'msTransform' is correct, but the other prefixes should be capitalized
    var badVendoredStyleNamePattern = /^(?:webkit|moz|o)[A-Z]/;
    var msPattern$1 = /^-ms-/;
    var hyphenPattern = /-(.)/g; // style values shouldn't contain a semicolon
    var badStyleValueWithSemicolonPattern = /;\s*$/;
    var warnedStyleNames = {};
    var warnedStyleValues = {};
    var warnedForNaNValue = false;
    var warnedForInfinityValue = false;
    var camelize = function(string) {
        return string.replace(hyphenPattern, function(_, character) {
            return character.toUpperCase();
        });
    };
    var warnHyphenatedStyleName = function(name) {
        if (warnedStyleNames.hasOwnProperty(name) && warnedStyleNames[name]) return;
        warnedStyleNames[name] = true;
        error("Unsupported style property %s. Did you mean %s?", name, // (http://www.andismith.com/blog/2012/02/modernizr-prefixed/), an `-ms` prefix
        // is converted to lowercase `ms`.
        camelize(name.replace(msPattern$1, "ms-")));
    };
    var warnBadVendoredStyleName = function(name) {
        if (warnedStyleNames.hasOwnProperty(name) && warnedStyleNames[name]) return;
        warnedStyleNames[name] = true;
        error("Unsupported vendor-prefixed style property %s. Did you mean %s?", name, name.charAt(0).toUpperCase() + name.slice(1));
    };
    var warnStyleValueWithSemicolon = function(name, value) {
        if (warnedStyleValues.hasOwnProperty(value) && warnedStyleValues[value]) return;
        warnedStyleValues[value] = true;
        error('Style property values shouldn\'t contain a semicolon. Try "%s: %s" instead.', name, value.replace(badStyleValueWithSemicolonPattern, ""));
    };
    var warnStyleValueIsNaN = function(name, value) {
        if (warnedForNaNValue) return;
        warnedForNaNValue = true;
        error("`NaN` is an invalid value for the `%s` css style property.", name);
    };
    var warnStyleValueIsInfinity = function(name, value) {
        if (warnedForInfinityValue) return;
        warnedForInfinityValue = true;
        error("`Infinity` is an invalid value for the `%s` css style property.", name);
    };
    warnValidStyle = function(name, value) {
        if (name.indexOf("-") > -1) warnHyphenatedStyleName(name);
        else if (badVendoredStyleNamePattern.test(name)) warnBadVendoredStyleName(name);
        else if (badStyleValueWithSemicolonPattern.test(value)) warnStyleValueWithSemicolon(name, value);
        if (typeof value === "number") {
            if (isNaN(value)) warnStyleValueIsNaN(name, value);
            else if (!isFinite(value)) warnStyleValueIsInfinity(name, value);
        }
    };
    var warnValidStyle$1 = warnValidStyle;
    /**
 * Operations for dealing with CSS properties.
 */ /**
 * This creates a string that is expected to be equivalent to the style
 * attribute generated by server-side rendering. It by-passes warnings and
 * security checks so it's not safe to use this value for anything other than
 * comparison. It is only used in DEV for SSR validation.
 */ function createDangerousStringForStyles(styles) {
        var serialized = "";
        var delimiter = "";
        for(var styleName in styles){
            if (!styles.hasOwnProperty(styleName)) continue;
            var styleValue = styles[styleName];
            if (styleValue != null) {
                var isCustomProperty = styleName.indexOf("--") === 0;
                serialized += delimiter + (isCustomProperty ? styleName : hyphenateStyleName(styleName)) + ":";
                serialized += dangerousStyleValue(styleName, styleValue, isCustomProperty);
                delimiter = ";";
            }
        }
        return serialized || null;
    }
    /**
 * Sets the value for multiple styles on a node.  If a value is specified as
 * '' (empty string), the corresponding style property will be unset.
 *
 * @param {DOMElement} node
 * @param {object} styles
 */ function setValueForStyles(node, styles) {
        var style = node.style;
        for(var styleName in styles){
            if (!styles.hasOwnProperty(styleName)) continue;
            var isCustomProperty = styleName.indexOf("--") === 0;
            if (!isCustomProperty) warnValidStyle$1(styleName, styles[styleName]);
            var styleValue = dangerousStyleValue(styleName, styles[styleName], isCustomProperty);
            if (styleName === "float") styleName = "cssFloat";
            if (isCustomProperty) style.setProperty(styleName, styleValue);
            else style[styleName] = styleValue;
        }
    }
    function isValueEmpty(value) {
        return value == null || typeof value === "boolean" || value === "";
    }
    /**
 * Given {color: 'red', overflow: 'hidden'} returns {
 *   color: 'color',
 *   overflowX: 'overflow',
 *   overflowY: 'overflow',
 * }. This can be read as "the overflowY property was set by the overflow
 * shorthand". That is, the values are the property that each was derived from.
 */ function expandShorthandMap(styles) {
        var expanded = {};
        for(var key in styles){
            var longhands = shorthandToLonghand[key] || [
                key
            ];
            for(var i = 0; i < longhands.length; i++)expanded[longhands[i]] = key;
        }
        return expanded;
    }
    /**
 * When mixing shorthand and longhand property names, we warn during updates if
 * we expect an incorrect result to occur. In particular, we warn for:
 *
 * Updating a shorthand property (longhand gets overwritten):
 *   {font: 'foo', fontVariant: 'bar'} -> {font: 'baz', fontVariant: 'bar'}
 *   becomes .style.font = 'baz'
 * Removing a shorthand property (longhand gets lost too):
 *   {font: 'foo', fontVariant: 'bar'} -> {fontVariant: 'bar'}
 *   becomes .style.font = ''
 * Removing a longhand property (should revert to shorthand; doesn't):
 *   {font: 'foo', fontVariant: 'bar'} -> {font: 'foo'}
 *   becomes .style.fontVariant = ''
 */ function validateShorthandPropertyCollisionInDev(styleUpdates, nextStyles) {
        if (!nextStyles) return;
        var expandedUpdates = expandShorthandMap(styleUpdates);
        var expandedStyles = expandShorthandMap(nextStyles);
        var warnedAbout = {};
        for(var key in expandedUpdates){
            var originalKey = expandedUpdates[key];
            var correctOriginalKey = expandedStyles[key];
            if (correctOriginalKey && originalKey !== correctOriginalKey) {
                var warningKey = originalKey + "," + correctOriginalKey;
                if (warnedAbout[warningKey]) continue;
                warnedAbout[warningKey] = true;
                error("%s a style property during rerender (%s) when a conflicting property is set (%s) can lead to styling bugs. To avoid this, don't mix shorthand and non-shorthand properties for the same value; instead, replace the shorthand with separate values.", isValueEmpty(styleUpdates[originalKey]) ? "Removing" : "Updating", originalKey, correctOriginalKey);
            }
        }
    }
    // For HTML, certain tags should omit their close tag. We keep a whitelist for
    // those special-case tags.
    var omittedCloseTags = {
        area: true,
        base: true,
        br: true,
        col: true,
        embed: true,
        hr: true,
        img: true,
        input: true,
        keygen: true,
        link: true,
        meta: true,
        param: true,
        source: true,
        track: true,
        wbr: true // NOTE: menuitem's close tag should be omitted, but that causes problems.
    };
    // `omittedCloseTags` except that `menuitem` should still have its closing tag.
    var voidElementTags = _assign({
        menuitem: true
    }, omittedCloseTags);
    var HTML = "__html";
    var ReactDebugCurrentFrame$3 = null;
    ReactDebugCurrentFrame$3 = ReactSharedInternals.ReactDebugCurrentFrame;
    function assertValidProps(tag, props) {
        if (!props) return;
         // Note the use of `==` which checks for null or undefined.
        if (voidElementTags[tag]) {
            if (!(props.children == null && props.dangerouslySetInnerHTML == null)) throw Error(tag + " is a void element tag and must neither have `children` nor use `dangerouslySetInnerHTML`." + ReactDebugCurrentFrame$3.getStackAddendum());
        }
        if (props.dangerouslySetInnerHTML != null) {
            if (!(props.children == null)) throw Error("Can only set one of `children` or `props.dangerouslySetInnerHTML`.");
            if (!(typeof props.dangerouslySetInnerHTML === "object" && HTML in props.dangerouslySetInnerHTML)) throw Error("`props.dangerouslySetInnerHTML` must be in the form `{__html: ...}`. Please visit https://fb.me/react-invariant-dangerously-set-inner-html for more information.");
        }
        if (!props.suppressContentEditableWarning && props.contentEditable && props.children != null) error("A component is `contentEditable` and contains `children` managed by React. It is now your responsibility to guarantee that none of those nodes are unexpectedly modified or duplicated. This is probably not intentional.");
        if (!(props.style == null || typeof props.style === "object")) throw Error("The `style` prop expects a mapping from style properties to values, not a string. For example, style={{marginRight: spacing + 'em'}} when using JSX." + ReactDebugCurrentFrame$3.getStackAddendum());
    }
    function isCustomComponent(tagName, props) {
        if (tagName.indexOf("-") === -1) return typeof props.is === "string";
        switch(tagName){
            // These are reserved SVG and MathML elements.
            // We don't mind this whitelist too much because we expect it to never grow.
            // The alternative is to track the namespace in a few places which is convoluted.
            // https://w3c.github.io/webcomponents/spec/custom/#custom-elements-core-concepts
            case "annotation-xml":
            case "color-profile":
            case "font-face":
            case "font-face-src":
            case "font-face-uri":
            case "font-face-format":
            case "font-face-name":
            case "missing-glyph":
                return false;
            default:
                return true;
        }
    }
    // When adding attributes to the HTML or SVG whitelist, be sure to
    // also add them to this module to ensure casing and incorrect name
    // warnings.
    var possibleStandardNames = {
        // HTML
        accept: "accept",
        acceptcharset: "acceptCharset",
        "accept-charset": "acceptCharset",
        accesskey: "accessKey",
        action: "action",
        allowfullscreen: "allowFullScreen",
        alt: "alt",
        as: "as",
        async: "async",
        autocapitalize: "autoCapitalize",
        autocomplete: "autoComplete",
        autocorrect: "autoCorrect",
        autofocus: "autoFocus",
        autoplay: "autoPlay",
        autosave: "autoSave",
        capture: "capture",
        cellpadding: "cellPadding",
        cellspacing: "cellSpacing",
        challenge: "challenge",
        charset: "charSet",
        checked: "checked",
        children: "children",
        cite: "cite",
        class: "className",
        classid: "classID",
        classname: "className",
        cols: "cols",
        colspan: "colSpan",
        content: "content",
        contenteditable: "contentEditable",
        contextmenu: "contextMenu",
        controls: "controls",
        controlslist: "controlsList",
        coords: "coords",
        crossorigin: "crossOrigin",
        dangerouslysetinnerhtml: "dangerouslySetInnerHTML",
        data: "data",
        datetime: "dateTime",
        default: "default",
        defaultchecked: "defaultChecked",
        defaultvalue: "defaultValue",
        defer: "defer",
        dir: "dir",
        disabled: "disabled",
        disablepictureinpicture: "disablePictureInPicture",
        download: "download",
        draggable: "draggable",
        enctype: "encType",
        for: "htmlFor",
        form: "form",
        formmethod: "formMethod",
        formaction: "formAction",
        formenctype: "formEncType",
        formnovalidate: "formNoValidate",
        formtarget: "formTarget",
        frameborder: "frameBorder",
        headers: "headers",
        height: "height",
        hidden: "hidden",
        high: "high",
        href: "href",
        hreflang: "hrefLang",
        htmlfor: "htmlFor",
        httpequiv: "httpEquiv",
        "http-equiv": "httpEquiv",
        icon: "icon",
        id: "id",
        innerhtml: "innerHTML",
        inputmode: "inputMode",
        integrity: "integrity",
        is: "is",
        itemid: "itemID",
        itemprop: "itemProp",
        itemref: "itemRef",
        itemscope: "itemScope",
        itemtype: "itemType",
        keyparams: "keyParams",
        keytype: "keyType",
        kind: "kind",
        label: "label",
        lang: "lang",
        list: "list",
        loop: "loop",
        low: "low",
        manifest: "manifest",
        marginwidth: "marginWidth",
        marginheight: "marginHeight",
        max: "max",
        maxlength: "maxLength",
        media: "media",
        mediagroup: "mediaGroup",
        method: "method",
        min: "min",
        minlength: "minLength",
        multiple: "multiple",
        muted: "muted",
        name: "name",
        nomodule: "noModule",
        nonce: "nonce",
        novalidate: "noValidate",
        open: "open",
        optimum: "optimum",
        pattern: "pattern",
        placeholder: "placeholder",
        playsinline: "playsInline",
        poster: "poster",
        preload: "preload",
        profile: "profile",
        radiogroup: "radioGroup",
        readonly: "readOnly",
        referrerpolicy: "referrerPolicy",
        rel: "rel",
        required: "required",
        reversed: "reversed",
        role: "role",
        rows: "rows",
        rowspan: "rowSpan",
        sandbox: "sandbox",
        scope: "scope",
        scoped: "scoped",
        scrolling: "scrolling",
        seamless: "seamless",
        selected: "selected",
        shape: "shape",
        size: "size",
        sizes: "sizes",
        span: "span",
        spellcheck: "spellCheck",
        src: "src",
        srcdoc: "srcDoc",
        srclang: "srcLang",
        srcset: "srcSet",
        start: "start",
        step: "step",
        style: "style",
        summary: "summary",
        tabindex: "tabIndex",
        target: "target",
        title: "title",
        type: "type",
        usemap: "useMap",
        value: "value",
        width: "width",
        wmode: "wmode",
        wrap: "wrap",
        // SVG
        about: "about",
        accentheight: "accentHeight",
        "accent-height": "accentHeight",
        accumulate: "accumulate",
        additive: "additive",
        alignmentbaseline: "alignmentBaseline",
        "alignment-baseline": "alignmentBaseline",
        allowreorder: "allowReorder",
        alphabetic: "alphabetic",
        amplitude: "amplitude",
        arabicform: "arabicForm",
        "arabic-form": "arabicForm",
        ascent: "ascent",
        attributename: "attributeName",
        attributetype: "attributeType",
        autoreverse: "autoReverse",
        azimuth: "azimuth",
        basefrequency: "baseFrequency",
        baselineshift: "baselineShift",
        "baseline-shift": "baselineShift",
        baseprofile: "baseProfile",
        bbox: "bbox",
        begin: "begin",
        bias: "bias",
        by: "by",
        calcmode: "calcMode",
        capheight: "capHeight",
        "cap-height": "capHeight",
        clip: "clip",
        clippath: "clipPath",
        "clip-path": "clipPath",
        clippathunits: "clipPathUnits",
        cliprule: "clipRule",
        "clip-rule": "clipRule",
        color: "color",
        colorinterpolation: "colorInterpolation",
        "color-interpolation": "colorInterpolation",
        colorinterpolationfilters: "colorInterpolationFilters",
        "color-interpolation-filters": "colorInterpolationFilters",
        colorprofile: "colorProfile",
        "color-profile": "colorProfile",
        colorrendering: "colorRendering",
        "color-rendering": "colorRendering",
        contentscripttype: "contentScriptType",
        contentstyletype: "contentStyleType",
        cursor: "cursor",
        cx: "cx",
        cy: "cy",
        d: "d",
        datatype: "datatype",
        decelerate: "decelerate",
        descent: "descent",
        diffuseconstant: "diffuseConstant",
        direction: "direction",
        display: "display",
        divisor: "divisor",
        dominantbaseline: "dominantBaseline",
        "dominant-baseline": "dominantBaseline",
        dur: "dur",
        dx: "dx",
        dy: "dy",
        edgemode: "edgeMode",
        elevation: "elevation",
        enablebackground: "enableBackground",
        "enable-background": "enableBackground",
        end: "end",
        exponent: "exponent",
        externalresourcesrequired: "externalResourcesRequired",
        fill: "fill",
        fillopacity: "fillOpacity",
        "fill-opacity": "fillOpacity",
        fillrule: "fillRule",
        "fill-rule": "fillRule",
        filter: "filter",
        filterres: "filterRes",
        filterunits: "filterUnits",
        floodopacity: "floodOpacity",
        "flood-opacity": "floodOpacity",
        floodcolor: "floodColor",
        "flood-color": "floodColor",
        focusable: "focusable",
        fontfamily: "fontFamily",
        "font-family": "fontFamily",
        fontsize: "fontSize",
        "font-size": "fontSize",
        fontsizeadjust: "fontSizeAdjust",
        "font-size-adjust": "fontSizeAdjust",
        fontstretch: "fontStretch",
        "font-stretch": "fontStretch",
        fontstyle: "fontStyle",
        "font-style": "fontStyle",
        fontvariant: "fontVariant",
        "font-variant": "fontVariant",
        fontweight: "fontWeight",
        "font-weight": "fontWeight",
        format: "format",
        from: "from",
        fx: "fx",
        fy: "fy",
        g1: "g1",
        g2: "g2",
        glyphname: "glyphName",
        "glyph-name": "glyphName",
        glyphorientationhorizontal: "glyphOrientationHorizontal",
        "glyph-orientation-horizontal": "glyphOrientationHorizontal",
        glyphorientationvertical: "glyphOrientationVertical",
        "glyph-orientation-vertical": "glyphOrientationVertical",
        glyphref: "glyphRef",
        gradienttransform: "gradientTransform",
        gradientunits: "gradientUnits",
        hanging: "hanging",
        horizadvx: "horizAdvX",
        "horiz-adv-x": "horizAdvX",
        horizoriginx: "horizOriginX",
        "horiz-origin-x": "horizOriginX",
        ideographic: "ideographic",
        imagerendering: "imageRendering",
        "image-rendering": "imageRendering",
        in2: "in2",
        in: "in",
        inlist: "inlist",
        intercept: "intercept",
        k1: "k1",
        k2: "k2",
        k3: "k3",
        k4: "k4",
        k: "k",
        kernelmatrix: "kernelMatrix",
        kernelunitlength: "kernelUnitLength",
        kerning: "kerning",
        keypoints: "keyPoints",
        keysplines: "keySplines",
        keytimes: "keyTimes",
        lengthadjust: "lengthAdjust",
        letterspacing: "letterSpacing",
        "letter-spacing": "letterSpacing",
        lightingcolor: "lightingColor",
        "lighting-color": "lightingColor",
        limitingconeangle: "limitingConeAngle",
        local: "local",
        markerend: "markerEnd",
        "marker-end": "markerEnd",
        markerheight: "markerHeight",
        markermid: "markerMid",
        "marker-mid": "markerMid",
        markerstart: "markerStart",
        "marker-start": "markerStart",
        markerunits: "markerUnits",
        markerwidth: "markerWidth",
        mask: "mask",
        maskcontentunits: "maskContentUnits",
        maskunits: "maskUnits",
        mathematical: "mathematical",
        mode: "mode",
        numoctaves: "numOctaves",
        offset: "offset",
        opacity: "opacity",
        operator: "operator",
        order: "order",
        orient: "orient",
        orientation: "orientation",
        origin: "origin",
        overflow: "overflow",
        overlineposition: "overlinePosition",
        "overline-position": "overlinePosition",
        overlinethickness: "overlineThickness",
        "overline-thickness": "overlineThickness",
        paintorder: "paintOrder",
        "paint-order": "paintOrder",
        panose1: "panose1",
        "panose-1": "panose1",
        pathlength: "pathLength",
        patterncontentunits: "patternContentUnits",
        patterntransform: "patternTransform",
        patternunits: "patternUnits",
        pointerevents: "pointerEvents",
        "pointer-events": "pointerEvents",
        points: "points",
        pointsatx: "pointsAtX",
        pointsaty: "pointsAtY",
        pointsatz: "pointsAtZ",
        prefix: "prefix",
        preservealpha: "preserveAlpha",
        preserveaspectratio: "preserveAspectRatio",
        primitiveunits: "primitiveUnits",
        property: "property",
        r: "r",
        radius: "radius",
        refx: "refX",
        refy: "refY",
        renderingintent: "renderingIntent",
        "rendering-intent": "renderingIntent",
        repeatcount: "repeatCount",
        repeatdur: "repeatDur",
        requiredextensions: "requiredExtensions",
        requiredfeatures: "requiredFeatures",
        resource: "resource",
        restart: "restart",
        result: "result",
        results: "results",
        rotate: "rotate",
        rx: "rx",
        ry: "ry",
        scale: "scale",
        security: "security",
        seed: "seed",
        shaperendering: "shapeRendering",
        "shape-rendering": "shapeRendering",
        slope: "slope",
        spacing: "spacing",
        specularconstant: "specularConstant",
        specularexponent: "specularExponent",
        speed: "speed",
        spreadmethod: "spreadMethod",
        startoffset: "startOffset",
        stddeviation: "stdDeviation",
        stemh: "stemh",
        stemv: "stemv",
        stitchtiles: "stitchTiles",
        stopcolor: "stopColor",
        "stop-color": "stopColor",
        stopopacity: "stopOpacity",
        "stop-opacity": "stopOpacity",
        strikethroughposition: "strikethroughPosition",
        "strikethrough-position": "strikethroughPosition",
        strikethroughthickness: "strikethroughThickness",
        "strikethrough-thickness": "strikethroughThickness",
        string: "string",
        stroke: "stroke",
        strokedasharray: "strokeDasharray",
        "stroke-dasharray": "strokeDasharray",
        strokedashoffset: "strokeDashoffset",
        "stroke-dashoffset": "strokeDashoffset",
        strokelinecap: "strokeLinecap",
        "stroke-linecap": "strokeLinecap",
        strokelinejoin: "strokeLinejoin",
        "stroke-linejoin": "strokeLinejoin",
        strokemiterlimit: "strokeMiterlimit",
        "stroke-miterlimit": "strokeMiterlimit",
        strokewidth: "strokeWidth",
        "stroke-width": "strokeWidth",
        strokeopacity: "strokeOpacity",
        "stroke-opacity": "strokeOpacity",
        suppresscontenteditablewarning: "suppressContentEditableWarning",
        suppresshydrationwarning: "suppressHydrationWarning",
        surfacescale: "surfaceScale",
        systemlanguage: "systemLanguage",
        tablevalues: "tableValues",
        targetx: "targetX",
        targety: "targetY",
        textanchor: "textAnchor",
        "text-anchor": "textAnchor",
        textdecoration: "textDecoration",
        "text-decoration": "textDecoration",
        textlength: "textLength",
        textrendering: "textRendering",
        "text-rendering": "textRendering",
        to: "to",
        transform: "transform",
        typeof: "typeof",
        u1: "u1",
        u2: "u2",
        underlineposition: "underlinePosition",
        "underline-position": "underlinePosition",
        underlinethickness: "underlineThickness",
        "underline-thickness": "underlineThickness",
        unicode: "unicode",
        unicodebidi: "unicodeBidi",
        "unicode-bidi": "unicodeBidi",
        unicoderange: "unicodeRange",
        "unicode-range": "unicodeRange",
        unitsperem: "unitsPerEm",
        "units-per-em": "unitsPerEm",
        unselectable: "unselectable",
        valphabetic: "vAlphabetic",
        "v-alphabetic": "vAlphabetic",
        values: "values",
        vectoreffect: "vectorEffect",
        "vector-effect": "vectorEffect",
        version: "version",
        vertadvy: "vertAdvY",
        "vert-adv-y": "vertAdvY",
        vertoriginx: "vertOriginX",
        "vert-origin-x": "vertOriginX",
        vertoriginy: "vertOriginY",
        "vert-origin-y": "vertOriginY",
        vhanging: "vHanging",
        "v-hanging": "vHanging",
        videographic: "vIdeographic",
        "v-ideographic": "vIdeographic",
        viewbox: "viewBox",
        viewtarget: "viewTarget",
        visibility: "visibility",
        vmathematical: "vMathematical",
        "v-mathematical": "vMathematical",
        vocab: "vocab",
        widths: "widths",
        wordspacing: "wordSpacing",
        "word-spacing": "wordSpacing",
        writingmode: "writingMode",
        "writing-mode": "writingMode",
        x1: "x1",
        x2: "x2",
        x: "x",
        xchannelselector: "xChannelSelector",
        xheight: "xHeight",
        "x-height": "xHeight",
        xlinkactuate: "xlinkActuate",
        "xlink:actuate": "xlinkActuate",
        xlinkarcrole: "xlinkArcrole",
        "xlink:arcrole": "xlinkArcrole",
        xlinkhref: "xlinkHref",
        "xlink:href": "xlinkHref",
        xlinkrole: "xlinkRole",
        "xlink:role": "xlinkRole",
        xlinkshow: "xlinkShow",
        "xlink:show": "xlinkShow",
        xlinktitle: "xlinkTitle",
        "xlink:title": "xlinkTitle",
        xlinktype: "xlinkType",
        "xlink:type": "xlinkType",
        xmlbase: "xmlBase",
        "xml:base": "xmlBase",
        xmllang: "xmlLang",
        "xml:lang": "xmlLang",
        xmlns: "xmlns",
        "xml:space": "xmlSpace",
        xmlnsxlink: "xmlnsXlink",
        "xmlns:xlink": "xmlnsXlink",
        xmlspace: "xmlSpace",
        y1: "y1",
        y2: "y2",
        y: "y",
        ychannelselector: "yChannelSelector",
        z: "z",
        zoomandpan: "zoomAndPan"
    };
    var ariaProperties = {
        "aria-current": 0,
        // state
        "aria-details": 0,
        "aria-disabled": 0,
        // state
        "aria-hidden": 0,
        // state
        "aria-invalid": 0,
        // state
        "aria-keyshortcuts": 0,
        "aria-label": 0,
        "aria-roledescription": 0,
        // Widget Attributes
        "aria-autocomplete": 0,
        "aria-checked": 0,
        "aria-expanded": 0,
        "aria-haspopup": 0,
        "aria-level": 0,
        "aria-modal": 0,
        "aria-multiline": 0,
        "aria-multiselectable": 0,
        "aria-orientation": 0,
        "aria-placeholder": 0,
        "aria-pressed": 0,
        "aria-readonly": 0,
        "aria-required": 0,
        "aria-selected": 0,
        "aria-sort": 0,
        "aria-valuemax": 0,
        "aria-valuemin": 0,
        "aria-valuenow": 0,
        "aria-valuetext": 0,
        // Live Region Attributes
        "aria-atomic": 0,
        "aria-busy": 0,
        "aria-live": 0,
        "aria-relevant": 0,
        // Drag-and-Drop Attributes
        "aria-dropeffect": 0,
        "aria-grabbed": 0,
        // Relationship Attributes
        "aria-activedescendant": 0,
        "aria-colcount": 0,
        "aria-colindex": 0,
        "aria-colspan": 0,
        "aria-controls": 0,
        "aria-describedby": 0,
        "aria-errormessage": 0,
        "aria-flowto": 0,
        "aria-labelledby": 0,
        "aria-owns": 0,
        "aria-posinset": 0,
        "aria-rowcount": 0,
        "aria-rowindex": 0,
        "aria-rowspan": 0,
        "aria-setsize": 0
    };
    var warnedProperties = {};
    var rARIA = new RegExp("^(aria)-[" + ATTRIBUTE_NAME_CHAR + "]*$");
    var rARIACamel = new RegExp("^(aria)[A-Z][" + ATTRIBUTE_NAME_CHAR + "]*$");
    var hasOwnProperty$1 = Object.prototype.hasOwnProperty;
    function validateProperty(tagName, name) {
        if (hasOwnProperty$1.call(warnedProperties, name) && warnedProperties[name]) return true;
        if (rARIACamel.test(name)) {
            var ariaName = "aria-" + name.slice(4).toLowerCase();
            var correctName = ariaProperties.hasOwnProperty(ariaName) ? ariaName : null; // If this is an aria-* attribute, but is not listed in the known DOM
            // DOM properties, then it is an invalid aria-* attribute.
            if (correctName == null) {
                error("Invalid ARIA attribute `%s`. ARIA attributes follow the pattern aria-* and must be lowercase.", name);
                warnedProperties[name] = true;
                return true;
            } // aria-* attributes should be lowercase; suggest the lowercase version.
            if (name !== correctName) {
                error("Invalid ARIA attribute `%s`. Did you mean `%s`?", name, correctName);
                warnedProperties[name] = true;
                return true;
            }
        }
        if (rARIA.test(name)) {
            var lowerCasedName = name.toLowerCase();
            var standardName = ariaProperties.hasOwnProperty(lowerCasedName) ? lowerCasedName : null; // If this is an aria-* attribute, but is not listed in the known DOM
            // DOM properties, then it is an invalid aria-* attribute.
            if (standardName == null) {
                warnedProperties[name] = true;
                return false;
            } // aria-* attributes should be lowercase; suggest the lowercase version.
            if (name !== standardName) {
                error("Unknown ARIA attribute `%s`. Did you mean `%s`?", name, standardName);
                warnedProperties[name] = true;
                return true;
            }
        }
        return true;
    }
    function warnInvalidARIAProps(type, props) {
        var invalidProps = [];
        for(var key in props){
            var isValid = validateProperty(type, key);
            if (!isValid) invalidProps.push(key);
        }
        var unknownPropString = invalidProps.map(function(prop) {
            return "`" + prop + "`";
        }).join(", ");
        if (invalidProps.length === 1) error("Invalid aria prop %s on <%s> tag. For details, see https://fb.me/invalid-aria-prop", unknownPropString, type);
        else if (invalidProps.length > 1) error("Invalid aria props %s on <%s> tag. For details, see https://fb.me/invalid-aria-prop", unknownPropString, type);
    }
    function validateProperties(type, props) {
        if (isCustomComponent(type, props)) return;
        warnInvalidARIAProps(type, props);
    }
    var didWarnValueNull = false;
    function validateProperties$1(type, props) {
        if (type !== "input" && type !== "textarea" && type !== "select") return;
        if (props != null && props.value === null && !didWarnValueNull) {
            didWarnValueNull = true;
            if (type === "select" && props.multiple) error("`value` prop on `%s` should not be null. Consider using an empty array when `multiple` is set to `true` to clear the component or `undefined` for uncontrolled components.", type);
            else error("`value` prop on `%s` should not be null. Consider using an empty string to clear the component or `undefined` for uncontrolled components.", type);
        }
    }
    var validateProperty$1 = function() {};
    var warnedProperties$1 = {};
    var _hasOwnProperty = Object.prototype.hasOwnProperty;
    var EVENT_NAME_REGEX = /^on./;
    var INVALID_EVENT_NAME_REGEX = /^on[^A-Z]/;
    var rARIA$1 = new RegExp("^(aria)-[" + ATTRIBUTE_NAME_CHAR + "]*$");
    var rARIACamel$1 = new RegExp("^(aria)[A-Z][" + ATTRIBUTE_NAME_CHAR + "]*$");
    validateProperty$1 = function(tagName, name, value, canUseEventSystem) {
        if (_hasOwnProperty.call(warnedProperties$1, name) && warnedProperties$1[name]) return true;
        var lowerCasedName = name.toLowerCase();
        if (lowerCasedName === "onfocusin" || lowerCasedName === "onfocusout") {
            error("React uses onFocus and onBlur instead of onFocusIn and onFocusOut. All React events are normalized to bubble, so onFocusIn and onFocusOut are not needed/supported by React.");
            warnedProperties$1[name] = true;
            return true;
        } // We can't rely on the event system being injected on the server.
        if (canUseEventSystem) {
            if (registrationNameModules.hasOwnProperty(name)) return true;
            var registrationName = possibleRegistrationNames.hasOwnProperty(lowerCasedName) ? possibleRegistrationNames[lowerCasedName] : null;
            if (registrationName != null) {
                error("Invalid event handler property `%s`. Did you mean `%s`?", name, registrationName);
                warnedProperties$1[name] = true;
                return true;
            }
            if (EVENT_NAME_REGEX.test(name)) {
                error("Unknown event handler property `%s`. It will be ignored.", name);
                warnedProperties$1[name] = true;
                return true;
            }
        } else if (EVENT_NAME_REGEX.test(name)) {
            // If no event plugins have been injected, we are in a server environment.
            // So we can't tell if the event name is correct for sure, but we can filter
            // out known bad ones like `onclick`. We can't suggest a specific replacement though.
            if (INVALID_EVENT_NAME_REGEX.test(name)) error("Invalid event handler property `%s`. React events use the camelCase naming convention, for example `onClick`.", name);
            warnedProperties$1[name] = true;
            return true;
        } // Let the ARIA attribute hook validate ARIA attributes
        if (rARIA$1.test(name) || rARIACamel$1.test(name)) return true;
        if (lowerCasedName === "innerhtml") {
            error("Directly setting property `innerHTML` is not permitted. For more information, lookup documentation on `dangerouslySetInnerHTML`.");
            warnedProperties$1[name] = true;
            return true;
        }
        if (lowerCasedName === "aria") {
            error("The `aria` attribute is reserved for future use in React. Pass individual `aria-` attributes instead.");
            warnedProperties$1[name] = true;
            return true;
        }
        if (lowerCasedName === "is" && value !== null && value !== undefined && typeof value !== "string") {
            error("Received a `%s` for a string attribute `is`. If this is expected, cast the value to a string.", typeof value);
            warnedProperties$1[name] = true;
            return true;
        }
        if (typeof value === "number" && isNaN(value)) {
            error("Received NaN for the `%s` attribute. If this is expected, cast the value to a string.", name);
            warnedProperties$1[name] = true;
            return true;
        }
        var propertyInfo = getPropertyInfo(name);
        var isReserved = propertyInfo !== null && propertyInfo.type === RESERVED; // Known attributes should match the casing specified in the property config.
        if (possibleStandardNames.hasOwnProperty(lowerCasedName)) {
            var standardName = possibleStandardNames[lowerCasedName];
            if (standardName !== name) {
                error("Invalid DOM property `%s`. Did you mean `%s`?", name, standardName);
                warnedProperties$1[name] = true;
                return true;
            }
        } else if (!isReserved && name !== lowerCasedName) {
            // Unknown attributes should have lowercase casing since that's how they
            // will be cased anyway with server rendering.
            error("React does not recognize the `%s` prop on a DOM element. If you intentionally want it to appear in the DOM as a custom attribute, spell it as lowercase `%s` instead. If you accidentally passed it from a parent component, remove it from the DOM element.", name, lowerCasedName);
            warnedProperties$1[name] = true;
            return true;
        }
        if (typeof value === "boolean" && shouldRemoveAttributeWithWarning(name, value, propertyInfo, false)) {
            if (value) error('Received `%s` for a non-boolean attribute `%s`.\n\nIf you want to write it to the DOM, pass a string instead: %s="%s" or %s={value.toString()}.', value, name, name, value, name);
            else error('Received `%s` for a non-boolean attribute `%s`.\n\nIf you want to write it to the DOM, pass a string instead: %s="%s" or %s={value.toString()}.\n\nIf you used to conditionally omit it with %s={condition && value}, pass %s={condition ? value : undefined} instead.', value, name, name, value, name, name, name);
            warnedProperties$1[name] = true;
            return true;
        } // Now that we've validated casing, do not validate
        // data types for reserved props
        if (isReserved) return true;
         // Warn when a known attribute is a bad type
        if (shouldRemoveAttributeWithWarning(name, value, propertyInfo, false)) {
            warnedProperties$1[name] = true;
            return false;
        } // Warn when passing the strings 'false' or 'true' into a boolean prop
        if ((value === "false" || value === "true") && propertyInfo !== null && propertyInfo.type === BOOLEAN) {
            error("Received the string `%s` for the boolean attribute `%s`. %s Did you mean %s={%s}?", value, name, value === "false" ? "The browser will interpret it as a truthy value." : 'Although this works, it will not work as expected if you pass the string "false".', name, value);
            warnedProperties$1[name] = true;
            return true;
        }
        return true;
    };
    var warnUnknownProperties = function(type, props, canUseEventSystem) {
        var unknownProps = [];
        for(var key in props){
            var isValid = validateProperty$1(type, key, props[key], canUseEventSystem);
            if (!isValid) unknownProps.push(key);
        }
        var unknownPropString = unknownProps.map(function(prop) {
            return "`" + prop + "`";
        }).join(", ");
        if (unknownProps.length === 1) error("Invalid value for prop %s on <%s> tag. Either remove it from the element, or pass a string or number value to keep it in the DOM. For details, see https://fb.me/react-attribute-behavior", unknownPropString, type);
        else if (unknownProps.length > 1) error("Invalid values for props %s on <%s> tag. Either remove them from the element, or pass a string or number value to keep them in the DOM. For details, see https://fb.me/react-attribute-behavior", unknownPropString, type);
    };
    function validateProperties$2(type, props, canUseEventSystem) {
        if (isCustomComponent(type, props)) return;
        warnUnknownProperties(type, props, canUseEventSystem);
    }
    var didWarnInvalidHydration = false;
    var DANGEROUSLY_SET_INNER_HTML = "dangerouslySetInnerHTML";
    var SUPPRESS_CONTENT_EDITABLE_WARNING = "suppressContentEditableWarning";
    var SUPPRESS_HYDRATION_WARNING = "suppressHydrationWarning";
    var AUTOFOCUS = "autoFocus";
    var CHILDREN = "children";
    var STYLE = "style";
    var HTML$1 = "__html";
    var HTML_NAMESPACE$1 = Namespaces.html;
    var warnedUnknownTags;
    var suppressHydrationWarning;
    var validatePropertiesInDevelopment;
    var warnForTextDifference;
    var warnForPropDifference;
    var warnForExtraAttributes;
    var warnForInvalidEventListener;
    var canDiffStyleForHydrationWarning;
    var normalizeMarkupForTextOrAttribute;
    var normalizeHTML;
    warnedUnknownTags = {
        // Chrome is the only major browser not shipping <time>. But as of July
        // 2017 it intends to ship it due to widespread usage. We intentionally
        // *don't* warn for <time> even if it's unrecognized by Chrome because
        // it soon will be, and many apps have been using it anyway.
        time: true,
        // There are working polyfills for <dialog>. Let people use it.
        dialog: true,
        // Electron ships a custom <webview> tag to display external web content in
        // an isolated frame and process.
        // This tag is not present in non Electron environments such as JSDom which
        // is often used for testing purposes.
        // @see https://electronjs.org/docs/api/webview-tag
        webview: true
    };
    validatePropertiesInDevelopment = function(type, props) {
        validateProperties(type, props);
        validateProperties$1(type, props);
        validateProperties$2(type, props, /* canUseEventSystem */ true);
    }; // IE 11 parses & normalizes the style attribute as opposed to other
    // browsers. It adds spaces and sorts the properties in some
    // non-alphabetical order. Handling that would require sorting CSS
    // properties in the client & server versions or applying
    // `expectedStyle` to a temporary DOM node to read its `style` attribute
    // normalized. Since it only affects IE, we're skipping style warnings
    // in that browser completely in favor of doing all that work.
    // See https://github.com/facebook/react/issues/11807
    canDiffStyleForHydrationWarning = canUseDOM && !document.documentMode; // HTML parsing normalizes CR and CRLF to LF.
    // It also can turn \u0000 into \uFFFD inside attributes.
    // https://www.w3.org/TR/html5/single-page.html#preprocessing-the-input-stream
    // If we have a mismatch, it might be caused by that.
    // We will still patch up in this case but not fire the warning.
    var NORMALIZE_NEWLINES_REGEX = /\r\n?/g;
    var NORMALIZE_NULL_AND_REPLACEMENT_REGEX = /\u0000|\uFFFD/g;
    normalizeMarkupForTextOrAttribute = function(markup) {
        var markupString = typeof markup === "string" ? markup : "" + markup;
        return markupString.replace(NORMALIZE_NEWLINES_REGEX, "\n").replace(NORMALIZE_NULL_AND_REPLACEMENT_REGEX, "");
    };
    warnForTextDifference = function(serverText, clientText) {
        if (didWarnInvalidHydration) return;
        var normalizedClientText = normalizeMarkupForTextOrAttribute(clientText);
        var normalizedServerText = normalizeMarkupForTextOrAttribute(serverText);
        if (normalizedServerText === normalizedClientText) return;
        didWarnInvalidHydration = true;
        error('Text content did not match. Server: "%s" Client: "%s"', normalizedServerText, normalizedClientText);
    };
    warnForPropDifference = function(propName, serverValue, clientValue) {
        if (didWarnInvalidHydration) return;
        var normalizedClientValue = normalizeMarkupForTextOrAttribute(clientValue);
        var normalizedServerValue = normalizeMarkupForTextOrAttribute(serverValue);
        if (normalizedServerValue === normalizedClientValue) return;
        didWarnInvalidHydration = true;
        error("Prop `%s` did not match. Server: %s Client: %s", propName, JSON.stringify(normalizedServerValue), JSON.stringify(normalizedClientValue));
    };
    warnForExtraAttributes = function(attributeNames) {
        if (didWarnInvalidHydration) return;
        didWarnInvalidHydration = true;
        var names = [];
        attributeNames.forEach(function(name) {
            names.push(name);
        });
        error("Extra attributes from the server: %s", names);
    };
    warnForInvalidEventListener = function(registrationName, listener) {
        if (listener === false) error("Expected `%s` listener to be a function, instead got `false`.\n\nIf you used to conditionally omit it with %s={condition && value}, pass %s={condition ? value : undefined} instead.", registrationName, registrationName, registrationName);
        else error("Expected `%s` listener to be a function, instead got a value of `%s` type.", registrationName, typeof listener);
    }; // Parse the HTML and read it back to normalize the HTML string so that it
    // can be used for comparison.
    normalizeHTML = function(parent, html) {
        // We could have created a separate document here to avoid
        // re-initializing custom elements if they exist. But this breaks
        // how <noscript> is being handled. So we use the same document.
        // See the discussion in https://github.com/facebook/react/pull/11157.
        var testElement = parent.namespaceURI === HTML_NAMESPACE$1 ? parent.ownerDocument.createElement(parent.tagName) : parent.ownerDocument.createElementNS(parent.namespaceURI, parent.tagName);
        testElement.innerHTML = html;
        return testElement.innerHTML;
    };
    function ensureListeningTo(rootContainerElement, registrationName) {
        var isDocumentOrFragment = rootContainerElement.nodeType === DOCUMENT_NODE || rootContainerElement.nodeType === DOCUMENT_FRAGMENT_NODE;
        var doc = isDocumentOrFragment ? rootContainerElement : rootContainerElement.ownerDocument;
        legacyListenToEvent(registrationName, doc);
    }
    function getOwnerDocumentFromRootContainer(rootContainerElement) {
        return rootContainerElement.nodeType === DOCUMENT_NODE ? rootContainerElement : rootContainerElement.ownerDocument;
    }
    function noop() {}
    function trapClickOnNonInteractiveElement(node) {
        // Mobile Safari does not fire properly bubble click events on
        // non-interactive elements, which means delegated click listeners do not
        // fire. The workaround for this bug involves attaching an empty click
        // listener on the target node.
        // http://www.quirksmode.org/blog/archives/2010/09/click_event_del.html
        // Just set it using the onclick property so that we don't have to manage any
        // bookkeeping for it. Not sure if we need to clear it when the listener is
        // removed.
        // TODO: Only do this for the relevant Safaris maybe?
        node.onclick = noop;
    }
    function setInitialDOMProperties(tag, domElement, rootContainerElement, nextProps, isCustomComponentTag) {
        for(var propKey in nextProps){
            if (!nextProps.hasOwnProperty(propKey)) continue;
            var nextProp = nextProps[propKey];
            if (propKey === STYLE) {
                if (nextProp) // Freeze the next style object so that we can assume it won't be
                // mutated. We have already warned for this in the past.
                Object.freeze(nextProp);
                setValueForStyles(domElement, nextProp);
            } else if (propKey === DANGEROUSLY_SET_INNER_HTML) {
                var nextHtml = nextProp ? nextProp[HTML$1] : undefined;
                if (nextHtml != null) setInnerHTML(domElement, nextHtml);
            } else if (propKey === CHILDREN) {
                if (typeof nextProp === "string") {
                    // Avoid setting initial textContent when the text is empty. In IE11 setting
                    // textContent on a <textarea> will cause the placeholder to not
                    // show within the <textarea> until it has been focused and blurred again.
                    // https://github.com/facebook/react/issues/6731#issuecomment-254874553
                    var canSetTextContent = tag !== "textarea" || nextProp !== "";
                    if (canSetTextContent) setTextContent(domElement, nextProp);
                } else if (typeof nextProp === "number") setTextContent(domElement, "" + nextProp);
            } else if (propKey === SUPPRESS_CONTENT_EDITABLE_WARNING || propKey === SUPPRESS_HYDRATION_WARNING) ;
            else if (propKey === AUTOFOCUS) ;
            else if (registrationNameModules.hasOwnProperty(propKey)) {
                if (nextProp != null) {
                    if (typeof nextProp !== "function") warnForInvalidEventListener(propKey, nextProp);
                    ensureListeningTo(rootContainerElement, propKey);
                }
            } else if (nextProp != null) setValueForProperty(domElement, propKey, nextProp, isCustomComponentTag);
        }
    }
    function updateDOMProperties(domElement, updatePayload, wasCustomComponentTag, isCustomComponentTag) {
        // TODO: Handle wasCustomComponentTag
        for(var i = 0; i < updatePayload.length; i += 2){
            var propKey = updatePayload[i];
            var propValue = updatePayload[i + 1];
            if (propKey === STYLE) setValueForStyles(domElement, propValue);
            else if (propKey === DANGEROUSLY_SET_INNER_HTML) setInnerHTML(domElement, propValue);
            else if (propKey === CHILDREN) setTextContent(domElement, propValue);
            else setValueForProperty(domElement, propKey, propValue, isCustomComponentTag);
        }
    }
    function createElement(type, props, rootContainerElement, parentNamespace) {
        var isCustomComponentTag; // We create tags in the namespace of their parent container, except HTML
        // tags get no namespace.
        var ownerDocument = getOwnerDocumentFromRootContainer(rootContainerElement);
        var domElement;
        var namespaceURI = parentNamespace;
        if (namespaceURI === HTML_NAMESPACE$1) namespaceURI = getIntrinsicNamespace(type);
        if (namespaceURI === HTML_NAMESPACE$1) {
            isCustomComponentTag = isCustomComponent(type, props); // Should this check be gated by parent namespace? Not sure we want to
            // allow <SVG> or <mATH>.
            if (!isCustomComponentTag && type !== type.toLowerCase()) error("<%s /> is using incorrect casing. Use PascalCase for React components, or lowercase for HTML elements.", type);
            if (type === "script") {
                // Create the script via .innerHTML so its "parser-inserted" flag is
                // set to true and it does not execute
                var div = ownerDocument.createElement("div");
                div.innerHTML = "<script></script>"; // eslint-disable-line
                // This is guaranteed to yield a script element.
                var firstChild = div.firstChild;
                domElement = div.removeChild(firstChild);
            } else if (typeof props.is === "string") // $FlowIssue `createElement` should be updated for Web Components
            domElement = ownerDocument.createElement(type, {
                is: props.is
            });
            else {
                // Separate else branch instead of using `props.is || undefined` above because of a Firefox bug.
                // See discussion in https://github.com/facebook/react/pull/6896
                // and discussion in https://bugzilla.mozilla.org/show_bug.cgi?id=1276240
                domElement = ownerDocument.createElement(type); // Normally attributes are assigned in `setInitialDOMProperties`, however the `multiple` and `size`
                // attributes on `select`s needs to be added before `option`s are inserted.
                // This prevents:
                // - a bug where the `select` does not scroll to the correct option because singular
                //  `select` elements automatically pick the first item #13222
                // - a bug where the `select` set the first item as selected despite the `size` attribute #14239
                // See https://github.com/facebook/react/issues/13222
                // and https://github.com/facebook/react/issues/14239
                if (type === "select") {
                    var node = domElement;
                    if (props.multiple) node.multiple = true;
                    else if (props.size) // Setting a size greater than 1 causes a select to behave like `multiple=true`, where
                    // it is possible that no option is selected.
                    //
                    // This is only necessary when a select in "single selection mode".
                    node.size = props.size;
                }
            }
        } else domElement = ownerDocument.createElementNS(namespaceURI, type);
        if (namespaceURI === HTML_NAMESPACE$1) {
            if (!isCustomComponentTag && Object.prototype.toString.call(domElement) === "[object HTMLUnknownElement]" && !Object.prototype.hasOwnProperty.call(warnedUnknownTags, type)) {
                warnedUnknownTags[type] = true;
                error("The tag <%s> is unrecognized in this browser. If you meant to render a React component, start its name with an uppercase letter.", type);
            }
        }
        return domElement;
    }
    function createTextNode(text, rootContainerElement) {
        return getOwnerDocumentFromRootContainer(rootContainerElement).createTextNode(text);
    }
    function setInitialProperties(domElement, tag, rawProps, rootContainerElement) {
        var isCustomComponentTag = isCustomComponent(tag, rawProps);
        validatePropertiesInDevelopment(tag, rawProps);
        var props;
        switch(tag){
            case "iframe":
            case "object":
            case "embed":
                trapBubbledEvent(TOP_LOAD, domElement);
                props = rawProps;
                break;
            case "video":
            case "audio":
                // Create listener for each media event
                for(var i = 0; i < mediaEventTypes.length; i++)trapBubbledEvent(mediaEventTypes[i], domElement);
                props = rawProps;
                break;
            case "source":
                trapBubbledEvent(TOP_ERROR, domElement);
                props = rawProps;
                break;
            case "img":
            case "image":
            case "link":
                trapBubbledEvent(TOP_ERROR, domElement);
                trapBubbledEvent(TOP_LOAD, domElement);
                props = rawProps;
                break;
            case "form":
                trapBubbledEvent(TOP_RESET, domElement);
                trapBubbledEvent(TOP_SUBMIT, domElement);
                props = rawProps;
                break;
            case "details":
                trapBubbledEvent(TOP_TOGGLE, domElement);
                props = rawProps;
                break;
            case "input":
                initWrapperState(domElement, rawProps);
                props = getHostProps(domElement, rawProps);
                trapBubbledEvent(TOP_INVALID, domElement); // For controlled components we always need to ensure we're listening
                // to onChange. Even if there is no listener.
                ensureListeningTo(rootContainerElement, "onChange");
                break;
            case "option":
                validateProps(domElement, rawProps);
                props = getHostProps$1(domElement, rawProps);
                break;
            case "select":
                initWrapperState$1(domElement, rawProps);
                props = getHostProps$2(domElement, rawProps);
                trapBubbledEvent(TOP_INVALID, domElement); // For controlled components we always need to ensure we're listening
                // to onChange. Even if there is no listener.
                ensureListeningTo(rootContainerElement, "onChange");
                break;
            case "textarea":
                initWrapperState$2(domElement, rawProps);
                props = getHostProps$3(domElement, rawProps);
                trapBubbledEvent(TOP_INVALID, domElement); // For controlled components we always need to ensure we're listening
                // to onChange. Even if there is no listener.
                ensureListeningTo(rootContainerElement, "onChange");
                break;
            default:
                props = rawProps;
        }
        assertValidProps(tag, props);
        setInitialDOMProperties(tag, domElement, rootContainerElement, props, isCustomComponentTag);
        switch(tag){
            case "input":
                // TODO: Make sure we check if this is still unmounted or do any clean
                // up necessary since we never stop tracking anymore.
                track(domElement);
                postMountWrapper(domElement, rawProps, false);
                break;
            case "textarea":
                // TODO: Make sure we check if this is still unmounted or do any clean
                // up necessary since we never stop tracking anymore.
                track(domElement);
                postMountWrapper$3(domElement);
                break;
            case "option":
                postMountWrapper$1(domElement, rawProps);
                break;
            case "select":
                postMountWrapper$2(domElement, rawProps);
                break;
            default:
                if (typeof props.onClick === "function") // TODO: This cast may not be sound for SVG, MathML or custom elements.
                trapClickOnNonInteractiveElement(domElement);
                break;
        }
    } // Calculate the diff between the two objects.
    function diffProperties(domElement, tag, lastRawProps, nextRawProps, rootContainerElement) {
        validatePropertiesInDevelopment(tag, nextRawProps);
        var updatePayload = null;
        var lastProps;
        var nextProps;
        switch(tag){
            case "input":
                lastProps = getHostProps(domElement, lastRawProps);
                nextProps = getHostProps(domElement, nextRawProps);
                updatePayload = [];
                break;
            case "option":
                lastProps = getHostProps$1(domElement, lastRawProps);
                nextProps = getHostProps$1(domElement, nextRawProps);
                updatePayload = [];
                break;
            case "select":
                lastProps = getHostProps$2(domElement, lastRawProps);
                nextProps = getHostProps$2(domElement, nextRawProps);
                updatePayload = [];
                break;
            case "textarea":
                lastProps = getHostProps$3(domElement, lastRawProps);
                nextProps = getHostProps$3(domElement, nextRawProps);
                updatePayload = [];
                break;
            default:
                lastProps = lastRawProps;
                nextProps = nextRawProps;
                if (typeof lastProps.onClick !== "function" && typeof nextProps.onClick === "function") // TODO: This cast may not be sound for SVG, MathML or custom elements.
                trapClickOnNonInteractiveElement(domElement);
                break;
        }
        assertValidProps(tag, nextProps);
        var propKey;
        var styleName;
        var styleUpdates = null;
        for(propKey in lastProps){
            if (nextProps.hasOwnProperty(propKey) || !lastProps.hasOwnProperty(propKey) || lastProps[propKey] == null) continue;
            if (propKey === STYLE) {
                var lastStyle = lastProps[propKey];
                for(styleName in lastStyle)if (lastStyle.hasOwnProperty(styleName)) {
                    if (!styleUpdates) styleUpdates = {};
                    styleUpdates[styleName] = "";
                }
            } else if (propKey === DANGEROUSLY_SET_INNER_HTML || propKey === CHILDREN) ;
            else if (propKey === SUPPRESS_CONTENT_EDITABLE_WARNING || propKey === SUPPRESS_HYDRATION_WARNING) ;
            else if (propKey === AUTOFOCUS) ;
            else if (registrationNameModules.hasOwnProperty(propKey)) // This is a special case. If any listener updates we need to ensure
            // that the "current" fiber pointer gets updated so we need a commit
            // to update this element.
            {
                if (!updatePayload) updatePayload = [];
            } else // For all other deleted properties we add it to the queue. We use
            // the whitelist in the commit phase instead.
            (updatePayload = updatePayload || []).push(propKey, null);
        }
        for(propKey in nextProps){
            var nextProp = nextProps[propKey];
            var lastProp = lastProps != null ? lastProps[propKey] : undefined;
            if (!nextProps.hasOwnProperty(propKey) || nextProp === lastProp || nextProp == null && lastProp == null) continue;
            if (propKey === STYLE) {
                if (nextProp) // Freeze the next style object so that we can assume it won't be
                // mutated. We have already warned for this in the past.
                Object.freeze(nextProp);
                if (lastProp) {
                    // Unset styles on `lastProp` but not on `nextProp`.
                    for(styleName in lastProp)if (lastProp.hasOwnProperty(styleName) && (!nextProp || !nextProp.hasOwnProperty(styleName))) {
                        if (!styleUpdates) styleUpdates = {};
                        styleUpdates[styleName] = "";
                    }
                     // Update styles that changed since `lastProp`.
                    for(styleName in nextProp)if (nextProp.hasOwnProperty(styleName) && lastProp[styleName] !== nextProp[styleName]) {
                        if (!styleUpdates) styleUpdates = {};
                        styleUpdates[styleName] = nextProp[styleName];
                    }
                } else {
                    // Relies on `updateStylesByID` not mutating `styleUpdates`.
                    if (!styleUpdates) {
                        if (!updatePayload) updatePayload = [];
                        updatePayload.push(propKey, styleUpdates);
                    }
                    styleUpdates = nextProp;
                }
            } else if (propKey === DANGEROUSLY_SET_INNER_HTML) {
                var nextHtml = nextProp ? nextProp[HTML$1] : undefined;
                var lastHtml = lastProp ? lastProp[HTML$1] : undefined;
                if (nextHtml != null) {
                    if (lastHtml !== nextHtml) (updatePayload = updatePayload || []).push(propKey, nextHtml);
                }
            } else if (propKey === CHILDREN) {
                if (lastProp !== nextProp && (typeof nextProp === "string" || typeof nextProp === "number")) (updatePayload = updatePayload || []).push(propKey, "" + nextProp);
            } else if (propKey === SUPPRESS_CONTENT_EDITABLE_WARNING || propKey === SUPPRESS_HYDRATION_WARNING) ;
            else if (registrationNameModules.hasOwnProperty(propKey)) {
                if (nextProp != null) {
                    // We eagerly listen to this even though we haven't committed yet.
                    if (typeof nextProp !== "function") warnForInvalidEventListener(propKey, nextProp);
                    ensureListeningTo(rootContainerElement, propKey);
                }
                if (!updatePayload && lastProp !== nextProp) // This is a special case. If any listener updates we need to ensure
                // that the "current" props pointer gets updated so we need a commit
                // to update this element.
                updatePayload = [];
            } else // For any other property we always add it to the queue and then we
            // filter it out using the whitelist during the commit.
            (updatePayload = updatePayload || []).push(propKey, nextProp);
        }
        if (styleUpdates) {
            validateShorthandPropertyCollisionInDev(styleUpdates, nextProps[STYLE]);
            (updatePayload = updatePayload || []).push(STYLE, styleUpdates);
        }
        return updatePayload;
    } // Apply the diff.
    function updateProperties(domElement, updatePayload, tag, lastRawProps, nextRawProps) {
        // Update checked *before* name.
        // In the middle of an update, it is possible to have multiple checked.
        // When a checked radio tries to change name, browser makes another radio's checked false.
        if (tag === "input" && nextRawProps.type === "radio" && nextRawProps.name != null) updateChecked(domElement, nextRawProps);
        var wasCustomComponentTag = isCustomComponent(tag, lastRawProps);
        var isCustomComponentTag = isCustomComponent(tag, nextRawProps); // Apply the diff.
        updateDOMProperties(domElement, updatePayload, wasCustomComponentTag, isCustomComponentTag); // TODO: Ensure that an update gets scheduled if any of the special props
        // changed.
        switch(tag){
            case "input":
                // Update the wrapper around inputs *after* updating props. This has to
                // happen after `updateDOMProperties`. Otherwise HTML5 input validations
                // raise warnings and prevent the new value from being assigned.
                updateWrapper(domElement, nextRawProps);
                break;
            case "textarea":
                updateWrapper$1(domElement, nextRawProps);
                break;
            case "select":
                // <select> value update needs to occur after <option> children
                // reconciliation
                postUpdateWrapper(domElement, nextRawProps);
                break;
        }
    }
    function getPossibleStandardName(propName) {
        var lowerCasedName = propName.toLowerCase();
        if (!possibleStandardNames.hasOwnProperty(lowerCasedName)) return null;
        return possibleStandardNames[lowerCasedName] || null;
    }
    function diffHydratedProperties(domElement, tag, rawProps, parentNamespace, rootContainerElement) {
        var isCustomComponentTag;
        var extraAttributeNames;
        suppressHydrationWarning = rawProps[SUPPRESS_HYDRATION_WARNING] === true;
        isCustomComponentTag = isCustomComponent(tag, rawProps);
        validatePropertiesInDevelopment(tag, rawProps);
        switch(tag){
            case "iframe":
            case "object":
            case "embed":
                trapBubbledEvent(TOP_LOAD, domElement);
                break;
            case "video":
            case "audio":
                // Create listener for each media event
                for(var i = 0; i < mediaEventTypes.length; i++)trapBubbledEvent(mediaEventTypes[i], domElement);
                break;
            case "source":
                trapBubbledEvent(TOP_ERROR, domElement);
                break;
            case "img":
            case "image":
            case "link":
                trapBubbledEvent(TOP_ERROR, domElement);
                trapBubbledEvent(TOP_LOAD, domElement);
                break;
            case "form":
                trapBubbledEvent(TOP_RESET, domElement);
                trapBubbledEvent(TOP_SUBMIT, domElement);
                break;
            case "details":
                trapBubbledEvent(TOP_TOGGLE, domElement);
                break;
            case "input":
                initWrapperState(domElement, rawProps);
                trapBubbledEvent(TOP_INVALID, domElement); // For controlled components we always need to ensure we're listening
                // to onChange. Even if there is no listener.
                ensureListeningTo(rootContainerElement, "onChange");
                break;
            case "option":
                validateProps(domElement, rawProps);
                break;
            case "select":
                initWrapperState$1(domElement, rawProps);
                trapBubbledEvent(TOP_INVALID, domElement); // For controlled components we always need to ensure we're listening
                // to onChange. Even if there is no listener.
                ensureListeningTo(rootContainerElement, "onChange");
                break;
            case "textarea":
                initWrapperState$2(domElement, rawProps);
                trapBubbledEvent(TOP_INVALID, domElement); // For controlled components we always need to ensure we're listening
                // to onChange. Even if there is no listener.
                ensureListeningTo(rootContainerElement, "onChange");
                break;
        }
        assertValidProps(tag, rawProps);
        extraAttributeNames = new Set();
        var attributes = domElement.attributes;
        for(var _i = 0; _i < attributes.length; _i++){
            var name = attributes[_i].name.toLowerCase();
            switch(name){
                // Built-in SSR attribute is whitelisted
                case "data-reactroot":
                    break;
                // Controlled attributes are not validated
                // TODO: Only ignore them on controlled tags.
                case "value":
                    break;
                case "checked":
                    break;
                case "selected":
                    break;
                default:
                    // Intentionally use the original name.
                    // See discussion in https://github.com/facebook/react/pull/10676.
                    extraAttributeNames.add(attributes[_i].name);
            }
        }
        var updatePayload = null;
        for(var propKey in rawProps){
            if (!rawProps.hasOwnProperty(propKey)) continue;
            var nextProp = rawProps[propKey];
            if (propKey === CHILDREN) {
                // For text content children we compare against textContent. This
                // might match additional HTML that is hidden when we read it using
                // textContent. E.g. "foo" will match "f<span>oo</span>" but that still
                // satisfies our requirement. Our requirement is not to produce perfect
                // HTML and attributes. Ideally we should preserve structure but it's
                // ok not to if the visible content is still enough to indicate what
                // even listeners these nodes might be wired up to.
                // TODO: Warn if there is more than a single textNode as a child.
                // TODO: Should we use domElement.firstChild.nodeValue to compare?
                if (typeof nextProp === "string") {
                    if (domElement.textContent !== nextProp) {
                        if (!suppressHydrationWarning) warnForTextDifference(domElement.textContent, nextProp);
                        updatePayload = [
                            CHILDREN,
                            nextProp
                        ];
                    }
                } else if (typeof nextProp === "number") {
                    if (domElement.textContent !== "" + nextProp) {
                        if (!suppressHydrationWarning) warnForTextDifference(domElement.textContent, nextProp);
                        updatePayload = [
                            CHILDREN,
                            "" + nextProp
                        ];
                    }
                }
            } else if (registrationNameModules.hasOwnProperty(propKey)) {
                if (nextProp != null) {
                    if (typeof nextProp !== "function") warnForInvalidEventListener(propKey, nextProp);
                    ensureListeningTo(rootContainerElement, propKey);
                }
            } else if (typeof isCustomComponentTag === "boolean") {
                // Validate that the properties correspond to their expected values.
                var serverValue = void 0;
                var propertyInfo = getPropertyInfo(propKey);
                if (suppressHydrationWarning) ;
                else if (propKey === SUPPRESS_CONTENT_EDITABLE_WARNING || propKey === SUPPRESS_HYDRATION_WARNING || // Controlled attributes are not validated
                // TODO: Only ignore them on controlled tags.
                propKey === "value" || propKey === "checked" || propKey === "selected") ;
                else if (propKey === DANGEROUSLY_SET_INNER_HTML) {
                    var serverHTML = domElement.innerHTML;
                    var nextHtml = nextProp ? nextProp[HTML$1] : undefined;
                    var expectedHTML = normalizeHTML(domElement, nextHtml != null ? nextHtml : "");
                    if (expectedHTML !== serverHTML) warnForPropDifference(propKey, serverHTML, expectedHTML);
                } else if (propKey === STYLE) {
                    // $FlowFixMe - Should be inferred as not undefined.
                    extraAttributeNames.delete(propKey);
                    if (canDiffStyleForHydrationWarning) {
                        var expectedStyle = createDangerousStringForStyles(nextProp);
                        serverValue = domElement.getAttribute("style");
                        if (expectedStyle !== serverValue) warnForPropDifference(propKey, serverValue, expectedStyle);
                    }
                } else if (isCustomComponentTag) {
                    // $FlowFixMe - Should be inferred as not undefined.
                    extraAttributeNames.delete(propKey.toLowerCase());
                    serverValue = getValueForAttribute(domElement, propKey, nextProp);
                    if (nextProp !== serverValue) warnForPropDifference(propKey, serverValue, nextProp);
                } else if (!shouldIgnoreAttribute(propKey, propertyInfo, isCustomComponentTag) && !shouldRemoveAttribute(propKey, nextProp, propertyInfo, isCustomComponentTag)) {
                    var isMismatchDueToBadCasing = false;
                    if (propertyInfo !== null) {
                        // $FlowFixMe - Should be inferred as not undefined.
                        extraAttributeNames.delete(propertyInfo.attributeName);
                        serverValue = getValueForProperty(domElement, propKey, nextProp, propertyInfo);
                    } else {
                        var ownNamespace = parentNamespace;
                        if (ownNamespace === HTML_NAMESPACE$1) ownNamespace = getIntrinsicNamespace(tag);
                        if (ownNamespace === HTML_NAMESPACE$1) // $FlowFixMe - Should be inferred as not undefined.
                        extraAttributeNames.delete(propKey.toLowerCase());
                        else {
                            var standardName = getPossibleStandardName(propKey);
                            if (standardName !== null && standardName !== propKey) {
                                // If an SVG prop is supplied with bad casing, it will
                                // be successfully parsed from HTML, but will produce a mismatch
                                // (and would be incorrectly rendered on the client).
                                // However, we already warn about bad casing elsewhere.
                                // So we'll skip the misleading extra mismatch warning in this case.
                                isMismatchDueToBadCasing = true; // $FlowFixMe - Should be inferred as not undefined.
                                extraAttributeNames.delete(standardName);
                            } // $FlowFixMe - Should be inferred as not undefined.
                            extraAttributeNames.delete(propKey);
                        }
                        serverValue = getValueForAttribute(domElement, propKey, nextProp);
                    }
                    if (nextProp !== serverValue && !isMismatchDueToBadCasing) warnForPropDifference(propKey, serverValue, nextProp);
                }
            }
        }
        // $FlowFixMe - Should be inferred as not undefined.
        if (extraAttributeNames.size > 0 && !suppressHydrationWarning) // $FlowFixMe - Should be inferred as not undefined.
        warnForExtraAttributes(extraAttributeNames);
        switch(tag){
            case "input":
                // TODO: Make sure we check if this is still unmounted or do any clean
                // up necessary since we never stop tracking anymore.
                track(domElement);
                postMountWrapper(domElement, rawProps, true);
                break;
            case "textarea":
                // TODO: Make sure we check if this is still unmounted or do any clean
                // up necessary since we never stop tracking anymore.
                track(domElement);
                postMountWrapper$3(domElement);
                break;
            case "select":
            case "option":
                break;
            default:
                if (typeof rawProps.onClick === "function") // TODO: This cast may not be sound for SVG, MathML or custom elements.
                trapClickOnNonInteractiveElement(domElement);
                break;
        }
        return updatePayload;
    }
    function diffHydratedText(textNode, text) {
        var isDifferent = textNode.nodeValue !== text;
        return isDifferent;
    }
    function warnForUnmatchedText(textNode, text) {
        warnForTextDifference(textNode.nodeValue, text);
    }
    function warnForDeletedHydratableElement(parentNode, child) {
        if (didWarnInvalidHydration) return;
        didWarnInvalidHydration = true;
        error("Did not expect server HTML to contain a <%s> in <%s>.", child.nodeName.toLowerCase(), parentNode.nodeName.toLowerCase());
    }
    function warnForDeletedHydratableText(parentNode, child) {
        if (didWarnInvalidHydration) return;
        didWarnInvalidHydration = true;
        error('Did not expect server HTML to contain the text node "%s" in <%s>.', child.nodeValue, parentNode.nodeName.toLowerCase());
    }
    function warnForInsertedHydratedElement(parentNode, tag, props) {
        if (didWarnInvalidHydration) return;
        didWarnInvalidHydration = true;
        error("Expected server HTML to contain a matching <%s> in <%s>.", tag, parentNode.nodeName.toLowerCase());
    }
    function warnForInsertedHydratedText(parentNode, text) {
        if (text === "") // We expect to insert empty text nodes since they're not represented in
        // the HTML.
        // TODO: Remove this special case if we can just avoid inserting empty
        // text nodes.
        return;
        if (didWarnInvalidHydration) return;
        didWarnInvalidHydration = true;
        error('Expected server HTML to contain a matching text node for "%s" in <%s>.', text, parentNode.nodeName.toLowerCase());
    }
    function restoreControlledState$3(domElement, tag, props) {
        switch(tag){
            case "input":
                restoreControlledState(domElement, props);
                return;
            case "textarea":
                restoreControlledState$2(domElement, props);
                return;
            case "select":
                restoreControlledState$1(domElement, props);
                return;
        }
    }
    function getActiveElement(doc) {
        doc = doc || (typeof document !== "undefined" ? document : undefined);
        if (typeof doc === "undefined") return null;
        try {
            return doc.activeElement || doc.body;
        } catch (e) {
            return doc.body;
        }
    }
    /**
 * Given any node return the first leaf node without children.
 *
 * @param {DOMElement|DOMTextNode} node
 * @return {DOMElement|DOMTextNode}
 */ function getLeafNode(node) {
        while(node && node.firstChild)node = node.firstChild;
        return node;
    }
    /**
 * Get the next sibling within a container. This will walk up the
 * DOM if a node's siblings have been exhausted.
 *
 * @param {DOMElement|DOMTextNode} node
 * @return {?DOMElement|DOMTextNode}
 */ function getSiblingNode(node) {
        while(node){
            if (node.nextSibling) return node.nextSibling;
            node = node.parentNode;
        }
    }
    /**
 * Get object describing the nodes which contain characters at offset.
 *
 * @param {DOMElement|DOMTextNode} root
 * @param {number} offset
 * @return {?object}
 */ function getNodeForCharacterOffset(root, offset) {
        var node = getLeafNode(root);
        var nodeStart = 0;
        var nodeEnd = 0;
        while(node){
            if (node.nodeType === TEXT_NODE) {
                nodeEnd = nodeStart + node.textContent.length;
                if (nodeStart <= offset && nodeEnd >= offset) return {
                    node: node,
                    offset: offset - nodeStart
                };
                nodeStart = nodeEnd;
            }
            node = getLeafNode(getSiblingNode(node));
        }
    }
    /**
 * @param {DOMElement} outerNode
 * @return {?object}
 */ function getOffsets(outerNode) {
        var ownerDocument = outerNode.ownerDocument;
        var win = ownerDocument && ownerDocument.defaultView || window;
        var selection = win.getSelection && win.getSelection();
        if (!selection || selection.rangeCount === 0) return null;
        var anchorNode = selection.anchorNode, anchorOffset = selection.anchorOffset, focusNode = selection.focusNode, focusOffset = selection.focusOffset; // In Firefox, anchorNode and focusNode can be "anonymous divs", e.g. the
        // up/down buttons on an <input type="number">. Anonymous divs do not seem to
        // expose properties, triggering a "Permission denied error" if any of its
        // properties are accessed. The only seemingly possible way to avoid erroring
        // is to access a property that typically works for non-anonymous divs and
        // catch any error that may otherwise arise. See
        // https://bugzilla.mozilla.org/show_bug.cgi?id=208427
        try {
            /* eslint-disable no-unused-expressions */ anchorNode.nodeType;
            focusNode.nodeType;
        /* eslint-enable no-unused-expressions */ } catch (e) {
            return null;
        }
        return getModernOffsetsFromPoints(outerNode, anchorNode, anchorOffset, focusNode, focusOffset);
    }
    /**
 * Returns {start, end} where `start` is the character/codepoint index of
 * (anchorNode, anchorOffset) within the textContent of `outerNode`, and
 * `end` is the index of (focusNode, focusOffset).
 *
 * Returns null if you pass in garbage input but we should probably just crash.
 *
 * Exported only for testing.
 */ function getModernOffsetsFromPoints(outerNode, anchorNode, anchorOffset, focusNode, focusOffset) {
        var length = 0;
        var start = -1;
        var end = -1;
        var indexWithinAnchor = 0;
        var indexWithinFocus = 0;
        var node = outerNode;
        var parentNode = null;
        outer: while(true){
            var next = null;
            while(true){
                if (node === anchorNode && (anchorOffset === 0 || node.nodeType === TEXT_NODE)) start = length + anchorOffset;
                if (node === focusNode && (focusOffset === 0 || node.nodeType === TEXT_NODE)) end = length + focusOffset;
                if (node.nodeType === TEXT_NODE) length += node.nodeValue.length;
                if ((next = node.firstChild) === null) break;
                 // Moving from `node` to its first child `next`.
                parentNode = node;
                node = next;
            }
            while(true){
                if (node === outerNode) break outer;
                if (parentNode === anchorNode && ++indexWithinAnchor === anchorOffset) start = length;
                if (parentNode === focusNode && ++indexWithinFocus === focusOffset) end = length;
                if ((next = node.nextSibling) !== null) break;
                node = parentNode;
                parentNode = node.parentNode;
            } // Moving from `node` to its next sibling `next`.
            node = next;
        }
        if (start === -1 || end === -1) // This should never happen. (Would happen if the anchor/focus nodes aren't
        // actually inside the passed-in node.)
        return null;
        return {
            start: start,
            end: end
        };
    }
    /**
 * In modern non-IE browsers, we can support both forward and backward
 * selections.
 *
 * Note: IE10+ supports the Selection object, but it does not support
 * the `extend` method, which means that even in modern IE, it's not possible
 * to programmatically create a backward selection. Thus, for all IE
 * versions, we use the old IE API to create our selections.
 *
 * @param {DOMElement|DOMTextNode} node
 * @param {object} offsets
 */ function setOffsets(node, offsets) {
        var doc = node.ownerDocument || document;
        var win = doc && doc.defaultView || window; // Edge fails with "Object expected" in some scenarios.
        // (For instance: TinyMCE editor used in a list component that supports pasting to add more,
        // fails when pasting 100+ items)
        if (!win.getSelection) return;
        var selection = win.getSelection();
        var length = node.textContent.length;
        var start = Math.min(offsets.start, length);
        var end = offsets.end === undefined ? start : Math.min(offsets.end, length); // IE 11 uses modern selection, but doesn't support the extend method.
        // Flip backward selections, so we can set with a single range.
        if (!selection.extend && start > end) {
            var temp = end;
            end = start;
            start = temp;
        }
        var startMarker = getNodeForCharacterOffset(node, start);
        var endMarker = getNodeForCharacterOffset(node, end);
        if (startMarker && endMarker) {
            if (selection.rangeCount === 1 && selection.anchorNode === startMarker.node && selection.anchorOffset === startMarker.offset && selection.focusNode === endMarker.node && selection.focusOffset === endMarker.offset) return;
            var range = doc.createRange();
            range.setStart(startMarker.node, startMarker.offset);
            selection.removeAllRanges();
            if (start > end) {
                selection.addRange(range);
                selection.extend(endMarker.node, endMarker.offset);
            } else {
                range.setEnd(endMarker.node, endMarker.offset);
                selection.addRange(range);
            }
        }
    }
    function isTextNode(node) {
        return node && node.nodeType === TEXT_NODE;
    }
    function containsNode(outerNode, innerNode) {
        if (!outerNode || !innerNode) return false;
        else if (outerNode === innerNode) return true;
        else if (isTextNode(outerNode)) return false;
        else if (isTextNode(innerNode)) return containsNode(outerNode, innerNode.parentNode);
        else if ("contains" in outerNode) return outerNode.contains(innerNode);
        else if (outerNode.compareDocumentPosition) return !!(outerNode.compareDocumentPosition(innerNode) & 16);
        else return false;
    }
    function isInDocument(node) {
        return node && node.ownerDocument && containsNode(node.ownerDocument.documentElement, node);
    }
    function isSameOriginFrame(iframe) {
        try {
            // Accessing the contentDocument of a HTMLIframeElement can cause the browser
            // to throw, e.g. if it has a cross-origin src attribute.
            // Safari will show an error in the console when the access results in "Blocked a frame with origin". e.g:
            // iframe.contentDocument.defaultView;
            // A safety way is to access one of the cross origin properties: Window or Location
            // Which might result in "SecurityError" DOM Exception and it is compatible to Safari.
            // https://html.spec.whatwg.org/multipage/browsers.html#integration-with-idl
            return typeof iframe.contentWindow.location.href === "string";
        } catch (err) {
            return false;
        }
    }
    function getActiveElementDeep() {
        var win = window;
        var element = getActiveElement();
        while(element instanceof win.HTMLIFrameElement){
            if (isSameOriginFrame(element)) win = element.contentWindow;
            else return element;
            element = getActiveElement(win.document);
        }
        return element;
    }
    /**
 * @ReactInputSelection: React input selection module. Based on Selection.js,
 * but modified to be suitable for react and has a couple of bug fixes (doesn't
 * assume buttons have range selections allowed).
 * Input selection module for React.
 */ /**
 * @hasSelectionCapabilities: we get the element types that support selection
 * from https://html.spec.whatwg.org/#do-not-apply, looking at `selectionStart`
 * and `selectionEnd` rows.
 */ function hasSelectionCapabilities(elem) {
        var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
        return nodeName && (nodeName === "input" && (elem.type === "text" || elem.type === "search" || elem.type === "tel" || elem.type === "url" || elem.type === "password") || nodeName === "textarea" || elem.contentEditable === "true");
    }
    function getSelectionInformation() {
        var focusedElem = getActiveElementDeep();
        return {
            // Used by Flare
            activeElementDetached: null,
            focusedElem: focusedElem,
            selectionRange: hasSelectionCapabilities(focusedElem) ? getSelection(focusedElem) : null
        };
    }
    /**
 * @restoreSelection: If any selection information was potentially lost,
 * restore it. This is useful when performing operations that could remove dom
 * nodes and place them back in, resulting in focus being lost.
 */ function restoreSelection(priorSelectionInformation) {
        var curFocusedElem = getActiveElementDeep();
        var priorFocusedElem = priorSelectionInformation.focusedElem;
        var priorSelectionRange = priorSelectionInformation.selectionRange;
        if (curFocusedElem !== priorFocusedElem && isInDocument(priorFocusedElem)) {
            if (priorSelectionRange !== null && hasSelectionCapabilities(priorFocusedElem)) setSelection(priorFocusedElem, priorSelectionRange);
             // Focusing a node can change the scroll position, which is undesirable
            var ancestors = [];
            var ancestor = priorFocusedElem;
            while(ancestor = ancestor.parentNode)if (ancestor.nodeType === ELEMENT_NODE) ancestors.push({
                element: ancestor,
                left: ancestor.scrollLeft,
                top: ancestor.scrollTop
            });
            if (typeof priorFocusedElem.focus === "function") priorFocusedElem.focus();
            for(var i = 0; i < ancestors.length; i++){
                var info = ancestors[i];
                info.element.scrollLeft = info.left;
                info.element.scrollTop = info.top;
            }
        }
    }
    /**
 * @getSelection: Gets the selection bounds of a focused textarea, input or
 * contentEditable node.
 * -@input: Look up selection bounds of this input
 * -@return {start: selectionStart, end: selectionEnd}
 */ function getSelection(input) {
        var selection;
        if ("selectionStart" in input) // Modern browser with input or textarea.
        selection = {
            start: input.selectionStart,
            end: input.selectionEnd
        };
        else // Content editable or old IE textarea.
        selection = getOffsets(input);
        return selection || {
            start: 0,
            end: 0
        };
    }
    /**
 * @setSelection: Sets the selection bounds of a textarea or input and focuses
 * the input.
 * -@input     Set selection bounds of this input or textarea
 * -@offsets   Object of same form that is returned from get*
 */ function setSelection(input, offsets) {
        var start = offsets.start, end = offsets.end;
        if (end === undefined) end = start;
        if ("selectionStart" in input) {
            input.selectionStart = start;
            input.selectionEnd = Math.min(end, input.value.length);
        } else setOffsets(input, offsets);
    }
    var validateDOMNesting = function() {};
    var updatedAncestorInfo = function() {};
    // This validation code was written based on the HTML5 parsing spec:
    // https://html.spec.whatwg.org/multipage/syntax.html#has-an-element-in-scope
    //
    // Note: this does not catch all invalid nesting, nor does it try to (as it's
    // not clear what practical benefit doing so provides); instead, we warn only
    // for cases where the parser will give a parse tree differing from what React
    // intended. For example, <b><div></div></b> is invalid but we don't warn
    // because it still parses correctly; we do warn for other cases like nested
    // <p> tags where the beginning of the second element implicitly closes the
    // first, causing a confusing mess.
    // https://html.spec.whatwg.org/multipage/syntax.html#special
    var specialTags = [
        "address",
        "applet",
        "area",
        "article",
        "aside",
        "base",
        "basefont",
        "bgsound",
        "blockquote",
        "body",
        "br",
        "button",
        "caption",
        "center",
        "col",
        "colgroup",
        "dd",
        "details",
        "dir",
        "div",
        "dl",
        "dt",
        "embed",
        "fieldset",
        "figcaption",
        "figure",
        "footer",
        "form",
        "frame",
        "frameset",
        "h1",
        "h2",
        "h3",
        "h4",
        "h5",
        "h6",
        "head",
        "header",
        "hgroup",
        "hr",
        "html",
        "iframe",
        "img",
        "input",
        "isindex",
        "li",
        "link",
        "listing",
        "main",
        "marquee",
        "menu",
        "menuitem",
        "meta",
        "nav",
        "noembed",
        "noframes",
        "noscript",
        "object",
        "ol",
        "p",
        "param",
        "plaintext",
        "pre",
        "script",
        "section",
        "select",
        "source",
        "style",
        "summary",
        "table",
        "tbody",
        "td",
        "template",
        "textarea",
        "tfoot",
        "th",
        "thead",
        "title",
        "tr",
        "track",
        "ul",
        "wbr",
        "xmp"
    ]; // https://html.spec.whatwg.org/multipage/syntax.html#has-an-element-in-scope
    var inScopeTags = [
        "applet",
        "caption",
        "html",
        "table",
        "td",
        "th",
        "marquee",
        "object",
        "template",
        // TODO: Distinguish by namespace here -- for <title>, including it here
        // errs on the side of fewer warnings
        "foreignObject",
        "desc",
        "title"
    ]; // https://html.spec.whatwg.org/multipage/syntax.html#has-an-element-in-button-scope
    var buttonScopeTags = inScopeTags.concat([
        "button"
    ]); // https://html.spec.whatwg.org/multipage/syntax.html#generate-implied-end-tags
    var impliedEndTags = [
        "dd",
        "dt",
        "li",
        "option",
        "optgroup",
        "p",
        "rp",
        "rt"
    ];
    var emptyAncestorInfo = {
        current: null,
        formTag: null,
        aTagInScope: null,
        buttonTagInScope: null,
        nobrTagInScope: null,
        pTagInButtonScope: null,
        listItemTagAutoclosing: null,
        dlItemTagAutoclosing: null
    };
    updatedAncestorInfo = function(oldInfo, tag) {
        var ancestorInfo = _assign({}, oldInfo || emptyAncestorInfo);
        var info = {
            tag: tag
        };
        if (inScopeTags.indexOf(tag) !== -1) {
            ancestorInfo.aTagInScope = null;
            ancestorInfo.buttonTagInScope = null;
            ancestorInfo.nobrTagInScope = null;
        }
        if (buttonScopeTags.indexOf(tag) !== -1) ancestorInfo.pTagInButtonScope = null;
         // See rules for 'li', 'dd', 'dt' start tags in
        // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inbody
        if (specialTags.indexOf(tag) !== -1 && tag !== "address" && tag !== "div" && tag !== "p") {
            ancestorInfo.listItemTagAutoclosing = null;
            ancestorInfo.dlItemTagAutoclosing = null;
        }
        ancestorInfo.current = info;
        if (tag === "form") ancestorInfo.formTag = info;
        if (tag === "a") ancestorInfo.aTagInScope = info;
        if (tag === "button") ancestorInfo.buttonTagInScope = info;
        if (tag === "nobr") ancestorInfo.nobrTagInScope = info;
        if (tag === "p") ancestorInfo.pTagInButtonScope = info;
        if (tag === "li") ancestorInfo.listItemTagAutoclosing = info;
        if (tag === "dd" || tag === "dt") ancestorInfo.dlItemTagAutoclosing = info;
        return ancestorInfo;
    };
    /**
   * Returns whether
   */ var isTagValidWithParent = function(tag, parentTag) {
        // First, let's check if we're in an unusual parsing mode...
        switch(parentTag){
            // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inselect
            case "select":
                return tag === "option" || tag === "optgroup" || tag === "#text";
            case "optgroup":
                return tag === "option" || tag === "#text";
            // Strictly speaking, seeing an <option> doesn't mean we're in a <select>
            // but
            case "option":
                return tag === "#text";
            // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intd
            // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-incaption
            // No special behavior since these rules fall back to "in body" mode for
            // all except special table nodes which cause bad parsing behavior anyway.
            // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intr
            case "tr":
                return tag === "th" || tag === "td" || tag === "style" || tag === "script" || tag === "template";
            // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intbody
            case "tbody":
            case "thead":
            case "tfoot":
                return tag === "tr" || tag === "style" || tag === "script" || tag === "template";
            // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-incolgroup
            case "colgroup":
                return tag === "col" || tag === "template";
            // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intable
            case "table":
                return tag === "caption" || tag === "colgroup" || tag === "tbody" || tag === "tfoot" || tag === "thead" || tag === "style" || tag === "script" || tag === "template";
            // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inhead
            case "head":
                return tag === "base" || tag === "basefont" || tag === "bgsound" || tag === "link" || tag === "meta" || tag === "title" || tag === "noscript" || tag === "noframes" || tag === "style" || tag === "script" || tag === "template";
            // https://html.spec.whatwg.org/multipage/semantics.html#the-html-element
            case "html":
                return tag === "head" || tag === "body" || tag === "frameset";
            case "frameset":
                return tag === "frame";
            case "#document":
                return tag === "html";
        } // Probably in the "in body" parsing mode, so we outlaw only tag combos
        // where the parsing rules cause implicit opens or closes to be added.
        // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inbody
        switch(tag){
            case "h1":
            case "h2":
            case "h3":
            case "h4":
            case "h5":
            case "h6":
                return parentTag !== "h1" && parentTag !== "h2" && parentTag !== "h3" && parentTag !== "h4" && parentTag !== "h5" && parentTag !== "h6";
            case "rp":
            case "rt":
                return impliedEndTags.indexOf(parentTag) === -1;
            case "body":
            case "caption":
            case "col":
            case "colgroup":
            case "frameset":
            case "frame":
            case "head":
            case "html":
            case "tbody":
            case "td":
            case "tfoot":
            case "th":
            case "thead":
            case "tr":
                // These tags are only valid with a few parents that have special child
                // parsing rules -- if we're down here, then none of those matched and
                // so we allow it only if we don't know what the parent is, as all other
                // cases are invalid.
                return parentTag == null;
        }
        return true;
    };
    /**
   * Returns whether
   */ var findInvalidAncestorForTag = function(tag, ancestorInfo) {
        switch(tag){
            case "address":
            case "article":
            case "aside":
            case "blockquote":
            case "center":
            case "details":
            case "dialog":
            case "dir":
            case "div":
            case "dl":
            case "fieldset":
            case "figcaption":
            case "figure":
            case "footer":
            case "header":
            case "hgroup":
            case "main":
            case "menu":
            case "nav":
            case "ol":
            case "p":
            case "section":
            case "summary":
            case "ul":
            case "pre":
            case "listing":
            case "table":
            case "hr":
            case "xmp":
            case "h1":
            case "h2":
            case "h3":
            case "h4":
            case "h5":
            case "h6":
                return ancestorInfo.pTagInButtonScope;
            case "form":
                return ancestorInfo.formTag || ancestorInfo.pTagInButtonScope;
            case "li":
                return ancestorInfo.listItemTagAutoclosing;
            case "dd":
            case "dt":
                return ancestorInfo.dlItemTagAutoclosing;
            case "button":
                return ancestorInfo.buttonTagInScope;
            case "a":
                // Spec says something about storing a list of markers, but it sounds
                // equivalent to this check.
                return ancestorInfo.aTagInScope;
            case "nobr":
                return ancestorInfo.nobrTagInScope;
        }
        return null;
    };
    var didWarn$1 = {};
    validateDOMNesting = function(childTag, childText, ancestorInfo) {
        ancestorInfo = ancestorInfo || emptyAncestorInfo;
        var parentInfo = ancestorInfo.current;
        var parentTag = parentInfo && parentInfo.tag;
        if (childText != null) {
            if (childTag != null) error("validateDOMNesting: when childText is passed, childTag should be null");
            childTag = "#text";
        }
        var invalidParent = isTagValidWithParent(childTag, parentTag) ? null : parentInfo;
        var invalidAncestor = invalidParent ? null : findInvalidAncestorForTag(childTag, ancestorInfo);
        var invalidParentOrAncestor = invalidParent || invalidAncestor;
        if (!invalidParentOrAncestor) return;
        var ancestorTag = invalidParentOrAncestor.tag;
        var addendum = getCurrentFiberStackInDev();
        var warnKey = !!invalidParent + "|" + childTag + "|" + ancestorTag + "|" + addendum;
        if (didWarn$1[warnKey]) return;
        didWarn$1[warnKey] = true;
        var tagDisplayName = childTag;
        var whitespaceInfo = "";
        if (childTag === "#text") {
            if (/\S/.test(childText)) tagDisplayName = "Text nodes";
            else {
                tagDisplayName = "Whitespace text nodes";
                whitespaceInfo = " Make sure you don't have any extra whitespace between tags on each line of your source code.";
            }
        } else tagDisplayName = "<" + childTag + ">";
        if (invalidParent) {
            var info = "";
            if (ancestorTag === "table" && childTag === "tr") info += " Add a <tbody>, <thead> or <tfoot> to your code to match the DOM tree generated by the browser.";
            error("validateDOMNesting(...): %s cannot appear as a child of <%s>.%s%s", tagDisplayName, ancestorTag, whitespaceInfo, info);
        } else error("validateDOMNesting(...): %s cannot appear as a descendant of <%s>.", tagDisplayName, ancestorTag);
    };
    var SUPPRESS_HYDRATION_WARNING$1;
    SUPPRESS_HYDRATION_WARNING$1 = "suppressHydrationWarning";
    var SUSPENSE_START_DATA = "$";
    var SUSPENSE_END_DATA = "/$";
    var SUSPENSE_PENDING_START_DATA = "$?";
    var SUSPENSE_FALLBACK_START_DATA = "$!";
    var STYLE$1 = "style";
    var eventsEnabled = null;
    var selectionInformation = null;
    function shouldAutoFocusHostComponent(type, props) {
        switch(type){
            case "button":
            case "input":
            case "select":
            case "textarea":
                return !!props.autoFocus;
        }
        return false;
    }
    function getRootHostContext(rootContainerInstance) {
        var type;
        var namespace;
        var nodeType = rootContainerInstance.nodeType;
        switch(nodeType){
            case DOCUMENT_NODE:
            case DOCUMENT_FRAGMENT_NODE:
                type = nodeType === DOCUMENT_NODE ? "#document" : "#fragment";
                var root = rootContainerInstance.documentElement;
                namespace = root ? root.namespaceURI : getChildNamespace(null, "");
                break;
            default:
                var container = nodeType === COMMENT_NODE ? rootContainerInstance.parentNode : rootContainerInstance;
                var ownNamespace = container.namespaceURI || null;
                type = container.tagName;
                namespace = getChildNamespace(ownNamespace, type);
                break;
        }
        var validatedTag = type.toLowerCase();
        var ancestorInfo = updatedAncestorInfo(null, validatedTag);
        return {
            namespace: namespace,
            ancestorInfo: ancestorInfo
        };
    }
    function getChildHostContext(parentHostContext, type, rootContainerInstance) {
        var parentHostContextDev = parentHostContext;
        var namespace = getChildNamespace(parentHostContextDev.namespace, type);
        var ancestorInfo = updatedAncestorInfo(parentHostContextDev.ancestorInfo, type);
        return {
            namespace: namespace,
            ancestorInfo: ancestorInfo
        };
    }
    function getPublicInstance(instance) {
        return instance;
    }
    function prepareForCommit(containerInfo) {
        eventsEnabled = isEnabled();
        selectionInformation = getSelectionInformation();
        setEnabled(false);
    }
    function resetAfterCommit(containerInfo) {
        restoreSelection(selectionInformation);
        setEnabled(eventsEnabled);
        eventsEnabled = null;
        selectionInformation = null;
    }
    function createInstance(type, props, rootContainerInstance, hostContext, internalInstanceHandle) {
        var parentNamespace;
        // TODO: take namespace into account when validating.
        var hostContextDev = hostContext;
        validateDOMNesting(type, null, hostContextDev.ancestorInfo);
        if (typeof props.children === "string" || typeof props.children === "number") {
            var string = "" + props.children;
            var ownAncestorInfo = updatedAncestorInfo(hostContextDev.ancestorInfo, type);
            validateDOMNesting(null, string, ownAncestorInfo);
        }
        parentNamespace = hostContextDev.namespace;
        var domElement = createElement(type, props, rootContainerInstance, parentNamespace);
        precacheFiberNode(internalInstanceHandle, domElement);
        updateFiberProps(domElement, props);
        return domElement;
    }
    function appendInitialChild(parentInstance, child) {
        parentInstance.appendChild(child);
    }
    function finalizeInitialChildren(domElement, type, props, rootContainerInstance, hostContext) {
        setInitialProperties(domElement, type, props, rootContainerInstance);
        return shouldAutoFocusHostComponent(type, props);
    }
    function prepareUpdate(domElement, type, oldProps, newProps, rootContainerInstance, hostContext) {
        var hostContextDev = hostContext;
        if (typeof newProps.children !== typeof oldProps.children && (typeof newProps.children === "string" || typeof newProps.children === "number")) {
            var string = "" + newProps.children;
            var ownAncestorInfo = updatedAncestorInfo(hostContextDev.ancestorInfo, type);
            validateDOMNesting(null, string, ownAncestorInfo);
        }
        return diffProperties(domElement, type, oldProps, newProps, rootContainerInstance);
    }
    function shouldSetTextContent(type, props) {
        return type === "textarea" || type === "option" || type === "noscript" || typeof props.children === "string" || typeof props.children === "number" || typeof props.dangerouslySetInnerHTML === "object" && props.dangerouslySetInnerHTML !== null && props.dangerouslySetInnerHTML.__html != null;
    }
    function shouldDeprioritizeSubtree(type, props) {
        return !!props.hidden;
    }
    function createTextInstance(text, rootContainerInstance, hostContext, internalInstanceHandle) {
        var hostContextDev = hostContext;
        validateDOMNesting(null, text, hostContextDev.ancestorInfo);
        var textNode = createTextNode(text, rootContainerInstance);
        precacheFiberNode(internalInstanceHandle, textNode);
        return textNode;
    }
    // if a component just imports ReactDOM (e.g. for findDOMNode).
    // Some environments might not have setTimeout or clearTimeout.
    var scheduleTimeout = typeof setTimeout === "function" ? setTimeout : undefined;
    var cancelTimeout = typeof clearTimeout === "function" ? clearTimeout : undefined;
    var noTimeout = -1; // -------------------
    function commitMount(domElement, type, newProps, internalInstanceHandle) {
        // Despite the naming that might imply otherwise, this method only
        // fires if there is an `Update` effect scheduled during mounting.
        // This happens if `finalizeInitialChildren` returns `true` (which it
        // does to implement the `autoFocus` attribute on the client). But
        // there are also other cases when this might happen (such as patching
        // up text content during hydration mismatch). So we'll check this again.
        if (shouldAutoFocusHostComponent(type, newProps)) domElement.focus();
    }
    function commitUpdate(domElement, updatePayload, type, oldProps, newProps, internalInstanceHandle) {
        // Update the props handle so that we know which props are the ones with
        // with current event handlers.
        updateFiberProps(domElement, newProps); // Apply the diff to the DOM node.
        updateProperties(domElement, updatePayload, type, oldProps, newProps);
    }
    function resetTextContent(domElement) {
        setTextContent(domElement, "");
    }
    function commitTextUpdate(textInstance, oldText, newText) {
        textInstance.nodeValue = newText;
    }
    function appendChild(parentInstance, child) {
        parentInstance.appendChild(child);
    }
    function appendChildToContainer(container, child) {
        var parentNode;
        if (container.nodeType === COMMENT_NODE) {
            parentNode = container.parentNode;
            parentNode.insertBefore(child, container);
        } else {
            parentNode = container;
            parentNode.appendChild(child);
        } // This container might be used for a portal.
        // If something inside a portal is clicked, that click should bubble
        // through the React tree. However, on Mobile Safari the click would
        // never bubble through the *DOM* tree unless an ancestor with onclick
        // event exists. So we wouldn't see it and dispatch it.
        // This is why we ensure that non React root containers have inline onclick
        // defined.
        // https://github.com/facebook/react/issues/11918
        var reactRootContainer = container._reactRootContainer;
        if ((reactRootContainer === null || reactRootContainer === undefined) && parentNode.onclick === null) // TODO: This cast may not be sound for SVG, MathML or custom elements.
        trapClickOnNonInteractiveElement(parentNode);
    }
    function insertBefore(parentInstance, child, beforeChild) {
        parentInstance.insertBefore(child, beforeChild);
    }
    function insertInContainerBefore(container, child, beforeChild) {
        if (container.nodeType === COMMENT_NODE) container.parentNode.insertBefore(child, beforeChild);
        else container.insertBefore(child, beforeChild);
    }
    function removeChild(parentInstance, child) {
        parentInstance.removeChild(child);
    }
    function removeChildFromContainer(container, child) {
        if (container.nodeType === COMMENT_NODE) container.parentNode.removeChild(child);
        else container.removeChild(child);
    }
    function hideInstance(instance) {
        // pass host context to this method?
        instance;
        var style = instance.style;
        if (typeof style.setProperty === "function") style.setProperty("display", "none", "important");
        else style.display = "none";
    }
    function hideTextInstance(textInstance) {
        textInstance.nodeValue = "";
    }
    function unhideInstance(instance, props) {
        instance;
        var styleProp = props[STYLE$1];
        var display = styleProp !== undefined && styleProp !== null && styleProp.hasOwnProperty("display") ? styleProp.display : null;
        instance.style.display = dangerousStyleValue("display", display);
    }
    function unhideTextInstance(textInstance, text) {
        textInstance.nodeValue = text;
    } // -------------------
    function canHydrateInstance(instance, type, props) {
        if (instance.nodeType !== ELEMENT_NODE || type.toLowerCase() !== instance.nodeName.toLowerCase()) return null;
         // This has now been refined to an element node.
        return instance;
    }
    function canHydrateTextInstance(instance, text) {
        if (text === "" || instance.nodeType !== TEXT_NODE) // Empty strings are not parsed by HTML so there won't be a correct match here.
        return null;
         // This has now been refined to a text node.
        return instance;
    }
    function isSuspenseInstancePending(instance) {
        return instance.data === SUSPENSE_PENDING_START_DATA;
    }
    function isSuspenseInstanceFallback(instance) {
        return instance.data === SUSPENSE_FALLBACK_START_DATA;
    }
    function getNextHydratable(node) {
        // Skip non-hydratable nodes.
        for(; node != null; node = node.nextSibling){
            var nodeType = node.nodeType;
            if (nodeType === ELEMENT_NODE || nodeType === TEXT_NODE) break;
        }
        return node;
    }
    function getNextHydratableSibling(instance) {
        return getNextHydratable(instance.nextSibling);
    }
    function getFirstHydratableChild(parentInstance) {
        return getNextHydratable(parentInstance.firstChild);
    }
    function hydrateInstance(instance, type, props, rootContainerInstance, hostContext, internalInstanceHandle) {
        precacheFiberNode(internalInstanceHandle, instance); // TODO: Possibly defer this until the commit phase where all the events
        // get attached.
        updateFiberProps(instance, props);
        var parentNamespace;
        var hostContextDev = hostContext;
        parentNamespace = hostContextDev.namespace;
        return diffHydratedProperties(instance, type, props, parentNamespace, rootContainerInstance);
    }
    function hydrateTextInstance(textInstance, text, internalInstanceHandle) {
        precacheFiberNode(internalInstanceHandle, textInstance);
        return diffHydratedText(textInstance, text);
    }
    function getNextHydratableInstanceAfterSuspenseInstance(suspenseInstance) {
        var node = suspenseInstance.nextSibling; // Skip past all nodes within this suspense boundary.
        // There might be nested nodes so we need to keep track of how
        // deep we are and only break out when we're back on top.
        var depth = 0;
        while(node){
            if (node.nodeType === COMMENT_NODE) {
                var data = node.data;
                if (data === SUSPENSE_END_DATA) {
                    if (depth === 0) return getNextHydratableSibling(node);
                    else depth--;
                } else if (data === SUSPENSE_START_DATA || data === SUSPENSE_FALLBACK_START_DATA || data === SUSPENSE_PENDING_START_DATA) depth++;
            }
            node = node.nextSibling;
        } // TODO: Warn, we didn't find the end comment boundary.
        return null;
    } // Returns the SuspenseInstance if this node is a direct child of a
    // SuspenseInstance. I.e. if its previous sibling is a Comment with
    // SUSPENSE_x_START_DATA. Otherwise, null.
    function getParentSuspenseInstance(targetInstance) {
        var node = targetInstance.previousSibling; // Skip past all nodes within this suspense boundary.
        // There might be nested nodes so we need to keep track of how
        // deep we are and only break out when we're back on top.
        var depth = 0;
        while(node){
            if (node.nodeType === COMMENT_NODE) {
                var data = node.data;
                if (data === SUSPENSE_START_DATA || data === SUSPENSE_FALLBACK_START_DATA || data === SUSPENSE_PENDING_START_DATA) {
                    if (depth === 0) return node;
                    else depth--;
                } else if (data === SUSPENSE_END_DATA) depth++;
            }
            node = node.previousSibling;
        }
        return null;
    }
    function commitHydratedContainer(container) {
        // Retry if any event replaying was blocked on this.
        retryIfBlockedOn(container);
    }
    function commitHydratedSuspenseInstance(suspenseInstance) {
        // Retry if any event replaying was blocked on this.
        retryIfBlockedOn(suspenseInstance);
    }
    function didNotMatchHydratedContainerTextInstance(parentContainer, textInstance, text) {
        warnForUnmatchedText(textInstance, text);
    }
    function didNotMatchHydratedTextInstance(parentType, parentProps, parentInstance, textInstance, text) {
        if (parentProps[SUPPRESS_HYDRATION_WARNING$1] !== true) warnForUnmatchedText(textInstance, text);
    }
    function didNotHydrateContainerInstance(parentContainer, instance) {
        if (instance.nodeType === ELEMENT_NODE) warnForDeletedHydratableElement(parentContainer, instance);
        else if (instance.nodeType === COMMENT_NODE) ;
        else warnForDeletedHydratableText(parentContainer, instance);
    }
    function didNotHydrateInstance(parentType, parentProps, parentInstance, instance) {
        if (parentProps[SUPPRESS_HYDRATION_WARNING$1] !== true) {
            if (instance.nodeType === ELEMENT_NODE) warnForDeletedHydratableElement(parentInstance, instance);
            else if (instance.nodeType === COMMENT_NODE) ;
            else warnForDeletedHydratableText(parentInstance, instance);
        }
    }
    function didNotFindHydratableContainerInstance(parentContainer, type, props) {
        warnForInsertedHydratedElement(parentContainer, type);
    }
    function didNotFindHydratableContainerTextInstance(parentContainer, text) {
        warnForInsertedHydratedText(parentContainer, text);
    }
    function didNotFindHydratableInstance(parentType, parentProps, parentInstance, type, props) {
        if (parentProps[SUPPRESS_HYDRATION_WARNING$1] !== true) warnForInsertedHydratedElement(parentInstance, type);
    }
    function didNotFindHydratableTextInstance(parentType, parentProps, parentInstance, text) {
        if (parentProps[SUPPRESS_HYDRATION_WARNING$1] !== true) warnForInsertedHydratedText(parentInstance, text);
    }
    function didNotFindHydratableSuspenseInstance(parentType, parentProps, parentInstance) {
        parentProps[SUPPRESS_HYDRATION_WARNING$1];
    }
    var randomKey = Math.random().toString(36).slice(2);
    var internalInstanceKey = "__reactInternalInstance$" + randomKey;
    var internalEventHandlersKey = "__reactEventHandlers$" + randomKey;
    var internalContainerInstanceKey = "__reactContainere$" + randomKey;
    function precacheFiberNode(hostInst, node) {
        node[internalInstanceKey] = hostInst;
    }
    function markContainerAsRoot(hostRoot, node) {
        node[internalContainerInstanceKey] = hostRoot;
    }
    function unmarkContainerAsRoot(node) {
        node[internalContainerInstanceKey] = null;
    }
    function isContainerMarkedAsRoot(node) {
        return !!node[internalContainerInstanceKey];
    } // Given a DOM node, return the closest HostComponent or HostText fiber ancestor.
    // If the target node is part of a hydrated or not yet rendered subtree, then
    // this may also return a SuspenseComponent or HostRoot to indicate that.
    // Conceptually the HostRoot fiber is a child of the Container node. So if you
    // pass the Container node as the targetNode, you will not actually get the
    // HostRoot back. To get to the HostRoot, you need to pass a child of it.
    // The same thing applies to Suspense boundaries.
    function getClosestInstanceFromNode(targetNode) {
        var targetInst = targetNode[internalInstanceKey];
        if (targetInst) // Don't return HostRoot or SuspenseComponent here.
        return targetInst;
         // If the direct event target isn't a React owned DOM node, we need to look
        // to see if one of its parents is a React owned DOM node.
        var parentNode = targetNode.parentNode;
        while(parentNode){
            // We'll check if this is a container root that could include
            // React nodes in the future. We need to check this first because
            // if we're a child of a dehydrated container, we need to first
            // find that inner container before moving on to finding the parent
            // instance. Note that we don't check this field on  the targetNode
            // itself because the fibers are conceptually between the container
            // node and the first child. It isn't surrounding the container node.
            // If it's not a container, we check if it's an instance.
            targetInst = parentNode[internalContainerInstanceKey] || parentNode[internalInstanceKey];
            if (targetInst) {
                // Since this wasn't the direct target of the event, we might have
                // stepped past dehydrated DOM nodes to get here. However they could
                // also have been non-React nodes. We need to answer which one.
                // If we the instance doesn't have any children, then there can't be
                // a nested suspense boundary within it. So we can use this as a fast
                // bailout. Most of the time, when people add non-React children to
                // the tree, it is using a ref to a child-less DOM node.
                // Normally we'd only need to check one of the fibers because if it
                // has ever gone from having children to deleting them or vice versa
                // it would have deleted the dehydrated boundary nested inside already.
                // However, since the HostRoot starts out with an alternate it might
                // have one on the alternate so we need to check in case this was a
                // root.
                var alternate = targetInst.alternate;
                if (targetInst.child !== null || alternate !== null && alternate.child !== null) {
                    // Next we need to figure out if the node that skipped past is
                    // nested within a dehydrated boundary and if so, which one.
                    var suspenseInstance = getParentSuspenseInstance(targetNode);
                    while(suspenseInstance !== null){
                        // We found a suspense instance. That means that we haven't
                        // hydrated it yet. Even though we leave the comments in the
                        // DOM after hydrating, and there are boundaries in the DOM
                        // that could already be hydrated, we wouldn't have found them
                        // through this pass since if the target is hydrated it would
                        // have had an internalInstanceKey on it.
                        // Let's get the fiber associated with the SuspenseComponent
                        // as the deepest instance.
                        var targetSuspenseInst = suspenseInstance[internalInstanceKey];
                        if (targetSuspenseInst) return targetSuspenseInst;
                         // If we don't find a Fiber on the comment, it might be because
                        // we haven't gotten to hydrate it yet. There might still be a
                        // parent boundary that hasn't above this one so we need to find
                        // the outer most that is known.
                        suspenseInstance = getParentSuspenseInstance(suspenseInstance); // If we don't find one, then that should mean that the parent
                    // host component also hasn't hydrated yet. We can return it
                    // below since it will bail out on the isMounted check later.
                    }
                }
                return targetInst;
            }
            targetNode = parentNode;
            parentNode = targetNode.parentNode;
        }
        return null;
    }
    /**
 * Given a DOM node, return the ReactDOMComponent or ReactDOMTextComponent
 * instance, or null if the node was not rendered by this React.
 */ function getInstanceFromNode$1(node) {
        var inst = node[internalInstanceKey] || node[internalContainerInstanceKey];
        if (inst) {
            if (inst.tag === HostComponent || inst.tag === HostText || inst.tag === SuspenseComponent || inst.tag === HostRoot) return inst;
            else return null;
        }
        return null;
    }
    /**
 * Given a ReactDOMComponent or ReactDOMTextComponent, return the corresponding
 * DOM node.
 */ function getNodeFromInstance$1(inst) {
        if (inst.tag === HostComponent || inst.tag === HostText) // In Fiber this, is just the state node right now. We assume it will be
        // a host component or host text.
        return inst.stateNode;
         // Without this first invariant, passing a non-DOM-component triggers the next
        throw Error("getNodeFromInstance: Invalid argument.");
    }
    function getFiberCurrentPropsFromNode$1(node) {
        return node[internalEventHandlersKey] || null;
    }
    function updateFiberProps(node, props) {
        node[internalEventHandlersKey] = props;
    }
    function getParent(inst) {
        do inst = inst.return; // TODO: If this is a HostRoot we might want to bail out.
        while (inst && inst.tag !== HostComponent);
        if (inst) return inst;
        return null;
    }
    /**
 * Return the lowest common ancestor of A and B, or null if they are in
 * different trees.
 */ function getLowestCommonAncestor(instA, instB) {
        var depthA = 0;
        for(var tempA = instA; tempA; tempA = getParent(tempA))depthA++;
        var depthB = 0;
        for(var tempB = instB; tempB; tempB = getParent(tempB))depthB++;
         // If A is deeper, crawl up.
        while(depthA - depthB > 0){
            instA = getParent(instA);
            depthA--;
        } // If B is deeper, crawl up.
        while(depthB - depthA > 0){
            instB = getParent(instB);
            depthB--;
        } // Walk in lockstep until we find a match.
        var depth = depthA;
        while(depth--){
            if (instA === instB || instA === instB.alternate) return instA;
            instA = getParent(instA);
            instB = getParent(instB);
        }
        return null;
    }
    /**
 * Simulates the traversal of a two-phase, capture/bubble event dispatch.
 */ function traverseTwoPhase(inst, fn, arg) {
        var path = [];
        while(inst){
            path.push(inst);
            inst = getParent(inst);
        }
        var i;
        for(i = path.length; i-- > 0;)fn(path[i], "captured", arg);
        for(i = 0; i < path.length; i++)fn(path[i], "bubbled", arg);
    }
    /**
 * Traverses the ID hierarchy and invokes the supplied `cb` on any IDs that
 * should would receive a `mouseEnter` or `mouseLeave` event.
 *
 * Does not invoke the callback on the nearest common ancestor because nothing
 * "entered" or "left" that element.
 */ function traverseEnterLeave(from, to, fn, argFrom, argTo) {
        var common = from && to ? getLowestCommonAncestor(from, to) : null;
        var pathFrom = [];
        while(true){
            if (!from) break;
            if (from === common) break;
            var alternate = from.alternate;
            if (alternate !== null && alternate === common) break;
            pathFrom.push(from);
            from = getParent(from);
        }
        var pathTo = [];
        while(true){
            if (!to) break;
            if (to === common) break;
            var _alternate = to.alternate;
            if (_alternate !== null && _alternate === common) break;
            pathTo.push(to);
            to = getParent(to);
        }
        for(var i = 0; i < pathFrom.length; i++)fn(pathFrom[i], "bubbled", argFrom);
        for(var _i = pathTo.length; _i-- > 0;)fn(pathTo[_i], "captured", argTo);
    }
    function isInteractive(tag) {
        return tag === "button" || tag === "input" || tag === "select" || tag === "textarea";
    }
    function shouldPreventMouseEvent(name, type, props) {
        switch(name){
            case "onClick":
            case "onClickCapture":
            case "onDoubleClick":
            case "onDoubleClickCapture":
            case "onMouseDown":
            case "onMouseDownCapture":
            case "onMouseMove":
            case "onMouseMoveCapture":
            case "onMouseUp":
            case "onMouseUpCapture":
            case "onMouseEnter":
                return !!(props.disabled && isInteractive(type));
            default:
                return false;
        }
    }
    /**
 * @param {object} inst The instance, which is the source of events.
 * @param {string} registrationName Name of listener (e.g. `onClick`).
 * @return {?function} The stored callback.
 */ function getListener(inst, registrationName) {
        var listener; // TODO: shouldPreventMouseEvent is DOM-specific and definitely should not
        // live here; needs to be moved to a better place soon
        var stateNode = inst.stateNode;
        if (!stateNode) // Work in progress (ex: onload events in incremental mode).
        return null;
        var props = getFiberCurrentPropsFromNode(stateNode);
        if (!props) // Work in progress.
        return null;
        listener = props[registrationName];
        if (shouldPreventMouseEvent(registrationName, inst.type, props)) return null;
        if (!(!listener || typeof listener === "function")) throw Error("Expected `" + registrationName + "` listener to be a function, instead got a value of `" + typeof listener + "` type.");
        return listener;
    }
    /**
 * Some event types have a notion of different registration names for different
 * "phases" of propagation. This finds listeners by a given phase.
 */ function listenerAtPhase(inst, event, propagationPhase) {
        var registrationName = event.dispatchConfig.phasedRegistrationNames[propagationPhase];
        return getListener(inst, registrationName);
    }
    /**
 * A small set of propagation patterns, each of which will accept a small amount
 * of information, and generate a set of "dispatch ready event objects" - which
 * are sets of events that have already been annotated with a set of dispatched
 * listener functions/ids. The API is designed this way to discourage these
 * propagation strategies from actually executing the dispatches, since we
 * always want to collect the entire set of dispatches before executing even a
 * single one.
 */ /**
 * Tags a `SyntheticEvent` with dispatched listeners. Creating this function
 * here, allows us to not have to bind or create functions for each event.
 * Mutating the event's members allows us to not have to create a wrapping
 * "dispatch" object that pairs the event with the listener.
 */ function accumulateDirectionalDispatches(inst, phase, event) {
        if (!inst) error("Dispatching inst must not be null");
        var listener = listenerAtPhase(inst, event, phase);
        if (listener) {
            event._dispatchListeners = accumulateInto(event._dispatchListeners, listener);
            event._dispatchInstances = accumulateInto(event._dispatchInstances, inst);
        }
    }
    /**
 * Collect dispatches (must be entirely collected before dispatching - see unit
 * tests). Lazily allocate the array to conserve memory.  We must loop through
 * each event and perform the traversal for each one. We cannot perform a
 * single traversal for the entire collection of events because each event may
 * have a different target.
 */ function accumulateTwoPhaseDispatchesSingle(event) {
        if (event && event.dispatchConfig.phasedRegistrationNames) traverseTwoPhase(event._targetInst, accumulateDirectionalDispatches, event);
    }
    /**
 * Accumulates without regard to direction, does not look for phased
 * registration names. Same as `accumulateDirectDispatchesSingle` but without
 * requiring that the `dispatchMarker` be the same as the dispatched ID.
 */ function accumulateDispatches(inst, ignoredDirection, event) {
        if (inst && event && event.dispatchConfig.registrationName) {
            var registrationName = event.dispatchConfig.registrationName;
            var listener = getListener(inst, registrationName);
            if (listener) {
                event._dispatchListeners = accumulateInto(event._dispatchListeners, listener);
                event._dispatchInstances = accumulateInto(event._dispatchInstances, inst);
            }
        }
    }
    /**
 * Accumulates dispatches on an `SyntheticEvent`, but only for the
 * `dispatchMarker`.
 * @param {SyntheticEvent} event
 */ function accumulateDirectDispatchesSingle(event) {
        if (event && event.dispatchConfig.registrationName) accumulateDispatches(event._targetInst, null, event);
    }
    function accumulateTwoPhaseDispatches(events) {
        forEachAccumulated(events, accumulateTwoPhaseDispatchesSingle);
    }
    function accumulateEnterLeaveDispatches(leave, enter, from, to) {
        traverseEnterLeave(from, to, accumulateDispatches, leave, enter);
    }
    function accumulateDirectDispatches(events) {
        forEachAccumulated(events, accumulateDirectDispatchesSingle);
    }
    /**
 * These variables store information about text content of a target node,
 * allowing comparison of content before and after a given event.
 *
 * Identify the node where selection currently begins, then observe
 * both its text content and its current position in the DOM. Since the
 * browser may natively replace the target node during composition, we can
 * use its position to find its replacement.
 *
 *
 */ var root = null;
    var startText = null;
    var fallbackText = null;
    function initialize(nativeEventTarget) {
        root = nativeEventTarget;
        startText = getText();
        return true;
    }
    function reset() {
        root = null;
        startText = null;
        fallbackText = null;
    }
    function getData() {
        if (fallbackText) return fallbackText;
        var start;
        var startValue = startText;
        var startLength = startValue.length;
        var end;
        var endValue = getText();
        var endLength = endValue.length;
        for(start = 0; start < startLength; start++){
            if (startValue[start] !== endValue[start]) break;
        }
        var minEnd = startLength - start;
        for(end = 1; end <= minEnd; end++){
            if (startValue[startLength - end] !== endValue[endLength - end]) break;
        }
        var sliceTail = end > 1 ? 1 - end : undefined;
        fallbackText = endValue.slice(start, sliceTail);
        return fallbackText;
    }
    function getText() {
        if ("value" in root) return root.value;
        return root.textContent;
    }
    var EVENT_POOL_SIZE = 10;
    /**
 * @interface Event
 * @see http://www.w3.org/TR/DOM-Level-3-Events/
 */ var EventInterface = {
        type: null,
        target: null,
        // currentTarget is set when dispatching; no use in copying it here
        currentTarget: function() {
            return null;
        },
        eventPhase: null,
        bubbles: null,
        cancelable: null,
        timeStamp: function(event) {
            return event.timeStamp || Date.now();
        },
        defaultPrevented: null,
        isTrusted: null
    };
    function functionThatReturnsTrue() {
        return true;
    }
    function functionThatReturnsFalse() {
        return false;
    }
    /**
 * Synthetic events are dispatched by event plugins, typically in response to a
 * top-level event delegation handler.
 *
 * These systems should generally use pooling to reduce the frequency of garbage
 * collection. The system should check `isPersistent` to determine whether the
 * event should be released into the pool after being dispatched. Users that
 * need a persisted event should invoke `persist`.
 *
 * Synthetic events (and subclasses) implement the DOM Level 3 Events API by
 * normalizing browser quirks. Subclasses do not necessarily have to implement a
 * DOM interface; custom application-specific events can also subclass this.
 *
 * @param {object} dispatchConfig Configuration used to dispatch this event.
 * @param {*} targetInst Marker identifying the event target.
 * @param {object} nativeEvent Native browser event.
 * @param {DOMEventTarget} nativeEventTarget Target node.
 */ function SyntheticEvent(dispatchConfig, targetInst, nativeEvent, nativeEventTarget) {
        // these have a getter/setter for warnings
        delete this.nativeEvent;
        delete this.preventDefault;
        delete this.stopPropagation;
        delete this.isDefaultPrevented;
        delete this.isPropagationStopped;
        this.dispatchConfig = dispatchConfig;
        this._targetInst = targetInst;
        this.nativeEvent = nativeEvent;
        var Interface = this.constructor.Interface;
        for(var propName in Interface){
            if (!Interface.hasOwnProperty(propName)) continue;
            delete this[propName]; // this has a getter/setter for warnings
            var normalize = Interface[propName];
            if (normalize) this[propName] = normalize(nativeEvent);
            else if (propName === "target") this.target = nativeEventTarget;
            else this[propName] = nativeEvent[propName];
        }
        var defaultPrevented = nativeEvent.defaultPrevented != null ? nativeEvent.defaultPrevented : nativeEvent.returnValue === false;
        if (defaultPrevented) this.isDefaultPrevented = functionThatReturnsTrue;
        else this.isDefaultPrevented = functionThatReturnsFalse;
        this.isPropagationStopped = functionThatReturnsFalse;
        return this;
    }
    _assign(SyntheticEvent.prototype, {
        preventDefault: function() {
            this.defaultPrevented = true;
            var event = this.nativeEvent;
            if (!event) return;
            if (event.preventDefault) event.preventDefault();
            else if (typeof event.returnValue !== "unknown") event.returnValue = false;
            this.isDefaultPrevented = functionThatReturnsTrue;
        },
        stopPropagation: function() {
            var event = this.nativeEvent;
            if (!event) return;
            if (event.stopPropagation) event.stopPropagation();
            else if (typeof event.cancelBubble !== "unknown") // The ChangeEventPlugin registers a "propertychange" event for
            // IE. This event does not support bubbling or cancelling, and
            // any references to cancelBubble throw "Member not found".  A
            // typeof check of "unknown" circumvents this issue (and is also
            // IE specific).
            event.cancelBubble = true;
            this.isPropagationStopped = functionThatReturnsTrue;
        },
        /**
   * We release all dispatched `SyntheticEvent`s after each event loop, adding
   * them back into the pool. This allows a way to hold onto a reference that
   * won't be added back into the pool.
   */ persist: function() {
            this.isPersistent = functionThatReturnsTrue;
        },
        /**
   * Checks if this event should be released back into the pool.
   *
   * @return {boolean} True if this should not be released, false otherwise.
   */ isPersistent: functionThatReturnsFalse,
        /**
   * `PooledClass` looks for `destructor` on each instance it releases.
   */ destructor: function() {
            var Interface = this.constructor.Interface;
            for(var propName in Interface)Object.defineProperty(this, propName, getPooledWarningPropertyDefinition(propName, Interface[propName]));
            this.dispatchConfig = null;
            this._targetInst = null;
            this.nativeEvent = null;
            this.isDefaultPrevented = functionThatReturnsFalse;
            this.isPropagationStopped = functionThatReturnsFalse;
            this._dispatchListeners = null;
            this._dispatchInstances = null;
            Object.defineProperty(this, "nativeEvent", getPooledWarningPropertyDefinition("nativeEvent", null));
            Object.defineProperty(this, "isDefaultPrevented", getPooledWarningPropertyDefinition("isDefaultPrevented", functionThatReturnsFalse));
            Object.defineProperty(this, "isPropagationStopped", getPooledWarningPropertyDefinition("isPropagationStopped", functionThatReturnsFalse));
            Object.defineProperty(this, "preventDefault", getPooledWarningPropertyDefinition("preventDefault", function() {}));
            Object.defineProperty(this, "stopPropagation", getPooledWarningPropertyDefinition("stopPropagation", function() {}));
        }
    });
    SyntheticEvent.Interface = EventInterface;
    /**
 * Helper to reduce boilerplate when creating subclasses.
 */ SyntheticEvent.extend = function(Interface) {
        var Super = this;
        var E = function() {};
        E.prototype = Super.prototype;
        var prototype = new E();
        function Class() {
            return Super.apply(this, arguments);
        }
        _assign(prototype, Class.prototype);
        Class.prototype = prototype;
        Class.prototype.constructor = Class;
        Class.Interface = _assign({}, Super.Interface, Interface);
        Class.extend = Super.extend;
        addEventPoolingTo(Class);
        return Class;
    };
    addEventPoolingTo(SyntheticEvent);
    /**
 * Helper to nullify syntheticEvent instance properties when destructing
 *
 * @param {String} propName
 * @param {?object} getVal
 * @return {object} defineProperty object
 */ function getPooledWarningPropertyDefinition(propName, getVal) {
        var isFunction = typeof getVal === "function";
        return {
            configurable: true,
            set: set,
            get: get
        };
        function set(val) {
            var action = isFunction ? "setting the method" : "setting the property";
            warn(action, "This is effectively a no-op");
            return val;
        }
        function get() {
            var action = isFunction ? "accessing the method" : "accessing the property";
            var result = isFunction ? "This is a no-op function" : "This is set to null";
            warn(action, result);
            return getVal;
        }
        function warn(action, result) {
            error("This synthetic event is reused for performance reasons. If you're seeing this, you're %s `%s` on a released/nullified synthetic event. %s. If you must keep the original synthetic event around, use event.persist(). See https://fb.me/react-event-pooling for more information.", action, propName, result);
        }
    }
    function getPooledEvent(dispatchConfig, targetInst, nativeEvent, nativeInst) {
        var EventConstructor = this;
        if (EventConstructor.eventPool.length) {
            var instance = EventConstructor.eventPool.pop();
            EventConstructor.call(instance, dispatchConfig, targetInst, nativeEvent, nativeInst);
            return instance;
        }
        return new EventConstructor(dispatchConfig, targetInst, nativeEvent, nativeInst);
    }
    function releasePooledEvent(event) {
        var EventConstructor = this;
        if (!(event instanceof EventConstructor)) throw Error("Trying to release an event instance into a pool of a different type.");
        event.destructor();
        if (EventConstructor.eventPool.length < EVENT_POOL_SIZE) EventConstructor.eventPool.push(event);
    }
    function addEventPoolingTo(EventConstructor) {
        EventConstructor.eventPool = [];
        EventConstructor.getPooled = getPooledEvent;
        EventConstructor.release = releasePooledEvent;
    }
    /**
 * @interface Event
 * @see http://www.w3.org/TR/DOM-Level-3-Events/#events-compositionevents
 */ var SyntheticCompositionEvent = SyntheticEvent.extend({
        data: null
    });
    /**
 * @interface Event
 * @see http://www.w3.org/TR/2013/WD-DOM-Level-3-Events-20131105
 *      /#events-inputevents
 */ var SyntheticInputEvent = SyntheticEvent.extend({
        data: null
    });
    var END_KEYCODES = [
        9,
        13,
        27,
        32
    ]; // Tab, Return, Esc, Space
    var START_KEYCODE = 229;
    var canUseCompositionEvent = canUseDOM && "CompositionEvent" in window;
    var documentMode = null;
    if (canUseDOM && "documentMode" in document) documentMode = document.documentMode;
     // Webkit offers a very useful `textInput` event that can be used to
    // directly represent `beforeInput`. The IE `textinput` event is not as
    // useful, so we don't use it.
    var canUseTextInputEvent = canUseDOM && "TextEvent" in window && !documentMode; // In IE9+, we have access to composition events, but the data supplied
    // by the native compositionend event may be incorrect. Japanese ideographic
    // spaces, for instance (\u3000) are not recorded correctly.
    var useFallbackCompositionData = canUseDOM && (!canUseCompositionEvent || documentMode && documentMode > 8 && documentMode <= 11);
    var SPACEBAR_CODE = 32;
    var SPACEBAR_CHAR = String.fromCharCode(SPACEBAR_CODE); // Events and their corresponding property names.
    var eventTypes = {
        beforeInput: {
            phasedRegistrationNames: {
                bubbled: "onBeforeInput",
                captured: "onBeforeInputCapture"
            },
            dependencies: [
                TOP_COMPOSITION_END,
                TOP_KEY_PRESS,
                TOP_TEXT_INPUT,
                TOP_PASTE
            ]
        },
        compositionEnd: {
            phasedRegistrationNames: {
                bubbled: "onCompositionEnd",
                captured: "onCompositionEndCapture"
            },
            dependencies: [
                TOP_BLUR,
                TOP_COMPOSITION_END,
                TOP_KEY_DOWN,
                TOP_KEY_PRESS,
                TOP_KEY_UP,
                TOP_MOUSE_DOWN
            ]
        },
        compositionStart: {
            phasedRegistrationNames: {
                bubbled: "onCompositionStart",
                captured: "onCompositionStartCapture"
            },
            dependencies: [
                TOP_BLUR,
                TOP_COMPOSITION_START,
                TOP_KEY_DOWN,
                TOP_KEY_PRESS,
                TOP_KEY_UP,
                TOP_MOUSE_DOWN
            ]
        },
        compositionUpdate: {
            phasedRegistrationNames: {
                bubbled: "onCompositionUpdate",
                captured: "onCompositionUpdateCapture"
            },
            dependencies: [
                TOP_BLUR,
                TOP_COMPOSITION_UPDATE,
                TOP_KEY_DOWN,
                TOP_KEY_PRESS,
                TOP_KEY_UP,
                TOP_MOUSE_DOWN
            ]
        }
    }; // Track whether we've ever handled a keypress on the space key.
    var hasSpaceKeypress = false;
    /**
 * Return whether a native keypress event is assumed to be a command.
 * This is required because Firefox fires `keypress` events for key commands
 * (cut, copy, select-all, etc.) even though no character is inserted.
 */ function isKeypressCommand(nativeEvent) {
        return (nativeEvent.ctrlKey || nativeEvent.altKey || nativeEvent.metaKey) && // ctrlKey && altKey is equivalent to AltGr, and is not a command.
        !(nativeEvent.ctrlKey && nativeEvent.altKey);
    }
    /**
 * Translate native top level events into event types.
 *
 * @param {string} topLevelType
 * @return {object}
 */ function getCompositionEventType(topLevelType) {
        switch(topLevelType){
            case TOP_COMPOSITION_START:
                return eventTypes.compositionStart;
            case TOP_COMPOSITION_END:
                return eventTypes.compositionEnd;
            case TOP_COMPOSITION_UPDATE:
                return eventTypes.compositionUpdate;
        }
    }
    /**
 * Does our fallback best-guess model think this event signifies that
 * composition has begun?
 *
 * @param {string} topLevelType
 * @param {object} nativeEvent
 * @return {boolean}
 */ function isFallbackCompositionStart(topLevelType, nativeEvent) {
        return topLevelType === TOP_KEY_DOWN && nativeEvent.keyCode === START_KEYCODE;
    }
    /**
 * Does our fallback mode think that this event is the end of composition?
 *
 * @param {string} topLevelType
 * @param {object} nativeEvent
 * @return {boolean}
 */ function isFallbackCompositionEnd(topLevelType, nativeEvent) {
        switch(topLevelType){
            case TOP_KEY_UP:
                // Command keys insert or clear IME input.
                return END_KEYCODES.indexOf(nativeEvent.keyCode) !== -1;
            case TOP_KEY_DOWN:
                // Expect IME keyCode on each keydown. If we get any other
                // code we must have exited earlier.
                return nativeEvent.keyCode !== START_KEYCODE;
            case TOP_KEY_PRESS:
            case TOP_MOUSE_DOWN:
            case TOP_BLUR:
                // Events are not possible without cancelling IME.
                return true;
            default:
                return false;
        }
    }
    /**
 * Google Input Tools provides composition data via a CustomEvent,
 * with the `data` property populated in the `detail` object. If this
 * is available on the event object, use it. If not, this is a plain
 * composition event and we have nothing special to extract.
 *
 * @param {object} nativeEvent
 * @return {?string}
 */ function getDataFromCustomEvent(nativeEvent) {
        var detail = nativeEvent.detail;
        if (typeof detail === "object" && "data" in detail) return detail.data;
        return null;
    }
    /**
 * Check if a composition event was triggered by Korean IME.
 * Our fallback mode does not work well with IE's Korean IME,
 * so just use native composition events when Korean IME is used.
 * Although CompositionEvent.locale property is deprecated,
 * it is available in IE, where our fallback mode is enabled.
 *
 * @param {object} nativeEvent
 * @return {boolean}
 */ function isUsingKoreanIME(nativeEvent) {
        return nativeEvent.locale === "ko";
    } // Track the current IME composition status, if any.
    var isComposing = false;
    /**
 * @return {?object} A SyntheticCompositionEvent.
 */ function extractCompositionEvent(topLevelType, targetInst, nativeEvent, nativeEventTarget) {
        var eventType;
        var fallbackData;
        if (canUseCompositionEvent) eventType = getCompositionEventType(topLevelType);
        else if (!isComposing) {
            if (isFallbackCompositionStart(topLevelType, nativeEvent)) eventType = eventTypes.compositionStart;
        } else if (isFallbackCompositionEnd(topLevelType, nativeEvent)) eventType = eventTypes.compositionEnd;
        if (!eventType) return null;
        if (useFallbackCompositionData && !isUsingKoreanIME(nativeEvent)) {
            // The current composition is stored statically and must not be
            // overwritten while composition continues.
            if (!isComposing && eventType === eventTypes.compositionStart) isComposing = initialize(nativeEventTarget);
            else if (eventType === eventTypes.compositionEnd) {
                if (isComposing) fallbackData = getData();
            }
        }
        var event = SyntheticCompositionEvent.getPooled(eventType, targetInst, nativeEvent, nativeEventTarget);
        if (fallbackData) // Inject data generated from fallback path into the synthetic event.
        // This matches the property of native CompositionEventInterface.
        event.data = fallbackData;
        else {
            var customData = getDataFromCustomEvent(nativeEvent);
            if (customData !== null) event.data = customData;
        }
        accumulateTwoPhaseDispatches(event);
        return event;
    }
    /**
 * @param {TopLevelType} topLevelType Number from `TopLevelType`.
 * @param {object} nativeEvent Native browser event.
 * @return {?string} The string corresponding to this `beforeInput` event.
 */ function getNativeBeforeInputChars(topLevelType, nativeEvent) {
        switch(topLevelType){
            case TOP_COMPOSITION_END:
                return getDataFromCustomEvent(nativeEvent);
            case TOP_KEY_PRESS:
                /**
       * If native `textInput` events are available, our goal is to make
       * use of them. However, there is a special case: the spacebar key.
       * In Webkit, preventing default on a spacebar `textInput` event
       * cancels character insertion, but it *also* causes the browser
       * to fall back to its default spacebar behavior of scrolling the
       * page.
       *
       * Tracking at:
       * https://code.google.com/p/chromium/issues/detail?id=355103
       *
       * To avoid this issue, use the keypress event as if no `textInput`
       * event is available.
       */ var which = nativeEvent.which;
                if (which !== SPACEBAR_CODE) return null;
                hasSpaceKeypress = true;
                return SPACEBAR_CHAR;
            case TOP_TEXT_INPUT:
                // Record the characters to be added to the DOM.
                var chars = nativeEvent.data; // If it's a spacebar character, assume that we have already handled
                // it at the keypress level and bail immediately. Android Chrome
                // doesn't give us keycodes, so we need to ignore it.
                if (chars === SPACEBAR_CHAR && hasSpaceKeypress) return null;
                return chars;
            default:
                // For other native event types, do nothing.
                return null;
        }
    }
    /**
 * For browsers that do not provide the `textInput` event, extract the
 * appropriate string to use for SyntheticInputEvent.
 *
 * @param {number} topLevelType Number from `TopLevelEventTypes`.
 * @param {object} nativeEvent Native browser event.
 * @return {?string} The fallback string for this `beforeInput` event.
 */ function getFallbackBeforeInputChars(topLevelType, nativeEvent) {
        // If we are currently composing (IME) and using a fallback to do so,
        // try to extract the composed characters from the fallback object.
        // If composition event is available, we extract a string only at
        // compositionevent, otherwise extract it at fallback events.
        if (isComposing) {
            if (topLevelType === TOP_COMPOSITION_END || !canUseCompositionEvent && isFallbackCompositionEnd(topLevelType, nativeEvent)) {
                var chars = getData();
                reset();
                isComposing = false;
                return chars;
            }
            return null;
        }
        switch(topLevelType){
            case TOP_PASTE:
                // If a paste event occurs after a keypress, throw out the input
                // chars. Paste events should not lead to BeforeInput events.
                return null;
            case TOP_KEY_PRESS:
                /**
       * As of v27, Firefox may fire keypress events even when no character
       * will be inserted. A few possibilities:
       *
       * - `which` is `0`. Arrow keys, Esc key, etc.
       *
       * - `which` is the pressed key code, but no char is available.
       *   Ex: 'AltGr + d` in Polish. There is no modified character for
       *   this key combination and no character is inserted into the
       *   document, but FF fires the keypress for char code `100` anyway.
       *   No `input` event will occur.
       *
       * - `which` is the pressed key code, but a command combination is
       *   being used. Ex: `Cmd+C`. No character is inserted, and no
       *   `input` event will occur.
       */ if (!isKeypressCommand(nativeEvent)) {
                    // IE fires the `keypress` event when a user types an emoji via
                    // Touch keyboard of Windows.  In such a case, the `char` property
                    // holds an emoji character like `\uD83D\uDE0A`.  Because its length
                    // is 2, the property `which` does not represent an emoji correctly.
                    // In such a case, we directly return the `char` property instead of
                    // using `which`.
                    if (nativeEvent.char && nativeEvent.char.length > 1) return nativeEvent.char;
                    else if (nativeEvent.which) return String.fromCharCode(nativeEvent.which);
                }
                return null;
            case TOP_COMPOSITION_END:
                return useFallbackCompositionData && !isUsingKoreanIME(nativeEvent) ? null : nativeEvent.data;
            default:
                return null;
        }
    }
    /**
 * Extract a SyntheticInputEvent for `beforeInput`, based on either native
 * `textInput` or fallback behavior.
 *
 * @return {?object} A SyntheticInputEvent.
 */ function extractBeforeInputEvent(topLevelType, targetInst, nativeEvent, nativeEventTarget) {
        var chars;
        if (canUseTextInputEvent) chars = getNativeBeforeInputChars(topLevelType, nativeEvent);
        else chars = getFallbackBeforeInputChars(topLevelType, nativeEvent);
         // If no characters are being inserted, no BeforeInput event should
        // be fired.
        if (!chars) return null;
        var event = SyntheticInputEvent.getPooled(eventTypes.beforeInput, targetInst, nativeEvent, nativeEventTarget);
        event.data = chars;
        accumulateTwoPhaseDispatches(event);
        return event;
    }
    /**
 * Create an `onBeforeInput` event to match
 * http://www.w3.org/TR/2013/WD-DOM-Level-3-Events-20131105/#events-inputevents.
 *
 * This event plugin is based on the native `textInput` event
 * available in Chrome, Safari, Opera, and IE. This event fires after
 * `onKeyPress` and `onCompositionEnd`, but before `onInput`.
 *
 * `beforeInput` is spec'd but not implemented in any browsers, and
 * the `input` event does not provide any useful information about what has
 * actually been added, contrary to the spec. Thus, `textInput` is the best
 * available event to identify the characters that have actually been inserted
 * into the target node.
 *
 * This plugin is also responsible for emitting `composition` events, thus
 * allowing us to share composition fallback code for both `beforeInput` and
 * `composition` event types.
 */ var BeforeInputEventPlugin = {
        eventTypes: eventTypes,
        extractEvents: function(topLevelType, targetInst, nativeEvent, nativeEventTarget, eventSystemFlags) {
            var composition = extractCompositionEvent(topLevelType, targetInst, nativeEvent, nativeEventTarget);
            var beforeInput = extractBeforeInputEvent(topLevelType, targetInst, nativeEvent, nativeEventTarget);
            if (composition === null) return beforeInput;
            if (beforeInput === null) return composition;
            return [
                composition,
                beforeInput
            ];
        }
    };
    /**
 * @see http://www.whatwg.org/specs/web-apps/current-work/multipage/the-input-element.html#input-type-attr-summary
 */ var supportedInputTypes = {
        color: true,
        date: true,
        datetime: true,
        "datetime-local": true,
        email: true,
        month: true,
        number: true,
        password: true,
        range: true,
        search: true,
        tel: true,
        text: true,
        time: true,
        url: true,
        week: true
    };
    function isTextInputElement(elem) {
        var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
        if (nodeName === "input") return !!supportedInputTypes[elem.type];
        if (nodeName === "textarea") return true;
        return false;
    }
    var eventTypes$1 = {
        change: {
            phasedRegistrationNames: {
                bubbled: "onChange",
                captured: "onChangeCapture"
            },
            dependencies: [
                TOP_BLUR,
                TOP_CHANGE,
                TOP_CLICK,
                TOP_FOCUS,
                TOP_INPUT,
                TOP_KEY_DOWN,
                TOP_KEY_UP,
                TOP_SELECTION_CHANGE
            ]
        }
    };
    function createAndAccumulateChangeEvent(inst, nativeEvent, target) {
        var event = SyntheticEvent.getPooled(eventTypes$1.change, inst, nativeEvent, target);
        event.type = "change"; // Flag this event loop as needing state restore.
        enqueueStateRestore(target);
        accumulateTwoPhaseDispatches(event);
        return event;
    }
    /**
 * For IE shims
 */ var activeElement = null;
    var activeElementInst = null;
    /**
 * SECTION: handle `change` event
 */ function shouldUseChangeEvent(elem) {
        var nodeName = elem.nodeName && elem.nodeName.toLowerCase();
        return nodeName === "select" || nodeName === "input" && elem.type === "file";
    }
    function manualDispatchChangeEvent(nativeEvent) {
        var event = createAndAccumulateChangeEvent(activeElementInst, nativeEvent, getEventTarget(nativeEvent)); // If change and propertychange bubbled, we'd just bind to it like all the
        // other events and have it go through ReactBrowserEventEmitter. Since it
        // doesn't, we manually listen for the events and so we have to enqueue and
        // process the abstract event manually.
        //
        // Batching is necessary here in order to ensure that all event handlers run
        // before the next rerender (including event handlers attached to ancestor
        // elements instead of directly on the input). Without this, controlled
        // components don't work properly in conjunction with event bubbling because
        // the component is rerendered and the value reverted before all the event
        // handlers can run. See https://github.com/facebook/react/issues/708.
        batchedUpdates(runEventInBatch, event);
    }
    function runEventInBatch(event) {
        runEventsInBatch(event);
    }
    function getInstIfValueChanged(targetInst) {
        var targetNode = getNodeFromInstance$1(targetInst);
        if (updateValueIfChanged(targetNode)) return targetInst;
    }
    function getTargetInstForChangeEvent(topLevelType, targetInst) {
        if (topLevelType === TOP_CHANGE) return targetInst;
    }
    /**
 * SECTION: handle `input` event
 */ var isInputEventSupported = false;
    if (canUseDOM) // IE9 claims to support the input event but fails to trigger it when
    // deleting text, so we ignore its input events.
    isInputEventSupported = isEventSupported("input") && (!document.documentMode || document.documentMode > 9);
    /**
 * (For IE <=9) Starts tracking propertychange events on the passed-in element
 * and override the value property so that we can distinguish user events from
 * value changes in JS.
 */ function startWatchingForValueChange(target, targetInst) {
        activeElement = target;
        activeElementInst = targetInst;
        activeElement.attachEvent("onpropertychange", handlePropertyChange);
    }
    /**
 * (For IE <=9) Removes the event listeners from the currently-tracked element,
 * if any exists.
 */ function stopWatchingForValueChange() {
        if (!activeElement) return;
        activeElement.detachEvent("onpropertychange", handlePropertyChange);
        activeElement = null;
        activeElementInst = null;
    }
    /**
 * (For IE <=9) Handles a propertychange event, sending a `change` event if
 * the value of the active element has changed.
 */ function handlePropertyChange(nativeEvent) {
        if (nativeEvent.propertyName !== "value") return;
        if (getInstIfValueChanged(activeElementInst)) manualDispatchChangeEvent(nativeEvent);
    }
    function handleEventsForInputEventPolyfill(topLevelType, target, targetInst) {
        if (topLevelType === TOP_FOCUS) {
            // In IE9, propertychange fires for most input events but is buggy and
            // doesn't fire when text is deleted, but conveniently, selectionchange
            // appears to fire in all of the remaining cases so we catch those and
            // forward the event if the value has changed
            // In either case, we don't want to call the event handler if the value
            // is changed from JS so we redefine a setter for `.value` that updates
            // our activeElementValue variable, allowing us to ignore those changes
            //
            // stopWatching() should be a noop here but we call it just in case we
            // missed a blur event somehow.
            stopWatchingForValueChange();
            startWatchingForValueChange(target, targetInst);
        } else if (topLevelType === TOP_BLUR) stopWatchingForValueChange();
    } // For IE8 and IE9.
    function getTargetInstForInputEventPolyfill(topLevelType, targetInst) {
        if (topLevelType === TOP_SELECTION_CHANGE || topLevelType === TOP_KEY_UP || topLevelType === TOP_KEY_DOWN) // On the selectionchange event, the target is just document which isn't
        // helpful for us so just check activeElement instead.
        //
        // 99% of the time, keydown and keyup aren't necessary. IE8 fails to fire
        // propertychange on the first input event after setting `value` from a
        // script and fires only keydown, keypress, keyup. Catching keyup usually
        // gets it and catching keydown lets us fire an event for the first
        // keystroke if user does a key repeat (it'll be a little delayed: right
        // before the second keystroke). Other input methods (e.g., paste) seem to
        // fire selectionchange normally.
        return getInstIfValueChanged(activeElementInst);
    }
    /**
 * SECTION: handle `click` event
 */ function shouldUseClickEvent(elem) {
        // Use the `click` event to detect changes to checkbox and radio inputs.
        // This approach works across all browsers, whereas `change` does not fire
        // until `blur` in IE8.
        var nodeName = elem.nodeName;
        return nodeName && nodeName.toLowerCase() === "input" && (elem.type === "checkbox" || elem.type === "radio");
    }
    function getTargetInstForClickEvent(topLevelType, targetInst) {
        if (topLevelType === TOP_CLICK) return getInstIfValueChanged(targetInst);
    }
    function getTargetInstForInputOrChangeEvent(topLevelType, targetInst) {
        if (topLevelType === TOP_INPUT || topLevelType === TOP_CHANGE) return getInstIfValueChanged(targetInst);
    }
    function handleControlledInputBlur(node) {
        var state = node._wrapperState;
        if (!state || !state.controlled || node.type !== "number") return;
        // If controlled, assign the value attribute to the current value on blur
        setDefaultValue(node, "number", node.value);
    }
    /**
 * This plugin creates an `onChange` event that normalizes change events
 * across form elements. This event fires at a time when it's possible to
 * change the element's value without seeing a flicker.
 *
 * Supported elements are:
 * - input (see `isTextInputElement`)
 * - textarea
 * - select
 */ var ChangeEventPlugin = {
        eventTypes: eventTypes$1,
        _isInputEventSupported: isInputEventSupported,
        extractEvents: function(topLevelType, targetInst, nativeEvent, nativeEventTarget, eventSystemFlags) {
            var targetNode = targetInst ? getNodeFromInstance$1(targetInst) : window;
            var getTargetInstFunc, handleEventFunc;
            if (shouldUseChangeEvent(targetNode)) getTargetInstFunc = getTargetInstForChangeEvent;
            else if (isTextInputElement(targetNode)) {
                if (isInputEventSupported) getTargetInstFunc = getTargetInstForInputOrChangeEvent;
                else {
                    getTargetInstFunc = getTargetInstForInputEventPolyfill;
                    handleEventFunc = handleEventsForInputEventPolyfill;
                }
            } else if (shouldUseClickEvent(targetNode)) getTargetInstFunc = getTargetInstForClickEvent;
            if (getTargetInstFunc) {
                var inst = getTargetInstFunc(topLevelType, targetInst);
                if (inst) {
                    var event = createAndAccumulateChangeEvent(inst, nativeEvent, nativeEventTarget);
                    return event;
                }
            }
            if (handleEventFunc) handleEventFunc(topLevelType, targetNode, targetInst);
             // When blurring, set the value attribute for number inputs
            if (topLevelType === TOP_BLUR) handleControlledInputBlur(targetNode);
        }
    };
    var SyntheticUIEvent = SyntheticEvent.extend({
        view: null,
        detail: null
    });
    /**
 * Translation from modifier key to the associated property in the event.
 * @see http://www.w3.org/TR/DOM-Level-3-Events/#keys-Modifiers
 */ var modifierKeyToProp = {
        Alt: "altKey",
        Control: "ctrlKey",
        Meta: "metaKey",
        Shift: "shiftKey"
    }; // Older browsers (Safari <= 10, iOS Safari <= 10.2) do not support
    // getModifierState. If getModifierState is not supported, we map it to a set of
    // modifier keys exposed by the event. In this case, Lock-keys are not supported.
    function modifierStateGetter(keyArg) {
        var syntheticEvent = this;
        var nativeEvent = syntheticEvent.nativeEvent;
        if (nativeEvent.getModifierState) return nativeEvent.getModifierState(keyArg);
        var keyProp = modifierKeyToProp[keyArg];
        return keyProp ? !!nativeEvent[keyProp] : false;
    }
    function getEventModifierState(nativeEvent) {
        return modifierStateGetter;
    }
    var previousScreenX = 0;
    var previousScreenY = 0; // Use flags to signal movementX/Y has already been set
    var isMovementXSet = false;
    var isMovementYSet = false;
    /**
 * @interface MouseEvent
 * @see http://www.w3.org/TR/DOM-Level-3-Events/
 */ var SyntheticMouseEvent = SyntheticUIEvent.extend({
        screenX: null,
        screenY: null,
        clientX: null,
        clientY: null,
        pageX: null,
        pageY: null,
        ctrlKey: null,
        shiftKey: null,
        altKey: null,
        metaKey: null,
        getModifierState: getEventModifierState,
        button: null,
        buttons: null,
        relatedTarget: function(event) {
            return event.relatedTarget || (event.fromElement === event.srcElement ? event.toElement : event.fromElement);
        },
        movementX: function(event) {
            if ("movementX" in event) return event.movementX;
            var screenX = previousScreenX;
            previousScreenX = event.screenX;
            if (!isMovementXSet) {
                isMovementXSet = true;
                return 0;
            }
            return event.type === "mousemove" ? event.screenX - screenX : 0;
        },
        movementY: function(event) {
            if ("movementY" in event) return event.movementY;
            var screenY = previousScreenY;
            previousScreenY = event.screenY;
            if (!isMovementYSet) {
                isMovementYSet = true;
                return 0;
            }
            return event.type === "mousemove" ? event.screenY - screenY : 0;
        }
    });
    /**
 * @interface PointerEvent
 * @see http://www.w3.org/TR/pointerevents/
 */ var SyntheticPointerEvent = SyntheticMouseEvent.extend({
        pointerId: null,
        width: null,
        height: null,
        pressure: null,
        tangentialPressure: null,
        tiltX: null,
        tiltY: null,
        twist: null,
        pointerType: null,
        isPrimary: null
    });
    var eventTypes$2 = {
        mouseEnter: {
            registrationName: "onMouseEnter",
            dependencies: [
                TOP_MOUSE_OUT,
                TOP_MOUSE_OVER
            ]
        },
        mouseLeave: {
            registrationName: "onMouseLeave",
            dependencies: [
                TOP_MOUSE_OUT,
                TOP_MOUSE_OVER
            ]
        },
        pointerEnter: {
            registrationName: "onPointerEnter",
            dependencies: [
                TOP_POINTER_OUT,
                TOP_POINTER_OVER
            ]
        },
        pointerLeave: {
            registrationName: "onPointerLeave",
            dependencies: [
                TOP_POINTER_OUT,
                TOP_POINTER_OVER
            ]
        }
    };
    var EnterLeaveEventPlugin = {
        eventTypes: eventTypes$2,
        /**
   * For almost every interaction we care about, there will be both a top-level
   * `mouseover` and `mouseout` event that occurs. Only use `mouseout` so that
   * we do not extract duplicate events. However, moving the mouse into the
   * browser from outside will not fire a `mouseout` event. In this case, we use
   * the `mouseover` top-level event.
   */ extractEvents: function(topLevelType, targetInst, nativeEvent, nativeEventTarget, eventSystemFlags) {
            var isOverEvent = topLevelType === TOP_MOUSE_OVER || topLevelType === TOP_POINTER_OVER;
            var isOutEvent = topLevelType === TOP_MOUSE_OUT || topLevelType === TOP_POINTER_OUT;
            if (isOverEvent && (eventSystemFlags & IS_REPLAYED) === 0 && (nativeEvent.relatedTarget || nativeEvent.fromElement)) // If this is an over event with a target, then we've already dispatched
            // the event in the out event of the other target. If this is replayed,
            // then it's because we couldn't dispatch against this target previously
            // so we have to do it now instead.
            return null;
            if (!isOutEvent && !isOverEvent) // Must not be a mouse or pointer in or out - ignoring.
            return null;
            var win;
            if (nativeEventTarget.window === nativeEventTarget) // `nativeEventTarget` is probably a window object.
            win = nativeEventTarget;
            else {
                // TODO: Figure out why `ownerDocument` is sometimes undefined in IE8.
                var doc = nativeEventTarget.ownerDocument;
                if (doc) win = doc.defaultView || doc.parentWindow;
                else win = window;
            }
            var from;
            var to;
            if (isOutEvent) {
                from = targetInst;
                var related = nativeEvent.relatedTarget || nativeEvent.toElement;
                to = related ? getClosestInstanceFromNode(related) : null;
                if (to !== null) {
                    var nearestMounted = getNearestMountedFiber(to);
                    if (to !== nearestMounted || to.tag !== HostComponent && to.tag !== HostText) to = null;
                }
            } else {
                // Moving to a node from outside the window.
                from = null;
                to = targetInst;
            }
            if (from === to) // Nothing pertains to our managed components.
            return null;
            var eventInterface, leaveEventType, enterEventType, eventTypePrefix;
            if (topLevelType === TOP_MOUSE_OUT || topLevelType === TOP_MOUSE_OVER) {
                eventInterface = SyntheticMouseEvent;
                leaveEventType = eventTypes$2.mouseLeave;
                enterEventType = eventTypes$2.mouseEnter;
                eventTypePrefix = "mouse";
            } else if (topLevelType === TOP_POINTER_OUT || topLevelType === TOP_POINTER_OVER) {
                eventInterface = SyntheticPointerEvent;
                leaveEventType = eventTypes$2.pointerLeave;
                enterEventType = eventTypes$2.pointerEnter;
                eventTypePrefix = "pointer";
            }
            var fromNode = from == null ? win : getNodeFromInstance$1(from);
            var toNode = to == null ? win : getNodeFromInstance$1(to);
            var leave = eventInterface.getPooled(leaveEventType, from, nativeEvent, nativeEventTarget);
            leave.type = eventTypePrefix + "leave";
            leave.target = fromNode;
            leave.relatedTarget = toNode;
            var enter = eventInterface.getPooled(enterEventType, to, nativeEvent, nativeEventTarget);
            enter.type = eventTypePrefix + "enter";
            enter.target = toNode;
            enter.relatedTarget = fromNode;
            accumulateEnterLeaveDispatches(leave, enter, from, to); // If we are not processing the first ancestor, then we
            // should not process the same nativeEvent again, as we
            // will have already processed it in the first ancestor.
            if ((eventSystemFlags & IS_FIRST_ANCESTOR) === 0) return [
                leave
            ];
            return [
                leave,
                enter
            ];
        }
    };
    /**
 * inlined Object.is polyfill to avoid requiring consumers ship their own
 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
 */ function is(x, y) {
        return x === y && (x !== 0 || 1 / x === 1 / y) || x !== x && y !== y // eslint-disable-line no-self-compare
        ;
    }
    var objectIs = typeof Object.is === "function" ? Object.is : is;
    var hasOwnProperty$2 = Object.prototype.hasOwnProperty;
    /**
 * Performs equality by iterating through keys on an object and returning false
 * when any key has values which are not strictly equal between the arguments.
 * Returns true when the values of all keys are strictly equal.
 */ function shallowEqual(objA, objB) {
        if (objectIs(objA, objB)) return true;
        if (typeof objA !== "object" || objA === null || typeof objB !== "object" || objB === null) return false;
        var keysA = Object.keys(objA);
        var keysB = Object.keys(objB);
        if (keysA.length !== keysB.length) return false;
         // Test for A's keys different from B.
        for(var i = 0; i < keysA.length; i++){
            if (!hasOwnProperty$2.call(objB, keysA[i]) || !objectIs(objA[keysA[i]], objB[keysA[i]])) return false;
        }
        return true;
    }
    var skipSelectionChangeEvent = canUseDOM && "documentMode" in document && document.documentMode <= 11;
    var eventTypes$3 = {
        select: {
            phasedRegistrationNames: {
                bubbled: "onSelect",
                captured: "onSelectCapture"
            },
            dependencies: [
                TOP_BLUR,
                TOP_CONTEXT_MENU,
                TOP_DRAG_END,
                TOP_FOCUS,
                TOP_KEY_DOWN,
                TOP_KEY_UP,
                TOP_MOUSE_DOWN,
                TOP_MOUSE_UP,
                TOP_SELECTION_CHANGE
            ]
        }
    };
    var activeElement$1 = null;
    var activeElementInst$1 = null;
    var lastSelection = null;
    var mouseDown = false;
    /**
 * Get an object which is a unique representation of the current selection.
 *
 * The return value will not be consistent across nodes or browsers, but
 * two identical selections on the same node will return identical objects.
 *
 * @param {DOMElement} node
 * @return {object}
 */ function getSelection$1(node) {
        if ("selectionStart" in node && hasSelectionCapabilities(node)) return {
            start: node.selectionStart,
            end: node.selectionEnd
        };
        else {
            var win = node.ownerDocument && node.ownerDocument.defaultView || window;
            var selection = win.getSelection();
            return {
                anchorNode: selection.anchorNode,
                anchorOffset: selection.anchorOffset,
                focusNode: selection.focusNode,
                focusOffset: selection.focusOffset
            };
        }
    }
    /**
 * Get document associated with the event target.
 *
 * @param {object} nativeEventTarget
 * @return {Document}
 */ function getEventTargetDocument(eventTarget) {
        return eventTarget.window === eventTarget ? eventTarget.document : eventTarget.nodeType === DOCUMENT_NODE ? eventTarget : eventTarget.ownerDocument;
    }
    /**
 * Poll selection to see whether it's changed.
 *
 * @param {object} nativeEvent
 * @param {object} nativeEventTarget
 * @return {?SyntheticEvent}
 */ function constructSelectEvent(nativeEvent, nativeEventTarget) {
        // Ensure we have the right element, and that the user is not dragging a
        // selection (this matches native `select` event behavior). In HTML5, select
        // fires only on input and textarea thus if there's no focused element we
        // won't dispatch.
        var doc = getEventTargetDocument(nativeEventTarget);
        if (mouseDown || activeElement$1 == null || activeElement$1 !== getActiveElement(doc)) return null;
         // Only fire when selection has actually changed.
        var currentSelection = getSelection$1(activeElement$1);
        if (!lastSelection || !shallowEqual(lastSelection, currentSelection)) {
            lastSelection = currentSelection;
            var syntheticEvent = SyntheticEvent.getPooled(eventTypes$3.select, activeElementInst$1, nativeEvent, nativeEventTarget);
            syntheticEvent.type = "select";
            syntheticEvent.target = activeElement$1;
            accumulateTwoPhaseDispatches(syntheticEvent);
            return syntheticEvent;
        }
        return null;
    }
    /**
 * This plugin creates an `onSelect` event that normalizes select events
 * across form elements.
 *
 * Supported elements are:
 * - input (see `isTextInputElement`)
 * - textarea
 * - contentEditable
 *
 * This differs from native browser implementations in the following ways:
 * - Fires on contentEditable fields as well as inputs.
 * - Fires for collapsed selection.
 * - Fires after user input.
 */ var SelectEventPlugin = {
        eventTypes: eventTypes$3,
        extractEvents: function(topLevelType, targetInst, nativeEvent, nativeEventTarget, eventSystemFlags, container) {
            var containerOrDoc = container || getEventTargetDocument(nativeEventTarget); // Track whether all listeners exists for this plugin. If none exist, we do
            // not extract events. See #3639.
            if (!containerOrDoc || !isListeningToAllDependencies("onSelect", containerOrDoc)) return null;
            var targetNode = targetInst ? getNodeFromInstance$1(targetInst) : window;
            switch(topLevelType){
                // Track the input node that has focus.
                case TOP_FOCUS:
                    if (isTextInputElement(targetNode) || targetNode.contentEditable === "true") {
                        activeElement$1 = targetNode;
                        activeElementInst$1 = targetInst;
                        lastSelection = null;
                    }
                    break;
                case TOP_BLUR:
                    activeElement$1 = null;
                    activeElementInst$1 = null;
                    lastSelection = null;
                    break;
                // Don't fire the event while the user is dragging. This matches the
                // semantics of the native select event.
                case TOP_MOUSE_DOWN:
                    mouseDown = true;
                    break;
                case TOP_CONTEXT_MENU:
                case TOP_MOUSE_UP:
                case TOP_DRAG_END:
                    mouseDown = false;
                    return constructSelectEvent(nativeEvent, nativeEventTarget);
                // Chrome and IE fire non-standard event when selection is changed (and
                // sometimes when it hasn't). IE's event fires out of order with respect
                // to key and input events on deletion, so we discard it.
                //
                // Firefox doesn't support selectionchange, so check selection status
                // after each key entry. The selection changes after keydown and before
                // keyup, but we check on keydown as well in the case of holding down a
                // key, when multiple keydown events are fired but only one keyup is.
                // This is also our approach for IE handling, for the reason above.
                case TOP_SELECTION_CHANGE:
                    if (skipSelectionChangeEvent) break;
                // falls through
                case TOP_KEY_DOWN:
                case TOP_KEY_UP:
                    return constructSelectEvent(nativeEvent, nativeEventTarget);
            }
            return null;
        }
    };
    /**
 * @interface Event
 * @see http://www.w3.org/TR/css3-animations/#AnimationEvent-interface
 * @see https://developer.mozilla.org/en-US/docs/Web/API/AnimationEvent
 */ var SyntheticAnimationEvent = SyntheticEvent.extend({
        animationName: null,
        elapsedTime: null,
        pseudoElement: null
    });
    /**
 * @interface Event
 * @see http://www.w3.org/TR/clipboard-apis/
 */ var SyntheticClipboardEvent = SyntheticEvent.extend({
        clipboardData: function(event) {
            return "clipboardData" in event ? event.clipboardData : window.clipboardData;
        }
    });
    /**
 * @interface FocusEvent
 * @see http://www.w3.org/TR/DOM-Level-3-Events/
 */ var SyntheticFocusEvent = SyntheticUIEvent.extend({
        relatedTarget: null
    });
    /**
 * `charCode` represents the actual "character code" and is safe to use with
 * `String.fromCharCode`. As such, only keys that correspond to printable
 * characters produce a valid `charCode`, the only exception to this is Enter.
 * The Tab-key is considered non-printable and does not have a `charCode`,
 * presumably because it does not produce a tab-character in browsers.
 *
 * @param {object} nativeEvent Native browser event.
 * @return {number} Normalized `charCode` property.
 */ function getEventCharCode(nativeEvent) {
        var charCode;
        var keyCode = nativeEvent.keyCode;
        if ("charCode" in nativeEvent) {
            charCode = nativeEvent.charCode; // FF does not set `charCode` for the Enter-key, check against `keyCode`.
            if (charCode === 0 && keyCode === 13) charCode = 13;
        } else // IE8 does not implement `charCode`, but `keyCode` has the correct value.
        charCode = keyCode;
         // IE and Edge (on Windows) and Chrome / Safari (on Windows and Linux)
        // report Enter as charCode 10 when ctrl is pressed.
        if (charCode === 10) charCode = 13;
         // Some non-printable keys are reported in `charCode`/`keyCode`, discard them.
        // Must not discard the (non-)printable Enter-key.
        if (charCode >= 32 || charCode === 13) return charCode;
        return 0;
    }
    /**
 * Normalization of deprecated HTML5 `key` values
 * @see https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent#Key_names
 */ var normalizeKey = {
        Esc: "Escape",
        Spacebar: " ",
        Left: "ArrowLeft",
        Up: "ArrowUp",
        Right: "ArrowRight",
        Down: "ArrowDown",
        Del: "Delete",
        Win: "OS",
        Menu: "ContextMenu",
        Apps: "ContextMenu",
        Scroll: "ScrollLock",
        MozPrintableKey: "Unidentified"
    };
    /**
 * Translation from legacy `keyCode` to HTML5 `key`
 * Only special keys supported, all others depend on keyboard layout or browser
 * @see https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent#Key_names
 */ var translateToKey = {
        "8": "Backspace",
        "9": "Tab",
        "12": "Clear",
        "13": "Enter",
        "16": "Shift",
        "17": "Control",
        "18": "Alt",
        "19": "Pause",
        "20": "CapsLock",
        "27": "Escape",
        "32": " ",
        "33": "PageUp",
        "34": "PageDown",
        "35": "End",
        "36": "Home",
        "37": "ArrowLeft",
        "38": "ArrowUp",
        "39": "ArrowRight",
        "40": "ArrowDown",
        "45": "Insert",
        "46": "Delete",
        "112": "F1",
        "113": "F2",
        "114": "F3",
        "115": "F4",
        "116": "F5",
        "117": "F6",
        "118": "F7",
        "119": "F8",
        "120": "F9",
        "121": "F10",
        "122": "F11",
        "123": "F12",
        "144": "NumLock",
        "145": "ScrollLock",
        "224": "Meta"
    };
    /**
 * @param {object} nativeEvent Native browser event.
 * @return {string} Normalized `key` property.
 */ function getEventKey(nativeEvent) {
        if (nativeEvent.key) {
            // Normalize inconsistent values reported by browsers due to
            // implementations of a working draft specification.
            // FireFox implements `key` but returns `MozPrintableKey` for all
            // printable characters (normalized to `Unidentified`), ignore it.
            var key = normalizeKey[nativeEvent.key] || nativeEvent.key;
            if (key !== "Unidentified") return key;
        } // Browser does not implement `key`, polyfill as much of it as we can.
        if (nativeEvent.type === "keypress") {
            var charCode = getEventCharCode(nativeEvent); // The enter-key is technically both printable and non-printable and can
            // thus be captured by `keypress`, no other non-printable key should.
            return charCode === 13 ? "Enter" : String.fromCharCode(charCode);
        }
        if (nativeEvent.type === "keydown" || nativeEvent.type === "keyup") // While user keyboard layout determines the actual meaning of each
        // `keyCode` value, almost all function keys have a universal value.
        return translateToKey[nativeEvent.keyCode] || "Unidentified";
        return "";
    }
    /**
 * @interface KeyboardEvent
 * @see http://www.w3.org/TR/DOM-Level-3-Events/
 */ var SyntheticKeyboardEvent = SyntheticUIEvent.extend({
        key: getEventKey,
        location: null,
        ctrlKey: null,
        shiftKey: null,
        altKey: null,
        metaKey: null,
        repeat: null,
        locale: null,
        getModifierState: getEventModifierState,
        // Legacy Interface
        charCode: function(event) {
            // `charCode` is the result of a KeyPress event and represents the value of
            // the actual printable character.
            // KeyPress is deprecated, but its replacement is not yet final and not
            // implemented in any major browser. Only KeyPress has charCode.
            if (event.type === "keypress") return getEventCharCode(event);
            return 0;
        },
        keyCode: function(event) {
            // `keyCode` is the result of a KeyDown/Up event and represents the value of
            // physical keyboard key.
            // The actual meaning of the value depends on the users' keyboard layout
            // which cannot be detected. Assuming that it is a US keyboard layout
            // provides a surprisingly accurate mapping for US and European users.
            // Due to this, it is left to the user to implement at this time.
            if (event.type === "keydown" || event.type === "keyup") return event.keyCode;
            return 0;
        },
        which: function(event) {
            // `which` is an alias for either `keyCode` or `charCode` depending on the
            // type of the event.
            if (event.type === "keypress") return getEventCharCode(event);
            if (event.type === "keydown" || event.type === "keyup") return event.keyCode;
            return 0;
        }
    });
    /**
 * @interface DragEvent
 * @see http://www.w3.org/TR/DOM-Level-3-Events/
 */ var SyntheticDragEvent = SyntheticMouseEvent.extend({
        dataTransfer: null
    });
    /**
 * @interface TouchEvent
 * @see http://www.w3.org/TR/touch-events/
 */ var SyntheticTouchEvent = SyntheticUIEvent.extend({
        touches: null,
        targetTouches: null,
        changedTouches: null,
        altKey: null,
        metaKey: null,
        ctrlKey: null,
        shiftKey: null,
        getModifierState: getEventModifierState
    });
    /**
 * @interface Event
 * @see http://www.w3.org/TR/2009/WD-css3-transitions-20090320/#transition-events-
 * @see https://developer.mozilla.org/en-US/docs/Web/API/TransitionEvent
 */ var SyntheticTransitionEvent = SyntheticEvent.extend({
        propertyName: null,
        elapsedTime: null,
        pseudoElement: null
    });
    /**
 * @interface WheelEvent
 * @see http://www.w3.org/TR/DOM-Level-3-Events/
 */ var SyntheticWheelEvent = SyntheticMouseEvent.extend({
        deltaX: function(event) {
            return "deltaX" in event ? event.deltaX : "wheelDeltaX" in event ? -event.wheelDeltaX : 0;
        },
        deltaY: function(event) {
            return "deltaY" in event ? event.deltaY : "wheelDeltaY" in event ? -event.wheelDeltaY : "wheelDelta" in event ? -event.wheelDelta : 0;
        },
        deltaZ: null,
        // Browsers without "deltaMode" is reporting in raw wheel delta where one
        // notch on the scroll is always +/- 120, roughly equivalent to pixels.
        // A good approximation of DOM_DELTA_LINE (1) is 5% of viewport size or
        // ~40 pixels, for DOM_DELTA_SCREEN (2) it is 87.5% of viewport size.
        deltaMode: null
    });
    var knownHTMLTopLevelTypes = [
        TOP_ABORT,
        TOP_CANCEL,
        TOP_CAN_PLAY,
        TOP_CAN_PLAY_THROUGH,
        TOP_CLOSE,
        TOP_DURATION_CHANGE,
        TOP_EMPTIED,
        TOP_ENCRYPTED,
        TOP_ENDED,
        TOP_ERROR,
        TOP_INPUT,
        TOP_INVALID,
        TOP_LOAD,
        TOP_LOADED_DATA,
        TOP_LOADED_METADATA,
        TOP_LOAD_START,
        TOP_PAUSE,
        TOP_PLAY,
        TOP_PLAYING,
        TOP_PROGRESS,
        TOP_RATE_CHANGE,
        TOP_RESET,
        TOP_SEEKED,
        TOP_SEEKING,
        TOP_STALLED,
        TOP_SUBMIT,
        TOP_SUSPEND,
        TOP_TIME_UPDATE,
        TOP_TOGGLE,
        TOP_VOLUME_CHANGE,
        TOP_WAITING
    ];
    var SimpleEventPlugin = {
        // simpleEventPluginEventTypes gets populated from
        // the DOMEventProperties module.
        eventTypes: simpleEventPluginEventTypes,
        extractEvents: function(topLevelType, targetInst, nativeEvent, nativeEventTarget, eventSystemFlags) {
            var dispatchConfig = topLevelEventsToDispatchConfig.get(topLevelType);
            if (!dispatchConfig) return null;
            var EventConstructor;
            switch(topLevelType){
                case TOP_KEY_PRESS:
                    // Firefox creates a keypress event for function keys too. This removes
                    // the unwanted keypress events. Enter is however both printable and
                    // non-printable. One would expect Tab to be as well (but it isn't).
                    if (getEventCharCode(nativeEvent) === 0) return null;
                /* falls through */ case TOP_KEY_DOWN:
                case TOP_KEY_UP:
                    EventConstructor = SyntheticKeyboardEvent;
                    break;
                case TOP_BLUR:
                case TOP_FOCUS:
                    EventConstructor = SyntheticFocusEvent;
                    break;
                case TOP_CLICK:
                    // Firefox creates a click event on right mouse clicks. This removes the
                    // unwanted click events.
                    if (nativeEvent.button === 2) return null;
                /* falls through */ case TOP_AUX_CLICK:
                case TOP_DOUBLE_CLICK:
                case TOP_MOUSE_DOWN:
                case TOP_MOUSE_MOVE:
                case TOP_MOUSE_UP:
                /* falls through */ case TOP_MOUSE_OUT:
                case TOP_MOUSE_OVER:
                case TOP_CONTEXT_MENU:
                    EventConstructor = SyntheticMouseEvent;
                    break;
                case TOP_DRAG:
                case TOP_DRAG_END:
                case TOP_DRAG_ENTER:
                case TOP_DRAG_EXIT:
                case TOP_DRAG_LEAVE:
                case TOP_DRAG_OVER:
                case TOP_DRAG_START:
                case TOP_DROP:
                    EventConstructor = SyntheticDragEvent;
                    break;
                case TOP_TOUCH_CANCEL:
                case TOP_TOUCH_END:
                case TOP_TOUCH_MOVE:
                case TOP_TOUCH_START:
                    EventConstructor = SyntheticTouchEvent;
                    break;
                case TOP_ANIMATION_END:
                case TOP_ANIMATION_ITERATION:
                case TOP_ANIMATION_START:
                    EventConstructor = SyntheticAnimationEvent;
                    break;
                case TOP_TRANSITION_END:
                    EventConstructor = SyntheticTransitionEvent;
                    break;
                case TOP_SCROLL:
                    EventConstructor = SyntheticUIEvent;
                    break;
                case TOP_WHEEL:
                    EventConstructor = SyntheticWheelEvent;
                    break;
                case TOP_COPY:
                case TOP_CUT:
                case TOP_PASTE:
                    EventConstructor = SyntheticClipboardEvent;
                    break;
                case TOP_GOT_POINTER_CAPTURE:
                case TOP_LOST_POINTER_CAPTURE:
                case TOP_POINTER_CANCEL:
                case TOP_POINTER_DOWN:
                case TOP_POINTER_MOVE:
                case TOP_POINTER_OUT:
                case TOP_POINTER_OVER:
                case TOP_POINTER_UP:
                    EventConstructor = SyntheticPointerEvent;
                    break;
                default:
                    if (knownHTMLTopLevelTypes.indexOf(topLevelType) === -1) error("SimpleEventPlugin: Unhandled event type, `%s`. This warning is likely caused by a bug in React. Please file an issue.", topLevelType);
                    // @see http://www.w3.org/TR/html5/index.html#events-0
                    EventConstructor = SyntheticEvent;
                    break;
            }
            var event = EventConstructor.getPooled(dispatchConfig, targetInst, nativeEvent, nativeEventTarget);
            accumulateTwoPhaseDispatches(event);
            return event;
        }
    };
    /**
 * Specifies a deterministic ordering of `EventPlugin`s. A convenient way to
 * reason about plugins, without having to package every one of them. This
 * is better than having plugins be ordered in the same order that they
 * are injected because that ordering would be influenced by the packaging order.
 * `ResponderEventPlugin` must occur before `SimpleEventPlugin` so that
 * preventing default on events is convenient in `SimpleEventPlugin` handlers.
 */ var DOMEventPluginOrder = [
        "ResponderEventPlugin",
        "SimpleEventPlugin",
        "EnterLeaveEventPlugin",
        "ChangeEventPlugin",
        "SelectEventPlugin",
        "BeforeInputEventPlugin"
    ];
    /**
 * Inject modules for resolving DOM hierarchy and plugin ordering.
 */ injectEventPluginOrder(DOMEventPluginOrder);
    setComponentTree(getFiberCurrentPropsFromNode$1, getInstanceFromNode$1, getNodeFromInstance$1);
    /**
 * Some important event plugins included by default (without having to require
 * them).
 */ injectEventPluginsByName({
        SimpleEventPlugin: SimpleEventPlugin,
        EnterLeaveEventPlugin: EnterLeaveEventPlugin,
        ChangeEventPlugin: ChangeEventPlugin,
        SelectEventPlugin: SelectEventPlugin,
        BeforeInputEventPlugin: BeforeInputEventPlugin
    });
    // Prefix measurements so that it's possible to filter them.
    // Longer prefixes are hard to read in DevTools.
    var reactEmoji = "\u269B";
    var warningEmoji = "\u26D4";
    var supportsUserTiming = typeof performance !== "undefined" && typeof performance.mark === "function" && typeof performance.clearMarks === "function" && typeof performance.measure === "function" && typeof performance.clearMeasures === "function"; // Keep track of current fiber so that we know the path to unwind on pause.
    // TODO: this looks the same as nextUnitOfWork in scheduler. Can we unify them?
    var currentFiber = null; // If we're in the middle of user code, which fiber and method is it?
    // Reusing `currentFiber` would be confusing for this because user code fiber
    // can change during commit phase too, but we don't need to unwind it (since
    // lifecycles in the commit phase don't resemble a tree).
    var currentPhase = null;
    var currentPhaseFiber = null; // Did lifecycle hook schedule an update? This is often a performance problem,
    // so we will keep track of it, and include it in the report.
    // Track commits caused by cascading updates.
    var isCommitting = false;
    var hasScheduledUpdateInCurrentCommit = false;
    var hasScheduledUpdateInCurrentPhase = false;
    var commitCountInCurrentWorkLoop = 0;
    var effectCountInCurrentCommit = 0;
    // to avoid stretch the commit phase with measurement overhead.
    var labelsInCurrentCommit = new Set();
    var formatMarkName = function(markName) {
        return reactEmoji + " " + markName;
    };
    var formatLabel = function(label, warning) {
        var prefix = warning ? warningEmoji + " " : reactEmoji + " ";
        var suffix = warning ? " Warning: " + warning : "";
        return "" + prefix + label + suffix;
    };
    var beginMark = function(markName) {
        performance.mark(formatMarkName(markName));
    };
    var clearMark = function(markName) {
        performance.clearMarks(formatMarkName(markName));
    };
    var endMark = function(label, markName, warning) {
        var formattedMarkName = formatMarkName(markName);
        var formattedLabel = formatLabel(label, warning);
        try {
            performance.measure(formattedLabel, formattedMarkName);
        } catch (err) {} // If previous mark was missing for some reason, this will throw.
        // This could only happen if React crashed in an unexpected place earlier.
        // Don't pile on with more errors.
        // Clear marks immediately to avoid growing buffer.
        performance.clearMarks(formattedMarkName);
        performance.clearMeasures(formattedLabel);
    };
    var getFiberMarkName = function(label, debugID) {
        return label + " (#" + debugID + ")";
    };
    var getFiberLabel = function(componentName, isMounted, phase) {
        if (phase === null) // These are composite component total time measurements.
        return componentName + " [" + (isMounted ? "update" : "mount") + "]";
        else // Composite component methods.
        return componentName + "." + phase;
    };
    var beginFiberMark = function(fiber, phase) {
        var componentName = getComponentName(fiber.type) || "Unknown";
        var debugID = fiber._debugID;
        var isMounted = fiber.alternate !== null;
        var label = getFiberLabel(componentName, isMounted, phase);
        if (isCommitting && labelsInCurrentCommit.has(label)) // During the commit phase, we don't show duplicate labels because
        // there is a fixed overhead for every measurement, and we don't
        // want to stretch the commit phase beyond necessary.
        return false;
        labelsInCurrentCommit.add(label);
        var markName = getFiberMarkName(label, debugID);
        beginMark(markName);
        return true;
    };
    var clearFiberMark = function(fiber, phase) {
        var componentName = getComponentName(fiber.type) || "Unknown";
        var debugID = fiber._debugID;
        var isMounted = fiber.alternate !== null;
        var label = getFiberLabel(componentName, isMounted, phase);
        var markName = getFiberMarkName(label, debugID);
        clearMark(markName);
    };
    var endFiberMark = function(fiber, phase, warning) {
        var componentName = getComponentName(fiber.type) || "Unknown";
        var debugID = fiber._debugID;
        var isMounted = fiber.alternate !== null;
        var label = getFiberLabel(componentName, isMounted, phase);
        var markName = getFiberMarkName(label, debugID);
        endMark(label, markName, warning);
    };
    var shouldIgnoreFiber = function(fiber) {
        // Host components should be skipped in the timeline.
        // We could check typeof fiber.type, but does this work with RN?
        switch(fiber.tag){
            case HostRoot:
            case HostComponent:
            case HostText:
            case HostPortal:
            case Fragment:
            case ContextProvider:
            case ContextConsumer:
            case Mode:
                return true;
            default:
                return false;
        }
    };
    var clearPendingPhaseMeasurement = function() {
        if (currentPhase !== null && currentPhaseFiber !== null) clearFiberMark(currentPhaseFiber, currentPhase);
        currentPhaseFiber = null;
        currentPhase = null;
        hasScheduledUpdateInCurrentPhase = false;
    };
    var pauseTimers = function() {
        // Stops all currently active measurements so that they can be resumed
        // if we continue in a later deferred loop from the same unit of work.
        var fiber = currentFiber;
        while(fiber){
            if (fiber._debugIsCurrentlyTiming) endFiberMark(fiber, null, null);
            fiber = fiber.return;
        }
    };
    var resumeTimersRecursively = function(fiber) {
        if (fiber.return !== null) resumeTimersRecursively(fiber.return);
        if (fiber._debugIsCurrentlyTiming) beginFiberMark(fiber, null);
    };
    var resumeTimers = function() {
        // Resumes all measurements that were active during the last deferred loop.
        if (currentFiber !== null) resumeTimersRecursively(currentFiber);
    };
    function recordEffect() {
        effectCountInCurrentCommit++;
    }
    function recordScheduleUpdate() {
        if (isCommitting) hasScheduledUpdateInCurrentCommit = true;
        if (currentPhase !== null && currentPhase !== "componentWillMount" && currentPhase !== "componentWillReceiveProps") hasScheduledUpdateInCurrentPhase = true;
    }
    function startWorkTimer(fiber) {
        if (!supportsUserTiming || shouldIgnoreFiber(fiber)) return;
         // If we pause, this is the fiber to unwind from.
        currentFiber = fiber;
        if (!beginFiberMark(fiber, null)) return;
        fiber._debugIsCurrentlyTiming = true;
    }
    function cancelWorkTimer(fiber) {
        if (!supportsUserTiming || shouldIgnoreFiber(fiber)) return;
         // Remember we shouldn't complete measurement for this fiber.
        // Otherwise flamechart will be deep even for small updates.
        fiber._debugIsCurrentlyTiming = false;
        clearFiberMark(fiber, null);
    }
    function stopWorkTimer(fiber) {
        if (!supportsUserTiming || shouldIgnoreFiber(fiber)) return;
         // If we pause, its parent is the fiber to unwind from.
        currentFiber = fiber.return;
        if (!fiber._debugIsCurrentlyTiming) return;
        fiber._debugIsCurrentlyTiming = false;
        endFiberMark(fiber, null, null);
    }
    function stopFailedWorkTimer(fiber) {
        if (!supportsUserTiming || shouldIgnoreFiber(fiber)) return;
         // If we pause, its parent is the fiber to unwind from.
        currentFiber = fiber.return;
        if (!fiber._debugIsCurrentlyTiming) return;
        fiber._debugIsCurrentlyTiming = false;
        var warning = fiber.tag === SuspenseComponent ? "Rendering was suspended" : "An error was thrown inside this error boundary";
        endFiberMark(fiber, null, warning);
    }
    function startPhaseTimer(fiber, phase) {
        if (!supportsUserTiming) return;
        clearPendingPhaseMeasurement();
        if (!beginFiberMark(fiber, phase)) return;
        currentPhaseFiber = fiber;
        currentPhase = phase;
    }
    function stopPhaseTimer() {
        if (!supportsUserTiming) return;
        if (currentPhase !== null && currentPhaseFiber !== null) {
            var warning = hasScheduledUpdateInCurrentPhase ? "Scheduled a cascading update" : null;
            endFiberMark(currentPhaseFiber, currentPhase, warning);
        }
        currentPhase = null;
        currentPhaseFiber = null;
    }
    function startWorkLoopTimer(nextUnitOfWork) {
        currentFiber = nextUnitOfWork;
        if (!supportsUserTiming) return;
        commitCountInCurrentWorkLoop = 0; // This is top level call.
        // Any other measurements are performed within.
        beginMark("(React Tree Reconciliation)"); // Resume any measurements that were in progress during the last loop.
        resumeTimers();
    }
    function stopWorkLoopTimer(interruptedBy, didCompleteRoot) {
        if (!supportsUserTiming) return;
        var warning = null;
        if (interruptedBy !== null) {
            if (interruptedBy.tag === HostRoot) warning = "A top-level update interrupted the previous render";
            else {
                var componentName = getComponentName(interruptedBy.type) || "Unknown";
                warning = "An update to " + componentName + " interrupted the previous render";
            }
        } else if (commitCountInCurrentWorkLoop > 1) warning = "There were cascading updates";
        commitCountInCurrentWorkLoop = 0;
        var label = didCompleteRoot ? "(React Tree Reconciliation: Completed Root)" : "(React Tree Reconciliation: Yielded)"; // Pause any measurements until the next loop.
        pauseTimers();
        endMark(label, "(React Tree Reconciliation)", warning);
    }
    function startCommitTimer() {
        if (!supportsUserTiming) return;
        isCommitting = true;
        hasScheduledUpdateInCurrentCommit = false;
        labelsInCurrentCommit.clear();
        beginMark("(Committing Changes)");
    }
    function stopCommitTimer() {
        if (!supportsUserTiming) return;
        var warning = null;
        if (hasScheduledUpdateInCurrentCommit) warning = "Lifecycle hook scheduled a cascading update";
        else if (commitCountInCurrentWorkLoop > 0) warning = "Caused by a cascading update in earlier commit";
        hasScheduledUpdateInCurrentCommit = false;
        commitCountInCurrentWorkLoop++;
        isCommitting = false;
        labelsInCurrentCommit.clear();
        endMark("(Committing Changes)", "(Committing Changes)", warning);
    }
    function startCommitSnapshotEffectsTimer() {
        if (!supportsUserTiming) return;
        effectCountInCurrentCommit = 0;
        beginMark("(Committing Snapshot Effects)");
    }
    function stopCommitSnapshotEffectsTimer() {
        if (!supportsUserTiming) return;
        var count = effectCountInCurrentCommit;
        effectCountInCurrentCommit = 0;
        endMark("(Committing Snapshot Effects: " + count + " Total)", "(Committing Snapshot Effects)", null);
    }
    function startCommitHostEffectsTimer() {
        if (!supportsUserTiming) return;
        effectCountInCurrentCommit = 0;
        beginMark("(Committing Host Effects)");
    }
    function stopCommitHostEffectsTimer() {
        if (!supportsUserTiming) return;
        var count = effectCountInCurrentCommit;
        effectCountInCurrentCommit = 0;
        endMark("(Committing Host Effects: " + count + " Total)", "(Committing Host Effects)", null);
    }
    function startCommitLifeCyclesTimer() {
        if (!supportsUserTiming) return;
        effectCountInCurrentCommit = 0;
        beginMark("(Calling Lifecycle Methods)");
    }
    function stopCommitLifeCyclesTimer() {
        if (!supportsUserTiming) return;
        var count = effectCountInCurrentCommit;
        effectCountInCurrentCommit = 0;
        endMark("(Calling Lifecycle Methods: " + count + " Total)", "(Calling Lifecycle Methods)", null);
    }
    var valueStack = [];
    var fiberStack;
    fiberStack = [];
    var index = -1;
    function createCursor(defaultValue) {
        return {
            current: defaultValue
        };
    }
    function pop(cursor, fiber) {
        if (index < 0) {
            error("Unexpected pop.");
            return;
        }
        if (fiber !== fiberStack[index]) error("Unexpected Fiber popped.");
        cursor.current = valueStack[index];
        valueStack[index] = null;
        fiberStack[index] = null;
        index--;
    }
    function push(cursor, value, fiber) {
        index++;
        valueStack[index] = cursor.current;
        fiberStack[index] = fiber;
        cursor.current = value;
    }
    var warnedAboutMissingGetChildContext;
    warnedAboutMissingGetChildContext = {};
    var emptyContextObject = {};
    Object.freeze(emptyContextObject);
    var contextStackCursor = createCursor(emptyContextObject); // A cursor to a boolean indicating whether the context has changed.
    var didPerformWorkStackCursor = createCursor(false); // Keep track of the previous context object that was on the stack.
    // We use this to get access to the parent context after we have already
    // pushed the next context provider, and now need to merge their contexts.
    var previousContext = emptyContextObject;
    function getUnmaskedContext(workInProgress, Component, didPushOwnContextIfProvider) {
        if (didPushOwnContextIfProvider && isContextProvider(Component)) // If the fiber is a context provider itself, when we read its context
        // we may have already pushed its own child context on the stack. A context
        // provider should not "see" its own child context. Therefore we read the
        // previous (parent) context instead for a context provider.
        return previousContext;
        return contextStackCursor.current;
    }
    function cacheContext(workInProgress, unmaskedContext, maskedContext) {
        var instance = workInProgress.stateNode;
        instance.__reactInternalMemoizedUnmaskedChildContext = unmaskedContext;
        instance.__reactInternalMemoizedMaskedChildContext = maskedContext;
    }
    function getMaskedContext(workInProgress, unmaskedContext) {
        var type = workInProgress.type;
        var contextTypes = type.contextTypes;
        if (!contextTypes) return emptyContextObject;
         // Avoid recreating masked context unless unmasked context has changed.
        // Failing to do this will result in unnecessary calls to componentWillReceiveProps.
        // This may trigger infinite loops if componentWillReceiveProps calls setState.
        var instance = workInProgress.stateNode;
        if (instance && instance.__reactInternalMemoizedUnmaskedChildContext === unmaskedContext) return instance.__reactInternalMemoizedMaskedChildContext;
        var context = {};
        for(var key in contextTypes)context[key] = unmaskedContext[key];
        var name = getComponentName(type) || "Unknown";
        checkPropTypes(contextTypes, context, "context", name, getCurrentFiberStackInDev);
        // Context is created before the class component is instantiated so check for instance.
        if (instance) cacheContext(workInProgress, unmaskedContext, context);
        return context;
    }
    function hasContextChanged() {
        return didPerformWorkStackCursor.current;
    }
    function isContextProvider(type) {
        var childContextTypes = type.childContextTypes;
        return childContextTypes !== null && childContextTypes !== undefined;
    }
    function popContext(fiber) {
        pop(didPerformWorkStackCursor, fiber);
        pop(contextStackCursor, fiber);
    }
    function popTopLevelContextObject(fiber) {
        pop(didPerformWorkStackCursor, fiber);
        pop(contextStackCursor, fiber);
    }
    function pushTopLevelContextObject(fiber, context, didChange) {
        if (!(contextStackCursor.current === emptyContextObject)) throw Error("Unexpected context found on stack. This error is likely caused by a bug in React. Please file an issue.");
        push(contextStackCursor, context, fiber);
        push(didPerformWorkStackCursor, didChange, fiber);
    }
    function processChildContext(fiber, type, parentContext) {
        var instance = fiber.stateNode;
        var childContextTypes = type.childContextTypes; // TODO (bvaughn) Replace this behavior with an invariant() in the future.
        // It has only been added in Fiber to match the (unintentional) behavior in Stack.
        if (typeof instance.getChildContext !== "function") {
            var componentName = getComponentName(type) || "Unknown";
            if (!warnedAboutMissingGetChildContext[componentName]) {
                warnedAboutMissingGetChildContext[componentName] = true;
                error("%s.childContextTypes is specified but there is no getChildContext() method on the instance. You can either define getChildContext() on %s or remove childContextTypes from it.", componentName, componentName);
            }
            return parentContext;
        }
        var childContext;
        startPhaseTimer(fiber, "getChildContext");
        childContext = instance.getChildContext();
        stopPhaseTimer();
        for(var contextKey in childContext){
            if (!(contextKey in childContextTypes)) throw Error((getComponentName(type) || "Unknown") + '.getChildContext(): key "' + contextKey + '" is not defined in childContextTypes.');
        }
        var name = getComponentName(type) || "Unknown";
        checkPropTypes(childContextTypes, childContext, "child context", name, // somebody calls unstable_renderSubtreeIntoContainer() and we process
        // context from the parent component instance. The stack will be missing
        // because it's outside of the reconciliation, and so the pointer has not
        // been set. This is rare and doesn't matter. We'll also remove that API.
        getCurrentFiberStackInDev);
        return _assign({}, parentContext, {}, childContext);
    }
    function pushContextProvider(workInProgress) {
        var instance = workInProgress.stateNode; // We push the context as early as possible to ensure stack integrity.
        // If the instance does not exist yet, we will push null at first,
        // and replace it on the stack later when invalidating the context.
        var memoizedMergedChildContext = instance && instance.__reactInternalMemoizedMergedChildContext || emptyContextObject; // Remember the parent context so we can merge with it later.
        // Inherit the parent's did-perform-work value to avoid inadvertently blocking updates.
        previousContext = contextStackCursor.current;
        push(contextStackCursor, memoizedMergedChildContext, workInProgress);
        push(didPerformWorkStackCursor, didPerformWorkStackCursor.current, workInProgress);
        return true;
    }
    function invalidateContextProvider(workInProgress, type, didChange) {
        var instance = workInProgress.stateNode;
        if (!instance) throw Error("Expected to have an instance by this point. This error is likely caused by a bug in React. Please file an issue.");
        if (didChange) {
            // Merge parent and own context.
            // Skip this if we're not updating due to sCU.
            // This avoids unnecessarily recomputing memoized values.
            var mergedContext = processChildContext(workInProgress, type, previousContext);
            instance.__reactInternalMemoizedMergedChildContext = mergedContext; // Replace the old (or empty) context with the new one.
            // It is important to unwind the context in the reverse order.
            pop(didPerformWorkStackCursor, workInProgress);
            pop(contextStackCursor, workInProgress); // Now push the new context and mark that it has changed.
            push(contextStackCursor, mergedContext, workInProgress);
            push(didPerformWorkStackCursor, didChange, workInProgress);
        } else {
            pop(didPerformWorkStackCursor, workInProgress);
            push(didPerformWorkStackCursor, didChange, workInProgress);
        }
    }
    function findCurrentUnmaskedContext(fiber) {
        // Currently this is only used with renderSubtreeIntoContainer; not sure if it
        // makes sense elsewhere
        if (!(isFiberMounted(fiber) && fiber.tag === ClassComponent)) throw Error("Expected subtree parent to be a mounted class component. This error is likely caused by a bug in React. Please file an issue.");
        var node = fiber;
        do {
            switch(node.tag){
                case HostRoot:
                    return node.stateNode.context;
                case ClassComponent:
                    var Component = node.type;
                    if (isContextProvider(Component)) return node.stateNode.__reactInternalMemoizedMergedChildContext;
                    break;
            }
            node = node.return;
        }while (node !== null);
        throw Error("Found unexpected detached subtree parent. This error is likely caused by a bug in React. Please file an issue.");
    }
    var LegacyRoot = 0;
    var BlockingRoot = 1;
    var ConcurrentRoot = 2;
    var Scheduler_runWithPriority = Scheduler.unstable_runWithPriority, Scheduler_scheduleCallback = Scheduler.unstable_scheduleCallback, Scheduler_cancelCallback = Scheduler.unstable_cancelCallback, Scheduler_shouldYield = Scheduler.unstable_shouldYield, Scheduler_requestPaint = Scheduler.unstable_requestPaint, Scheduler_now = Scheduler.unstable_now, Scheduler_getCurrentPriorityLevel = Scheduler.unstable_getCurrentPriorityLevel, Scheduler_ImmediatePriority = Scheduler.unstable_ImmediatePriority, Scheduler_UserBlockingPriority = Scheduler.unstable_UserBlockingPriority, Scheduler_NormalPriority = Scheduler.unstable_NormalPriority, Scheduler_LowPriority = Scheduler.unstable_LowPriority, Scheduler_IdlePriority = Scheduler.unstable_IdlePriority;
    // Provide explicit error message when production+profiling bundle of e.g.
    // react-dom is used with production (non-profiling) bundle of
    // scheduler/tracing
    if (!(tracing.__interactionsRef != null && tracing.__interactionsRef.current != null)) throw Error("It is not supported to run the profiling version of a renderer (for example, `react-dom/profiling`) without also replacing the `scheduler/tracing` module with `scheduler/tracing-profiling`. Your bundler might have a setting for aliasing both modules. Learn more at http://fb.me/react-profiling");
    var fakeCallbackNode = {}; // Except for NoPriority, these correspond to Scheduler priorities. We use
    // ascending numbers so we can compare them like numbers. They start at 90 to
    // avoid clashing with Scheduler's priorities.
    var ImmediatePriority = 99;
    var UserBlockingPriority$1 = 98;
    var NormalPriority = 97;
    var LowPriority = 96;
    var IdlePriority = 95; // NoPriority is the absence of priority. Also React-only.
    var NoPriority = 90;
    var shouldYield = Scheduler_shouldYield;
    var requestPaint = Scheduler_requestPaint !== undefined ? Scheduler_requestPaint : function() {};
    var syncQueue = null;
    var immediateQueueCallbackNode = null;
    var isFlushingSyncQueue = false;
    var initialTimeMs = Scheduler_now(); // If the initial timestamp is reasonably small, use Scheduler's `now` directly.
    // This will be the case for modern browsers that support `performance.now`. In
    // older browsers, Scheduler falls back to `Date.now`, which returns a Unix
    // timestamp. In that case, subtract the module initialization time to simulate
    // the behavior of performance.now and keep our times small enough to fit
    // within 32 bits.
    // TODO: Consider lifting this into Scheduler.
    var now = initialTimeMs < 10000 ? Scheduler_now : function() {
        return Scheduler_now() - initialTimeMs;
    };
    function getCurrentPriorityLevel() {
        switch(Scheduler_getCurrentPriorityLevel()){
            case Scheduler_ImmediatePriority:
                return ImmediatePriority;
            case Scheduler_UserBlockingPriority:
                return UserBlockingPriority$1;
            case Scheduler_NormalPriority:
                return NormalPriority;
            case Scheduler_LowPriority:
                return LowPriority;
            case Scheduler_IdlePriority:
                return IdlePriority;
            default:
                throw Error("Unknown priority level.");
        }
    }
    function reactPriorityToSchedulerPriority(reactPriorityLevel) {
        switch(reactPriorityLevel){
            case ImmediatePriority:
                return Scheduler_ImmediatePriority;
            case UserBlockingPriority$1:
                return Scheduler_UserBlockingPriority;
            case NormalPriority:
                return Scheduler_NormalPriority;
            case LowPriority:
                return Scheduler_LowPriority;
            case IdlePriority:
                return Scheduler_IdlePriority;
            default:
                throw Error("Unknown priority level.");
        }
    }
    function runWithPriority$1(reactPriorityLevel, fn) {
        var priorityLevel = reactPriorityToSchedulerPriority(reactPriorityLevel);
        return Scheduler_runWithPriority(priorityLevel, fn);
    }
    function scheduleCallback(reactPriorityLevel, callback, options) {
        var priorityLevel = reactPriorityToSchedulerPriority(reactPriorityLevel);
        return Scheduler_scheduleCallback(priorityLevel, callback, options);
    }
    function scheduleSyncCallback(callback) {
        // Push this callback into an internal queue. We'll flush these either in
        // the next tick, or earlier if something calls `flushSyncCallbackQueue`.
        if (syncQueue === null) {
            syncQueue = [
                callback
            ]; // Flush the queue in the next tick, at the earliest.
            immediateQueueCallbackNode = Scheduler_scheduleCallback(Scheduler_ImmediatePriority, flushSyncCallbackQueueImpl);
        } else // Push onto existing queue. Don't need to schedule a callback because
        // we already scheduled one when we created the queue.
        syncQueue.push(callback);
        return fakeCallbackNode;
    }
    function cancelCallback(callbackNode) {
        if (callbackNode !== fakeCallbackNode) Scheduler_cancelCallback(callbackNode);
    }
    function flushSyncCallbackQueue() {
        if (immediateQueueCallbackNode !== null) {
            var node = immediateQueueCallbackNode;
            immediateQueueCallbackNode = null;
            Scheduler_cancelCallback(node);
        }
        flushSyncCallbackQueueImpl();
    }
    function flushSyncCallbackQueueImpl() {
        if (!isFlushingSyncQueue && syncQueue !== null) {
            // Prevent re-entrancy.
            isFlushingSyncQueue = true;
            var i = 0;
            try {
                var _isSync = true;
                var queue = syncQueue;
                runWithPriority$1(ImmediatePriority, function() {
                    for(; i < queue.length; i++){
                        var callback = queue[i];
                        do callback = callback(_isSync);
                        while (callback !== null);
                    }
                });
                syncQueue = null;
            } catch (error) {
                // If something throws, leave the remaining callbacks on the queue.
                if (syncQueue !== null) syncQueue = syncQueue.slice(i + 1);
                 // Resume flushing in the next tick
                Scheduler_scheduleCallback(Scheduler_ImmediatePriority, flushSyncCallbackQueue);
                throw error;
            } finally{
                isFlushingSyncQueue = false;
            }
        }
    }
    var NoMode = 0;
    var StrictMode = 1; // TODO: Remove BlockingMode and ConcurrentMode by reading from the root
    // tag instead
    var BlockingMode = 2;
    var ConcurrentMode = 4;
    var ProfileMode = 8;
    // Max 31 bit integer. The max integer size in V8 for 32-bit systems.
    // Math.pow(2, 30) - 1
    // 0b111111111111111111111111111111
    var MAX_SIGNED_31_BIT_INT = 1073741823;
    var NoWork = 0; // TODO: Think of a better name for Never. The key difference with Idle is that
    // Never work can be committed in an inconsistent state without tearing the UI.
    // The main example is offscreen content, like a hidden subtree. So one possible
    // name is Offscreen. However, it also includes dehydrated Suspense boundaries,
    // which are inconsistent in the sense that they haven't finished yet, but
    // aren't visibly inconsistent because the server rendered HTML matches what the
    // hydrated tree would look like.
    var Never = 1; // Idle is slightly higher priority than Never. It must completely finish in
    // order to be consistent.
    var Idle = 2; // Continuous Hydration is slightly higher than Idle and is used to increase
    // priority of hover targets.
    var ContinuousHydration = 3;
    var Sync = MAX_SIGNED_31_BIT_INT;
    var Batched = Sync - 1;
    var UNIT_SIZE = 10;
    var MAGIC_NUMBER_OFFSET = Batched - 1; // 1 unit of expiration time represents 10ms.
    function msToExpirationTime(ms) {
        // Always subtract from the offset so that we don't clash with the magic number for NoWork.
        return MAGIC_NUMBER_OFFSET - (ms / UNIT_SIZE | 0);
    }
    function expirationTimeToMs(expirationTime) {
        return (MAGIC_NUMBER_OFFSET - expirationTime) * UNIT_SIZE;
    }
    function ceiling(num, precision) {
        return ((num / precision | 0) + 1) * precision;
    }
    function computeExpirationBucket(currentTime, expirationInMs, bucketSizeMs) {
        return MAGIC_NUMBER_OFFSET - ceiling(MAGIC_NUMBER_OFFSET - currentTime + expirationInMs / UNIT_SIZE, bucketSizeMs / UNIT_SIZE);
    } // TODO: This corresponds to Scheduler's NormalPriority, not LowPriority. Update
    // the names to reflect.
    var LOW_PRIORITY_EXPIRATION = 5000;
    var LOW_PRIORITY_BATCH_SIZE = 250;
    function computeAsyncExpiration(currentTime) {
        return computeExpirationBucket(currentTime, LOW_PRIORITY_EXPIRATION, LOW_PRIORITY_BATCH_SIZE);
    }
    function computeSuspenseExpiration(currentTime, timeoutMs) {
        // TODO: Should we warn if timeoutMs is lower than the normal pri expiration time?
        return computeExpirationBucket(currentTime, timeoutMs, LOW_PRIORITY_BATCH_SIZE);
    } // We intentionally set a higher expiration time for interactive updates in
    // dev than in production.
    //
    // If the main thread is being blocked so long that you hit the expiration,
    // it's a problem that could be solved with better scheduling.
    //
    // People will be more likely to notice this and fix it with the long
    // expiration time in development.
    //
    // In production we opt for better UX at the risk of masking scheduling
    // problems, by expiring fast.
    var HIGH_PRIORITY_EXPIRATION = 500;
    var HIGH_PRIORITY_BATCH_SIZE = 100;
    function computeInteractiveExpiration(currentTime) {
        return computeExpirationBucket(currentTime, HIGH_PRIORITY_EXPIRATION, HIGH_PRIORITY_BATCH_SIZE);
    }
    function inferPriorityFromExpirationTime(currentTime, expirationTime) {
        if (expirationTime === Sync) return ImmediatePriority;
        if (expirationTime === Never || expirationTime === Idle) return IdlePriority;
        var msUntil = expirationTimeToMs(expirationTime) - expirationTimeToMs(currentTime);
        if (msUntil <= 0) return ImmediatePriority;
        if (msUntil <= HIGH_PRIORITY_EXPIRATION + HIGH_PRIORITY_BATCH_SIZE) return UserBlockingPriority$1;
        if (msUntil <= LOW_PRIORITY_EXPIRATION + LOW_PRIORITY_BATCH_SIZE) return NormalPriority;
         // TODO: Handle LowPriority
        // Assume anything lower has idle priority
        return IdlePriority;
    }
    var ReactStrictModeWarnings = {
        recordUnsafeLifecycleWarnings: function(fiber, instance) {},
        flushPendingUnsafeLifecycleWarnings: function() {},
        recordLegacyContextWarning: function(fiber, instance) {},
        flushLegacyContextWarning: function() {},
        discardPendingWarnings: function() {}
    };
    var findStrictRoot = function(fiber) {
        var maybeStrictRoot = null;
        var node = fiber;
        while(node !== null){
            if (node.mode & StrictMode) maybeStrictRoot = node;
            node = node.return;
        }
        return maybeStrictRoot;
    };
    var setToSortedString = function(set) {
        var array = [];
        set.forEach(function(value) {
            array.push(value);
        });
        return array.sort().join(", ");
    };
    var pendingComponentWillMountWarnings = [];
    var pendingUNSAFE_ComponentWillMountWarnings = [];
    var pendingComponentWillReceivePropsWarnings = [];
    var pendingUNSAFE_ComponentWillReceivePropsWarnings = [];
    var pendingComponentWillUpdateWarnings = [];
    var pendingUNSAFE_ComponentWillUpdateWarnings = []; // Tracks components we have already warned about.
    var didWarnAboutUnsafeLifecycles = new Set();
    ReactStrictModeWarnings.recordUnsafeLifecycleWarnings = function(fiber, instance) {
        // Dedup strategy: Warn once per component.
        if (didWarnAboutUnsafeLifecycles.has(fiber.type)) return;
        if (typeof instance.componentWillMount === "function" && // Don't warn about react-lifecycles-compat polyfilled components.
        instance.componentWillMount.__suppressDeprecationWarning !== true) pendingComponentWillMountWarnings.push(fiber);
        if (fiber.mode & StrictMode && typeof instance.UNSAFE_componentWillMount === "function") pendingUNSAFE_ComponentWillMountWarnings.push(fiber);
        if (typeof instance.componentWillReceiveProps === "function" && instance.componentWillReceiveProps.__suppressDeprecationWarning !== true) pendingComponentWillReceivePropsWarnings.push(fiber);
        if (fiber.mode & StrictMode && typeof instance.UNSAFE_componentWillReceiveProps === "function") pendingUNSAFE_ComponentWillReceivePropsWarnings.push(fiber);
        if (typeof instance.componentWillUpdate === "function" && instance.componentWillUpdate.__suppressDeprecationWarning !== true) pendingComponentWillUpdateWarnings.push(fiber);
        if (fiber.mode & StrictMode && typeof instance.UNSAFE_componentWillUpdate === "function") pendingUNSAFE_ComponentWillUpdateWarnings.push(fiber);
    };
    ReactStrictModeWarnings.flushPendingUnsafeLifecycleWarnings = function() {
        // We do an initial pass to gather component names
        var componentWillMountUniqueNames = new Set();
        if (pendingComponentWillMountWarnings.length > 0) {
            pendingComponentWillMountWarnings.forEach(function(fiber) {
                componentWillMountUniqueNames.add(getComponentName(fiber.type) || "Component");
                didWarnAboutUnsafeLifecycles.add(fiber.type);
            });
            pendingComponentWillMountWarnings = [];
        }
        var UNSAFE_componentWillMountUniqueNames = new Set();
        if (pendingUNSAFE_ComponentWillMountWarnings.length > 0) {
            pendingUNSAFE_ComponentWillMountWarnings.forEach(function(fiber) {
                UNSAFE_componentWillMountUniqueNames.add(getComponentName(fiber.type) || "Component");
                didWarnAboutUnsafeLifecycles.add(fiber.type);
            });
            pendingUNSAFE_ComponentWillMountWarnings = [];
        }
        var componentWillReceivePropsUniqueNames = new Set();
        if (pendingComponentWillReceivePropsWarnings.length > 0) {
            pendingComponentWillReceivePropsWarnings.forEach(function(fiber) {
                componentWillReceivePropsUniqueNames.add(getComponentName(fiber.type) || "Component");
                didWarnAboutUnsafeLifecycles.add(fiber.type);
            });
            pendingComponentWillReceivePropsWarnings = [];
        }
        var UNSAFE_componentWillReceivePropsUniqueNames = new Set();
        if (pendingUNSAFE_ComponentWillReceivePropsWarnings.length > 0) {
            pendingUNSAFE_ComponentWillReceivePropsWarnings.forEach(function(fiber) {
                UNSAFE_componentWillReceivePropsUniqueNames.add(getComponentName(fiber.type) || "Component");
                didWarnAboutUnsafeLifecycles.add(fiber.type);
            });
            pendingUNSAFE_ComponentWillReceivePropsWarnings = [];
        }
        var componentWillUpdateUniqueNames = new Set();
        if (pendingComponentWillUpdateWarnings.length > 0) {
            pendingComponentWillUpdateWarnings.forEach(function(fiber) {
                componentWillUpdateUniqueNames.add(getComponentName(fiber.type) || "Component");
                didWarnAboutUnsafeLifecycles.add(fiber.type);
            });
            pendingComponentWillUpdateWarnings = [];
        }
        var UNSAFE_componentWillUpdateUniqueNames = new Set();
        if (pendingUNSAFE_ComponentWillUpdateWarnings.length > 0) {
            pendingUNSAFE_ComponentWillUpdateWarnings.forEach(function(fiber) {
                UNSAFE_componentWillUpdateUniqueNames.add(getComponentName(fiber.type) || "Component");
                didWarnAboutUnsafeLifecycles.add(fiber.type);
            });
            pendingUNSAFE_ComponentWillUpdateWarnings = [];
        } // Finally, we flush all the warnings
        // UNSAFE_ ones before the deprecated ones, since they'll be 'louder'
        if (UNSAFE_componentWillMountUniqueNames.size > 0) {
            var sortedNames = setToSortedString(UNSAFE_componentWillMountUniqueNames);
            error("Using UNSAFE_componentWillMount in strict mode is not recommended and may indicate bugs in your code. See https://fb.me/react-unsafe-component-lifecycles for details.\n\n* Move code with side effects to componentDidMount, and set initial state in the constructor.\n\nPlease update the following components: %s", sortedNames);
        }
        if (UNSAFE_componentWillReceivePropsUniqueNames.size > 0) {
            var _sortedNames = setToSortedString(UNSAFE_componentWillReceivePropsUniqueNames);
            error("Using UNSAFE_componentWillReceiveProps in strict mode is not recommended and may indicate bugs in your code. See https://fb.me/react-unsafe-component-lifecycles for details.\n\n* Move data fetching code or side effects to componentDidUpdate.\n* If you're updating state whenever props change, refactor your code to use memoization techniques or move it to static getDerivedStateFromProps. Learn more at: https://fb.me/react-derived-state\n\nPlease update the following components: %s", _sortedNames);
        }
        if (UNSAFE_componentWillUpdateUniqueNames.size > 0) {
            var _sortedNames2 = setToSortedString(UNSAFE_componentWillUpdateUniqueNames);
            error("Using UNSAFE_componentWillUpdate in strict mode is not recommended and may indicate bugs in your code. See https://fb.me/react-unsafe-component-lifecycles for details.\n\n* Move data fetching code or side effects to componentDidUpdate.\n\nPlease update the following components: %s", _sortedNames2);
        }
        if (componentWillMountUniqueNames.size > 0) {
            var _sortedNames3 = setToSortedString(componentWillMountUniqueNames);
            warn("componentWillMount has been renamed, and is not recommended for use. See https://fb.me/react-unsafe-component-lifecycles for details.\n\n* Move code with side effects to componentDidMount, and set initial state in the constructor.\n* Rename componentWillMount to UNSAFE_componentWillMount to suppress this warning in non-strict mode. In React 17.x, only the UNSAFE_ name will work. To rename all deprecated lifecycles to their new names, you can run `npx react-codemod rename-unsafe-lifecycles` in your project source folder.\n\nPlease update the following components: %s", _sortedNames3);
        }
        if (componentWillReceivePropsUniqueNames.size > 0) {
            var _sortedNames4 = setToSortedString(componentWillReceivePropsUniqueNames);
            warn("componentWillReceiveProps has been renamed, and is not recommended for use. See https://fb.me/react-unsafe-component-lifecycles for details.\n\n* Move data fetching code or side effects to componentDidUpdate.\n* If you're updating state whenever props change, refactor your code to use memoization techniques or move it to static getDerivedStateFromProps. Learn more at: https://fb.me/react-derived-state\n* Rename componentWillReceiveProps to UNSAFE_componentWillReceiveProps to suppress this warning in non-strict mode. In React 17.x, only the UNSAFE_ name will work. To rename all deprecated lifecycles to their new names, you can run `npx react-codemod rename-unsafe-lifecycles` in your project source folder.\n\nPlease update the following components: %s", _sortedNames4);
        }
        if (componentWillUpdateUniqueNames.size > 0) {
            var _sortedNames5 = setToSortedString(componentWillUpdateUniqueNames);
            warn("componentWillUpdate has been renamed, and is not recommended for use. See https://fb.me/react-unsafe-component-lifecycles for details.\n\n* Move data fetching code or side effects to componentDidUpdate.\n* Rename componentWillUpdate to UNSAFE_componentWillUpdate to suppress this warning in non-strict mode. In React 17.x, only the UNSAFE_ name will work. To rename all deprecated lifecycles to their new names, you can run `npx react-codemod rename-unsafe-lifecycles` in your project source folder.\n\nPlease update the following components: %s", _sortedNames5);
        }
    };
    var pendingLegacyContextWarning = new Map(); // Tracks components we have already warned about.
    var didWarnAboutLegacyContext = new Set();
    ReactStrictModeWarnings.recordLegacyContextWarning = function(fiber, instance) {
        var strictRoot = findStrictRoot(fiber);
        if (strictRoot === null) {
            error("Expected to find a StrictMode component in a strict mode tree. This error is likely caused by a bug in React. Please file an issue.");
            return;
        } // Dedup strategy: Warn once per component.
        if (didWarnAboutLegacyContext.has(fiber.type)) return;
        var warningsForRoot = pendingLegacyContextWarning.get(strictRoot);
        if (fiber.type.contextTypes != null || fiber.type.childContextTypes != null || instance !== null && typeof instance.getChildContext === "function") {
            if (warningsForRoot === undefined) {
                warningsForRoot = [];
                pendingLegacyContextWarning.set(strictRoot, warningsForRoot);
            }
            warningsForRoot.push(fiber);
        }
    };
    ReactStrictModeWarnings.flushLegacyContextWarning = function() {
        pendingLegacyContextWarning.forEach(function(fiberArray, strictRoot) {
            if (fiberArray.length === 0) return;
            var firstFiber = fiberArray[0];
            var uniqueNames = new Set();
            fiberArray.forEach(function(fiber) {
                uniqueNames.add(getComponentName(fiber.type) || "Component");
                didWarnAboutLegacyContext.add(fiber.type);
            });
            var sortedNames = setToSortedString(uniqueNames);
            var firstComponentStack = getStackByFiberInDevAndProd(firstFiber);
            error("Legacy context API has been detected within a strict-mode tree.\n\nThe old API will be supported in all 16.x releases, but applications using it should migrate to the new version.\n\nPlease update the following components: %s\n\nLearn more about this warning here: https://fb.me/react-legacy-context%s", sortedNames, firstComponentStack);
        });
    };
    ReactStrictModeWarnings.discardPendingWarnings = function() {
        pendingComponentWillMountWarnings = [];
        pendingUNSAFE_ComponentWillMountWarnings = [];
        pendingComponentWillReceivePropsWarnings = [];
        pendingUNSAFE_ComponentWillReceivePropsWarnings = [];
        pendingComponentWillUpdateWarnings = [];
        pendingUNSAFE_ComponentWillUpdateWarnings = [];
        pendingLegacyContextWarning = new Map();
    };
    var resolveFamily = null; // $FlowFixMe Flow gets confused by a WeakSet feature check below.
    var failedBoundaries = null;
    var setRefreshHandler = function(handler) {
        resolveFamily = handler;
    };
    function resolveFunctionForHotReloading(type) {
        if (resolveFamily === null) // Hot reloading is disabled.
        return type;
        var family = resolveFamily(type);
        if (family === undefined) return type;
         // Use the latest known implementation.
        return family.current;
    }
    function resolveClassForHotReloading(type) {
        // No implementation differences.
        return resolveFunctionForHotReloading(type);
    }
    function resolveForwardRefForHotReloading(type) {
        if (resolveFamily === null) // Hot reloading is disabled.
        return type;
        var family = resolveFamily(type);
        if (family === undefined) {
            // Check if we're dealing with a real forwardRef. Don't want to crash early.
            if (type !== null && type !== undefined && typeof type.render === "function") {
                // ForwardRef is special because its resolved .type is an object,
                // but it's possible that we only have its inner render function in the map.
                // If that inner render function is different, we'll build a new forwardRef type.
                var currentRender = resolveFunctionForHotReloading(type.render);
                if (type.render !== currentRender) {
                    var syntheticType = {
                        $$typeof: REACT_FORWARD_REF_TYPE,
                        render: currentRender
                    };
                    if (type.displayName !== undefined) syntheticType.displayName = type.displayName;
                    return syntheticType;
                }
            }
            return type;
        } // Use the latest known implementation.
        return family.current;
    }
    function isCompatibleFamilyForHotReloading(fiber, element) {
        if (resolveFamily === null) // Hot reloading is disabled.
        return false;
        var prevType = fiber.elementType;
        var nextType = element.type; // If we got here, we know types aren't === equal.
        var needsCompareFamilies = false;
        var $$typeofNextType = typeof nextType === "object" && nextType !== null ? nextType.$$typeof : null;
        switch(fiber.tag){
            case ClassComponent:
                if (typeof nextType === "function") needsCompareFamilies = true;
                break;
            case FunctionComponent:
                if (typeof nextType === "function") needsCompareFamilies = true;
                else if ($$typeofNextType === REACT_LAZY_TYPE) // We don't know the inner type yet.
                // We're going to assume that the lazy inner type is stable,
                // and so it is sufficient to avoid reconciling it away.
                // We're not going to unwrap or actually use the new lazy type.
                needsCompareFamilies = true;
                break;
            case ForwardRef:
                if ($$typeofNextType === REACT_FORWARD_REF_TYPE) needsCompareFamilies = true;
                else if ($$typeofNextType === REACT_LAZY_TYPE) needsCompareFamilies = true;
                break;
            case MemoComponent:
            case SimpleMemoComponent:
                if ($$typeofNextType === REACT_MEMO_TYPE) // TODO: if it was but can no longer be simple,
                // we shouldn't set this.
                needsCompareFamilies = true;
                else if ($$typeofNextType === REACT_LAZY_TYPE) needsCompareFamilies = true;
                break;
            default:
                return false;
        } // Check if both types have a family and it's the same one.
        if (needsCompareFamilies) {
            // Note: memo() and forwardRef() we'll compare outer rather than inner type.
            // This means both of them need to be registered to preserve state.
            // If we unwrapped and compared the inner types for wrappers instead,
            // then we would risk falsely saying two separate memo(Foo)
            // calls are equivalent because they wrap the same Foo function.
            var prevFamily = resolveFamily(prevType);
            if (prevFamily !== undefined && prevFamily === resolveFamily(nextType)) return true;
        }
        return false;
    }
    function markFailedErrorBoundaryForHotReloading(fiber) {
        if (resolveFamily === null) // Hot reloading is disabled.
        return;
        if (typeof WeakSet !== "function") return;
        if (failedBoundaries === null) failedBoundaries = new WeakSet();
        failedBoundaries.add(fiber);
    }
    var scheduleRefresh = function(root, update) {
        if (resolveFamily === null) // Hot reloading is disabled.
        return;
        var staleFamilies = update.staleFamilies, updatedFamilies = update.updatedFamilies;
        flushPassiveEffects();
        flushSync(function() {
            scheduleFibersWithFamiliesRecursively(root.current, updatedFamilies, staleFamilies);
        });
    };
    var scheduleRoot = function(root, element) {
        if (root.context !== emptyContextObject) // Super edge case: root has a legacy _renderSubtree context
        // but we don't know the parentComponent so we can't pass it.
        // Just ignore. We'll delete this with _renderSubtree code path later.
        return;
        flushPassiveEffects();
        syncUpdates(function() {
            updateContainer(element, root, null, null);
        });
    };
    function scheduleFibersWithFamiliesRecursively(fiber, updatedFamilies, staleFamilies) {
        var alternate = fiber.alternate, child = fiber.child, sibling = fiber.sibling, tag = fiber.tag, type = fiber.type;
        var candidateType = null;
        switch(tag){
            case FunctionComponent:
            case SimpleMemoComponent:
            case ClassComponent:
                candidateType = type;
                break;
            case ForwardRef:
                candidateType = type.render;
                break;
        }
        if (resolveFamily === null) throw new Error("Expected resolveFamily to be set during hot reload.");
        var needsRender = false;
        var needsRemount = false;
        if (candidateType !== null) {
            var family = resolveFamily(candidateType);
            if (family !== undefined) {
                if (staleFamilies.has(family)) needsRemount = true;
                else if (updatedFamilies.has(family)) {
                    if (tag === ClassComponent) needsRemount = true;
                    else needsRender = true;
                }
            }
        }
        if (failedBoundaries !== null) {
            if (failedBoundaries.has(fiber) || alternate !== null && failedBoundaries.has(alternate)) needsRemount = true;
        }
        if (needsRemount) fiber._debugNeedsRemount = true;
        if (needsRemount || needsRender) scheduleWork(fiber, Sync);
        if (child !== null && !needsRemount) scheduleFibersWithFamiliesRecursively(child, updatedFamilies, staleFamilies);
        if (sibling !== null) scheduleFibersWithFamiliesRecursively(sibling, updatedFamilies, staleFamilies);
    }
    var findHostInstancesForRefresh = function(root, families) {
        var hostInstances = new Set();
        var types = new Set(families.map(function(family) {
            return family.current;
        }));
        findHostInstancesForMatchingFibersRecursively(root.current, types, hostInstances);
        return hostInstances;
    };
    function findHostInstancesForMatchingFibersRecursively(fiber, types, hostInstances) {
        var child = fiber.child, sibling = fiber.sibling, tag = fiber.tag, type = fiber.type;
        var candidateType = null;
        switch(tag){
            case FunctionComponent:
            case SimpleMemoComponent:
            case ClassComponent:
                candidateType = type;
                break;
            case ForwardRef:
                candidateType = type.render;
                break;
        }
        var didMatch = false;
        if (candidateType !== null) {
            if (types.has(candidateType)) didMatch = true;
        }
        if (didMatch) // We have a match. This only drills down to the closest host components.
        // There's no need to search deeper because for the purpose of giving
        // visual feedback, "flashing" outermost parent rectangles is sufficient.
        findHostInstancesForFiberShallowly(fiber, hostInstances);
        else // If there's no match, maybe there will be one further down in the child tree.
        if (child !== null) findHostInstancesForMatchingFibersRecursively(child, types, hostInstances);
        if (sibling !== null) findHostInstancesForMatchingFibersRecursively(sibling, types, hostInstances);
    }
    function findHostInstancesForFiberShallowly(fiber, hostInstances) {
        var foundHostInstances = findChildHostInstancesForFiberShallowly(fiber, hostInstances);
        if (foundHostInstances) return;
         // If we didn't find any host children, fallback to closest host parent.
        var node = fiber;
        while(true){
            switch(node.tag){
                case HostComponent:
                    hostInstances.add(node.stateNode);
                    return;
                case HostPortal:
                    hostInstances.add(node.stateNode.containerInfo);
                    return;
                case HostRoot:
                    hostInstances.add(node.stateNode.containerInfo);
                    return;
            }
            if (node.return === null) throw new Error("Expected to reach root first.");
            node = node.return;
        }
    }
    function findChildHostInstancesForFiberShallowly(fiber, hostInstances) {
        var node = fiber;
        var foundHostInstances = false;
        while(true){
            if (node.tag === HostComponent) {
                // We got a match.
                foundHostInstances = true;
                hostInstances.add(node.stateNode); // There may still be more, so keep searching.
            } else if (node.child !== null) {
                node.child.return = node;
                node = node.child;
                continue;
            }
            if (node === fiber) return foundHostInstances;
            while(node.sibling === null){
                if (node.return === null || node.return === fiber) return foundHostInstances;
                node = node.return;
            }
            node.sibling.return = node.return;
            node = node.sibling;
        }
        return false;
    }
    function resolveDefaultProps(Component, baseProps) {
        if (Component && Component.defaultProps) {
            // Resolve default props. Taken from ReactElement
            var props = _assign({}, baseProps);
            var defaultProps = Component.defaultProps;
            for(var propName in defaultProps)if (props[propName] === undefined) props[propName] = defaultProps[propName];
            return props;
        }
        return baseProps;
    }
    function readLazyComponentType(lazyComponent) {
        initializeLazyComponentType(lazyComponent);
        if (lazyComponent._status !== Resolved) throw lazyComponent._result;
        return lazyComponent._result;
    }
    var valueCursor = createCursor(null);
    var rendererSigil;
    // Use this to detect multiple renderers using the same context
    rendererSigil = {};
    var currentlyRenderingFiber = null;
    var lastContextDependency = null;
    var lastContextWithAllBitsObserved = null;
    var isDisallowedContextReadInDEV = false;
    function resetContextDependencies() {
        // This is called right before React yields execution, to ensure `readContext`
        // cannot be called outside the render phase.
        currentlyRenderingFiber = null;
        lastContextDependency = null;
        lastContextWithAllBitsObserved = null;
        isDisallowedContextReadInDEV = false;
    }
    function enterDisallowedContextReadInDEV() {
        isDisallowedContextReadInDEV = true;
    }
    function exitDisallowedContextReadInDEV() {
        isDisallowedContextReadInDEV = false;
    }
    function pushProvider(providerFiber, nextValue) {
        var context = providerFiber.type._context;
        push(valueCursor, context._currentValue, providerFiber);
        context._currentValue = nextValue;
        if (context._currentRenderer !== undefined && context._currentRenderer !== null && context._currentRenderer !== rendererSigil) error("Detected multiple renderers concurrently rendering the same context provider. This is currently unsupported.");
        context._currentRenderer = rendererSigil;
    }
    function popProvider(providerFiber) {
        var currentValue = valueCursor.current;
        pop(valueCursor, providerFiber);
        var context = providerFiber.type._context;
        context._currentValue = currentValue;
    }
    function calculateChangedBits(context, newValue, oldValue) {
        if (objectIs(oldValue, newValue)) // No change
        return 0;
        else {
            var changedBits = typeof context._calculateChangedBits === "function" ? context._calculateChangedBits(oldValue, newValue) : MAX_SIGNED_31_BIT_INT;
            if ((changedBits & MAX_SIGNED_31_BIT_INT) !== changedBits) error("calculateChangedBits: Expected the return value to be a 31-bit integer. Instead received: %s", changedBits);
            return changedBits | 0;
        }
    }
    function scheduleWorkOnParentPath(parent, renderExpirationTime) {
        // Update the child expiration time of all the ancestors, including
        // the alternates.
        var node = parent;
        while(node !== null){
            var alternate = node.alternate;
            if (node.childExpirationTime < renderExpirationTime) {
                node.childExpirationTime = renderExpirationTime;
                if (alternate !== null && alternate.childExpirationTime < renderExpirationTime) alternate.childExpirationTime = renderExpirationTime;
            } else if (alternate !== null && alternate.childExpirationTime < renderExpirationTime) alternate.childExpirationTime = renderExpirationTime;
            else break;
            node = node.return;
        }
    }
    function propagateContextChange(workInProgress, context, changedBits, renderExpirationTime) {
        var fiber = workInProgress.child;
        if (fiber !== null) // Set the return pointer of the child to the work-in-progress fiber.
        fiber.return = workInProgress;
        while(fiber !== null){
            var nextFiber = void 0; // Visit this fiber.
            var list = fiber.dependencies;
            if (list !== null) {
                nextFiber = fiber.child;
                var dependency = list.firstContext;
                while(dependency !== null){
                    // Check if the context matches.
                    if (dependency.context === context && (dependency.observedBits & changedBits) !== 0) {
                        // Match! Schedule an update on this fiber.
                        if (fiber.tag === ClassComponent) {
                            // Schedule a force update on the work-in-progress.
                            var update = createUpdate(renderExpirationTime, null);
                            update.tag = ForceUpdate; // TODO: Because we don't have a work-in-progress, this will add the
                            // update to the current fiber, too, which means it will persist even if
                            // this render is thrown away. Since it's a race condition, not sure it's
                            // worth fixing.
                            enqueueUpdate(fiber, update);
                        }
                        if (fiber.expirationTime < renderExpirationTime) fiber.expirationTime = renderExpirationTime;
                        var alternate = fiber.alternate;
                        if (alternate !== null && alternate.expirationTime < renderExpirationTime) alternate.expirationTime = renderExpirationTime;
                        scheduleWorkOnParentPath(fiber.return, renderExpirationTime); // Mark the expiration time on the list, too.
                        if (list.expirationTime < renderExpirationTime) list.expirationTime = renderExpirationTime;
                         // Since we already found a match, we can stop traversing the
                        break;
                    }
                    dependency = dependency.next;
                }
            } else if (fiber.tag === ContextProvider) // Don't scan deeper if this is a matching provider
            nextFiber = fiber.type === workInProgress.type ? null : fiber.child;
            else // Traverse down.
            nextFiber = fiber.child;
            if (nextFiber !== null) // Set the return pointer of the child to the work-in-progress fiber.
            nextFiber.return = fiber;
            else {
                // No child. Traverse to next sibling.
                nextFiber = fiber;
                while(nextFiber !== null){
                    if (nextFiber === workInProgress) {
                        // We're back to the root of this subtree. Exit.
                        nextFiber = null;
                        break;
                    }
                    var sibling = nextFiber.sibling;
                    if (sibling !== null) {
                        // Set the return pointer of the sibling to the work-in-progress fiber.
                        sibling.return = nextFiber.return;
                        nextFiber = sibling;
                        break;
                    } // No more siblings. Traverse up.
                    nextFiber = nextFiber.return;
                }
            }
            fiber = nextFiber;
        }
    }
    function prepareToReadContext(workInProgress, renderExpirationTime) {
        currentlyRenderingFiber = workInProgress;
        lastContextDependency = null;
        lastContextWithAllBitsObserved = null;
        var dependencies = workInProgress.dependencies;
        if (dependencies !== null) {
            var firstContext = dependencies.firstContext;
            if (firstContext !== null) {
                if (dependencies.expirationTime >= renderExpirationTime) // Context list has a pending update. Mark that this fiber performed work.
                markWorkInProgressReceivedUpdate();
                 // Reset the work-in-progress list
                dependencies.firstContext = null;
            }
        }
    }
    function readContext(context, observedBits) {
        // This warning would fire if you read context inside a Hook like useMemo.
        // Unlike the class check below, it's not enforced in production for perf.
        if (isDisallowedContextReadInDEV) error("Context can only be read while React is rendering. In classes, you can read it in the render method or getDerivedStateFromProps. In function components, you can read it directly in the function body, but not inside Hooks like useReducer() or useMemo().");
        if (lastContextWithAllBitsObserved === context) ;
        else if (observedBits === false || observedBits === 0) ;
        else {
            var resolvedObservedBits; // Avoid deopting on observable arguments or heterogeneous types.
            if (typeof observedBits !== "number" || observedBits === MAX_SIGNED_31_BIT_INT) {
                // Observe all updates.
                lastContextWithAllBitsObserved = context;
                resolvedObservedBits = MAX_SIGNED_31_BIT_INT;
            } else resolvedObservedBits = observedBits;
            var contextItem = {
                context: context,
                observedBits: resolvedObservedBits,
                next: null
            };
            if (lastContextDependency === null) {
                if (!(currentlyRenderingFiber !== null)) throw Error("Context can only be read while React is rendering. In classes, you can read it in the render method or getDerivedStateFromProps. In function components, you can read it directly in the function body, but not inside Hooks like useReducer() or useMemo().");
                 // This is the first dependency for this component. Create a new list.
                lastContextDependency = contextItem;
                currentlyRenderingFiber.dependencies = {
                    expirationTime: NoWork,
                    firstContext: contextItem,
                    responders: null
                };
            } else // Append a new context item.
            lastContextDependency = lastContextDependency.next = contextItem;
        }
        return context._currentValue;
    }
    var UpdateState = 0;
    var ReplaceState = 1;
    var ForceUpdate = 2;
    var CaptureUpdate = 3; // Global state that is reset at the beginning of calling `processUpdateQueue`.
    // It should only be read right after calling `processUpdateQueue`, via
    // `checkHasForceUpdateAfterProcessing`.
    var hasForceUpdate = false;
    var didWarnUpdateInsideUpdate;
    var currentlyProcessingQueue;
    didWarnUpdateInsideUpdate = false;
    currentlyProcessingQueue = null;
    function initializeUpdateQueue(fiber) {
        var queue = {
            baseState: fiber.memoizedState,
            baseQueue: null,
            shared: {
                pending: null
            },
            effects: null
        };
        fiber.updateQueue = queue;
    }
    function cloneUpdateQueue(current, workInProgress) {
        // Clone the update queue from current. Unless it's already a clone.
        var queue = workInProgress.updateQueue;
        var currentQueue = current.updateQueue;
        if (queue === currentQueue) {
            var clone = {
                baseState: currentQueue.baseState,
                baseQueue: currentQueue.baseQueue,
                shared: currentQueue.shared,
                effects: currentQueue.effects
            };
            workInProgress.updateQueue = clone;
        }
    }
    function createUpdate(expirationTime, suspenseConfig) {
        var update = {
            expirationTime: expirationTime,
            suspenseConfig: suspenseConfig,
            tag: UpdateState,
            payload: null,
            callback: null,
            next: null
        };
        update.next = update;
        update.priority = getCurrentPriorityLevel();
        return update;
    }
    function enqueueUpdate(fiber, update) {
        var updateQueue = fiber.updateQueue;
        if (updateQueue === null) // Only occurs if the fiber has been unmounted.
        return;
        var sharedQueue = updateQueue.shared;
        var pending = sharedQueue.pending;
        if (pending === null) // This is the first update. Create a circular list.
        update.next = update;
        else {
            update.next = pending.next;
            pending.next = update;
        }
        sharedQueue.pending = update;
        if (currentlyProcessingQueue === sharedQueue && !didWarnUpdateInsideUpdate) {
            error("An update (setState, replaceState, or forceUpdate) was scheduled from inside an update function. Update functions should be pure, with zero side-effects. Consider using componentDidUpdate or a callback.");
            didWarnUpdateInsideUpdate = true;
        }
    }
    function enqueueCapturedUpdate(workInProgress, update) {
        var current = workInProgress.alternate;
        if (current !== null) // Ensure the work-in-progress queue is a clone
        cloneUpdateQueue(current, workInProgress);
         // Captured updates go only on the work-in-progress queue.
        var queue = workInProgress.updateQueue; // Append the update to the end of the list.
        var last = queue.baseQueue;
        if (last === null) {
            queue.baseQueue = update.next = update;
            update.next = update;
        } else {
            update.next = last.next;
            last.next = update;
        }
    }
    function getStateFromUpdate(workInProgress, queue, update, prevState, nextProps, instance) {
        switch(update.tag){
            case ReplaceState:
                var payload = update.payload;
                if (typeof payload === "function") {
                    enterDisallowedContextReadInDEV();
                    if (workInProgress.mode & StrictMode) payload.call(instance, prevState, nextProps);
                    var nextState = payload.call(instance, prevState, nextProps);
                    exitDisallowedContextReadInDEV();
                    return nextState;
                } // State object
                return payload;
            case CaptureUpdate:
                workInProgress.effectTag = workInProgress.effectTag & ~ShouldCapture | DidCapture;
            // Intentional fallthrough
            case UpdateState:
                var _payload = update.payload;
                var partialState;
                if (typeof _payload === "function") {
                    enterDisallowedContextReadInDEV();
                    if (workInProgress.mode & StrictMode) _payload.call(instance, prevState, nextProps);
                    partialState = _payload.call(instance, prevState, nextProps);
                    exitDisallowedContextReadInDEV();
                } else // Partial state object
                partialState = _payload;
                if (partialState === null || partialState === undefined) // Null and undefined are treated as no-ops.
                return prevState;
                 // Merge the partial state and the previous state.
                return _assign({}, prevState, partialState);
            case ForceUpdate:
                hasForceUpdate = true;
                return prevState;
        }
        return prevState;
    }
    function processUpdateQueue(workInProgress, props, instance, renderExpirationTime) {
        // This is always non-null on a ClassComponent or HostRoot
        var queue = workInProgress.updateQueue;
        hasForceUpdate = false;
        currentlyProcessingQueue = queue.shared;
        var baseQueue = queue.baseQueue; // The last pending update that hasn't been processed yet.
        var pendingQueue = queue.shared.pending;
        if (pendingQueue !== null) {
            // We have new updates that haven't been processed yet.
            // We'll add them to the base queue.
            if (baseQueue !== null) {
                // Merge the pending queue and the base queue.
                var baseFirst = baseQueue.next;
                var pendingFirst = pendingQueue.next;
                baseQueue.next = pendingFirst;
                pendingQueue.next = baseFirst;
            }
            baseQueue = pendingQueue;
            queue.shared.pending = null; // TODO: Pass `current` as argument
            var current = workInProgress.alternate;
            if (current !== null) {
                var currentQueue = current.updateQueue;
                if (currentQueue !== null) currentQueue.baseQueue = pendingQueue;
            }
        } // These values may change as we process the queue.
        if (baseQueue !== null) {
            var first = baseQueue.next; // Iterate through the list of updates to compute the result.
            var newState = queue.baseState;
            var newExpirationTime = NoWork;
            var newBaseState = null;
            var newBaseQueueFirst = null;
            var newBaseQueueLast = null;
            if (first !== null) {
                var update = first;
                do {
                    var updateExpirationTime = update.expirationTime;
                    if (updateExpirationTime < renderExpirationTime) {
                        // Priority is insufficient. Skip this update. If this is the first
                        // skipped update, the previous update/state is the new base
                        // update/state.
                        var clone = {
                            expirationTime: update.expirationTime,
                            suspenseConfig: update.suspenseConfig,
                            tag: update.tag,
                            payload: update.payload,
                            callback: update.callback,
                            next: null
                        };
                        if (newBaseQueueLast === null) {
                            newBaseQueueFirst = newBaseQueueLast = clone;
                            newBaseState = newState;
                        } else newBaseQueueLast = newBaseQueueLast.next = clone;
                         // Update the remaining priority in the queue.
                        if (updateExpirationTime > newExpirationTime) newExpirationTime = updateExpirationTime;
                    } else {
                        // This update does have sufficient priority.
                        if (newBaseQueueLast !== null) {
                            var _clone = {
                                expirationTime: Sync,
                                // This update is going to be committed so we never want uncommit it.
                                suspenseConfig: update.suspenseConfig,
                                tag: update.tag,
                                payload: update.payload,
                                callback: update.callback,
                                next: null
                            };
                            newBaseQueueLast = newBaseQueueLast.next = _clone;
                        } // Mark the event time of this update as relevant to this render pass.
                        // TODO: This should ideally use the true event time of this update rather than
                        // its priority which is a derived and not reverseable value.
                        // TODO: We should skip this update if it was already committed but currently
                        // we have no way of detecting the difference between a committed and suspended
                        // update here.
                        markRenderEventTimeAndConfig(updateExpirationTime, update.suspenseConfig); // Process this update.
                        newState = getStateFromUpdate(workInProgress, queue, update, newState, props, instance);
                        var callback = update.callback;
                        if (callback !== null) {
                            workInProgress.effectTag |= Callback;
                            var effects = queue.effects;
                            if (effects === null) queue.effects = [
                                update
                            ];
                            else effects.push(update);
                        }
                    }
                    update = update.next;
                    if (update === null || update === first) {
                        pendingQueue = queue.shared.pending;
                        if (pendingQueue === null) break;
                        else {
                            // An update was scheduled from inside a reducer. Add the new
                            // pending updates to the end of the list and keep processing.
                            update = baseQueue.next = pendingQueue.next;
                            pendingQueue.next = first;
                            queue.baseQueue = baseQueue = pendingQueue;
                            queue.shared.pending = null;
                        }
                    }
                }while (true);
            }
            if (newBaseQueueLast === null) newBaseState = newState;
            else newBaseQueueLast.next = newBaseQueueFirst;
            queue.baseState = newBaseState;
            queue.baseQueue = newBaseQueueLast; // Set the remaining expiration time to be whatever is remaining in the queue.
            // This should be fine because the only two other things that contribute to
            // expiration time are props and context. We're already in the middle of the
            // begin phase by the time we start processing the queue, so we've already
            // dealt with the props. Context in components that specify
            // shouldComponentUpdate is tricky; but we'll have to account for
            // that regardless.
            markUnprocessedUpdateTime(newExpirationTime);
            workInProgress.expirationTime = newExpirationTime;
            workInProgress.memoizedState = newState;
        }
        currentlyProcessingQueue = null;
    }
    function callCallback(callback, context) {
        if (!(typeof callback === "function")) throw Error("Invalid argument passed as callback. Expected a function. Instead received: " + callback);
        callback.call(context);
    }
    function resetHasForceUpdateBeforeProcessing() {
        hasForceUpdate = false;
    }
    function checkHasForceUpdateAfterProcessing() {
        return hasForceUpdate;
    }
    function commitUpdateQueue(finishedWork, finishedQueue, instance) {
        // Commit the effects
        var effects = finishedQueue.effects;
        finishedQueue.effects = null;
        if (effects !== null) for(var i = 0; i < effects.length; i++){
            var effect = effects[i];
            var callback = effect.callback;
            if (callback !== null) {
                effect.callback = null;
                callCallback(callback, instance);
            }
        }
    }
    var ReactCurrentBatchConfig = ReactSharedInternals.ReactCurrentBatchConfig;
    function requestCurrentSuspenseConfig() {
        return ReactCurrentBatchConfig.suspense;
    }
    var fakeInternalInstance = {};
    var isArray = Array.isArray; // React.Component uses a shared frozen object by default.
    // We'll use it to determine whether we need to initialize legacy refs.
    var emptyRefsObject = new React.Component().refs;
    var didWarnAboutStateAssignmentForComponent;
    var didWarnAboutUninitializedState;
    var didWarnAboutGetSnapshotBeforeUpdateWithoutDidUpdate;
    var didWarnAboutLegacyLifecyclesAndDerivedState;
    var didWarnAboutUndefinedDerivedState;
    var warnOnUndefinedDerivedState;
    var warnOnInvalidCallback;
    var didWarnAboutDirectlyAssigningPropsToState;
    var didWarnAboutContextTypeAndContextTypes;
    var didWarnAboutInvalidateContextType;
    didWarnAboutStateAssignmentForComponent = new Set();
    didWarnAboutUninitializedState = new Set();
    didWarnAboutGetSnapshotBeforeUpdateWithoutDidUpdate = new Set();
    didWarnAboutLegacyLifecyclesAndDerivedState = new Set();
    didWarnAboutDirectlyAssigningPropsToState = new Set();
    didWarnAboutUndefinedDerivedState = new Set();
    didWarnAboutContextTypeAndContextTypes = new Set();
    didWarnAboutInvalidateContextType = new Set();
    var didWarnOnInvalidCallback = new Set();
    warnOnInvalidCallback = function(callback, callerName) {
        if (callback === null || typeof callback === "function") return;
        var key = callerName + "_" + callback;
        if (!didWarnOnInvalidCallback.has(key)) {
            didWarnOnInvalidCallback.add(key);
            error("%s(...): Expected the last optional `callback` argument to be a function. Instead received: %s.", callerName, callback);
        }
    };
    warnOnUndefinedDerivedState = function(type, partialState) {
        if (partialState === undefined) {
            var componentName = getComponentName(type) || "Component";
            if (!didWarnAboutUndefinedDerivedState.has(componentName)) {
                didWarnAboutUndefinedDerivedState.add(componentName);
                error("%s.getDerivedStateFromProps(): A valid state object (or null) must be returned. You have returned undefined.", componentName);
            }
        }
    }; // This is so gross but it's at least non-critical and can be removed if
    // it causes problems. This is meant to give a nicer error message for
    // ReactDOM15.unstable_renderSubtreeIntoContainer(reactDOM16Component,
    // ...)) which otherwise throws a "_processChildContext is not a function"
    // exception.
    Object.defineProperty(fakeInternalInstance, "_processChildContext", {
        enumerable: false,
        value: function() {
            throw Error("_processChildContext is not available in React 16+. This likely means you have multiple copies of React and are attempting to nest a React 15 tree inside a React 16 tree using unstable_renderSubtreeIntoContainer, which isn't supported. Try to make sure you have only one copy of React (and ideally, switch to ReactDOM.createPortal).");
        }
    });
    Object.freeze(fakeInternalInstance);
    function applyDerivedStateFromProps(workInProgress, ctor, getDerivedStateFromProps, nextProps) {
        var prevState = workInProgress.memoizedState;
        if (workInProgress.mode & StrictMode) // Invoke the function an extra time to help detect side-effects.
        getDerivedStateFromProps(nextProps, prevState);
        var partialState = getDerivedStateFromProps(nextProps, prevState);
        warnOnUndefinedDerivedState(ctor, partialState);
        var memoizedState = partialState === null || partialState === undefined ? prevState : _assign({}, prevState, partialState);
        workInProgress.memoizedState = memoizedState; // Once the update queue is empty, persist the derived state onto the
        // base state.
        if (workInProgress.expirationTime === NoWork) {
            // Queue is always non-null for classes
            var updateQueue = workInProgress.updateQueue;
            updateQueue.baseState = memoizedState;
        }
    }
    var classComponentUpdater = {
        isMounted: isMounted,
        enqueueSetState: function(inst, payload, callback) {
            var fiber = get(inst);
            var currentTime = requestCurrentTimeForUpdate();
            var suspenseConfig = requestCurrentSuspenseConfig();
            var expirationTime = computeExpirationForFiber(currentTime, fiber, suspenseConfig);
            var update = createUpdate(expirationTime, suspenseConfig);
            update.payload = payload;
            if (callback !== undefined && callback !== null) {
                warnOnInvalidCallback(callback, "setState");
                update.callback = callback;
            }
            enqueueUpdate(fiber, update);
            scheduleWork(fiber, expirationTime);
        },
        enqueueReplaceState: function(inst, payload, callback) {
            var fiber = get(inst);
            var currentTime = requestCurrentTimeForUpdate();
            var suspenseConfig = requestCurrentSuspenseConfig();
            var expirationTime = computeExpirationForFiber(currentTime, fiber, suspenseConfig);
            var update = createUpdate(expirationTime, suspenseConfig);
            update.tag = ReplaceState;
            update.payload = payload;
            if (callback !== undefined && callback !== null) {
                warnOnInvalidCallback(callback, "replaceState");
                update.callback = callback;
            }
            enqueueUpdate(fiber, update);
            scheduleWork(fiber, expirationTime);
        },
        enqueueForceUpdate: function(inst, callback) {
            var fiber = get(inst);
            var currentTime = requestCurrentTimeForUpdate();
            var suspenseConfig = requestCurrentSuspenseConfig();
            var expirationTime = computeExpirationForFiber(currentTime, fiber, suspenseConfig);
            var update = createUpdate(expirationTime, suspenseConfig);
            update.tag = ForceUpdate;
            if (callback !== undefined && callback !== null) {
                warnOnInvalidCallback(callback, "forceUpdate");
                update.callback = callback;
            }
            enqueueUpdate(fiber, update);
            scheduleWork(fiber, expirationTime);
        }
    };
    function checkShouldComponentUpdate(workInProgress, ctor, oldProps, newProps, oldState, newState, nextContext) {
        var instance = workInProgress.stateNode;
        if (typeof instance.shouldComponentUpdate === "function") {
            if (workInProgress.mode & StrictMode) // Invoke the function an extra time to help detect side-effects.
            instance.shouldComponentUpdate(newProps, newState, nextContext);
            startPhaseTimer(workInProgress, "shouldComponentUpdate");
            var shouldUpdate = instance.shouldComponentUpdate(newProps, newState, nextContext);
            stopPhaseTimer();
            if (shouldUpdate === undefined) error("%s.shouldComponentUpdate(): Returned undefined instead of a boolean value. Make sure to return true or false.", getComponentName(ctor) || "Component");
            return shouldUpdate;
        }
        if (ctor.prototype && ctor.prototype.isPureReactComponent) return !shallowEqual(oldProps, newProps) || !shallowEqual(oldState, newState);
        return true;
    }
    function checkClassInstance(workInProgress, ctor, newProps) {
        var instance = workInProgress.stateNode;
        var name = getComponentName(ctor) || "Component";
        var renderPresent = instance.render;
        if (!renderPresent) {
            if (ctor.prototype && typeof ctor.prototype.render === "function") error("%s(...): No `render` method found on the returned component instance: did you accidentally return an object from the constructor?", name);
            else error("%s(...): No `render` method found on the returned component instance: you may have forgotten to define `render`.", name);
        }
        if (instance.getInitialState && !instance.getInitialState.isReactClassApproved && !instance.state) error("getInitialState was defined on %s, a plain JavaScript class. This is only supported for classes created using React.createClass. Did you mean to define a state property instead?", name);
        if (instance.getDefaultProps && !instance.getDefaultProps.isReactClassApproved) error("getDefaultProps was defined on %s, a plain JavaScript class. This is only supported for classes created using React.createClass. Use a static property to define defaultProps instead.", name);
        if (instance.propTypes) error("propTypes was defined as an instance property on %s. Use a static property to define propTypes instead.", name);
        if (instance.contextType) error("contextType was defined as an instance property on %s. Use a static property to define contextType instead.", name);
        if (instance.contextTypes) error("contextTypes was defined as an instance property on %s. Use a static property to define contextTypes instead.", name);
        if (ctor.contextType && ctor.contextTypes && !didWarnAboutContextTypeAndContextTypes.has(ctor)) {
            didWarnAboutContextTypeAndContextTypes.add(ctor);
            error("%s declares both contextTypes and contextType static properties. The legacy contextTypes property will be ignored.", name);
        }
        if (typeof instance.componentShouldUpdate === "function") error("%s has a method called componentShouldUpdate(). Did you mean shouldComponentUpdate()? The name is phrased as a question because the function is expected to return a value.", name);
        if (ctor.prototype && ctor.prototype.isPureReactComponent && typeof instance.shouldComponentUpdate !== "undefined") error("%s has a method called shouldComponentUpdate(). shouldComponentUpdate should not be used when extending React.PureComponent. Please extend React.Component if shouldComponentUpdate is used.", getComponentName(ctor) || "A pure component");
        if (typeof instance.componentDidUnmount === "function") error("%s has a method called componentDidUnmount(). But there is no such lifecycle method. Did you mean componentWillUnmount()?", name);
        if (typeof instance.componentDidReceiveProps === "function") error("%s has a method called componentDidReceiveProps(). But there is no such lifecycle method. If you meant to update the state in response to changing props, use componentWillReceiveProps(). If you meant to fetch data or run side-effects or mutations after React has updated the UI, use componentDidUpdate().", name);
        if (typeof instance.componentWillRecieveProps === "function") error("%s has a method called componentWillRecieveProps(). Did you mean componentWillReceiveProps()?", name);
        if (typeof instance.UNSAFE_componentWillRecieveProps === "function") error("%s has a method called UNSAFE_componentWillRecieveProps(). Did you mean UNSAFE_componentWillReceiveProps()?", name);
        var hasMutatedProps = instance.props !== newProps;
        if (instance.props !== undefined && hasMutatedProps) error("%s(...): When calling super() in `%s`, make sure to pass up the same props that your component's constructor was passed.", name, name);
        if (instance.defaultProps) error("Setting defaultProps as an instance property on %s is not supported and will be ignored. Instead, define defaultProps as a static property on %s.", name, name);
        if (typeof instance.getSnapshotBeforeUpdate === "function" && typeof instance.componentDidUpdate !== "function" && !didWarnAboutGetSnapshotBeforeUpdateWithoutDidUpdate.has(ctor)) {
            didWarnAboutGetSnapshotBeforeUpdateWithoutDidUpdate.add(ctor);
            error("%s: getSnapshotBeforeUpdate() should be used with componentDidUpdate(). This component defines getSnapshotBeforeUpdate() only.", getComponentName(ctor));
        }
        if (typeof instance.getDerivedStateFromProps === "function") error("%s: getDerivedStateFromProps() is defined as an instance method and will be ignored. Instead, declare it as a static method.", name);
        if (typeof instance.getDerivedStateFromError === "function") error("%s: getDerivedStateFromError() is defined as an instance method and will be ignored. Instead, declare it as a static method.", name);
        if (typeof ctor.getSnapshotBeforeUpdate === "function") error("%s: getSnapshotBeforeUpdate() is defined as a static method and will be ignored. Instead, declare it as an instance method.", name);
        var _state = instance.state;
        if (_state && (typeof _state !== "object" || isArray(_state))) error("%s.state: must be set to an object or null", name);
        if (typeof instance.getChildContext === "function" && typeof ctor.childContextTypes !== "object") error("%s.getChildContext(): childContextTypes must be defined in order to use getChildContext().", name);
    }
    function adoptClassInstance(workInProgress, instance) {
        instance.updater = classComponentUpdater;
        workInProgress.stateNode = instance; // The instance needs access to the fiber so that it can schedule updates
        set(instance, workInProgress);
        instance._reactInternalInstance = fakeInternalInstance;
    }
    function constructClassInstance(workInProgress, ctor, props) {
        var isLegacyContextConsumer = false;
        var unmaskedContext = emptyContextObject;
        var context = emptyContextObject;
        var contextType = ctor.contextType;
        if ("contextType" in ctor) {
            var isValid = contextType === null || contextType !== undefined && contextType.$$typeof === REACT_CONTEXT_TYPE && contextType._context === undefined; // Not a <Context.Consumer>
            if (!isValid && !didWarnAboutInvalidateContextType.has(ctor)) {
                didWarnAboutInvalidateContextType.add(ctor);
                var addendum = "";
                if (contextType === undefined) addendum = " However, it is set to undefined. This can be caused by a typo or by mixing up named and default imports. This can also happen due to a circular dependency, so try moving the createContext() call to a separate file.";
                else if (typeof contextType !== "object") addendum = " However, it is set to a " + typeof contextType + ".";
                else if (contextType.$$typeof === REACT_PROVIDER_TYPE) addendum = " Did you accidentally pass the Context.Provider instead?";
                else if (contextType._context !== undefined) // <Context.Consumer>
                addendum = " Did you accidentally pass the Context.Consumer instead?";
                else addendum = " However, it is set to an object with keys {" + Object.keys(contextType).join(", ") + "}.";
                error("%s defines an invalid contextType. contextType should point to the Context object returned by React.createContext().%s", getComponentName(ctor) || "Component", addendum);
            }
        }
        if (typeof contextType === "object" && contextType !== null) context = readContext(contextType);
        else {
            unmaskedContext = getUnmaskedContext(workInProgress, ctor, true);
            var contextTypes = ctor.contextTypes;
            isLegacyContextConsumer = contextTypes !== null && contextTypes !== undefined;
            context = isLegacyContextConsumer ? getMaskedContext(workInProgress, unmaskedContext) : emptyContextObject;
        } // Instantiate twice to help detect side-effects.
        if (workInProgress.mode & StrictMode) new ctor(props, context); // eslint-disable-line no-new
        var instance = new ctor(props, context);
        var state = workInProgress.memoizedState = instance.state !== null && instance.state !== undefined ? instance.state : null;
        adoptClassInstance(workInProgress, instance);
        if (typeof ctor.getDerivedStateFromProps === "function" && state === null) {
            var componentName = getComponentName(ctor) || "Component";
            if (!didWarnAboutUninitializedState.has(componentName)) {
                didWarnAboutUninitializedState.add(componentName);
                error("`%s` uses `getDerivedStateFromProps` but its initial state is %s. This is not recommended. Instead, define the initial state by assigning an object to `this.state` in the constructor of `%s`. This ensures that `getDerivedStateFromProps` arguments have a consistent shape.", componentName, instance.state === null ? "null" : "undefined", componentName);
            }
        } // If new component APIs are defined, "unsafe" lifecycles won't be called.
        // Warn about these lifecycles if they are present.
        // Don't warn about react-lifecycles-compat polyfilled methods though.
        if (typeof ctor.getDerivedStateFromProps === "function" || typeof instance.getSnapshotBeforeUpdate === "function") {
            var foundWillMountName = null;
            var foundWillReceivePropsName = null;
            var foundWillUpdateName = null;
            if (typeof instance.componentWillMount === "function" && instance.componentWillMount.__suppressDeprecationWarning !== true) foundWillMountName = "componentWillMount";
            else if (typeof instance.UNSAFE_componentWillMount === "function") foundWillMountName = "UNSAFE_componentWillMount";
            if (typeof instance.componentWillReceiveProps === "function" && instance.componentWillReceiveProps.__suppressDeprecationWarning !== true) foundWillReceivePropsName = "componentWillReceiveProps";
            else if (typeof instance.UNSAFE_componentWillReceiveProps === "function") foundWillReceivePropsName = "UNSAFE_componentWillReceiveProps";
            if (typeof instance.componentWillUpdate === "function" && instance.componentWillUpdate.__suppressDeprecationWarning !== true) foundWillUpdateName = "componentWillUpdate";
            else if (typeof instance.UNSAFE_componentWillUpdate === "function") foundWillUpdateName = "UNSAFE_componentWillUpdate";
            if (foundWillMountName !== null || foundWillReceivePropsName !== null || foundWillUpdateName !== null) {
                var _componentName = getComponentName(ctor) || "Component";
                var newApiName = typeof ctor.getDerivedStateFromProps === "function" ? "getDerivedStateFromProps()" : "getSnapshotBeforeUpdate()";
                if (!didWarnAboutLegacyLifecyclesAndDerivedState.has(_componentName)) {
                    didWarnAboutLegacyLifecyclesAndDerivedState.add(_componentName);
                    error("Unsafe legacy lifecycles will not be called for components using new component APIs.\n\n%s uses %s but also contains the following legacy lifecycles:%s%s%s\n\nThe above lifecycles should be removed. Learn more about this warning here:\nhttps://fb.me/react-unsafe-component-lifecycles", _componentName, newApiName, foundWillMountName !== null ? "\n  " + foundWillMountName : "", foundWillReceivePropsName !== null ? "\n  " + foundWillReceivePropsName : "", foundWillUpdateName !== null ? "\n  " + foundWillUpdateName : "");
                }
            }
        }
        // ReactFiberContext usually updates this cache but can't for newly-created instances.
        if (isLegacyContextConsumer) cacheContext(workInProgress, unmaskedContext, context);
        return instance;
    }
    function callComponentWillMount(workInProgress, instance) {
        startPhaseTimer(workInProgress, "componentWillMount");
        var oldState = instance.state;
        if (typeof instance.componentWillMount === "function") instance.componentWillMount();
        if (typeof instance.UNSAFE_componentWillMount === "function") instance.UNSAFE_componentWillMount();
        stopPhaseTimer();
        if (oldState !== instance.state) {
            error("%s.componentWillMount(): Assigning directly to this.state is deprecated (except inside a component's constructor). Use setState instead.", getComponentName(workInProgress.type) || "Component");
            classComponentUpdater.enqueueReplaceState(instance, instance.state, null);
        }
    }
    function callComponentWillReceiveProps(workInProgress, instance, newProps, nextContext) {
        var oldState = instance.state;
        startPhaseTimer(workInProgress, "componentWillReceiveProps");
        if (typeof instance.componentWillReceiveProps === "function") instance.componentWillReceiveProps(newProps, nextContext);
        if (typeof instance.UNSAFE_componentWillReceiveProps === "function") instance.UNSAFE_componentWillReceiveProps(newProps, nextContext);
        stopPhaseTimer();
        if (instance.state !== oldState) {
            var componentName = getComponentName(workInProgress.type) || "Component";
            if (!didWarnAboutStateAssignmentForComponent.has(componentName)) {
                didWarnAboutStateAssignmentForComponent.add(componentName);
                error("%s.componentWillReceiveProps(): Assigning directly to this.state is deprecated (except inside a component's constructor). Use setState instead.", componentName);
            }
            classComponentUpdater.enqueueReplaceState(instance, instance.state, null);
        }
    } // Invokes the mount life-cycles on a previously never rendered instance.
    function mountClassInstance(workInProgress, ctor, newProps, renderExpirationTime) {
        checkClassInstance(workInProgress, ctor, newProps);
        var instance = workInProgress.stateNode;
        instance.props = newProps;
        instance.state = workInProgress.memoizedState;
        instance.refs = emptyRefsObject;
        initializeUpdateQueue(workInProgress);
        var contextType = ctor.contextType;
        if (typeof contextType === "object" && contextType !== null) instance.context = readContext(contextType);
        else {
            var unmaskedContext = getUnmaskedContext(workInProgress, ctor, true);
            instance.context = getMaskedContext(workInProgress, unmaskedContext);
        }
        if (instance.state === newProps) {
            var componentName = getComponentName(ctor) || "Component";
            if (!didWarnAboutDirectlyAssigningPropsToState.has(componentName)) {
                didWarnAboutDirectlyAssigningPropsToState.add(componentName);
                error("%s: It is not recommended to assign props directly to state because updates to props won't be reflected in state. In most cases, it is better to use props directly.", componentName);
            }
        }
        if (workInProgress.mode & StrictMode) ReactStrictModeWarnings.recordLegacyContextWarning(workInProgress, instance);
        ReactStrictModeWarnings.recordUnsafeLifecycleWarnings(workInProgress, instance);
        processUpdateQueue(workInProgress, newProps, instance, renderExpirationTime);
        instance.state = workInProgress.memoizedState;
        var getDerivedStateFromProps = ctor.getDerivedStateFromProps;
        if (typeof getDerivedStateFromProps === "function") {
            applyDerivedStateFromProps(workInProgress, ctor, getDerivedStateFromProps, newProps);
            instance.state = workInProgress.memoizedState;
        } // In order to support react-lifecycles-compat polyfilled components,
        // Unsafe lifecycles should not be invoked for components using the new APIs.
        if (typeof ctor.getDerivedStateFromProps !== "function" && typeof instance.getSnapshotBeforeUpdate !== "function" && (typeof instance.UNSAFE_componentWillMount === "function" || typeof instance.componentWillMount === "function")) {
            callComponentWillMount(workInProgress, instance); // If we had additional state updates during this life-cycle, let's
            // process them now.
            processUpdateQueue(workInProgress, newProps, instance, renderExpirationTime);
            instance.state = workInProgress.memoizedState;
        }
        if (typeof instance.componentDidMount === "function") workInProgress.effectTag |= Update;
    }
    function resumeMountClassInstance(workInProgress, ctor, newProps, renderExpirationTime) {
        var instance = workInProgress.stateNode;
        var oldProps = workInProgress.memoizedProps;
        instance.props = oldProps;
        var oldContext = instance.context;
        var contextType = ctor.contextType;
        var nextContext = emptyContextObject;
        if (typeof contextType === "object" && contextType !== null) nextContext = readContext(contextType);
        else {
            var nextLegacyUnmaskedContext = getUnmaskedContext(workInProgress, ctor, true);
            nextContext = getMaskedContext(workInProgress, nextLegacyUnmaskedContext);
        }
        var getDerivedStateFromProps = ctor.getDerivedStateFromProps;
        var hasNewLifecycles = typeof getDerivedStateFromProps === "function" || typeof instance.getSnapshotBeforeUpdate === "function"; // Note: During these life-cycles, instance.props/instance.state are what
        // ever the previously attempted to render - not the "current". However,
        // during componentDidUpdate we pass the "current" props.
        // In order to support react-lifecycles-compat polyfilled components,
        // Unsafe lifecycles should not be invoked for components using the new APIs.
        if (!hasNewLifecycles && (typeof instance.UNSAFE_componentWillReceiveProps === "function" || typeof instance.componentWillReceiveProps === "function")) {
            if (oldProps !== newProps || oldContext !== nextContext) callComponentWillReceiveProps(workInProgress, instance, newProps, nextContext);
        }
        resetHasForceUpdateBeforeProcessing();
        var oldState = workInProgress.memoizedState;
        var newState = instance.state = oldState;
        processUpdateQueue(workInProgress, newProps, instance, renderExpirationTime);
        newState = workInProgress.memoizedState;
        if (oldProps === newProps && oldState === newState && !hasContextChanged() && !checkHasForceUpdateAfterProcessing()) {
            // If an update was already in progress, we should schedule an Update
            // effect even though we're bailing out, so that cWU/cDU are called.
            if (typeof instance.componentDidMount === "function") workInProgress.effectTag |= Update;
            return false;
        }
        if (typeof getDerivedStateFromProps === "function") {
            applyDerivedStateFromProps(workInProgress, ctor, getDerivedStateFromProps, newProps);
            newState = workInProgress.memoizedState;
        }
        var shouldUpdate = checkHasForceUpdateAfterProcessing() || checkShouldComponentUpdate(workInProgress, ctor, oldProps, newProps, oldState, newState, nextContext);
        if (shouldUpdate) {
            // In order to support react-lifecycles-compat polyfilled components,
            // Unsafe lifecycles should not be invoked for components using the new APIs.
            if (!hasNewLifecycles && (typeof instance.UNSAFE_componentWillMount === "function" || typeof instance.componentWillMount === "function")) {
                startPhaseTimer(workInProgress, "componentWillMount");
                if (typeof instance.componentWillMount === "function") instance.componentWillMount();
                if (typeof instance.UNSAFE_componentWillMount === "function") instance.UNSAFE_componentWillMount();
                stopPhaseTimer();
            }
            if (typeof instance.componentDidMount === "function") workInProgress.effectTag |= Update;
        } else {
            // If an update was already in progress, we should schedule an Update
            // effect even though we're bailing out, so that cWU/cDU are called.
            if (typeof instance.componentDidMount === "function") workInProgress.effectTag |= Update;
             // If shouldComponentUpdate returned false, we should still update the
            // memoized state to indicate that this work can be reused.
            workInProgress.memoizedProps = newProps;
            workInProgress.memoizedState = newState;
        } // Update the existing instance's state, props, and context pointers even
        // if shouldComponentUpdate returns false.
        instance.props = newProps;
        instance.state = newState;
        instance.context = nextContext;
        return shouldUpdate;
    } // Invokes the update life-cycles and returns false if it shouldn't rerender.
    function updateClassInstance(current, workInProgress, ctor, newProps, renderExpirationTime) {
        var instance = workInProgress.stateNode;
        cloneUpdateQueue(current, workInProgress);
        var oldProps = workInProgress.memoizedProps;
        instance.props = workInProgress.type === workInProgress.elementType ? oldProps : resolveDefaultProps(workInProgress.type, oldProps);
        var oldContext = instance.context;
        var contextType = ctor.contextType;
        var nextContext = emptyContextObject;
        if (typeof contextType === "object" && contextType !== null) nextContext = readContext(contextType);
        else {
            var nextUnmaskedContext = getUnmaskedContext(workInProgress, ctor, true);
            nextContext = getMaskedContext(workInProgress, nextUnmaskedContext);
        }
        var getDerivedStateFromProps = ctor.getDerivedStateFromProps;
        var hasNewLifecycles = typeof getDerivedStateFromProps === "function" || typeof instance.getSnapshotBeforeUpdate === "function"; // Note: During these life-cycles, instance.props/instance.state are what
        // ever the previously attempted to render - not the "current". However,
        // during componentDidUpdate we pass the "current" props.
        // In order to support react-lifecycles-compat polyfilled components,
        // Unsafe lifecycles should not be invoked for components using the new APIs.
        if (!hasNewLifecycles && (typeof instance.UNSAFE_componentWillReceiveProps === "function" || typeof instance.componentWillReceiveProps === "function")) {
            if (oldProps !== newProps || oldContext !== nextContext) callComponentWillReceiveProps(workInProgress, instance, newProps, nextContext);
        }
        resetHasForceUpdateBeforeProcessing();
        var oldState = workInProgress.memoizedState;
        var newState = instance.state = oldState;
        processUpdateQueue(workInProgress, newProps, instance, renderExpirationTime);
        newState = workInProgress.memoizedState;
        if (oldProps === newProps && oldState === newState && !hasContextChanged() && !checkHasForceUpdateAfterProcessing()) {
            // If an update was already in progress, we should schedule an Update
            // effect even though we're bailing out, so that cWU/cDU are called.
            if (typeof instance.componentDidUpdate === "function") {
                if (oldProps !== current.memoizedProps || oldState !== current.memoizedState) workInProgress.effectTag |= Update;
            }
            if (typeof instance.getSnapshotBeforeUpdate === "function") {
                if (oldProps !== current.memoizedProps || oldState !== current.memoizedState) workInProgress.effectTag |= Snapshot;
            }
            return false;
        }
        if (typeof getDerivedStateFromProps === "function") {
            applyDerivedStateFromProps(workInProgress, ctor, getDerivedStateFromProps, newProps);
            newState = workInProgress.memoizedState;
        }
        var shouldUpdate = checkHasForceUpdateAfterProcessing() || checkShouldComponentUpdate(workInProgress, ctor, oldProps, newProps, oldState, newState, nextContext);
        if (shouldUpdate) {
            // In order to support react-lifecycles-compat polyfilled components,
            // Unsafe lifecycles should not be invoked for components using the new APIs.
            if (!hasNewLifecycles && (typeof instance.UNSAFE_componentWillUpdate === "function" || typeof instance.componentWillUpdate === "function")) {
                startPhaseTimer(workInProgress, "componentWillUpdate");
                if (typeof instance.componentWillUpdate === "function") instance.componentWillUpdate(newProps, newState, nextContext);
                if (typeof instance.UNSAFE_componentWillUpdate === "function") instance.UNSAFE_componentWillUpdate(newProps, newState, nextContext);
                stopPhaseTimer();
            }
            if (typeof instance.componentDidUpdate === "function") workInProgress.effectTag |= Update;
            if (typeof instance.getSnapshotBeforeUpdate === "function") workInProgress.effectTag |= Snapshot;
        } else {
            // If an update was already in progress, we should schedule an Update
            // effect even though we're bailing out, so that cWU/cDU are called.
            if (typeof instance.componentDidUpdate === "function") {
                if (oldProps !== current.memoizedProps || oldState !== current.memoizedState) workInProgress.effectTag |= Update;
            }
            if (typeof instance.getSnapshotBeforeUpdate === "function") {
                if (oldProps !== current.memoizedProps || oldState !== current.memoizedState) workInProgress.effectTag |= Snapshot;
            } // If shouldComponentUpdate returned false, we should still update the
            // memoized props/state to indicate that this work can be reused.
            workInProgress.memoizedProps = newProps;
            workInProgress.memoizedState = newState;
        } // Update the existing instance's state, props, and context pointers even
        // if shouldComponentUpdate returns false.
        instance.props = newProps;
        instance.state = newState;
        instance.context = nextContext;
        return shouldUpdate;
    }
    var didWarnAboutMaps;
    var didWarnAboutGenerators;
    var didWarnAboutStringRefs;
    var ownerHasKeyUseWarning;
    var ownerHasFunctionTypeWarning;
    var warnForMissingKey = function(child) {};
    didWarnAboutMaps = false;
    didWarnAboutGenerators = false;
    didWarnAboutStringRefs = {};
    /**
   * Warn if there's no key explicitly set on dynamic arrays of children or
   * object keys are not valid. This allows us to keep track of children between
   * updates.
   */ ownerHasKeyUseWarning = {};
    ownerHasFunctionTypeWarning = {};
    warnForMissingKey = function(child) {
        if (child === null || typeof child !== "object") return;
        if (!child._store || child._store.validated || child.key != null) return;
        if (!(typeof child._store === "object")) throw Error("React Component in warnForMissingKey should have a _store. This error is likely caused by a bug in React. Please file an issue.");
        child._store.validated = true;
        var currentComponentErrorInfo = 'Each child in a list should have a unique "key" prop. See https://fb.me/react-warning-keys for more information.' + getCurrentFiberStackInDev();
        if (ownerHasKeyUseWarning[currentComponentErrorInfo]) return;
        ownerHasKeyUseWarning[currentComponentErrorInfo] = true;
        error('Each child in a list should have a unique "key" prop. See https://fb.me/react-warning-keys for more information.');
    };
    var isArray$1 = Array.isArray;
    function coerceRef(returnFiber, current, element) {
        var mixedRef = element.ref;
        if (mixedRef !== null && typeof mixedRef !== "function" && typeof mixedRef !== "object") {
            // TODO: Clean this up once we turn on the string ref warning for
            // everyone, because the strict mode case will no longer be relevant
            if ((returnFiber.mode & StrictMode || warnAboutStringRefs) && // We warn in ReactElement.js if owner and self are equal for string refs
            // because these cannot be automatically converted to an arrow function
            // using a codemod. Therefore, we don't have to warn about string refs again.
            !(element._owner && element._self && element._owner.stateNode !== element._self)) {
                var componentName = getComponentName(returnFiber.type) || "Component";
                if (!didWarnAboutStringRefs[componentName]) {
                    error('A string ref, "%s", has been found within a strict mode tree. String refs are a source of potential bugs and should be avoided. We recommend using useRef() or createRef() instead. Learn more about using refs safely here: https://fb.me/react-strict-mode-string-ref%s', mixedRef, getStackByFiberInDevAndProd(returnFiber));
                    didWarnAboutStringRefs[componentName] = true;
                }
            }
            if (element._owner) {
                var owner = element._owner;
                var inst;
                if (owner) {
                    var ownerFiber = owner;
                    if (!(ownerFiber.tag === ClassComponent)) throw Error("Function components cannot have string refs. We recommend using useRef() instead. Learn more about using refs safely here: https://fb.me/react-strict-mode-string-ref");
                    inst = ownerFiber.stateNode;
                }
                if (!inst) throw Error("Missing owner for string ref " + mixedRef + ". This error is likely caused by a bug in React. Please file an issue.");
                var stringRef = "" + mixedRef; // Check if previous string ref matches new string ref
                if (current !== null && current.ref !== null && typeof current.ref === "function" && current.ref._stringRef === stringRef) return current.ref;
                var ref = function(value) {
                    var refs = inst.refs;
                    if (refs === emptyRefsObject) // This is a lazy pooled frozen object, so we need to initialize.
                    refs = inst.refs = {};
                    if (value === null) delete refs[stringRef];
                    else refs[stringRef] = value;
                };
                ref._stringRef = stringRef;
                return ref;
            } else {
                if (!(typeof mixedRef === "string")) throw Error("Expected ref to be a function, a string, an object returned by React.createRef(), or null.");
                if (!element._owner) throw Error("Element ref was specified as a string (" + mixedRef + ") but no owner was set. This could happen for one of the following reasons:\n1. You may be adding a ref to a function component\n2. You may be adding a ref to a component that was not created inside a component's render method\n3. You have multiple copies of React loaded\nSee https://fb.me/react-refs-must-have-owner for more information.");
            }
        }
        return mixedRef;
    }
    function throwOnInvalidObjectType(returnFiber, newChild) {
        if (returnFiber.type !== "textarea") {
            var addendum = "";
            addendum = " If you meant to render a collection of children, use an array instead." + getCurrentFiberStackInDev();
            throw Error("Objects are not valid as a React child (found: " + (Object.prototype.toString.call(newChild) === "[object Object]" ? "object with keys {" + Object.keys(newChild).join(", ") + "}" : newChild) + ")." + addendum);
        }
    }
    function warnOnFunctionType() {
        var currentComponentErrorInfo = "Functions are not valid as a React child. This may happen if you return a Component instead of <Component /> from render. Or maybe you meant to call this function rather than return it." + getCurrentFiberStackInDev();
        if (ownerHasFunctionTypeWarning[currentComponentErrorInfo]) return;
        ownerHasFunctionTypeWarning[currentComponentErrorInfo] = true;
        error("Functions are not valid as a React child. This may happen if you return a Component instead of <Component /> from render. Or maybe you meant to call this function rather than return it.");
    } // This wrapper function exists because I expect to clone the code in each path
    // to be able to optimize each path individually by branching early. This needs
    // a compiler or we can do it manually. Helpers that don't need this branching
    // live outside of this function.
    function ChildReconciler(shouldTrackSideEffects) {
        function deleteChild(returnFiber, childToDelete) {
            if (!shouldTrackSideEffects) // Noop.
            return;
             // Deletions are added in reversed order so we add it to the front.
            // At this point, the return fiber's effect list is empty except for
            // deletions, so we can just append the deletion to the list. The remaining
            // effects aren't added until the complete phase. Once we implement
            // resuming, this may not be true.
            var last = returnFiber.lastEffect;
            if (last !== null) {
                last.nextEffect = childToDelete;
                returnFiber.lastEffect = childToDelete;
            } else returnFiber.firstEffect = returnFiber.lastEffect = childToDelete;
            childToDelete.nextEffect = null;
            childToDelete.effectTag = Deletion;
        }
        function deleteRemainingChildren(returnFiber, currentFirstChild) {
            if (!shouldTrackSideEffects) // Noop.
            return null;
             // TODO: For the shouldClone case, this could be micro-optimized a bit by
            // assuming that after the first child we've already added everything.
            var childToDelete = currentFirstChild;
            while(childToDelete !== null){
                deleteChild(returnFiber, childToDelete);
                childToDelete = childToDelete.sibling;
            }
            return null;
        }
        function mapRemainingChildren(returnFiber, currentFirstChild) {
            // Add the remaining children to a temporary map so that we can find them by
            // keys quickly. Implicit (null) keys get added to this set with their index
            // instead.
            var existingChildren = new Map();
            var existingChild = currentFirstChild;
            while(existingChild !== null){
                if (existingChild.key !== null) existingChildren.set(existingChild.key, existingChild);
                else existingChildren.set(existingChild.index, existingChild);
                existingChild = existingChild.sibling;
            }
            return existingChildren;
        }
        function useFiber(fiber, pendingProps) {
            // We currently set sibling to null and index to 0 here because it is easy
            // to forget to do before returning it. E.g. for the single child case.
            var clone = createWorkInProgress(fiber, pendingProps);
            clone.index = 0;
            clone.sibling = null;
            return clone;
        }
        function placeChild(newFiber, lastPlacedIndex, newIndex) {
            newFiber.index = newIndex;
            if (!shouldTrackSideEffects) // Noop.
            return lastPlacedIndex;
            var current = newFiber.alternate;
            if (current !== null) {
                var oldIndex = current.index;
                if (oldIndex < lastPlacedIndex) {
                    // This is a move.
                    newFiber.effectTag = Placement;
                    return lastPlacedIndex;
                } else // This item can stay in place.
                return oldIndex;
            } else {
                // This is an insertion.
                newFiber.effectTag = Placement;
                return lastPlacedIndex;
            }
        }
        function placeSingleChild(newFiber) {
            // This is simpler for the single child case. We only need to do a
            // placement for inserting new children.
            if (shouldTrackSideEffects && newFiber.alternate === null) newFiber.effectTag = Placement;
            return newFiber;
        }
        function updateTextNode(returnFiber, current, textContent, expirationTime) {
            if (current === null || current.tag !== HostText) {
                // Insert
                var created = createFiberFromText(textContent, returnFiber.mode, expirationTime);
                created.return = returnFiber;
                return created;
            } else {
                // Update
                var existing = useFiber(current, textContent);
                existing.return = returnFiber;
                return existing;
            }
        }
        function updateElement(returnFiber, current, element, expirationTime) {
            if (current !== null) {
                if (current.elementType === element.type || isCompatibleFamilyForHotReloading(current, element)) {
                    // Move based on index
                    var existing = useFiber(current, element.props);
                    existing.ref = coerceRef(returnFiber, current, element);
                    existing.return = returnFiber;
                    existing._debugSource = element._source;
                    existing._debugOwner = element._owner;
                    return existing;
                }
            } // Insert
            var created = createFiberFromElement(element, returnFiber.mode, expirationTime);
            created.ref = coerceRef(returnFiber, current, element);
            created.return = returnFiber;
            return created;
        }
        function updatePortal(returnFiber, current, portal, expirationTime) {
            if (current === null || current.tag !== HostPortal || current.stateNode.containerInfo !== portal.containerInfo || current.stateNode.implementation !== portal.implementation) {
                // Insert
                var created = createFiberFromPortal(portal, returnFiber.mode, expirationTime);
                created.return = returnFiber;
                return created;
            } else {
                // Update
                var existing = useFiber(current, portal.children || []);
                existing.return = returnFiber;
                return existing;
            }
        }
        function updateFragment(returnFiber, current, fragment, expirationTime, key) {
            if (current === null || current.tag !== Fragment) {
                // Insert
                var created = createFiberFromFragment(fragment, returnFiber.mode, expirationTime, key);
                created.return = returnFiber;
                return created;
            } else {
                // Update
                var existing = useFiber(current, fragment);
                existing.return = returnFiber;
                return existing;
            }
        }
        function createChild(returnFiber, newChild, expirationTime) {
            if (typeof newChild === "string" || typeof newChild === "number") {
                // Text nodes don't have keys. If the previous node is implicitly keyed
                // we can continue to replace it without aborting even if it is not a text
                // node.
                var created = createFiberFromText("" + newChild, returnFiber.mode, expirationTime);
                created.return = returnFiber;
                return created;
            }
            if (typeof newChild === "object" && newChild !== null) {
                switch(newChild.$$typeof){
                    case REACT_ELEMENT_TYPE:
                        var _created = createFiberFromElement(newChild, returnFiber.mode, expirationTime);
                        _created.ref = coerceRef(returnFiber, null, newChild);
                        _created.return = returnFiber;
                        return _created;
                    case REACT_PORTAL_TYPE:
                        var _created2 = createFiberFromPortal(newChild, returnFiber.mode, expirationTime);
                        _created2.return = returnFiber;
                        return _created2;
                }
                if (isArray$1(newChild) || getIteratorFn(newChild)) {
                    var _created3 = createFiberFromFragment(newChild, returnFiber.mode, expirationTime, null);
                    _created3.return = returnFiber;
                    return _created3;
                }
                throwOnInvalidObjectType(returnFiber, newChild);
            }
            if (typeof newChild === "function") warnOnFunctionType();
            return null;
        }
        function updateSlot(returnFiber, oldFiber, newChild, expirationTime) {
            // Update the fiber if the keys match, otherwise return null.
            var key = oldFiber !== null ? oldFiber.key : null;
            if (typeof newChild === "string" || typeof newChild === "number") {
                // Text nodes don't have keys. If the previous node is implicitly keyed
                // we can continue to replace it without aborting even if it is not a text
                // node.
                if (key !== null) return null;
                return updateTextNode(returnFiber, oldFiber, "" + newChild, expirationTime);
            }
            if (typeof newChild === "object" && newChild !== null) {
                switch(newChild.$$typeof){
                    case REACT_ELEMENT_TYPE:
                        if (newChild.key === key) {
                            if (newChild.type === REACT_FRAGMENT_TYPE) return updateFragment(returnFiber, oldFiber, newChild.props.children, expirationTime, key);
                            return updateElement(returnFiber, oldFiber, newChild, expirationTime);
                        } else return null;
                    case REACT_PORTAL_TYPE:
                        if (newChild.key === key) return updatePortal(returnFiber, oldFiber, newChild, expirationTime);
                        else return null;
                }
                if (isArray$1(newChild) || getIteratorFn(newChild)) {
                    if (key !== null) return null;
                    return updateFragment(returnFiber, oldFiber, newChild, expirationTime, null);
                }
                throwOnInvalidObjectType(returnFiber, newChild);
            }
            if (typeof newChild === "function") warnOnFunctionType();
            return null;
        }
        function updateFromMap(existingChildren, returnFiber, newIdx, newChild, expirationTime) {
            if (typeof newChild === "string" || typeof newChild === "number") {
                // Text nodes don't have keys, so we neither have to check the old nor
                // new node for the key. If both are text nodes, they match.
                var matchedFiber = existingChildren.get(newIdx) || null;
                return updateTextNode(returnFiber, matchedFiber, "" + newChild, expirationTime);
            }
            if (typeof newChild === "object" && newChild !== null) {
                switch(newChild.$$typeof){
                    case REACT_ELEMENT_TYPE:
                        var _matchedFiber = existingChildren.get(newChild.key === null ? newIdx : newChild.key) || null;
                        if (newChild.type === REACT_FRAGMENT_TYPE) return updateFragment(returnFiber, _matchedFiber, newChild.props.children, expirationTime, newChild.key);
                        return updateElement(returnFiber, _matchedFiber, newChild, expirationTime);
                    case REACT_PORTAL_TYPE:
                        var _matchedFiber2 = existingChildren.get(newChild.key === null ? newIdx : newChild.key) || null;
                        return updatePortal(returnFiber, _matchedFiber2, newChild, expirationTime);
                }
                if (isArray$1(newChild) || getIteratorFn(newChild)) {
                    var _matchedFiber3 = existingChildren.get(newIdx) || null;
                    return updateFragment(returnFiber, _matchedFiber3, newChild, expirationTime, null);
                }
                throwOnInvalidObjectType(returnFiber, newChild);
            }
            if (typeof newChild === "function") warnOnFunctionType();
            return null;
        }
        /**
   * Warns if there is a duplicate or missing key
   */ function warnOnInvalidKey(child, knownKeys) {
            if (typeof child !== "object" || child === null) return knownKeys;
            switch(child.$$typeof){
                case REACT_ELEMENT_TYPE:
                case REACT_PORTAL_TYPE:
                    warnForMissingKey(child);
                    var key = child.key;
                    if (typeof key !== "string") break;
                    if (knownKeys === null) {
                        knownKeys = new Set();
                        knownKeys.add(key);
                        break;
                    }
                    if (!knownKeys.has(key)) {
                        knownKeys.add(key);
                        break;
                    }
                    error("Encountered two children with the same key, `%s`. Keys should be unique so that components maintain their identity across updates. Non-unique keys may cause children to be duplicated and/or omitted \u2014 the behavior is unsupported and could change in a future version.", key);
                    break;
            }
            return knownKeys;
        }
        function reconcileChildrenArray(returnFiber, currentFirstChild, newChildren, expirationTime) {
            // First, validate keys.
            var knownKeys = null;
            for(var i = 0; i < newChildren.length; i++){
                var child = newChildren[i];
                knownKeys = warnOnInvalidKey(child, knownKeys);
            }
            var resultingFirstChild = null;
            var previousNewFiber = null;
            var oldFiber = currentFirstChild;
            var lastPlacedIndex = 0;
            var newIdx = 0;
            var nextOldFiber = null;
            for(; oldFiber !== null && newIdx < newChildren.length; newIdx++){
                if (oldFiber.index > newIdx) {
                    nextOldFiber = oldFiber;
                    oldFiber = null;
                } else nextOldFiber = oldFiber.sibling;
                var newFiber = updateSlot(returnFiber, oldFiber, newChildren[newIdx], expirationTime);
                if (newFiber === null) {
                    // TODO: This breaks on empty slots like null children. That's
                    // unfortunate because it triggers the slow path all the time. We need
                    // a better way to communicate whether this was a miss or null,
                    // boolean, undefined, etc.
                    if (oldFiber === null) oldFiber = nextOldFiber;
                    break;
                }
                if (shouldTrackSideEffects) {
                    if (oldFiber && newFiber.alternate === null) // We matched the slot, but we didn't reuse the existing fiber, so we
                    // need to delete the existing child.
                    deleteChild(returnFiber, oldFiber);
                }
                lastPlacedIndex = placeChild(newFiber, lastPlacedIndex, newIdx);
                if (previousNewFiber === null) // TODO: Move out of the loop. This only happens for the first run.
                resultingFirstChild = newFiber;
                else // TODO: Defer siblings if we're not at the right index for this slot.
                // I.e. if we had null values before, then we want to defer this
                // for each null value. However, we also don't want to call updateSlot
                // with the previous one.
                previousNewFiber.sibling = newFiber;
                previousNewFiber = newFiber;
                oldFiber = nextOldFiber;
            }
            if (newIdx === newChildren.length) {
                // We've reached the end of the new children. We can delete the rest.
                deleteRemainingChildren(returnFiber, oldFiber);
                return resultingFirstChild;
            }
            if (oldFiber === null) {
                // If we don't have any more existing children we can choose a fast path
                // since the rest will all be insertions.
                for(; newIdx < newChildren.length; newIdx++){
                    var _newFiber = createChild(returnFiber, newChildren[newIdx], expirationTime);
                    if (_newFiber === null) continue;
                    lastPlacedIndex = placeChild(_newFiber, lastPlacedIndex, newIdx);
                    if (previousNewFiber === null) // TODO: Move out of the loop. This only happens for the first run.
                    resultingFirstChild = _newFiber;
                    else previousNewFiber.sibling = _newFiber;
                    previousNewFiber = _newFiber;
                }
                return resultingFirstChild;
            } // Add all children to a key map for quick lookups.
            var existingChildren = mapRemainingChildren(returnFiber, oldFiber); // Keep scanning and use the map to restore deleted items as moves.
            for(; newIdx < newChildren.length; newIdx++){
                var _newFiber2 = updateFromMap(existingChildren, returnFiber, newIdx, newChildren[newIdx], expirationTime);
                if (_newFiber2 !== null) {
                    if (shouldTrackSideEffects) {
                        if (_newFiber2.alternate !== null) // The new fiber is a work in progress, but if there exists a
                        // current, that means that we reused the fiber. We need to delete
                        // it from the child list so that we don't add it to the deletion
                        // list.
                        existingChildren.delete(_newFiber2.key === null ? newIdx : _newFiber2.key);
                    }
                    lastPlacedIndex = placeChild(_newFiber2, lastPlacedIndex, newIdx);
                    if (previousNewFiber === null) resultingFirstChild = _newFiber2;
                    else previousNewFiber.sibling = _newFiber2;
                    previousNewFiber = _newFiber2;
                }
            }
            if (shouldTrackSideEffects) // Any existing children that weren't consumed above were deleted. We need
            // to add them to the deletion list.
            existingChildren.forEach(function(child) {
                return deleteChild(returnFiber, child);
            });
            return resultingFirstChild;
        }
        function reconcileChildrenIterator(returnFiber, currentFirstChild, newChildrenIterable, expirationTime) {
            // This is the same implementation as reconcileChildrenArray(),
            // but using the iterator instead.
            var iteratorFn = getIteratorFn(newChildrenIterable);
            if (!(typeof iteratorFn === "function")) throw Error("An object is not an iterable. This error is likely caused by a bug in React. Please file an issue.");
            // We don't support rendering Generators because it's a mutation.
            // See https://github.com/facebook/react/issues/12995
            if (typeof Symbol === "function" && // $FlowFixMe Flow doesn't know about toStringTag
            newChildrenIterable[Symbol.toStringTag] === "Generator") {
                if (!didWarnAboutGenerators) error("Using Generators as children is unsupported and will likely yield unexpected results because enumerating a generator mutates it. You may convert it to an array with `Array.from()` or the `[...spread]` operator before rendering. Keep in mind you might need to polyfill these features for older browsers.");
                didWarnAboutGenerators = true;
            } // Warn about using Maps as children
            if (newChildrenIterable.entries === iteratorFn) {
                if (!didWarnAboutMaps) error("Using Maps as children is unsupported and will likely yield unexpected results. Convert it to a sequence/iterable of keyed ReactElements instead.");
                didWarnAboutMaps = true;
            } // First, validate keys.
            // We'll get a different iterator later for the main pass.
            var _newChildren = iteratorFn.call(newChildrenIterable);
            if (_newChildren) {
                var knownKeys = null;
                var _step = _newChildren.next();
                for(; !_step.done; _step = _newChildren.next()){
                    var child = _step.value;
                    knownKeys = warnOnInvalidKey(child, knownKeys);
                }
            }
            var newChildren = iteratorFn.call(newChildrenIterable);
            if (!(newChildren != null)) throw Error("An iterable object provided no iterator.");
            var resultingFirstChild = null;
            var previousNewFiber = null;
            var oldFiber = currentFirstChild;
            var lastPlacedIndex = 0;
            var newIdx = 0;
            var nextOldFiber = null;
            var step = newChildren.next();
            for(; oldFiber !== null && !step.done; newIdx++, step = newChildren.next()){
                if (oldFiber.index > newIdx) {
                    nextOldFiber = oldFiber;
                    oldFiber = null;
                } else nextOldFiber = oldFiber.sibling;
                var newFiber = updateSlot(returnFiber, oldFiber, step.value, expirationTime);
                if (newFiber === null) {
                    // TODO: This breaks on empty slots like null children. That's
                    // unfortunate because it triggers the slow path all the time. We need
                    // a better way to communicate whether this was a miss or null,
                    // boolean, undefined, etc.
                    if (oldFiber === null) oldFiber = nextOldFiber;
                    break;
                }
                if (shouldTrackSideEffects) {
                    if (oldFiber && newFiber.alternate === null) // We matched the slot, but we didn't reuse the existing fiber, so we
                    // need to delete the existing child.
                    deleteChild(returnFiber, oldFiber);
                }
                lastPlacedIndex = placeChild(newFiber, lastPlacedIndex, newIdx);
                if (previousNewFiber === null) // TODO: Move out of the loop. This only happens for the first run.
                resultingFirstChild = newFiber;
                else // TODO: Defer siblings if we're not at the right index for this slot.
                // I.e. if we had null values before, then we want to defer this
                // for each null value. However, we also don't want to call updateSlot
                // with the previous one.
                previousNewFiber.sibling = newFiber;
                previousNewFiber = newFiber;
                oldFiber = nextOldFiber;
            }
            if (step.done) {
                // We've reached the end of the new children. We can delete the rest.
                deleteRemainingChildren(returnFiber, oldFiber);
                return resultingFirstChild;
            }
            if (oldFiber === null) {
                // If we don't have any more existing children we can choose a fast path
                // since the rest will all be insertions.
                for(; !step.done; newIdx++, step = newChildren.next()){
                    var _newFiber3 = createChild(returnFiber, step.value, expirationTime);
                    if (_newFiber3 === null) continue;
                    lastPlacedIndex = placeChild(_newFiber3, lastPlacedIndex, newIdx);
                    if (previousNewFiber === null) // TODO: Move out of the loop. This only happens for the first run.
                    resultingFirstChild = _newFiber3;
                    else previousNewFiber.sibling = _newFiber3;
                    previousNewFiber = _newFiber3;
                }
                return resultingFirstChild;
            } // Add all children to a key map for quick lookups.
            var existingChildren = mapRemainingChildren(returnFiber, oldFiber); // Keep scanning and use the map to restore deleted items as moves.
            for(; !step.done; newIdx++, step = newChildren.next()){
                var _newFiber4 = updateFromMap(existingChildren, returnFiber, newIdx, step.value, expirationTime);
                if (_newFiber4 !== null) {
                    if (shouldTrackSideEffects) {
                        if (_newFiber4.alternate !== null) // The new fiber is a work in progress, but if there exists a
                        // current, that means that we reused the fiber. We need to delete
                        // it from the child list so that we don't add it to the deletion
                        // list.
                        existingChildren.delete(_newFiber4.key === null ? newIdx : _newFiber4.key);
                    }
                    lastPlacedIndex = placeChild(_newFiber4, lastPlacedIndex, newIdx);
                    if (previousNewFiber === null) resultingFirstChild = _newFiber4;
                    else previousNewFiber.sibling = _newFiber4;
                    previousNewFiber = _newFiber4;
                }
            }
            if (shouldTrackSideEffects) // Any existing children that weren't consumed above were deleted. We need
            // to add them to the deletion list.
            existingChildren.forEach(function(child) {
                return deleteChild(returnFiber, child);
            });
            return resultingFirstChild;
        }
        function reconcileSingleTextNode(returnFiber, currentFirstChild, textContent, expirationTime) {
            // There's no need to check for keys on text nodes since we don't have a
            // way to define them.
            if (currentFirstChild !== null && currentFirstChild.tag === HostText) {
                // We already have an existing node so let's just update it and delete
                // the rest.
                deleteRemainingChildren(returnFiber, currentFirstChild.sibling);
                var existing = useFiber(currentFirstChild, textContent);
                existing.return = returnFiber;
                return existing;
            } // The existing first child is not a text node so we need to create one
            // and delete the existing ones.
            deleteRemainingChildren(returnFiber, currentFirstChild);
            var created = createFiberFromText(textContent, returnFiber.mode, expirationTime);
            created.return = returnFiber;
            return created;
        }
        function reconcileSingleElement(returnFiber, currentFirstChild, element, expirationTime) {
            var key = element.key;
            var child = currentFirstChild;
            while(child !== null){
                // TODO: If key === null and child.key === null, then this only applies to
                // the first item in the list.
                if (child.key === key) {
                    switch(child.tag){
                        case Fragment:
                            if (element.type === REACT_FRAGMENT_TYPE) {
                                deleteRemainingChildren(returnFiber, child.sibling);
                                var existing = useFiber(child, element.props.children);
                                existing.return = returnFiber;
                                existing._debugSource = element._source;
                                existing._debugOwner = element._owner;
                                return existing;
                            }
                            break;
                        case Block:
                        // We intentionally fallthrough here if enableBlocksAPI is not on.
                        // eslint-disable-next-lined no-fallthrough
                        default:
                            if (child.elementType === element.type || isCompatibleFamilyForHotReloading(child, element)) {
                                deleteRemainingChildren(returnFiber, child.sibling);
                                var _existing3 = useFiber(child, element.props);
                                _existing3.ref = coerceRef(returnFiber, child, element);
                                _existing3.return = returnFiber;
                                _existing3._debugSource = element._source;
                                _existing3._debugOwner = element._owner;
                                return _existing3;
                            }
                            break;
                    } // Didn't match.
                    deleteRemainingChildren(returnFiber, child);
                    break;
                } else deleteChild(returnFiber, child);
                child = child.sibling;
            }
            if (element.type === REACT_FRAGMENT_TYPE) {
                var created = createFiberFromFragment(element.props.children, returnFiber.mode, expirationTime, element.key);
                created.return = returnFiber;
                return created;
            } else {
                var _created4 = createFiberFromElement(element, returnFiber.mode, expirationTime);
                _created4.ref = coerceRef(returnFiber, currentFirstChild, element);
                _created4.return = returnFiber;
                return _created4;
            }
        }
        function reconcileSinglePortal(returnFiber, currentFirstChild, portal, expirationTime) {
            var key = portal.key;
            var child = currentFirstChild;
            while(child !== null){
                // TODO: If key === null and child.key === null, then this only applies to
                // the first item in the list.
                if (child.key === key) {
                    if (child.tag === HostPortal && child.stateNode.containerInfo === portal.containerInfo && child.stateNode.implementation === portal.implementation) {
                        deleteRemainingChildren(returnFiber, child.sibling);
                        var existing = useFiber(child, portal.children || []);
                        existing.return = returnFiber;
                        return existing;
                    } else {
                        deleteRemainingChildren(returnFiber, child);
                        break;
                    }
                } else deleteChild(returnFiber, child);
                child = child.sibling;
            }
            var created = createFiberFromPortal(portal, returnFiber.mode, expirationTime);
            created.return = returnFiber;
            return created;
        } // This API will tag the children with the side-effect of the reconciliation
        // itself. They will be added to the side-effect list as we pass through the
        // children and the parent.
        function reconcileChildFibers(returnFiber, currentFirstChild, newChild, expirationTime) {
            // This function is not recursive.
            // If the top level item is an array, we treat it as a set of children,
            // not as a fragment. Nested arrays on the other hand will be treated as
            // fragment nodes. Recursion happens at the normal flow.
            // Handle top level unkeyed fragments as if they were arrays.
            // This leads to an ambiguity between <>{[...]}</> and <>...</>.
            // We treat the ambiguous cases above the same.
            var isUnkeyedTopLevelFragment = typeof newChild === "object" && newChild !== null && newChild.type === REACT_FRAGMENT_TYPE && newChild.key === null;
            if (isUnkeyedTopLevelFragment) newChild = newChild.props.children;
             // Handle object types
            var isObject = typeof newChild === "object" && newChild !== null;
            if (isObject) switch(newChild.$$typeof){
                case REACT_ELEMENT_TYPE:
                    return placeSingleChild(reconcileSingleElement(returnFiber, currentFirstChild, newChild, expirationTime));
                case REACT_PORTAL_TYPE:
                    return placeSingleChild(reconcileSinglePortal(returnFiber, currentFirstChild, newChild, expirationTime));
            }
            if (typeof newChild === "string" || typeof newChild === "number") return placeSingleChild(reconcileSingleTextNode(returnFiber, currentFirstChild, "" + newChild, expirationTime));
            if (isArray$1(newChild)) return reconcileChildrenArray(returnFiber, currentFirstChild, newChild, expirationTime);
            if (getIteratorFn(newChild)) return reconcileChildrenIterator(returnFiber, currentFirstChild, newChild, expirationTime);
            if (isObject) throwOnInvalidObjectType(returnFiber, newChild);
            if (typeof newChild === "function") warnOnFunctionType();
            if (typeof newChild === "undefined" && !isUnkeyedTopLevelFragment) // If the new child is undefined, and the return fiber is a composite
            // component, throw an error. If Fiber return types are disabled,
            // we already threw above.
            switch(returnFiber.tag){
                case ClassComponent:
                    var instance = returnFiber.stateNode;
                    if (instance.render._isMockFunction) break;
                // Intentionally fall through to the next case, which handles both
                // functions and classes
                // eslint-disable-next-lined no-fallthrough
                case FunctionComponent:
                    var Component = returnFiber.type;
                    throw Error((Component.displayName || Component.name || "Component") + "(...): Nothing was returned from render. This usually means a return statement is missing. Or, to render nothing, return null.");
            }
             // Remaining cases are all treated as empty.
            return deleteRemainingChildren(returnFiber, currentFirstChild);
        }
        return reconcileChildFibers;
    }
    var reconcileChildFibers = ChildReconciler(true);
    var mountChildFibers = ChildReconciler(false);
    function cloneChildFibers(current, workInProgress) {
        if (!(current === null || workInProgress.child === current.child)) throw Error("Resuming work not yet implemented.");
        if (workInProgress.child === null) return;
        var currentChild = workInProgress.child;
        var newChild = createWorkInProgress(currentChild, currentChild.pendingProps);
        workInProgress.child = newChild;
        newChild.return = workInProgress;
        while(currentChild.sibling !== null){
            currentChild = currentChild.sibling;
            newChild = newChild.sibling = createWorkInProgress(currentChild, currentChild.pendingProps);
            newChild.return = workInProgress;
        }
        newChild.sibling = null;
    } // Reset a workInProgress child set to prepare it for a second pass.
    function resetChildFibers(workInProgress, renderExpirationTime) {
        var child = workInProgress.child;
        while(child !== null){
            resetWorkInProgress(child, renderExpirationTime);
            child = child.sibling;
        }
    }
    var NO_CONTEXT = {};
    var contextStackCursor$1 = createCursor(NO_CONTEXT);
    var contextFiberStackCursor = createCursor(NO_CONTEXT);
    var rootInstanceStackCursor = createCursor(NO_CONTEXT);
    function requiredContext(c) {
        if (!(c !== NO_CONTEXT)) throw Error("Expected host context to exist. This error is likely caused by a bug in React. Please file an issue.");
        return c;
    }
    function getRootHostContainer() {
        var rootInstance = requiredContext(rootInstanceStackCursor.current);
        return rootInstance;
    }
    function pushHostContainer(fiber, nextRootInstance) {
        // Push current root instance onto the stack;
        // This allows us to reset root when portals are popped.
        push(rootInstanceStackCursor, nextRootInstance, fiber); // Track the context and the Fiber that provided it.
        // This enables us to pop only Fibers that provide unique contexts.
        push(contextFiberStackCursor, fiber, fiber); // Finally, we need to push the host context to the stack.
        // However, we can't just call getRootHostContext() and push it because
        // we'd have a different number of entries on the stack depending on
        // whether getRootHostContext() throws somewhere in renderer code or not.
        // So we push an empty value first. This lets us safely unwind on errors.
        push(contextStackCursor$1, NO_CONTEXT, fiber);
        var nextRootContext = getRootHostContext(nextRootInstance); // Now that we know this function doesn't throw, replace it.
        pop(contextStackCursor$1, fiber);
        push(contextStackCursor$1, nextRootContext, fiber);
    }
    function popHostContainer(fiber) {
        pop(contextStackCursor$1, fiber);
        pop(contextFiberStackCursor, fiber);
        pop(rootInstanceStackCursor, fiber);
    }
    function getHostContext() {
        var context = requiredContext(contextStackCursor$1.current);
        return context;
    }
    function pushHostContext(fiber) {
        var rootInstance = requiredContext(rootInstanceStackCursor.current);
        var context = requiredContext(contextStackCursor$1.current);
        var nextContext = getChildHostContext(context, fiber.type); // Don't push this Fiber's context unless it's unique.
        if (context === nextContext) return;
         // Track the context and the Fiber that provided it.
        // This enables us to pop only Fibers that provide unique contexts.
        push(contextFiberStackCursor, fiber, fiber);
        push(contextStackCursor$1, nextContext, fiber);
    }
    function popHostContext(fiber) {
        // Do not pop unless this Fiber provided the current context.
        // pushHostContext() only pushes Fibers that provide unique contexts.
        if (contextFiberStackCursor.current !== fiber) return;
        pop(contextStackCursor$1, fiber);
        pop(contextFiberStackCursor, fiber);
    }
    var DefaultSuspenseContext = 0; // The Suspense Context is split into two parts. The lower bits is
    // inherited deeply down the subtree. The upper bits only affect
    // this immediate suspense boundary and gets reset each new
    // boundary or suspense list.
    var SubtreeSuspenseContextMask = 1; // Subtree Flags:
    // InvisibleParentSuspenseContext indicates that one of our parent Suspense
    // boundaries is not currently showing visible main content.
    // Either because it is already showing a fallback or is not mounted at all.
    // We can use this to determine if it is desirable to trigger a fallback at
    // the parent. If not, then we might need to trigger undesirable boundaries
    // and/or suspend the commit to avoid hiding the parent content.
    var InvisibleParentSuspenseContext = 1; // Shallow Flags:
    // ForceSuspenseFallback can be used by SuspenseList to force newly added
    // items into their fallback state during one of the render passes.
    var ForceSuspenseFallback = 2;
    var suspenseStackCursor = createCursor(DefaultSuspenseContext);
    function hasSuspenseContext(parentContext, flag) {
        return (parentContext & flag) !== 0;
    }
    function setDefaultShallowSuspenseContext(parentContext) {
        return parentContext & SubtreeSuspenseContextMask;
    }
    function setShallowSuspenseContext(parentContext, shallowContext) {
        return parentContext & SubtreeSuspenseContextMask | shallowContext;
    }
    function addSubtreeSuspenseContext(parentContext, subtreeContext) {
        return parentContext | subtreeContext;
    }
    function pushSuspenseContext(fiber, newContext) {
        push(suspenseStackCursor, newContext, fiber);
    }
    function popSuspenseContext(fiber) {
        pop(suspenseStackCursor, fiber);
    }
    function shouldCaptureSuspense(workInProgress, hasInvisibleParent) {
        // If it was the primary children that just suspended, capture and render the
        // fallback. Otherwise, don't capture and bubble to the next boundary.
        var nextState = workInProgress.memoizedState;
        if (nextState !== null) {
            if (nextState.dehydrated !== null) // A dehydrated boundary always captures.
            return true;
            return false;
        }
        var props = workInProgress.memoizedProps; // In order to capture, the Suspense component must have a fallback prop.
        if (props.fallback === undefined) return false;
         // Regular boundaries always capture.
        if (props.unstable_avoidThisFallback !== true) return true;
         // If it's a boundary we should avoid, then we prefer to bubble up to the
        // parent boundary if it is currently invisible.
        if (hasInvisibleParent) return false;
         // If the parent is not able to handle it, we must handle it.
        return true;
    }
    function findFirstSuspended(row) {
        var node = row;
        while(node !== null){
            if (node.tag === SuspenseComponent) {
                var state = node.memoizedState;
                if (state !== null) {
                    var dehydrated = state.dehydrated;
                    if (dehydrated === null || isSuspenseInstancePending(dehydrated) || isSuspenseInstanceFallback(dehydrated)) return node;
                }
            } else if (node.tag === SuspenseListComponent && // revealOrder undefined can't be trusted because it don't
            // keep track of whether it suspended or not.
            node.memoizedProps.revealOrder !== undefined) {
                var didSuspend = (node.effectTag & DidCapture) !== NoEffect;
                if (didSuspend) return node;
            } else if (node.child !== null) {
                node.child.return = node;
                node = node.child;
                continue;
            }
            if (node === row) return null;
            while(node.sibling === null){
                if (node.return === null || node.return === row) return null;
                node = node.return;
            }
            node.sibling.return = node.return;
            node = node.sibling;
        }
        return null;
    }
    function createDeprecatedResponderListener(responder, props) {
        var eventResponderListener = {
            responder: responder,
            props: props
        };
        Object.freeze(eventResponderListener);
        return eventResponderListener;
    }
    var HasEffect = /* */ 1; // Represents the phase in which the effect (not the clean-up) fires.
    var Layout = /*    */ 2;
    var Passive$1 = /*   */ 4;
    var ReactCurrentDispatcher = ReactSharedInternals.ReactCurrentDispatcher, ReactCurrentBatchConfig$1 = ReactSharedInternals.ReactCurrentBatchConfig;
    var didWarnAboutMismatchedHooksForComponent;
    didWarnAboutMismatchedHooksForComponent = new Set();
    // These are set right before calling the component.
    var renderExpirationTime = NoWork; // The work-in-progress fiber. I've named it differently to distinguish it from
    // the work-in-progress hook.
    var currentlyRenderingFiber$1 = null; // Hooks are stored as a linked list on the fiber's memoizedState field. The
    // current hook list is the list that belongs to the current fiber. The
    // work-in-progress hook list is a new list that will be added to the
    // work-in-progress fiber.
    var currentHook = null;
    var workInProgressHook = null; // Whether an update was scheduled at any point during the render phase. This
    // does not get reset if we do another render pass; only when we're completely
    // finished evaluating this component. This is an optimization so we know
    // whether we need to clear render phase updates after a throw.
    var didScheduleRenderPhaseUpdate = false;
    var RE_RENDER_LIMIT = 25; // In DEV, this is the name of the currently executing primitive hook
    var currentHookNameInDev = null; // In DEV, this list ensures that hooks are called in the same order between renders.
    // The list stores the order of hooks used during the initial render (mount).
    // Subsequent renders (updates) reference this list.
    var hookTypesDev = null;
    var hookTypesUpdateIndexDev = -1; // In DEV, this tracks whether currently rendering component needs to ignore
    // the dependencies for Hooks that need them (e.g. useEffect or useMemo).
    // When true, such Hooks will always be "remounted". Only used during hot reload.
    var ignorePreviousDependencies = false;
    function mountHookTypesDev() {
        var hookName = currentHookNameInDev;
        if (hookTypesDev === null) hookTypesDev = [
            hookName
        ];
        else hookTypesDev.push(hookName);
    }
    function updateHookTypesDev() {
        var hookName = currentHookNameInDev;
        if (hookTypesDev !== null) {
            hookTypesUpdateIndexDev++;
            if (hookTypesDev[hookTypesUpdateIndexDev] !== hookName) warnOnHookMismatchInDev(hookName);
        }
    }
    function checkDepsAreArrayDev(deps) {
        if (deps !== undefined && deps !== null && !Array.isArray(deps)) // Verify deps, but only on mount to avoid extra checks.
        // It's unlikely their type would change as usually you define them inline.
        error("%s received a final argument that is not an array (instead, received `%s`). When specified, the final argument must be an array.", currentHookNameInDev, typeof deps);
    }
    function warnOnHookMismatchInDev(currentHookName) {
        var componentName = getComponentName(currentlyRenderingFiber$1.type);
        if (!didWarnAboutMismatchedHooksForComponent.has(componentName)) {
            didWarnAboutMismatchedHooksForComponent.add(componentName);
            if (hookTypesDev !== null) {
                var table = "";
                var secondColumnStart = 30;
                for(var i = 0; i <= hookTypesUpdateIndexDev; i++){
                    var oldHookName = hookTypesDev[i];
                    var newHookName = i === hookTypesUpdateIndexDev ? currentHookName : oldHookName;
                    var row = i + 1 + ". " + oldHookName; // Extra space so second column lines up
                    // lol @ IE not supporting String#repeat
                    while(row.length < secondColumnStart)row += " ";
                    row += newHookName + "\n";
                    table += row;
                }
                error("React has detected a change in the order of Hooks called by %s. This will lead to bugs and errors if not fixed. For more information, read the Rules of Hooks: https://fb.me/rules-of-hooks\n\n   Previous render            Next render\n   ------------------------------------------------------\n%s   ^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^\n", componentName, table);
            }
        }
    }
    function throwInvalidHookError() {
        throw Error("Invalid hook call. Hooks can only be called inside of the body of a function component. This could happen for one of the following reasons:\n1. You might have mismatching versions of React and the renderer (such as React DOM)\n2. You might be breaking the Rules of Hooks\n3. You might have more than one copy of React in the same app\nSee https://fb.me/react-invalid-hook-call for tips about how to debug and fix this problem.");
    }
    function areHookInputsEqual(nextDeps, prevDeps) {
        if (ignorePreviousDependencies) // Only true when this component is being hot reloaded.
        return false;
        if (prevDeps === null) {
            error("%s received a final argument during this render, but not during the previous render. Even though the final argument is optional, its type cannot change between renders.", currentHookNameInDev);
            return false;
        }
        // Don't bother comparing lengths in prod because these arrays should be
        // passed inline.
        if (nextDeps.length !== prevDeps.length) error("The final argument passed to %s changed size between renders. The order and size of this array must remain constant.\n\nPrevious: %s\nIncoming: %s", currentHookNameInDev, "[" + prevDeps.join(", ") + "]", "[" + nextDeps.join(", ") + "]");
        for(var i = 0; i < prevDeps.length && i < nextDeps.length; i++){
            if (objectIs(nextDeps[i], prevDeps[i])) continue;
            return false;
        }
        return true;
    }
    function renderWithHooks(current, workInProgress, Component, props, secondArg, nextRenderExpirationTime) {
        renderExpirationTime = nextRenderExpirationTime;
        currentlyRenderingFiber$1 = workInProgress;
        hookTypesDev = current !== null ? current._debugHookTypes : null;
        hookTypesUpdateIndexDev = -1; // Used for hot reloading:
        ignorePreviousDependencies = current !== null && current.type !== workInProgress.type;
        workInProgress.memoizedState = null;
        workInProgress.updateQueue = null;
        workInProgress.expirationTime = NoWork; // The following should have already been reset
        if (current !== null && current.memoizedState !== null) ReactCurrentDispatcher.current = HooksDispatcherOnUpdateInDEV;
        else if (hookTypesDev !== null) // This dispatcher handles an edge case where a component is updating,
        // but no stateful hooks have been used.
        // We want to match the production code behavior (which will use HooksDispatcherOnMount),
        // but with the extra DEV validation to ensure hooks ordering hasn't changed.
        // This dispatcher does that.
        ReactCurrentDispatcher.current = HooksDispatcherOnMountWithHookTypesInDEV;
        else ReactCurrentDispatcher.current = HooksDispatcherOnMountInDEV;
        var children = Component(props, secondArg); // Check if there was a render phase update
        if (workInProgress.expirationTime === renderExpirationTime) {
            // Keep rendering in a loop for as long as render phase updates continue to
            // be scheduled. Use a counter to prevent infinite loops.
            var numberOfReRenders = 0;
            do {
                workInProgress.expirationTime = NoWork;
                if (!(numberOfReRenders < RE_RENDER_LIMIT)) throw Error("Too many re-renders. React limits the number of renders to prevent an infinite loop.");
                numberOfReRenders += 1;
                // Even when hot reloading, allow dependencies to stabilize
                // after first render to prevent infinite render phase updates.
                ignorePreviousDependencies = false;
                currentHook = null;
                workInProgressHook = null;
                workInProgress.updateQueue = null;
                // Also validate hook order for cascading updates.
                hookTypesUpdateIndexDev = -1;
                ReactCurrentDispatcher.current = HooksDispatcherOnRerenderInDEV;
                children = Component(props, secondArg);
            }while (workInProgress.expirationTime === renderExpirationTime);
        } // We can assume the previous dispatcher is always this one, since we set it
        // at the beginning of the render phase and there's no re-entrancy.
        ReactCurrentDispatcher.current = ContextOnlyDispatcher;
        workInProgress._debugHookTypes = hookTypesDev;
        // hookTypesDev could catch more cases (e.g. context) but only in DEV bundles.
        var didRenderTooFewHooks = currentHook !== null && currentHook.next !== null;
        renderExpirationTime = NoWork;
        currentlyRenderingFiber$1 = null;
        currentHook = null;
        workInProgressHook = null;
        currentHookNameInDev = null;
        hookTypesDev = null;
        hookTypesUpdateIndexDev = -1;
        didScheduleRenderPhaseUpdate = false;
        if (!!didRenderTooFewHooks) throw Error("Rendered fewer hooks than expected. This may be caused by an accidental early return statement.");
        return children;
    }
    function bailoutHooks(current, workInProgress, expirationTime) {
        workInProgress.updateQueue = current.updateQueue;
        workInProgress.effectTag &= ~(Passive | Update);
        if (current.expirationTime <= expirationTime) current.expirationTime = NoWork;
    }
    function resetHooksAfterThrow() {
        // We can assume the previous dispatcher is always this one, since we set it
        // at the beginning of the render phase and there's no re-entrancy.
        ReactCurrentDispatcher.current = ContextOnlyDispatcher;
        if (didScheduleRenderPhaseUpdate) {
            // There were render phase updates. These are only valid for this render
            // phase, which we are now aborting. Remove the updates from the queues so
            // they do not persist to the next render. Do not remove updates from hooks
            // that weren't processed.
            //
            // Only reset the updates from the queue if it has a clone. If it does
            // not have a clone, that means it wasn't processed, and the updates were
            // scheduled before we entered the render phase.
            var hook = currentlyRenderingFiber$1.memoizedState;
            while(hook !== null){
                var queue = hook.queue;
                if (queue !== null) queue.pending = null;
                hook = hook.next;
            }
        }
        renderExpirationTime = NoWork;
        currentlyRenderingFiber$1 = null;
        currentHook = null;
        workInProgressHook = null;
        hookTypesDev = null;
        hookTypesUpdateIndexDev = -1;
        currentHookNameInDev = null;
        didScheduleRenderPhaseUpdate = false;
    }
    function mountWorkInProgressHook() {
        var hook = {
            memoizedState: null,
            baseState: null,
            baseQueue: null,
            queue: null,
            next: null
        };
        if (workInProgressHook === null) // This is the first hook in the list
        currentlyRenderingFiber$1.memoizedState = workInProgressHook = hook;
        else // Append to the end of the list
        workInProgressHook = workInProgressHook.next = hook;
        return workInProgressHook;
    }
    function updateWorkInProgressHook() {
        // This function is used both for updates and for re-renders triggered by a
        // render phase update. It assumes there is either a current hook we can
        // clone, or a work-in-progress hook from a previous render pass that we can
        // use as a base. When we reach the end of the base list, we must switch to
        // the dispatcher used for mounts.
        var nextCurrentHook;
        if (currentHook === null) {
            var current = currentlyRenderingFiber$1.alternate;
            if (current !== null) nextCurrentHook = current.memoizedState;
            else nextCurrentHook = null;
        } else nextCurrentHook = currentHook.next;
        var nextWorkInProgressHook;
        if (workInProgressHook === null) nextWorkInProgressHook = currentlyRenderingFiber$1.memoizedState;
        else nextWorkInProgressHook = workInProgressHook.next;
        if (nextWorkInProgressHook !== null) {
            // There's already a work-in-progress. Reuse it.
            workInProgressHook = nextWorkInProgressHook;
            nextWorkInProgressHook = workInProgressHook.next;
            currentHook = nextCurrentHook;
        } else {
            // Clone from the current hook.
            if (!(nextCurrentHook !== null)) throw Error("Rendered more hooks than during the previous render.");
            currentHook = nextCurrentHook;
            var newHook = {
                memoizedState: currentHook.memoizedState,
                baseState: currentHook.baseState,
                baseQueue: currentHook.baseQueue,
                queue: currentHook.queue,
                next: null
            };
            if (workInProgressHook === null) // This is the first hook in the list.
            currentlyRenderingFiber$1.memoizedState = workInProgressHook = newHook;
            else // Append to the end of the list.
            workInProgressHook = workInProgressHook.next = newHook;
        }
        return workInProgressHook;
    }
    function createFunctionComponentUpdateQueue() {
        return {
            lastEffect: null
        };
    }
    function basicStateReducer(state, action) {
        // $FlowFixMe: Flow doesn't like mixed types
        return typeof action === "function" ? action(state) : action;
    }
    function mountReducer(reducer, initialArg, init) {
        var hook = mountWorkInProgressHook();
        var initialState;
        if (init !== undefined) initialState = init(initialArg);
        else initialState = initialArg;
        hook.memoizedState = hook.baseState = initialState;
        var queue = hook.queue = {
            pending: null,
            dispatch: null,
            lastRenderedReducer: reducer,
            lastRenderedState: initialState
        };
        var dispatch = queue.dispatch = dispatchAction.bind(null, currentlyRenderingFiber$1, queue);
        return [
            hook.memoizedState,
            dispatch
        ];
    }
    function updateReducer(reducer, initialArg, init) {
        var hook = updateWorkInProgressHook();
        var queue = hook.queue;
        if (!(queue !== null)) throw Error("Should have a queue. This is likely a bug in React. Please file an issue.");
        queue.lastRenderedReducer = reducer;
        var current = currentHook; // The last rebase update that is NOT part of the base state.
        var baseQueue = current.baseQueue; // The last pending update that hasn't been processed yet.
        var pendingQueue = queue.pending;
        if (pendingQueue !== null) {
            // We have new updates that haven't been processed yet.
            // We'll add them to the base queue.
            if (baseQueue !== null) {
                // Merge the pending queue and the base queue.
                var baseFirst = baseQueue.next;
                var pendingFirst = pendingQueue.next;
                baseQueue.next = pendingFirst;
                pendingQueue.next = baseFirst;
            }
            current.baseQueue = baseQueue = pendingQueue;
            queue.pending = null;
        }
        if (baseQueue !== null) {
            // We have a queue to process.
            var first = baseQueue.next;
            var newState = current.baseState;
            var newBaseState = null;
            var newBaseQueueFirst = null;
            var newBaseQueueLast = null;
            var update = first;
            do {
                var updateExpirationTime = update.expirationTime;
                if (updateExpirationTime < renderExpirationTime) {
                    // Priority is insufficient. Skip this update. If this is the first
                    // skipped update, the previous update/state is the new base
                    // update/state.
                    var clone = {
                        expirationTime: update.expirationTime,
                        suspenseConfig: update.suspenseConfig,
                        action: update.action,
                        eagerReducer: update.eagerReducer,
                        eagerState: update.eagerState,
                        next: null
                    };
                    if (newBaseQueueLast === null) {
                        newBaseQueueFirst = newBaseQueueLast = clone;
                        newBaseState = newState;
                    } else newBaseQueueLast = newBaseQueueLast.next = clone;
                     // Update the remaining priority in the queue.
                    if (updateExpirationTime > currentlyRenderingFiber$1.expirationTime) {
                        currentlyRenderingFiber$1.expirationTime = updateExpirationTime;
                        markUnprocessedUpdateTime(updateExpirationTime);
                    }
                } else {
                    // This update does have sufficient priority.
                    if (newBaseQueueLast !== null) {
                        var _clone = {
                            expirationTime: Sync,
                            // This update is going to be committed so we never want uncommit it.
                            suspenseConfig: update.suspenseConfig,
                            action: update.action,
                            eagerReducer: update.eagerReducer,
                            eagerState: update.eagerState,
                            next: null
                        };
                        newBaseQueueLast = newBaseQueueLast.next = _clone;
                    } // Mark the event time of this update as relevant to this render pass.
                    // TODO: This should ideally use the true event time of this update rather than
                    // its priority which is a derived and not reverseable value.
                    // TODO: We should skip this update if it was already committed but currently
                    // we have no way of detecting the difference between a committed and suspended
                    // update here.
                    markRenderEventTimeAndConfig(updateExpirationTime, update.suspenseConfig); // Process this update.
                    if (update.eagerReducer === reducer) // If this update was processed eagerly, and its reducer matches the
                    // current reducer, we can use the eagerly computed state.
                    newState = update.eagerState;
                    else {
                        var action = update.action;
                        newState = reducer(newState, action);
                    }
                }
                update = update.next;
            }while (update !== null && update !== first);
            if (newBaseQueueLast === null) newBaseState = newState;
            else newBaseQueueLast.next = newBaseQueueFirst;
             // Mark that the fiber performed work, but only if the new state is
            // different from the current state.
            if (!objectIs(newState, hook.memoizedState)) markWorkInProgressReceivedUpdate();
            hook.memoizedState = newState;
            hook.baseState = newBaseState;
            hook.baseQueue = newBaseQueueLast;
            queue.lastRenderedState = newState;
        }
        var dispatch = queue.dispatch;
        return [
            hook.memoizedState,
            dispatch
        ];
    }
    function rerenderReducer(reducer, initialArg, init) {
        var hook = updateWorkInProgressHook();
        var queue = hook.queue;
        if (!(queue !== null)) throw Error("Should have a queue. This is likely a bug in React. Please file an issue.");
        queue.lastRenderedReducer = reducer; // This is a re-render. Apply the new render phase updates to the previous
        // work-in-progress hook.
        var dispatch = queue.dispatch;
        var lastRenderPhaseUpdate = queue.pending;
        var newState = hook.memoizedState;
        if (lastRenderPhaseUpdate !== null) {
            // The queue doesn't persist past this render pass.
            queue.pending = null;
            var firstRenderPhaseUpdate = lastRenderPhaseUpdate.next;
            var update = firstRenderPhaseUpdate;
            do {
                // Process this render phase update. We don't have to check the
                // priority because it will always be the same as the current
                // render's.
                var action = update.action;
                newState = reducer(newState, action);
                update = update.next;
            }while (update !== firstRenderPhaseUpdate); // Mark that the fiber performed work, but only if the new state is
            // different from the current state.
            if (!objectIs(newState, hook.memoizedState)) markWorkInProgressReceivedUpdate();
            hook.memoizedState = newState; // Don't persist the state accumulated from the render phase updates to
            // the base state unless the queue is empty.
            // TODO: Not sure if this is the desired semantics, but it's what we
            // do for gDSFP. I can't remember why.
            if (hook.baseQueue === null) hook.baseState = newState;
            queue.lastRenderedState = newState;
        }
        return [
            newState,
            dispatch
        ];
    }
    function mountState(initialState) {
        var hook = mountWorkInProgressHook();
        if (typeof initialState === "function") // $FlowFixMe: Flow doesn't like mixed types
        initialState = initialState();
        hook.memoizedState = hook.baseState = initialState;
        var queue = hook.queue = {
            pending: null,
            dispatch: null,
            lastRenderedReducer: basicStateReducer,
            lastRenderedState: initialState
        };
        var dispatch = queue.dispatch = dispatchAction.bind(null, currentlyRenderingFiber$1, queue);
        return [
            hook.memoizedState,
            dispatch
        ];
    }
    function updateState(initialState) {
        return updateReducer(basicStateReducer);
    }
    function rerenderState(initialState) {
        return rerenderReducer(basicStateReducer);
    }
    function pushEffect(tag, create, destroy, deps) {
        var effect = {
            tag: tag,
            create: create,
            destroy: destroy,
            deps: deps,
            // Circular
            next: null
        };
        var componentUpdateQueue = currentlyRenderingFiber$1.updateQueue;
        if (componentUpdateQueue === null) {
            componentUpdateQueue = createFunctionComponentUpdateQueue();
            currentlyRenderingFiber$1.updateQueue = componentUpdateQueue;
            componentUpdateQueue.lastEffect = effect.next = effect;
        } else {
            var lastEffect = componentUpdateQueue.lastEffect;
            if (lastEffect === null) componentUpdateQueue.lastEffect = effect.next = effect;
            else {
                var firstEffect = lastEffect.next;
                lastEffect.next = effect;
                effect.next = firstEffect;
                componentUpdateQueue.lastEffect = effect;
            }
        }
        return effect;
    }
    function mountRef(initialValue) {
        var hook = mountWorkInProgressHook();
        var ref = {
            current: initialValue
        };
        Object.seal(ref);
        hook.memoizedState = ref;
        return ref;
    }
    function updateRef(initialValue) {
        var hook = updateWorkInProgressHook();
        return hook.memoizedState;
    }
    function mountEffectImpl(fiberEffectTag, hookEffectTag, create, deps) {
        var hook = mountWorkInProgressHook();
        var nextDeps = deps === undefined ? null : deps;
        currentlyRenderingFiber$1.effectTag |= fiberEffectTag;
        hook.memoizedState = pushEffect(HasEffect | hookEffectTag, create, undefined, nextDeps);
    }
    function updateEffectImpl(fiberEffectTag, hookEffectTag, create, deps) {
        var hook = updateWorkInProgressHook();
        var nextDeps = deps === undefined ? null : deps;
        var destroy = undefined;
        if (currentHook !== null) {
            var prevEffect = currentHook.memoizedState;
            destroy = prevEffect.destroy;
            if (nextDeps !== null) {
                var prevDeps = prevEffect.deps;
                if (areHookInputsEqual(nextDeps, prevDeps)) {
                    pushEffect(hookEffectTag, create, destroy, nextDeps);
                    return;
                }
            }
        }
        currentlyRenderingFiber$1.effectTag |= fiberEffectTag;
        hook.memoizedState = pushEffect(HasEffect | hookEffectTag, create, destroy, nextDeps);
    }
    function mountEffect(create, deps) {
        // $FlowExpectedError - jest isn't a global, and isn't recognized outside of tests
        if ("undefined" !== typeof jest) warnIfNotCurrentlyActingEffectsInDEV(currentlyRenderingFiber$1);
        return mountEffectImpl(Update | Passive, Passive$1, create, deps);
    }
    function updateEffect(create, deps) {
        // $FlowExpectedError - jest isn't a global, and isn't recognized outside of tests
        if ("undefined" !== typeof jest) warnIfNotCurrentlyActingEffectsInDEV(currentlyRenderingFiber$1);
        return updateEffectImpl(Update | Passive, Passive$1, create, deps);
    }
    function mountLayoutEffect(create, deps) {
        return mountEffectImpl(Update, Layout, create, deps);
    }
    function updateLayoutEffect(create, deps) {
        return updateEffectImpl(Update, Layout, create, deps);
    }
    function imperativeHandleEffect(create, ref) {
        if (typeof ref === "function") {
            var refCallback = ref;
            var _inst = create();
            refCallback(_inst);
            return function() {
                refCallback(null);
            };
        } else if (ref !== null && ref !== undefined) {
            var refObject = ref;
            if (!refObject.hasOwnProperty("current")) error("Expected useImperativeHandle() first argument to either be a ref callback or React.createRef() object. Instead received: %s.", "an object with keys {" + Object.keys(refObject).join(", ") + "}");
            var _inst2 = create();
            refObject.current = _inst2;
            return function() {
                refObject.current = null;
            };
        }
    }
    function mountImperativeHandle(ref, create, deps) {
        if (typeof create !== "function") error("Expected useImperativeHandle() second argument to be a function that creates a handle. Instead received: %s.", create !== null ? typeof create : "null");
        var effectDeps = deps !== null && deps !== undefined ? deps.concat([
            ref
        ]) : null;
        return mountEffectImpl(Update, Layout, imperativeHandleEffect.bind(null, create, ref), effectDeps);
    }
    function updateImperativeHandle(ref, create, deps) {
        if (typeof create !== "function") error("Expected useImperativeHandle() second argument to be a function that creates a handle. Instead received: %s.", create !== null ? typeof create : "null");
        var effectDeps = deps !== null && deps !== undefined ? deps.concat([
            ref
        ]) : null;
        return updateEffectImpl(Update, Layout, imperativeHandleEffect.bind(null, create, ref), effectDeps);
    }
    function mountDebugValue(value, formatterFn) {
    // The react-debug-hooks package injects its own implementation
    // so that e.g. DevTools can display custom hook values.
    }
    var updateDebugValue = mountDebugValue;
    function mountCallback(callback, deps) {
        var hook = mountWorkInProgressHook();
        var nextDeps = deps === undefined ? null : deps;
        hook.memoizedState = [
            callback,
            nextDeps
        ];
        return callback;
    }
    function updateCallback(callback, deps) {
        var hook = updateWorkInProgressHook();
        var nextDeps = deps === undefined ? null : deps;
        var prevState = hook.memoizedState;
        if (prevState !== null) {
            if (nextDeps !== null) {
                var prevDeps = prevState[1];
                if (areHookInputsEqual(nextDeps, prevDeps)) return prevState[0];
            }
        }
        hook.memoizedState = [
            callback,
            nextDeps
        ];
        return callback;
    }
    function mountMemo(nextCreate, deps) {
        var hook = mountWorkInProgressHook();
        var nextDeps = deps === undefined ? null : deps;
        var nextValue = nextCreate();
        hook.memoizedState = [
            nextValue,
            nextDeps
        ];
        return nextValue;
    }
    function updateMemo(nextCreate, deps) {
        var hook = updateWorkInProgressHook();
        var nextDeps = deps === undefined ? null : deps;
        var prevState = hook.memoizedState;
        if (prevState !== null) // Assume these are defined. If they're not, areHookInputsEqual will warn.
        {
            if (nextDeps !== null) {
                var prevDeps = prevState[1];
                if (areHookInputsEqual(nextDeps, prevDeps)) return prevState[0];
            }
        }
        var nextValue = nextCreate();
        hook.memoizedState = [
            nextValue,
            nextDeps
        ];
        return nextValue;
    }
    function mountDeferredValue(value, config) {
        var _mountState = mountState(value), prevValue = _mountState[0], setValue = _mountState[1];
        mountEffect(function() {
            var previousConfig = ReactCurrentBatchConfig$1.suspense;
            ReactCurrentBatchConfig$1.suspense = config === undefined ? null : config;
            try {
                setValue(value);
            } finally{
                ReactCurrentBatchConfig$1.suspense = previousConfig;
            }
        }, [
            value,
            config
        ]);
        return prevValue;
    }
    function updateDeferredValue(value, config) {
        var _updateState = updateState(), prevValue = _updateState[0], setValue = _updateState[1];
        updateEffect(function() {
            var previousConfig = ReactCurrentBatchConfig$1.suspense;
            ReactCurrentBatchConfig$1.suspense = config === undefined ? null : config;
            try {
                setValue(value);
            } finally{
                ReactCurrentBatchConfig$1.suspense = previousConfig;
            }
        }, [
            value,
            config
        ]);
        return prevValue;
    }
    function rerenderDeferredValue(value, config) {
        var _rerenderState = rerenderState(), prevValue = _rerenderState[0], setValue = _rerenderState[1];
        updateEffect(function() {
            var previousConfig = ReactCurrentBatchConfig$1.suspense;
            ReactCurrentBatchConfig$1.suspense = config === undefined ? null : config;
            try {
                setValue(value);
            } finally{
                ReactCurrentBatchConfig$1.suspense = previousConfig;
            }
        }, [
            value,
            config
        ]);
        return prevValue;
    }
    function startTransition(setPending, config, callback) {
        var priorityLevel = getCurrentPriorityLevel();
        runWithPriority$1(priorityLevel < UserBlockingPriority$1 ? UserBlockingPriority$1 : priorityLevel, function() {
            setPending(true);
        });
        runWithPriority$1(priorityLevel > NormalPriority ? NormalPriority : priorityLevel, function() {
            var previousConfig = ReactCurrentBatchConfig$1.suspense;
            ReactCurrentBatchConfig$1.suspense = config === undefined ? null : config;
            try {
                setPending(false);
                callback();
            } finally{
                ReactCurrentBatchConfig$1.suspense = previousConfig;
            }
        });
    }
    function mountTransition(config) {
        var _mountState2 = mountState(false), isPending = _mountState2[0], setPending = _mountState2[1];
        var start = mountCallback(startTransition.bind(null, setPending, config), [
            setPending,
            config
        ]);
        return [
            start,
            isPending
        ];
    }
    function updateTransition(config) {
        var _updateState2 = updateState(), isPending = _updateState2[0], setPending = _updateState2[1];
        var start = updateCallback(startTransition.bind(null, setPending, config), [
            setPending,
            config
        ]);
        return [
            start,
            isPending
        ];
    }
    function rerenderTransition(config) {
        var _rerenderState2 = rerenderState(), isPending = _rerenderState2[0], setPending = _rerenderState2[1];
        var start = updateCallback(startTransition.bind(null, setPending, config), [
            setPending,
            config
        ]);
        return [
            start,
            isPending
        ];
    }
    function dispatchAction(fiber, queue, action) {
        if (typeof arguments[3] === "function") error("State updates from the useState() and useReducer() Hooks don't support the second callback argument. To execute a side effect after rendering, declare it in the component body with useEffect().");
        var currentTime = requestCurrentTimeForUpdate();
        var suspenseConfig = requestCurrentSuspenseConfig();
        var expirationTime = computeExpirationForFiber(currentTime, fiber, suspenseConfig);
        var update = {
            expirationTime: expirationTime,
            suspenseConfig: suspenseConfig,
            action: action,
            eagerReducer: null,
            eagerState: null,
            next: null
        };
        update.priority = getCurrentPriorityLevel();
        var pending = queue.pending;
        if (pending === null) // This is the first update. Create a circular list.
        update.next = update;
        else {
            update.next = pending.next;
            pending.next = update;
        }
        queue.pending = update;
        var alternate = fiber.alternate;
        if (fiber === currentlyRenderingFiber$1 || alternate !== null && alternate === currentlyRenderingFiber$1) {
            // This is a render phase update. Stash it in a lazily-created map of
            // queue -> linked list of updates. After this render pass, we'll restart
            // and apply the stashed updates on top of the work-in-progress hook.
            didScheduleRenderPhaseUpdate = true;
            update.expirationTime = renderExpirationTime;
            currentlyRenderingFiber$1.expirationTime = renderExpirationTime;
        } else {
            if (fiber.expirationTime === NoWork && (alternate === null || alternate.expirationTime === NoWork)) {
                // The queue is currently empty, which means we can eagerly compute the
                // next state before entering the render phase. If the new state is the
                // same as the current state, we may be able to bail out entirely.
                var lastRenderedReducer = queue.lastRenderedReducer;
                if (lastRenderedReducer !== null) {
                    var prevDispatcher;
                    prevDispatcher = ReactCurrentDispatcher.current;
                    ReactCurrentDispatcher.current = InvalidNestedHooksDispatcherOnUpdateInDEV;
                    try {
                        var currentState = queue.lastRenderedState;
                        var eagerState = lastRenderedReducer(currentState, action); // Stash the eagerly computed state, and the reducer used to compute
                        // it, on the update object. If the reducer hasn't changed by the
                        // time we enter the render phase, then the eager state can be used
                        // without calling the reducer again.
                        update.eagerReducer = lastRenderedReducer;
                        update.eagerState = eagerState;
                        if (objectIs(eagerState, currentState)) // Fast path. We can bail out without scheduling React to re-render.
                        // It's still possible that we'll need to rebase this update later,
                        // if the component re-renders for a different reason and by that
                        // time the reducer has changed.
                        return;
                    } catch (error) {} finally{
                        ReactCurrentDispatcher.current = prevDispatcher;
                    }
                }
            }
            // $FlowExpectedError - jest isn't a global, and isn't recognized outside of tests
            if ("undefined" !== typeof jest) {
                warnIfNotScopedWithMatchingAct(fiber);
                warnIfNotCurrentlyActingUpdatesInDev(fiber);
            }
            scheduleWork(fiber, expirationTime);
        }
    }
    var ContextOnlyDispatcher = {
        readContext: readContext,
        useCallback: throwInvalidHookError,
        useContext: throwInvalidHookError,
        useEffect: throwInvalidHookError,
        useImperativeHandle: throwInvalidHookError,
        useLayoutEffect: throwInvalidHookError,
        useMemo: throwInvalidHookError,
        useReducer: throwInvalidHookError,
        useRef: throwInvalidHookError,
        useState: throwInvalidHookError,
        useDebugValue: throwInvalidHookError,
        useResponder: throwInvalidHookError,
        useDeferredValue: throwInvalidHookError,
        useTransition: throwInvalidHookError
    };
    var HooksDispatcherOnMountInDEV = null;
    var HooksDispatcherOnMountWithHookTypesInDEV = null;
    var HooksDispatcherOnUpdateInDEV = null;
    var HooksDispatcherOnRerenderInDEV = null;
    var InvalidNestedHooksDispatcherOnMountInDEV = null;
    var InvalidNestedHooksDispatcherOnUpdateInDEV = null;
    var InvalidNestedHooksDispatcherOnRerenderInDEV = null;
    var warnInvalidContextAccess = function() {
        error("Context can only be read while React is rendering. In classes, you can read it in the render method or getDerivedStateFromProps. In function components, you can read it directly in the function body, but not inside Hooks like useReducer() or useMemo().");
    };
    var warnInvalidHookAccess = function() {
        error("Do not call Hooks inside useEffect(...), useMemo(...), or other built-in Hooks. You can only call Hooks at the top level of your React function. For more information, see https://fb.me/rules-of-hooks");
    };
    HooksDispatcherOnMountInDEV = {
        readContext: function(context, observedBits) {
            return readContext(context, observedBits);
        },
        useCallback: function(callback, deps) {
            currentHookNameInDev = "useCallback";
            mountHookTypesDev();
            checkDepsAreArrayDev(deps);
            return mountCallback(callback, deps);
        },
        useContext: function(context, observedBits) {
            currentHookNameInDev = "useContext";
            mountHookTypesDev();
            return readContext(context, observedBits);
        },
        useEffect: function(create, deps) {
            currentHookNameInDev = "useEffect";
            mountHookTypesDev();
            checkDepsAreArrayDev(deps);
            return mountEffect(create, deps);
        },
        useImperativeHandle: function(ref, create, deps) {
            currentHookNameInDev = "useImperativeHandle";
            mountHookTypesDev();
            checkDepsAreArrayDev(deps);
            return mountImperativeHandle(ref, create, deps);
        },
        useLayoutEffect: function(create, deps) {
            currentHookNameInDev = "useLayoutEffect";
            mountHookTypesDev();
            checkDepsAreArrayDev(deps);
            return mountLayoutEffect(create, deps);
        },
        useMemo: function(create, deps) {
            currentHookNameInDev = "useMemo";
            mountHookTypesDev();
            checkDepsAreArrayDev(deps);
            var prevDispatcher = ReactCurrentDispatcher.current;
            ReactCurrentDispatcher.current = InvalidNestedHooksDispatcherOnMountInDEV;
            try {
                return mountMemo(create, deps);
            } finally{
                ReactCurrentDispatcher.current = prevDispatcher;
            }
        },
        useReducer: function(reducer, initialArg, init) {
            currentHookNameInDev = "useReducer";
            mountHookTypesDev();
            var prevDispatcher = ReactCurrentDispatcher.current;
            ReactCurrentDispatcher.current = InvalidNestedHooksDispatcherOnMountInDEV;
            try {
                return mountReducer(reducer, initialArg, init);
            } finally{
                ReactCurrentDispatcher.current = prevDispatcher;
            }
        },
        useRef: function(initialValue) {
            currentHookNameInDev = "useRef";
            mountHookTypesDev();
            return mountRef(initialValue);
        },
        useState: function(initialState) {
            currentHookNameInDev = "useState";
            mountHookTypesDev();
            var prevDispatcher = ReactCurrentDispatcher.current;
            ReactCurrentDispatcher.current = InvalidNestedHooksDispatcherOnMountInDEV;
            try {
                return mountState(initialState);
            } finally{
                ReactCurrentDispatcher.current = prevDispatcher;
            }
        },
        useDebugValue: function(value, formatterFn) {
            currentHookNameInDev = "useDebugValue";
            mountHookTypesDev();
            return mountDebugValue();
        },
        useResponder: function(responder, props) {
            currentHookNameInDev = "useResponder";
            mountHookTypesDev();
            return createDeprecatedResponderListener(responder, props);
        },
        useDeferredValue: function(value, config) {
            currentHookNameInDev = "useDeferredValue";
            mountHookTypesDev();
            return mountDeferredValue(value, config);
        },
        useTransition: function(config) {
            currentHookNameInDev = "useTransition";
            mountHookTypesDev();
            return mountTransition(config);
        }
    };
    HooksDispatcherOnMountWithHookTypesInDEV = {
        readContext: function(context, observedBits) {
            return readContext(context, observedBits);
        },
        useCallback: function(callback, deps) {
            currentHookNameInDev = "useCallback";
            updateHookTypesDev();
            return mountCallback(callback, deps);
        },
        useContext: function(context, observedBits) {
            currentHookNameInDev = "useContext";
            updateHookTypesDev();
            return readContext(context, observedBits);
        },
        useEffect: function(create, deps) {
            currentHookNameInDev = "useEffect";
            updateHookTypesDev();
            return mountEffect(create, deps);
        },
        useImperativeHandle: function(ref, create, deps) {
            currentHookNameInDev = "useImperativeHandle";
            updateHookTypesDev();
            return mountImperativeHandle(ref, create, deps);
        },
        useLayoutEffect: function(create, deps) {
            currentHookNameInDev = "useLayoutEffect";
            updateHookTypesDev();
            return mountLayoutEffect(create, deps);
        },
        useMemo: function(create, deps) {
            currentHookNameInDev = "useMemo";
            updateHookTypesDev();
            var prevDispatcher = ReactCurrentDispatcher.current;
            ReactCurrentDispatcher.current = InvalidNestedHooksDispatcherOnMountInDEV;
            try {
                return mountMemo(create, deps);
            } finally{
                ReactCurrentDispatcher.current = prevDispatcher;
            }
        },
        useReducer: function(reducer, initialArg, init) {
            currentHookNameInDev = "useReducer";
            updateHookTypesDev();
            var prevDispatcher = ReactCurrentDispatcher.current;
            ReactCurrentDispatcher.current = InvalidNestedHooksDispatcherOnMountInDEV;
            try {
                return mountReducer(reducer, initialArg, init);
            } finally{
                ReactCurrentDispatcher.current = prevDispatcher;
            }
        },
        useRef: function(initialValue) {
            currentHookNameInDev = "useRef";
            updateHookTypesDev();
            return mountRef(initialValue);
        },
        useState: function(initialState) {
            currentHookNameInDev = "useState";
            updateHookTypesDev();
            var prevDispatcher = ReactCurrentDispatcher.current;
            ReactCurrentDispatcher.current = InvalidNestedHooksDispatcherOnMountInDEV;
            try {
                return mountState(initialState);
            } finally{
                ReactCurrentDispatcher.current = prevDispatcher;
            }
        },
        useDebugValue: function(value, formatterFn) {
            currentHookNameInDev = "useDebugValue";
            updateHookTypesDev();
            return mountDebugValue();
        },
        useResponder: function(responder, props) {
            currentHookNameInDev = "useResponder";
            updateHookTypesDev();
            return createDeprecatedResponderListener(responder, props);
        },
        useDeferredValue: function(value, config) {
            currentHookNameInDev = "useDeferredValue";
            updateHookTypesDev();
            return mountDeferredValue(value, config);
        },
        useTransition: function(config) {
            currentHookNameInDev = "useTransition";
            updateHookTypesDev();
            return mountTransition(config);
        }
    };
    HooksDispatcherOnUpdateInDEV = {
        readContext: function(context, observedBits) {
            return readContext(context, observedBits);
        },
        useCallback: function(callback, deps) {
            currentHookNameInDev = "useCallback";
            updateHookTypesDev();
            return updateCallback(callback, deps);
        },
        useContext: function(context, observedBits) {
            currentHookNameInDev = "useContext";
            updateHookTypesDev();
            return readContext(context, observedBits);
        },
        useEffect: function(create, deps) {
            currentHookNameInDev = "useEffect";
            updateHookTypesDev();
            return updateEffect(create, deps);
        },
        useImperativeHandle: function(ref, create, deps) {
            currentHookNameInDev = "useImperativeHandle";
            updateHookTypesDev();
            return updateImperativeHandle(ref, create, deps);
        },
        useLayoutEffect: function(create, deps) {
            currentHookNameInDev = "useLayoutEffect";
            updateHookTypesDev();
            return updateLayoutEffect(create, deps);
        },
        useMemo: function(create, deps) {
            currentHookNameInDev = "useMemo";
            updateHookTypesDev();
            var prevDispatcher = ReactCurrentDispatcher.current;
            ReactCurrentDispatcher.current = InvalidNestedHooksDispatcherOnUpdateInDEV;
            try {
                return updateMemo(create, deps);
            } finally{
                ReactCurrentDispatcher.current = prevDispatcher;
            }
        },
        useReducer: function(reducer, initialArg, init) {
            currentHookNameInDev = "useReducer";
            updateHookTypesDev();
            var prevDispatcher = ReactCurrentDispatcher.current;
            ReactCurrentDispatcher.current = InvalidNestedHooksDispatcherOnUpdateInDEV;
            try {
                return updateReducer(reducer, initialArg, init);
            } finally{
                ReactCurrentDispatcher.current = prevDispatcher;
            }
        },
        useRef: function(initialValue) {
            currentHookNameInDev = "useRef";
            updateHookTypesDev();
            return updateRef();
        },
        useState: function(initialState) {
            currentHookNameInDev = "useState";
            updateHookTypesDev();
            var prevDispatcher = ReactCurrentDispatcher.current;
            ReactCurrentDispatcher.current = InvalidNestedHooksDispatcherOnUpdateInDEV;
            try {
                return updateState(initialState);
            } finally{
                ReactCurrentDispatcher.current = prevDispatcher;
            }
        },
        useDebugValue: function(value, formatterFn) {
            currentHookNameInDev = "useDebugValue";
            updateHookTypesDev();
            return updateDebugValue();
        },
        useResponder: function(responder, props) {
            currentHookNameInDev = "useResponder";
            updateHookTypesDev();
            return createDeprecatedResponderListener(responder, props);
        },
        useDeferredValue: function(value, config) {
            currentHookNameInDev = "useDeferredValue";
            updateHookTypesDev();
            return updateDeferredValue(value, config);
        },
        useTransition: function(config) {
            currentHookNameInDev = "useTransition";
            updateHookTypesDev();
            return updateTransition(config);
        }
    };
    HooksDispatcherOnRerenderInDEV = {
        readContext: function(context, observedBits) {
            return readContext(context, observedBits);
        },
        useCallback: function(callback, deps) {
            currentHookNameInDev = "useCallback";
            updateHookTypesDev();
            return updateCallback(callback, deps);
        },
        useContext: function(context, observedBits) {
            currentHookNameInDev = "useContext";
            updateHookTypesDev();
            return readContext(context, observedBits);
        },
        useEffect: function(create, deps) {
            currentHookNameInDev = "useEffect";
            updateHookTypesDev();
            return updateEffect(create, deps);
        },
        useImperativeHandle: function(ref, create, deps) {
            currentHookNameInDev = "useImperativeHandle";
            updateHookTypesDev();
            return updateImperativeHandle(ref, create, deps);
        },
        useLayoutEffect: function(create, deps) {
            currentHookNameInDev = "useLayoutEffect";
            updateHookTypesDev();
            return updateLayoutEffect(create, deps);
        },
        useMemo: function(create, deps) {
            currentHookNameInDev = "useMemo";
            updateHookTypesDev();
            var prevDispatcher = ReactCurrentDispatcher.current;
            ReactCurrentDispatcher.current = InvalidNestedHooksDispatcherOnRerenderInDEV;
            try {
                return updateMemo(create, deps);
            } finally{
                ReactCurrentDispatcher.current = prevDispatcher;
            }
        },
        useReducer: function(reducer, initialArg, init) {
            currentHookNameInDev = "useReducer";
            updateHookTypesDev();
            var prevDispatcher = ReactCurrentDispatcher.current;
            ReactCurrentDispatcher.current = InvalidNestedHooksDispatcherOnRerenderInDEV;
            try {
                return rerenderReducer(reducer, initialArg, init);
            } finally{
                ReactCurrentDispatcher.current = prevDispatcher;
            }
        },
        useRef: function(initialValue) {
            currentHookNameInDev = "useRef";
            updateHookTypesDev();
            return updateRef();
        },
        useState: function(initialState) {
            currentHookNameInDev = "useState";
            updateHookTypesDev();
            var prevDispatcher = ReactCurrentDispatcher.current;
            ReactCurrentDispatcher.current = InvalidNestedHooksDispatcherOnRerenderInDEV;
            try {
                return rerenderState(initialState);
            } finally{
                ReactCurrentDispatcher.current = prevDispatcher;
            }
        },
        useDebugValue: function(value, formatterFn) {
            currentHookNameInDev = "useDebugValue";
            updateHookTypesDev();
            return updateDebugValue();
        },
        useResponder: function(responder, props) {
            currentHookNameInDev = "useResponder";
            updateHookTypesDev();
            return createDeprecatedResponderListener(responder, props);
        },
        useDeferredValue: function(value, config) {
            currentHookNameInDev = "useDeferredValue";
            updateHookTypesDev();
            return rerenderDeferredValue(value, config);
        },
        useTransition: function(config) {
            currentHookNameInDev = "useTransition";
            updateHookTypesDev();
            return rerenderTransition(config);
        }
    };
    InvalidNestedHooksDispatcherOnMountInDEV = {
        readContext: function(context, observedBits) {
            warnInvalidContextAccess();
            return readContext(context, observedBits);
        },
        useCallback: function(callback, deps) {
            currentHookNameInDev = "useCallback";
            warnInvalidHookAccess();
            mountHookTypesDev();
            return mountCallback(callback, deps);
        },
        useContext: function(context, observedBits) {
            currentHookNameInDev = "useContext";
            warnInvalidHookAccess();
            mountHookTypesDev();
            return readContext(context, observedBits);
        },
        useEffect: function(create, deps) {
            currentHookNameInDev = "useEffect";
            warnInvalidHookAccess();
            mountHookTypesDev();
            return mountEffect(create, deps);
        },
        useImperativeHandle: function(ref, create, deps) {
            currentHookNameInDev = "useImperativeHandle";
            warnInvalidHookAccess();
            mountHookTypesDev();
            return mountImperativeHandle(ref, create, deps);
        },
        useLayoutEffect: function(create, deps) {
            currentHookNameInDev = "useLayoutEffect";
            warnInvalidHookAccess();
            mountHookTypesDev();
            return mountLayoutEffect(create, deps);
        },
        useMemo: function(create, deps) {
            currentHookNameInDev = "useMemo";
            warnInvalidHookAccess();
            mountHookTypesDev();
            var prevDispatcher = ReactCurrentDispatcher.current;
            ReactCurrentDispatcher.current = InvalidNestedHooksDispatcherOnMountInDEV;
            try {
                return mountMemo(create, deps);
            } finally{
                ReactCurrentDispatcher.current = prevDispatcher;
            }
        },
        useReducer: function(reducer, initialArg, init) {
            currentHookNameInDev = "useReducer";
            warnInvalidHookAccess();
            mountHookTypesDev();
            var prevDispatcher = ReactCurrentDispatcher.current;
            ReactCurrentDispatcher.current = InvalidNestedHooksDispatcherOnMountInDEV;
            try {
                return mountReducer(reducer, initialArg, init);
            } finally{
                ReactCurrentDispatcher.current = prevDispatcher;
            }
        },
        useRef: function(initialValue) {
            currentHookNameInDev = "useRef";
            warnInvalidHookAccess();
            mountHookTypesDev();
            return mountRef(initialValue);
        },
        useState: function(initialState) {
            currentHookNameInDev = "useState";
            warnInvalidHookAccess();
            mountHookTypesDev();
            var prevDispatcher = ReactCurrentDispatcher.current;
            ReactCurrentDispatcher.current = InvalidNestedHooksDispatcherOnMountInDEV;
            try {
                return mountState(initialState);
            } finally{
                ReactCurrentDispatcher.current = prevDispatcher;
            }
        },
        useDebugValue: function(value, formatterFn) {
            currentHookNameInDev = "useDebugValue";
            warnInvalidHookAccess();
            mountHookTypesDev();
            return mountDebugValue();
        },
        useResponder: function(responder, props) {
            currentHookNameInDev = "useResponder";
            warnInvalidHookAccess();
            mountHookTypesDev();
            return createDeprecatedResponderListener(responder, props);
        },
        useDeferredValue: function(value, config) {
            currentHookNameInDev = "useDeferredValue";
            warnInvalidHookAccess();
            mountHookTypesDev();
            return mountDeferredValue(value, config);
        },
        useTransition: function(config) {
            currentHookNameInDev = "useTransition";
            warnInvalidHookAccess();
            mountHookTypesDev();
            return mountTransition(config);
        }
    };
    InvalidNestedHooksDispatcherOnUpdateInDEV = {
        readContext: function(context, observedBits) {
            warnInvalidContextAccess();
            return readContext(context, observedBits);
        },
        useCallback: function(callback, deps) {
            currentHookNameInDev = "useCallback";
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateCallback(callback, deps);
        },
        useContext: function(context, observedBits) {
            currentHookNameInDev = "useContext";
            warnInvalidHookAccess();
            updateHookTypesDev();
            return readContext(context, observedBits);
        },
        useEffect: function(create, deps) {
            currentHookNameInDev = "useEffect";
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateEffect(create, deps);
        },
        useImperativeHandle: function(ref, create, deps) {
            currentHookNameInDev = "useImperativeHandle";
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateImperativeHandle(ref, create, deps);
        },
        useLayoutEffect: function(create, deps) {
            currentHookNameInDev = "useLayoutEffect";
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateLayoutEffect(create, deps);
        },
        useMemo: function(create, deps) {
            currentHookNameInDev = "useMemo";
            warnInvalidHookAccess();
            updateHookTypesDev();
            var prevDispatcher = ReactCurrentDispatcher.current;
            ReactCurrentDispatcher.current = InvalidNestedHooksDispatcherOnUpdateInDEV;
            try {
                return updateMemo(create, deps);
            } finally{
                ReactCurrentDispatcher.current = prevDispatcher;
            }
        },
        useReducer: function(reducer, initialArg, init) {
            currentHookNameInDev = "useReducer";
            warnInvalidHookAccess();
            updateHookTypesDev();
            var prevDispatcher = ReactCurrentDispatcher.current;
            ReactCurrentDispatcher.current = InvalidNestedHooksDispatcherOnUpdateInDEV;
            try {
                return updateReducer(reducer, initialArg, init);
            } finally{
                ReactCurrentDispatcher.current = prevDispatcher;
            }
        },
        useRef: function(initialValue) {
            currentHookNameInDev = "useRef";
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateRef();
        },
        useState: function(initialState) {
            currentHookNameInDev = "useState";
            warnInvalidHookAccess();
            updateHookTypesDev();
            var prevDispatcher = ReactCurrentDispatcher.current;
            ReactCurrentDispatcher.current = InvalidNestedHooksDispatcherOnUpdateInDEV;
            try {
                return updateState(initialState);
            } finally{
                ReactCurrentDispatcher.current = prevDispatcher;
            }
        },
        useDebugValue: function(value, formatterFn) {
            currentHookNameInDev = "useDebugValue";
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateDebugValue();
        },
        useResponder: function(responder, props) {
            currentHookNameInDev = "useResponder";
            warnInvalidHookAccess();
            updateHookTypesDev();
            return createDeprecatedResponderListener(responder, props);
        },
        useDeferredValue: function(value, config) {
            currentHookNameInDev = "useDeferredValue";
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateDeferredValue(value, config);
        },
        useTransition: function(config) {
            currentHookNameInDev = "useTransition";
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateTransition(config);
        }
    };
    InvalidNestedHooksDispatcherOnRerenderInDEV = {
        readContext: function(context, observedBits) {
            warnInvalidContextAccess();
            return readContext(context, observedBits);
        },
        useCallback: function(callback, deps) {
            currentHookNameInDev = "useCallback";
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateCallback(callback, deps);
        },
        useContext: function(context, observedBits) {
            currentHookNameInDev = "useContext";
            warnInvalidHookAccess();
            updateHookTypesDev();
            return readContext(context, observedBits);
        },
        useEffect: function(create, deps) {
            currentHookNameInDev = "useEffect";
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateEffect(create, deps);
        },
        useImperativeHandle: function(ref, create, deps) {
            currentHookNameInDev = "useImperativeHandle";
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateImperativeHandle(ref, create, deps);
        },
        useLayoutEffect: function(create, deps) {
            currentHookNameInDev = "useLayoutEffect";
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateLayoutEffect(create, deps);
        },
        useMemo: function(create, deps) {
            currentHookNameInDev = "useMemo";
            warnInvalidHookAccess();
            updateHookTypesDev();
            var prevDispatcher = ReactCurrentDispatcher.current;
            ReactCurrentDispatcher.current = InvalidNestedHooksDispatcherOnUpdateInDEV;
            try {
                return updateMemo(create, deps);
            } finally{
                ReactCurrentDispatcher.current = prevDispatcher;
            }
        },
        useReducer: function(reducer, initialArg, init) {
            currentHookNameInDev = "useReducer";
            warnInvalidHookAccess();
            updateHookTypesDev();
            var prevDispatcher = ReactCurrentDispatcher.current;
            ReactCurrentDispatcher.current = InvalidNestedHooksDispatcherOnUpdateInDEV;
            try {
                return rerenderReducer(reducer, initialArg, init);
            } finally{
                ReactCurrentDispatcher.current = prevDispatcher;
            }
        },
        useRef: function(initialValue) {
            currentHookNameInDev = "useRef";
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateRef();
        },
        useState: function(initialState) {
            currentHookNameInDev = "useState";
            warnInvalidHookAccess();
            updateHookTypesDev();
            var prevDispatcher = ReactCurrentDispatcher.current;
            ReactCurrentDispatcher.current = InvalidNestedHooksDispatcherOnUpdateInDEV;
            try {
                return rerenderState(initialState);
            } finally{
                ReactCurrentDispatcher.current = prevDispatcher;
            }
        },
        useDebugValue: function(value, formatterFn) {
            currentHookNameInDev = "useDebugValue";
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateDebugValue();
        },
        useResponder: function(responder, props) {
            currentHookNameInDev = "useResponder";
            warnInvalidHookAccess();
            updateHookTypesDev();
            return createDeprecatedResponderListener(responder, props);
        },
        useDeferredValue: function(value, config) {
            currentHookNameInDev = "useDeferredValue";
            warnInvalidHookAccess();
            updateHookTypesDev();
            return rerenderDeferredValue(value, config);
        },
        useTransition: function(config) {
            currentHookNameInDev = "useTransition";
            warnInvalidHookAccess();
            updateHookTypesDev();
            return rerenderTransition(config);
        }
    };
    var now$1 = Scheduler.unstable_now;
    var commitTime = 0;
    var profilerStartTime = -1;
    function getCommitTime() {
        return commitTime;
    }
    function recordCommitTime() {
        commitTime = now$1();
    }
    function startProfilerTimer(fiber) {
        profilerStartTime = now$1();
        if (fiber.actualStartTime < 0) fiber.actualStartTime = now$1();
    }
    function stopProfilerTimerIfRunning(fiber) {
        profilerStartTime = -1;
    }
    function stopProfilerTimerIfRunningAndRecordDelta(fiber, overrideBaseTime) {
        if (profilerStartTime >= 0) {
            var elapsedTime = now$1() - profilerStartTime;
            fiber.actualDuration += elapsedTime;
            if (overrideBaseTime) fiber.selfBaseDuration = elapsedTime;
            profilerStartTime = -1;
        }
    }
    // This may have been an insertion or a hydration.
    var hydrationParentFiber = null;
    var nextHydratableInstance = null;
    var isHydrating = false;
    function enterHydrationState(fiber) {
        var parentInstance = fiber.stateNode.containerInfo;
        nextHydratableInstance = getFirstHydratableChild(parentInstance);
        hydrationParentFiber = fiber;
        isHydrating = true;
        return true;
    }
    function deleteHydratableInstance(returnFiber, instance) {
        switch(returnFiber.tag){
            case HostRoot:
                didNotHydrateContainerInstance(returnFiber.stateNode.containerInfo, instance);
                break;
            case HostComponent:
                didNotHydrateInstance(returnFiber.type, returnFiber.memoizedProps, returnFiber.stateNode, instance);
                break;
        }
        var childToDelete = createFiberFromHostInstanceForDeletion();
        childToDelete.stateNode = instance;
        childToDelete.return = returnFiber;
        childToDelete.effectTag = Deletion; // This might seem like it belongs on progressedFirstDeletion. However,
        // these children are not part of the reconciliation list of children.
        // Even if we abort and rereconcile the children, that will try to hydrate
        // again and the nodes are still in the host tree so these will be
        // recreated.
        if (returnFiber.lastEffect !== null) {
            returnFiber.lastEffect.nextEffect = childToDelete;
            returnFiber.lastEffect = childToDelete;
        } else returnFiber.firstEffect = returnFiber.lastEffect = childToDelete;
    }
    function insertNonHydratedInstance(returnFiber, fiber) {
        fiber.effectTag = fiber.effectTag & ~Hydrating | Placement;
        switch(returnFiber.tag){
            case HostRoot:
                var parentContainer = returnFiber.stateNode.containerInfo;
                switch(fiber.tag){
                    case HostComponent:
                        var type = fiber.type;
                        var props = fiber.pendingProps;
                        didNotFindHydratableContainerInstance(parentContainer, type);
                        break;
                    case HostText:
                        var text = fiber.pendingProps;
                        didNotFindHydratableContainerTextInstance(parentContainer, text);
                        break;
                }
                break;
            case HostComponent:
                var parentType = returnFiber.type;
                var parentProps = returnFiber.memoizedProps;
                var parentInstance = returnFiber.stateNode;
                switch(fiber.tag){
                    case HostComponent:
                        var _type = fiber.type;
                        var _props = fiber.pendingProps;
                        didNotFindHydratableInstance(parentType, parentProps, parentInstance, _type);
                        break;
                    case HostText:
                        var _text = fiber.pendingProps;
                        didNotFindHydratableTextInstance(parentType, parentProps, parentInstance, _text);
                        break;
                    case SuspenseComponent:
                        didNotFindHydratableSuspenseInstance(parentType, parentProps);
                        break;
                }
                break;
            default:
                return;
        }
    }
    function tryHydrate(fiber, nextInstance) {
        switch(fiber.tag){
            case HostComponent:
                var type = fiber.type;
                var props = fiber.pendingProps;
                var instance = canHydrateInstance(nextInstance, type);
                if (instance !== null) {
                    fiber.stateNode = instance;
                    return true;
                }
                return false;
            case HostText:
                var text = fiber.pendingProps;
                var textInstance = canHydrateTextInstance(nextInstance, text);
                if (textInstance !== null) {
                    fiber.stateNode = textInstance;
                    return true;
                }
                return false;
            case SuspenseComponent:
                return false;
            default:
                return false;
        }
    }
    function tryToClaimNextHydratableInstance(fiber) {
        if (!isHydrating) return;
        var nextInstance = nextHydratableInstance;
        if (!nextInstance) {
            // Nothing to hydrate. Make it an insertion.
            insertNonHydratedInstance(hydrationParentFiber, fiber);
            isHydrating = false;
            hydrationParentFiber = fiber;
            return;
        }
        var firstAttemptedInstance = nextInstance;
        if (!tryHydrate(fiber, nextInstance)) {
            // If we can't hydrate this instance let's try the next one.
            // We use this as a heuristic. It's based on intuition and not data so it
            // might be flawed or unnecessary.
            nextInstance = getNextHydratableSibling(firstAttemptedInstance);
            if (!nextInstance || !tryHydrate(fiber, nextInstance)) {
                // Nothing to hydrate. Make it an insertion.
                insertNonHydratedInstance(hydrationParentFiber, fiber);
                isHydrating = false;
                hydrationParentFiber = fiber;
                return;
            } // We matched the next one, we'll now assume that the first one was
            // superfluous and we'll delete it. Since we can't eagerly delete it
            // we'll have to schedule a deletion. To do that, this node needs a dummy
            // fiber associated with it.
            deleteHydratableInstance(hydrationParentFiber, firstAttemptedInstance);
        }
        hydrationParentFiber = fiber;
        nextHydratableInstance = getFirstHydratableChild(nextInstance);
    }
    function prepareToHydrateHostInstance(fiber, rootContainerInstance, hostContext) {
        var instance = fiber.stateNode;
        var updatePayload = hydrateInstance(instance, fiber.type, fiber.memoizedProps, rootContainerInstance, hostContext, fiber); // TODO: Type this specific to this type of component.
        fiber.updateQueue = updatePayload; // If the update payload indicates that there is a change or if there
        // is a new ref we mark this as an update.
        if (updatePayload !== null) return true;
        return false;
    }
    function prepareToHydrateHostTextInstance(fiber) {
        var textInstance = fiber.stateNode;
        var textContent = fiber.memoizedProps;
        var shouldUpdate = hydrateTextInstance(textInstance, textContent, fiber);
        if (shouldUpdate) {
            // We assume that prepareToHydrateHostTextInstance is called in a context where the
            // hydration parent is the parent host component of this host text.
            var returnFiber = hydrationParentFiber;
            if (returnFiber !== null) switch(returnFiber.tag){
                case HostRoot:
                    var parentContainer = returnFiber.stateNode.containerInfo;
                    didNotMatchHydratedContainerTextInstance(parentContainer, textInstance, textContent);
                    break;
                case HostComponent:
                    var parentType = returnFiber.type;
                    var parentProps = returnFiber.memoizedProps;
                    var parentInstance = returnFiber.stateNode;
                    didNotMatchHydratedTextInstance(parentType, parentProps, parentInstance, textInstance, textContent);
                    break;
            }
        }
        return shouldUpdate;
    }
    function skipPastDehydratedSuspenseInstance(fiber) {
        var suspenseState = fiber.memoizedState;
        var suspenseInstance = suspenseState !== null ? suspenseState.dehydrated : null;
        if (!suspenseInstance) throw Error("Expected to have a hydrated suspense instance. This error is likely caused by a bug in React. Please file an issue.");
        return getNextHydratableInstanceAfterSuspenseInstance(suspenseInstance);
    }
    function popToNextHostParent(fiber) {
        var parent = fiber.return;
        while(parent !== null && parent.tag !== HostComponent && parent.tag !== HostRoot && parent.tag !== SuspenseComponent)parent = parent.return;
        hydrationParentFiber = parent;
    }
    function popHydrationState(fiber) {
        if (fiber !== hydrationParentFiber) // We're deeper than the current hydration context, inside an inserted
        // tree.
        return false;
        if (!isHydrating) {
            // If we're not currently hydrating but we're in a hydration context, then
            // we were an insertion and now need to pop up reenter hydration of our
            // siblings.
            popToNextHostParent(fiber);
            isHydrating = true;
            return false;
        }
        var type = fiber.type; // If we have any remaining hydratable nodes, we need to delete them now.
        // We only do this deeper than head and body since they tend to have random
        // other nodes in them. We also ignore components with pure text content in
        // side of them.
        // TODO: Better heuristic.
        if (fiber.tag !== HostComponent || type !== "head" && type !== "body" && !shouldSetTextContent(type, fiber.memoizedProps)) {
            var nextInstance = nextHydratableInstance;
            while(nextInstance){
                deleteHydratableInstance(fiber, nextInstance);
                nextInstance = getNextHydratableSibling(nextInstance);
            }
        }
        popToNextHostParent(fiber);
        if (fiber.tag === SuspenseComponent) nextHydratableInstance = skipPastDehydratedSuspenseInstance(fiber);
        else nextHydratableInstance = hydrationParentFiber ? getNextHydratableSibling(fiber.stateNode) : null;
        return true;
    }
    function resetHydrationState() {
        hydrationParentFiber = null;
        nextHydratableInstance = null;
        isHydrating = false;
    }
    var ReactCurrentOwner$1 = ReactSharedInternals.ReactCurrentOwner;
    var didReceiveUpdate = false;
    var didWarnAboutBadClass;
    var didWarnAboutModulePatternComponent;
    var didWarnAboutContextTypeOnFunctionComponent;
    var didWarnAboutGetDerivedStateOnFunctionComponent;
    var didWarnAboutFunctionRefs;
    var didWarnAboutReassigningProps;
    var didWarnAboutRevealOrder;
    var didWarnAboutTailOptions;
    didWarnAboutBadClass = {};
    didWarnAboutModulePatternComponent = {};
    didWarnAboutContextTypeOnFunctionComponent = {};
    didWarnAboutGetDerivedStateOnFunctionComponent = {};
    didWarnAboutFunctionRefs = {};
    didWarnAboutReassigningProps = false;
    didWarnAboutRevealOrder = {};
    didWarnAboutTailOptions = {};
    function reconcileChildren(current, workInProgress, nextChildren, renderExpirationTime) {
        if (current === null) // If this is a fresh new component that hasn't been rendered yet, we
        // won't update its child set by applying minimal side-effects. Instead,
        // we will add them all to the child before it gets rendered. That means
        // we can optimize this reconciliation pass by not tracking side-effects.
        workInProgress.child = mountChildFibers(workInProgress, null, nextChildren, renderExpirationTime);
        else // If the current child is the same as the work in progress, it means that
        // we haven't yet started any work on these children. Therefore, we use
        // the clone algorithm to create a copy of all the current children.
        // If we had any progressed work already, that is invalid at this point so
        // let's throw it out.
        workInProgress.child = reconcileChildFibers(workInProgress, current.child, nextChildren, renderExpirationTime);
    }
    function forceUnmountCurrentAndReconcile(current, workInProgress, nextChildren, renderExpirationTime) {
        // This function is fork of reconcileChildren. It's used in cases where we
        // want to reconcile without matching against the existing set. This has the
        // effect of all current children being unmounted; even if the type and key
        // are the same, the old child is unmounted and a new child is created.
        //
        // To do this, we're going to go through the reconcile algorithm twice. In
        // the first pass, we schedule a deletion for all the current children by
        // passing null.
        workInProgress.child = reconcileChildFibers(workInProgress, current.child, null, renderExpirationTime); // In the second pass, we mount the new children. The trick here is that we
        // pass null in place of where we usually pass the current child set. This has
        // the effect of remounting all children regardless of whether their
        // identities match.
        workInProgress.child = reconcileChildFibers(workInProgress, null, nextChildren, renderExpirationTime);
    }
    function updateForwardRef(current, workInProgress, Component, nextProps, renderExpirationTime) {
        if (workInProgress.type !== workInProgress.elementType) {
            // Lazy component props can't be validated in createElement
            // because they're only guaranteed to be resolved here.
            var innerPropTypes = Component.propTypes;
            if (innerPropTypes) checkPropTypes(innerPropTypes, nextProps, "prop", getComponentName(Component), getCurrentFiberStackInDev);
        }
        var render = Component.render;
        var ref = workInProgress.ref; // The rest is a fork of updateFunctionComponent
        var nextChildren;
        prepareToReadContext(workInProgress, renderExpirationTime);
        ReactCurrentOwner$1.current = workInProgress;
        setIsRendering(true);
        nextChildren = renderWithHooks(current, workInProgress, render, nextProps, ref, renderExpirationTime);
        if (workInProgress.mode & StrictMode) // Only double-render components with Hooks
        {
            if (workInProgress.memoizedState !== null) nextChildren = renderWithHooks(current, workInProgress, render, nextProps, ref, renderExpirationTime);
        }
        setIsRendering(false);
        if (current !== null && !didReceiveUpdate) {
            bailoutHooks(current, workInProgress, renderExpirationTime);
            return bailoutOnAlreadyFinishedWork(current, workInProgress, renderExpirationTime);
        } // React DevTools reads this flag.
        workInProgress.effectTag |= PerformedWork;
        reconcileChildren(current, workInProgress, nextChildren, renderExpirationTime);
        return workInProgress.child;
    }
    function updateMemoComponent(current, workInProgress, Component, nextProps, updateExpirationTime, renderExpirationTime) {
        if (current === null) {
            var type = Component.type;
            if (isSimpleFunctionComponent(type) && Component.compare === null && // SimpleMemoComponent codepath doesn't resolve outer props either.
            Component.defaultProps === undefined) {
                var resolvedType = type;
                resolvedType = resolveFunctionForHotReloading(type);
                // and with only the default shallow comparison, we upgrade it
                // to a SimpleMemoComponent to allow fast path updates.
                workInProgress.tag = SimpleMemoComponent;
                workInProgress.type = resolvedType;
                validateFunctionComponentInDev(workInProgress, type);
                return updateSimpleMemoComponent(current, workInProgress, resolvedType, nextProps, updateExpirationTime, renderExpirationTime);
            }
            var innerPropTypes = type.propTypes;
            if (innerPropTypes) // Inner memo component props aren't currently validated in createElement.
            // We could move it there, but we'd still need this for lazy code path.
            checkPropTypes(innerPropTypes, nextProps, "prop", getComponentName(type), getCurrentFiberStackInDev);
            var child = createFiberFromTypeAndProps(Component.type, null, nextProps, null, workInProgress.mode, renderExpirationTime);
            child.ref = workInProgress.ref;
            child.return = workInProgress;
            workInProgress.child = child;
            return child;
        }
        var _type = Component.type;
        var _innerPropTypes = _type.propTypes;
        if (_innerPropTypes) // Inner memo component props aren't currently validated in createElement.
        // We could move it there, but we'd still need this for lazy code path.
        checkPropTypes(_innerPropTypes, nextProps, "prop", getComponentName(_type), getCurrentFiberStackInDev);
        var currentChild = current.child; // This is always exactly one child
        if (updateExpirationTime < renderExpirationTime) {
            // This will be the props with resolved defaultProps,
            // unlike current.memoizedProps which will be the unresolved ones.
            var prevProps = currentChild.memoizedProps; // Default to shallow comparison
            var compare = Component.compare;
            compare = compare !== null ? compare : shallowEqual;
            if (compare(prevProps, nextProps) && current.ref === workInProgress.ref) return bailoutOnAlreadyFinishedWork(current, workInProgress, renderExpirationTime);
        } // React DevTools reads this flag.
        workInProgress.effectTag |= PerformedWork;
        var newChild = createWorkInProgress(currentChild, nextProps);
        newChild.ref = workInProgress.ref;
        newChild.return = workInProgress;
        workInProgress.child = newChild;
        return newChild;
    }
    function updateSimpleMemoComponent(current, workInProgress, Component, nextProps, updateExpirationTime, renderExpirationTime) {
        if (workInProgress.type !== workInProgress.elementType) {
            // Lazy component props can't be validated in createElement
            // because they're only guaranteed to be resolved here.
            var outerMemoType = workInProgress.elementType;
            if (outerMemoType.$$typeof === REACT_LAZY_TYPE) // We warn when you define propTypes on lazy()
            // so let's just skip over it to find memo() outer wrapper.
            // Inner props for memo are validated later.
            outerMemoType = refineResolvedLazyComponent(outerMemoType);
            var outerPropTypes = outerMemoType && outerMemoType.propTypes;
            if (outerPropTypes) checkPropTypes(outerPropTypes, nextProps, "prop", getComponentName(outerMemoType), getCurrentFiberStackInDev);
             // Inner propTypes will be validated in the function component path.
        }
        if (current !== null) {
            var prevProps = current.memoizedProps;
            if (shallowEqual(prevProps, nextProps) && current.ref === workInProgress.ref && workInProgress.type === current.type) {
                didReceiveUpdate = false;
                if (updateExpirationTime < renderExpirationTime) {
                    // The pending update priority was cleared at the beginning of
                    // beginWork. We're about to bail out, but there might be additional
                    // updates at a lower priority. Usually, the priority level of the
                    // remaining updates is accumlated during the evaluation of the
                    // component (i.e. when processing the update queue). But since since
                    // we're bailing out early *without* evaluating the component, we need
                    // to account for it here, too. Reset to the value of the current fiber.
                    // NOTE: This only applies to SimpleMemoComponent, not MemoComponent,
                    // because a MemoComponent fiber does not have hooks or an update queue;
                    // rather, it wraps around an inner component, which may or may not
                    // contains hooks.
                    // TODO: Move the reset at in beginWork out of the common path so that
                    // this is no longer necessary.
                    workInProgress.expirationTime = current.expirationTime;
                    return bailoutOnAlreadyFinishedWork(current, workInProgress, renderExpirationTime);
                }
            }
        }
        return updateFunctionComponent(current, workInProgress, Component, nextProps, renderExpirationTime);
    }
    function updateFragment(current, workInProgress, renderExpirationTime) {
        var nextChildren = workInProgress.pendingProps;
        reconcileChildren(current, workInProgress, nextChildren, renderExpirationTime);
        return workInProgress.child;
    }
    function updateMode(current, workInProgress, renderExpirationTime) {
        var nextChildren = workInProgress.pendingProps.children;
        reconcileChildren(current, workInProgress, nextChildren, renderExpirationTime);
        return workInProgress.child;
    }
    function updateProfiler(current, workInProgress, renderExpirationTime) {
        workInProgress.effectTag |= Update;
        var nextProps = workInProgress.pendingProps;
        var nextChildren = nextProps.children;
        reconcileChildren(current, workInProgress, nextChildren, renderExpirationTime);
        return workInProgress.child;
    }
    function markRef(current, workInProgress) {
        var ref = workInProgress.ref;
        if (current === null && ref !== null || current !== null && current.ref !== ref) // Schedule a Ref effect
        workInProgress.effectTag |= Ref;
    }
    function updateFunctionComponent(current, workInProgress, Component, nextProps, renderExpirationTime) {
        if (workInProgress.type !== workInProgress.elementType) {
            // Lazy component props can't be validated in createElement
            // because they're only guaranteed to be resolved here.
            var innerPropTypes = Component.propTypes;
            if (innerPropTypes) checkPropTypes(innerPropTypes, nextProps, "prop", getComponentName(Component), getCurrentFiberStackInDev);
        }
        var context;
        var unmaskedContext = getUnmaskedContext(workInProgress, Component, true);
        context = getMaskedContext(workInProgress, unmaskedContext);
        var nextChildren;
        prepareToReadContext(workInProgress, renderExpirationTime);
        ReactCurrentOwner$1.current = workInProgress;
        setIsRendering(true);
        nextChildren = renderWithHooks(current, workInProgress, Component, nextProps, context, renderExpirationTime);
        if (workInProgress.mode & StrictMode) // Only double-render components with Hooks
        {
            if (workInProgress.memoizedState !== null) nextChildren = renderWithHooks(current, workInProgress, Component, nextProps, context, renderExpirationTime);
        }
        setIsRendering(false);
        if (current !== null && !didReceiveUpdate) {
            bailoutHooks(current, workInProgress, renderExpirationTime);
            return bailoutOnAlreadyFinishedWork(current, workInProgress, renderExpirationTime);
        } // React DevTools reads this flag.
        workInProgress.effectTag |= PerformedWork;
        reconcileChildren(current, workInProgress, nextChildren, renderExpirationTime);
        return workInProgress.child;
    }
    function updateClassComponent(current, workInProgress, Component, nextProps, renderExpirationTime) {
        if (workInProgress.type !== workInProgress.elementType) {
            // Lazy component props can't be validated in createElement
            // because they're only guaranteed to be resolved here.
            var innerPropTypes = Component.propTypes;
            if (innerPropTypes) checkPropTypes(innerPropTypes, nextProps, "prop", getComponentName(Component), getCurrentFiberStackInDev);
        }
        // During mounting we don't know the child context yet as the instance doesn't exist.
        // We will invalidate the child context in finishClassComponent() right after rendering.
        var hasContext;
        if (isContextProvider(Component)) {
            hasContext = true;
            pushContextProvider(workInProgress);
        } else hasContext = false;
        prepareToReadContext(workInProgress, renderExpirationTime);
        var instance = workInProgress.stateNode;
        var shouldUpdate;
        if (instance === null) {
            if (current !== null) {
                // A class component without an instance only mounts if it suspended
                // inside a non-concurrent tree, in an inconsistent state. We want to
                // treat it like a new mount, even though an empty version of it already
                // committed. Disconnect the alternate pointers.
                current.alternate = null;
                workInProgress.alternate = null; // Since this is conceptually a new fiber, schedule a Placement effect
                workInProgress.effectTag |= Placement;
            } // In the initial pass we might need to construct the instance.
            constructClassInstance(workInProgress, Component, nextProps);
            mountClassInstance(workInProgress, Component, nextProps, renderExpirationTime);
            shouldUpdate = true;
        } else if (current === null) // In a resume, we'll already have an instance we can reuse.
        shouldUpdate = resumeMountClassInstance(workInProgress, Component, nextProps, renderExpirationTime);
        else shouldUpdate = updateClassInstance(current, workInProgress, Component, nextProps, renderExpirationTime);
        var nextUnitOfWork = finishClassComponent(current, workInProgress, Component, shouldUpdate, hasContext, renderExpirationTime);
        var inst = workInProgress.stateNode;
        if (inst.props !== nextProps) {
            if (!didWarnAboutReassigningProps) error("It looks like %s is reassigning its own `this.props` while rendering. This is not supported and can lead to confusing bugs.", getComponentName(workInProgress.type) || "a component");
            didWarnAboutReassigningProps = true;
        }
        return nextUnitOfWork;
    }
    function finishClassComponent(current, workInProgress, Component, shouldUpdate, hasContext, renderExpirationTime) {
        // Refs should update even if shouldComponentUpdate returns false
        markRef(current, workInProgress);
        var didCaptureError = (workInProgress.effectTag & DidCapture) !== NoEffect;
        if (!shouldUpdate && !didCaptureError) {
            // Context providers should defer to sCU for rendering
            if (hasContext) invalidateContextProvider(workInProgress, Component, false);
            return bailoutOnAlreadyFinishedWork(current, workInProgress, renderExpirationTime);
        }
        var instance = workInProgress.stateNode; // Rerender
        ReactCurrentOwner$1.current = workInProgress;
        var nextChildren;
        if (didCaptureError && typeof Component.getDerivedStateFromError !== "function") {
            // If we captured an error, but getDerivedStateFromError is not defined,
            // unmount all the children. componentDidCatch will schedule an update to
            // re-render a fallback. This is temporary until we migrate everyone to
            // the new API.
            // TODO: Warn in a future release.
            nextChildren = null;
            stopProfilerTimerIfRunning();
        } else {
            setIsRendering(true);
            nextChildren = instance.render();
            if (workInProgress.mode & StrictMode) instance.render();
            setIsRendering(false);
        } // React DevTools reads this flag.
        workInProgress.effectTag |= PerformedWork;
        if (current !== null && didCaptureError) // If we're recovering from an error, reconcile without reusing any of
        // the existing children. Conceptually, the normal children and the children
        // that are shown on error are two different sets, so we shouldn't reuse
        // normal children even if their identities match.
        forceUnmountCurrentAndReconcile(current, workInProgress, nextChildren, renderExpirationTime);
        else reconcileChildren(current, workInProgress, nextChildren, renderExpirationTime);
         // Memoize state using the values we just used to render.
        // TODO: Restructure so we never read values from the instance.
        workInProgress.memoizedState = instance.state; // The context might have changed so we need to recalculate it.
        if (hasContext) invalidateContextProvider(workInProgress, Component, true);
        return workInProgress.child;
    }
    function pushHostRootContext(workInProgress) {
        var root = workInProgress.stateNode;
        if (root.pendingContext) pushTopLevelContextObject(workInProgress, root.pendingContext, root.pendingContext !== root.context);
        else if (root.context) // Should always be set
        pushTopLevelContextObject(workInProgress, root.context, false);
        pushHostContainer(workInProgress, root.containerInfo);
    }
    function updateHostRoot(current, workInProgress, renderExpirationTime) {
        pushHostRootContext(workInProgress);
        var updateQueue = workInProgress.updateQueue;
        if (!(current !== null && updateQueue !== null)) throw Error("If the root does not have an updateQueue, we should have already bailed out. This error is likely caused by a bug in React. Please file an issue.");
        var nextProps = workInProgress.pendingProps;
        var prevState = workInProgress.memoizedState;
        var prevChildren = prevState !== null ? prevState.element : null;
        cloneUpdateQueue(current, workInProgress);
        processUpdateQueue(workInProgress, nextProps, null, renderExpirationTime);
        var nextState = workInProgress.memoizedState; // Caution: React DevTools currently depends on this property
        // being called "element".
        var nextChildren = nextState.element;
        if (nextChildren === prevChildren) {
            // If the state is the same as before, that's a bailout because we had
            // no work that expires at this time.
            resetHydrationState();
            return bailoutOnAlreadyFinishedWork(current, workInProgress, renderExpirationTime);
        }
        var root = workInProgress.stateNode;
        if (root.hydrate && enterHydrationState(workInProgress)) {
            // If we don't have any current children this might be the first pass.
            // We always try to hydrate. If this isn't a hydration pass there won't
            // be any children to hydrate which is effectively the same thing as
            // not hydrating.
            var child = mountChildFibers(workInProgress, null, nextChildren, renderExpirationTime);
            workInProgress.child = child;
            var node = child;
            while(node){
                // Mark each child as hydrating. This is a fast path to know whether this
                // tree is part of a hydrating tree. This is used to determine if a child
                // node has fully mounted yet, and for scheduling event replaying.
                // Conceptually this is similar to Placement in that a new subtree is
                // inserted into the React tree here. It just happens to not need DOM
                // mutations because it already exists.
                node.effectTag = node.effectTag & ~Placement | Hydrating;
                node = node.sibling;
            }
        } else {
            // Otherwise reset hydration state in case we aborted and resumed another
            // root.
            reconcileChildren(current, workInProgress, nextChildren, renderExpirationTime);
            resetHydrationState();
        }
        return workInProgress.child;
    }
    function updateHostComponent(current, workInProgress, renderExpirationTime) {
        pushHostContext(workInProgress);
        if (current === null) tryToClaimNextHydratableInstance(workInProgress);
        var type = workInProgress.type;
        var nextProps = workInProgress.pendingProps;
        var prevProps = current !== null ? current.memoizedProps : null;
        var nextChildren = nextProps.children;
        var isDirectTextChild = shouldSetTextContent(type, nextProps);
        if (isDirectTextChild) // We special case a direct text child of a host node. This is a common
        // case. We won't handle it as a reified child. We will instead handle
        // this in the host environment that also has access to this prop. That
        // avoids allocating another HostText fiber and traversing it.
        nextChildren = null;
        else if (prevProps !== null && shouldSetTextContent(type, prevProps)) // If we're switching from a direct text child to a normal child, or to
        // empty, we need to schedule the text content to be reset.
        workInProgress.effectTag |= ContentReset;
        markRef(current, workInProgress); // Check the host config to see if the children are offscreen/hidden.
        if (workInProgress.mode & ConcurrentMode && renderExpirationTime !== Never && shouldDeprioritizeSubtree(type, nextProps)) {
            markSpawnedWork(Never);
            workInProgress.expirationTime = workInProgress.childExpirationTime = Never;
            return null;
        }
        reconcileChildren(current, workInProgress, nextChildren, renderExpirationTime);
        return workInProgress.child;
    }
    function updateHostText(current, workInProgress) {
        if (current === null) tryToClaimNextHydratableInstance(workInProgress);
         // Nothing to do here. This is terminal. We'll do the completion step
        // immediately after.
        return null;
    }
    function mountLazyComponent(_current, workInProgress, elementType, updateExpirationTime, renderExpirationTime) {
        if (_current !== null) {
            // A lazy component only mounts if it suspended inside a non-
            // concurrent tree, in an inconsistent state. We want to treat it like
            // a new mount, even though an empty version of it already committed.
            // Disconnect the alternate pointers.
            _current.alternate = null;
            workInProgress.alternate = null; // Since this is conceptually a new fiber, schedule a Placement effect
            workInProgress.effectTag |= Placement;
        }
        var props = workInProgress.pendingProps; // We can't start a User Timing measurement with correct label yet.
        // Cancel and resume right after we know the tag.
        cancelWorkTimer(workInProgress);
        var Component = readLazyComponentType(elementType); // Store the unwrapped component in the type.
        workInProgress.type = Component;
        var resolvedTag = workInProgress.tag = resolveLazyComponentTag(Component);
        startWorkTimer(workInProgress);
        var resolvedProps = resolveDefaultProps(Component, props);
        var child;
        switch(resolvedTag){
            case FunctionComponent:
                validateFunctionComponentInDev(workInProgress, Component);
                workInProgress.type = Component = resolveFunctionForHotReloading(Component);
                child = updateFunctionComponent(null, workInProgress, Component, resolvedProps, renderExpirationTime);
                return child;
            case ClassComponent:
                workInProgress.type = Component = resolveClassForHotReloading(Component);
                child = updateClassComponent(null, workInProgress, Component, resolvedProps, renderExpirationTime);
                return child;
            case ForwardRef:
                workInProgress.type = Component = resolveForwardRefForHotReloading(Component);
                child = updateForwardRef(null, workInProgress, Component, resolvedProps, renderExpirationTime);
                return child;
            case MemoComponent:
                if (workInProgress.type !== workInProgress.elementType) {
                    var outerPropTypes = Component.propTypes;
                    if (outerPropTypes) checkPropTypes(outerPropTypes, resolvedProps, "prop", getComponentName(Component), getCurrentFiberStackInDev);
                }
                child = updateMemoComponent(null, workInProgress, Component, resolveDefaultProps(Component.type, resolvedProps), updateExpirationTime, renderExpirationTime);
                return child;
        }
        var hint = "";
        if (Component !== null && typeof Component === "object" && Component.$$typeof === REACT_LAZY_TYPE) hint = " Did you wrap a component in React.lazy() more than once?";
        throw Error("Element type is invalid. Received a promise that resolves to: " + Component + ". Lazy element type must resolve to a class or function." + hint);
    }
    function mountIncompleteClassComponent(_current, workInProgress, Component, nextProps, renderExpirationTime) {
        if (_current !== null) {
            // An incomplete component only mounts if it suspended inside a non-
            // concurrent tree, in an inconsistent state. We want to treat it like
            // a new mount, even though an empty version of it already committed.
            // Disconnect the alternate pointers.
            _current.alternate = null;
            workInProgress.alternate = null; // Since this is conceptually a new fiber, schedule a Placement effect
            workInProgress.effectTag |= Placement;
        } // Promote the fiber to a class and try rendering again.
        workInProgress.tag = ClassComponent; // The rest of this function is a fork of `updateClassComponent`
        // Push context providers early to prevent context stack mismatches.
        // During mounting we don't know the child context yet as the instance doesn't exist.
        // We will invalidate the child context in finishClassComponent() right after rendering.
        var hasContext;
        if (isContextProvider(Component)) {
            hasContext = true;
            pushContextProvider(workInProgress);
        } else hasContext = false;
        prepareToReadContext(workInProgress, renderExpirationTime);
        constructClassInstance(workInProgress, Component, nextProps);
        mountClassInstance(workInProgress, Component, nextProps, renderExpirationTime);
        return finishClassComponent(null, workInProgress, Component, true, hasContext, renderExpirationTime);
    }
    function mountIndeterminateComponent(_current, workInProgress, Component, renderExpirationTime) {
        if (_current !== null) {
            // An indeterminate component only mounts if it suspended inside a non-
            // concurrent tree, in an inconsistent state. We want to treat it like
            // a new mount, even though an empty version of it already committed.
            // Disconnect the alternate pointers.
            _current.alternate = null;
            workInProgress.alternate = null; // Since this is conceptually a new fiber, schedule a Placement effect
            workInProgress.effectTag |= Placement;
        }
        var props = workInProgress.pendingProps;
        var context;
        var unmaskedContext = getUnmaskedContext(workInProgress, Component, false);
        context = getMaskedContext(workInProgress, unmaskedContext);
        prepareToReadContext(workInProgress, renderExpirationTime);
        var value;
        if (Component.prototype && typeof Component.prototype.render === "function") {
            var componentName = getComponentName(Component) || "Unknown";
            if (!didWarnAboutBadClass[componentName]) {
                error("The <%s /> component appears to have a render method, but doesn't extend React.Component. This is likely to cause errors. Change %s to extend React.Component instead.", componentName, componentName);
                didWarnAboutBadClass[componentName] = true;
            }
        }
        if (workInProgress.mode & StrictMode) ReactStrictModeWarnings.recordLegacyContextWarning(workInProgress, null);
        setIsRendering(true);
        ReactCurrentOwner$1.current = workInProgress;
        value = renderWithHooks(null, workInProgress, Component, props, context, renderExpirationTime);
        setIsRendering(false);
        workInProgress.effectTag |= PerformedWork;
        if (typeof value === "object" && value !== null && typeof value.render === "function" && value.$$typeof === undefined) {
            var _componentName = getComponentName(Component) || "Unknown";
            if (!didWarnAboutModulePatternComponent[_componentName]) {
                error("The <%s /> component appears to be a function component that returns a class instance. Change %s to a class that extends React.Component instead. If you can't use a class try assigning the prototype on the function as a workaround. `%s.prototype = React.Component.prototype`. Don't use an arrow function since it cannot be called with `new` by React.", _componentName, _componentName, _componentName);
                didWarnAboutModulePatternComponent[_componentName] = true;
            }
            workInProgress.tag = ClassComponent; // Throw out any hooks that were used.
            workInProgress.memoizedState = null;
            workInProgress.updateQueue = null; // Push context providers early to prevent context stack mismatches.
            // During mounting we don't know the child context yet as the instance doesn't exist.
            // We will invalidate the child context in finishClassComponent() right after rendering.
            var hasContext = false;
            if (isContextProvider(Component)) {
                hasContext = true;
                pushContextProvider(workInProgress);
            } else hasContext = false;
            workInProgress.memoizedState = value.state !== null && value.state !== undefined ? value.state : null;
            initializeUpdateQueue(workInProgress);
            var getDerivedStateFromProps = Component.getDerivedStateFromProps;
            if (typeof getDerivedStateFromProps === "function") applyDerivedStateFromProps(workInProgress, Component, getDerivedStateFromProps, props);
            adoptClassInstance(workInProgress, value);
            mountClassInstance(workInProgress, Component, props, renderExpirationTime);
            return finishClassComponent(null, workInProgress, Component, true, hasContext, renderExpirationTime);
        } else {
            // Proceed under the assumption that this is a function component
            workInProgress.tag = FunctionComponent;
            if (workInProgress.mode & StrictMode) // Only double-render components with Hooks
            {
                if (workInProgress.memoizedState !== null) value = renderWithHooks(null, workInProgress, Component, props, context, renderExpirationTime);
            }
            reconcileChildren(null, workInProgress, value, renderExpirationTime);
            validateFunctionComponentInDev(workInProgress, Component);
            return workInProgress.child;
        }
    }
    function validateFunctionComponentInDev(workInProgress, Component) {
        if (Component) {
            if (Component.childContextTypes) error("%s(...): childContextTypes cannot be defined on a function component.", Component.displayName || Component.name || "Component");
        }
        if (workInProgress.ref !== null) {
            var info = "";
            var ownerName = getCurrentFiberOwnerNameInDevOrNull();
            if (ownerName) info += "\n\nCheck the render method of `" + ownerName + "`.";
            var warningKey = ownerName || workInProgress._debugID || "";
            var debugSource = workInProgress._debugSource;
            if (debugSource) warningKey = debugSource.fileName + ":" + debugSource.lineNumber;
            if (!didWarnAboutFunctionRefs[warningKey]) {
                didWarnAboutFunctionRefs[warningKey] = true;
                error("Function components cannot be given refs. Attempts to access this ref will fail. Did you mean to use React.forwardRef()?%s", info);
            }
        }
        if (typeof Component.getDerivedStateFromProps === "function") {
            var _componentName2 = getComponentName(Component) || "Unknown";
            if (!didWarnAboutGetDerivedStateOnFunctionComponent[_componentName2]) {
                error("%s: Function components do not support getDerivedStateFromProps.", _componentName2);
                didWarnAboutGetDerivedStateOnFunctionComponent[_componentName2] = true;
            }
        }
        if (typeof Component.contextType === "object" && Component.contextType !== null) {
            var _componentName3 = getComponentName(Component) || "Unknown";
            if (!didWarnAboutContextTypeOnFunctionComponent[_componentName3]) {
                error("%s: Function components do not support contextType.", _componentName3);
                didWarnAboutContextTypeOnFunctionComponent[_componentName3] = true;
            }
        }
    }
    var SUSPENDED_MARKER = {
        dehydrated: null,
        retryTime: NoWork
    };
    function shouldRemainOnFallback(suspenseContext, current, workInProgress) {
        // If the context is telling us that we should show a fallback, and we're not
        // already showing content, then we should show the fallback instead.
        return hasSuspenseContext(suspenseContext, ForceSuspenseFallback) && (current === null || current.memoizedState !== null);
    }
    function updateSuspenseComponent(current, workInProgress, renderExpirationTime) {
        var mode = workInProgress.mode;
        var nextProps = workInProgress.pendingProps; // This is used by DevTools to force a boundary to suspend.
        if (shouldSuspend(workInProgress)) workInProgress.effectTag |= DidCapture;
        var suspenseContext = suspenseStackCursor.current;
        var nextDidTimeout = false;
        var didSuspend = (workInProgress.effectTag & DidCapture) !== NoEffect;
        if (didSuspend || shouldRemainOnFallback(suspenseContext, current)) {
            // Something in this boundary's subtree already suspended. Switch to
            // rendering the fallback children.
            nextDidTimeout = true;
            workInProgress.effectTag &= ~DidCapture;
        } else {
            // Attempting the main content
            if (current === null || current.memoizedState !== null) // This is a new mount or this boundary is already showing a fallback state.
            // Mark this subtree context as having at least one invisible parent that could
            // handle the fallback state.
            // Boundaries without fallbacks or should be avoided are not considered since
            // they cannot handle preferred fallback states.
            {
                if (nextProps.fallback !== undefined && nextProps.unstable_avoidThisFallback !== true) suspenseContext = addSubtreeSuspenseContext(suspenseContext, InvisibleParentSuspenseContext);
            }
        }
        suspenseContext = setDefaultShallowSuspenseContext(suspenseContext);
        pushSuspenseContext(workInProgress, suspenseContext); // This next part is a bit confusing. If the children timeout, we switch to
        // showing the fallback children in place of the "primary" children.
        // However, we don't want to delete the primary children because then their
        // state will be lost (both the React state and the host state, e.g.
        // uncontrolled form inputs). Instead we keep them mounted and hide them.
        // Both the fallback children AND the primary children are rendered at the
        // same time. Once the primary children are un-suspended, we can delete
        // the fallback children — don't need to preserve their state.
        //
        // The two sets of children are siblings in the host environment, but
        // semantically, for purposes of reconciliation, they are two separate sets.
        // So we store them using two fragment fibers.
        //
        // However, we want to avoid allocating extra fibers for every placeholder.
        // They're only necessary when the children time out, because that's the
        // only time when both sets are mounted.
        //
        // So, the extra fragment fibers are only used if the children time out.
        // Otherwise, we render the primary children directly. This requires some
        // custom reconciliation logic to preserve the state of the primary
        // children. It's essentially a very basic form of re-parenting.
        if (current === null) {
            // If we're currently hydrating, try to hydrate this boundary.
            // But only if this has a fallback.
            if (nextProps.fallback !== undefined) tryToClaimNextHydratableInstance(workInProgress); // This could've been a dehydrated suspense component.
             // This is the initial mount. This branch is pretty simple because there's
            // no previous state that needs to be preserved.
            if (nextDidTimeout) {
                // Mount separate fragments for primary and fallback children.
                var nextFallbackChildren = nextProps.fallback;
                var primaryChildFragment = createFiberFromFragment(null, mode, NoWork, null);
                primaryChildFragment.return = workInProgress;
                if ((workInProgress.mode & BlockingMode) === NoMode) {
                    // Outside of blocking mode, we commit the effects from the
                    // partially completed, timed-out tree, too.
                    var progressedState = workInProgress.memoizedState;
                    var progressedPrimaryChild = progressedState !== null ? workInProgress.child.child : workInProgress.child;
                    primaryChildFragment.child = progressedPrimaryChild;
                    var progressedChild = progressedPrimaryChild;
                    while(progressedChild !== null){
                        progressedChild.return = primaryChildFragment;
                        progressedChild = progressedChild.sibling;
                    }
                }
                var fallbackChildFragment = createFiberFromFragment(nextFallbackChildren, mode, renderExpirationTime, null);
                fallbackChildFragment.return = workInProgress;
                primaryChildFragment.sibling = fallbackChildFragment; // Skip the primary children, and continue working on the
                // fallback children.
                workInProgress.memoizedState = SUSPENDED_MARKER;
                workInProgress.child = primaryChildFragment;
                return fallbackChildFragment;
            } else {
                // Mount the primary children without an intermediate fragment fiber.
                var nextPrimaryChildren = nextProps.children;
                workInProgress.memoizedState = null;
                return workInProgress.child = mountChildFibers(workInProgress, null, nextPrimaryChildren, renderExpirationTime);
            }
        } else {
            // This is an update. This branch is more complicated because we need to
            // ensure the state of the primary children is preserved.
            var prevState = current.memoizedState;
            if (prevState !== null) {
                // wrapped in a fragment fiber.
                var currentPrimaryChildFragment = current.child;
                var currentFallbackChildFragment = currentPrimaryChildFragment.sibling;
                if (nextDidTimeout) {
                    // Still timed out. Reuse the current primary children by cloning
                    // its fragment. We're going to skip over these entirely.
                    var _nextFallbackChildren2 = nextProps.fallback;
                    var _primaryChildFragment2 = createWorkInProgress(currentPrimaryChildFragment, currentPrimaryChildFragment.pendingProps);
                    _primaryChildFragment2.return = workInProgress;
                    if ((workInProgress.mode & BlockingMode) === NoMode) {
                        // Outside of blocking mode, we commit the effects from the
                        // partially completed, timed-out tree, too.
                        var _progressedState = workInProgress.memoizedState;
                        var _progressedPrimaryChild = _progressedState !== null ? workInProgress.child.child : workInProgress.child;
                        if (_progressedPrimaryChild !== currentPrimaryChildFragment.child) {
                            _primaryChildFragment2.child = _progressedPrimaryChild;
                            var _progressedChild2 = _progressedPrimaryChild;
                            while(_progressedChild2 !== null){
                                _progressedChild2.return = _primaryChildFragment2;
                                _progressedChild2 = _progressedChild2.sibling;
                            }
                        }
                    } // Because primaryChildFragment is a new fiber that we're inserting as the
                    // parent of a new tree, we need to set its treeBaseDuration.
                    if (workInProgress.mode & ProfileMode) {
                        // treeBaseDuration is the sum of all the child tree base durations.
                        var _treeBaseDuration = 0;
                        var _hiddenChild = _primaryChildFragment2.child;
                        while(_hiddenChild !== null){
                            _treeBaseDuration += _hiddenChild.treeBaseDuration;
                            _hiddenChild = _hiddenChild.sibling;
                        }
                        _primaryChildFragment2.treeBaseDuration = _treeBaseDuration;
                    } // Clone the fallback child fragment, too. These we'll continue
                    // working on.
                    var _fallbackChildFragment2 = createWorkInProgress(currentFallbackChildFragment, _nextFallbackChildren2);
                    _fallbackChildFragment2.return = workInProgress;
                    _primaryChildFragment2.sibling = _fallbackChildFragment2;
                    _primaryChildFragment2.childExpirationTime = NoWork; // Skip the primary children, and continue working on the
                    // fallback children.
                    workInProgress.memoizedState = SUSPENDED_MARKER;
                    workInProgress.child = _primaryChildFragment2;
                    return _fallbackChildFragment2;
                } else {
                    // No longer suspended. Switch back to showing the primary children,
                    // and remove the intermediate fragment fiber.
                    var _nextPrimaryChildren = nextProps.children;
                    var currentPrimaryChild = currentPrimaryChildFragment.child;
                    var primaryChild = reconcileChildFibers(workInProgress, currentPrimaryChild, _nextPrimaryChildren, renderExpirationTime); // If this render doesn't suspend, we need to delete the fallback
                    // children. Wait until the complete phase, after we've confirmed the
                    // fallback is no longer needed.
                    // TODO: Would it be better to store the fallback fragment on
                    // the stateNode?
                    // Continue rendering the children, like we normally do.
                    workInProgress.memoizedState = null;
                    return workInProgress.child = primaryChild;
                }
            } else {
                // The current tree has not already timed out. That means the primary
                // children are not wrapped in a fragment fiber.
                var _currentPrimaryChild = current.child;
                if (nextDidTimeout) {
                    // Timed out. Wrap the children in a fragment fiber to keep them
                    // separate from the fallback children.
                    var _nextFallbackChildren3 = nextProps.fallback;
                    var _primaryChildFragment3 = createFiberFromFragment(// going to render this fragment.
                    null, mode, NoWork, null);
                    _primaryChildFragment3.return = workInProgress;
                    _primaryChildFragment3.child = _currentPrimaryChild;
                    if (_currentPrimaryChild !== null) _currentPrimaryChild.return = _primaryChildFragment3;
                     // Even though we're creating a new fiber, there are no new children,
                    // because we're reusing an already mounted tree. So we don't need to
                    // schedule a placement.
                    // primaryChildFragment.effectTag |= Placement;
                    if ((workInProgress.mode & BlockingMode) === NoMode) {
                        // Outside of blocking mode, we commit the effects from the
                        // partially completed, timed-out tree, too.
                        var _progressedState2 = workInProgress.memoizedState;
                        var _progressedPrimaryChild2 = _progressedState2 !== null ? workInProgress.child.child : workInProgress.child;
                        _primaryChildFragment3.child = _progressedPrimaryChild2;
                        var _progressedChild3 = _progressedPrimaryChild2;
                        while(_progressedChild3 !== null){
                            _progressedChild3.return = _primaryChildFragment3;
                            _progressedChild3 = _progressedChild3.sibling;
                        }
                    } // Because primaryChildFragment is a new fiber that we're inserting as the
                    // parent of a new tree, we need to set its treeBaseDuration.
                    if (workInProgress.mode & ProfileMode) {
                        // treeBaseDuration is the sum of all the child tree base durations.
                        var _treeBaseDuration2 = 0;
                        var _hiddenChild2 = _primaryChildFragment3.child;
                        while(_hiddenChild2 !== null){
                            _treeBaseDuration2 += _hiddenChild2.treeBaseDuration;
                            _hiddenChild2 = _hiddenChild2.sibling;
                        }
                        _primaryChildFragment3.treeBaseDuration = _treeBaseDuration2;
                    } // Create a fragment from the fallback children, too.
                    var _fallbackChildFragment3 = createFiberFromFragment(_nextFallbackChildren3, mode, renderExpirationTime, null);
                    _fallbackChildFragment3.return = workInProgress;
                    _primaryChildFragment3.sibling = _fallbackChildFragment3;
                    _fallbackChildFragment3.effectTag |= Placement;
                    _primaryChildFragment3.childExpirationTime = NoWork; // Skip the primary children, and continue working on the
                    // fallback children.
                    workInProgress.memoizedState = SUSPENDED_MARKER;
                    workInProgress.child = _primaryChildFragment3;
                    return _fallbackChildFragment3;
                } else {
                    // Still haven't timed out. Continue rendering the children, like we
                    // normally do.
                    workInProgress.memoizedState = null;
                    var _nextPrimaryChildren2 = nextProps.children;
                    return workInProgress.child = reconcileChildFibers(workInProgress, _currentPrimaryChild, _nextPrimaryChildren2, renderExpirationTime);
                }
            }
        }
    }
    function scheduleWorkOnFiber(fiber, renderExpirationTime) {
        if (fiber.expirationTime < renderExpirationTime) fiber.expirationTime = renderExpirationTime;
        var alternate = fiber.alternate;
        if (alternate !== null && alternate.expirationTime < renderExpirationTime) alternate.expirationTime = renderExpirationTime;
        scheduleWorkOnParentPath(fiber.return, renderExpirationTime);
    }
    function propagateSuspenseContextChange(workInProgress, firstChild, renderExpirationTime) {
        // Mark any Suspense boundaries with fallbacks as having work to do.
        // If they were previously forced into fallbacks, they may now be able
        // to unblock.
        var node = firstChild;
        while(node !== null){
            if (node.tag === SuspenseComponent) {
                var state = node.memoizedState;
                if (state !== null) scheduleWorkOnFiber(node, renderExpirationTime);
            } else if (node.tag === SuspenseListComponent) // If the tail is hidden there might not be an Suspense boundaries
            // to schedule work on. In this case we have to schedule it on the
            // list itself.
            // We don't have to traverse to the children of the list since
            // the list will propagate the change when it rerenders.
            scheduleWorkOnFiber(node, renderExpirationTime);
            else if (node.child !== null) {
                node.child.return = node;
                node = node.child;
                continue;
            }
            if (node === workInProgress) return;
            while(node.sibling === null){
                if (node.return === null || node.return === workInProgress) return;
                node = node.return;
            }
            node.sibling.return = node.return;
            node = node.sibling;
        }
    }
    function findLastContentRow(firstChild) {
        // This is going to find the last row among these children that is already
        // showing content on the screen, as opposed to being in fallback state or
        // new. If a row has multiple Suspense boundaries, any of them being in the
        // fallback state, counts as the whole row being in a fallback state.
        // Note that the "rows" will be workInProgress, but any nested children
        // will still be current since we haven't rendered them yet. The mounted
        // order may not be the same as the new order. We use the new order.
        var row = firstChild;
        var lastContentRow = null;
        while(row !== null){
            var currentRow = row.alternate; // New rows can't be content rows.
            if (currentRow !== null && findFirstSuspended(currentRow) === null) lastContentRow = row;
            row = row.sibling;
        }
        return lastContentRow;
    }
    function validateRevealOrder(revealOrder) {
        if (revealOrder !== undefined && revealOrder !== "forwards" && revealOrder !== "backwards" && revealOrder !== "together" && !didWarnAboutRevealOrder[revealOrder]) {
            didWarnAboutRevealOrder[revealOrder] = true;
            if (typeof revealOrder === "string") switch(revealOrder.toLowerCase()){
                case "together":
                case "forwards":
                case "backwards":
                    error('"%s" is not a valid value for revealOrder on <SuspenseList />. Use lowercase "%s" instead.', revealOrder, revealOrder.toLowerCase());
                    break;
                case "forward":
                case "backward":
                    error('"%s" is not a valid value for revealOrder on <SuspenseList />. React uses the -s suffix in the spelling. Use "%ss" instead.', revealOrder, revealOrder.toLowerCase());
                    break;
                default:
                    error('"%s" is not a supported revealOrder on <SuspenseList />. Did you mean "together", "forwards" or "backwards"?', revealOrder);
                    break;
            }
            else error('%s is not a supported value for revealOrder on <SuspenseList />. Did you mean "together", "forwards" or "backwards"?', revealOrder);
        }
    }
    function validateTailOptions(tailMode, revealOrder) {
        if (tailMode !== undefined && !didWarnAboutTailOptions[tailMode]) {
            if (tailMode !== "collapsed" && tailMode !== "hidden") {
                didWarnAboutTailOptions[tailMode] = true;
                error('"%s" is not a supported value for tail on <SuspenseList />. Did you mean "collapsed" or "hidden"?', tailMode);
            } else if (revealOrder !== "forwards" && revealOrder !== "backwards") {
                didWarnAboutTailOptions[tailMode] = true;
                error('<SuspenseList tail="%s" /> is only valid if revealOrder is "forwards" or "backwards". Did you mean to specify revealOrder="forwards"?', tailMode);
            }
        }
    }
    function validateSuspenseListNestedChild(childSlot, index) {
        var isArray = Array.isArray(childSlot);
        var isIterable = !isArray && typeof getIteratorFn(childSlot) === "function";
        if (isArray || isIterable) {
            var type = isArray ? "array" : "iterable";
            error("A nested %s was passed to row #%s in <SuspenseList />. Wrap it in an additional SuspenseList to configure its revealOrder: <SuspenseList revealOrder=...> ... <SuspenseList revealOrder=...>{%s}</SuspenseList> ... </SuspenseList>", type, index, type);
            return false;
        }
        return true;
    }
    function validateSuspenseListChildren(children, revealOrder) {
        if ((revealOrder === "forwards" || revealOrder === "backwards") && children !== undefined && children !== null && children !== false) {
            if (Array.isArray(children)) for(var i = 0; i < children.length; i++){
                if (!validateSuspenseListNestedChild(children[i], i)) return;
            }
            else {
                var iteratorFn = getIteratorFn(children);
                if (typeof iteratorFn === "function") {
                    var childrenIterator = iteratorFn.call(children);
                    if (childrenIterator) {
                        var step = childrenIterator.next();
                        var _i = 0;
                        for(; !step.done; step = childrenIterator.next()){
                            if (!validateSuspenseListNestedChild(step.value, _i)) return;
                            _i++;
                        }
                    }
                } else error('A single row was passed to a <SuspenseList revealOrder="%s" />. This is not useful since it needs multiple rows. Did you mean to pass multiple children or an array?', revealOrder);
            }
        }
    }
    function initSuspenseListRenderState(workInProgress, isBackwards, tail, lastContentRow, tailMode, lastEffectBeforeRendering) {
        var renderState = workInProgress.memoizedState;
        if (renderState === null) workInProgress.memoizedState = {
            isBackwards: isBackwards,
            rendering: null,
            renderingStartTime: 0,
            last: lastContentRow,
            tail: tail,
            tailExpiration: 0,
            tailMode: tailMode,
            lastEffect: lastEffectBeforeRendering
        };
        else {
            // We can reuse the existing object from previous renders.
            renderState.isBackwards = isBackwards;
            renderState.rendering = null;
            renderState.renderingStartTime = 0;
            renderState.last = lastContentRow;
            renderState.tail = tail;
            renderState.tailExpiration = 0;
            renderState.tailMode = tailMode;
            renderState.lastEffect = lastEffectBeforeRendering;
        }
    } // This can end up rendering this component multiple passes.
    // The first pass splits the children fibers into two sets. A head and tail.
    // We first render the head. If anything is in fallback state, we do another
    // pass through beginWork to rerender all children (including the tail) with
    // the force suspend context. If the first render didn't have anything in
    // in fallback state. Then we render each row in the tail one-by-one.
    // That happens in the completeWork phase without going back to beginWork.
    function updateSuspenseListComponent(current, workInProgress, renderExpirationTime) {
        var nextProps = workInProgress.pendingProps;
        var revealOrder = nextProps.revealOrder;
        var tailMode = nextProps.tail;
        var newChildren = nextProps.children;
        validateRevealOrder(revealOrder);
        validateTailOptions(tailMode, revealOrder);
        validateSuspenseListChildren(newChildren, revealOrder);
        reconcileChildren(current, workInProgress, newChildren, renderExpirationTime);
        var suspenseContext = suspenseStackCursor.current;
        var shouldForceFallback = hasSuspenseContext(suspenseContext, ForceSuspenseFallback);
        if (shouldForceFallback) {
            suspenseContext = setShallowSuspenseContext(suspenseContext, ForceSuspenseFallback);
            workInProgress.effectTag |= DidCapture;
        } else {
            var didSuspendBefore = current !== null && (current.effectTag & DidCapture) !== NoEffect;
            if (didSuspendBefore) // If we previously forced a fallback, we need to schedule work
            // on any nested boundaries to let them know to try to render
            // again. This is the same as context updating.
            propagateSuspenseContextChange(workInProgress, workInProgress.child, renderExpirationTime);
            suspenseContext = setDefaultShallowSuspenseContext(suspenseContext);
        }
        pushSuspenseContext(workInProgress, suspenseContext);
        if ((workInProgress.mode & BlockingMode) === NoMode) // Outside of blocking mode, SuspenseList doesn't work so we just
        // use make it a noop by treating it as the default revealOrder.
        workInProgress.memoizedState = null;
        else switch(revealOrder){
            case "forwards":
                var lastContentRow = findLastContentRow(workInProgress.child);
                var tail;
                if (lastContentRow === null) {
                    // The whole list is part of the tail.
                    // TODO: We could fast path by just rendering the tail now.
                    tail = workInProgress.child;
                    workInProgress.child = null;
                } else {
                    // Disconnect the tail rows after the content row.
                    // We're going to render them separately later.
                    tail = lastContentRow.sibling;
                    lastContentRow.sibling = null;
                }
                initSuspenseListRenderState(workInProgress, false, tail, lastContentRow, tailMode, workInProgress.lastEffect);
                break;
            case "backwards":
                // We're going to find the first row that has existing content.
                // At the same time we're going to reverse the list of everything
                // we pass in the meantime. That's going to be our tail in reverse
                // order.
                var _tail = null;
                var row = workInProgress.child;
                workInProgress.child = null;
                while(row !== null){
                    var currentRow = row.alternate; // New rows can't be content rows.
                    if (currentRow !== null && findFirstSuspended(currentRow) === null) {
                        // This is the beginning of the main content.
                        workInProgress.child = row;
                        break;
                    }
                    var nextRow = row.sibling;
                    row.sibling = _tail;
                    _tail = row;
                    row = nextRow;
                } // TODO: If workInProgress.child is null, we can continue on the tail immediately.
                initSuspenseListRenderState(workInProgress, true, _tail, null, tailMode, workInProgress.lastEffect);
                break;
            case "together":
                initSuspenseListRenderState(workInProgress, false, null, null, undefined, workInProgress.lastEffect);
                break;
            default:
                // The default reveal order is the same as not having
                // a boundary.
                workInProgress.memoizedState = null;
        }
        return workInProgress.child;
    }
    function updatePortalComponent(current, workInProgress, renderExpirationTime) {
        pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo);
        var nextChildren = workInProgress.pendingProps;
        if (current === null) // Portals are special because we don't append the children during mount
        // but at commit. Therefore we need to track insertions which the normal
        // flow doesn't do during mount. This doesn't happen at the root because
        // the root always starts with a "current" with a null child.
        // TODO: Consider unifying this with how the root works.
        workInProgress.child = reconcileChildFibers(workInProgress, null, nextChildren, renderExpirationTime);
        else reconcileChildren(current, workInProgress, nextChildren, renderExpirationTime);
        return workInProgress.child;
    }
    function updateContextProvider(current, workInProgress, renderExpirationTime) {
        var providerType = workInProgress.type;
        var context = providerType._context;
        var newProps = workInProgress.pendingProps;
        var oldProps = workInProgress.memoizedProps;
        var newValue = newProps.value;
        var providerPropTypes = workInProgress.type.propTypes;
        if (providerPropTypes) checkPropTypes(providerPropTypes, newProps, "prop", "Context.Provider", getCurrentFiberStackInDev);
        pushProvider(workInProgress, newValue);
        if (oldProps !== null) {
            var oldValue = oldProps.value;
            var changedBits = calculateChangedBits(context, newValue, oldValue);
            if (changedBits === 0) {
                // No change. Bailout early if children are the same.
                if (oldProps.children === newProps.children && !hasContextChanged()) return bailoutOnAlreadyFinishedWork(current, workInProgress, renderExpirationTime);
            } else // The context value changed. Search for matching consumers and schedule
            // them to update.
            propagateContextChange(workInProgress, context, changedBits, renderExpirationTime);
        }
        var newChildren = newProps.children;
        reconcileChildren(current, workInProgress, newChildren, renderExpirationTime);
        return workInProgress.child;
    }
    var hasWarnedAboutUsingContextAsConsumer = false;
    function updateContextConsumer(current, workInProgress, renderExpirationTime) {
        var context = workInProgress.type; // The logic below for Context differs depending on PROD or DEV mode. In
        if (context._context === undefined) {
            // This may be because it's a Context (rather than a Consumer).
            // Or it may be because it's older React where they're the same thing.
            // We only want to warn if we're sure it's a new React.
            if (context !== context.Consumer) {
                if (!hasWarnedAboutUsingContextAsConsumer) {
                    hasWarnedAboutUsingContextAsConsumer = true;
                    error("Rendering <Context> directly is not supported and will be removed in a future major release. Did you mean to render <Context.Consumer> instead?");
                }
            }
        } else context = context._context;
        var newProps = workInProgress.pendingProps;
        var render = newProps.children;
        if (typeof render !== "function") error("A context consumer was rendered with multiple children, or a child that isn't a function. A context consumer expects a single child that is a function. If you did pass a function, make sure there is no trailing or leading whitespace around it.");
        prepareToReadContext(workInProgress, renderExpirationTime);
        var newValue = readContext(context, newProps.unstable_observedBits);
        var newChildren;
        ReactCurrentOwner$1.current = workInProgress;
        setIsRendering(true);
        newChildren = render(newValue);
        setIsRendering(false);
        workInProgress.effectTag |= PerformedWork;
        reconcileChildren(current, workInProgress, newChildren, renderExpirationTime);
        return workInProgress.child;
    }
    function markWorkInProgressReceivedUpdate() {
        didReceiveUpdate = true;
    }
    function bailoutOnAlreadyFinishedWork(current, workInProgress, renderExpirationTime) {
        cancelWorkTimer(workInProgress);
        if (current !== null) // Reuse previous dependencies
        workInProgress.dependencies = current.dependencies;
        // Don't update "base" render times for bailouts.
        stopProfilerTimerIfRunning();
        var updateExpirationTime = workInProgress.expirationTime;
        if (updateExpirationTime !== NoWork) markUnprocessedUpdateTime(updateExpirationTime);
         // Check if the children have any pending work.
        var childExpirationTime = workInProgress.childExpirationTime;
        if (childExpirationTime < renderExpirationTime) // The children don't have any work either. We can skip them.
        // TODO: Once we add back resuming, we should check if the children are
        // a work-in-progress set. If so, we need to transfer their effects.
        return null;
        else {
            // This fiber doesn't have work, but its subtree does. Clone the child
            // fibers and continue.
            cloneChildFibers(current, workInProgress);
            return workInProgress.child;
        }
    }
    function remountFiber(current, oldWorkInProgress, newWorkInProgress) {
        var returnFiber = oldWorkInProgress.return;
        if (returnFiber === null) throw new Error("Cannot swap the root fiber.");
         // Disconnect from the old current.
        // It will get deleted.
        current.alternate = null;
        oldWorkInProgress.alternate = null; // Connect to the new tree.
        newWorkInProgress.index = oldWorkInProgress.index;
        newWorkInProgress.sibling = oldWorkInProgress.sibling;
        newWorkInProgress.return = oldWorkInProgress.return;
        newWorkInProgress.ref = oldWorkInProgress.ref; // Replace the child/sibling pointers above it.
        if (oldWorkInProgress === returnFiber.child) returnFiber.child = newWorkInProgress;
        else {
            var prevSibling = returnFiber.child;
            if (prevSibling === null) throw new Error("Expected parent to have a child.");
            while(prevSibling.sibling !== oldWorkInProgress){
                prevSibling = prevSibling.sibling;
                if (prevSibling === null) throw new Error("Expected to find the previous sibling.");
            }
            prevSibling.sibling = newWorkInProgress;
        } // Delete the old fiber and place the new one.
        // Since the old fiber is disconnected, we have to schedule it manually.
        var last = returnFiber.lastEffect;
        if (last !== null) {
            last.nextEffect = current;
            returnFiber.lastEffect = current;
        } else returnFiber.firstEffect = returnFiber.lastEffect = current;
        current.nextEffect = null;
        current.effectTag = Deletion;
        newWorkInProgress.effectTag |= Placement; // Restart work from the new fiber.
        return newWorkInProgress;
    }
    function beginWork(current, workInProgress, renderExpirationTime) {
        var updateExpirationTime = workInProgress.expirationTime;
        if (workInProgress._debugNeedsRemount && current !== null) // This will restart the begin phase with a new fiber.
        return remountFiber(current, workInProgress, createFiberFromTypeAndProps(workInProgress.type, workInProgress.key, workInProgress.pendingProps, workInProgress._debugOwner || null, workInProgress.mode, workInProgress.expirationTime));
        if (current !== null) {
            var oldProps = current.memoizedProps;
            var newProps = workInProgress.pendingProps;
            if (oldProps !== newProps || hasContextChanged() || workInProgress.type !== current.type) // If props or context changed, mark the fiber as having performed work.
            // This may be unset if the props are determined to be equal later (memo).
            didReceiveUpdate = true;
            else if (updateExpirationTime < renderExpirationTime) {
                didReceiveUpdate = false; // This fiber does not have any pending work. Bailout without entering
                // the begin phase. There's still some bookkeeping we that needs to be done
                // in this optimized path, mostly pushing stuff onto the stack.
                switch(workInProgress.tag){
                    case HostRoot:
                        pushHostRootContext(workInProgress);
                        resetHydrationState();
                        break;
                    case HostComponent:
                        pushHostContext(workInProgress);
                        if (workInProgress.mode & ConcurrentMode && renderExpirationTime !== Never && shouldDeprioritizeSubtree(workInProgress.type, newProps)) {
                            markSpawnedWork(Never);
                            workInProgress.expirationTime = workInProgress.childExpirationTime = Never;
                            return null;
                        }
                        break;
                    case ClassComponent:
                        var Component = workInProgress.type;
                        if (isContextProvider(Component)) pushContextProvider(workInProgress);
                        break;
                    case HostPortal:
                        pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo);
                        break;
                    case ContextProvider:
                        var newValue = workInProgress.memoizedProps.value;
                        pushProvider(workInProgress, newValue);
                        break;
                    case Profiler:
                        // Profiler should only call onRender when one of its descendants actually rendered.
                        var hasChildWork = workInProgress.childExpirationTime >= renderExpirationTime;
                        if (hasChildWork) workInProgress.effectTag |= Update;
                        break;
                    case SuspenseComponent:
                        var state = workInProgress.memoizedState;
                        if (state !== null) {
                            // whether to retry the primary children, or to skip over it and
                            // go straight to the fallback. Check the priority of the primary
                            // child fragment.
                            var primaryChildFragment = workInProgress.child;
                            var primaryChildExpirationTime = primaryChildFragment.childExpirationTime;
                            if (primaryChildExpirationTime !== NoWork && primaryChildExpirationTime >= renderExpirationTime) // The primary children have pending work. Use the normal path
                            // to attempt to render the primary children again.
                            return updateSuspenseComponent(current, workInProgress, renderExpirationTime);
                            else {
                                pushSuspenseContext(workInProgress, setDefaultShallowSuspenseContext(suspenseStackCursor.current)); // The primary children do not have pending work with sufficient
                                // priority. Bailout.
                                var child = bailoutOnAlreadyFinishedWork(current, workInProgress, renderExpirationTime);
                                if (child !== null) // The fallback children have pending work. Skip over the
                                // primary children and work on the fallback.
                                return child.sibling;
                                else return null;
                            }
                        } else pushSuspenseContext(workInProgress, setDefaultShallowSuspenseContext(suspenseStackCursor.current));
                        break;
                    case SuspenseListComponent:
                        var didSuspendBefore = (current.effectTag & DidCapture) !== NoEffect;
                        var _hasChildWork = workInProgress.childExpirationTime >= renderExpirationTime;
                        if (didSuspendBefore) {
                            if (_hasChildWork) // If something was in fallback state last time, and we have all the
                            // same children then we're still in progressive loading state.
                            // Something might get unblocked by state updates or retries in the
                            // tree which will affect the tail. So we need to use the normal
                            // path to compute the correct tail.
                            return updateSuspenseListComponent(current, workInProgress, renderExpirationTime);
                             // If none of the children had any work, that means that none of
                            // them got retried so they'll still be blocked in the same way
                            // as before. We can fast bail out.
                            workInProgress.effectTag |= DidCapture;
                        } // If nothing suspended before and we're rendering the same children,
                        // then the tail doesn't matter. Anything new that suspends will work
                        // in the "together" mode, so we can continue from the state we had.
                        var renderState = workInProgress.memoizedState;
                        if (renderState !== null) {
                            // Reset to the "together" mode in case we've started a different
                            // update in the past but didn't complete it.
                            renderState.rendering = null;
                            renderState.tail = null;
                        }
                        pushSuspenseContext(workInProgress, suspenseStackCursor.current);
                        if (_hasChildWork) break;
                        else // If none of the children had any work, that means that none of
                        // them got retried so they'll still be blocked in the same way
                        // as before. We can fast bail out.
                        return null;
                }
                return bailoutOnAlreadyFinishedWork(current, workInProgress, renderExpirationTime);
            } else // An update was scheduled on this fiber, but there are no new props
            // nor legacy context. Set this to false. If an update queue or context
            // consumer produces a changed value, it will set this to true. Otherwise,
            // the component will assume the children have not changed and bail out.
            didReceiveUpdate = false;
        } else didReceiveUpdate = false;
         // Before entering the begin phase, clear pending update priority.
        // TODO: This assumes that we're about to evaluate the component and process
        // the update queue. However, there's an exception: SimpleMemoComponent
        // sometimes bails out later in the begin phase. This indicates that we should
        // move this assignment out of the common path and into each branch.
        workInProgress.expirationTime = NoWork;
        switch(workInProgress.tag){
            case IndeterminateComponent:
                return mountIndeterminateComponent(current, workInProgress, workInProgress.type, renderExpirationTime);
            case LazyComponent:
                var elementType = workInProgress.elementType;
                return mountLazyComponent(current, workInProgress, elementType, updateExpirationTime, renderExpirationTime);
            case FunctionComponent:
                var _Component = workInProgress.type;
                var unresolvedProps = workInProgress.pendingProps;
                var resolvedProps = workInProgress.elementType === _Component ? unresolvedProps : resolveDefaultProps(_Component, unresolvedProps);
                return updateFunctionComponent(current, workInProgress, _Component, resolvedProps, renderExpirationTime);
            case ClassComponent:
                var _Component2 = workInProgress.type;
                var _unresolvedProps = workInProgress.pendingProps;
                var _resolvedProps = workInProgress.elementType === _Component2 ? _unresolvedProps : resolveDefaultProps(_Component2, _unresolvedProps);
                return updateClassComponent(current, workInProgress, _Component2, _resolvedProps, renderExpirationTime);
            case HostRoot:
                return updateHostRoot(current, workInProgress, renderExpirationTime);
            case HostComponent:
                return updateHostComponent(current, workInProgress, renderExpirationTime);
            case HostText:
                return updateHostText(current, workInProgress);
            case SuspenseComponent:
                return updateSuspenseComponent(current, workInProgress, renderExpirationTime);
            case HostPortal:
                return updatePortalComponent(current, workInProgress, renderExpirationTime);
            case ForwardRef:
                var type = workInProgress.type;
                var _unresolvedProps2 = workInProgress.pendingProps;
                var _resolvedProps2 = workInProgress.elementType === type ? _unresolvedProps2 : resolveDefaultProps(type, _unresolvedProps2);
                return updateForwardRef(current, workInProgress, type, _resolvedProps2, renderExpirationTime);
            case Fragment:
                return updateFragment(current, workInProgress, renderExpirationTime);
            case Mode:
                return updateMode(current, workInProgress, renderExpirationTime);
            case Profiler:
                return updateProfiler(current, workInProgress, renderExpirationTime);
            case ContextProvider:
                return updateContextProvider(current, workInProgress, renderExpirationTime);
            case ContextConsumer:
                return updateContextConsumer(current, workInProgress, renderExpirationTime);
            case MemoComponent:
                var _type2 = workInProgress.type;
                var _unresolvedProps3 = workInProgress.pendingProps; // Resolve outer props first, then resolve inner props.
                var _resolvedProps3 = resolveDefaultProps(_type2, _unresolvedProps3);
                if (workInProgress.type !== workInProgress.elementType) {
                    var outerPropTypes = _type2.propTypes;
                    if (outerPropTypes) checkPropTypes(outerPropTypes, _resolvedProps3, "prop", getComponentName(_type2), getCurrentFiberStackInDev);
                }
                _resolvedProps3 = resolveDefaultProps(_type2.type, _resolvedProps3);
                return updateMemoComponent(current, workInProgress, _type2, _resolvedProps3, updateExpirationTime, renderExpirationTime);
            case SimpleMemoComponent:
                return updateSimpleMemoComponent(current, workInProgress, workInProgress.type, workInProgress.pendingProps, updateExpirationTime, renderExpirationTime);
            case IncompleteClassComponent:
                var _Component3 = workInProgress.type;
                var _unresolvedProps4 = workInProgress.pendingProps;
                var _resolvedProps4 = workInProgress.elementType === _Component3 ? _unresolvedProps4 : resolveDefaultProps(_Component3, _unresolvedProps4);
                return mountIncompleteClassComponent(current, workInProgress, _Component3, _resolvedProps4, renderExpirationTime);
            case SuspenseListComponent:
                return updateSuspenseListComponent(current, workInProgress, renderExpirationTime);
        }
        throw Error("Unknown unit of work tag (" + workInProgress.tag + "). This error is likely caused by a bug in React. Please file an issue.");
    }
    function markUpdate(workInProgress) {
        // Tag the fiber with an update effect. This turns a Placement into
        // a PlacementAndUpdate.
        workInProgress.effectTag |= Update;
    }
    function markRef$1(workInProgress) {
        workInProgress.effectTag |= Ref;
    }
    var appendAllChildren;
    var updateHostContainer;
    var updateHostComponent$1;
    var updateHostText$1;
    // Mutation mode
    appendAllChildren = function(parent, workInProgress, needsVisibilityToggle, isHidden) {
        // We only have the top Fiber that was created but we need recurse down its
        // children to find all the terminal nodes.
        var node = workInProgress.child;
        while(node !== null){
            if (node.tag === HostComponent || node.tag === HostText) appendInitialChild(parent, node.stateNode);
            else if (node.tag === HostPortal) ;
            else if (node.child !== null) {
                node.child.return = node;
                node = node.child;
                continue;
            }
            if (node === workInProgress) return;
            while(node.sibling === null){
                if (node.return === null || node.return === workInProgress) return;
                node = node.return;
            }
            node.sibling.return = node.return;
            node = node.sibling;
        }
    };
    updateHostContainer = function(workInProgress) {};
    updateHostComponent$1 = function(current, workInProgress, type, newProps, rootContainerInstance) {
        // If we have an alternate, that means this is an update and we need to
        // schedule a side-effect to do the updates.
        var oldProps = current.memoizedProps;
        if (oldProps === newProps) // In mutation mode, this is sufficient for a bailout because
        // we won't touch this node even if children changed.
        return;
         // If we get updated because one of our children updated, we don't
        // have newProps so we'll have to reuse them.
        // TODO: Split the update API as separate for the props vs. children.
        // Even better would be if children weren't special cased at all tho.
        var instance = workInProgress.stateNode;
        var currentHostContext = getHostContext(); // TODO: Experiencing an error where oldProps is null. Suggests a host
        // component is hitting the resume path. Figure out why. Possibly
        // related to `hidden`.
        var updatePayload = prepareUpdate(instance, type, oldProps, newProps, rootContainerInstance, currentHostContext); // TODO: Type this specific to this type of component.
        workInProgress.updateQueue = updatePayload; // If the update payload indicates that there is a change or if there
        // is a new ref we mark this as an update. All the work is done in commitWork.
        if (updatePayload) markUpdate(workInProgress);
    };
    updateHostText$1 = function(current, workInProgress, oldText, newText) {
        // If the text differs, mark it as an update. All the work in done in commitWork.
        if (oldText !== newText) markUpdate(workInProgress);
    };
    function cutOffTailIfNeeded(renderState, hasRenderedATailFallback) {
        switch(renderState.tailMode){
            case "hidden":
                // Any insertions at the end of the tail list after this point
                // should be invisible. If there are already mounted boundaries
                // anything before them are not considered for collapsing.
                // Therefore we need to go through the whole tail to find if
                // there are any.
                var tailNode = renderState.tail;
                var lastTailNode = null;
                while(tailNode !== null){
                    if (tailNode.alternate !== null) lastTailNode = tailNode;
                    tailNode = tailNode.sibling;
                } // Next we're simply going to delete all insertions after the
                // last rendered item.
                if (lastTailNode === null) // All remaining items in the tail are insertions.
                renderState.tail = null;
                else // Detach the insertion after the last node that was already
                // inserted.
                lastTailNode.sibling = null;
                break;
            case "collapsed":
                // Any insertions at the end of the tail list after this point
                // should be invisible. If there are already mounted boundaries
                // anything before them are not considered for collapsing.
                // Therefore we need to go through the whole tail to find if
                // there are any.
                var _tailNode = renderState.tail;
                var _lastTailNode = null;
                while(_tailNode !== null){
                    if (_tailNode.alternate !== null) _lastTailNode = _tailNode;
                    _tailNode = _tailNode.sibling;
                } // Next we're simply going to delete all insertions after the
                // last rendered item.
                if (_lastTailNode === null) {
                    // All remaining items in the tail are insertions.
                    if (!hasRenderedATailFallback && renderState.tail !== null) // We suspended during the head. We want to show at least one
                    // row at the tail. So we'll keep on and cut off the rest.
                    renderState.tail.sibling = null;
                    else renderState.tail = null;
                } else // Detach the insertion after the last node that was already
                // inserted.
                _lastTailNode.sibling = null;
                break;
        }
    }
    function completeWork(current, workInProgress, renderExpirationTime) {
        var newProps = workInProgress.pendingProps;
        switch(workInProgress.tag){
            case IndeterminateComponent:
            case LazyComponent:
            case SimpleMemoComponent:
            case FunctionComponent:
            case ForwardRef:
            case Fragment:
            case Mode:
            case Profiler:
            case ContextConsumer:
            case MemoComponent:
                return null;
            case ClassComponent:
                var Component = workInProgress.type;
                if (isContextProvider(Component)) popContext(workInProgress);
                return null;
            case HostRoot:
                popHostContainer(workInProgress);
                popTopLevelContextObject(workInProgress);
                var fiberRoot = workInProgress.stateNode;
                if (fiberRoot.pendingContext) {
                    fiberRoot.context = fiberRoot.pendingContext;
                    fiberRoot.pendingContext = null;
                }
                if (current === null || current.child === null) {
                    // If we hydrated, pop so that we can delete any remaining children
                    // that weren't hydrated.
                    var wasHydrated = popHydrationState(workInProgress);
                    if (wasHydrated) // If we hydrated, then we'll need to schedule an update for
                    // the commit side-effects on the root.
                    markUpdate(workInProgress);
                }
                updateHostContainer(workInProgress);
                return null;
            case HostComponent:
                popHostContext(workInProgress);
                var rootContainerInstance = getRootHostContainer();
                var type = workInProgress.type;
                if (current !== null && workInProgress.stateNode != null) {
                    updateHostComponent$1(current, workInProgress, type, newProps, rootContainerInstance);
                    if (current.ref !== workInProgress.ref) markRef$1(workInProgress);
                } else {
                    if (!newProps) {
                        if (!(workInProgress.stateNode !== null)) throw Error("We must have new props for new mounts. This error is likely caused by a bug in React. Please file an issue.");
                         // This can happen when we abort work.
                        return null;
                    }
                    var currentHostContext = getHostContext(); // TODO: Move createInstance to beginWork and keep it on a context
                    // "stack" as the parent. Then append children as we go in beginWork
                    // or completeWork depending on whether we want to add them top->down or
                    // bottom->up. Top->down is faster in IE11.
                    var _wasHydrated = popHydrationState(workInProgress);
                    if (_wasHydrated) // TODO: Move this and createInstance step into the beginPhase
                    // to consolidate.
                    {
                        if (prepareToHydrateHostInstance(workInProgress, rootContainerInstance, currentHostContext)) // If changes to the hydrated node need to be applied at the
                        // commit-phase we mark this as such.
                        markUpdate(workInProgress);
                    } else {
                        var instance = createInstance(type, newProps, rootContainerInstance, currentHostContext, workInProgress);
                        appendAllChildren(instance, workInProgress, false, false); // This needs to be set before we mount Flare event listeners
                        workInProgress.stateNode = instance;
                        // (eg DOM renderer supports auto-focus for certain elements).
                        // Make sure such renderers get scheduled for later work.
                        if (finalizeInitialChildren(instance, type, newProps, rootContainerInstance)) markUpdate(workInProgress);
                    }
                    if (workInProgress.ref !== null) // If there is a ref on a host node we need to schedule a callback
                    markRef$1(workInProgress);
                }
                return null;
            case HostText:
                var newText = newProps;
                if (current && workInProgress.stateNode != null) {
                    var oldText = current.memoizedProps; // If we have an alternate, that means this is an update and we need
                    // to schedule a side-effect to do the updates.
                    updateHostText$1(current, workInProgress, oldText, newText);
                } else {
                    if (typeof newText !== "string") {
                        if (!(workInProgress.stateNode !== null)) throw Error("We must have new props for new mounts. This error is likely caused by a bug in React. Please file an issue.");
                         // This can happen when we abort work.
                    }
                    var _rootContainerInstance = getRootHostContainer();
                    var _currentHostContext = getHostContext();
                    var _wasHydrated2 = popHydrationState(workInProgress);
                    if (_wasHydrated2) {
                        if (prepareToHydrateHostTextInstance(workInProgress)) markUpdate(workInProgress);
                    } else workInProgress.stateNode = createTextInstance(newText, _rootContainerInstance, _currentHostContext, workInProgress);
                }
                return null;
            case SuspenseComponent:
                popSuspenseContext(workInProgress);
                var nextState = workInProgress.memoizedState;
                if ((workInProgress.effectTag & DidCapture) !== NoEffect) {
                    // Something suspended. Re-render with the fallback children.
                    workInProgress.expirationTime = renderExpirationTime; // Do not reset the effect list.
                    return workInProgress;
                }
                var nextDidTimeout = nextState !== null;
                var prevDidTimeout = false;
                if (current === null) {
                    if (workInProgress.memoizedProps.fallback !== undefined) popHydrationState(workInProgress);
                } else {
                    var prevState = current.memoizedState;
                    prevDidTimeout = prevState !== null;
                    if (!nextDidTimeout && prevState !== null) {
                        // We just switched from the fallback to the normal children.
                        // Delete the fallback.
                        // TODO: Would it be better to store the fallback fragment on
                        // the stateNode during the begin phase?
                        var currentFallbackChild = current.child.sibling;
                        if (currentFallbackChild !== null) {
                            // Deletions go at the beginning of the return fiber's effect list
                            var first = workInProgress.firstEffect;
                            if (first !== null) {
                                workInProgress.firstEffect = currentFallbackChild;
                                currentFallbackChild.nextEffect = first;
                            } else {
                                workInProgress.firstEffect = workInProgress.lastEffect = currentFallbackChild;
                                currentFallbackChild.nextEffect = null;
                            }
                            currentFallbackChild.effectTag = Deletion;
                        }
                    }
                }
                if (nextDidTimeout && !prevDidTimeout) // If this subtreee is running in blocking mode we can suspend,
                // otherwise we won't suspend.
                // TODO: This will still suspend a synchronous tree if anything
                // in the concurrent tree already suspended during this render.
                // This is a known bug.
                {
                    if ((workInProgress.mode & BlockingMode) !== NoMode) {
                        // TODO: Move this back to throwException because this is too late
                        // if this is a large tree which is common for initial loads. We
                        // don't know if we should restart a render or not until we get
                        // this marker, and this is too late.
                        // If this render already had a ping or lower pri updates,
                        // and this is the first time we know we're going to suspend we
                        // should be able to immediately restart from within throwException.
                        var hasInvisibleChildContext = current === null && workInProgress.memoizedProps.unstable_avoidThisFallback !== true;
                        if (hasInvisibleChildContext || hasSuspenseContext(suspenseStackCursor.current, InvisibleParentSuspenseContext)) // If this was in an invisible tree or a new render, then showing
                        // this boundary is ok.
                        renderDidSuspend();
                        else // Otherwise, we're going to have to hide content so we should
                        // suspend for longer if possible.
                        renderDidSuspendDelayIfPossible();
                    }
                }
                // TODO: Only schedule updates if these values are non equal, i.e. it changed.
                if (nextDidTimeout || prevDidTimeout) // If this boundary just timed out, schedule an effect to attach a
                // retry listener to the promise. This flag is also used to hide the
                // primary children. In mutation mode, we also need the flag to
                // *unhide* children that were previously hidden, so check if this
                // is currently timed out, too.
                workInProgress.effectTag |= Update;
                return null;
            case HostPortal:
                popHostContainer(workInProgress);
                updateHostContainer(workInProgress);
                return null;
            case ContextProvider:
                // Pop provider fiber
                popProvider(workInProgress);
                return null;
            case IncompleteClassComponent:
                // Same as class component case. I put it down here so that the tags are
                // sequential to ensure this switch is compiled to a jump table.
                var _Component = workInProgress.type;
                if (isContextProvider(_Component)) popContext(workInProgress);
                return null;
            case SuspenseListComponent:
                popSuspenseContext(workInProgress);
                var renderState = workInProgress.memoizedState;
                if (renderState === null) // We're running in the default, "independent" mode.
                // We don't do anything in this mode.
                return null;
                var didSuspendAlready = (workInProgress.effectTag & DidCapture) !== NoEffect;
                var renderedTail = renderState.rendering;
                if (renderedTail === null) {
                    // We just rendered the head.
                    if (!didSuspendAlready) {
                        // This is the first pass. We need to figure out if anything is still
                        // suspended in the rendered set.
                        // If new content unsuspended, but there's still some content that
                        // didn't. Then we need to do a second pass that forces everything
                        // to keep showing their fallbacks.
                        // We might be suspended if something in this render pass suspended, or
                        // something in the previous committed pass suspended. Otherwise,
                        // there's no chance so we can skip the expensive call to
                        // findFirstSuspended.
                        var cannotBeSuspended = renderHasNotSuspendedYet() && (current === null || (current.effectTag & DidCapture) === NoEffect);
                        if (!cannotBeSuspended) {
                            var row = workInProgress.child;
                            while(row !== null){
                                var suspended = findFirstSuspended(row);
                                if (suspended !== null) {
                                    didSuspendAlready = true;
                                    workInProgress.effectTag |= DidCapture;
                                    cutOffTailIfNeeded(renderState, false); // If this is a newly suspended tree, it might not get committed as
                                    // part of the second pass. In that case nothing will subscribe to
                                    // its thennables. Instead, we'll transfer its thennables to the
                                    // SuspenseList so that it can retry if they resolve.
                                    // There might be multiple of these in the list but since we're
                                    // going to wait for all of them anyway, it doesn't really matter
                                    // which ones gets to ping. In theory we could get clever and keep
                                    // track of how many dependencies remain but it gets tricky because
                                    // in the meantime, we can add/remove/change items and dependencies.
                                    // We might bail out of the loop before finding any but that
                                    // doesn't matter since that means that the other boundaries that
                                    // we did find already has their listeners attached.
                                    var newThennables = suspended.updateQueue;
                                    if (newThennables !== null) {
                                        workInProgress.updateQueue = newThennables;
                                        workInProgress.effectTag |= Update;
                                    } // Rerender the whole list, but this time, we'll force fallbacks
                                    // to stay in place.
                                    // Reset the effect list before doing the second pass since that's now invalid.
                                    if (renderState.lastEffect === null) workInProgress.firstEffect = null;
                                    workInProgress.lastEffect = renderState.lastEffect; // Reset the child fibers to their original state.
                                    resetChildFibers(workInProgress, renderExpirationTime); // Set up the Suspense Context to force suspense and immediately
                                    // rerender the children.
                                    pushSuspenseContext(workInProgress, setShallowSuspenseContext(suspenseStackCursor.current, ForceSuspenseFallback));
                                    return workInProgress.child;
                                }
                                row = row.sibling;
                            }
                        }
                    } else cutOffTailIfNeeded(renderState, false);
                     // Next we're going to render the tail.
                } else {
                    // Append the rendered row to the child list.
                    if (!didSuspendAlready) {
                        var _suspended = findFirstSuspended(renderedTail);
                        if (_suspended !== null) {
                            workInProgress.effectTag |= DidCapture;
                            didSuspendAlready = true; // Ensure we transfer the update queue to the parent so that it doesn't
                            // get lost if this row ends up dropped during a second pass.
                            var _newThennables = _suspended.updateQueue;
                            if (_newThennables !== null) {
                                workInProgress.updateQueue = _newThennables;
                                workInProgress.effectTag |= Update;
                            }
                            cutOffTailIfNeeded(renderState, true); // This might have been modified.
                            if (renderState.tail === null && renderState.tailMode === "hidden" && !renderedTail.alternate) {
                                // We need to delete the row we just rendered.
                                // Reset the effect list to what it was before we rendered this
                                // child. The nested children have already appended themselves.
                                var lastEffect = workInProgress.lastEffect = renderState.lastEffect; // Remove any effects that were appended after this point.
                                if (lastEffect !== null) lastEffect.nextEffect = null;
                                 // We're done.
                                return null;
                            }
                        } else if (// the expiration.
                        now() * 2 - renderState.renderingStartTime > renderState.tailExpiration && renderExpirationTime > Never) {
                            // We have now passed our CPU deadline and we'll just give up further
                            // attempts to render the main content and only render fallbacks.
                            // The assumption is that this is usually faster.
                            workInProgress.effectTag |= DidCapture;
                            didSuspendAlready = true;
                            cutOffTailIfNeeded(renderState, false); // Since nothing actually suspended, there will nothing to ping this
                            // to get it started back up to attempt the next item. If we can show
                            // them, then they really have the same priority as this render.
                            // So we'll pick it back up the very next render pass once we've had
                            // an opportunity to yield for paint.
                            var nextPriority = renderExpirationTime - 1;
                            workInProgress.expirationTime = workInProgress.childExpirationTime = nextPriority;
                            markSpawnedWork(nextPriority);
                        }
                    }
                    if (renderState.isBackwards) {
                        // The effect list of the backwards tail will have been added
                        // to the end. This breaks the guarantee that life-cycles fire in
                        // sibling order but that isn't a strong guarantee promised by React.
                        // Especially since these might also just pop in during future commits.
                        // Append to the beginning of the list.
                        renderedTail.sibling = workInProgress.child;
                        workInProgress.child = renderedTail;
                    } else {
                        var previousSibling = renderState.last;
                        if (previousSibling !== null) previousSibling.sibling = renderedTail;
                        else workInProgress.child = renderedTail;
                        renderState.last = renderedTail;
                    }
                }
                if (renderState.tail !== null) {
                    // We still have tail rows to render.
                    if (renderState.tailExpiration === 0) {
                        // Heuristic for how long we're willing to spend rendering rows
                        // until we just give up and show what we have so far.
                        var TAIL_EXPIRATION_TIMEOUT_MS = 500;
                        renderState.tailExpiration = now() + TAIL_EXPIRATION_TIMEOUT_MS; // TODO: This is meant to mimic the train model or JND but this
                    // is a per component value. It should really be since the start
                    // of the total render or last commit. Consider using something like
                    // globalMostRecentFallbackTime. That doesn't account for being
                    // suspended for part of the time or when it's a new render.
                    // It should probably use a global start time value instead.
                    } // Pop a row.
                    var next = renderState.tail;
                    renderState.rendering = next;
                    renderState.tail = next.sibling;
                    renderState.lastEffect = workInProgress.lastEffect;
                    renderState.renderingStartTime = now();
                    next.sibling = null; // Restore the context.
                    // TODO: We can probably just avoid popping it instead and only
                    // setting it the first time we go from not suspended to suspended.
                    var suspenseContext = suspenseStackCursor.current;
                    if (didSuspendAlready) suspenseContext = setShallowSuspenseContext(suspenseContext, ForceSuspenseFallback);
                    else suspenseContext = setDefaultShallowSuspenseContext(suspenseContext);
                    pushSuspenseContext(workInProgress, suspenseContext); // Do a pass over the next row.
                    return next;
                }
                return null;
        }
        throw Error("Unknown unit of work tag (" + workInProgress.tag + "). This error is likely caused by a bug in React. Please file an issue.");
    }
    function unwindWork(workInProgress, renderExpirationTime) {
        switch(workInProgress.tag){
            case ClassComponent:
                var Component = workInProgress.type;
                if (isContextProvider(Component)) popContext(workInProgress);
                var effectTag = workInProgress.effectTag;
                if (effectTag & ShouldCapture) {
                    workInProgress.effectTag = effectTag & ~ShouldCapture | DidCapture;
                    return workInProgress;
                }
                return null;
            case HostRoot:
                popHostContainer(workInProgress);
                popTopLevelContextObject(workInProgress);
                var _effectTag = workInProgress.effectTag;
                if (!((_effectTag & DidCapture) === NoEffect)) throw Error("The root failed to unmount after an error. This is likely a bug in React. Please file an issue.");
                workInProgress.effectTag = _effectTag & ~ShouldCapture | DidCapture;
                return workInProgress;
            case HostComponent:
                // TODO: popHydrationState
                popHostContext(workInProgress);
                return null;
            case SuspenseComponent:
                popSuspenseContext(workInProgress);
                var _effectTag2 = workInProgress.effectTag;
                if (_effectTag2 & ShouldCapture) {
                    workInProgress.effectTag = _effectTag2 & ~ShouldCapture | DidCapture; // Captured a suspense effect. Re-render the boundary.
                    return workInProgress;
                }
                return null;
            case SuspenseListComponent:
                popSuspenseContext(workInProgress); // SuspenseList doesn't actually catch anything. It should've been
                // caught by a nested boundary. If not, it should bubble through.
                return null;
            case HostPortal:
                popHostContainer(workInProgress);
                return null;
            case ContextProvider:
                popProvider(workInProgress);
                return null;
            default:
                return null;
        }
    }
    function unwindInterruptedWork(interruptedWork) {
        switch(interruptedWork.tag){
            case ClassComponent:
                var childContextTypes = interruptedWork.type.childContextTypes;
                if (childContextTypes !== null && childContextTypes !== undefined) popContext(interruptedWork);
                break;
            case HostRoot:
                popHostContainer(interruptedWork);
                popTopLevelContextObject(interruptedWork);
                break;
            case HostComponent:
                popHostContext(interruptedWork);
                break;
            case HostPortal:
                popHostContainer(interruptedWork);
                break;
            case SuspenseComponent:
                popSuspenseContext(interruptedWork);
                break;
            case SuspenseListComponent:
                popSuspenseContext(interruptedWork);
                break;
            case ContextProvider:
                popProvider(interruptedWork);
                break;
        }
    }
    function createCapturedValue(value, source) {
        // If the value is an error, call this function immediately after it is thrown
        // so the stack is accurate.
        return {
            value: value,
            source: source,
            stack: getStackByFiberInDevAndProd(source)
        };
    }
    function logCapturedError(capturedError) {
        var error = capturedError.error;
        var componentName = capturedError.componentName, componentStack = capturedError.componentStack, errorBoundaryName = capturedError.errorBoundaryName, errorBoundaryFound = capturedError.errorBoundaryFound, willRetry = capturedError.willRetry; // Browsers support silencing uncaught errors by calling
        // `preventDefault()` in window `error` handler.
        // We record this information as an expando on the error.
        if (error != null && error._suppressLogging) {
            if (errorBoundaryFound && willRetry) // The error is recoverable and was silenced.
            // Ignore it and don't print the stack addendum.
            // This is handy for testing error boundaries without noise.
            return;
             // The error is fatal. Since the silencing might have
            // been accidental, we'll surface it anyway.
            // However, the browser would have silenced the original error
            // so we'll print it first, and then print the stack addendum.
            console["error"](error); // Don't transform to our wrapper
        // For a more detailed description of this block, see:
        // https://github.com/facebook/react/pull/13384
        }
        var componentNameMessage = componentName ? "The above error occurred in the <" + componentName + "> component:" : "The above error occurred in one of your React components:";
        var errorBoundaryMessage; // errorBoundaryFound check is sufficient; errorBoundaryName check is to satisfy Flow.
        if (errorBoundaryFound && errorBoundaryName) {
            if (willRetry) errorBoundaryMessage = "React will try to recreate this component tree from scratch " + ("using the error boundary you provided, " + errorBoundaryName + ".");
            else errorBoundaryMessage = "This error was initially handled by the error boundary " + errorBoundaryName + ".\n" + "Recreating the tree from scratch failed so React will unmount the tree.";
        } else errorBoundaryMessage = "Consider adding an error boundary to your tree to customize error handling behavior.\nVisit https://fb.me/react-error-boundaries to learn more about error boundaries.";
        var combinedMessage = "" + componentNameMessage + componentStack + "\n\n" + ("" + errorBoundaryMessage); // In development, we provide our own message with just the component stack.
        // We don't include the original error message and JS stack because the browser
        // has already printed it. Even if the application swallows the error, it is still
        // displayed by the browser thanks to the DEV-only fake event trick in ReactErrorUtils.
        console["error"](combinedMessage); // Don't transform to our wrapper
    }
    var didWarnAboutUndefinedSnapshotBeforeUpdate = null;
    didWarnAboutUndefinedSnapshotBeforeUpdate = new Set();
    var PossiblyWeakSet = typeof WeakSet === "function" ? WeakSet : Set;
    function logError(boundary, errorInfo) {
        var source = errorInfo.source;
        var stack = errorInfo.stack;
        if (stack === null && source !== null) stack = getStackByFiberInDevAndProd(source);
        var capturedError = {
            componentName: source !== null ? getComponentName(source.type) : null,
            componentStack: stack !== null ? stack : "",
            error: errorInfo.value,
            errorBoundary: null,
            errorBoundaryName: null,
            errorBoundaryFound: false,
            willRetry: false
        };
        if (boundary !== null && boundary.tag === ClassComponent) {
            capturedError.errorBoundary = boundary.stateNode;
            capturedError.errorBoundaryName = getComponentName(boundary.type);
            capturedError.errorBoundaryFound = true;
            capturedError.willRetry = true;
        }
        try {
            logCapturedError(capturedError);
        } catch (e) {
            // This method must not throw, or React internal state will get messed up.
            // If console.error is overridden, or logCapturedError() shows a dialog that throws,
            // we want to report this error outside of the normal stack as a last resort.
            // https://github.com/facebook/react/issues/13188
            setTimeout(function() {
                throw e;
            });
        }
    }
    var callComponentWillUnmountWithTimer = function(current, instance) {
        startPhaseTimer(current, "componentWillUnmount");
        instance.props = current.memoizedProps;
        instance.state = current.memoizedState;
        instance.componentWillUnmount();
        stopPhaseTimer();
    }; // Capture errors so they don't interrupt unmounting.
    function safelyCallComponentWillUnmount(current, instance) {
        invokeGuardedCallback(null, callComponentWillUnmountWithTimer, null, current, instance);
        if (hasCaughtError()) {
            var unmountError = clearCaughtError();
            captureCommitPhaseError(current, unmountError);
        }
    }
    function safelyDetachRef(current) {
        var ref = current.ref;
        if (ref !== null) {
            if (typeof ref === "function") {
                invokeGuardedCallback(null, ref, null, null);
                if (hasCaughtError()) {
                    var refError = clearCaughtError();
                    captureCommitPhaseError(current, refError);
                }
            } else ref.current = null;
        }
    }
    function safelyCallDestroy(current, destroy) {
        invokeGuardedCallback(null, destroy, null);
        if (hasCaughtError()) {
            var error = clearCaughtError();
            captureCommitPhaseError(current, error);
        }
    }
    function commitBeforeMutationLifeCycles(current, finishedWork) {
        switch(finishedWork.tag){
            case FunctionComponent:
            case ForwardRef:
            case SimpleMemoComponent:
            case Block:
                return;
            case ClassComponent:
                if (finishedWork.effectTag & Snapshot) {
                    if (current !== null) {
                        var prevProps = current.memoizedProps;
                        var prevState = current.memoizedState;
                        startPhaseTimer(finishedWork, "getSnapshotBeforeUpdate");
                        var instance = finishedWork.stateNode; // We could update instance props and state here,
                        if (finishedWork.type === finishedWork.elementType && !didWarnAboutReassigningProps) {
                            if (instance.props !== finishedWork.memoizedProps) error("Expected %s props to match memoized props before getSnapshotBeforeUpdate. This might either be because of a bug in React, or because a component reassigns its own `this.props`. Please file an issue.", getComponentName(finishedWork.type) || "instance");
                            if (instance.state !== finishedWork.memoizedState) error("Expected %s state to match memoized state before getSnapshotBeforeUpdate. This might either be because of a bug in React, or because a component reassigns its own `this.props`. Please file an issue.", getComponentName(finishedWork.type) || "instance");
                        }
                        var snapshot = instance.getSnapshotBeforeUpdate(finishedWork.elementType === finishedWork.type ? prevProps : resolveDefaultProps(finishedWork.type, prevProps), prevState);
                        var didWarnSet = didWarnAboutUndefinedSnapshotBeforeUpdate;
                        if (snapshot === undefined && !didWarnSet.has(finishedWork.type)) {
                            didWarnSet.add(finishedWork.type);
                            error("%s.getSnapshotBeforeUpdate(): A snapshot value (or null) must be returned. You have returned undefined.", getComponentName(finishedWork.type));
                        }
                        instance.__reactInternalSnapshotBeforeUpdate = snapshot;
                        stopPhaseTimer();
                    }
                }
                return;
            case HostRoot:
            case HostComponent:
            case HostText:
            case HostPortal:
            case IncompleteClassComponent:
                // Nothing to do for these component types
                return;
        }
        throw Error("This unit of work tag should not have side-effects. This error is likely caused by a bug in React. Please file an issue.");
    }
    function commitHookEffectListUnmount(tag, finishedWork) {
        var updateQueue = finishedWork.updateQueue;
        var lastEffect = updateQueue !== null ? updateQueue.lastEffect : null;
        if (lastEffect !== null) {
            var firstEffect = lastEffect.next;
            var effect = firstEffect;
            do {
                if ((effect.tag & tag) === tag) {
                    // Unmount
                    var destroy = effect.destroy;
                    effect.destroy = undefined;
                    if (destroy !== undefined) destroy();
                }
                effect = effect.next;
            }while (effect !== firstEffect);
        }
    }
    function commitHookEffectListMount(tag, finishedWork) {
        var updateQueue = finishedWork.updateQueue;
        var lastEffect = updateQueue !== null ? updateQueue.lastEffect : null;
        if (lastEffect !== null) {
            var firstEffect = lastEffect.next;
            var effect = firstEffect;
            do {
                if ((effect.tag & tag) === tag) {
                    // Mount
                    var create = effect.create;
                    effect.destroy = create();
                    var destroy = effect.destroy;
                    if (destroy !== undefined && typeof destroy !== "function") {
                        var addendum = void 0;
                        if (destroy === null) addendum = " You returned null. If your effect does not require clean up, return undefined (or nothing).";
                        else if (typeof destroy.then === "function") addendum = "\n\nIt looks like you wrote useEffect(async () => ...) or returned a Promise. Instead, write the async function inside your effect and call it immediately:\n\nuseEffect(() => {\n  async function fetchData() {\n    // You can await here\n    const response = await MyAPI.getData(someId);\n    // ...\n  }\n  fetchData();\n}, [someId]); // Or [] if effect doesn't need props or state\n\nLearn more about data fetching with Hooks: https://fb.me/react-hooks-data-fetching";
                        else addendum = " You returned: " + destroy;
                        error("An effect function must not return anything besides a function, which is used for clean-up.%s%s", addendum, getStackByFiberInDevAndProd(finishedWork));
                    }
                }
                effect = effect.next;
            }while (effect !== firstEffect);
        }
    }
    function commitPassiveHookEffects(finishedWork) {
        if ((finishedWork.effectTag & Passive) !== NoEffect) switch(finishedWork.tag){
            case FunctionComponent:
            case ForwardRef:
            case SimpleMemoComponent:
            case Block:
                // TODO (#17945) We should call all passive destroy functions (for all fibers)
                // before calling any create functions. The current approach only serializes
                // these for a single fiber.
                commitHookEffectListUnmount(Passive$1 | HasEffect, finishedWork);
                commitHookEffectListMount(Passive$1 | HasEffect, finishedWork);
                break;
        }
    }
    function commitLifeCycles(finishedRoot, current, finishedWork, committedExpirationTime) {
        switch(finishedWork.tag){
            case FunctionComponent:
            case ForwardRef:
            case SimpleMemoComponent:
            case Block:
                // At this point layout effects have already been destroyed (during mutation phase).
                // This is done to prevent sibling component effects from interfering with each other,
                // e.g. a destroy function in one component should never override a ref set
                // by a create function in another component during the same commit.
                commitHookEffectListMount(Layout | HasEffect, finishedWork);
                return;
            case ClassComponent:
                var instance = finishedWork.stateNode;
                if (finishedWork.effectTag & Update) {
                    if (current === null) {
                        startPhaseTimer(finishedWork, "componentDidMount"); // We could update instance props and state here,
                        if (finishedWork.type === finishedWork.elementType && !didWarnAboutReassigningProps) {
                            if (instance.props !== finishedWork.memoizedProps) error("Expected %s props to match memoized props before componentDidMount. This might either be because of a bug in React, or because a component reassigns its own `this.props`. Please file an issue.", getComponentName(finishedWork.type) || "instance");
                            if (instance.state !== finishedWork.memoizedState) error("Expected %s state to match memoized state before componentDidMount. This might either be because of a bug in React, or because a component reassigns its own `this.props`. Please file an issue.", getComponentName(finishedWork.type) || "instance");
                        }
                        instance.componentDidMount();
                        stopPhaseTimer();
                    } else {
                        var prevProps = finishedWork.elementType === finishedWork.type ? current.memoizedProps : resolveDefaultProps(finishedWork.type, current.memoizedProps);
                        var prevState = current.memoizedState;
                        startPhaseTimer(finishedWork, "componentDidUpdate"); // We could update instance props and state here,
                        if (finishedWork.type === finishedWork.elementType && !didWarnAboutReassigningProps) {
                            if (instance.props !== finishedWork.memoizedProps) error("Expected %s props to match memoized props before componentDidUpdate. This might either be because of a bug in React, or because a component reassigns its own `this.props`. Please file an issue.", getComponentName(finishedWork.type) || "instance");
                            if (instance.state !== finishedWork.memoizedState) error("Expected %s state to match memoized state before componentDidUpdate. This might either be because of a bug in React, or because a component reassigns its own `this.props`. Please file an issue.", getComponentName(finishedWork.type) || "instance");
                        }
                        instance.componentDidUpdate(prevProps, prevState, instance.__reactInternalSnapshotBeforeUpdate);
                        stopPhaseTimer();
                    }
                }
                var updateQueue = finishedWork.updateQueue;
                if (updateQueue !== null) {
                    if (finishedWork.type === finishedWork.elementType && !didWarnAboutReassigningProps) {
                        if (instance.props !== finishedWork.memoizedProps) error("Expected %s props to match memoized props before processing the update queue. This might either be because of a bug in React, or because a component reassigns its own `this.props`. Please file an issue.", getComponentName(finishedWork.type) || "instance");
                        if (instance.state !== finishedWork.memoizedState) error("Expected %s state to match memoized state before processing the update queue. This might either be because of a bug in React, or because a component reassigns its own `this.props`. Please file an issue.", getComponentName(finishedWork.type) || "instance");
                    }
                    // but instead we rely on them being set during last render.
                    // TODO: revisit this when we implement resuming.
                    commitUpdateQueue(finishedWork, updateQueue, instance);
                }
                return;
            case HostRoot:
                var _updateQueue = finishedWork.updateQueue;
                if (_updateQueue !== null) {
                    var _instance = null;
                    if (finishedWork.child !== null) switch(finishedWork.child.tag){
                        case HostComponent:
                            _instance = getPublicInstance(finishedWork.child.stateNode);
                            break;
                        case ClassComponent:
                            _instance = finishedWork.child.stateNode;
                            break;
                    }
                    commitUpdateQueue(finishedWork, _updateQueue, _instance);
                }
                return;
            case HostComponent:
                var _instance2 = finishedWork.stateNode; // Renderers may schedule work to be done after host components are mounted
                // (eg DOM renderer may schedule auto-focus for inputs and form controls).
                // These effects should only be committed when components are first mounted,
                // aka when there is no current/alternate.
                if (current === null && finishedWork.effectTag & Update) {
                    var type = finishedWork.type;
                    var props = finishedWork.memoizedProps;
                    commitMount(_instance2, type, props);
                }
                return;
            case HostText:
                // We have no life-cycles associated with text.
                return;
            case HostPortal:
                // We have no life-cycles associated with portals.
                return;
            case Profiler:
                var onRender = finishedWork.memoizedProps.onRender;
                if (typeof onRender === "function") onRender(finishedWork.memoizedProps.id, current === null ? "mount" : "update", finishedWork.actualDuration, finishedWork.treeBaseDuration, finishedWork.actualStartTime, getCommitTime(), finishedRoot.memoizedInteractions);
                return;
            case SuspenseComponent:
                commitSuspenseHydrationCallbacks(finishedRoot, finishedWork);
                return;
            case SuspenseListComponent:
            case IncompleteClassComponent:
            case FundamentalComponent:
            case ScopeComponent:
                return;
        }
        throw Error("This unit of work tag should not have side-effects. This error is likely caused by a bug in React. Please file an issue.");
    }
    function hideOrUnhideAllChildren(finishedWork, isHidden) {
        // We only have the top Fiber that was inserted but we need to recurse down its
        // children to find all the terminal nodes.
        var node = finishedWork;
        while(true){
            if (node.tag === HostComponent) {
                var instance = node.stateNode;
                if (isHidden) hideInstance(instance);
                else unhideInstance(node.stateNode, node.memoizedProps);
            } else if (node.tag === HostText) {
                var _instance3 = node.stateNode;
                if (isHidden) hideTextInstance(_instance3);
                else unhideTextInstance(_instance3, node.memoizedProps);
            } else if (node.tag === SuspenseComponent && node.memoizedState !== null && node.memoizedState.dehydrated === null) {
                // Found a nested Suspense component that timed out. Skip over the
                // primary child fragment, which should remain hidden.
                var fallbackChildFragment = node.child.sibling;
                fallbackChildFragment.return = node;
                node = fallbackChildFragment;
                continue;
            } else if (node.child !== null) {
                node.child.return = node;
                node = node.child;
                continue;
            }
            if (node === finishedWork) return;
            while(node.sibling === null){
                if (node.return === null || node.return === finishedWork) return;
                node = node.return;
            }
            node.sibling.return = node.return;
            node = node.sibling;
        }
    }
    function commitAttachRef(finishedWork) {
        var ref = finishedWork.ref;
        if (ref !== null) {
            var instance = finishedWork.stateNode;
            var instanceToUse;
            switch(finishedWork.tag){
                case HostComponent:
                    instanceToUse = getPublicInstance(instance);
                    break;
                default:
                    instanceToUse = instance;
            } // Moved outside to ensure DCE works with this flag
            if (typeof ref === "function") ref(instanceToUse);
            else {
                if (!ref.hasOwnProperty("current")) error("Unexpected ref object provided for %s. Use either a ref-setter function or React.createRef().%s", getComponentName(finishedWork.type), getStackByFiberInDevAndProd(finishedWork));
                ref.current = instanceToUse;
            }
        }
    }
    function commitDetachRef(current) {
        var currentRef = current.ref;
        if (currentRef !== null) {
            if (typeof currentRef === "function") currentRef(null);
            else currentRef.current = null;
        }
    } // User-originating errors (lifecycles and refs) should not interrupt
    // deletion, so don't let them throw. Host-originating errors should
    // interrupt deletion, so it's okay
    function commitUnmount(finishedRoot, current, renderPriorityLevel) {
        onCommitUnmount(current);
        switch(current.tag){
            case FunctionComponent:
            case ForwardRef:
            case MemoComponent:
            case SimpleMemoComponent:
            case Block:
                var updateQueue = current.updateQueue;
                if (updateQueue !== null) {
                    var lastEffect = updateQueue.lastEffect;
                    if (lastEffect !== null) {
                        var firstEffect = lastEffect.next;
                        // When the owner fiber is deleted, the destroy function of a passive
                        // effect hook is called during the synchronous commit phase. This is
                        // a concession to implementation complexity. Calling it in the
                        // passive effect phase (like they usually are, when dependencies
                        // change during an update) would require either traversing the
                        // children of the deleted fiber again, or including unmount effects
                        // as part of the fiber effect list.
                        //
                        // Because this is during the sync commit phase, we need to change
                        // the priority.
                        //
                        // TODO: Reconsider this implementation trade off.
                        var priorityLevel = renderPriorityLevel > NormalPriority ? NormalPriority : renderPriorityLevel;
                        runWithPriority$1(priorityLevel, function() {
                            var effect = firstEffect;
                            do {
                                var _destroy = effect.destroy;
                                if (_destroy !== undefined) safelyCallDestroy(current, _destroy);
                                effect = effect.next;
                            }while (effect !== firstEffect);
                        });
                    }
                }
                return;
            case ClassComponent:
                safelyDetachRef(current);
                var instance = current.stateNode;
                if (typeof instance.componentWillUnmount === "function") safelyCallComponentWillUnmount(current, instance);
                return;
            case HostComponent:
                safelyDetachRef(current);
                return;
            case HostPortal:
                unmountHostComponents(finishedRoot, current, renderPriorityLevel);
                return;
            case FundamentalComponent:
                return;
            case DehydratedFragment:
                return;
            case ScopeComponent:
                return;
        }
    }
    function commitNestedUnmounts(finishedRoot, root, renderPriorityLevel) {
        // While we're inside a removed host node we don't want to call
        // removeChild on the inner nodes because they're removed by the top
        // call anyway. We also want to call componentWillUnmount on all
        // composites before this host node is removed from the tree. Therefore
        // we do an inner loop while we're still inside the host node.
        var node = root;
        while(true){
            commitUnmount(finishedRoot, node, renderPriorityLevel); // Visit children because they may contain more composite or host nodes.
            // Skip portals because commitUnmount() currently visits them recursively.
            if (node.child !== null && // If we don't use mutation we drill down into portals here instead.
            node.tag !== HostPortal) {
                node.child.return = node;
                node = node.child;
                continue;
            }
            if (node === root) return;
            while(node.sibling === null){
                if (node.return === null || node.return === root) return;
                node = node.return;
            }
            node.sibling.return = node.return;
            node = node.sibling;
        }
    }
    function detachFiber(current) {
        var alternate = current.alternate; // Cut off the return pointers to disconnect it from the tree. Ideally, we
        // should clear the child pointer of the parent alternate to let this
        // get GC:ed but we don't know which for sure which parent is the current
        // one so we'll settle for GC:ing the subtree of this child. This child
        // itself will be GC:ed when the parent updates the next time.
        current.return = null;
        current.child = null;
        current.memoizedState = null;
        current.updateQueue = null;
        current.dependencies = null;
        current.alternate = null;
        current.firstEffect = null;
        current.lastEffect = null;
        current.pendingProps = null;
        current.memoizedProps = null;
        current.stateNode = null;
        if (alternate !== null) detachFiber(alternate);
    }
    function getHostParentFiber(fiber) {
        var parent = fiber.return;
        while(parent !== null){
            if (isHostParent(parent)) return parent;
            parent = parent.return;
        }
        throw Error("Expected to find a host parent. This error is likely caused by a bug in React. Please file an issue.");
    }
    function isHostParent(fiber) {
        return fiber.tag === HostComponent || fiber.tag === HostRoot || fiber.tag === HostPortal;
    }
    function getHostSibling(fiber) {
        // We're going to search forward into the tree until we find a sibling host
        // node. Unfortunately, if multiple insertions are done in a row we have to
        // search past them. This leads to exponential search for the next sibling.
        // TODO: Find a more efficient way to do this.
        var node = fiber;
        siblings: while(true){
            // If we didn't find anything, let's try the next sibling.
            while(node.sibling === null){
                if (node.return === null || isHostParent(node.return)) // If we pop out of the root or hit the parent the fiber we are the
                // last sibling.
                return null;
                node = node.return;
            }
            node.sibling.return = node.return;
            node = node.sibling;
            while(node.tag !== HostComponent && node.tag !== HostText && node.tag !== DehydratedFragment){
                // If it is not host node and, we might have a host node inside it.
                // Try to search down until we find one.
                if (node.effectTag & Placement) continue siblings;
                 // If we don't have a child, try the siblings instead.
                // We also skip portals because they are not part of this host tree.
                if (node.child === null || node.tag === HostPortal) continue siblings;
                else {
                    node.child.return = node;
                    node = node.child;
                }
            } // Check if this host node is stable or about to be placed.
            if (!(node.effectTag & Placement)) // Found it!
            return node.stateNode;
        }
    }
    function commitPlacement(finishedWork) {
        var parentFiber = getHostParentFiber(finishedWork); // Note: these two variables *must* always be updated together.
        var parent;
        var isContainer;
        var parentStateNode = parentFiber.stateNode;
        switch(parentFiber.tag){
            case HostComponent:
                parent = parentStateNode;
                isContainer = false;
                break;
            case HostRoot:
                parent = parentStateNode.containerInfo;
                isContainer = true;
                break;
            case HostPortal:
                parent = parentStateNode.containerInfo;
                isContainer = true;
                break;
            case FundamentalComponent:
            // eslint-disable-next-line-no-fallthrough
            default:
                throw Error("Invalid host parent fiber. This error is likely caused by a bug in React. Please file an issue.");
        }
        if (parentFiber.effectTag & ContentReset) {
            // Reset the text content of the parent before doing any insertions
            resetTextContent(parent); // Clear ContentReset from the effect tag
            parentFiber.effectTag &= ~ContentReset;
        }
        var before = getHostSibling(finishedWork); // We only have the top Fiber that was inserted but we need to recurse down its
        // children to find all the terminal nodes.
        if (isContainer) insertOrAppendPlacementNodeIntoContainer(finishedWork, before, parent);
        else insertOrAppendPlacementNode(finishedWork, before, parent);
    }
    function insertOrAppendPlacementNodeIntoContainer(node, before, parent) {
        var tag = node.tag;
        var isHost = tag === HostComponent || tag === HostText;
        if (isHost || enableFundamentalAPI) {
            var stateNode = isHost ? node.stateNode : node.stateNode.instance;
            if (before) insertInContainerBefore(parent, stateNode, before);
            else appendChildToContainer(parent, stateNode);
        } else if (tag === HostPortal) ;
        else {
            var child = node.child;
            if (child !== null) {
                insertOrAppendPlacementNodeIntoContainer(child, before, parent);
                var sibling = child.sibling;
                while(sibling !== null){
                    insertOrAppendPlacementNodeIntoContainer(sibling, before, parent);
                    sibling = sibling.sibling;
                }
            }
        }
    }
    function insertOrAppendPlacementNode(node, before, parent) {
        var tag = node.tag;
        var isHost = tag === HostComponent || tag === HostText;
        if (isHost || enableFundamentalAPI) {
            var stateNode = isHost ? node.stateNode : node.stateNode.instance;
            if (before) insertBefore(parent, stateNode, before);
            else appendChild(parent, stateNode);
        } else if (tag === HostPortal) ;
        else {
            var child = node.child;
            if (child !== null) {
                insertOrAppendPlacementNode(child, before, parent);
                var sibling = child.sibling;
                while(sibling !== null){
                    insertOrAppendPlacementNode(sibling, before, parent);
                    sibling = sibling.sibling;
                }
            }
        }
    }
    function unmountHostComponents(finishedRoot, current, renderPriorityLevel) {
        // We only have the top Fiber that was deleted but we need to recurse down its
        // children to find all the terminal nodes.
        var node = current; // Each iteration, currentParent is populated with node's host parent if not
        // currentParentIsValid.
        var currentParentIsValid = false; // Note: these two variables *must* always be updated together.
        var currentParent;
        var currentParentIsContainer;
        while(true){
            if (!currentParentIsValid) {
                var parent = node.return;
                findParent: while(true){
                    if (!(parent !== null)) throw Error("Expected to find a host parent. This error is likely caused by a bug in React. Please file an issue.");
                    var parentStateNode = parent.stateNode;
                    switch(parent.tag){
                        case HostComponent:
                            currentParent = parentStateNode;
                            currentParentIsContainer = false;
                            break findParent;
                        case HostRoot:
                            currentParent = parentStateNode.containerInfo;
                            currentParentIsContainer = true;
                            break findParent;
                        case HostPortal:
                            currentParent = parentStateNode.containerInfo;
                            currentParentIsContainer = true;
                            break findParent;
                    }
                    parent = parent.return;
                }
                currentParentIsValid = true;
            }
            if (node.tag === HostComponent || node.tag === HostText) {
                commitNestedUnmounts(finishedRoot, node, renderPriorityLevel); // After all the children have unmounted, it is now safe to remove the
                // node from the tree.
                if (currentParentIsContainer) removeChildFromContainer(currentParent, node.stateNode);
                else removeChild(currentParent, node.stateNode);
                 // Don't visit children because we already visited them.
            } else if (node.tag === HostPortal) {
                if (node.child !== null) {
                    // When we go into a portal, it becomes the parent to remove from.
                    // We will reassign it back when we pop the portal on the way up.
                    currentParent = node.stateNode.containerInfo;
                    currentParentIsContainer = true; // Visit children because portals might contain host components.
                    node.child.return = node;
                    node = node.child;
                    continue;
                }
            } else {
                commitUnmount(finishedRoot, node, renderPriorityLevel); // Visit children because we may find more host components below.
                if (node.child !== null) {
                    node.child.return = node;
                    node = node.child;
                    continue;
                }
            }
            if (node === current) return;
            while(node.sibling === null){
                if (node.return === null || node.return === current) return;
                node = node.return;
                if (node.tag === HostPortal) // When we go out of the portal, we need to restore the parent.
                // Since we don't keep a stack of them, we will search for it.
                currentParentIsValid = false;
            }
            node.sibling.return = node.return;
            node = node.sibling;
        }
    }
    function commitDeletion(finishedRoot, current, renderPriorityLevel) {
        // Recursively delete all host nodes from the parent.
        // Detach refs and call componentWillUnmount() on the whole subtree.
        unmountHostComponents(finishedRoot, current, renderPriorityLevel);
        detachFiber(current);
    }
    function commitWork(current, finishedWork) {
        switch(finishedWork.tag){
            case FunctionComponent:
            case ForwardRef:
            case MemoComponent:
            case SimpleMemoComponent:
            case Block:
                // Layout effects are destroyed during the mutation phase so that all
                // destroy functions for all fibers are called before any create functions.
                // This prevents sibling component effects from interfering with each other,
                // e.g. a destroy function in one component should never override a ref set
                // by a create function in another component during the same commit.
                commitHookEffectListUnmount(Layout | HasEffect, finishedWork);
                return;
            case ClassComponent:
                return;
            case HostComponent:
                var instance = finishedWork.stateNode;
                if (instance != null) {
                    // Commit the work prepared earlier.
                    var newProps = finishedWork.memoizedProps; // For hydration we reuse the update path but we treat the oldProps
                    // as the newProps. The updatePayload will contain the real change in
                    // this case.
                    var oldProps = current !== null ? current.memoizedProps : newProps;
                    var type = finishedWork.type; // TODO: Type the updateQueue to be specific to host components.
                    var updatePayload = finishedWork.updateQueue;
                    finishedWork.updateQueue = null;
                    if (updatePayload !== null) commitUpdate(instance, updatePayload, type, oldProps, newProps);
                }
                return;
            case HostText:
                if (!(finishedWork.stateNode !== null)) throw Error("This should have a text node initialized. This error is likely caused by a bug in React. Please file an issue.");
                var textInstance = finishedWork.stateNode;
                var newText = finishedWork.memoizedProps; // For hydration we reuse the update path but we treat the oldProps
                // as the newProps. The updatePayload will contain the real change in
                // this case.
                var oldText = current !== null ? current.memoizedProps : newText;
                commitTextUpdate(textInstance, oldText, newText);
                return;
            case HostRoot:
                var _root = finishedWork.stateNode;
                if (_root.hydrate) {
                    // We've just hydrated. No need to hydrate again.
                    _root.hydrate = false;
                    commitHydratedContainer(_root.containerInfo);
                }
                return;
            case Profiler:
                return;
            case SuspenseComponent:
                commitSuspenseComponent(finishedWork);
                attachSuspenseRetryListeners(finishedWork);
                return;
            case SuspenseListComponent:
                attachSuspenseRetryListeners(finishedWork);
                return;
            case IncompleteClassComponent:
                return;
        }
        throw Error("This unit of work tag should not have side-effects. This error is likely caused by a bug in React. Please file an issue.");
    }
    function commitSuspenseComponent(finishedWork) {
        var newState = finishedWork.memoizedState;
        var newDidTimeout;
        var primaryChildParent = finishedWork;
        if (newState === null) newDidTimeout = false;
        else {
            newDidTimeout = true;
            primaryChildParent = finishedWork.child;
            markCommitTimeOfFallback();
        }
        if (primaryChildParent !== null) hideOrUnhideAllChildren(primaryChildParent, newDidTimeout);
    }
    function commitSuspenseHydrationCallbacks(finishedRoot, finishedWork) {
        var newState = finishedWork.memoizedState;
        if (newState === null) {
            var current = finishedWork.alternate;
            if (current !== null) {
                var prevState = current.memoizedState;
                if (prevState !== null) {
                    var suspenseInstance = prevState.dehydrated;
                    if (suspenseInstance !== null) commitHydratedSuspenseInstance(suspenseInstance);
                }
            }
        }
    }
    function attachSuspenseRetryListeners(finishedWork) {
        // If this boundary just timed out, then it will have a set of thenables.
        // For each thenable, attach a listener so that when it resolves, React
        // attempts to re-render the boundary in the primary (pre-timeout) state.
        var thenables = finishedWork.updateQueue;
        if (thenables !== null) {
            finishedWork.updateQueue = null;
            var retryCache = finishedWork.stateNode;
            if (retryCache === null) retryCache = finishedWork.stateNode = new PossiblyWeakSet();
            thenables.forEach(function(thenable) {
                // Memoize using the boundary fiber to prevent redundant listeners.
                var retry = resolveRetryThenable.bind(null, finishedWork, thenable);
                if (!retryCache.has(thenable)) {
                    if (thenable.__reactDoNotTraceInteractions !== true) retry = tracing.unstable_wrap(retry);
                    retryCache.add(thenable);
                    thenable.then(retry, retry);
                }
            });
        }
    }
    function commitResetTextContent(current) {
        resetTextContent(current.stateNode);
    }
    var PossiblyWeakMap$1 = typeof WeakMap === "function" ? WeakMap : Map;
    function createRootErrorUpdate(fiber, errorInfo, expirationTime) {
        var update = createUpdate(expirationTime, null); // Unmount the root by rendering null.
        update.tag = CaptureUpdate; // Caution: React DevTools currently depends on this property
        // being called "element".
        update.payload = {
            element: null
        };
        var error = errorInfo.value;
        update.callback = function() {
            onUncaughtError(error);
            logError(fiber, errorInfo);
        };
        return update;
    }
    function createClassErrorUpdate(fiber, errorInfo, expirationTime) {
        var update = createUpdate(expirationTime, null);
        update.tag = CaptureUpdate;
        var getDerivedStateFromError = fiber.type.getDerivedStateFromError;
        if (typeof getDerivedStateFromError === "function") {
            var error$1 = errorInfo.value;
            update.payload = function() {
                logError(fiber, errorInfo);
                return getDerivedStateFromError(error$1);
            };
        }
        var inst = fiber.stateNode;
        if (inst !== null && typeof inst.componentDidCatch === "function") update.callback = function callback() {
            markFailedErrorBoundaryForHotReloading(fiber);
            if (typeof getDerivedStateFromError !== "function") {
                // To preserve the preexisting retry behavior of error boundaries,
                // we keep track of which ones already failed during this batch.
                // This gets reset before we yield back to the browser.
                // TODO: Warn in strict mode if getDerivedStateFromError is
                // not defined.
                markLegacyErrorBoundaryAsFailed(this); // Only log here if componentDidCatch is the only error boundary method defined
                logError(fiber, errorInfo);
            }
            var error$1 = errorInfo.value;
            var stack = errorInfo.stack;
            this.componentDidCatch(error$1, {
                componentStack: stack !== null ? stack : ""
            });
            if (typeof getDerivedStateFromError !== "function") // If componentDidCatch is the only error boundary method defined,
            // then it needs to call setState to recover from errors.
            // If no state update is scheduled then the boundary will swallow the error.
            {
                if (fiber.expirationTime !== Sync) error("%s: Error boundaries should implement getDerivedStateFromError(). In that method, return a state update to display an error message or fallback UI.", getComponentName(fiber.type) || "Unknown");
            }
        };
        else update.callback = function() {
            markFailedErrorBoundaryForHotReloading(fiber);
        };
        return update;
    }
    function attachPingListener(root, renderExpirationTime, thenable) {
        // Attach a listener to the promise to "ping" the root and retry. But
        // only if one does not already exist for the current render expiration
        // time (which acts like a "thread ID" here).
        var pingCache = root.pingCache;
        var threadIDs;
        if (pingCache === null) {
            pingCache = root.pingCache = new PossiblyWeakMap$1();
            threadIDs = new Set();
            pingCache.set(thenable, threadIDs);
        } else {
            threadIDs = pingCache.get(thenable);
            if (threadIDs === undefined) {
                threadIDs = new Set();
                pingCache.set(thenable, threadIDs);
            }
        }
        if (!threadIDs.has(renderExpirationTime)) {
            // Memoize using the thread ID to prevent redundant listeners.
            threadIDs.add(renderExpirationTime);
            var ping = pingSuspendedRoot.bind(null, root, thenable, renderExpirationTime);
            thenable.then(ping, ping);
        }
    }
    function throwException(root, returnFiber, sourceFiber, value, renderExpirationTime) {
        // The source fiber did not complete.
        sourceFiber.effectTag |= Incomplete; // Its effect list is no longer valid.
        sourceFiber.firstEffect = sourceFiber.lastEffect = null;
        if (value !== null && typeof value === "object" && typeof value.then === "function") {
            // This is a thenable.
            var thenable = value;
            if ((sourceFiber.mode & BlockingMode) === NoMode) {
                // Reset the memoizedState to what it was before we attempted
                // to render it.
                var currentSource = sourceFiber.alternate;
                if (currentSource) {
                    sourceFiber.updateQueue = currentSource.updateQueue;
                    sourceFiber.memoizedState = currentSource.memoizedState;
                    sourceFiber.expirationTime = currentSource.expirationTime;
                } else {
                    sourceFiber.updateQueue = null;
                    sourceFiber.memoizedState = null;
                }
            }
            var hasInvisibleParentBoundary = hasSuspenseContext(suspenseStackCursor.current, InvisibleParentSuspenseContext); // Schedule the nearest Suspense to re-render the timed out view.
            var _workInProgress = returnFiber;
            do {
                if (_workInProgress.tag === SuspenseComponent && shouldCaptureSuspense(_workInProgress, hasInvisibleParentBoundary)) {
                    // Found the nearest boundary.
                    // Stash the promise on the boundary fiber. If the boundary times out, we'll
                    // attach another listener to flip the boundary back to its normal state.
                    var thenables = _workInProgress.updateQueue;
                    if (thenables === null) {
                        var updateQueue = new Set();
                        updateQueue.add(thenable);
                        _workInProgress.updateQueue = updateQueue;
                    } else thenables.add(thenable);
                     // If the boundary is outside of blocking mode, we should *not*
                    // suspend the commit. Pretend as if the suspended component rendered
                    // null and keep rendering. In the commit phase, we'll schedule a
                    // subsequent synchronous update to re-render the Suspense.
                    //
                    // Note: It doesn't matter whether the component that suspended was
                    // inside a blocking mode tree. If the Suspense is outside of it, we
                    // should *not* suspend the commit.
                    if ((_workInProgress.mode & BlockingMode) === NoMode) {
                        _workInProgress.effectTag |= DidCapture; // We're going to commit this fiber even though it didn't complete.
                        // But we shouldn't call any lifecycle methods or callbacks. Remove
                        // all lifecycle effect tags.
                        sourceFiber.effectTag &= ~(LifecycleEffectMask | Incomplete);
                        if (sourceFiber.tag === ClassComponent) {
                            var currentSourceFiber = sourceFiber.alternate;
                            if (currentSourceFiber === null) // This is a new mount. Change the tag so it's not mistaken for a
                            // completed class component. For example, we should not call
                            // componentWillUnmount if it is deleted.
                            sourceFiber.tag = IncompleteClassComponent;
                            else {
                                // When we try rendering again, we should not reuse the current fiber,
                                // since it's known to be in an inconsistent state. Use a force update to
                                // prevent a bail out.
                                var update = createUpdate(Sync, null);
                                update.tag = ForceUpdate;
                                enqueueUpdate(sourceFiber, update);
                            }
                        } // The source fiber did not complete. Mark it with Sync priority to
                        // indicate that it still has pending work.
                        sourceFiber.expirationTime = Sync; // Exit without suspending.
                        return;
                    } // Confirmed that the boundary is in a concurrent mode tree. Continue
                    // with the normal suspend path.
                    //
                    // After this we'll use a set of heuristics to determine whether this
                    // render pass will run to completion or restart or "suspend" the commit.
                    // The actual logic for this is spread out in different places.
                    //
                    // This first principle is that if we're going to suspend when we complete
                    // a root, then we should also restart if we get an update or ping that
                    // might unsuspend it, and vice versa. The only reason to suspend is
                    // because you think you might want to restart before committing. However,
                    // it doesn't make sense to restart only while in the period we're suspended.
                    //
                    // Restarting too aggressively is also not good because it starves out any
                    // intermediate loading state. So we use heuristics to determine when.
                    // Suspense Heuristics
                    //
                    // If nothing threw a Promise or all the same fallbacks are already showing,
                    // then don't suspend/restart.
                    //
                    // If this is an initial render of a new tree of Suspense boundaries and
                    // those trigger a fallback, then don't suspend/restart. We want to ensure
                    // that we can show the initial loading state as quickly as possible.
                    //
                    // If we hit a "Delayed" case, such as when we'd switch from content back into
                    // a fallback, then we should always suspend/restart. SuspenseConfig applies to
                    // this case. If none is defined, JND is used instead.
                    //
                    // If we're already showing a fallback and it gets "retried", allowing us to show
                    // another level, but there's still an inner boundary that would show a fallback,
                    // then we suspend/restart for 500ms since the last time we showed a fallback
                    // anywhere in the tree. This effectively throttles progressive loading into a
                    // consistent train of commits. This also gives us an opportunity to restart to
                    // get to the completed state slightly earlier.
                    //
                    // If there's ambiguity due to batching it's resolved in preference of:
                    // 1) "delayed", 2) "initial render", 3) "retry".
                    //
                    // We want to ensure that a "busy" state doesn't get force committed. We want to
                    // ensure that new initial loading states can commit as soon as possible.
                    attachPingListener(root, renderExpirationTime, thenable);
                    _workInProgress.effectTag |= ShouldCapture;
                    _workInProgress.expirationTime = renderExpirationTime;
                    return;
                } // This boundary already captured during this render. Continue to the next
                // boundary.
                _workInProgress = _workInProgress.return;
            }while (_workInProgress !== null); // No boundary was found. Fallthrough to error mode.
            // TODO: Use invariant so the message is stripped in prod?
            value = new Error((getComponentName(sourceFiber.type) || "A React component") + " suspended while rendering, but no fallback UI was specified.\n" + "\n" + "Add a <Suspense fallback=...> component higher in the tree to " + "provide a loading indicator or placeholder to display." + getStackByFiberInDevAndProd(sourceFiber));
        } // We didn't find a boundary that could handle this type of exception. Start
        // over and traverse parent path again, this time treating the exception
        // as an error.
        renderDidError();
        value = createCapturedValue(value, sourceFiber);
        var workInProgress = returnFiber;
        do {
            switch(workInProgress.tag){
                case HostRoot:
                    var _errorInfo = value;
                    workInProgress.effectTag |= ShouldCapture;
                    workInProgress.expirationTime = renderExpirationTime;
                    var _update = createRootErrorUpdate(workInProgress, _errorInfo, renderExpirationTime);
                    enqueueCapturedUpdate(workInProgress, _update);
                    return;
                case ClassComponent:
                    // Capture and retry
                    var errorInfo = value;
                    var ctor = workInProgress.type;
                    var instance = workInProgress.stateNode;
                    if ((workInProgress.effectTag & DidCapture) === NoEffect && (typeof ctor.getDerivedStateFromError === "function" || instance !== null && typeof instance.componentDidCatch === "function" && !isAlreadyFailedLegacyErrorBoundary(instance))) {
                        workInProgress.effectTag |= ShouldCapture;
                        workInProgress.expirationTime = renderExpirationTime; // Schedule the error boundary to re-render using updated state
                        var _update2 = createClassErrorUpdate(workInProgress, errorInfo, renderExpirationTime);
                        enqueueCapturedUpdate(workInProgress, _update2);
                        return;
                    }
                    break;
            }
            workInProgress = workInProgress.return;
        }while (workInProgress !== null);
    }
    var ceil = Math.ceil;
    var ReactCurrentDispatcher$1 = ReactSharedInternals.ReactCurrentDispatcher, ReactCurrentOwner$2 = ReactSharedInternals.ReactCurrentOwner, IsSomeRendererActing = ReactSharedInternals.IsSomeRendererActing;
    var NoContext = /*                    */ 0;
    var BatchedContext = /*               */ 1;
    var EventContext = /*                 */ 2;
    var DiscreteEventContext = /*         */ 4;
    var LegacyUnbatchedContext = /*       */ 8;
    var RenderContext = /*                */ 16;
    var CommitContext = /*                */ 32;
    var RootIncomplete = 0;
    var RootFatalErrored = 1;
    var RootErrored = 2;
    var RootSuspended = 3;
    var RootSuspendedWithDelay = 4;
    var RootCompleted = 5;
    // Describes where we are in the React execution stack
    var executionContext = NoContext; // The root we're working on
    var workInProgressRoot = null; // The fiber we're working on
    var workInProgress = null; // The expiration time we're rendering
    var renderExpirationTime$1 = NoWork; // Whether to root completed, errored, suspended, etc.
    var workInProgressRootExitStatus = RootIncomplete; // A fatal error, if one is thrown
    var workInProgressRootFatalError = null; // Most recent event time among processed updates during this render.
    // This is conceptually a time stamp but expressed in terms of an ExpirationTime
    // because we deal mostly with expiration times in the hot path, so this avoids
    // the conversion happening in the hot path.
    var workInProgressRootLatestProcessedExpirationTime = Sync;
    var workInProgressRootLatestSuspenseTimeout = Sync;
    var workInProgressRootCanSuspendUsingConfig = null; // The work left over by components that were visited during this render. Only
    // includes unprocessed updates, not work in bailed out children.
    var workInProgressRootNextUnprocessedUpdateTime = NoWork; // If we're pinged while rendering we don't always restart immediately.
    // This flag determines if it might be worthwhile to restart if an opportunity
    // happens latere.
    var workInProgressRootHasPendingPing = false; // The most recent time we committed a fallback. This lets us ensure a train
    // model where we don't commit new loading states in too quick succession.
    var globalMostRecentFallbackTime = 0;
    var FALLBACK_THROTTLE_MS = 500;
    var nextEffect = null;
    var hasUncaughtError = false;
    var firstUncaughtError = null;
    var legacyErrorBoundariesThatAlreadyFailed = null;
    var rootDoesHavePassiveEffects = false;
    var rootWithPendingPassiveEffects = null;
    var pendingPassiveEffectsRenderPriority = NoPriority;
    var pendingPassiveEffectsExpirationTime = NoWork;
    var rootsWithPendingDiscreteUpdates = null; // Use these to prevent an infinite loop of nested updates
    var NESTED_UPDATE_LIMIT = 50;
    var nestedUpdateCount = 0;
    var rootWithNestedUpdates = null;
    var NESTED_PASSIVE_UPDATE_LIMIT = 50;
    var nestedPassiveUpdateCount = 0;
    var interruptedBy = null; // Marks the need to reschedule pending interactions at these expiration times
    // during the commit phase. This enables them to be traced across components
    // that spawn new work during render. E.g. hidden boundaries, suspended SSR
    // hydration or SuspenseList.
    var spawnedWorkDuringRender = null; // Expiration times are computed by adding to the current time (the start
    // time). However, if two updates are scheduled within the same event, we
    // should treat their start times as simultaneous, even if the actual clock
    // time has advanced between the first and second call.
    // In other words, because expiration times determine how updates are batched,
    // we want all updates of like priority that occur within the same event to
    // receive the same expiration time. Otherwise we get tearing.
    var currentEventTime = NoWork;
    function requestCurrentTimeForUpdate() {
        if ((executionContext & (RenderContext | CommitContext)) !== NoContext) // We're inside React, so it's fine to read the actual time.
        return msToExpirationTime(now());
         // We're not inside React, so we may be in the middle of a browser event.
        if (currentEventTime !== NoWork) // Use the same start time for all updates until we enter React again.
        return currentEventTime;
         // This is the first update since React yielded. Compute a new start time.
        currentEventTime = msToExpirationTime(now());
        return currentEventTime;
    }
    function getCurrentTime() {
        return msToExpirationTime(now());
    }
    function computeExpirationForFiber(currentTime, fiber, suspenseConfig) {
        var mode = fiber.mode;
        if ((mode & BlockingMode) === NoMode) return Sync;
        var priorityLevel = getCurrentPriorityLevel();
        if ((mode & ConcurrentMode) === NoMode) return priorityLevel === ImmediatePriority ? Sync : Batched;
        if ((executionContext & RenderContext) !== NoContext) // Use whatever time we're already rendering
        // TODO: Should there be a way to opt out, like with `runWithPriority`?
        return renderExpirationTime$1;
        var expirationTime;
        if (suspenseConfig !== null) // Compute an expiration time based on the Suspense timeout.
        expirationTime = computeSuspenseExpiration(currentTime, suspenseConfig.timeoutMs | 0 || LOW_PRIORITY_EXPIRATION);
        else // Compute an expiration time based on the Scheduler priority.
        switch(priorityLevel){
            case ImmediatePriority:
                expirationTime = Sync;
                break;
            case UserBlockingPriority$1:
                // TODO: Rename this to computeUserBlockingExpiration
                expirationTime = computeInteractiveExpiration(currentTime);
                break;
            case NormalPriority:
            case LowPriority:
                // TODO: Handle LowPriority
                // TODO: Rename this to... something better.
                expirationTime = computeAsyncExpiration(currentTime);
                break;
            case IdlePriority:
                expirationTime = Idle;
                break;
            default:
                throw Error("Expected a valid priority level");
        }
         // If we're in the middle of rendering a tree, do not update at the same
        // expiration time that is already rendering.
        // TODO: We shouldn't have to do this if the update is on a different root.
        // Refactor computeExpirationForFiber + scheduleUpdate so we have access to
        // the root when we check for this condition.
        if (workInProgressRoot !== null && expirationTime === renderExpirationTime$1) // This is a trick to move this update into a separate batch
        expirationTime -= 1;
        return expirationTime;
    }
    function scheduleUpdateOnFiber(fiber, expirationTime) {
        checkForNestedUpdates();
        warnAboutRenderPhaseUpdatesInDEV(fiber);
        var root = markUpdateTimeFromFiberToRoot(fiber, expirationTime);
        if (root === null) {
            warnAboutUpdateOnUnmountedFiberInDEV(fiber);
            return;
        }
        checkForInterruption(fiber, expirationTime);
        recordScheduleUpdate(); // TODO: computeExpirationForFiber also reads the priority. Pass the
        // priority as an argument to that function and this one.
        var priorityLevel = getCurrentPriorityLevel();
        if (expirationTime === Sync) {
            if ((executionContext & LegacyUnbatchedContext) !== NoContext && // Check if we're not already rendering
            (executionContext & (RenderContext | CommitContext)) === NoContext) {
                // Register pending interactions on the root to avoid losing traced interaction data.
                schedulePendingInteractions(root, expirationTime); // This is a legacy edge case. The initial mount of a ReactDOM.render-ed
                // root inside of batchedUpdates should be synchronous, but layout updates
                // should be deferred until the end of the batch.
                performSyncWorkOnRoot(root);
            } else {
                ensureRootIsScheduled(root);
                schedulePendingInteractions(root, expirationTime);
                if (executionContext === NoContext) // Flush the synchronous work now, unless we're already working or inside
                // a batch. This is intentionally inside scheduleUpdateOnFiber instead of
                // scheduleCallbackForFiber to preserve the ability to schedule a callback
                // without immediately flushing it. We only do this for user-initiated
                // updates, to preserve historical behavior of legacy mode.
                flushSyncCallbackQueue();
            }
        } else {
            ensureRootIsScheduled(root);
            schedulePendingInteractions(root, expirationTime);
        }
        if ((executionContext & DiscreteEventContext) !== NoContext && // discrete, even inside a discrete event.
        (priorityLevel === UserBlockingPriority$1 || priorityLevel === ImmediatePriority)) {
            // This is the result of a discrete event. Track the lowest priority
            // discrete update per root so we can flush them early, if needed.
            if (rootsWithPendingDiscreteUpdates === null) rootsWithPendingDiscreteUpdates = new Map([
                [
                    root,
                    expirationTime
                ]
            ]);
            else {
                var lastDiscreteTime = rootsWithPendingDiscreteUpdates.get(root);
                if (lastDiscreteTime === undefined || lastDiscreteTime > expirationTime) rootsWithPendingDiscreteUpdates.set(root, expirationTime);
            }
        }
    }
    var scheduleWork = scheduleUpdateOnFiber; // This is split into a separate function so we can mark a fiber with pending
    // work without treating it as a typical update that originates from an event;
    // e.g. retrying a Suspense boundary isn't an update, but it does schedule work
    // on a fiber.
    function markUpdateTimeFromFiberToRoot(fiber, expirationTime) {
        // Update the source fiber's expiration time
        if (fiber.expirationTime < expirationTime) fiber.expirationTime = expirationTime;
        var alternate = fiber.alternate;
        if (alternate !== null && alternate.expirationTime < expirationTime) alternate.expirationTime = expirationTime;
         // Walk the parent path to the root and update the child expiration time.
        var node = fiber.return;
        var root = null;
        if (node === null && fiber.tag === HostRoot) root = fiber.stateNode;
        else while(node !== null){
            alternate = node.alternate;
            if (node.childExpirationTime < expirationTime) {
                node.childExpirationTime = expirationTime;
                if (alternate !== null && alternate.childExpirationTime < expirationTime) alternate.childExpirationTime = expirationTime;
            } else if (alternate !== null && alternate.childExpirationTime < expirationTime) alternate.childExpirationTime = expirationTime;
            if (node.return === null && node.tag === HostRoot) {
                root = node.stateNode;
                break;
            }
            node = node.return;
        }
        if (root !== null) {
            if (workInProgressRoot === root) {
                // Received an update to a tree that's in the middle of rendering. Mark
                // that's unprocessed work on this root.
                markUnprocessedUpdateTime(expirationTime);
                if (workInProgressRootExitStatus === RootSuspendedWithDelay) // The root already suspended with a delay, which means this render
                // definitely won't finish. Since we have a new update, let's mark it as
                // suspended now, right before marking the incoming update. This has the
                // effect of interrupting the current render and switching to the update.
                // TODO: This happens to work when receiving an update during the render
                // phase, because of the trick inside computeExpirationForFiber to
                // subtract 1 from `renderExpirationTime` to move it into a
                // separate bucket. But we should probably model it with an exception,
                // using the same mechanism we use to force hydration of a subtree.
                // TODO: This does not account for low pri updates that were already
                // scheduled before the root started rendering. Need to track the next
                // pending expiration time (perhaps by backtracking the return path) and
                // then trigger a restart in the `renderDidSuspendDelayIfPossible` path.
                markRootSuspendedAtTime(root, renderExpirationTime$1);
            } // Mark that the root has a pending update.
            markRootUpdatedAtTime(root, expirationTime);
        }
        return root;
    }
    function getNextRootExpirationTimeToWorkOn(root) {
        // Determines the next expiration time that the root should render, taking
        // into account levels that may be suspended, or levels that may have
        // received a ping.
        var lastExpiredTime = root.lastExpiredTime;
        if (lastExpiredTime !== NoWork) return lastExpiredTime;
         // "Pending" refers to any update that hasn't committed yet, including if it
        // suspended. The "suspended" range is therefore a subset.
        var firstPendingTime = root.firstPendingTime;
        if (!isRootSuspendedAtTime(root, firstPendingTime)) // The highest priority pending time is not suspended. Let's work on that.
        return firstPendingTime;
         // If the first pending time is suspended, check if there's a lower priority
        // pending level that we know about. Or check if we received a ping. Work
        // on whichever is higher priority.
        var lastPingedTime = root.lastPingedTime;
        var nextKnownPendingLevel = root.nextKnownPendingLevel;
        var nextLevel = lastPingedTime > nextKnownPendingLevel ? lastPingedTime : nextKnownPendingLevel;
        if (nextLevel <= Idle && firstPendingTime !== nextLevel) // Don't work on Idle/Never priority unless everything else is committed.
        return NoWork;
        return nextLevel;
    } // Use this function to schedule a task for a root. There's only one task per
    // root; if a task was already scheduled, we'll check to make sure the
    // expiration time of the existing task is the same as the expiration time of
    // the next level that the root has work on. This function is called on every
    // update, and right before exiting a task.
    function ensureRootIsScheduled(root) {
        var lastExpiredTime = root.lastExpiredTime;
        if (lastExpiredTime !== NoWork) {
            // Special case: Expired work should flush synchronously.
            root.callbackExpirationTime = Sync;
            root.callbackPriority = ImmediatePriority;
            root.callbackNode = scheduleSyncCallback(performSyncWorkOnRoot.bind(null, root));
            return;
        }
        var expirationTime = getNextRootExpirationTimeToWorkOn(root);
        var existingCallbackNode = root.callbackNode;
        if (expirationTime === NoWork) {
            // There's nothing to work on.
            if (existingCallbackNode !== null) {
                root.callbackNode = null;
                root.callbackExpirationTime = NoWork;
                root.callbackPriority = NoPriority;
            }
            return;
        } // TODO: If this is an update, we already read the current time. Pass the
        // time as an argument.
        var currentTime = requestCurrentTimeForUpdate();
        var priorityLevel = inferPriorityFromExpirationTime(currentTime, expirationTime); // If there's an existing render task, confirm it has the correct priority and
        // expiration time. Otherwise, we'll cancel it and schedule a new one.
        if (existingCallbackNode !== null) {
            var existingCallbackPriority = root.callbackPriority;
            var existingCallbackExpirationTime = root.callbackExpirationTime;
            if (existingCallbackExpirationTime === expirationTime && // Callback must have greater or equal priority.
            existingCallbackPriority >= priorityLevel) // Existing callback is sufficient.
            return;
             // Need to schedule a new task.
            // TODO: Instead of scheduling a new task, we should be able to change the
            // priority of the existing one.
            cancelCallback(existingCallbackNode);
        }
        root.callbackExpirationTime = expirationTime;
        root.callbackPriority = priorityLevel;
        var callbackNode;
        if (expirationTime === Sync) // Sync React callbacks are scheduled on a special internal queue
        callbackNode = scheduleSyncCallback(performSyncWorkOnRoot.bind(null, root));
        else callbackNode = scheduleCallback(priorityLevel, performConcurrentWorkOnRoot.bind(null, root), // ordering because tasks are processed in timeout order.
        {
            timeout: expirationTimeToMs(expirationTime) - now()
        });
        root.callbackNode = callbackNode;
    } // This is the entry point for every concurrent task, i.e. anything that
    // goes through Scheduler.
    function performConcurrentWorkOnRoot(root, didTimeout) {
        // Since we know we're in a React event, we can clear the current
        // event time. The next update will compute a new event time.
        currentEventTime = NoWork;
        if (didTimeout) {
            // The render task took too long to complete. Mark the current time as
            // expired to synchronously render all expired work in a single batch.
            var currentTime = requestCurrentTimeForUpdate();
            markRootExpiredAtTime(root, currentTime); // This will schedule a synchronous callback.
            ensureRootIsScheduled(root);
            return null;
        } // Determine the next expiration time to work on, using the fields stored
        // on the root.
        var expirationTime = getNextRootExpirationTimeToWorkOn(root);
        if (expirationTime !== NoWork) {
            var originalCallbackNode = root.callbackNode;
            if (!((executionContext & (RenderContext | CommitContext)) === NoContext)) throw Error("Should not already be working.");
            flushPassiveEffects(); // If the root or expiration time have changed, throw out the existing stack
            // and prepare a fresh one. Otherwise we'll continue where we left off.
            if (root !== workInProgressRoot || expirationTime !== renderExpirationTime$1) {
                prepareFreshStack(root, expirationTime);
                startWorkOnPendingInteractions(root, expirationTime);
            } // If we have a work-in-progress fiber, it means there's still work to do
            // in this root.
            if (workInProgress !== null) {
                var prevExecutionContext = executionContext;
                executionContext |= RenderContext;
                var prevDispatcher = pushDispatcher();
                var prevInteractions = pushInteractions(root);
                startWorkLoopTimer(workInProgress);
                for(;;)try {
                    workLoopConcurrent();
                    break;
                } catch (thrownValue) {
                    handleError(root, thrownValue);
                }
                resetContextDependencies();
                executionContext = prevExecutionContext;
                popDispatcher(prevDispatcher);
                popInteractions(prevInteractions);
                if (workInProgressRootExitStatus === RootFatalErrored) {
                    var fatalError = workInProgressRootFatalError;
                    stopInterruptedWorkLoopTimer();
                    prepareFreshStack(root, expirationTime);
                    markRootSuspendedAtTime(root, expirationTime);
                    ensureRootIsScheduled(root);
                    throw fatalError;
                }
                if (workInProgress !== null) // There's still work left over. Exit without committing.
                stopInterruptedWorkLoopTimer();
                else {
                    // We now have a consistent tree. The next step is either to commit it,
                    // or, if something suspended, wait to commit it after a timeout.
                    stopFinishedWorkLoopTimer();
                    var finishedWork = root.finishedWork = root.current.alternate;
                    root.finishedExpirationTime = expirationTime;
                    finishConcurrentRender(root, finishedWork, workInProgressRootExitStatus, expirationTime);
                }
                ensureRootIsScheduled(root);
                if (root.callbackNode === originalCallbackNode) // The task node scheduled for this root is the same one that's
                // currently executed. Need to return a continuation.
                return performConcurrentWorkOnRoot.bind(null, root);
            }
        }
        return null;
    }
    function finishConcurrentRender(root, finishedWork, exitStatus, expirationTime) {
        // Set this to null to indicate there's no in-progress render.
        workInProgressRoot = null;
        switch(exitStatus){
            case RootIncomplete:
            case RootFatalErrored:
                throw Error("Root did not complete. This is a bug in React.");
            // Flow knows about invariant, so it complains if I add a break
            // statement, but eslint doesn't know about invariant, so it complains
            // if I do. eslint-disable-next-line no-fallthrough
            case RootErrored:
                // If this was an async render, the error may have happened due to
                // a mutation in a concurrent event. Try rendering one more time,
                // synchronously, to see if the error goes away. If there are
                // lower priority updates, let's include those, too, in case they
                // fix the inconsistency. Render at Idle to include all updates.
                // If it was Idle or Never or some not-yet-invented time, render
                // at that time.
                markRootExpiredAtTime(root, expirationTime > Idle ? Idle : expirationTime); // We assume that this second render pass will be synchronous
                break;
            case RootSuspended:
                markRootSuspendedAtTime(root, expirationTime);
                var lastSuspendedTime = root.lastSuspendedTime;
                if (expirationTime === lastSuspendedTime) root.nextKnownPendingLevel = getRemainingExpirationTime(finishedWork);
                 // We have an acceptable loading state. We need to figure out if we
                // should immediately commit it or wait a bit.
                // If we have processed new updates during this render, we may now
                // have a new loading state ready. We want to ensure that we commit
                // that as soon as possible.
                var hasNotProcessedNewUpdates = workInProgressRootLatestProcessedExpirationTime === Sync;
                if (hasNotProcessedNewUpdates && // do not delay if we're inside an act() scope
                !IsThisRendererActing.current) {
                    // If we have not processed any new updates during this pass, then
                    // this is either a retry of an existing fallback state or a
                    // hidden tree. Hidden trees shouldn't be batched with other work
                    // and after that's fixed it can only be a retry. We're going to
                    // throttle committing retries so that we don't show too many
                    // loading states too quickly.
                    var msUntilTimeout = globalMostRecentFallbackTime + FALLBACK_THROTTLE_MS - now(); // Don't bother with a very short suspense time.
                    if (msUntilTimeout > 10) {
                        if (workInProgressRootHasPendingPing) {
                            var lastPingedTime = root.lastPingedTime;
                            if (lastPingedTime === NoWork || lastPingedTime >= expirationTime) {
                                // This render was pinged but we didn't get to restart
                                // earlier so try restarting now instead.
                                root.lastPingedTime = expirationTime;
                                prepareFreshStack(root, expirationTime);
                                break;
                            }
                        }
                        var nextTime = getNextRootExpirationTimeToWorkOn(root);
                        if (nextTime !== NoWork && nextTime !== expirationTime) break;
                        if (lastSuspendedTime !== NoWork && lastSuspendedTime !== expirationTime) {
                            // We should prefer to render the fallback of at the last
                            // suspended level. Ping the last suspended level to try
                            // rendering it again.
                            root.lastPingedTime = lastSuspendedTime;
                            break;
                        } // The render is suspended, it hasn't timed out, and there's no
                        // lower priority work to do. Instead of committing the fallback
                        // immediately, wait for more data to arrive.
                        root.timeoutHandle = scheduleTimeout(commitRoot.bind(null, root), msUntilTimeout);
                        break;
                    }
                } // The work expired. Commit immediately.
                commitRoot(root);
                break;
            case RootSuspendedWithDelay:
                markRootSuspendedAtTime(root, expirationTime);
                var _lastSuspendedTime = root.lastSuspendedTime;
                if (expirationTime === _lastSuspendedTime) root.nextKnownPendingLevel = getRemainingExpirationTime(finishedWork);
                if (!IsThisRendererActing.current) {
                    // We're suspended in a state that should be avoided. We'll try to
                    // avoid committing it for as long as the timeouts let us.
                    if (workInProgressRootHasPendingPing) {
                        var _lastPingedTime = root.lastPingedTime;
                        if (_lastPingedTime === NoWork || _lastPingedTime >= expirationTime) {
                            // This render was pinged but we didn't get to restart earlier
                            // so try restarting now instead.
                            root.lastPingedTime = expirationTime;
                            prepareFreshStack(root, expirationTime);
                            break;
                        }
                    }
                    var _nextTime = getNextRootExpirationTimeToWorkOn(root);
                    if (_nextTime !== NoWork && _nextTime !== expirationTime) break;
                    if (_lastSuspendedTime !== NoWork && _lastSuspendedTime !== expirationTime) {
                        // We should prefer to render the fallback of at the last
                        // suspended level. Ping the last suspended level to try
                        // rendering it again.
                        root.lastPingedTime = _lastSuspendedTime;
                        break;
                    }
                    var _msUntilTimeout;
                    if (workInProgressRootLatestSuspenseTimeout !== Sync) // We have processed a suspense config whose expiration time we
                    // can use as the timeout.
                    _msUntilTimeout = expirationTimeToMs(workInProgressRootLatestSuspenseTimeout) - now();
                    else if (workInProgressRootLatestProcessedExpirationTime === Sync) // This should never normally happen because only new updates
                    // cause delayed states, so we should have processed something.
                    // However, this could also happen in an offscreen tree.
                    _msUntilTimeout = 0;
                    else {
                        // If we don't have a suspense config, we're going to use a
                        // heuristic to determine how long we can suspend.
                        var eventTimeMs = inferTimeFromExpirationTime(workInProgressRootLatestProcessedExpirationTime);
                        var currentTimeMs = now();
                        var timeUntilExpirationMs = expirationTimeToMs(expirationTime) - currentTimeMs;
                        var timeElapsed = currentTimeMs - eventTimeMs;
                        if (timeElapsed < 0) // We get this wrong some time since we estimate the time.
                        timeElapsed = 0;
                        _msUntilTimeout = jnd(timeElapsed) - timeElapsed; // Clamp the timeout to the expiration time. TODO: Once the
                        // event time is exact instead of inferred from expiration time
                        // we don't need this.
                        if (timeUntilExpirationMs < _msUntilTimeout) _msUntilTimeout = timeUntilExpirationMs;
                    } // Don't bother with a very short suspense time.
                    if (_msUntilTimeout > 10) {
                        // The render is suspended, it hasn't timed out, and there's no
                        // lower priority work to do. Instead of committing the fallback
                        // immediately, wait for more data to arrive.
                        root.timeoutHandle = scheduleTimeout(commitRoot.bind(null, root), _msUntilTimeout);
                        break;
                    }
                } // The work expired. Commit immediately.
                commitRoot(root);
                break;
            case RootCompleted:
                // The work completed. Ready to commit.
                if (!IsThisRendererActing.current && workInProgressRootLatestProcessedExpirationTime !== Sync && workInProgressRootCanSuspendUsingConfig !== null) {
                    // If we have exceeded the minimum loading delay, which probably
                    // means we have shown a spinner already, we might have to suspend
                    // a bit longer to ensure that the spinner is shown for
                    // enough time.
                    var _msUntilTimeout2 = computeMsUntilSuspenseLoadingDelay(workInProgressRootLatestProcessedExpirationTime, expirationTime, workInProgressRootCanSuspendUsingConfig);
                    if (_msUntilTimeout2 > 10) {
                        markRootSuspendedAtTime(root, expirationTime);
                        root.timeoutHandle = scheduleTimeout(commitRoot.bind(null, root), _msUntilTimeout2);
                        break;
                    }
                }
                commitRoot(root);
                break;
            default:
                throw Error("Unknown root exit status.");
        }
    } // This is the entry point for synchronous tasks that don't go
    // through Scheduler
    function performSyncWorkOnRoot(root) {
        // Check if there's expired work on this root. Otherwise, render at Sync.
        var lastExpiredTime = root.lastExpiredTime;
        var expirationTime = lastExpiredTime !== NoWork ? lastExpiredTime : Sync;
        if (!((executionContext & (RenderContext | CommitContext)) === NoContext)) throw Error("Should not already be working.");
        flushPassiveEffects(); // If the root or expiration time have changed, throw out the existing stack
        // and prepare a fresh one. Otherwise we'll continue where we left off.
        if (root !== workInProgressRoot || expirationTime !== renderExpirationTime$1) {
            prepareFreshStack(root, expirationTime);
            startWorkOnPendingInteractions(root, expirationTime);
        } // If we have a work-in-progress fiber, it means there's still work to do
        // in this root.
        if (workInProgress !== null) {
            var prevExecutionContext = executionContext;
            executionContext |= RenderContext;
            var prevDispatcher = pushDispatcher();
            var prevInteractions = pushInteractions(root);
            startWorkLoopTimer(workInProgress);
            for(;;)try {
                workLoopSync();
                break;
            } catch (thrownValue) {
                handleError(root, thrownValue);
            }
            resetContextDependencies();
            executionContext = prevExecutionContext;
            popDispatcher(prevDispatcher);
            popInteractions(prevInteractions);
            if (workInProgressRootExitStatus === RootFatalErrored) {
                var fatalError = workInProgressRootFatalError;
                stopInterruptedWorkLoopTimer();
                prepareFreshStack(root, expirationTime);
                markRootSuspendedAtTime(root, expirationTime);
                ensureRootIsScheduled(root);
                throw fatalError;
            }
            if (workInProgress !== null) throw Error("Cannot commit an incomplete root. This error is likely caused by a bug in React. Please file an issue.");
            else {
                // We now have a consistent tree. Because this is a sync render, we
                // will commit it even if something suspended.
                stopFinishedWorkLoopTimer();
                root.finishedWork = root.current.alternate;
                root.finishedExpirationTime = expirationTime;
                finishSyncRender(root);
            } // Before exiting, make sure there's a callback scheduled for the next
            // pending level.
            ensureRootIsScheduled(root);
        }
        return null;
    }
    function finishSyncRender(root) {
        // Set this to null to indicate there's no in-progress render.
        workInProgressRoot = null;
        commitRoot(root);
    }
    function flushDiscreteUpdates() {
        // TODO: Should be able to flush inside batchedUpdates, but not inside `act`.
        // However, `act` uses `batchedUpdates`, so there's no way to distinguish
        // those two cases. Need to fix this before exposing flushDiscreteUpdates
        // as a public API.
        if ((executionContext & (BatchedContext | RenderContext | CommitContext)) !== NoContext) {
            if ((executionContext & RenderContext) !== NoContext) error("unstable_flushDiscreteUpdates: Cannot flush updates when React is already rendering.");
            // This is probably a nested event dispatch triggered by a lifecycle/effect,
            // like `el.focus()`. Exit.
            return;
        }
        flushPendingDiscreteUpdates(); // If the discrete updates scheduled passive effects, flush them now so that
        // they fire before the next serial event.
        flushPassiveEffects();
    }
    function syncUpdates(fn, a, b, c) {
        return runWithPriority$1(ImmediatePriority, fn.bind(null, a, b, c));
    }
    function flushPendingDiscreteUpdates() {
        if (rootsWithPendingDiscreteUpdates !== null) {
            // For each root with pending discrete updates, schedule a callback to
            // immediately flush them.
            var roots = rootsWithPendingDiscreteUpdates;
            rootsWithPendingDiscreteUpdates = null;
            roots.forEach(function(expirationTime, root) {
                markRootExpiredAtTime(root, expirationTime);
                ensureRootIsScheduled(root);
            }); // Now flush the immediate queue.
            flushSyncCallbackQueue();
        }
    }
    function batchedUpdates$1(fn, a) {
        var prevExecutionContext = executionContext;
        executionContext |= BatchedContext;
        try {
            return fn(a);
        } finally{
            executionContext = prevExecutionContext;
            if (executionContext === NoContext) // Flush the immediate callbacks that were scheduled during this batch
            flushSyncCallbackQueue();
        }
    }
    function batchedEventUpdates$1(fn, a) {
        var prevExecutionContext = executionContext;
        executionContext |= EventContext;
        try {
            return fn(a);
        } finally{
            executionContext = prevExecutionContext;
            if (executionContext === NoContext) // Flush the immediate callbacks that were scheduled during this batch
            flushSyncCallbackQueue();
        }
    }
    function discreteUpdates$1(fn, a, b, c, d) {
        var prevExecutionContext = executionContext;
        executionContext |= DiscreteEventContext;
        try {
            // Should this
            return runWithPriority$1(UserBlockingPriority$1, fn.bind(null, a, b, c, d));
        } finally{
            executionContext = prevExecutionContext;
            if (executionContext === NoContext) // Flush the immediate callbacks that were scheduled during this batch
            flushSyncCallbackQueue();
        }
    }
    function unbatchedUpdates(fn, a) {
        var prevExecutionContext = executionContext;
        executionContext &= ~BatchedContext;
        executionContext |= LegacyUnbatchedContext;
        try {
            return fn(a);
        } finally{
            executionContext = prevExecutionContext;
            if (executionContext === NoContext) // Flush the immediate callbacks that were scheduled during this batch
            flushSyncCallbackQueue();
        }
    }
    function flushSync(fn, a) {
        if ((executionContext & (RenderContext | CommitContext)) !== NoContext) throw Error("flushSync was called from inside a lifecycle method. It cannot be called when React is already rendering.");
        var prevExecutionContext = executionContext;
        executionContext |= BatchedContext;
        try {
            return runWithPriority$1(ImmediatePriority, fn.bind(null, a));
        } finally{
            executionContext = prevExecutionContext; // Flush the immediate callbacks that were scheduled during this batch.
            // Note that this will happen even if batchedUpdates is higher up
            // the stack.
            flushSyncCallbackQueue();
        }
    }
    function prepareFreshStack(root, expirationTime) {
        root.finishedWork = null;
        root.finishedExpirationTime = NoWork;
        var timeoutHandle = root.timeoutHandle;
        if (timeoutHandle !== noTimeout) {
            // The root previous suspended and scheduled a timeout to commit a fallback
            // state. Now that we have additional work, cancel the timeout.
            root.timeoutHandle = noTimeout; // $FlowFixMe Complains noTimeout is not a TimeoutID, despite the check above
            cancelTimeout(timeoutHandle);
        }
        if (workInProgress !== null) {
            var interruptedWork = workInProgress.return;
            while(interruptedWork !== null){
                unwindInterruptedWork(interruptedWork);
                interruptedWork = interruptedWork.return;
            }
        }
        workInProgressRoot = root;
        workInProgress = createWorkInProgress(root.current, null);
        renderExpirationTime$1 = expirationTime;
        workInProgressRootExitStatus = RootIncomplete;
        workInProgressRootFatalError = null;
        workInProgressRootLatestProcessedExpirationTime = Sync;
        workInProgressRootLatestSuspenseTimeout = Sync;
        workInProgressRootCanSuspendUsingConfig = null;
        workInProgressRootNextUnprocessedUpdateTime = NoWork;
        workInProgressRootHasPendingPing = false;
        spawnedWorkDuringRender = null;
        ReactStrictModeWarnings.discardPendingWarnings();
    }
    function handleError(root, thrownValue) {
        do {
            try {
                // Reset module-level state that was set during the render phase.
                resetContextDependencies();
                resetHooksAfterThrow();
                resetCurrentFiber();
                if (workInProgress === null || workInProgress.return === null) {
                    // Expected to be working on a non-root fiber. This is a fatal error
                    // because there's no ancestor that can handle it; the root is
                    // supposed to capture all errors that weren't caught by an error
                    // boundary.
                    workInProgressRootExitStatus = RootFatalErrored;
                    workInProgressRootFatalError = thrownValue; // Set `workInProgress` to null. This represents advancing to the next
                    // sibling, or the parent if there are no siblings. But since the root
                    // has no siblings nor a parent, we set it to null. Usually this is
                    // handled by `completeUnitOfWork` or `unwindWork`, but since we're
                    // interntionally not calling those, we need set it here.
                    // TODO: Consider calling `unwindWork` to pop the contexts.
                    workInProgress = null;
                    return null;
                }
                if (enableProfilerTimer && workInProgress.mode & ProfileMode) // Record the time spent rendering before an error was thrown. This
                // avoids inaccurate Profiler durations in the case of a
                // suspended render.
                stopProfilerTimerIfRunningAndRecordDelta(workInProgress, true);
                throwException(root, workInProgress.return, workInProgress, thrownValue, renderExpirationTime$1);
                workInProgress = completeUnitOfWork(workInProgress);
            } catch (yetAnotherThrownValue) {
                // Something in the return path also threw.
                thrownValue = yetAnotherThrownValue;
                continue;
            } // Return to the normal work loop.
            return;
        }while (true);
    }
    function pushDispatcher(root) {
        var prevDispatcher = ReactCurrentDispatcher$1.current;
        ReactCurrentDispatcher$1.current = ContextOnlyDispatcher;
        if (prevDispatcher === null) // The React isomorphic package does not include a default dispatcher.
        // Instead the first renderer will lazily attach one, in order to give
        // nicer error messages.
        return ContextOnlyDispatcher;
        else return prevDispatcher;
    }
    function popDispatcher(prevDispatcher) {
        ReactCurrentDispatcher$1.current = prevDispatcher;
    }
    function pushInteractions(root) {
        var prevInteractions = tracing.__interactionsRef.current;
        tracing.__interactionsRef.current = root.memoizedInteractions;
        return prevInteractions;
    }
    function popInteractions(prevInteractions) {
        tracing.__interactionsRef.current = prevInteractions;
    }
    function markCommitTimeOfFallback() {
        globalMostRecentFallbackTime = now();
    }
    function markRenderEventTimeAndConfig(expirationTime, suspenseConfig) {
        if (expirationTime < workInProgressRootLatestProcessedExpirationTime && expirationTime > Idle) workInProgressRootLatestProcessedExpirationTime = expirationTime;
        if (suspenseConfig !== null) {
            if (expirationTime < workInProgressRootLatestSuspenseTimeout && expirationTime > Idle) {
                workInProgressRootLatestSuspenseTimeout = expirationTime; // Most of the time we only have one config and getting wrong is not bad.
                workInProgressRootCanSuspendUsingConfig = suspenseConfig;
            }
        }
    }
    function markUnprocessedUpdateTime(expirationTime) {
        if (expirationTime > workInProgressRootNextUnprocessedUpdateTime) workInProgressRootNextUnprocessedUpdateTime = expirationTime;
    }
    function renderDidSuspend() {
        if (workInProgressRootExitStatus === RootIncomplete) workInProgressRootExitStatus = RootSuspended;
    }
    function renderDidSuspendDelayIfPossible() {
        if (workInProgressRootExitStatus === RootIncomplete || workInProgressRootExitStatus === RootSuspended) workInProgressRootExitStatus = RootSuspendedWithDelay;
         // Check if there's a lower priority update somewhere else in the tree.
        if (workInProgressRootNextUnprocessedUpdateTime !== NoWork && workInProgressRoot !== null) {
            // Mark the current render as suspended, and then mark that there's a
            // pending update.
            // TODO: This should immediately interrupt the current render, instead
            // of waiting until the next time we yield.
            markRootSuspendedAtTime(workInProgressRoot, renderExpirationTime$1);
            markRootUpdatedAtTime(workInProgressRoot, workInProgressRootNextUnprocessedUpdateTime);
        }
    }
    function renderDidError() {
        if (workInProgressRootExitStatus !== RootCompleted) workInProgressRootExitStatus = RootErrored;
    } // Called during render to determine if anything has suspended.
    // Returns false if we're not sure.
    function renderHasNotSuspendedYet() {
        // If something errored or completed, we can't really be sure,
        // so those are false.
        return workInProgressRootExitStatus === RootIncomplete;
    }
    function inferTimeFromExpirationTime(expirationTime) {
        // We don't know exactly when the update was scheduled, but we can infer an
        // approximate start time from the expiration time.
        var earliestExpirationTimeMs = expirationTimeToMs(expirationTime);
        return earliestExpirationTimeMs - LOW_PRIORITY_EXPIRATION;
    }
    function inferTimeFromExpirationTimeWithSuspenseConfig(expirationTime, suspenseConfig) {
        // We don't know exactly when the update was scheduled, but we can infer an
        // approximate start time from the expiration time by subtracting the timeout
        // that was added to the event time.
        var earliestExpirationTimeMs = expirationTimeToMs(expirationTime);
        return earliestExpirationTimeMs - (suspenseConfig.timeoutMs | 0 || LOW_PRIORITY_EXPIRATION);
    } // The work loop is an extremely hot path. Tell Closure not to inline it.
    /** @noinline */ function workLoopSync() {
        // Already timed out, so perform work without checking if we need to yield.
        while(workInProgress !== null)workInProgress = performUnitOfWork(workInProgress);
    }
    /** @noinline */ function workLoopConcurrent() {
        // Perform work until Scheduler asks us to yield
        while(workInProgress !== null && !shouldYield())workInProgress = performUnitOfWork(workInProgress);
    }
    function performUnitOfWork(unitOfWork) {
        // The current, flushed, state of this fiber is the alternate. Ideally
        // nothing should rely on this, but relying on it here means that we don't
        // need an additional field on the work in progress.
        var current = unitOfWork.alternate;
        startWorkTimer(unitOfWork);
        setCurrentFiber(unitOfWork);
        var next;
        if ((unitOfWork.mode & ProfileMode) !== NoMode) {
            startProfilerTimer(unitOfWork);
            next = beginWork$1(current, unitOfWork, renderExpirationTime$1);
            stopProfilerTimerIfRunningAndRecordDelta(unitOfWork, true);
        } else next = beginWork$1(current, unitOfWork, renderExpirationTime$1);
        resetCurrentFiber();
        unitOfWork.memoizedProps = unitOfWork.pendingProps;
        if (next === null) // If this doesn't spawn new work, complete the current work.
        next = completeUnitOfWork(unitOfWork);
        ReactCurrentOwner$2.current = null;
        return next;
    }
    function completeUnitOfWork(unitOfWork) {
        // Attempt to complete the current unit of work, then move to the next
        // sibling. If there are no more siblings, return to the parent fiber.
        workInProgress = unitOfWork;
        do {
            // The current, flushed, state of this fiber is the alternate. Ideally
            // nothing should rely on this, but relying on it here means that we don't
            // need an additional field on the work in progress.
            var current = workInProgress.alternate;
            var returnFiber = workInProgress.return; // Check if the work completed or if something threw.
            if ((workInProgress.effectTag & Incomplete) === NoEffect) {
                setCurrentFiber(workInProgress);
                var next = void 0;
                if ((workInProgress.mode & ProfileMode) === NoMode) next = completeWork(current, workInProgress, renderExpirationTime$1);
                else {
                    startProfilerTimer(workInProgress);
                    next = completeWork(current, workInProgress, renderExpirationTime$1); // Update render duration assuming we didn't error.
                    stopProfilerTimerIfRunningAndRecordDelta(workInProgress, false);
                }
                stopWorkTimer(workInProgress);
                resetCurrentFiber();
                resetChildExpirationTime(workInProgress);
                if (next !== null) // Completing this fiber spawned new work. Work on that next.
                return next;
                if (returnFiber !== null && // Do not append effects to parents if a sibling failed to complete
                (returnFiber.effectTag & Incomplete) === NoEffect) {
                    // Append all the effects of the subtree and this fiber onto the effect
                    // list of the parent. The completion order of the children affects the
                    // side-effect order.
                    if (returnFiber.firstEffect === null) returnFiber.firstEffect = workInProgress.firstEffect;
                    if (workInProgress.lastEffect !== null) {
                        if (returnFiber.lastEffect !== null) returnFiber.lastEffect.nextEffect = workInProgress.firstEffect;
                        returnFiber.lastEffect = workInProgress.lastEffect;
                    } // If this fiber had side-effects, we append it AFTER the children's
                    // side-effects. We can perform certain side-effects earlier if needed,
                    // by doing multiple passes over the effect list. We don't want to
                    // schedule our own side-effect on our own list because if end up
                    // reusing children we'll schedule this effect onto itself since we're
                    // at the end.
                    var effectTag = workInProgress.effectTag; // Skip both NoWork and PerformedWork tags when creating the effect
                    // list. PerformedWork effect is read by React DevTools but shouldn't be
                    // committed.
                    if (effectTag > PerformedWork) {
                        if (returnFiber.lastEffect !== null) returnFiber.lastEffect.nextEffect = workInProgress;
                        else returnFiber.firstEffect = workInProgress;
                        returnFiber.lastEffect = workInProgress;
                    }
                }
            } else {
                // This fiber did not complete because something threw. Pop values off
                // the stack without entering the complete phase. If this is a boundary,
                // capture values if possible.
                var _next = unwindWork(workInProgress); // Because this fiber did not complete, don't reset its expiration time.
                if ((workInProgress.mode & ProfileMode) !== NoMode) {
                    // Record the render duration for the fiber that errored.
                    stopProfilerTimerIfRunningAndRecordDelta(workInProgress, false); // Include the time spent working on failed children before continuing.
                    var actualDuration = workInProgress.actualDuration;
                    var child = workInProgress.child;
                    while(child !== null){
                        actualDuration += child.actualDuration;
                        child = child.sibling;
                    }
                    workInProgress.actualDuration = actualDuration;
                }
                if (_next !== null) {
                    // If completing this work spawned new work, do that next. We'll come
                    // back here again.
                    // Since we're restarting, remove anything that is not a host effect
                    // from the effect tag.
                    // TODO: The name stopFailedWorkTimer is misleading because Suspense
                    // also captures and restarts.
                    stopFailedWorkTimer(workInProgress);
                    _next.effectTag &= HostEffectMask;
                    return _next;
                }
                stopWorkTimer(workInProgress);
                if (returnFiber !== null) {
                    // Mark the parent fiber as incomplete and clear its effect list.
                    returnFiber.firstEffect = returnFiber.lastEffect = null;
                    returnFiber.effectTag |= Incomplete;
                }
            }
            var siblingFiber = workInProgress.sibling;
            if (siblingFiber !== null) // If there is more work to do in this returnFiber, do that next.
            return siblingFiber;
             // Otherwise, return to the parent
            workInProgress = returnFiber;
        }while (workInProgress !== null); // We've reached the root.
        if (workInProgressRootExitStatus === RootIncomplete) workInProgressRootExitStatus = RootCompleted;
        return null;
    }
    function getRemainingExpirationTime(fiber) {
        var updateExpirationTime = fiber.expirationTime;
        var childExpirationTime = fiber.childExpirationTime;
        return updateExpirationTime > childExpirationTime ? updateExpirationTime : childExpirationTime;
    }
    function resetChildExpirationTime(completedWork) {
        if (renderExpirationTime$1 !== Never && completedWork.childExpirationTime === Never) // The children of this component are hidden. Don't bubble their
        // expiration times.
        return;
        var newChildExpirationTime = NoWork; // Bubble up the earliest expiration time.
        if ((completedWork.mode & ProfileMode) !== NoMode) {
            // In profiling mode, resetChildExpirationTime is also used to reset
            // profiler durations.
            var actualDuration = completedWork.actualDuration;
            var treeBaseDuration = completedWork.selfBaseDuration; // When a fiber is cloned, its actualDuration is reset to 0. This value will
            // only be updated if work is done on the fiber (i.e. it doesn't bailout).
            // When work is done, it should bubble to the parent's actualDuration. If
            // the fiber has not been cloned though, (meaning no work was done), then
            // this value will reflect the amount of time spent working on a previous
            // render. In that case it should not bubble. We determine whether it was
            // cloned by comparing the child pointer.
            var shouldBubbleActualDurations = completedWork.alternate === null || completedWork.child !== completedWork.alternate.child;
            var child = completedWork.child;
            while(child !== null){
                var childUpdateExpirationTime = child.expirationTime;
                var childChildExpirationTime = child.childExpirationTime;
                if (childUpdateExpirationTime > newChildExpirationTime) newChildExpirationTime = childUpdateExpirationTime;
                if (childChildExpirationTime > newChildExpirationTime) newChildExpirationTime = childChildExpirationTime;
                if (shouldBubbleActualDurations) actualDuration += child.actualDuration;
                treeBaseDuration += child.treeBaseDuration;
                child = child.sibling;
            }
            completedWork.actualDuration = actualDuration;
            completedWork.treeBaseDuration = treeBaseDuration;
        } else {
            var _child = completedWork.child;
            while(_child !== null){
                var _childUpdateExpirationTime = _child.expirationTime;
                var _childChildExpirationTime = _child.childExpirationTime;
                if (_childUpdateExpirationTime > newChildExpirationTime) newChildExpirationTime = _childUpdateExpirationTime;
                if (_childChildExpirationTime > newChildExpirationTime) newChildExpirationTime = _childChildExpirationTime;
                _child = _child.sibling;
            }
        }
        completedWork.childExpirationTime = newChildExpirationTime;
    }
    function commitRoot(root) {
        var renderPriorityLevel = getCurrentPriorityLevel();
        runWithPriority$1(ImmediatePriority, commitRootImpl.bind(null, root, renderPriorityLevel));
        return null;
    }
    function commitRootImpl(root, renderPriorityLevel) {
        do // `flushPassiveEffects` will call `flushSyncUpdateQueue` at the end, which
        // means `flushPassiveEffects` will sometimes result in additional
        // passive effects. So we need to keep flushing in a loop until there are
        // no more pending effects.
        // TODO: Might be better if `flushPassiveEffects` did not automatically
        // flush synchronous work at the end, to avoid factoring hazards like this.
        flushPassiveEffects();
        while (rootWithPendingPassiveEffects !== null);
        flushRenderPhaseStrictModeWarningsInDEV();
        if (!((executionContext & (RenderContext | CommitContext)) === NoContext)) throw Error("Should not already be working.");
        var finishedWork = root.finishedWork;
        var expirationTime = root.finishedExpirationTime;
        if (finishedWork === null) return null;
        root.finishedWork = null;
        root.finishedExpirationTime = NoWork;
        if (!(finishedWork !== root.current)) throw Error("Cannot commit the same tree as before. This error is likely caused by a bug in React. Please file an issue.");
         // commitRoot never returns a continuation; it always finishes synchronously.
        // So we can clear these now to allow a new callback to be scheduled.
        root.callbackNode = null;
        root.callbackExpirationTime = NoWork;
        root.callbackPriority = NoPriority;
        root.nextKnownPendingLevel = NoWork;
        startCommitTimer(); // Update the first and last pending times on this root. The new first
        // pending time is whatever is left on the root fiber.
        var remainingExpirationTimeBeforeCommit = getRemainingExpirationTime(finishedWork);
        markRootFinishedAtTime(root, expirationTime, remainingExpirationTimeBeforeCommit);
        if (root === workInProgressRoot) {
            // We can reset these now that they are finished.
            workInProgressRoot = null;
            workInProgress = null;
            renderExpirationTime$1 = NoWork;
        } // This indicates that the last root we worked on is not the same one that
        // we're committing now. This most commonly happens when a suspended root
        // times out.
        // Get the list of effects.
        var firstEffect;
        if (finishedWork.effectTag > PerformedWork) {
            // A fiber's effect list consists only of its children, not itself. So if
            // the root has an effect, we need to add it to the end of the list. The
            // resulting list is the set that would belong to the root's parent, if it
            // had one; that is, all the effects in the tree including the root.
            if (finishedWork.lastEffect !== null) {
                finishedWork.lastEffect.nextEffect = finishedWork;
                firstEffect = finishedWork.firstEffect;
            } else firstEffect = finishedWork;
        } else // There is no effect on the root.
        firstEffect = finishedWork.firstEffect;
        if (firstEffect !== null) {
            var prevExecutionContext = executionContext;
            executionContext |= CommitContext;
            var prevInteractions = pushInteractions(root); // Reset this to null before calling lifecycles
            ReactCurrentOwner$2.current = null; // The commit phase is broken into several sub-phases. We do a separate pass
            // of the effect list for each phase: all mutation effects come before all
            // layout effects, and so on.
            // The first phase a "before mutation" phase. We use this phase to read the
            // state of the host tree right before we mutate it. This is where
            // getSnapshotBeforeUpdate is called.
            startCommitSnapshotEffectsTimer();
            prepareForCommit(root.containerInfo);
            nextEffect = firstEffect;
            do {
                invokeGuardedCallback(null, commitBeforeMutationEffects, null);
                if (hasCaughtError()) {
                    if (!(nextEffect !== null)) throw Error("Should be working on an effect.");
                    var error = clearCaughtError();
                    captureCommitPhaseError(nextEffect, error);
                    nextEffect = nextEffect.nextEffect;
                }
            }while (nextEffect !== null);
            stopCommitSnapshotEffectsTimer();
            // Mark the current commit time to be shared by all Profilers in this
            // batch. This enables them to be grouped later.
            recordCommitTime();
            startCommitHostEffectsTimer();
            nextEffect = firstEffect;
            do {
                invokeGuardedCallback(null, commitMutationEffects, null, root, renderPriorityLevel);
                if (hasCaughtError()) {
                    if (!(nextEffect !== null)) throw Error("Should be working on an effect.");
                    var _error = clearCaughtError();
                    captureCommitPhaseError(nextEffect, _error);
                    nextEffect = nextEffect.nextEffect;
                }
            }while (nextEffect !== null);
            stopCommitHostEffectsTimer();
            resetAfterCommit(root.containerInfo); // The work-in-progress tree is now the current tree. This must come after
            // the mutation phase, so that the previous tree is still current during
            // componentWillUnmount, but before the layout phase, so that the finished
            // work is current during componentDidMount/Update.
            root.current = finishedWork; // The next phase is the layout phase, where we call effects that read
            // the host tree after it's been mutated. The idiomatic use case for this is
            // layout, but class component lifecycles also fire here for legacy reasons.
            startCommitLifeCyclesTimer();
            nextEffect = firstEffect;
            do {
                invokeGuardedCallback(null, commitLayoutEffects, null, root, expirationTime);
                if (hasCaughtError()) {
                    if (!(nextEffect !== null)) throw Error("Should be working on an effect.");
                    var _error2 = clearCaughtError();
                    captureCommitPhaseError(nextEffect, _error2);
                    nextEffect = nextEffect.nextEffect;
                }
            }while (nextEffect !== null);
            stopCommitLifeCyclesTimer();
            nextEffect = null; // Tell Scheduler to yield at the end of the frame, so the browser has an
            // opportunity to paint.
            requestPaint();
            popInteractions(prevInteractions);
            executionContext = prevExecutionContext;
        } else {
            // No effects.
            root.current = finishedWork; // Measure these anyway so the flamegraph explicitly shows that there were
            // no effects.
            // TODO: Maybe there's a better way to report this.
            startCommitSnapshotEffectsTimer();
            stopCommitSnapshotEffectsTimer();
            recordCommitTime();
            startCommitHostEffectsTimer();
            stopCommitHostEffectsTimer();
            startCommitLifeCyclesTimer();
            stopCommitLifeCyclesTimer();
        }
        stopCommitTimer();
        var rootDidHavePassiveEffects = rootDoesHavePassiveEffects;
        if (rootDoesHavePassiveEffects) {
            // This commit has passive effects. Stash a reference to them. But don't
            // schedule a callback until after flushing layout work.
            rootDoesHavePassiveEffects = false;
            rootWithPendingPassiveEffects = root;
            pendingPassiveEffectsExpirationTime = expirationTime;
            pendingPassiveEffectsRenderPriority = renderPriorityLevel;
        } else {
            // We are done with the effect chain at this point so let's clear the
            // nextEffect pointers to assist with GC. If we have passive effects, we'll
            // clear this in flushPassiveEffects.
            nextEffect = firstEffect;
            while(nextEffect !== null){
                var nextNextEffect = nextEffect.nextEffect;
                nextEffect.nextEffect = null;
                nextEffect = nextNextEffect;
            }
        } // Check if there's remaining work on this root
        var remainingExpirationTime = root.firstPendingTime;
        if (remainingExpirationTime !== NoWork) {
            if (spawnedWorkDuringRender !== null) {
                var expirationTimes = spawnedWorkDuringRender;
                spawnedWorkDuringRender = null;
                for(var i = 0; i < expirationTimes.length; i++)scheduleInteractions(root, expirationTimes[i], root.memoizedInteractions);
            }
            schedulePendingInteractions(root, remainingExpirationTime);
        } else // If there's no remaining work, we can clear the set of already failed
        // error boundaries.
        legacyErrorBoundariesThatAlreadyFailed = null;
        if (!rootDidHavePassiveEffects) // If there are no passive effects, then we can complete the pending interactions.
        // Otherwise, we'll wait until after the passive effects are flushed.
        // Wait to do this until after remaining work has been scheduled,
        // so that we don't prematurely signal complete for interactions when there's e.g. hidden work.
        finishPendingInteractions(root, expirationTime);
        if (remainingExpirationTime === Sync) {
            // Count the number of times the root synchronously re-renders without
            // finishing. If there are too many, it indicates an infinite update loop.
            if (root === rootWithNestedUpdates) nestedUpdateCount++;
            else {
                nestedUpdateCount = 0;
                rootWithNestedUpdates = root;
            }
        } else nestedUpdateCount = 0;
        onCommitRoot(finishedWork.stateNode, expirationTime); // Always call this before exiting `commitRoot`, to ensure that any
        // additional work on this root is scheduled.
        ensureRootIsScheduled(root);
        if (hasUncaughtError) {
            hasUncaughtError = false;
            var _error3 = firstUncaughtError;
            firstUncaughtError = null;
            throw _error3;
        }
        if ((executionContext & LegacyUnbatchedContext) !== NoContext) // This is a legacy edge case. We just committed the initial mount of
        // a ReactDOM.render-ed root inside of batchedUpdates. The commit fired
        // synchronously, but layout updates should be deferred until the end
        // of the batch.
        return null;
         // If layout work was scheduled, flush it now.
        flushSyncCallbackQueue();
        return null;
    }
    function commitBeforeMutationEffects() {
        while(nextEffect !== null){
            var effectTag = nextEffect.effectTag;
            if ((effectTag & Snapshot) !== NoEffect) {
                setCurrentFiber(nextEffect);
                recordEffect();
                var current = nextEffect.alternate;
                commitBeforeMutationLifeCycles(current, nextEffect);
                resetCurrentFiber();
            }
            if ((effectTag & Passive) !== NoEffect) // If there are passive effects, schedule a callback to flush at
            // the earliest opportunity.
            {
                if (!rootDoesHavePassiveEffects) {
                    rootDoesHavePassiveEffects = true;
                    scheduleCallback(NormalPriority, function() {
                        flushPassiveEffects();
                        return null;
                    });
                }
            }
            nextEffect = nextEffect.nextEffect;
        }
    }
    function commitMutationEffects(root, renderPriorityLevel) {
        // TODO: Should probably move the bulk of this function to commitWork.
        while(nextEffect !== null){
            setCurrentFiber(nextEffect);
            var effectTag = nextEffect.effectTag;
            if (effectTag & ContentReset) commitResetTextContent(nextEffect);
            if (effectTag & Ref) {
                var current = nextEffect.alternate;
                if (current !== null) commitDetachRef(current);
            } // The following switch statement is only concerned about placement,
            // updates, and deletions. To avoid needing to add a case for every possible
            // bitmap value, we remove the secondary effects from the effect tag and
            // switch on that value.
            var primaryEffectTag = effectTag & (Placement | Update | Deletion | Hydrating);
            switch(primaryEffectTag){
                case Placement:
                    commitPlacement(nextEffect); // Clear the "placement" from effect tag so that we know that this is
                    // inserted, before any life-cycles like componentDidMount gets called.
                    // TODO: findDOMNode doesn't rely on this any more but isMounted does
                    // and isMounted is deprecated anyway so we should be able to kill this.
                    nextEffect.effectTag &= ~Placement;
                    break;
                case PlacementAndUpdate:
                    // Placement
                    commitPlacement(nextEffect); // Clear the "placement" from effect tag so that we know that this is
                    // inserted, before any life-cycles like componentDidMount gets called.
                    nextEffect.effectTag &= ~Placement; // Update
                    var _current = nextEffect.alternate;
                    commitWork(_current, nextEffect);
                    break;
                case Hydrating:
                    nextEffect.effectTag &= ~Hydrating;
                    break;
                case HydratingAndUpdate:
                    nextEffect.effectTag &= ~Hydrating; // Update
                    var _current2 = nextEffect.alternate;
                    commitWork(_current2, nextEffect);
                    break;
                case Update:
                    var _current3 = nextEffect.alternate;
                    commitWork(_current3, nextEffect);
                    break;
                case Deletion:
                    commitDeletion(root, nextEffect, renderPriorityLevel);
                    break;
            } // TODO: Only record a mutation effect if primaryEffectTag is non-zero.
            recordEffect();
            resetCurrentFiber();
            nextEffect = nextEffect.nextEffect;
        }
    }
    function commitLayoutEffects(root, committedExpirationTime) {
        // TODO: Should probably move the bulk of this function to commitWork.
        while(nextEffect !== null){
            setCurrentFiber(nextEffect);
            var effectTag = nextEffect.effectTag;
            if (effectTag & (Update | Callback)) {
                recordEffect();
                var current = nextEffect.alternate;
                commitLifeCycles(root, current, nextEffect);
            }
            if (effectTag & Ref) {
                recordEffect();
                commitAttachRef(nextEffect);
            }
            resetCurrentFiber();
            nextEffect = nextEffect.nextEffect;
        }
    }
    function flushPassiveEffects() {
        if (pendingPassiveEffectsRenderPriority !== NoPriority) {
            var priorityLevel = pendingPassiveEffectsRenderPriority > NormalPriority ? NormalPriority : pendingPassiveEffectsRenderPriority;
            pendingPassiveEffectsRenderPriority = NoPriority;
            return runWithPriority$1(priorityLevel, flushPassiveEffectsImpl);
        }
    }
    function flushPassiveEffectsImpl() {
        if (rootWithPendingPassiveEffects === null) return false;
        var root = rootWithPendingPassiveEffects;
        var expirationTime = pendingPassiveEffectsExpirationTime;
        rootWithPendingPassiveEffects = null;
        pendingPassiveEffectsExpirationTime = NoWork;
        if (!((executionContext & (RenderContext | CommitContext)) === NoContext)) throw Error("Cannot flush passive effects while already rendering.");
        var prevExecutionContext = executionContext;
        executionContext |= CommitContext;
        var prevInteractions = pushInteractions(root);
        // Note: This currently assumes there are no passive effects on the root fiber
        // because the root is not part of its own effect list.
        // This could change in the future.
        var _effect2 = root.current.firstEffect;
        while(_effect2 !== null){
            setCurrentFiber(_effect2);
            invokeGuardedCallback(null, commitPassiveHookEffects, null, _effect2);
            if (hasCaughtError()) {
                if (!(_effect2 !== null)) throw Error("Should be working on an effect.");
                var _error5 = clearCaughtError();
                captureCommitPhaseError(_effect2, _error5);
            }
            resetCurrentFiber();
            var nextNextEffect = _effect2.nextEffect; // Remove nextEffect pointer to assist GC
            _effect2.nextEffect = null;
            _effect2 = nextNextEffect;
        }
        popInteractions(prevInteractions);
        finishPendingInteractions(root, expirationTime);
        executionContext = prevExecutionContext;
        flushSyncCallbackQueue(); // If additional passive effects were scheduled, increment a counter. If this
        // exceeds the limit, we'll fire a warning.
        nestedPassiveUpdateCount = rootWithPendingPassiveEffects === null ? 0 : nestedPassiveUpdateCount + 1;
        return true;
    }
    function isAlreadyFailedLegacyErrorBoundary(instance) {
        return legacyErrorBoundariesThatAlreadyFailed !== null && legacyErrorBoundariesThatAlreadyFailed.has(instance);
    }
    function markLegacyErrorBoundaryAsFailed(instance) {
        if (legacyErrorBoundariesThatAlreadyFailed === null) legacyErrorBoundariesThatAlreadyFailed = new Set([
            instance
        ]);
        else legacyErrorBoundariesThatAlreadyFailed.add(instance);
    }
    function prepareToThrowUncaughtError(error) {
        if (!hasUncaughtError) {
            hasUncaughtError = true;
            firstUncaughtError = error;
        }
    }
    var onUncaughtError = prepareToThrowUncaughtError;
    function captureCommitPhaseErrorOnRoot(rootFiber, sourceFiber, error) {
        var errorInfo = createCapturedValue(error, sourceFiber);
        var update = createRootErrorUpdate(rootFiber, errorInfo, Sync);
        enqueueUpdate(rootFiber, update);
        var root = markUpdateTimeFromFiberToRoot(rootFiber, Sync);
        if (root !== null) {
            ensureRootIsScheduled(root);
            schedulePendingInteractions(root, Sync);
        }
    }
    function captureCommitPhaseError(sourceFiber, error) {
        if (sourceFiber.tag === HostRoot) {
            // Error was thrown at the root. There is no parent, so the root
            // itself should capture it.
            captureCommitPhaseErrorOnRoot(sourceFiber, sourceFiber, error);
            return;
        }
        var fiber = sourceFiber.return;
        while(fiber !== null){
            if (fiber.tag === HostRoot) {
                captureCommitPhaseErrorOnRoot(fiber, sourceFiber, error);
                return;
            } else if (fiber.tag === ClassComponent) {
                var ctor = fiber.type;
                var instance = fiber.stateNode;
                if (typeof ctor.getDerivedStateFromError === "function" || typeof instance.componentDidCatch === "function" && !isAlreadyFailedLegacyErrorBoundary(instance)) {
                    var errorInfo = createCapturedValue(error, sourceFiber);
                    var update = createClassErrorUpdate(fiber, errorInfo, Sync);
                    enqueueUpdate(fiber, update);
                    var root = markUpdateTimeFromFiberToRoot(fiber, Sync);
                    if (root !== null) {
                        ensureRootIsScheduled(root);
                        schedulePendingInteractions(root, Sync);
                    }
                    return;
                }
            }
            fiber = fiber.return;
        }
    }
    function pingSuspendedRoot(root, thenable, suspendedTime) {
        var pingCache = root.pingCache;
        if (pingCache !== null) // The thenable resolved, so we no longer need to memoize, because it will
        // never be thrown again.
        pingCache.delete(thenable);
        if (workInProgressRoot === root && renderExpirationTime$1 === suspendedTime) {
            // Received a ping at the same priority level at which we're currently
            // rendering. We might want to restart this render. This should mirror
            // the logic of whether or not a root suspends once it completes.
            // TODO: If we're rendering sync either due to Sync, Batched or expired,
            // we should probably never restart.
            // If we're suspended with delay, we'll always suspend so we can always
            // restart. If we're suspended without any updates, it might be a retry.
            // If it's early in the retry we can restart. We can't know for sure
            // whether we'll eventually process an update during this render pass,
            // but it's somewhat unlikely that we get to a ping before that, since
            // getting to the root most update is usually very fast.
            if (workInProgressRootExitStatus === RootSuspendedWithDelay || workInProgressRootExitStatus === RootSuspended && workInProgressRootLatestProcessedExpirationTime === Sync && now() - globalMostRecentFallbackTime < FALLBACK_THROTTLE_MS) // Restart from the root. Don't need to schedule a ping because
            // we're already working on this tree.
            prepareFreshStack(root, renderExpirationTime$1);
            else // Even though we can't restart right now, we might get an
            // opportunity later. So we mark this render as having a ping.
            workInProgressRootHasPendingPing = true;
            return;
        }
        if (!isRootSuspendedAtTime(root, suspendedTime)) // The root is no longer suspended at this time.
        return;
        var lastPingedTime = root.lastPingedTime;
        if (lastPingedTime !== NoWork && lastPingedTime < suspendedTime) // There's already a lower priority ping scheduled.
        return;
         // Mark the time at which this ping was scheduled.
        root.lastPingedTime = suspendedTime;
        ensureRootIsScheduled(root);
        schedulePendingInteractions(root, suspendedTime);
    }
    function retryTimedOutBoundary(boundaryFiber, retryTime) {
        // The boundary fiber (a Suspense component or SuspenseList component)
        // previously was rendered in its fallback state. One of the promises that
        // suspended it has resolved, which means at least part of the tree was
        // likely unblocked. Try rendering again, at a new expiration time.
        if (retryTime === NoWork) {
            var suspenseConfig = null; // Retries don't carry over the already committed update.
            var currentTime = requestCurrentTimeForUpdate();
            retryTime = computeExpirationForFiber(currentTime, boundaryFiber, suspenseConfig);
        } // TODO: Special case idle priority?
        var root = markUpdateTimeFromFiberToRoot(boundaryFiber, retryTime);
        if (root !== null) {
            ensureRootIsScheduled(root);
            schedulePendingInteractions(root, retryTime);
        }
    }
    function resolveRetryThenable(boundaryFiber, thenable) {
        var retryTime = NoWork; // Default
        var retryCache;
        retryCache = boundaryFiber.stateNode;
        if (retryCache !== null) // The thenable resolved, so we no longer need to memoize, because it will
        // never be thrown again.
        retryCache.delete(thenable);
        retryTimedOutBoundary(boundaryFiber, retryTime);
    } // Computes the next Just Noticeable Difference (JND) boundary.
    // The theory is that a person can't tell the difference between small differences in time.
    // Therefore, if we wait a bit longer than necessary that won't translate to a noticeable
    // difference in the experience. However, waiting for longer might mean that we can avoid
    // showing an intermediate loading state. The longer we have already waited, the harder it
    // is to tell small differences in time. Therefore, the longer we've already waited,
    // the longer we can wait additionally. At some point we have to give up though.
    // We pick a train model where the next boundary commits at a consistent schedule.
    // These particular numbers are vague estimates. We expect to adjust them based on research.
    function jnd(timeElapsed) {
        return timeElapsed < 120 ? 120 : timeElapsed < 480 ? 480 : timeElapsed < 1080 ? 1080 : timeElapsed < 1920 ? 1920 : timeElapsed < 3000 ? 3000 : timeElapsed < 4320 ? 4320 : ceil(timeElapsed / 1960) * 1960;
    }
    function computeMsUntilSuspenseLoadingDelay(mostRecentEventTime, committedExpirationTime, suspenseConfig) {
        var busyMinDurationMs = suspenseConfig.busyMinDurationMs | 0;
        if (busyMinDurationMs <= 0) return 0;
        var busyDelayMs = suspenseConfig.busyDelayMs | 0; // Compute the time until this render pass would expire.
        var currentTimeMs = now();
        var eventTimeMs = inferTimeFromExpirationTimeWithSuspenseConfig(mostRecentEventTime, suspenseConfig);
        var timeElapsed = currentTimeMs - eventTimeMs;
        if (timeElapsed <= busyDelayMs) // If we haven't yet waited longer than the initial delay, we don't
        // have to wait any additional time.
        return 0;
        var msUntilTimeout = busyDelayMs + busyMinDurationMs - timeElapsed; // This is the value that is passed to `setTimeout`.
        return msUntilTimeout;
    }
    function checkForNestedUpdates() {
        if (nestedUpdateCount > NESTED_UPDATE_LIMIT) {
            nestedUpdateCount = 0;
            rootWithNestedUpdates = null;
            throw Error("Maximum update depth exceeded. This can happen when a component repeatedly calls setState inside componentWillUpdate or componentDidUpdate. React limits the number of nested updates to prevent infinite loops.");
        }
        if (nestedPassiveUpdateCount > NESTED_PASSIVE_UPDATE_LIMIT) {
            nestedPassiveUpdateCount = 0;
            error("Maximum update depth exceeded. This can happen when a component calls setState inside useEffect, but useEffect either doesn't have a dependency array, or one of the dependencies changes on every render.");
        }
    }
    function flushRenderPhaseStrictModeWarningsInDEV() {
        ReactStrictModeWarnings.flushLegacyContextWarning();
        ReactStrictModeWarnings.flushPendingUnsafeLifecycleWarnings();
    }
    function stopFinishedWorkLoopTimer() {
        var didCompleteRoot = true;
        stopWorkLoopTimer(interruptedBy, didCompleteRoot);
        interruptedBy = null;
    }
    function stopInterruptedWorkLoopTimer() {
        // TODO: Track which fiber caused the interruption.
        var didCompleteRoot = false;
        stopWorkLoopTimer(interruptedBy, didCompleteRoot);
        interruptedBy = null;
    }
    function checkForInterruption(fiberThatReceivedUpdate, updateExpirationTime) {
        if (workInProgressRoot !== null && updateExpirationTime > renderExpirationTime$1) interruptedBy = fiberThatReceivedUpdate;
    }
    var didWarnStateUpdateForUnmountedComponent = null;
    function warnAboutUpdateOnUnmountedFiberInDEV(fiber) {
        var tag = fiber.tag;
        if (tag !== HostRoot && tag !== ClassComponent && tag !== FunctionComponent && tag !== ForwardRef && tag !== MemoComponent && tag !== SimpleMemoComponent && tag !== Block) // Only warn for user-defined components, not internal ones like Suspense.
        return;
        // the problematic code almost always lies inside that component.
        var componentName = getComponentName(fiber.type) || "ReactComponent";
        if (didWarnStateUpdateForUnmountedComponent !== null) {
            if (didWarnStateUpdateForUnmountedComponent.has(componentName)) return;
            didWarnStateUpdateForUnmountedComponent.add(componentName);
        } else didWarnStateUpdateForUnmountedComponent = new Set([
            componentName
        ]);
        error("Can't perform a React state update on an unmounted component. This is a no-op, but it indicates a memory leak in your application. To fix, cancel all subscriptions and asynchronous tasks in %s.%s", tag === ClassComponent ? "the componentWillUnmount method" : "a useEffect cleanup function", getStackByFiberInDevAndProd(fiber));
    }
    var beginWork$1;
    var dummyFiber = null;
    beginWork$1 = function(current, unitOfWork, expirationTime) {
        // If a component throws an error, we replay it again in a synchronously
        // dispatched event, so that the debugger will treat it as an uncaught
        // error See ReactErrorUtils for more information.
        // Before entering the begin phase, copy the work-in-progress onto a dummy
        // fiber. If beginWork throws, we'll use this to reset the state.
        var originalWorkInProgressCopy = assignFiberPropertiesInDEV(dummyFiber, unitOfWork);
        try {
            return beginWork(current, unitOfWork, expirationTime);
        } catch (originalError) {
            if (originalError !== null && typeof originalError === "object" && typeof originalError.then === "function") // Don't replay promises. Treat everything else like an error.
            throw originalError;
             // Keep this code in sync with handleError; any changes here must have
            // corresponding changes there.
            resetContextDependencies();
            resetHooksAfterThrow(); // Don't reset current debug fiber, since we're about to work on the
            // same fiber again.
            // Unwind the failed stack frame
            unwindInterruptedWork(unitOfWork); // Restore the original properties of the fiber.
            assignFiberPropertiesInDEV(unitOfWork, originalWorkInProgressCopy);
            if (unitOfWork.mode & ProfileMode) // Reset the profiler timer.
            startProfilerTimer(unitOfWork);
             // Run beginWork again.
            invokeGuardedCallback(null, beginWork, null, current, unitOfWork, expirationTime);
            if (hasCaughtError()) {
                var replayError = clearCaughtError(); // `invokeGuardedCallback` sometimes sets an expando `_suppressLogging`.
                // Rethrow this error instead of the original one.
                throw replayError;
            } else // This branch is reachable if the render phase is impure.
            throw originalError;
        }
    };
    var didWarnAboutUpdateInRender = false;
    var didWarnAboutUpdateInRenderForAnotherComponent;
    didWarnAboutUpdateInRenderForAnotherComponent = new Set();
    function warnAboutRenderPhaseUpdatesInDEV(fiber) {
        if (isRendering && (executionContext & RenderContext) !== NoContext) switch(fiber.tag){
            case FunctionComponent:
            case ForwardRef:
            case SimpleMemoComponent:
                var renderingComponentName = workInProgress && getComponentName(workInProgress.type) || "Unknown"; // Dedupe by the rendering component because it's the one that needs to be fixed.
                var dedupeKey = renderingComponentName;
                if (!didWarnAboutUpdateInRenderForAnotherComponent.has(dedupeKey)) {
                    didWarnAboutUpdateInRenderForAnotherComponent.add(dedupeKey);
                    var setStateComponentName = getComponentName(fiber.type) || "Unknown";
                    error("Cannot update a component (`%s`) while rendering a different component (`%s`). To locate the bad setState() call inside `%s`, follow the stack trace as described in https://fb.me/setstate-in-render", setStateComponentName, renderingComponentName, renderingComponentName);
                }
                break;
            case ClassComponent:
                if (!didWarnAboutUpdateInRender) {
                    error("Cannot update during an existing state transition (such as within `render`). Render methods should be a pure function of props and state.");
                    didWarnAboutUpdateInRender = true;
                }
                break;
        }
    } // a 'shared' variable that changes when act() opens/closes in tests.
    var IsThisRendererActing = {
        current: false
    };
    function warnIfNotScopedWithMatchingAct(fiber) {
        if (IsSomeRendererActing.current === true && IsThisRendererActing.current !== true) error("It looks like you're using the wrong act() around your test interactions.\nBe sure to use the matching version of act() corresponding to your renderer:\n\n// for react-dom:\nimport {act} from 'react-dom/test-utils';\n// ...\nact(() => ...);\n\n// for react-test-renderer:\nimport TestRenderer from 'react-test-renderer';\nconst {act} = TestRenderer;\n// ...\nact(() => ...);%s", getStackByFiberInDevAndProd(fiber));
    }
    function warnIfNotCurrentlyActingEffectsInDEV(fiber) {
        if ((fiber.mode & StrictMode) !== NoMode && IsSomeRendererActing.current === false && IsThisRendererActing.current === false) error("An update to %s ran an effect, but was not wrapped in act(...).\n\nWhen testing, code that causes React state updates should be wrapped into act(...):\n\nact(() => {\n  /* fire events that update state */\n});\n/* assert on the output */\n\nThis ensures that you're testing the behavior the user would see in the browser. Learn more at https://fb.me/react-wrap-tests-with-act%s", getComponentName(fiber.type), getStackByFiberInDevAndProd(fiber));
    }
    function warnIfNotCurrentlyActingUpdatesInDEV(fiber) {
        if (executionContext === NoContext && IsSomeRendererActing.current === false && IsThisRendererActing.current === false) error("An update to %s inside a test was not wrapped in act(...).\n\nWhen testing, code that causes React state updates should be wrapped into act(...):\n\nact(() => {\n  /* fire events that update state */\n});\n/* assert on the output */\n\nThis ensures that you're testing the behavior the user would see in the browser. Learn more at https://fb.me/react-wrap-tests-with-act%s", getComponentName(fiber.type), getStackByFiberInDevAndProd(fiber));
    }
    var warnIfNotCurrentlyActingUpdatesInDev = warnIfNotCurrentlyActingUpdatesInDEV; // In tests, we want to enforce a mocked scheduler.
    var didWarnAboutUnmockedScheduler = false; // TODO Before we release concurrent mode, revisit this and decide whether a mocked
    // scheduler is the actual recommendation. The alternative could be a testing build,
    // a new lib, or whatever; we dunno just yet. This message is for early adopters
    // to get their tests right.
    function warnIfUnmockedScheduler(fiber) {
        if (didWarnAboutUnmockedScheduler === false && Scheduler.unstable_flushAllWithoutAsserting === undefined) {
            if (fiber.mode & BlockingMode || fiber.mode & ConcurrentMode) {
                didWarnAboutUnmockedScheduler = true;
                error("In Concurrent or Sync modes, the \"scheduler\" module needs to be mocked to guarantee consistent behaviour across tests and browsers. For example, with jest: \njest.mock('scheduler', () => require('scheduler/unstable_mock'));\n\nFor more info, visit https://fb.me/react-mock-scheduler");
            }
        }
    }
    function computeThreadID(root, expirationTime) {
        // Interaction threads are unique per root and expiration time.
        return expirationTime * 1000 + root.interactionThreadID;
    }
    function markSpawnedWork(expirationTime) {
        if (spawnedWorkDuringRender === null) spawnedWorkDuringRender = [
            expirationTime
        ];
        else spawnedWorkDuringRender.push(expirationTime);
    }
    function scheduleInteractions(root, expirationTime, interactions) {
        if (interactions.size > 0) {
            var pendingInteractionMap = root.pendingInteractionMap;
            var pendingInteractions = pendingInteractionMap.get(expirationTime);
            if (pendingInteractions != null) interactions.forEach(function(interaction) {
                if (!pendingInteractions.has(interaction)) // Update the pending async work count for previously unscheduled interaction.
                interaction.__count++;
                pendingInteractions.add(interaction);
            });
            else {
                pendingInteractionMap.set(expirationTime, new Set(interactions)); // Update the pending async work count for the current interactions.
                interactions.forEach(function(interaction) {
                    interaction.__count++;
                });
            }
            var subscriber = tracing.__subscriberRef.current;
            if (subscriber !== null) {
                var threadID = computeThreadID(root, expirationTime);
                subscriber.onWorkScheduled(interactions, threadID);
            }
        }
    }
    function schedulePendingInteractions(root, expirationTime) {
        scheduleInteractions(root, expirationTime, tracing.__interactionsRef.current);
    }
    function startWorkOnPendingInteractions(root, expirationTime) {
        // we can accurately attribute time spent working on it, And so that cascading
        // work triggered during the render phase will be associated with it.
        var interactions = new Set();
        root.pendingInteractionMap.forEach(function(scheduledInteractions, scheduledExpirationTime) {
            if (scheduledExpirationTime >= expirationTime) scheduledInteractions.forEach(function(interaction) {
                return interactions.add(interaction);
            });
        }); // Store the current set of interactions on the FiberRoot for a few reasons:
        // We can re-use it in hot functions like performConcurrentWorkOnRoot()
        // without having to recalculate it. We will also use it in commitWork() to
        // pass to any Profiler onRender() hooks. This also provides DevTools with a
        // way to access it when the onCommitRoot() hook is called.
        root.memoizedInteractions = interactions;
        if (interactions.size > 0) {
            var subscriber = tracing.__subscriberRef.current;
            if (subscriber !== null) {
                var threadID = computeThreadID(root, expirationTime);
                try {
                    subscriber.onWorkStarted(interactions, threadID);
                } catch (error) {
                    // If the subscriber throws, rethrow it in a separate task
                    scheduleCallback(ImmediatePriority, function() {
                        throw error;
                    });
                }
            }
        }
    }
    function finishPendingInteractions(root, committedExpirationTime) {
        var earliestRemainingTimeAfterCommit = root.firstPendingTime;
        var subscriber;
        try {
            subscriber = tracing.__subscriberRef.current;
            if (subscriber !== null && root.memoizedInteractions.size > 0) {
                var threadID = computeThreadID(root, committedExpirationTime);
                subscriber.onWorkStopped(root.memoizedInteractions, threadID);
            }
        } catch (error) {
            // If the subscriber throws, rethrow it in a separate task
            scheduleCallback(ImmediatePriority, function() {
                throw error;
            });
        } finally{
            // Clear completed interactions from the pending Map.
            // Unless the render was suspended or cascading work was scheduled,
            // In which case– leave pending interactions until the subsequent render.
            var pendingInteractionMap = root.pendingInteractionMap;
            pendingInteractionMap.forEach(function(scheduledInteractions, scheduledExpirationTime) {
                // Only decrement the pending interaction count if we're done.
                // If there's still work at the current priority,
                // That indicates that we are waiting for suspense data.
                if (scheduledExpirationTime > earliestRemainingTimeAfterCommit) {
                    pendingInteractionMap.delete(scheduledExpirationTime);
                    scheduledInteractions.forEach(function(interaction) {
                        interaction.__count--;
                        if (subscriber !== null && interaction.__count === 0) try {
                            subscriber.onInteractionScheduledWorkCompleted(interaction);
                        } catch (error) {
                            // If the subscriber throws, rethrow it in a separate task
                            scheduleCallback(ImmediatePriority, function() {
                                throw error;
                            });
                        }
                    });
                }
            });
        }
    }
    var onScheduleFiberRoot = null;
    var onCommitFiberRoot = null;
    var onCommitFiberUnmount = null;
    var hasLoggedError = false;
    var isDevToolsPresent = typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ !== "undefined";
    function injectInternals(internals) {
        if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === "undefined") // No DevTools
        return false;
        var hook = __REACT_DEVTOOLS_GLOBAL_HOOK__;
        if (hook.isDisabled) // This isn't a real property on the hook, but it can be set to opt out
        // of DevTools integration and associated warnings and logs.
        // https://github.com/facebook/react/issues/3877
        return true;
        if (!hook.supportsFiber) {
            error("The installed version of React DevTools is too old and will not work with the current version of React. Please update React DevTools. https://fb.me/react-devtools");
            return true;
        }
        try {
            var rendererID = hook.inject(internals); // We have successfully injected, so now it is safe to set up hooks.
            // Only used by Fast Refresh
            if (typeof hook.onScheduleFiberRoot === "function") onScheduleFiberRoot = function(root, children) {
                try {
                    hook.onScheduleFiberRoot(rendererID, root, children);
                } catch (err) {
                    if (!hasLoggedError) {
                        hasLoggedError = true;
                        error("React instrumentation encountered an error: %s", err);
                    }
                }
            };
            onCommitFiberRoot = function(root, expirationTime) {
                try {
                    var didError = (root.current.effectTag & DidCapture) === DidCapture;
                    if (enableProfilerTimer) {
                        var currentTime = getCurrentTime();
                        var priorityLevel = inferPriorityFromExpirationTime(currentTime, expirationTime);
                        hook.onCommitFiberRoot(rendererID, root, priorityLevel, didError);
                    } else hook.onCommitFiberRoot(rendererID, root, undefined, didError);
                } catch (err) {
                    if (!hasLoggedError) {
                        hasLoggedError = true;
                        error("React instrumentation encountered an error: %s", err);
                    }
                }
            };
            onCommitFiberUnmount = function(fiber) {
                try {
                    hook.onCommitFiberUnmount(rendererID, fiber);
                } catch (err) {
                    if (!hasLoggedError) {
                        hasLoggedError = true;
                        error("React instrumentation encountered an error: %s", err);
                    }
                }
            };
        } catch (err) {
            error("React instrumentation encountered an error: %s.", err);
        } // DevTools exists
        return true;
    }
    function onScheduleRoot(root, children) {
        if (typeof onScheduleFiberRoot === "function") onScheduleFiberRoot(root, children);
    }
    function onCommitRoot(root, expirationTime) {
        if (typeof onCommitFiberRoot === "function") onCommitFiberRoot(root, expirationTime);
    }
    function onCommitUnmount(fiber) {
        if (typeof onCommitFiberUnmount === "function") onCommitFiberUnmount(fiber);
    }
    var hasBadMapPolyfill;
    hasBadMapPolyfill = false;
    try {
        var nonExtensibleObject = Object.preventExtensions({});
        var testMap = new Map([
            [
                nonExtensibleObject,
                null
            ]
        ]);
        var testSet = new Set([
            nonExtensibleObject
        ]); // This is necessary for Rollup to not consider these unused.
        // https://github.com/rollup/rollup/issues/1771
        // TODO: we can remove these if Rollup fixes the bug.
        testMap.set(0, 0);
        testSet.add(0);
    } catch (e) {
        // TODO: Consider warning about bad polyfills
        hasBadMapPolyfill = true;
    }
    var debugCounter = 1;
    function FiberNode(tag, pendingProps, key, mode) {
        // Instance
        this.tag = tag;
        this.key = key;
        this.elementType = null;
        this.type = null;
        this.stateNode = null; // Fiber
        this.return = null;
        this.child = null;
        this.sibling = null;
        this.index = 0;
        this.ref = null;
        this.pendingProps = pendingProps;
        this.memoizedProps = null;
        this.updateQueue = null;
        this.memoizedState = null;
        this.dependencies = null;
        this.mode = mode; // Effects
        this.effectTag = NoEffect;
        this.nextEffect = null;
        this.firstEffect = null;
        this.lastEffect = null;
        this.expirationTime = NoWork;
        this.childExpirationTime = NoWork;
        this.alternate = null;
        // Note: The following is done to avoid a v8 performance cliff.
        //
        // Initializing the fields below to smis and later updating them with
        // double values will cause Fibers to end up having separate shapes.
        // This behavior/bug has something to do with Object.preventExtension().
        // Fortunately this only impacts DEV builds.
        // Unfortunately it makes React unusably slow for some applications.
        // To work around this, initialize the fields below with doubles.
        //
        // Learn more about this here:
        // https://github.com/facebook/react/issues/14365
        // https://bugs.chromium.org/p/v8/issues/detail?id=8538
        this.actualDuration = Number.NaN;
        this.actualStartTime = Number.NaN;
        this.selfBaseDuration = Number.NaN;
        this.treeBaseDuration = Number.NaN; // It's okay to replace the initial doubles with smis after initialization.
        // This won't trigger the performance cliff mentioned above,
        // and it simplifies other profiler code (including DevTools).
        this.actualDuration = 0;
        this.actualStartTime = -1;
        this.selfBaseDuration = 0;
        this.treeBaseDuration = 0;
        this._debugID = debugCounter++;
        this._debugIsCurrentlyTiming = false;
        this._debugSource = null;
        this._debugOwner = null;
        this._debugNeedsRemount = false;
        this._debugHookTypes = null;
        if (!hasBadMapPolyfill && typeof Object.preventExtensions === "function") Object.preventExtensions(this);
    } // This is a constructor function, rather than a POJO constructor, still
    // please ensure we do the following:
    // 1) Nobody should add any instance methods on this. Instance methods can be
    //    more difficult to predict when they get optimized and they are almost
    //    never inlined properly in static compilers.
    // 2) Nobody should rely on `instanceof Fiber` for type testing. We should
    //    always know when it is a fiber.
    // 3) We might want to experiment with using numeric keys since they are easier
    //    to optimize in a non-JIT environment.
    // 4) We can easily go from a constructor to a createFiber object literal if that
    //    is faster.
    // 5) It should be easy to port this to a C struct and keep a C implementation
    //    compatible.
    var createFiber = function(tag, pendingProps, key, mode) {
        // $FlowFixMe: the shapes are exact here but Flow doesn't like constructors
        return new FiberNode(tag, pendingProps, key, mode);
    };
    function shouldConstruct(Component) {
        var prototype = Component.prototype;
        return !!(prototype && prototype.isReactComponent);
    }
    function isSimpleFunctionComponent(type) {
        return typeof type === "function" && !shouldConstruct(type) && type.defaultProps === undefined;
    }
    function resolveLazyComponentTag(Component) {
        if (typeof Component === "function") return shouldConstruct(Component) ? ClassComponent : FunctionComponent;
        else if (Component !== undefined && Component !== null) {
            var $$typeof = Component.$$typeof;
            if ($$typeof === REACT_FORWARD_REF_TYPE) return ForwardRef;
            if ($$typeof === REACT_MEMO_TYPE) return MemoComponent;
        }
        return IndeterminateComponent;
    } // This is used to create an alternate fiber to do work on.
    function createWorkInProgress(current, pendingProps) {
        var workInProgress = current.alternate;
        if (workInProgress === null) {
            // We use a double buffering pooling technique because we know that we'll
            // only ever need at most two versions of a tree. We pool the "other" unused
            // node that we're free to reuse. This is lazily created to avoid allocating
            // extra objects for things that are never updated. It also allow us to
            // reclaim the extra memory if needed.
            workInProgress = createFiber(current.tag, pendingProps, current.key, current.mode);
            workInProgress.elementType = current.elementType;
            workInProgress.type = current.type;
            workInProgress.stateNode = current.stateNode;
            workInProgress._debugID = current._debugID;
            workInProgress._debugSource = current._debugSource;
            workInProgress._debugOwner = current._debugOwner;
            workInProgress._debugHookTypes = current._debugHookTypes;
            workInProgress.alternate = current;
            current.alternate = workInProgress;
        } else {
            workInProgress.pendingProps = pendingProps; // We already have an alternate.
            // Reset the effect tag.
            workInProgress.effectTag = NoEffect; // The effect list is no longer valid.
            workInProgress.nextEffect = null;
            workInProgress.firstEffect = null;
            workInProgress.lastEffect = null;
            // We intentionally reset, rather than copy, actualDuration & actualStartTime.
            // This prevents time from endlessly accumulating in new commits.
            // This has the downside of resetting values for different priority renders,
            // But works for yielding (the common case) and should support resuming.
            workInProgress.actualDuration = 0;
            workInProgress.actualStartTime = -1;
        }
        workInProgress.childExpirationTime = current.childExpirationTime;
        workInProgress.expirationTime = current.expirationTime;
        workInProgress.child = current.child;
        workInProgress.memoizedProps = current.memoizedProps;
        workInProgress.memoizedState = current.memoizedState;
        workInProgress.updateQueue = current.updateQueue; // Clone the dependencies object. This is mutated during the render phase, so
        // it cannot be shared with the current fiber.
        var currentDependencies = current.dependencies;
        workInProgress.dependencies = currentDependencies === null ? null : {
            expirationTime: currentDependencies.expirationTime,
            firstContext: currentDependencies.firstContext,
            responders: currentDependencies.responders
        }; // These will be overridden during the parent's reconciliation
        workInProgress.sibling = current.sibling;
        workInProgress.index = current.index;
        workInProgress.ref = current.ref;
        workInProgress.selfBaseDuration = current.selfBaseDuration;
        workInProgress.treeBaseDuration = current.treeBaseDuration;
        workInProgress._debugNeedsRemount = current._debugNeedsRemount;
        switch(workInProgress.tag){
            case IndeterminateComponent:
            case FunctionComponent:
            case SimpleMemoComponent:
                workInProgress.type = resolveFunctionForHotReloading(current.type);
                break;
            case ClassComponent:
                workInProgress.type = resolveClassForHotReloading(current.type);
                break;
            case ForwardRef:
                workInProgress.type = resolveForwardRefForHotReloading(current.type);
                break;
        }
        return workInProgress;
    } // Used to reuse a Fiber for a second pass.
    function resetWorkInProgress(workInProgress, renderExpirationTime) {
        // This resets the Fiber to what createFiber or createWorkInProgress would
        // have set the values to before during the first pass. Ideally this wouldn't
        // be necessary but unfortunately many code paths reads from the workInProgress
        // when they should be reading from current and writing to workInProgress.
        // We assume pendingProps, index, key, ref, return are still untouched to
        // avoid doing another reconciliation.
        // Reset the effect tag but keep any Placement tags, since that's something
        // that child fiber is setting, not the reconciliation.
        workInProgress.effectTag &= Placement; // The effect list is no longer valid.
        workInProgress.nextEffect = null;
        workInProgress.firstEffect = null;
        workInProgress.lastEffect = null;
        var current = workInProgress.alternate;
        if (current === null) {
            // Reset to createFiber's initial values.
            workInProgress.childExpirationTime = NoWork;
            workInProgress.expirationTime = renderExpirationTime;
            workInProgress.child = null;
            workInProgress.memoizedProps = null;
            workInProgress.memoizedState = null;
            workInProgress.updateQueue = null;
            workInProgress.dependencies = null;
            // Note: We don't reset the actualTime counts. It's useful to accumulate
            // actual time across multiple render passes.
            workInProgress.selfBaseDuration = 0;
            workInProgress.treeBaseDuration = 0;
        } else {
            // Reset to the cloned values that createWorkInProgress would've.
            workInProgress.childExpirationTime = current.childExpirationTime;
            workInProgress.expirationTime = current.expirationTime;
            workInProgress.child = current.child;
            workInProgress.memoizedProps = current.memoizedProps;
            workInProgress.memoizedState = current.memoizedState;
            workInProgress.updateQueue = current.updateQueue; // Clone the dependencies object. This is mutated during the render phase, so
            // it cannot be shared with the current fiber.
            var currentDependencies = current.dependencies;
            workInProgress.dependencies = currentDependencies === null ? null : {
                expirationTime: currentDependencies.expirationTime,
                firstContext: currentDependencies.firstContext,
                responders: currentDependencies.responders
            };
            // Note: We don't reset the actualTime counts. It's useful to accumulate
            // actual time across multiple render passes.
            workInProgress.selfBaseDuration = current.selfBaseDuration;
            workInProgress.treeBaseDuration = current.treeBaseDuration;
        }
        return workInProgress;
    }
    function createHostRootFiber(tag) {
        var mode;
        if (tag === ConcurrentRoot) mode = ConcurrentMode | BlockingMode | StrictMode;
        else if (tag === BlockingRoot) mode = BlockingMode | StrictMode;
        else mode = NoMode;
        if (isDevToolsPresent) // Always collect profile timings when DevTools are present.
        // This enables DevTools to start capturing timing at any point–
        // Without some nodes in the tree having empty base times.
        mode |= ProfileMode;
        return createFiber(HostRoot, null, null, mode);
    }
    function createFiberFromTypeAndProps(type, key, pendingProps, owner, mode, expirationTime) {
        var fiber;
        var fiberTag = IndeterminateComponent; // The resolved type is set if we know what the final type will be. I.e. it's not lazy.
        var resolvedType = type;
        if (typeof type === "function") {
            if (shouldConstruct(type)) {
                fiberTag = ClassComponent;
                resolvedType = resolveClassForHotReloading(resolvedType);
            } else resolvedType = resolveFunctionForHotReloading(resolvedType);
        } else if (typeof type === "string") fiberTag = HostComponent;
        else getTag: switch(type){
            case REACT_FRAGMENT_TYPE:
                return createFiberFromFragment(pendingProps.children, mode, expirationTime, key);
            case REACT_CONCURRENT_MODE_TYPE:
                fiberTag = Mode;
                mode |= ConcurrentMode | BlockingMode | StrictMode;
                break;
            case REACT_STRICT_MODE_TYPE:
                fiberTag = Mode;
                mode |= StrictMode;
                break;
            case REACT_PROFILER_TYPE:
                return createFiberFromProfiler(pendingProps, mode, expirationTime, key);
            case REACT_SUSPENSE_TYPE:
                return createFiberFromSuspense(pendingProps, mode, expirationTime, key);
            case REACT_SUSPENSE_LIST_TYPE:
                return createFiberFromSuspenseList(pendingProps, mode, expirationTime, key);
            default:
                if (typeof type === "object" && type !== null) switch(type.$$typeof){
                    case REACT_PROVIDER_TYPE:
                        fiberTag = ContextProvider;
                        break getTag;
                    case REACT_CONTEXT_TYPE:
                        // This is a consumer
                        fiberTag = ContextConsumer;
                        break getTag;
                    case REACT_FORWARD_REF_TYPE:
                        fiberTag = ForwardRef;
                        resolvedType = resolveForwardRefForHotReloading(resolvedType);
                        break getTag;
                    case REACT_MEMO_TYPE:
                        fiberTag = MemoComponent;
                        break getTag;
                    case REACT_LAZY_TYPE:
                        fiberTag = LazyComponent;
                        resolvedType = null;
                        break getTag;
                    case REACT_BLOCK_TYPE:
                        fiberTag = Block;
                        break getTag;
                }
                var info = "";
                if (type === undefined || typeof type === "object" && type !== null && Object.keys(type).length === 0) info += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.";
                var ownerName = owner ? getComponentName(owner.type) : null;
                if (ownerName) info += "\n\nCheck the render method of `" + ownerName + "`.";
                throw Error("Element type is invalid: expected a string (for built-in components) or a class/function (for composite components) but got: " + (type == null ? type : typeof type) + "." + info);
        }
        fiber = createFiber(fiberTag, pendingProps, key, mode);
        fiber.elementType = type;
        fiber.type = resolvedType;
        fiber.expirationTime = expirationTime;
        return fiber;
    }
    function createFiberFromElement(element, mode, expirationTime) {
        var owner = null;
        owner = element._owner;
        var type = element.type;
        var key = element.key;
        var pendingProps = element.props;
        var fiber = createFiberFromTypeAndProps(type, key, pendingProps, owner, mode, expirationTime);
        fiber._debugSource = element._source;
        fiber._debugOwner = element._owner;
        return fiber;
    }
    function createFiberFromFragment(elements, mode, expirationTime, key) {
        var fiber = createFiber(Fragment, elements, key, mode);
        fiber.expirationTime = expirationTime;
        return fiber;
    }
    function createFiberFromProfiler(pendingProps, mode, expirationTime, key) {
        if (typeof pendingProps.id !== "string" || typeof pendingProps.onRender !== "function") error('Profiler must specify an "id" string and "onRender" function as props');
        var fiber = createFiber(Profiler, pendingProps, key, mode | ProfileMode); // TODO: The Profiler fiber shouldn't have a type. It has a tag.
        fiber.elementType = REACT_PROFILER_TYPE;
        fiber.type = REACT_PROFILER_TYPE;
        fiber.expirationTime = expirationTime;
        return fiber;
    }
    function createFiberFromSuspense(pendingProps, mode, expirationTime, key) {
        var fiber = createFiber(SuspenseComponent, pendingProps, key, mode); // TODO: The SuspenseComponent fiber shouldn't have a type. It has a tag.
        // This needs to be fixed in getComponentName so that it relies on the tag
        // instead.
        fiber.type = REACT_SUSPENSE_TYPE;
        fiber.elementType = REACT_SUSPENSE_TYPE;
        fiber.expirationTime = expirationTime;
        return fiber;
    }
    function createFiberFromSuspenseList(pendingProps, mode, expirationTime, key) {
        var fiber = createFiber(SuspenseListComponent, pendingProps, key, mode);
        // TODO: The SuspenseListComponent fiber shouldn't have a type. It has a tag.
        // This needs to be fixed in getComponentName so that it relies on the tag
        // instead.
        fiber.type = REACT_SUSPENSE_LIST_TYPE;
        fiber.elementType = REACT_SUSPENSE_LIST_TYPE;
        fiber.expirationTime = expirationTime;
        return fiber;
    }
    function createFiberFromText(content, mode, expirationTime) {
        var fiber = createFiber(HostText, content, null, mode);
        fiber.expirationTime = expirationTime;
        return fiber;
    }
    function createFiberFromHostInstanceForDeletion() {
        var fiber = createFiber(HostComponent, null, null, NoMode); // TODO: These should not need a type.
        fiber.elementType = "DELETED";
        fiber.type = "DELETED";
        return fiber;
    }
    function createFiberFromPortal(portal, mode, expirationTime) {
        var pendingProps = portal.children !== null ? portal.children : [];
        var fiber = createFiber(HostPortal, pendingProps, portal.key, mode);
        fiber.expirationTime = expirationTime;
        fiber.stateNode = {
            containerInfo: portal.containerInfo,
            pendingChildren: null,
            // Used by persistent updates
            implementation: portal.implementation
        };
        return fiber;
    } // Used for stashing WIP properties to replay failed work in DEV.
    function assignFiberPropertiesInDEV(target, source) {
        if (target === null) // This Fiber's initial properties will always be overwritten.
        // We only use a Fiber to ensure the same hidden class so DEV isn't slow.
        target = createFiber(IndeterminateComponent, null, null, NoMode);
         // This is intentionally written as a list of all properties.
        // We tried to use Object.assign() instead but this is called in
        // the hottest path, and Object.assign() was too slow:
        // https://github.com/facebook/react/issues/12502
        // This code is DEV-only so size is not a concern.
        target.tag = source.tag;
        target.key = source.key;
        target.elementType = source.elementType;
        target.type = source.type;
        target.stateNode = source.stateNode;
        target.return = source.return;
        target.child = source.child;
        target.sibling = source.sibling;
        target.index = source.index;
        target.ref = source.ref;
        target.pendingProps = source.pendingProps;
        target.memoizedProps = source.memoizedProps;
        target.updateQueue = source.updateQueue;
        target.memoizedState = source.memoizedState;
        target.dependencies = source.dependencies;
        target.mode = source.mode;
        target.effectTag = source.effectTag;
        target.nextEffect = source.nextEffect;
        target.firstEffect = source.firstEffect;
        target.lastEffect = source.lastEffect;
        target.expirationTime = source.expirationTime;
        target.childExpirationTime = source.childExpirationTime;
        target.alternate = source.alternate;
        target.actualDuration = source.actualDuration;
        target.actualStartTime = source.actualStartTime;
        target.selfBaseDuration = source.selfBaseDuration;
        target.treeBaseDuration = source.treeBaseDuration;
        target._debugID = source._debugID;
        target._debugSource = source._debugSource;
        target._debugOwner = source._debugOwner;
        target._debugIsCurrentlyTiming = source._debugIsCurrentlyTiming;
        target._debugNeedsRemount = source._debugNeedsRemount;
        target._debugHookTypes = source._debugHookTypes;
        return target;
    }
    function FiberRootNode(containerInfo, tag, hydrate) {
        this.tag = tag;
        this.current = null;
        this.containerInfo = containerInfo;
        this.pendingChildren = null;
        this.pingCache = null;
        this.finishedExpirationTime = NoWork;
        this.finishedWork = null;
        this.timeoutHandle = noTimeout;
        this.context = null;
        this.pendingContext = null;
        this.hydrate = hydrate;
        this.callbackNode = null;
        this.callbackPriority = NoPriority;
        this.firstPendingTime = NoWork;
        this.firstSuspendedTime = NoWork;
        this.lastSuspendedTime = NoWork;
        this.nextKnownPendingLevel = NoWork;
        this.lastPingedTime = NoWork;
        this.lastExpiredTime = NoWork;
        this.interactionThreadID = tracing.unstable_getThreadID();
        this.memoizedInteractions = new Set();
        this.pendingInteractionMap = new Map();
    }
    function createFiberRoot(containerInfo, tag, hydrate, hydrationCallbacks) {
        var root = new FiberRootNode(containerInfo, tag, hydrate);
        // stateNode is any.
        var uninitializedFiber = createHostRootFiber(tag);
        root.current = uninitializedFiber;
        uninitializedFiber.stateNode = root;
        initializeUpdateQueue(uninitializedFiber);
        return root;
    }
    function isRootSuspendedAtTime(root, expirationTime) {
        var firstSuspendedTime = root.firstSuspendedTime;
        var lastSuspendedTime = root.lastSuspendedTime;
        return firstSuspendedTime !== NoWork && firstSuspendedTime >= expirationTime && lastSuspendedTime <= expirationTime;
    }
    function markRootSuspendedAtTime(root, expirationTime) {
        var firstSuspendedTime = root.firstSuspendedTime;
        var lastSuspendedTime = root.lastSuspendedTime;
        if (firstSuspendedTime < expirationTime) root.firstSuspendedTime = expirationTime;
        if (lastSuspendedTime > expirationTime || firstSuspendedTime === NoWork) root.lastSuspendedTime = expirationTime;
        if (expirationTime <= root.lastPingedTime) root.lastPingedTime = NoWork;
        if (expirationTime <= root.lastExpiredTime) root.lastExpiredTime = NoWork;
    }
    function markRootUpdatedAtTime(root, expirationTime) {
        // Update the range of pending times
        var firstPendingTime = root.firstPendingTime;
        if (expirationTime > firstPendingTime) root.firstPendingTime = expirationTime;
         // Update the range of suspended times. Treat everything lower priority or
        // equal to this update as unsuspended.
        var firstSuspendedTime = root.firstSuspendedTime;
        if (firstSuspendedTime !== NoWork) {
            if (expirationTime >= firstSuspendedTime) // The entire suspended range is now unsuspended.
            root.firstSuspendedTime = root.lastSuspendedTime = root.nextKnownPendingLevel = NoWork;
            else if (expirationTime >= root.lastSuspendedTime) root.lastSuspendedTime = expirationTime + 1;
             // This is a pending level. Check if it's higher priority than the next
            // known pending level.
            if (expirationTime > root.nextKnownPendingLevel) root.nextKnownPendingLevel = expirationTime;
        }
    }
    function markRootFinishedAtTime(root, finishedExpirationTime, remainingExpirationTime) {
        // Update the range of pending times
        root.firstPendingTime = remainingExpirationTime; // Update the range of suspended times. Treat everything higher priority or
        // equal to this update as unsuspended.
        if (finishedExpirationTime <= root.lastSuspendedTime) // The entire suspended range is now unsuspended.
        root.firstSuspendedTime = root.lastSuspendedTime = root.nextKnownPendingLevel = NoWork;
        else if (finishedExpirationTime <= root.firstSuspendedTime) // Part of the suspended range is now unsuspended. Narrow the range to
        // include everything between the unsuspended time (non-inclusive) and the
        // last suspended time.
        root.firstSuspendedTime = finishedExpirationTime - 1;
        if (finishedExpirationTime <= root.lastPingedTime) // Clear the pinged time
        root.lastPingedTime = NoWork;
        if (finishedExpirationTime <= root.lastExpiredTime) // Clear the expired time
        root.lastExpiredTime = NoWork;
    }
    function markRootExpiredAtTime(root, expirationTime) {
        var lastExpiredTime = root.lastExpiredTime;
        if (lastExpiredTime === NoWork || lastExpiredTime > expirationTime) root.lastExpiredTime = expirationTime;
    }
    var didWarnAboutNestedUpdates;
    var didWarnAboutFindNodeInStrictMode;
    didWarnAboutNestedUpdates = false;
    didWarnAboutFindNodeInStrictMode = {};
    function getContextForSubtree(parentComponent) {
        if (!parentComponent) return emptyContextObject;
        var fiber = get(parentComponent);
        var parentContext = findCurrentUnmaskedContext(fiber);
        if (fiber.tag === ClassComponent) {
            var Component = fiber.type;
            if (isContextProvider(Component)) return processChildContext(fiber, Component, parentContext);
        }
        return parentContext;
    }
    function findHostInstanceWithWarning(component, methodName) {
        var fiber = get(component);
        if (fiber === undefined) {
            if (typeof component.render === "function") throw Error("Unable to find node on an unmounted component.");
            else throw Error("Argument appears to not be a ReactComponent. Keys: " + Object.keys(component));
        }
        var hostFiber = findCurrentHostFiber(fiber);
        if (hostFiber === null) return null;
        if (hostFiber.mode & StrictMode) {
            var componentName = getComponentName(fiber.type) || "Component";
            if (!didWarnAboutFindNodeInStrictMode[componentName]) {
                didWarnAboutFindNodeInStrictMode[componentName] = true;
                if (fiber.mode & StrictMode) error("%s is deprecated in StrictMode. %s was passed an instance of %s which is inside StrictMode. Instead, add a ref directly to the element you want to reference. Learn more about using refs safely here: https://fb.me/react-strict-mode-find-node%s", methodName, methodName, componentName, getStackByFiberInDevAndProd(hostFiber));
                else error("%s is deprecated in StrictMode. %s was passed an instance of %s which renders StrictMode children. Instead, add a ref directly to the element you want to reference. Learn more about using refs safely here: https://fb.me/react-strict-mode-find-node%s", methodName, methodName, componentName, getStackByFiberInDevAndProd(hostFiber));
            }
        }
        return hostFiber.stateNode;
    }
    function createContainer(containerInfo, tag, hydrate, hydrationCallbacks) {
        return createFiberRoot(containerInfo, tag, hydrate);
    }
    function updateContainer(element, container, parentComponent, callback) {
        onScheduleRoot(container, element);
        var current$1 = container.current;
        var currentTime = requestCurrentTimeForUpdate();
        // $FlowExpectedError - jest isn't a global, and isn't recognized outside of tests
        if ("undefined" !== typeof jest) {
            warnIfUnmockedScheduler(current$1);
            warnIfNotScopedWithMatchingAct(current$1);
        }
        var suspenseConfig = requestCurrentSuspenseConfig();
        var expirationTime = computeExpirationForFiber(currentTime, current$1, suspenseConfig);
        var context = getContextForSubtree(parentComponent);
        if (container.context === null) container.context = context;
        else container.pendingContext = context;
        if (isRendering && current !== null && !didWarnAboutNestedUpdates) {
            didWarnAboutNestedUpdates = true;
            error("Render methods should be a pure function of props and state; triggering nested component updates from render is not allowed. If necessary, trigger nested updates in componentDidUpdate.\n\nCheck the render method of %s.", getComponentName(current.type) || "Unknown");
        }
        var update = createUpdate(expirationTime, suspenseConfig); // Caution: React DevTools currently depends on this property
        // being called "element".
        update.payload = {
            element: element
        };
        callback = callback === undefined ? null : callback;
        if (callback !== null) {
            if (typeof callback !== "function") error("render(...): Expected the last optional `callback` argument to be a function. Instead received: %s.", callback);
            update.callback = callback;
        }
        enqueueUpdate(current$1, update);
        scheduleWork(current$1, expirationTime);
        return expirationTime;
    }
    function getPublicRootInstance(container) {
        var containerFiber = container.current;
        if (!containerFiber.child) return null;
        switch(containerFiber.child.tag){
            case HostComponent:
                return getPublicInstance(containerFiber.child.stateNode);
            default:
                return containerFiber.child.stateNode;
        }
    }
    function markRetryTimeImpl(fiber, retryTime) {
        var suspenseState = fiber.memoizedState;
        if (suspenseState !== null && suspenseState.dehydrated !== null) {
            if (suspenseState.retryTime < retryTime) suspenseState.retryTime = retryTime;
        }
    } // Increases the priority of thennables when they resolve within this boundary.
    function markRetryTimeIfNotHydrated(fiber, retryTime) {
        markRetryTimeImpl(fiber, retryTime);
        var alternate = fiber.alternate;
        if (alternate) markRetryTimeImpl(alternate, retryTime);
    }
    function attemptUserBlockingHydration$1(fiber) {
        if (fiber.tag !== SuspenseComponent) // We ignore HostRoots here because we can't increase
        // their priority and they should not suspend on I/O,
        // since you have to wrap anything that might suspend in
        // Suspense.
        return;
        var expTime = computeInteractiveExpiration(requestCurrentTimeForUpdate());
        scheduleWork(fiber, expTime);
        markRetryTimeIfNotHydrated(fiber, expTime);
    }
    function attemptContinuousHydration$1(fiber) {
        if (fiber.tag !== SuspenseComponent) // We ignore HostRoots here because we can't increase
        // their priority and they should not suspend on I/O,
        // since you have to wrap anything that might suspend in
        // Suspense.
        return;
        scheduleWork(fiber, ContinuousHydration);
        markRetryTimeIfNotHydrated(fiber, ContinuousHydration);
    }
    function attemptHydrationAtCurrentPriority$1(fiber) {
        if (fiber.tag !== SuspenseComponent) // We ignore HostRoots here because we can't increase
        // their priority other than synchronously flush it.
        return;
        var currentTime = requestCurrentTimeForUpdate();
        var expTime = computeExpirationForFiber(currentTime, fiber, null);
        scheduleWork(fiber, expTime);
        markRetryTimeIfNotHydrated(fiber, expTime);
    }
    function findHostInstanceWithNoPortals(fiber) {
        var hostFiber = findCurrentHostFiberWithNoPortals(fiber);
        if (hostFiber === null) return null;
        if (hostFiber.tag === FundamentalComponent) return hostFiber.stateNode.instance;
        return hostFiber.stateNode;
    }
    var shouldSuspendImpl = function(fiber) {
        return false;
    };
    function shouldSuspend(fiber) {
        return shouldSuspendImpl(fiber);
    }
    var overrideHookState = null;
    var overrideProps = null;
    var scheduleUpdate = null;
    var setSuspenseHandler = null;
    var copyWithSetImpl = function(obj, path, idx, value) {
        if (idx >= path.length) return value;
        var key = path[idx];
        var updated = Array.isArray(obj) ? obj.slice() : _assign({}, obj); // $FlowFixMe number or string is fine here
        updated[key] = copyWithSetImpl(obj[key], path, idx + 1, value);
        return updated;
    };
    var copyWithSet = function(obj, path, value) {
        return copyWithSetImpl(obj, path, 0, value);
    }; // Support DevTools editable values for useState and useReducer.
    overrideHookState = function(fiber, id, path, value) {
        // For now, the "id" of stateful hooks is just the stateful hook index.
        // This may change in the future with e.g. nested hooks.
        var currentHook = fiber.memoizedState;
        while(currentHook !== null && id > 0){
            currentHook = currentHook.next;
            id--;
        }
        if (currentHook !== null) {
            var newState = copyWithSet(currentHook.memoizedState, path, value);
            currentHook.memoizedState = newState;
            currentHook.baseState = newState; // We aren't actually adding an update to the queue,
            // because there is no update we can add for useReducer hooks that won't trigger an error.
            // (There's no appropriate action type for DevTools overrides.)
            // As a result though, React will see the scheduled update as a noop and bailout.
            // Shallow cloning props works as a workaround for now to bypass the bailout check.
            fiber.memoizedProps = _assign({}, fiber.memoizedProps);
            scheduleWork(fiber, Sync);
        }
    }; // Support DevTools props for function components, forwardRef, memo, host components, etc.
    overrideProps = function(fiber, path, value) {
        fiber.pendingProps = copyWithSet(fiber.memoizedProps, path, value);
        if (fiber.alternate) fiber.alternate.pendingProps = fiber.pendingProps;
        scheduleWork(fiber, Sync);
    };
    scheduleUpdate = function(fiber) {
        scheduleWork(fiber, Sync);
    };
    setSuspenseHandler = function(newShouldSuspendImpl) {
        shouldSuspendImpl = newShouldSuspendImpl;
    };
    function injectIntoDevTools(devToolsConfig) {
        var findFiberByHostInstance = devToolsConfig.findFiberByHostInstance;
        var ReactCurrentDispatcher = ReactSharedInternals.ReactCurrentDispatcher;
        return injectInternals(_assign({}, devToolsConfig, {
            overrideHookState: overrideHookState,
            overrideProps: overrideProps,
            setSuspenseHandler: setSuspenseHandler,
            scheduleUpdate: scheduleUpdate,
            currentDispatcherRef: ReactCurrentDispatcher,
            findHostInstanceByFiber: function(fiber) {
                var hostFiber = findCurrentHostFiber(fiber);
                if (hostFiber === null) return null;
                return hostFiber.stateNode;
            },
            findFiberByHostInstance: function(instance) {
                if (!findFiberByHostInstance) // Might not be implemented by the renderer.
                return null;
                return findFiberByHostInstance(instance);
            },
            // React Refresh
            findHostInstancesForRefresh: findHostInstancesForRefresh,
            scheduleRefresh: scheduleRefresh,
            scheduleRoot: scheduleRoot,
            setRefreshHandler: setRefreshHandler,
            // Enables DevTools to append owner stacks to error messages in DEV mode.
            getCurrentFiber: function() {
                return current;
            }
        }));
    }
    var IsSomeRendererActing$1 = ReactSharedInternals.IsSomeRendererActing;
    function ReactDOMRoot(container, options) {
        this._internalRoot = createRootImpl(container, ConcurrentRoot, options);
    }
    function ReactDOMBlockingRoot(container, tag, options) {
        this._internalRoot = createRootImpl(container, tag, options);
    }
    ReactDOMRoot.prototype.render = ReactDOMBlockingRoot.prototype.render = function(children) {
        var root = this._internalRoot;
        if (typeof arguments[1] === "function") error("render(...): does not support the second callback argument. To execute a side effect after rendering, declare it in a component body with useEffect().");
        var container = root.containerInfo;
        if (container.nodeType !== COMMENT_NODE) {
            var hostInstance = findHostInstanceWithNoPortals(root.current);
            if (hostInstance) {
                if (hostInstance.parentNode !== container) error("render(...): It looks like the React-rendered content of the root container was removed without using React. This is not supported and will cause errors. Instead, call root.unmount() to empty a root's container.");
            }
        }
        updateContainer(children, root, null, null);
    };
    ReactDOMRoot.prototype.unmount = ReactDOMBlockingRoot.prototype.unmount = function() {
        if (typeof arguments[0] === "function") error("unmount(...): does not support a callback argument. To execute a side effect after rendering, declare it in a component body with useEffect().");
        var root = this._internalRoot;
        var container = root.containerInfo;
        updateContainer(null, root, null, function() {
            unmarkContainerAsRoot(container);
        });
    };
    function createRootImpl(container, tag, options) {
        // Tag is either LegacyRoot or Concurrent Root
        var hydrate = options != null && options.hydrate === true;
        var hydrationCallbacks = options != null && options.hydrationOptions || null;
        var root = createContainer(container, tag, hydrate);
        markContainerAsRoot(root.current, container);
        if (hydrate && tag !== LegacyRoot) {
            var doc = container.nodeType === DOCUMENT_NODE ? container : container.ownerDocument;
            eagerlyTrapReplayableEvents(container, doc);
        }
        return root;
    }
    function createLegacyRoot(container, options) {
        return new ReactDOMBlockingRoot(container, LegacyRoot, options);
    }
    function isValidContainer(node) {
        return !!(node && (node.nodeType === ELEMENT_NODE || node.nodeType === DOCUMENT_NODE || node.nodeType === DOCUMENT_FRAGMENT_NODE || node.nodeType === COMMENT_NODE && node.nodeValue === " react-mount-point-unstable "));
    }
    var ReactCurrentOwner$3 = ReactSharedInternals.ReactCurrentOwner;
    var topLevelUpdateWarnings;
    var warnedAboutHydrateAPI = false;
    topLevelUpdateWarnings = function(container) {
        if (container._reactRootContainer && container.nodeType !== COMMENT_NODE) {
            var hostInstance = findHostInstanceWithNoPortals(container._reactRootContainer._internalRoot.current);
            if (hostInstance) {
                if (hostInstance.parentNode !== container) error("render(...): It looks like the React-rendered content of this container was removed without using React. This is not supported and will cause errors. Instead, call ReactDOM.unmountComponentAtNode to empty a container.");
            }
        }
        var isRootRenderedBySomeReact = !!container._reactRootContainer;
        var rootEl = getReactRootElementInContainer(container);
        var hasNonRootReactChild = !!(rootEl && getInstanceFromNode$1(rootEl));
        if (hasNonRootReactChild && !isRootRenderedBySomeReact) error("render(...): Replacing React-rendered children with a new root component. If you intended to update the children of this node, you should instead have the existing children update their state and render the new components instead of calling ReactDOM.render.");
        if (container.nodeType === ELEMENT_NODE && container.tagName && container.tagName.toUpperCase() === "BODY") error("render(): Rendering components directly into document.body is discouraged, since its children are often manipulated by third-party scripts and browser extensions. This may lead to subtle reconciliation issues. Try rendering into a container element created for your app.");
    };
    function getReactRootElementInContainer(container) {
        if (!container) return null;
        if (container.nodeType === DOCUMENT_NODE) return container.documentElement;
        else return container.firstChild;
    }
    function shouldHydrateDueToLegacyHeuristic(container) {
        var rootElement = getReactRootElementInContainer(container);
        return !!(rootElement && rootElement.nodeType === ELEMENT_NODE && rootElement.hasAttribute(ROOT_ATTRIBUTE_NAME));
    }
    function legacyCreateRootFromDOMContainer(container, forceHydrate) {
        var shouldHydrate = forceHydrate || shouldHydrateDueToLegacyHeuristic(container); // First clear any existing content.
        if (!shouldHydrate) {
            var warned = false;
            var rootSibling;
            while(rootSibling = container.lastChild){
                if (!warned && rootSibling.nodeType === ELEMENT_NODE && rootSibling.hasAttribute(ROOT_ATTRIBUTE_NAME)) {
                    warned = true;
                    error("render(): Target node has markup rendered by React, but there are unrelated nodes as well. This is most commonly caused by white-space inserted around server-rendered markup.");
                }
                container.removeChild(rootSibling);
            }
        }
        if (shouldHydrate && !forceHydrate && !warnedAboutHydrateAPI) {
            warnedAboutHydrateAPI = true;
            warn("render(): Calling ReactDOM.render() to hydrate server-rendered markup will stop working in React v17. Replace the ReactDOM.render() call with ReactDOM.hydrate() if you want React to attach to the server HTML.");
        }
        return createLegacyRoot(container, shouldHydrate ? {
            hydrate: true
        } : undefined);
    }
    function warnOnInvalidCallback$1(callback, callerName) {
        if (callback !== null && typeof callback !== "function") error("%s(...): Expected the last optional `callback` argument to be a function. Instead received: %s.", callerName, callback);
    }
    function legacyRenderSubtreeIntoContainer(parentComponent, children, container, forceHydrate, callback) {
        topLevelUpdateWarnings(container);
        warnOnInvalidCallback$1(callback === undefined ? null : callback, "render");
        // member of intersection type." Whyyyyyy.
        var root = container._reactRootContainer;
        var fiberRoot;
        if (!root) {
            // Initial mount
            root = container._reactRootContainer = legacyCreateRootFromDOMContainer(container, forceHydrate);
            fiberRoot = root._internalRoot;
            if (typeof callback === "function") {
                var originalCallback = callback;
                callback = function() {
                    var instance = getPublicRootInstance(fiberRoot);
                    originalCallback.call(instance);
                };
            } // Initial mount should not be batched.
            unbatchedUpdates(function() {
                updateContainer(children, fiberRoot, parentComponent, callback);
            });
        } else {
            fiberRoot = root._internalRoot;
            if (typeof callback === "function") {
                var _originalCallback = callback;
                callback = function() {
                    var instance = getPublicRootInstance(fiberRoot);
                    _originalCallback.call(instance);
                };
            } // Update
            updateContainer(children, fiberRoot, parentComponent, callback);
        }
        return getPublicRootInstance(fiberRoot);
    }
    function findDOMNode(componentOrElement) {
        var owner = ReactCurrentOwner$3.current;
        if (owner !== null && owner.stateNode !== null) {
            var warnedAboutRefsInRender = owner.stateNode._warnedAboutRefsInRender;
            if (!warnedAboutRefsInRender) error("%s is accessing findDOMNode inside its render(). render() should be a pure function of props and state. It should never access something that requires stale data from the previous render, such as refs. Move this logic to componentDidMount and componentDidUpdate instead.", getComponentName(owner.type) || "A component");
            owner.stateNode._warnedAboutRefsInRender = true;
        }
        if (componentOrElement == null) return null;
        if (componentOrElement.nodeType === ELEMENT_NODE) return componentOrElement;
        return findHostInstanceWithWarning(componentOrElement, "findDOMNode");
    }
    function hydrate(element, container, callback) {
        if (!isValidContainer(container)) throw Error("Target container is not a DOM element.");
        var isModernRoot = isContainerMarkedAsRoot(container) && container._reactRootContainer === undefined;
        if (isModernRoot) error("You are calling ReactDOM.hydrate() on a container that was previously passed to ReactDOM.createRoot(). This is not supported. Did you mean to call createRoot(container, {hydrate: true}).render(element)?");
        return legacyRenderSubtreeIntoContainer(null, element, container, true, callback);
    }
    function render(element, container, callback) {
        if (!isValidContainer(container)) throw Error("Target container is not a DOM element.");
        var isModernRoot = isContainerMarkedAsRoot(container) && container._reactRootContainer === undefined;
        if (isModernRoot) error("You are calling ReactDOM.render() on a container that was previously passed to ReactDOM.createRoot(). This is not supported. Did you mean to call root.render(element)?");
        return legacyRenderSubtreeIntoContainer(null, element, container, false, callback);
    }
    function unstable_renderSubtreeIntoContainer(parentComponent, element, containerNode, callback) {
        if (!isValidContainer(containerNode)) throw Error("Target container is not a DOM element.");
        if (!(parentComponent != null && has(parentComponent))) throw Error("parentComponent must be a valid React Component");
        return legacyRenderSubtreeIntoContainer(parentComponent, element, containerNode, false, callback);
    }
    function unmountComponentAtNode(container) {
        if (!isValidContainer(container)) throw Error("unmountComponentAtNode(...): Target container is not a DOM element.");
        var isModernRoot = isContainerMarkedAsRoot(container) && container._reactRootContainer === undefined;
        if (isModernRoot) error("You are calling ReactDOM.unmountComponentAtNode() on a container that was previously passed to ReactDOM.createRoot(). This is not supported. Did you mean to call root.unmount()?");
        if (container._reactRootContainer) {
            var rootEl = getReactRootElementInContainer(container);
            var renderedByDifferentReact = rootEl && !getInstanceFromNode$1(rootEl);
            if (renderedByDifferentReact) error("unmountComponentAtNode(): The node you're attempting to unmount was rendered by another copy of React.");
            unbatchedUpdates(function() {
                legacyRenderSubtreeIntoContainer(null, null, container, false, function() {
                    // $FlowFixMe This should probably use `delete container._reactRootContainer`
                    container._reactRootContainer = null;
                    unmarkContainerAsRoot(container);
                });
            }); // If you call unmountComponentAtNode twice in quick succession, you'll
            // get `true` twice. That's probably fine?
            return true;
        } else {
            var _rootEl = getReactRootElementInContainer(container);
            var hasNonRootReactChild = !!(_rootEl && getInstanceFromNode$1(_rootEl)); // Check if the container itself is a React root node.
            var isContainerReactRoot = container.nodeType === ELEMENT_NODE && isValidContainer(container.parentNode) && !!container.parentNode._reactRootContainer;
            if (hasNonRootReactChild) error("unmountComponentAtNode(): The node you're attempting to unmount was rendered by React and is not a top-level container. %s", isContainerReactRoot ? "You may have accidentally passed in a React root node instead of its container." : "Instead, have the parent component update its state and rerender in order to remove this component.");
            return false;
        }
    }
    function createPortal(children, containerInfo, implementation) {
        var key = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
        return {
            // This tag allow us to uniquely identify this as a React Portal
            $$typeof: REACT_PORTAL_TYPE,
            key: key == null ? null : "" + key,
            children: children,
            containerInfo: containerInfo,
            implementation: implementation
        };
    }
    var ReactVersion = "16.13.1";
    setAttemptUserBlockingHydration(attemptUserBlockingHydration$1);
    setAttemptContinuousHydration(attemptContinuousHydration$1);
    setAttemptHydrationAtCurrentPriority(attemptHydrationAtCurrentPriority$1);
    var didWarnAboutUnstableCreatePortal = false;
    if (typeof Map !== "function" || // $FlowIssue Flow incorrectly thinks Map has no prototype
    Map.prototype == null || typeof Map.prototype.forEach !== "function" || typeof Set !== "function" || // $FlowIssue Flow incorrectly thinks Set has no prototype
    Set.prototype == null || typeof Set.prototype.clear !== "function" || typeof Set.prototype.forEach !== "function") error("React depends on Map and Set built-in types. Make sure that you load a polyfill in older browsers. https://fb.me/react-polyfills");
    setRestoreImplementation(restoreControlledState$3);
    setBatchingImplementation(batchedUpdates$1, discreteUpdates$1, flushDiscreteUpdates, batchedEventUpdates$1);
    function createPortal$1(children, container) {
        var key = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
        if (!isValidContainer(container)) throw Error("Target container is not a DOM element.");
         // TODO: pass ReactDOM portal implementation as third argument
        // $FlowFixMe The Flow type is opaque but there's no way to actually create it.
        return createPortal(children, container, null, key);
    }
    function renderSubtreeIntoContainer(parentComponent, element, containerNode, callback) {
        return unstable_renderSubtreeIntoContainer(parentComponent, element, containerNode, callback);
    }
    function unstable_createPortal(children, container) {
        var key = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
        if (!didWarnAboutUnstableCreatePortal) {
            didWarnAboutUnstableCreatePortal = true;
            warn('The ReactDOM.unstable_createPortal() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactDOM.createPortal() instead. It has the exact same API, but without the "unstable_" prefix.');
        }
        return createPortal$1(children, container, key);
    }
    var Internals = {
        // Keep in sync with ReactDOMUnstableNativeDependencies.js
        // ReactTestUtils.js, and ReactTestUtilsAct.js. This is an array for better minification.
        Events: [
            getInstanceFromNode$1,
            getNodeFromInstance$1,
            getFiberCurrentPropsFromNode$1,
            injectEventPluginsByName,
            eventNameDispatchConfigs,
            accumulateTwoPhaseDispatches,
            accumulateDirectDispatches,
            enqueueStateRestore,
            restoreStateIfNeeded,
            dispatchEvent,
            runEventsInBatch,
            flushPassiveEffects,
            IsThisRendererActing
        ]
    };
    var foundDevTools = injectIntoDevTools({
        findFiberByHostInstance: getClosestInstanceFromNode,
        bundleType: 1,
        version: ReactVersion,
        rendererPackageName: "react-dom"
    });
    if (!foundDevTools && canUseDOM && window.top === window.self) // If we're in Chrome or Firefox, provide a download link if not installed.
    {
        if (navigator.userAgent.indexOf("Chrome") > -1 && navigator.userAgent.indexOf("Edge") === -1 || navigator.userAgent.indexOf("Firefox") > -1) {
            var protocol = window.location.protocol; // Don't warn in exotic cases like chrome-extension://.
            if (/^(https?|file):$/.test(protocol)) // eslint-disable-next-line react-internal/no-production-logging
            console.info("%cDownload the React DevTools for a better development experience: https://fb.me/react-devtools" + (protocol === "file:" ? "\nYou might need to use a local HTTP server (instead of file://): https://fb.me/react-devtools-faq" : ""), "font-weight:bold");
        }
    }
    exports.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED = Internals;
    exports.createPortal = createPortal$1;
    exports.findDOMNode = findDOMNode;
    exports.flushSync = flushSync;
    exports.hydrate = hydrate;
    exports.render = render;
    exports.unmountComponentAtNode = unmountComponentAtNode;
    exports.unstable_batchedUpdates = batchedUpdates$1;
    exports.unstable_createPortal = unstable_createPortal;
    exports.unstable_renderSubtreeIntoContainer = renderSubtreeIntoContainer;
    exports.version = ReactVersion;
})();

});
parcelRegister("1MX31", function(module, exports) {
"use strict";

module.exports = (parcelRequire("h0PqN"));

});
parcelRegister("h0PqN", function(module, exports) {

$parcel$export(module.exports, "unstable_now", function () { return $c62a54e7e97de14b$export$c4744153514ff05d; }, function (v) { return $c62a54e7e97de14b$export$c4744153514ff05d = v; });
$parcel$export(module.exports, "unstable_forceFrameRate", function () { return $c62a54e7e97de14b$export$d66a1c1c77bd778b; }, function (v) { return $c62a54e7e97de14b$export$d66a1c1c77bd778b = v; });
$parcel$export(module.exports, "unstable_IdlePriority", function () { return $c62a54e7e97de14b$export$3e506c1ccc9cc1a7; }, function (v) { return $c62a54e7e97de14b$export$3e506c1ccc9cc1a7 = v; });
$parcel$export(module.exports, "unstable_ImmediatePriority", function () { return $c62a54e7e97de14b$export$e26fe2ed2fa76875; }, function (v) { return $c62a54e7e97de14b$export$e26fe2ed2fa76875 = v; });
$parcel$export(module.exports, "unstable_LowPriority", function () { return $c62a54e7e97de14b$export$502329bbf4b505b1; }, function (v) { return $c62a54e7e97de14b$export$502329bbf4b505b1 = v; });
$parcel$export(module.exports, "unstable_NormalPriority", function () { return $c62a54e7e97de14b$export$6e3807111c4874c4; }, function (v) { return $c62a54e7e97de14b$export$6e3807111c4874c4 = v; });
$parcel$export(module.exports, "unstable_Profiling", function () { return $c62a54e7e97de14b$export$c27134553091fb3a; }, function (v) { return $c62a54e7e97de14b$export$c27134553091fb3a = v; });
$parcel$export(module.exports, "unstable_UserBlockingPriority", function () { return $c62a54e7e97de14b$export$33ee1acdc04fd2a2; }, function (v) { return $c62a54e7e97de14b$export$33ee1acdc04fd2a2 = v; });
$parcel$export(module.exports, "unstable_cancelCallback", function () { return $c62a54e7e97de14b$export$b00a404bbd5edef2; }, function (v) { return $c62a54e7e97de14b$export$b00a404bbd5edef2 = v; });
$parcel$export(module.exports, "unstable_continueExecution", function () { return $c62a54e7e97de14b$export$8352ce38b91d0c62; }, function (v) { return $c62a54e7e97de14b$export$8352ce38b91d0c62 = v; });
$parcel$export(module.exports, "unstable_getCurrentPriorityLevel", function () { return $c62a54e7e97de14b$export$d3dfb8e4810cb555; }, function (v) { return $c62a54e7e97de14b$export$d3dfb8e4810cb555 = v; });
$parcel$export(module.exports, "unstable_getFirstCallbackNode", function () { return $c62a54e7e97de14b$export$839f9183b0465a69; }, function (v) { return $c62a54e7e97de14b$export$839f9183b0465a69 = v; });
$parcel$export(module.exports, "unstable_next", function () { return $c62a54e7e97de14b$export$72fdf0e06517287b; }, function (v) { return $c62a54e7e97de14b$export$72fdf0e06517287b = v; });
$parcel$export(module.exports, "unstable_pauseExecution", function () { return $c62a54e7e97de14b$export$4b844e58a3e414b4; }, function (v) { return $c62a54e7e97de14b$export$4b844e58a3e414b4 = v; });
$parcel$export(module.exports, "unstable_requestPaint", function () { return $c62a54e7e97de14b$export$816d2913ae6b83b1; }, function (v) { return $c62a54e7e97de14b$export$816d2913ae6b83b1 = v; });
$parcel$export(module.exports, "unstable_runWithPriority", function () { return $c62a54e7e97de14b$export$61bcfe829111a1d0; }, function (v) { return $c62a54e7e97de14b$export$61bcfe829111a1d0 = v; });
$parcel$export(module.exports, "unstable_scheduleCallback", function () { return $c62a54e7e97de14b$export$7ee8c9beb337bc3f; }, function (v) { return $c62a54e7e97de14b$export$7ee8c9beb337bc3f = v; });
$parcel$export(module.exports, "unstable_shouldYield", function () { return $c62a54e7e97de14b$export$b5836b71941fa3ed; }, function (v) { return $c62a54e7e97de14b$export$b5836b71941fa3ed = v; });
$parcel$export(module.exports, "unstable_wrapCallback", function () { return $c62a54e7e97de14b$export$cf845f2c119da08a; }, function (v) { return $c62a54e7e97de14b$export$cf845f2c119da08a = v; });
/** @license React v0.19.1
 * scheduler.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $c62a54e7e97de14b$export$c4744153514ff05d;
var $c62a54e7e97de14b$export$d66a1c1c77bd778b;
var $c62a54e7e97de14b$export$3e506c1ccc9cc1a7;
var $c62a54e7e97de14b$export$e26fe2ed2fa76875;
var $c62a54e7e97de14b$export$502329bbf4b505b1;
var $c62a54e7e97de14b$export$6e3807111c4874c4;
var $c62a54e7e97de14b$export$c27134553091fb3a;
var $c62a54e7e97de14b$export$33ee1acdc04fd2a2;
var $c62a54e7e97de14b$export$b00a404bbd5edef2;
var $c62a54e7e97de14b$export$8352ce38b91d0c62;
var $c62a54e7e97de14b$export$d3dfb8e4810cb555;
var $c62a54e7e97de14b$export$839f9183b0465a69;
var $c62a54e7e97de14b$export$72fdf0e06517287b;
var $c62a54e7e97de14b$export$4b844e58a3e414b4;
var $c62a54e7e97de14b$export$816d2913ae6b83b1;
var $c62a54e7e97de14b$export$61bcfe829111a1d0;
var $c62a54e7e97de14b$export$7ee8c9beb337bc3f;
var $c62a54e7e97de14b$export$b5836b71941fa3ed;
var $c62a54e7e97de14b$export$cf845f2c119da08a;
"use strict";
(function() {
    "use strict";
    var enableSchedulerDebugging = false;
    var enableProfiling = true;
    var requestHostCallback;
    var requestHostTimeout;
    var cancelHostTimeout;
    var shouldYieldToHost;
    var requestPaint;
    if (// implementation using setTimeout.
    typeof window === "undefined" || // Check if MessageChannel is supported, too.
    typeof MessageChannel !== "function") {
        // If this accidentally gets imported in a non-browser environment, e.g. JavaScriptCore,
        // fallback to a naive implementation.
        var _callback = null;
        var _timeoutID = null;
        var _flushCallback = function() {
            if (_callback !== null) try {
                var currentTime = $c62a54e7e97de14b$export$c4744153514ff05d();
                var hasRemainingTime = true;
                _callback(hasRemainingTime, currentTime);
                _callback = null;
            } catch (e) {
                setTimeout(_flushCallback, 0);
                throw e;
            }
        };
        var initialTime = Date.now();
        $c62a54e7e97de14b$export$c4744153514ff05d = function() {
            return Date.now() - initialTime;
        };
        requestHostCallback = function(cb) {
            if (_callback !== null) // Protect against re-entrancy.
            setTimeout(requestHostCallback, 0, cb);
            else {
                _callback = cb;
                setTimeout(_flushCallback, 0);
            }
        };
        requestHostTimeout = function(cb, ms) {
            _timeoutID = setTimeout(cb, ms);
        };
        cancelHostTimeout = function() {
            clearTimeout(_timeoutID);
        };
        shouldYieldToHost = function() {
            return false;
        };
        requestPaint = $c62a54e7e97de14b$export$d66a1c1c77bd778b = function() {};
    } else {
        // Capture local references to native APIs, in case a polyfill overrides them.
        var performance = window.performance;
        var _Date = window.Date;
        var _setTimeout = window.setTimeout;
        var _clearTimeout = window.clearTimeout;
        if (typeof console !== "undefined") {
            // TODO: Scheduler no longer requires these methods to be polyfilled. But
            // maybe we want to continue warning if they don't exist, to preserve the
            // option to rely on it in the future?
            var requestAnimationFrame = window.requestAnimationFrame;
            var cancelAnimationFrame = window.cancelAnimationFrame; // TODO: Remove fb.me link
            if (typeof requestAnimationFrame !== "function") // Using console['error'] to evade Babel and ESLint
            console["error"]("This browser doesn't support requestAnimationFrame. Make sure that you load a polyfill in older browsers. https://fb.me/react-polyfills");
            if (typeof cancelAnimationFrame !== "function") // Using console['error'] to evade Babel and ESLint
            console["error"]("This browser doesn't support cancelAnimationFrame. Make sure that you load a polyfill in older browsers. https://fb.me/react-polyfills");
        }
        if (typeof performance === "object" && typeof performance.now === "function") $c62a54e7e97de14b$export$c4744153514ff05d = function() {
            return performance.now();
        };
        else {
            var _initialTime = _Date.now();
            $c62a54e7e97de14b$export$c4744153514ff05d = function() {
                return _Date.now() - _initialTime;
            };
        }
        var isMessageLoopRunning = false;
        var scheduledHostCallback = null;
        var taskTimeoutID = -1; // Scheduler periodically yields in case there is other work on the main
        // thread, like user events. By default, it yields multiple times per frame.
        // It does not attempt to align with frame boundaries, since most tasks don't
        // need to be frame aligned; for those that do, use requestAnimationFrame.
        var yieldInterval = 5;
        var deadline = 0; // TODO: Make this configurable
        // `isInputPending` is not available. Since we have no way of knowing if
        // there's pending input, always yield at the end of the frame.
        shouldYieldToHost = function() {
            return $c62a54e7e97de14b$export$c4744153514ff05d() >= deadline;
        }; // Since we yield every frame regardless, `requestPaint` has no effect.
        requestPaint = function() {};
        $c62a54e7e97de14b$export$d66a1c1c77bd778b = function(fps) {
            if (fps < 0 || fps > 125) {
                // Using console['error'] to evade Babel and ESLint
                console["error"]("forceFrameRate takes a positive int between 0 and 125, forcing framerates higher than 125 fps is not unsupported");
                return;
            }
            if (fps > 0) yieldInterval = Math.floor(1000 / fps);
            else // reset the framerate
            yieldInterval = 5;
        };
        var performWorkUntilDeadline = function() {
            if (scheduledHostCallback !== null) {
                var currentTime = $c62a54e7e97de14b$export$c4744153514ff05d(); // Yield after `yieldInterval` ms, regardless of where we are in the vsync
                // cycle. This means there's always time remaining at the beginning of
                // the message event.
                deadline = currentTime + yieldInterval;
                var hasTimeRemaining = true;
                try {
                    var hasMoreWork = scheduledHostCallback(hasTimeRemaining, currentTime);
                    if (!hasMoreWork) {
                        isMessageLoopRunning = false;
                        scheduledHostCallback = null;
                    } else // If there's more work, schedule the next message event at the end
                    // of the preceding one.
                    port.postMessage(null);
                } catch (error) {
                    // If a scheduler task throws, exit the current browser task so the
                    // error can be observed.
                    port.postMessage(null);
                    throw error;
                }
            } else isMessageLoopRunning = false;
             // Yielding to the browser will give it a chance to paint, so we can
        };
        var channel = new MessageChannel();
        var port = channel.port2;
        channel.port1.onmessage = performWorkUntilDeadline;
        requestHostCallback = function(callback) {
            scheduledHostCallback = callback;
            if (!isMessageLoopRunning) {
                isMessageLoopRunning = true;
                port.postMessage(null);
            }
        };
        requestHostTimeout = function(callback, ms) {
            taskTimeoutID = _setTimeout(function() {
                callback($c62a54e7e97de14b$export$c4744153514ff05d());
            }, ms);
        };
        cancelHostTimeout = function() {
            _clearTimeout(taskTimeoutID);
            taskTimeoutID = -1;
        };
    }
    function push(heap, node) {
        var index = heap.length;
        heap.push(node);
        siftUp(heap, node, index);
    }
    function peek(heap) {
        var first = heap[0];
        return first === undefined ? null : first;
    }
    function pop(heap) {
        var first = heap[0];
        if (first !== undefined) {
            var last = heap.pop();
            if (last !== first) {
                heap[0] = last;
                siftDown(heap, last, 0);
            }
            return first;
        } else return null;
    }
    function siftUp(heap, node, i) {
        var index = i;
        while(true){
            var parentIndex = index - 1 >>> 1;
            var parent = heap[parentIndex];
            if (parent !== undefined && compare(parent, node) > 0) {
                // The parent is larger. Swap positions.
                heap[parentIndex] = node;
                heap[index] = parent;
                index = parentIndex;
            } else // The parent is smaller. Exit.
            return;
        }
    }
    function siftDown(heap, node, i) {
        var index = i;
        var length = heap.length;
        while(index < length){
            var leftIndex = (index + 1) * 2 - 1;
            var left = heap[leftIndex];
            var rightIndex = leftIndex + 1;
            var right = heap[rightIndex]; // If the left or right node is smaller, swap with the smaller of those.
            if (left !== undefined && compare(left, node) < 0) {
                if (right !== undefined && compare(right, left) < 0) {
                    heap[index] = right;
                    heap[rightIndex] = node;
                    index = rightIndex;
                } else {
                    heap[index] = left;
                    heap[leftIndex] = node;
                    index = leftIndex;
                }
            } else if (right !== undefined && compare(right, node) < 0) {
                heap[index] = right;
                heap[rightIndex] = node;
                index = rightIndex;
            } else // Neither child is smaller. Exit.
            return;
        }
    }
    function compare(a, b) {
        // Compare sort index first, then task id.
        var diff = a.sortIndex - b.sortIndex;
        return diff !== 0 ? diff : a.id - b.id;
    }
    // TODO: Use symbols?
    var NoPriority = 0;
    var ImmediatePriority = 1;
    var UserBlockingPriority = 2;
    var NormalPriority = 3;
    var LowPriority = 4;
    var IdlePriority = 5;
    var runIdCounter = 0;
    var mainThreadIdCounter = 0;
    var profilingStateSize = 4;
    var sharedProfilingBuffer = typeof SharedArrayBuffer === "function" ? new SharedArrayBuffer(profilingStateSize * Int32Array.BYTES_PER_ELEMENT) : typeof ArrayBuffer === "function" ? new ArrayBuffer(profilingStateSize * Int32Array.BYTES_PER_ELEMENT) : null // Don't crash the init path on IE9
    ;
    var profilingState = sharedProfilingBuffer !== null ? new Int32Array(sharedProfilingBuffer) : []; // We can't read this but it helps save bytes for null checks
    var PRIORITY = 0;
    var CURRENT_TASK_ID = 1;
    var CURRENT_RUN_ID = 2;
    var QUEUE_SIZE = 3;
    profilingState[PRIORITY] = NoPriority; // This is maintained with a counter, because the size of the priority queue
    // array might include canceled tasks.
    profilingState[QUEUE_SIZE] = 0;
    profilingState[CURRENT_TASK_ID] = 0;
    var INITIAL_EVENT_LOG_SIZE = 131072;
    var MAX_EVENT_LOG_SIZE = 524288; // Equivalent to 2 megabytes
    var eventLogSize = 0;
    var eventLogBuffer = null;
    var eventLog = null;
    var eventLogIndex = 0;
    var TaskStartEvent = 1;
    var TaskCompleteEvent = 2;
    var TaskErrorEvent = 3;
    var TaskCancelEvent = 4;
    var TaskRunEvent = 5;
    var TaskYieldEvent = 6;
    var SchedulerSuspendEvent = 7;
    var SchedulerResumeEvent = 8;
    function logEvent(entries) {
        if (eventLog !== null) {
            var offset = eventLogIndex;
            eventLogIndex += entries.length;
            if (eventLogIndex + 1 > eventLogSize) {
                eventLogSize *= 2;
                if (eventLogSize > MAX_EVENT_LOG_SIZE) {
                    // Using console['error'] to evade Babel and ESLint
                    console["error"]("Scheduler Profiling: Event log exceeded maximum size. Don't forget to call `stopLoggingProfilingEvents()`.");
                    stopLoggingProfilingEvents();
                    return;
                }
                var newEventLog = new Int32Array(eventLogSize * 4);
                newEventLog.set(eventLog);
                eventLogBuffer = newEventLog.buffer;
                eventLog = newEventLog;
            }
            eventLog.set(entries, offset);
        }
    }
    function startLoggingProfilingEvents() {
        eventLogSize = INITIAL_EVENT_LOG_SIZE;
        eventLogBuffer = new ArrayBuffer(eventLogSize * 4);
        eventLog = new Int32Array(eventLogBuffer);
        eventLogIndex = 0;
    }
    function stopLoggingProfilingEvents() {
        var buffer = eventLogBuffer;
        eventLogSize = 0;
        eventLogBuffer = null;
        eventLog = null;
        eventLogIndex = 0;
        return buffer;
    }
    function markTaskStart(task, ms) {
        profilingState[QUEUE_SIZE]++;
        if (eventLog !== null) // performance.now returns a float, representing milliseconds. When the
        // event is logged, it's coerced to an int. Convert to microseconds to
        // maintain extra degrees of precision.
        logEvent([
            TaskStartEvent,
            ms * 1000,
            task.id,
            task.priorityLevel
        ]);
    }
    function markTaskCompleted(task, ms) {
        profilingState[PRIORITY] = NoPriority;
        profilingState[CURRENT_TASK_ID] = 0;
        profilingState[QUEUE_SIZE]--;
        if (eventLog !== null) logEvent([
            TaskCompleteEvent,
            ms * 1000,
            task.id
        ]);
    }
    function markTaskCanceled(task, ms) {
        profilingState[QUEUE_SIZE]--;
        if (eventLog !== null) logEvent([
            TaskCancelEvent,
            ms * 1000,
            task.id
        ]);
    }
    function markTaskErrored(task, ms) {
        profilingState[PRIORITY] = NoPriority;
        profilingState[CURRENT_TASK_ID] = 0;
        profilingState[QUEUE_SIZE]--;
        if (eventLog !== null) logEvent([
            TaskErrorEvent,
            ms * 1000,
            task.id
        ]);
    }
    function markTaskRun(task, ms) {
        runIdCounter++;
        profilingState[PRIORITY] = task.priorityLevel;
        profilingState[CURRENT_TASK_ID] = task.id;
        profilingState[CURRENT_RUN_ID] = runIdCounter;
        if (eventLog !== null) logEvent([
            TaskRunEvent,
            ms * 1000,
            task.id,
            runIdCounter
        ]);
    }
    function markTaskYield(task, ms) {
        profilingState[PRIORITY] = NoPriority;
        profilingState[CURRENT_TASK_ID] = 0;
        profilingState[CURRENT_RUN_ID] = 0;
        if (eventLog !== null) logEvent([
            TaskYieldEvent,
            ms * 1000,
            task.id,
            runIdCounter
        ]);
    }
    function markSchedulerSuspended(ms) {
        mainThreadIdCounter++;
        if (eventLog !== null) logEvent([
            SchedulerSuspendEvent,
            ms * 1000,
            mainThreadIdCounter
        ]);
    }
    function markSchedulerUnsuspended(ms) {
        if (eventLog !== null) logEvent([
            SchedulerResumeEvent,
            ms * 1000,
            mainThreadIdCounter
        ]);
    }
    /* eslint-disable no-var */ // Math.pow(2, 30) - 1
    // 0b111111111111111111111111111111
    var maxSigned31BitInt = 1073741823; // Times out immediately
    var IMMEDIATE_PRIORITY_TIMEOUT = -1; // Eventually times out
    var USER_BLOCKING_PRIORITY = 250;
    var NORMAL_PRIORITY_TIMEOUT = 5000;
    var LOW_PRIORITY_TIMEOUT = 10000; // Never times out
    var IDLE_PRIORITY = maxSigned31BitInt; // Tasks are stored on a min heap
    var taskQueue = [];
    var timerQueue = []; // Incrementing id counter. Used to maintain insertion order.
    var taskIdCounter = 1; // Pausing the scheduler is useful for debugging.
    var currentTask = null;
    var currentPriorityLevel = NormalPriority; // This is set while performing work, to prevent re-entrancy.
    var isPerformingWork = false;
    var isHostCallbackScheduled = false;
    var isHostTimeoutScheduled = false;
    function advanceTimers(currentTime) {
        // Check for tasks that are no longer delayed and add them to the queue.
        var timer = peek(timerQueue);
        while(timer !== null){
            if (timer.callback === null) // Timer was cancelled.
            pop(timerQueue);
            else if (timer.startTime <= currentTime) {
                // Timer fired. Transfer to the task queue.
                pop(timerQueue);
                timer.sortIndex = timer.expirationTime;
                push(taskQueue, timer);
                markTaskStart(timer, currentTime);
                timer.isQueued = true;
            } else // Remaining timers are pending.
            return;
            timer = peek(timerQueue);
        }
    }
    function handleTimeout(currentTime) {
        isHostTimeoutScheduled = false;
        advanceTimers(currentTime);
        if (!isHostCallbackScheduled) {
            if (peek(taskQueue) !== null) {
                isHostCallbackScheduled = true;
                requestHostCallback(flushWork);
            } else {
                var firstTimer = peek(timerQueue);
                if (firstTimer !== null) requestHostTimeout(handleTimeout, firstTimer.startTime - currentTime);
            }
        }
    }
    function flushWork(hasTimeRemaining, initialTime) {
        markSchedulerUnsuspended(initialTime);
        isHostCallbackScheduled = false;
        if (isHostTimeoutScheduled) {
            // We scheduled a timeout but it's no longer needed. Cancel it.
            isHostTimeoutScheduled = false;
            cancelHostTimeout();
        }
        isPerformingWork = true;
        var previousPriorityLevel = currentPriorityLevel;
        try {
            if (enableProfiling) try {
                return workLoop(hasTimeRemaining, initialTime);
            } catch (error) {
                if (currentTask !== null) {
                    var currentTime = $c62a54e7e97de14b$export$c4744153514ff05d();
                    markTaskErrored(currentTask, currentTime);
                    currentTask.isQueued = false;
                }
                throw error;
            }
            else // No catch in prod codepath.
            return workLoop(hasTimeRemaining, initialTime);
        } finally{
            currentTask = null;
            currentPriorityLevel = previousPriorityLevel;
            isPerformingWork = false;
            var _currentTime = $c62a54e7e97de14b$export$c4744153514ff05d();
            markSchedulerSuspended(_currentTime);
        }
    }
    function workLoop(hasTimeRemaining, initialTime) {
        var currentTime = initialTime;
        advanceTimers(currentTime);
        currentTask = peek(taskQueue);
        while(currentTask !== null && !enableSchedulerDebugging){
            if (currentTask.expirationTime > currentTime && (!hasTimeRemaining || shouldYieldToHost())) break;
            var callback = currentTask.callback;
            if (callback !== null) {
                currentTask.callback = null;
                currentPriorityLevel = currentTask.priorityLevel;
                var didUserCallbackTimeout = currentTask.expirationTime <= currentTime;
                markTaskRun(currentTask, currentTime);
                var continuationCallback = callback(didUserCallbackTimeout);
                currentTime = $c62a54e7e97de14b$export$c4744153514ff05d();
                if (typeof continuationCallback === "function") {
                    currentTask.callback = continuationCallback;
                    markTaskYield(currentTask, currentTime);
                } else {
                    markTaskCompleted(currentTask, currentTime);
                    currentTask.isQueued = false;
                    if (currentTask === peek(taskQueue)) pop(taskQueue);
                }
                advanceTimers(currentTime);
            } else pop(taskQueue);
            currentTask = peek(taskQueue);
        } // Return whether there's additional work
        if (currentTask !== null) return true;
        else {
            var firstTimer = peek(timerQueue);
            if (firstTimer !== null) requestHostTimeout(handleTimeout, firstTimer.startTime - currentTime);
            return false;
        }
    }
    function unstable_runWithPriority(priorityLevel, eventHandler) {
        switch(priorityLevel){
            case ImmediatePriority:
            case UserBlockingPriority:
            case NormalPriority:
            case LowPriority:
            case IdlePriority:
                break;
            default:
                priorityLevel = NormalPriority;
        }
        var previousPriorityLevel = currentPriorityLevel;
        currentPriorityLevel = priorityLevel;
        try {
            return eventHandler();
        } finally{
            currentPriorityLevel = previousPriorityLevel;
        }
    }
    function unstable_next(eventHandler) {
        var priorityLevel;
        switch(currentPriorityLevel){
            case ImmediatePriority:
            case UserBlockingPriority:
            case NormalPriority:
                // Shift down to normal priority
                priorityLevel = NormalPriority;
                break;
            default:
                // Anything lower than normal priority should remain at the current level.
                priorityLevel = currentPriorityLevel;
                break;
        }
        var previousPriorityLevel = currentPriorityLevel;
        currentPriorityLevel = priorityLevel;
        try {
            return eventHandler();
        } finally{
            currentPriorityLevel = previousPriorityLevel;
        }
    }
    function unstable_wrapCallback(callback) {
        var parentPriorityLevel = currentPriorityLevel;
        return function() {
            // This is a fork of runWithPriority, inlined for performance.
            var previousPriorityLevel = currentPriorityLevel;
            currentPriorityLevel = parentPriorityLevel;
            try {
                return callback.apply(this, arguments);
            } finally{
                currentPriorityLevel = previousPriorityLevel;
            }
        };
    }
    function timeoutForPriorityLevel(priorityLevel) {
        switch(priorityLevel){
            case ImmediatePriority:
                return IMMEDIATE_PRIORITY_TIMEOUT;
            case UserBlockingPriority:
                return USER_BLOCKING_PRIORITY;
            case IdlePriority:
                return IDLE_PRIORITY;
            case LowPriority:
                return LOW_PRIORITY_TIMEOUT;
            case NormalPriority:
            default:
                return NORMAL_PRIORITY_TIMEOUT;
        }
    }
    function unstable_scheduleCallback(priorityLevel, callback, options) {
        var currentTime = $c62a54e7e97de14b$export$c4744153514ff05d();
        var startTime;
        var timeout;
        if (typeof options === "object" && options !== null) {
            var delay = options.delay;
            if (typeof delay === "number" && delay > 0) startTime = currentTime + delay;
            else startTime = currentTime;
            timeout = typeof options.timeout === "number" ? options.timeout : timeoutForPriorityLevel(priorityLevel);
        } else {
            timeout = timeoutForPriorityLevel(priorityLevel);
            startTime = currentTime;
        }
        var expirationTime = startTime + timeout;
        var newTask = {
            id: taskIdCounter++,
            callback: callback,
            priorityLevel: priorityLevel,
            startTime: startTime,
            expirationTime: expirationTime,
            sortIndex: -1
        };
        newTask.isQueued = false;
        if (startTime > currentTime) {
            // This is a delayed task.
            newTask.sortIndex = startTime;
            push(timerQueue, newTask);
            if (peek(taskQueue) === null && newTask === peek(timerQueue)) {
                // All tasks are delayed, and this is the task with the earliest delay.
                if (isHostTimeoutScheduled) // Cancel an existing timeout.
                cancelHostTimeout();
                else isHostTimeoutScheduled = true;
                 // Schedule a timeout.
                requestHostTimeout(handleTimeout, startTime - currentTime);
            }
        } else {
            newTask.sortIndex = expirationTime;
            push(taskQueue, newTask);
            markTaskStart(newTask, currentTime);
            newTask.isQueued = true;
            // wait until the next time we yield.
            if (!isHostCallbackScheduled && !isPerformingWork) {
                isHostCallbackScheduled = true;
                requestHostCallback(flushWork);
            }
        }
        return newTask;
    }
    function unstable_pauseExecution() {}
    function unstable_continueExecution() {
        if (!isHostCallbackScheduled && !isPerformingWork) {
            isHostCallbackScheduled = true;
            requestHostCallback(flushWork);
        }
    }
    function unstable_getFirstCallbackNode() {
        return peek(taskQueue);
    }
    function unstable_cancelCallback(task) {
        if (task.isQueued) {
            var currentTime = $c62a54e7e97de14b$export$c4744153514ff05d();
            markTaskCanceled(task, currentTime);
            task.isQueued = false;
        }
        // remove from the queue because you can't remove arbitrary nodes from an
        // array based heap, only the first one.)
        task.callback = null;
    }
    function unstable_getCurrentPriorityLevel() {
        return currentPriorityLevel;
    }
    function unstable_shouldYield() {
        var currentTime = $c62a54e7e97de14b$export$c4744153514ff05d();
        advanceTimers(currentTime);
        var firstTask = peek(taskQueue);
        return firstTask !== currentTask && currentTask !== null && firstTask !== null && firstTask.callback !== null && firstTask.startTime <= currentTime && firstTask.expirationTime < currentTask.expirationTime || shouldYieldToHost();
    }
    var unstable_requestPaint = requestPaint;
    var unstable_Profiling = {
        startLoggingProfilingEvents: startLoggingProfilingEvents,
        stopLoggingProfilingEvents: stopLoggingProfilingEvents,
        sharedProfilingBuffer: sharedProfilingBuffer
    };
    $c62a54e7e97de14b$export$3e506c1ccc9cc1a7 = IdlePriority;
    $c62a54e7e97de14b$export$e26fe2ed2fa76875 = ImmediatePriority;
    $c62a54e7e97de14b$export$502329bbf4b505b1 = LowPriority;
    $c62a54e7e97de14b$export$6e3807111c4874c4 = NormalPriority;
    $c62a54e7e97de14b$export$c27134553091fb3a = unstable_Profiling;
    $c62a54e7e97de14b$export$33ee1acdc04fd2a2 = UserBlockingPriority;
    $c62a54e7e97de14b$export$b00a404bbd5edef2 = unstable_cancelCallback;
    $c62a54e7e97de14b$export$8352ce38b91d0c62 = unstable_continueExecution;
    $c62a54e7e97de14b$export$d3dfb8e4810cb555 = unstable_getCurrentPriorityLevel;
    $c62a54e7e97de14b$export$839f9183b0465a69 = unstable_getFirstCallbackNode;
    $c62a54e7e97de14b$export$72fdf0e06517287b = unstable_next;
    $c62a54e7e97de14b$export$4b844e58a3e414b4 = unstable_pauseExecution;
    $c62a54e7e97de14b$export$816d2913ae6b83b1 = unstable_requestPaint;
    $c62a54e7e97de14b$export$61bcfe829111a1d0 = unstable_runWithPriority;
    $c62a54e7e97de14b$export$7ee8c9beb337bc3f = unstable_scheduleCallback;
    $c62a54e7e97de14b$export$b5836b71941fa3ed = unstable_shouldYield;
    $c62a54e7e97de14b$export$cf845f2c119da08a = unstable_wrapCallback;
})();

});


parcelRegister("fGF8G", function(module, exports) {
"use strict";

module.exports = (parcelRequire("vEchA"));

});
parcelRegister("vEchA", function(module, exports) {

$parcel$export(module.exports, "__interactionsRef", function () { return $05f213ac43f77348$export$236303149b061964; }, function (v) { return $05f213ac43f77348$export$236303149b061964 = v; });
$parcel$export(module.exports, "__subscriberRef", function () { return $05f213ac43f77348$export$d8c36835f54f0a3b; }, function (v) { return $05f213ac43f77348$export$d8c36835f54f0a3b = v; });
$parcel$export(module.exports, "unstable_clear", function () { return $05f213ac43f77348$export$4a908c8bc96de6cd; }, function (v) { return $05f213ac43f77348$export$4a908c8bc96de6cd = v; });
$parcel$export(module.exports, "unstable_getCurrent", function () { return $05f213ac43f77348$export$49d8199c8144c803; }, function (v) { return $05f213ac43f77348$export$49d8199c8144c803 = v; });
$parcel$export(module.exports, "unstable_getThreadID", function () { return $05f213ac43f77348$export$c7d3dd8712817dbc; }, function (v) { return $05f213ac43f77348$export$c7d3dd8712817dbc = v; });
$parcel$export(module.exports, "unstable_subscribe", function () { return $05f213ac43f77348$export$932a6d6a24b633a5; }, function (v) { return $05f213ac43f77348$export$932a6d6a24b633a5 = v; });
$parcel$export(module.exports, "unstable_trace", function () { return $05f213ac43f77348$export$8405cb466bd0a1f1; }, function (v) { return $05f213ac43f77348$export$8405cb466bd0a1f1 = v; });
$parcel$export(module.exports, "unstable_unsubscribe", function () { return $05f213ac43f77348$export$4fd753a282912317; }, function (v) { return $05f213ac43f77348$export$4fd753a282912317 = v; });
$parcel$export(module.exports, "unstable_wrap", function () { return $05f213ac43f77348$export$230d7bceee602808; }, function (v) { return $05f213ac43f77348$export$230d7bceee602808 = v; });
/** @license React v0.19.1
 * scheduler-tracing.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ // Interactions "stack"–
// Meaning that newly traced interactions are appended to the previously active set.
// When an interaction goes out of scope, the previous set (if any) is restored.
var $05f213ac43f77348$export$236303149b061964;
var $05f213ac43f77348$export$d8c36835f54f0a3b;
var $05f213ac43f77348$export$4a908c8bc96de6cd;
var $05f213ac43f77348$export$49d8199c8144c803;
var $05f213ac43f77348$export$c7d3dd8712817dbc;
var $05f213ac43f77348$export$932a6d6a24b633a5;
var $05f213ac43f77348$export$8405cb466bd0a1f1;
var $05f213ac43f77348$export$4fd753a282912317;
var $05f213ac43f77348$export$230d7bceee602808;
"use strict";
(function() {
    "use strict";
    var DEFAULT_THREAD_ID = 0; // Counters used to generate unique IDs.
    var interactionIDCounter = 0;
    var threadIDCounter = 0; // Set of currently traced interactions.
    $05f213ac43f77348$export$236303149b061964 = null; // Listener(s) to notify when interactions begin and end.
    $05f213ac43f77348$export$d8c36835f54f0a3b = null;
    $05f213ac43f77348$export$236303149b061964 = {
        current: new Set()
    };
    $05f213ac43f77348$export$d8c36835f54f0a3b = {
        current: null
    };
    function unstable_clear(callback) {
        var prevInteractions = $05f213ac43f77348$export$236303149b061964.current;
        $05f213ac43f77348$export$236303149b061964.current = new Set();
        try {
            return callback();
        } finally{
            $05f213ac43f77348$export$236303149b061964.current = prevInteractions;
        }
    }
    function unstable_getCurrent() {
        return $05f213ac43f77348$export$236303149b061964.current;
    }
    function unstable_getThreadID() {
        return ++threadIDCounter;
    }
    function unstable_trace(name, timestamp, callback) {
        var threadID = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : DEFAULT_THREAD_ID;
        var interaction = {
            __count: 1,
            id: interactionIDCounter++,
            name: name,
            timestamp: timestamp
        };
        var prevInteractions = $05f213ac43f77348$export$236303149b061964.current; // Traced interactions should stack/accumulate.
        // To do that, clone the current interactions.
        // The previous set will be restored upon completion.
        var interactions = new Set(prevInteractions);
        interactions.add(interaction);
        $05f213ac43f77348$export$236303149b061964.current = interactions;
        var subscriber = $05f213ac43f77348$export$d8c36835f54f0a3b.current;
        var returnValue;
        try {
            if (subscriber !== null) subscriber.onInteractionTraced(interaction);
        } finally{
            try {
                if (subscriber !== null) subscriber.onWorkStarted(interactions, threadID);
            } finally{
                try {
                    returnValue = callback();
                } finally{
                    $05f213ac43f77348$export$236303149b061964.current = prevInteractions;
                    try {
                        if (subscriber !== null) subscriber.onWorkStopped(interactions, threadID);
                    } finally{
                        interaction.__count--; // If no async work was scheduled for this interaction,
                        // Notify subscribers that it's completed.
                        if (subscriber !== null && interaction.__count === 0) subscriber.onInteractionScheduledWorkCompleted(interaction);
                    }
                }
            }
        }
        return returnValue;
    }
    function unstable_wrap(callback) {
        var threadID = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : DEFAULT_THREAD_ID;
        var wrappedInteractions = $05f213ac43f77348$export$236303149b061964.current;
        var subscriber = $05f213ac43f77348$export$d8c36835f54f0a3b.current;
        if (subscriber !== null) subscriber.onWorkScheduled(wrappedInteractions, threadID);
         // Update the pending async work count for the current interactions.
        // Update after calling subscribers in case of error.
        wrappedInteractions.forEach(function(interaction) {
            interaction.__count++;
        });
        var hasRun = false;
        function wrapped() {
            var prevInteractions = $05f213ac43f77348$export$236303149b061964.current;
            $05f213ac43f77348$export$236303149b061964.current = wrappedInteractions;
            subscriber = $05f213ac43f77348$export$d8c36835f54f0a3b.current;
            try {
                var returnValue;
                try {
                    if (subscriber !== null) subscriber.onWorkStarted(wrappedInteractions, threadID);
                } finally{
                    try {
                        returnValue = callback.apply(undefined, arguments);
                    } finally{
                        $05f213ac43f77348$export$236303149b061964.current = prevInteractions;
                        if (subscriber !== null) subscriber.onWorkStopped(wrappedInteractions, threadID);
                    }
                }
                return returnValue;
            } finally{
                if (!hasRun) {
                    // We only expect a wrapped function to be executed once,
                    // But in the event that it's executed more than once–
                    // Only decrement the outstanding interaction counts once.
                    hasRun = true; // Update pending async counts for all wrapped interactions.
                    // If this was the last scheduled async work for any of them,
                    // Mark them as completed.
                    wrappedInteractions.forEach(function(interaction) {
                        interaction.__count--;
                        if (subscriber !== null && interaction.__count === 0) subscriber.onInteractionScheduledWorkCompleted(interaction);
                    });
                }
            }
        }
        wrapped.cancel = function cancel() {
            subscriber = $05f213ac43f77348$export$d8c36835f54f0a3b.current;
            try {
                if (subscriber !== null) subscriber.onWorkCanceled(wrappedInteractions, threadID);
            } finally{
                // Update pending async counts for all wrapped interactions.
                // If this was the last scheduled async work for any of them,
                // Mark them as completed.
                wrappedInteractions.forEach(function(interaction) {
                    interaction.__count--;
                    if (subscriber && interaction.__count === 0) subscriber.onInteractionScheduledWorkCompleted(interaction);
                });
            }
        };
        return wrapped;
    }
    var subscribers = null;
    subscribers = new Set();
    function unstable_subscribe(subscriber) {
        subscribers.add(subscriber);
        if (subscribers.size === 1) $05f213ac43f77348$export$d8c36835f54f0a3b.current = {
            onInteractionScheduledWorkCompleted: onInteractionScheduledWorkCompleted,
            onInteractionTraced: onInteractionTraced,
            onWorkCanceled: onWorkCanceled,
            onWorkScheduled: onWorkScheduled,
            onWorkStarted: onWorkStarted,
            onWorkStopped: onWorkStopped
        };
    }
    function unstable_unsubscribe(subscriber) {
        subscribers.delete(subscriber);
        if (subscribers.size === 0) $05f213ac43f77348$export$d8c36835f54f0a3b.current = null;
    }
    function onInteractionTraced(interaction) {
        var didCatchError = false;
        var caughtError = null;
        subscribers.forEach(function(subscriber) {
            try {
                subscriber.onInteractionTraced(interaction);
            } catch (error) {
                if (!didCatchError) {
                    didCatchError = true;
                    caughtError = error;
                }
            }
        });
        if (didCatchError) throw caughtError;
    }
    function onInteractionScheduledWorkCompleted(interaction) {
        var didCatchError = false;
        var caughtError = null;
        subscribers.forEach(function(subscriber) {
            try {
                subscriber.onInteractionScheduledWorkCompleted(interaction);
            } catch (error) {
                if (!didCatchError) {
                    didCatchError = true;
                    caughtError = error;
                }
            }
        });
        if (didCatchError) throw caughtError;
    }
    function onWorkScheduled(interactions, threadID) {
        var didCatchError = false;
        var caughtError = null;
        subscribers.forEach(function(subscriber) {
            try {
                subscriber.onWorkScheduled(interactions, threadID);
            } catch (error) {
                if (!didCatchError) {
                    didCatchError = true;
                    caughtError = error;
                }
            }
        });
        if (didCatchError) throw caughtError;
    }
    function onWorkStarted(interactions, threadID) {
        var didCatchError = false;
        var caughtError = null;
        subscribers.forEach(function(subscriber) {
            try {
                subscriber.onWorkStarted(interactions, threadID);
            } catch (error) {
                if (!didCatchError) {
                    didCatchError = true;
                    caughtError = error;
                }
            }
        });
        if (didCatchError) throw caughtError;
    }
    function onWorkStopped(interactions, threadID) {
        var didCatchError = false;
        var caughtError = null;
        subscribers.forEach(function(subscriber) {
            try {
                subscriber.onWorkStopped(interactions, threadID);
            } catch (error) {
                if (!didCatchError) {
                    didCatchError = true;
                    caughtError = error;
                }
            }
        });
        if (didCatchError) throw caughtError;
    }
    function onWorkCanceled(interactions, threadID) {
        var didCatchError = false;
        var caughtError = null;
        subscribers.forEach(function(subscriber) {
            try {
                subscriber.onWorkCanceled(interactions, threadID);
            } catch (error) {
                if (!didCatchError) {
                    didCatchError = true;
                    caughtError = error;
                }
            }
        });
        if (didCatchError) throw caughtError;
    }
    $05f213ac43f77348$export$4a908c8bc96de6cd = unstable_clear;
    $05f213ac43f77348$export$49d8199c8144c803 = unstable_getCurrent;
    $05f213ac43f77348$export$c7d3dd8712817dbc = unstable_getThreadID;
    $05f213ac43f77348$export$932a6d6a24b633a5 = unstable_subscribe;
    $05f213ac43f77348$export$8405cb466bd0a1f1 = unstable_trace;
    $05f213ac43f77348$export$4fd753a282912317 = unstable_unsubscribe;
    $05f213ac43f77348$export$230d7bceee602808 = unstable_wrap;
})();

});




parcelRegister("iUAyZ", function(module, exports) {
(function(f) {
    var g;
    module.exports = f();
})(function() {
    var define, module1, exports;
    var _$breadcrumbTypes_8 = [
        "navigation",
        "request",
        "process",
        "log",
        "user",
        "state",
        "error",
        "manual"
    ];
    // Array#reduce
    var _$reduce_17 = function(arr, fn, accum) {
        var val = accum;
        for(var i = 0, len = arr.length; i < len; i++)val = fn(val, arr[i], i, arr);
        return val;
    }; /* removed: var _$reduce_17 = require('./reduce'); */ 
    var _$filter_12 = function(arr, fn) {
        return _$reduce_17(arr, function(accum, item, i, arr) {
            return !fn(item, i, arr) ? accum : accum.concat(item);
        }, []);
    }; /* removed: var _$reduce_17 = require('./reduce'); */ 
    var _$includes_13 = function(arr, x) {
        return _$reduce_17(arr, function(accum, item, i, arr) {
            return accum === true || item === x;
        }, false);
    };
    // Array#isArray
    var _$isArray_14 = function(obj) {
        return Object.prototype.toString.call(obj) === "[object Array]";
    };
    /* eslint-disable-next-line no-prototype-builtins */ var _hasDontEnumBug = !({
        toString: null
    }).propertyIsEnumerable("toString");
    var _dontEnums = [
        "toString",
        "toLocaleString",
        "valueOf",
        "hasOwnProperty",
        "isPrototypeOf",
        "propertyIsEnumerable",
        "constructor"
    ]; // Object#keys
    var _$keys_15 = function(obj) {
        // stripped down version of
        // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/Keys
        var result = [];
        var prop;
        for(prop in obj)if (Object.prototype.hasOwnProperty.call(obj, prop)) result.push(prop);
        if (!_hasDontEnumBug) return result;
        for(var i = 0, len = _dontEnums.length; i < len; i++)if (Object.prototype.hasOwnProperty.call(obj, _dontEnums[i])) result.push(_dontEnums[i]);
        return result;
    };
    var _$intRange_24 = function(min, max) {
        if (min === void 0) min = 1;
        if (max === void 0) max = Infinity;
        return function(value) {
            return typeof value === "number" && parseInt("" + value, 10) === value && value >= min && value <= max;
        };
    }; /* removed: var _$filter_12 = require('../es-utils/filter'); */ 
    var _$listOfFunctions_25 = function(value) {
        return typeof value === "function" || _$isArray_14(value) && _$filter_12(value, function(f) {
            return typeof f === "function";
        }).length === value.length;
    };
    var _$stringWithLength_26 = function(value) {
        return typeof value === "string" && !!value.length;
    };
    var _$config_5 = {}; /* removed: var _$filter_12 = require('./lib/es-utils/filter'); */ 
    var defaultErrorTypes = function() {
        return {
            unhandledExceptions: true,
            unhandledRejections: true
        };
    };
    _$config_5.schema = {
        apiKey: {
            defaultValue: function() {
                return null;
            },
            message: "is required",
            validate: _$stringWithLength_26
        },
        appVersion: {
            defaultValue: function() {
                return undefined;
            },
            message: "should be a string",
            validate: function(value) {
                return value === undefined || _$stringWithLength_26(value);
            }
        },
        appType: {
            defaultValue: function() {
                return undefined;
            },
            message: "should be a string",
            validate: function(value) {
                return value === undefined || _$stringWithLength_26(value);
            }
        },
        autoDetectErrors: {
            defaultValue: function() {
                return true;
            },
            message: "should be true|false",
            validate: function(value) {
                return value === true || value === false;
            }
        },
        enabledErrorTypes: {
            defaultValue: function() {
                return defaultErrorTypes();
            },
            message: "should be an object containing the flags { unhandledExceptions:true|false, unhandledRejections:true|false }",
            allowPartialObject: true,
            validate: function(value) {
                // ensure we have an object
                if (typeof value !== "object" || !value) return false;
                var providedKeys = _$keys_15(value);
                var defaultKeys = _$keys_15(defaultErrorTypes()); // ensure it only has a subset of the allowed keys
                if (_$filter_12(providedKeys, function(k) {
                    return _$includes_13(defaultKeys, k);
                }).length < providedKeys.length) return false; // ensure all of the values are boolean
                if (_$filter_12(_$keys_15(value), function(k) {
                    return typeof value[k] !== "boolean";
                }).length > 0) return false;
                return true;
            }
        },
        onError: {
            defaultValue: function() {
                return [];
            },
            message: "should be a function or array of functions",
            validate: _$listOfFunctions_25
        },
        onSession: {
            defaultValue: function() {
                return [];
            },
            message: "should be a function or array of functions",
            validate: _$listOfFunctions_25
        },
        onBreadcrumb: {
            defaultValue: function() {
                return [];
            },
            message: "should be a function or array of functions",
            validate: _$listOfFunctions_25
        },
        endpoints: {
            defaultValue: function() {
                return {
                    notify: "https://notify.bugsnag.com",
                    sessions: "https://sessions.bugsnag.com"
                };
            },
            message: "should be an object containing endpoint URLs { notify, sessions }",
            validate: function(val) {
                return val && typeof val === "object" && // notify and sessions must always be set
                _$stringWithLength_26(val.notify) && _$stringWithLength_26(val.sessions) && // ensure no keys other than notify/session are set on endpoints object
                _$filter_12(_$keys_15(val), function(k) {
                    return !_$includes_13([
                        "notify",
                        "sessions"
                    ], k);
                }).length === 0;
            }
        },
        autoTrackSessions: {
            defaultValue: function(val) {
                return true;
            },
            message: "should be true|false",
            validate: function(val) {
                return val === true || val === false;
            }
        },
        enabledReleaseStages: {
            defaultValue: function() {
                return null;
            },
            message: "should be an array of strings",
            validate: function(value) {
                return value === null || _$isArray_14(value) && _$filter_12(value, function(f) {
                    return typeof f === "string";
                }).length === value.length;
            }
        },
        releaseStage: {
            defaultValue: function() {
                return "production";
            },
            message: "should be a string",
            validate: function(value) {
                return typeof value === "string" && value.length;
            }
        },
        maxBreadcrumbs: {
            defaultValue: function() {
                return 25;
            },
            message: "should be a number \u2264100",
            validate: function(value) {
                return _$intRange_24(0, 100)(value);
            }
        },
        enabledBreadcrumbTypes: {
            defaultValue: function() {
                return _$breadcrumbTypes_8;
            },
            message: "should be null or a list of available breadcrumb types (" + _$breadcrumbTypes_8.join(",") + ")",
            validate: function(value) {
                return value === null || _$isArray_14(value) && _$reduce_17(value, function(accum, maybeType) {
                    if (accum === false) return accum;
                    return _$includes_13(_$breadcrumbTypes_8, maybeType);
                }, true);
            }
        },
        context: {
            defaultValue: function() {
                return undefined;
            },
            message: "should be a string",
            validate: function(value) {
                return value === undefined || typeof value === "string";
            }
        },
        user: {
            defaultValue: function() {
                return {};
            },
            message: "should be an object with { id, email, name } properties",
            validate: function(value) {
                return value === null || value && _$reduce_17(_$keys_15(value), function(accum, key) {
                    return accum && _$includes_13([
                        "id",
                        "email",
                        "name"
                    ], key);
                }, true);
            }
        },
        metadata: {
            defaultValue: function() {
                return {};
            },
            message: "should be an object",
            validate: function(value) {
                return typeof value === "object" && value !== null;
            }
        },
        logger: {
            defaultValue: function() {
                return undefined;
            },
            message: "should be null or an object with methods { debug, info, warn, error }",
            validate: function(value) {
                return !value || value && _$reduce_17([
                    "debug",
                    "info",
                    "warn",
                    "error"
                ], function(accum, method) {
                    return accum && typeof value[method] === "function";
                }, true);
            }
        },
        redactedKeys: {
            defaultValue: function() {
                return [
                    "password"
                ];
            },
            message: "should be an array of strings|regexes",
            validate: function(value) {
                return _$isArray_14(value) && value.length === _$filter_12(value, function(s) {
                    return typeof s === "string" || s && typeof s.test === "function";
                }).length;
            }
        },
        plugins: {
            defaultValue: function() {
                return [];
            },
            message: "should be an array of plugin objects",
            validate: function(value) {
                return _$isArray_14(value) && value.length === _$filter_12(value, function(p) {
                    return p && typeof p === "object" && typeof p.load === "function";
                }).length;
            }
        },
        featureFlags: {
            defaultValue: function() {
                return [];
            },
            message: 'should be an array of objects that have a "name" property',
            validate: function(value) {
                return _$isArray_14(value) && value.length === _$filter_12(value, function(feature) {
                    return feature && typeof feature === "object" && typeof feature.name === "string";
                }).length;
            }
        }
    };
    // extends helper from babel
    // https://github.com/babel/babel/blob/916429b516e6466fd06588ee820e40e025d7f3a3/packages/babel-helpers/src/helpers.js#L377-L393
    var _$assign_11 = function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    }; /* removed: var _$reduce_17 = require('./reduce'); */ 
    var _$map_16 = function(arr, fn) {
        return _$reduce_17(arr, function(accum, item, i, arr) {
            return accum.concat(fn(item, i, arr));
        }, []);
    };
    function _extends() {
        _extends = Object.assign || function(target) {
            for(var i = 1; i < arguments.length; i++){
                var source = arguments[i];
                for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
            }
            return target;
        };
        return _extends.apply(this, arguments);
    }
    var schema = _$config_5.schema; /* removed: var _$map_16 = require('@bugsnag/core/lib/es-utils/map'); */ 
    var _$config_1 = {
        releaseStage: _$assign_11({}, schema.releaseStage, {
            defaultValue: function() {
                if (/^localhost(:\d+)?$/.test(window.location.host)) return "development";
                return "production";
            }
        }),
        appType: _extends({}, schema.appType, {
            defaultValue: function() {
                return "browser";
            }
        }),
        logger: _$assign_11({}, schema.logger, {
            defaultValue: function() {
                return typeof console !== "undefined" && typeof console.debug === "function" ? getPrefixedConsole() : undefined;
            }
        })
    };
    var getPrefixedConsole = function() {
        var logger = {};
        var consoleLog = console.log;
        _$map_16([
            "debug",
            "info",
            "warn",
            "error"
        ], function(method) {
            var consoleMethod = console[method];
            logger[method] = typeof consoleMethod === "function" ? consoleMethod.bind(console, "[bugsnag]") : consoleLog.bind(console, "[bugsnag]");
        });
        return logger;
    };
    var Breadcrumb = /*#__PURE__*/ function() {
        function Breadcrumb(message, metadata, type, timestamp) {
            if (timestamp === void 0) timestamp = new Date();
            this.type = type;
            this.message = message;
            this.metadata = metadata;
            this.timestamp = timestamp;
        }
        var _proto = Breadcrumb.prototype;
        _proto.toJSON = function toJSON() {
            return {
                type: this.type,
                name: this.message,
                timestamp: this.timestamp,
                metaData: this.metadata
            };
        };
        return Breadcrumb;
    }();
    var _$Breadcrumb_3 = Breadcrumb;
    var _$stackframe_34 = {};
    (function(root, factory) {
        "use strict"; // Universal Module Definition (UMD) to support AMD, CommonJS/Node.js, Rhino, and browsers.
        /* istanbul ignore next */ if (typeof define === "function" && define.amd) define("stackframe", [], factory);
        else if (typeof _$stackframe_34 === "object") _$stackframe_34 = factory();
        else root.StackFrame = factory();
    })(this, function() {
        "use strict";
        function _isNumber(n) {
            return !isNaN(parseFloat(n)) && isFinite(n);
        }
        function _capitalize(str) {
            return str.charAt(0).toUpperCase() + str.substring(1);
        }
        function _getter(p) {
            return function() {
                return this[p];
            };
        }
        var booleanProps = [
            "isConstructor",
            "isEval",
            "isNative",
            "isToplevel"
        ];
        var numericProps = [
            "columnNumber",
            "lineNumber"
        ];
        var stringProps = [
            "fileName",
            "functionName",
            "source"
        ];
        var arrayProps = [
            "args"
        ];
        var props = booleanProps.concat(numericProps, stringProps, arrayProps);
        function StackFrame(obj) {
            if (obj instanceof Object) {
                for(var i = 0; i < props.length; i++)if (obj.hasOwnProperty(props[i]) && obj[props[i]] !== undefined) this["set" + _capitalize(props[i])](obj[props[i]]);
            }
        }
        StackFrame.prototype = {
            getArgs: function() {
                return this.args;
            },
            setArgs: function(v) {
                if (Object.prototype.toString.call(v) !== "[object Array]") throw new TypeError("Args must be an Array");
                this.args = v;
            },
            getEvalOrigin: function() {
                return this.evalOrigin;
            },
            setEvalOrigin: function(v) {
                if (v instanceof StackFrame) this.evalOrigin = v;
                else if (v instanceof Object) this.evalOrigin = new StackFrame(v);
                else throw new TypeError("Eval Origin must be an Object or StackFrame");
            },
            toString: function() {
                var functionName = this.getFunctionName() || "{anonymous}";
                var args = "(" + (this.getArgs() || []).join(",") + ")";
                var fileName = this.getFileName() ? "@" + this.getFileName() : "";
                var lineNumber = _isNumber(this.getLineNumber()) ? ":" + this.getLineNumber() : "";
                var columnNumber = _isNumber(this.getColumnNumber()) ? ":" + this.getColumnNumber() : "";
                return functionName + args + fileName + lineNumber + columnNumber;
            }
        };
        for(var i = 0; i < booleanProps.length; i++){
            StackFrame.prototype["get" + _capitalize(booleanProps[i])] = _getter(booleanProps[i]);
            StackFrame.prototype["set" + _capitalize(booleanProps[i])] = function(p) {
                return function(v) {
                    this[p] = Boolean(v);
                };
            }(booleanProps[i]);
        }
        for(var j = 0; j < numericProps.length; j++){
            StackFrame.prototype["get" + _capitalize(numericProps[j])] = _getter(numericProps[j]);
            StackFrame.prototype["set" + _capitalize(numericProps[j])] = function(p) {
                return function(v) {
                    if (!_isNumber(v)) throw new TypeError(p + " must be a Number");
                    this[p] = Number(v);
                };
            }(numericProps[j]);
        }
        for(var k = 0; k < stringProps.length; k++){
            StackFrame.prototype["get" + _capitalize(stringProps[k])] = _getter(stringProps[k]);
            StackFrame.prototype["set" + _capitalize(stringProps[k])] = function(p) {
                return function(v) {
                    this[p] = String(v);
                };
            }(stringProps[k]);
        }
        return StackFrame;
    });
    var _$errorStackParser_31 = {};
    (function(root, factory) {
        "use strict"; // Universal Module Definition (UMD) to support AMD, CommonJS/Node.js, Rhino, and browsers.
        /* istanbul ignore next */ if (typeof define === "function" && define.amd) define("error-stack-parser", [
            "stackframe"
        ], factory);
        else if (typeof _$errorStackParser_31 === "object") _$errorStackParser_31 = factory(_$stackframe_34);
        else root.ErrorStackParser = factory(root.StackFrame);
    })(this, function ErrorStackParser(StackFrame) {
        "use strict";
        var FIREFOX_SAFARI_STACK_REGEXP = /(^|@)\S+\:\d+/;
        var CHROME_IE_STACK_REGEXP = /^\s*at .*(\S+\:\d+|\(native\))/m;
        var SAFARI_NATIVE_CODE_REGEXP = /^(eval@)?(\[native code\])?$/;
        return {
            /**
     * Given an Error object, extract the most information from it.
     *
     * @param {Error} error object
     * @return {Array} of StackFrames
     */ parse: function ErrorStackParser$$parse(error) {
                if (typeof error.stacktrace !== "undefined" || typeof error["opera#sourceloc"] !== "undefined") return this.parseOpera(error);
                else if (error.stack && error.stack.match(CHROME_IE_STACK_REGEXP)) return this.parseV8OrIE(error);
                else if (error.stack) return this.parseFFOrSafari(error);
                else throw new Error("Cannot parse given Error object");
            },
            // Separate line and column numbers from a string of the form: (URI:Line:Column)
            extractLocation: function ErrorStackParser$$extractLocation(urlLike) {
                // Fail-fast but return locations like "(native)"
                if (urlLike.indexOf(":") === -1) return [
                    urlLike
                ];
                var regExp = /(.+?)(?:\:(\d+))?(?:\:(\d+))?$/;
                var parts = regExp.exec(urlLike.replace(/[\(\)]/g, ""));
                return [
                    parts[1],
                    parts[2] || undefined,
                    parts[3] || undefined
                ];
            },
            parseV8OrIE: function ErrorStackParser$$parseV8OrIE(error) {
                var filtered = error.stack.split("\n").filter(function(line) {
                    return !!line.match(CHROME_IE_STACK_REGEXP);
                }, this);
                return filtered.map(function(line) {
                    if (line.indexOf("(eval ") > -1) // Throw away eval information until we implement stacktrace.js/stackframe#8
                    line = line.replace(/eval code/g, "eval").replace(/(\(eval at [^\()]*)|(\)\,.*$)/g, "");
                    var sanitizedLine = line.replace(/^\s+/, "").replace(/\(eval code/g, "("); // capture and preseve the parenthesized location "(/foo/my bar.js:12:87)" in
                    // case it has spaces in it, as the string is split on \s+ later on
                    var location = sanitizedLine.match(/ (\((.+):(\d+):(\d+)\)$)/); // remove the parenthesized location from the line, if it was matched
                    sanitizedLine = location ? sanitizedLine.replace(location[0], "") : sanitizedLine;
                    var tokens = sanitizedLine.split(/\s+/).slice(1); // if a location was matched, pass it to extractLocation() otherwise pop the last token
                    var locationParts = this.extractLocation(location ? location[1] : tokens.pop());
                    var functionName = tokens.join(" ") || undefined;
                    var fileName = [
                        "eval",
                        "<anonymous>"
                    ].indexOf(locationParts[0]) > -1 ? undefined : locationParts[0];
                    return new StackFrame({
                        functionName: functionName,
                        fileName: fileName,
                        lineNumber: locationParts[1],
                        columnNumber: locationParts[2],
                        source: line
                    });
                }, this);
            },
            parseFFOrSafari: function ErrorStackParser$$parseFFOrSafari(error) {
                var filtered = error.stack.split("\n").filter(function(line) {
                    return !line.match(SAFARI_NATIVE_CODE_REGEXP);
                }, this);
                return filtered.map(function(line) {
                    // Throw away eval information until we implement stacktrace.js/stackframe#8
                    if (line.indexOf(" > eval") > -1) line = line.replace(/ line (\d+)(?: > eval line \d+)* > eval\:\d+\:\d+/g, ":$1");
                    if (line.indexOf("@") === -1 && line.indexOf(":") === -1) // Safari eval frames only have function names and nothing else
                    return new StackFrame({
                        functionName: line
                    });
                    else {
                        var functionNameRegex = /((.*".+"[^@]*)?[^@]*)(?:@)/;
                        var matches = line.match(functionNameRegex);
                        var functionName = matches && matches[1] ? matches[1] : undefined;
                        var locationParts = this.extractLocation(line.replace(functionNameRegex, ""));
                        return new StackFrame({
                            functionName: functionName,
                            fileName: locationParts[0],
                            lineNumber: locationParts[1],
                            columnNumber: locationParts[2],
                            source: line
                        });
                    }
                }, this);
            },
            parseOpera: function ErrorStackParser$$parseOpera(e) {
                if (!e.stacktrace || e.message.indexOf("\n") > -1 && e.message.split("\n").length > e.stacktrace.split("\n").length) return this.parseOpera9(e);
                else if (!e.stack) return this.parseOpera10(e);
                else return this.parseOpera11(e);
            },
            parseOpera9: function ErrorStackParser$$parseOpera9(e) {
                var lineRE = /Line (\d+).*script (?:in )?(\S+)/i;
                var lines = e.message.split("\n");
                var result = [];
                for(var i = 2, len = lines.length; i < len; i += 2){
                    var match = lineRE.exec(lines[i]);
                    if (match) result.push(new StackFrame({
                        fileName: match[2],
                        lineNumber: match[1],
                        source: lines[i]
                    }));
                }
                return result;
            },
            parseOpera10: function ErrorStackParser$$parseOpera10(e) {
                var lineRE = /Line (\d+).*script (?:in )?(\S+)(?:: In function (\S+))?$/i;
                var lines = e.stacktrace.split("\n");
                var result = [];
                for(var i = 0, len = lines.length; i < len; i += 2){
                    var match = lineRE.exec(lines[i]);
                    if (match) result.push(new StackFrame({
                        functionName: match[3] || undefined,
                        fileName: match[2],
                        lineNumber: match[1],
                        source: lines[i]
                    }));
                }
                return result;
            },
            // Opera 10.65+ Error.stack very similar to FF/Safari
            parseOpera11: function ErrorStackParser$$parseOpera11(error) {
                var filtered = error.stack.split("\n").filter(function(line) {
                    return !!line.match(FIREFOX_SAFARI_STACK_REGEXP) && !line.match(/^Error created at/);
                }, this);
                return filtered.map(function(line) {
                    var tokens = line.split("@");
                    var locationParts = this.extractLocation(tokens.pop());
                    var functionCall = tokens.shift() || "";
                    var functionName = functionCall.replace(/<anonymous function(: (\w+))?>/, "$2").replace(/\([^\)]*\)/g, "") || undefined;
                    var argsRaw;
                    if (functionCall.match(/\(([^\)]*)\)/)) argsRaw = functionCall.replace(/^[^\(]+\(([^\)]*)\)$/, "$1");
                    var args = argsRaw === undefined || argsRaw === "[arguments not available]" ? undefined : argsRaw.split(",");
                    return new StackFrame({
                        functionName: functionName,
                        args: args,
                        fileName: locationParts[0],
                        lineNumber: locationParts[1],
                        columnNumber: locationParts[2],
                        source: line
                    });
                }, this);
            }
        };
    });
    var _$errorStackParser_10 = _$errorStackParser_31;
    var _$safeJsonStringify_30 = function(data, replacer, space, opts) {
        var redactedKeys = opts && opts.redactedKeys ? opts.redactedKeys : [];
        var redactedPaths = opts && opts.redactedPaths ? opts.redactedPaths : [];
        return JSON.stringify(prepareObjForSerialization(data, redactedKeys, redactedPaths), replacer, space);
    };
    var MAX_DEPTH = 20;
    var MAX_EDGES = 25000;
    var MIN_PRESERVED_DEPTH = 8;
    var REPLACEMENT_NODE = "...";
    function isError(o) {
        return o instanceof Error || /^\[object (Error|(Dom)?Exception)\]$/.test(Object.prototype.toString.call(o));
    }
    function throwsMessage(err) {
        return "[Throws: " + (err ? err.message : "?") + "]";
    }
    function find(haystack, needle) {
        for(var i = 0, len = haystack.length; i < len; i++){
            if (haystack[i] === needle) return true;
        }
        return false;
    } // returns true if the string `path` starts with any of the provided `paths`
    function isDescendent(paths, path) {
        for(var i = 0, len = paths.length; i < len; i++){
            if (path.indexOf(paths[i]) === 0) return true;
        }
        return false;
    }
    function shouldRedact(patterns, key) {
        for(var i = 0, len = patterns.length; i < len; i++){
            if (typeof patterns[i] === "string" && patterns[i].toLowerCase() === key.toLowerCase()) return true;
            if (patterns[i] && typeof patterns[i].test === "function" && patterns[i].test(key)) return true;
        }
        return false;
    }
    function __isArray_30(obj) {
        return Object.prototype.toString.call(obj) === "[object Array]";
    }
    function safelyGetProp(obj, prop) {
        try {
            return obj[prop];
        } catch (err) {
            return throwsMessage(err);
        }
    }
    function prepareObjForSerialization(obj, redactedKeys, redactedPaths) {
        var seen = []; // store references to objects we have seen before
        var edges = 0;
        function visit(obj, path) {
            function edgesExceeded() {
                return path.length > MIN_PRESERVED_DEPTH && edges > MAX_EDGES;
            }
            edges++;
            if (path.length > MAX_DEPTH) return REPLACEMENT_NODE;
            if (edgesExceeded()) return REPLACEMENT_NODE;
            if (obj === null || typeof obj !== "object") return obj;
            if (find(seen, obj)) return "[Circular]";
            seen.push(obj);
            if (typeof obj.toJSON === "function") try {
                // we're not going to count this as an edge because it
                // replaces the value of the currently visited object
                edges--;
                var fResult = visit(obj.toJSON(), path);
                seen.pop();
                return fResult;
            } catch (err) {
                return throwsMessage(err);
            }
            var er = isError(obj);
            if (er) {
                edges--;
                var eResult = visit({
                    name: obj.name,
                    message: obj.message
                }, path);
                seen.pop();
                return eResult;
            }
            if (__isArray_30(obj)) {
                var aResult = [];
                for(var i = 0, len = obj.length; i < len; i++){
                    if (edgesExceeded()) {
                        aResult.push(REPLACEMENT_NODE);
                        break;
                    }
                    aResult.push(visit(obj[i], path.concat("[]")));
                }
                seen.pop();
                return aResult;
            }
            var result = {};
            try {
                for(var prop in obj){
                    if (!Object.prototype.hasOwnProperty.call(obj, prop)) continue;
                    if (isDescendent(redactedPaths, path.join(".")) && shouldRedact(redactedKeys, prop)) {
                        result[prop] = "[REDACTED]";
                        continue;
                    }
                    if (edgesExceeded()) {
                        result[prop] = REPLACEMENT_NODE;
                        break;
                    }
                    result[prop] = visit(safelyGetProp(obj, prop), path.concat(prop));
                }
            } catch (e) {}
            seen.pop();
            return result;
        }
        return visit(obj, []);
    } /* removed: var _$map_16 = require('./es-utils/map'); */ 
    function add(existingFeatures, existingFeatureKeys, name, variant) {
        if (typeof name !== "string") return;
        if (variant === undefined) variant = null;
        else if (variant !== null && typeof variant !== "string") variant = _$safeJsonStringify_30(variant);
        var existingIndex = existingFeatureKeys[name];
        if (typeof existingIndex === "number") {
            existingFeatures[existingIndex] = {
                name: name,
                variant: variant
            };
            return;
        }
        existingFeatures.push({
            name: name,
            variant: variant
        });
        existingFeatureKeys[name] = existingFeatures.length - 1;
    }
    function merge(existingFeatures, newFeatures, existingFeatureKeys) {
        if (!_$isArray_14(newFeatures)) return;
        for(var i = 0; i < newFeatures.length; ++i){
            var feature = newFeatures[i];
            if (feature === null || typeof feature !== "object") continue;
             // 'add' will handle if 'name' doesn't exist & 'variant' is optional
            add(existingFeatures, existingFeatureKeys, feature.name, feature.variant);
        }
        return existingFeatures;
    } // convert feature flags from a map of 'name -> variant' into the format required
    // by the Bugsnag Event API:
    //   [{ featureFlag: 'name', variant: 'variant' }, { featureFlag: 'name 2' }]
    function toEventApi(featureFlags) {
        return _$map_16(_$filter_12(featureFlags, Boolean), function(_ref) {
            var name = _ref.name, variant = _ref.variant;
            var flag = {
                featureFlag: name
            }; // don't add a 'variant' property unless there's actually a value
            if (typeof variant === "string") flag.variant = variant;
            return flag;
        });
    }
    function clear(features, featuresIndex, name) {
        var existingIndex = featuresIndex[name];
        if (typeof existingIndex === "number") {
            features[existingIndex] = null;
            delete featuresIndex[name];
        }
    }
    var _$featureFlagDelegate_18 = {
        add: add,
        clear: clear,
        merge: merge,
        toEventApi: toEventApi
    };
    // Given `err` which may be an error, does it have a stack property which is a string?
    var _$hasStack_19 = function(err) {
        return !!err && (!!err.stack || !!err.stacktrace || !!err["opera#sourceloc"]) && typeof (err.stack || err.stacktrace || err["opera#sourceloc"]) === "string" && err.stack !== err.name + ": " + err.message;
    };
    /**
 * Expose `isError`.
 */ var _$isError_32 = __isError_32;
    /**
 * Test whether `value` is error object.
 *
 * @param {*} value
 * @returns {boolean}
 */ function __isError_32(value) {
        switch(Object.prototype.toString.call(value)){
            case "[object Error]":
                return true;
            case "[object Exception]":
                return true;
            case "[object DOMException]":
                return true;
            default:
                return value instanceof Error;
        }
    }
    var _$iserror_20 = _$isError_32; /* removed: var _$assign_11 = require('./es-utils/assign'); */ 
    var __add_22 = function(state, section, keyOrObj, maybeVal) {
        var _updates;
        if (!section) return;
        var updates; // addMetadata("section", null) -> clears section
        if (keyOrObj === null) return __clear_22(state, section); // normalise the two supported input types into object form
        if (typeof keyOrObj === "object") updates = keyOrObj;
        if (typeof keyOrObj === "string") updates = (_updates = {}, _updates[keyOrObj] = maybeVal, _updates); // exit if we don't have an updates object at this point
        if (!updates) return; // ensure a section with this name exists
        if (!state[section]) state[section] = {}; // merge the updates with the existing section
        state[section] = _$assign_11({}, state[section], updates);
    };
    var get = function(state, section, key) {
        if (typeof section !== "string") return undefined;
        if (!key) return state[section];
        if (state[section]) return state[section][key];
        return undefined;
    };
    var __clear_22 = function(state, section, key) {
        if (typeof section !== "string") return; // clear an entire section
        if (!key) {
            delete state[section];
            return;
        } // clear a single value from a section
        if (state[section]) delete state[section][key];
    };
    var _$metadataDelegate_22 = {
        add: __add_22,
        get: get,
        clear: __clear_22
    };
    var _$stackGenerator_33 = {};
    (function(root, factory) {
        "use strict"; // Universal Module Definition (UMD) to support AMD, CommonJS/Node.js, Rhino, and browsers.
        /* istanbul ignore next */ if (typeof define === "function" && define.amd) define("stack-generator", [
            "stackframe"
        ], factory);
        else if (typeof _$stackGenerator_33 === "object") _$stackGenerator_33 = factory(_$stackframe_34);
        else root.StackGenerator = factory(root.StackFrame);
    })(this, function(StackFrame) {
        return {
            backtrace: function StackGenerator$$backtrace(opts) {
                var stack = [];
                var maxStackSize = 10;
                if (typeof opts === "object" && typeof opts.maxStackSize === "number") maxStackSize = opts.maxStackSize;
                var curr = arguments.callee;
                while(curr && stack.length < maxStackSize && curr["arguments"]){
                    // Allow V8 optimizations
                    var args = new Array(curr["arguments"].length);
                    for(var i = 0; i < args.length; ++i)args[i] = curr["arguments"][i];
                    if (/function(?:\s+([\w$]+))+\s*\(/.test(curr.toString())) stack.push(new StackFrame({
                        functionName: RegExp.$1 || undefined,
                        args: args
                    }));
                    else stack.push(new StackFrame({
                        args: args
                    }));
                    try {
                        curr = curr.caller;
                    } catch (e) {
                        break;
                    }
                }
                return stack;
            }
        };
    }); /* removed: var _$errorStackParser_10 = require('./lib/error-stack-parser'); */ 
    var Event = /*#__PURE__*/ function() {
        function Event(errorClass, errorMessage, stacktrace, handledState, originalError) {
            if (stacktrace === void 0) stacktrace = [];
            if (handledState === void 0) handledState = defaultHandledState();
            this.apiKey = undefined;
            this.context = undefined;
            this.groupingHash = undefined;
            this.originalError = originalError;
            this._handledState = handledState;
            this.severity = this._handledState.severity;
            this.unhandled = this._handledState.unhandled;
            this.app = {};
            this.device = {};
            this.request = {};
            this.breadcrumbs = [];
            this.threads = [];
            this._metadata = {};
            this._features = [];
            this._featuresIndex = {};
            this._user = {};
            this._session = undefined;
            this.errors = [
                createBugsnagError(errorClass, errorMessage, Event.__type, stacktrace)
            ]; // Flags.
        // Note these are not initialised unless they are used
        // to save unnecessary bytes in the browser bundle
        /* this.attemptImmediateDelivery, default: true */ }
        var _proto = Event.prototype;
        _proto.addMetadata = function addMetadata(section, keyOrObj, maybeVal) {
            return _$metadataDelegate_22.add(this._metadata, section, keyOrObj, maybeVal);
        };
        _proto.getMetadata = function getMetadata(section, key) {
            return _$metadataDelegate_22.get(this._metadata, section, key);
        };
        _proto.clearMetadata = function clearMetadata(section, key) {
            return _$metadataDelegate_22.clear(this._metadata, section, key);
        };
        _proto.addFeatureFlag = function addFeatureFlag(name, variant) {
            if (variant === void 0) variant = null;
            _$featureFlagDelegate_18.add(this._features, this._featuresIndex, name, variant);
        };
        _proto.addFeatureFlags = function addFeatureFlags(featureFlags) {
            _$featureFlagDelegate_18.merge(this._features, featureFlags, this._featuresIndex);
        };
        _proto.getFeatureFlags = function getFeatureFlags() {
            return _$featureFlagDelegate_18.toEventApi(this._features);
        };
        _proto.clearFeatureFlag = function clearFeatureFlag(name) {
            _$featureFlagDelegate_18.clear(this._features, this._featuresIndex, name);
        };
        _proto.clearFeatureFlags = function clearFeatureFlags() {
            this._features = [];
            this._featuresIndex = {};
        };
        _proto.getUser = function getUser() {
            return this._user;
        };
        _proto.setUser = function setUser(id, email, name) {
            this._user = {
                id: id,
                email: email,
                name: name
            };
        };
        _proto.toJSON = function toJSON() {
            return {
                payloadVersion: "4",
                exceptions: _$map_16(this.errors, function(er) {
                    return _$assign_11({}, er, {
                        message: er.errorMessage
                    });
                }),
                severity: this.severity,
                unhandled: this._handledState.unhandled,
                severityReason: this._handledState.severityReason,
                app: this.app,
                device: this.device,
                request: this.request,
                breadcrumbs: this.breadcrumbs,
                context: this.context,
                groupingHash: this.groupingHash,
                metaData: this._metadata,
                user: this._user,
                session: this._session,
                featureFlags: this.getFeatureFlags()
            };
        };
        return Event;
    }(); // takes a stacktrace.js style stackframe (https://github.com/stacktracejs/stackframe)
    // and returns a Bugsnag compatible stackframe (https://docs.bugsnag.com/api/error-reporting/#json-payload)
    var formatStackframe = function(frame) {
        var f = {
            file: frame.fileName,
            method: normaliseFunctionName(frame.functionName),
            lineNumber: frame.lineNumber,
            columnNumber: frame.columnNumber,
            code: undefined,
            inProject: undefined
        }; // Some instances result in no file:
        // - calling notify() from chrome's terminal results in no file/method.
        // - non-error exception thrown from global code in FF
        // This adds one.
        if (f.lineNumber > -1 && !f.file && !f.method) f.file = "global code";
        return f;
    };
    var normaliseFunctionName = function(name) {
        return /^global code$/i.test(name) ? "global code" : name;
    };
    var defaultHandledState = function() {
        return {
            unhandled: false,
            severity: "warning",
            severityReason: {
                type: "handledException"
            }
        };
    };
    var ensureString = function(str) {
        return typeof str === "string" ? str : "";
    };
    function createBugsnagError(errorClass, errorMessage, type, stacktrace) {
        return {
            errorClass: ensureString(errorClass),
            errorMessage: ensureString(errorMessage),
            type: type,
            stacktrace: _$reduce_17(stacktrace, function(accum, frame) {
                var f = formatStackframe(frame); // don't include a stackframe if none of its properties are defined
                try {
                    if (JSON.stringify(f) === "{}") return accum;
                    return accum.concat(f);
                } catch (e) {
                    return accum;
                }
            }, [])
        };
    }
    function getCauseStack(error) {
        if (error.cause) return [
            error
        ].concat(getCauseStack(error.cause));
        else return [
            error
        ];
    } // Helpers
    Event.getStacktrace = function(error, errorFramesToSkip, backtraceFramesToSkip) {
        if (_$hasStack_19(error)) return _$errorStackParser_10.parse(error).slice(errorFramesToSkip); // error wasn't provided or didn't have a stacktrace so try to walk the callstack
        try {
            return _$filter_12(_$stackGenerator_33.backtrace(), function(frame) {
                return (frame.functionName || "").indexOf("StackGenerator$$") === -1;
            }).slice(1 + backtraceFramesToSkip);
        } catch (e) {
            return [];
        }
    };
    Event.create = function(maybeError, tolerateNonErrors, handledState, component, errorFramesToSkip, logger) {
        if (errorFramesToSkip === void 0) errorFramesToSkip = 0;
        var _normaliseError = normaliseError(maybeError, tolerateNonErrors, component, logger), error = _normaliseError[0], internalFrames = _normaliseError[1];
        var event;
        try {
            var stacktrace = Event.getStacktrace(error, // tell the getStacktrace() function to skip the number of frames we know will
            // be from our own functions. This is added to the number of frames deep we
            // were told about
            internalFrames > 0 ? 1 + internalFrames + errorFramesToSkip : 0, // this is how many frames should be removed because they come from our library
            1 + errorFramesToSkip);
            event = new Event(error.name, error.message, stacktrace, handledState, maybeError);
        } catch (e) {
            event = new Event(error.name, error.message, [], handledState, maybeError);
        }
        if (error.name === "InvalidError") event.addMetadata("" + component, "non-error parameter", makeSerialisable(maybeError));
        if (error.cause) {
            var _event$errors;
            var causes = getCauseStack(error).slice(1);
            var normalisedCauses = _$map_16(causes, function(cause) {
                // Only get stacktrace for error causes that are a valid JS Error and already have a stack
                var stacktrace = _$iserror_20(cause) && _$hasStack_19(cause) ? _$errorStackParser_10.parse(cause) : [];
                var _normaliseError2 = normaliseError(cause, true, "error cause"), error = _normaliseError2[0];
                if (error.name === "InvalidError") event.addMetadata("error cause", makeSerialisable(cause));
                return createBugsnagError(error.name, error.message, Event.__type, stacktrace);
            });
            (_event$errors = event.errors).push.apply(_event$errors, normalisedCauses);
        }
        return event;
    };
    var makeSerialisable = function(err) {
        if (err === null) return "null";
        if (err === undefined) return "undefined";
        return err;
    };
    var normaliseError = function(maybeError, tolerateNonErrors, component, logger) {
        var error;
        var internalFrames = 0;
        var createAndLogInputError = function(reason) {
            var verb = component === "error cause" ? "was" : "received";
            if (logger) logger.warn(component + " " + verb + ' a non-error: "' + reason + '"');
            var err = new Error(component + " " + verb + ' a non-error. See "' + component + '" tab for more detail.');
            err.name = "InvalidError";
            return err;
        }; // In some cases:
        //
        //  - the promise rejection handler (both in the browser and node)
        //  - the node uncaughtException handler
        //
        // We are really limited in what we can do to get a stacktrace. So we use the
        // tolerateNonErrors option to ensure that the resulting error communicates as
        // such.
        if (!tolerateNonErrors) {
            if (_$iserror_20(maybeError)) error = maybeError;
            else {
                error = createAndLogInputError(typeof maybeError);
                internalFrames += 2;
            }
        } else switch(typeof maybeError){
            case "string":
            case "number":
            case "boolean":
                error = new Error(String(maybeError));
                internalFrames += 1;
                break;
            case "function":
                error = createAndLogInputError("function");
                internalFrames += 2;
                break;
            case "object":
                if (maybeError !== null && _$iserror_20(maybeError)) error = maybeError;
                else if (maybeError !== null && hasNecessaryFields(maybeError)) {
                    error = new Error(maybeError.message || maybeError.errorMessage);
                    error.name = maybeError.name || maybeError.errorClass;
                    internalFrames += 1;
                } else {
                    error = createAndLogInputError(maybeError === null ? "null" : "unsupported object");
                    internalFrames += 2;
                }
                break;
            default:
                error = createAndLogInputError("nothing");
                internalFrames += 2;
        }
        if (!_$hasStack_19(error)) // in IE10/11 a new Error() doesn't have a stacktrace until you throw it, so try that here
        try {
            throw error;
        } catch (e) {
            if (_$hasStack_19(e)) {
                error = e; // if the error only got a stacktrace after we threw it here, we know it
                // will only have one extra internal frame from this function, regardless
                // of whether it went through createAndLogInputError() or not
                internalFrames = 1;
            }
        }
        return [
            error,
            internalFrames
        ];
    }; // default value for stacktrace.type
    Event.__type = "browserjs";
    var hasNecessaryFields = function(error) {
        return (typeof error.name === "string" || typeof error.errorClass === "string") && (typeof error.message === "string" || typeof error.errorMessage === "string");
    };
    var _$Event_6 = Event;
    // This is a heavily modified/simplified version of
    //   https://github.com/othiym23/async-some
    // with the logic flipped so that it is akin to the
    // synchronous "every" method instead of "some".
    // run the asynchronous test function (fn) over each item in the array (arr)
    // in series until:
    //   - fn(item, cb) => calls cb(null, false)
    //   - or the end of the array is reached
    // the callback (cb) will be passed (null, false) if any of the items in arr
    // caused fn to call back with false, otherwise it will be passed (null, true)
    var _$asyncEvery_7 = function(arr, fn, cb) {
        var index = 0;
        var next = function() {
            if (index >= arr.length) return cb(null, true);
            fn(arr[index], function(err, result) {
                if (err) return cb(err);
                if (result === false) return cb(null, false);
                index++;
                next();
            });
        };
        next();
    }; /* removed: var _$asyncEvery_7 = require('./async-every'); */ 
    var _$callbackRunner_9 = function(callbacks, event, onCallbackError, cb) {
        // This function is how we support different kinds of callback:
        //  - synchronous - return value
        //  - node-style async with callback - cb(err, value)
        //  - promise/thenable - resolve(value)
        // It normalises each of these into the lowest common denominator – a node-style callback
        var runMaybeAsyncCallback = function(fn, cb) {
            if (typeof fn !== "function") return cb(null);
            try {
                // if function appears sync…
                if (fn.length !== 2) {
                    var ret = fn(event); // check if it returned a "thenable" (promise)
                    if (ret && typeof ret.then === "function") return ret.then(function(val) {
                        return setTimeout(function() {
                            return cb(null, val);
                        });
                    }, function(err) {
                        setTimeout(function() {
                            onCallbackError(err);
                            return cb(null, true);
                        });
                    });
                    return cb(null, ret);
                } // if function is async…
                fn(event, function(err, result) {
                    if (err) {
                        onCallbackError(err);
                        return cb(null);
                    }
                    cb(null, result);
                });
            } catch (e) {
                onCallbackError(e);
                cb(null);
            }
        };
        _$asyncEvery_7(callbacks, runMaybeAsyncCallback, cb);
    };
    var _$syncCallbackRunner_23 = function(callbacks, callbackArg, callbackType, logger) {
        var ignore = false;
        var cbs = callbacks.slice();
        while(!ignore){
            if (!cbs.length) break;
            try {
                ignore = cbs.pop()(callbackArg) === false;
            } catch (e) {
                logger.error("Error occurred in " + callbackType + " callback, continuing anyway\u2026");
                logger.error(e);
            }
        }
        return ignore;
    };
    var _$pad_29 = function pad(num, size) {
        var s = "000000000" + num;
        return s.substr(s.length - size);
    }; /* removed: var _$pad_29 = require('./pad.js'); */ 
    var env = typeof window === "object" ? window : self;
    var globalCount = 0;
    for(var prop in env)if (Object.hasOwnProperty.call(env, prop)) globalCount++;
    var mimeTypesLength = navigator.mimeTypes ? navigator.mimeTypes.length : 0;
    var clientId = _$pad_29((mimeTypesLength + navigator.userAgent.length).toString(36) + globalCount.toString(36), 4);
    var _$fingerprint_28 = function fingerprint() {
        return clientId;
    }; /* removed: var _$fingerprint_28 = require('./lib/fingerprint.js'); */ 
    var c = 0, blockSize = 4, base = 36, discreteValues = Math.pow(base, blockSize);
    function randomBlock() {
        return _$pad_29((Math.random() * discreteValues << 0).toString(base), blockSize);
    }
    function safeCounter() {
        c = c < discreteValues ? c : 0;
        c++; // this is not subliminal
        return c - 1;
    }
    function cuid() {
        // Starting with a lowercase letter makes
        // it HTML element ID friendly.
        var letter = "c", // hard-coded allows for sequential access
        // timestamp
        // warning: this exposes the exact date and time
        // that the uid was created.
        timestamp = new Date().getTime().toString(base), // Prevent same-machine collisions.
        counter = _$pad_29(safeCounter().toString(base), blockSize), // A few chars to generate distinct ids for different
        // clients (so different computers are far less
        // likely to generate the same id)
        print = _$fingerprint_28(), // Grab some more chars from Math.random()
        random = randomBlock() + randomBlock();
        return letter + timestamp + counter + print + random;
    }
    cuid.fingerprint = _$fingerprint_28;
    var _$cuid_27 = cuid; /* removed: var _$cuid_27 = require('@bugsnag/cuid'); */ 
    var Session = /*#__PURE__*/ function() {
        function Session() {
            this.id = _$cuid_27();
            this.startedAt = new Date();
            this._handled = 0;
            this._unhandled = 0;
            this._user = {};
            this.app = {};
            this.device = {};
        }
        var _proto = Session.prototype;
        _proto.getUser = function getUser() {
            return this._user;
        };
        _proto.setUser = function setUser(id, email, name) {
            this._user = {
                id: id,
                email: email,
                name: name
            };
        };
        _proto.toJSON = function toJSON() {
            return {
                id: this.id,
                startedAt: this.startedAt,
                events: {
                    handled: this._handled,
                    unhandled: this._unhandled
                }
            };
        };
        _proto._track = function _track(event) {
            this[event._handledState.unhandled ? "_unhandled" : "_handled"] += 1;
        };
        return Session;
    }();
    var _$Session_35 = Session; /* removed: var _$config_5 = require('./config'); */ 
    var __add_4 = _$featureFlagDelegate_18.add, __clear_4 = _$featureFlagDelegate_18.clear, __merge_4 = _$featureFlagDelegate_18.merge;
    var noop = function() {};
    var Client = /*#__PURE__*/ function() {
        function Client(configuration, schema, internalPlugins, notifier) {
            var _this = this;
            if (schema === void 0) schema = _$config_5.schema;
            if (internalPlugins === void 0) internalPlugins = [];
            // notifier id
            this._notifier = notifier; // intialise opts and config
            this._config = {};
            this._schema = schema; // i/o
            this._delivery = {
                sendSession: noop,
                sendEvent: noop
            };
            this._logger = {
                debug: noop,
                info: noop,
                warn: noop,
                error: noop
            }; // plugins
            this._plugins = {}; // state
            this._breadcrumbs = [];
            this._session = null;
            this._metadata = {};
            this._featuresIndex = {};
            this._features = [];
            this._context = undefined;
            this._user = {}; // callbacks:
            //  e: onError
            //  s: onSession
            //  sp: onSessionPayload
            //  b: onBreadcrumb
            // (note these names are minified by hand because object
            // properties are not safe to minify automatically)
            this._cbs = {
                e: [],
                s: [],
                sp: [],
                b: []
            }; // expose internal constructors
            this.Client = Client;
            this.Event = _$Event_6;
            this.Breadcrumb = _$Breadcrumb_3;
            this.Session = _$Session_35;
            this._config = this._configure(configuration, internalPlugins);
            _$map_16(internalPlugins.concat(this._config.plugins), function(pl) {
                if (pl) _this._loadPlugin(pl);
            }); // when notify() is called we need to know how many frames are from our own source
            // this inital value is 1 not 0 because we wrap notify() to ensure it is always
            // bound to have the client as its `this` value – see below.
            this._depth = 1;
            var self1 = this;
            var notify = this.notify;
            this.notify = function() {
                return notify.apply(self1, arguments);
            };
        }
        var _proto = Client.prototype;
        _proto.addMetadata = function addMetadata(section, keyOrObj, maybeVal) {
            return _$metadataDelegate_22.add(this._metadata, section, keyOrObj, maybeVal);
        };
        _proto.getMetadata = function getMetadata(section, key) {
            return _$metadataDelegate_22.get(this._metadata, section, key);
        };
        _proto.clearMetadata = function clearMetadata(section, key) {
            return _$metadataDelegate_22.clear(this._metadata, section, key);
        };
        _proto.addFeatureFlag = function addFeatureFlag(name, variant) {
            if (variant === void 0) variant = null;
            __add_4(this._features, this._featuresIndex, name, variant);
        };
        _proto.addFeatureFlags = function addFeatureFlags(featureFlags) {
            __merge_4(this._features, featureFlags, this._featuresIndex);
        };
        _proto.clearFeatureFlag = function clearFeatureFlag(name) {
            __clear_4(this._features, this._featuresIndex, name);
        };
        _proto.clearFeatureFlags = function clearFeatureFlags() {
            this._features = [];
            this._featuresIndex = {};
        };
        _proto.getContext = function getContext() {
            return this._context;
        };
        _proto.setContext = function setContext(c) {
            this._context = c;
        };
        _proto._configure = function _configure(opts, internalPlugins) {
            var schema = _$reduce_17(internalPlugins, function(schema, plugin) {
                if (plugin && plugin.configSchema) return _$assign_11({}, schema, plugin.configSchema);
                return schema;
            }, this._schema); // accumulate configuration and error messages
            var _reduce = _$reduce_17(_$keys_15(schema), function(accum, key) {
                var defaultValue = schema[key].defaultValue(opts[key]);
                if (opts[key] !== undefined) {
                    var valid = schema[key].validate(opts[key]);
                    if (!valid) {
                        accum.errors[key] = schema[key].message;
                        accum.config[key] = defaultValue;
                    } else if (schema[key].allowPartialObject) accum.config[key] = _$assign_11(defaultValue, opts[key]);
                    else accum.config[key] = opts[key];
                } else accum.config[key] = defaultValue;
                return accum;
            }, {
                errors: {},
                config: {}
            }), errors = _reduce.errors, config = _reduce.config;
            if (schema.apiKey) {
                // missing api key is the only fatal error
                if (!config.apiKey) throw new Error("No Bugsnag API Key set"); // warn about an apikey that is not of the expected format
                if (!/^[0-9a-f]{32}$/i.test(config.apiKey)) errors.apiKey = "should be a string of 32 hexadecimal characters";
            } // update and elevate some options
            this._metadata = _$assign_11({}, config.metadata);
            __merge_4(this._features, config.featureFlags, this._featuresIndex);
            this._user = _$assign_11({}, config.user);
            this._context = config.context;
            if (config.logger) this._logger = config.logger; // add callbacks
            if (config.onError) this._cbs.e = this._cbs.e.concat(config.onError);
            if (config.onBreadcrumb) this._cbs.b = this._cbs.b.concat(config.onBreadcrumb);
            if (config.onSession) this._cbs.s = this._cbs.s.concat(config.onSession); // finally warn about any invalid config where we fell back to the default
            if (_$keys_15(errors).length) this._logger.warn(generateConfigErrorMessage(errors, opts));
            return config;
        };
        _proto.getUser = function getUser() {
            return this._user;
        };
        _proto.setUser = function setUser(id, email, name) {
            this._user = {
                id: id,
                email: email,
                name: name
            };
        };
        _proto._loadPlugin = function _loadPlugin(plugin) {
            var result = plugin.load(this); // JS objects are not the safest way to store arbitrarily keyed values,
            // so bookend the key with some characters that prevent tampering with
            // stuff like __proto__ etc. (only store the result if the plugin had a
            // name)
            if (plugin.name) this._plugins["~" + plugin.name + "~"] = result;
            return this;
        };
        _proto.getPlugin = function getPlugin(name) {
            return this._plugins["~" + name + "~"];
        };
        _proto._setDelivery = function _setDelivery(d) {
            this._delivery = d(this);
        };
        _proto.startSession = function startSession() {
            var session = new _$Session_35();
            session.app.releaseStage = this._config.releaseStage;
            session.app.version = this._config.appVersion;
            session.app.type = this._config.appType;
            session._user = _$assign_11({}, this._user); // run onSession callbacks
            var ignore = _$syncCallbackRunner_23(this._cbs.s, session, "onSession", this._logger);
            if (ignore) {
                this._logger.debug("Session not started due to onSession callback");
                return this;
            }
            return this._sessionDelegate.startSession(this, session);
        };
        _proto.addOnError = function addOnError(fn, front) {
            if (front === void 0) front = false;
            this._cbs.e[front ? "unshift" : "push"](fn);
        };
        _proto.removeOnError = function removeOnError(fn) {
            this._cbs.e = _$filter_12(this._cbs.e, function(f) {
                return f !== fn;
            });
        };
        _proto._addOnSessionPayload = function _addOnSessionPayload(fn) {
            this._cbs.sp.push(fn);
        };
        _proto.addOnSession = function addOnSession(fn) {
            this._cbs.s.push(fn);
        };
        _proto.removeOnSession = function removeOnSession(fn) {
            this._cbs.s = _$filter_12(this._cbs.s, function(f) {
                return f !== fn;
            });
        };
        _proto.addOnBreadcrumb = function addOnBreadcrumb(fn, front) {
            if (front === void 0) front = false;
            this._cbs.b[front ? "unshift" : "push"](fn);
        };
        _proto.removeOnBreadcrumb = function removeOnBreadcrumb(fn) {
            this._cbs.b = _$filter_12(this._cbs.b, function(f) {
                return f !== fn;
            });
        };
        _proto.pauseSession = function pauseSession() {
            return this._sessionDelegate.pauseSession(this);
        };
        _proto.resumeSession = function resumeSession() {
            return this._sessionDelegate.resumeSession(this);
        };
        _proto.leaveBreadcrumb = function leaveBreadcrumb(message, metadata, type) {
            // coerce bad values so that the defaults get set
            message = typeof message === "string" ? message : "";
            type = typeof type === "string" && _$includes_13(_$breadcrumbTypes_8, type) ? type : "manual";
            metadata = typeof metadata === "object" && metadata !== null ? metadata : {}; // if no message, discard
            if (!message) return;
            var crumb = new _$Breadcrumb_3(message, metadata, type); // run onBreadcrumb callbacks
            var ignore = _$syncCallbackRunner_23(this._cbs.b, crumb, "onBreadcrumb", this._logger);
            if (ignore) {
                this._logger.debug("Breadcrumb not attached due to onBreadcrumb callback");
                return;
            } // push the valid crumb onto the queue and maintain the length
            this._breadcrumbs.push(crumb);
            if (this._breadcrumbs.length > this._config.maxBreadcrumbs) this._breadcrumbs = this._breadcrumbs.slice(this._breadcrumbs.length - this._config.maxBreadcrumbs);
        };
        _proto._isBreadcrumbTypeEnabled = function _isBreadcrumbTypeEnabled(type) {
            var types = this._config.enabledBreadcrumbTypes;
            return types === null || _$includes_13(types, type);
        };
        _proto.notify = function notify(maybeError, onError, postReportCallback) {
            if (postReportCallback === void 0) postReportCallback = noop;
            var event = _$Event_6.create(maybeError, true, undefined, "notify()", this._depth + 1, this._logger);
            this._notify(event, onError, postReportCallback);
        };
        _proto._notify = function _notify(event, onError, postReportCallback) {
            var _this2 = this;
            if (postReportCallback === void 0) postReportCallback = noop;
            event.app = _$assign_11({}, event.app, {
                releaseStage: this._config.releaseStage,
                version: this._config.appVersion,
                type: this._config.appType
            });
            event.context = event.context || this._context;
            event._metadata = _$assign_11({}, event._metadata, this._metadata);
            event._user = _$assign_11({}, event._user, this._user);
            event.breadcrumbs = this._breadcrumbs.slice();
            __merge_4(event._features, this._features, event._featuresIndex); // exit early if events should not be sent on the current releaseStage
            if (this._config.enabledReleaseStages !== null && !_$includes_13(this._config.enabledReleaseStages, this._config.releaseStage)) {
                this._logger.warn("Event not sent due to releaseStage/enabledReleaseStages configuration");
                return postReportCallback(null, event);
            }
            var originalSeverity = event.severity;
            var onCallbackError = function(err) {
                // errors in callbacks are tolerated but we want to log them out
                _this2._logger.error("Error occurred in onError callback, continuing anyway\u2026");
                _this2._logger.error(err);
            };
            var callbacks = [].concat(this._cbs.e).concat(onError);
            _$callbackRunner_9(callbacks, event, onCallbackError, function(err, shouldSend) {
                if (err) onCallbackError(err);
                if (!shouldSend) {
                    _this2._logger.debug("Event not sent due to onError callback");
                    return postReportCallback(null, event);
                }
                if (_this2._isBreadcrumbTypeEnabled("error")) // only leave a crumb for the error if actually got sent
                Client.prototype.leaveBreadcrumb.call(_this2, event.errors[0].errorClass, {
                    errorClass: event.errors[0].errorClass,
                    errorMessage: event.errors[0].errorMessage,
                    severity: event.severity
                }, "error");
                if (originalSeverity !== event.severity) event._handledState.severityReason = {
                    type: "userCallbackSetSeverity"
                };
                if (event.unhandled !== event._handledState.unhandled) {
                    event._handledState.severityReason.unhandledOverridden = true;
                    event._handledState.unhandled = event.unhandled;
                }
                if (_this2._session) {
                    _this2._session._track(event);
                    event._session = _this2._session;
                }
                _this2._delivery.sendEvent({
                    apiKey: event.apiKey || _this2._config.apiKey,
                    notifier: _this2._notifier,
                    events: [
                        event
                    ]
                }, function(err) {
                    return postReportCallback(err, event);
                });
            });
        };
        return Client;
    }();
    var generateConfigErrorMessage = function(errors, rawInput) {
        var er = new Error("Invalid configuration\n" + _$map_16(_$keys_15(errors), function(key) {
            return "  - " + key + " " + errors[key] + ", got " + stringify(rawInput[key]);
        }).join("\n\n"));
        return er;
    };
    var stringify = function(val) {
        switch(typeof val){
            case "string":
            case "number":
            case "object":
                return JSON.stringify(val);
            default:
                return String(val);
        }
    };
    var _$Client_4 = Client;
    var _$jsonPayload_21 = {}; /* removed: var _$safeJsonStringify_30 = require('@bugsnag/safe-json-stringify'); */ 
    var EVENT_REDACTION_PATHS = [
        "events.[].metaData",
        "events.[].breadcrumbs.[].metaData",
        "events.[].request"
    ];
    _$jsonPayload_21.event = function(event, redactedKeys) {
        var payload = _$safeJsonStringify_30(event, null, null, {
            redactedPaths: EVENT_REDACTION_PATHS,
            redactedKeys: redactedKeys
        });
        if (payload.length > 10e5) {
            event.events[0]._metadata = {
                notifier: "WARNING!\nSerialized payload was " + payload.length / 10e5 + "MB (limit = 1MB)\nmetadata was removed"
            };
            payload = _$safeJsonStringify_30(event, null, null, {
                redactedPaths: EVENT_REDACTION_PATHS,
                redactedKeys: redactedKeys
            });
        }
        return payload;
    };
    _$jsonPayload_21.session = function(session, redactedKeys) {
        var payload = _$safeJsonStringify_30(session, null, null);
        return payload;
    };
    var _$delivery_36 = {}; /* removed: var _$jsonPayload_21 = require('@bugsnag/core/lib/json-payload'); */ 
    _$delivery_36 = function(client, win) {
        if (win === void 0) win = window;
        return {
            sendEvent: function(event, cb) {
                if (cb === void 0) cb = function() {};
                var url = getApiUrl(client._config, "notify", "4", win);
                var body = _$jsonPayload_21.event(event, client._config.redactedKeys);
                var req = new win.XDomainRequest();
                req.onload = function() {
                    cb(null);
                };
                req.onerror = function() {
                    var err = new Error("Event failed to send");
                    client._logger.error("Event failed to send\u2026", err);
                    if (body.length > 10e5) client._logger.warn("Event oversized (" + (body.length / 10e5).toFixed(2) + " MB)");
                    cb(err);
                };
                req.open("POST", url);
                setTimeout(function() {
                    try {
                        req.send(body);
                    } catch (e) {
                        client._logger.error(e);
                        cb(e);
                    }
                }, 0);
            },
            sendSession: function(session, cb) {
                if (cb === void 0) cb = function() {};
                var url = getApiUrl(client._config, "sessions", "1", win);
                var req = new win.XDomainRequest();
                req.onload = function() {
                    cb(null);
                };
                req.open("POST", url);
                setTimeout(function() {
                    try {
                        req.send(_$jsonPayload_21.session(session, client._config.redactedKeys));
                    } catch (e) {
                        client._logger.error(e);
                        cb(e);
                    }
                }, 0);
            }
        };
    };
    var getApiUrl = function(config, endpoint, version, win) {
        // IE8 doesn't support Date.prototype.toISOstring(), but it does convert a date
        // to an ISO string when you use JSON stringify. Simply parsing the result of
        // JSON.stringify is smaller than using a toISOstring() polyfill.
        var isoDate = JSON.parse(JSON.stringify(new Date()));
        var url = matchPageProtocol(config.endpoints[endpoint], win.location.protocol);
        return url + "?apiKey=" + encodeURIComponent(config.apiKey) + "&payloadVersion=" + version + "&sentAt=" + encodeURIComponent(isoDate);
    };
    var matchPageProtocol = _$delivery_36._matchPageProtocol = function(endpoint, pageProtocol) {
        return pageProtocol === "http:" ? endpoint.replace(/^https:/, "http:") : endpoint;
    }; /* removed: var _$jsonPayload_21 = require('@bugsnag/core/lib/json-payload'); */ 
    var _$delivery_37 = function(client, win) {
        if (win === void 0) win = window;
        return {
            sendEvent: function(event, cb) {
                if (cb === void 0) cb = function() {};
                try {
                    var url = client._config.endpoints.notify;
                    var req = new win.XMLHttpRequest();
                    var body = _$jsonPayload_21.event(event, client._config.redactedKeys);
                    req.onreadystatechange = function() {
                        if (req.readyState === win.XMLHttpRequest.DONE) {
                            var status = req.status;
                            if (status === 0 || status >= 400) {
                                var err = new Error("Request failed with status " + status);
                                client._logger.error("Event failed to send\u2026", err);
                                if (body.length > 10e5) client._logger.warn("Event oversized (" + (body.length / 10e5).toFixed(2) + " MB)");
                                cb(err);
                            } else cb(null);
                        }
                    };
                    req.open("POST", url);
                    req.setRequestHeader("Content-Type", "application/json");
                    req.setRequestHeader("Bugsnag-Api-Key", event.apiKey || client._config.apiKey);
                    req.setRequestHeader("Bugsnag-Payload-Version", "4");
                    req.setRequestHeader("Bugsnag-Sent-At", new Date().toISOString());
                    req.send(body);
                } catch (e) {
                    client._logger.error(e);
                }
            },
            sendSession: function(session, cb) {
                if (cb === void 0) cb = function() {};
                try {
                    var url = client._config.endpoints.sessions;
                    var req = new win.XMLHttpRequest();
                    req.onreadystatechange = function() {
                        if (req.readyState === win.XMLHttpRequest.DONE) {
                            var status = req.status;
                            if (status === 0 || status >= 400) {
                                var err = new Error("Request failed with status " + status);
                                client._logger.error("Session failed to send\u2026", err);
                                cb(err);
                            } else cb(null);
                        }
                    };
                    req.open("POST", url);
                    req.setRequestHeader("Content-Type", "application/json");
                    req.setRequestHeader("Bugsnag-Api-Key", client._config.apiKey);
                    req.setRequestHeader("Bugsnag-Payload-Version", "1");
                    req.setRequestHeader("Bugsnag-Sent-At", new Date().toISOString());
                    req.send(_$jsonPayload_21.session(session, client._config.redactedKeys));
                } catch (e) {
                    client._logger.error(e);
                }
            }
        };
    };
    var appStart = new Date();
    var reset = function() {
        appStart = new Date();
    };
    var _$app_38 = {
        name: "appDuration",
        load: function(client) {
            client.addOnError(function(event) {
                var now = new Date();
                event.app.duration = now - appStart;
            }, true);
            return {
                reset: reset
            };
        }
    };
    /*
 * Sets the default context to be the current URL
 */ var _$context_39 = function(win) {
        if (win === void 0) win = window;
        return {
            load: function(client) {
                client.addOnError(function(event) {
                    if (event.context !== undefined) return;
                    event.context = win.location.pathname;
                }, true);
            }
        };
    };
    var _$pad_43 = function pad(num, size) {
        var s = "000000000" + num;
        return s.substr(s.length - size);
    }; /* removed: var _$pad_43 = require('./pad.js'); */ 
    var __env_42 = typeof window === "object" ? window : self;
    var __globalCount_42 = 0;
    for(var __prop_42 in __env_42)if (Object.hasOwnProperty.call(__env_42, __prop_42)) __globalCount_42++;
    var __mimeTypesLength_42 = navigator.mimeTypes ? navigator.mimeTypes.length : 0;
    var __clientId_42 = _$pad_43((__mimeTypesLength_42 + navigator.userAgent.length).toString(36) + __globalCount_42.toString(36), 4);
    var _$fingerprint_42 = function fingerprint() {
        return __clientId_42;
    }; /* removed: var _$fingerprint_42 = require('./lib/fingerprint.js'); */ 
    var __c_41 = 0, __blockSize_41 = 4, __base_41 = 36, __discreteValues_41 = Math.pow(__base_41, __blockSize_41);
    function __randomBlock_41() {
        return _$pad_43((Math.random() * __discreteValues_41 << 0).toString(__base_41), __blockSize_41);
    }
    function __safeCounter_41() {
        __c_41 = __c_41 < __discreteValues_41 ? __c_41 : 0;
        __c_41++; // this is not subliminal
        return __c_41 - 1;
    }
    function __cuid_41() {
        // Starting with a lowercase letter makes
        // it HTML element ID friendly.
        var letter = "c", // hard-coded allows for sequential access
        // timestamp
        // warning: this exposes the exact date and time
        // that the uid was created.
        timestamp = new Date().getTime().toString(__base_41), // Prevent same-machine collisions.
        counter = _$pad_43(__safeCounter_41().toString(__base_41), __blockSize_41), // A few chars to generate distinct ids for different
        // clients (so different computers are far less
        // likely to generate the same id)
        print = _$fingerprint_42(), // Grab some more chars from Math.random()
        random = __randomBlock_41() + __randomBlock_41();
        return letter + timestamp + counter + print + random;
    }
    __cuid_41.fingerprint = _$fingerprint_42;
    var _$cuid_41 = __cuid_41; /* removed: var _$assign_11 = require('@bugsnag/core/lib/es-utils/assign'); */ 
    var BUGSNAG_ANONYMOUS_ID_KEY = "bugsnag-anonymous-id";
    var getDeviceId = function(win) {
        try {
            var storage = win.localStorage;
            var id = storage.getItem(BUGSNAG_ANONYMOUS_ID_KEY); // If we get an ID, make sure it looks like a valid cuid. The length can
            // fluctuate slightly, so some leeway is built in
            if (id && /^c[a-z0-9]{20,32}$/.test(id)) return id;
             /* removed: var _$cuid_41 = require('@bugsnag/cuid'); */ 
            id = _$cuid_41();
            storage.setItem(BUGSNAG_ANONYMOUS_ID_KEY, id);
            return id;
        } catch (err) {}
    };
    /*
 * Automatically detects browser device details
 */ var _$device_40 = function(nav, win) {
        if (nav === void 0) nav = navigator;
        if (win === void 0) win = window;
        return {
            load: function(client) {
                var device = {
                    locale: nav.browserLanguage || nav.systemLanguage || nav.userLanguage || nav.language,
                    userAgent: nav.userAgent
                };
                if (win && win.screen && win.screen.orientation && win.screen.orientation.type) device.orientation = win.screen.orientation.type;
                else if (win && win.document) device.orientation = win.document.documentElement.clientWidth > win.document.documentElement.clientHeight ? "landscape" : "portrait";
                if (client._config.generateAnonymousId) device.id = getDeviceId(win);
                client.addOnSession(function(session) {
                    session.device = _$assign_11({}, session.device, device); // only set device id if collectUserIp is false
                    if (!client._config.collectUserIp) setDefaultUserId(session);
                }); // add time just as the event is sent
                client.addOnError(function(event) {
                    event.device = _$assign_11({}, event.device, device, {
                        time: new Date()
                    });
                    if (!client._config.collectUserIp) setDefaultUserId(event);
                }, true);
            },
            configSchema: {
                generateAnonymousId: {
                    validate: function(value) {
                        return value === true || value === false;
                    },
                    defaultValue: function() {
                        return true;
                    },
                    message: "should be true|false"
                }
            }
        };
    };
    var setDefaultUserId = function(eventOrSession) {
        // device id is also used to populate the user id field, if it's not already set
        var user = eventOrSession.getUser();
        if (!user || !user.id) eventOrSession.setUser(eventOrSession.device.id);
    }; /* removed: var _$assign_11 = require('@bugsnag/core/lib/es-utils/assign'); */ 
    /*
 * Sets the event request: { url } to be the current href
 */ var _$request_44 = function(win) {
        if (win === void 0) win = window;
        return {
            load: function(client) {
                client.addOnError(function(event) {
                    if (event.request && event.request.url) return;
                    event.request = _$assign_11({}, event.request, {
                        url: win.location.href
                    });
                }, true);
            }
        };
    }; /* removed: var _$includes_13 = require('@bugsnag/core/lib/es-utils/includes'); */ 
    var _$session_45 = {
        load: function(client) {
            client._sessionDelegate = sessionDelegate;
        }
    };
    var sessionDelegate = {
        startSession: function(client, session) {
            var sessionClient = client;
            sessionClient._session = session;
            sessionClient._pausedSession = null; // exit early if the current releaseStage is not enabled
            if (sessionClient._config.enabledReleaseStages !== null && !_$includes_13(sessionClient._config.enabledReleaseStages, sessionClient._config.releaseStage)) {
                sessionClient._logger.warn("Session not sent due to releaseStage/enabledReleaseStages configuration");
                return sessionClient;
            }
            sessionClient._delivery.sendSession({
                notifier: sessionClient._notifier,
                device: session.device,
                app: session.app,
                sessions: [
                    {
                        id: session.id,
                        startedAt: session.startedAt,
                        user: session._user
                    }
                ]
            });
            return sessionClient;
        },
        resumeSession: function(client) {
            // Do nothing if there's already an active session
            if (client._session) return client;
             // If we have a paused session then make it the active session
            if (client._pausedSession) {
                client._session = client._pausedSession;
                client._pausedSession = null;
                return client;
            } // Otherwise start a new session
            return client.startSession();
        },
        pauseSession: function(client) {
            client._pausedSession = client._session;
            client._session = null;
        }
    }; /* removed: var _$assign_11 = require('@bugsnag/core/lib/es-utils/assign'); */ 
    /*
 * Prevent collection of user IPs
 */ var _$clientIp_46 = {
        load: function(client) {
            if (client._config.collectUserIp) return;
            client.addOnError(function(event) {
                // If user.id is explicitly undefined, it will be missing from the payload. It needs
                // removing so that the following line replaces it
                if (event._user && typeof event._user.id === "undefined") delete event._user.id;
                event._user = _$assign_11({
                    id: "[REDACTED]"
                }, event._user);
                event.request = _$assign_11({
                    clientIp: "[REDACTED]"
                }, event.request);
            });
        },
        configSchema: {
            collectUserIp: {
                defaultValue: function() {
                    return true;
                },
                message: "should be true|false",
                validate: function(value) {
                    return value === true || value === false;
                }
            }
        }
    };
    var _$consoleBreadcrumbs_47 = {}; /* removed: var _$map_16 = require('@bugsnag/core/lib/es-utils/map'); */ 
    /*
 * Leaves breadcrumbs when console log methods are called
 */ _$consoleBreadcrumbs_47.load = function(client) {
        var isDev = /^(local-)?dev(elopment)?$/.test(client._config.releaseStage);
        if (isDev || !client._isBreadcrumbTypeEnabled("log")) return;
        _$map_16(CONSOLE_LOG_METHODS, function(method) {
            var original = console[method];
            console[method] = function() {
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
                client.leaveBreadcrumb("Console output", _$reduce_17(args, function(accum, arg, i) {
                    // do the best/simplest stringification of each argument
                    var stringified = "[Unknown value]"; // this may fail if the input is:
                    // - an object whose [[Prototype]] is null (no toString)
                    // - an object with a broken toString or @@toPrimitive implementation
                    try {
                        stringified = String(arg);
                    } catch (e) {} // if it stringifies to [object Object] attempt to JSON stringify
                    if (stringified === "[object Object]") // catch stringify errors and fallback to [object Object]
                    try {
                        stringified = JSON.stringify(arg);
                    } catch (e) {}
                    accum["[" + i + "]"] = stringified;
                    return accum;
                }, {
                    severity: method.indexOf("group") === 0 ? "log" : method
                }), "log");
                original.apply(console, args);
            };
            console[method]._restore = function() {
                console[method] = original;
            };
        });
    };
    var CONSOLE_LOG_METHODS = _$filter_12([
        "log",
        "debug",
        "info",
        "warn",
        "error"
    ], function(method) {
        return typeof console !== "undefined" && typeof console[method] === "function";
    }); /* removed: var _$map_16 = require('@bugsnag/core/lib/es-utils/map'); */ 
    var MAX_LINE_LENGTH = 200;
    var MAX_SCRIPT_LENGTH = 500000;
    var _$inlineScriptContent_48 = function(doc, win) {
        if (doc === void 0) doc = document;
        if (win === void 0) win = window;
        return {
            load: function(client) {
                if (!client._config.trackInlineScripts) return;
                var originalLocation = win.location.href;
                var html = ""; // in IE8-10 the 'interactive' state can fire too soon (before scripts have finished executing), so in those
                // we wait for the 'complete' state before assuming that synchronous scripts are no longer executing
                var isOldIe = !!doc.attachEvent;
                var DOMContentLoaded = isOldIe ? doc.readyState === "complete" : doc.readyState !== "loading";
                var getHtml = function() {
                    return doc.documentElement.outerHTML;
                }; // get whatever HTML exists at this point in time
                html = getHtml();
                var prev = doc.onreadystatechange; // then update it when the DOM content has loaded
                doc.onreadystatechange = function() {
                    // IE8 compatible alternative to document#DOMContentLoaded
                    if (doc.readyState === "interactive") {
                        html = getHtml();
                        DOMContentLoaded = true;
                    }
                    try {
                        prev.apply(this, arguments);
                    } catch (e) {}
                };
                var _lastScript = null;
                var updateLastScript = function(script) {
                    _lastScript = script;
                };
                var getCurrentScript = function() {
                    var script = doc.currentScript || _lastScript;
                    if (!script && !DOMContentLoaded) {
                        var scripts = doc.scripts || doc.getElementsByTagName("script");
                        script = scripts[scripts.length - 1];
                    }
                    return script;
                };
                var addSurroundingCode = function(lineNumber) {
                    // get whatever html has rendered at this point
                    if (!DOMContentLoaded || !html) html = getHtml(); // simulate the raw html
                    var htmlLines = [
                        "<!-- DOC START -->"
                    ].concat(html.split("\n"));
                    var zeroBasedLine = lineNumber - 1;
                    var start = Math.max(zeroBasedLine - 3, 0);
                    var end = Math.min(zeroBasedLine + 3, htmlLines.length);
                    return _$reduce_17(htmlLines.slice(start, end), function(accum, line, i) {
                        accum[start + 1 + i] = line.length <= MAX_LINE_LENGTH ? line : line.substr(0, MAX_LINE_LENGTH);
                        return accum;
                    }, {});
                };
                client.addOnError(function(event) {
                    // remove any of our own frames that may be part the stack this
                    // happens before the inline script check as it happens for all errors
                    event.errors[0].stacktrace = _$filter_12(event.errors[0].stacktrace, function(f) {
                        return !/__trace__$/.test(f.method);
                    });
                    var frame = event.errors[0].stacktrace[0]; // if frame.file exists and is not the original location of the page, this can't be an inline script
                    if (frame && frame.file && frame.file.replace(/#.*$/, "") !== originalLocation.replace(/#.*$/, "")) return; // grab the last script known to have run
                    var currentScript = getCurrentScript();
                    if (currentScript) {
                        var content = currentScript.innerHTML;
                        event.addMetadata("script", "content", content.length <= MAX_SCRIPT_LENGTH ? content : content.substr(0, MAX_SCRIPT_LENGTH)); // only attempt to grab some surrounding code if we have a line number
                        if (frame && frame.lineNumber) frame.code = addSurroundingCode(frame.lineNumber);
                    }
                }, true); // Proxy all the timer functions whose callback is their 0th argument.
                // Keep a reference to the original setTimeout because we need it later
                var _map = _$map_16([
                    "setTimeout",
                    "setInterval",
                    "setImmediate",
                    "requestAnimationFrame"
                ], function(fn) {
                    return __proxy(win, fn, function(original) {
                        return __traceOriginalScript(original, function(args) {
                            return {
                                get: function() {
                                    return args[0];
                                },
                                replace: function(fn) {
                                    args[0] = fn;
                                }
                            };
                        });
                    });
                }), _setTimeout = _map[0]; // Proxy all the host objects whose prototypes have an addEventListener function
                _$map_16([
                    "EventTarget",
                    "Window",
                    "Node",
                    "ApplicationCache",
                    "AudioTrackList",
                    "ChannelMergerNode",
                    "CryptoOperation",
                    "EventSource",
                    "FileReader",
                    "HTMLUnknownElement",
                    "IDBDatabase",
                    "IDBRequest",
                    "IDBTransaction",
                    "KeyOperation",
                    "MediaController",
                    "MessagePort",
                    "ModalWindow",
                    "Notification",
                    "SVGElementInstance",
                    "Screen",
                    "TextTrack",
                    "TextTrackCue",
                    "TextTrackList",
                    "WebSocket",
                    "WebSocketWorker",
                    "Worker",
                    "XMLHttpRequest",
                    "XMLHttpRequestEventTarget",
                    "XMLHttpRequestUpload"
                ], function(o) {
                    if (!win[o] || !win[o].prototype || !Object.prototype.hasOwnProperty.call(win[o].prototype, "addEventListener")) return;
                    __proxy(win[o].prototype, "addEventListener", function(original) {
                        return __traceOriginalScript(original, eventTargetCallbackAccessor);
                    });
                    __proxy(win[o].prototype, "removeEventListener", function(original) {
                        return __traceOriginalScript(original, eventTargetCallbackAccessor, true);
                    });
                });
                function __traceOriginalScript(fn, callbackAccessor, alsoCallOriginal) {
                    if (alsoCallOriginal === void 0) alsoCallOriginal = false;
                    return function() {
                        // this is required for removeEventListener to remove anything added with
                        // addEventListener before the functions started being wrapped by Bugsnag
                        var args = [].slice.call(arguments);
                        try {
                            var cba = callbackAccessor(args);
                            var cb = cba.get();
                            if (alsoCallOriginal) fn.apply(this, args);
                            if (typeof cb !== "function") return fn.apply(this, args);
                            if (cb.__trace__) cba.replace(cb.__trace__);
                            else {
                                var script = getCurrentScript(); // this function mustn't be annonymous due to a bug in the stack
                                // generation logic, meaning it gets tripped up
                                // see: https://github.com/stacktracejs/stack-generator/issues/6
                                cb.__trace__ = function __trace__() {
                                    // set the script that called this function
                                    updateLastScript(script); // immediately unset the currentScript synchronously below, however
                                    // if this cb throws an error the line after will not get run so schedule
                                    // an almost-immediate aysnc update too
                                    _setTimeout(function() {
                                        updateLastScript(null);
                                    }, 0);
                                    var ret = cb.apply(this, arguments);
                                    updateLastScript(null);
                                    return ret;
                                };
                                cb.__trace__.__trace__ = cb.__trace__;
                                cba.replace(cb.__trace__);
                            }
                        } catch (e) {
                        // Permission denied to access property '__trace__'
                        // WebDriverException: Message: Permission denied to access property "handleEvent"
                        } // IE8 doesn't let you call .apply() on setTimeout/setInterval
                        if (fn.apply) return fn.apply(this, args);
                        switch(args.length){
                            case 1:
                                return fn(args[0]);
                            case 2:
                                return fn(args[0], args[1]);
                            default:
                                return fn();
                        }
                    };
                }
            },
            configSchema: {
                trackInlineScripts: {
                    validate: function(value) {
                        return value === true || value === false;
                    },
                    defaultValue: function() {
                        return true;
                    },
                    message: "should be true|false"
                }
            }
        };
    };
    function __proxy(host, name, replacer) {
        var original = host[name];
        if (!original) return original;
        var replacement = replacer(original);
        host[name] = replacement;
        return original;
    }
    function eventTargetCallbackAccessor(args) {
        var isEventHandlerObj = !!args[1] && typeof args[1].handleEvent === "function";
        return {
            get: function() {
                return isEventHandlerObj ? args[1].handleEvent : args[1];
            },
            replace: function(fn) {
                if (isEventHandlerObj) args[1].handleEvent = fn;
                else args[1] = fn;
            }
        };
    }
    /*
 * Leaves breadcrumbs when the user interacts with the DOM
 */ var _$interactionBreadcrumbs_49 = function(win) {
        if (win === void 0) win = window;
        return {
            load: function(client) {
                if (!("addEventListener" in win)) return;
                if (!client._isBreadcrumbTypeEnabled("user")) return;
                win.addEventListener("click", function(event) {
                    var targetText, targetSelector;
                    try {
                        targetText = getNodeText(event.target);
                        targetSelector = getNodeSelector(event.target, win);
                    } catch (e) {
                        targetText = "[hidden]";
                        targetSelector = "[hidden]";
                        client._logger.error("Cross domain error when tracking click event. See docs: https://tinyurl.com/yy3rn63z");
                    }
                    client.leaveBreadcrumb("UI click", {
                        targetText: targetText,
                        targetSelector: targetSelector
                    }, "user");
                }, true);
            }
        };
    };
    var trimStart = /^\s+/;
    var trimEnd = /(^|[^\s])\s+$/;
    function getNodeText(el) {
        var text = el.textContent || el.innerText || "";
        if (!text && (el.type === "submit" || el.type === "button")) text = el.value;
        text = text.replace(trimStart, "").replace(trimEnd, "$1");
        if (text.length > 140) return text.slice(0, 135) + "(...)";
        return text;
    } // Create a label from tagname, id and css class of the element
    function getNodeSelector(el, win) {
        var parts = [
            el.tagName
        ];
        if (el.id) parts.push("#" + el.id);
        if (el.className && el.className.length) parts.push("." + el.className.split(" ").join(".")); // Can't get much more advanced with the current browser
        if (!win.document.querySelectorAll || !Array.prototype.indexOf) return parts.join("");
        try {
            if (win.document.querySelectorAll(parts.join("")).length === 1) return parts.join("");
        } catch (e) {
            // Sometimes the query selector can be invalid just return it as-is
            return parts.join("");
        } // try to get a more specific selector if this one matches more than one element
        if (el.parentNode.childNodes.length > 1) {
            var index = Array.prototype.indexOf.call(el.parentNode.childNodes, el) + 1;
            parts.push(":nth-child(" + index + ")");
        }
        if (win.document.querySelectorAll(parts.join("")).length === 1) return parts.join(""); // try prepending the parent node selector
        if (el.parentNode) return getNodeSelector(el.parentNode, win) + " > " + parts.join("");
        return parts.join("");
    }
    var _$navigationBreadcrumbs_50 = {};
    /*
* Leaves breadcrumbs when navigation methods are called or events are emitted
*/ _$navigationBreadcrumbs_50 = function(win) {
        if (win === void 0) win = window;
        var plugin = {
            load: function(client) {
                if (!("addEventListener" in win)) return;
                if (!client._isBreadcrumbTypeEnabled("navigation")) return; // returns a function that will drop a breadcrumb with a given name
                var drop = function(name) {
                    return function() {
                        return client.leaveBreadcrumb(name, {}, "navigation");
                    };
                }; // simple drops – just names, no meta
                win.addEventListener("pagehide", drop("Page hidden"), true);
                win.addEventListener("pageshow", drop("Page shown"), true);
                win.addEventListener("load", drop("Page loaded"), true);
                win.document.addEventListener("DOMContentLoaded", drop("DOMContentLoaded"), true); // some browsers like to emit popstate when the page loads, so only add the popstate listener after that
                win.addEventListener("load", function() {
                    return win.addEventListener("popstate", drop("Navigated back"), true);
                }); // hashchange has some metadata that we care about
                win.addEventListener("hashchange", function(event) {
                    var metadata = event.oldURL ? {
                        from: relativeLocation(event.oldURL, win),
                        to: relativeLocation(event.newURL, win),
                        state: getCurrentState(win)
                    } : {
                        to: relativeLocation(win.location.href, win)
                    };
                    client.leaveBreadcrumb("Hash changed", metadata, "navigation");
                }, true); // the only way to know about replaceState/pushState is to wrap them… >_<
                if (win.history.replaceState) wrapHistoryFn(client, win.history, "replaceState", win);
                if (win.history.pushState) wrapHistoryFn(client, win.history, "pushState", win);
            }
        };
        return plugin;
    };
    // just the path and hash parts, e.g. /pages/01.html?yes=no#section-2
    var relativeLocation = function(url, win) {
        var a = win.document.createElement("A");
        a.href = url;
        return "" + a.pathname + a.search + a.hash;
    };
    var stateChangeToMetadata = function(win, state, title, url) {
        var currentPath = relativeLocation(win.location.href, win);
        return {
            title: title,
            state: state,
            prevState: getCurrentState(win),
            to: url || currentPath,
            from: currentPath
        };
    };
    var wrapHistoryFn = function(client, target, fn, win) {
        var orig = target[fn];
        target[fn] = function(state, title, url) {
            client.leaveBreadcrumb("History " + fn, stateChangeToMetadata(win, state, title, url), "navigation"); // if throttle plugin is in use, reset the event sent count
            if (typeof client.resetEventCount === "function") client.resetEventCount(); // if the client is operating in auto session-mode, a new route should trigger a new session
            if (client._config.autoTrackSessions) client.startSession(); // Internet Explorer will convert `undefined` to a string when passed, causing an unintended redirect
            // to '/undefined'. therefore we only pass the url if it's not undefined.
            orig.apply(target, [
                state,
                title
            ].concat(url !== undefined ? url : []));
        };
    };
    var getCurrentState = function(win) {
        try {
            return win.history.state;
        } catch (e) {}
    };
    var BREADCRUMB_TYPE = "request"; /* removed: var _$includes_13 = require('@bugsnag/core/lib/es-utils/includes'); */ 
    /*
 * Leaves breadcrumbs when network requests occur
 */ var _$networkBreadcrumbs_51 = function(_ignoredUrls, win) {
        if (_ignoredUrls === void 0) _ignoredUrls = [];
        if (win === void 0) win = window;
        var restoreFunctions = [];
        var plugin = {
            load: function(client) {
                if (!client._isBreadcrumbTypeEnabled("request")) return;
                var ignoredUrls = [
                    client._config.endpoints.notify,
                    client._config.endpoints.sessions
                ].concat(_ignoredUrls);
                monkeyPatchXMLHttpRequest();
                monkeyPatchFetch(); // XMLHttpRequest monkey patch
                function monkeyPatchXMLHttpRequest() {
                    if (!("addEventListener" in win.XMLHttpRequest.prototype)) return;
                    var nativeOpen = win.XMLHttpRequest.prototype.open; // override native open()
                    win.XMLHttpRequest.prototype.open = function open(method, url) {
                        var _this = this;
                        var requestSetupKey = false;
                        var error = function() {
                            return handleXHRError(method, url);
                        };
                        var load = function() {
                            return handleXHRLoad(method, url, _this.status);
                        }; // if we have already setup listeners, it means open() was called twice, we need to remove
                        // the listeners and recreate them
                        if (requestSetupKey) {
                            this.removeEventListener("load", load);
                            this.removeEventListener("error", error);
                        } // attach load event listener
                        this.addEventListener("load", load); // attach error event listener
                        this.addEventListener("error", error);
                        requestSetupKey = true;
                        nativeOpen.apply(this, arguments);
                    };
                }
                function handleXHRLoad(method, url, status) {
                    if (url === undefined) {
                        client._logger.warn("The request URL is no longer present on this XMLHttpRequest. A breadcrumb cannot be left for this request.");
                        return;
                    } // an XMLHttpRequest's URL can be an object as long as its 'toString'
                    // returns a URL, e.g. a HTMLAnchorElement
                    if (typeof url === "string" && _$includes_13(ignoredUrls, url.replace(/\?.*$/, ""))) // don't leave a network breadcrumb from bugsnag notify calls
                    return;
                    var metadata = {
                        status: status,
                        request: method + " " + url
                    };
                    if (status >= 400) // contacted server but got an error response
                    client.leaveBreadcrumb("XMLHttpRequest failed", metadata, BREADCRUMB_TYPE);
                    else client.leaveBreadcrumb("XMLHttpRequest succeeded", metadata, BREADCRUMB_TYPE);
                }
                function handleXHRError(method, url) {
                    if (url === undefined) {
                        client._logger.warn("The request URL is no longer present on this XMLHttpRequest. A breadcrumb cannot be left for this request.");
                        return;
                    }
                    if (typeof url === "string" && _$includes_13(ignoredUrls, url.replace(/\?.*$/, ""))) // don't leave a network breadcrumb from bugsnag notify calls
                    return;
                     // failed to contact server
                    client.leaveBreadcrumb("XMLHttpRequest error", {
                        request: method + " " + url
                    }, BREADCRUMB_TYPE);
                } // window.fetch monkey patch
                function monkeyPatchFetch() {
                    // only patch it if it exists and if it is not a polyfill (patching a polyfilled
                    // fetch() results in duplicate breadcrumbs for the same request because the
                    // implementation uses XMLHttpRequest which is also patched)
                    if (!("fetch" in win) || win.fetch.polyfill) return;
                    var oldFetch = win.fetch;
                    win.fetch = function fetch() {
                        var _arguments = arguments;
                        var urlOrRequest = arguments[0];
                        var options = arguments[1];
                        var method;
                        var url = null;
                        if (urlOrRequest && typeof urlOrRequest === "object") {
                            url = urlOrRequest.url;
                            if (options && "method" in options) method = options.method;
                            else if (urlOrRequest && "method" in urlOrRequest) method = urlOrRequest.method;
                        } else {
                            url = urlOrRequest;
                            if (options && "method" in options) method = options.method;
                        }
                        if (method === undefined) method = "GET";
                        return new Promise(function(resolve, reject) {
                            // pass through to native fetch
                            oldFetch.apply(void 0, _arguments).then(function(response) {
                                handleFetchSuccess(response, method, url);
                                resolve(response);
                            })["catch"](function(error) {
                                handleFetchError(method, url);
                                reject(error);
                            });
                        });
                    };
                }
                var handleFetchSuccess = function(response, method, url) {
                    var metadata = {
                        status: response.status,
                        request: method + " " + url
                    };
                    if (response.status >= 400) // when the request comes back with a 4xx or 5xx status it does not reject the fetch promise,
                    client.leaveBreadcrumb("fetch() failed", metadata, BREADCRUMB_TYPE);
                    else client.leaveBreadcrumb("fetch() succeeded", metadata, BREADCRUMB_TYPE);
                };
                var handleFetchError = function(method, url) {
                    client.leaveBreadcrumb("fetch() error", {
                        request: method + " " + url
                    }, BREADCRUMB_TYPE);
                };
            }
        };
        return plugin;
    }; /* removed: var _$intRange_24 = require('@bugsnag/core/lib/validators/int-range'); */ 
    /*
 * Throttles and dedupes events
 */ var _$throttle_52 = {
        load: function(client) {
            // track sent events for each init of the plugin
            var n = 0; // add onError hook
            client.addOnError(function(event) {
                // have max events been sent already?
                if (n >= client._config.maxEvents) {
                    client._logger.warn("Cancelling event send due to maxEvents per session limit of " + client._config.maxEvents + " being reached");
                    return false;
                }
                n++;
            });
            client.resetEventCount = function() {
                n = 0;
            };
        },
        configSchema: {
            maxEvents: {
                defaultValue: function() {
                    return 10;
                },
                message: "should be a positive integer \u2264100",
                validate: function(val) {
                    return _$intRange_24(1, 100)(val);
                }
            }
        }
    };
    var _$stripQueryString_53 = {}; /* removed: var _$map_16 = require('@bugsnag/core/lib/es-utils/map'); */ 
    _$stripQueryString_53 = {
        load: function(client) {
            client.addOnError(function(event) {
                var allFrames = _$reduce_17(event.errors, function(accum, er) {
                    return accum.concat(er.stacktrace);
                }, []);
                _$map_16(allFrames, function(frame) {
                    frame.file = strip(frame.file);
                });
            });
        }
    };
    var strip = _$stripQueryString_53._strip = function(str) {
        return typeof str === "string" ? str.replace(/\?.*$/, "").replace(/#.*$/, "") : str;
    };
    /*
 * Automatically notifies Bugsnag when window.onerror is called
 */ var _$onerror_54 = function(win, component) {
        if (win === void 0) win = window;
        if (component === void 0) component = "window onerror";
        return {
            load: function(client) {
                if (!client._config.autoDetectErrors) return;
                if (!client._config.enabledErrorTypes.unhandledExceptions) return;
                function onerror(messageOrEvent, url, lineNo, charNo, error) {
                    // Ignore errors with no info due to CORS settings
                    if (lineNo === 0 && /Script error\.?/.test(messageOrEvent)) client._logger.warn("Ignoring cross-domain or eval script error. See docs: https://tinyurl.com/yy3rn63z");
                    else {
                        // any error sent to window.onerror is unhandled and has severity=error
                        var handledState = {
                            severity: "error",
                            unhandled: true,
                            severityReason: {
                                type: "unhandledException"
                            }
                        };
                        var event; // window.onerror can be called in a number of ways. This big if-else is how we
                        // figure out which arguments were supplied, and what kind of values it received.
                        if (error) {
                            // if the last parameter (error) was supplied, this is a modern browser's
                            // way of saying "this value was thrown and not caught"
                            event = client.Event.create(error, true, handledState, component, 1);
                            decorateStack(event.errors[0].stacktrace, url, lineNo, charNo);
                        } else if (// by jquery's trigger method (although can be created in other ways). In
                        // order to detect this:
                        // - the first argument (message) must exist and be an object (most likely it's a jQuery event)
                        // - the second argument (url) must either not exist or be something other than a string (if it
                        //    exists and is not a string, it'll be the extraParameters argument from jQuery's trigger()
                        //    function)
                        // - the third, fourth and fifth arguments must not exist (lineNo, charNo and error)
                        typeof messageOrEvent === "object" && messageOrEvent !== null && (!url || typeof url !== "string") && !lineNo && !charNo && !error) {
                            // The jQuery event may have a "type" property, if so use it as part of the error message
                            var name = messageOrEvent.type ? "Event: " + messageOrEvent.type : "Error"; // attempt to find a message from one of the conventional properties, but
                            // default to empty string (the event will fill it with a placeholder)
                            var message = messageOrEvent.message || messageOrEvent.detail || "";
                            event = client.Event.create({
                                name: name,
                                message: message
                            }, true, handledState, component, 1); // provide the original thing onerror received – not our error-like object we passed to _notify
                            event.originalError = messageOrEvent; // include the raw input as metadata – it might contain more info than we extracted
                            event.addMetadata(component, {
                                event: messageOrEvent,
                                extraParameters: url
                            });
                        } else {
                            // Lastly, if there was no "error" parameter this event was probably from an old
                            // browser that doesn't support that. Instead we need to generate a stacktrace.
                            event = client.Event.create(messageOrEvent, true, handledState, component, 1);
                            decorateStack(event.errors[0].stacktrace, url, lineNo, charNo);
                        }
                        client._notify(event);
                    }
                    if (typeof prevOnError === "function") prevOnError.apply(this, arguments);
                }
                var prevOnError = win.onerror;
                win.onerror = onerror;
            }
        };
    }; // Sometimes the stacktrace has less information than was passed to window.onerror.
    // This function will augment the first stackframe with any useful info that was
    // received as arguments to the onerror callback.
    var decorateStack = function(stack, url, lineNo, charNo) {
        if (!stack[0]) stack.push({});
        var culprit = stack[0];
        if (!culprit.file && typeof url === "string") culprit.file = url;
        if (!culprit.lineNumber && isActualNumber(lineNo)) culprit.lineNumber = lineNo;
        if (!culprit.columnNumber) {
            if (isActualNumber(charNo)) culprit.columnNumber = charNo;
            else if (window.event && isActualNumber(window.event.errorCharacter)) culprit.columnNumber = window.event.errorCharacter;
        }
    };
    var isActualNumber = function(n) {
        return typeof n === "number" && String.call(n) !== "NaN";
    }; /* removed: var _$map_16 = require('@bugsnag/core/lib/es-utils/map'); */ 
    var _listener;
    /*
 * Automatically notifies Bugsnag when window.onunhandledrejection is called
 */ var _$unhandledRejection_55 = function(win) {
        if (win === void 0) win = window;
        var plugin = {
            load: function(client) {
                if (!client._config.autoDetectErrors || !client._config.enabledErrorTypes.unhandledRejections) return;
                var listener = function(evt) {
                    var error = evt.reason;
                    var isBluebird = false; // accessing properties on evt.detail can throw errors (see #394)
                    try {
                        if (evt.detail && evt.detail.reason) {
                            error = evt.detail.reason;
                            isBluebird = true;
                        }
                    } catch (e) {}
                    var event = client.Event.create(error, false, {
                        severity: "error",
                        unhandled: true,
                        severityReason: {
                            type: "unhandledPromiseRejection"
                        }
                    }, "unhandledrejection handler", 1, client._logger);
                    if (isBluebird) _$map_16(event.errors[0].stacktrace, fixBluebirdStacktrace(error));
                    client._notify(event, function(event) {
                        if (_$iserror_20(event.originalError) && !event.originalError.stack) {
                            var _event$addMetadata;
                            event.addMetadata("unhandledRejection handler", (_event$addMetadata = {}, _event$addMetadata[Object.prototype.toString.call(event.originalError)] = {
                                name: event.originalError.name,
                                message: event.originalError.message,
                                code: event.originalError.code
                            }, _event$addMetadata));
                        }
                    });
                };
                if ("addEventListener" in win) win.addEventListener("unhandledrejection", listener);
                else win.onunhandledrejection = function(reason, promise) {
                    listener({
                        detail: {
                            reason: reason,
                            promise: promise
                        }
                    });
                };
                _listener = listener;
            }
        };
        return plugin;
    }; // The stack parser on bluebird stacks in FF get a suprious first frame:
    //
    // Error: derp
    //   b@http://localhost:5000/bluebird.html:22:24
    //   a@http://localhost:5000/bluebird.html:18:9
    //   @http://localhost:5000/bluebird.html:14:9
    //
    // results in
    //   […]
    //     0: Object { file: "Error: derp", method: undefined, lineNumber: undefined, … }
    //     1: Object { file: "http://localhost:5000/bluebird.html", method: "b", lineNumber: 22, … }
    //     2: Object { file: "http://localhost:5000/bluebird.html", method: "a", lineNumber: 18, … }
    //     3: Object { file: "http://localhost:5000/bluebird.html", lineNumber: 14, columnNumber: 9, … }
    //
    // so the following reduce/accumulator function removes such frames
    //
    // Bluebird pads method names with spaces so trim that too…
    // https://github.com/petkaantonov/bluebird/blob/b7f21399816d02f979fe434585334ce901dcaf44/src/debuggability.js#L568-L571
    var fixBluebirdStacktrace = function(error) {
        return function(frame) {
            if (frame.file === error.toString()) return;
            if (frame.method) frame.method = frame.method.replace(/^\s+/, "");
        };
    };
    var _$notifier_2 = {};
    var name = "Bugsnag JavaScript";
    var version = "7.20.0";
    var url = "https://github.com/bugsnag/bugsnag-js"; /* removed: var _$Client_4 = require('@bugsnag/core/client'); */ 
    var __schema_2 = _$assign_11({}, _$config_5.schema, _$config_1); /* removed: var _$onerror_54 = require('@bugsnag/plugin-window-onerror'); */ 
    var Bugsnag = {
        _client: null,
        createClient: function(opts) {
            // handle very simple use case where user supplies just the api key as a string
            if (typeof opts === "string") opts = {
                apiKey: opts
            };
            if (!opts) opts = {};
            var internalPlugins = [
                _$app_38,
                _$device_40(),
                _$context_39(),
                _$request_44(),
                _$throttle_52,
                _$session_45,
                _$clientIp_46,
                _$stripQueryString_53,
                _$onerror_54(),
                _$unhandledRejection_55(),
                _$navigationBreadcrumbs_50(),
                _$interactionBreadcrumbs_49(),
                _$networkBreadcrumbs_51(),
                _$consoleBreadcrumbs_47,
                _$inlineScriptContent_48()
            ]; // configure a client with user supplied options
            var bugsnag = new _$Client_4(opts, __schema_2, internalPlugins, {
                name: name,
                version: version,
                url: url
            }); // set delivery based on browser capability (IE 8+9 have an XDomainRequest object)
            bugsnag._setDelivery(window.XDomainRequest ? _$delivery_36 : _$delivery_37);
            bugsnag._logger.debug("Loaded!");
            bugsnag.leaveBreadcrumb("Bugsnag loaded", {}, "state");
            return bugsnag._config.autoTrackSessions ? bugsnag.startSession() : bugsnag;
        },
        start: function(opts) {
            if (Bugsnag._client) {
                Bugsnag._client._logger.warn("Bugsnag.start() was called more than once. Ignoring.");
                return Bugsnag._client;
            }
            Bugsnag._client = Bugsnag.createClient(opts);
            return Bugsnag._client;
        },
        isStarted: function() {
            return Bugsnag._client != null;
        }
    };
    _$map_16([
        "resetEventCount"
    ].concat(_$keys_15(_$Client_4.prototype)), function(m) {
        if (/^_/.test(m)) return;
        Bugsnag[m] = function() {
            if (!Bugsnag._client) return console.log("Bugsnag." + m + "() was called before Bugsnag.start()");
            Bugsnag._client._depth += 1;
            var ret = Bugsnag._client[m].apply(Bugsnag._client, arguments);
            Bugsnag._client._depth -= 1;
            return ret;
        };
    });
    _$notifier_2 = Bugsnag;
    _$notifier_2.Client = _$Client_4;
    _$notifier_2.Event = _$Event_6;
    _$notifier_2.Session = _$Session_35;
    _$notifier_2.Breadcrumb = _$Breadcrumb_3; // Export a "default" property for compatibility with ESM imports
    _$notifier_2["default"] = Bugsnag;
    return _$notifier_2;
});

});

parcelRegister("hFJEF", function(module, exports) {
/**
 * Lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright OpenJS Foundation and other contributors <https://openjsf.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */ /** Used as the size to enable large array optimizations. */ var LARGE_ARRAY_SIZE = 200;
/** Used to stand-in for `undefined` hash values. */ var HASH_UNDEFINED = "__lodash_hash_undefined__";
/** Used to detect hot functions by number of calls within a span of milliseconds. */ var HOT_COUNT = 800, HOT_SPAN = 16;
/** Used as references for various `Number` constants. */ var MAX_SAFE_INTEGER = 9007199254740991;
/** `Object#toString` result references. */ var argsTag = "[object Arguments]", arrayTag = "[object Array]", asyncTag = "[object AsyncFunction]", boolTag = "[object Boolean]", dateTag = "[object Date]", errorTag = "[object Error]", funcTag = "[object Function]", genTag = "[object GeneratorFunction]", mapTag = "[object Map]", numberTag = "[object Number]", nullTag = "[object Null]", objectTag = "[object Object]", proxyTag = "[object Proxy]", regexpTag = "[object RegExp]", setTag = "[object Set]", stringTag = "[object String]", undefinedTag = "[object Undefined]", weakMapTag = "[object WeakMap]";
var arrayBufferTag = "[object ArrayBuffer]", dataViewTag = "[object DataView]", float32Tag = "[object Float32Array]", float64Tag = "[object Float64Array]", int8Tag = "[object Int8Array]", int16Tag = "[object Int16Array]", int32Tag = "[object Int32Array]", uint8Tag = "[object Uint8Array]", uint8ClampedTag = "[object Uint8ClampedArray]", uint16Tag = "[object Uint16Array]", uint32Tag = "[object Uint32Array]";
/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */ var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
/** Used to detect host constructors (Safari). */ var reIsHostCtor = /^\[object .+?Constructor\]$/;
/** Used to detect unsigned integer values. */ var reIsUint = /^(?:0|[1-9]\d*)$/;
/** Used to identify `toStringTag` values of typed arrays. */ var typedArrayTags = {};
typedArrayTags[float32Tag] = typedArrayTags[float64Tag] = typedArrayTags[int8Tag] = typedArrayTags[int16Tag] = typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] = typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] = typedArrayTags[uint32Tag] = true;
typedArrayTags[argsTag] = typedArrayTags[arrayTag] = typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] = typedArrayTags[dataViewTag] = typedArrayTags[dateTag] = typedArrayTags[errorTag] = typedArrayTags[funcTag] = typedArrayTags[mapTag] = typedArrayTags[numberTag] = typedArrayTags[objectTag] = typedArrayTags[regexpTag] = typedArrayTags[setTag] = typedArrayTags[stringTag] = typedArrayTags[weakMapTag] = false;
/** Detect free variable `global` from Node.js. */ var freeGlobal = typeof $parcel$global == "object" && $parcel$global && $parcel$global.Object === Object && $parcel$global;
/** Detect free variable `self`. */ var freeSelf = typeof self == "object" && self && self.Object === Object && self;
/** Used as a reference to the global object. */ var root = freeGlobal || freeSelf || Function("return this")();
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Detect free variable `process` from Node.js. */ var freeProcess = moduleExports && freeGlobal.process;
/** Used to access faster Node.js helpers. */ var nodeUtil = function() {
    try {
        // Use `util.types` for Node.js 10+.
        var types = freeModule && freeModule.require && freeModule.require("util").types;
        if (types) return types;
        // Legacy `process.binding('util')` for Node.js < 10.
        return freeProcess && freeProcess.binding && freeProcess.binding("util");
    } catch (e) {}
}();
/* Node.js helper references. */ var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
/**
 * A faster alternative to `Function#apply`, this function invokes `func`
 * with the `this` binding of `thisArg` and the arguments of `args`.
 *
 * @private
 * @param {Function} func The function to invoke.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {Array} args The arguments to invoke `func` with.
 * @returns {*} Returns the result of `func`.
 */ function apply(func, thisArg, args) {
    switch(args.length){
        case 0:
            return func.call(thisArg);
        case 1:
            return func.call(thisArg, args[0]);
        case 2:
            return func.call(thisArg, args[0], args[1]);
        case 3:
            return func.call(thisArg, args[0], args[1], args[2]);
    }
    return func.apply(thisArg, args);
}
/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */ function baseTimes(n, iteratee) {
    var index = -1, result = Array(n);
    while(++index < n)result[index] = iteratee(index);
    return result;
}
/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */ function baseUnary(func) {
    return function(value) {
        return func(value);
    };
}
/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */ function getValue(object, key) {
    return object == null ? undefined : object[key];
}
/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */ function overArg(func, transform) {
    return function(arg) {
        return func(transform(arg));
    };
}
/** Used for built-in method references. */ var arrayProto = Array.prototype, funcProto = Function.prototype, objectProto = Object.prototype;
/** Used to detect overreaching core-js shims. */ var coreJsData = root["__core-js_shared__"];
/** Used to resolve the decompiled source of functions. */ var funcToString = funcProto.toString;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/** Used to detect methods masquerading as native. */ var maskSrcKey = function() {
    var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || "");
    return uid ? "Symbol(src)_1." + uid : "";
}();
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var nativeObjectToString = objectProto.toString;
/** Used to infer the `Object` constructor. */ var objectCtorString = funcToString.call(Object);
/** Used to detect if a method is native. */ var reIsNative = RegExp("^" + funcToString.call(hasOwnProperty).replace(reRegExpChar, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$");
/** Built-in value references. */ var Buffer = moduleExports ? root.Buffer : undefined, Symbol = root.Symbol, Uint8Array = root.Uint8Array, allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined, getPrototype = overArg(Object.getPrototypeOf, Object), objectCreate = Object.create, propertyIsEnumerable = objectProto.propertyIsEnumerable, splice = arrayProto.splice, symToStringTag = Symbol ? Symbol.toStringTag : undefined;
var defineProperty = function() {
    try {
        var func = getNative(Object, "defineProperty");
        func({}, "", {});
        return func;
    } catch (e) {}
}();
/* Built-in method references for those with the same name as other `lodash` methods. */ var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined, nativeMax = Math.max, nativeNow = Date.now;
/* Built-in method references that are verified to be native. */ var Map = getNative(root, "Map"), nativeCreate = getNative(Object, "create");
/**
 * The base implementation of `_.create` without support for assigning
 * properties to the created object.
 *
 * @private
 * @param {Object} proto The object to inherit from.
 * @returns {Object} Returns the new object.
 */ var baseCreate = function() {
    function object() {}
    return function(proto) {
        if (!isObject(proto)) return {};
        if (objectCreate) return objectCreate(proto);
        object.prototype = proto;
        var result = new object;
        object.prototype = undefined;
        return result;
    };
}();
/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function Hash(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */ function hashClear() {
    this.__data__ = nativeCreate ? nativeCreate(null) : {};
    this.size = 0;
}
/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function hashDelete(key) {
    var result = this.has(key) && delete this.__data__[key];
    this.size -= result ? 1 : 0;
    return result;
}
/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function hashGet(key) {
    var data = this.__data__;
    if (nativeCreate) {
        var result = data[key];
        return result === HASH_UNDEFINED ? undefined : result;
    }
    return hasOwnProperty.call(data, key) ? data[key] : undefined;
}
/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function hashHas(key) {
    var data = this.__data__;
    return nativeCreate ? data[key] !== undefined : hasOwnProperty.call(data, key);
}
/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */ function hashSet(key, value) {
    var data = this.__data__;
    this.size += this.has(key) ? 0 : 1;
    data[key] = nativeCreate && value === undefined ? HASH_UNDEFINED : value;
    return this;
}
// Add methods to `Hash`.
Hash.prototype.clear = hashClear;
Hash.prototype["delete"] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;
/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function ListCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */ function listCacheClear() {
    this.__data__ = [];
    this.size = 0;
}
/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function listCacheDelete(key) {
    var data = this.__data__, index = assocIndexOf(data, key);
    if (index < 0) return false;
    var lastIndex = data.length - 1;
    if (index == lastIndex) data.pop();
    else splice.call(data, index, 1);
    --this.size;
    return true;
}
/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function listCacheGet(key) {
    var data = this.__data__, index = assocIndexOf(data, key);
    return index < 0 ? undefined : data[index][1];
}
/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function listCacheHas(key) {
    return assocIndexOf(this.__data__, key) > -1;
}
/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */ function listCacheSet(key, value) {
    var data = this.__data__, index = assocIndexOf(data, key);
    if (index < 0) {
        ++this.size;
        data.push([
            key,
            value
        ]);
    } else data[index][1] = value;
    return this;
}
// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype["delete"] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;
/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function MapCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */ function mapCacheClear() {
    this.size = 0;
    this.__data__ = {
        "hash": new Hash,
        "map": new (Map || ListCache),
        "string": new Hash
    };
}
/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function mapCacheDelete(key) {
    var result = getMapData(this, key)["delete"](key);
    this.size -= result ? 1 : 0;
    return result;
}
/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function mapCacheGet(key) {
    return getMapData(this, key).get(key);
}
/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function mapCacheHas(key) {
    return getMapData(this, key).has(key);
}
/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */ function mapCacheSet(key, value) {
    var data = getMapData(this, key), size = data.size;
    data.set(key, value);
    this.size += data.size == size ? 0 : 1;
    return this;
}
// Add methods to `MapCache`.
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype["delete"] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;
/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function Stack(entries) {
    var data = this.__data__ = new ListCache(entries);
    this.size = data.size;
}
/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */ function stackClear() {
    this.__data__ = new ListCache;
    this.size = 0;
}
/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function stackDelete(key) {
    var data = this.__data__, result = data["delete"](key);
    this.size = data.size;
    return result;
}
/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function stackGet(key) {
    return this.__data__.get(key);
}
/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function stackHas(key) {
    return this.__data__.has(key);
}
/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */ function stackSet(key, value) {
    var data = this.__data__;
    if (data instanceof ListCache) {
        var pairs = data.__data__;
        if (!Map || pairs.length < LARGE_ARRAY_SIZE - 1) {
            pairs.push([
                key,
                value
            ]);
            this.size = ++data.size;
            return this;
        }
        data = this.__data__ = new MapCache(pairs);
    }
    data.set(key, value);
    this.size = data.size;
    return this;
}
// Add methods to `Stack`.
Stack.prototype.clear = stackClear;
Stack.prototype["delete"] = stackDelete;
Stack.prototype.get = stackGet;
Stack.prototype.has = stackHas;
Stack.prototype.set = stackSet;
/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */ function arrayLikeKeys(value, inherited) {
    var isArr = isArray(value), isArg = !isArr && isArguments(value), isBuff = !isArr && !isArg && isBuffer(value), isType = !isArr && !isArg && !isBuff && isTypedArray(value), skipIndexes = isArr || isArg || isBuff || isType, result = skipIndexes ? baseTimes(value.length, String) : [], length = result.length;
    for(var key in value)if ((inherited || hasOwnProperty.call(value, key)) && !(skipIndexes && // Safari 9 has enumerable `arguments.length` in strict mode.
    (key == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
    isBuff && (key == "offset" || key == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
    isType && (key == "buffer" || key == "byteLength" || key == "byteOffset") || // Skip index properties.
    isIndex(key, length)))) result.push(key);
    return result;
}
/**
 * This function is like `assignValue` except that it doesn't assign
 * `undefined` values.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */ function assignMergeValue(object, key, value) {
    if (value !== undefined && !eq(object[key], value) || value === undefined && !(key in object)) baseAssignValue(object, key, value);
}
/**
 * Assigns `value` to `key` of `object` if the existing value is not equivalent
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */ function assignValue(object, key, value) {
    var objValue = object[key];
    if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) || value === undefined && !(key in object)) baseAssignValue(object, key, value);
}
/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function assocIndexOf(array, key) {
    var length = array.length;
    while(length--){
        if (eq(array[length][0], key)) return length;
    }
    return -1;
}
/**
 * The base implementation of `assignValue` and `assignMergeValue` without
 * value checks.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */ function baseAssignValue(object, key, value) {
    if (key == "__proto__" && defineProperty) defineProperty(object, key, {
        "configurable": true,
        "enumerable": true,
        "value": value,
        "writable": true
    });
    else object[key] = value;
}
/**
 * The base implementation of `baseForOwn` which iterates over `object`
 * properties returned by `keysFunc` and invokes `iteratee` for each property.
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @returns {Object} Returns `object`.
 */ var baseFor = createBaseFor();
/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ function baseGetTag(value) {
    if (value == null) return value === undefined ? undefinedTag : nullTag;
    return symToStringTag && symToStringTag in Object(value) ? getRawTag(value) : objectToString(value);
}
/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */ function baseIsArguments(value) {
    return isObjectLike(value) && baseGetTag(value) == argsTag;
}
/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */ function baseIsNative(value) {
    if (!isObject(value) || isMasked(value)) return false;
    var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
    return pattern.test(toSource(value));
}
/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */ function baseIsTypedArray(value) {
    return isObjectLike(value) && isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
}
/**
 * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function baseKeysIn(object) {
    if (!isObject(object)) return nativeKeysIn(object);
    var isProto = isPrototype(object), result = [];
    for(var key in object)if (!(key == "constructor" && (isProto || !hasOwnProperty.call(object, key)))) result.push(key);
    return result;
}
/**
 * The base implementation of `_.merge` without support for multiple sources.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @param {number} srcIndex The index of `source`.
 * @param {Function} [customizer] The function to customize merged values.
 * @param {Object} [stack] Tracks traversed source values and their merged
 *  counterparts.
 */ function baseMerge(object, source, srcIndex, customizer, stack) {
    if (object === source) return;
    baseFor(source, function(srcValue, key) {
        stack || (stack = new Stack);
        if (isObject(srcValue)) baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
        else {
            var newValue = customizer ? customizer(safeGet(object, key), srcValue, key + "", object, source, stack) : undefined;
            if (newValue === undefined) newValue = srcValue;
            assignMergeValue(object, key, newValue);
        }
    }, keysIn);
}
/**
 * A specialized version of `baseMerge` for arrays and objects which performs
 * deep merges and tracks traversed objects enabling objects with circular
 * references to be merged.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @param {string} key The key of the value to merge.
 * @param {number} srcIndex The index of `source`.
 * @param {Function} mergeFunc The function to merge values.
 * @param {Function} [customizer] The function to customize assigned values.
 * @param {Object} [stack] Tracks traversed source values and their merged
 *  counterparts.
 */ function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
    var objValue = safeGet(object, key), srcValue = safeGet(source, key), stacked = stack.get(srcValue);
    if (stacked) {
        assignMergeValue(object, key, stacked);
        return;
    }
    var newValue = customizer ? customizer(objValue, srcValue, key + "", object, source, stack) : undefined;
    var isCommon = newValue === undefined;
    if (isCommon) {
        var isArr = isArray(srcValue), isBuff = !isArr && isBuffer(srcValue), isTyped = !isArr && !isBuff && isTypedArray(srcValue);
        newValue = srcValue;
        if (isArr || isBuff || isTyped) {
            if (isArray(objValue)) newValue = objValue;
            else if (isArrayLikeObject(objValue)) newValue = copyArray(objValue);
            else if (isBuff) {
                isCommon = false;
                newValue = cloneBuffer(srcValue, true);
            } else if (isTyped) {
                isCommon = false;
                newValue = cloneTypedArray(srcValue, true);
            } else newValue = [];
        } else if (isPlainObject(srcValue) || isArguments(srcValue)) {
            newValue = objValue;
            if (isArguments(objValue)) newValue = toPlainObject(objValue);
            else if (!isObject(objValue) || isFunction(objValue)) newValue = initCloneObject(srcValue);
        } else isCommon = false;
    }
    if (isCommon) {
        // Recursively merge objects and arrays (susceptible to call stack limits).
        stack.set(srcValue, newValue);
        mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
        stack["delete"](srcValue);
    }
    assignMergeValue(object, key, newValue);
}
/**
 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @returns {Function} Returns the new function.
 */ function baseRest(func, start) {
    return setToString(overRest(func, start, identity), func + "");
}
/**
 * The base implementation of `setToString` without support for hot loop shorting.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */ var baseSetToString = !defineProperty ? identity : function(func, string) {
    return defineProperty(func, "toString", {
        "configurable": true,
        "enumerable": false,
        "value": constant(string),
        "writable": true
    });
};
/**
 * Creates a clone of  `buffer`.
 *
 * @private
 * @param {Buffer} buffer The buffer to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Buffer} Returns the cloned buffer.
 */ function cloneBuffer(buffer, isDeep) {
    if (isDeep) return buffer.slice();
    var length = buffer.length, result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);
    buffer.copy(result);
    return result;
}
/**
 * Creates a clone of `arrayBuffer`.
 *
 * @private
 * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
 * @returns {ArrayBuffer} Returns the cloned array buffer.
 */ function cloneArrayBuffer(arrayBuffer) {
    var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
    new Uint8Array(result).set(new Uint8Array(arrayBuffer));
    return result;
}
/**
 * Creates a clone of `typedArray`.
 *
 * @private
 * @param {Object} typedArray The typed array to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned typed array.
 */ function cloneTypedArray(typedArray, isDeep) {
    var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
    return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
}
/**
 * Copies the values of `source` to `array`.
 *
 * @private
 * @param {Array} source The array to copy values from.
 * @param {Array} [array=[]] The array to copy values to.
 * @returns {Array} Returns `array`.
 */ function copyArray(source, array) {
    var index = -1, length = source.length;
    array || (array = Array(length));
    while(++index < length)array[index] = source[index];
    return array;
}
/**
 * Copies properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy properties from.
 * @param {Array} props The property identifiers to copy.
 * @param {Object} [object={}] The object to copy properties to.
 * @param {Function} [customizer] The function to customize copied values.
 * @returns {Object} Returns `object`.
 */ function copyObject(source, props, object, customizer) {
    var isNew = !object;
    object || (object = {});
    var index = -1, length = props.length;
    while(++index < length){
        var key = props[index];
        var newValue = customizer ? customizer(object[key], source[key], key, object, source) : undefined;
        if (newValue === undefined) newValue = source[key];
        if (isNew) baseAssignValue(object, key, newValue);
        else assignValue(object, key, newValue);
    }
    return object;
}
/**
 * Creates a function like `_.assign`.
 *
 * @private
 * @param {Function} assigner The function to assign values.
 * @returns {Function} Returns the new assigner function.
 */ function createAssigner(assigner) {
    return baseRest(function(object, sources) {
        var index = -1, length = sources.length, customizer = length > 1 ? sources[length - 1] : undefined, guard = length > 2 ? sources[2] : undefined;
        customizer = assigner.length > 3 && typeof customizer == "function" ? (length--, customizer) : undefined;
        if (guard && isIterateeCall(sources[0], sources[1], guard)) {
            customizer = length < 3 ? undefined : customizer;
            length = 1;
        }
        object = Object(object);
        while(++index < length){
            var source = sources[index];
            if (source) assigner(object, source, index, customizer);
        }
        return object;
    });
}
/**
 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */ function createBaseFor(fromRight) {
    return function(object, iteratee, keysFunc) {
        var index = -1, iterable = Object(object), props = keysFunc(object), length = props.length;
        while(length--){
            var key = props[fromRight ? length : ++index];
            if (iteratee(iterable[key], key, iterable) === false) break;
        }
        return object;
    };
}
/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */ function getMapData(map, key) {
    var data = map.__data__;
    return isKeyable(key) ? data[typeof key == "string" ? "string" : "hash"] : data.map;
}
/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */ function getNative(object, key) {
    var value = getValue(object, key);
    return baseIsNative(value) ? value : undefined;
}
/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */ function getRawTag(value) {
    var isOwn = hasOwnProperty.call(value, symToStringTag), tag = value[symToStringTag];
    try {
        value[symToStringTag] = undefined;
        var unmasked = true;
    } catch (e) {}
    var result = nativeObjectToString.call(value);
    if (unmasked) {
        if (isOwn) value[symToStringTag] = tag;
        else delete value[symToStringTag];
    }
    return result;
}
/**
 * Initializes an object clone.
 *
 * @private
 * @param {Object} object The object to clone.
 * @returns {Object} Returns the initialized clone.
 */ function initCloneObject(object) {
    return typeof object.constructor == "function" && !isPrototype(object) ? baseCreate(getPrototype(object)) : {};
}
/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */ function isIndex(value, length) {
    var type = typeof value;
    length = length == null ? MAX_SAFE_INTEGER : length;
    return !!length && (type == "number" || type != "symbol" && reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
}
/**
 * Checks if the given arguments are from an iteratee call.
 *
 * @private
 * @param {*} value The potential iteratee value argument.
 * @param {*} index The potential iteratee index or key argument.
 * @param {*} object The potential iteratee object argument.
 * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
 *  else `false`.
 */ function isIterateeCall(value, index, object) {
    if (!isObject(object)) return false;
    var type = typeof index;
    if (type == "number" ? isArrayLike(object) && isIndex(index, object.length) : type == "string" && index in object) return eq(object[index], value);
    return false;
}
/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */ function isKeyable(value) {
    var type = typeof value;
    return type == "string" || type == "number" || type == "symbol" || type == "boolean" ? value !== "__proto__" : value === null;
}
/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */ function isMasked(func) {
    return !!maskSrcKey && maskSrcKey in func;
}
/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */ function isPrototype(value) {
    var Ctor = value && value.constructor, proto = typeof Ctor == "function" && Ctor.prototype || objectProto;
    return value === proto;
}
/**
 * This function is like
 * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * except that it includes inherited enumerable properties.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function nativeKeysIn(object) {
    var result = [];
    if (object != null) for(var key in Object(object))result.push(key);
    return result;
}
/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */ function objectToString(value) {
    return nativeObjectToString.call(value);
}
/**
 * A specialized version of `baseRest` which transforms the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @param {Function} transform The rest array transform.
 * @returns {Function} Returns the new function.
 */ function overRest(func, start, transform) {
    start = nativeMax(start === undefined ? func.length - 1 : start, 0);
    return function() {
        var args = arguments, index = -1, length = nativeMax(args.length - start, 0), array = Array(length);
        while(++index < length)array[index] = args[start + index];
        index = -1;
        var otherArgs = Array(start + 1);
        while(++index < start)otherArgs[index] = args[index];
        otherArgs[start] = transform(array);
        return apply(func, this, otherArgs);
    };
}
/**
 * Gets the value at `key`, unless `key` is "__proto__" or "constructor".
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */ function safeGet(object, key) {
    if (key === "constructor" && typeof object[key] === "function") return;
    if (key == "__proto__") return;
    return object[key];
}
/**
 * Sets the `toString` method of `func` to return `string`.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */ var setToString = shortOut(baseSetToString);
/**
 * Creates a function that'll short out and invoke `identity` instead
 * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
 * milliseconds.
 *
 * @private
 * @param {Function} func The function to restrict.
 * @returns {Function} Returns the new shortable function.
 */ function shortOut(func) {
    var count = 0, lastCalled = 0;
    return function() {
        var stamp = nativeNow(), remaining = HOT_SPAN - (stamp - lastCalled);
        lastCalled = stamp;
        if (remaining > 0) {
            if (++count >= HOT_COUNT) return arguments[0];
        } else count = 0;
        return func.apply(undefined, arguments);
    };
}
/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */ function toSource(func) {
    if (func != null) {
        try {
            return funcToString.call(func);
        } catch (e) {}
        try {
            return func + "";
        } catch (e) {}
    }
    return "";
}
/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */ function eq(value, other) {
    return value === other || value !== value && other !== other;
}
/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */ var isArguments = baseIsArguments(function() {
    return arguments;
}()) ? baseIsArguments : function(value) {
    return isObjectLike(value) && hasOwnProperty.call(value, "callee") && !propertyIsEnumerable.call(value, "callee");
};
/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */ var isArray = Array.isArray;
/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */ function isArrayLike(value) {
    return value != null && isLength(value.length) && !isFunction(value);
}
/**
 * This method is like `_.isArrayLike` except that it also checks if `value`
 * is an object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array-like object,
 *  else `false`.
 * @example
 *
 * _.isArrayLikeObject([1, 2, 3]);
 * // => true
 *
 * _.isArrayLikeObject(document.body.children);
 * // => true
 *
 * _.isArrayLikeObject('abc');
 * // => false
 *
 * _.isArrayLikeObject(_.noop);
 * // => false
 */ function isArrayLikeObject(value) {
    return isObjectLike(value) && isArrayLike(value);
}
/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */ var isBuffer = nativeIsBuffer || stubFalse;
/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */ function isFunction(value) {
    if (!isObject(value)) return false;
    // The use of `Object#toString` avoids issues with the `typeof` operator
    // in Safari 9 which returns 'object' for typed arrays and other constructors.
    var tag = baseGetTag(value);
    return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
}
/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */ function isLength(value) {
    return typeof value == "number" && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */ function isObject(value) {
    var type = typeof value;
    return value != null && (type == "object" || type == "function");
}
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function isObjectLike(value) {
    return value != null && typeof value == "object";
}
/**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * @static
 * @memberOf _
 * @since 0.8.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */ function isPlainObject(value) {
    if (!isObjectLike(value) || baseGetTag(value) != objectTag) return false;
    var proto = getPrototype(value);
    if (proto === null) return true;
    var Ctor = hasOwnProperty.call(proto, "constructor") && proto.constructor;
    return typeof Ctor == "function" && Ctor instanceof Ctor && funcToString.call(Ctor) == objectCtorString;
}
/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */ var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
/**
 * Converts `value` to a plain object flattening inherited enumerable string
 * keyed properties of `value` to own properties of the plain object.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {Object} Returns the converted plain object.
 * @example
 *
 * function Foo() {
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.assign({ 'a': 1 }, new Foo);
 * // => { 'a': 1, 'b': 2 }
 *
 * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
 * // => { 'a': 1, 'b': 2, 'c': 3 }
 */ function toPlainObject(value) {
    return copyObject(value, keysIn(value));
}
/**
 * Creates an array of the own and inherited enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keysIn(new Foo);
 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
 */ function keysIn(object) {
    return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
}
/**
 * This method is like `_.merge` except that it accepts `customizer` which
 * is invoked to produce the merged values of the destination and source
 * properties. If `customizer` returns `undefined`, merging is handled by the
 * method instead. The `customizer` is invoked with six arguments:
 * (objValue, srcValue, key, object, source, stack).
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The destination object.
 * @param {...Object} sources The source objects.
 * @param {Function} customizer The function to customize assigned values.
 * @returns {Object} Returns `object`.
 * @example
 *
 * function customizer(objValue, srcValue) {
 *   if (_.isArray(objValue)) {
 *     return objValue.concat(srcValue);
 *   }
 * }
 *
 * var object = { 'a': [1], 'b': [2] };
 * var other = { 'a': [3], 'b': [4] };
 *
 * _.mergeWith(object, other, customizer);
 * // => { 'a': [1, 3], 'b': [2, 4] }
 */ var mergeWith = createAssigner(function(object, source, srcIndex, customizer) {
    baseMerge(object, source, srcIndex, customizer);
});
/**
 * Creates a function that returns `value`.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {*} value The value to return from the new function.
 * @returns {Function} Returns the new constant function.
 * @example
 *
 * var objects = _.times(2, _.constant({ 'a': 1 }));
 *
 * console.log(objects);
 * // => [{ 'a': 1 }, { 'a': 1 }]
 *
 * console.log(objects[0] === objects[1]);
 * // => true
 */ function constant(value) {
    return function() {
        return value;
    };
}
/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */ function identity(value) {
    return value;
}
/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */ function stubFalse() {
    return false;
}
module.exports = mergeWith;

});

parcelRegister("269Bb", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1873966958b84bde$export$2e2bcd8739ae039; });
function $1873966958b84bde$export$2e2bcd8739ae039(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}

});

parcelRegister("fsWgf", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b426a9fd6aa5bcb7$export$2e2bcd8739ae039; });

var $4Tov4 = parcelRequire("4Tov4");
function $b426a9fd6aa5bcb7$export$2e2bcd8739ae039(source, excluded) {
    if (source == null) return {};
    var target = (0, $4Tov4.default)(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}

});
parcelRegister("4Tov4", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $38ff4db73cf07254$export$2e2bcd8739ae039; });
function $38ff4db73cf07254$export$2e2bcd8739ae039(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}

});


parcelRegister("gtn2B", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $bfe13a4239a95b8a$export$2e2bcd8739ae039; });
function $bfe13a4239a95b8a$export$2e2bcd8739ae039() {
    $bfe13a4239a95b8a$export$2e2bcd8739ae039 = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $bfe13a4239a95b8a$export$2e2bcd8739ae039.apply(this, arguments);
}

});

parcelRegister("80wVS", function(module, exports) {

$parcel$export(module.exports, "getContrastRatio", function () { return $5d47de89e3e59380$export$d061e26956a60b0a; });
$parcel$export(module.exports, "darken", function () { return $5d47de89e3e59380$export$4b073707ff63303; });
$parcel$export(module.exports, "lighten", function () { return $5d47de89e3e59380$export$c0816ed86df316af; });
$parcel$export(module.exports, "alpha", function () { return $5d47de89e3e59380$export$58f0f39f63f3cf42; });

/* eslint-disable no-use-before-define */ /**
 * Returns a number whose value is limited to the given range.
 *
 * @param {number} value The value to be clamped
 * @param {number} min The lower boundary of the output range
 * @param {number} max The upper boundary of the output range
 * @returns {number} A number in the range [min, max]
 */ function $5d47de89e3e59380$var$clamp(value) {
    var min = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    var max = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
    if (value < min || value > max) console.error("Material-UI: The value provided ".concat(value, " is out of range [").concat(min, ", ").concat(max, "]."));
    return Math.min(Math.max(min, value), max);
}
function $5d47de89e3e59380$export$5a544e13ad4e1fa5(color) {
    color = color.substr(1);
    var re = new RegExp(".{1,".concat(color.length >= 6 ? 2 : 1, "}"), "g");
    var colors = color.match(re);
    if (colors && colors[0].length === 1) colors = colors.map(function(n) {
        return n + n;
    });
    return colors ? "rgb".concat(colors.length === 4 ? "a" : "", "(").concat(colors.map(function(n, index) {
        return index < 3 ? parseInt(n, 16) : Math.round(parseInt(n, 16) / 255 * 1000) / 1000;
    }).join(", "), ")") : "";
}
function $5d47de89e3e59380$var$intToHex(int) {
    var hex = int.toString(16);
    return hex.length === 1 ? "0".concat(hex) : hex;
}
function $5d47de89e3e59380$export$34d09c4a771c46ef(color) {
    // Idempotent
    if (color.indexOf("#") === 0) return color;
    var _decomposeColor = $5d47de89e3e59380$export$677b39864803984e(color), values = _decomposeColor.values;
    return "#".concat(values.map(function(n) {
        return $5d47de89e3e59380$var$intToHex(n);
    }).join(""));
}
function $5d47de89e3e59380$export$29fb7152bd3f781a(color) {
    color = $5d47de89e3e59380$export$677b39864803984e(color);
    var _color = color, values = _color.values;
    var h = values[0];
    var s = values[1] / 100;
    var l = values[2] / 100;
    var a = s * Math.min(l, 1 - l);
    var f = function f(n) {
        var k = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : (n + h / 30) % 12;
        return l - a * Math.max(Math.min(k - 3, 9 - k, 1), -1);
    };
    var type = "rgb";
    var rgb = [
        Math.round(f(0) * 255),
        Math.round(f(8) * 255),
        Math.round(f(4) * 255)
    ];
    if (color.type === "hsla") {
        type += "a";
        rgb.push(values[3]);
    }
    return $5d47de89e3e59380$export$211a73f2b8c10ce4({
        type: type,
        values: rgb
    });
}
function $5d47de89e3e59380$export$677b39864803984e(color) {
    // Idempotent
    if (color.type) return color;
    if (color.charAt(0) === "#") return $5d47de89e3e59380$export$677b39864803984e($5d47de89e3e59380$export$5a544e13ad4e1fa5(color));
    var marker = color.indexOf("(");
    var type = color.substring(0, marker);
    if ([
        "rgb",
        "rgba",
        "hsl",
        "hsla"
    ].indexOf(type) === -1) throw new Error("Material-UI: Unsupported `".concat(color, "` color.\nWe support the following formats: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()."));
    var values = color.substring(marker + 1, color.length - 1).split(",");
    values = values.map(function(value) {
        return parseFloat(value);
    });
    return {
        type: type,
        values: values
    };
}
function $5d47de89e3e59380$export$211a73f2b8c10ce4(color) {
    var type = color.type;
    var values = color.values;
    if (type.indexOf("rgb") !== -1) // Only convert the first 3 values to int (i.e. not alpha)
    values = values.map(function(n, i) {
        return i < 3 ? parseInt(n, 10) : n;
    });
    else if (type.indexOf("hsl") !== -1) {
        values[1] = "".concat(values[1], "%");
        values[2] = "".concat(values[2], "%");
    }
    return "".concat(type, "(").concat(values.join(", "), ")");
}
function $5d47de89e3e59380$export$d061e26956a60b0a(foreground, background) {
    var lumA = $5d47de89e3e59380$export$c852d90bf7403b62(foreground);
    var lumB = $5d47de89e3e59380$export$c852d90bf7403b62(background);
    return (Math.max(lumA, lumB) + 0.05) / (Math.min(lumA, lumB) + 0.05);
}
function $5d47de89e3e59380$export$c852d90bf7403b62(color) {
    color = $5d47de89e3e59380$export$677b39864803984e(color);
    var rgb = color.type === "hsl" ? $5d47de89e3e59380$export$677b39864803984e($5d47de89e3e59380$export$29fb7152bd3f781a(color)).values : color.values;
    rgb = rgb.map(function(val) {
        val /= 255; // normalized
        return val <= 0.03928 ? val / 12.92 : Math.pow((val + 0.055) / 1.055, 2.4);
    }); // Truncate at 3 digits
    return Number((0.2126 * rgb[0] + 0.7152 * rgb[1] + 0.0722 * rgb[2]).toFixed(3));
}
function $5d47de89e3e59380$export$e665714f76e581fd(color) {
    var coefficient = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0.15;
    return $5d47de89e3e59380$export$c852d90bf7403b62(color) > 0.5 ? $5d47de89e3e59380$export$4b073707ff63303(color, coefficient) : $5d47de89e3e59380$export$c0816ed86df316af(color, coefficient);
}
var $5d47de89e3e59380$var$warnedOnce = false;
function $5d47de89e3e59380$export$cbea29d068a2e18f(color, value) {
    if (!$5d47de89e3e59380$var$warnedOnce) {
        $5d47de89e3e59380$var$warnedOnce = true;
        console.error([
            "Material-UI: The `fade` color utility was renamed to `alpha` to better describe its functionality.",
            "",
            "You should use `import { alpha } from '@material-ui/core/styles'`"
        ].join("\n"));
    }
    return $5d47de89e3e59380$export$58f0f39f63f3cf42(color, value);
}
function $5d47de89e3e59380$export$58f0f39f63f3cf42(color, value) {
    color = $5d47de89e3e59380$export$677b39864803984e(color);
    value = $5d47de89e3e59380$var$clamp(value);
    if (color.type === "rgb" || color.type === "hsl") color.type += "a";
    color.values[3] = value;
    return $5d47de89e3e59380$export$211a73f2b8c10ce4(color);
}
function $5d47de89e3e59380$export$4b073707ff63303(color, coefficient) {
    color = $5d47de89e3e59380$export$677b39864803984e(color);
    coefficient = $5d47de89e3e59380$var$clamp(coefficient);
    if (color.type.indexOf("hsl") !== -1) color.values[2] *= 1 - coefficient;
    else if (color.type.indexOf("rgb") !== -1) for(var i = 0; i < 3; i += 1)color.values[i] *= 1 - coefficient;
    return $5d47de89e3e59380$export$211a73f2b8c10ce4(color);
}
function $5d47de89e3e59380$export$c0816ed86df316af(color, coefficient) {
    color = $5d47de89e3e59380$export$677b39864803984e(color);
    coefficient = $5d47de89e3e59380$var$clamp(coefficient);
    if (color.type.indexOf("hsl") !== -1) color.values[2] += (100 - color.values[2]) * coefficient;
    else if (color.type.indexOf("rgb") !== -1) for(var i = 0; i < 3; i += 1)color.values[i] += (255 - color.values[i]) * coefficient;
    return $5d47de89e3e59380$export$211a73f2b8c10ce4(color);
}

});

parcelRegister("icOS8", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d410cf22e98b25f6$export$2e2bcd8739ae039; });
// We need to centralize the zIndex definitions as they work
// like global values in the browser.
var $d410cf22e98b25f6$var$zIndex = {
    mobileStepper: 1000,
    speedDial: 1050,
    appBar: 1100,
    drawer: 1200,
    modal: 1300,
    snackbar: 1400,
    tooltip: 1500
};
var $d410cf22e98b25f6$export$2e2bcd8739ae039 = $d410cf22e98b25f6$var$zIndex;

});

parcelRegister("7b1Lp", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $539aedb282032fc2$export$2e2bcd8739ae039; });

var $gyDGU = parcelRequire("gyDGU");

var $815Xb = parcelRequire("815Xb");

var $cQNHH = parcelRequire("cQNHH");

var $ipwm3 = parcelRequire("ipwm3");

var $a6yxM = parcelRequire("a6yxM");

var $3K7R2 = parcelRequire("3K7R2");

var $6WDy5 = parcelRequire("6WDy5");

var $1krVc = parcelRequire("1krVc");

var $a4mPI = parcelRequire("a4mPI");

var $96kaR = parcelRequire("96kaR");

var $ks5BK = parcelRequire("ks5BK");
function $539aedb282032fc2$var$getClasses(_ref, classes, Component) {
    var state = _ref.state, stylesOptions = _ref.stylesOptions;
    if (stylesOptions.disableGeneration) return classes || {};
    if (!state.cacheClasses) state.cacheClasses = {
        // Cache for the finalized classes value.
        value: null,
        // Cache for the last used classes prop pointer.
        lastProp: null,
        // Cache for the last used rendered classes pointer.
        lastJSS: {}
    };
     // Tracks if either the rendered classes or classes prop has changed,
    // requiring the generation of a new finalized classes object.
    var generate = false;
    if (state.classes !== state.cacheClasses.lastJSS) {
        state.cacheClasses.lastJSS = state.classes;
        generate = true;
    }
    if (classes !== state.cacheClasses.lastProp) {
        state.cacheClasses.lastProp = classes;
        generate = true;
    }
    if (generate) state.cacheClasses.value = (0, $a6yxM.default)({
        baseClasses: state.cacheClasses.lastJSS,
        newClasses: classes,
        Component: Component
    });
    return state.cacheClasses.value;
}
function $539aedb282032fc2$var$attach(_ref2, props) {
    var state = _ref2.state, theme = _ref2.theme, stylesOptions = _ref2.stylesOptions, stylesCreator = _ref2.stylesCreator, name = _ref2.name;
    if (stylesOptions.disableGeneration) return;
    var sheetManager = (0, $3K7R2.default).get(stylesOptions.sheetsManager, stylesCreator, theme);
    if (!sheetManager) {
        sheetManager = {
            refs: 0,
            staticSheet: null,
            dynamicStyles: null
        };
        (0, $3K7R2.default).set(stylesOptions.sheetsManager, stylesCreator, theme, sheetManager);
    }
    var options = (0, $815Xb.default)({}, stylesCreator.options, stylesOptions, {
        theme: theme,
        flip: typeof stylesOptions.flip === "boolean" ? stylesOptions.flip : theme.direction === "rtl"
    });
    options.generateId = options.serverGenerateClassName || options.generateClassName;
    var sheetsRegistry = stylesOptions.sheetsRegistry;
    if (sheetManager.refs === 0) {
        var staticSheet;
        if (stylesOptions.sheetsCache) staticSheet = (0, $3K7R2.default).get(stylesOptions.sheetsCache, stylesCreator, theme);
        var styles = stylesCreator.create(theme, name);
        if (!staticSheet) {
            staticSheet = stylesOptions.jss.createStyleSheet(styles, (0, $815Xb.default)({
                link: false
            }, options));
            staticSheet.attach();
            if (stylesOptions.sheetsCache) (0, $3K7R2.default).set(stylesOptions.sheetsCache, stylesCreator, theme, staticSheet);
        }
        if (sheetsRegistry) sheetsRegistry.add(staticSheet);
        sheetManager.staticSheet = staticSheet;
        sheetManager.dynamicStyles = (0, $ipwm3.getDynamicStyles)(styles);
    }
    if (sheetManager.dynamicStyles) {
        var dynamicSheet = stylesOptions.jss.createStyleSheet(sheetManager.dynamicStyles, (0, $815Xb.default)({
            link: true
        }, options));
        dynamicSheet.update(props);
        dynamicSheet.attach();
        state.dynamicSheet = dynamicSheet;
        state.classes = (0, $a6yxM.default)({
            baseClasses: sheetManager.staticSheet.classes,
            newClasses: dynamicSheet.classes
        });
        if (sheetsRegistry) sheetsRegistry.add(dynamicSheet);
    } else state.classes = sheetManager.staticSheet.classes;
    sheetManager.refs += 1;
}
function $539aedb282032fc2$var$update(_ref3, props) {
    var state = _ref3.state;
    if (state.dynamicSheet) state.dynamicSheet.update(props);
}
function $539aedb282032fc2$var$detach(_ref4) {
    var state = _ref4.state, theme = _ref4.theme, stylesOptions = _ref4.stylesOptions, stylesCreator = _ref4.stylesCreator;
    if (stylesOptions.disableGeneration) return;
    var sheetManager = (0, $3K7R2.default).get(stylesOptions.sheetsManager, stylesCreator, theme);
    sheetManager.refs -= 1;
    var sheetsRegistry = stylesOptions.sheetsRegistry;
    if (sheetManager.refs === 0) {
        (0, $3K7R2.default).delete(stylesOptions.sheetsManager, stylesCreator, theme);
        stylesOptions.jss.removeStyleSheet(sheetManager.staticSheet);
        if (sheetsRegistry) sheetsRegistry.remove(sheetManager.staticSheet);
    }
    if (state.dynamicSheet) {
        stylesOptions.jss.removeStyleSheet(state.dynamicSheet);
        if (sheetsRegistry) sheetsRegistry.remove(state.dynamicSheet);
    }
}
function $539aedb282032fc2$var$useSynchronousEffect(func, values) {
    var key = (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).useRef([]);
    var output; // Store "generation" key. Just returns a new object every time
    var currentKey = (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).useMemo(function() {
        return {};
    }, values); // eslint-disable-line react-hooks/exhaustive-deps
    // "the first render", or "memo dropped the value"
    if (key.current !== currentKey) {
        key.current = currentKey;
        output = func();
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).useEffect(function() {
        return function() {
            if (output) output();
        };
    }, [
        currentKey
    ] // eslint-disable-line react-hooks/exhaustive-deps
    );
}
function $539aedb282032fc2$export$2e2bcd8739ae039(stylesOrCreator) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var name = options.name, classNamePrefixOption = options.classNamePrefix, Component = options.Component, _options$defaultTheme = options.defaultTheme, defaultTheme = _options$defaultTheme === void 0 ? (0, $ks5BK.default) : _options$defaultTheme, stylesOptions2 = (0, $gyDGU.default)(options, [
        "name",
        "classNamePrefix",
        "Component",
        "defaultTheme"
    ]);
    var stylesCreator = (0, $96kaR.default)(stylesOrCreator);
    var classNamePrefix = name || classNamePrefixOption || "makeStyles";
    stylesCreator.options = {
        index: (0, $a4mPI.increment)(),
        name: name,
        meta: classNamePrefix,
        classNamePrefix: classNamePrefix
    };
    var useStyles = function useStyles() {
        var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        var theme = (0, $6WDy5.default)() || defaultTheme;
        var stylesOptions = (0, $815Xb.default)({}, (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).useContext((0, $1krVc.StylesContext)), stylesOptions2);
        var instance = (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).useRef();
        var shouldUpdate = (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).useRef();
        $539aedb282032fc2$var$useSynchronousEffect(function() {
            var current = {
                name: name,
                state: {},
                stylesCreator: stylesCreator,
                stylesOptions: stylesOptions,
                theme: theme
            };
            $539aedb282032fc2$var$attach(current, props);
            shouldUpdate.current = false;
            instance.current = current;
            return function() {
                $539aedb282032fc2$var$detach(current);
            };
        }, [
            theme,
            stylesCreator
        ]);
        (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).useEffect(function() {
            if (shouldUpdate.current) $539aedb282032fc2$var$update(instance.current, props);
            shouldUpdate.current = true;
        });
        var classes = $539aedb282032fc2$var$getClasses(instance.current, props.classes, Component);
        // eslint-disable-next-line react-hooks/rules-of-hooks
        (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).useDebugValue(classes);
        return classes;
    };
    return useStyles;
}

});
parcelRegister("gyDGU", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c0de9c29217d4ae1$export$2e2bcd8739ae039; });

var $jPENd = parcelRequire("jPENd");
function $c0de9c29217d4ae1$export$2e2bcd8739ae039(source, excluded) {
    if (source == null) return {};
    var target = (0, $jPENd.default)(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}

});
parcelRegister("jPENd", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e7026c59a0fb8b4a$export$2e2bcd8739ae039; });
function $e7026c59a0fb8b4a$export$2e2bcd8739ae039(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}

});


parcelRegister("ipwm3", function(module, exports) {

$parcel$export(module.exports, "createRule", function () { return createRule; });
$parcel$export(module.exports, "toCssValue", function () { return toCssValue; });
$parcel$export(module.exports, "RuleList", function () { return RuleList; });
$parcel$export(module.exports, "create", function () { return createJss; });
$parcel$export(module.exports, "hasCSSTOMSupport", function () { return hasCSSTOMSupport; });
$parcel$export(module.exports, "getDynamicStyles", function () { return getDynamicStyles; });

var $1ksDm = parcelRequire("1ksDm");

var $aGThG = parcelRequire("aGThG");

var $1UzpR = parcelRequire("1UzpR");

var $hXbED = parcelRequire("hXbED");

var $82w9t = parcelRequire("82w9t");

var $bV0Px = parcelRequire("bV0Px");

var $1sb8G = parcelRequire("1sb8G");
var plainObjectConstrurctor = {}.constructor;
function cloneStyle(style) {
    if (style == null || typeof style !== "object") return style;
    if (Array.isArray(style)) return style.map(cloneStyle);
    if (style.constructor !== plainObjectConstrurctor) return style;
    var newStyle = {};
    for(var name in style)newStyle[name] = cloneStyle(style[name]);
    return newStyle;
}
/**
 * Create a rule instance.
 */ function createRule(name, decl, options) {
    if (name === void 0) name = "unnamed";
    var jss = options.jss;
    var declCopy = cloneStyle(decl);
    var rule = jss.plugins.onCreateRule(name, declCopy, options);
    if (rule) return rule; // It is an at-rule and it has no instance.
    if (name[0] === "@") (0, $1UzpR.default)(false, "[JSS] Unknown rule " + name);
    return null;
}
var join = function join(value, by) {
    var result = "";
    for(var i = 0; i < value.length; i++){
        // Remove !important from the value, it will be readded later.
        if (value[i] === "!important") break;
        if (result) result += by;
        result += value[i];
    }
    return result;
};
/**
 * Converts JSS array value to a CSS string.
 *
 * `margin: [['5px', '10px']]` > `margin: 5px 10px;`
 * `border: ['1px', '2px']` > `border: 1px, 2px;`
 * `margin: [['5px', '10px'], '!important']` > `margin: 5px 10px !important;`
 * `color: ['red', !important]` > `color: red !important;`
 */ var toCssValue = function toCssValue(value, ignoreImportant) {
    if (ignoreImportant === void 0) ignoreImportant = false;
    if (!Array.isArray(value)) return value;
    var cssValue = ""; // Support space separated values via `[['5px', '10px']]`.
    if (Array.isArray(value[0])) for(var i = 0; i < value.length; i++){
        if (value[i] === "!important") break;
        if (cssValue) cssValue += ", ";
        cssValue += join(value[i], " ");
    }
    else cssValue = join(value, ", "); // Add !important, because it was ignored.
    if (!ignoreImportant && value[value.length - 1] === "!important") cssValue += " !important";
    return cssValue;
};
function getWhitespaceSymbols(options) {
    if (options && options.format === false) return {
        linebreak: "",
        space: ""
    };
    return {
        linebreak: "\n",
        space: " "
    };
}
/**
 * Indent a string.
 * http://jsperf.com/array-join-vs-for
 */ function indentStr(str, indent) {
    var result = "";
    for(var index = 0; index < indent; index++)result += "  ";
    return result + str;
}
/**
 * Converts a Rule to CSS string.
 */ function toCss(selector, style, options) {
    if (options === void 0) options = {};
    var result = "";
    if (!style) return result;
    var _options = options, _options$indent = _options.indent, indent = _options$indent === void 0 ? 0 : _options$indent;
    var fallbacks = style.fallbacks;
    if (options.format === false) indent = -Infinity;
    var _getWhitespaceSymbols = getWhitespaceSymbols(options), linebreak = _getWhitespaceSymbols.linebreak, space = _getWhitespaceSymbols.space;
    if (selector) indent++; // Apply fallbacks first.
    if (fallbacks) {
        // Array syntax {fallbacks: [{prop: value}]}
        if (Array.isArray(fallbacks)) for(var index = 0; index < fallbacks.length; index++){
            var fallback = fallbacks[index];
            for(var prop in fallback){
                var value = fallback[prop];
                if (value != null) {
                    if (result) result += linebreak;
                    result += indentStr(prop + ":" + space + toCssValue(value) + ";", indent);
                }
            }
        }
        else // Object syntax {fallbacks: {prop: value}}
        for(var _prop in fallbacks){
            var _value = fallbacks[_prop];
            if (_value != null) {
                if (result) result += linebreak;
                result += indentStr(_prop + ":" + space + toCssValue(_value) + ";", indent);
            }
        }
    }
    for(var _prop2 in style){
        var _value2 = style[_prop2];
        if (_value2 != null && _prop2 !== "fallbacks") {
            if (result) result += linebreak;
            result += indentStr(_prop2 + ":" + space + toCssValue(_value2) + ";", indent);
        }
    } // Allow empty style in this case, because properties will be added dynamically.
    if (!result && !options.allowEmpty) return result; // When rule is being stringified before selector was defined.
    if (!selector) return result;
    indent--;
    if (result) result = "" + linebreak + result + linebreak;
    return indentStr("" + selector + space + "{" + result, indent) + indentStr("}", indent);
}
var escapeRegex = /([[\].#*$><+~=|^:(),"'`\s])/g;
var nativeEscape = typeof CSS !== "undefined" && CSS.escape;
var escape = function(str) {
    return nativeEscape ? nativeEscape(str) : str.replace(escapeRegex, "\\$1");
};
var BaseStyleRule = /*#__PURE__*/ function() {
    function BaseStyleRule(key, style, options) {
        this.type = "style";
        this.isProcessed = false;
        var sheet = options.sheet, Renderer = options.Renderer;
        this.key = key;
        this.options = options;
        this.style = style;
        if (sheet) this.renderer = sheet.renderer;
        else if (Renderer) this.renderer = new Renderer();
    }
    /**
   * Get or set a style property.
   */ var _proto = BaseStyleRule.prototype;
    _proto.prop = function prop(name, value, options) {
        // It's a getter.
        if (value === undefined) return this.style[name]; // Don't do anything if the value has not changed.
        var force = options ? options.force : false;
        if (!force && this.style[name] === value) return this;
        var newValue = value;
        if (!options || options.process !== false) newValue = this.options.jss.plugins.onChangeValue(value, name, this);
        var isEmpty = newValue == null || newValue === false;
        var isDefined = name in this.style; // Value is empty and wasn't defined before.
        if (isEmpty && !isDefined && !force) return this; // We are going to remove this value.
        var remove = isEmpty && isDefined;
        if (remove) delete this.style[name];
        else this.style[name] = newValue; // Renderable is defined if StyleSheet option `link` is true.
        if (this.renderable && this.renderer) {
            if (remove) this.renderer.removeProperty(this.renderable, name);
            else this.renderer.setProperty(this.renderable, name, newValue);
            return this;
        }
        var sheet = this.options.sheet;
        if (sheet && sheet.attached) (0, $1UzpR.default)(false, '[JSS] Rule is not linked. Missing sheet option "link: true".');
        return this;
    };
    return BaseStyleRule;
}();
var StyleRule = /*#__PURE__*/ function(_BaseStyleRule) {
    (0, $82w9t.default)(StyleRule, _BaseStyleRule);
    function StyleRule(key, style, options) {
        var _this;
        _this = _BaseStyleRule.call(this, key, style, options) || this;
        var selector = options.selector, scoped = options.scoped, sheet = options.sheet, generateId = options.generateId;
        if (selector) _this.selectorText = selector;
        else if (scoped !== false) {
            _this.id = generateId((0, $bV0Px.default)((0, $bV0Px.default)(_this)), sheet);
            _this.selectorText = "." + escape(_this.id);
        }
        return _this;
    }
    /**
   * Set selector string.
   * Attention: use this with caution. Most browsers didn't implement
   * selectorText setter, so this may result in rerendering of entire Style Sheet.
   */ var _proto2 = StyleRule.prototype;
    /**
   * Apply rule to an element inline.
   */ _proto2.applyTo = function applyTo(renderable) {
        var renderer = this.renderer;
        if (renderer) {
            var json = this.toJSON();
            for(var prop in json)renderer.setProperty(renderable, prop, json[prop]);
        }
        return this;
    } /**
   * Returns JSON representation of the rule.
   * Fallbacks are not supported.
   * Useful for inline styles.
   */ ;
    _proto2.toJSON = function toJSON() {
        var json = {};
        for(var prop in this.style){
            var value = this.style[prop];
            if (typeof value !== "object") json[prop] = value;
            else if (Array.isArray(value)) json[prop] = toCssValue(value);
        }
        return json;
    } /**
   * Generates a CSS string.
   */ ;
    _proto2.toString = function toString(options) {
        var sheet = this.options.sheet;
        var link = sheet ? sheet.options.link : false;
        var opts = link ? (0, $1ksDm.default)({}, options, {
            allowEmpty: true
        }) : options;
        return toCss(this.selectorText, this.style, opts);
    };
    (0, $hXbED.default)(StyleRule, [
        {
            key: "selector",
            set: function set(selector) {
                if (selector === this.selectorText) return;
                this.selectorText = selector;
                var renderer = this.renderer, renderable = this.renderable;
                if (!renderable || !renderer) return;
                var hasChanged = renderer.setSelector(renderable, selector); // If selector setter is not implemented, rerender the rule.
                if (!hasChanged) renderer.replaceRule(renderable, this);
            },
            get: function get() {
                return this.selectorText;
            }
        }
    ]);
    return StyleRule;
}(BaseStyleRule);
var pluginStyleRule = {
    onCreateRule: function onCreateRule(key, style, options) {
        if (key[0] === "@" || options.parent && options.parent.type === "keyframes") return null;
        return new StyleRule(key, style, options);
    }
};
var defaultToStringOptions = {
    indent: 1,
    children: true
};
var atRegExp = /@([\w-]+)/;
/**
 * Conditional rule for @media, @supports
 */ var ConditionalRule = /*#__PURE__*/ function() {
    function ConditionalRule(key, styles, options) {
        this.type = "conditional";
        this.isProcessed = false;
        this.key = key;
        var atMatch = key.match(atRegExp);
        this.at = atMatch ? atMatch[1] : "unknown"; // Key might contain a unique suffix in case the `name` passed by user was duplicate.
        this.query = options.name || "@" + this.at;
        this.options = options;
        this.rules = new RuleList((0, $1ksDm.default)({}, options, {
            parent: this
        }));
        for(var name in styles)this.rules.add(name, styles[name]);
        this.rules.process();
    }
    /**
   * Get a rule.
   */ var _proto = ConditionalRule.prototype;
    _proto.getRule = function getRule(name) {
        return this.rules.get(name);
    } /**
   * Get index of a rule.
   */ ;
    _proto.indexOf = function indexOf(rule) {
        return this.rules.indexOf(rule);
    } /**
   * Create and register rule, run plugins.
   */ ;
    _proto.addRule = function addRule(name, style, options) {
        var rule = this.rules.add(name, style, options);
        if (!rule) return null;
        this.options.jss.plugins.onProcessRule(rule);
        return rule;
    } /**
   * Generates a CSS string.
   */ ;
    _proto.toString = function toString(options) {
        if (options === void 0) options = defaultToStringOptions;
        var _getWhitespaceSymbols = getWhitespaceSymbols(options), linebreak = _getWhitespaceSymbols.linebreak;
        if (options.indent == null) options.indent = defaultToStringOptions.indent;
        if (options.children == null) options.children = defaultToStringOptions.children;
        if (options.children === false) return this.query + " {}";
        var children = this.rules.toString(options);
        return children ? this.query + " {" + linebreak + children + linebreak + "}" : "";
    };
    return ConditionalRule;
}();
var keyRegExp = /@media|@supports\s+/;
var pluginConditionalRule = {
    onCreateRule: function onCreateRule(key, styles, options) {
        return keyRegExp.test(key) ? new ConditionalRule(key, styles, options) : null;
    }
};
var defaultToStringOptions$1 = {
    indent: 1,
    children: true
};
var nameRegExp = /@keyframes\s+([\w-]+)/;
/**
 * Rule for @keyframes
 */ var KeyframesRule = /*#__PURE__*/ function() {
    function KeyframesRule(key, frames, options) {
        this.type = "keyframes";
        this.at = "@keyframes";
        this.isProcessed = false;
        var nameMatch = key.match(nameRegExp);
        if (nameMatch && nameMatch[1]) this.name = nameMatch[1];
        else {
            this.name = "noname";
            (0, $1UzpR.default)(false, "[JSS] Bad keyframes name " + key);
        }
        this.key = this.type + "-" + this.name;
        this.options = options;
        var scoped = options.scoped, sheet = options.sheet, generateId = options.generateId;
        this.id = scoped === false ? this.name : escape(generateId(this, sheet));
        this.rules = new RuleList((0, $1ksDm.default)({}, options, {
            parent: this
        }));
        for(var name in frames)this.rules.add(name, frames[name], (0, $1ksDm.default)({}, options, {
            parent: this
        }));
        this.rules.process();
    }
    /**
   * Generates a CSS string.
   */ var _proto = KeyframesRule.prototype;
    _proto.toString = function toString(options) {
        if (options === void 0) options = defaultToStringOptions$1;
        var _getWhitespaceSymbols = getWhitespaceSymbols(options), linebreak = _getWhitespaceSymbols.linebreak;
        if (options.indent == null) options.indent = defaultToStringOptions$1.indent;
        if (options.children == null) options.children = defaultToStringOptions$1.children;
        if (options.children === false) return this.at + " " + this.id + " {}";
        var children = this.rules.toString(options);
        if (children) children = "" + linebreak + children + linebreak;
        return this.at + " " + this.id + " {" + children + "}";
    };
    return KeyframesRule;
}();
var keyRegExp$1 = /@keyframes\s+/;
var refRegExp = /\$([\w-]+)/g;
var findReferencedKeyframe = function findReferencedKeyframe(val, keyframes) {
    if (typeof val === "string") return val.replace(refRegExp, function(match, name) {
        if (name in keyframes) return keyframes[name];
        (0, $1UzpR.default)(false, '[JSS] Referenced keyframes rule "' + name + '" is not defined.');
        return match;
    });
    return val;
};
/**
 * Replace the reference for a animation name.
 */ var replaceRef = function replaceRef(style, prop, keyframes) {
    var value = style[prop];
    var refKeyframe = findReferencedKeyframe(value, keyframes);
    if (refKeyframe !== value) style[prop] = refKeyframe;
};
var pluginKeyframesRule = {
    onCreateRule: function onCreateRule(key, frames, options) {
        return typeof key === "string" && keyRegExp$1.test(key) ? new KeyframesRule(key, frames, options) : null;
    },
    // Animation name ref replacer.
    onProcessStyle: function onProcessStyle(style, rule, sheet) {
        if (rule.type !== "style" || !sheet) return style;
        if ("animation-name" in style) replaceRef(style, "animation-name", sheet.keyframes);
        if ("animation" in style) replaceRef(style, "animation", sheet.keyframes);
        return style;
    },
    onChangeValue: function onChangeValue(val, prop, rule) {
        var sheet = rule.options.sheet;
        if (!sheet) return val;
        switch(prop){
            case "animation":
                return findReferencedKeyframe(val, sheet.keyframes);
            case "animation-name":
                return findReferencedKeyframe(val, sheet.keyframes);
            default:
                return val;
        }
    }
};
var KeyframeRule = /*#__PURE__*/ function(_BaseStyleRule) {
    (0, $82w9t.default)(KeyframeRule, _BaseStyleRule);
    function KeyframeRule() {
        return _BaseStyleRule.apply(this, arguments) || this;
    }
    var _proto = KeyframeRule.prototype;
    /**
   * Generates a CSS string.
   */ _proto.toString = function toString(options) {
        var sheet = this.options.sheet;
        var link = sheet ? sheet.options.link : false;
        var opts = link ? (0, $1ksDm.default)({}, options, {
            allowEmpty: true
        }) : options;
        return toCss(this.key, this.style, opts);
    };
    return KeyframeRule;
}(BaseStyleRule);
var pluginKeyframeRule = {
    onCreateRule: function onCreateRule(key, style, options) {
        if (options.parent && options.parent.type === "keyframes") return new KeyframeRule(key, style, options);
        return null;
    }
};
var FontFaceRule = /*#__PURE__*/ function() {
    function FontFaceRule(key, style, options) {
        this.type = "font-face";
        this.at = "@font-face";
        this.isProcessed = false;
        this.key = key;
        this.style = style;
        this.options = options;
    }
    /**
   * Generates a CSS string.
   */ var _proto = FontFaceRule.prototype;
    _proto.toString = function toString(options) {
        var _getWhitespaceSymbols = getWhitespaceSymbols(options), linebreak = _getWhitespaceSymbols.linebreak;
        if (Array.isArray(this.style)) {
            var str = "";
            for(var index = 0; index < this.style.length; index++){
                str += toCss(this.at, this.style[index]);
                if (this.style[index + 1]) str += linebreak;
            }
            return str;
        }
        return toCss(this.at, this.style, options);
    };
    return FontFaceRule;
}();
var keyRegExp$2 = /@font-face/;
var pluginFontFaceRule = {
    onCreateRule: function onCreateRule(key, style, options) {
        return keyRegExp$2.test(key) ? new FontFaceRule(key, style, options) : null;
    }
};
var ViewportRule = /*#__PURE__*/ function() {
    function ViewportRule(key, style, options) {
        this.type = "viewport";
        this.at = "@viewport";
        this.isProcessed = false;
        this.key = key;
        this.style = style;
        this.options = options;
    }
    /**
   * Generates a CSS string.
   */ var _proto = ViewportRule.prototype;
    _proto.toString = function toString(options) {
        return toCss(this.key, this.style, options);
    };
    return ViewportRule;
}();
var pluginViewportRule = {
    onCreateRule: function onCreateRule(key, style, options) {
        return key === "@viewport" || key === "@-ms-viewport" ? new ViewportRule(key, style, options) : null;
    }
};
var SimpleRule = /*#__PURE__*/ function() {
    function SimpleRule(key, value, options) {
        this.type = "simple";
        this.isProcessed = false;
        this.key = key;
        this.value = value;
        this.options = options;
    }
    /**
   * Generates a CSS string.
   */ // eslint-disable-next-line no-unused-vars
    var _proto = SimpleRule.prototype;
    _proto.toString = function toString(options) {
        if (Array.isArray(this.value)) {
            var str = "";
            for(var index = 0; index < this.value.length; index++){
                str += this.key + " " + this.value[index] + ";";
                if (this.value[index + 1]) str += "\n";
            }
            return str;
        }
        return this.key + " " + this.value + ";";
    };
    return SimpleRule;
}();
var keysMap = {
    "@charset": true,
    "@import": true,
    "@namespace": true
};
var pluginSimpleRule = {
    onCreateRule: function onCreateRule(key, value, options) {
        return key in keysMap ? new SimpleRule(key, value, options) : null;
    }
};
var plugins = [
    pluginStyleRule,
    pluginConditionalRule,
    pluginKeyframesRule,
    pluginKeyframeRule,
    pluginFontFaceRule,
    pluginViewportRule,
    pluginSimpleRule
];
var defaultUpdateOptions = {
    process: true
};
var forceUpdateOptions = {
    force: true,
    process: true
};
var RuleList = /*#__PURE__*/ function() {
    // Rules registry for access by .get() method.
    // It contains the same rule registered by name and by selector.
    // Original styles object.
    // Used to ensure correct rules order.
    function RuleList(options) {
        this.map = {};
        this.raw = {};
        this.index = [];
        this.counter = 0;
        this.options = options;
        this.classes = options.classes;
        this.keyframes = options.keyframes;
    }
    /**
   * Create and register rule.
   *
   * Will not render after Style Sheet was rendered the first time.
   */ var _proto = RuleList.prototype;
    _proto.add = function add(name, decl, ruleOptions) {
        var _this$options = this.options, parent = _this$options.parent, sheet = _this$options.sheet, jss = _this$options.jss, Renderer = _this$options.Renderer, generateId = _this$options.generateId, scoped = _this$options.scoped;
        var options = (0, $1ksDm.default)({
            classes: this.classes,
            parent: parent,
            sheet: sheet,
            jss: jss,
            Renderer: Renderer,
            generateId: generateId,
            scoped: scoped,
            name: name,
            keyframes: this.keyframes,
            selector: undefined
        }, ruleOptions); // When user uses .createStyleSheet(), duplicate names are not possible, but
        // `sheet.addRule()` opens the door for any duplicate rule name. When this happens
        // we need to make the key unique within this RuleList instance scope.
        var key = name;
        if (name in this.raw) key = name + "-d" + this.counter++;
         // We need to save the original decl before creating the rule
        // because cache plugin needs to use it as a key to return a cached rule.
        this.raw[key] = decl;
        if (key in this.classes) // E.g. rules inside of @media container
        options.selector = "." + escape(this.classes[key]);
        var rule = createRule(key, decl, options);
        if (!rule) return null;
        this.register(rule);
        var index = options.index === undefined ? this.index.length : options.index;
        this.index.splice(index, 0, rule);
        return rule;
    } /**
   * Get a rule.
   */ ;
    _proto.get = function get(name) {
        return this.map[name];
    } /**
   * Delete a rule.
   */ ;
    _proto.remove = function remove(rule) {
        this.unregister(rule);
        delete this.raw[rule.key];
        this.index.splice(this.index.indexOf(rule), 1);
    } /**
   * Get index of a rule.
   */ ;
    _proto.indexOf = function indexOf(rule) {
        return this.index.indexOf(rule);
    } /**
   * Run `onProcessRule()` plugins on every rule.
   */ ;
    _proto.process = function process() {
        var plugins = this.options.jss.plugins; // We need to clone array because if we modify the index somewhere else during a loop
        // we end up with very hard-to-track-down side effects.
        this.index.slice(0).forEach(plugins.onProcessRule, plugins);
    } /**
   * Register a rule in `.map`, `.classes` and `.keyframes` maps.
   */ ;
    _proto.register = function register(rule) {
        this.map[rule.key] = rule;
        if (rule instanceof StyleRule) {
            this.map[rule.selector] = rule;
            if (rule.id) this.classes[rule.key] = rule.id;
        } else if (rule instanceof KeyframesRule && this.keyframes) this.keyframes[rule.name] = rule.id;
    } /**
   * Unregister a rule.
   */ ;
    _proto.unregister = function unregister(rule) {
        delete this.map[rule.key];
        if (rule instanceof StyleRule) {
            delete this.map[rule.selector];
            delete this.classes[rule.key];
        } else if (rule instanceof KeyframesRule) delete this.keyframes[rule.name];
    } /**
   * Update the function values with a new data.
   */ ;
    _proto.update = function update() {
        var name;
        var data;
        var options;
        if (typeof (arguments.length <= 0 ? undefined : arguments[0]) === "string") {
            name = arguments.length <= 0 ? undefined : arguments[0];
            data = arguments.length <= 1 ? undefined : arguments[1];
            options = arguments.length <= 2 ? undefined : arguments[2];
        } else {
            data = arguments.length <= 0 ? undefined : arguments[0];
            options = arguments.length <= 1 ? undefined : arguments[1];
            name = null;
        }
        if (name) this.updateOne(this.map[name], data, options);
        else for(var index = 0; index < this.index.length; index++)this.updateOne(this.index[index], data, options);
    } /**
   * Execute plugins, update rule props.
   */ ;
    _proto.updateOne = function updateOne(rule, data, options) {
        if (options === void 0) options = defaultUpdateOptions;
        var _this$options2 = this.options, plugins = _this$options2.jss.plugins, sheet = _this$options2.sheet; // It is a rules container like for e.g. ConditionalRule.
        if (rule.rules instanceof RuleList) {
            rule.rules.update(data, options);
            return;
        }
        var style = rule.style;
        plugins.onUpdate(data, rule, sheet, options); // We rely on a new `style` ref in case it was mutated during onUpdate hook.
        if (options.process && style && style !== rule.style) {
            // We need to run the plugins in case new `style` relies on syntax plugins.
            plugins.onProcessStyle(rule.style, rule, sheet); // Update and add props.
            for(var prop in rule.style){
                var nextValue = rule.style[prop];
                var prevValue = style[prop]; // We need to use `force: true` because `rule.style` has been updated during onUpdate hook, so `rule.prop()` will not update the CSSOM rule.
                // We do this comparison to avoid unneeded `rule.prop()` calls, since we have the old `style` object here.
                if (nextValue !== prevValue) rule.prop(prop, nextValue, forceUpdateOptions);
            } // Remove props.
            for(var _prop in style){
                var _nextValue = rule.style[_prop];
                var _prevValue = style[_prop]; // We need to use `force: true` because `rule.style` has been updated during onUpdate hook, so `rule.prop()` will not update the CSSOM rule.
                // We do this comparison to avoid unneeded `rule.prop()` calls, since we have the old `style` object here.
                if (_nextValue == null && _nextValue !== _prevValue) rule.prop(_prop, null, forceUpdateOptions);
            }
        }
    } /**
   * Convert rules to a CSS string.
   */ ;
    _proto.toString = function toString(options) {
        var str = "";
        var sheet = this.options.sheet;
        var link = sheet ? sheet.options.link : false;
        var _getWhitespaceSymbols = getWhitespaceSymbols(options), linebreak = _getWhitespaceSymbols.linebreak;
        for(var index = 0; index < this.index.length; index++){
            var rule = this.index[index];
            var css = rule.toString(options); // No need to render an empty rule.
            if (!css && !link) continue;
            if (str) str += linebreak;
            str += css;
        }
        return str;
    };
    return RuleList;
}();
var StyleSheet = /*#__PURE__*/ function() {
    function StyleSheet(styles, options) {
        this.attached = false;
        this.deployed = false;
        this.classes = {};
        this.keyframes = {};
        this.options = (0, $1ksDm.default)({}, options, {
            sheet: this,
            parent: this,
            classes: this.classes,
            keyframes: this.keyframes
        });
        if (options.Renderer) this.renderer = new options.Renderer(this);
        this.rules = new RuleList(this.options);
        for(var name in styles)this.rules.add(name, styles[name]);
        this.rules.process();
    }
    /**
   * Attach renderable to the render tree.
   */ var _proto = StyleSheet.prototype;
    _proto.attach = function attach() {
        if (this.attached) return this;
        if (this.renderer) this.renderer.attach();
        this.attached = true; // Order is important, because we can't use insertRule API if style element is not attached.
        if (!this.deployed) this.deploy();
        return this;
    } /**
   * Remove renderable from render tree.
   */ ;
    _proto.detach = function detach() {
        if (!this.attached) return this;
        if (this.renderer) this.renderer.detach();
        this.attached = false;
        return this;
    } /**
   * Add a rule to the current stylesheet.
   * Will insert a rule also after the stylesheet has been rendered first time.
   */ ;
    _proto.addRule = function addRule(name, decl, options) {
        var queue = this.queue; // Plugins can create rules.
        // In order to preserve the right order, we need to queue all `.addRule` calls,
        // which happen after the first `rules.add()` call.
        if (this.attached && !queue) this.queue = [];
        var rule = this.rules.add(name, decl, options);
        if (!rule) return null;
        this.options.jss.plugins.onProcessRule(rule);
        if (this.attached) {
            if (!this.deployed) return rule; // Don't insert rule directly if there is no stringified version yet.
            // It will be inserted all together when .attach is called.
            if (queue) queue.push(rule);
            else {
                this.insertRule(rule);
                if (this.queue) {
                    this.queue.forEach(this.insertRule, this);
                    this.queue = undefined;
                }
            }
            return rule;
        } // We can't add rules to a detached style node.
        // We will redeploy the sheet once user will attach it.
        this.deployed = false;
        return rule;
    } /**
   * Insert rule into the StyleSheet
   */ ;
    _proto.insertRule = function insertRule(rule) {
        if (this.renderer) this.renderer.insertRule(rule);
    } /**
   * Create and add rules.
   * Will render also after Style Sheet was rendered the first time.
   */ ;
    _proto.addRules = function addRules(styles, options) {
        var added = [];
        for(var name in styles){
            var rule = this.addRule(name, styles[name], options);
            if (rule) added.push(rule);
        }
        return added;
    } /**
   * Get a rule by name.
   */ ;
    _proto.getRule = function getRule(name) {
        return this.rules.get(name);
    } /**
   * Delete a rule by name.
   * Returns `true`: if rule has been deleted from the DOM.
   */ ;
    _proto.deleteRule = function deleteRule(name) {
        var rule = typeof name === "object" ? name : this.rules.get(name);
        if (!rule || // Style sheet was created without link: true and attached, in this case we
        // won't be able to remove the CSS rule from the DOM.
        this.attached && !rule.renderable) return false;
        this.rules.remove(rule);
        if (this.attached && rule.renderable && this.renderer) return this.renderer.deleteRule(rule.renderable);
        return true;
    } /**
   * Get index of a rule.
   */ ;
    _proto.indexOf = function indexOf(rule) {
        return this.rules.indexOf(rule);
    } /**
   * Deploy pure CSS string to a renderable.
   */ ;
    _proto.deploy = function deploy() {
        if (this.renderer) this.renderer.deploy();
        this.deployed = true;
        return this;
    } /**
   * Update the function values with a new data.
   */ ;
    _proto.update = function update() {
        var _this$rules;
        (_this$rules = this.rules).update.apply(_this$rules, arguments);
        return this;
    } /**
   * Updates a single rule.
   */ ;
    _proto.updateOne = function updateOne(rule, data, options) {
        this.rules.updateOne(rule, data, options);
        return this;
    } /**
   * Convert rules to a CSS string.
   */ ;
    _proto.toString = function toString(options) {
        return this.rules.toString(options);
    };
    return StyleSheet;
}();
var PluginsRegistry = /*#__PURE__*/ function() {
    function PluginsRegistry() {
        this.plugins = {
            internal: [],
            external: []
        };
        this.registry = {};
    }
    var _proto = PluginsRegistry.prototype;
    /**
   * Call `onCreateRule` hooks and return an object if returned by a hook.
   */ _proto.onCreateRule = function onCreateRule(name, decl, options) {
        for(var i = 0; i < this.registry.onCreateRule.length; i++){
            var rule = this.registry.onCreateRule[i](name, decl, options);
            if (rule) return rule;
        }
        return null;
    } /**
   * Call `onProcessRule` hooks.
   */ ;
    _proto.onProcessRule = function onProcessRule(rule) {
        if (rule.isProcessed) return;
        var sheet = rule.options.sheet;
        for(var i = 0; i < this.registry.onProcessRule.length; i++)this.registry.onProcessRule[i](rule, sheet);
        if (rule.style) this.onProcessStyle(rule.style, rule, sheet);
        rule.isProcessed = true;
    } /**
   * Call `onProcessStyle` hooks.
   */ ;
    _proto.onProcessStyle = function onProcessStyle(style, rule, sheet) {
        for(var i = 0; i < this.registry.onProcessStyle.length; i++)rule.style = this.registry.onProcessStyle[i](rule.style, rule, sheet);
    } /**
   * Call `onProcessSheet` hooks.
   */ ;
    _proto.onProcessSheet = function onProcessSheet(sheet) {
        for(var i = 0; i < this.registry.onProcessSheet.length; i++)this.registry.onProcessSheet[i](sheet);
    } /**
   * Call `onUpdate` hooks.
   */ ;
    _proto.onUpdate = function onUpdate(data, rule, sheet, options) {
        for(var i = 0; i < this.registry.onUpdate.length; i++)this.registry.onUpdate[i](data, rule, sheet, options);
    } /**
   * Call `onChangeValue` hooks.
   */ ;
    _proto.onChangeValue = function onChangeValue(value, prop, rule) {
        var processedValue = value;
        for(var i = 0; i < this.registry.onChangeValue.length; i++)processedValue = this.registry.onChangeValue[i](processedValue, prop, rule);
        return processedValue;
    } /**
   * Register a plugin.
   */ ;
    _proto.use = function use(newPlugin, options) {
        if (options === void 0) options = {
            queue: "external"
        };
        var plugins = this.plugins[options.queue]; // Avoids applying same plugin twice, at least based on ref.
        if (plugins.indexOf(newPlugin) !== -1) return;
        plugins.push(newPlugin);
        this.registry = [].concat(this.plugins.external, this.plugins.internal).reduce(function(registry, plugin) {
            for(var name in plugin)if (name in registry) registry[name].push(plugin[name]);
            else (0, $1UzpR.default)(false, '[JSS] Unknown hook "' + name + '".');
            return registry;
        }, {
            onCreateRule: [],
            onProcessRule: [],
            onProcessStyle: [],
            onProcessSheet: [],
            onChangeValue: [],
            onUpdate: []
        });
    };
    return PluginsRegistry;
}();
/**
 * Sheets registry to access all instances in one place.
 */ var SheetsRegistry = /*#__PURE__*/ function() {
    function SheetsRegistry() {
        this.registry = [];
    }
    var _proto = SheetsRegistry.prototype;
    /**
   * Register a Style Sheet.
   */ _proto.add = function add(sheet) {
        var registry = this.registry;
        var index = sheet.options.index;
        if (registry.indexOf(sheet) !== -1) return;
        if (registry.length === 0 || index >= this.index) {
            registry.push(sheet);
            return;
        } // Find a position.
        for(var i = 0; i < registry.length; i++)if (registry[i].options.index > index) {
            registry.splice(i, 0, sheet);
            return;
        }
    } /**
   * Reset the registry.
   */ ;
    _proto.reset = function reset() {
        this.registry = [];
    } /**
   * Remove a Style Sheet.
   */ ;
    _proto.remove = function remove(sheet) {
        var index = this.registry.indexOf(sheet);
        this.registry.splice(index, 1);
    } /**
   * Convert all attached sheets to a CSS string.
   */ ;
    _proto.toString = function toString(_temp) {
        var _ref = _temp === void 0 ? {} : _temp, attached = _ref.attached, options = (0, $1sb8G.default)(_ref, [
            "attached"
        ]);
        var _getWhitespaceSymbols = getWhitespaceSymbols(options), linebreak = _getWhitespaceSymbols.linebreak;
        var css = "";
        for(var i = 0; i < this.registry.length; i++){
            var sheet = this.registry[i];
            if (attached != null && sheet.attached !== attached) continue;
            if (css) css += linebreak;
            css += sheet.toString(options);
        }
        return css;
    };
    (0, $hXbED.default)(SheetsRegistry, [
        {
            key: "index",
            /**
     * Current highest index number.
     */ get: function get() {
                return this.registry.length === 0 ? 0 : this.registry[this.registry.length - 1].options.index;
            }
        }
    ]);
    return SheetsRegistry;
}();
/**
 * This is a global sheets registry. Only DomRenderer will add sheets to it.
 * On the server one should use an own SheetsRegistry instance and add the
 * sheets to it, because you need to make sure to create a new registry for
 * each request in order to not leak sheets across requests.
 */ var sheets = new SheetsRegistry();
/* eslint-disable */ /**
 * Now that `globalThis` is available on most platforms
 * (https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/globalThis#browser_compatibility)
 * we check for `globalThis` first. `globalThis` is necessary for jss
 * to run in Agoric's secure version of JavaScript (SES). Under SES,
 * `globalThis` exists, but `window`, `self`, and `Function('return
 * this')()` are all undefined for security reasons.
 *
 * https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
 */ var globalThis$1 = typeof globalThis !== "undefined" ? globalThis : typeof window !== "undefined" && window.Math === Math ? window : typeof self !== "undefined" && self.Math === Math ? self : Function("return this")();
var ns = "2f1acc6c3a606b082e5eef5e54414ffb";
if (globalThis$1[ns] == null) globalThis$1[ns] = 0; // Bundle may contain multiple JSS versions at the same time. In order to identify
// the current version with just one short number and use it for classes generation
// we use a counter. Also it is more accurate, because user can manually reevaluate
// the module.
var moduleId = globalThis$1[ns]++;
var maxRules = 1e10;
/**
 * Returns a function which generates unique class names based on counters.
 * When new generator function is created, rule counter is reseted.
 * We need to reset the rule counter for SSR for each request.
 */ var createGenerateId = function createGenerateId(options) {
    if (options === void 0) options = {};
    var ruleCounter = 0;
    var generateId = function generateId(rule, sheet) {
        ruleCounter += 1;
        if (ruleCounter > maxRules) (0, $1UzpR.default)(false, "[JSS] You might have a memory leak. Rule counter is at " + ruleCounter + ".");
        var jssId = "";
        var prefix = "";
        if (sheet) {
            if (sheet.options.classNamePrefix) prefix = sheet.options.classNamePrefix;
            if (sheet.options.jss.id != null) jssId = String(sheet.options.jss.id);
        }
        if (options.minify) // Using "c" because a number can't be the first char in a class name.
        return "" + (prefix || "c") + moduleId + jssId + ruleCounter;
        return prefix + rule.key + "-" + moduleId + (jssId ? "-" + jssId : "") + "-" + ruleCounter;
    };
    return generateId;
};
/**
 * Cache the value from the first time a function is called.
 */ var memoize = function memoize(fn) {
    var value;
    return function() {
        if (!value) value = fn();
        return value;
    };
};
/**
 * Get a style property value.
 */ var getPropertyValue = function getPropertyValue(cssRule, prop) {
    try {
        // Support CSSTOM.
        if (cssRule.attributeStyleMap) return cssRule.attributeStyleMap.get(prop);
        return cssRule.style.getPropertyValue(prop);
    } catch (err) {
        // IE may throw if property is unknown.
        return "";
    }
};
/**
 * Set a style property.
 */ var setProperty = function setProperty(cssRule, prop, value) {
    try {
        var cssValue = value;
        if (Array.isArray(value)) {
            cssValue = toCssValue(value, true);
            if (value[value.length - 1] === "!important") {
                cssRule.style.setProperty(prop, cssValue, "important");
                return true;
            }
        } // Support CSSTOM.
        if (cssRule.attributeStyleMap) cssRule.attributeStyleMap.set(prop, cssValue);
        else cssRule.style.setProperty(prop, cssValue);
    } catch (err) {
        // IE may throw if property is unknown.
        return false;
    }
    return true;
};
/**
 * Remove a style property.
 */ var removeProperty = function removeProperty(cssRule, prop) {
    try {
        // Support CSSTOM.
        if (cssRule.attributeStyleMap) cssRule.attributeStyleMap.delete(prop);
        else cssRule.style.removeProperty(prop);
    } catch (err) {
        (0, $1UzpR.default)(false, '[JSS] DOMException "' + err.message + '" was thrown. Tried to remove property "' + prop + '".');
    }
};
/**
 * Set the selector.
 */ var setSelector = function setSelector(cssRule, selectorText) {
    cssRule.selectorText = selectorText; // Return false if setter was not successful.
    // Currently works in chrome only.
    return cssRule.selectorText === selectorText;
};
/**
 * Gets the `head` element upon the first call and caches it.
 * We assume it can't be null.
 */ var getHead = memoize(function() {
    return document.querySelector("head");
});
/**
 * Find attached sheet with an index higher than the passed one.
 */ function findHigherSheet(registry, options) {
    for(var i = 0; i < registry.length; i++){
        var sheet = registry[i];
        if (sheet.attached && sheet.options.index > options.index && sheet.options.insertionPoint === options.insertionPoint) return sheet;
    }
    return null;
}
/**
 * Find attached sheet with the highest index.
 */ function findHighestSheet(registry, options) {
    for(var i = registry.length - 1; i >= 0; i--){
        var sheet = registry[i];
        if (sheet.attached && sheet.options.insertionPoint === options.insertionPoint) return sheet;
    }
    return null;
}
/**
 * Find a comment with "jss" inside.
 */ function findCommentNode(text) {
    var head = getHead();
    for(var i = 0; i < head.childNodes.length; i++){
        var node = head.childNodes[i];
        if (node.nodeType === 8 && node.nodeValue.trim() === text) return node;
    }
    return null;
}
/**
 * Find a node before which we can insert the sheet.
 */ function findPrevNode(options) {
    var registry = sheets.registry;
    if (registry.length > 0) {
        // Try to insert before the next higher sheet.
        var sheet = findHigherSheet(registry, options);
        if (sheet && sheet.renderer) return {
            parent: sheet.renderer.element.parentNode,
            node: sheet.renderer.element
        };
         // Otherwise insert after the last attached.
        sheet = findHighestSheet(registry, options);
        if (sheet && sheet.renderer) return {
            parent: sheet.renderer.element.parentNode,
            node: sheet.renderer.element.nextSibling
        };
    } // Try to find a comment placeholder if registry is empty.
    var insertionPoint = options.insertionPoint;
    if (insertionPoint && typeof insertionPoint === "string") {
        var comment = findCommentNode(insertionPoint);
        if (comment) return {
            parent: comment.parentNode,
            node: comment.nextSibling
        };
         // If user specifies an insertion point and it can't be found in the document -
        // bad specificity issues may appear.
        (0, $1UzpR.default)(false, '[JSS] Insertion point "' + insertionPoint + '" not found.');
    }
    return false;
}
/**
 * Insert style element into the DOM.
 */ function insertStyle(style, options) {
    var insertionPoint = options.insertionPoint;
    var nextNode = findPrevNode(options);
    if (nextNode !== false && nextNode.parent) {
        nextNode.parent.insertBefore(style, nextNode.node);
        return;
    } // Works with iframes and any node types.
    if (insertionPoint && typeof insertionPoint.nodeType === "number") {
        var insertionPointElement = insertionPoint;
        var parentNode = insertionPointElement.parentNode;
        if (parentNode) parentNode.insertBefore(style, insertionPointElement.nextSibling);
        else (0, $1UzpR.default)(false, "[JSS] Insertion point is not in the DOM.");
        return;
    }
    getHead().appendChild(style);
}
/**
 * Read jss nonce setting from the page if the user has set it.
 */ var getNonce = memoize(function() {
    var node = document.querySelector('meta[property="csp-nonce"]');
    return node ? node.getAttribute("content") : null;
});
var _insertRule = function insertRule(container, rule, index) {
    try {
        if ("insertRule" in container) container.insertRule(rule, index);
        else if ("appendRule" in container) container.appendRule(rule);
    } catch (err) {
        (0, $1UzpR.default)(false, "[JSS] " + err.message);
        return false;
    }
    return container.cssRules[index];
};
var getValidRuleInsertionIndex = function getValidRuleInsertionIndex(container, index) {
    var maxIndex = container.cssRules.length; // In case previous insertion fails, passed index might be wrong
    if (index === undefined || index > maxIndex) // eslint-disable-next-line no-param-reassign
    return maxIndex;
    return index;
};
var createStyle = function createStyle() {
    var el = document.createElement("style"); // Without it, IE will have a broken source order specificity if we
    // insert rules after we insert the style tag.
    // It seems to kick-off the source order specificity algorithm.
    el.textContent = "\n";
    return el;
};
var DomRenderer = /*#__PURE__*/ function() {
    // Will be empty if link: true option is not set, because
    // it is only for use together with insertRule API.
    function DomRenderer(sheet) {
        this.getPropertyValue = getPropertyValue;
        this.setProperty = setProperty;
        this.removeProperty = removeProperty;
        this.setSelector = setSelector;
        this.hasInsertedRules = false;
        this.cssRules = [];
        // There is no sheet when the renderer is used from a standalone StyleRule.
        if (sheet) sheets.add(sheet);
        this.sheet = sheet;
        var _ref = this.sheet ? this.sheet.options : {}, media = _ref.media, meta = _ref.meta, element = _ref.element;
        this.element = element || createStyle();
        this.element.setAttribute("data-jss", "");
        if (media) this.element.setAttribute("media", media);
        if (meta) this.element.setAttribute("data-meta", meta);
        var nonce = getNonce();
        if (nonce) this.element.setAttribute("nonce", nonce);
    }
    /**
   * Insert style element into render tree.
   */ var _proto = DomRenderer.prototype;
    _proto.attach = function attach() {
        // In the case the element node is external and it is already in the DOM.
        if (this.element.parentNode || !this.sheet) return;
        insertStyle(this.element, this.sheet.options); // When rules are inserted using `insertRule` API, after `sheet.detach().attach()`
        // most browsers create a new CSSStyleSheet, except of all IEs.
        var deployed = Boolean(this.sheet && this.sheet.deployed);
        if (this.hasInsertedRules && deployed) {
            this.hasInsertedRules = false;
            this.deploy();
        }
    } /**
   * Remove style element from render tree.
   */ ;
    _proto.detach = function detach() {
        if (!this.sheet) return;
        var parentNode = this.element.parentNode;
        if (parentNode) parentNode.removeChild(this.element); // In the most browsers, rules inserted using insertRule() API will be lost when style element is removed.
        // Though IE will keep them and we need a consistent behavior.
        if (this.sheet.options.link) {
            this.cssRules = [];
            this.element.textContent = "\n";
        }
    } /**
   * Inject CSS string into element.
   */ ;
    _proto.deploy = function deploy() {
        var sheet = this.sheet;
        if (!sheet) return;
        if (sheet.options.link) {
            this.insertRules(sheet.rules);
            return;
        }
        this.element.textContent = "\n" + sheet.toString() + "\n";
    } /**
   * Insert RuleList into an element.
   */ ;
    _proto.insertRules = function insertRules(rules, nativeParent) {
        for(var i = 0; i < rules.index.length; i++)this.insertRule(rules.index[i], i, nativeParent);
    } /**
   * Insert a rule into element.
   */ ;
    _proto.insertRule = function insertRule(rule, index, nativeParent) {
        if (nativeParent === void 0) nativeParent = this.element.sheet;
        if (rule.rules) {
            var parent = rule;
            var latestNativeParent = nativeParent;
            if (rule.type === "conditional" || rule.type === "keyframes") {
                var _insertionIndex = getValidRuleInsertionIndex(nativeParent, index); // We need to render the container without children first.
                latestNativeParent = _insertRule(nativeParent, parent.toString({
                    children: false
                }), _insertionIndex);
                if (latestNativeParent === false) return false;
                this.refCssRule(rule, _insertionIndex, latestNativeParent);
            }
            this.insertRules(parent.rules, latestNativeParent);
            return latestNativeParent;
        }
        var ruleStr = rule.toString();
        if (!ruleStr) return false;
        var insertionIndex = getValidRuleInsertionIndex(nativeParent, index);
        var nativeRule = _insertRule(nativeParent, ruleStr, insertionIndex);
        if (nativeRule === false) return false;
        this.hasInsertedRules = true;
        this.refCssRule(rule, insertionIndex, nativeRule);
        return nativeRule;
    };
    _proto.refCssRule = function refCssRule(rule, index, cssRule) {
        rule.renderable = cssRule; // We only want to reference the top level rules, deleteRule API doesn't support removing nested rules
        // like rules inside media queries or keyframes
        if (rule.options.parent instanceof StyleSheet) this.cssRules[index] = cssRule;
    } /**
   * Delete a rule.
   */ ;
    _proto.deleteRule = function deleteRule(cssRule) {
        var sheet = this.element.sheet;
        var index = this.indexOf(cssRule);
        if (index === -1) return false;
        sheet.deleteRule(index);
        this.cssRules.splice(index, 1);
        return true;
    } /**
   * Get index of a CSS Rule.
   */ ;
    _proto.indexOf = function indexOf(cssRule) {
        return this.cssRules.indexOf(cssRule);
    } /**
   * Generate a new CSS rule and replace the existing one.
   *
   * Only used for some old browsers because they can't set a selector.
   */ ;
    _proto.replaceRule = function replaceRule(cssRule, rule) {
        var index = this.indexOf(cssRule);
        if (index === -1) return false;
        this.element.sheet.deleteRule(index);
        this.cssRules.splice(index, 1);
        return this.insertRule(rule, index);
    } /**
   * Get all rules elements.
   */ ;
    _proto.getRules = function getRules() {
        return this.element.sheet.cssRules;
    };
    return DomRenderer;
}();
var instanceCounter = 0;
var Jss = /*#__PURE__*/ function() {
    function Jss(options) {
        this.id = instanceCounter++;
        this.version = "10.8.2";
        this.plugins = new PluginsRegistry();
        this.options = {
            id: {
                minify: false
            },
            createGenerateId: createGenerateId,
            Renderer: (0, $aGThG.default) ? DomRenderer : null,
            plugins: []
        };
        this.generateId = createGenerateId({
            minify: false
        });
        for(var i = 0; i < plugins.length; i++)this.plugins.use(plugins[i], {
            queue: "internal"
        });
        this.setup(options);
    }
    /**
   * Prepares various options, applies plugins.
   * Should not be used twice on the same instance, because there is no plugins
   * deduplication logic.
   */ var _proto = Jss.prototype;
    _proto.setup = function setup(options) {
        if (options === void 0) options = {};
        if (options.createGenerateId) this.options.createGenerateId = options.createGenerateId;
        if (options.id) this.options.id = (0, $1ksDm.default)({}, this.options.id, options.id);
        if (options.createGenerateId || options.id) this.generateId = this.options.createGenerateId(this.options.id);
        if (options.insertionPoint != null) this.options.insertionPoint = options.insertionPoint;
        if ("Renderer" in options) this.options.Renderer = options.Renderer;
         // eslint-disable-next-line prefer-spread
        if (options.plugins) this.use.apply(this, options.plugins);
        return this;
    } /**
   * Create a Style Sheet.
   */ ;
    _proto.createStyleSheet = function createStyleSheet(styles, options) {
        if (options === void 0) options = {};
        var _options = options, index = _options.index;
        if (typeof index !== "number") index = sheets.index === 0 ? 0 : sheets.index + 1;
        var sheet = new StyleSheet(styles, (0, $1ksDm.default)({}, options, {
            jss: this,
            generateId: options.generateId || this.generateId,
            insertionPoint: this.options.insertionPoint,
            Renderer: this.options.Renderer,
            index: index
        }));
        this.plugins.onProcessSheet(sheet);
        return sheet;
    } /**
   * Detach the Style Sheet and remove it from the registry.
   */ ;
    _proto.removeStyleSheet = function removeStyleSheet(sheet) {
        sheet.detach();
        sheets.remove(sheet);
        return this;
    } /**
   * Create a rule without a Style Sheet.
   * [Deprecated] will be removed in the next major version.
   */ ;
    _proto.createRule = function createRule$1(name, style, options) {
        if (style === void 0) style = {};
        if (options === void 0) options = {};
        // Enable rule without name for inline styles.
        if (typeof name === "object") return this.createRule(undefined, name, style);
        var ruleOptions = (0, $1ksDm.default)({}, options, {
            name: name,
            jss: this,
            Renderer: this.options.Renderer
        });
        if (!ruleOptions.generateId) ruleOptions.generateId = this.generateId;
        if (!ruleOptions.classes) ruleOptions.classes = {};
        if (!ruleOptions.keyframes) ruleOptions.keyframes = {};
        var rule = createRule(name, style, ruleOptions);
        if (rule) this.plugins.onProcessRule(rule);
        return rule;
    } /**
   * Register plugin. Passed function will be invoked with a rule instance.
   */ ;
    _proto.use = function use() {
        var _this = this;
        for(var _len = arguments.length, plugins = new Array(_len), _key = 0; _key < _len; _key++)plugins[_key] = arguments[_key];
        plugins.forEach(function(plugin) {
            _this.plugins.use(plugin);
        });
        return this;
    };
    return Jss;
}();
var createJss = function createJss(options) {
    return new Jss(options);
};
/**
 * SheetsManager is like a WeakMap which is designed to count StyleSheet
 * instances and attach/detach automatically.
 * Used in react-jss.
 */ var SheetsManager = /*#__PURE__*/ function() {
    function SheetsManager() {
        this.length = 0;
        this.sheets = new WeakMap();
    }
    var _proto = SheetsManager.prototype;
    _proto.get = function get(key) {
        var entry = this.sheets.get(key);
        return entry && entry.sheet;
    };
    _proto.add = function add(key, sheet) {
        if (this.sheets.has(key)) return;
        this.length++;
        this.sheets.set(key, {
            sheet: sheet,
            refs: 0
        });
    };
    _proto.manage = function manage(key) {
        var entry = this.sheets.get(key);
        if (entry) {
            if (entry.refs === 0) entry.sheet.attach();
            entry.refs++;
            return entry.sheet;
        }
        (0, $1UzpR.default)(false, "[JSS] SheetsManager: can't find sheet to manage");
        return undefined;
    };
    _proto.unmanage = function unmanage(key) {
        var entry = this.sheets.get(key);
        if (entry) {
            if (entry.refs > 0) {
                entry.refs--;
                if (entry.refs === 0) entry.sheet.detach();
            }
        } else (0, $1UzpR.default)(false, "SheetsManager: can't find sheet to unmanage");
    };
    (0, $hXbED.default)(SheetsManager, [
        {
            key: "size",
            get: function get() {
                return this.length;
            }
        }
    ]);
    return SheetsManager;
}();
/**
* Export a constant indicating if this browser has CSSTOM support.
* https://developers.google.com/web/updates/2018/03/cssom
*/ var hasCSSTOMSupport = typeof CSS === "object" && CSS != null && "number" in CSS;
/**
 * Extracts a styles object with only props that contain function values.
 */ function getDynamicStyles(styles) {
    var to = null;
    for(var key in styles){
        var value = styles[key];
        var type = typeof value;
        if (type === "function") {
            if (!to) to = {};
            to[key] = value;
        } else if (type === "object" && value !== null && !Array.isArray(value)) {
            var extracted = getDynamicStyles(value);
            if (extracted) {
                if (!to) to = {};
                to[key] = extracted;
            }
        }
    }
    return to;
}
/**
 * A better abstraction over CSS.
 *
 * @copyright Oleg Isonen (Slobodskoi) / Isonen 2014-present
 * @website https://github.com/cssinjs/jss
 * @license MIT
 */ var index = createJss();
var $d673a8c732c05879$export$2e2bcd8739ae039 = index;

});
parcelRegister("1ksDm", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0f7ddec51ea633a5$export$2e2bcd8739ae039; });
function $0f7ddec51ea633a5$export$2e2bcd8739ae039() {
    $0f7ddec51ea633a5$export$2e2bcd8739ae039 = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $0f7ddec51ea633a5$export$2e2bcd8739ae039.apply(this, arguments);
}

});

parcelRegister("aGThG", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7c88b5e9f1840927$export$2e2bcd8739ae039; });
var $7c88b5e9f1840927$var$_typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function(obj) {
    return typeof obj;
} : function(obj) {
    return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};
var $7c88b5e9f1840927$export$4e09c449d6c407f7 = (typeof window === "undefined" ? "undefined" : $7c88b5e9f1840927$var$_typeof(window)) === "object" && (typeof document === "undefined" ? "undefined" : $7c88b5e9f1840927$var$_typeof(document)) === "object" && document.nodeType === 9;
var $7c88b5e9f1840927$export$2e2bcd8739ae039 = $7c88b5e9f1840927$export$4e09c449d6c407f7;

});

parcelRegister("1UzpR", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $16467e548dcd83b1$export$2e2bcd8739ae039; });
var $16467e548dcd83b1$var$isProduction = false;
function $16467e548dcd83b1$var$warning(condition, message) {
    if (!$16467e548dcd83b1$var$isProduction) {
        if (condition) return;
        var text = "Warning: " + message;
        if (typeof console !== "undefined") console.warn(text);
        try {
            throw Error(text);
        } catch (x) {}
    }
}
var $16467e548dcd83b1$export$2e2bcd8739ae039 = $16467e548dcd83b1$var$warning;

});

parcelRegister("hXbED", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $035f7ff25c8ed8f0$export$2e2bcd8739ae039; });
function $035f7ff25c8ed8f0$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $035f7ff25c8ed8f0$export$2e2bcd8739ae039(Constructor, protoProps, staticProps) {
    if (protoProps) $035f7ff25c8ed8f0$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $035f7ff25c8ed8f0$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}

});

parcelRegister("82w9t", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5da77351594631b4$export$2e2bcd8739ae039; });

var $OlfsS = parcelRequire("OlfsS");
function $5da77351594631b4$export$2e2bcd8739ae039(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    (0, $OlfsS.default)(subClass, superClass);
}

});
parcelRegister("OlfsS", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0975271f6cf83c70$export$2e2bcd8739ae039; });
function $0975271f6cf83c70$export$2e2bcd8739ae039(o, p) {
    $0975271f6cf83c70$export$2e2bcd8739ae039 = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $0975271f6cf83c70$export$2e2bcd8739ae039(o, p);
}

});


parcelRegister("bV0Px", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8ad5a97543a4f19a$export$2e2bcd8739ae039; });
function $8ad5a97543a4f19a$export$2e2bcd8739ae039(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}

});

parcelRegister("1sb8G", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $10f10bf588a52721$export$2e2bcd8739ae039; });
function $10f10bf588a52721$export$2e2bcd8739ae039(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}

});


parcelRegister("a6yxM", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $75b54299b87620a7$export$2e2bcd8739ae039; });

var $815Xb = parcelRequire("815Xb");

var $3gm9p = parcelRequire("3gm9p");
function $75b54299b87620a7$export$2e2bcd8739ae039() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var baseClasses = options.baseClasses, newClasses = options.newClasses, Component = options.Component;
    if (!newClasses) return baseClasses;
    var nextClasses = (0, $815Xb.default)({}, baseClasses);
    if (typeof newClasses === "string") {
        console.error([
            "Material-UI: The value `".concat(newClasses, "` ") + "provided to the classes prop of ".concat((0, $3gm9p.default)(Component), " is incorrect."),
            "You might want to use the className prop instead."
        ].join("\n"));
        return baseClasses;
    }
    Object.keys(newClasses).forEach(function(key) {
        if (!baseClasses[key] && newClasses[key]) console.error([
            "Material-UI: The key `".concat(key, "` ") + "provided to the classes prop is not implemented in ".concat((0, $3gm9p.default)(Component), "."),
            "You can only override one of the following: ".concat(Object.keys(baseClasses).join(","), ".")
        ].join("\n"));
        if (newClasses[key] && typeof newClasses[key] !== "string") console.error([
            "Material-UI: The key `".concat(key, "` ") + "provided to the classes prop is not valid for ".concat((0, $3gm9p.default)(Component), "."),
            "You need to provide a non empty string instead of: ".concat(newClasses[key], ".")
        ].join("\n"));
        if (newClasses[key]) nextClasses[key] = "".concat(baseClasses[key], " ").concat(newClasses[key]);
    });
    return nextClasses;
}

});
parcelRegister("3gm9p", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $26040c6b2af3f85e$export$2e2bcd8739ae039; });

var $l7JxS = parcelRequire("l7JxS");

var $anmus = parcelRequire("anmus");
// https://github.com/JamesMGreene/Function.name/blob/58b314d4a983110c3682f1228f845d39ccca1817/Function.name.js#L3
var $26040c6b2af3f85e$var$fnNameMatchRegex = /^\s*function(?:\s|\s*\/\*.*\*\/\s*)+([^(\s/]*)\s*/;
function $26040c6b2af3f85e$export$aad197c7121a6651(fn) {
    var match = "".concat(fn).match($26040c6b2af3f85e$var$fnNameMatchRegex);
    var name = match && match[1];
    return name || "";
}
/**
 * @param {function} Component
 * @param {string} fallback
 * @returns {string | undefined}
 */ function $26040c6b2af3f85e$var$getFunctionComponentName(Component) {
    var fallback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";
    return Component.displayName || Component.name || $26040c6b2af3f85e$export$aad197c7121a6651(Component) || fallback;
}
function $26040c6b2af3f85e$var$getWrappedName(outerType, innerType, wrapperName) {
    var functionName = $26040c6b2af3f85e$var$getFunctionComponentName(innerType);
    return outerType.displayName || (functionName !== "" ? "".concat(wrapperName, "(").concat(functionName, ")") : wrapperName);
}
function $26040c6b2af3f85e$export$2e2bcd8739ae039(Component) {
    if (Component == null) return undefined;
    if (typeof Component === "string") return Component;
    if (typeof Component === "function") return $26040c6b2af3f85e$var$getFunctionComponentName(Component, "Component");
    if ((0, $l7JxS.default)(Component) === "object") switch(Component.$$typeof){
        case 0, $anmus.ForwardRef:
            return $26040c6b2af3f85e$var$getWrappedName(Component, Component.render, "ForwardRef");
        case 0, $anmus.Memo:
            return $26040c6b2af3f85e$var$getWrappedName(Component, Component.type, "memo");
        default:
            return undefined;
    }
    return undefined;
}

});
parcelRegister("l7JxS", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f60d94cfa9f16e9d$export$2e2bcd8739ae039; });
function $f60d94cfa9f16e9d$export$2e2bcd8739ae039(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $f60d94cfa9f16e9d$export$2e2bcd8739ae039 = function _typeof(obj) {
        return typeof obj;
    };
    else $f60d94cfa9f16e9d$export$2e2bcd8739ae039 = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $f60d94cfa9f16e9d$export$2e2bcd8739ae039(obj);
}

});

parcelRegister("anmus", function(module, exports) {
"use strict";

module.exports = (parcelRequire("iDNXS"));

});
parcelRegister("iDNXS", function(module, exports) {

$parcel$export(module.exports, "ContextConsumer", function () { return $d922a07aaf04d318$export$a7c73072b1a182ae; }, function (v) { return $d922a07aaf04d318$export$a7c73072b1a182ae = v; });
$parcel$export(module.exports, "ContextProvider", function () { return $d922a07aaf04d318$export$9f27bc3417b4524d; }, function (v) { return $d922a07aaf04d318$export$9f27bc3417b4524d = v; });
$parcel$export(module.exports, "Element", function () { return $d922a07aaf04d318$export$db77ccec0bb4ccac; }, function (v) { return $d922a07aaf04d318$export$db77ccec0bb4ccac = v; });
$parcel$export(module.exports, "ForwardRef", function () { return $d922a07aaf04d318$export$8392c0c9d3dcbd35; }, function (v) { return $d922a07aaf04d318$export$8392c0c9d3dcbd35 = v; });
$parcel$export(module.exports, "Fragment", function () { return $d922a07aaf04d318$export$ffb0004e005737fa; }, function (v) { return $d922a07aaf04d318$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "Lazy", function () { return $d922a07aaf04d318$export$b624eff549462981; }, function (v) { return $d922a07aaf04d318$export$b624eff549462981 = v; });
$parcel$export(module.exports, "Memo", function () { return $d922a07aaf04d318$export$7897aa7841a5380c; }, function (v) { return $d922a07aaf04d318$export$7897aa7841a5380c = v; });
$parcel$export(module.exports, "Portal", function () { return $d922a07aaf04d318$export$602eac185826482c; }, function (v) { return $d922a07aaf04d318$export$602eac185826482c = v; });
$parcel$export(module.exports, "Profiler", function () { return $d922a07aaf04d318$export$e2c29f18771995cb; }, function (v) { return $d922a07aaf04d318$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "StrictMode", function () { return $d922a07aaf04d318$export$5f8d39834fd61797; }, function (v) { return $d922a07aaf04d318$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Suspense", function () { return $d922a07aaf04d318$export$74bf444e3cd11ea5; }, function (v) { return $d922a07aaf04d318$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "isAsyncMode", function () { return $d922a07aaf04d318$export$92387174baf9b227; }, function (v) { return $d922a07aaf04d318$export$92387174baf9b227 = v; });
$parcel$export(module.exports, "isConcurrentMode", function () { return $d922a07aaf04d318$export$ec112efeb987d9c6; }, function (v) { return $d922a07aaf04d318$export$ec112efeb987d9c6 = v; });
$parcel$export(module.exports, "isContextConsumer", function () { return $d922a07aaf04d318$export$b706b080d889d2c9; }, function (v) { return $d922a07aaf04d318$export$b706b080d889d2c9 = v; });
$parcel$export(module.exports, "isContextProvider", function () { return $d922a07aaf04d318$export$5be5a87408f70ddc; }, function (v) { return $d922a07aaf04d318$export$5be5a87408f70ddc = v; });
$parcel$export(module.exports, "isElement", function () { return $d922a07aaf04d318$export$45a5e7f76e0caa8d; }, function (v) { return $d922a07aaf04d318$export$45a5e7f76e0caa8d = v; });
$parcel$export(module.exports, "isForwardRef", function () { return $d922a07aaf04d318$export$455c2e768291efa6; }, function (v) { return $d922a07aaf04d318$export$455c2e768291efa6 = v; });
$parcel$export(module.exports, "isFragment", function () { return $d922a07aaf04d318$export$9522e17588c12572; }, function (v) { return $d922a07aaf04d318$export$9522e17588c12572 = v; });
$parcel$export(module.exports, "isLazy", function () { return $d922a07aaf04d318$export$2110ac352bb060b9; }, function (v) { return $d922a07aaf04d318$export$2110ac352bb060b9 = v; });
$parcel$export(module.exports, "isMemo", function () { return $d922a07aaf04d318$export$56885ab8b9c456ab; }, function (v) { return $d922a07aaf04d318$export$56885ab8b9c456ab = v; });
$parcel$export(module.exports, "isPortal", function () { return $d922a07aaf04d318$export$d927fcb6adf8f9de; }, function (v) { return $d922a07aaf04d318$export$d927fcb6adf8f9de = v; });
$parcel$export(module.exports, "isProfiler", function () { return $d922a07aaf04d318$export$b82d16f27459e05a; }, function (v) { return $d922a07aaf04d318$export$b82d16f27459e05a = v; });
$parcel$export(module.exports, "isStrictMode", function () { return $d922a07aaf04d318$export$522c17b4f5e123e8; }, function (v) { return $d922a07aaf04d318$export$522c17b4f5e123e8 = v; });
$parcel$export(module.exports, "isSuspense", function () { return $d922a07aaf04d318$export$1aabd8a0274ecfd6; }, function (v) { return $d922a07aaf04d318$export$1aabd8a0274ecfd6 = v; });
$parcel$export(module.exports, "isValidElementType", function () { return $d922a07aaf04d318$export$9b621391a187a31a; }, function (v) { return $d922a07aaf04d318$export$9b621391a187a31a = v; });
$parcel$export(module.exports, "typeOf", function () { return $d922a07aaf04d318$export$f5bbd400c2f4426f; }, function (v) { return $d922a07aaf04d318$export$f5bbd400c2f4426f = v; });
/** @license React v17.0.2
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $d922a07aaf04d318$export$a7c73072b1a182ae;
var $d922a07aaf04d318$export$9f27bc3417b4524d;
var $d922a07aaf04d318$export$db77ccec0bb4ccac;
var $d922a07aaf04d318$export$8392c0c9d3dcbd35;
var $d922a07aaf04d318$export$ffb0004e005737fa;
var $d922a07aaf04d318$export$b624eff549462981;
var $d922a07aaf04d318$export$7897aa7841a5380c;
var $d922a07aaf04d318$export$602eac185826482c;
var $d922a07aaf04d318$export$e2c29f18771995cb;
var $d922a07aaf04d318$export$5f8d39834fd61797;
var $d922a07aaf04d318$export$74bf444e3cd11ea5;
var $d922a07aaf04d318$export$92387174baf9b227;
var $d922a07aaf04d318$export$ec112efeb987d9c6;
var $d922a07aaf04d318$export$b706b080d889d2c9;
var $d922a07aaf04d318$export$5be5a87408f70ddc;
var $d922a07aaf04d318$export$45a5e7f76e0caa8d;
var $d922a07aaf04d318$export$455c2e768291efa6;
var $d922a07aaf04d318$export$9522e17588c12572;
var $d922a07aaf04d318$export$2110ac352bb060b9;
var $d922a07aaf04d318$export$56885ab8b9c456ab;
var $d922a07aaf04d318$export$d927fcb6adf8f9de;
var $d922a07aaf04d318$export$b82d16f27459e05a;
var $d922a07aaf04d318$export$522c17b4f5e123e8;
var $d922a07aaf04d318$export$1aabd8a0274ecfd6;
var $d922a07aaf04d318$export$9b621391a187a31a;
var $d922a07aaf04d318$export$f5bbd400c2f4426f;
"use strict";
(function() {
    "use strict";
    // ATTENTION
    // When adding new symbols to this file,
    // Please consider also adding to 'react-devtools-shared/src/backend/ReactSymbols'
    // The Symbol used to tag the ReactElement-like types. If there is no native Symbol
    // nor polyfill, then a plain number is used for performance.
    var REACT_ELEMENT_TYPE = 0xeac7;
    var REACT_PORTAL_TYPE = 0xeaca;
    var REACT_FRAGMENT_TYPE = 0xeacb;
    var REACT_STRICT_MODE_TYPE = 0xeacc;
    var REACT_PROFILER_TYPE = 0xead2;
    var REACT_PROVIDER_TYPE = 0xeacd;
    var REACT_CONTEXT_TYPE = 0xeace;
    var REACT_FORWARD_REF_TYPE = 0xead0;
    var REACT_SUSPENSE_TYPE = 0xead1;
    var REACT_SUSPENSE_LIST_TYPE = 0xead8;
    var REACT_MEMO_TYPE = 0xead3;
    var REACT_LAZY_TYPE = 0xead4;
    var REACT_BLOCK_TYPE = 0xead9;
    var REACT_SERVER_BLOCK_TYPE = 0xeada;
    var REACT_FUNDAMENTAL_TYPE = 0xead5;
    var REACT_SCOPE_TYPE = 0xead7;
    var REACT_OPAQUE_ID_TYPE = 0xeae0;
    var REACT_DEBUG_TRACING_MODE_TYPE = 0xeae1;
    var REACT_OFFSCREEN_TYPE = 0xeae2;
    var REACT_LEGACY_HIDDEN_TYPE = 0xeae3;
    if (typeof Symbol === "function" && Symbol.for) {
        var symbolFor = Symbol.for;
        REACT_ELEMENT_TYPE = symbolFor("react.element");
        REACT_PORTAL_TYPE = symbolFor("react.portal");
        REACT_FRAGMENT_TYPE = symbolFor("react.fragment");
        REACT_STRICT_MODE_TYPE = symbolFor("react.strict_mode");
        REACT_PROFILER_TYPE = symbolFor("react.profiler");
        REACT_PROVIDER_TYPE = symbolFor("react.provider");
        REACT_CONTEXT_TYPE = symbolFor("react.context");
        REACT_FORWARD_REF_TYPE = symbolFor("react.forward_ref");
        REACT_SUSPENSE_TYPE = symbolFor("react.suspense");
        REACT_SUSPENSE_LIST_TYPE = symbolFor("react.suspense_list");
        REACT_MEMO_TYPE = symbolFor("react.memo");
        REACT_LAZY_TYPE = symbolFor("react.lazy");
        REACT_BLOCK_TYPE = symbolFor("react.block");
        REACT_SERVER_BLOCK_TYPE = symbolFor("react.server.block");
        REACT_FUNDAMENTAL_TYPE = symbolFor("react.fundamental");
        REACT_SCOPE_TYPE = symbolFor("react.scope");
        REACT_OPAQUE_ID_TYPE = symbolFor("react.opaque.id");
        REACT_DEBUG_TRACING_MODE_TYPE = symbolFor("react.debug_trace_mode");
        REACT_OFFSCREEN_TYPE = symbolFor("react.offscreen");
        REACT_LEGACY_HIDDEN_TYPE = symbolFor("react.legacy_hidden");
    }
    // Filter certain DOM attributes (e.g. src, href) if their values are empty strings.
    var enableScopeAPI = false; // Experimental Create Event Handle API.
    function isValidElementType(type) {
        if (typeof type === "string" || typeof type === "function") return true;
         // Note: typeof might be other than 'symbol' or 'number' (e.g. if it's a polyfill).
        if (type === REACT_FRAGMENT_TYPE || type === REACT_PROFILER_TYPE || type === REACT_DEBUG_TRACING_MODE_TYPE || type === REACT_STRICT_MODE_TYPE || type === REACT_SUSPENSE_TYPE || type === REACT_SUSPENSE_LIST_TYPE || type === REACT_LEGACY_HIDDEN_TYPE || enableScopeAPI) return true;
        if (typeof type === "object" && type !== null) {
            if (type.$$typeof === REACT_LAZY_TYPE || type.$$typeof === REACT_MEMO_TYPE || type.$$typeof === REACT_PROVIDER_TYPE || type.$$typeof === REACT_CONTEXT_TYPE || type.$$typeof === REACT_FORWARD_REF_TYPE || type.$$typeof === REACT_FUNDAMENTAL_TYPE || type.$$typeof === REACT_BLOCK_TYPE || type[0] === REACT_SERVER_BLOCK_TYPE) return true;
        }
        return false;
    }
    function typeOf(object) {
        if (typeof object === "object" && object !== null) {
            var $$typeof = object.$$typeof;
            switch($$typeof){
                case REACT_ELEMENT_TYPE:
                    var type = object.type;
                    switch(type){
                        case REACT_FRAGMENT_TYPE:
                        case REACT_PROFILER_TYPE:
                        case REACT_STRICT_MODE_TYPE:
                        case REACT_SUSPENSE_TYPE:
                        case REACT_SUSPENSE_LIST_TYPE:
                            return type;
                        default:
                            var $$typeofType = type && type.$$typeof;
                            switch($$typeofType){
                                case REACT_CONTEXT_TYPE:
                                case REACT_FORWARD_REF_TYPE:
                                case REACT_LAZY_TYPE:
                                case REACT_MEMO_TYPE:
                                case REACT_PROVIDER_TYPE:
                                    return $$typeofType;
                                default:
                                    return $$typeof;
                            }
                    }
                case REACT_PORTAL_TYPE:
                    return $$typeof;
            }
        }
        return undefined;
    }
    var ContextConsumer = REACT_CONTEXT_TYPE;
    var ContextProvider = REACT_PROVIDER_TYPE;
    var Element = REACT_ELEMENT_TYPE;
    var ForwardRef = REACT_FORWARD_REF_TYPE;
    var Fragment = REACT_FRAGMENT_TYPE;
    var Lazy = REACT_LAZY_TYPE;
    var Memo = REACT_MEMO_TYPE;
    var Portal = REACT_PORTAL_TYPE;
    var Profiler = REACT_PROFILER_TYPE;
    var StrictMode = REACT_STRICT_MODE_TYPE;
    var Suspense = REACT_SUSPENSE_TYPE;
    var hasWarnedAboutDeprecatedIsAsyncMode = false;
    var hasWarnedAboutDeprecatedIsConcurrentMode = false; // AsyncMode should be deprecated
    function isAsyncMode(object) {
        if (!hasWarnedAboutDeprecatedIsAsyncMode) {
            hasWarnedAboutDeprecatedIsAsyncMode = true; // Using console['warn'] to evade Babel and ESLint
            console["warn"]("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 18+.");
        }
        return false;
    }
    function isConcurrentMode(object) {
        if (!hasWarnedAboutDeprecatedIsConcurrentMode) {
            hasWarnedAboutDeprecatedIsConcurrentMode = true; // Using console['warn'] to evade Babel and ESLint
            console["warn"]("The ReactIs.isConcurrentMode() alias has been deprecated, and will be removed in React 18+.");
        }
        return false;
    }
    function isContextConsumer(object) {
        return typeOf(object) === REACT_CONTEXT_TYPE;
    }
    function isContextProvider(object) {
        return typeOf(object) === REACT_PROVIDER_TYPE;
    }
    function isElement(object) {
        return typeof object === "object" && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
    }
    function isForwardRef(object) {
        return typeOf(object) === REACT_FORWARD_REF_TYPE;
    }
    function isFragment(object) {
        return typeOf(object) === REACT_FRAGMENT_TYPE;
    }
    function isLazy(object) {
        return typeOf(object) === REACT_LAZY_TYPE;
    }
    function isMemo(object) {
        return typeOf(object) === REACT_MEMO_TYPE;
    }
    function isPortal(object) {
        return typeOf(object) === REACT_PORTAL_TYPE;
    }
    function isProfiler(object) {
        return typeOf(object) === REACT_PROFILER_TYPE;
    }
    function isStrictMode(object) {
        return typeOf(object) === REACT_STRICT_MODE_TYPE;
    }
    function isSuspense(object) {
        return typeOf(object) === REACT_SUSPENSE_TYPE;
    }
    $d922a07aaf04d318$export$a7c73072b1a182ae = ContextConsumer;
    $d922a07aaf04d318$export$9f27bc3417b4524d = ContextProvider;
    $d922a07aaf04d318$export$db77ccec0bb4ccac = Element;
    $d922a07aaf04d318$export$8392c0c9d3dcbd35 = ForwardRef;
    $d922a07aaf04d318$export$ffb0004e005737fa = Fragment;
    $d922a07aaf04d318$export$b624eff549462981 = Lazy;
    $d922a07aaf04d318$export$7897aa7841a5380c = Memo;
    $d922a07aaf04d318$export$602eac185826482c = Portal;
    $d922a07aaf04d318$export$e2c29f18771995cb = Profiler;
    $d922a07aaf04d318$export$5f8d39834fd61797 = StrictMode;
    $d922a07aaf04d318$export$74bf444e3cd11ea5 = Suspense;
    $d922a07aaf04d318$export$92387174baf9b227 = isAsyncMode;
    $d922a07aaf04d318$export$ec112efeb987d9c6 = isConcurrentMode;
    $d922a07aaf04d318$export$b706b080d889d2c9 = isContextConsumer;
    $d922a07aaf04d318$export$5be5a87408f70ddc = isContextProvider;
    $d922a07aaf04d318$export$45a5e7f76e0caa8d = isElement;
    $d922a07aaf04d318$export$455c2e768291efa6 = isForwardRef;
    $d922a07aaf04d318$export$9522e17588c12572 = isFragment;
    $d922a07aaf04d318$export$2110ac352bb060b9 = isLazy;
    $d922a07aaf04d318$export$56885ab8b9c456ab = isMemo;
    $d922a07aaf04d318$export$d927fcb6adf8f9de = isPortal;
    $d922a07aaf04d318$export$b82d16f27459e05a = isProfiler;
    $d922a07aaf04d318$export$522c17b4f5e123e8 = isStrictMode;
    $d922a07aaf04d318$export$1aabd8a0274ecfd6 = isSuspense;
    $d922a07aaf04d318$export$9b621391a187a31a = isValidElementType;
    $d922a07aaf04d318$export$f5bbd400c2f4426f = typeOf;
})();

});




parcelRegister("3K7R2", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2b9bc2b3c21b4faf$export$2e2bcd8739ae039; });
// Used https://github.com/thinkloop/multi-key-cache as inspiration
var $2b9bc2b3c21b4faf$var$multiKeyStore = {
    set: function set(cache, key1, key2, value) {
        var subCache = cache.get(key1);
        if (!subCache) {
            subCache = new Map();
            cache.set(key1, subCache);
        }
        subCache.set(key2, value);
    },
    get: function get(cache, key1, key2) {
        var subCache = cache.get(key1);
        return subCache ? subCache.get(key2) : undefined;
    },
    delete: function _delete(cache, key1, key2) {
        var subCache = cache.get(key1);
        subCache.delete(key2);
    }
};
var $2b9bc2b3c21b4faf$export$2e2bcd8739ae039 = $2b9bc2b3c21b4faf$var$multiKeyStore;

});

parcelRegister("1krVc", function(module, exports) {

$parcel$export(module.exports, "StylesContext", function () { return $0f7d515dfbe6a364$export$f4de434b269fe487; });
$parcel$export(module.exports, "default", function () { return $0f7d515dfbe6a364$export$2e2bcd8739ae039; });

var $815Xb = parcelRequire("815Xb");

var $gyDGU = parcelRequire("gyDGU");

var $cQNHH = parcelRequire("cQNHH");

var $1xEYC = parcelRequire("1xEYC");

var $jf4OJ = parcelRequire("jf4OJ");

var $dCWGK = parcelRequire("dCWGK");

var $ipwm3 = parcelRequire("ipwm3");

var $iCH0W = parcelRequire("iCH0W");
var $0f7d515dfbe6a364$var$jss = (0, $ipwm3.create)((0, $iCH0W.default)()); // Use a singleton or the provided one by the context.
//
// The counter-based approach doesn't tolerate any mistake.
// It's much safer to use the same counter everywhere.
var $0f7d515dfbe6a364$var$generateClassName = (0, $dCWGK.default)(); // Exported for test purposes
var $0f7d515dfbe6a364$export$70a8aea9ff58d1cd = new Map();
var $0f7d515dfbe6a364$var$defaultOptions = {
    disableGeneration: false,
    generateClassName: $0f7d515dfbe6a364$var$generateClassName,
    jss: $0f7d515dfbe6a364$var$jss,
    sheetsCache: null,
    sheetsManager: $0f7d515dfbe6a364$export$70a8aea9ff58d1cd,
    sheetsRegistry: null
};
var $0f7d515dfbe6a364$export$f4de434b269fe487 = (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createContext($0f7d515dfbe6a364$var$defaultOptions);
$0f7d515dfbe6a364$export$f4de434b269fe487.displayName = "StylesContext";
var $0f7d515dfbe6a364$var$injectFirstNode;
function $0f7d515dfbe6a364$export$2e2bcd8739ae039(props) {
    var children = props.children, _props$injectFirst = props.injectFirst, injectFirst = _props$injectFirst === void 0 ? false : _props$injectFirst, _props$disableGenerat = props.disableGeneration, disableGeneration = _props$disableGenerat === void 0 ? false : _props$disableGenerat, localOptions = (0, $gyDGU.default)(props, [
        "children",
        "injectFirst",
        "disableGeneration"
    ]);
    var outerOptions = (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).useContext($0f7d515dfbe6a364$export$f4de434b269fe487);
    var context = (0, $815Xb.default)({}, outerOptions, {
        disableGeneration: disableGeneration
    }, localOptions);
    if (typeof window === "undefined" && !context.sheetsManager) console.error("Material-UI: You need to use the ServerStyleSheets API when rendering on the server.");
    if (context.jss.options.insertionPoint && injectFirst) console.error("Material-UI: You cannot use a custom insertionPoint and <StylesContext injectFirst> at the same time.");
    if (injectFirst && localOptions.jss) console.error("Material-UI: You cannot use the jss and injectFirst props at the same time.");
    if (!context.jss.options.insertionPoint && injectFirst && typeof window !== "undefined") {
        if (!$0f7d515dfbe6a364$var$injectFirstNode) {
            var head = document.head;
            $0f7d515dfbe6a364$var$injectFirstNode = document.createComment("mui-inject-first");
            head.insertBefore($0f7d515dfbe6a364$var$injectFirstNode, head.firstChild);
        }
        context.jss = (0, $ipwm3.create)({
            plugins: (0, $iCH0W.default)().plugins,
            insertionPoint: $0f7d515dfbe6a364$var$injectFirstNode
        });
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement($0f7d515dfbe6a364$export$f4de434b269fe487.Provider, {
        value: context
    }, children);
}
$0f7d515dfbe6a364$export$2e2bcd8739ae039.propTypes = {
    /**
   * Your component tree.
   */ children: (0, (/*@__PURE__*/$parcel$interopDefault($1xEYC))).node.isRequired,
    /**
   * You can disable the generation of the styles with this option.
   * It can be useful when traversing the React tree outside of the HTML
   * rendering step on the server.
   * Let's say you are using react-apollo to extract all
   * the queries made by the interface server-side - you can significantly speed up the traversal with this prop.
   */ disableGeneration: (0, (/*@__PURE__*/$parcel$interopDefault($1xEYC))).bool,
    /**
   * JSS's class name generator.
   */ generateClassName: (0, (/*@__PURE__*/$parcel$interopDefault($1xEYC))).func,
    /**
   * By default, the styles are injected last in the <head> element of the page.
   * As a result, they gain more specificity than any other style sheet.
   * If you want to override Material-UI's styles, set this prop.
   */ injectFirst: (0, (/*@__PURE__*/$parcel$interopDefault($1xEYC))).bool,
    /**
   * JSS's instance.
   */ jss: (0, (/*@__PURE__*/$parcel$interopDefault($1xEYC))).object,
    /**
   * @ignore
   */ serverGenerateClassName: (0, (/*@__PURE__*/$parcel$interopDefault($1xEYC))).func,
    /**
   * @ignore
   *
   * Beta feature.
   *
   * Cache for the sheets.
   */ sheetsCache: (0, (/*@__PURE__*/$parcel$interopDefault($1xEYC))).object,
    /**
   * @ignore
   *
   * The sheetsManager is used to deduplicate style sheet injection in the page.
   * It's deduplicating using the (theme, styles) couple.
   * On the server, you should provide a new instance for each request.
   */ sheetsManager: (0, (/*@__PURE__*/$parcel$interopDefault($1xEYC))).object,
    /**
   * @ignore
   *
   * Collect the sheets.
   */ sheetsRegistry: (0, (/*@__PURE__*/$parcel$interopDefault($1xEYC))).object
};
$0f7d515dfbe6a364$export$2e2bcd8739ae039.propTypes = (0, $jf4OJ.default)($0f7d515dfbe6a364$export$2e2bcd8739ae039.propTypes);

});
parcelRegister("dCWGK", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9ebc5941a4d4dbb6$export$2e2bcd8739ae039; });

var $49sgH = parcelRequire("49sgH");
/**
 * This is the list of the style rule name we use as drop in replacement for the built-in
 * pseudo classes (:checked, :disabled, :focused, etc.).
 *
 * Why do they exist in the first place?
 * These classes are used at a specificity of 2.
 * It allows them to override previously definied styles as well as
 * being untouched by simple user overrides.
 */ var $9ebc5941a4d4dbb6$var$pseudoClasses = [
    "checked",
    "disabled",
    "error",
    "focused",
    "focusVisible",
    "required",
    "expanded",
    "selected"
]; // Returns a function which generates unique class names based on counters.
function $9ebc5941a4d4dbb6$export$2e2bcd8739ae039() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var _options$disableGloba = options.disableGlobal, disableGlobal = _options$disableGloba === void 0 ? false : _options$disableGloba, _options$productionPr = options.productionPrefix, productionPrefix = _options$productionPr === void 0 ? "jss" : _options$productionPr, _options$seed = options.seed, seed = _options$seed === void 0 ? "" : _options$seed;
    var seedPrefix = seed === "" ? "" : "".concat(seed, "-");
    var ruleCounter = 0;
    var getNextCounterId = function getNextCounterId() {
        ruleCounter += 1;
        if (ruleCounter >= 1e10) console.warn([
            "Material-UI: You might have a memory leak.",
            "The ruleCounter is not supposed to grow that much."
        ].join(""));
        return ruleCounter;
    };
    return function(rule, styleSheet) {
        var name = styleSheet.options.name; // Is a global static MUI style?
        if (name && name.indexOf("Mui") === 0 && !styleSheet.options.link && !disableGlobal) {
            // We can use a shorthand class name, we never use the keys to style the components.
            if ($9ebc5941a4d4dbb6$var$pseudoClasses.indexOf(rule.key) !== -1) return "Mui-".concat(rule.key);
            var prefix = "".concat(seedPrefix).concat(name, "-").concat(rule.key);
            if (!styleSheet.options.theme[0, $49sgH.default] || seed !== "") return prefix;
            return "".concat(prefix, "-").concat(getNextCounterId());
        }
        var suffix = "".concat(rule.key, "-").concat(getNextCounterId()); // Help with debuggability.
        if (styleSheet.options.classNamePrefix) return "".concat(seedPrefix).concat(styleSheet.options.classNamePrefix, "-").concat(suffix);
        return "".concat(seedPrefix).concat(suffix);
    };
}

});
parcelRegister("49sgH", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $305dee35e9856e4c$export$2e2bcd8739ae039; });
var $305dee35e9856e4c$var$hasSymbol = typeof Symbol === "function" && Symbol.for;
var $305dee35e9856e4c$export$2e2bcd8739ae039 = $305dee35e9856e4c$var$hasSymbol ? Symbol.for("mui.nested") : "__THEME_NESTED__";

});


parcelRegister("iCH0W", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d8ed24578f916d32$export$2e2bcd8739ae039; });

var $62JkZ = parcelRequire("62JkZ");

var $cyEBW = parcelRequire("cyEBW");

var $hdsV5 = parcelRequire("hdsV5");

var $3J7gu = parcelRequire("3J7gu");

var $f9Oxo = parcelRequire("f9Oxo");

var $302Yl = parcelRequire("302Yl");

var $efFhT = parcelRequire("efFhT");
function $d8ed24578f916d32$export$2e2bcd8739ae039() {
    return {
        plugins: [
            (0, $62JkZ.default)(),
            (0, $cyEBW.default)(),
            (0, $hdsV5.default)(),
            (0, $3J7gu.default)(),
            (0, $f9Oxo.default)(),
            // This way, we can get a performance boost.
            // In the documentation, we are using `autoprefixer` to solve this problem.
            typeof window === "undefined" ? null : (0, $302Yl.default)(),
            (0, $efFhT.default)()
        ]
    };
}

});
parcelRegister("62JkZ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $46661918fe532c0b$export$2e2bcd8739ae039; });


var $ipwm3 = parcelRequire("ipwm3");
var $46661918fe532c0b$var$now = Date.now();
var $46661918fe532c0b$var$fnValuesNs = "fnValues" + $46661918fe532c0b$var$now;
var $46661918fe532c0b$var$fnRuleNs = "fnStyle" + ++$46661918fe532c0b$var$now;
var $46661918fe532c0b$var$functionPlugin = function functionPlugin() {
    return {
        onCreateRule: function onCreateRule(name, decl, options) {
            if (typeof decl !== "function") return null;
            var rule = (0, $ipwm3.createRule)(name, {}, options);
            rule[$46661918fe532c0b$var$fnRuleNs] = decl;
            return rule;
        },
        onProcessStyle: function onProcessStyle(style, rule) {
            // We need to extract function values from the declaration, so that we can keep core unaware of them.
            // We need to do that only once.
            // We don't need to extract functions on each style update, since this can happen only once.
            // We don't support function values inside of function rules.
            if ($46661918fe532c0b$var$fnValuesNs in rule || $46661918fe532c0b$var$fnRuleNs in rule) return style;
            var fnValues = {};
            for(var prop in style){
                var value = style[prop];
                if (typeof value !== "function") continue;
                delete style[prop];
                fnValues[prop] = value;
            }
            rule[$46661918fe532c0b$var$fnValuesNs] = fnValues;
            return style;
        },
        onUpdate: function onUpdate(data, rule, sheet, options) {
            var styleRule = rule;
            var fnRule = styleRule[$46661918fe532c0b$var$fnRuleNs]; // If we have a style function, the entire rule is dynamic and style object
            // will be returned from that function.
            if (fnRule) {
                // Empty object will remove all currently defined props
                // in case function rule returns a falsy value.
                styleRule.style = fnRule(data) || {};
                var prop;
            }
            var fnValues = styleRule[$46661918fe532c0b$var$fnValuesNs]; // If we have a fn values map, it is a rule with function values.
            if (fnValues) for(var _prop in fnValues)styleRule.prop(_prop, fnValues[_prop](data), options);
        }
    };
};
var $46661918fe532c0b$export$2e2bcd8739ae039 = $46661918fe532c0b$var$functionPlugin;

});

parcelRegister("cyEBW", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $92482982f55e24af$export$2e2bcd8739ae039; });

var $gRSze = parcelRequire("gRSze");

var $ipwm3 = parcelRequire("ipwm3");
var $92482982f55e24af$var$at = "@global";
var $92482982f55e24af$var$atPrefix = "@global ";
var $92482982f55e24af$var$GlobalContainerRule = /*#__PURE__*/ function() {
    function GlobalContainerRule(key, styles, options) {
        this.type = "global";
        this.at = $92482982f55e24af$var$at;
        this.isProcessed = false;
        this.key = key;
        this.options = options;
        this.rules = new (0, $ipwm3.RuleList)((0, $gRSze.default)({}, options, {
            parent: this
        }));
        for(var selector in styles)this.rules.add(selector, styles[selector]);
        this.rules.process();
    }
    /**
   * Get a rule.
   */ var _proto = GlobalContainerRule.prototype;
    _proto.getRule = function getRule(name) {
        return this.rules.get(name);
    } /**
   * Create and register rule, run plugins.
   */ ;
    _proto.addRule = function addRule(name, style, options) {
        var rule = this.rules.add(name, style, options);
        if (rule) this.options.jss.plugins.onProcessRule(rule);
        return rule;
    } /**
   * Get index of a rule.
   */ ;
    _proto.indexOf = function indexOf(rule) {
        return this.rules.indexOf(rule);
    } /**
   * Generates a CSS string.
   */ ;
    _proto.toString = function toString() {
        return this.rules.toString();
    };
    return GlobalContainerRule;
}();
var $92482982f55e24af$var$GlobalPrefixedRule = /*#__PURE__*/ function() {
    function GlobalPrefixedRule(key, style, options) {
        this.type = "global";
        this.at = $92482982f55e24af$var$at;
        this.isProcessed = false;
        this.key = key;
        this.options = options;
        var selector = key.substr($92482982f55e24af$var$atPrefix.length);
        this.rule = options.jss.createRule(selector, style, (0, $gRSze.default)({}, options, {
            parent: this
        }));
    }
    var _proto2 = GlobalPrefixedRule.prototype;
    _proto2.toString = function toString(options) {
        return this.rule ? this.rule.toString(options) : "";
    };
    return GlobalPrefixedRule;
}();
var $92482982f55e24af$var$separatorRegExp = /\s*,\s*/g;
function $92482982f55e24af$var$addScope(selector, scope) {
    var parts = selector.split($92482982f55e24af$var$separatorRegExp);
    var scoped = "";
    for(var i = 0; i < parts.length; i++){
        scoped += scope + " " + parts[i].trim();
        if (parts[i + 1]) scoped += ", ";
    }
    return scoped;
}
function $92482982f55e24af$var$handleNestedGlobalContainerRule(rule, sheet) {
    var options = rule.options, style = rule.style;
    var rules = style ? style[$92482982f55e24af$var$at] : null;
    if (!rules) return;
    for(var name in rules)sheet.addRule(name, rules[name], (0, $gRSze.default)({}, options, {
        selector: $92482982f55e24af$var$addScope(name, rule.selector)
    }));
    delete style[$92482982f55e24af$var$at];
}
function $92482982f55e24af$var$handlePrefixedGlobalRule(rule, sheet) {
    var options = rule.options, style = rule.style;
    for(var prop in style){
        if (prop[0] !== "@" || prop.substr(0, $92482982f55e24af$var$at.length) !== $92482982f55e24af$var$at) continue;
        var selector = $92482982f55e24af$var$addScope(prop.substr($92482982f55e24af$var$at.length), rule.selector);
        sheet.addRule(selector, style[prop], (0, $gRSze.default)({}, options, {
            selector: selector
        }));
        delete style[prop];
    }
}
/**
 * Convert nested rules to separate, remove them from original styles.
 */ function $92482982f55e24af$var$jssGlobal() {
    function onCreateRule(name, styles, options) {
        if (!name) return null;
        if (name === $92482982f55e24af$var$at) return new $92482982f55e24af$var$GlobalContainerRule(name, styles, options);
        if (name[0] === "@" && name.substr(0, $92482982f55e24af$var$atPrefix.length) === $92482982f55e24af$var$atPrefix) return new $92482982f55e24af$var$GlobalPrefixedRule(name, styles, options);
        var parent = options.parent;
        if (parent) {
            if (parent.type === "global" || parent.options.parent && parent.options.parent.type === "global") options.scoped = false;
        }
        if (options.scoped === false) options.selector = name;
        return null;
    }
    function onProcessRule(rule, sheet) {
        if (rule.type !== "style" || !sheet) return;
        $92482982f55e24af$var$handleNestedGlobalContainerRule(rule, sheet);
        $92482982f55e24af$var$handlePrefixedGlobalRule(rule, sheet);
    }
    return {
        onCreateRule: onCreateRule,
        onProcessRule: onProcessRule
    };
}
var $92482982f55e24af$export$2e2bcd8739ae039 = $92482982f55e24af$var$jssGlobal;

});
parcelRegister("gRSze", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c47bec82326a2b4a$export$2e2bcd8739ae039; });
function $c47bec82326a2b4a$export$2e2bcd8739ae039() {
    $c47bec82326a2b4a$export$2e2bcd8739ae039 = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $c47bec82326a2b4a$export$2e2bcd8739ae039.apply(this, arguments);
}

});


parcelRegister("hdsV5", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c88a15730120666e$export$2e2bcd8739ae039; });

var $RdkRM = parcelRequire("RdkRM");

var $1UzpR = parcelRequire("1UzpR");
var $c88a15730120666e$var$separatorRegExp = /\s*,\s*/g;
var $c88a15730120666e$var$parentRegExp = /&/g;
var $c88a15730120666e$var$refRegExp = /\$([\w-]+)/g;
/**
 * Convert nested rules to separate, remove them from original styles.
 */ function $c88a15730120666e$var$jssNested() {
    // Get a function to be used for $ref replacement.
    function getReplaceRef(container, sheet) {
        return function(match, key) {
            var rule = container.getRule(key) || sheet && sheet.getRule(key);
            if (rule) return rule.selector;
            (0, $1UzpR.default)(false, '[JSS] Could not find the referenced rule "' + key + '" in "' + (container.options.meta || container.toString()) + '".');
            return key;
        };
    }
    function replaceParentRefs(nestedProp, parentProp) {
        var parentSelectors = parentProp.split($c88a15730120666e$var$separatorRegExp);
        var nestedSelectors = nestedProp.split($c88a15730120666e$var$separatorRegExp);
        var result = "";
        for(var i = 0; i < parentSelectors.length; i++){
            var parent = parentSelectors[i];
            for(var j = 0; j < nestedSelectors.length; j++){
                var nested = nestedSelectors[j];
                if (result) result += ", "; // Replace all & by the parent or prefix & with the parent.
                result += nested.indexOf("&") !== -1 ? nested.replace($c88a15730120666e$var$parentRegExp, parent) : parent + " " + nested;
            }
        }
        return result;
    }
    function getOptions(rule, container, prevOptions) {
        // Options has been already created, now we only increase index.
        if (prevOptions) return (0, $RdkRM.default)({}, prevOptions, {
            index: prevOptions.index + 1
        });
        var nestingLevel = rule.options.nestingLevel;
        nestingLevel = nestingLevel === undefined ? 1 : nestingLevel + 1;
        var options = (0, $RdkRM.default)({}, rule.options, {
            nestingLevel: nestingLevel,
            index: container.indexOf(rule) + 1 // We don't need the parent name to be set options for chlid.
        });
        delete options.name;
        return options;
    }
    function onProcessStyle(style, rule, sheet) {
        if (rule.type !== "style") return style;
        var styleRule = rule;
        var container = styleRule.options.parent;
        var options;
        var replaceRef;
        for(var prop in style){
            var isNested = prop.indexOf("&") !== -1;
            var isNestedConditional = prop[0] === "@";
            if (!isNested && !isNestedConditional) continue;
            options = getOptions(styleRule, container, options);
            if (isNested) {
                var selector = replaceParentRefs(prop, styleRule.selector); // Lazily create the ref replacer function just once for
                // all nested rules within the sheet.
                if (!replaceRef) replaceRef = getReplaceRef(container, sheet); // Replace all $refs.
                selector = selector.replace($c88a15730120666e$var$refRegExp, replaceRef);
                container.addRule(selector, style[prop], (0, $RdkRM.default)({}, options, {
                    selector: selector
                }));
            } else if (isNestedConditional) // Place conditional right after the parent rule to ensure right ordering.
            container.addRule(prop, {}, options).addRule(styleRule.key, style[prop], {
                selector: styleRule.selector
            });
            delete style[prop];
        }
        return style;
    }
    return {
        onProcessStyle: onProcessStyle
    };
}
var $c88a15730120666e$export$2e2bcd8739ae039 = $c88a15730120666e$var$jssNested;

});
parcelRegister("RdkRM", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $09ff4b83e25ced66$export$2e2bcd8739ae039; });
function $09ff4b83e25ced66$export$2e2bcd8739ae039() {
    $09ff4b83e25ced66$export$2e2bcd8739ae039 = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $09ff4b83e25ced66$export$2e2bcd8739ae039.apply(this, arguments);
}

});


parcelRegister("3J7gu", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2b6b35bb19b78d13$export$2e2bcd8739ae039; });

var $4UeHv = parcelRequire("4UeHv");
/**
 * Convert camel cased property names to dash separated.
 */ function $2b6b35bb19b78d13$var$convertCase(style) {
    var converted = {};
    for(var prop in style){
        var key = prop.indexOf("--") === 0 ? prop : (0, $4UeHv.default)(prop);
        converted[key] = style[prop];
    }
    if (style.fallbacks) {
        if (Array.isArray(style.fallbacks)) converted.fallbacks = style.fallbacks.map($2b6b35bb19b78d13$var$convertCase);
        else converted.fallbacks = $2b6b35bb19b78d13$var$convertCase(style.fallbacks);
    }
    return converted;
}
/**
 * Allow camel cased property names by converting them back to dasherized.
 */ function $2b6b35bb19b78d13$var$camelCase() {
    function onProcessStyle(style) {
        if (Array.isArray(style)) {
            // Handle rules like @font-face, which can have multiple styles in an array
            for(var index = 0; index < style.length; index++)style[index] = $2b6b35bb19b78d13$var$convertCase(style[index]);
            return style;
        }
        return $2b6b35bb19b78d13$var$convertCase(style);
    }
    function onChangeValue(value, prop, rule) {
        if (prop.indexOf("--") === 0) return value;
        var hyphenatedProp = (0, $4UeHv.default)(prop); // There was no camel case in place
        if (prop === hyphenatedProp) return value;
        rule.prop(hyphenatedProp, value); // Core will ignore that property value we set the proper one above.
        return null;
    }
    return {
        onProcessStyle: onProcessStyle,
        onChangeValue: onChangeValue
    };
}
var $2b6b35bb19b78d13$export$2e2bcd8739ae039 = $2b6b35bb19b78d13$var$camelCase;

});
parcelRegister("4UeHv", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3927cbaa97fc2f54$export$2e2bcd8739ae039; });
/* eslint-disable no-var, prefer-template */ var $3927cbaa97fc2f54$var$uppercasePattern = /[A-Z]/g;
var $3927cbaa97fc2f54$var$msPattern = /^ms-/;
var $3927cbaa97fc2f54$var$cache = {};
function $3927cbaa97fc2f54$var$toHyphenLower(match) {
    return "-" + match.toLowerCase();
}
function $3927cbaa97fc2f54$var$hyphenateStyleName(name) {
    if ($3927cbaa97fc2f54$var$cache.hasOwnProperty(name)) return $3927cbaa97fc2f54$var$cache[name];
    var hName = name.replace($3927cbaa97fc2f54$var$uppercasePattern, $3927cbaa97fc2f54$var$toHyphenLower);
    return $3927cbaa97fc2f54$var$cache[name] = $3927cbaa97fc2f54$var$msPattern.test(hName) ? "-" + hName : hName;
}
var $3927cbaa97fc2f54$export$2e2bcd8739ae039 = $3927cbaa97fc2f54$var$hyphenateStyleName;

});


parcelRegister("f9Oxo", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b08ee6037077f5f0$export$2e2bcd8739ae039; });

var $ipwm3 = parcelRequire("ipwm3");
var $b08ee6037077f5f0$var$px = (0, $ipwm3.hasCSSTOMSupport) && CSS ? CSS.px : "px";
var $b08ee6037077f5f0$var$ms = (0, $ipwm3.hasCSSTOMSupport) && CSS ? CSS.ms : "ms";
var $b08ee6037077f5f0$var$percent = (0, $ipwm3.hasCSSTOMSupport) && CSS ? CSS.percent : "%";
/**
 * Generated jss-plugin-default-unit CSS property units
 */ var $b08ee6037077f5f0$var$defaultUnits = {
    // Animation properties
    "animation-delay": $b08ee6037077f5f0$var$ms,
    "animation-duration": $b08ee6037077f5f0$var$ms,
    // Background properties
    "background-position": $b08ee6037077f5f0$var$px,
    "background-position-x": $b08ee6037077f5f0$var$px,
    "background-position-y": $b08ee6037077f5f0$var$px,
    "background-size": $b08ee6037077f5f0$var$px,
    // Border Properties
    border: $b08ee6037077f5f0$var$px,
    "border-bottom": $b08ee6037077f5f0$var$px,
    "border-bottom-left-radius": $b08ee6037077f5f0$var$px,
    "border-bottom-right-radius": $b08ee6037077f5f0$var$px,
    "border-bottom-width": $b08ee6037077f5f0$var$px,
    "border-left": $b08ee6037077f5f0$var$px,
    "border-left-width": $b08ee6037077f5f0$var$px,
    "border-radius": $b08ee6037077f5f0$var$px,
    "border-right": $b08ee6037077f5f0$var$px,
    "border-right-width": $b08ee6037077f5f0$var$px,
    "border-top": $b08ee6037077f5f0$var$px,
    "border-top-left-radius": $b08ee6037077f5f0$var$px,
    "border-top-right-radius": $b08ee6037077f5f0$var$px,
    "border-top-width": $b08ee6037077f5f0$var$px,
    "border-width": $b08ee6037077f5f0$var$px,
    "border-block": $b08ee6037077f5f0$var$px,
    "border-block-end": $b08ee6037077f5f0$var$px,
    "border-block-end-width": $b08ee6037077f5f0$var$px,
    "border-block-start": $b08ee6037077f5f0$var$px,
    "border-block-start-width": $b08ee6037077f5f0$var$px,
    "border-block-width": $b08ee6037077f5f0$var$px,
    "border-inline": $b08ee6037077f5f0$var$px,
    "border-inline-end": $b08ee6037077f5f0$var$px,
    "border-inline-end-width": $b08ee6037077f5f0$var$px,
    "border-inline-start": $b08ee6037077f5f0$var$px,
    "border-inline-start-width": $b08ee6037077f5f0$var$px,
    "border-inline-width": $b08ee6037077f5f0$var$px,
    "border-start-start-radius": $b08ee6037077f5f0$var$px,
    "border-start-end-radius": $b08ee6037077f5f0$var$px,
    "border-end-start-radius": $b08ee6037077f5f0$var$px,
    "border-end-end-radius": $b08ee6037077f5f0$var$px,
    // Margin properties
    margin: $b08ee6037077f5f0$var$px,
    "margin-bottom": $b08ee6037077f5f0$var$px,
    "margin-left": $b08ee6037077f5f0$var$px,
    "margin-right": $b08ee6037077f5f0$var$px,
    "margin-top": $b08ee6037077f5f0$var$px,
    "margin-block": $b08ee6037077f5f0$var$px,
    "margin-block-end": $b08ee6037077f5f0$var$px,
    "margin-block-start": $b08ee6037077f5f0$var$px,
    "margin-inline": $b08ee6037077f5f0$var$px,
    "margin-inline-end": $b08ee6037077f5f0$var$px,
    "margin-inline-start": $b08ee6037077f5f0$var$px,
    // Padding properties
    padding: $b08ee6037077f5f0$var$px,
    "padding-bottom": $b08ee6037077f5f0$var$px,
    "padding-left": $b08ee6037077f5f0$var$px,
    "padding-right": $b08ee6037077f5f0$var$px,
    "padding-top": $b08ee6037077f5f0$var$px,
    "padding-block": $b08ee6037077f5f0$var$px,
    "padding-block-end": $b08ee6037077f5f0$var$px,
    "padding-block-start": $b08ee6037077f5f0$var$px,
    "padding-inline": $b08ee6037077f5f0$var$px,
    "padding-inline-end": $b08ee6037077f5f0$var$px,
    "padding-inline-start": $b08ee6037077f5f0$var$px,
    // Mask properties
    "mask-position-x": $b08ee6037077f5f0$var$px,
    "mask-position-y": $b08ee6037077f5f0$var$px,
    "mask-size": $b08ee6037077f5f0$var$px,
    // Width and height properties
    height: $b08ee6037077f5f0$var$px,
    width: $b08ee6037077f5f0$var$px,
    "min-height": $b08ee6037077f5f0$var$px,
    "max-height": $b08ee6037077f5f0$var$px,
    "min-width": $b08ee6037077f5f0$var$px,
    "max-width": $b08ee6037077f5f0$var$px,
    // Position properties
    bottom: $b08ee6037077f5f0$var$px,
    left: $b08ee6037077f5f0$var$px,
    top: $b08ee6037077f5f0$var$px,
    right: $b08ee6037077f5f0$var$px,
    inset: $b08ee6037077f5f0$var$px,
    "inset-block": $b08ee6037077f5f0$var$px,
    "inset-block-end": $b08ee6037077f5f0$var$px,
    "inset-block-start": $b08ee6037077f5f0$var$px,
    "inset-inline": $b08ee6037077f5f0$var$px,
    "inset-inline-end": $b08ee6037077f5f0$var$px,
    "inset-inline-start": $b08ee6037077f5f0$var$px,
    // Shadow properties
    "box-shadow": $b08ee6037077f5f0$var$px,
    "text-shadow": $b08ee6037077f5f0$var$px,
    // Column properties
    "column-gap": $b08ee6037077f5f0$var$px,
    "column-rule": $b08ee6037077f5f0$var$px,
    "column-rule-width": $b08ee6037077f5f0$var$px,
    "column-width": $b08ee6037077f5f0$var$px,
    // Font and text properties
    "font-size": $b08ee6037077f5f0$var$px,
    "font-size-delta": $b08ee6037077f5f0$var$px,
    "letter-spacing": $b08ee6037077f5f0$var$px,
    "text-decoration-thickness": $b08ee6037077f5f0$var$px,
    "text-indent": $b08ee6037077f5f0$var$px,
    "text-stroke": $b08ee6037077f5f0$var$px,
    "text-stroke-width": $b08ee6037077f5f0$var$px,
    "word-spacing": $b08ee6037077f5f0$var$px,
    // Motion properties
    motion: $b08ee6037077f5f0$var$px,
    "motion-offset": $b08ee6037077f5f0$var$px,
    // Outline properties
    outline: $b08ee6037077f5f0$var$px,
    "outline-offset": $b08ee6037077f5f0$var$px,
    "outline-width": $b08ee6037077f5f0$var$px,
    // Perspective properties
    perspective: $b08ee6037077f5f0$var$px,
    "perspective-origin-x": $b08ee6037077f5f0$var$percent,
    "perspective-origin-y": $b08ee6037077f5f0$var$percent,
    // Transform properties
    "transform-origin": $b08ee6037077f5f0$var$percent,
    "transform-origin-x": $b08ee6037077f5f0$var$percent,
    "transform-origin-y": $b08ee6037077f5f0$var$percent,
    "transform-origin-z": $b08ee6037077f5f0$var$percent,
    // Transition properties
    "transition-delay": $b08ee6037077f5f0$var$ms,
    "transition-duration": $b08ee6037077f5f0$var$ms,
    // Alignment properties
    "vertical-align": $b08ee6037077f5f0$var$px,
    "flex-basis": $b08ee6037077f5f0$var$px,
    // Some random properties
    "shape-margin": $b08ee6037077f5f0$var$px,
    size: $b08ee6037077f5f0$var$px,
    gap: $b08ee6037077f5f0$var$px,
    // Grid properties
    grid: $b08ee6037077f5f0$var$px,
    "grid-gap": $b08ee6037077f5f0$var$px,
    "row-gap": $b08ee6037077f5f0$var$px,
    "grid-row-gap": $b08ee6037077f5f0$var$px,
    "grid-column-gap": $b08ee6037077f5f0$var$px,
    "grid-template-rows": $b08ee6037077f5f0$var$px,
    "grid-template-columns": $b08ee6037077f5f0$var$px,
    "grid-auto-rows": $b08ee6037077f5f0$var$px,
    "grid-auto-columns": $b08ee6037077f5f0$var$px,
    // Not existing properties.
    // Used to avoid issues with jss-plugin-expand integration.
    "box-shadow-x": $b08ee6037077f5f0$var$px,
    "box-shadow-y": $b08ee6037077f5f0$var$px,
    "box-shadow-blur": $b08ee6037077f5f0$var$px,
    "box-shadow-spread": $b08ee6037077f5f0$var$px,
    "font-line-height": $b08ee6037077f5f0$var$px,
    "text-shadow-x": $b08ee6037077f5f0$var$px,
    "text-shadow-y": $b08ee6037077f5f0$var$px,
    "text-shadow-blur": $b08ee6037077f5f0$var$px
};
/**
 * Clones the object and adds a camel cased property version.
 */ function $b08ee6037077f5f0$var$addCamelCasedVersion(obj) {
    var regExp = /(-[a-z])/g;
    var replace = function replace(str) {
        return str[1].toUpperCase();
    };
    var newObj = {};
    for(var key in obj){
        newObj[key] = obj[key];
        newObj[key.replace(regExp, replace)] = obj[key];
    }
    return newObj;
}
var $b08ee6037077f5f0$var$units = $b08ee6037077f5f0$var$addCamelCasedVersion($b08ee6037077f5f0$var$defaultUnits);
/**
 * Recursive deep style passing function
 */ function $b08ee6037077f5f0$var$iterate(prop, value, options) {
    if (value == null) return value;
    if (Array.isArray(value)) for(var i = 0; i < value.length; i++)value[i] = $b08ee6037077f5f0$var$iterate(prop, value[i], options);
    else if (typeof value === "object") {
        if (prop === "fallbacks") for(var innerProp in value)value[innerProp] = $b08ee6037077f5f0$var$iterate(innerProp, value[innerProp], options);
        else for(var _innerProp in value)value[_innerProp] = $b08ee6037077f5f0$var$iterate(prop + "-" + _innerProp, value[_innerProp], options);
         // eslint-disable-next-line no-restricted-globals
    } else if (typeof value === "number" && isNaN(value) === false) {
        var unit = options[prop] || $b08ee6037077f5f0$var$units[prop]; // Add the unit if available, except for the special case of 0px.
        if (unit && !(value === 0 && unit === $b08ee6037077f5f0$var$px)) return typeof unit === "function" ? unit(value).toString() : "" + value + unit;
        return value.toString();
    }
    return value;
}
/**
 * Add unit to numeric values.
 */ function $b08ee6037077f5f0$var$defaultUnit(options) {
    if (options === void 0) options = {};
    var camelCasedOptions = $b08ee6037077f5f0$var$addCamelCasedVersion(options);
    function onProcessStyle(style, rule) {
        if (rule.type !== "style") return style;
        for(var prop in style)style[prop] = $b08ee6037077f5f0$var$iterate(prop, style[prop], camelCasedOptions);
        return style;
    }
    function onChangeValue(value, prop) {
        return $b08ee6037077f5f0$var$iterate(prop, value, camelCasedOptions);
    }
    return {
        onProcessStyle: onProcessStyle,
        onChangeValue: onChangeValue
    };
}
var $b08ee6037077f5f0$export$2e2bcd8739ae039 = $b08ee6037077f5f0$var$defaultUnit;

});

parcelRegister("302Yl", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $22f3ad6e9ae4010b$export$2e2bcd8739ae039; });

var $9N9Yr = parcelRequire("9N9Yr");

var $ipwm3 = parcelRequire("ipwm3");
/**
 * Add vendor prefix to a property name when needed.
 */ function $22f3ad6e9ae4010b$var$jssVendorPrefixer() {
    function onProcessRule(rule) {
        if (rule.type === "keyframes") {
            var atRule = rule;
            atRule.at = (0, $9N9Yr.supportedKeyframes)(atRule.at);
        }
    }
    function prefixStyle(style) {
        for(var prop in style){
            var value = style[prop];
            if (prop === "fallbacks" && Array.isArray(value)) {
                style[prop] = value.map(prefixStyle);
                continue;
            }
            var changeProp = false;
            var supportedProp = (0, $9N9Yr.supportedProperty)(prop);
            if (supportedProp && supportedProp !== prop) changeProp = true;
            var changeValue = false;
            var supportedValue$1 = (0, $9N9Yr.supportedValue)(supportedProp, (0, $ipwm3.toCssValue)(value));
            if (supportedValue$1 && supportedValue$1 !== value) changeValue = true;
            if (changeProp || changeValue) {
                if (changeProp) delete style[prop];
                style[supportedProp || prop] = supportedValue$1 || value;
            }
        }
        return style;
    }
    function onProcessStyle(style, rule) {
        if (rule.type !== "style") return style;
        return prefixStyle(style);
    }
    function onChangeValue(value, prop) {
        return (0, $9N9Yr.supportedValue)(prop, (0, $ipwm3.toCssValue)(value)) || value;
    }
    return {
        onProcessRule: onProcessRule,
        onProcessStyle: onProcessStyle,
        onChangeValue: onChangeValue
    };
}
var $22f3ad6e9ae4010b$export$2e2bcd8739ae039 = $22f3ad6e9ae4010b$var$jssVendorPrefixer;

});
parcelRegister("9N9Yr", function(module, exports) {

$parcel$export(module.exports, "supportedKeyframes", function () { return $72106d40d165074e$export$b6aa0648d950180a; });
$parcel$export(module.exports, "supportedProperty", function () { return $72106d40d165074e$export$ce097f82c2e4551a; });
$parcel$export(module.exports, "supportedValue", function () { return $72106d40d165074e$export$511766124059c277; });

var $aGThG = parcelRequire("aGThG");

var $fYCHx = parcelRequire("fYCHx");
// Export javascript style and css style vendor prefixes.
var $72106d40d165074e$var$js = "";
var $72106d40d165074e$var$css = "";
var $72106d40d165074e$var$vendor = "";
var $72106d40d165074e$var$browser = "";
var $72106d40d165074e$var$isTouch = (0, $aGThG.default) && "ontouchstart" in document.documentElement; // We should not do anything if required serverside.
if (0, $aGThG.default) {
    // Order matters. We need to check Webkit the last one because
    // other vendors use to add Webkit prefixes to some properties
    var $72106d40d165074e$var$jsCssMap = {
        Moz: "-moz-",
        ms: "-ms-",
        O: "-o-",
        Webkit: "-webkit-"
    };
    var $72106d40d165074e$var$_document$createEleme = document.createElement("p"), $72106d40d165074e$var$style = $72106d40d165074e$var$_document$createEleme.style;
    var $72106d40d165074e$var$testProp = "Transform";
    for(var $72106d40d165074e$var$key in $72106d40d165074e$var$jsCssMap)if ($72106d40d165074e$var$key + $72106d40d165074e$var$testProp in $72106d40d165074e$var$style) {
        $72106d40d165074e$var$js = $72106d40d165074e$var$key;
        $72106d40d165074e$var$css = $72106d40d165074e$var$jsCssMap[$72106d40d165074e$var$key];
        break;
    }
     // Correctly detect the Edge browser.
    if ($72106d40d165074e$var$js === "Webkit" && "msHyphens" in $72106d40d165074e$var$style) {
        $72106d40d165074e$var$js = "ms";
        $72106d40d165074e$var$css = $72106d40d165074e$var$jsCssMap.ms;
        $72106d40d165074e$var$browser = "edge";
    } // Correctly detect the Safari browser.
    if ($72106d40d165074e$var$js === "Webkit" && "-apple-trailing-word" in $72106d40d165074e$var$style) $72106d40d165074e$var$vendor = "apple";
}
/**
 * Vendor prefix string for the current browser.
 *
 * @type {{js: String, css: String, vendor: String, browser: String}}
 * @api public
 */ var $72106d40d165074e$export$82e9f45cca5ba907 = {
    js: $72106d40d165074e$var$js,
    css: $72106d40d165074e$var$css,
    vendor: $72106d40d165074e$var$vendor,
    browser: $72106d40d165074e$var$browser,
    isTouch: $72106d40d165074e$var$isTouch
};
/**
 * Test if a keyframe at-rule should be prefixed or not
 *
 * @param {String} vendor prefix string for the current browser.
 * @return {String}
 * @api public
 */ function $72106d40d165074e$export$b6aa0648d950180a(key) {
    // Keyframes is already prefixed. e.g. key = '@-webkit-keyframes a'
    if (key[1] === "-") return key; // No need to prefix IE/Edge. Older browsers will ignore unsupported rules.
    // https://caniuse.com/#search=keyframes
    if ($72106d40d165074e$export$82e9f45cca5ba907.js === "ms") return key;
    return "@" + $72106d40d165074e$export$82e9f45cca5ba907.css + "keyframes" + key.substr(10);
}
// https://caniuse.com/#search=appearance
var $72106d40d165074e$var$appearence = {
    noPrefill: [
        "appearance"
    ],
    supportedProperty: function supportedProperty(prop) {
        if (prop !== "appearance") return false;
        if ($72106d40d165074e$export$82e9f45cca5ba907.js === "ms") return "-webkit-" + prop;
        return $72106d40d165074e$export$82e9f45cca5ba907.css + prop;
    }
};
// https://caniuse.com/#search=color-adjust
var $72106d40d165074e$var$colorAdjust = {
    noPrefill: [
        "color-adjust"
    ],
    supportedProperty: function supportedProperty(prop) {
        if (prop !== "color-adjust") return false;
        if ($72106d40d165074e$export$82e9f45cca5ba907.js === "Webkit") return $72106d40d165074e$export$82e9f45cca5ba907.css + "print-" + prop;
        return prop;
    }
};
var $72106d40d165074e$var$regExp = /[-\s]+(.)?/g;
/**
 * Replaces the letter with the capital letter
 *
 * @param {String} match
 * @param {String} c
 * @return {String}
 * @api private
 */ function $72106d40d165074e$var$toUpper(match, c) {
    return c ? c.toUpperCase() : "";
}
/**
 * Convert dash separated strings to camel-cased.
 *
 * @param {String} str
 * @return {String}
 * @api private
 */ function $72106d40d165074e$var$camelize(str) {
    return str.replace($72106d40d165074e$var$regExp, $72106d40d165074e$var$toUpper);
}
/**
 * Convert dash separated strings to pascal cased.
 *
 * @param {String} str
 * @return {String}
 * @api private
 */ function $72106d40d165074e$var$pascalize(str) {
    return $72106d40d165074e$var$camelize("-" + str);
}
// but we can use a longhand property instead.
// https://caniuse.com/#search=mask
var $72106d40d165074e$var$mask = {
    noPrefill: [
        "mask"
    ],
    supportedProperty: function supportedProperty(prop, style) {
        if (!/^mask/.test(prop)) return false;
        if ($72106d40d165074e$export$82e9f45cca5ba907.js === "Webkit") {
            var longhand = "mask-image";
            if ($72106d40d165074e$var$camelize(longhand) in style) return prop;
            if ($72106d40d165074e$export$82e9f45cca5ba907.js + $72106d40d165074e$var$pascalize(longhand) in style) return $72106d40d165074e$export$82e9f45cca5ba907.css + prop;
        }
        return prop;
    }
};
// https://caniuse.com/#search=text-orientation
var $72106d40d165074e$var$textOrientation = {
    noPrefill: [
        "text-orientation"
    ],
    supportedProperty: function supportedProperty(prop) {
        if (prop !== "text-orientation") return false;
        if ($72106d40d165074e$export$82e9f45cca5ba907.vendor === "apple" && !$72106d40d165074e$export$82e9f45cca5ba907.isTouch) return $72106d40d165074e$export$82e9f45cca5ba907.css + prop;
        return prop;
    }
};
// https://caniuse.com/#search=transform
var $72106d40d165074e$var$transform = {
    noPrefill: [
        "transform"
    ],
    supportedProperty: function supportedProperty(prop, style, options) {
        if (prop !== "transform") return false;
        if (options.transform) return prop;
        return $72106d40d165074e$export$82e9f45cca5ba907.css + prop;
    }
};
// https://caniuse.com/#search=transition
var $72106d40d165074e$var$transition = {
    noPrefill: [
        "transition"
    ],
    supportedProperty: function supportedProperty(prop, style, options) {
        if (prop !== "transition") return false;
        if (options.transition) return prop;
        return $72106d40d165074e$export$82e9f45cca5ba907.css + prop;
    }
};
// https://caniuse.com/#search=writing-mode
var $72106d40d165074e$var$writingMode = {
    noPrefill: [
        "writing-mode"
    ],
    supportedProperty: function supportedProperty(prop) {
        if (prop !== "writing-mode") return false;
        if ($72106d40d165074e$export$82e9f45cca5ba907.js === "Webkit" || $72106d40d165074e$export$82e9f45cca5ba907.js === "ms" && $72106d40d165074e$export$82e9f45cca5ba907.browser !== "edge") return $72106d40d165074e$export$82e9f45cca5ba907.css + prop;
        return prop;
    }
};
// https://caniuse.com/#search=user-select
var $72106d40d165074e$var$userSelect = {
    noPrefill: [
        "user-select"
    ],
    supportedProperty: function supportedProperty(prop) {
        if (prop !== "user-select") return false;
        if ($72106d40d165074e$export$82e9f45cca5ba907.js === "Moz" || $72106d40d165074e$export$82e9f45cca5ba907.js === "ms" || $72106d40d165074e$export$82e9f45cca5ba907.vendor === "apple") return $72106d40d165074e$export$82e9f45cca5ba907.css + prop;
        return prop;
    }
};
// https://caniuse.com/#search=multicolumn
// https://github.com/postcss/autoprefixer/issues/491
// https://github.com/postcss/autoprefixer/issues/177
var $72106d40d165074e$var$breakPropsOld = {
    supportedProperty: function supportedProperty(prop, style) {
        if (!/^break-/.test(prop)) return false;
        if ($72106d40d165074e$export$82e9f45cca5ba907.js === "Webkit") {
            var jsProp = "WebkitColumn" + $72106d40d165074e$var$pascalize(prop);
            return jsProp in style ? $72106d40d165074e$export$82e9f45cca5ba907.css + "column-" + prop : false;
        }
        if ($72106d40d165074e$export$82e9f45cca5ba907.js === "Moz") {
            var _jsProp = "page" + $72106d40d165074e$var$pascalize(prop);
            return _jsProp in style ? "page-" + prop : false;
        }
        return false;
    }
};
// See https://github.com/postcss/autoprefixer/issues/324.
var $72106d40d165074e$var$inlineLogicalOld = {
    supportedProperty: function supportedProperty(prop, style) {
        if (!/^(border|margin|padding)-inline/.test(prop)) return false;
        if ($72106d40d165074e$export$82e9f45cca5ba907.js === "Moz") return prop;
        var newProp = prop.replace("-inline", "");
        return $72106d40d165074e$export$82e9f45cca5ba907.js + $72106d40d165074e$var$pascalize(newProp) in style ? $72106d40d165074e$export$82e9f45cca5ba907.css + newProp : false;
    }
};
// Camelization is required because we can't test using.
// CSS syntax for e.g. in FF.
var $72106d40d165074e$var$unprefixed = {
    supportedProperty: function supportedProperty(prop, style) {
        return $72106d40d165074e$var$camelize(prop) in style ? prop : false;
    }
};
var $72106d40d165074e$var$prefixed = {
    supportedProperty: function supportedProperty(prop, style) {
        var pascalized = $72106d40d165074e$var$pascalize(prop); // Return custom CSS variable without prefixing.
        if (prop[0] === "-") return prop; // Return already prefixed value without prefixing.
        if (prop[0] === "-" && prop[1] === "-") return prop;
        if ($72106d40d165074e$export$82e9f45cca5ba907.js + pascalized in style) return $72106d40d165074e$export$82e9f45cca5ba907.css + prop; // Try webkit fallback.
        if ($72106d40d165074e$export$82e9f45cca5ba907.js !== "Webkit" && "Webkit" + pascalized in style) return "-webkit-" + prop;
        return false;
    }
};
// https://caniuse.com/#search=scroll-snap
var $72106d40d165074e$var$scrollSnap = {
    supportedProperty: function supportedProperty(prop) {
        if (prop.substring(0, 11) !== "scroll-snap") return false;
        if ($72106d40d165074e$export$82e9f45cca5ba907.js === "ms") return "" + $72106d40d165074e$export$82e9f45cca5ba907.css + prop;
        return prop;
    }
};
// https://caniuse.com/#search=overscroll-behavior
var $72106d40d165074e$var$overscrollBehavior = {
    supportedProperty: function supportedProperty(prop) {
        if (prop !== "overscroll-behavior") return false;
        if ($72106d40d165074e$export$82e9f45cca5ba907.js === "ms") return $72106d40d165074e$export$82e9f45cca5ba907.css + "scroll-chaining";
        return prop;
    }
};
var $72106d40d165074e$var$propMap = {
    "flex-grow": "flex-positive",
    "flex-shrink": "flex-negative",
    "flex-basis": "flex-preferred-size",
    "justify-content": "flex-pack",
    order: "flex-order",
    "align-items": "flex-align",
    "align-content": "flex-line-pack" // 'align-self' is handled by 'align-self' plugin.
}; // Support old flex spec from 2012.
var $72106d40d165074e$var$flex2012 = {
    supportedProperty: function supportedProperty(prop, style) {
        var newProp = $72106d40d165074e$var$propMap[prop];
        if (!newProp) return false;
        return $72106d40d165074e$export$82e9f45cca5ba907.js + $72106d40d165074e$var$pascalize(newProp) in style ? $72106d40d165074e$export$82e9f45cca5ba907.css + newProp : false;
    }
};
var $72106d40d165074e$var$propMap$1 = {
    flex: "box-flex",
    "flex-grow": "box-flex",
    "flex-direction": [
        "box-orient",
        "box-direction"
    ],
    order: "box-ordinal-group",
    "align-items": "box-align",
    "flex-flow": [
        "box-orient",
        "box-direction"
    ],
    "justify-content": "box-pack"
};
var $72106d40d165074e$var$propKeys = Object.keys($72106d40d165074e$var$propMap$1);
var $72106d40d165074e$var$prefixCss = function prefixCss(p) {
    return $72106d40d165074e$export$82e9f45cca5ba907.css + p;
}; // Support old flex spec from 2009.
var $72106d40d165074e$var$flex2009 = {
    supportedProperty: function supportedProperty(prop, style, _ref) {
        var multiple = _ref.multiple;
        if ($72106d40d165074e$var$propKeys.indexOf(prop) > -1) {
            var newProp = $72106d40d165074e$var$propMap$1[prop];
            if (!Array.isArray(newProp)) return $72106d40d165074e$export$82e9f45cca5ba907.js + $72106d40d165074e$var$pascalize(newProp) in style ? $72106d40d165074e$export$82e9f45cca5ba907.css + newProp : false;
            if (!multiple) return false;
            for(var i = 0; i < newProp.length; i++){
                if (!($72106d40d165074e$export$82e9f45cca5ba907.js + $72106d40d165074e$var$pascalize(newProp[0]) in style)) return false;
            }
            return newProp.map($72106d40d165074e$var$prefixCss);
        }
        return false;
    }
};
// plugins = [
//   ...plugins,
//    breakPropsOld,
//    inlineLogicalOld,
//    unprefixed,
//    prefixed,
//    scrollSnap,
//    flex2012,
//    flex2009
// ]
// Plugins without 'noPrefill' value, going last.
// 'flex-*' plugins should be at the bottom.
// 'flex2009' going after 'flex2012'.
// 'prefixed' going after 'unprefixed'
var $72106d40d165074e$var$plugins = [
    $72106d40d165074e$var$appearence,
    $72106d40d165074e$var$colorAdjust,
    $72106d40d165074e$var$mask,
    $72106d40d165074e$var$textOrientation,
    $72106d40d165074e$var$transform,
    $72106d40d165074e$var$transition,
    $72106d40d165074e$var$writingMode,
    $72106d40d165074e$var$userSelect,
    $72106d40d165074e$var$breakPropsOld,
    $72106d40d165074e$var$inlineLogicalOld,
    $72106d40d165074e$var$unprefixed,
    $72106d40d165074e$var$prefixed,
    $72106d40d165074e$var$scrollSnap,
    $72106d40d165074e$var$overscrollBehavior,
    $72106d40d165074e$var$flex2012,
    $72106d40d165074e$var$flex2009
];
var $72106d40d165074e$var$propertyDetectors = $72106d40d165074e$var$plugins.filter(function(p) {
    return p.supportedProperty;
}).map(function(p) {
    return p.supportedProperty;
});
var $72106d40d165074e$var$noPrefill = $72106d40d165074e$var$plugins.filter(function(p) {
    return p.noPrefill;
}).reduce(function(a, p) {
    a.push.apply(a, (0, $fYCHx.default)(p.noPrefill));
    return a;
}, []);
var $72106d40d165074e$var$el;
var $72106d40d165074e$var$cache = {};
if (0, $aGThG.default) {
    $72106d40d165074e$var$el = document.createElement("p"); // We test every property on vendor prefix requirement.
    // Once tested, result is cached. It gives us up to 70% perf boost.
    // http://jsperf.com/element-style-object-access-vs-plain-object
    //
    // Prefill cache with known css properties to reduce amount of
    // properties we need to feature test at runtime.
    // http://davidwalsh.name/vendor-prefix
    var $72106d40d165074e$var$computed = window.getComputedStyle(document.documentElement, "");
    for(var $72106d40d165074e$var$key$1 in $72106d40d165074e$var$computed)// eslint-disable-next-line no-restricted-globals
    if (!isNaN($72106d40d165074e$var$key$1)) $72106d40d165074e$var$cache[$72106d40d165074e$var$computed[$72106d40d165074e$var$key$1]] = $72106d40d165074e$var$computed[$72106d40d165074e$var$key$1];
     // Properties that cannot be correctly detected using the
    // cache prefill method.
    $72106d40d165074e$var$noPrefill.forEach(function(x) {
        return delete $72106d40d165074e$var$cache[x];
    });
}
/**
 * Test if a property is supported, returns supported property with vendor
 * prefix if required. Returns `false` if not supported.
 *
 * @param {String} prop dash separated
 * @param {Object} [options]
 * @return {String|Boolean}
 * @api public
 */ function $72106d40d165074e$export$ce097f82c2e4551a(prop, options) {
    if (options === void 0) options = {};
    // For server-side rendering.
    if (!$72106d40d165074e$var$el) return prop; // Remove cache for benchmark tests or return property from the cache.
    if ($72106d40d165074e$var$cache[prop] != null) return $72106d40d165074e$var$cache[prop];
     // Check if 'transition' or 'transform' natively supported in browser.
    if (prop === "transition" || prop === "transform") options[prop] = prop in $72106d40d165074e$var$el.style;
     // Find a plugin for current prefix property.
    for(var i = 0; i < $72106d40d165074e$var$propertyDetectors.length; i++){
        $72106d40d165074e$var$cache[prop] = $72106d40d165074e$var$propertyDetectors[i](prop, $72106d40d165074e$var$el.style, options); // Break loop, if value found.
        if ($72106d40d165074e$var$cache[prop]) break;
    } // Reset styles for current property.
    // Firefox can even throw an error for invalid properties, e.g., "0".
    try {
        $72106d40d165074e$var$el.style[prop] = "";
    } catch (err) {
        return false;
    }
    return $72106d40d165074e$var$cache[prop];
}
var $72106d40d165074e$var$cache$1 = {};
var $72106d40d165074e$var$transitionProperties = {
    transition: 1,
    "transition-property": 1,
    "-webkit-transition": 1,
    "-webkit-transition-property": 1
};
var $72106d40d165074e$var$transPropsRegExp = /(^\s*[\w-]+)|, (\s*[\w-]+)(?![^()]*\))/g;
var $72106d40d165074e$var$el$1;
/**
 * Returns prefixed value transition/transform if needed.
 *
 * @param {String} match
 * @param {String} p1
 * @param {String} p2
 * @return {String}
 * @api private
 */ function $72106d40d165074e$var$prefixTransitionCallback(match, p1, p2) {
    if (p1 === "var") return "var";
    if (p1 === "all") return "all";
    if (p2 === "all") return ", all";
    var prefixedValue = p1 ? $72106d40d165074e$export$ce097f82c2e4551a(p1) : ", " + $72106d40d165074e$export$ce097f82c2e4551a(p2);
    if (!prefixedValue) return p1 || p2;
    return prefixedValue;
}
if (0, $aGThG.default) $72106d40d165074e$var$el$1 = document.createElement("p");
/**
 * Returns prefixed value if needed. Returns `false` if value is not supported.
 *
 * @param {String} property
 * @param {String} value
 * @return {String|Boolean}
 * @api public
 */ function $72106d40d165074e$export$511766124059c277(property, value) {
    // For server-side rendering.
    var prefixedValue = value;
    if (!$72106d40d165074e$var$el$1 || property === "content") return value; // It is a string or a number as a string like '1'.
    // We want only prefixable values here.
    // eslint-disable-next-line no-restricted-globals
    if (typeof prefixedValue !== "string" || !isNaN(parseInt(prefixedValue, 10))) return prefixedValue;
     // Create cache key for current value.
    var cacheKey = property + prefixedValue; // Remove cache for benchmark tests or return value from cache.
    if ($72106d40d165074e$var$cache$1[cacheKey] != null) return $72106d40d165074e$var$cache$1[cacheKey];
     // IE can even throw an error in some cases, for e.g. style.content = 'bar'.
    try {
        // Test value as it is.
        $72106d40d165074e$var$el$1.style[property] = prefixedValue;
    } catch (err) {
        // Return false if value not supported.
        $72106d40d165074e$var$cache$1[cacheKey] = false;
        return false;
    } // If 'transition' or 'transition-property' property.
    if ($72106d40d165074e$var$transitionProperties[property]) prefixedValue = prefixedValue.replace($72106d40d165074e$var$transPropsRegExp, $72106d40d165074e$var$prefixTransitionCallback);
    else if ($72106d40d165074e$var$el$1.style[property] === "") {
        // Value with a vendor prefix.
        prefixedValue = $72106d40d165074e$export$82e9f45cca5ba907.css + prefixedValue; // Hardcode test to convert "flex" to "-ms-flexbox" for IE10.
        if (prefixedValue === "-ms-flex") $72106d40d165074e$var$el$1.style[property] = "-ms-flexbox"; // Test prefixed value.
        $72106d40d165074e$var$el$1.style[property] = prefixedValue; // Return false if value not supported.
        if ($72106d40d165074e$var$el$1.style[property] === "") {
            $72106d40d165074e$var$cache$1[cacheKey] = false;
            return false;
        }
    } // Reset styles for current property.
    $72106d40d165074e$var$el$1.style[property] = ""; // Write current value to cache.
    $72106d40d165074e$var$cache$1[cacheKey] = prefixedValue;
    return $72106d40d165074e$var$cache$1[cacheKey];
}

});
parcelRegister("fYCHx", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ba1a7ae3e4bf0e26$export$2e2bcd8739ae039; });

var $8HlD9 = parcelRequire("8HlD9");

var $elYkf = parcelRequire("elYkf");

var $hvqJQ = parcelRequire("hvqJQ");

var $awOnb = parcelRequire("awOnb");
function $ba1a7ae3e4bf0e26$export$2e2bcd8739ae039(arr) {
    return (0, $8HlD9.default)(arr) || (0, $elYkf.default)(arr) || (0, $hvqJQ.default)(arr) || (0, $awOnb.default)();
}

});
parcelRegister("8HlD9", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $65531e437642a083$export$2e2bcd8739ae039; });

var $7wbf1 = parcelRequire("7wbf1");
function $65531e437642a083$export$2e2bcd8739ae039(arr) {
    if (Array.isArray(arr)) return (0, $7wbf1.default)(arr);
}

});
parcelRegister("7wbf1", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $57943dd3d9447bb2$export$2e2bcd8739ae039; });
function $57943dd3d9447bb2$export$2e2bcd8739ae039(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}

});


parcelRegister("elYkf", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a731d24472956bbc$export$2e2bcd8739ae039; });
function $a731d24472956bbc$export$2e2bcd8739ae039(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}

});

parcelRegister("hvqJQ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $cbea129a04028f02$export$2e2bcd8739ae039; });

var $7wbf1 = parcelRequire("7wbf1");
function $cbea129a04028f02$export$2e2bcd8739ae039(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return (0, $7wbf1.default)(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return (0, $7wbf1.default)(o, minLen);
}

});

parcelRegister("awOnb", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7aa3f7903d15eb9c$export$2e2bcd8739ae039; });
function $7aa3f7903d15eb9c$export$2e2bcd8739ae039() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

});




parcelRegister("efFhT", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a6027e40a356f9cf$export$2e2bcd8739ae039; });
/**
 * Sort props by length.
 */ function $a6027e40a356f9cf$var$jssPropsSort() {
    var sort = function sort(prop0, prop1) {
        if (prop0.length === prop1.length) return prop0 > prop1 ? 1 : -1;
        return prop0.length - prop1.length;
    };
    return {
        onProcessStyle: function onProcessStyle(style, rule) {
            if (rule.type !== "style") return style;
            var newStyle = {};
            var props = Object.keys(style).sort(sort);
            for(var i = 0; i < props.length; i++)newStyle[props[i]] = style[props[i]];
            return newStyle;
        }
    };
}
var $a6027e40a356f9cf$export$2e2bcd8739ae039 = $a6027e40a356f9cf$var$jssPropsSort;

});



parcelRegister("a4mPI", function(module, exports) {

$parcel$export(module.exports, "increment", function () { return $754bfd437ef97723$export$a2647aa13413c947; });
/* eslint-disable import/prefer-default-export */ // Global index counter to preserve source order.
// We create the style sheet during the creation of the component,
// children are handled after the parents, so the order of style elements would be parent->child.
// It is a problem though when a parent passes a className
// which needs to override any child's styles.
// StyleSheet of the child has a higher specificity, because of the source order.
// So our solution is to render sheets them in the reverse order child->sheet, so
// that parent has a higher specificity.
var $754bfd437ef97723$var$indexCounter = -1000000000;
function $754bfd437ef97723$export$a2647aa13413c947() {
    $754bfd437ef97723$var$indexCounter += 1;
    if ($754bfd437ef97723$var$indexCounter >= 0) console.warn([
        "Material-UI: You might have a memory leak.",
        "The indexCounter is not supposed to grow that much."
    ].join("\n"));
    return $754bfd437ef97723$var$indexCounter;
}

});

parcelRegister("96kaR", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6a0452c6c6c25f78$export$2e2bcd8739ae039; });

var $815Xb = parcelRequire("815Xb");

var $ki4MK = parcelRequire("ki4MK");

var $kt6Ie = parcelRequire("kt6Ie");

var $ks5BK = parcelRequire("ks5BK");
function $6a0452c6c6c25f78$export$2e2bcd8739ae039(stylesOrCreator) {
    var themingEnabled = typeof stylesOrCreator === "function";
    if ((0, $ki4MK.default)(stylesOrCreator) !== "object" && !themingEnabled) console.error([
        "Material-UI: The `styles` argument provided is invalid.",
        "You need to provide a function generating the styles or a styles object."
    ].join("\n"));
    return {
        create: function create(theme, name) {
            var styles;
            try {
                styles = themingEnabled ? stylesOrCreator(theme) : stylesOrCreator;
            } catch (err) {
                if (themingEnabled === true && theme === (0, $ks5BK.default)) // TODO: prepend error message/name instead
                console.error([
                    "Material-UI: The `styles` argument provided is invalid.",
                    "You are providing a function without a theme in the context.",
                    "One of the parent elements needs to use a ThemeProvider."
                ].join("\n"));
                throw err;
            }
            if (!name || !theme.overrides || !theme.overrides[name]) return styles;
            var overrides = theme.overrides[name];
            var stylesWithOverrides = (0, $815Xb.default)({}, styles);
            Object.keys(overrides).forEach(function(key) {
                if (!stylesWithOverrides[key]) console.warn([
                    "Material-UI: You are trying to override a style that does not exist.",
                    "Fix the `".concat(key, "` key of `theme.overrides.").concat(name, "`.")
                ].join("\n"));
                stylesWithOverrides[key] = (0, $kt6Ie.default)(stylesWithOverrides[key], overrides[key]);
            });
            return stylesWithOverrides;
        },
        options: {}
    };
}

});
parcelRegister("ki4MK", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ec59335c238fe2d2$export$2e2bcd8739ae039; });
function $ec59335c238fe2d2$export$2e2bcd8739ae039(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $ec59335c238fe2d2$export$2e2bcd8739ae039 = function _typeof(obj) {
        return typeof obj;
    };
    else $ec59335c238fe2d2$export$2e2bcd8739ae039 = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $ec59335c238fe2d2$export$2e2bcd8739ae039(obj);
}

});

parcelRegister("kt6Ie", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ee6bb90bb1e42d0a$export$2e2bcd8739ae039; });

var $9CubZ = parcelRequire("9CubZ");

var $l7JxS = parcelRequire("l7JxS");
function $ee6bb90bb1e42d0a$export$53b83ca8eaab0383(item) {
    return item && (0, $l7JxS.default)(item) === "object" && item.constructor === Object;
}
function $ee6bb90bb1e42d0a$export$2e2bcd8739ae039(target, source) {
    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {
        clone: true
    };
    var output = options.clone ? (0, $9CubZ.default)({}, target) : target;
    if ($ee6bb90bb1e42d0a$export$53b83ca8eaab0383(target) && $ee6bb90bb1e42d0a$export$53b83ca8eaab0383(source)) Object.keys(source).forEach(function(key) {
        // Avoid prototype pollution
        if (key === "__proto__") return;
        if ($ee6bb90bb1e42d0a$export$53b83ca8eaab0383(source[key]) && key in target) output[key] = $ee6bb90bb1e42d0a$export$2e2bcd8739ae039(target[key], source[key], options);
        else output[key] = source[key];
    });
    return output;
}

});

parcelRegister("ks5BK", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ee3ac5c719b4f330$export$2e2bcd8739ae039; });
// We use the same empty object to ref count the styles that don't need a theme object.
var $ee3ac5c719b4f330$var$noopTheme = {};
var $ee3ac5c719b4f330$export$2e2bcd8739ae039 = $ee3ac5c719b4f330$var$noopTheme;

});



parcelRegister("szrnD", function(module, exports) {

$parcel$export(module.exports, "Provider", function () { return $055e1b686e8e9f5d$export$2881499e37b75b9a; });
$parcel$export(module.exports, "Context", function () { return $055e1b686e8e9f5d$export$841858b892ce1f4c; });
$parcel$export(module.exports, "default", function () { return $055e1b686e8e9f5d$export$2e2bcd8739ae039; });

var $gb4K1 = parcelRequire("gb4K1");

var $cQNHH = parcelRequire("cQNHH");

var $aoqh7 = parcelRequire("aoqh7");

var $2KDk6 = parcelRequire("2KDk6");
function $055e1b686e8e9f5d$var$getDisplayName(Component) {
    return Component.displayName || Component.name || "Component";
}
// This is primarily dealing with packaging systems where multiple copies of react-intl
// might exist
var $055e1b686e8e9f5d$var$IntlContext = typeof window !== "undefined" && !window.__REACT_INTL_BYPASS_GLOBAL_CONTEXT__ ? window.__REACT_INTL_CONTEXT__ || (window.__REACT_INTL_CONTEXT__ = $cQNHH.createContext(null)) : $cQNHH.createContext(null);
var $055e1b686e8e9f5d$var$IntlConsumer = $055e1b686e8e9f5d$var$IntlContext.Consumer, $055e1b686e8e9f5d$var$IntlProvider = $055e1b686e8e9f5d$var$IntlContext.Provider;
var $055e1b686e8e9f5d$export$2881499e37b75b9a = $055e1b686e8e9f5d$var$IntlProvider;
var $055e1b686e8e9f5d$export$841858b892ce1f4c = $055e1b686e8e9f5d$var$IntlContext;
function $055e1b686e8e9f5d$export$2e2bcd8739ae039(WrappedComponent, options) {
    var _a = options || {}, _b = _a.intlPropName, intlPropName = _b === void 0 ? "intl" : _b, _c = _a.forwardRef, forwardRef = _c === void 0 ? false : _c, _d = _a.enforceContext, enforceContext = _d === void 0 ? true : _d;
    var WithIntl = function(props) {
        return $cQNHH.createElement($055e1b686e8e9f5d$var$IntlConsumer, null, function(intl) {
            var _a;
            if (enforceContext) (0, $2KDk6.invariantIntlContext)(intl);
            var intlProp = (_a = {}, _a[intlPropName] = intl, _a);
            return $cQNHH.createElement(WrappedComponent, (0, $gb4K1.__assign)({}, props, intlProp, {
                ref: forwardRef ? props.forwardedRef : null
            }));
        });
    };
    WithIntl.displayName = "injectIntl(".concat($055e1b686e8e9f5d$var$getDisplayName(WrappedComponent), ")");
    WithIntl.WrappedComponent = WrappedComponent;
    if (forwardRef) return (0, (/*@__PURE__*/$parcel$interopDefault($aoqh7)))($cQNHH.forwardRef(function(props, ref) {
        return $cQNHH.createElement(WithIntl, (0, $gb4K1.__assign)({}, props, {
            forwardedRef: ref
        }));
    }), WrappedComponent);
    return (0, (/*@__PURE__*/$parcel$interopDefault($aoqh7)))(WithIntl, WrappedComponent);
}

});
parcelRegister("gb4K1", function(module, exports) {

$parcel$export(module.exports, "__extends", function () { return $bc7159ecac4d4618$export$a8ba968b8961cb8a; });
$parcel$export(module.exports, "__assign", function () { return $bc7159ecac4d4618$export$18ce0697a983be9b; });
$parcel$export(module.exports, "__rest", function () { return $bc7159ecac4d4618$export$3c9a16f847548506; });
$parcel$export(module.exports, "__spreadArray", function () { return $bc7159ecac4d4618$export$1216008129fb82ed; });
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise, SuppressedError, Symbol */ var $bc7159ecac4d4618$var$extendStatics = function(d, b) {
    $bc7159ecac4d4618$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return $bc7159ecac4d4618$var$extendStatics(d, b);
};
function $bc7159ecac4d4618$export$a8ba968b8961cb8a(d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    $bc7159ecac4d4618$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $bc7159ecac4d4618$export$18ce0697a983be9b = function() {
    $bc7159ecac4d4618$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $bc7159ecac4d4618$export$18ce0697a983be9b.apply(this, arguments);
};
function $bc7159ecac4d4618$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $bc7159ecac4d4618$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $bc7159ecac4d4618$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $bc7159ecac4d4618$export$3a84e1ae4e97e9b0(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
}
function $bc7159ecac4d4618$export$d831c04e792af3d(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
}
function $bc7159ecac4d4618$export$6a2a36740a146cb8(x) {
    return typeof x === "symbol" ? x : "".concat(x);
}
function $bc7159ecac4d4618$export$d1a06452d3489bc7(f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
}
function $bc7159ecac4d4618$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $bc7159ecac4d4618$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $bc7159ecac4d4618$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var $bc7159ecac4d4618$export$45d3717a4c69092e = Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
};
function $bc7159ecac4d4618$export$f33643c0debef087(m, o) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) $bc7159ecac4d4618$export$45d3717a4c69092e(o, m, p);
}
function $bc7159ecac4d4618$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $bc7159ecac4d4618$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $bc7159ecac4d4618$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($bc7159ecac4d4618$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $bc7159ecac4d4618$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $bc7159ecac4d4618$export$1216008129fb82ed(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}
function $bc7159ecac4d4618$export$10c90e4f7922046c(v) {
    return this instanceof $bc7159ecac4d4618$export$10c90e4f7922046c ? (this.v = v, this) : new $bc7159ecac4d4618$export$10c90e4f7922046c(v);
}
function $bc7159ecac4d4618$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $bc7159ecac4d4618$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $bc7159ecac4d4618$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $bc7159ecac4d4618$export$10c90e4f7922046c(o[n](v)),
                done: false
            } : f ? f(v) : v;
        } : f;
    }
}
function $bc7159ecac4d4618$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $bc7159ecac4d4618$export$19a8beecd37a4c45 === "function" ? $bc7159ecac4d4618$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $bc7159ecac4d4618$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
var $bc7159ecac4d4618$var$__setModuleDefault = Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
};
function $bc7159ecac4d4618$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $bc7159ecac4d4618$export$45d3717a4c69092e(result, mod, k);
    }
    $bc7159ecac4d4618$var$__setModuleDefault(result, mod);
    return result;
}
function $bc7159ecac4d4618$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $bc7159ecac4d4618$export$d5dcaf168c640c35(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}
function $bc7159ecac4d4618$export$d40a35129aaff81f(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
}
function $bc7159ecac4d4618$export$81fdc39f203e4e04(state, receiver) {
    if (receiver === null || typeof receiver !== "object" && typeof receiver !== "function") throw new TypeError("Cannot use 'in' operator on non-object");
    return typeof state === "function" ? receiver === state : state.has(receiver);
}
function $bc7159ecac4d4618$export$88ac25d8e944e405(env, value, async) {
    if (value !== null && value !== void 0) {
        if (typeof value !== "object" && typeof value !== "function") throw new TypeError("Object expected.");
        var dispose;
        if (async) {
            if (!Symbol.asyncDispose) throw new TypeError("Symbol.asyncDispose is not defined.");
            dispose = value[Symbol.asyncDispose];
        }
        if (dispose === void 0) {
            if (!Symbol.dispose) throw new TypeError("Symbol.dispose is not defined.");
            dispose = value[Symbol.dispose];
        }
        if (typeof dispose !== "function") throw new TypeError("Object not disposable.");
        env.stack.push({
            value: value,
            dispose: dispose,
            async: async
        });
    } else if (async) env.stack.push({
        async: true
    });
    return value;
}
var $bc7159ecac4d4618$var$_SuppressedError = typeof SuppressedError === "function" ? SuppressedError : function(error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};
function $bc7159ecac4d4618$export$8f076105dc360e92(env) {
    function fail(e) {
        env.error = env.hasError ? new $bc7159ecac4d4618$var$_SuppressedError(e, env.error, "An error was suppressed during disposal.") : e;
        env.hasError = true;
    }
    function next() {
        while(env.stack.length){
            var rec = env.stack.pop();
            try {
                var result = rec.dispose && rec.dispose.call(rec.value);
                if (rec.async) return Promise.resolve(result).then(next, function(e) {
                    fail(e);
                    return next();
                });
            } catch (e) {
                fail(e);
            }
        }
        if (env.hasError) throw env.error;
    }
    return next();
}
var $bc7159ecac4d4618$export$2e2bcd8739ae039 = {
    __extends: $bc7159ecac4d4618$export$a8ba968b8961cb8a,
    __assign: $bc7159ecac4d4618$export$18ce0697a983be9b,
    __rest: $bc7159ecac4d4618$export$3c9a16f847548506,
    __decorate: $bc7159ecac4d4618$export$29e00dfd3077644b,
    __param: $bc7159ecac4d4618$export$d5ad3fd78186038f,
    __metadata: $bc7159ecac4d4618$export$f1db080c865becb9,
    __awaiter: $bc7159ecac4d4618$export$1050f835b63b671e,
    __generator: $bc7159ecac4d4618$export$67ebef60e6f28a6,
    __createBinding: $bc7159ecac4d4618$export$45d3717a4c69092e,
    __exportStar: $bc7159ecac4d4618$export$f33643c0debef087,
    __values: $bc7159ecac4d4618$export$19a8beecd37a4c45,
    __read: $bc7159ecac4d4618$export$8d051b38c9118094,
    __spread: $bc7159ecac4d4618$export$afc72e2116322959,
    __spreadArrays: $bc7159ecac4d4618$export$6388937ca91ccae8,
    __spreadArray: $bc7159ecac4d4618$export$1216008129fb82ed,
    __await: $bc7159ecac4d4618$export$10c90e4f7922046c,
    __asyncGenerator: $bc7159ecac4d4618$export$e427f37a30a4de9b,
    __asyncDelegator: $bc7159ecac4d4618$export$bbd80228419bb833,
    __asyncValues: $bc7159ecac4d4618$export$e3b29a3d6162315f,
    __makeTemplateObject: $bc7159ecac4d4618$export$4fb47efe1390b86f,
    __importStar: $bc7159ecac4d4618$export$c21735bcef00d192,
    __importDefault: $bc7159ecac4d4618$export$da59b14a69baef04,
    __classPrivateFieldGet: $bc7159ecac4d4618$export$d5dcaf168c640c35,
    __classPrivateFieldSet: $bc7159ecac4d4618$export$d40a35129aaff81f,
    __classPrivateFieldIn: $bc7159ecac4d4618$export$81fdc39f203e4e04,
    __addDisposableResource: $bc7159ecac4d4618$export$88ac25d8e944e405,
    __disposeResources: $bc7159ecac4d4618$export$8f076105dc360e92
};

});

parcelRegister("aoqh7", function(module, exports) {
"use strict";

var $4EmWC = parcelRequire("4EmWC");
/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */ var $791086f2059ab2e4$var$REACT_STATICS = {
    childContextTypes: true,
    contextType: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    getDerivedStateFromError: true,
    getDerivedStateFromProps: true,
    mixins: true,
    propTypes: true,
    type: true
};
var $791086f2059ab2e4$var$KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    callee: true,
    arguments: true,
    arity: true
};
var $791086f2059ab2e4$var$FORWARD_REF_STATICS = {
    "$$typeof": true,
    render: true,
    defaultProps: true,
    displayName: true,
    propTypes: true
};
var $791086f2059ab2e4$var$MEMO_STATICS = {
    "$$typeof": true,
    compare: true,
    defaultProps: true,
    displayName: true,
    propTypes: true,
    type: true
};
var $791086f2059ab2e4$var$TYPE_STATICS = {};
$791086f2059ab2e4$var$TYPE_STATICS[$4EmWC.ForwardRef] = $791086f2059ab2e4$var$FORWARD_REF_STATICS;
$791086f2059ab2e4$var$TYPE_STATICS[$4EmWC.Memo] = $791086f2059ab2e4$var$MEMO_STATICS;
function $791086f2059ab2e4$var$getStatics(component) {
    // React v16.11 and below
    if ($4EmWC.isMemo(component)) return $791086f2059ab2e4$var$MEMO_STATICS;
     // React v16.12 and above
    return $791086f2059ab2e4$var$TYPE_STATICS[component["$$typeof"]] || $791086f2059ab2e4$var$REACT_STATICS;
}
var $791086f2059ab2e4$var$defineProperty = Object.defineProperty;
var $791086f2059ab2e4$var$getOwnPropertyNames = Object.getOwnPropertyNames;
var $791086f2059ab2e4$var$getOwnPropertySymbols = Object.getOwnPropertySymbols;
var $791086f2059ab2e4$var$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var $791086f2059ab2e4$var$getPrototypeOf = Object.getPrototypeOf;
var $791086f2059ab2e4$var$objectPrototype = Object.prototype;
function $791086f2059ab2e4$var$hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
    if (typeof sourceComponent !== "string") {
        // don't hoist over string (html) components
        if ($791086f2059ab2e4$var$objectPrototype) {
            var inheritedComponent = $791086f2059ab2e4$var$getPrototypeOf(sourceComponent);
            if (inheritedComponent && inheritedComponent !== $791086f2059ab2e4$var$objectPrototype) $791086f2059ab2e4$var$hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
        }
        var keys = $791086f2059ab2e4$var$getOwnPropertyNames(sourceComponent);
        if ($791086f2059ab2e4$var$getOwnPropertySymbols) keys = keys.concat($791086f2059ab2e4$var$getOwnPropertySymbols(sourceComponent));
        var targetStatics = $791086f2059ab2e4$var$getStatics(targetComponent);
        var sourceStatics = $791086f2059ab2e4$var$getStatics(sourceComponent);
        for(var i = 0; i < keys.length; ++i){
            var key = keys[i];
            if (!$791086f2059ab2e4$var$KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
                var descriptor = $791086f2059ab2e4$var$getOwnPropertyDescriptor(sourceComponent, key);
                try {
                    // Avoid failures from read-only properties
                    $791086f2059ab2e4$var$defineProperty(targetComponent, key, descriptor);
                } catch (e) {}
            }
        }
    }
    return targetComponent;
}
module.exports = $791086f2059ab2e4$var$hoistNonReactStatics;

});

parcelRegister("2KDk6", function(module, exports) {

$parcel$export(module.exports, "invariantIntlContext", function () { return $200e617138395888$export$45c4bbf6e55bba1f; });
$parcel$export(module.exports, "DEFAULT_INTL_CONFIG", function () { return $200e617138395888$export$b52f8d6fc0d47415; });
$parcel$export(module.exports, "assignUniqueKeysToParts", function () { return $200e617138395888$export$cfec03d26465fa63; });
$parcel$export(module.exports, "shallowEqual", function () { return $200e617138395888$export$d36bdfa510afb180; });

var $gb4K1 = parcelRequire("gb4K1");

var $cQNHH = parcelRequire("cQNHH");

var $gvCUa = parcelRequire("gvCUa");

var $5VJfG = parcelRequire("5VJfG");
function $200e617138395888$export$45c4bbf6e55bba1f(intl) {
    (0, $gvCUa.invariant)(intl, "[React Intl] Could not find required `intl` object. <IntlProvider> needs to exist in the component ancestry.");
}
var $200e617138395888$export$b52f8d6fc0d47415 = (0, $gb4K1.__assign)((0, $gb4K1.__assign)({}, (0, $5VJfG.DEFAULT_INTL_CONFIG)), {
    textComponent: $cQNHH.Fragment
});
function $200e617138395888$export$cfec03d26465fa63(formatXMLElementFn) {
    return function(parts) {
        // eslint-disable-next-line prefer-rest-params
        return formatXMLElementFn($cQNHH.Children.toArray(parts));
    };
}
function $200e617138395888$export$d36bdfa510afb180(objA, objB) {
    if (objA === objB) return true;
    if (!objA || !objB) return false;
    var aKeys = Object.keys(objA);
    var bKeys = Object.keys(objB);
    var len = aKeys.length;
    if (bKeys.length !== len) return false;
    for(var i = 0; i < len; i++){
        var key = aKeys[i];
        if (objA[key] !== objB[key] || !Object.prototype.hasOwnProperty.call(objB, key)) return false;
    }
    return true;
}

});
parcelRegister("gvCUa", function(module, exports) {

$parcel$export(module.exports, "invariant", function () { return $c04db85177ba69df$export$f5708dca728d7177; });
/**
 * Cannot do Math.log(x) / Math.log(10) bc if IEEE floating point issue
 * @param x number
 */ function $c04db85177ba69df$export$f535bb00660c42db(x) {
    // Cannot count string length via Number.toString because it may use scientific notation
    // for very small or very large numbers.
    return Math.floor(Math.log(x) * Math.LOG10E);
}
function $c04db85177ba69df$export$76d90c956114f2c2(s, times) {
    if (typeof s.repeat === "function") return s.repeat(times);
    var arr = new Array(times);
    for(var i = 0; i < arr.length; i++)arr[i] = s;
    return arr.join("");
}
function $c04db85177ba69df$export$489176b9ebc725cc(map, pl, field, value) {
    if (!map.get(pl)) map.set(pl, Object.create(null));
    var slots = map.get(pl);
    slots[field] = value;
}
function $c04db85177ba69df$export$d21499e79b5c28e2(map, pl, props) {
    for(var _i = 0, _a = Object.keys(props); _i < _a.length; _i++){
        var k = _a[_i];
        $c04db85177ba69df$export$489176b9ebc725cc(map, pl, k, props[k]);
    }
}
function $c04db85177ba69df$export$3fae2929ed23c202(map, pl, field) {
    return $c04db85177ba69df$export$ca4e2274c058dd9f(map, pl, field)[field];
}
function $c04db85177ba69df$export$ca4e2274c058dd9f(map, pl) {
    var fields = [];
    for(var _i = 2; _i < arguments.length; _i++)fields[_i - 2] = arguments[_i];
    var slots = map.get(pl);
    if (!slots) throw new TypeError("".concat(pl, " InternalSlot has not been initialized"));
    return fields.reduce(function(all, f) {
        all[f] = slots[f];
        return all;
    }, Object.create(null));
}
function $c04db85177ba69df$export$25c75e09b890f24e(patternPart) {
    return patternPart.type === "literal";
}
function $c04db85177ba69df$export$fdab3c20aae16ddf(target, name, _a) {
    var value = _a.value;
    Object.defineProperty(target, name, {
        configurable: true,
        enumerable: false,
        writable: true,
        value: value
    });
}
var $c04db85177ba69df$export$9049a02e759202e4 = /-u(?:-[0-9a-z]{2,8})+/gi;
function $c04db85177ba69df$export$f5708dca728d7177(condition, message, Err) {
    if (Err === void 0) Err = Error;
    if (!condition) throw new Err(message);
}

});

parcelRegister("5VJfG", function(module, exports) {

$parcel$export(module.exports, "filterProps", function () { return $451560b32c66f622$export$d697c39a2985a4c; });
$parcel$export(module.exports, "DEFAULT_INTL_CONFIG", function () { return $451560b32c66f622$export$b52f8d6fc0d47415; });
$parcel$export(module.exports, "createIntlCache", function () { return $451560b32c66f622$export$51c4f4e973f2dc00; });
$parcel$export(module.exports, "createFormatters", function () { return $451560b32c66f622$export$c3f4cd5551df13fd; });
$parcel$export(module.exports, "getNamedFormat", function () { return $451560b32c66f622$export$4ee1db8ce44a209b; });

var $gb4K1 = parcelRequire("gb4K1");
parcelRequire("iTKsw");
var $4kwTT = parcelRequire("4kwTT");

var $bX0Gd = parcelRequire("bX0Gd");

var $dCg2n = parcelRequire("dCg2n");
function $451560b32c66f622$export$d697c39a2985a4c(props, allowlist, defaults) {
    if (defaults === void 0) defaults = {};
    return allowlist.reduce(function(filtered, name) {
        if (name in props) filtered[name] = props[name];
        else if (name in defaults) filtered[name] = defaults[name];
        return filtered;
    }, {});
}
var $451560b32c66f622$var$defaultErrorHandler = function(error) {
    console.error(error);
};
var $451560b32c66f622$var$defaultWarnHandler = function(warning) {
    console.warn(warning);
};
var $451560b32c66f622$export$b52f8d6fc0d47415 = {
    formats: {},
    messages: {},
    timeZone: undefined,
    defaultLocale: "en",
    defaultFormats: {},
    fallbackOnEmptyString: true,
    onError: $451560b32c66f622$var$defaultErrorHandler,
    onWarn: $451560b32c66f622$var$defaultWarnHandler
};
function $451560b32c66f622$export$51c4f4e973f2dc00() {
    return {
        dateTime: {},
        number: {},
        message: {},
        relativeTime: {},
        pluralRules: {},
        list: {},
        displayNames: {}
    };
}
function $451560b32c66f622$var$createFastMemoizeCache(store) {
    return {
        create: function() {
            return {
                get: function(key) {
                    return store[key];
                },
                set: function(key, value) {
                    store[key] = value;
                }
            };
        }
    };
}
function $451560b32c66f622$export$c3f4cd5551df13fd(cache) {
    if (cache === void 0) cache = $451560b32c66f622$export$51c4f4e973f2dc00();
    var RelativeTimeFormat = Intl.RelativeTimeFormat;
    var ListFormat = Intl.ListFormat;
    var DisplayNames = Intl.DisplayNames;
    var getDateTimeFormat = (0, $bX0Gd.memoize)(function() {
        var _a;
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        return new ((_a = Intl.DateTimeFormat).bind.apply(_a, (0, $gb4K1.__spreadArray)([
            void 0
        ], args, false)))();
    }, {
        cache: $451560b32c66f622$var$createFastMemoizeCache(cache.dateTime),
        strategy: (0, $bX0Gd.strategies).variadic
    });
    var getNumberFormat = (0, $bX0Gd.memoize)(function() {
        var _a;
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        return new ((_a = Intl.NumberFormat).bind.apply(_a, (0, $gb4K1.__spreadArray)([
            void 0
        ], args, false)))();
    }, {
        cache: $451560b32c66f622$var$createFastMemoizeCache(cache.number),
        strategy: (0, $bX0Gd.strategies).variadic
    });
    var getPluralRules = (0, $bX0Gd.memoize)(function() {
        var _a;
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        return new ((_a = Intl.PluralRules).bind.apply(_a, (0, $gb4K1.__spreadArray)([
            void 0
        ], args, false)))();
    }, {
        cache: $451560b32c66f622$var$createFastMemoizeCache(cache.pluralRules),
        strategy: (0, $bX0Gd.strategies).variadic
    });
    return {
        getDateTimeFormat: getDateTimeFormat,
        getNumberFormat: getNumberFormat,
        getMessageFormat: (0, $bX0Gd.memoize)(function(message, locales, overrideFormats, opts) {
            return new (0, $4kwTT.IntlMessageFormat)(message, locales, overrideFormats, (0, $gb4K1.__assign)({
                formatters: {
                    getNumberFormat: getNumberFormat,
                    getDateTimeFormat: getDateTimeFormat,
                    getPluralRules: getPluralRules
                }
            }, opts || {}));
        }, {
            cache: $451560b32c66f622$var$createFastMemoizeCache(cache.message),
            strategy: (0, $bX0Gd.strategies).variadic
        }),
        getRelativeTimeFormat: (0, $bX0Gd.memoize)(function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            return new (RelativeTimeFormat.bind.apply(RelativeTimeFormat, (0, $gb4K1.__spreadArray)([
                void 0
            ], args, false)))();
        }, {
            cache: $451560b32c66f622$var$createFastMemoizeCache(cache.relativeTime),
            strategy: (0, $bX0Gd.strategies).variadic
        }),
        getPluralRules: getPluralRules,
        getListFormat: (0, $bX0Gd.memoize)(function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            return new (ListFormat.bind.apply(ListFormat, (0, $gb4K1.__spreadArray)([
                void 0
            ], args, false)))();
        }, {
            cache: $451560b32c66f622$var$createFastMemoizeCache(cache.list),
            strategy: (0, $bX0Gd.strategies).variadic
        }),
        getDisplayNames: (0, $bX0Gd.memoize)(function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            return new (DisplayNames.bind.apply(DisplayNames, (0, $gb4K1.__spreadArray)([
                void 0
            ], args, false)))();
        }, {
            cache: $451560b32c66f622$var$createFastMemoizeCache(cache.displayNames),
            strategy: (0, $bX0Gd.strategies).variadic
        })
    };
}
function $451560b32c66f622$export$4ee1db8ce44a209b(formats, type, name, onError) {
    var formatType = formats && formats[type];
    var format;
    if (formatType) format = formatType[name];
    if (format) return format;
    onError(new (0, $dCg2n.UnsupportedFormatterError)("No ".concat(type, " format named: ").concat(name)));
}

});
parcelRegister("iTKsw", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "ErrorCode", function () { return (parcelRequire("8RUL4")).ErrorCode; });
$parcel$export(module.exports, "FormatError", function () { return (parcelRequire("8RUL4")).FormatError; });
$parcel$export(module.exports, "isFormatXMLElementFn", function () { return (parcelRequire("9FMnG")).isFormatXMLElementFn; });

$parcel$export(module.exports, "IntlMessageFormat", function () { return (parcelRequire("4kwTT")).IntlMessageFormat; });
/*
Copyright (c) 2014, Yahoo! Inc. All rights reserved.
Copyrights licensed under the New BSD License.
See the accompanying LICENSE file for terms.
*/ 
var $4kwTT = parcelRequire("4kwTT");
parcelRequire("8RUL4");
parcelRequire("9FMnG");
var $dc2166db9278051b$export$2e2bcd8739ae039 = (0, $4kwTT.IntlMessageFormat);

});
parcelRegister("4kwTT", function(module, exports) {

$parcel$export(module.exports, "IntlMessageFormat", function () { return $32728d0a3cb8395c$export$d342343268debc40; });
/*
Copyright (c) 2014, Yahoo! Inc. All rights reserved.
Copyrights licensed under the New BSD License.
See the accompanying LICENSE file for terms.
*/ 
var $gb4K1 = parcelRequire("gb4K1");

var $b4svv = parcelRequire("b4svv");

var $bX0Gd = parcelRequire("bX0Gd");

var $9FMnG = parcelRequire("9FMnG");
// -- MessageFormat --------------------------------------------------------
function $32728d0a3cb8395c$var$mergeConfig(c1, c2) {
    if (!c2) return c1;
    return (0, $gb4K1.__assign)((0, $gb4K1.__assign)((0, $gb4K1.__assign)({}, c1 || {}), c2 || {}), Object.keys(c1).reduce(function(all, k) {
        all[k] = (0, $gb4K1.__assign)((0, $gb4K1.__assign)({}, c1[k]), c2[k] || {});
        return all;
    }, {}));
}
function $32728d0a3cb8395c$var$mergeConfigs(defaultConfig, configs) {
    if (!configs) return defaultConfig;
    return Object.keys(defaultConfig).reduce(function(all, k) {
        all[k] = $32728d0a3cb8395c$var$mergeConfig(defaultConfig[k], configs[k]);
        return all;
    }, (0, $gb4K1.__assign)({}, defaultConfig));
}
function $32728d0a3cb8395c$var$createFastMemoizeCache(store) {
    return {
        create: function() {
            return {
                get: function(key) {
                    return store[key];
                },
                set: function(key, value) {
                    store[key] = value;
                }
            };
        }
    };
}
function $32728d0a3cb8395c$var$createDefaultFormatters(cache) {
    if (cache === void 0) cache = {
        number: {},
        dateTime: {},
        pluralRules: {}
    };
    return {
        getNumberFormat: (0, $bX0Gd.memoize)(function() {
            var _a;
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            return new ((_a = Intl.NumberFormat).bind.apply(_a, (0, $gb4K1.__spreadArray)([
                void 0
            ], args, false)))();
        }, {
            cache: $32728d0a3cb8395c$var$createFastMemoizeCache(cache.number),
            strategy: (0, $bX0Gd.strategies).variadic
        }),
        getDateTimeFormat: (0, $bX0Gd.memoize)(function() {
            var _a;
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            return new ((_a = Intl.DateTimeFormat).bind.apply(_a, (0, $gb4K1.__spreadArray)([
                void 0
            ], args, false)))();
        }, {
            cache: $32728d0a3cb8395c$var$createFastMemoizeCache(cache.dateTime),
            strategy: (0, $bX0Gd.strategies).variadic
        }),
        getPluralRules: (0, $bX0Gd.memoize)(function() {
            var _a;
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            return new ((_a = Intl.PluralRules).bind.apply(_a, (0, $gb4K1.__spreadArray)([
                void 0
            ], args, false)))();
        }, {
            cache: $32728d0a3cb8395c$var$createFastMemoizeCache(cache.pluralRules),
            strategy: (0, $bX0Gd.strategies).variadic
        })
    };
}
var $32728d0a3cb8395c$export$d342343268debc40 = /** @class */ function() {
    function IntlMessageFormat(message, locales, overrideFormats, opts) {
        var _this = this;
        if (locales === void 0) locales = IntlMessageFormat.defaultLocale;
        this.formatterCache = {
            number: {},
            dateTime: {},
            pluralRules: {}
        };
        this.format = function(values) {
            var parts = _this.formatToParts(values);
            // Hot path for straight simple msg translations
            if (parts.length === 1) return parts[0].value;
            var result = parts.reduce(function(all, part) {
                if (!all.length || part.type !== (0, $9FMnG.PART_TYPE).literal || typeof all[all.length - 1] !== "string") all.push(part.value);
                else all[all.length - 1] += part.value;
                return all;
            }, []);
            if (result.length <= 1) return result[0] || "";
            return result;
        };
        this.formatToParts = function(values) {
            return (0, $9FMnG.formatToParts)(_this.ast, _this.locales, _this.formatters, _this.formats, values, undefined, _this.message);
        };
        this.resolvedOptions = function() {
            var _a;
            return {
                locale: ((_a = _this.resolvedLocale) === null || _a === void 0 ? void 0 : _a.toString()) || Intl.NumberFormat.supportedLocalesOf(_this.locales)[0]
            };
        };
        this.getAst = function() {
            return _this.ast;
        };
        // Defined first because it's used to build the format pattern.
        this.locales = locales;
        this.resolvedLocale = IntlMessageFormat.resolveLocale(locales);
        if (typeof message === "string") {
            this.message = message;
            if (!IntlMessageFormat.__parse) throw new TypeError("IntlMessageFormat.__parse must be set to process `message` of type `string`");
            var _a = opts || {}, formatters = _a.formatters, parseOpts = (0, $gb4K1.__rest)(_a, [
                "formatters"
            ]);
            // Parse string messages into an AST.
            this.ast = IntlMessageFormat.__parse(message, (0, $gb4K1.__assign)((0, $gb4K1.__assign)({}, parseOpts), {
                locale: this.resolvedLocale
            }));
        } else this.ast = message;
        if (!Array.isArray(this.ast)) throw new TypeError("A message must be provided as a String or AST.");
        // Creates a new object with the specified `formats` merged with the default
        // formats.
        this.formats = $32728d0a3cb8395c$var$mergeConfigs(IntlMessageFormat.formats, overrideFormats);
        this.formatters = opts && opts.formatters || $32728d0a3cb8395c$var$createDefaultFormatters(this.formatterCache);
    }
    Object.defineProperty(IntlMessageFormat, "defaultLocale", {
        get: function() {
            if (!IntlMessageFormat.memoizedDefaultLocale) IntlMessageFormat.memoizedDefaultLocale = new Intl.NumberFormat().resolvedOptions().locale;
            return IntlMessageFormat.memoizedDefaultLocale;
        },
        enumerable: false,
        configurable: true
    });
    IntlMessageFormat.memoizedDefaultLocale = null;
    IntlMessageFormat.resolveLocale = function(locales) {
        if (typeof Intl.Locale === "undefined") return;
        var supportedLocales = Intl.NumberFormat.supportedLocalesOf(locales);
        if (supportedLocales.length > 0) return new Intl.Locale(supportedLocales[0]);
        return new Intl.Locale(typeof locales === "string" ? locales : locales[0]);
    };
    IntlMessageFormat.__parse = (0, $b4svv.parse);
    // Default format options used as the prototype of the `formats` provided to the
    // constructor. These are used when constructing the internal Intl.NumberFormat
    // and Intl.DateTimeFormat instances.
    IntlMessageFormat.formats = {
        number: {
            integer: {
                maximumFractionDigits: 0
            },
            currency: {
                style: "currency"
            },
            percent: {
                style: "percent"
            }
        },
        date: {
            short: {
                month: "numeric",
                day: "numeric",
                year: "2-digit"
            },
            medium: {
                month: "short",
                day: "numeric",
                year: "numeric"
            },
            long: {
                month: "long",
                day: "numeric",
                year: "numeric"
            },
            full: {
                weekday: "long",
                month: "long",
                day: "numeric",
                year: "numeric"
            }
        },
        time: {
            short: {
                hour: "numeric",
                minute: "numeric"
            },
            medium: {
                hour: "numeric",
                minute: "numeric",
                second: "numeric"
            },
            long: {
                hour: "numeric",
                minute: "numeric",
                second: "numeric",
                timeZoneName: "short"
            },
            full: {
                hour: "numeric",
                minute: "numeric",
                second: "numeric",
                timeZoneName: "short"
            }
        }
    };
    return IntlMessageFormat;
}();

});
parcelRegister("b4svv", function(module, exports) {
$parcel$export(module.exports, "isArgumentElement", function () { return (parcelRequire("a5i87")).isArgumentElement; });
$parcel$export(module.exports, "isDateElement", function () { return (parcelRequire("a5i87")).isDateElement; });
$parcel$export(module.exports, "isDateTimeSkeleton", function () { return (parcelRequire("a5i87")).isDateTimeSkeleton; });
$parcel$export(module.exports, "isLiteralElement", function () { return (parcelRequire("a5i87")).isLiteralElement; });
$parcel$export(module.exports, "isNumberElement", function () { return (parcelRequire("a5i87")).isNumberElement; });
$parcel$export(module.exports, "isNumberSkeleton", function () { return (parcelRequire("a5i87")).isNumberSkeleton; });
$parcel$export(module.exports, "isPluralElement", function () { return (parcelRequire("a5i87")).isPluralElement; });
$parcel$export(module.exports, "isPoundElement", function () { return (parcelRequire("a5i87")).isPoundElement; });
$parcel$export(module.exports, "isSelectElement", function () { return (parcelRequire("a5i87")).isSelectElement; });
$parcel$export(module.exports, "isTagElement", function () { return (parcelRequire("a5i87")).isTagElement; });
$parcel$export(module.exports, "isTimeElement", function () { return (parcelRequire("a5i87")).isTimeElement; });
$parcel$export(module.exports, "TYPE", function () { return (parcelRequire("a5i87")).TYPE; });

$parcel$export(module.exports, "parse", function () { return $80f62e5a8c2ca55f$export$98e6a39c04603d36; });

var $gb4K1 = parcelRequire("gb4K1");

var $iGmlb = parcelRequire("iGmlb");

var $5C8At = parcelRequire("5C8At");

var $a5i87 = parcelRequire("a5i87");
function $80f62e5a8c2ca55f$var$pruneLocation(els) {
    els.forEach(function(el) {
        delete el.location;
        if ((0, $a5i87.isSelectElement)(el) || (0, $a5i87.isPluralElement)(el)) for(var k in el.options){
            delete el.options[k].location;
            $80f62e5a8c2ca55f$var$pruneLocation(el.options[k].value);
        }
        else if ((0, $a5i87.isNumberElement)(el) && (0, $a5i87.isNumberSkeleton)(el.style)) delete el.style.location;
        else if (((0, $a5i87.isDateElement)(el) || (0, $a5i87.isTimeElement)(el)) && (0, $a5i87.isDateTimeSkeleton)(el.style)) delete el.style.location;
        else if ((0, $a5i87.isTagElement)(el)) $80f62e5a8c2ca55f$var$pruneLocation(el.children);
    });
}
function $80f62e5a8c2ca55f$export$98e6a39c04603d36(message, opts) {
    if (opts === void 0) opts = {};
    opts = (0, $gb4K1.__assign)({
        shouldParseSkeletons: true,
        requiresOtherClause: true
    }, opts);
    var result = new (0, $5C8At.Parser)(message, opts).parse();
    if (result.err) {
        var error = SyntaxError((0, $iGmlb.ErrorKind)[result.err.kind]);
        // @ts-expect-error Assign to error object
        error.location = result.err.location;
        // @ts-expect-error Assign to error object
        error.originalMessage = result.err.message;
        throw error;
    }
    if (!(opts === null || opts === void 0 ? void 0 : opts.captureLocation)) $80f62e5a8c2ca55f$var$pruneLocation(result.val);
    return result.val;
}
var $80f62e5a8c2ca55f$export$d3c1bfa0f7d806e9 = (0, $5C8At.Parser);

});
parcelRegister("iGmlb", function(module, exports) {

$parcel$export(module.exports, "ErrorKind", function () { return $d99d7a9d104f8dad$export$896afd8541959ee5; });
var $d99d7a9d104f8dad$export$896afd8541959ee5;
(function(ErrorKind) {
    /** Argument is unclosed (e.g. `{0`) */ ErrorKind[ErrorKind["EXPECT_ARGUMENT_CLOSING_BRACE"] = 1] = "EXPECT_ARGUMENT_CLOSING_BRACE";
    /** Argument is empty (e.g. `{}`). */ ErrorKind[ErrorKind["EMPTY_ARGUMENT"] = 2] = "EMPTY_ARGUMENT";
    /** Argument is malformed (e.g. `{foo!}``) */ ErrorKind[ErrorKind["MALFORMED_ARGUMENT"] = 3] = "MALFORMED_ARGUMENT";
    /** Expect an argument type (e.g. `{foo,}`) */ ErrorKind[ErrorKind["EXPECT_ARGUMENT_TYPE"] = 4] = "EXPECT_ARGUMENT_TYPE";
    /** Unsupported argument type (e.g. `{foo,foo}`) */ ErrorKind[ErrorKind["INVALID_ARGUMENT_TYPE"] = 5] = "INVALID_ARGUMENT_TYPE";
    /** Expect an argument style (e.g. `{foo, number, }`) */ ErrorKind[ErrorKind["EXPECT_ARGUMENT_STYLE"] = 6] = "EXPECT_ARGUMENT_STYLE";
    /** The number skeleton is invalid. */ ErrorKind[ErrorKind["INVALID_NUMBER_SKELETON"] = 7] = "INVALID_NUMBER_SKELETON";
    /** The date time skeleton is invalid. */ ErrorKind[ErrorKind["INVALID_DATE_TIME_SKELETON"] = 8] = "INVALID_DATE_TIME_SKELETON";
    /** Exepct a number skeleton following the `::` (e.g. `{foo, number, ::}`) */ ErrorKind[ErrorKind["EXPECT_NUMBER_SKELETON"] = 9] = "EXPECT_NUMBER_SKELETON";
    /** Exepct a date time skeleton following the `::` (e.g. `{foo, date, ::}`) */ ErrorKind[ErrorKind["EXPECT_DATE_TIME_SKELETON"] = 10] = "EXPECT_DATE_TIME_SKELETON";
    /** Unmatched apostrophes in the argument style (e.g. `{foo, number, 'test`) */ ErrorKind[ErrorKind["UNCLOSED_QUOTE_IN_ARGUMENT_STYLE"] = 11] = "UNCLOSED_QUOTE_IN_ARGUMENT_STYLE";
    /** Missing select argument options (e.g. `{foo, select}`) */ ErrorKind[ErrorKind["EXPECT_SELECT_ARGUMENT_OPTIONS"] = 12] = "EXPECT_SELECT_ARGUMENT_OPTIONS";
    /** Expecting an offset value in `plural` or `selectordinal` argument (e.g `{foo, plural, offset}`) */ ErrorKind[ErrorKind["EXPECT_PLURAL_ARGUMENT_OFFSET_VALUE"] = 13] = "EXPECT_PLURAL_ARGUMENT_OFFSET_VALUE";
    /** Offset value in `plural` or `selectordinal` is invalid (e.g. `{foo, plural, offset: x}`) */ ErrorKind[ErrorKind["INVALID_PLURAL_ARGUMENT_OFFSET_VALUE"] = 14] = "INVALID_PLURAL_ARGUMENT_OFFSET_VALUE";
    /** Expecting a selector in `select` argument (e.g `{foo, select}`) */ ErrorKind[ErrorKind["EXPECT_SELECT_ARGUMENT_SELECTOR"] = 15] = "EXPECT_SELECT_ARGUMENT_SELECTOR";
    /** Expecting a selector in `plural` or `selectordinal` argument (e.g `{foo, plural}`) */ ErrorKind[ErrorKind["EXPECT_PLURAL_ARGUMENT_SELECTOR"] = 16] = "EXPECT_PLURAL_ARGUMENT_SELECTOR";
    /** Expecting a message fragment after the `select` selector (e.g. `{foo, select, apple}`) */ ErrorKind[ErrorKind["EXPECT_SELECT_ARGUMENT_SELECTOR_FRAGMENT"] = 17] = "EXPECT_SELECT_ARGUMENT_SELECTOR_FRAGMENT";
    /**
     * Expecting a message fragment after the `plural` or `selectordinal` selector
     * (e.g. `{foo, plural, one}`)
     */ ErrorKind[ErrorKind["EXPECT_PLURAL_ARGUMENT_SELECTOR_FRAGMENT"] = 18] = "EXPECT_PLURAL_ARGUMENT_SELECTOR_FRAGMENT";
    /** Selector in `plural` or `selectordinal` is malformed (e.g. `{foo, plural, =x {#}}`) */ ErrorKind[ErrorKind["INVALID_PLURAL_ARGUMENT_SELECTOR"] = 19] = "INVALID_PLURAL_ARGUMENT_SELECTOR";
    /**
     * Duplicate selectors in `plural` or `selectordinal` argument.
     * (e.g. {foo, plural, one {#} one {#}})
     */ ErrorKind[ErrorKind["DUPLICATE_PLURAL_ARGUMENT_SELECTOR"] = 20] = "DUPLICATE_PLURAL_ARGUMENT_SELECTOR";
    /** Duplicate selectors in `select` argument.
     * (e.g. {foo, select, apple {apple} apple {apple}})
     */ ErrorKind[ErrorKind["DUPLICATE_SELECT_ARGUMENT_SELECTOR"] = 21] = "DUPLICATE_SELECT_ARGUMENT_SELECTOR";
    /** Plural or select argument option must have `other` clause. */ ErrorKind[ErrorKind["MISSING_OTHER_CLAUSE"] = 22] = "MISSING_OTHER_CLAUSE";
    /** The tag is malformed. (e.g. `<bold!>foo</bold!>) */ ErrorKind[ErrorKind["INVALID_TAG"] = 23] = "INVALID_TAG";
    /** The tag name is invalid. (e.g. `<123>foo</123>`) */ ErrorKind[ErrorKind["INVALID_TAG_NAME"] = 25] = "INVALID_TAG_NAME";
    /** The closing tag does not match the opening tag. (e.g. `<bold>foo</italic>`) */ ErrorKind[ErrorKind["UNMATCHED_CLOSING_TAG"] = 26] = "UNMATCHED_CLOSING_TAG";
    /** The opening tag has unmatched closing tag. (e.g. `<bold>foo`) */ ErrorKind[ErrorKind["UNCLOSED_TAG"] = 27] = "UNCLOSED_TAG";
})($d99d7a9d104f8dad$export$896afd8541959ee5 || ($d99d7a9d104f8dad$export$896afd8541959ee5 = {}));

});

parcelRegister("5C8At", function(module, exports) {

$parcel$export(module.exports, "Parser", function () { return $4167299d39181961$export$7acfa6ed01010e37; });

var $gb4K1 = parcelRequire("gb4K1");

var $iGmlb = parcelRequire("iGmlb");

var $a5i87 = parcelRequire("a5i87");

var $2m77C = parcelRequire("2m77C");
parcelRequire("hDzp7");
var $2WsKD = parcelRequire("2WsKD");
var $4GppD = parcelRequire("4GppD");

var $6hTU2 = parcelRequire("6hTU2");
var $4167299d39181961$var$_a;
var $4167299d39181961$var$SPACE_SEPARATOR_START_REGEX = new RegExp("^".concat((0, $2m77C.SPACE_SEPARATOR_REGEX).source, "*"));
var $4167299d39181961$var$SPACE_SEPARATOR_END_REGEX = new RegExp("".concat((0, $2m77C.SPACE_SEPARATOR_REGEX).source, "*$"));
function $4167299d39181961$var$createLocation(start, end) {
    return {
        start: start,
        end: end
    };
}
// #region Ponyfills
// Consolidate these variables up top for easier toggling during debugging
var $4167299d39181961$var$hasNativeStartsWith = !!String.prototype.startsWith && "_a".startsWith("a", 1);
var $4167299d39181961$var$hasNativeFromCodePoint = !!String.fromCodePoint;
var $4167299d39181961$var$hasNativeFromEntries = !!Object.fromEntries;
var $4167299d39181961$var$hasNativeCodePointAt = !!String.prototype.codePointAt;
var $4167299d39181961$var$hasTrimStart = !!String.prototype.trimStart;
var $4167299d39181961$var$hasTrimEnd = !!String.prototype.trimEnd;
var $4167299d39181961$var$hasNativeIsSafeInteger = !!Number.isSafeInteger;
var $4167299d39181961$var$isSafeInteger = $4167299d39181961$var$hasNativeIsSafeInteger ? Number.isSafeInteger : function(n) {
    return typeof n === "number" && isFinite(n) && Math.floor(n) === n && Math.abs(n) <= 0x1fffffffffffff;
};
// IE11 does not support y and u.
var $4167299d39181961$var$REGEX_SUPPORTS_U_AND_Y = true;
try {
    var $4167299d39181961$var$re = $4167299d39181961$var$RE("([^\\p{White_Space}\\p{Pattern_Syntax}]*)", "yu");
    /**
     * legacy Edge or Xbox One browser
     * Unicode flag support: supported
     * Pattern_Syntax support: not supported
     * See https://github.com/formatjs/formatjs/issues/2822
     */ $4167299d39181961$var$REGEX_SUPPORTS_U_AND_Y = (($4167299d39181961$var$_a = $4167299d39181961$var$re.exec("a")) === null || $4167299d39181961$var$_a === void 0 ? void 0 : $4167299d39181961$var$_a[0]) === "a";
} catch (_) {
    $4167299d39181961$var$REGEX_SUPPORTS_U_AND_Y = false;
}
var $4167299d39181961$var$startsWith = $4167299d39181961$var$hasNativeStartsWith ? function startsWith(s, search, position) {
    return s.startsWith(search, position);
} : function startsWith(s, search, position) {
    return s.slice(position, position + search.length) === search;
};
var $4167299d39181961$var$fromCodePoint = $4167299d39181961$var$hasNativeFromCodePoint ? String.fromCodePoint : function fromCodePoint() {
    var codePoints = [];
    for(var _i = 0; _i < arguments.length; _i++)codePoints[_i] = arguments[_i];
    var elements = "";
    var length = codePoints.length;
    var i = 0;
    var code;
    while(length > i){
        code = codePoints[i++];
        if (code > 0x10ffff) throw RangeError(code + " is not a valid code point");
        elements += code < 0x10000 ? String.fromCharCode(code) : String.fromCharCode(((code -= 0x10000) >> 10) + 0xd800, code % 0x400 + 0xdc00);
    }
    return elements;
};
var $4167299d39181961$var$fromEntries = // native
$4167299d39181961$var$hasNativeFromEntries ? Object.fromEntries : function fromEntries(entries) {
    var obj = {};
    for(var _i = 0, entries_1 = entries; _i < entries_1.length; _i++){
        var _a = entries_1[_i], k = _a[0], v = _a[1];
        obj[k] = v;
    }
    return obj;
};
var $4167299d39181961$var$codePointAt = $4167299d39181961$var$hasNativeCodePointAt ? function codePointAt(s, index) {
    return s.codePointAt(index);
} : function codePointAt(s, index) {
    var size = s.length;
    if (index < 0 || index >= size) return undefined;
    var first = s.charCodeAt(index);
    var second;
    return first < 0xd800 || first > 0xdbff || index + 1 === size || (second = s.charCodeAt(index + 1)) < 0xdc00 || second > 0xdfff ? first : (first - 0xd800 << 10) + (second - 0xdc00) + 0x10000;
};
var $4167299d39181961$var$trimStart = $4167299d39181961$var$hasTrimStart ? function trimStart(s) {
    return s.trimStart();
} : function trimStart(s) {
    return s.replace($4167299d39181961$var$SPACE_SEPARATOR_START_REGEX, "");
};
var $4167299d39181961$var$trimEnd = $4167299d39181961$var$hasTrimEnd ? function trimEnd(s) {
    return s.trimEnd();
} : function trimEnd(s) {
    return s.replace($4167299d39181961$var$SPACE_SEPARATOR_END_REGEX, "");
};
// Prevent minifier to translate new RegExp to literal form that might cause syntax error on IE11.
function $4167299d39181961$var$RE(s, flag) {
    return new RegExp(s, flag);
}
// #endregion
var $4167299d39181961$var$matchIdentifierAtIndex;
if ($4167299d39181961$var$REGEX_SUPPORTS_U_AND_Y) {
    // Native
    var $4167299d39181961$var$IDENTIFIER_PREFIX_RE_1 = $4167299d39181961$var$RE("([^\\p{White_Space}\\p{Pattern_Syntax}]*)", "yu");
    $4167299d39181961$var$matchIdentifierAtIndex = function matchIdentifierAtIndex(s, index) {
        var _a;
        $4167299d39181961$var$IDENTIFIER_PREFIX_RE_1.lastIndex = index;
        var match = $4167299d39181961$var$IDENTIFIER_PREFIX_RE_1.exec(s);
        return (_a = match[1]) !== null && _a !== void 0 ? _a : "";
    };
} else // IE11
$4167299d39181961$var$matchIdentifierAtIndex = function matchIdentifierAtIndex(s, index) {
    var match = [];
    while(true){
        var c = $4167299d39181961$var$codePointAt(s, index);
        if (c === undefined || $4167299d39181961$var$_isWhiteSpace(c) || $4167299d39181961$var$_isPatternSyntax(c)) break;
        match.push(c);
        index += c >= 0x10000 ? 2 : 1;
    }
    return $4167299d39181961$var$fromCodePoint.apply(void 0, match);
};
var $4167299d39181961$export$7acfa6ed01010e37 = /** @class */ function() {
    function Parser(message, options) {
        if (options === void 0) options = {};
        this.message = message;
        this.position = {
            offset: 0,
            line: 1,
            column: 1
        };
        this.ignoreTag = !!options.ignoreTag;
        this.locale = options.locale;
        this.requiresOtherClause = !!options.requiresOtherClause;
        this.shouldParseSkeletons = !!options.shouldParseSkeletons;
    }
    Parser.prototype.parse = function() {
        if (this.offset() !== 0) throw Error("parser can only be used once");
        return this.parseMessage(0, "", false);
    };
    Parser.prototype.parseMessage = function(nestingLevel, parentArgType, expectingCloseTag) {
        var elements = [];
        while(!this.isEOF()){
            var char = this.char();
            if (char === 123 /* `{` */ ) {
                var result = this.parseArgument(nestingLevel, expectingCloseTag);
                if (result.err) return result;
                elements.push(result.val);
            } else if (char === 125 /* `}` */  && nestingLevel > 0) break;
            else if (char === 35 /* `#` */  && (parentArgType === "plural" || parentArgType === "selectordinal")) {
                var position = this.clonePosition();
                this.bump();
                elements.push({
                    type: (0, $a5i87.TYPE).pound,
                    location: $4167299d39181961$var$createLocation(position, this.clonePosition())
                });
            } else if (char === 60 /* `<` */  && !this.ignoreTag && this.peek() === 47 // char code for '/'
            ) {
                if (expectingCloseTag) break;
                else return this.error((0, $iGmlb.ErrorKind).UNMATCHED_CLOSING_TAG, $4167299d39181961$var$createLocation(this.clonePosition(), this.clonePosition()));
            } else if (char === 60 /* `<` */  && !this.ignoreTag && $4167299d39181961$var$_isAlpha(this.peek() || 0)) {
                var result = this.parseTag(nestingLevel, parentArgType);
                if (result.err) return result;
                elements.push(result.val);
            } else {
                var result = this.parseLiteral(nestingLevel, parentArgType);
                if (result.err) return result;
                elements.push(result.val);
            }
        }
        return {
            val: elements,
            err: null
        };
    };
    /**
     * A tag name must start with an ASCII lower/upper case letter. The grammar is based on the
     * [custom element name][] except that a dash is NOT always mandatory and uppercase letters
     * are accepted:
     *
     * ```
     * tag ::= "<" tagName (whitespace)* "/>" | "<" tagName (whitespace)* ">" message "</" tagName (whitespace)* ">"
     * tagName ::= [a-z] (PENChar)*
     * PENChar ::=
     *     "-" | "." | [0-9] | "_" | [a-z] | [A-Z] | #xB7 | [#xC0-#xD6] | [#xD8-#xF6] | [#xF8-#x37D] |
     *     [#x37F-#x1FFF] | [#x200C-#x200D] | [#x203F-#x2040] | [#x2070-#x218F] | [#x2C00-#x2FEF] |
     *     [#x3001-#xD7FF] | [#xF900-#xFDCF] | [#xFDF0-#xFFFD] | [#x10000-#xEFFFF]
     * ```
     *
     * [custom element name]: https://html.spec.whatwg.org/multipage/custom-elements.html#valid-custom-element-name
     * NOTE: We're a bit more lax here since HTML technically does not allow uppercase HTML element but we do
     * since other tag-based engines like React allow it
     */ Parser.prototype.parseTag = function(nestingLevel, parentArgType) {
        var startPosition = this.clonePosition();
        this.bump(); // `<`
        var tagName = this.parseTagName();
        this.bumpSpace();
        if (this.bumpIf("/>")) // Self closing tag
        return {
            val: {
                type: (0, $a5i87.TYPE).literal,
                value: "<".concat(tagName, "/>"),
                location: $4167299d39181961$var$createLocation(startPosition, this.clonePosition())
            },
            err: null
        };
        else if (this.bumpIf(">")) {
            var childrenResult = this.parseMessage(nestingLevel + 1, parentArgType, true);
            if (childrenResult.err) return childrenResult;
            var children = childrenResult.val;
            // Expecting a close tag
            var endTagStartPosition = this.clonePosition();
            if (this.bumpIf("</")) {
                if (this.isEOF() || !$4167299d39181961$var$_isAlpha(this.char())) return this.error((0, $iGmlb.ErrorKind).INVALID_TAG, $4167299d39181961$var$createLocation(endTagStartPosition, this.clonePosition()));
                var closingTagNameStartPosition = this.clonePosition();
                var closingTagName = this.parseTagName();
                if (tagName !== closingTagName) return this.error((0, $iGmlb.ErrorKind).UNMATCHED_CLOSING_TAG, $4167299d39181961$var$createLocation(closingTagNameStartPosition, this.clonePosition()));
                this.bumpSpace();
                if (!this.bumpIf(">")) return this.error((0, $iGmlb.ErrorKind).INVALID_TAG, $4167299d39181961$var$createLocation(endTagStartPosition, this.clonePosition()));
                return {
                    val: {
                        type: (0, $a5i87.TYPE).tag,
                        value: tagName,
                        children: children,
                        location: $4167299d39181961$var$createLocation(startPosition, this.clonePosition())
                    },
                    err: null
                };
            } else return this.error((0, $iGmlb.ErrorKind).UNCLOSED_TAG, $4167299d39181961$var$createLocation(startPosition, this.clonePosition()));
        } else return this.error((0, $iGmlb.ErrorKind).INVALID_TAG, $4167299d39181961$var$createLocation(startPosition, this.clonePosition()));
    };
    /**
     * This method assumes that the caller has peeked ahead for the first tag character.
     */ Parser.prototype.parseTagName = function() {
        var startOffset = this.offset();
        this.bump(); // the first tag name character
        while(!this.isEOF() && $4167299d39181961$var$_isPotentialElementNameChar(this.char()))this.bump();
        return this.message.slice(startOffset, this.offset());
    };
    Parser.prototype.parseLiteral = function(nestingLevel, parentArgType) {
        var start = this.clonePosition();
        var value = "";
        while(true){
            var parseQuoteResult = this.tryParseQuote(parentArgType);
            if (parseQuoteResult) {
                value += parseQuoteResult;
                continue;
            }
            var parseUnquotedResult = this.tryParseUnquoted(nestingLevel, parentArgType);
            if (parseUnquotedResult) {
                value += parseUnquotedResult;
                continue;
            }
            var parseLeftAngleResult = this.tryParseLeftAngleBracket();
            if (parseLeftAngleResult) {
                value += parseLeftAngleResult;
                continue;
            }
            break;
        }
        var location = $4167299d39181961$var$createLocation(start, this.clonePosition());
        return {
            val: {
                type: (0, $a5i87.TYPE).literal,
                value: value,
                location: location
            },
            err: null
        };
    };
    Parser.prototype.tryParseLeftAngleBracket = function() {
        if (!this.isEOF() && this.char() === 60 /* `<` */  && (this.ignoreTag || // If at the opening tag or closing tag position, bail.
        !$4167299d39181961$var$_isAlphaOrSlash(this.peek() || 0))) {
            this.bump(); // `<`
            return "<";
        }
        return null;
    };
    /**
     * Starting with ICU 4.8, an ASCII apostrophe only starts quoted text if it immediately precedes
     * a character that requires quoting (that is, "only where needed"), and works the same in
     * nested messages as on the top level of the pattern. The new behavior is otherwise compatible.
     */ Parser.prototype.tryParseQuote = function(parentArgType) {
        if (this.isEOF() || this.char() !== 39 /* `'` */ ) return null;
        // Parse escaped char following the apostrophe, or early return if there is no escaped char.
        // Check if is valid escaped character
        switch(this.peek()){
            case 39 /* `'` */ :
                // double quote, should return as a single quote.
                this.bump();
                this.bump();
                return "'";
            // '{', '<', '>', '}'
            case 123:
            case 60:
            case 62:
            case 125:
                break;
            case 35:
                if (parentArgType === "plural" || parentArgType === "selectordinal") break;
                return null;
            default:
                return null;
        }
        this.bump(); // apostrophe
        var codePoints = [
            this.char()
        ]; // escaped char
        this.bump();
        // read chars until the optional closing apostrophe is found
        while(!this.isEOF()){
            var ch = this.char();
            if (ch === 39 /* `'` */ ) {
                if (this.peek() === 39 /* `'` */ ) {
                    codePoints.push(39);
                    // Bump one more time because we need to skip 2 characters.
                    this.bump();
                } else {
                    // Optional closing apostrophe.
                    this.bump();
                    break;
                }
            } else codePoints.push(ch);
            this.bump();
        }
        return $4167299d39181961$var$fromCodePoint.apply(void 0, codePoints);
    };
    Parser.prototype.tryParseUnquoted = function(nestingLevel, parentArgType) {
        if (this.isEOF()) return null;
        var ch = this.char();
        if (ch === 60 /* `<` */  || ch === 123 /* `{` */  || ch === 35 /* `#` */  && (parentArgType === "plural" || parentArgType === "selectordinal") || ch === 125 /* `}` */  && nestingLevel > 0) return null;
        else {
            this.bump();
            return $4167299d39181961$var$fromCodePoint(ch);
        }
    };
    Parser.prototype.parseArgument = function(nestingLevel, expectingCloseTag) {
        var openingBracePosition = this.clonePosition();
        this.bump(); // `{`
        this.bumpSpace();
        if (this.isEOF()) return this.error((0, $iGmlb.ErrorKind).EXPECT_ARGUMENT_CLOSING_BRACE, $4167299d39181961$var$createLocation(openingBracePosition, this.clonePosition()));
        if (this.char() === 125 /* `}` */ ) {
            this.bump();
            return this.error((0, $iGmlb.ErrorKind).EMPTY_ARGUMENT, $4167299d39181961$var$createLocation(openingBracePosition, this.clonePosition()));
        }
        // argument name
        var value = this.parseIdentifierIfPossible().value;
        if (!value) return this.error((0, $iGmlb.ErrorKind).MALFORMED_ARGUMENT, $4167299d39181961$var$createLocation(openingBracePosition, this.clonePosition()));
        this.bumpSpace();
        if (this.isEOF()) return this.error((0, $iGmlb.ErrorKind).EXPECT_ARGUMENT_CLOSING_BRACE, $4167299d39181961$var$createLocation(openingBracePosition, this.clonePosition()));
        switch(this.char()){
            // Simple argument: `{name}`
            case 125 /* `}` */ :
                this.bump(); // `}`
                return {
                    val: {
                        type: (0, $a5i87.TYPE).argument,
                        // value does not include the opening and closing braces.
                        value: value,
                        location: $4167299d39181961$var$createLocation(openingBracePosition, this.clonePosition())
                    },
                    err: null
                };
            // Argument with options: `{name, format, ...}`
            case 44 /* `,` */ :
                this.bump(); // `,`
                this.bumpSpace();
                if (this.isEOF()) return this.error((0, $iGmlb.ErrorKind).EXPECT_ARGUMENT_CLOSING_BRACE, $4167299d39181961$var$createLocation(openingBracePosition, this.clonePosition()));
                return this.parseArgumentOptions(nestingLevel, expectingCloseTag, value, openingBracePosition);
            default:
                return this.error((0, $iGmlb.ErrorKind).MALFORMED_ARGUMENT, $4167299d39181961$var$createLocation(openingBracePosition, this.clonePosition()));
        }
    };
    /**
     * Advance the parser until the end of the identifier, if it is currently on
     * an identifier character. Return an empty string otherwise.
     */ Parser.prototype.parseIdentifierIfPossible = function() {
        var startingPosition = this.clonePosition();
        var startOffset = this.offset();
        var value = $4167299d39181961$var$matchIdentifierAtIndex(this.message, startOffset);
        var endOffset = startOffset + value.length;
        this.bumpTo(endOffset);
        var endPosition = this.clonePosition();
        var location = $4167299d39181961$var$createLocation(startingPosition, endPosition);
        return {
            value: value,
            location: location
        };
    };
    Parser.prototype.parseArgumentOptions = function(nestingLevel, expectingCloseTag, value, openingBracePosition) {
        var _a;
        // Parse this range:
        // {name, type, style}
        //        ^---^
        var typeStartPosition = this.clonePosition();
        var argType = this.parseIdentifierIfPossible().value;
        var typeEndPosition = this.clonePosition();
        switch(argType){
            case "":
                // Expecting a style string number, date, time, plural, selectordinal, or select.
                return this.error((0, $iGmlb.ErrorKind).EXPECT_ARGUMENT_TYPE, $4167299d39181961$var$createLocation(typeStartPosition, typeEndPosition));
            case "number":
            case "date":
            case "time":
                // Parse this range:
                // {name, number, style}
                //              ^-------^
                this.bumpSpace();
                var styleAndLocation = null;
                if (this.bumpIf(",")) {
                    this.bumpSpace();
                    var styleStartPosition = this.clonePosition();
                    var result = this.parseSimpleArgStyleIfPossible();
                    if (result.err) return result;
                    var style = $4167299d39181961$var$trimEnd(result.val);
                    if (style.length === 0) return this.error((0, $iGmlb.ErrorKind).EXPECT_ARGUMENT_STYLE, $4167299d39181961$var$createLocation(this.clonePosition(), this.clonePosition()));
                    var styleLocation = $4167299d39181961$var$createLocation(styleStartPosition, this.clonePosition());
                    styleAndLocation = {
                        style: style,
                        styleLocation: styleLocation
                    };
                }
                var argCloseResult = this.tryParseArgumentClose(openingBracePosition);
                if (argCloseResult.err) return argCloseResult;
                var location_1 = $4167299d39181961$var$createLocation(openingBracePosition, this.clonePosition());
                // Extract style or skeleton
                if (styleAndLocation && $4167299d39181961$var$startsWith(styleAndLocation === null || styleAndLocation === void 0 ? void 0 : styleAndLocation.style, "::", 0)) {
                    // Skeleton starts with `::`.
                    var skeleton = $4167299d39181961$var$trimStart(styleAndLocation.style.slice(2));
                    if (argType === "number") {
                        var result = this.parseNumberSkeletonFromString(skeleton, styleAndLocation.styleLocation);
                        if (result.err) return result;
                        return {
                            val: {
                                type: (0, $a5i87.TYPE).number,
                                value: value,
                                location: location_1,
                                style: result.val
                            },
                            err: null
                        };
                    } else {
                        if (skeleton.length === 0) return this.error((0, $iGmlb.ErrorKind).EXPECT_DATE_TIME_SKELETON, location_1);
                        var dateTimePattern = skeleton;
                        // Get "best match" pattern only if locale is passed, if not, let it
                        // pass as-is where `parseDateTimeSkeleton()` will throw an error
                        // for unsupported patterns.
                        if (this.locale) dateTimePattern = (0, $6hTU2.getBestPattern)(skeleton, this.locale);
                        var style = {
                            type: (0, $a5i87.SKELETON_TYPE).dateTime,
                            pattern: dateTimePattern,
                            location: styleAndLocation.styleLocation,
                            parsedOptions: this.shouldParseSkeletons ? (0, $2WsKD.parseDateTimeSkeleton)(dateTimePattern) : {}
                        };
                        var type = argType === "date" ? (0, $a5i87.TYPE).date : (0, $a5i87.TYPE).time;
                        return {
                            val: {
                                type: type,
                                value: value,
                                location: location_1,
                                style: style
                            },
                            err: null
                        };
                    }
                }
                // Regular style or no style.
                return {
                    val: {
                        type: argType === "number" ? (0, $a5i87.TYPE).number : argType === "date" ? (0, $a5i87.TYPE).date : (0, $a5i87.TYPE).time,
                        value: value,
                        location: location_1,
                        style: (_a = styleAndLocation === null || styleAndLocation === void 0 ? void 0 : styleAndLocation.style) !== null && _a !== void 0 ? _a : null
                    },
                    err: null
                };
            case "plural":
            case "selectordinal":
            case "select":
                // Parse this range:
                // {name, plural, options}
                //              ^---------^
                var typeEndPosition_1 = this.clonePosition();
                this.bumpSpace();
                if (!this.bumpIf(",")) return this.error((0, $iGmlb.ErrorKind).EXPECT_SELECT_ARGUMENT_OPTIONS, $4167299d39181961$var$createLocation(typeEndPosition_1, (0, $gb4K1.__assign)({}, typeEndPosition_1)));
                this.bumpSpace();
                // Parse offset:
                // {name, plural, offset:1, options}
                //                ^-----^
                //
                // or the first option:
                //
                // {name, plural, one {...} other {...}}
                //                ^--^
                var identifierAndLocation = this.parseIdentifierIfPossible();
                var pluralOffset = 0;
                if (argType !== "select" && identifierAndLocation.value === "offset") {
                    if (!this.bumpIf(":")) return this.error((0, $iGmlb.ErrorKind).EXPECT_PLURAL_ARGUMENT_OFFSET_VALUE, $4167299d39181961$var$createLocation(this.clonePosition(), this.clonePosition()));
                    this.bumpSpace();
                    var result = this.tryParseDecimalInteger((0, $iGmlb.ErrorKind).EXPECT_PLURAL_ARGUMENT_OFFSET_VALUE, (0, $iGmlb.ErrorKind).INVALID_PLURAL_ARGUMENT_OFFSET_VALUE);
                    if (result.err) return result;
                    // Parse another identifier for option parsing
                    this.bumpSpace();
                    identifierAndLocation = this.parseIdentifierIfPossible();
                    pluralOffset = result.val;
                }
                var optionsResult = this.tryParsePluralOrSelectOptions(nestingLevel, argType, expectingCloseTag, identifierAndLocation);
                if (optionsResult.err) return optionsResult;
                var argCloseResult = this.tryParseArgumentClose(openingBracePosition);
                if (argCloseResult.err) return argCloseResult;
                var location_2 = $4167299d39181961$var$createLocation(openingBracePosition, this.clonePosition());
                if (argType === "select") return {
                    val: {
                        type: (0, $a5i87.TYPE).select,
                        value: value,
                        options: $4167299d39181961$var$fromEntries(optionsResult.val),
                        location: location_2
                    },
                    err: null
                };
                else return {
                    val: {
                        type: (0, $a5i87.TYPE).plural,
                        value: value,
                        options: $4167299d39181961$var$fromEntries(optionsResult.val),
                        offset: pluralOffset,
                        pluralType: argType === "plural" ? "cardinal" : "ordinal",
                        location: location_2
                    },
                    err: null
                };
            default:
                return this.error((0, $iGmlb.ErrorKind).INVALID_ARGUMENT_TYPE, $4167299d39181961$var$createLocation(typeStartPosition, typeEndPosition));
        }
    };
    Parser.prototype.tryParseArgumentClose = function(openingBracePosition) {
        // Parse: {value, number, ::currency/GBP }
        //
        if (this.isEOF() || this.char() !== 125 /* `}` */ ) return this.error((0, $iGmlb.ErrorKind).EXPECT_ARGUMENT_CLOSING_BRACE, $4167299d39181961$var$createLocation(openingBracePosition, this.clonePosition()));
        this.bump(); // `}`
        return {
            val: true,
            err: null
        };
    };
    /**
     * See: https://github.com/unicode-org/icu/blob/af7ed1f6d2298013dc303628438ec4abe1f16479/icu4c/source/common/messagepattern.cpp#L659
     */ Parser.prototype.parseSimpleArgStyleIfPossible = function() {
        var nestedBraces = 0;
        var startPosition = this.clonePosition();
        while(!this.isEOF()){
            var ch = this.char();
            switch(ch){
                case 39 /* `'` */ :
                    // Treat apostrophe as quoting but include it in the style part.
                    // Find the end of the quoted literal text.
                    this.bump();
                    var apostrophePosition = this.clonePosition();
                    if (!this.bumpUntil("'")) return this.error((0, $iGmlb.ErrorKind).UNCLOSED_QUOTE_IN_ARGUMENT_STYLE, $4167299d39181961$var$createLocation(apostrophePosition, this.clonePosition()));
                    this.bump();
                    break;
                case 123 /* `{` */ :
                    nestedBraces += 1;
                    this.bump();
                    break;
                case 125 /* `}` */ :
                    if (nestedBraces > 0) nestedBraces -= 1;
                    else return {
                        val: this.message.slice(startPosition.offset, this.offset()),
                        err: null
                    };
                    break;
                default:
                    this.bump();
                    break;
            }
        }
        return {
            val: this.message.slice(startPosition.offset, this.offset()),
            err: null
        };
    };
    Parser.prototype.parseNumberSkeletonFromString = function(skeleton, location) {
        var tokens = [];
        try {
            tokens = (0, $4GppD.parseNumberSkeletonFromString)(skeleton);
        } catch (e) {
            return this.error((0, $iGmlb.ErrorKind).INVALID_NUMBER_SKELETON, location);
        }
        return {
            val: {
                type: (0, $a5i87.SKELETON_TYPE).number,
                tokens: tokens,
                location: location,
                parsedOptions: this.shouldParseSkeletons ? (0, $4GppD.parseNumberSkeleton)(tokens) : {}
            },
            err: null
        };
    };
    /**
     * @param nesting_level The current nesting level of messages.
     *     This can be positive when parsing message fragment in select or plural argument options.
     * @param parent_arg_type The parent argument's type.
     * @param parsed_first_identifier If provided, this is the first identifier-like selector of
     *     the argument. It is a by-product of a previous parsing attempt.
     * @param expecting_close_tag If true, this message is directly or indirectly nested inside
     *     between a pair of opening and closing tags. The nested message will not parse beyond
     *     the closing tag boundary.
     */ Parser.prototype.tryParsePluralOrSelectOptions = function(nestingLevel, parentArgType, expectCloseTag, parsedFirstIdentifier) {
        var _a;
        var hasOtherClause = false;
        var options = [];
        var parsedSelectors = new Set();
        var selector = parsedFirstIdentifier.value, selectorLocation = parsedFirstIdentifier.location;
        // Parse:
        // one {one apple}
        // ^--^
        while(true){
            if (selector.length === 0) {
                var startPosition = this.clonePosition();
                if (parentArgType !== "select" && this.bumpIf("=")) {
                    // Try parse `={number}` selector
                    var result = this.tryParseDecimalInteger((0, $iGmlb.ErrorKind).EXPECT_PLURAL_ARGUMENT_SELECTOR, (0, $iGmlb.ErrorKind).INVALID_PLURAL_ARGUMENT_SELECTOR);
                    if (result.err) return result;
                    selectorLocation = $4167299d39181961$var$createLocation(startPosition, this.clonePosition());
                    selector = this.message.slice(startPosition.offset, this.offset());
                } else break;
            }
            // Duplicate selector clauses
            if (parsedSelectors.has(selector)) return this.error(parentArgType === "select" ? (0, $iGmlb.ErrorKind).DUPLICATE_SELECT_ARGUMENT_SELECTOR : (0, $iGmlb.ErrorKind).DUPLICATE_PLURAL_ARGUMENT_SELECTOR, selectorLocation);
            if (selector === "other") hasOtherClause = true;
            // Parse:
            // one {one apple}
            //     ^----------^
            this.bumpSpace();
            var openingBracePosition = this.clonePosition();
            if (!this.bumpIf("{")) return this.error(parentArgType === "select" ? (0, $iGmlb.ErrorKind).EXPECT_SELECT_ARGUMENT_SELECTOR_FRAGMENT : (0, $iGmlb.ErrorKind).EXPECT_PLURAL_ARGUMENT_SELECTOR_FRAGMENT, $4167299d39181961$var$createLocation(this.clonePosition(), this.clonePosition()));
            var fragmentResult = this.parseMessage(nestingLevel + 1, parentArgType, expectCloseTag);
            if (fragmentResult.err) return fragmentResult;
            var argCloseResult = this.tryParseArgumentClose(openingBracePosition);
            if (argCloseResult.err) return argCloseResult;
            options.push([
                selector,
                {
                    value: fragmentResult.val,
                    location: $4167299d39181961$var$createLocation(openingBracePosition, this.clonePosition())
                }
            ]);
            // Keep track of the existing selectors
            parsedSelectors.add(selector);
            // Prep next selector clause.
            this.bumpSpace();
            _a = this.parseIdentifierIfPossible(), selector = _a.value, selectorLocation = _a.location;
        }
        if (options.length === 0) return this.error(parentArgType === "select" ? (0, $iGmlb.ErrorKind).EXPECT_SELECT_ARGUMENT_SELECTOR : (0, $iGmlb.ErrorKind).EXPECT_PLURAL_ARGUMENT_SELECTOR, $4167299d39181961$var$createLocation(this.clonePosition(), this.clonePosition()));
        if (this.requiresOtherClause && !hasOtherClause) return this.error((0, $iGmlb.ErrorKind).MISSING_OTHER_CLAUSE, $4167299d39181961$var$createLocation(this.clonePosition(), this.clonePosition()));
        return {
            val: options,
            err: null
        };
    };
    Parser.prototype.tryParseDecimalInteger = function(expectNumberError, invalidNumberError) {
        var sign = 1;
        var startingPosition = this.clonePosition();
        if (this.bumpIf("+")) ;
        else if (this.bumpIf("-")) sign = -1;
        var hasDigits = false;
        var decimal = 0;
        while(!this.isEOF()){
            var ch = this.char();
            if (ch >= 48 /* `0` */  && ch <= 57 /* `9` */ ) {
                hasDigits = true;
                decimal = decimal * 10 + (ch - 48);
                this.bump();
            } else break;
        }
        var location = $4167299d39181961$var$createLocation(startingPosition, this.clonePosition());
        if (!hasDigits) return this.error(expectNumberError, location);
        decimal *= sign;
        if (!$4167299d39181961$var$isSafeInteger(decimal)) return this.error(invalidNumberError, location);
        return {
            val: decimal,
            err: null
        };
    };
    Parser.prototype.offset = function() {
        return this.position.offset;
    };
    Parser.prototype.isEOF = function() {
        return this.offset() === this.message.length;
    };
    Parser.prototype.clonePosition = function() {
        // This is much faster than `Object.assign` or spread.
        return {
            offset: this.position.offset,
            line: this.position.line,
            column: this.position.column
        };
    };
    /**
     * Return the code point at the current position of the parser.
     * Throws if the index is out of bound.
     */ Parser.prototype.char = function() {
        var offset = this.position.offset;
        if (offset >= this.message.length) throw Error("out of bound");
        var code = $4167299d39181961$var$codePointAt(this.message, offset);
        if (code === undefined) throw Error("Offset ".concat(offset, " is at invalid UTF-16 code unit boundary"));
        return code;
    };
    Parser.prototype.error = function(kind, location) {
        return {
            val: null,
            err: {
                kind: kind,
                message: this.message,
                location: location
            }
        };
    };
    /** Bump the parser to the next UTF-16 code unit. */ Parser.prototype.bump = function() {
        if (this.isEOF()) return;
        var code = this.char();
        if (code === 10 /* '\n' */ ) {
            this.position.line += 1;
            this.position.column = 1;
            this.position.offset += 1;
        } else {
            this.position.column += 1;
            // 0 ~ 0x10000 -> unicode BMP, otherwise skip the surrogate pair.
            this.position.offset += code < 0x10000 ? 1 : 2;
        }
    };
    /**
     * If the substring starting at the current position of the parser has
     * the given prefix, then bump the parser to the character immediately
     * following the prefix and return true. Otherwise, don't bump the parser
     * and return false.
     */ Parser.prototype.bumpIf = function(prefix) {
        if ($4167299d39181961$var$startsWith(this.message, prefix, this.offset())) {
            for(var i = 0; i < prefix.length; i++)this.bump();
            return true;
        }
        return false;
    };
    /**
     * Bump the parser until the pattern character is found and return `true`.
     * Otherwise bump to the end of the file and return `false`.
     */ Parser.prototype.bumpUntil = function(pattern) {
        var currentOffset = this.offset();
        var index = this.message.indexOf(pattern, currentOffset);
        if (index >= 0) {
            this.bumpTo(index);
            return true;
        } else {
            this.bumpTo(this.message.length);
            return false;
        }
    };
    /**
     * Bump the parser to the target offset.
     * If target offset is beyond the end of the input, bump the parser to the end of the input.
     */ Parser.prototype.bumpTo = function(targetOffset) {
        if (this.offset() > targetOffset) throw Error("targetOffset ".concat(targetOffset, " must be greater than or equal to the current offset ").concat(this.offset()));
        targetOffset = Math.min(targetOffset, this.message.length);
        while(true){
            var offset = this.offset();
            if (offset === targetOffset) break;
            if (offset > targetOffset) throw Error("targetOffset ".concat(targetOffset, " is at invalid UTF-16 code unit boundary"));
            this.bump();
            if (this.isEOF()) break;
        }
    };
    /** advance the parser through all whitespace to the next non-whitespace code unit. */ Parser.prototype.bumpSpace = function() {
        while(!this.isEOF() && $4167299d39181961$var$_isWhiteSpace(this.char()))this.bump();
    };
    /**
     * Peek at the *next* Unicode codepoint in the input without advancing the parser.
     * If the input has been exhausted, then this returns null.
     */ Parser.prototype.peek = function() {
        if (this.isEOF()) return null;
        var code = this.char();
        var offset = this.offset();
        var nextCode = this.message.charCodeAt(offset + (code >= 0x10000 ? 2 : 1));
        return nextCode !== null && nextCode !== void 0 ? nextCode : null;
    };
    return Parser;
}();
/**
 * This check if codepoint is alphabet (lower & uppercase)
 * @param codepoint
 * @returns
 */ function $4167299d39181961$var$_isAlpha(codepoint) {
    return codepoint >= 97 && codepoint <= 122 || codepoint >= 65 && codepoint <= 90;
}
function $4167299d39181961$var$_isAlphaOrSlash(codepoint) {
    return $4167299d39181961$var$_isAlpha(codepoint) || codepoint === 47; /* '/' */ 
}
/** See `parseTag` function docs. */ function $4167299d39181961$var$_isPotentialElementNameChar(c) {
    return c === 45 /* '-' */  || c === 46 /* '.' */  || c >= 48 && c <= 57 || c === 95 /* '_' */  || c >= 97 && c <= 122 || c >= 65 && c <= 90 || c == 0xb7 || c >= 0xc0 && c <= 0xd6 || c >= 0xd8 && c <= 0xf6 || c >= 0xf8 && c <= 0x37d || c >= 0x37f && c <= 0x1fff || c >= 0x200c && c <= 0x200d || c >= 0x203f && c <= 0x2040 || c >= 0x2070 && c <= 0x218f || c >= 0x2c00 && c <= 0x2fef || c >= 0x3001 && c <= 0xd7ff || c >= 0xf900 && c <= 0xfdcf || c >= 0xfdf0 && c <= 0xfffd || c >= 0x10000 && c <= 0xeffff;
}
/**
 * Code point equivalent of regex `\p{White_Space}`.
 * From: https://www.unicode.org/Public/UCD/latest/ucd/PropList.txt
 */ function $4167299d39181961$var$_isWhiteSpace(c) {
    return c >= 0x0009 && c <= 0x000d || c === 0x0020 || c === 0x0085 || c >= 0x200e && c <= 0x200f || c === 0x2028 || c === 0x2029;
}
/**
 * Code point equivalent of regex `\p{Pattern_Syntax}`.
 * See https://www.unicode.org/Public/UCD/latest/ucd/PropList.txt
 */ function $4167299d39181961$var$_isPatternSyntax(c) {
    return c >= 0x0021 && c <= 0x0023 || c === 0x0024 || c >= 0x0025 && c <= 0x0027 || c === 0x0028 || c === 0x0029 || c === 0x002a || c === 0x002b || c === 0x002c || c === 0x002d || c >= 0x002e && c <= 0x002f || c >= 0x003a && c <= 0x003b || c >= 0x003c && c <= 0x003e || c >= 0x003f && c <= 0x0040 || c === 0x005b || c === 0x005c || c === 0x005d || c === 0x005e || c === 0x0060 || c === 0x007b || c === 0x007c || c === 0x007d || c === 0x007e || c === 0x00a1 || c >= 0x00a2 && c <= 0x00a5 || c === 0x00a6 || c === 0x00a7 || c === 0x00a9 || c === 0x00ab || c === 0x00ac || c === 0x00ae || c === 0x00b0 || c === 0x00b1 || c === 0x00b6 || c === 0x00bb || c === 0x00bf || c === 0x00d7 || c === 0x00f7 || c >= 0x2010 && c <= 0x2015 || c >= 0x2016 && c <= 0x2017 || c === 0x2018 || c === 0x2019 || c === 0x201a || c >= 0x201b && c <= 0x201c || c === 0x201d || c === 0x201e || c === 0x201f || c >= 0x2020 && c <= 0x2027 || c >= 0x2030 && c <= 0x2038 || c === 0x2039 || c === 0x203a || c >= 0x203b && c <= 0x203e || c >= 0x2041 && c <= 0x2043 || c === 0x2044 || c === 0x2045 || c === 0x2046 || c >= 0x2047 && c <= 0x2051 || c === 0x2052 || c === 0x2053 || c >= 0x2055 && c <= 0x205e || c >= 0x2190 && c <= 0x2194 || c >= 0x2195 && c <= 0x2199 || c >= 0x219a && c <= 0x219b || c >= 0x219c && c <= 0x219f || c === 0x21a0 || c >= 0x21a1 && c <= 0x21a2 || c === 0x21a3 || c >= 0x21a4 && c <= 0x21a5 || c === 0x21a6 || c >= 0x21a7 && c <= 0x21ad || c === 0x21ae || c >= 0x21af && c <= 0x21cd || c >= 0x21ce && c <= 0x21cf || c >= 0x21d0 && c <= 0x21d1 || c === 0x21d2 || c === 0x21d3 || c === 0x21d4 || c >= 0x21d5 && c <= 0x21f3 || c >= 0x21f4 && c <= 0x22ff || c >= 0x2300 && c <= 0x2307 || c === 0x2308 || c === 0x2309 || c === 0x230a || c === 0x230b || c >= 0x230c && c <= 0x231f || c >= 0x2320 && c <= 0x2321 || c >= 0x2322 && c <= 0x2328 || c === 0x2329 || c === 0x232a || c >= 0x232b && c <= 0x237b || c === 0x237c || c >= 0x237d && c <= 0x239a || c >= 0x239b && c <= 0x23b3 || c >= 0x23b4 && c <= 0x23db || c >= 0x23dc && c <= 0x23e1 || c >= 0x23e2 && c <= 0x2426 || c >= 0x2427 && c <= 0x243f || c >= 0x2440 && c <= 0x244a || c >= 0x244b && c <= 0x245f || c >= 0x2500 && c <= 0x25b6 || c === 0x25b7 || c >= 0x25b8 && c <= 0x25c0 || c === 0x25c1 || c >= 0x25c2 && c <= 0x25f7 || c >= 0x25f8 && c <= 0x25ff || c >= 0x2600 && c <= 0x266e || c === 0x266f || c >= 0x2670 && c <= 0x2767 || c === 0x2768 || c === 0x2769 || c === 0x276a || c === 0x276b || c === 0x276c || c === 0x276d || c === 0x276e || c === 0x276f || c === 0x2770 || c === 0x2771 || c === 0x2772 || c === 0x2773 || c === 0x2774 || c === 0x2775 || c >= 0x2794 && c <= 0x27bf || c >= 0x27c0 && c <= 0x27c4 || c === 0x27c5 || c === 0x27c6 || c >= 0x27c7 && c <= 0x27e5 || c === 0x27e6 || c === 0x27e7 || c === 0x27e8 || c === 0x27e9 || c === 0x27ea || c === 0x27eb || c === 0x27ec || c === 0x27ed || c === 0x27ee || c === 0x27ef || c >= 0x27f0 && c <= 0x27ff || c >= 0x2800 && c <= 0x28ff || c >= 0x2900 && c <= 0x2982 || c === 0x2983 || c === 0x2984 || c === 0x2985 || c === 0x2986 || c === 0x2987 || c === 0x2988 || c === 0x2989 || c === 0x298a || c === 0x298b || c === 0x298c || c === 0x298d || c === 0x298e || c === 0x298f || c === 0x2990 || c === 0x2991 || c === 0x2992 || c === 0x2993 || c === 0x2994 || c === 0x2995 || c === 0x2996 || c === 0x2997 || c === 0x2998 || c >= 0x2999 && c <= 0x29d7 || c === 0x29d8 || c === 0x29d9 || c === 0x29da || c === 0x29db || c >= 0x29dc && c <= 0x29fb || c === 0x29fc || c === 0x29fd || c >= 0x29fe && c <= 0x2aff || c >= 0x2b00 && c <= 0x2b2f || c >= 0x2b30 && c <= 0x2b44 || c >= 0x2b45 && c <= 0x2b46 || c >= 0x2b47 && c <= 0x2b4c || c >= 0x2b4d && c <= 0x2b73 || c >= 0x2b74 && c <= 0x2b75 || c >= 0x2b76 && c <= 0x2b95 || c === 0x2b96 || c >= 0x2b97 && c <= 0x2bff || c >= 0x2e00 && c <= 0x2e01 || c === 0x2e02 || c === 0x2e03 || c === 0x2e04 || c === 0x2e05 || c >= 0x2e06 && c <= 0x2e08 || c === 0x2e09 || c === 0x2e0a || c === 0x2e0b || c === 0x2e0c || c === 0x2e0d || c >= 0x2e0e && c <= 0x2e16 || c === 0x2e17 || c >= 0x2e18 && c <= 0x2e19 || c === 0x2e1a || c === 0x2e1b || c === 0x2e1c || c === 0x2e1d || c >= 0x2e1e && c <= 0x2e1f || c === 0x2e20 || c === 0x2e21 || c === 0x2e22 || c === 0x2e23 || c === 0x2e24 || c === 0x2e25 || c === 0x2e26 || c === 0x2e27 || c === 0x2e28 || c === 0x2e29 || c >= 0x2e2a && c <= 0x2e2e || c === 0x2e2f || c >= 0x2e30 && c <= 0x2e39 || c >= 0x2e3a && c <= 0x2e3b || c >= 0x2e3c && c <= 0x2e3f || c === 0x2e40 || c === 0x2e41 || c === 0x2e42 || c >= 0x2e43 && c <= 0x2e4f || c >= 0x2e50 && c <= 0x2e51 || c === 0x2e52 || c >= 0x2e53 && c <= 0x2e7f || c >= 0x3001 && c <= 0x3003 || c === 0x3008 || c === 0x3009 || c === 0x300a || c === 0x300b || c === 0x300c || c === 0x300d || c === 0x300e || c === 0x300f || c === 0x3010 || c === 0x3011 || c >= 0x3012 && c <= 0x3013 || c === 0x3014 || c === 0x3015 || c === 0x3016 || c === 0x3017 || c === 0x3018 || c === 0x3019 || c === 0x301a || c === 0x301b || c === 0x301c || c === 0x301d || c >= 0x301e && c <= 0x301f || c === 0x3020 || c === 0x3030 || c === 0xfd3e || c === 0xfd3f || c >= 0xfe45 && c <= 0xfe46;
}

});
parcelRegister("a5i87", function(module, exports) {

$parcel$export(module.exports, "TYPE", function () { return $75786f449df6d2b2$export$b87f371cbc396fcf; });
$parcel$export(module.exports, "SKELETON_TYPE", function () { return $75786f449df6d2b2$export$906452485466fa53; });
$parcel$export(module.exports, "isLiteralElement", function () { return $75786f449df6d2b2$export$cfa10c5697238752; });
$parcel$export(module.exports, "isArgumentElement", function () { return $75786f449df6d2b2$export$4f55724281bdfaf9; });
$parcel$export(module.exports, "isNumberElement", function () { return $75786f449df6d2b2$export$e11187b219e191e1; });
$parcel$export(module.exports, "isDateElement", function () { return $75786f449df6d2b2$export$32d811605da75f40; });
$parcel$export(module.exports, "isTimeElement", function () { return $75786f449df6d2b2$export$34ec46f596b1702f; });
$parcel$export(module.exports, "isSelectElement", function () { return $75786f449df6d2b2$export$dcfe1c11d168b5a1; });
$parcel$export(module.exports, "isPluralElement", function () { return $75786f449df6d2b2$export$6c796d116f0a4fbc; });
$parcel$export(module.exports, "isPoundElement", function () { return $75786f449df6d2b2$export$c0ece297bdd0c082; });
$parcel$export(module.exports, "isTagElement", function () { return $75786f449df6d2b2$export$5c83de34745812b; });
$parcel$export(module.exports, "isNumberSkeleton", function () { return $75786f449df6d2b2$export$3f9a19cd4152eda3; });
$parcel$export(module.exports, "isDateTimeSkeleton", function () { return $75786f449df6d2b2$export$7680c41f1a55f4cf; });
var $75786f449df6d2b2$export$b87f371cbc396fcf;
(function(TYPE) {
    /**
     * Raw text
     */ TYPE[TYPE["literal"] = 0] = "literal";
    /**
     * Variable w/o any format, e.g `var` in `this is a {var}`
     */ TYPE[TYPE["argument"] = 1] = "argument";
    /**
     * Variable w/ number format
     */ TYPE[TYPE["number"] = 2] = "number";
    /**
     * Variable w/ date format
     */ TYPE[TYPE["date"] = 3] = "date";
    /**
     * Variable w/ time format
     */ TYPE[TYPE["time"] = 4] = "time";
    /**
     * Variable w/ select format
     */ TYPE[TYPE["select"] = 5] = "select";
    /**
     * Variable w/ plural format
     */ TYPE[TYPE["plural"] = 6] = "plural";
    /**
     * Only possible within plural argument.
     * This is the `#` symbol that will be substituted with the count.
     */ TYPE[TYPE["pound"] = 7] = "pound";
    /**
     * XML-like tag
     */ TYPE[TYPE["tag"] = 8] = "tag";
})($75786f449df6d2b2$export$b87f371cbc396fcf || ($75786f449df6d2b2$export$b87f371cbc396fcf = {}));
var $75786f449df6d2b2$export$906452485466fa53;
(function(SKELETON_TYPE) {
    SKELETON_TYPE[SKELETON_TYPE["number"] = 0] = "number";
    SKELETON_TYPE[SKELETON_TYPE["dateTime"] = 1] = "dateTime";
})($75786f449df6d2b2$export$906452485466fa53 || ($75786f449df6d2b2$export$906452485466fa53 = {}));
function $75786f449df6d2b2$export$cfa10c5697238752(el) {
    return el.type === $75786f449df6d2b2$export$b87f371cbc396fcf.literal;
}
function $75786f449df6d2b2$export$4f55724281bdfaf9(el) {
    return el.type === $75786f449df6d2b2$export$b87f371cbc396fcf.argument;
}
function $75786f449df6d2b2$export$e11187b219e191e1(el) {
    return el.type === $75786f449df6d2b2$export$b87f371cbc396fcf.number;
}
function $75786f449df6d2b2$export$32d811605da75f40(el) {
    return el.type === $75786f449df6d2b2$export$b87f371cbc396fcf.date;
}
function $75786f449df6d2b2$export$34ec46f596b1702f(el) {
    return el.type === $75786f449df6d2b2$export$b87f371cbc396fcf.time;
}
function $75786f449df6d2b2$export$dcfe1c11d168b5a1(el) {
    return el.type === $75786f449df6d2b2$export$b87f371cbc396fcf.select;
}
function $75786f449df6d2b2$export$6c796d116f0a4fbc(el) {
    return el.type === $75786f449df6d2b2$export$b87f371cbc396fcf.plural;
}
function $75786f449df6d2b2$export$c0ece297bdd0c082(el) {
    return el.type === $75786f449df6d2b2$export$b87f371cbc396fcf.pound;
}
function $75786f449df6d2b2$export$5c83de34745812b(el) {
    return el.type === $75786f449df6d2b2$export$b87f371cbc396fcf.tag;
}
function $75786f449df6d2b2$export$3f9a19cd4152eda3(el) {
    return !!(el && typeof el === "object" && el.type === $75786f449df6d2b2$export$906452485466fa53.number);
}
function $75786f449df6d2b2$export$7680c41f1a55f4cf(el) {
    return !!(el && typeof el === "object" && el.type === $75786f449df6d2b2$export$906452485466fa53.dateTime);
}
function $75786f449df6d2b2$export$f0ac572c1121c662(value) {
    return {
        type: $75786f449df6d2b2$export$b87f371cbc396fcf.literal,
        value: value
    };
}
function $75786f449df6d2b2$export$425e864b0ba114f1(value, style) {
    return {
        type: $75786f449df6d2b2$export$b87f371cbc396fcf.number,
        value: value,
        style: style
    };
}

});

parcelRegister("2m77C", function(module, exports) {

$parcel$export(module.exports, "SPACE_SEPARATOR_REGEX", function () { return $1b73291d395e5a94$export$523451f94304dd6c; });
// @generated from regex-gen.ts
var $1b73291d395e5a94$export$523451f94304dd6c = /[ \xA0\u1680\u2000-\u200A\u202F\u205F\u3000]/;
var $1b73291d395e5a94$export$2b8db14d8bcaece7 = /[\t-\r \x85\u200E\u200F\u2028\u2029]/;

});

parcelRegister("hDzp7", function(module, exports) {
$parcel$export(module.exports, "parseDateTimeSkeleton", function () { return (parcelRequire("2WsKD")).parseDateTimeSkeleton; });
$parcel$export(module.exports, "parseNumberSkeleton", function () { return (parcelRequire("4GppD")).parseNumberSkeleton; });
$parcel$export(module.exports, "parseNumberSkeletonFromString", function () { return (parcelRequire("4GppD")).parseNumberSkeletonFromString; });
parcelRequire("2WsKD");
parcelRequire("4GppD");

});
parcelRegister("2WsKD", function(module, exports) {

$parcel$export(module.exports, "parseDateTimeSkeleton", function () { return $22474cec4db80596$export$f7b99fb377fe69fa; });
/**
 * https://unicode.org/reports/tr35/tr35-dates.html#Date_Field_Symbol_Table
 * Credit: https://github.com/caridy/intl-datetimeformat-pattern/blob/master/index.js
 * with some tweaks
 */ var $22474cec4db80596$var$DATE_TIME_REGEX = /(?:[Eec]{1,6}|G{1,5}|[Qq]{1,5}|(?:[yYur]+|U{1,5})|[ML]{1,5}|d{1,2}|D{1,3}|F{1}|[abB]{1,5}|[hkHK]{1,2}|w{1,2}|W{1}|m{1,2}|s{1,2}|[zZOvVxX]{1,4})(?=([^']*'[^']*')*[^']*$)/g;
function $22474cec4db80596$export$f7b99fb377fe69fa(skeleton) {
    var result = {};
    skeleton.replace($22474cec4db80596$var$DATE_TIME_REGEX, function(match) {
        var len = match.length;
        switch(match[0]){
            // Era
            case "G":
                result.era = len === 4 ? "long" : len === 5 ? "narrow" : "short";
                break;
            // Year
            case "y":
                result.year = len === 2 ? "2-digit" : "numeric";
                break;
            case "Y":
            case "u":
            case "U":
            case "r":
                throw new RangeError("`Y/u/U/r` (year) patterns are not supported, use `y` instead");
            // Quarter
            case "q":
            case "Q":
                throw new RangeError("`q/Q` (quarter) patterns are not supported");
            // Month
            case "M":
            case "L":
                result.month = [
                    "numeric",
                    "2-digit",
                    "short",
                    "long",
                    "narrow"
                ][len - 1];
                break;
            // Week
            case "w":
            case "W":
                throw new RangeError("`w/W` (week) patterns are not supported");
            case "d":
                result.day = [
                    "numeric",
                    "2-digit"
                ][len - 1];
                break;
            case "D":
            case "F":
            case "g":
                throw new RangeError("`D/F/g` (day) patterns are not supported, use `d` instead");
            // Weekday
            case "E":
                result.weekday = len === 4 ? "long" : len === 5 ? "narrow" : "short";
                break;
            case "e":
                if (len < 4) throw new RangeError("`e..eee` (weekday) patterns are not supported");
                result.weekday = [
                    "short",
                    "long",
                    "narrow",
                    "short"
                ][len - 4];
                break;
            case "c":
                if (len < 4) throw new RangeError("`c..ccc` (weekday) patterns are not supported");
                result.weekday = [
                    "short",
                    "long",
                    "narrow",
                    "short"
                ][len - 4];
                break;
            // Period
            case "a":
                result.hour12 = true;
                break;
            case "b":
            case "B":
                throw new RangeError("`b/B` (period) patterns are not supported, use `a` instead");
            // Hour
            case "h":
                result.hourCycle = "h12";
                result.hour = [
                    "numeric",
                    "2-digit"
                ][len - 1];
                break;
            case "H":
                result.hourCycle = "h23";
                result.hour = [
                    "numeric",
                    "2-digit"
                ][len - 1];
                break;
            case "K":
                result.hourCycle = "h11";
                result.hour = [
                    "numeric",
                    "2-digit"
                ][len - 1];
                break;
            case "k":
                result.hourCycle = "h24";
                result.hour = [
                    "numeric",
                    "2-digit"
                ][len - 1];
                break;
            case "j":
            case "J":
            case "C":
                throw new RangeError("`j/J/C` (hour) patterns are not supported, use `h/H/K/k` instead");
            // Minute
            case "m":
                result.minute = [
                    "numeric",
                    "2-digit"
                ][len - 1];
                break;
            // Second
            case "s":
                result.second = [
                    "numeric",
                    "2-digit"
                ][len - 1];
                break;
            case "S":
            case "A":
                throw new RangeError("`S/A` (second) patterns are not supported, use `s` instead");
            // Zone
            case "z":
                result.timeZoneName = len < 4 ? "short" : "long";
                break;
            case "Z":
            case "O":
            case "v":
            case "V":
            case "X":
            case "x":
                throw new RangeError("`Z/O/v/V/X/x` (timeZone) patterns are not supported, use `z` instead");
        }
        return "";
    });
    return result;
}

});

parcelRegister("4GppD", function(module, exports) {

$parcel$export(module.exports, "parseNumberSkeletonFromString", function () { return $368ecc0b5163d758$export$71cee2f16fba2480; });
$parcel$export(module.exports, "parseNumberSkeleton", function () { return $368ecc0b5163d758$export$47c6f8480bda3e11; });

var $gb4K1 = parcelRequire("gb4K1");

var $8lL8v = parcelRequire("8lL8v");
function $368ecc0b5163d758$export$71cee2f16fba2480(skeleton) {
    if (skeleton.length === 0) throw new Error("Number skeleton cannot be empty");
    // Parse the skeleton
    var stringTokens = skeleton.split((0, $8lL8v.WHITE_SPACE_REGEX)).filter(function(x) {
        return x.length > 0;
    });
    var tokens = [];
    for(var _i = 0, stringTokens_1 = stringTokens; _i < stringTokens_1.length; _i++){
        var stringToken = stringTokens_1[_i];
        var stemAndOptions = stringToken.split("/");
        if (stemAndOptions.length === 0) throw new Error("Invalid number skeleton");
        var stem = stemAndOptions[0], options = stemAndOptions.slice(1);
        for(var _a = 0, options_1 = options; _a < options_1.length; _a++){
            var option = options_1[_a];
            if (option.length === 0) throw new Error("Invalid number skeleton");
        }
        tokens.push({
            stem: stem,
            options: options
        });
    }
    return tokens;
}
function $368ecc0b5163d758$var$icuUnitToEcma(unit) {
    return unit.replace(/^(.*?)-/, "");
}
var $368ecc0b5163d758$var$FRACTION_PRECISION_REGEX = /^\.(?:(0+)(\*)?|(#+)|(0+)(#+))$/g;
var $368ecc0b5163d758$var$SIGNIFICANT_PRECISION_REGEX = /^(@+)?(\+|#+)?[rs]?$/g;
var $368ecc0b5163d758$var$INTEGER_WIDTH_REGEX = /(\*)(0+)|(#+)(0+)|(0+)/g;
var $368ecc0b5163d758$var$CONCISE_INTEGER_WIDTH_REGEX = /^(0+)$/;
function $368ecc0b5163d758$var$parseSignificantPrecision(str) {
    var result = {};
    if (str[str.length - 1] === "r") result.roundingPriority = "morePrecision";
    else if (str[str.length - 1] === "s") result.roundingPriority = "lessPrecision";
    str.replace($368ecc0b5163d758$var$SIGNIFICANT_PRECISION_REGEX, function(_, g1, g2) {
        // @@@ case
        if (typeof g2 !== "string") {
            result.minimumSignificantDigits = g1.length;
            result.maximumSignificantDigits = g1.length;
        } else if (g2 === "+") result.minimumSignificantDigits = g1.length;
        else if (g1[0] === "#") result.maximumSignificantDigits = g1.length;
        else {
            result.minimumSignificantDigits = g1.length;
            result.maximumSignificantDigits = g1.length + (typeof g2 === "string" ? g2.length : 0);
        }
        return "";
    });
    return result;
}
function $368ecc0b5163d758$var$parseSign(str) {
    switch(str){
        case "sign-auto":
            return {
                signDisplay: "auto"
            };
        case "sign-accounting":
        case "()":
            return {
                currencySign: "accounting"
            };
        case "sign-always":
        case "+!":
            return {
                signDisplay: "always"
            };
        case "sign-accounting-always":
        case "()!":
            return {
                signDisplay: "always",
                currencySign: "accounting"
            };
        case "sign-except-zero":
        case "+?":
            return {
                signDisplay: "exceptZero"
            };
        case "sign-accounting-except-zero":
        case "()?":
            return {
                signDisplay: "exceptZero",
                currencySign: "accounting"
            };
        case "sign-never":
        case "+_":
            return {
                signDisplay: "never"
            };
    }
}
function $368ecc0b5163d758$var$parseConciseScientificAndEngineeringStem(stem) {
    // Engineering
    var result;
    if (stem[0] === "E" && stem[1] === "E") {
        result = {
            notation: "engineering"
        };
        stem = stem.slice(2);
    } else if (stem[0] === "E") {
        result = {
            notation: "scientific"
        };
        stem = stem.slice(1);
    }
    if (result) {
        var signDisplay = stem.slice(0, 2);
        if (signDisplay === "+!") {
            result.signDisplay = "always";
            stem = stem.slice(2);
        } else if (signDisplay === "+?") {
            result.signDisplay = "exceptZero";
            stem = stem.slice(2);
        }
        if (!$368ecc0b5163d758$var$CONCISE_INTEGER_WIDTH_REGEX.test(stem)) throw new Error("Malformed concise eng/scientific notation");
        result.minimumIntegerDigits = stem.length;
    }
    return result;
}
function $368ecc0b5163d758$var$parseNotationOptions(opt) {
    var result = {};
    var signOpts = $368ecc0b5163d758$var$parseSign(opt);
    if (signOpts) return signOpts;
    return result;
}
function $368ecc0b5163d758$export$47c6f8480bda3e11(tokens) {
    var result = {};
    for(var _i = 0, tokens_1 = tokens; _i < tokens_1.length; _i++){
        var token = tokens_1[_i];
        switch(token.stem){
            case "percent":
            case "%":
                result.style = "percent";
                continue;
            case "%x100":
                result.style = "percent";
                result.scale = 100;
                continue;
            case "currency":
                result.style = "currency";
                result.currency = token.options[0];
                continue;
            case "group-off":
            case ",_":
                result.useGrouping = false;
                continue;
            case "precision-integer":
            case ".":
                result.maximumFractionDigits = 0;
                continue;
            case "measure-unit":
            case "unit":
                result.style = "unit";
                result.unit = $368ecc0b5163d758$var$icuUnitToEcma(token.options[0]);
                continue;
            case "compact-short":
            case "K":
                result.notation = "compact";
                result.compactDisplay = "short";
                continue;
            case "compact-long":
            case "KK":
                result.notation = "compact";
                result.compactDisplay = "long";
                continue;
            case "scientific":
                result = (0, $gb4K1.__assign)((0, $gb4K1.__assign)((0, $gb4K1.__assign)({}, result), {
                    notation: "scientific"
                }), token.options.reduce(function(all, opt) {
                    return (0, $gb4K1.__assign)((0, $gb4K1.__assign)({}, all), $368ecc0b5163d758$var$parseNotationOptions(opt));
                }, {}));
                continue;
            case "engineering":
                result = (0, $gb4K1.__assign)((0, $gb4K1.__assign)((0, $gb4K1.__assign)({}, result), {
                    notation: "engineering"
                }), token.options.reduce(function(all, opt) {
                    return (0, $gb4K1.__assign)((0, $gb4K1.__assign)({}, all), $368ecc0b5163d758$var$parseNotationOptions(opt));
                }, {}));
                continue;
            case "notation-simple":
                result.notation = "standard";
                continue;
            // https://github.com/unicode-org/icu/blob/master/icu4c/source/i18n/unicode/unumberformatter.h
            case "unit-width-narrow":
                result.currencyDisplay = "narrowSymbol";
                result.unitDisplay = "narrow";
                continue;
            case "unit-width-short":
                result.currencyDisplay = "code";
                result.unitDisplay = "short";
                continue;
            case "unit-width-full-name":
                result.currencyDisplay = "name";
                result.unitDisplay = "long";
                continue;
            case "unit-width-iso-code":
                result.currencyDisplay = "symbol";
                continue;
            case "scale":
                result.scale = parseFloat(token.options[0]);
                continue;
            // https://unicode-org.github.io/icu/userguide/format_parse/numbers/skeletons.html#integer-width
            case "integer-width":
                if (token.options.length > 1) throw new RangeError("integer-width stems only accept a single optional option");
                token.options[0].replace($368ecc0b5163d758$var$INTEGER_WIDTH_REGEX, function(_, g1, g2, g3, g4, g5) {
                    if (g1) result.minimumIntegerDigits = g2.length;
                    else if (g3 && g4) throw new Error("We currently do not support maximum integer digits");
                    else if (g5) throw new Error("We currently do not support exact integer digits");
                    return "";
                });
                continue;
        }
        // https://unicode-org.github.io/icu/userguide/format_parse/numbers/skeletons.html#integer-width
        if ($368ecc0b5163d758$var$CONCISE_INTEGER_WIDTH_REGEX.test(token.stem)) {
            result.minimumIntegerDigits = token.stem.length;
            continue;
        }
        if ($368ecc0b5163d758$var$FRACTION_PRECISION_REGEX.test(token.stem)) {
            // Precision
            // https://unicode-org.github.io/icu/userguide/format_parse/numbers/skeletons.html#fraction-precision
            // precision-integer case
            if (token.options.length > 1) throw new RangeError("Fraction-precision stems only accept a single optional option");
            token.stem.replace($368ecc0b5163d758$var$FRACTION_PRECISION_REGEX, function(_, g1, g2, g3, g4, g5) {
                // .000* case (before ICU67 it was .000+)
                if (g2 === "*") result.minimumFractionDigits = g1.length;
                else if (g3 && g3[0] === "#") result.maximumFractionDigits = g3.length;
                else if (g4 && g5) {
                    result.minimumFractionDigits = g4.length;
                    result.maximumFractionDigits = g4.length + g5.length;
                } else {
                    result.minimumFractionDigits = g1.length;
                    result.maximumFractionDigits = g1.length;
                }
                return "";
            });
            var opt = token.options[0];
            // https://unicode-org.github.io/icu/userguide/format_parse/numbers/skeletons.html#trailing-zero-display
            if (opt === "w") result = (0, $gb4K1.__assign)((0, $gb4K1.__assign)({}, result), {
                trailingZeroDisplay: "stripIfInteger"
            });
            else if (opt) result = (0, $gb4K1.__assign)((0, $gb4K1.__assign)({}, result), $368ecc0b5163d758$var$parseSignificantPrecision(opt));
            continue;
        }
        // https://unicode-org.github.io/icu/userguide/format_parse/numbers/skeletons.html#significant-digits-precision
        if ($368ecc0b5163d758$var$SIGNIFICANT_PRECISION_REGEX.test(token.stem)) {
            result = (0, $gb4K1.__assign)((0, $gb4K1.__assign)({}, result), $368ecc0b5163d758$var$parseSignificantPrecision(token.stem));
            continue;
        }
        var signOpts = $368ecc0b5163d758$var$parseSign(token.stem);
        if (signOpts) result = (0, $gb4K1.__assign)((0, $gb4K1.__assign)({}, result), signOpts);
        var conciseScientificAndEngineeringOpts = $368ecc0b5163d758$var$parseConciseScientificAndEngineeringStem(token.stem);
        if (conciseScientificAndEngineeringOpts) result = (0, $gb4K1.__assign)((0, $gb4K1.__assign)({}, result), conciseScientificAndEngineeringOpts);
    }
    return result;
}

});
parcelRegister("8lL8v", function(module, exports) {

$parcel$export(module.exports, "WHITE_SPACE_REGEX", function () { return $6144d926f66f1e6a$export$2b8db14d8bcaece7; });
// @generated from regex-gen.ts
var $6144d926f66f1e6a$export$2b8db14d8bcaece7 = /[\t-\r \x85\u200E\u200F\u2028\u2029]/i;

});



parcelRegister("6hTU2", function(module, exports) {

$parcel$export(module.exports, "getBestPattern", function () { return $493fb1c51895e6a4$export$29c5368be8904d27; });

var $eEJFp = parcelRequire("eEJFp");
function $493fb1c51895e6a4$export$29c5368be8904d27(skeleton, locale) {
    var skeletonCopy = "";
    for(var patternPos = 0; patternPos < skeleton.length; patternPos++){
        var patternChar = skeleton.charAt(patternPos);
        if (patternChar === "j") {
            var extraLength = 0;
            while(patternPos + 1 < skeleton.length && skeleton.charAt(patternPos + 1) === patternChar){
                extraLength++;
                patternPos++;
            }
            var hourLen = 1 + (extraLength & 1);
            var dayPeriodLen = extraLength < 2 ? 1 : 3 + (extraLength >> 1);
            var dayPeriodChar = "a";
            var hourChar = $493fb1c51895e6a4$var$getDefaultHourSymbolFromLocale(locale);
            if (hourChar == "H" || hourChar == "k") dayPeriodLen = 0;
            while(dayPeriodLen-- > 0)skeletonCopy += dayPeriodChar;
            while(hourLen-- > 0)skeletonCopy = hourChar + skeletonCopy;
        } else if (patternChar === "J") skeletonCopy += "H";
        else skeletonCopy += patternChar;
    }
    return skeletonCopy;
}
/**
 * Maps the [hour cycle type](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/Locale/hourCycle)
 * of the given `locale` to the corresponding time pattern.
 * @param locale
 */ function $493fb1c51895e6a4$var$getDefaultHourSymbolFromLocale(locale) {
    var hourCycle = locale.hourCycle;
    if (hourCycle === undefined && // @ts-ignore hourCycle(s) is not identified yet
    locale.hourCycles && // @ts-ignore
    locale.hourCycles.length) // @ts-ignore
    hourCycle = locale.hourCycles[0];
    if (hourCycle) switch(hourCycle){
        case "h24":
            return "k";
        case "h23":
            return "H";
        case "h12":
            return "h";
        case "h11":
            return "K";
        default:
            throw new Error("Invalid hourCycle");
    }
    // TODO: Once hourCycle is fully supported remove the following with data generation
    var languageTag = locale.language;
    var regionTag;
    if (languageTag !== "root") regionTag = locale.maximize().region;
    var hourCycles = (0, $eEJFp.timeData)[regionTag || ""] || (0, $eEJFp.timeData)[languageTag || ""] || (0, $eEJFp.timeData)["".concat(languageTag, "-001")] || (0, $eEJFp.timeData)["001"];
    return hourCycles[0];
}

});
parcelRegister("eEJFp", function(module, exports) {

$parcel$export(module.exports, "timeData", function () { return $aab8399e6b194b97$export$a8c9209db4084317; });
// @generated from time-data-gen.ts
// prettier-ignore  
var $aab8399e6b194b97$export$a8c9209db4084317 = {
    "001": [
        "H",
        "h"
    ],
    "AC": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "AD": [
        "H",
        "hB"
    ],
    "AE": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "AF": [
        "H",
        "hb",
        "hB",
        "h"
    ],
    "AG": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "AI": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "AL": [
        "h",
        "H",
        "hB"
    ],
    "AM": [
        "H",
        "hB"
    ],
    "AO": [
        "H",
        "hB"
    ],
    "AR": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "AS": [
        "h",
        "H"
    ],
    "AT": [
        "H",
        "hB"
    ],
    "AU": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "AW": [
        "H",
        "hB"
    ],
    "AX": [
        "H"
    ],
    "AZ": [
        "H",
        "hB",
        "h"
    ],
    "BA": [
        "H",
        "hB",
        "h"
    ],
    "BB": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "BD": [
        "h",
        "hB",
        "H"
    ],
    "BE": [
        "H",
        "hB"
    ],
    "BF": [
        "H",
        "hB"
    ],
    "BG": [
        "H",
        "hB",
        "h"
    ],
    "BH": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "BI": [
        "H",
        "h"
    ],
    "BJ": [
        "H",
        "hB"
    ],
    "BL": [
        "H",
        "hB"
    ],
    "BM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "BN": [
        "hb",
        "hB",
        "h",
        "H"
    ],
    "BO": [
        "H",
        "hB",
        "h",
        "hb"
    ],
    "BQ": [
        "H"
    ],
    "BR": [
        "H",
        "hB"
    ],
    "BS": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "BT": [
        "h",
        "H"
    ],
    "BW": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "BY": [
        "H",
        "h"
    ],
    "BZ": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "CA": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "CC": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "CD": [
        "hB",
        "H"
    ],
    "CF": [
        "H",
        "h",
        "hB"
    ],
    "CG": [
        "H",
        "hB"
    ],
    "CH": [
        "H",
        "hB",
        "h"
    ],
    "CI": [
        "H",
        "hB"
    ],
    "CK": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "CL": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "CM": [
        "H",
        "h",
        "hB"
    ],
    "CN": [
        "H",
        "hB",
        "hb",
        "h"
    ],
    "CO": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "CP": [
        "H"
    ],
    "CR": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "CU": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "CV": [
        "H",
        "hB"
    ],
    "CW": [
        "H",
        "hB"
    ],
    "CX": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "CY": [
        "h",
        "H",
        "hb",
        "hB"
    ],
    "CZ": [
        "H"
    ],
    "DE": [
        "H",
        "hB"
    ],
    "DG": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "DJ": [
        "h",
        "H"
    ],
    "DK": [
        "H"
    ],
    "DM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "DO": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "DZ": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "EA": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "EC": [
        "H",
        "hB",
        "h",
        "hb"
    ],
    "EE": [
        "H",
        "hB"
    ],
    "EG": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "EH": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "ER": [
        "h",
        "H"
    ],
    "ES": [
        "H",
        "hB",
        "h",
        "hb"
    ],
    "ET": [
        "hB",
        "hb",
        "h",
        "H"
    ],
    "FI": [
        "H"
    ],
    "FJ": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "FK": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "FM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "FO": [
        "H",
        "h"
    ],
    "FR": [
        "H",
        "hB"
    ],
    "GA": [
        "H",
        "hB"
    ],
    "GB": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "GD": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "GE": [
        "H",
        "hB",
        "h"
    ],
    "GF": [
        "H",
        "hB"
    ],
    "GG": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "GH": [
        "h",
        "H"
    ],
    "GI": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "GL": [
        "H",
        "h"
    ],
    "GM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "GN": [
        "H",
        "hB"
    ],
    "GP": [
        "H",
        "hB"
    ],
    "GQ": [
        "H",
        "hB",
        "h",
        "hb"
    ],
    "GR": [
        "h",
        "H",
        "hb",
        "hB"
    ],
    "GT": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "GU": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "GW": [
        "H",
        "hB"
    ],
    "GY": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "HK": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "HN": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "HR": [
        "H",
        "hB"
    ],
    "HU": [
        "H",
        "h"
    ],
    "IC": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "ID": [
        "H"
    ],
    "IE": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "IL": [
        "H",
        "hB"
    ],
    "IM": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "IN": [
        "h",
        "H"
    ],
    "IO": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "IQ": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "IR": [
        "hB",
        "H"
    ],
    "IS": [
        "H"
    ],
    "IT": [
        "H",
        "hB"
    ],
    "JE": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "JM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "JO": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "JP": [
        "H",
        "K",
        "h"
    ],
    "KE": [
        "hB",
        "hb",
        "H",
        "h"
    ],
    "KG": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "KH": [
        "hB",
        "h",
        "H",
        "hb"
    ],
    "KI": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "KM": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "KN": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "KP": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "KR": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "KW": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "KY": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "KZ": [
        "H",
        "hB"
    ],
    "LA": [
        "H",
        "hb",
        "hB",
        "h"
    ],
    "LB": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "LC": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "LI": [
        "H",
        "hB",
        "h"
    ],
    "LK": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "LR": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "LS": [
        "h",
        "H"
    ],
    "LT": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "LU": [
        "H",
        "h",
        "hB"
    ],
    "LV": [
        "H",
        "hB",
        "hb",
        "h"
    ],
    "LY": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "MA": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "MC": [
        "H",
        "hB"
    ],
    "MD": [
        "H",
        "hB"
    ],
    "ME": [
        "H",
        "hB",
        "h"
    ],
    "MF": [
        "H",
        "hB"
    ],
    "MG": [
        "H",
        "h"
    ],
    "MH": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "MK": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "ML": [
        "H"
    ],
    "MM": [
        "hB",
        "hb",
        "H",
        "h"
    ],
    "MN": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "MO": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "MP": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "MQ": [
        "H",
        "hB"
    ],
    "MR": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "MS": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "MT": [
        "H",
        "h"
    ],
    "MU": [
        "H",
        "h"
    ],
    "MV": [
        "H",
        "h"
    ],
    "MW": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "MX": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "MY": [
        "hb",
        "hB",
        "h",
        "H"
    ],
    "MZ": [
        "H",
        "hB"
    ],
    "NA": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "NC": [
        "H",
        "hB"
    ],
    "NE": [
        "H"
    ],
    "NF": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "NG": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "NI": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "NL": [
        "H",
        "hB"
    ],
    "NO": [
        "H",
        "h"
    ],
    "NP": [
        "H",
        "h",
        "hB"
    ],
    "NR": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "NU": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "NZ": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "OM": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "PA": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "PE": [
        "H",
        "hB",
        "h",
        "hb"
    ],
    "PF": [
        "H",
        "h",
        "hB"
    ],
    "PG": [
        "h",
        "H"
    ],
    "PH": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "PK": [
        "h",
        "hB",
        "H"
    ],
    "PL": [
        "H",
        "h"
    ],
    "PM": [
        "H",
        "hB"
    ],
    "PN": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "PR": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "PS": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "PT": [
        "H",
        "hB"
    ],
    "PW": [
        "h",
        "H"
    ],
    "PY": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "QA": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "RE": [
        "H",
        "hB"
    ],
    "RO": [
        "H",
        "hB"
    ],
    "RS": [
        "H",
        "hB",
        "h"
    ],
    "RU": [
        "H"
    ],
    "RW": [
        "H",
        "h"
    ],
    "SA": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "SB": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "SC": [
        "H",
        "h",
        "hB"
    ],
    "SD": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "SE": [
        "H"
    ],
    "SG": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "SH": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "SI": [
        "H",
        "hB"
    ],
    "SJ": [
        "H"
    ],
    "SK": [
        "H"
    ],
    "SL": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "SM": [
        "H",
        "h",
        "hB"
    ],
    "SN": [
        "H",
        "h",
        "hB"
    ],
    "SO": [
        "h",
        "H"
    ],
    "SR": [
        "H",
        "hB"
    ],
    "SS": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "ST": [
        "H",
        "hB"
    ],
    "SV": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "SX": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "SY": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "SZ": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "TA": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "TC": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "TD": [
        "h",
        "H",
        "hB"
    ],
    "TF": [
        "H",
        "h",
        "hB"
    ],
    "TG": [
        "H",
        "hB"
    ],
    "TH": [
        "H",
        "h"
    ],
    "TJ": [
        "H",
        "h"
    ],
    "TL": [
        "H",
        "hB",
        "hb",
        "h"
    ],
    "TM": [
        "H",
        "h"
    ],
    "TN": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "TO": [
        "h",
        "H"
    ],
    "TR": [
        "H",
        "hB"
    ],
    "TT": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "TW": [
        "hB",
        "hb",
        "h",
        "H"
    ],
    "TZ": [
        "hB",
        "hb",
        "H",
        "h"
    ],
    "UA": [
        "H",
        "hB",
        "h"
    ],
    "UG": [
        "hB",
        "hb",
        "H",
        "h"
    ],
    "UM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "US": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "UY": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "UZ": [
        "H",
        "hB",
        "h"
    ],
    "VA": [
        "H",
        "h",
        "hB"
    ],
    "VC": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "VE": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "VG": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "VI": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "VN": [
        "H",
        "h"
    ],
    "VU": [
        "h",
        "H"
    ],
    "WF": [
        "H",
        "hB"
    ],
    "WS": [
        "h",
        "H"
    ],
    "XK": [
        "H",
        "hB",
        "h"
    ],
    "YE": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "YT": [
        "H",
        "hB"
    ],
    "ZA": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "ZM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "ZW": [
        "H",
        "h"
    ],
    "af-ZA": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "ar-001": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "ca-ES": [
        "H",
        "h",
        "hB"
    ],
    "en-001": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "es-BO": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "es-BR": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "es-EC": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "es-ES": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "es-GQ": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "es-PE": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "fr-CA": [
        "H",
        "h",
        "hB"
    ],
    "gl-ES": [
        "H",
        "h",
        "hB"
    ],
    "gu-IN": [
        "hB",
        "hb",
        "h",
        "H"
    ],
    "hi-IN": [
        "hB",
        "h",
        "H"
    ],
    "it-CH": [
        "H",
        "h",
        "hB"
    ],
    "it-IT": [
        "H",
        "h",
        "hB"
    ],
    "kn-IN": [
        "hB",
        "h",
        "H"
    ],
    "ml-IN": [
        "hB",
        "h",
        "H"
    ],
    "mr-IN": [
        "hB",
        "hb",
        "h",
        "H"
    ],
    "pa-IN": [
        "hB",
        "hb",
        "h",
        "H"
    ],
    "ta-IN": [
        "hB",
        "h",
        "hb",
        "H"
    ],
    "te-IN": [
        "hB",
        "h",
        "H"
    ],
    "zu-ZA": [
        "H",
        "hB",
        "hb",
        "h"
    ]
};

});




parcelRegister("bX0Gd", function(module, exports) {

$parcel$export(module.exports, "memoize", function () { return $8b35bb6f41aac165$export$fc10aeed3a532e2a; });
$parcel$export(module.exports, "strategies", function () { return $8b35bb6f41aac165$export$c5491a8691a23b9e; });
//
// Main
//
function $8b35bb6f41aac165$export$fc10aeed3a532e2a(fn, options) {
    var cache = options && options.cache ? options.cache : $8b35bb6f41aac165$var$cacheDefault;
    var serializer = options && options.serializer ? options.serializer : $8b35bb6f41aac165$var$serializerDefault;
    var strategy = options && options.strategy ? options.strategy : $8b35bb6f41aac165$var$strategyDefault;
    return strategy(fn, {
        cache: cache,
        serializer: serializer
    });
}
//
// Strategy
//
function $8b35bb6f41aac165$var$isPrimitive(value) {
    return value == null || typeof value === "number" || typeof value === "boolean"; // || typeof value === "string" 'unsafe' primitive for our needs
}
function $8b35bb6f41aac165$var$monadic(fn, cache, serializer, arg) {
    var cacheKey = $8b35bb6f41aac165$var$isPrimitive(arg) ? arg : serializer(arg);
    var computedValue = cache.get(cacheKey);
    if (typeof computedValue === "undefined") {
        computedValue = fn.call(this, arg);
        cache.set(cacheKey, computedValue);
    }
    return computedValue;
}
function $8b35bb6f41aac165$var$variadic(fn, cache, serializer) {
    var args = Array.prototype.slice.call(arguments, 3);
    var cacheKey = serializer(args);
    var computedValue = cache.get(cacheKey);
    if (typeof computedValue === "undefined") {
        computedValue = fn.apply(this, args);
        cache.set(cacheKey, computedValue);
    }
    return computedValue;
}
function $8b35bb6f41aac165$var$assemble(fn, context, strategy, cache, serialize) {
    return strategy.bind(context, fn, cache, serialize);
}
function $8b35bb6f41aac165$var$strategyDefault(fn, options) {
    var strategy = fn.length === 1 ? $8b35bb6f41aac165$var$monadic : $8b35bb6f41aac165$var$variadic;
    return $8b35bb6f41aac165$var$assemble(fn, this, strategy, options.cache.create(), options.serializer);
}
function $8b35bb6f41aac165$var$strategyVariadic(fn, options) {
    return $8b35bb6f41aac165$var$assemble(fn, this, $8b35bb6f41aac165$var$variadic, options.cache.create(), options.serializer);
}
function $8b35bb6f41aac165$var$strategyMonadic(fn, options) {
    return $8b35bb6f41aac165$var$assemble(fn, this, $8b35bb6f41aac165$var$monadic, options.cache.create(), options.serializer);
}
//
// Serializer
//
var $8b35bb6f41aac165$var$serializerDefault = function() {
    return JSON.stringify(arguments);
};
//
// Cache
//
function $8b35bb6f41aac165$var$ObjectWithoutPrototypeCache() {
    this.cache = Object.create(null);
}
$8b35bb6f41aac165$var$ObjectWithoutPrototypeCache.prototype.get = function(key) {
    return this.cache[key];
};
$8b35bb6f41aac165$var$ObjectWithoutPrototypeCache.prototype.set = function(key, value) {
    this.cache[key] = value;
};
var $8b35bb6f41aac165$var$cacheDefault = {
    create: function create() {
        // @ts-ignore
        return new $8b35bb6f41aac165$var$ObjectWithoutPrototypeCache();
    }
};
var $8b35bb6f41aac165$export$c5491a8691a23b9e = {
    variadic: $8b35bb6f41aac165$var$strategyVariadic,
    monadic: $8b35bb6f41aac165$var$strategyMonadic
};

});

parcelRegister("9FMnG", function(module, exports) {

$parcel$export(module.exports, "PART_TYPE", function () { return $70ad78ded0c32382$export$49694c2877b44c57; });
$parcel$export(module.exports, "isFormatXMLElementFn", function () { return $70ad78ded0c32382$export$df0c12a2d414a163; });
$parcel$export(module.exports, "formatToParts", function () { return $70ad78ded0c32382$export$275d4a3bb5f66fda; });
parcelRequire("b4svv");
var $a5i87 = parcelRequire("a5i87");

var $8RUL4 = parcelRequire("8RUL4");
var $70ad78ded0c32382$export$49694c2877b44c57;
(function(PART_TYPE) {
    PART_TYPE[PART_TYPE["literal"] = 0] = "literal";
    PART_TYPE[PART_TYPE["object"] = 1] = "object";
})($70ad78ded0c32382$export$49694c2877b44c57 || ($70ad78ded0c32382$export$49694c2877b44c57 = {}));
function $70ad78ded0c32382$var$mergeLiteral(parts) {
    if (parts.length < 2) return parts;
    return parts.reduce(function(all, part) {
        var lastPart = all[all.length - 1];
        if (!lastPart || lastPart.type !== $70ad78ded0c32382$export$49694c2877b44c57.literal || part.type !== $70ad78ded0c32382$export$49694c2877b44c57.literal) all.push(part);
        else lastPart.value += part.value;
        return all;
    }, []);
}
function $70ad78ded0c32382$export$df0c12a2d414a163(el) {
    return typeof el === "function";
}
function $70ad78ded0c32382$export$275d4a3bb5f66fda(els, locales, formatters, formats, values, currentPluralValue, // For debugging
originalMessage) {
    // Hot path for straight simple msg translations
    if (els.length === 1 && (0, $a5i87.isLiteralElement)(els[0])) return [
        {
            type: $70ad78ded0c32382$export$49694c2877b44c57.literal,
            value: els[0].value
        }
    ];
    var result = [];
    for(var _i = 0, els_1 = els; _i < els_1.length; _i++){
        var el = els_1[_i];
        // Exit early for string parts.
        if ((0, $a5i87.isLiteralElement)(el)) {
            result.push({
                type: $70ad78ded0c32382$export$49694c2877b44c57.literal,
                value: el.value
            });
            continue;
        }
        // TODO: should this part be literal type?
        // Replace `#` in plural rules with the actual numeric value.
        if ((0, $a5i87.isPoundElement)(el)) {
            if (typeof currentPluralValue === "number") result.push({
                type: $70ad78ded0c32382$export$49694c2877b44c57.literal,
                value: formatters.getNumberFormat(locales).format(currentPluralValue)
            });
            continue;
        }
        var varName = el.value;
        // Enforce that all required values are provided by the caller.
        if (!(values && varName in values)) throw new (0, $8RUL4.MissingValueError)(varName, originalMessage);
        var value = values[varName];
        if ((0, $a5i87.isArgumentElement)(el)) {
            if (!value || typeof value === "string" || typeof value === "number") value = typeof value === "string" || typeof value === "number" ? String(value) : "";
            result.push({
                type: typeof value === "string" ? $70ad78ded0c32382$export$49694c2877b44c57.literal : $70ad78ded0c32382$export$49694c2877b44c57.object,
                value: value
            });
            continue;
        }
        // Recursively format plural and select parts' option — which can be a
        // nested pattern structure. The choosing of the option to use is
        // abstracted-by and delegated-to the part helper object.
        if ((0, $a5i87.isDateElement)(el)) {
            var style = typeof el.style === "string" ? formats.date[el.style] : (0, $a5i87.isDateTimeSkeleton)(el.style) ? el.style.parsedOptions : undefined;
            result.push({
                type: $70ad78ded0c32382$export$49694c2877b44c57.literal,
                value: formatters.getDateTimeFormat(locales, style).format(value)
            });
            continue;
        }
        if ((0, $a5i87.isTimeElement)(el)) {
            var style = typeof el.style === "string" ? formats.time[el.style] : (0, $a5i87.isDateTimeSkeleton)(el.style) ? el.style.parsedOptions : formats.time.medium;
            result.push({
                type: $70ad78ded0c32382$export$49694c2877b44c57.literal,
                value: formatters.getDateTimeFormat(locales, style).format(value)
            });
            continue;
        }
        if ((0, $a5i87.isNumberElement)(el)) {
            var style = typeof el.style === "string" ? formats.number[el.style] : (0, $a5i87.isNumberSkeleton)(el.style) ? el.style.parsedOptions : undefined;
            if (style && style.scale) value = value * (style.scale || 1);
            result.push({
                type: $70ad78ded0c32382$export$49694c2877b44c57.literal,
                value: formatters.getNumberFormat(locales, style).format(value)
            });
            continue;
        }
        if ((0, $a5i87.isTagElement)(el)) {
            var children = el.children, value_1 = el.value;
            var formatFn = values[value_1];
            if (!$70ad78ded0c32382$export$df0c12a2d414a163(formatFn)) throw new (0, $8RUL4.InvalidValueTypeError)(value_1, "function", originalMessage);
            var parts = $70ad78ded0c32382$export$275d4a3bb5f66fda(children, locales, formatters, formats, values, currentPluralValue);
            var chunks = formatFn(parts.map(function(p) {
                return p.value;
            }));
            if (!Array.isArray(chunks)) chunks = [
                chunks
            ];
            result.push.apply(result, chunks.map(function(c) {
                return {
                    type: typeof c === "string" ? $70ad78ded0c32382$export$49694c2877b44c57.literal : $70ad78ded0c32382$export$49694c2877b44c57.object,
                    value: c
                };
            }));
        }
        if ((0, $a5i87.isSelectElement)(el)) {
            var opt = el.options[value] || el.options.other;
            if (!opt) throw new (0, $8RUL4.InvalidValueError)(el.value, value, Object.keys(el.options), originalMessage);
            result.push.apply(result, $70ad78ded0c32382$export$275d4a3bb5f66fda(opt.value, locales, formatters, formats, values));
            continue;
        }
        if ((0, $a5i87.isPluralElement)(el)) {
            var opt = el.options["=".concat(value)];
            if (!opt) {
                if (!Intl.PluralRules) throw new (0, $8RUL4.FormatError)('Intl.PluralRules is not available in this environment.\nTry polyfilling it using "@formatjs/intl-pluralrules"\n', (0, $8RUL4.ErrorCode).MISSING_INTL_API, originalMessage);
                var rule = formatters.getPluralRules(locales, {
                    type: el.pluralType
                }).select(value - (el.offset || 0));
                opt = el.options[rule] || el.options.other;
            }
            if (!opt) throw new (0, $8RUL4.InvalidValueError)(el.value, value, Object.keys(el.options), originalMessage);
            result.push.apply(result, $70ad78ded0c32382$export$275d4a3bb5f66fda(opt.value, locales, formatters, formats, values, value - (el.offset || 0)));
            continue;
        }
    }
    return $70ad78ded0c32382$var$mergeLiteral(result);
}

});
parcelRegister("8RUL4", function(module, exports) {

$parcel$export(module.exports, "ErrorCode", function () { return $674f4cfa6a43b28f$export$d4e71bc0b80dc0fb; });
$parcel$export(module.exports, "FormatError", function () { return $674f4cfa6a43b28f$export$7369836851cc1329; });
$parcel$export(module.exports, "InvalidValueError", function () { return $674f4cfa6a43b28f$export$565c3afc07dfa382; });
$parcel$export(module.exports, "InvalidValueTypeError", function () { return $674f4cfa6a43b28f$export$cbc0db47c750f7c9; });
$parcel$export(module.exports, "MissingValueError", function () { return $674f4cfa6a43b28f$export$8bfc137e4d23fdf0; });

var $gb4K1 = parcelRequire("gb4K1");
var $674f4cfa6a43b28f$export$d4e71bc0b80dc0fb;
(function(ErrorCode) {
    // When we have a placeholder but no value to format
    ErrorCode["MISSING_VALUE"] = "MISSING_VALUE";
    // When value supplied is invalid
    ErrorCode["INVALID_VALUE"] = "INVALID_VALUE";
    // When we need specific Intl API but it's not available
    ErrorCode["MISSING_INTL_API"] = "MISSING_INTL_API";
})($674f4cfa6a43b28f$export$d4e71bc0b80dc0fb || ($674f4cfa6a43b28f$export$d4e71bc0b80dc0fb = {}));
var $674f4cfa6a43b28f$export$7369836851cc1329 = /** @class */ function(_super) {
    (0, $gb4K1.__extends)(FormatError, _super);
    function FormatError(msg, code, originalMessage) {
        var _this = _super.call(this, msg) || this;
        _this.code = code;
        _this.originalMessage = originalMessage;
        return _this;
    }
    FormatError.prototype.toString = function() {
        return "[formatjs Error: ".concat(this.code, "] ").concat(this.message);
    };
    return FormatError;
}(Error);
var $674f4cfa6a43b28f$export$565c3afc07dfa382 = /** @class */ function(_super) {
    (0, $gb4K1.__extends)(InvalidValueError, _super);
    function InvalidValueError(variableId, value, options, originalMessage) {
        return _super.call(this, 'Invalid values for "'.concat(variableId, '": "').concat(value, '". Options are "').concat(Object.keys(options).join('", "'), '"'), $674f4cfa6a43b28f$export$d4e71bc0b80dc0fb.INVALID_VALUE, originalMessage) || this;
    }
    return InvalidValueError;
}($674f4cfa6a43b28f$export$7369836851cc1329);
var $674f4cfa6a43b28f$export$cbc0db47c750f7c9 = /** @class */ function(_super) {
    (0, $gb4K1.__extends)(InvalidValueTypeError, _super);
    function InvalidValueTypeError(value, type, originalMessage) {
        return _super.call(this, 'Value for "'.concat(value, '" must be of type ').concat(type), $674f4cfa6a43b28f$export$d4e71bc0b80dc0fb.INVALID_VALUE, originalMessage) || this;
    }
    return InvalidValueTypeError;
}($674f4cfa6a43b28f$export$7369836851cc1329);
var $674f4cfa6a43b28f$export$8bfc137e4d23fdf0 = /** @class */ function(_super) {
    (0, $gb4K1.__extends)(MissingValueError, _super);
    function MissingValueError(variableId, originalMessage) {
        return _super.call(this, 'The intl string context variable "'.concat(variableId, '" was not provided to the string "').concat(originalMessage, '"'), $674f4cfa6a43b28f$export$d4e71bc0b80dc0fb.MISSING_VALUE, originalMessage) || this;
    }
    return MissingValueError;
}($674f4cfa6a43b28f$export$7369836851cc1329);

});




parcelRegister("dCg2n", function(module, exports) {

$parcel$export(module.exports, "UnsupportedFormatterError", function () { return $9e9b43ad85e9132d$export$549f97e137a05c90; });
$parcel$export(module.exports, "InvalidConfigError", function () { return $9e9b43ad85e9132d$export$3ca04dd7fb305893; });
$parcel$export(module.exports, "MissingDataError", function () { return $9e9b43ad85e9132d$export$c1eaf877d81384b6; });
$parcel$export(module.exports, "IntlFormatError", function () { return $9e9b43ad85e9132d$export$e3b7eee1dbc44895; });
$parcel$export(module.exports, "MessageFormatError", function () { return $9e9b43ad85e9132d$export$74a601a3d3f31621; });
$parcel$export(module.exports, "MissingTranslationError", function () { return $9e9b43ad85e9132d$export$2ddcb436d0aa3688; });

var $gb4K1 = parcelRequire("gb4K1");
var $9e9b43ad85e9132d$export$557d6acb76e8a244;
(function(IntlErrorCode) {
    IntlErrorCode["FORMAT_ERROR"] = "FORMAT_ERROR";
    IntlErrorCode["UNSUPPORTED_FORMATTER"] = "UNSUPPORTED_FORMATTER";
    IntlErrorCode["INVALID_CONFIG"] = "INVALID_CONFIG";
    IntlErrorCode["MISSING_DATA"] = "MISSING_DATA";
    IntlErrorCode["MISSING_TRANSLATION"] = "MISSING_TRANSLATION";
})($9e9b43ad85e9132d$export$557d6acb76e8a244 || ($9e9b43ad85e9132d$export$557d6acb76e8a244 = {}));
var $9e9b43ad85e9132d$export$c016d36112f6ddf8 = /** @class */ function(_super) {
    (0, $gb4K1.__extends)(IntlError, _super);
    function IntlError(code, message, exception) {
        var _this = this;
        var err = exception ? exception instanceof Error ? exception : new Error(String(exception)) : undefined;
        _this = _super.call(this, "[@formatjs/intl Error ".concat(code, "] ").concat(message, "\n").concat(err ? "\n".concat(err.message, "\n").concat(err.stack) : "")) || this;
        _this.code = code;
        // @ts-ignore just so we don't need to declare dep on @types/node
        if (typeof Error.captureStackTrace === "function") // @ts-ignore just so we don't need to declare dep on @types/node
        Error.captureStackTrace(_this, IntlError);
        return _this;
    }
    return IntlError;
}(Error);
var $9e9b43ad85e9132d$export$549f97e137a05c90 = /** @class */ function(_super) {
    (0, $gb4K1.__extends)(UnsupportedFormatterError, _super);
    function UnsupportedFormatterError(message, exception) {
        return _super.call(this, $9e9b43ad85e9132d$export$557d6acb76e8a244.UNSUPPORTED_FORMATTER, message, exception) || this;
    }
    return UnsupportedFormatterError;
}($9e9b43ad85e9132d$export$c016d36112f6ddf8);
var $9e9b43ad85e9132d$export$3ca04dd7fb305893 = /** @class */ function(_super) {
    (0, $gb4K1.__extends)(InvalidConfigError, _super);
    function InvalidConfigError(message, exception) {
        return _super.call(this, $9e9b43ad85e9132d$export$557d6acb76e8a244.INVALID_CONFIG, message, exception) || this;
    }
    return InvalidConfigError;
}($9e9b43ad85e9132d$export$c016d36112f6ddf8);
var $9e9b43ad85e9132d$export$c1eaf877d81384b6 = /** @class */ function(_super) {
    (0, $gb4K1.__extends)(MissingDataError, _super);
    function MissingDataError(message, exception) {
        return _super.call(this, $9e9b43ad85e9132d$export$557d6acb76e8a244.MISSING_DATA, message, exception) || this;
    }
    return MissingDataError;
}($9e9b43ad85e9132d$export$c016d36112f6ddf8);
var $9e9b43ad85e9132d$export$e3b7eee1dbc44895 = /** @class */ function(_super) {
    (0, $gb4K1.__extends)(IntlFormatError, _super);
    function IntlFormatError(message, locale, exception) {
        var _this = _super.call(this, $9e9b43ad85e9132d$export$557d6acb76e8a244.FORMAT_ERROR, "".concat(message, "\nLocale: ").concat(locale, "\n"), exception) || this;
        _this.locale = locale;
        return _this;
    }
    return IntlFormatError;
}($9e9b43ad85e9132d$export$c016d36112f6ddf8);
var $9e9b43ad85e9132d$export$74a601a3d3f31621 = /** @class */ function(_super) {
    (0, $gb4K1.__extends)(MessageFormatError, _super);
    function MessageFormatError(message, locale, descriptor, exception) {
        var _this = _super.call(this, "".concat(message, "\nMessageID: ").concat(descriptor === null || descriptor === void 0 ? void 0 : descriptor.id, "\nDefault Message: ").concat(descriptor === null || descriptor === void 0 ? void 0 : descriptor.defaultMessage, "\nDescription: ").concat(descriptor === null || descriptor === void 0 ? void 0 : descriptor.description, "\n"), locale, exception) || this;
        _this.descriptor = descriptor;
        _this.locale = locale;
        return _this;
    }
    return MessageFormatError;
}($9e9b43ad85e9132d$export$e3b7eee1dbc44895);
var $9e9b43ad85e9132d$export$2ddcb436d0aa3688 = /** @class */ function(_super) {
    (0, $gb4K1.__extends)(MissingTranslationError, _super);
    function MissingTranslationError(descriptor, locale) {
        var _this = _super.call(this, $9e9b43ad85e9132d$export$557d6acb76e8a244.MISSING_TRANSLATION, 'Missing message: "'.concat(descriptor.id, '" for locale "').concat(locale, '", using ').concat(descriptor.defaultMessage ? "default message (".concat(typeof descriptor.defaultMessage === "string" ? descriptor.defaultMessage : descriptor.defaultMessage.map(function(e) {
            var _a;
            return (_a = e.value) !== null && _a !== void 0 ? _a : JSON.stringify(e);
        }).join(), ")") : "id", " as fallback.")) || this;
        _this.descriptor = descriptor;
        return _this;
    }
    return MissingTranslationError;
}($9e9b43ad85e9132d$export$c016d36112f6ddf8);

});




parcelRegister("8mLXY", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $617595e7d282f605$export$2e2bcd8739ae039; });

var $lHE6I = parcelRequire("lHE6I");

var $7b1Lp = parcelRequire("7b1Lp");

var $1GRlU = parcelRequire("1GRlU");

var $cQNHH = parcelRequire("cQNHH");
parcelRequire("8u8eZ");
const $617595e7d282f605$var$useStyles = (0, $7b1Lp.default)({
    root: {
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        width: "100%",
        height: "100%",
        position: "absolute",
        top: 0,
        right: 0,
        bottom: 0,
        left: 0
    },
    white: {
        color: "white"
    }
});
function $617595e7d282f605$export$2e2bcd8739ae039({ dark: dark }) {
    const classes = $617595e7d282f605$var$useStyles();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("div", {
        className: classes.root
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement((0, $lHE6I.default), {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($1GRlU)))({
            [classes.white]: !dark
        })
    }));
}
$617595e7d282f605$export$2e2bcd8739ae039.defaultProps = {
    dark: false
};

});
parcelRegister("lHE6I", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $fcccb99d67900b6d$export$2e2bcd8739ae039; });

var $gtn2B = parcelRequire("gtn2B");

var $fsWgf = parcelRequire("fsWgf");

var $cQNHH = parcelRequire("cQNHH");

var $1xEYC = parcelRequire("1xEYC");

var $bKF6r = parcelRequire("bKF6r");

var $dcECW = parcelRequire("dcECW");

var $eyd6T = parcelRequire("eyd6T");

var $5beWR = parcelRequire("5beWR");
var $fcccb99d67900b6d$var$SIZE = 44;
var $fcccb99d67900b6d$export$9dd6ff9ea0189349 = function styles(theme) {
    return {
        /* Styles applied to the root element. */ root: {
            display: "inline-block"
        },
        /* Styles applied to the root element if `variant="static"`. */ static: {
            transition: theme.transitions.create("transform")
        },
        /* Styles applied to the root element if `variant="indeterminate"`. */ indeterminate: {
            animation: "$circular-rotate 1.4s linear infinite"
        },
        /* Styles applied to the root element if `variant="determinate"`. */ determinate: {
            transition: theme.transitions.create("transform")
        },
        /* Styles applied to the root element if `color="primary"`. */ colorPrimary: {
            color: theme.palette.primary.main
        },
        /* Styles applied to the root element if `color="secondary"`. */ colorSecondary: {
            color: theme.palette.secondary.main
        },
        /* Styles applied to the `svg` element. */ svg: {
            display: "block" // Keeps the progress centered
        },
        /* Styles applied to the `circle` svg path. */ circle: {
            stroke: "currentColor" // Use butt to follow the specification, by chance, it's already the default CSS value.
        },
        /* Styles applied to the `circle` svg path if `variant="static"`. */ circleStatic: {
            transition: theme.transitions.create("stroke-dashoffset")
        },
        /* Styles applied to the `circle` svg path if `variant="indeterminate"`. */ circleIndeterminate: {
            animation: "$circular-dash 1.4s ease-in-out infinite",
            // Some default value that looks fine waiting for the animation to kicks in.
            strokeDasharray: "80px, 200px",
            strokeDashoffset: "0px" // Add the unit to fix a Edge 16 and below bug.
        },
        /* Styles applied to the `circle` svg path if `variant="determinate"`. */ circleDeterminate: {
            transition: theme.transitions.create("stroke-dashoffset")
        },
        "@keyframes circular-rotate": {
            "0%": {
                // Fix IE 11 wobbly
                transformOrigin: "50% 50%"
            },
            "100%": {
                transform: "rotate(360deg)"
            }
        },
        "@keyframes circular-dash": {
            "0%": {
                strokeDasharray: "1px, 200px",
                strokeDashoffset: "0px"
            },
            "50%": {
                strokeDasharray: "100px, 200px",
                strokeDashoffset: "-15px"
            },
            "100%": {
                strokeDasharray: "100px, 200px",
                strokeDashoffset: "-125px"
            }
        },
        /* Styles applied to the `circle` svg path if `disableShrink={true}`. */ circleDisableShrink: {
            animation: "none"
        }
    };
};
/**
 * ## ARIA
 *
 * If the progress bar is describing the loading progress of a particular region of a page,
 * you should use `aria-describedby` to point to the progress bar, and set the `aria-busy`
 * attribute to `true` on that region until it has finished loading.
 */ var $fcccb99d67900b6d$var$CircularProgress = /*#__PURE__*/ $cQNHH.forwardRef(function CircularProgress(props, ref) {
    var classes = props.classes, className = props.className, _props$color = props.color, color = _props$color === void 0 ? "primary" : _props$color, _props$disableShrink = props.disableShrink, disableShrink = _props$disableShrink === void 0 ? false : _props$disableShrink, _props$size = props.size, size = _props$size === void 0 ? 40 : _props$size, style = props.style, _props$thickness = props.thickness, thickness = _props$thickness === void 0 ? 3.6 : _props$thickness, _props$value = props.value, value = _props$value === void 0 ? 0 : _props$value, _props$variant = props.variant, variant = _props$variant === void 0 ? "indeterminate" : _props$variant, other = (0, $fsWgf.default)(props, [
        "classes",
        "className",
        "color",
        "disableShrink",
        "size",
        "style",
        "thickness",
        "value",
        "variant"
    ]);
    var circleStyle = {};
    var rootStyle = {};
    var rootProps = {};
    if (variant === "determinate" || variant === "static") {
        var circumference = 2 * Math.PI * (($fcccb99d67900b6d$var$SIZE - thickness) / 2);
        circleStyle.strokeDasharray = circumference.toFixed(3);
        rootProps["aria-valuenow"] = Math.round(value);
        circleStyle.strokeDashoffset = "".concat(((100 - value) / 100 * circumference).toFixed(3), "px");
        rootStyle.transform = "rotate(-90deg)";
    }
    return /*#__PURE__*/ $cQNHH.createElement("div", (0, $gtn2B.default)({
        className: (0, $bKF6r.default)(classes.root, className, color !== "inherit" && classes["color".concat((0, $5beWR.default)(color))], {
            "determinate": classes.determinate,
            "indeterminate": classes.indeterminate,
            "static": classes.static
        }[variant]),
        style: (0, $gtn2B.default)({
            width: size,
            height: size
        }, rootStyle, style),
        ref: ref,
        role: "progressbar"
    }, rootProps, other), /*#__PURE__*/ $cQNHH.createElement("svg", {
        className: classes.svg,
        viewBox: "".concat($fcccb99d67900b6d$var$SIZE / 2, " ").concat($fcccb99d67900b6d$var$SIZE / 2, " ").concat($fcccb99d67900b6d$var$SIZE, " ").concat($fcccb99d67900b6d$var$SIZE)
    }, /*#__PURE__*/ $cQNHH.createElement("circle", {
        className: (0, $bKF6r.default)(classes.circle, disableShrink && classes.circleDisableShrink, {
            "determinate": classes.circleDeterminate,
            "indeterminate": classes.circleIndeterminate,
            "static": classes.circleStatic
        }[variant]),
        style: circleStyle,
        cx: $fcccb99d67900b6d$var$SIZE,
        cy: $fcccb99d67900b6d$var$SIZE,
        r: ($fcccb99d67900b6d$var$SIZE - thickness) / 2,
        fill: "none",
        strokeWidth: thickness
    })));
});
$fcccb99d67900b6d$var$CircularProgress.propTypes = {
    // ----------------------------- Warning --------------------------------
    // | These PropTypes are generated from the TypeScript type definitions |
    // |     To update them edit the d.ts file and run "yarn proptypes"     |
    // ----------------------------------------------------------------------
    /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */ classes: (0, (/*@__PURE__*/$parcel$interopDefault($1xEYC))).object,
    /**
   * @ignore
   */ className: (0, (/*@__PURE__*/$parcel$interopDefault($1xEYC))).string,
    /**
   * The color of the component. It supports those theme colors that make sense for this component.
   */ color: (0, (/*@__PURE__*/$parcel$interopDefault($1xEYC))).oneOf([
        "inherit",
        "primary",
        "secondary"
    ]),
    /**
   * If `true`, the shrink animation is disabled.
   * This only works if variant is `indeterminate`.
   */ disableShrink: (0, $dcECW.default)((0, (/*@__PURE__*/$parcel$interopDefault($1xEYC))).bool, function(props) {
        if (props.disableShrink && props.variant && props.variant !== "indeterminate") return new Error("Material-UI: You have provided the `disableShrink` prop with a variant other than `indeterminate`. This will have no effect.");
        return null;
    }),
    /**
   * The size of the circle.
   * If using a number, the pixel unit is assumed.
   * If using a string, you need to provide the CSS unit, e.g '3rem'.
   */ size: (0, (/*@__PURE__*/$parcel$interopDefault($1xEYC))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($1xEYC))).number,
        (0, (/*@__PURE__*/$parcel$interopDefault($1xEYC))).string
    ]),
    /**
   * @ignore
   */ style: (0, (/*@__PURE__*/$parcel$interopDefault($1xEYC))).object,
    /**
   * The thickness of the circle.
   */ thickness: (0, (/*@__PURE__*/$parcel$interopDefault($1xEYC))).number,
    /**
   * The value of the progress indicator for the determinate variant.
   * Value between 0 and 100.
   */ value: (0, (/*@__PURE__*/$parcel$interopDefault($1xEYC))).number,
    /**
   * The variant to use.
   * Use indeterminate when there is no progress value.
   */ variant: (0, $dcECW.default)((0, (/*@__PURE__*/$parcel$interopDefault($1xEYC))).oneOf([
        "determinate",
        "indeterminate",
        "static"
    ]), function(props) {
        var variant = props.variant;
        if (variant === "static") throw new Error('Material-UI: `variant="static"` was deprecated. Use `variant="determinate"` instead.');
        return null;
    })
};
var $fcccb99d67900b6d$export$2e2bcd8739ae039 = (0, $eyd6T.default)($fcccb99d67900b6d$export$9dd6ff9ea0189349, {
    name: "MuiCircularProgress",
    flip: false
})($fcccb99d67900b6d$var$CircularProgress);

});
parcelRegister("bKF6r", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $023539494c2e2e2c$export$2e2bcd8739ae039; });
function $023539494c2e2e2c$var$toVal(mix) {
    var k, y, str = "";
    if (typeof mix === "string" || typeof mix === "number") str += mix;
    else if (typeof mix === "object") {
        if (Array.isArray(mix)) for(k = 0; k < mix.length; k++){
            if (mix[k]) {
                if (y = $023539494c2e2e2c$var$toVal(mix[k])) {
                    str && (str += " ");
                    str += y;
                }
            }
        }
        else {
            for(k in mix)if (mix[k]) {
                str && (str += " ");
                str += k;
            }
        }
    }
    return str;
}
function $023539494c2e2e2c$export$2e2bcd8739ae039() {
    var i = 0, tmp, x, str = "";
    while(i < arguments.length){
        if (tmp = arguments[i++]) {
            if (x = $023539494c2e2e2c$var$toVal(tmp)) {
                str && (str += " ");
                str += x;
            }
        }
    }
    return str;
}

});

parcelRegister("dcECW", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $99cbe90a58d74306$export$2e2bcd8739ae039; });
function $99cbe90a58d74306$export$2e2bcd8739ae039(propType1, propType2) {
    return function validate() {
        return propType1.apply(void 0, arguments) || propType2.apply(void 0, arguments);
    };
}

});

parcelRegister("eyd6T", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a97e690eb1af1eef$export$2e2bcd8739ae039; });

var $gtn2B = parcelRequire("gtn2B");

var $d51DM = parcelRequire("d51DM");

var $8dv03 = parcelRequire("8dv03");
function $a97e690eb1af1eef$var$withStyles(stylesOrCreator, options) {
    return (0, $d51DM.default)(stylesOrCreator, (0, $gtn2B.default)({
        defaultTheme: (0, $8dv03.default)
    }, options));
}
var $a97e690eb1af1eef$export$2e2bcd8739ae039 = $a97e690eb1af1eef$var$withStyles;

});
parcelRegister("d51DM", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $985d03cef2734122$export$2e2bcd8739ae039; });

var $815Xb = parcelRequire("815Xb");

var $gyDGU = parcelRequire("gyDGU");

var $cQNHH = parcelRequire("cQNHH");

var $1xEYC = parcelRequire("1xEYC");

var $aoqh7 = parcelRequire("aoqh7");

var $dcECW = parcelRequire("dcECW");
var $3gm9p = parcelRequire("3gm9p");

var $7b1Lp = parcelRequire("7b1Lp");

var $jB5O2 = parcelRequire("jB5O2");

var $6WDy5 = parcelRequire("6WDy5");
// It does not modify the component passed to it;
// instead, it returns a new component, with a `classes` property.
var $985d03cef2734122$var$withStyles = function withStyles(stylesOrCreator) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    return function(Component) {
        var defaultTheme = options.defaultTheme, _options$withTheme = options.withTheme, withTheme = _options$withTheme === void 0 ? false : _options$withTheme, name = options.name, stylesOptions = (0, $gyDGU.default)(options, [
            "defaultTheme",
            "withTheme",
            "name"
        ]);
        if (Component === undefined) throw new Error([
            "You are calling withStyles(styles)(Component) with an undefined component.",
            "You may have forgotten to import it."
        ].join("\n"));
        var classNamePrefix = name;
        if (!name) {
            // Provide a better DX outside production.
            var displayName = (0, $3gm9p.default)(Component);
            if (displayName !== undefined) classNamePrefix = displayName;
        }
        var useStyles = (0, $7b1Lp.default)(stylesOrCreator, (0, $815Xb.default)({
            defaultTheme: defaultTheme,
            Component: Component,
            name: name || Component.displayName,
            classNamePrefix: classNamePrefix
        }, stylesOptions));
        var WithStyles = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).forwardRef(function WithStyles(props, ref) {
            var classesProp = props.classes, innerRef = props.innerRef, other = (0, $gyDGU.default)(props, [
                "classes",
                "innerRef"
            ]); // The wrapper receives only user supplied props, which could be a subset of
            // the actual props Component might receive due to merging with defaultProps.
            // So copying it here would give us the same result in the wrapper as well.
            var classes = useStyles((0, $815Xb.default)({}, Component.defaultProps, props));
            var theme;
            var more = other;
            if (typeof name === "string" || withTheme) {
                // name and withTheme are invariant in the outer scope
                // eslint-disable-next-line react-hooks/rules-of-hooks
                theme = (0, $6WDy5.default)() || defaultTheme;
                if (name) more = (0, $jB5O2.default)({
                    theme: theme,
                    name: name,
                    props: other
                });
                 // Provide the theme to the wrapped component.
                // So we don't have to use the `withTheme()` Higher-order Component.
                if (withTheme && !more.theme) more.theme = theme;
            }
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement(Component, (0, $815Xb.default)({
                ref: innerRef || ref,
                classes: classes
            }, more));
        });
        WithStyles.propTypes = {
            /**
       * Override or extend the styles applied to the component.
       */ classes: (0, (/*@__PURE__*/$parcel$interopDefault($1xEYC))).object,
            /**
       * Use that prop to pass a ref to the decorated component.
       * @deprecated
       */ innerRef: (0, $dcECW.default)((0, (/*@__PURE__*/$parcel$interopDefault($1xEYC))).oneOfType([
                (0, (/*@__PURE__*/$parcel$interopDefault($1xEYC))).func,
                (0, (/*@__PURE__*/$parcel$interopDefault($1xEYC))).object
            ]), function(props) {
                if (props.innerRef == null) return null;
                return null; // return new Error(
            //   'Material-UI: The `innerRef` prop is deprecated and will be removed in v5. ' +
            //     'Refs are now automatically forwarded to the inner component.',
            // );
            })
        };
        WithStyles.displayName = "WithStyles(".concat((0, $3gm9p.default)(Component), ")");
        (0, (/*@__PURE__*/$parcel$interopDefault($aoqh7)))(WithStyles, Component);
        // Exposed for test purposes.
        WithStyles.Naked = Component;
        WithStyles.options = options;
        WithStyles.useStyles = useStyles;
        return WithStyles;
    };
};
var $985d03cef2734122$export$2e2bcd8739ae039 = $985d03cef2734122$var$withStyles;

});
parcelRegister("jB5O2", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e445f9fc25a0bc01$export$2e2bcd8739ae039; });
/* eslint-disable no-restricted-syntax */ function $e445f9fc25a0bc01$export$2e2bcd8739ae039(params) {
    var theme = params.theme, name = params.name, props = params.props;
    if (!theme || !theme.props || !theme.props[name]) return props;
     // Resolve default props, code borrow from React source.
    // https://github.com/facebook/react/blob/15a8f031838a553e41c0b66eb1bcf1da8448104d/packages/react/src/ReactElement.js#L221
    var defaultProps = theme.props[name];
    var propName;
    for(propName in defaultProps)if (props[propName] === undefined) props[propName] = defaultProps[propName];
    return props;
}

});


parcelRegister("8dv03", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5fb79592c098a066$export$2e2bcd8739ae039; });

var $elwbS = parcelRequire("elwbS");
var $5fb79592c098a066$var$defaultTheme = (0, $elwbS.default)();
var $5fb79592c098a066$export$2e2bcd8739ae039 = $5fb79592c098a066$var$defaultTheme;

});
parcelRegister("elwbS", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a71bff40f023b26e$export$2e2bcd8739ae039; });

var $269Bb = parcelRequire("269Bb");

var $fsWgf = parcelRequire("fsWgf");

var $kt6Ie = parcelRequire("kt6Ie");

var $lkMpL = parcelRequire("lkMpL");

var $4GONF = parcelRequire("4GONF");

var $adeGL = parcelRequire("adeGL");

var $b3xjG = parcelRequire("b3xjG");

var $b07Va = parcelRequire("b07Va");

var $K4Wzh = parcelRequire("K4Wzh");

var $lzf3y = parcelRequire("lzf3y");

var $ijxDf = parcelRequire("ijxDf");

var $icOS8 = parcelRequire("icOS8");
function $a71bff40f023b26e$var$createTheme() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var _options$breakpoints = options.breakpoints, breakpointsInput = _options$breakpoints === void 0 ? {} : _options$breakpoints, _options$mixins = options.mixins, mixinsInput = _options$mixins === void 0 ? {} : _options$mixins, _options$palette = options.palette, paletteInput = _options$palette === void 0 ? {} : _options$palette, spacingInput = options.spacing, _options$typography = options.typography, typographyInput = _options$typography === void 0 ? {} : _options$typography, other = (0, $fsWgf.default)(options, [
        "breakpoints",
        "mixins",
        "palette",
        "spacing",
        "typography"
    ]);
    var palette = (0, $adeGL.default)(paletteInput);
    var breakpoints = (0, $lkMpL.default)(breakpointsInput);
    var spacing = (0, $lzf3y.default)(spacingInput);
    var muiTheme = (0, $kt6Ie.default)({
        breakpoints: breakpoints,
        direction: "ltr",
        mixins: (0, $4GONF.default)(breakpoints, spacing, mixinsInput),
        overrides: {},
        // Inject custom styles
        palette: palette,
        props: {},
        // Provide default props
        shadows: (0, $b07Va.default),
        typography: (0, $b3xjG.default)(palette, typographyInput),
        spacing: spacing,
        shape: (0, $K4Wzh.default),
        transitions: (0, $ijxDf.default),
        zIndex: (0, $icOS8.default)
    }, other);
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
    muiTheme = args.reduce(function(acc, argument) {
        return (0, $kt6Ie.default)(acc, argument);
    }, muiTheme);
    var pseudoClasses = [
        "checked",
        "disabled",
        "error",
        "focused",
        "focusVisible",
        "required",
        "expanded",
        "selected"
    ];
    var traverse = function traverse(node, parentKey) {
        var depth = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
        var key; // eslint-disable-next-line guard-for-in, no-restricted-syntax
        for(key in node){
            var child = node[key];
            if (depth === 1) {
                if (key.indexOf("Mui") === 0 && child) traverse(child, key, depth + 1);
            } else if (pseudoClasses.indexOf(key) !== -1 && Object.keys(child).length > 0) {
                console.error([
                    "Material-UI: The `".concat(parentKey, "` component increases ") + "the CSS specificity of the `".concat(key, "` internal state."),
                    "You can not override it like this: ",
                    JSON.stringify(node, null, 2),
                    "",
                    "Instead, you need to use the $ruleName syntax:",
                    JSON.stringify({
                        root: (0, $269Bb.default)({}, "&$".concat(key), child)
                    }, null, 2),
                    "",
                    "https://material-ui.com/r/pseudo-classes-guide"
                ].join("\n"));
                node[key] = {};
            }
        }
    };
    traverse(muiTheme.overrides);
    return muiTheme;
}
var $a71bff40f023b26e$var$warnedOnce = false;
function $a71bff40f023b26e$export$c469355549431d9b() {
    if (!$a71bff40f023b26e$var$warnedOnce) {
        $a71bff40f023b26e$var$warnedOnce = true;
        console.error([
            "Material-UI: the createMuiTheme function was renamed to createTheme.",
            "",
            "You should use `import { createTheme } from '@material-ui/core/styles'`"
        ].join("\n"));
    }
    return $a71bff40f023b26e$var$createTheme.apply(void 0, arguments);
}
var $a71bff40f023b26e$export$2e2bcd8739ae039 = $a71bff40f023b26e$var$createTheme;

});
parcelRegister("lkMpL", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $040214bb4e643271$export$2e2bcd8739ae039; });

var $gtn2B = parcelRequire("gtn2B");

var $fsWgf = parcelRequire("fsWgf");
var $040214bb4e643271$export$ed97f33186d4b816 = [
    "xs",
    "sm",
    "md",
    "lg",
    "xl"
]; // Keep in mind that @media is inclusive by the CSS specification.
function $040214bb4e643271$export$2e2bcd8739ae039(breakpoints) {
    var _breakpoints$values = breakpoints.values, values = _breakpoints$values === void 0 ? {
        xs: 0,
        sm: 600,
        md: 960,
        lg: 1280,
        xl: 1920
    } : _breakpoints$values, _breakpoints$unit = breakpoints.unit, unit = _breakpoints$unit === void 0 ? "px" : _breakpoints$unit, _breakpoints$step = breakpoints.step, step = _breakpoints$step === void 0 ? 5 : _breakpoints$step, other = (0, $fsWgf.default)(breakpoints, [
        "values",
        "unit",
        "step"
    ]);
    function up(key) {
        var value = typeof values[key] === "number" ? values[key] : key;
        return "@media (min-width:".concat(value).concat(unit, ")");
    }
    function down(key) {
        var endIndex = $040214bb4e643271$export$ed97f33186d4b816.indexOf(key) + 1;
        var upperbound = values[$040214bb4e643271$export$ed97f33186d4b816[endIndex]];
        if (endIndex === $040214bb4e643271$export$ed97f33186d4b816.length) // xl down applies to all sizes
        return up("xs");
        var value = typeof upperbound === "number" && endIndex > 0 ? upperbound : key;
        return "@media (max-width:".concat(value - step / 100).concat(unit, ")");
    }
    function between(start, end) {
        var endIndex = $040214bb4e643271$export$ed97f33186d4b816.indexOf(end);
        if (endIndex === $040214bb4e643271$export$ed97f33186d4b816.length - 1) return up(start);
        return "@media (min-width:".concat(typeof values[start] === "number" ? values[start] : start).concat(unit, ") and ") + "(max-width:".concat((endIndex !== -1 && typeof values[$040214bb4e643271$export$ed97f33186d4b816[endIndex + 1]] === "number" ? values[$040214bb4e643271$export$ed97f33186d4b816[endIndex + 1]] : end) - step / 100).concat(unit, ")");
    }
    function only(key) {
        return between(key, key);
    }
    var warnedOnce = false;
    function width(key) {
        if (!warnedOnce) {
            warnedOnce = true;
            console.warn([
                "Material-UI: The `theme.breakpoints.width` utility is deprecated because it's redundant.",
                "Use the `theme.breakpoints.values` instead."
            ].join("\n"));
        }
        return values[key];
    }
    return (0, $gtn2B.default)({
        keys: $040214bb4e643271$export$ed97f33186d4b816,
        values: values,
        up: up,
        down: down,
        between: between,
        only: only,
        width: width
    }, other);
}

});

parcelRegister("4GONF", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $36a27d805a478ecd$export$2e2bcd8739ae039; });

var $269Bb = parcelRequire("269Bb");

var $gtn2B = parcelRequire("gtn2B");
function $36a27d805a478ecd$export$2e2bcd8739ae039(breakpoints, spacing, mixins) {
    var _toolbar;
    return (0, $gtn2B.default)({
        gutters: function gutters() {
            var styles = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
            console.warn([
                "Material-UI: theme.mixins.gutters() is deprecated.",
                "You can use the source of the mixin directly:",
                "\n      paddingLeft: theme.spacing(2),\n      paddingRight: theme.spacing(2),\n      [theme.breakpoints.up('sm')]: {\n        paddingLeft: theme.spacing(3),\n        paddingRight: theme.spacing(3),\n      },\n      "
            ].join("\n"));
            return (0, $gtn2B.default)({
                paddingLeft: spacing(2),
                paddingRight: spacing(2)
            }, styles, (0, $269Bb.default)({}, breakpoints.up("sm"), (0, $gtn2B.default)({
                paddingLeft: spacing(3),
                paddingRight: spacing(3)
            }, styles[breakpoints.up("sm")])));
        },
        toolbar: (_toolbar = {
            minHeight: 56
        }, (0, $269Bb.default)(_toolbar, "".concat(breakpoints.up("xs"), " and (orientation: landscape)"), {
            minHeight: 48
        }), (0, $269Bb.default)(_toolbar, breakpoints.up("sm"), {
            minHeight: 64
        }), _toolbar)
    }, mixins);
}

});

parcelRegister("adeGL", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $76f6832225758e88$export$2e2bcd8739ae039; });

var $gtn2B = parcelRequire("gtn2B");

var $fsWgf = parcelRequire("fsWgf");

var $kt6Ie = parcelRequire("kt6Ie");

var $9TCcK = parcelRequire("9TCcK");

var $051CJ = parcelRequire("051CJ");

var $NZaiv = parcelRequire("NZaiv");

var $9VDdv = parcelRequire("9VDdv");

var $fdcrk = parcelRequire("fdcrk");

var $iujT5 = parcelRequire("iujT5");

var $hz3ne = parcelRequire("hz3ne");

var $ecMVT = parcelRequire("ecMVT");

var $80wVS = parcelRequire("80wVS");
var $76f6832225758e88$export$a43af521ac8c3202 = {
    // The colors used to style the text.
    text: {
        // The most important text.
        primary: "rgba(0, 0, 0, 0.87)",
        // Secondary text.
        secondary: "rgba(0, 0, 0, 0.54)",
        // Disabled text have even lower visual prominence.
        disabled: "rgba(0, 0, 0, 0.38)",
        // Text hints.
        hint: "rgba(0, 0, 0, 0.38)"
    },
    // The color used to divide different elements.
    divider: "rgba(0, 0, 0, 0.12)",
    // The background colors used to style the surfaces.
    // Consistency between these values is important.
    background: {
        paper: (0, $9TCcK.default).white,
        default: (0, $051CJ.default)[50]
    },
    // The colors used to style the action elements.
    action: {
        // The color of an active action like an icon button.
        active: "rgba(0, 0, 0, 0.54)",
        // The color of an hovered action.
        hover: "rgba(0, 0, 0, 0.04)",
        hoverOpacity: 0.04,
        // The color of a selected action.
        selected: "rgba(0, 0, 0, 0.08)",
        selectedOpacity: 0.08,
        // The color of a disabled action.
        disabled: "rgba(0, 0, 0, 0.26)",
        // The background color of a disabled action.
        disabledBackground: "rgba(0, 0, 0, 0.12)",
        disabledOpacity: 0.38,
        focus: "rgba(0, 0, 0, 0.12)",
        focusOpacity: 0.12,
        activatedOpacity: 0.12
    }
};
var $76f6832225758e88$export$55ce6f3a06c59543 = {
    text: {
        primary: (0, $9TCcK.default).white,
        secondary: "rgba(255, 255, 255, 0.7)",
        disabled: "rgba(255, 255, 255, 0.5)",
        hint: "rgba(255, 255, 255, 0.5)",
        icon: "rgba(255, 255, 255, 0.5)"
    },
    divider: "rgba(255, 255, 255, 0.12)",
    background: {
        paper: (0, $051CJ.default)[800],
        default: "#303030"
    },
    action: {
        active: (0, $9TCcK.default).white,
        hover: "rgba(255, 255, 255, 0.08)",
        hoverOpacity: 0.08,
        selected: "rgba(255, 255, 255, 0.16)",
        selectedOpacity: 0.16,
        disabled: "rgba(255, 255, 255, 0.3)",
        disabledBackground: "rgba(255, 255, 255, 0.12)",
        disabledOpacity: 0.38,
        focus: "rgba(255, 255, 255, 0.12)",
        focusOpacity: 0.12,
        activatedOpacity: 0.24
    }
};
function $76f6832225758e88$var$addLightOrDark(intent, direction, shade, tonalOffset) {
    var tonalOffsetLight = tonalOffset.light || tonalOffset;
    var tonalOffsetDark = tonalOffset.dark || tonalOffset * 1.5;
    if (!intent[direction]) {
        if (intent.hasOwnProperty(shade)) intent[direction] = intent[shade];
        else if (direction === "light") intent.light = (0, $80wVS.lighten)(intent.main, tonalOffsetLight);
        else if (direction === "dark") intent.dark = (0, $80wVS.darken)(intent.main, tonalOffsetDark);
    }
}
function $76f6832225758e88$export$2e2bcd8739ae039(palette) {
    var _palette$primary = palette.primary, primary = _palette$primary === void 0 ? {
        light: (0, $NZaiv.default)[300],
        main: (0, $NZaiv.default)[500],
        dark: (0, $NZaiv.default)[700]
    } : _palette$primary, _palette$secondary = palette.secondary, secondary = _palette$secondary === void 0 ? {
        light: (0, $9VDdv.default).A200,
        main: (0, $9VDdv.default).A400,
        dark: (0, $9VDdv.default).A700
    } : _palette$secondary, _palette$error = palette.error, error = _palette$error === void 0 ? {
        light: (0, $fdcrk.default)[300],
        main: (0, $fdcrk.default)[500],
        dark: (0, $fdcrk.default)[700]
    } : _palette$error, _palette$warning = palette.warning, warning = _palette$warning === void 0 ? {
        light: (0, $iujT5.default)[300],
        main: (0, $iujT5.default)[500],
        dark: (0, $iujT5.default)[700]
    } : _palette$warning, _palette$info = palette.info, info = _palette$info === void 0 ? {
        light: (0, $hz3ne.default)[300],
        main: (0, $hz3ne.default)[500],
        dark: (0, $hz3ne.default)[700]
    } : _palette$info, _palette$success = palette.success, success = _palette$success === void 0 ? {
        light: (0, $ecMVT.default)[300],
        main: (0, $ecMVT.default)[500],
        dark: (0, $ecMVT.default)[700]
    } : _palette$success, _palette$type = palette.type, type = _palette$type === void 0 ? "light" : _palette$type, _palette$contrastThre = palette.contrastThreshold, contrastThreshold = _palette$contrastThre === void 0 ? 3 : _palette$contrastThre, _palette$tonalOffset = palette.tonalOffset, tonalOffset = _palette$tonalOffset === void 0 ? 0.2 : _palette$tonalOffset, other = (0, $fsWgf.default)(palette, [
        "primary",
        "secondary",
        "error",
        "warning",
        "info",
        "success",
        "type",
        "contrastThreshold",
        "tonalOffset"
    ]); // Use the same logic as
    // Bootstrap: https://github.com/twbs/bootstrap/blob/1d6e3710dd447de1a200f29e8fa521f8a0908f70/scss/_functions.scss#L59
    // and material-components-web https://github.com/material-components/material-components-web/blob/ac46b8863c4dab9fc22c4c662dc6bd1b65dd652f/packages/mdc-theme/_functions.scss#L54
    function getContrastText(background) {
        var contrastText = (0, $80wVS.getContrastRatio)(background, $76f6832225758e88$export$55ce6f3a06c59543.text.primary) >= contrastThreshold ? $76f6832225758e88$export$55ce6f3a06c59543.text.primary : $76f6832225758e88$export$a43af521ac8c3202.text.primary;
        var contrast = (0, $80wVS.getContrastRatio)(background, contrastText);
        if (contrast < 3) console.error([
            "Material-UI: The contrast ratio of ".concat(contrast, ":1 for ").concat(contrastText, " on ").concat(background),
            "falls below the WCAG recommended absolute minimum contrast ratio of 3:1.",
            "https://www.w3.org/TR/2008/REC-WCAG20-20081211/#visual-audio-contrast-contrast"
        ].join("\n"));
        return contrastText;
    }
    var augmentColor = function augmentColor(color) {
        var mainShade = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 500;
        var lightShade = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 300;
        var darkShade = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 700;
        color = (0, $gtn2B.default)({}, color);
        if (!color.main && color[mainShade]) color.main = color[mainShade];
        if (!color.main) throw new Error("Material-UI: The color provided to augmentColor(color) is invalid.\nThe color object needs to have a `main` property or a `".concat(mainShade, "` property."));
        if (typeof color.main !== "string") throw new Error("Material-UI: The color provided to augmentColor(color) is invalid.\n`color.main` should be a string, but `".concat(JSON.stringify(color.main), '` was provided instead.\n\nDid you intend to use one of the following approaches?\n\nimport {\xa0green } from "@material-ui/core/colors";\n\nconst theme1 = createTheme({ palette: {\n  primary: green,\n} });\n\nconst theme2 = createTheme({ palette: {\n  primary: { main: green[500] },\n} });'));
        $76f6832225758e88$var$addLightOrDark(color, "light", lightShade, tonalOffset);
        $76f6832225758e88$var$addLightOrDark(color, "dark", darkShade, tonalOffset);
        if (!color.contrastText) color.contrastText = getContrastText(color.main);
        return color;
    };
    var types = {
        dark: $76f6832225758e88$export$55ce6f3a06c59543,
        light: $76f6832225758e88$export$a43af521ac8c3202
    };
    if (!types[type]) console.error("Material-UI: The palette type `".concat(type, "` is not supported."));
    var paletteOutput = (0, $kt6Ie.default)((0, $gtn2B.default)({
        // A collection of common colors.
        common: (0, $9TCcK.default),
        // The palette type, can be light or dark.
        type: type,
        // The colors used to represent primary interface elements for a user.
        primary: augmentColor(primary),
        // The colors used to represent secondary interface elements for a user.
        secondary: augmentColor(secondary, "A400", "A200", "A700"),
        // The colors used to represent interface elements that the user should be made aware of.
        error: augmentColor(error),
        // The colors used to represent potentially dangerous actions or important messages.
        warning: augmentColor(warning),
        // The colors used to present information to the user that is neutral and not necessarily important.
        info: augmentColor(info),
        // The colors used to indicate the successful completion of an action that user triggered.
        success: augmentColor(success),
        // The grey colors.
        grey: (0, $051CJ.default),
        // Used by `getContrastText()` to maximize the contrast between
        // the background and the text.
        contrastThreshold: contrastThreshold,
        // Takes a background color and returns the text color that maximizes the contrast.
        getContrastText: getContrastText,
        // Generate a rich color object.
        augmentColor: augmentColor,
        // Used by the functions below to shift a color's luminance by approximately
        // two indexes within its tonal palette.
        // E.g., shift from Red 500 to Red 300 or Red 700.
        tonalOffset: tonalOffset
    }, types[type]), other);
    return paletteOutput;
}

});
parcelRegister("9TCcK", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7346e2bda4197486$export$2e2bcd8739ae039; });
var $7346e2bda4197486$var$common = {
    black: "#000",
    white: "#fff"
};
var $7346e2bda4197486$export$2e2bcd8739ae039 = $7346e2bda4197486$var$common;

});

parcelRegister("051CJ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $00f1ba29dcdc9761$export$2e2bcd8739ae039; });
var $00f1ba29dcdc9761$var$grey = {
    50: "#fafafa",
    100: "#f5f5f5",
    200: "#eeeeee",
    300: "#e0e0e0",
    400: "#bdbdbd",
    500: "#9e9e9e",
    600: "#757575",
    700: "#616161",
    800: "#424242",
    900: "#212121",
    A100: "#d5d5d5",
    A200: "#aaaaaa",
    A400: "#303030",
    A700: "#616161"
};
var $00f1ba29dcdc9761$export$2e2bcd8739ae039 = $00f1ba29dcdc9761$var$grey;

});

parcelRegister("NZaiv", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $096405d4ab423029$export$2e2bcd8739ae039; });
var $096405d4ab423029$var$indigo = {
    50: "#e8eaf6",
    100: "#c5cae9",
    200: "#9fa8da",
    300: "#7986cb",
    400: "#5c6bc0",
    500: "#3f51b5",
    600: "#3949ab",
    700: "#303f9f",
    800: "#283593",
    900: "#1a237e",
    A100: "#8c9eff",
    A200: "#536dfe",
    A400: "#3d5afe",
    A700: "#304ffe"
};
var $096405d4ab423029$export$2e2bcd8739ae039 = $096405d4ab423029$var$indigo;

});

parcelRegister("9VDdv", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $73a7db8f43fcc9e3$export$2e2bcd8739ae039; });
var $73a7db8f43fcc9e3$var$pink = {
    50: "#fce4ec",
    100: "#f8bbd0",
    200: "#f48fb1",
    300: "#f06292",
    400: "#ec407a",
    500: "#e91e63",
    600: "#d81b60",
    700: "#c2185b",
    800: "#ad1457",
    900: "#880e4f",
    A100: "#ff80ab",
    A200: "#ff4081",
    A400: "#f50057",
    A700: "#c51162"
};
var $73a7db8f43fcc9e3$export$2e2bcd8739ae039 = $73a7db8f43fcc9e3$var$pink;

});

parcelRegister("fdcrk", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b131b82f87dc9910$export$2e2bcd8739ae039; });
var $b131b82f87dc9910$var$red = {
    50: "#ffebee",
    100: "#ffcdd2",
    200: "#ef9a9a",
    300: "#e57373",
    400: "#ef5350",
    500: "#f44336",
    600: "#e53935",
    700: "#d32f2f",
    800: "#c62828",
    900: "#b71c1c",
    A100: "#ff8a80",
    A200: "#ff5252",
    A400: "#ff1744",
    A700: "#d50000"
};
var $b131b82f87dc9910$export$2e2bcd8739ae039 = $b131b82f87dc9910$var$red;

});

parcelRegister("iujT5", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d75a749302b9f0b3$export$2e2bcd8739ae039; });
var $d75a749302b9f0b3$var$orange = {
    50: "#fff3e0",
    100: "#ffe0b2",
    200: "#ffcc80",
    300: "#ffb74d",
    400: "#ffa726",
    500: "#ff9800",
    600: "#fb8c00",
    700: "#f57c00",
    800: "#ef6c00",
    900: "#e65100",
    A100: "#ffd180",
    A200: "#ffab40",
    A400: "#ff9100",
    A700: "#ff6d00"
};
var $d75a749302b9f0b3$export$2e2bcd8739ae039 = $d75a749302b9f0b3$var$orange;

});

parcelRegister("hz3ne", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $cc9852826ea8b595$export$2e2bcd8739ae039; });
var $cc9852826ea8b595$var$blue = {
    50: "#e3f2fd",
    100: "#bbdefb",
    200: "#90caf9",
    300: "#64b5f6",
    400: "#42a5f5",
    500: "#2196f3",
    600: "#1e88e5",
    700: "#1976d2",
    800: "#1565c0",
    900: "#0d47a1",
    A100: "#82b1ff",
    A200: "#448aff",
    A400: "#2979ff",
    A700: "#2962ff"
};
var $cc9852826ea8b595$export$2e2bcd8739ae039 = $cc9852826ea8b595$var$blue;

});

parcelRegister("ecMVT", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a57824b5225a5ddf$export$2e2bcd8739ae039; });
var $a57824b5225a5ddf$var$green = {
    50: "#e8f5e9",
    100: "#c8e6c9",
    200: "#a5d6a7",
    300: "#81c784",
    400: "#66bb6a",
    500: "#4caf50",
    600: "#43a047",
    700: "#388e3c",
    800: "#2e7d32",
    900: "#1b5e20",
    A100: "#b9f6ca",
    A200: "#69f0ae",
    A400: "#00e676",
    A700: "#00c853"
};
var $a57824b5225a5ddf$export$2e2bcd8739ae039 = $a57824b5225a5ddf$var$green;

});


parcelRegister("b3xjG", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $80c9d1759486e639$export$2e2bcd8739ae039; });

var $gtn2B = parcelRequire("gtn2B");

var $fsWgf = parcelRequire("fsWgf");

var $kt6Ie = parcelRequire("kt6Ie");
function $80c9d1759486e639$var$round(value) {
    return Math.round(value * 1e5) / 1e5;
}
var $80c9d1759486e639$var$warnedOnce = false;
function $80c9d1759486e639$var$roundWithDeprecationWarning(value) {
    if (!$80c9d1759486e639$var$warnedOnce) {
        console.warn([
            "Material-UI: The `theme.typography.round` helper is deprecated.",
            "Head to https://material-ui.com/r/migration-v4/#theme for a migration path."
        ].join("\n"));
        $80c9d1759486e639$var$warnedOnce = true;
    }
    return $80c9d1759486e639$var$round(value);
}
var $80c9d1759486e639$var$caseAllCaps = {
    textTransform: "uppercase"
};
var $80c9d1759486e639$var$defaultFontFamily = '"Roboto", "Helvetica", "Arial", sans-serif';
function $80c9d1759486e639$export$2e2bcd8739ae039(palette, typography) {
    var _ref = typeof typography === "function" ? typography(palette) : typography, _ref$fontFamily = _ref.fontFamily, fontFamily = _ref$fontFamily === void 0 ? $80c9d1759486e639$var$defaultFontFamily : _ref$fontFamily, _ref$fontSize = _ref.fontSize, fontSize = _ref$fontSize === void 0 ? 14 : _ref$fontSize, _ref$fontWeightLight = _ref.fontWeightLight, fontWeightLight = _ref$fontWeightLight === void 0 ? 300 : _ref$fontWeightLight, _ref$fontWeightRegula = _ref.fontWeightRegular, fontWeightRegular = _ref$fontWeightRegula === void 0 ? 400 : _ref$fontWeightRegula, _ref$fontWeightMedium = _ref.fontWeightMedium, fontWeightMedium = _ref$fontWeightMedium === void 0 ? 500 : _ref$fontWeightMedium, _ref$fontWeightBold = _ref.fontWeightBold, fontWeightBold = _ref$fontWeightBold === void 0 ? 700 : _ref$fontWeightBold, _ref$htmlFontSize = _ref.htmlFontSize, htmlFontSize = _ref$htmlFontSize === void 0 ? 16 : _ref$htmlFontSize, allVariants = _ref.allVariants, pxToRem2 = _ref.pxToRem, other = (0, $fsWgf.default)(_ref, [
        "fontFamily",
        "fontSize",
        "fontWeightLight",
        "fontWeightRegular",
        "fontWeightMedium",
        "fontWeightBold",
        "htmlFontSize",
        "allVariants",
        "pxToRem"
    ]);
    if (typeof fontSize !== "number") console.error("Material-UI: `fontSize` is required to be a number.");
    if (typeof htmlFontSize !== "number") console.error("Material-UI: `htmlFontSize` is required to be a number.");
    var coef = fontSize / 14;
    var pxToRem = pxToRem2 || function(size) {
        return "".concat(size / htmlFontSize * coef, "rem");
    };
    var buildVariant = function buildVariant(fontWeight, size, lineHeight, letterSpacing, casing) {
        return (0, $gtn2B.default)({
            fontFamily: fontFamily,
            fontWeight: fontWeight,
            fontSize: pxToRem(size),
            // Unitless following https://meyerweb.com/eric/thoughts/2006/02/08/unitless-line-heights/
            lineHeight: lineHeight
        }, fontFamily === $80c9d1759486e639$var$defaultFontFamily ? {
            letterSpacing: "".concat($80c9d1759486e639$var$round(letterSpacing / size), "em")
        } : {}, casing, allVariants);
    };
    var variants = {
        h1: buildVariant(fontWeightLight, 96, 1.167, -1.5),
        h2: buildVariant(fontWeightLight, 60, 1.2, -0.5),
        h3: buildVariant(fontWeightRegular, 48, 1.167, 0),
        h4: buildVariant(fontWeightRegular, 34, 1.235, 0.25),
        h5: buildVariant(fontWeightRegular, 24, 1.334, 0),
        h6: buildVariant(fontWeightMedium, 20, 1.6, 0.15),
        subtitle1: buildVariant(fontWeightRegular, 16, 1.75, 0.15),
        subtitle2: buildVariant(fontWeightMedium, 14, 1.57, 0.1),
        body1: buildVariant(fontWeightRegular, 16, 1.5, 0.15),
        body2: buildVariant(fontWeightRegular, 14, 1.43, 0.15),
        button: buildVariant(fontWeightMedium, 14, 1.75, 0.4, $80c9d1759486e639$var$caseAllCaps),
        caption: buildVariant(fontWeightRegular, 12, 1.66, 0.4),
        overline: buildVariant(fontWeightRegular, 12, 2.66, 1, $80c9d1759486e639$var$caseAllCaps)
    };
    return (0, $kt6Ie.default)((0, $gtn2B.default)({
        htmlFontSize: htmlFontSize,
        pxToRem: pxToRem,
        round: $80c9d1759486e639$var$roundWithDeprecationWarning,
        // TODO v5: remove
        fontFamily: fontFamily,
        fontSize: fontSize,
        fontWeightLight: fontWeightLight,
        fontWeightRegular: fontWeightRegular,
        fontWeightMedium: fontWeightMedium,
        fontWeightBold: fontWeightBold
    }, variants), other, {
        clone: false // No need to clone deep
    });
}

});

parcelRegister("b07Va", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8025d6c1e5036b25$export$2e2bcd8739ae039; });
var $8025d6c1e5036b25$var$shadowKeyUmbraOpacity = 0.2;
var $8025d6c1e5036b25$var$shadowKeyPenumbraOpacity = 0.14;
var $8025d6c1e5036b25$var$shadowAmbientShadowOpacity = 0.12;
function $8025d6c1e5036b25$var$createShadow() {
    return [
        "".concat(arguments.length <= 0 ? undefined : arguments[0], "px ").concat(arguments.length <= 1 ? undefined : arguments[1], "px ").concat(arguments.length <= 2 ? undefined : arguments[2], "px ").concat(arguments.length <= 3 ? undefined : arguments[3], "px rgba(0,0,0,").concat($8025d6c1e5036b25$var$shadowKeyUmbraOpacity, ")"),
        "".concat(arguments.length <= 4 ? undefined : arguments[4], "px ").concat(arguments.length <= 5 ? undefined : arguments[5], "px ").concat(arguments.length <= 6 ? undefined : arguments[6], "px ").concat(arguments.length <= 7 ? undefined : arguments[7], "px rgba(0,0,0,").concat($8025d6c1e5036b25$var$shadowKeyPenumbraOpacity, ")"),
        "".concat(arguments.length <= 8 ? undefined : arguments[8], "px ").concat(arguments.length <= 9 ? undefined : arguments[9], "px ").concat(arguments.length <= 10 ? undefined : arguments[10], "px ").concat(arguments.length <= 11 ? undefined : arguments[11], "px rgba(0,0,0,").concat($8025d6c1e5036b25$var$shadowAmbientShadowOpacity, ")")
    ].join(",");
} // Values from https://github.com/material-components/material-components-web/blob/be8747f94574669cb5e7add1a7c54fa41a89cec7/packages/mdc-elevation/_variables.scss
var $8025d6c1e5036b25$var$shadows = [
    "none",
    $8025d6c1e5036b25$var$createShadow(0, 2, 1, -1, 0, 1, 1, 0, 0, 1, 3, 0),
    $8025d6c1e5036b25$var$createShadow(0, 3, 1, -2, 0, 2, 2, 0, 0, 1, 5, 0),
    $8025d6c1e5036b25$var$createShadow(0, 3, 3, -2, 0, 3, 4, 0, 0, 1, 8, 0),
    $8025d6c1e5036b25$var$createShadow(0, 2, 4, -1, 0, 4, 5, 0, 0, 1, 10, 0),
    $8025d6c1e5036b25$var$createShadow(0, 3, 5, -1, 0, 5, 8, 0, 0, 1, 14, 0),
    $8025d6c1e5036b25$var$createShadow(0, 3, 5, -1, 0, 6, 10, 0, 0, 1, 18, 0),
    $8025d6c1e5036b25$var$createShadow(0, 4, 5, -2, 0, 7, 10, 1, 0, 2, 16, 1),
    $8025d6c1e5036b25$var$createShadow(0, 5, 5, -3, 0, 8, 10, 1, 0, 3, 14, 2),
    $8025d6c1e5036b25$var$createShadow(0, 5, 6, -3, 0, 9, 12, 1, 0, 3, 16, 2),
    $8025d6c1e5036b25$var$createShadow(0, 6, 6, -3, 0, 10, 14, 1, 0, 4, 18, 3),
    $8025d6c1e5036b25$var$createShadow(0, 6, 7, -4, 0, 11, 15, 1, 0, 4, 20, 3),
    $8025d6c1e5036b25$var$createShadow(0, 7, 8, -4, 0, 12, 17, 2, 0, 5, 22, 4),
    $8025d6c1e5036b25$var$createShadow(0, 7, 8, -4, 0, 13, 19, 2, 0, 5, 24, 4),
    $8025d6c1e5036b25$var$createShadow(0, 7, 9, -4, 0, 14, 21, 2, 0, 5, 26, 4),
    $8025d6c1e5036b25$var$createShadow(0, 8, 9, -5, 0, 15, 22, 2, 0, 6, 28, 5),
    $8025d6c1e5036b25$var$createShadow(0, 8, 10, -5, 0, 16, 24, 2, 0, 6, 30, 5),
    $8025d6c1e5036b25$var$createShadow(0, 8, 11, -5, 0, 17, 26, 2, 0, 6, 32, 5),
    $8025d6c1e5036b25$var$createShadow(0, 9, 11, -5, 0, 18, 28, 2, 0, 7, 34, 6),
    $8025d6c1e5036b25$var$createShadow(0, 9, 12, -6, 0, 19, 29, 2, 0, 7, 36, 6),
    $8025d6c1e5036b25$var$createShadow(0, 10, 13, -6, 0, 20, 31, 3, 0, 8, 38, 7),
    $8025d6c1e5036b25$var$createShadow(0, 10, 13, -6, 0, 21, 33, 3, 0, 8, 40, 7),
    $8025d6c1e5036b25$var$createShadow(0, 10, 14, -6, 0, 22, 35, 3, 0, 8, 42, 7),
    $8025d6c1e5036b25$var$createShadow(0, 11, 14, -7, 0, 23, 36, 3, 0, 9, 44, 8),
    $8025d6c1e5036b25$var$createShadow(0, 11, 15, -7, 0, 24, 38, 3, 0, 9, 46, 8)
];
var $8025d6c1e5036b25$export$2e2bcd8739ae039 = $8025d6c1e5036b25$var$shadows;

});

parcelRegister("K4Wzh", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $08a821b2a29d41fe$export$2e2bcd8739ae039; });
var $08a821b2a29d41fe$var$shape = {
    borderRadius: 4
};
var $08a821b2a29d41fe$export$2e2bcd8739ae039 = $08a821b2a29d41fe$var$shape;

});

parcelRegister("lzf3y", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $fb388bb65aa1abcc$export$2e2bcd8739ae039; });

var $9SGLk = parcelRequire("9SGLk");
var $fb388bb65aa1abcc$var$warnOnce;
function $fb388bb65aa1abcc$export$2e2bcd8739ae039() {
    var spacingInput = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 8;
    // Already transformed.
    if (spacingInput.mui) return spacingInput;
     // Material Design layouts are visually balanced. Most measurements align to an 8dp grid applied, which aligns both spacing and the overall layout.
    // Smaller components, such as icons and type, can align to a 4dp grid.
    // https://material.io/design/layout/understanding-layout.html#usage
    var transform = (0, $9SGLk.createUnarySpacing)({
        spacing: spacingInput
    });
    var spacing = function spacing() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        if (!(args.length <= 4)) console.error("Material-UI: Too many arguments provided, expected between 0 and 4, got ".concat(args.length));
        if (args.length === 0) return transform(1);
        if (args.length === 1) return transform(args[0]);
        return args.map(function(argument) {
            if (typeof argument === "string") return argument;
            var output = transform(argument);
            return typeof output === "number" ? "".concat(output, "px") : output;
        }).join(" ");
    }; // Backward compatibility, to remove in v5.
    Object.defineProperty(spacing, "unit", {
        get: function get() {
            if (!$fb388bb65aa1abcc$var$warnOnce || false) console.error([
                "Material-UI: theme.spacing.unit usage has been deprecated.",
                "It will be removed in v5.",
                "You can replace `theme.spacing.unit * y` with `theme.spacing(y)`.",
                "",
                "You can use the `https://github.com/mui-org/material-ui/tree/master/packages/material-ui-codemod/README.md#theme-spacing-api` migration helper to make the process smoother."
            ].join("\n"));
            $fb388bb65aa1abcc$var$warnOnce = true;
            return spacingInput;
        }
    });
    spacing.mui = true;
    return spacing;
}

});
parcelRegister("9SGLk", function(module, exports) {

$parcel$export(module.exports, "createUnarySpacing", function () { return $731a53edb0f4ac6e$export$1def6f833384e3d1; });

var $gz0Kt = parcelRequire("gz0Kt");

var $1NDUI = parcelRequire("1NDUI");

var $3fJgA = parcelRequire("3fJgA");

var $5DANl = parcelRequire("5DANl");

var $kXi0m = parcelRequire("kXi0m");
var $731a53edb0f4ac6e$var$properties = {
    m: "margin",
    p: "padding"
};
var $731a53edb0f4ac6e$var$directions = {
    t: "Top",
    r: "Right",
    b: "Bottom",
    l: "Left",
    x: [
        "Left",
        "Right"
    ],
    y: [
        "Top",
        "Bottom"
    ]
};
var $731a53edb0f4ac6e$var$aliases = {
    marginX: "mx",
    marginY: "my",
    paddingX: "px",
    paddingY: "py"
}; // memoize() impact:
// From 300,000 ops/sec
// To 350,000 ops/sec
var $731a53edb0f4ac6e$var$getCssProperties = (0, $kXi0m.default)(function(prop) {
    // It's not a shorthand notation.
    if (prop.length > 2) {
        if ($731a53edb0f4ac6e$var$aliases[prop]) prop = $731a53edb0f4ac6e$var$aliases[prop];
        else return [
            prop
        ];
    }
    var _prop$split = prop.split(""), _prop$split2 = (0, $gz0Kt.default)(_prop$split, 2), a = _prop$split2[0], b = _prop$split2[1];
    var property = $731a53edb0f4ac6e$var$properties[a];
    var direction = $731a53edb0f4ac6e$var$directions[b] || "";
    return Array.isArray(direction) ? direction.map(function(dir) {
        return property + dir;
    }) : [
        property + direction
    ];
});
var $731a53edb0f4ac6e$var$spacingKeys = [
    "m",
    "mt",
    "mr",
    "mb",
    "ml",
    "mx",
    "my",
    "p",
    "pt",
    "pr",
    "pb",
    "pl",
    "px",
    "py",
    "margin",
    "marginTop",
    "marginRight",
    "marginBottom",
    "marginLeft",
    "marginX",
    "marginY",
    "padding",
    "paddingTop",
    "paddingRight",
    "paddingBottom",
    "paddingLeft",
    "paddingX",
    "paddingY"
];
function $731a53edb0f4ac6e$export$1def6f833384e3d1(theme) {
    var themeSpacing = theme.spacing || 8;
    if (typeof themeSpacing === "number") return function(abs) {
        if (typeof abs !== "number") console.error("Material-UI: Expected spacing argument to be a number, got ".concat(abs, "."));
        return themeSpacing * abs;
    };
    if (Array.isArray(themeSpacing)) return function(abs) {
        if (abs > themeSpacing.length - 1) console.error([
            "Material-UI: The value provided (".concat(abs, ") overflows."),
            "The supported values are: ".concat(JSON.stringify(themeSpacing), "."),
            "".concat(abs, " > ").concat(themeSpacing.length - 1, ", you need to add the missing values.")
        ].join("\n"));
        return themeSpacing[abs];
    };
    if (typeof themeSpacing === "function") return themeSpacing;
    console.error([
        "Material-UI: The `theme.spacing` value (".concat(themeSpacing, ") is invalid."),
        "It should be a number, an array or a function."
    ].join("\n"));
    return function() {
        return undefined;
    };
}
function $731a53edb0f4ac6e$var$getValue(transformer, propValue) {
    if (typeof propValue === "string" || propValue == null) return propValue;
    var abs = Math.abs(propValue);
    var transformed = transformer(abs);
    if (propValue >= 0) return transformed;
    if (typeof transformed === "number") return -transformed;
    return "-".concat(transformed);
}
function $731a53edb0f4ac6e$var$getStyleFromPropValue(cssProperties, transformer) {
    return function(propValue) {
        return cssProperties.reduce(function(acc, cssProperty) {
            acc[cssProperty] = $731a53edb0f4ac6e$var$getValue(transformer, propValue);
            return acc;
        }, {});
    };
}
function $731a53edb0f4ac6e$var$spacing(props) {
    var theme = props.theme;
    var transformer = $731a53edb0f4ac6e$export$1def6f833384e3d1(theme);
    return Object.keys(props).map(function(prop) {
        // Using a hash computation over an array iteration could be faster, but with only 28 items,
        // it's doesn't worth the bundle size.
        if ($731a53edb0f4ac6e$var$spacingKeys.indexOf(prop) === -1) return null;
        var cssProperties = $731a53edb0f4ac6e$var$getCssProperties(prop);
        var styleFromPropValue = $731a53edb0f4ac6e$var$getStyleFromPropValue(cssProperties, transformer);
        var propValue = props[prop];
        return (0, $3fJgA.handleBreakpoints)(props, propValue, styleFromPropValue);
    }).reduce((0, $5DANl.default), {});
}
$731a53edb0f4ac6e$var$spacing.propTypes = $731a53edb0f4ac6e$var$spacingKeys.reduce(function(obj, key) {
    obj[key] = (0, $1NDUI.default);
    return obj;
}, {});
$731a53edb0f4ac6e$var$spacing.filterProps = $731a53edb0f4ac6e$var$spacingKeys;
var $731a53edb0f4ac6e$export$2e2bcd8739ae039 = $731a53edb0f4ac6e$var$spacing;

});
parcelRegister("gz0Kt", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c0f07ee6dc52cafe$export$2e2bcd8739ae039; });

var $g8eN4 = parcelRequire("g8eN4");

var $7GVqY = parcelRequire("7GVqY");

var $ckYPN = parcelRequire("ckYPN");

var $ez4um = parcelRequire("ez4um");
function $c0f07ee6dc52cafe$export$2e2bcd8739ae039(arr, i) {
    return (0, $g8eN4.default)(arr) || (0, $7GVqY.default)(arr, i) || (0, $ckYPN.default)(arr, i) || (0, $ez4um.default)();
}

});
parcelRegister("g8eN4", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $bbe8ddc18fa78d73$export$2e2bcd8739ae039; });
function $bbe8ddc18fa78d73$export$2e2bcd8739ae039(arr) {
    if (Array.isArray(arr)) return arr;
}

});

parcelRegister("7GVqY", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $599901dc822f2782$export$2e2bcd8739ae039; });
function $599901dc822f2782$export$2e2bcd8739ae039(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}

});

parcelRegister("ckYPN", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8fb68ac233b05c9d$export$2e2bcd8739ae039; });

var $2tQb7 = parcelRequire("2tQb7");
function $8fb68ac233b05c9d$export$2e2bcd8739ae039(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return (0, $2tQb7.default)(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return (0, $2tQb7.default)(o, minLen);
}

});
parcelRegister("2tQb7", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1ce6c3b6a66b7b6f$export$2e2bcd8739ae039; });
function $1ce6c3b6a66b7b6f$export$2e2bcd8739ae039(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}

});


parcelRegister("ez4um", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a9a7d0f305bd9213$export$2e2bcd8739ae039; });
function $a9a7d0f305bd9213$export$2e2bcd8739ae039() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

});


parcelRegister("1NDUI", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $14f9541c4887afe7$export$2e2bcd8739ae039; });

var $1xEYC = parcelRequire("1xEYC");
var $14f9541c4887afe7$var$responsivePropType = (0, (/*@__PURE__*/$parcel$interopDefault($1xEYC))).oneOfType([
    (0, (/*@__PURE__*/$parcel$interopDefault($1xEYC))).number,
    (0, (/*@__PURE__*/$parcel$interopDefault($1xEYC))).string,
    (0, (/*@__PURE__*/$parcel$interopDefault($1xEYC))).object,
    (0, (/*@__PURE__*/$parcel$interopDefault($1xEYC))).array
]);
var $14f9541c4887afe7$export$2e2bcd8739ae039 = $14f9541c4887afe7$var$responsivePropType;

});

parcelRegister("3fJgA", function(module, exports) {

$parcel$export(module.exports, "handleBreakpoints", function () { return $25e5e2c6bba237bf$export$88347efdb2e19abd; });

var $5vwUL = parcelRequire("5vwUL");

var $d9u0Q = parcelRequire("d9u0Q");

var $geaQ7 = parcelRequire("geaQ7");

var $1xEYC = parcelRequire("1xEYC");

var $5DANl = parcelRequire("5DANl");
// For instance with the first breakpoint xs: [xs, sm[.
var $25e5e2c6bba237bf$var$values = {
    xs: 0,
    sm: 600,
    md: 960,
    lg: 1280,
    xl: 1920
};
var $25e5e2c6bba237bf$var$defaultBreakpoints = {
    // Sorted ASC by size. That's important.
    // It can't be configured as it's used statically for propTypes.
    keys: [
        "xs",
        "sm",
        "md",
        "lg",
        "xl"
    ],
    up: function up(key) {
        return "@media (min-width:".concat($25e5e2c6bba237bf$var$values[key], "px)");
    }
};
function $25e5e2c6bba237bf$export$88347efdb2e19abd(props, propValue, styleFromPropValue) {
    if (!props.theme) console.error("Material-UI: You are calling a style function without a theme value.");
    if (Array.isArray(propValue)) {
        var themeBreakpoints = props.theme.breakpoints || $25e5e2c6bba237bf$var$defaultBreakpoints;
        return propValue.reduce(function(acc, item, index) {
            acc[themeBreakpoints.up(themeBreakpoints.keys[index])] = styleFromPropValue(propValue[index]);
            return acc;
        }, {});
    }
    if ((0, $geaQ7.default)(propValue) === "object") {
        var _themeBreakpoints = props.theme.breakpoints || $25e5e2c6bba237bf$var$defaultBreakpoints;
        return Object.keys(propValue).reduce(function(acc, breakpoint) {
            acc[_themeBreakpoints.up(breakpoint)] = styleFromPropValue(propValue[breakpoint]);
            return acc;
        }, {});
    }
    var output = styleFromPropValue(propValue);
    return output;
}
function $25e5e2c6bba237bf$var$breakpoints(styleFunction) {
    var newStyleFunction = function newStyleFunction(props) {
        var base = styleFunction(props);
        var themeBreakpoints = props.theme.breakpoints || $25e5e2c6bba237bf$var$defaultBreakpoints;
        var extended = themeBreakpoints.keys.reduce(function(acc, key) {
            if (props[key]) {
                acc = acc || {};
                acc[themeBreakpoints.up(key)] = styleFunction((0, $d9u0Q.default)({
                    theme: props.theme
                }, props[key]));
            }
            return acc;
        }, null);
        return (0, $5DANl.default)(base, extended);
    };
    newStyleFunction.propTypes = (0, $d9u0Q.default)({}, styleFunction.propTypes, {
        xs: (0, (/*@__PURE__*/$parcel$interopDefault($1xEYC))).object,
        sm: (0, (/*@__PURE__*/$parcel$interopDefault($1xEYC))).object,
        md: (0, (/*@__PURE__*/$parcel$interopDefault($1xEYC))).object,
        lg: (0, (/*@__PURE__*/$parcel$interopDefault($1xEYC))).object,
        xl: (0, (/*@__PURE__*/$parcel$interopDefault($1xEYC))).object
    });
    newStyleFunction.filterProps = [
        "xs",
        "sm",
        "md",
        "lg",
        "xl"
    ].concat((0, $5vwUL.default)(styleFunction.filterProps));
    return newStyleFunction;
}
var $25e5e2c6bba237bf$export$2e2bcd8739ae039 = $25e5e2c6bba237bf$var$breakpoints;

});
parcelRegister("5vwUL", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $40296128f0b1ffa4$export$2e2bcd8739ae039; });

var $5ROPm = parcelRequire("5ROPm");

var $8e7xG = parcelRequire("8e7xG");

var $ckYPN = parcelRequire("ckYPN");

var $l8uy1 = parcelRequire("l8uy1");
function $40296128f0b1ffa4$export$2e2bcd8739ae039(arr) {
    return (0, $5ROPm.default)(arr) || (0, $8e7xG.default)(arr) || (0, $ckYPN.default)(arr) || (0, $l8uy1.default)();
}

});
parcelRegister("5ROPm", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4459543e84e5ccb9$export$2e2bcd8739ae039; });

var $2tQb7 = parcelRequire("2tQb7");
function $4459543e84e5ccb9$export$2e2bcd8739ae039(arr) {
    if (Array.isArray(arr)) return (0, $2tQb7.default)(arr);
}

});

parcelRegister("8e7xG", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5fd57b4ca072ed95$export$2e2bcd8739ae039; });
function $5fd57b4ca072ed95$export$2e2bcd8739ae039(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}

});

parcelRegister("l8uy1", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f6320a7fd1550648$export$2e2bcd8739ae039; });
function $f6320a7fd1550648$export$2e2bcd8739ae039() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

});


parcelRegister("d9u0Q", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9933657f497b2faa$export$2e2bcd8739ae039; });
function $9933657f497b2faa$export$2e2bcd8739ae039() {
    $9933657f497b2faa$export$2e2bcd8739ae039 = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $9933657f497b2faa$export$2e2bcd8739ae039.apply(this, arguments);
}

});

parcelRegister("geaQ7", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $bd065cada0a9ba14$export$2e2bcd8739ae039; });
function $bd065cada0a9ba14$export$2e2bcd8739ae039(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $bd065cada0a9ba14$export$2e2bcd8739ae039 = function _typeof(obj) {
        return typeof obj;
    };
    else $bd065cada0a9ba14$export$2e2bcd8739ae039 = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $bd065cada0a9ba14$export$2e2bcd8739ae039(obj);
}

});

parcelRegister("5DANl", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $41ad22f171612a8a$export$2e2bcd8739ae039; });

var $kt6Ie = parcelRequire("kt6Ie");
function $41ad22f171612a8a$var$merge(acc, item) {
    if (!item) return acc;
    return (0, $kt6Ie.default)(acc, item, {
        clone: false // No need to clone deep, it's way faster.
    });
}
var $41ad22f171612a8a$export$2e2bcd8739ae039 = $41ad22f171612a8a$var$merge;

});


parcelRegister("kXi0m", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f41748bc89937e63$export$2e2bcd8739ae039; });
function $f41748bc89937e63$export$2e2bcd8739ae039(fn) {
    var cache = {};
    return function(arg) {
        if (cache[arg] === undefined) cache[arg] = fn(arg);
        return cache[arg];
    };
}

});



parcelRegister("ijxDf", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d55416f5c7eecff1$export$2e2bcd8739ae039; });

var $fsWgf = parcelRequire("fsWgf");
var $d55416f5c7eecff1$export$24c5ac7c37452e7d = {
    // This is the most common easing curve.
    easeInOut: "cubic-bezier(0.4, 0, 0.2, 1)",
    // Objects enter the screen at full velocity from off-screen and
    // slowly decelerate to a resting point.
    easeOut: "cubic-bezier(0.0, 0, 0.2, 1)",
    // Objects leave the screen at full velocity. They do not decelerate when off-screen.
    easeIn: "cubic-bezier(0.4, 0, 1, 1)",
    // The sharp curve is used by objects that may return to the screen at any time.
    sharp: "cubic-bezier(0.4, 0, 0.6, 1)"
}; // Follow https://material.io/guidelines/motion/duration-easing.html#duration-easing-common-durations
var $d55416f5c7eecff1$export$1f34108aa9eb96ab = {
    shortest: 150,
    shorter: 200,
    short: 250,
    // most basic recommended timing
    standard: 300,
    // this is to be used in complex animations
    complex: 375,
    // recommended when something is entering screen
    enteringScreen: 225,
    // recommended when something is leaving screen
    leavingScreen: 195
};
function $d55416f5c7eecff1$var$formatMs(milliseconds) {
    return "".concat(Math.round(milliseconds), "ms");
}
var /**
 * @param {string|Array} props
 * @param {object} param
 * @param {string} param.prop
 * @param {number} param.duration
 * @param {string} param.easing
 * @param {number} param.delay
 */ $d55416f5c7eecff1$export$2e2bcd8739ae039 = {
    easing: $d55416f5c7eecff1$export$24c5ac7c37452e7d,
    duration: $d55416f5c7eecff1$export$1f34108aa9eb96ab,
    create: function create() {
        var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [
            "all"
        ];
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var _options$duration = options.duration, durationOption = _options$duration === void 0 ? $d55416f5c7eecff1$export$1f34108aa9eb96ab.standard : _options$duration, _options$easing = options.easing, easingOption = _options$easing === void 0 ? $d55416f5c7eecff1$export$24c5ac7c37452e7d.easeInOut : _options$easing, _options$delay = options.delay, delay = _options$delay === void 0 ? 0 : _options$delay, other = (0, $fsWgf.default)(options, [
            "duration",
            "easing",
            "delay"
        ]);
        var isString = function isString(value) {
            return typeof value === "string";
        };
        var isNumber = function isNumber(value) {
            return !isNaN(parseFloat(value));
        };
        if (!isString(props) && !Array.isArray(props)) console.error('Material-UI: Argument "props" must be a string or Array.');
        if (!isNumber(durationOption) && !isString(durationOption)) console.error('Material-UI: Argument "duration" must be a number or a string but found '.concat(durationOption, "."));
        if (!isString(easingOption)) console.error('Material-UI: Argument "easing" must be a string.');
        if (!isNumber(delay) && !isString(delay)) console.error('Material-UI: Argument "delay" must be a number or a string.');
        if (Object.keys(other).length !== 0) console.error("Material-UI: Unrecognized argument(s) [".concat(Object.keys(other).join(","), "]."));
        return (Array.isArray(props) ? props : [
            props
        ]).map(function(animatedProp) {
            return "".concat(animatedProp, " ").concat(typeof durationOption === "string" ? durationOption : $d55416f5c7eecff1$var$formatMs(durationOption), " ").concat(easingOption, " ").concat(typeof delay === "string" ? delay : $d55416f5c7eecff1$var$formatMs(delay));
        }).join(",");
    },
    getAutoHeightDuration: function getAutoHeightDuration(height) {
        if (!height) return 0;
        var constant = height / 36; // https://www.wolframalpha.com/input/?i=(4+%2B+15+*+(x+%2F+36+)+**+0.25+%2B+(x+%2F+36)+%2F+5)+*+10
        return Math.round((4 + 15 * Math.pow(constant, 0.25) + constant / 5) * 10);
    }
};

});




parcelRegister("5beWR", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3c599346d9c42cf8$export$2e2bcd8739ae039; });

function $3c599346d9c42cf8$export$2e2bcd8739ae039(string) {
    if (typeof string !== "string") throw new Error("Material-UI: capitalize(string) expects a string argument.");
    return string.charAt(0).toUpperCase() + string.slice(1);
}

});


parcelRegister("1GRlU", function(module, exports) {
/*!
  Copyright (c) 2017 Jed Watson.
  Licensed under the MIT License (MIT), see
  http://jedwatson.github.io/classnames
*/ /* global define */ (function() {
    "use strict";
    var hasOwn = {}.hasOwnProperty;
    function classNames() {
        var classes = [];
        for(var i = 0; i < arguments.length; i++){
            var arg = arguments[i];
            if (!arg) continue;
            var argType = typeof arg;
            if (argType === "string" || argType === "number") classes.push(arg);
            else if (Array.isArray(arg) && arg.length) {
                var inner = classNames.apply(null, arg);
                if (inner) classes.push(inner);
            } else if (argType === "object") {
                for(var key in arg)if (hasOwn.call(arg, key) && arg[key]) classes.push(key);
            }
        }
        return classes.join(" ");
    }
    if (0, module.exports) {
        classNames.default = classNames;
        module.exports = classNames;
    } else if (typeof define === "function" && typeof define.amd === "object" && define.amd) // register as 'classnames', consistent with npm package name
    define("classnames", [], function() {
        return classNames;
    });
    else window.classNames = classNames;
})();

});

parcelRegister("8u8eZ", function(module, exports) {

var $1xEYC = parcelRequire("1xEYC");
const $62d784828f63e593$export$7e927f89b22caf2c = (0, (/*@__PURE__*/$parcel$interopDefault($1xEYC))).shape({
    formatMessage: (0, (/*@__PURE__*/$parcel$interopDefault($1xEYC))).func.isRequired
});
const $62d784828f63e593$export$1d69e636f1b32562 = (0, (/*@__PURE__*/$parcel$interopDefault($1xEYC))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($1xEYC))).shape({
    inlineText: (0, (/*@__PURE__*/$parcel$interopDefault($1xEYC))).bool,
    key: (0, (/*@__PURE__*/$parcel$interopDefault($1xEYC))).string.isRequired,
    label: (0, (/*@__PURE__*/$parcel$interopDefault($1xEYC))).string.isRequired
}));
const $62d784828f63e593$export$9bc1f4057b1b7043 = (0, (/*@__PURE__*/$parcel$interopDefault($1xEYC))).shape({
    description: (0, (/*@__PURE__*/$parcel$interopDefault($1xEYC))).string,
    id: (0, (/*@__PURE__*/$parcel$interopDefault($1xEYC))).string.isRequired,
    items: $62d784828f63e593$export$1d69e636f1b32562,
    options: (0, (/*@__PURE__*/$parcel$interopDefault($1xEYC))).shape(),
    question: (0, (/*@__PURE__*/$parcel$interopDefault($1xEYC))).string.isRequired,
    type: (0, (/*@__PURE__*/$parcel$interopDefault($1xEYC))).string.isRequired
});
const $62d784828f63e593$export$aaf0649dab15c9f5 = (0, (/*@__PURE__*/$parcel$interopDefault($1xEYC))).shape({
    questions: (0, (/*@__PURE__*/$parcel$interopDefault($1xEYC))).arrayOf($62d784828f63e593$export$9bc1f4057b1b7043).isRequired
});
const $62d784828f63e593$export$3084229670219754 = (0, (/*@__PURE__*/$parcel$interopDefault($1xEYC))).shape({
    subText: (0, (/*@__PURE__*/$parcel$interopDefault($1xEYC))).string,
    text: (0, (/*@__PURE__*/$parcel$interopDefault($1xEYC))).string,
    title: (0, (/*@__PURE__*/$parcel$interopDefault($1xEYC))).string
});
const $62d784828f63e593$export$e4ca1b6fd62441ab = (0, (/*@__PURE__*/$parcel$interopDefault($1xEYC))).shape({
    completed: $62d784828f63e593$export$3084229670219754,
    eligibl: $62d784828f63e593$export$3084229670219754,
    ineligible: $62d784828f63e593$export$3084229670219754,
    leave: $62d784828f63e593$export$3084229670219754,
    welcome: $62d784828f63e593$export$3084229670219754
});
var $62d784828f63e593$export$2e2bcd8739ae039 = (0, (/*@__PURE__*/$parcel$interopDefault($1xEYC)));

});


parcelRegister("7YYXE", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5cfd6c9aeb364ae4$export$2e2bcd8739ae039; });

var $fsWgf = parcelRequire("fsWgf");

var $gtn2B = parcelRequire("gtn2B");

var $cQNHH = parcelRequire("cQNHH");

var $1xEYC = parcelRequire("1xEYC");

var $bKF6r = parcelRequire("bKF6r");

var $eyd6T = parcelRequire("eyd6T");

var $80wVS = parcelRequire("80wVS");

var $6apHB = parcelRequire("6apHB");

var $5beWR = parcelRequire("5beWR");
var $5cfd6c9aeb364ae4$export$9dd6ff9ea0189349 = function styles(theme) {
    return {
        /* Styles applied to the root element. */ root: (0, $gtn2B.default)({}, theme.typography.button, {
            boxSizing: "border-box",
            minWidth: 64,
            padding: "6px 16px",
            borderRadius: theme.shape.borderRadius,
            color: theme.palette.text.primary,
            transition: theme.transitions.create([
                "background-color",
                "box-shadow",
                "border"
            ], {
                duration: theme.transitions.duration.short
            }),
            "&:hover": {
                textDecoration: "none",
                backgroundColor: (0, $80wVS.alpha)(theme.palette.text.primary, theme.palette.action.hoverOpacity),
                // Reset on touch devices, it doesn't add specificity
                "@media (hover: none)": {
                    backgroundColor: "transparent"
                },
                "&$disabled": {
                    backgroundColor: "transparent"
                }
            },
            "&$disabled": {
                color: theme.palette.action.disabled
            }
        }),
        /* Styles applied to the span element that wraps the children. */ label: {
            width: "100%",
            // Ensure the correct width for iOS Safari
            display: "inherit",
            alignItems: "inherit",
            justifyContent: "inherit"
        },
        /* Styles applied to the root element if `variant="text"`. */ text: {
            padding: "6px 8px"
        },
        /* Styles applied to the root element if `variant="text"` and `color="primary"`. */ textPrimary: {
            color: theme.palette.primary.main,
            "&:hover": {
                backgroundColor: (0, $80wVS.alpha)(theme.palette.primary.main, theme.palette.action.hoverOpacity),
                // Reset on touch devices, it doesn't add specificity
                "@media (hover: none)": {
                    backgroundColor: "transparent"
                }
            }
        },
        /* Styles applied to the root element if `variant="text"` and `color="secondary"`. */ textSecondary: {
            color: theme.palette.secondary.main,
            "&:hover": {
                backgroundColor: (0, $80wVS.alpha)(theme.palette.secondary.main, theme.palette.action.hoverOpacity),
                // Reset on touch devices, it doesn't add specificity
                "@media (hover: none)": {
                    backgroundColor: "transparent"
                }
            }
        },
        /* Styles applied to the root element if `variant="outlined"`. */ outlined: {
            padding: "5px 15px",
            border: "1px solid ".concat(theme.palette.type === "light" ? "rgba(0, 0, 0, 0.23)" : "rgba(255, 255, 255, 0.23)"),
            "&$disabled": {
                border: "1px solid ".concat(theme.palette.action.disabledBackground)
            }
        },
        /* Styles applied to the root element if `variant="outlined"` and `color="primary"`. */ outlinedPrimary: {
            color: theme.palette.primary.main,
            border: "1px solid ".concat((0, $80wVS.alpha)(theme.palette.primary.main, 0.5)),
            "&:hover": {
                border: "1px solid ".concat(theme.palette.primary.main),
                backgroundColor: (0, $80wVS.alpha)(theme.palette.primary.main, theme.palette.action.hoverOpacity),
                // Reset on touch devices, it doesn't add specificity
                "@media (hover: none)": {
                    backgroundColor: "transparent"
                }
            }
        },
        /* Styles applied to the root element if `variant="outlined"` and `color="secondary"`. */ outlinedSecondary: {
            color: theme.palette.secondary.main,
            border: "1px solid ".concat((0, $80wVS.alpha)(theme.palette.secondary.main, 0.5)),
            "&:hover": {
                border: "1px solid ".concat(theme.palette.secondary.main),
                backgroundColor: (0, $80wVS.alpha)(theme.palette.secondary.main, theme.palette.action.hoverOpacity),
                // Reset on touch devices, it doesn't add specificity
                "@media (hover: none)": {
                    backgroundColor: "transparent"
                }
            },
            "&$disabled": {
                border: "1px solid ".concat(theme.palette.action.disabled)
            }
        },
        /* Styles applied to the root element if `variant="contained"`. */ contained: {
            color: theme.palette.getContrastText(theme.palette.grey[300]),
            backgroundColor: theme.palette.grey[300],
            boxShadow: theme.shadows[2],
            "&:hover": {
                backgroundColor: theme.palette.grey.A100,
                boxShadow: theme.shadows[4],
                // Reset on touch devices, it doesn't add specificity
                "@media (hover: none)": {
                    boxShadow: theme.shadows[2],
                    backgroundColor: theme.palette.grey[300]
                },
                "&$disabled": {
                    backgroundColor: theme.palette.action.disabledBackground
                }
            },
            "&$focusVisible": {
                boxShadow: theme.shadows[6]
            },
            "&:active": {
                boxShadow: theme.shadows[8]
            },
            "&$disabled": {
                color: theme.palette.action.disabled,
                boxShadow: theme.shadows[0],
                backgroundColor: theme.palette.action.disabledBackground
            }
        },
        /* Styles applied to the root element if `variant="contained"` and `color="primary"`. */ containedPrimary: {
            color: theme.palette.primary.contrastText,
            backgroundColor: theme.palette.primary.main,
            "&:hover": {
                backgroundColor: theme.palette.primary.dark,
                // Reset on touch devices, it doesn't add specificity
                "@media (hover: none)": {
                    backgroundColor: theme.palette.primary.main
                }
            }
        },
        /* Styles applied to the root element if `variant="contained"` and `color="secondary"`. */ containedSecondary: {
            color: theme.palette.secondary.contrastText,
            backgroundColor: theme.palette.secondary.main,
            "&:hover": {
                backgroundColor: theme.palette.secondary.dark,
                // Reset on touch devices, it doesn't add specificity
                "@media (hover: none)": {
                    backgroundColor: theme.palette.secondary.main
                }
            }
        },
        /* Styles applied to the root element if `disableElevation={true}`. */ disableElevation: {
            boxShadow: "none",
            "&:hover": {
                boxShadow: "none"
            },
            "&$focusVisible": {
                boxShadow: "none"
            },
            "&:active": {
                boxShadow: "none"
            },
            "&$disabled": {
                boxShadow: "none"
            }
        },
        /* Pseudo-class applied to the ButtonBase root element if the button is keyboard focused. */ focusVisible: {},
        /* Pseudo-class applied to the root element if `disabled={true}`. */ disabled: {},
        /* Styles applied to the root element if `color="inherit"`. */ colorInherit: {
            color: "inherit",
            borderColor: "currentColor"
        },
        /* Styles applied to the root element if `size="small"` and `variant="text"`. */ textSizeSmall: {
            padding: "4px 5px",
            fontSize: theme.typography.pxToRem(13)
        },
        /* Styles applied to the root element if `size="large"` and `variant="text"`. */ textSizeLarge: {
            padding: "8px 11px",
            fontSize: theme.typography.pxToRem(15)
        },
        /* Styles applied to the root element if `size="small"` and `variant="outlined"`. */ outlinedSizeSmall: {
            padding: "3px 9px",
            fontSize: theme.typography.pxToRem(13)
        },
        /* Styles applied to the root element if `size="large"` and `variant="outlined"`. */ outlinedSizeLarge: {
            padding: "7px 21px",
            fontSize: theme.typography.pxToRem(15)
        },
        /* Styles applied to the root element if `size="small"` and `variant="contained"`. */ containedSizeSmall: {
            padding: "4px 10px",
            fontSize: theme.typography.pxToRem(13)
        },
        /* Styles applied to the root element if `size="large"` and `variant="contained"`. */ containedSizeLarge: {
            padding: "8px 22px",
            fontSize: theme.typography.pxToRem(15)
        },
        /* Styles applied to the root element if `size="small"`. */ sizeSmall: {},
        /* Styles applied to the root element if `size="large"`. */ sizeLarge: {},
        /* Styles applied to the root element if `fullWidth={true}`. */ fullWidth: {
            width: "100%"
        },
        /* Styles applied to the startIcon element if supplied. */ startIcon: {
            display: "inherit",
            marginRight: 8,
            marginLeft: -4,
            "&$iconSizeSmall": {
                marginLeft: -2
            }
        },
        /* Styles applied to the endIcon element if supplied. */ endIcon: {
            display: "inherit",
            marginRight: -4,
            marginLeft: 8,
            "&$iconSizeSmall": {
                marginRight: -2
            }
        },
        /* Styles applied to the icon element if supplied and `size="small"`. */ iconSizeSmall: {
            "& > *:first-child": {
                fontSize: 18
            }
        },
        /* Styles applied to the icon element if supplied and `size="medium"`. */ iconSizeMedium: {
            "& > *:first-child": {
                fontSize: 20
            }
        },
        /* Styles applied to the icon element if supplied and `size="large"`. */ iconSizeLarge: {
            "& > *:first-child": {
                fontSize: 22
            }
        }
    };
};
var $5cfd6c9aeb364ae4$var$Button = /*#__PURE__*/ $cQNHH.forwardRef(function Button(props, ref) {
    var children = props.children, classes = props.classes, className = props.className, _props$color = props.color, color = _props$color === void 0 ? "default" : _props$color, _props$component = props.component, component = _props$component === void 0 ? "button" : _props$component, _props$disabled = props.disabled, disabled = _props$disabled === void 0 ? false : _props$disabled, _props$disableElevati = props.disableElevation, disableElevation = _props$disableElevati === void 0 ? false : _props$disableElevati, _props$disableFocusRi = props.disableFocusRipple, disableFocusRipple = _props$disableFocusRi === void 0 ? false : _props$disableFocusRi, endIconProp = props.endIcon, focusVisibleClassName = props.focusVisibleClassName, _props$fullWidth = props.fullWidth, fullWidth = _props$fullWidth === void 0 ? false : _props$fullWidth, _props$size = props.size, size = _props$size === void 0 ? "medium" : _props$size, startIconProp = props.startIcon, _props$type = props.type, type = _props$type === void 0 ? "button" : _props$type, _props$variant = props.variant, variant = _props$variant === void 0 ? "text" : _props$variant, other = (0, $fsWgf.default)(props, [
        "children",
        "classes",
        "className",
        "color",
        "component",
        "disabled",
        "disableElevation",
        "disableFocusRipple",
        "endIcon",
        "focusVisibleClassName",
        "fullWidth",
        "size",
        "startIcon",
        "type",
        "variant"
    ]);
    var startIcon = startIconProp && /*#__PURE__*/ $cQNHH.createElement("span", {
        className: (0, $bKF6r.default)(classes.startIcon, classes["iconSize".concat((0, $5beWR.default)(size))])
    }, startIconProp);
    var endIcon = endIconProp && /*#__PURE__*/ $cQNHH.createElement("span", {
        className: (0, $bKF6r.default)(classes.endIcon, classes["iconSize".concat((0, $5beWR.default)(size))])
    }, endIconProp);
    return /*#__PURE__*/ $cQNHH.createElement((0, $6apHB.default), (0, $gtn2B.default)({
        className: (0, $bKF6r.default)(classes.root, classes[variant], className, color === "inherit" ? classes.colorInherit : color !== "default" && classes["".concat(variant).concat((0, $5beWR.default)(color))], size !== "medium" && [
            classes["".concat(variant, "Size").concat((0, $5beWR.default)(size))],
            classes["size".concat((0, $5beWR.default)(size))]
        ], disableElevation && classes.disableElevation, disabled && classes.disabled, fullWidth && classes.fullWidth),
        component: component,
        disabled: disabled,
        focusRipple: !disableFocusRipple,
        focusVisibleClassName: (0, $bKF6r.default)(classes.focusVisible, focusVisibleClassName),
        ref: ref,
        type: type
    }, other), /*#__PURE__*/ $cQNHH.createElement("span", {
        className: classes.label
    }, startIcon, children, endIcon));
});
$5cfd6c9aeb364ae4$var$Button.propTypes = {
    // ----------------------------- Warning --------------------------------
    // | These PropTypes are generated from the TypeScript type definitions |
    // |     To update them edit the d.ts file and run "yarn proptypes"     |
    // ----------------------------------------------------------------------
    /**
   * The content of the button.
   */ children: (0, (/*@__PURE__*/$parcel$interopDefault($1xEYC))).node,
    /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */ classes: (0, (/*@__PURE__*/$parcel$interopDefault($1xEYC))).object,
    /**
   * @ignore
   */ className: (0, (/*@__PURE__*/$parcel$interopDefault($1xEYC))).string,
    /**
   * The color of the component. It supports those theme colors that make sense for this component.
   */ color: (0, (/*@__PURE__*/$parcel$interopDefault($1xEYC))).oneOf([
        "default",
        "inherit",
        "primary",
        "secondary"
    ]),
    /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */ component: (0, (/*@__PURE__*/$parcel$interopDefault($1xEYC)))/* @typescript-to-proptypes-ignore */ .elementType,
    /**
   * If `true`, the button will be disabled.
   */ disabled: (0, (/*@__PURE__*/$parcel$interopDefault($1xEYC))).bool,
    /**
   * If `true`, no elevation is used.
   */ disableElevation: (0, (/*@__PURE__*/$parcel$interopDefault($1xEYC))).bool,
    /**
   * If `true`, the  keyboard focus ripple will be disabled.
   */ disableFocusRipple: (0, (/*@__PURE__*/$parcel$interopDefault($1xEYC))).bool,
    /**
   * If `true`, the ripple effect will be disabled.
   *
   * ⚠️ Without a ripple there is no styling for :focus-visible by default. Be sure
   * to highlight the element by applying separate styles with the `focusVisibleClassName`.
   */ disableRipple: (0, (/*@__PURE__*/$parcel$interopDefault($1xEYC))).bool,
    /**
   * Element placed after the children.
   */ endIcon: (0, (/*@__PURE__*/$parcel$interopDefault($1xEYC))).node,
    /**
   * @ignore
   */ focusVisibleClassName: (0, (/*@__PURE__*/$parcel$interopDefault($1xEYC))).string,
    /**
   * If `true`, the button will take up the full width of its container.
   */ fullWidth: (0, (/*@__PURE__*/$parcel$interopDefault($1xEYC))).bool,
    /**
   * The URL to link to when the button is clicked.
   * If defined, an `a` element will be used as the root node.
   */ href: (0, (/*@__PURE__*/$parcel$interopDefault($1xEYC))).string,
    /**
   * The size of the button.
   * `small` is equivalent to the dense button styling.
   */ size: (0, (/*@__PURE__*/$parcel$interopDefault($1xEYC))).oneOf([
        "large",
        "medium",
        "small"
    ]),
    /**
   * Element placed before the children.
   */ startIcon: (0, (/*@__PURE__*/$parcel$interopDefault($1xEYC))).node,
    /**
   * @ignore
   */ type: (0, (/*@__PURE__*/$parcel$interopDefault($1xEYC))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($1xEYC))).oneOf([
            "button",
            "reset",
            "submit"
        ]),
        (0, (/*@__PURE__*/$parcel$interopDefault($1xEYC))).string
    ]),
    /**
   * The variant to use.
   */ variant: (0, (/*@__PURE__*/$parcel$interopDefault($1xEYC))).oneOf([
        "contained",
        "outlined",
        "text"
    ])
};
var $5cfd6c9aeb364ae4$export$2e2bcd8739ae039 = (0, $eyd6T.default)($5cfd6c9aeb364ae4$export$9dd6ff9ea0189349, {
    name: "MuiButton"
})($5cfd6c9aeb364ae4$var$Button);

});
parcelRegister("6apHB", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $47d79d2fb924a37f$export$2e2bcd8739ae039; });

var $gtn2B = parcelRequire("gtn2B");

var $fsWgf = parcelRequire("fsWgf");

var $cQNHH = parcelRequire("cQNHH");

var $1xEYC = parcelRequire("1xEYC");

var $dLwnG = parcelRequire("dLwnG");

var $bKF6r = parcelRequire("bKF6r");

var $hyUPo = parcelRequire("hyUPo");
var $kkieU = parcelRequire("kkieU");

var $ge6Tz = parcelRequire("ge6Tz");

var $3uSqW = parcelRequire("3uSqW");

var $hhBX2 = parcelRequire("hhBX2");

var $eyd6T = parcelRequire("eyd6T");

var $9fjCj = parcelRequire("9fjCj");

var $iqfQ6 = parcelRequire("iqfQ6");
var $47d79d2fb924a37f$export$9dd6ff9ea0189349 = {
    /* Styles applied to the root element. */ root: {
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        position: "relative",
        WebkitTapHighlightColor: "transparent",
        backgroundColor: "transparent",
        // Reset default value
        // We disable the focus ring for mouse, touch and keyboard users.
        outline: 0,
        border: 0,
        margin: 0,
        // Remove the margin in Safari
        borderRadius: 0,
        padding: 0,
        // Remove the padding in Firefox
        cursor: "pointer",
        userSelect: "none",
        verticalAlign: "middle",
        "-moz-appearance": "none",
        // Reset
        "-webkit-appearance": "none",
        // Reset
        textDecoration: "none",
        // So we take precedent over the style of a native <a /> element.
        color: "inherit",
        "&::-moz-focus-inner": {
            borderStyle: "none" // Remove Firefox dotted outline.
        },
        "&$disabled": {
            pointerEvents: "none",
            // Disable link interactions
            cursor: "default"
        },
        "@media print": {
            colorAdjust: "exact"
        }
    },
    /* Pseudo-class applied to the root element if `disabled={true}`. */ disabled: {},
    /* Pseudo-class applied to the root element if keyboard focused. */ focusVisible: {}
};
/**
 * `ButtonBase` contains as few styles as possible.
 * It aims to be a simple building block for creating a button.
 * It contains a load of style reset and some focus/ripple logic.
 */ var $47d79d2fb924a37f$var$ButtonBase = /*#__PURE__*/ $cQNHH.forwardRef(function ButtonBase(props, ref) {
    var action = props.action, buttonRefProp = props.buttonRef, _props$centerRipple = props.centerRipple, centerRipple = _props$centerRipple === void 0 ? false : _props$centerRipple, children = props.children, classes = props.classes, className = props.className, _props$component = props.component, component = _props$component === void 0 ? "button" : _props$component, _props$disabled = props.disabled, disabled = _props$disabled === void 0 ? false : _props$disabled, _props$disableRipple = props.disableRipple, disableRipple = _props$disableRipple === void 0 ? false : _props$disableRipple, _props$disableTouchRi = props.disableTouchRipple, disableTouchRipple = _props$disableTouchRi === void 0 ? false : _props$disableTouchRi, _props$focusRipple = props.focusRipple, focusRipple = _props$focusRipple === void 0 ? false : _props$focusRipple, focusVisibleClassName = props.focusVisibleClassName, onBlur = props.onBlur, onClick = props.onClick, onFocus = props.onFocus, onFocusVisible = props.onFocusVisible, onKeyDown = props.onKeyDown, onKeyUp = props.onKeyUp, onMouseDown = props.onMouseDown, onMouseLeave = props.onMouseLeave, onMouseUp = props.onMouseUp, onTouchEnd = props.onTouchEnd, onTouchMove = props.onTouchMove, onTouchStart = props.onTouchStart, onDragLeave = props.onDragLeave, _props$tabIndex = props.tabIndex, tabIndex = _props$tabIndex === void 0 ? 0 : _props$tabIndex, TouchRippleProps = props.TouchRippleProps, _props$type = props.type, type = _props$type === void 0 ? "button" : _props$type, other = (0, $fsWgf.default)(props, [
        "action",
        "buttonRef",
        "centerRipple",
        "children",
        "classes",
        "className",
        "component",
        "disabled",
        "disableRipple",
        "disableTouchRipple",
        "focusRipple",
        "focusVisibleClassName",
        "onBlur",
        "onClick",
        "onFocus",
        "onFocusVisible",
        "onKeyDown",
        "onKeyUp",
        "onMouseDown",
        "onMouseLeave",
        "onMouseUp",
        "onTouchEnd",
        "onTouchMove",
        "onTouchStart",
        "onDragLeave",
        "tabIndex",
        "TouchRippleProps",
        "type"
    ]);
    var buttonRef = $cQNHH.useRef(null);
    function getButtonNode() {
        // #StrictMode ready
        return $dLwnG.findDOMNode(buttonRef.current);
    }
    var rippleRef = $cQNHH.useRef(null);
    var _React$useState = $cQNHH.useState(false), focusVisible = _React$useState[0], setFocusVisible = _React$useState[1];
    if (disabled && focusVisible) setFocusVisible(false);
    var _useIsFocusVisible = (0, $9fjCj.default)(), isFocusVisible = _useIsFocusVisible.isFocusVisible, onBlurVisible = _useIsFocusVisible.onBlurVisible, focusVisibleRef = _useIsFocusVisible.ref;
    $cQNHH.useImperativeHandle(action, function() {
        return {
            focusVisible: function focusVisible() {
                setFocusVisible(true);
                buttonRef.current.focus();
            }
        };
    }, []);
    $cQNHH.useEffect(function() {
        if (focusVisible && focusRipple && !disableRipple) rippleRef.current.pulsate();
    }, [
        disableRipple,
        focusRipple,
        focusVisible
    ]);
    function useRippleHandler(rippleAction, eventCallback) {
        var skipRippleAction = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : disableTouchRipple;
        return (0, $3uSqW.default)(function(event) {
            if (eventCallback) eventCallback(event);
            var ignore = skipRippleAction;
            if (!ignore && rippleRef.current) rippleRef.current[rippleAction](event);
            return true;
        });
    }
    var handleMouseDown = useRippleHandler("start", onMouseDown);
    var handleDragLeave = useRippleHandler("stop", onDragLeave);
    var handleMouseUp = useRippleHandler("stop", onMouseUp);
    var handleMouseLeave = useRippleHandler("stop", function(event) {
        if (focusVisible) event.preventDefault();
        if (onMouseLeave) onMouseLeave(event);
    });
    var handleTouchStart = useRippleHandler("start", onTouchStart);
    var handleTouchEnd = useRippleHandler("stop", onTouchEnd);
    var handleTouchMove = useRippleHandler("stop", onTouchMove);
    var handleBlur = useRippleHandler("stop", function(event) {
        if (focusVisible) {
            onBlurVisible(event);
            setFocusVisible(false);
        }
        if (onBlur) onBlur(event);
    }, false);
    var handleFocus = (0, $3uSqW.default)(function(event) {
        // Fix for https://github.com/facebook/react/issues/7769
        if (!buttonRef.current) buttonRef.current = event.currentTarget;
        if (isFocusVisible(event)) {
            setFocusVisible(true);
            if (onFocusVisible) onFocusVisible(event);
        }
        if (onFocus) onFocus(event);
    });
    var isNonNativeButton = function isNonNativeButton() {
        var button = getButtonNode();
        return component && component !== "button" && !(button.tagName === "A" && button.href);
    };
    /**
   * IE 11 shim for https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent/repeat
   */ var keydownRef = $cQNHH.useRef(false);
    var handleKeyDown = (0, $3uSqW.default)(function(event) {
        // Check if key is already down to avoid repeats being counted as multiple activations
        if (focusRipple && !keydownRef.current && focusVisible && rippleRef.current && event.key === " ") {
            keydownRef.current = true;
            event.persist();
            rippleRef.current.stop(event, function() {
                rippleRef.current.start(event);
            });
        }
        if (event.target === event.currentTarget && isNonNativeButton() && event.key === " ") event.preventDefault();
        if (onKeyDown) onKeyDown(event);
         // Keyboard accessibility for non interactive elements
        if (event.target === event.currentTarget && isNonNativeButton() && event.key === "Enter" && !disabled) {
            event.preventDefault();
            if (onClick) onClick(event);
        }
    });
    var handleKeyUp = (0, $3uSqW.default)(function(event) {
        // calling preventDefault in keyUp on a <button> will not dispatch a click event if Space is pressed
        // https://codesandbox.io/s/button-keyup-preventdefault-dn7f0
        if (focusRipple && event.key === " " && rippleRef.current && focusVisible && !event.defaultPrevented) {
            keydownRef.current = false;
            event.persist();
            rippleRef.current.stop(event, function() {
                rippleRef.current.pulsate(event);
            });
        }
        if (onKeyUp) onKeyUp(event);
         // Keyboard accessibility for non interactive elements
        if (onClick && event.target === event.currentTarget && isNonNativeButton() && event.key === " " && !event.defaultPrevented) onClick(event);
    });
    var ComponentProp = component;
    if (ComponentProp === "button" && other.href) ComponentProp = "a";
    var buttonProps = {};
    if (ComponentProp === "button") {
        buttonProps.type = type;
        buttonProps.disabled = disabled;
    } else {
        if (ComponentProp !== "a" || !other.href) buttonProps.role = "button";
        buttonProps["aria-disabled"] = disabled;
    }
    var handleUserRef = (0, $ge6Tz.default)(buttonRefProp, ref);
    var handleOwnRef = (0, $ge6Tz.default)(focusVisibleRef, buttonRef);
    var handleRef = (0, $ge6Tz.default)(handleUserRef, handleOwnRef);
    var _React$useState2 = $cQNHH.useState(false), mountedState = _React$useState2[0], setMountedState = _React$useState2[1];
    $cQNHH.useEffect(function() {
        setMountedState(true);
    }, []);
    var enableTouchRipple = mountedState && !disableRipple && !disabled;
    // eslint-disable-next-line react-hooks/rules-of-hooks
    $cQNHH.useEffect(function() {
        if (enableTouchRipple && !rippleRef.current) console.error([
            "Material-UI: The `component` prop provided to ButtonBase is invalid.",
            "Please make sure the children prop is rendered in this custom component."
        ].join("\n"));
    }, [
        enableTouchRipple
    ]);
    return /*#__PURE__*/ $cQNHH.createElement(ComponentProp, (0, $gtn2B.default)({
        className: (0, $bKF6r.default)(classes.root, className, focusVisible && [
            classes.focusVisible,
            focusVisibleClassName
        ], disabled && classes.disabled),
        onBlur: handleBlur,
        onClick: onClick,
        onFocus: handleFocus,
        onKeyDown: handleKeyDown,
        onKeyUp: handleKeyUp,
        onMouseDown: handleMouseDown,
        onMouseLeave: handleMouseLeave,
        onMouseUp: handleMouseUp,
        onDragLeave: handleDragLeave,
        onTouchEnd: handleTouchEnd,
        onTouchMove: handleTouchMove,
        onTouchStart: handleTouchStart,
        ref: handleRef,
        tabIndex: disabled ? -1 : tabIndex
    }, buttonProps, other), children, enableTouchRipple ? /*#__PURE__*/ /* TouchRipple is only needed client-side, x2 boost on the server. */ $cQNHH.createElement((0, $iqfQ6.default), (0, $gtn2B.default)({
        ref: rippleRef,
        center: centerRipple
    }, TouchRippleProps)) : null);
});
$47d79d2fb924a37f$var$ButtonBase.propTypes = {
    // ----------------------------- Warning --------------------------------
    // | These PropTypes are generated from the TypeScript type definitions |
    // |     To update them edit the d.ts file and run "yarn proptypes"     |
    // ----------------------------------------------------------------------
    /**
   * A ref for imperative actions.
   * It currently only supports `focusVisible()` action.
   */ action: (0, $kkieU.default),
    /**
   * @ignore
   *
   * Use that prop to pass a ref to the native button component.
   * @deprecated Use `ref` instead.
   */ buttonRef: (0, $hhBX2.default)((0, $kkieU.default), "Use `ref` instead."),
    /**
   * If `true`, the ripples will be centered.
   * They won't start at the cursor interaction position.
   */ centerRipple: (0, (/*@__PURE__*/$parcel$interopDefault($1xEYC))).bool,
    /**
   * The content of the component.
   */ children: (0, (/*@__PURE__*/$parcel$interopDefault($1xEYC))).node,
    /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */ classes: (0, (/*@__PURE__*/$parcel$interopDefault($1xEYC))).object,
    /**
   * @ignore
   */ className: (0, (/*@__PURE__*/$parcel$interopDefault($1xEYC))).string,
    /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */ component: (0, $hyUPo.default),
    /**
   * If `true`, the base button will be disabled.
   */ disabled: (0, (/*@__PURE__*/$parcel$interopDefault($1xEYC))).bool,
    /**
   * If `true`, the ripple effect will be disabled.
   *
   * ⚠️ Without a ripple there is no styling for :focus-visible by default. Be sure
   * to highlight the element by applying separate styles with the `focusVisibleClassName`.
   */ disableRipple: (0, (/*@__PURE__*/$parcel$interopDefault($1xEYC))).bool,
    /**
   * If `true`, the touch ripple effect will be disabled.
   */ disableTouchRipple: (0, (/*@__PURE__*/$parcel$interopDefault($1xEYC))).bool,
    /**
   * If `true`, the base button will have a keyboard focus ripple.
   */ focusRipple: (0, (/*@__PURE__*/$parcel$interopDefault($1xEYC))).bool,
    /**
   * This prop can help identify which element has keyboard focus.
   * The class name will be applied when the element gains the focus through keyboard interaction.
   * It's a polyfill for the [CSS :focus-visible selector](https://drafts.csswg.org/selectors-4/#the-focus-visible-pseudo).
   * The rationale for using this feature [is explained here](https://github.com/WICG/focus-visible/blob/master/explainer.md).
   * A [polyfill can be used](https://github.com/WICG/focus-visible) to apply a `focus-visible` class to other components
   * if needed.
   */ focusVisibleClassName: (0, (/*@__PURE__*/$parcel$interopDefault($1xEYC))).string,
    /**
   * @ignore
   */ href: (0, (/*@__PURE__*/$parcel$interopDefault($1xEYC))).string,
    /**
   * @ignore
   */ onBlur: (0, (/*@__PURE__*/$parcel$interopDefault($1xEYC))).func,
    /**
   * @ignore
   */ onClick: (0, (/*@__PURE__*/$parcel$interopDefault($1xEYC))).func,
    /**
   * @ignore
   */ onDragLeave: (0, (/*@__PURE__*/$parcel$interopDefault($1xEYC))).func,
    /**
   * @ignore
   */ onFocus: (0, (/*@__PURE__*/$parcel$interopDefault($1xEYC))).func,
    /**
   * Callback fired when the component is focused with a keyboard.
   * We trigger a `onFocus` callback too.
   */ onFocusVisible: (0, (/*@__PURE__*/$parcel$interopDefault($1xEYC))).func,
    /**
   * @ignore
   */ onKeyDown: (0, (/*@__PURE__*/$parcel$interopDefault($1xEYC))).func,
    /**
   * @ignore
   */ onKeyUp: (0, (/*@__PURE__*/$parcel$interopDefault($1xEYC))).func,
    /**
   * @ignore
   */ onMouseDown: (0, (/*@__PURE__*/$parcel$interopDefault($1xEYC))).func,
    /**
   * @ignore
   */ onMouseLeave: (0, (/*@__PURE__*/$parcel$interopDefault($1xEYC))).func,
    /**
   * @ignore
   */ onMouseUp: (0, (/*@__PURE__*/$parcel$interopDefault($1xEYC))).func,
    /**
   * @ignore
   */ onTouchEnd: (0, (/*@__PURE__*/$parcel$interopDefault($1xEYC))).func,
    /**
   * @ignore
   */ onTouchMove: (0, (/*@__PURE__*/$parcel$interopDefault($1xEYC))).func,
    /**
   * @ignore
   */ onTouchStart: (0, (/*@__PURE__*/$parcel$interopDefault($1xEYC))).func,
    /**
   * @ignore
   */ tabIndex: (0, (/*@__PURE__*/$parcel$interopDefault($1xEYC))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($1xEYC))).number,
        (0, (/*@__PURE__*/$parcel$interopDefault($1xEYC))).string
    ]),
    /**
   * Props applied to the `TouchRipple` element.
   */ TouchRippleProps: (0, (/*@__PURE__*/$parcel$interopDefault($1xEYC))).object,
    /**
   * @ignore
   */ type: (0, (/*@__PURE__*/$parcel$interopDefault($1xEYC))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($1xEYC))).oneOf([
            "button",
            "reset",
            "submit"
        ]),
        (0, (/*@__PURE__*/$parcel$interopDefault($1xEYC))).string
    ])
};
var $47d79d2fb924a37f$export$2e2bcd8739ae039 = (0, $eyd6T.default)($47d79d2fb924a37f$export$9dd6ff9ea0189349, {
    name: "MuiButtonBase"
})($47d79d2fb924a37f$var$ButtonBase);

});
parcelRegister("hyUPo", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $cc91b17e61ee337f$export$2e2bcd8739ae039; });

var $1xEYC = parcelRequire("1xEYC");

var $dcECW = parcelRequire("dcECW");
function $cc91b17e61ee337f$var$isClassComponent(elementType) {
    // elementType.prototype?.isReactComponent
    var _elementType$prototyp = elementType.prototype, prototype = _elementType$prototyp === void 0 ? {} : _elementType$prototyp;
    return Boolean(prototype.isReactComponent);
}
function $cc91b17e61ee337f$var$elementTypeAcceptingRef(props, propName, componentName, location, propFullName) {
    var propValue = props[propName];
    var safePropName = propFullName || propName;
    if (propValue == null) return null;
    var warningHint;
    /**
   * Blacklisting instead of whitelisting
   *
   * Blacklisting will miss some components, such as React.Fragment. Those will at least
   * trigger a warning in React.
   * We can't whitelist because there is no safe way to detect React.forwardRef
   * or class components. "Safe" means there's no public API.
   *
   */ if (typeof propValue === "function" && !$cc91b17e61ee337f$var$isClassComponent(propValue)) warningHint = "Did you accidentally provide a plain function component instead?";
    if (warningHint !== undefined) return new Error("Invalid ".concat(location, " `").concat(safePropName, "` supplied to `").concat(componentName, "`. ") + "Expected an element type that can hold a ref. ".concat(warningHint, " ") + "For more information see https://material-ui.com/r/caveat-with-refs-guide");
    return null;
}
var $cc91b17e61ee337f$export$2e2bcd8739ae039 = (0, $dcECW.default)($1xEYC.elementType, $cc91b17e61ee337f$var$elementTypeAcceptingRef);

});

parcelRegister("kkieU", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ecc3d2e12b57912c$export$2e2bcd8739ae039; });

var $1xEYC = parcelRequire("1xEYC");
var $ecc3d2e12b57912c$var$refType = (0, (/*@__PURE__*/$parcel$interopDefault($1xEYC))).oneOfType([
    (0, (/*@__PURE__*/$parcel$interopDefault($1xEYC))).func,
    (0, (/*@__PURE__*/$parcel$interopDefault($1xEYC))).object
]);
var $ecc3d2e12b57912c$export$2e2bcd8739ae039 = $ecc3d2e12b57912c$var$refType;

});

parcelRegister("ge6Tz", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $bd034d6561620cdc$export$2e2bcd8739ae039; });

var $cQNHH = parcelRequire("cQNHH");

var $dNhy6 = parcelRequire("dNhy6");
function $bd034d6561620cdc$export$2e2bcd8739ae039(refA, refB) {
    /**
   * This will create a new function if the ref props change and are defined.
   * This means react will call the old forkRef with `null` and the new forkRef
   * with the ref. Cleanup naturally emerges from this behavior
   */ return $cQNHH.useMemo(function() {
        if (refA == null && refB == null) return null;
        return function(refValue) {
            (0, $dNhy6.default)(refA, refValue);
            (0, $dNhy6.default)(refB, refValue);
        };
    }, [
        refA,
        refB
    ]);
}

});
parcelRegister("dNhy6", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a0ad76dbd8c041a0$export$2e2bcd8739ae039; });
// TODO v5: consider to make it private
function $a0ad76dbd8c041a0$export$2e2bcd8739ae039(ref, value) {
    if (typeof ref === "function") ref(value);
    else if (ref) ref.current = value;
}

});


parcelRegister("3uSqW", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $28be65d3ec97a86f$export$2e2bcd8739ae039; });

var $cQNHH = parcelRequire("cQNHH");
var $28be65d3ec97a86f$var$useEnhancedEffect = typeof window !== "undefined" ? $cQNHH.useLayoutEffect : $cQNHH.useEffect;
function $28be65d3ec97a86f$export$2e2bcd8739ae039(fn) {
    var ref = $cQNHH.useRef(fn);
    $28be65d3ec97a86f$var$useEnhancedEffect(function() {
        ref.current = fn;
    });
    return $cQNHH.useCallback(function() {
        return (0, ref.current).apply(void 0, arguments);
    }, []);
}

});

parcelRegister("hhBX2", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c9517686d2f22cad$export$2e2bcd8739ae039; });
function $c9517686d2f22cad$export$2e2bcd8739ae039(validator, reason) {
    return function(props, propName, componentName, location, propFullName) {
        var componentNameSafe = componentName || "<<anonymous>>";
        var propFullNameSafe = propFullName || propName;
        if (typeof props[propName] !== "undefined") return new Error("The ".concat(location, " `").concat(propFullNameSafe, "` of ") + "`".concat(componentNameSafe, "` is deprecated. ").concat(reason));
        return null;
    };
}

});

parcelRegister("9fjCj", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6bb4bb481cb61c23$export$2e2bcd8739ae039; });
// based on https://github.com/WICG/focus-visible/blob/v4.1.5/src/focus-visible.js

var $cQNHH = parcelRequire("cQNHH");

var $dLwnG = parcelRequire("dLwnG");
var $6bb4bb481cb61c23$var$hadKeyboardEvent = true;
var $6bb4bb481cb61c23$var$hadFocusVisibleRecently = false;
var $6bb4bb481cb61c23$var$hadFocusVisibleRecentlyTimeout = null;
var $6bb4bb481cb61c23$var$inputTypesWhitelist = {
    text: true,
    search: true,
    url: true,
    tel: true,
    email: true,
    password: true,
    number: true,
    date: true,
    month: true,
    week: true,
    time: true,
    datetime: true,
    "datetime-local": true
};
/**
 * Computes whether the given element should automatically trigger the
 * `focus-visible` class being added, i.e. whether it should always match
 * `:focus-visible` when focused.
 * @param {Element} node
 * @return {boolean}
 */ function $6bb4bb481cb61c23$var$focusTriggersKeyboardModality(node) {
    var type = node.type, tagName = node.tagName;
    if (tagName === "INPUT" && $6bb4bb481cb61c23$var$inputTypesWhitelist[type] && !node.readOnly) return true;
    if (tagName === "TEXTAREA" && !node.readOnly) return true;
    if (node.isContentEditable) return true;
    return false;
}
/**
 * Keep track of our keyboard modality state with `hadKeyboardEvent`.
 * If the most recent user interaction was via the keyboard;
 * and the key press did not include a meta, alt/option, or control key;
 * then the modality is keyboard. Otherwise, the modality is not keyboard.
 * @param {KeyboardEvent} event
 */ function $6bb4bb481cb61c23$var$handleKeyDown(event) {
    if (event.metaKey || event.altKey || event.ctrlKey) return;
    $6bb4bb481cb61c23$var$hadKeyboardEvent = true;
}
/**
 * If at any point a user clicks with a pointing device, ensure that we change
 * the modality away from keyboard.
 * This avoids the situation where a user presses a key on an already focused
 * element, and then clicks on a different element, focusing it with a
 * pointing device, while we still think we're in keyboard modality.
 */ function $6bb4bb481cb61c23$var$handlePointerDown() {
    $6bb4bb481cb61c23$var$hadKeyboardEvent = false;
}
function $6bb4bb481cb61c23$var$handleVisibilityChange() {
    if (this.visibilityState === "hidden") // If the tab becomes active again, the browser will handle calling focus
    // on the element (Safari actually calls it twice).
    // If this tab change caused a blur on an element with focus-visible,
    // re-apply the class when the user switches back to the tab.
    {
        if ($6bb4bb481cb61c23$var$hadFocusVisibleRecently) $6bb4bb481cb61c23$var$hadKeyboardEvent = true;
    }
}
function $6bb4bb481cb61c23$var$prepare(doc) {
    doc.addEventListener("keydown", $6bb4bb481cb61c23$var$handleKeyDown, true);
    doc.addEventListener("mousedown", $6bb4bb481cb61c23$var$handlePointerDown, true);
    doc.addEventListener("pointerdown", $6bb4bb481cb61c23$var$handlePointerDown, true);
    doc.addEventListener("touchstart", $6bb4bb481cb61c23$var$handlePointerDown, true);
    doc.addEventListener("visibilitychange", $6bb4bb481cb61c23$var$handleVisibilityChange, true);
}
function $6bb4bb481cb61c23$export$4794d9b1949031cf(doc) {
    doc.removeEventListener("keydown", $6bb4bb481cb61c23$var$handleKeyDown, true);
    doc.removeEventListener("mousedown", $6bb4bb481cb61c23$var$handlePointerDown, true);
    doc.removeEventListener("pointerdown", $6bb4bb481cb61c23$var$handlePointerDown, true);
    doc.removeEventListener("touchstart", $6bb4bb481cb61c23$var$handlePointerDown, true);
    doc.removeEventListener("visibilitychange", $6bb4bb481cb61c23$var$handleVisibilityChange, true);
}
function $6bb4bb481cb61c23$var$isFocusVisible(event) {
    var target = event.target;
    try {
        return target.matches(":focus-visible");
    } catch (error) {} // browsers not implementing :focus-visible will throw a SyntaxError
    // we use our own heuristic for those browsers
    // rethrow might be better if it's not the expected error but do we really
    // want to crash if focus-visible malfunctioned?
    // no need for validFocusTarget check. the user does that by attaching it to
    // focusable events only
    return $6bb4bb481cb61c23$var$hadKeyboardEvent || $6bb4bb481cb61c23$var$focusTriggersKeyboardModality(target);
}
/**
 * Should be called if a blur event is fired on a focus-visible element
 */ function $6bb4bb481cb61c23$var$handleBlurVisible() {
    // To detect a tab/window switch, we look for a blur event followed
    // rapidly by a visibility change.
    // If we don't see a visibility change within 100ms, it's probably a
    // regular focus change.
    $6bb4bb481cb61c23$var$hadFocusVisibleRecently = true;
    window.clearTimeout($6bb4bb481cb61c23$var$hadFocusVisibleRecentlyTimeout);
    $6bb4bb481cb61c23$var$hadFocusVisibleRecentlyTimeout = window.setTimeout(function() {
        $6bb4bb481cb61c23$var$hadFocusVisibleRecently = false;
    }, 100);
}
function $6bb4bb481cb61c23$export$2e2bcd8739ae039() {
    var ref = $cQNHH.useCallback(function(instance) {
        var node = $dLwnG.findDOMNode(instance);
        if (node != null) $6bb4bb481cb61c23$var$prepare(node.ownerDocument);
    }, []);
    // eslint-disable-next-line react-hooks/rules-of-hooks
    $cQNHH.useDebugValue($6bb4bb481cb61c23$var$isFocusVisible);
    return {
        isFocusVisible: $6bb4bb481cb61c23$var$isFocusVisible,
        onBlurVisible: $6bb4bb481cb61c23$var$handleBlurVisible,
        ref: ref
    };
}

});

parcelRegister("iqfQ6", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d696f110982781b3$export$2e2bcd8739ae039; });

var $gtn2B = parcelRequire("gtn2B");

var $6YeMW = parcelRequire("6YeMW");

var $fsWgf = parcelRequire("fsWgf");

var $cQNHH = parcelRequire("cQNHH");

var $1xEYC = parcelRequire("1xEYC");

var $c4T9R = parcelRequire("c4T9R");

var $bKF6r = parcelRequire("bKF6r");

var $eyd6T = parcelRequire("eyd6T");

var $2tdAk = parcelRequire("2tdAk");
var $d696f110982781b3$var$DURATION = 550;
var $d696f110982781b3$export$95d0c9356b2231a3 = 80;
var $d696f110982781b3$export$9dd6ff9ea0189349 = function styles(theme) {
    return {
        /* Styles applied to the root element. */ root: {
            overflow: "hidden",
            pointerEvents: "none",
            position: "absolute",
            zIndex: 0,
            top: 0,
            right: 0,
            bottom: 0,
            left: 0,
            borderRadius: "inherit"
        },
        /* Styles applied to the internal `Ripple` components `ripple` class. */ ripple: {
            opacity: 0,
            position: "absolute"
        },
        /* Styles applied to the internal `Ripple` components `rippleVisible` class. */ rippleVisible: {
            opacity: 0.3,
            transform: "scale(1)",
            animation: "$enter ".concat($d696f110982781b3$var$DURATION, "ms ").concat(theme.transitions.easing.easeInOut)
        },
        /* Styles applied to the internal `Ripple` components `ripplePulsate` class. */ ripplePulsate: {
            animationDuration: "".concat(theme.transitions.duration.shorter, "ms")
        },
        /* Styles applied to the internal `Ripple` components `child` class. */ child: {
            opacity: 1,
            display: "block",
            width: "100%",
            height: "100%",
            borderRadius: "50%",
            backgroundColor: "currentColor"
        },
        /* Styles applied to the internal `Ripple` components `childLeaving` class. */ childLeaving: {
            opacity: 0,
            animation: "$exit ".concat($d696f110982781b3$var$DURATION, "ms ").concat(theme.transitions.easing.easeInOut)
        },
        /* Styles applied to the internal `Ripple` components `childPulsate` class. */ childPulsate: {
            position: "absolute",
            left: 0,
            top: 0,
            animation: "$pulsate 2500ms ".concat(theme.transitions.easing.easeInOut, " 200ms infinite")
        },
        "@keyframes enter": {
            "0%": {
                transform: "scale(0)",
                opacity: 0.1
            },
            "100%": {
                transform: "scale(1)",
                opacity: 0.3
            }
        },
        "@keyframes exit": {
            "0%": {
                opacity: 1
            },
            "100%": {
                opacity: 0
            }
        },
        "@keyframes pulsate": {
            "0%": {
                transform: "scale(1)"
            },
            "50%": {
                transform: "scale(0.92)"
            },
            "100%": {
                transform: "scale(1)"
            }
        }
    };
};
/**
 * @ignore - internal component.
 *
 * TODO v5: Make private
 */ var $d696f110982781b3$var$TouchRipple = /*#__PURE__*/ $cQNHH.forwardRef(function TouchRipple(props, ref) {
    var _props$center = props.center, centerProp = _props$center === void 0 ? false : _props$center, classes = props.classes, className = props.className, other = (0, $fsWgf.default)(props, [
        "center",
        "classes",
        "className"
    ]);
    var _React$useState = $cQNHH.useState([]), ripples = _React$useState[0], setRipples = _React$useState[1];
    var nextKey = $cQNHH.useRef(0);
    var rippleCallback = $cQNHH.useRef(null);
    $cQNHH.useEffect(function() {
        if (rippleCallback.current) {
            rippleCallback.current();
            rippleCallback.current = null;
        }
    }, [
        ripples
    ]); // Used to filter out mouse emulated events on mobile.
    var ignoringMouseDown = $cQNHH.useRef(false); // We use a timer in order to only show the ripples for touch "click" like events.
    // We don't want to display the ripple for touch scroll events.
    var startTimer = $cQNHH.useRef(null); // This is the hook called once the previous timeout is ready.
    var startTimerCommit = $cQNHH.useRef(null);
    var container = $cQNHH.useRef(null);
    $cQNHH.useEffect(function() {
        return function() {
            clearTimeout(startTimer.current);
        };
    }, []);
    var startCommit = $cQNHH.useCallback(function(params) {
        var pulsate = params.pulsate, rippleX = params.rippleX, rippleY = params.rippleY, rippleSize = params.rippleSize, cb = params.cb;
        setRipples(function(oldRipples) {
            return [].concat((0, $6YeMW.default)(oldRipples), [
                /*#__PURE__*/ $cQNHH.createElement((0, $2tdAk.default), {
                    key: nextKey.current,
                    classes: classes,
                    timeout: $d696f110982781b3$var$DURATION,
                    pulsate: pulsate,
                    rippleX: rippleX,
                    rippleY: rippleY,
                    rippleSize: rippleSize
                })
            ]);
        });
        nextKey.current += 1;
        rippleCallback.current = cb;
    }, [
        classes
    ]);
    var start = $cQNHH.useCallback(function() {
        var event = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var cb = arguments.length > 2 ? arguments[2] : undefined;
        var _options$pulsate = options.pulsate, pulsate = _options$pulsate === void 0 ? false : _options$pulsate, _options$center = options.center, center = _options$center === void 0 ? centerProp || options.pulsate : _options$center, _options$fakeElement = options.fakeElement, fakeElement = _options$fakeElement === void 0 ? false : _options$fakeElement;
        if (event.type === "mousedown" && ignoringMouseDown.current) {
            ignoringMouseDown.current = false;
            return;
        }
        if (event.type === "touchstart") ignoringMouseDown.current = true;
        var element = fakeElement ? null : container.current;
        var rect = element ? element.getBoundingClientRect() : {
            width: 0,
            height: 0,
            left: 0,
            top: 0
        }; // Get the size of the ripple
        var rippleX;
        var rippleY;
        var rippleSize;
        if (center || event.clientX === 0 && event.clientY === 0 || !event.clientX && !event.touches) {
            rippleX = Math.round(rect.width / 2);
            rippleY = Math.round(rect.height / 2);
        } else {
            var _ref = event.touches ? event.touches[0] : event, clientX = _ref.clientX, clientY = _ref.clientY;
            rippleX = Math.round(clientX - rect.left);
            rippleY = Math.round(clientY - rect.top);
        }
        if (center) {
            rippleSize = Math.sqrt((2 * Math.pow(rect.width, 2) + Math.pow(rect.height, 2)) / 3); // For some reason the animation is broken on Mobile Chrome if the size if even.
            if (rippleSize % 2 === 0) rippleSize += 1;
        } else {
            var sizeX = Math.max(Math.abs((element ? element.clientWidth : 0) - rippleX), rippleX) * 2 + 2;
            var sizeY = Math.max(Math.abs((element ? element.clientHeight : 0) - rippleY), rippleY) * 2 + 2;
            rippleSize = Math.sqrt(Math.pow(sizeX, 2) + Math.pow(sizeY, 2));
        } // Touche devices
        if (event.touches) // check that this isn't another touchstart due to multitouch
        // otherwise we will only clear a single timer when unmounting while two
        // are running
        {
            if (startTimerCommit.current === null) {
                // Prepare the ripple effect.
                startTimerCommit.current = function() {
                    startCommit({
                        pulsate: pulsate,
                        rippleX: rippleX,
                        rippleY: rippleY,
                        rippleSize: rippleSize,
                        cb: cb
                    });
                }; // Delay the execution of the ripple effect.
                startTimer.current = setTimeout(function() {
                    if (startTimerCommit.current) {
                        startTimerCommit.current();
                        startTimerCommit.current = null;
                    }
                }, $d696f110982781b3$export$95d0c9356b2231a3); // We have to make a tradeoff with this value.
            }
        } else startCommit({
            pulsate: pulsate,
            rippleX: rippleX,
            rippleY: rippleY,
            rippleSize: rippleSize,
            cb: cb
        });
    }, [
        centerProp,
        startCommit
    ]);
    var pulsate = $cQNHH.useCallback(function() {
        start({}, {
            pulsate: true
        });
    }, [
        start
    ]);
    var stop = $cQNHH.useCallback(function(event, cb) {
        clearTimeout(startTimer.current); // The touch interaction occurs too quickly.
        // We still want to show ripple effect.
        if (event.type === "touchend" && startTimerCommit.current) {
            event.persist();
            startTimerCommit.current();
            startTimerCommit.current = null;
            startTimer.current = setTimeout(function() {
                stop(event, cb);
            });
            return;
        }
        startTimerCommit.current = null;
        setRipples(function(oldRipples) {
            if (oldRipples.length > 0) return oldRipples.slice(1);
            return oldRipples;
        });
        rippleCallback.current = cb;
    }, []);
    $cQNHH.useImperativeHandle(ref, function() {
        return {
            pulsate: pulsate,
            start: start,
            stop: stop
        };
    }, [
        pulsate,
        start,
        stop
    ]);
    return /*#__PURE__*/ $cQNHH.createElement("span", (0, $gtn2B.default)({
        className: (0, $bKF6r.default)(classes.root, className),
        ref: container
    }, other), /*#__PURE__*/ $cQNHH.createElement((0, $c4T9R.default), {
        component: null,
        exit: true
    }, ripples));
});
$d696f110982781b3$var$TouchRipple.propTypes = {
    /**
   * If `true`, the ripple starts at the center of the component
   * rather than at the point of interaction.
   */ center: (0, (/*@__PURE__*/$parcel$interopDefault($1xEYC))).bool,
    /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */ classes: (0, (/*@__PURE__*/$parcel$interopDefault($1xEYC))).object.isRequired,
    /**
   * @ignore
   */ className: (0, (/*@__PURE__*/$parcel$interopDefault($1xEYC))).string
};
var $d696f110982781b3$export$2e2bcd8739ae039 = (0, $eyd6T.default)($d696f110982781b3$export$9dd6ff9ea0189349, {
    flip: false,
    name: "MuiTouchRipple"
})(/*#__PURE__*/ $cQNHH.memo($d696f110982781b3$var$TouchRipple));

});
parcelRegister("6YeMW", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $014f4991f4d0f092$export$2e2bcd8739ae039; });

var $knZSh = parcelRequire("knZSh");

var $k5BsA = parcelRequire("k5BsA");

var $baMhu = parcelRequire("baMhu");

var $bnRQJ = parcelRequire("bnRQJ");
function $014f4991f4d0f092$export$2e2bcd8739ae039(arr) {
    return (0, $knZSh.default)(arr) || (0, $k5BsA.default)(arr) || (0, $baMhu.default)(arr) || (0, $bnRQJ.default)();
}

});
parcelRegister("knZSh", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ed75f39b613f9081$export$2e2bcd8739ae039; });

var $gpw9Q = parcelRequire("gpw9Q");
function $ed75f39b613f9081$export$2e2bcd8739ae039(arr) {
    if (Array.isArray(arr)) return (0, $gpw9Q.default)(arr);
}

});
parcelRegister("gpw9Q", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $bf27ed05ce04d7f9$export$2e2bcd8739ae039; });
function $bf27ed05ce04d7f9$export$2e2bcd8739ae039(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}

});


parcelRegister("k5BsA", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ea01551684783848$export$2e2bcd8739ae039; });
function $ea01551684783848$export$2e2bcd8739ae039(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}

});

parcelRegister("baMhu", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8226147f2fa55264$export$2e2bcd8739ae039; });

var $gpw9Q = parcelRequire("gpw9Q");
function $8226147f2fa55264$export$2e2bcd8739ae039(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return (0, $gpw9Q.default)(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return (0, $gpw9Q.default)(o, minLen);
}

});

parcelRegister("bnRQJ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $849b9d1829ec10aa$export$2e2bcd8739ae039; });
function $849b9d1829ec10aa$export$2e2bcd8739ae039() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

});


parcelRegister("c4T9R", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8cb0a4fa412dae56$export$2e2bcd8739ae039; });

var $6lOdG = parcelRequire("6lOdG");

var $i6zBg = parcelRequire("i6zBg");

var $b7QTH = parcelRequire("b7QTH");

var $8hqNG = parcelRequire("8hqNG");

var $1xEYC = parcelRequire("1xEYC");

var $cQNHH = parcelRequire("cQNHH");

var $bjgr0 = parcelRequire("bjgr0");

var $6ig0S = parcelRequire("6ig0S");
var $8cb0a4fa412dae56$var$values = Object.values || function(obj) {
    return Object.keys(obj).map(function(k) {
        return obj[k];
    });
};
var $8cb0a4fa412dae56$var$defaultProps = {
    component: "div",
    childFactory: function childFactory(child) {
        return child;
    }
};
/**
 * The `<TransitionGroup>` component manages a set of transition components
 * (`<Transition>` and `<CSSTransition>`) in a list. Like with the transition
 * components, `<TransitionGroup>` is a state machine for managing the mounting
 * and unmounting of components over time.
 *
 * Consider the example below. As items are removed or added to the TodoList the
 * `in` prop is toggled automatically by the `<TransitionGroup>`.
 *
 * Note that `<TransitionGroup>`  does not define any animation behavior!
 * Exactly _how_ a list item animates is up to the individual transition
 * component. This means you can mix and match animations across different list
 * items.
 */ var $8cb0a4fa412dae56$var$TransitionGroup = /*#__PURE__*/ function(_React$Component) {
    (0, $8hqNG.default)(TransitionGroup, _React$Component);
    function TransitionGroup(props, context) {
        var _this;
        _this = _React$Component.call(this, props, context) || this;
        var handleExited = _this.handleExited.bind((0, $b7QTH.default)(_this)); // Initial children should all be entering, dependent on appear
        _this.state = {
            contextValue: {
                isMounting: true
            },
            handleExited: handleExited,
            firstRender: true
        };
        return _this;
    }
    var _proto = TransitionGroup.prototype;
    _proto.componentDidMount = function componentDidMount() {
        this.mounted = true;
        this.setState({
            contextValue: {
                isMounting: false
            }
        });
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        this.mounted = false;
    };
    TransitionGroup.getDerivedStateFromProps = function getDerivedStateFromProps(nextProps, _ref) {
        var prevChildMapping = _ref.children, handleExited = _ref.handleExited, firstRender = _ref.firstRender;
        return {
            children: firstRender ? (0, $6ig0S.getInitialChildMapping)(nextProps, handleExited) : (0, $6ig0S.getNextChildMapping)(nextProps, prevChildMapping, handleExited),
            firstRender: false
        };
    } // node is `undefined` when user provided `nodeRef` prop
    ;
    _proto.handleExited = function handleExited(child, node) {
        var currentChildMapping = (0, $6ig0S.getChildMapping)(this.props.children);
        if (child.key in currentChildMapping) return;
        if (child.props.onExited) child.props.onExited(node);
        if (this.mounted) this.setState(function(state) {
            var children = (0, $i6zBg.default)({}, state.children);
            delete children[child.key];
            return {
                children: children
            };
        });
    };
    _proto.render = function render() {
        var _this$props = this.props, Component = _this$props.component, childFactory = _this$props.childFactory, props = (0, $6lOdG.default)(_this$props, [
            "component",
            "childFactory"
        ]);
        var contextValue = this.state.contextValue;
        var children = $8cb0a4fa412dae56$var$values(this.state.children).map(childFactory);
        delete props.appear;
        delete props.enter;
        delete props.exit;
        if (Component === null) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement((0, $bjgr0.default).Provider, {
            value: contextValue
        }, children);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement((0, $bjgr0.default).Provider, {
            value: contextValue
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement(Component, props, children));
    };
    return TransitionGroup;
}((0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).Component);
$8cb0a4fa412dae56$var$TransitionGroup.propTypes = {
    /**
   * `<TransitionGroup>` renders a `<div>` by default. You can change this
   * behavior by providing a `component` prop.
   * If you use React v16+ and would like to avoid a wrapping `<div>` element
   * you can pass in `component={null}`. This is useful if the wrapping div
   * borks your css styles.
   */ component: (0, (/*@__PURE__*/$parcel$interopDefault($1xEYC))).any,
    /**
   * A set of `<Transition>` components, that are toggled `in` and out as they
   * leave. the `<TransitionGroup>` will inject specific transition props, so
   * remember to spread them through if you are wrapping the `<Transition>` as
   * with our `<Fade>` example.
   *
   * While this component is meant for multiple `Transition` or `CSSTransition`
   * children, sometimes you may want to have a single transition child with
   * content that you want to be transitioned out and in when you change it
   * (e.g. routes, images etc.) In that case you can change the `key` prop of
   * the transition child as you change its content, this will cause
   * `TransitionGroup` to transition the child out and back in.
   */ children: (0, (/*@__PURE__*/$parcel$interopDefault($1xEYC))).node,
    /**
   * A convenience prop that enables or disables appear animations
   * for all children. Note that specifying this will override any defaults set
   * on individual children Transitions.
   */ appear: (0, (/*@__PURE__*/$parcel$interopDefault($1xEYC))).bool,
    /**
   * A convenience prop that enables or disables enter animations
   * for all children. Note that specifying this will override any defaults set
   * on individual children Transitions.
   */ enter: (0, (/*@__PURE__*/$parcel$interopDefault($1xEYC))).bool,
    /**
   * A convenience prop that enables or disables exit animations
   * for all children. Note that specifying this will override any defaults set
   * on individual children Transitions.
   */ exit: (0, (/*@__PURE__*/$parcel$interopDefault($1xEYC))).bool,
    /**
   * You may need to apply reactive updates to a child as it is exiting.
   * This is generally done by using `cloneElement` however in the case of an exiting
   * child the element has already been removed and not accessible to the consumer.
   *
   * If you do need to update a child as it leaves you can provide a `childFactory`
   * to wrap every child, even the ones that are leaving.
   *
   * @type Function(child: ReactElement) -> ReactElement
   */ childFactory: (0, (/*@__PURE__*/$parcel$interopDefault($1xEYC))).func
};
$8cb0a4fa412dae56$var$TransitionGroup.defaultProps = $8cb0a4fa412dae56$var$defaultProps;
var $8cb0a4fa412dae56$export$2e2bcd8739ae039 = $8cb0a4fa412dae56$var$TransitionGroup;

});
parcelRegister("6lOdG", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $49fba8cdda0d58ac$export$2e2bcd8739ae039; });
function $49fba8cdda0d58ac$export$2e2bcd8739ae039(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}

});

parcelRegister("i6zBg", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d2e466f1eaa47316$export$2e2bcd8739ae039; });
function $d2e466f1eaa47316$export$2e2bcd8739ae039() {
    $d2e466f1eaa47316$export$2e2bcd8739ae039 = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $d2e466f1eaa47316$export$2e2bcd8739ae039.apply(this, arguments);
}

});

parcelRegister("b7QTH", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8199617eadd0ac5d$export$2e2bcd8739ae039; });
function $8199617eadd0ac5d$export$2e2bcd8739ae039(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}

});

parcelRegister("8hqNG", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6074b33ab09718d9$export$2e2bcd8739ae039; });
function $6074b33ab09718d9$export$2e2bcd8739ae039(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    subClass.__proto__ = superClass;
}

});

parcelRegister("bjgr0", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $83be37a334a682ab$export$2e2bcd8739ae039; });

var $cQNHH = parcelRequire("cQNHH");
var $83be37a334a682ab$export$2e2bcd8739ae039 = (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createContext(null);

});

parcelRegister("6ig0S", function(module, exports) {

$parcel$export(module.exports, "getChildMapping", function () { return $4950d85fc708fe19$export$bbc8a025727ea824; });
$parcel$export(module.exports, "getInitialChildMapping", function () { return $4950d85fc708fe19$export$fa71e2345c31d7a2; });
$parcel$export(module.exports, "getNextChildMapping", function () { return $4950d85fc708fe19$export$36fd1af28d383ec0; });

var $cQNHH = parcelRequire("cQNHH");
function $4950d85fc708fe19$export$bbc8a025727ea824(children, mapFn) {
    var mapper = function mapper(child) {
        return mapFn && (0, $cQNHH.isValidElement)(child) ? mapFn(child) : child;
    };
    var result = Object.create(null);
    if (children) (0, $cQNHH.Children).map(children, function(c) {
        return c;
    }).forEach(function(child) {
        // run the map function here instead so that the key is the computed one
        result[child.key] = mapper(child);
    });
    return result;
}
function $4950d85fc708fe19$export$7a874f95ccf533dd(prev, next) {
    prev = prev || {};
    next = next || {};
    function getValueForKey(key) {
        return key in next ? next[key] : prev[key];
    } // For each key of `next`, the list of keys to insert before that key in
    // the combined list
    var nextKeysPending = Object.create(null);
    var pendingKeys = [];
    for(var prevKey in prev){
        if (prevKey in next) {
            if (pendingKeys.length) {
                nextKeysPending[prevKey] = pendingKeys;
                pendingKeys = [];
            }
        } else pendingKeys.push(prevKey);
    }
    var i;
    var childMapping = {};
    for(var nextKey in next){
        if (nextKeysPending[nextKey]) for(i = 0; i < nextKeysPending[nextKey].length; i++){
            var pendingNextKey = nextKeysPending[nextKey][i];
            childMapping[nextKeysPending[nextKey][i]] = getValueForKey(pendingNextKey);
        }
        childMapping[nextKey] = getValueForKey(nextKey);
    } // Finally, add the keys which didn't appear before any key in `next`
    for(i = 0; i < pendingKeys.length; i++)childMapping[pendingKeys[i]] = getValueForKey(pendingKeys[i]);
    return childMapping;
}
function $4950d85fc708fe19$var$getProp(child, prop, props) {
    return props[prop] != null ? props[prop] : child.props[prop];
}
function $4950d85fc708fe19$export$fa71e2345c31d7a2(props, onExited) {
    return $4950d85fc708fe19$export$bbc8a025727ea824(props.children, function(child) {
        return (0, $cQNHH.cloneElement)(child, {
            onExited: onExited.bind(null, child),
            in: true,
            appear: $4950d85fc708fe19$var$getProp(child, "appear", props),
            enter: $4950d85fc708fe19$var$getProp(child, "enter", props),
            exit: $4950d85fc708fe19$var$getProp(child, "exit", props)
        });
    });
}
function $4950d85fc708fe19$export$36fd1af28d383ec0(nextProps, prevChildMapping, onExited) {
    var nextChildMapping = $4950d85fc708fe19$export$bbc8a025727ea824(nextProps.children);
    var children = $4950d85fc708fe19$export$7a874f95ccf533dd(prevChildMapping, nextChildMapping);
    Object.keys(children).forEach(function(key) {
        var child = children[key];
        if (!(0, $cQNHH.isValidElement)(child)) return;
        var hasPrev = key in prevChildMapping;
        var hasNext = key in nextChildMapping;
        var prevChild = prevChildMapping[key];
        var isLeaving = (0, $cQNHH.isValidElement)(prevChild) && !prevChild.props.in; // item is new (entering)
        if (hasNext && (!hasPrev || isLeaving)) // console.log('entering', key)
        children[key] = (0, $cQNHH.cloneElement)(child, {
            onExited: onExited.bind(null, child),
            in: true,
            exit: $4950d85fc708fe19$var$getProp(child, "exit", nextProps),
            enter: $4950d85fc708fe19$var$getProp(child, "enter", nextProps)
        });
        else if (!hasNext && hasPrev && !isLeaving) // item is old (exiting)
        // console.log('leaving', key)
        children[key] = (0, $cQNHH.cloneElement)(child, {
            in: false
        });
        else if (hasNext && hasPrev && (0, $cQNHH.isValidElement)(prevChild)) // item hasn't changed transition states
        // copy over the last transition props;
        // console.log('unchanged', key)
        children[key] = (0, $cQNHH.cloneElement)(child, {
            onExited: onExited.bind(null, child),
            in: prevChild.props.in,
            exit: $4950d85fc708fe19$var$getProp(child, "exit", nextProps),
            enter: $4950d85fc708fe19$var$getProp(child, "enter", nextProps)
        });
    });
    return children;
}

});


parcelRegister("2tdAk", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1cc8d3df6a1dfa78$export$2e2bcd8739ae039; });

var $cQNHH = parcelRequire("cQNHH");

var $1xEYC = parcelRequire("1xEYC");

var $bKF6r = parcelRequire("bKF6r");

var $3uSqW = parcelRequire("3uSqW");
var $1cc8d3df6a1dfa78$var$useEnhancedEffect = typeof window === "undefined" ? $cQNHH.useEffect : $cQNHH.useLayoutEffect;
/**
 * @ignore - internal component.
 */ function $1cc8d3df6a1dfa78$var$Ripple(props) {
    var classes = props.classes, _props$pulsate = props.pulsate, pulsate = _props$pulsate === void 0 ? false : _props$pulsate, rippleX = props.rippleX, rippleY = props.rippleY, rippleSize = props.rippleSize, inProp = props.in, _props$onExited = props.onExited, onExited = _props$onExited === void 0 ? function() {} : _props$onExited, timeout = props.timeout;
    var _React$useState = $cQNHH.useState(false), leaving = _React$useState[0], setLeaving = _React$useState[1];
    var rippleClassName = (0, $bKF6r.default)(classes.ripple, classes.rippleVisible, pulsate && classes.ripplePulsate);
    var rippleStyles = {
        width: rippleSize,
        height: rippleSize,
        top: -(rippleSize / 2) + rippleY,
        left: -(rippleSize / 2) + rippleX
    };
    var childClassName = (0, $bKF6r.default)(classes.child, leaving && classes.childLeaving, pulsate && classes.childPulsate);
    var handleExited = (0, $3uSqW.default)(onExited); // Ripple is used for user feedback (e.g. click or press) so we want to apply styles with the highest priority
    $1cc8d3df6a1dfa78$var$useEnhancedEffect(function() {
        if (!inProp) {
            // react-transition-group#onExit
            setLeaving(true); // react-transition-group#onExited
            var timeoutId = setTimeout(handleExited, timeout);
            return function() {
                clearTimeout(timeoutId);
            };
        }
        return undefined;
    }, [
        handleExited,
        inProp,
        timeout
    ]);
    return /*#__PURE__*/ $cQNHH.createElement("span", {
        className: rippleClassName,
        style: rippleStyles
    }, /*#__PURE__*/ $cQNHH.createElement("span", {
        className: childClassName
    }));
}
$1cc8d3df6a1dfa78$var$Ripple.propTypes = {
    /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */ classes: (0, (/*@__PURE__*/$parcel$interopDefault($1xEYC))).object.isRequired,
    /**
   * @ignore - injected from TransitionGroup
   */ in: (0, (/*@__PURE__*/$parcel$interopDefault($1xEYC))).bool,
    /**
   * @ignore - injected from TransitionGroup
   */ onExited: (0, (/*@__PURE__*/$parcel$interopDefault($1xEYC))).func,
    /**
   * If `true`, the ripple pulsates, typically indicating the keyboard focus state of an element.
   */ pulsate: (0, (/*@__PURE__*/$parcel$interopDefault($1xEYC))).bool,
    /**
   * Diameter of the ripple.
   */ rippleSize: (0, (/*@__PURE__*/$parcel$interopDefault($1xEYC))).number,
    /**
   * Horizontal position of the ripple center.
   */ rippleX: (0, (/*@__PURE__*/$parcel$interopDefault($1xEYC))).number,
    /**
   * Vertical position of the ripple center.
   */ rippleY: (0, (/*@__PURE__*/$parcel$interopDefault($1xEYC))).number,
    /**
   * exit delay
   */ timeout: (0, (/*@__PURE__*/$parcel$interopDefault($1xEYC))).number.isRequired
};
var $1cc8d3df6a1dfa78$export$2e2bcd8739ae039 = $1cc8d3df6a1dfa78$var$Ripple;

});




parcelRegister("kV13H", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f3a9f3bdcc3e49ef$export$2e2bcd8739ae039; });
/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */ 
var $gb4K1 = parcelRequire("gb4K1");

var $cQNHH = parcelRequire("cQNHH");

var $4uhmr = parcelRequire("4uhmr");

var $2KDk6 = parcelRequire("2KDk6");
function $f3a9f3bdcc3e49ef$var$areEqual(prevProps, nextProps) {
    var values = prevProps.values, otherProps = (0, $gb4K1.__rest)(prevProps, [
        "values"
    ]);
    var nextValues = nextProps.values, nextOtherProps = (0, $gb4K1.__rest)(nextProps, [
        "values"
    ]);
    return (0, $2KDk6.shallowEqual)(nextValues, values) && (0, $2KDk6.shallowEqual)(otherProps, nextOtherProps);
}
function $f3a9f3bdcc3e49ef$var$FormattedMessage(props) {
    var intl = (0, $4uhmr.default)();
    var formatMessage = intl.formatMessage, _a = intl.textComponent, Text = _a === void 0 ? $cQNHH.Fragment : _a;
    var id = props.id, description = props.description, defaultMessage = props.defaultMessage, values = props.values, children = props.children, _b = props.tagName, Component = _b === void 0 ? Text : _b, ignoreTag = props.ignoreTag;
    var descriptor = {
        id: id,
        description: description,
        defaultMessage: defaultMessage
    };
    var nodes = formatMessage(descriptor, values, {
        ignoreTag: ignoreTag
    });
    if (typeof children === "function") return children(Array.isArray(nodes) ? nodes : [
        nodes
    ]);
    if (Component) return $cQNHH.createElement(Component, null, $cQNHH.Children.toArray(nodes));
    return $cQNHH.createElement($cQNHH.Fragment, null, nodes);
}
$f3a9f3bdcc3e49ef$var$FormattedMessage.displayName = "FormattedMessage";
var $f3a9f3bdcc3e49ef$var$MemoizedFormattedMessage = $cQNHH.memo($f3a9f3bdcc3e49ef$var$FormattedMessage, $f3a9f3bdcc3e49ef$var$areEqual);
$f3a9f3bdcc3e49ef$var$MemoizedFormattedMessage.displayName = "MemoizedFormattedMessage";
var $f3a9f3bdcc3e49ef$export$2e2bcd8739ae039 = $f3a9f3bdcc3e49ef$var$MemoizedFormattedMessage;

});
parcelRegister("4uhmr", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $34476e4abdeb83b0$export$2e2bcd8739ae039; });

var $cQNHH = parcelRequire("cQNHH");

var $szrnD = parcelRequire("szrnD");

var $2KDk6 = parcelRequire("2KDk6");
function $34476e4abdeb83b0$export$2e2bcd8739ae039() {
    var intl = $cQNHH.useContext((0, $szrnD.Context));
    (0, $2KDk6.invariantIntlContext)(intl);
    return intl;
}

});


parcelRegister("1YSJM", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1715dab906eefb27$export$2e2bcd8739ae039; });

var $cQNHH = parcelRequire("cQNHH");
function $1715dab906eefb27$export$2e2bcd8739ae039({ noFocus: noFocus, ref: outsideRef } = {}) {
    const [refState, setRefState] = (0, $cQNHH.useState)(null);
    const setRef = (ref)=>{
        setRefState(ref);
        if (typeof outsideRef === "function") outsideRef(ref);
        else if (typeof outsideRef === "object") // eslint-disable-next-line no-param-reassign
        outsideRef.current = ref;
    };
    (0, $cQNHH.useEffect)(()=>{
        if (!refState || noFocus) return;
        refState.focus();
    }, [
        refState
    ]);
    return {
        ref: setRef,
        tabIndex: "-1",
        style: {
            outline: "none"
        }
    };
}

});

parcelRegister("jge0r", function(module, exports) {

$parcel$export(module.exports, "userMetrics", function () { return $e05a604081b2ade4$export$914b7abbe5f6a98d; });
/* eslint-disable import/prefer-default-export */ 
var $eAAXH = parcelRequire("eAAXH");
// The value should either be replaced as late as possible for production builds
// or, during development, using environment variables (.env or docker env)
const $e05a604081b2ade4$var$MIXPANEL_TOKEN = "____MIXPANEL_TOKEN____";
// We decide if we should log to console or to MixPanel based on if token was configured
const $e05a604081b2ade4$var$isMixPanelConfigured = !$e05a604081b2ade4$var$MIXPANEL_TOKEN.includes("____");
if (!$e05a604081b2ade4$var$isMixPanelConfigured) console.warn("\uD83C\uDF6F Development mode: Environment variable MIXPANEL_TOKEN is not defined/replaced.");
(0, (/*@__PURE__*/$parcel$interopDefault($eAAXH))).init($e05a604081b2ade4$var$MIXPANEL_TOKEN);
const $e05a604081b2ade4$export$914b7abbe5f6a98d = {
    identify: (id)=>{
        if ($e05a604081b2ade4$var$isMixPanelConfigured) (0, (/*@__PURE__*/$parcel$interopDefault($eAAXH))).identify(id);
        else console.log("Mixpanel - identify:", id);
    },
    alias: (id)=>{
        if ($e05a604081b2ade4$var$isMixPanelConfigured) (0, (/*@__PURE__*/$parcel$interopDefault($eAAXH))).alias(id);
        else console.log("Mixpanel - alias:", id);
    },
    track: (name, props)=>{
        if ($e05a604081b2ade4$var$isMixPanelConfigured) (0, (/*@__PURE__*/$parcel$interopDefault($eAAXH))).track(name, props);
        else console.log("Mixpanel - track:", name, props);
    },
    people: {
        set: (props)=>{
            if ($e05a604081b2ade4$var$isMixPanelConfigured) (0, (/*@__PURE__*/$parcel$interopDefault($eAAXH))).people.set(props);
            else console.log("Mixpanel - people:", props);
        }
    },
    register: (props)=>{
        if ($e05a604081b2ade4$var$isMixPanelConfigured) (0, (/*@__PURE__*/$parcel$interopDefault($eAAXH))).register(props);
        else console.log("Mixpanel - register:", props);
    },
    register_once: (props)=>{
        if ($e05a604081b2ade4$var$isMixPanelConfigured) (0, (/*@__PURE__*/$parcel$interopDefault($eAAXH))).register_once(props);
        else console.log("Mixpanel - register once:", props);
    }
};

});
parcelRegister("eAAXH", function(module, exports) {
"use strict";
var $a9f1195cdd0a4fb0$var$Config = {
    DEBUG: false,
    LIB_VERSION: "2.45.0"
};
// since es6 imports are static and we run unit tests from the console, window won't be defined when importing this file
var $a9f1195cdd0a4fb0$var$window$1;
if (typeof window === "undefined") {
    var $a9f1195cdd0a4fb0$var$loc = {
        hostname: ""
    };
    $a9f1195cdd0a4fb0$var$window$1 = {
        navigator: {
            userAgent: ""
        },
        document: {
            location: $a9f1195cdd0a4fb0$var$loc,
            referrer: ""
        },
        screen: {
            width: 0,
            height: 0
        },
        location: $a9f1195cdd0a4fb0$var$loc
    };
} else $a9f1195cdd0a4fb0$var$window$1 = window;
/*
 * Saved references to long variable names, so that closure compiler can
 * minimize file size.
 */ var $a9f1195cdd0a4fb0$var$ArrayProto = Array.prototype;
var $a9f1195cdd0a4fb0$var$FuncProto = Function.prototype;
var $a9f1195cdd0a4fb0$var$ObjProto = Object.prototype;
var $a9f1195cdd0a4fb0$var$slice = $a9f1195cdd0a4fb0$var$ArrayProto.slice;
var $a9f1195cdd0a4fb0$var$toString = $a9f1195cdd0a4fb0$var$ObjProto.toString;
var $a9f1195cdd0a4fb0$var$hasOwnProperty = $a9f1195cdd0a4fb0$var$ObjProto.hasOwnProperty;
var $a9f1195cdd0a4fb0$var$windowConsole = $a9f1195cdd0a4fb0$var$window$1.console;
var $a9f1195cdd0a4fb0$var$navigator = $a9f1195cdd0a4fb0$var$window$1.navigator;
var $a9f1195cdd0a4fb0$var$document$1 = $a9f1195cdd0a4fb0$var$window$1.document;
var $a9f1195cdd0a4fb0$var$windowOpera = $a9f1195cdd0a4fb0$var$window$1.opera;
var $a9f1195cdd0a4fb0$var$screen = $a9f1195cdd0a4fb0$var$window$1.screen;
var $a9f1195cdd0a4fb0$var$userAgent = $a9f1195cdd0a4fb0$var$navigator.userAgent;
var $a9f1195cdd0a4fb0$var$nativeBind = $a9f1195cdd0a4fb0$var$FuncProto.bind;
var $a9f1195cdd0a4fb0$var$nativeForEach = $a9f1195cdd0a4fb0$var$ArrayProto.forEach;
var $a9f1195cdd0a4fb0$var$nativeIndexOf = $a9f1195cdd0a4fb0$var$ArrayProto.indexOf;
var $a9f1195cdd0a4fb0$var$nativeMap = $a9f1195cdd0a4fb0$var$ArrayProto.map;
var $a9f1195cdd0a4fb0$var$nativeIsArray = Array.isArray;
var $a9f1195cdd0a4fb0$var$breaker = {};
var $a9f1195cdd0a4fb0$var$_ = {
    trim: function(str) {
        // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/Trim#Polyfill
        return str.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, "");
    }
};
// Console override
var $a9f1195cdd0a4fb0$var$console = {
    /** @type {function(...*)} */ log: function() {
        if ($a9f1195cdd0a4fb0$var$Config.DEBUG && !$a9f1195cdd0a4fb0$var$_.isUndefined($a9f1195cdd0a4fb0$var$windowConsole) && $a9f1195cdd0a4fb0$var$windowConsole) try {
            $a9f1195cdd0a4fb0$var$windowConsole.log.apply($a9f1195cdd0a4fb0$var$windowConsole, arguments);
        } catch (err) {
            $a9f1195cdd0a4fb0$var$_.each(arguments, function(arg) {
                $a9f1195cdd0a4fb0$var$windowConsole.log(arg);
            });
        }
    },
    /** @type {function(...*)} */ warn: function() {
        if ($a9f1195cdd0a4fb0$var$Config.DEBUG && !$a9f1195cdd0a4fb0$var$_.isUndefined($a9f1195cdd0a4fb0$var$windowConsole) && $a9f1195cdd0a4fb0$var$windowConsole) {
            var args = [
                "Mixpanel warning:"
            ].concat($a9f1195cdd0a4fb0$var$_.toArray(arguments));
            try {
                $a9f1195cdd0a4fb0$var$windowConsole.warn.apply($a9f1195cdd0a4fb0$var$windowConsole, args);
            } catch (err) {
                $a9f1195cdd0a4fb0$var$_.each(args, function(arg) {
                    $a9f1195cdd0a4fb0$var$windowConsole.warn(arg);
                });
            }
        }
    },
    /** @type {function(...*)} */ error: function() {
        if ($a9f1195cdd0a4fb0$var$Config.DEBUG && !$a9f1195cdd0a4fb0$var$_.isUndefined($a9f1195cdd0a4fb0$var$windowConsole) && $a9f1195cdd0a4fb0$var$windowConsole) {
            var args = [
                "Mixpanel error:"
            ].concat($a9f1195cdd0a4fb0$var$_.toArray(arguments));
            try {
                $a9f1195cdd0a4fb0$var$windowConsole.error.apply($a9f1195cdd0a4fb0$var$windowConsole, args);
            } catch (err) {
                $a9f1195cdd0a4fb0$var$_.each(args, function(arg) {
                    $a9f1195cdd0a4fb0$var$windowConsole.error(arg);
                });
            }
        }
    },
    /** @type {function(...*)} */ critical: function() {
        if (!$a9f1195cdd0a4fb0$var$_.isUndefined($a9f1195cdd0a4fb0$var$windowConsole) && $a9f1195cdd0a4fb0$var$windowConsole) {
            var args = [
                "Mixpanel error:"
            ].concat($a9f1195cdd0a4fb0$var$_.toArray(arguments));
            try {
                $a9f1195cdd0a4fb0$var$windowConsole.error.apply($a9f1195cdd0a4fb0$var$windowConsole, args);
            } catch (err) {
                $a9f1195cdd0a4fb0$var$_.each(args, function(arg) {
                    $a9f1195cdd0a4fb0$var$windowConsole.error(arg);
                });
            }
        }
    }
};
var $a9f1195cdd0a4fb0$var$log_func_with_prefix = function(func, prefix) {
    return function() {
        arguments[0] = "[" + prefix + "] " + arguments[0];
        return func.apply($a9f1195cdd0a4fb0$var$console, arguments);
    };
};
var $a9f1195cdd0a4fb0$var$console_with_prefix = function(prefix) {
    return {
        log: $a9f1195cdd0a4fb0$var$log_func_with_prefix($a9f1195cdd0a4fb0$var$console.log, prefix),
        error: $a9f1195cdd0a4fb0$var$log_func_with_prefix($a9f1195cdd0a4fb0$var$console.error, prefix),
        critical: $a9f1195cdd0a4fb0$var$log_func_with_prefix($a9f1195cdd0a4fb0$var$console.critical, prefix)
    };
};
// UNDERSCORE
// Embed part of the Underscore Library
$a9f1195cdd0a4fb0$var$_.bind = function(func, context) {
    var args, bound;
    if ($a9f1195cdd0a4fb0$var$nativeBind && func.bind === $a9f1195cdd0a4fb0$var$nativeBind) return $a9f1195cdd0a4fb0$var$nativeBind.apply(func, $a9f1195cdd0a4fb0$var$slice.call(arguments, 1));
    if (!$a9f1195cdd0a4fb0$var$_.isFunction(func)) throw new TypeError();
    args = $a9f1195cdd0a4fb0$var$slice.call(arguments, 2);
    bound = function() {
        if (!(this instanceof bound)) return func.apply(context, args.concat($a9f1195cdd0a4fb0$var$slice.call(arguments)));
        var ctor = {};
        ctor.prototype = func.prototype;
        var self = new ctor();
        ctor.prototype = null;
        var result = func.apply(self, args.concat($a9f1195cdd0a4fb0$var$slice.call(arguments)));
        if (Object(result) === result) return result;
        return self;
    };
    return bound;
};
/**
 * @param {*=} obj
 * @param {function(...*)=} iterator
 * @param {Object=} context
 */ $a9f1195cdd0a4fb0$var$_.each = function(obj, iterator, context) {
    if (obj === null || obj === undefined) return;
    if ($a9f1195cdd0a4fb0$var$nativeForEach && obj.forEach === $a9f1195cdd0a4fb0$var$nativeForEach) obj.forEach(iterator, context);
    else if (obj.length === +obj.length) for(var i = 0, l = obj.length; i < l; i++){
        if (i in obj && iterator.call(context, obj[i], i, obj) === $a9f1195cdd0a4fb0$var$breaker) return;
    }
    else {
        for(var key in obj)if ($a9f1195cdd0a4fb0$var$hasOwnProperty.call(obj, key)) {
            if (iterator.call(context, obj[key], key, obj) === $a9f1195cdd0a4fb0$var$breaker) return;
        }
    }
};
$a9f1195cdd0a4fb0$var$_.extend = function(obj) {
    $a9f1195cdd0a4fb0$var$_.each($a9f1195cdd0a4fb0$var$slice.call(arguments, 1), function(source) {
        for(var prop in source)if (source[prop] !== void 0) obj[prop] = source[prop];
    });
    return obj;
};
$a9f1195cdd0a4fb0$var$_.isArray = $a9f1195cdd0a4fb0$var$nativeIsArray || function(obj) {
    return $a9f1195cdd0a4fb0$var$toString.call(obj) === "[object Array]";
};
// from a comment on http://dbj.org/dbj/?p=286
// fails on only one very rare and deliberate custom object:
// var bomb = { toString : undefined, valueOf: function(o) { return "function BOMBA!"; }};
$a9f1195cdd0a4fb0$var$_.isFunction = function(f) {
    try {
        return /^\s*\bfunction\b/.test(f);
    } catch (x) {
        return false;
    }
};
$a9f1195cdd0a4fb0$var$_.isArguments = function(obj) {
    return !!(obj && $a9f1195cdd0a4fb0$var$hasOwnProperty.call(obj, "callee"));
};
$a9f1195cdd0a4fb0$var$_.toArray = function(iterable) {
    if (!iterable) return [];
    if (iterable.toArray) return iterable.toArray();
    if ($a9f1195cdd0a4fb0$var$_.isArray(iterable)) return $a9f1195cdd0a4fb0$var$slice.call(iterable);
    if ($a9f1195cdd0a4fb0$var$_.isArguments(iterable)) return $a9f1195cdd0a4fb0$var$slice.call(iterable);
    return $a9f1195cdd0a4fb0$var$_.values(iterable);
};
$a9f1195cdd0a4fb0$var$_.map = function(arr, callback, context) {
    if ($a9f1195cdd0a4fb0$var$nativeMap && arr.map === $a9f1195cdd0a4fb0$var$nativeMap) return arr.map(callback, context);
    else {
        var results = [];
        $a9f1195cdd0a4fb0$var$_.each(arr, function(item) {
            results.push(callback.call(context, item));
        });
        return results;
    }
};
$a9f1195cdd0a4fb0$var$_.keys = function(obj) {
    var results = [];
    if (obj === null) return results;
    $a9f1195cdd0a4fb0$var$_.each(obj, function(value, key) {
        results[results.length] = key;
    });
    return results;
};
$a9f1195cdd0a4fb0$var$_.values = function(obj) {
    var results = [];
    if (obj === null) return results;
    $a9f1195cdd0a4fb0$var$_.each(obj, function(value) {
        results[results.length] = value;
    });
    return results;
};
$a9f1195cdd0a4fb0$var$_.include = function(obj, target) {
    var found = false;
    if (obj === null) return found;
    if ($a9f1195cdd0a4fb0$var$nativeIndexOf && obj.indexOf === $a9f1195cdd0a4fb0$var$nativeIndexOf) return obj.indexOf(target) != -1;
    $a9f1195cdd0a4fb0$var$_.each(obj, function(value) {
        if (found || (found = value === target)) return $a9f1195cdd0a4fb0$var$breaker;
    });
    return found;
};
$a9f1195cdd0a4fb0$var$_.includes = function(str, needle) {
    return str.indexOf(needle) !== -1;
};
// Underscore Addons
$a9f1195cdd0a4fb0$var$_.inherit = function(subclass, superclass) {
    subclass.prototype = new superclass();
    subclass.prototype.constructor = subclass;
    subclass.superclass = superclass.prototype;
    return subclass;
};
$a9f1195cdd0a4fb0$var$_.isObject = function(obj) {
    return obj === Object(obj) && !$a9f1195cdd0a4fb0$var$_.isArray(obj);
};
$a9f1195cdd0a4fb0$var$_.isEmptyObject = function(obj) {
    if ($a9f1195cdd0a4fb0$var$_.isObject(obj)) {
        for(var key in obj){
            if ($a9f1195cdd0a4fb0$var$hasOwnProperty.call(obj, key)) return false;
        }
        return true;
    }
    return false;
};
$a9f1195cdd0a4fb0$var$_.isUndefined = function(obj) {
    return obj === void 0;
};
$a9f1195cdd0a4fb0$var$_.isString = function(obj) {
    return $a9f1195cdd0a4fb0$var$toString.call(obj) == "[object String]";
};
$a9f1195cdd0a4fb0$var$_.isDate = function(obj) {
    return $a9f1195cdd0a4fb0$var$toString.call(obj) == "[object Date]";
};
$a9f1195cdd0a4fb0$var$_.isNumber = function(obj) {
    return $a9f1195cdd0a4fb0$var$toString.call(obj) == "[object Number]";
};
$a9f1195cdd0a4fb0$var$_.isElement = function(obj) {
    return !!(obj && obj.nodeType === 1);
};
$a9f1195cdd0a4fb0$var$_.encodeDates = function(obj) {
    $a9f1195cdd0a4fb0$var$_.each(obj, function(v, k) {
        if ($a9f1195cdd0a4fb0$var$_.isDate(v)) obj[k] = $a9f1195cdd0a4fb0$var$_.formatDate(v);
        else if ($a9f1195cdd0a4fb0$var$_.isObject(v)) obj[k] = $a9f1195cdd0a4fb0$var$_.encodeDates(v); // recurse
    });
    return obj;
};
$a9f1195cdd0a4fb0$var$_.timestamp = function() {
    Date.now = Date.now || function() {
        return +new Date;
    };
    return Date.now();
};
$a9f1195cdd0a4fb0$var$_.formatDate = function(d) {
    // YYYY-MM-DDTHH:MM:SS in UTC
    function pad(n) {
        return n < 10 ? "0" + n : n;
    }
    return d.getUTCFullYear() + "-" + pad(d.getUTCMonth() + 1) + "-" + pad(d.getUTCDate()) + "T" + pad(d.getUTCHours()) + ":" + pad(d.getUTCMinutes()) + ":" + pad(d.getUTCSeconds());
};
$a9f1195cdd0a4fb0$var$_.strip_empty_properties = function(p) {
    var ret = {};
    $a9f1195cdd0a4fb0$var$_.each(p, function(v, k) {
        if ($a9f1195cdd0a4fb0$var$_.isString(v) && v.length > 0) ret[k] = v;
    });
    return ret;
};
/*
 * this function returns a copy of object after truncating it.  If
 * passed an Array or Object it will iterate through obj and
 * truncate all the values recursively.
 */ $a9f1195cdd0a4fb0$var$_.truncate = function(obj, length) {
    var ret;
    if (typeof obj === "string") ret = obj.slice(0, length);
    else if ($a9f1195cdd0a4fb0$var$_.isArray(obj)) {
        ret = [];
        $a9f1195cdd0a4fb0$var$_.each(obj, function(val) {
            ret.push($a9f1195cdd0a4fb0$var$_.truncate(val, length));
        });
    } else if ($a9f1195cdd0a4fb0$var$_.isObject(obj)) {
        ret = {};
        $a9f1195cdd0a4fb0$var$_.each(obj, function(val, key) {
            ret[key] = $a9f1195cdd0a4fb0$var$_.truncate(val, length);
        });
    } else ret = obj;
    return ret;
};
$a9f1195cdd0a4fb0$var$_.JSONEncode = function() {
    return function(mixed_val) {
        var value = mixed_val;
        var quote = function(string) {
            var escapable = /[\\"\x00-\x1f\x7f-\x9f\u00ad\u0600-\u0604\u070f\u17b4\u17b5\u200c-\u200f\u2028-\u202f\u2060-\u206f\ufeff\ufff0-\uffff]/g; // eslint-disable-line no-control-regex
            var meta = {
                "\b": "\\b",
                "	": "\\t",
                "\n": "\\n",
                "\f": "\\f",
                "\r": "\\r",
                '"': '\\"',
                "\\": "\\\\"
            };
            escapable.lastIndex = 0;
            return escapable.test(string) ? '"' + string.replace(escapable, function(a) {
                var c = meta[a];
                return typeof c === "string" ? c : "\\u" + ("0000" + a.charCodeAt(0).toString(16)).slice(-4);
            }) + '"' : '"' + string + '"';
        };
        var str = function(key, holder) {
            var gap = "";
            var indent = "    ";
            var i = 0; // The loop counter.
            var k = ""; // The member key.
            var v = ""; // The member value.
            var length = 0;
            var mind = gap;
            var partial = [];
            var value = holder[key];
            // If the value has a toJSON method, call it to obtain a replacement value.
            if (value && typeof value === "object" && typeof value.toJSON === "function") value = value.toJSON(key);
            // What happens next depends on the value's type.
            switch(typeof value){
                case "string":
                    return quote(value);
                case "number":
                    // JSON numbers must be finite. Encode non-finite numbers as null.
                    return isFinite(value) ? String(value) : "null";
                case "boolean":
                case "null":
                    // If the value is a boolean or null, convert it to a string. Note:
                    // typeof null does not produce 'null'. The case is included here in
                    // the remote chance that this gets fixed someday.
                    return String(value);
                case "object":
                    // If the type is 'object', we might be dealing with an object or an array or
                    // null.
                    // Due to a specification blunder in ECMAScript, typeof null is 'object',
                    // so watch out for that case.
                    if (!value) return "null";
                    // Make an array to hold the partial results of stringifying this object value.
                    gap += indent;
                    partial = [];
                    // Is the value an array?
                    if ($a9f1195cdd0a4fb0$var$toString.apply(value) === "[object Array]") {
                        // The value is an array. Stringify every element. Use null as a placeholder
                        // for non-JSON values.
                        length = value.length;
                        for(i = 0; i < length; i += 1)partial[i] = str(i, value) || "null";
                        // Join all of the elements together, separated with commas, and wrap them in
                        // brackets.
                        v = partial.length === 0 ? "[]" : gap ? "[\n" + gap + partial.join(",\n" + gap) + "\n" + mind + "]" : "[" + partial.join(",") + "]";
                        gap = mind;
                        return v;
                    }
                    // Iterate through all of the keys in the object.
                    for(k in value)if ($a9f1195cdd0a4fb0$var$hasOwnProperty.call(value, k)) {
                        v = str(k, value);
                        if (v) partial.push(quote(k) + (gap ? ": " : ":") + v);
                    }
                    // Join all of the member texts together, separated with commas,
                    // and wrap them in braces.
                    v = partial.length === 0 ? "{}" : gap ? "{" + partial.join(",") + "" + mind + "}" : "{" + partial.join(",") + "}";
                    gap = mind;
                    return v;
            }
        };
        // Make a fake root object containing our value under the key of ''.
        // Return the result of stringifying the value.
        return str("", {
            "": value
        });
    };
}();
/**
 * From https://github.com/douglascrockford/JSON-js/blob/master/json_parse.js
 * Slightly modified to throw a real Error rather than a POJO
 */ $a9f1195cdd0a4fb0$var$_.JSONDecode = function() {
    var at, ch, escapee = {
        '"': '"',
        "\\": "\\",
        "/": "/",
        "b": "\b",
        "f": "\f",
        "n": "\n",
        "r": "\r",
        "t": "	"
    }, text, error = function(m) {
        var e = new SyntaxError(m);
        e.at = at;
        e.text = text;
        throw e;
    }, next = function(c) {
        // If a c parameter is provided, verify that it matches the current character.
        if (c && c !== ch) error("Expected '" + c + "' instead of '" + ch + "'");
        // Get the next character. When there are no more characters,
        // return the empty string.
        ch = text.charAt(at);
        at += 1;
        return ch;
    }, number = function() {
        // Parse a number value.
        var number, string = "";
        if (ch === "-") {
            string = "-";
            next("-");
        }
        while(ch >= "0" && ch <= "9"){
            string += ch;
            next();
        }
        if (ch === ".") {
            string += ".";
            while(next() && ch >= "0" && ch <= "9")string += ch;
        }
        if (ch === "e" || ch === "E") {
            string += ch;
            next();
            if (ch === "-" || ch === "+") {
                string += ch;
                next();
            }
            while(ch >= "0" && ch <= "9"){
                string += ch;
                next();
            }
        }
        number = +string;
        if (!isFinite(number)) error("Bad number");
        else return number;
    }, string = function() {
        // Parse a string value.
        var hex, i, string = "", uffff;
        // When parsing for string values, we must look for " and \ characters.
        if (ch === '"') while(next()){
            if (ch === '"') {
                next();
                return string;
            }
            if (ch === "\\") {
                next();
                if (ch === "u") {
                    uffff = 0;
                    for(i = 0; i < 4; i += 1){
                        hex = parseInt(next(), 16);
                        if (!isFinite(hex)) break;
                        uffff = uffff * 16 + hex;
                    }
                    string += String.fromCharCode(uffff);
                } else if (typeof escapee[ch] === "string") string += escapee[ch];
                else break;
            } else string += ch;
        }
        error("Bad string");
    }, white = function() {
        // Skip whitespace.
        while(ch && ch <= " ")next();
    }, word = function() {
        // true, false, or null.
        switch(ch){
            case "t":
                next("t");
                next("r");
                next("u");
                next("e");
                return true;
            case "f":
                next("f");
                next("a");
                next("l");
                next("s");
                next("e");
                return false;
            case "n":
                next("n");
                next("u");
                next("l");
                next("l");
                return null;
        }
        error('Unexpected "' + ch + '"');
    }, value, array = function() {
        // Parse an array value.
        var array = [];
        if (ch === "[") {
            next("[");
            white();
            if (ch === "]") {
                next("]");
                return array; // empty array
            }
            while(ch){
                array.push(value());
                white();
                if (ch === "]") {
                    next("]");
                    return array;
                }
                next(",");
                white();
            }
        }
        error("Bad array");
    }, object = function() {
        // Parse an object value.
        var key, object = {};
        if (ch === "{") {
            next("{");
            white();
            if (ch === "}") {
                next("}");
                return object; // empty object
            }
            while(ch){
                key = string();
                white();
                next(":");
                if (Object.hasOwnProperty.call(object, key)) error('Duplicate key "' + key + '"');
                object[key] = value();
                white();
                if (ch === "}") {
                    next("}");
                    return object;
                }
                next(",");
                white();
            }
        }
        error("Bad object");
    };
    value = function() {
        // Parse a JSON value. It could be an object, an array, a string,
        // a number, or a word.
        white();
        switch(ch){
            case "{":
                return object();
            case "[":
                return array();
            case '"':
                return string();
            case "-":
                return number();
            default:
                return ch >= "0" && ch <= "9" ? number() : word();
        }
    };
    // Return the json_parse function. It will have access to all of the
    // above functions and variables.
    return function(source) {
        var result;
        text = source;
        at = 0;
        ch = " ";
        result = value();
        white();
        if (ch) error("Syntax error");
        return result;
    };
}();
$a9f1195cdd0a4fb0$var$_.base64Encode = function(data) {
    var b64 = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=";
    var o1, o2, o3, h1, h2, h3, h4, bits, i = 0, ac = 0, enc = "", tmp_arr = [];
    if (!data) return data;
    data = $a9f1195cdd0a4fb0$var$_.utf8Encode(data);
    do {
        o1 = data.charCodeAt(i++);
        o2 = data.charCodeAt(i++);
        o3 = data.charCodeAt(i++);
        bits = o1 << 16 | o2 << 8 | o3;
        h1 = bits >> 18 & 0x3f;
        h2 = bits >> 12 & 0x3f;
        h3 = bits >> 6 & 0x3f;
        h4 = bits & 0x3f;
        // use hexets to index into b64, and append result to encoded string
        tmp_arr[ac++] = b64.charAt(h1) + b64.charAt(h2) + b64.charAt(h3) + b64.charAt(h4);
    }while (i < data.length);
    enc = tmp_arr.join("");
    switch(data.length % 3){
        case 1:
            enc = enc.slice(0, -2) + "==";
            break;
        case 2:
            enc = enc.slice(0, -1) + "=";
            break;
    }
    return enc;
};
$a9f1195cdd0a4fb0$var$_.utf8Encode = function(string) {
    string = (string + "").replace(/\r\n/g, "\n").replace(/\r/g, "\n");
    var utftext = "", start, end;
    var stringl = 0, n;
    start = end = 0;
    stringl = string.length;
    for(n = 0; n < stringl; n++){
        var c1 = string.charCodeAt(n);
        var enc = null;
        if (c1 < 128) end++;
        else if (c1 > 127 && c1 < 2048) enc = String.fromCharCode(c1 >> 6 | 192, c1 & 63 | 128);
        else enc = String.fromCharCode(c1 >> 12 | 224, c1 >> 6 & 63 | 128, c1 & 63 | 128);
        if (enc !== null) {
            if (end > start) utftext += string.substring(start, end);
            utftext += enc;
            start = end = n + 1;
        }
    }
    if (end > start) utftext += string.substring(start, string.length);
    return utftext;
};
$a9f1195cdd0a4fb0$var$_.UUID = function() {
    // Time/ticks information
    // 1*new Date() is a cross browser version of Date.now()
    var T = function() {
        var d = 1 * new Date(), i = 0;
        // this while loop figures how many browser ticks go by
        // before 1*new Date() returns a new number, ie the amount
        // of ticks that go by per millisecond
        while(d == 1 * new Date())i++;
        return d.toString(16) + i.toString(16);
    };
    // Math.Random entropy
    var R = function() {
        return Math.random().toString(16).replace(".", "");
    };
    // User agent entropy
    // This function takes the user agent string, and then xors
    // together each sequence of 8 bytes.  This produces a final
    // sequence of 8 bytes which it returns as hex.
    var UA = function() {
        var ua = $a9f1195cdd0a4fb0$var$userAgent, i, ch, buffer = [], ret = 0;
        function xor(result, byte_array) {
            var j, tmp = 0;
            for(j = 0; j < byte_array.length; j++)tmp |= buffer[j] << j * 8;
            return result ^ tmp;
        }
        for(i = 0; i < ua.length; i++){
            ch = ua.charCodeAt(i);
            buffer.unshift(ch & 0xFF);
            if (buffer.length >= 4) {
                ret = xor(ret, buffer);
                buffer = [];
            }
        }
        if (buffer.length > 0) ret = xor(ret, buffer);
        return ret.toString(16);
    };
    return function() {
        var se = ($a9f1195cdd0a4fb0$var$screen.height * $a9f1195cdd0a4fb0$var$screen.width).toString(16);
        return T() + "-" + R() + "-" + UA() + "-" + se + "-" + T();
    };
}();
// _.isBlockedUA()
// This is to block various web spiders from executing our JS and
// sending false tracking data
var $a9f1195cdd0a4fb0$var$BLOCKED_UA_STRS = [
    "ahrefsbot",
    "baiduspider",
    "bingbot",
    "bingpreview",
    "facebookexternal",
    "petalbot",
    "pinterest",
    "screaming frog",
    "yahoo! slurp",
    "yandexbot",
    // a whole bunch of goog-specific crawlers
    // https://developers.google.com/search/docs/advanced/crawling/overview-google-crawlers
    "adsbot-google",
    "apis-google",
    "duplexweb-google",
    "feedfetcher-google",
    "google favicon",
    "google web preview",
    "google-read-aloud",
    "googlebot",
    "googleweblight",
    "mediapartners-google",
    "storebot-google"
];
$a9f1195cdd0a4fb0$var$_.isBlockedUA = function(ua) {
    var i;
    ua = ua.toLowerCase();
    for(i = 0; i < $a9f1195cdd0a4fb0$var$BLOCKED_UA_STRS.length; i++){
        if (ua.indexOf($a9f1195cdd0a4fb0$var$BLOCKED_UA_STRS[i]) !== -1) return true;
    }
    return false;
};
/**
 * @param {Object=} formdata
 * @param {string=} arg_separator
 */ $a9f1195cdd0a4fb0$var$_.HTTPBuildQuery = function(formdata, arg_separator) {
    var use_val, use_key, tmp_arr = [];
    if ($a9f1195cdd0a4fb0$var$_.isUndefined(arg_separator)) arg_separator = "&";
    $a9f1195cdd0a4fb0$var$_.each(formdata, function(val, key) {
        use_val = encodeURIComponent(val.toString());
        use_key = encodeURIComponent(key);
        tmp_arr[tmp_arr.length] = use_key + "=" + use_val;
    });
    return tmp_arr.join(arg_separator);
};
$a9f1195cdd0a4fb0$var$_.getQueryParam = function(url, param) {
    // Expects a raw URL
    param = param.replace(/[[]/, "\\[").replace(/[\]]/, "\\]");
    var regexS = "[\\?&]" + param + "=([^&#]*)", regex = new RegExp(regexS), results = regex.exec(url);
    if (results === null || results && typeof results[1] !== "string" && results[1].length) return "";
    else {
        var result = results[1];
        try {
            result = decodeURIComponent(result);
        } catch (err) {
            $a9f1195cdd0a4fb0$var$console.error("Skipping decoding for malformed query param: " + result);
        }
        return result.replace(/\+/g, " ");
    }
};
// _.cookie
// Methods partially borrowed from quirksmode.org/js/cookies.html
$a9f1195cdd0a4fb0$var$_.cookie = {
    get: function(name) {
        var nameEQ = name + "=";
        var ca = $a9f1195cdd0a4fb0$var$document$1.cookie.split(";");
        for(var i = 0; i < ca.length; i++){
            var c = ca[i];
            while(c.charAt(0) == " ")c = c.substring(1, c.length);
            if (c.indexOf(nameEQ) === 0) return decodeURIComponent(c.substring(nameEQ.length, c.length));
        }
        return null;
    },
    parse: function(name) {
        var cookie;
        try {
            cookie = $a9f1195cdd0a4fb0$var$_.JSONDecode($a9f1195cdd0a4fb0$var$_.cookie.get(name)) || {};
        } catch (err) {
        // noop
        }
        return cookie;
    },
    set_seconds: function(name, value, seconds, is_cross_subdomain, is_secure, is_cross_site, domain_override) {
        var cdomain = "", expires = "", secure = "";
        if (domain_override) cdomain = "; domain=" + domain_override;
        else if (is_cross_subdomain) {
            var domain = $a9f1195cdd0a4fb0$var$extract_domain($a9f1195cdd0a4fb0$var$document$1.location.hostname);
            cdomain = domain ? "; domain=." + domain : "";
        }
        if (seconds) {
            var date = new Date();
            date.setTime(date.getTime() + seconds * 1000);
            expires = "; expires=" + date.toGMTString();
        }
        if (is_cross_site) {
            is_secure = true;
            secure = "; SameSite=None";
        }
        if (is_secure) secure += "; secure";
        $a9f1195cdd0a4fb0$var$document$1.cookie = name + "=" + encodeURIComponent(value) + expires + "; path=/" + cdomain + secure;
    },
    set: function(name, value, days, is_cross_subdomain, is_secure, is_cross_site, domain_override) {
        var cdomain = "", expires = "", secure = "";
        if (domain_override) cdomain = "; domain=" + domain_override;
        else if (is_cross_subdomain) {
            var domain = $a9f1195cdd0a4fb0$var$extract_domain($a9f1195cdd0a4fb0$var$document$1.location.hostname);
            cdomain = domain ? "; domain=." + domain : "";
        }
        if (days) {
            var date = new Date();
            date.setTime(date.getTime() + days * 86400000);
            expires = "; expires=" + date.toGMTString();
        }
        if (is_cross_site) {
            is_secure = true;
            secure = "; SameSite=None";
        }
        if (is_secure) secure += "; secure";
        var new_cookie_val = name + "=" + encodeURIComponent(value) + expires + "; path=/" + cdomain + secure;
        $a9f1195cdd0a4fb0$var$document$1.cookie = new_cookie_val;
        return new_cookie_val;
    },
    remove: function(name, is_cross_subdomain, domain_override) {
        $a9f1195cdd0a4fb0$var$_.cookie.set(name, "", -1, is_cross_subdomain, false, false, domain_override);
    }
};
var $a9f1195cdd0a4fb0$var$_localStorageSupported = null;
var $a9f1195cdd0a4fb0$var$localStorageSupported = function(storage, forceCheck) {
    if ($a9f1195cdd0a4fb0$var$_localStorageSupported !== null && !forceCheck) return $a9f1195cdd0a4fb0$var$_localStorageSupported;
    var supported = true;
    try {
        storage = storage || window.localStorage;
        var key = "__mplss_" + $a9f1195cdd0a4fb0$var$cheap_guid(8), val = "xyz";
        storage.setItem(key, val);
        if (storage.getItem(key) !== val) supported = false;
        storage.removeItem(key);
    } catch (err) {
        supported = false;
    }
    $a9f1195cdd0a4fb0$var$_localStorageSupported = supported;
    return supported;
};
// _.localStorage
$a9f1195cdd0a4fb0$var$_.localStorage = {
    is_supported: function(force_check) {
        var supported = $a9f1195cdd0a4fb0$var$localStorageSupported(null, force_check);
        if (!supported) $a9f1195cdd0a4fb0$var$console.error("localStorage unsupported; falling back to cookie store");
        return supported;
    },
    error: function(msg) {
        $a9f1195cdd0a4fb0$var$console.error("localStorage error: " + msg);
    },
    get: function(name) {
        try {
            return window.localStorage.getItem(name);
        } catch (err) {
            $a9f1195cdd0a4fb0$var$_.localStorage.error(err);
        }
        return null;
    },
    parse: function(name) {
        try {
            return $a9f1195cdd0a4fb0$var$_.JSONDecode($a9f1195cdd0a4fb0$var$_.localStorage.get(name)) || {};
        } catch (err) {
        // noop
        }
        return null;
    },
    set: function(name, value) {
        try {
            window.localStorage.setItem(name, value);
        } catch (err) {
            $a9f1195cdd0a4fb0$var$_.localStorage.error(err);
        }
    },
    remove: function(name) {
        try {
            window.localStorage.removeItem(name);
        } catch (err) {
            $a9f1195cdd0a4fb0$var$_.localStorage.error(err);
        }
    }
};
$a9f1195cdd0a4fb0$var$_.register_event = function() {
    // written by Dean Edwards, 2005
    // with input from Tino Zijdel - crisp@xs4all.nl
    // with input from Carl Sverre - mail@carlsverre.com
    // with input from Mixpanel
    // http://dean.edwards.name/weblog/2005/10/add-event/
    // https://gist.github.com/1930440
    /**
     * @param {Object} element
     * @param {string} type
     * @param {function(...*)} handler
     * @param {boolean=} oldSchool
     * @param {boolean=} useCapture
     */ var register_event = function(element, type, handler, oldSchool, useCapture) {
        if (!element) {
            $a9f1195cdd0a4fb0$var$console.error("No valid element provided to register_event");
            return;
        }
        if (element.addEventListener && !oldSchool) element.addEventListener(type, handler, !!useCapture);
        else {
            var ontype = "on" + type;
            var old_handler = element[ontype]; // can be undefined
            element[ontype] = makeHandler(element, handler, old_handler);
        }
    };
    function makeHandler(element, new_handler, old_handlers) {
        var handler = function(event) {
            event = event || fixEvent(window.event);
            // this basically happens in firefox whenever another script
            // overwrites the onload callback and doesn't pass the event
            // object to previously defined callbacks.  All the browsers
            // that don't define window.event implement addEventListener
            // so the dom_loaded handler will still be fired as usual.
            if (!event) return undefined;
            var ret = true;
            var old_result, new_result;
            if ($a9f1195cdd0a4fb0$var$_.isFunction(old_handlers)) old_result = old_handlers(event);
            new_result = new_handler.call(element, event);
            if (false === old_result || false === new_result) ret = false;
            return ret;
        };
        return handler;
    }
    function fixEvent(event) {
        if (event) {
            event.preventDefault = fixEvent.preventDefault;
            event.stopPropagation = fixEvent.stopPropagation;
        }
        return event;
    }
    fixEvent.preventDefault = function() {
        this.returnValue = false;
    };
    fixEvent.stopPropagation = function() {
        this.cancelBubble = true;
    };
    return register_event;
}();
var $a9f1195cdd0a4fb0$var$TOKEN_MATCH_REGEX = new RegExp('^(\\w*)\\[(\\w+)([=~\\|\\^\\$\\*]?)=?"?([^\\]"]*)"?\\]$');
$a9f1195cdd0a4fb0$var$_.dom_query = function() {
    /* document.getElementsBySelector(selector)
    - returns an array of element objects from the current document
    matching the CSS selector. Selectors can contain element names,
    class names and ids and can be nested. For example:

    elements = document.getElementsBySelector('div#main p a.external')

    Will return an array of all 'a' elements with 'external' in their
    class attribute that are contained inside 'p' elements that are
    contained inside the 'div' element which has id="main"

    New in version 0.4: Support for CSS2 and CSS3 attribute selectors:
    See http://www.w3.org/TR/css3-selectors/#attribute-selectors

    Version 0.4 - Simon Willison, March 25th 2003
    -- Works in Phoenix 0.5, Mozilla 1.3, Opera 7, Internet Explorer 6, Internet Explorer 5 on Windows
    -- Opera 7 fails

    Version 0.5 - Carl Sverre, Jan 7th 2013
    -- Now uses jQuery-esque `hasClass` for testing class name
    equality.  This fixes a bug related to '-' characters being
    considered not part of a 'word' in regex.
    */ function getAllChildren(e) {
        // Returns all children of element. Workaround required for IE5/Windows. Ugh.
        return e.all ? e.all : e.getElementsByTagName("*");
    }
    var bad_whitespace = /[\t\r\n]/g;
    function hasClass(elem, selector) {
        var className = " " + selector + " ";
        return (" " + elem.className + " ").replace(bad_whitespace, " ").indexOf(className) >= 0;
    }
    function getElementsBySelector(selector) {
        // Attempt to fail gracefully in lesser browsers
        if (!$a9f1195cdd0a4fb0$var$document$1.getElementsByTagName) return [];
        // Split selector in to tokens
        var tokens = selector.split(" ");
        var token, bits, tagName, found, foundCount, i, j, k, elements, currentContextIndex;
        var currentContext = [
            $a9f1195cdd0a4fb0$var$document$1
        ];
        for(i = 0; i < tokens.length; i++){
            token = tokens[i].replace(/^\s+/, "").replace(/\s+$/, "");
            if (token.indexOf("#") > -1) {
                // Token is an ID selector
                bits = token.split("#");
                tagName = bits[0];
                var id = bits[1];
                var element = $a9f1195cdd0a4fb0$var$document$1.getElementById(id);
                if (!element || tagName && element.nodeName.toLowerCase() != tagName) // element not found or tag with that ID not found, return false
                return [];
                // Set currentContext to contain just this element
                currentContext = [
                    element
                ];
                continue; // Skip to next token
            }
            if (token.indexOf(".") > -1) {
                // Token contains a class selector
                bits = token.split(".");
                tagName = bits[0];
                var className = bits[1];
                if (!tagName) tagName = "*";
                // Get elements matching tag, filter them for class selector
                found = [];
                foundCount = 0;
                for(j = 0; j < currentContext.length; j++){
                    if (tagName == "*") elements = getAllChildren(currentContext[j]);
                    else elements = currentContext[j].getElementsByTagName(tagName);
                    for(k = 0; k < elements.length; k++)found[foundCount++] = elements[k];
                }
                currentContext = [];
                currentContextIndex = 0;
                for(j = 0; j < found.length; j++)if (found[j].className && $a9f1195cdd0a4fb0$var$_.isString(found[j].className) && // some SVG elements have classNames which are not strings
                hasClass(found[j], className)) currentContext[currentContextIndex++] = found[j];
                continue; // Skip to next token
            }
            // Code to deal with attribute selectors
            var token_match = token.match($a9f1195cdd0a4fb0$var$TOKEN_MATCH_REGEX);
            if (token_match) {
                tagName = token_match[1];
                var attrName = token_match[2];
                var attrOperator = token_match[3];
                var attrValue = token_match[4];
                if (!tagName) tagName = "*";
                // Grab all of the tagName elements within current context
                found = [];
                foundCount = 0;
                for(j = 0; j < currentContext.length; j++){
                    if (tagName == "*") elements = getAllChildren(currentContext[j]);
                    else elements = currentContext[j].getElementsByTagName(tagName);
                    for(k = 0; k < elements.length; k++)found[foundCount++] = elements[k];
                }
                currentContext = [];
                currentContextIndex = 0;
                var checkFunction; // This function will be used to filter the elements
                switch(attrOperator){
                    case "=":
                        checkFunction = function(e) {
                            return e.getAttribute(attrName) == attrValue;
                        };
                        break;
                    case "~":
                        checkFunction = function(e) {
                            return e.getAttribute(attrName).match(new RegExp("\\b" + attrValue + "\\b"));
                        };
                        break;
                    case "|":
                        checkFunction = function(e) {
                            return e.getAttribute(attrName).match(new RegExp("^" + attrValue + "-?"));
                        };
                        break;
                    case "^":
                        checkFunction = function(e) {
                            return e.getAttribute(attrName).indexOf(attrValue) === 0;
                        };
                        break;
                    case "$":
                        checkFunction = function(e) {
                            return e.getAttribute(attrName).lastIndexOf(attrValue) == e.getAttribute(attrName).length - attrValue.length;
                        };
                        break;
                    case "*":
                        checkFunction = function(e) {
                            return e.getAttribute(attrName).indexOf(attrValue) > -1;
                        };
                        break;
                    default:
                        // Just test for existence of attribute
                        checkFunction = function(e) {
                            return e.getAttribute(attrName);
                        };
                }
                currentContext = [];
                currentContextIndex = 0;
                for(j = 0; j < found.length; j++)if (checkFunction(found[j])) currentContext[currentContextIndex++] = found[j];
                continue; // Skip to next token
            }
            // If we get here, token is JUST an element (not a class or ID selector)
            tagName = token;
            found = [];
            foundCount = 0;
            for(j = 0; j < currentContext.length; j++){
                elements = currentContext[j].getElementsByTagName(tagName);
                for(k = 0; k < elements.length; k++)found[foundCount++] = elements[k];
            }
            currentContext = found;
        }
        return currentContext;
    }
    return function(query) {
        if ($a9f1195cdd0a4fb0$var$_.isElement(query)) return [
            query
        ];
        else if ($a9f1195cdd0a4fb0$var$_.isObject(query) && !$a9f1195cdd0a4fb0$var$_.isUndefined(query.length)) return query;
        else return getElementsBySelector.call(this, query);
    };
}();
$a9f1195cdd0a4fb0$var$_.info = {
    campaignParams: function() {
        var campaign_keywords = "utm_source utm_medium utm_campaign utm_content utm_term".split(" "), kw = "", params = {};
        $a9f1195cdd0a4fb0$var$_.each(campaign_keywords, function(kwkey) {
            kw = $a9f1195cdd0a4fb0$var$_.getQueryParam($a9f1195cdd0a4fb0$var$document$1.URL, kwkey);
            if (kw.length) params[kwkey] = kw;
        });
        return params;
    },
    searchEngine: function(referrer) {
        if (referrer.search("https?://(.*)google.([^/?]*)") === 0) return "google";
        else if (referrer.search("https?://(.*)bing.com") === 0) return "bing";
        else if (referrer.search("https?://(.*)yahoo.com") === 0) return "yahoo";
        else if (referrer.search("https?://(.*)duckduckgo.com") === 0) return "duckduckgo";
        else return null;
    },
    searchInfo: function(referrer) {
        var search = $a9f1195cdd0a4fb0$var$_.info.searchEngine(referrer), param = search != "yahoo" ? "q" : "p", ret = {};
        if (search !== null) {
            ret["$search_engine"] = search;
            var keyword = $a9f1195cdd0a4fb0$var$_.getQueryParam(referrer, param);
            if (keyword.length) ret["mp_keyword"] = keyword;
        }
        return ret;
    },
    /**
     * This function detects which browser is running this script.
     * The order of the checks are important since many user agents
     * include key words used in later checks.
     */ browser: function(user_agent, vendor, opera) {
        vendor = vendor || ""; // vendor is undefined for at least IE9
        if (opera || $a9f1195cdd0a4fb0$var$_.includes(user_agent, " OPR/")) {
            if ($a9f1195cdd0a4fb0$var$_.includes(user_agent, "Mini")) return "Opera Mini";
            return "Opera";
        } else if (/(BlackBerry|PlayBook|BB10)/i.test(user_agent)) return "BlackBerry";
        else if ($a9f1195cdd0a4fb0$var$_.includes(user_agent, "IEMobile") || $a9f1195cdd0a4fb0$var$_.includes(user_agent, "WPDesktop")) return "Internet Explorer Mobile";
        else if ($a9f1195cdd0a4fb0$var$_.includes(user_agent, "SamsungBrowser/")) // https://developer.samsung.com/internet/user-agent-string-format
        return "Samsung Internet";
        else if ($a9f1195cdd0a4fb0$var$_.includes(user_agent, "Edge") || $a9f1195cdd0a4fb0$var$_.includes(user_agent, "Edg/")) return "Microsoft Edge";
        else if ($a9f1195cdd0a4fb0$var$_.includes(user_agent, "FBIOS")) return "Facebook Mobile";
        else if ($a9f1195cdd0a4fb0$var$_.includes(user_agent, "Chrome")) return "Chrome";
        else if ($a9f1195cdd0a4fb0$var$_.includes(user_agent, "CriOS")) return "Chrome iOS";
        else if ($a9f1195cdd0a4fb0$var$_.includes(user_agent, "UCWEB") || $a9f1195cdd0a4fb0$var$_.includes(user_agent, "UCBrowser")) return "UC Browser";
        else if ($a9f1195cdd0a4fb0$var$_.includes(user_agent, "FxiOS")) return "Firefox iOS";
        else if ($a9f1195cdd0a4fb0$var$_.includes(vendor, "Apple")) {
            if ($a9f1195cdd0a4fb0$var$_.includes(user_agent, "Mobile")) return "Mobile Safari";
            return "Safari";
        } else if ($a9f1195cdd0a4fb0$var$_.includes(user_agent, "Android")) return "Android Mobile";
        else if ($a9f1195cdd0a4fb0$var$_.includes(user_agent, "Konqueror")) return "Konqueror";
        else if ($a9f1195cdd0a4fb0$var$_.includes(user_agent, "Firefox")) return "Firefox";
        else if ($a9f1195cdd0a4fb0$var$_.includes(user_agent, "MSIE") || $a9f1195cdd0a4fb0$var$_.includes(user_agent, "Trident/")) return "Internet Explorer";
        else if ($a9f1195cdd0a4fb0$var$_.includes(user_agent, "Gecko")) return "Mozilla";
        else return "";
    },
    /**
     * This function detects which browser version is running this script,
     * parsing major and minor version (e.g., 42.1). User agent strings from:
     * http://www.useragentstring.com/pages/useragentstring.php
     */ browserVersion: function(userAgent, vendor, opera) {
        var browser = $a9f1195cdd0a4fb0$var$_.info.browser(userAgent, vendor, opera);
        var versionRegexs = {
            "Internet Explorer Mobile": /rv:(\d+(\.\d+)?)/,
            "Microsoft Edge": /Edge?\/(\d+(\.\d+)?)/,
            "Chrome": /Chrome\/(\d+(\.\d+)?)/,
            "Chrome iOS": /CriOS\/(\d+(\.\d+)?)/,
            "UC Browser": /(UCBrowser|UCWEB)\/(\d+(\.\d+)?)/,
            "Safari": /Version\/(\d+(\.\d+)?)/,
            "Mobile Safari": /Version\/(\d+(\.\d+)?)/,
            "Opera": /(Opera|OPR)\/(\d+(\.\d+)?)/,
            "Firefox": /Firefox\/(\d+(\.\d+)?)/,
            "Firefox iOS": /FxiOS\/(\d+(\.\d+)?)/,
            "Konqueror": /Konqueror:(\d+(\.\d+)?)/,
            "BlackBerry": /BlackBerry (\d+(\.\d+)?)/,
            "Android Mobile": /android\s(\d+(\.\d+)?)/,
            "Samsung Internet": /SamsungBrowser\/(\d+(\.\d+)?)/,
            "Internet Explorer": /(rv:|MSIE )(\d+(\.\d+)?)/,
            "Mozilla": /rv:(\d+(\.\d+)?)/
        };
        var regex = versionRegexs[browser];
        if (regex === undefined) return null;
        var matches = userAgent.match(regex);
        if (!matches) return null;
        return parseFloat(matches[matches.length - 2]);
    },
    os: function() {
        var a = $a9f1195cdd0a4fb0$var$userAgent;
        if (/Windows/i.test(a)) {
            if (/Phone/.test(a) || /WPDesktop/.test(a)) return "Windows Phone";
            return "Windows";
        } else if (/(iPhone|iPad|iPod)/.test(a)) return "iOS";
        else if (/Android/.test(a)) return "Android";
        else if (/(BlackBerry|PlayBook|BB10)/i.test(a)) return "BlackBerry";
        else if (/Mac/i.test(a)) return "Mac OS X";
        else if (/Linux/.test(a)) return "Linux";
        else if (/CrOS/.test(a)) return "Chrome OS";
        else return "";
    },
    device: function(user_agent) {
        if (/Windows Phone/i.test(user_agent) || /WPDesktop/.test(user_agent)) return "Windows Phone";
        else if (/iPad/.test(user_agent)) return "iPad";
        else if (/iPod/.test(user_agent)) return "iPod Touch";
        else if (/iPhone/.test(user_agent)) return "iPhone";
        else if (/(BlackBerry|PlayBook|BB10)/i.test(user_agent)) return "BlackBerry";
        else if (/Android/.test(user_agent)) return "Android";
        else return "";
    },
    referringDomain: function(referrer) {
        var split = referrer.split("/");
        if (split.length >= 3) return split[2];
        return "";
    },
    properties: function() {
        return $a9f1195cdd0a4fb0$var$_.extend($a9f1195cdd0a4fb0$var$_.strip_empty_properties({
            "$os": $a9f1195cdd0a4fb0$var$_.info.os(),
            "$browser": $a9f1195cdd0a4fb0$var$_.info.browser($a9f1195cdd0a4fb0$var$userAgent, $a9f1195cdd0a4fb0$var$navigator.vendor, $a9f1195cdd0a4fb0$var$windowOpera),
            "$referrer": $a9f1195cdd0a4fb0$var$document$1.referrer,
            "$referring_domain": $a9f1195cdd0a4fb0$var$_.info.referringDomain($a9f1195cdd0a4fb0$var$document$1.referrer),
            "$device": $a9f1195cdd0a4fb0$var$_.info.device($a9f1195cdd0a4fb0$var$userAgent)
        }), {
            "$current_url": $a9f1195cdd0a4fb0$var$window$1.location.href,
            "$browser_version": $a9f1195cdd0a4fb0$var$_.info.browserVersion($a9f1195cdd0a4fb0$var$userAgent, $a9f1195cdd0a4fb0$var$navigator.vendor, $a9f1195cdd0a4fb0$var$windowOpera),
            "$screen_height": $a9f1195cdd0a4fb0$var$screen.height,
            "$screen_width": $a9f1195cdd0a4fb0$var$screen.width,
            "mp_lib": "web",
            "$lib_version": $a9f1195cdd0a4fb0$var$Config.LIB_VERSION,
            "$insert_id": $a9f1195cdd0a4fb0$var$cheap_guid(),
            "time": $a9f1195cdd0a4fb0$var$_.timestamp() / 1000 // epoch time in seconds
        });
    },
    people_properties: function() {
        return $a9f1195cdd0a4fb0$var$_.extend($a9f1195cdd0a4fb0$var$_.strip_empty_properties({
            "$os": $a9f1195cdd0a4fb0$var$_.info.os(),
            "$browser": $a9f1195cdd0a4fb0$var$_.info.browser($a9f1195cdd0a4fb0$var$userAgent, $a9f1195cdd0a4fb0$var$navigator.vendor, $a9f1195cdd0a4fb0$var$windowOpera)
        }), {
            "$browser_version": $a9f1195cdd0a4fb0$var$_.info.browserVersion($a9f1195cdd0a4fb0$var$userAgent, $a9f1195cdd0a4fb0$var$navigator.vendor, $a9f1195cdd0a4fb0$var$windowOpera)
        });
    },
    pageviewInfo: function(page) {
        return $a9f1195cdd0a4fb0$var$_.strip_empty_properties({
            "mp_page": page,
            "mp_referrer": $a9f1195cdd0a4fb0$var$document$1.referrer,
            "mp_browser": $a9f1195cdd0a4fb0$var$_.info.browser($a9f1195cdd0a4fb0$var$userAgent, $a9f1195cdd0a4fb0$var$navigator.vendor, $a9f1195cdd0a4fb0$var$windowOpera),
            "mp_platform": $a9f1195cdd0a4fb0$var$_.info.os()
        });
    }
};
var $a9f1195cdd0a4fb0$var$cheap_guid = function(maxlen) {
    var guid = Math.random().toString(36).substring(2, 10) + Math.random().toString(36).substring(2, 10);
    return maxlen ? guid.substring(0, maxlen) : guid;
};
// naive way to extract domain name (example.com) from full hostname (my.sub.example.com)
var $a9f1195cdd0a4fb0$var$SIMPLE_DOMAIN_MATCH_REGEX = /[a-z0-9][a-z0-9-]*\.[a-z]+$/i;
// this next one attempts to account for some ccSLDs, e.g. extracting oxford.ac.uk from www.oxford.ac.uk
var $a9f1195cdd0a4fb0$var$DOMAIN_MATCH_REGEX = /[a-z0-9][a-z0-9-]+\.[a-z.]{2,6}$/i;
/**
 * Attempts to extract main domain name from full hostname, using a few blunt heuristics. For
 * common TLDs like .com/.org that always have a simple SLD.TLD structure (example.com), we
 * simply extract the last two .-separated parts of the hostname (SIMPLE_DOMAIN_MATCH_REGEX).
 * For others, we attempt to account for short ccSLD+TLD combos (.ac.uk) with the legacy
 * DOMAIN_MATCH_REGEX (kept to maintain backwards compatibility with existing Mixpanel
 * integrations). The only _reliable_ way to extract domain from hostname is with an up-to-date
 * list like at https://publicsuffix.org/ so for cases that this helper fails at, the SDK
 * offers the 'cookie_domain' config option to set it explicitly.
 * @example
 * extract_domain('my.sub.example.com')
 * // 'example.com'
 */ var $a9f1195cdd0a4fb0$var$extract_domain = function(hostname) {
    var domain_regex = $a9f1195cdd0a4fb0$var$DOMAIN_MATCH_REGEX;
    var parts = hostname.split(".");
    var tld = parts[parts.length - 1];
    if (tld.length > 4 || tld === "com" || tld === "org") domain_regex = $a9f1195cdd0a4fb0$var$SIMPLE_DOMAIN_MATCH_REGEX;
    var matches = hostname.match(domain_regex);
    return matches ? matches[0] : "";
};
var $a9f1195cdd0a4fb0$var$JSONStringify = null;
var $a9f1195cdd0a4fb0$var$JSONParse = null;
if (typeof JSON !== "undefined") {
    $a9f1195cdd0a4fb0$var$JSONStringify = JSON.stringify;
    $a9f1195cdd0a4fb0$var$JSONParse = JSON.parse;
}
$a9f1195cdd0a4fb0$var$JSONStringify = $a9f1195cdd0a4fb0$var$JSONStringify || $a9f1195cdd0a4fb0$var$_.JSONEncode;
$a9f1195cdd0a4fb0$var$JSONParse = $a9f1195cdd0a4fb0$var$JSONParse || $a9f1195cdd0a4fb0$var$_.JSONDecode;
// EXPORTS (for closure compiler)
$a9f1195cdd0a4fb0$var$_["toArray"] = $a9f1195cdd0a4fb0$var$_.toArray;
$a9f1195cdd0a4fb0$var$_["isObject"] = $a9f1195cdd0a4fb0$var$_.isObject;
$a9f1195cdd0a4fb0$var$_["JSONEncode"] = $a9f1195cdd0a4fb0$var$_.JSONEncode;
$a9f1195cdd0a4fb0$var$_["JSONDecode"] = $a9f1195cdd0a4fb0$var$_.JSONDecode;
$a9f1195cdd0a4fb0$var$_["isBlockedUA"] = $a9f1195cdd0a4fb0$var$_.isBlockedUA;
$a9f1195cdd0a4fb0$var$_["isEmptyObject"] = $a9f1195cdd0a4fb0$var$_.isEmptyObject;
$a9f1195cdd0a4fb0$var$_["info"] = $a9f1195cdd0a4fb0$var$_.info;
$a9f1195cdd0a4fb0$var$_["info"]["device"] = $a9f1195cdd0a4fb0$var$_.info.device;
$a9f1195cdd0a4fb0$var$_["info"]["browser"] = $a9f1195cdd0a4fb0$var$_.info.browser;
$a9f1195cdd0a4fb0$var$_["info"]["browserVersion"] = $a9f1195cdd0a4fb0$var$_.info.browserVersion;
$a9f1195cdd0a4fb0$var$_["info"]["properties"] = $a9f1195cdd0a4fb0$var$_.info.properties;
/**
 * DomTracker Object
 * @constructor
 */ var $a9f1195cdd0a4fb0$var$DomTracker = function() {};
// interface
$a9f1195cdd0a4fb0$var$DomTracker.prototype.create_properties = function() {};
$a9f1195cdd0a4fb0$var$DomTracker.prototype.event_handler = function() {};
$a9f1195cdd0a4fb0$var$DomTracker.prototype.after_track_handler = function() {};
$a9f1195cdd0a4fb0$var$DomTracker.prototype.init = function(mixpanel_instance) {
    this.mp = mixpanel_instance;
    return this;
};
/**
 * @param {Object|string} query
 * @param {string} event_name
 * @param {Object=} properties
 * @param {function=} user_callback
 */ $a9f1195cdd0a4fb0$var$DomTracker.prototype.track = function(query, event_name, properties, user_callback) {
    var that = this;
    var elements = $a9f1195cdd0a4fb0$var$_.dom_query(query);
    if (elements.length === 0) {
        $a9f1195cdd0a4fb0$var$console.error("The DOM query (" + query + ") returned 0 elements");
        return;
    }
    $a9f1195cdd0a4fb0$var$_.each(elements, function(element) {
        $a9f1195cdd0a4fb0$var$_.register_event(element, this.override_event, function(e) {
            var options = {};
            var props = that.create_properties(properties, this);
            var timeout = that.mp.get_config("track_links_timeout");
            that.event_handler(e, this, options);
            // in case the mixpanel servers don't get back to us in time
            window.setTimeout(that.track_callback(user_callback, props, options, true), timeout);
            // fire the tracking event
            that.mp.track(event_name, props, that.track_callback(user_callback, props, options));
        });
    }, this);
    return true;
};
/**
 * @param {function} user_callback
 * @param {Object} props
 * @param {boolean=} timeout_occured
 */ $a9f1195cdd0a4fb0$var$DomTracker.prototype.track_callback = function(user_callback, props, options, timeout_occured) {
    timeout_occured = timeout_occured || false;
    var that = this;
    return function() {
        // options is referenced from both callbacks, so we can have
        // a 'lock' of sorts to ensure only one fires
        if (options.callback_fired) return;
        options.callback_fired = true;
        if (user_callback && user_callback(timeout_occured, props) === false) // user can prevent the default functionality by
        // returning false from their callback
        return;
        that.after_track_handler(props, options, timeout_occured);
    };
};
$a9f1195cdd0a4fb0$var$DomTracker.prototype.create_properties = function(properties, element) {
    var props;
    if (typeof properties === "function") props = properties(element);
    else props = $a9f1195cdd0a4fb0$var$_.extend({}, properties);
    return props;
};
/**
 * LinkTracker Object
 * @constructor
 * @extends DomTracker
 */ var $a9f1195cdd0a4fb0$var$LinkTracker = function() {
    this.override_event = "click";
};
$a9f1195cdd0a4fb0$var$_.inherit($a9f1195cdd0a4fb0$var$LinkTracker, $a9f1195cdd0a4fb0$var$DomTracker);
$a9f1195cdd0a4fb0$var$LinkTracker.prototype.create_properties = function(properties, element) {
    var props = $a9f1195cdd0a4fb0$var$LinkTracker.superclass.create_properties.apply(this, arguments);
    if (element.href) props["url"] = element.href;
    return props;
};
$a9f1195cdd0a4fb0$var$LinkTracker.prototype.event_handler = function(evt, element, options) {
    options.new_tab = evt.which === 2 || evt.metaKey || evt.ctrlKey || element.target === "_blank";
    options.href = element.href;
    if (!options.new_tab) evt.preventDefault();
};
$a9f1195cdd0a4fb0$var$LinkTracker.prototype.after_track_handler = function(props, options) {
    if (options.new_tab) return;
    setTimeout(function() {
        window.location = options.href;
    }, 0);
};
/**
 * FormTracker Object
 * @constructor
 * @extends DomTracker
 */ var $a9f1195cdd0a4fb0$var$FormTracker = function() {
    this.override_event = "submit";
};
$a9f1195cdd0a4fb0$var$_.inherit($a9f1195cdd0a4fb0$var$FormTracker, $a9f1195cdd0a4fb0$var$DomTracker);
$a9f1195cdd0a4fb0$var$FormTracker.prototype.event_handler = function(evt, element, options) {
    options.element = element;
    evt.preventDefault();
};
$a9f1195cdd0a4fb0$var$FormTracker.prototype.after_track_handler = function(props, options) {
    setTimeout(function() {
        options.element.submit();
    }, 0);
};
// eslint-disable-line camelcase
var $a9f1195cdd0a4fb0$var$logger$2 = $a9f1195cdd0a4fb0$var$console_with_prefix("lock");
/**
 * SharedLock: a mutex built on HTML5 localStorage, to ensure that only one browser
 * window/tab at a time will be able to access shared resources.
 *
 * Based on the Alur and Taubenfeld fast lock
 * (http://www.cs.rochester.edu/research/synchronization/pseudocode/fastlock.html)
 * with an added timeout to ensure there will be eventual progress in the event
 * that a window is closed in the middle of the callback.
 *
 * Implementation based on the original version by David Wolever (https://github.com/wolever)
 * at https://gist.github.com/wolever/5fd7573d1ef6166e8f8c4af286a69432.
 *
 * @example
 * const myLock = new SharedLock('some-key');
 * myLock.withLock(function() {
 *   console.log('I hold the mutex!');
 * });
 *
 * @constructor
 */ var $a9f1195cdd0a4fb0$var$SharedLock = function(key, options) {
    options = options || {};
    this.storageKey = key;
    this.storage = options.storage || window.localStorage;
    this.pollIntervalMS = options.pollIntervalMS || 100;
    this.timeoutMS = options.timeoutMS || 2000;
};
// pass in a specific pid to test contention scenarios; otherwise
// it is chosen randomly for each acquisition attempt
$a9f1195cdd0a4fb0$var$SharedLock.prototype.withLock = function(lockedCB, errorCB, pid) {
    if (!pid && typeof errorCB !== "function") {
        pid = errorCB;
        errorCB = null;
    }
    var i = pid || new Date().getTime() + "|" + Math.random();
    var startTime = new Date().getTime();
    var key = this.storageKey;
    var pollIntervalMS = this.pollIntervalMS;
    var timeoutMS = this.timeoutMS;
    var storage = this.storage;
    var keyX = key + ":X";
    var keyY = key + ":Y";
    var keyZ = key + ":Z";
    var reportError = function(err) {
        errorCB && errorCB(err);
    };
    var delay = function(cb) {
        if (new Date().getTime() - startTime > timeoutMS) {
            $a9f1195cdd0a4fb0$var$logger$2.error("Timeout waiting for mutex on " + key + "; clearing lock. [" + i + "]");
            storage.removeItem(keyZ);
            storage.removeItem(keyY);
            loop();
            return;
        }
        setTimeout(function() {
            try {
                cb();
            } catch (err) {
                reportError(err);
            }
        }, pollIntervalMS * (Math.random() + 0.1));
    };
    var waitFor = function(predicate, cb) {
        if (predicate()) cb();
        else delay(function() {
            waitFor(predicate, cb);
        });
    };
    var getSetY = function() {
        var valY = storage.getItem(keyY);
        if (valY && valY !== i) return false;
        else {
            storage.setItem(keyY, i);
            if (storage.getItem(keyY) === i) return true;
            else {
                if (!$a9f1195cdd0a4fb0$var$localStorageSupported(storage, true)) throw new Error("localStorage support dropped while acquiring lock");
                return false;
            }
        }
    };
    var loop = function() {
        storage.setItem(keyX, i);
        waitFor(getSetY, function() {
            if (storage.getItem(keyX) === i) {
                criticalSection();
                return;
            }
            delay(function() {
                if (storage.getItem(keyY) !== i) {
                    loop();
                    return;
                }
                waitFor(function() {
                    return !storage.getItem(keyZ);
                }, criticalSection);
            });
        });
    };
    var criticalSection = function() {
        storage.setItem(keyZ, "1");
        try {
            lockedCB();
        } finally{
            storage.removeItem(keyZ);
            if (storage.getItem(keyY) === i) storage.removeItem(keyY);
            if (storage.getItem(keyX) === i) storage.removeItem(keyX);
        }
    };
    try {
        if ($a9f1195cdd0a4fb0$var$localStorageSupported(storage, true)) loop();
        else throw new Error("localStorage support check failed");
    } catch (err) {
        reportError(err);
    }
};
// eslint-disable-line camelcase
var $a9f1195cdd0a4fb0$var$logger$1 = $a9f1195cdd0a4fb0$var$console_with_prefix("batch");
/**
 * RequestQueue: queue for batching API requests with localStorage backup for retries.
 * Maintains an in-memory queue which represents the source of truth for the current
 * page, but also writes all items out to a copy in the browser's localStorage, which
 * can be read on subsequent pageloads and retried. For batchability, all the request
 * items in the queue should be of the same type (events, people updates, group updates)
 * so they can be sent in a single request to the same API endpoint.
 *
 * LocalStorage keying and locking: In order for reloads and subsequent pageloads of
 * the same site to access the same persisted data, they must share the same localStorage
 * key (for instance based on project token and queue type). Therefore access to the
 * localStorage entry is guarded by an asynchronous mutex (SharedLock) to prevent
 * simultaneously open windows/tabs from overwriting each other's data (which would lead
 * to data loss in some situations).
 * @constructor
 */ var $a9f1195cdd0a4fb0$var$RequestQueue = function(storageKey, options) {
    options = options || {};
    this.storageKey = storageKey;
    this.storage = options.storage || window.localStorage;
    this.reportError = options.errorReporter || $a9f1195cdd0a4fb0$var$_.bind($a9f1195cdd0a4fb0$var$logger$1.error, $a9f1195cdd0a4fb0$var$logger$1);
    this.lock = new $a9f1195cdd0a4fb0$var$SharedLock(storageKey, {
        storage: this.storage
    });
    this.pid = options.pid || null; // pass pid to test out storage lock contention scenarios
    this.memQueue = [];
};
/**
 * Add one item to queues (memory and localStorage). The queued entry includes
 * the given item along with an auto-generated ID and a "flush-after" timestamp.
 * It is expected that the item will be sent over the network and dequeued
 * before the flush-after time; if this doesn't happen it is considered orphaned
 * (e.g., the original tab where it was enqueued got closed before it could be
 * sent) and the item can be sent by any tab that finds it in localStorage.
 *
 * The final callback param is called with a param indicating success or
 * failure of the enqueue operation; it is asynchronous because the localStorage
 * lock is asynchronous.
 */ $a9f1195cdd0a4fb0$var$RequestQueue.prototype.enqueue = function(item, flushInterval, cb) {
    var queueEntry = {
        "id": $a9f1195cdd0a4fb0$var$cheap_guid(),
        "flushAfter": new Date().getTime() + flushInterval * 2,
        "payload": item
    };
    this.lock.withLock($a9f1195cdd0a4fb0$var$_.bind(function lockAcquired() {
        var succeeded;
        try {
            var storedQueue = this.readFromStorage();
            storedQueue.push(queueEntry);
            succeeded = this.saveToStorage(storedQueue);
            if (succeeded) // only add to in-memory queue when storage succeeds
            this.memQueue.push(queueEntry);
        } catch (err) {
            this.reportError("Error enqueueing item", item);
            succeeded = false;
        }
        if (cb) cb(succeeded);
    }, this), $a9f1195cdd0a4fb0$var$_.bind(function lockFailure(err) {
        this.reportError("Error acquiring storage lock", err);
        if (cb) cb(false);
    }, this), this.pid);
};
/**
 * Read out the given number of queue entries. If this.memQueue
 * has fewer than batchSize items, then look for "orphaned" items
 * in the persisted queue (items where the 'flushAfter' time has
 * already passed).
 */ $a9f1195cdd0a4fb0$var$RequestQueue.prototype.fillBatch = function(batchSize) {
    var batch = this.memQueue.slice(0, batchSize);
    if (batch.length < batchSize) {
        // don't need lock just to read events; localStorage is thread-safe
        // and the worst that could happen is a duplicate send of some
        // orphaned events, which will be deduplicated on the server side
        var storedQueue = this.readFromStorage();
        if (storedQueue.length) {
            // item IDs already in batch; don't duplicate out of storage
            var idsInBatch = {}; // poor man's Set
            $a9f1195cdd0a4fb0$var$_.each(batch, function(item) {
                idsInBatch[item["id"]] = true;
            });
            for(var i = 0; i < storedQueue.length; i++){
                var item = storedQueue[i];
                if (new Date().getTime() > item["flushAfter"] && !idsInBatch[item["id"]]) {
                    item.orphaned = true;
                    batch.push(item);
                    if (batch.length >= batchSize) break;
                }
            }
        }
    }
    return batch;
};
/**
 * Remove items with matching 'id' from array (immutably)
 * also remove any item without a valid id (e.g., malformed
 * storage entries).
 */ var $a9f1195cdd0a4fb0$var$filterOutIDsAndInvalid = function(items, idSet) {
    var filteredItems = [];
    $a9f1195cdd0a4fb0$var$_.each(items, function(item) {
        if (item["id"] && !idSet[item["id"]]) filteredItems.push(item);
    });
    return filteredItems;
};
/**
 * Remove items with matching IDs from both in-memory queue
 * and persisted queue
 */ $a9f1195cdd0a4fb0$var$RequestQueue.prototype.removeItemsByID = function(ids, cb) {
    var idSet = {}; // poor man's Set
    $a9f1195cdd0a4fb0$var$_.each(ids, function(id) {
        idSet[id] = true;
    });
    this.memQueue = $a9f1195cdd0a4fb0$var$filterOutIDsAndInvalid(this.memQueue, idSet);
    var removeFromStorage = $a9f1195cdd0a4fb0$var$_.bind(function() {
        var succeeded;
        try {
            var storedQueue = this.readFromStorage();
            storedQueue = $a9f1195cdd0a4fb0$var$filterOutIDsAndInvalid(storedQueue, idSet);
            succeeded = this.saveToStorage(storedQueue);
            // an extra check: did storage report success but somehow
            // the items are still there?
            if (succeeded) {
                storedQueue = this.readFromStorage();
                for(var i = 0; i < storedQueue.length; i++){
                    var item = storedQueue[i];
                    if (item["id"] && !!idSet[item["id"]]) {
                        this.reportError("Item not removed from storage");
                        return false;
                    }
                }
            }
        } catch (err) {
            this.reportError("Error removing items", ids);
            succeeded = false;
        }
        return succeeded;
    }, this);
    this.lock.withLock(function lockAcquired() {
        var succeeded = removeFromStorage();
        if (cb) cb(succeeded);
    }, $a9f1195cdd0a4fb0$var$_.bind(function lockFailure(err) {
        var succeeded = false;
        this.reportError("Error acquiring storage lock", err);
        if (!$a9f1195cdd0a4fb0$var$localStorageSupported(this.storage, true)) {
            // Looks like localStorage writes have stopped working sometime after
            // initialization (probably full), and so nobody can acquire locks
            // anymore. Consider it temporarily safe to remove items without the
            // lock, since nobody's writing successfully anyway.
            succeeded = removeFromStorage();
            if (!succeeded) // OK, we couldn't even write out the smaller queue. Try clearing it
            // entirely.
            try {
                this.storage.removeItem(this.storageKey);
            } catch (err) {
                this.reportError("Error clearing queue", err);
            }
        }
        if (cb) cb(succeeded);
    }, this), this.pid);
};
// internal helper for RequestQueue.updatePayloads
var $a9f1195cdd0a4fb0$var$updatePayloads = function(existingItems, itemsToUpdate) {
    var newItems = [];
    $a9f1195cdd0a4fb0$var$_.each(existingItems, function(item) {
        var id = item["id"];
        if (id in itemsToUpdate) {
            var newPayload = itemsToUpdate[id];
            if (newPayload !== null) {
                item["payload"] = newPayload;
                newItems.push(item);
            }
        } else // no update
        newItems.push(item);
    });
    return newItems;
};
/**
 * Update payloads of given items in both in-memory queue and
 * persisted queue. Items set to null are removed from queues.
 */ $a9f1195cdd0a4fb0$var$RequestQueue.prototype.updatePayloads = function(itemsToUpdate, cb) {
    this.memQueue = $a9f1195cdd0a4fb0$var$updatePayloads(this.memQueue, itemsToUpdate);
    this.lock.withLock($a9f1195cdd0a4fb0$var$_.bind(function lockAcquired() {
        var succeeded;
        try {
            var storedQueue = this.readFromStorage();
            storedQueue = $a9f1195cdd0a4fb0$var$updatePayloads(storedQueue, itemsToUpdate);
            succeeded = this.saveToStorage(storedQueue);
        } catch (err) {
            this.reportError("Error updating items", itemsToUpdate);
            succeeded = false;
        }
        if (cb) cb(succeeded);
    }, this), $a9f1195cdd0a4fb0$var$_.bind(function lockFailure(err) {
        this.reportError("Error acquiring storage lock", err);
        if (cb) cb(false);
    }, this), this.pid);
};
/**
 * Read and parse items array from localStorage entry, handling
 * malformed/missing data if necessary.
 */ $a9f1195cdd0a4fb0$var$RequestQueue.prototype.readFromStorage = function() {
    var storageEntry;
    try {
        storageEntry = this.storage.getItem(this.storageKey);
        if (storageEntry) {
            storageEntry = $a9f1195cdd0a4fb0$var$JSONParse(storageEntry);
            if (!$a9f1195cdd0a4fb0$var$_.isArray(storageEntry)) {
                this.reportError("Invalid storage entry:", storageEntry);
                storageEntry = null;
            }
        }
    } catch (err) {
        this.reportError("Error retrieving queue", err);
        storageEntry = null;
    }
    return storageEntry || [];
};
/**
 * Serialize the given items array to localStorage.
 */ $a9f1195cdd0a4fb0$var$RequestQueue.prototype.saveToStorage = function(queue) {
    try {
        this.storage.setItem(this.storageKey, $a9f1195cdd0a4fb0$var$JSONStringify(queue));
        return true;
    } catch (err) {
        this.reportError("Error saving queue", err);
        return false;
    }
};
/**
 * Clear out queues (memory and localStorage).
 */ $a9f1195cdd0a4fb0$var$RequestQueue.prototype.clear = function() {
    this.memQueue = [];
    this.storage.removeItem(this.storageKey);
};
// eslint-disable-line camelcase
// maximum interval between request retries after exponential backoff
var $a9f1195cdd0a4fb0$var$MAX_RETRY_INTERVAL_MS = 600000; // 10 minutes
var $a9f1195cdd0a4fb0$var$logger = $a9f1195cdd0a4fb0$var$console_with_prefix("batch");
/**
 * RequestBatcher: manages the queueing, flushing, retry etc of requests of one
 * type (events, people, groups).
 * Uses RequestQueue to manage the backing store.
 * @constructor
 */ var $a9f1195cdd0a4fb0$var$RequestBatcher = function(storageKey, options) {
    this.errorReporter = options.errorReporter;
    this.queue = new $a9f1195cdd0a4fb0$var$RequestQueue(storageKey, {
        errorReporter: $a9f1195cdd0a4fb0$var$_.bind(this.reportError, this),
        storage: options.storage
    });
    this.libConfig = options.libConfig;
    this.sendRequest = options.sendRequestFunc;
    this.beforeSendHook = options.beforeSendHook;
    this.stopAllBatching = options.stopAllBatchingFunc;
    // seed variable batch size + flush interval with configured values
    this.batchSize = this.libConfig["batch_size"];
    this.flushInterval = this.libConfig["batch_flush_interval_ms"];
    this.stopped = !this.libConfig["batch_autostart"];
    this.consecutiveRemovalFailures = 0;
};
/**
 * Add one item to queue.
 */ $a9f1195cdd0a4fb0$var$RequestBatcher.prototype.enqueue = function(item, cb) {
    this.queue.enqueue(item, this.flushInterval, cb);
};
/**
 * Start flushing batches at the configured time interval. Must call
 * this method upon SDK init in order to send anything over the network.
 */ $a9f1195cdd0a4fb0$var$RequestBatcher.prototype.start = function() {
    this.stopped = false;
    this.consecutiveRemovalFailures = 0;
    this.flush();
};
/**
 * Stop flushing batches. Can be restarted by calling start().
 */ $a9f1195cdd0a4fb0$var$RequestBatcher.prototype.stop = function() {
    this.stopped = true;
    if (this.timeoutID) {
        clearTimeout(this.timeoutID);
        this.timeoutID = null;
    }
};
/**
 * Clear out queue.
 */ $a9f1195cdd0a4fb0$var$RequestBatcher.prototype.clear = function() {
    this.queue.clear();
};
/**
 * Restore batch size configuration to whatever is set in the main SDK.
 */ $a9f1195cdd0a4fb0$var$RequestBatcher.prototype.resetBatchSize = function() {
    this.batchSize = this.libConfig["batch_size"];
};
/**
 * Restore flush interval time configuration to whatever is set in the main SDK.
 */ $a9f1195cdd0a4fb0$var$RequestBatcher.prototype.resetFlush = function() {
    this.scheduleFlush(this.libConfig["batch_flush_interval_ms"]);
};
/**
 * Schedule the next flush in the given number of milliseconds.
 */ $a9f1195cdd0a4fb0$var$RequestBatcher.prototype.scheduleFlush = function(flushMS) {
    this.flushInterval = flushMS;
    if (!this.stopped) this.timeoutID = setTimeout($a9f1195cdd0a4fb0$var$_.bind(this.flush, this), this.flushInterval);
};
/**
 * Flush one batch to network. Depending on success/failure modes, it will either
 * remove the batch from the queue or leave it in for retry, and schedule the next
 * flush. In cases of most network or API failures, it will back off exponentially
 * when retrying.
 * @param {Object} [options]
 * @param {boolean} [options.sendBeacon] - whether to send batch with
 * navigator.sendBeacon (only useful for sending batches before page unloads, as
 * sendBeacon offers no callbacks or status indications)
 */ $a9f1195cdd0a4fb0$var$RequestBatcher.prototype.flush = function(options) {
    try {
        if (this.requestInProgress) {
            $a9f1195cdd0a4fb0$var$logger.log("Flush: Request already in progress");
            return;
        }
        options = options || {};
        var timeoutMS = this.libConfig["batch_request_timeout_ms"];
        var startTime = new Date().getTime();
        var currentBatchSize = this.batchSize;
        var batch = this.queue.fillBatch(currentBatchSize);
        var dataForRequest = [];
        var transformedItems = {};
        $a9f1195cdd0a4fb0$var$_.each(batch, function(item) {
            var payload = item["payload"];
            if (this.beforeSendHook && !item.orphaned) payload = this.beforeSendHook(payload);
            if (payload) dataForRequest.push(payload);
            transformedItems[item["id"]] = payload;
        }, this);
        if (dataForRequest.length < 1) {
            this.resetFlush();
            return; // nothing to do
        }
        this.requestInProgress = true;
        var batchSendCallback = $a9f1195cdd0a4fb0$var$_.bind(function(res) {
            this.requestInProgress = false;
            try {
                // handle API response in a try-catch to make sure we can reset the
                // flush operation if something goes wrong
                var removeItemsFromQueue = false;
                if (options.unloading) // update persisted data to include hook transformations
                this.queue.updatePayloads(transformedItems);
                else if ($a9f1195cdd0a4fb0$var$_.isObject(res) && res.error === "timeout" && new Date().getTime() - startTime >= timeoutMS) {
                    this.reportError("Network timeout; retrying");
                    this.flush();
                } else if ($a9f1195cdd0a4fb0$var$_.isObject(res) && res.xhr_req && (res.xhr_req["status"] >= 500 || res.xhr_req["status"] === 429 || res.error === "timeout")) {
                    // network or API error, or 429 Too Many Requests, retry
                    var retryMS = this.flushInterval * 2;
                    var headers = res.xhr_req["responseHeaders"];
                    if (headers) {
                        var retryAfter = headers["Retry-After"];
                        if (retryAfter) retryMS = parseInt(retryAfter, 10) * 1000 || retryMS;
                    }
                    retryMS = Math.min($a9f1195cdd0a4fb0$var$MAX_RETRY_INTERVAL_MS, retryMS);
                    this.reportError("Error; retry in " + retryMS + " ms");
                    this.scheduleFlush(retryMS);
                } else if ($a9f1195cdd0a4fb0$var$_.isObject(res) && res.xhr_req && res.xhr_req["status"] === 413) {
                    // 413 Payload Too Large
                    if (batch.length > 1) {
                        var halvedBatchSize = Math.max(1, Math.floor(currentBatchSize / 2));
                        this.batchSize = Math.min(this.batchSize, halvedBatchSize, batch.length - 1);
                        this.reportError("413 response; reducing batch size to " + this.batchSize);
                        this.resetFlush();
                    } else {
                        this.reportError("Single-event request too large; dropping", batch);
                        this.resetBatchSize();
                        removeItemsFromQueue = true;
                    }
                } else // successful network request+response; remove each item in batch from queue
                // (even if it was e.g. a 400, in which case retrying won't help)
                removeItemsFromQueue = true;
                if (removeItemsFromQueue) this.queue.removeItemsByID($a9f1195cdd0a4fb0$var$_.map(batch, function(item) {
                    return item["id"];
                }), $a9f1195cdd0a4fb0$var$_.bind(function(succeeded) {
                    if (succeeded) {
                        this.consecutiveRemovalFailures = 0;
                        this.flush(); // handle next batch if the queue isn't empty
                    } else {
                        this.reportError("Failed to remove items from queue");
                        if (++this.consecutiveRemovalFailures > 5) {
                            this.reportError("Too many queue failures; disabling batching system.");
                            this.stopAllBatching();
                        } else this.resetFlush();
                    }
                }, this));
            } catch (err) {
                this.reportError("Error handling API response", err);
                this.resetFlush();
            }
        }, this);
        var requestOptions = {
            method: "POST",
            verbose: true,
            ignore_json_errors: true,
            timeout_ms: timeoutMS // eslint-disable-line camelcase
        };
        if (options.unloading) requestOptions.transport = "sendBeacon";
        $a9f1195cdd0a4fb0$var$logger.log("MIXPANEL REQUEST:", dataForRequest);
        this.sendRequest(dataForRequest, requestOptions, batchSendCallback);
    } catch (err) {
        this.reportError("Error flushing request queue", err);
        this.resetFlush();
    }
};
/**
 * Log error to global logger and optional user-defined logger.
 */ $a9f1195cdd0a4fb0$var$RequestBatcher.prototype.reportError = function(msg, err) {
    $a9f1195cdd0a4fb0$var$logger.error.apply($a9f1195cdd0a4fb0$var$logger.error, arguments);
    if (this.errorReporter) try {
        if (!(err instanceof Error)) err = new Error(msg);
        this.errorReporter(msg, err);
    } catch (err) {
        $a9f1195cdd0a4fb0$var$logger.error(err);
    }
};
/**
 * A function used to track a Mixpanel event (e.g. MixpanelLib.track)
 * @callback trackFunction
 * @param {String} event_name The name of the event. This can be anything the user does - 'Button Click', 'Sign Up', 'Item Purchased', etc.
 * @param {Object} [properties] A set of properties to include with the event you're sending. These describe the user who did the event or details about the event itself.
 * @param {Function} [callback] If provided, the callback function will be called after tracking the event.
 */ /** Public **/ var $a9f1195cdd0a4fb0$var$GDPR_DEFAULT_PERSISTENCE_PREFIX = "__mp_opt_in_out_";
/**
 * Opt the user in to data tracking and cookies/localstorage for the given token
 * @param {string} token - Mixpanel project tracking token
 * @param {Object} [options]
 * @param {trackFunction} [options.track] - function used for tracking a Mixpanel event to record the opt-in action
 * @param {string} [options.trackEventName] - event name to be used for tracking the opt-in action
 * @param {Object} [options.trackProperties] - set of properties to be tracked along with the opt-in action
 * @param {string} [options.persistenceType] Persistence mechanism used - cookie or localStorage
 * @param {string} [options.persistencePrefix=__mp_opt_in_out] - custom prefix to be used in the cookie/localstorage name
 * @param {Number} [options.cookieExpiration] - number of days until the opt-in cookie expires
 * @param {string} [options.cookieDomain] - custom cookie domain
 * @param {boolean} [options.crossSiteCookie] - whether the opt-in cookie is set as cross-site-enabled
 * @param {boolean} [options.crossSubdomainCookie] - whether the opt-in cookie is set as cross-subdomain or not
 * @param {boolean} [options.secureCookie] - whether the opt-in cookie is set as secure or not
 */ function $a9f1195cdd0a4fb0$var$optIn(token, options) {
    $a9f1195cdd0a4fb0$var$_optInOut(true, token, options);
}
/**
 * Opt the user out of data tracking and cookies/localstorage for the given token
 * @param {string} token - Mixpanel project tracking token
 * @param {Object} [options]
 * @param {string} [options.persistenceType] Persistence mechanism used - cookie or localStorage
 * @param {string} [options.persistencePrefix=__mp_opt_in_out] - custom prefix to be used in the cookie/localstorage name
 * @param {Number} [options.cookieExpiration] - number of days until the opt-out cookie expires
 * @param {string} [options.cookieDomain] - custom cookie domain
 * @param {boolean} [options.crossSiteCookie] - whether the opt-in cookie is set as cross-site-enabled
 * @param {boolean} [options.crossSubdomainCookie] - whether the opt-out cookie is set as cross-subdomain or not
 * @param {boolean} [options.secureCookie] - whether the opt-out cookie is set as secure or not
 */ function $a9f1195cdd0a4fb0$var$optOut(token, options) {
    $a9f1195cdd0a4fb0$var$_optInOut(false, token, options);
}
/**
 * Check whether the user has opted in to data tracking and cookies/localstorage for the given token
 * @param {string} token - Mixpanel project tracking token
 * @param {Object} [options]
 * @param {string} [options.persistenceType] Persistence mechanism used - cookie or localStorage
 * @param {string} [options.persistencePrefix=__mp_opt_in_out] - custom prefix to be used in the cookie/localstorage name
 * @returns {boolean} whether the user has opted in to the given opt type
 */ function $a9f1195cdd0a4fb0$var$hasOptedIn(token, options) {
    return $a9f1195cdd0a4fb0$var$_getStorageValue(token, options) === "1";
}
/**
 * Check whether the user has opted out of data tracking and cookies/localstorage for the given token
 * @param {string} token - Mixpanel project tracking token
 * @param {Object} [options]
 * @param {string} [options.persistenceType] Persistence mechanism used - cookie or localStorage
 * @param {string} [options.persistencePrefix=__mp_opt_in_out] - custom prefix to be used in the cookie/localstorage name
 * @param {boolean} [options.ignoreDnt] - flag to ignore browser DNT settings and always return false
 * @returns {boolean} whether the user has opted out of the given opt type
 */ function $a9f1195cdd0a4fb0$var$hasOptedOut(token, options) {
    if ($a9f1195cdd0a4fb0$var$_hasDoNotTrackFlagOn(options)) {
        $a9f1195cdd0a4fb0$var$console.warn('This browser has "Do Not Track" enabled. This will prevent the Mixpanel SDK from sending any data. To ignore the "Do Not Track" browser setting, initialize the Mixpanel instance with the config "ignore_dnt: true"');
        return true;
    }
    var optedOut = $a9f1195cdd0a4fb0$var$_getStorageValue(token, options) === "0";
    if (optedOut) $a9f1195cdd0a4fb0$var$console.warn("You are opted out of Mixpanel tracking. This will prevent the Mixpanel SDK from sending any data.");
    return optedOut;
}
/**
 * Wrap a MixpanelLib method with a check for whether the user is opted out of data tracking and cookies/localstorage for the given token
 * If the user has opted out, return early instead of executing the method.
 * If a callback argument was provided, execute it passing the 0 error code.
 * @param {function} method - wrapped method to be executed if the user has not opted out
 * @returns {*} the result of executing method OR undefined if the user has opted out
 */ function $a9f1195cdd0a4fb0$var$addOptOutCheckMixpanelLib(method) {
    return $a9f1195cdd0a4fb0$var$_addOptOutCheck(method, function(name) {
        return this.get_config(name);
    });
}
/**
 * Wrap a MixpanelPeople method with a check for whether the user is opted out of data tracking and cookies/localstorage for the given token
 * If the user has opted out, return early instead of executing the method.
 * If a callback argument was provided, execute it passing the 0 error code.
 * @param {function} method - wrapped method to be executed if the user has not opted out
 * @returns {*} the result of executing method OR undefined if the user has opted out
 */ function $a9f1195cdd0a4fb0$var$addOptOutCheckMixpanelPeople(method) {
    return $a9f1195cdd0a4fb0$var$_addOptOutCheck(method, function(name) {
        return this._get_config(name);
    });
}
/**
 * Wrap a MixpanelGroup method with a check for whether the user is opted out of data tracking and cookies/localstorage for the given token
 * If the user has opted out, return early instead of executing the method.
 * If a callback argument was provided, execute it passing the 0 error code.
 * @param {function} method - wrapped method to be executed if the user has not opted out
 * @returns {*} the result of executing method OR undefined if the user has opted out
 */ function $a9f1195cdd0a4fb0$var$addOptOutCheckMixpanelGroup(method) {
    return $a9f1195cdd0a4fb0$var$_addOptOutCheck(method, function(name) {
        return this._get_config(name);
    });
}
/**
 * Clear the user's opt in/out status of data tracking and cookies/localstorage for the given token
 * @param {string} token - Mixpanel project tracking token
 * @param {Object} [options]
 * @param {string} [options.persistenceType] Persistence mechanism used - cookie or localStorage
 * @param {string} [options.persistencePrefix=__mp_opt_in_out] - custom prefix to be used in the cookie/localstorage name
 * @param {Number} [options.cookieExpiration] - number of days until the opt-in cookie expires
 * @param {string} [options.cookieDomain] - custom cookie domain
 * @param {boolean} [options.crossSiteCookie] - whether the opt-in cookie is set as cross-site-enabled
 * @param {boolean} [options.crossSubdomainCookie] - whether the opt-in cookie is set as cross-subdomain or not
 * @param {boolean} [options.secureCookie] - whether the opt-in cookie is set as secure or not
 */ function $a9f1195cdd0a4fb0$var$clearOptInOut(token, options) {
    options = options || {};
    $a9f1195cdd0a4fb0$var$_getStorage(options).remove($a9f1195cdd0a4fb0$var$_getStorageKey(token, options), !!options.crossSubdomainCookie, options.cookieDomain);
}
/** Private **/ /**
 * Get storage util
 * @param {Object} [options]
 * @param {string} [options.persistenceType]
 * @returns {object} either _.cookie or _.localstorage
 */ function $a9f1195cdd0a4fb0$var$_getStorage(options) {
    options = options || {};
    return options.persistenceType === "localStorage" ? $a9f1195cdd0a4fb0$var$_.localStorage : $a9f1195cdd0a4fb0$var$_.cookie;
}
/**
 * Get the name of the cookie that is used for the given opt type (tracking, cookie, etc.)
 * @param {string} token - Mixpanel project tracking token
 * @param {Object} [options]
 * @param {string} [options.persistencePrefix=__mp_opt_in_out] - custom prefix to be used in the cookie/localstorage name
 * @returns {string} the name of the cookie for the given opt type
 */ function $a9f1195cdd0a4fb0$var$_getStorageKey(token, options) {
    options = options || {};
    return (options.persistencePrefix || $a9f1195cdd0a4fb0$var$GDPR_DEFAULT_PERSISTENCE_PREFIX) + token;
}
/**
 * Get the value of the cookie that is used for the given opt type (tracking, cookie, etc.)
 * @param {string} token - Mixpanel project tracking token
 * @param {Object} [options]
 * @param {string} [options.persistencePrefix=__mp_opt_in_out] - custom prefix to be used in the cookie/localstorage name
 * @returns {string} the value of the cookie for the given opt type
 */ function $a9f1195cdd0a4fb0$var$_getStorageValue(token, options) {
    return $a9f1195cdd0a4fb0$var$_getStorage(options).get($a9f1195cdd0a4fb0$var$_getStorageKey(token, options));
}
/**
 * Check whether the user has set the DNT/doNotTrack setting to true in their browser
 * @param {Object} [options]
 * @param {string} [options.window] - alternate window object to check; used to force various DNT settings in browser tests
 * @param {boolean} [options.ignoreDnt] - flag to ignore browser DNT settings and always return false
 * @returns {boolean} whether the DNT setting is true
 */ function $a9f1195cdd0a4fb0$var$_hasDoNotTrackFlagOn(options) {
    if (options && options.ignoreDnt) return false;
    var win = options && options.window || $a9f1195cdd0a4fb0$var$window$1;
    var nav = win["navigator"] || {};
    var hasDntOn = false;
    $a9f1195cdd0a4fb0$var$_.each([
        nav["doNotTrack"],
        nav["msDoNotTrack"],
        win["doNotTrack"]
    ], function(dntValue) {
        if ($a9f1195cdd0a4fb0$var$_.includes([
            true,
            1,
            "1",
            "yes"
        ], dntValue)) hasDntOn = true;
    });
    return hasDntOn;
}
/**
 * Set cookie/localstorage for the user indicating that they are opted in or out for the given opt type
 * @param {boolean} optValue - whether to opt the user in or out for the given opt type
 * @param {string} token - Mixpanel project tracking token
 * @param {Object} [options]
 * @param {trackFunction} [options.track] - function used for tracking a Mixpanel event to record the opt-in action
 * @param {string} [options.trackEventName] - event name to be used for tracking the opt-in action
 * @param {Object} [options.trackProperties] - set of properties to be tracked along with the opt-in action
 * @param {string} [options.persistencePrefix=__mp_opt_in_out] - custom prefix to be used in the cookie/localstorage name
 * @param {Number} [options.cookieExpiration] - number of days until the opt-in cookie expires
 * @param {string} [options.cookieDomain] - custom cookie domain
 * @param {boolean} [options.crossSiteCookie] - whether the opt-in cookie is set as cross-site-enabled
 * @param {boolean} [options.crossSubdomainCookie] - whether the opt-in cookie is set as cross-subdomain or not
 * @param {boolean} [options.secureCookie] - whether the opt-in cookie is set as secure or not
 */ function $a9f1195cdd0a4fb0$var$_optInOut(optValue, token, options) {
    if (!$a9f1195cdd0a4fb0$var$_.isString(token) || !token.length) {
        $a9f1195cdd0a4fb0$var$console.error("gdpr." + (optValue ? "optIn" : "optOut") + " called with an invalid token");
        return;
    }
    options = options || {};
    $a9f1195cdd0a4fb0$var$_getStorage(options).set($a9f1195cdd0a4fb0$var$_getStorageKey(token, options), optValue ? 1 : 0, $a9f1195cdd0a4fb0$var$_.isNumber(options.cookieExpiration) ? options.cookieExpiration : null, !!options.crossSubdomainCookie, !!options.secureCookie, !!options.crossSiteCookie, options.cookieDomain);
    if (options.track && optValue) options.track(options.trackEventName || "$opt_in", options.trackProperties, {
        "send_immediately": true
    });
}
/**
 * Wrap a method with a check for whether the user is opted out of data tracking and cookies/localstorage for the given token
 * If the user has opted out, return early instead of executing the method.
 * If a callback argument was provided, execute it passing the 0 error code.
 * @param {function} method - wrapped method to be executed if the user has not opted out
 * @param {function} getConfigValue - getter function for the Mixpanel API token and other options to be used with opt-out check
 * @returns {*} the result of executing method OR undefined if the user has opted out
 */ function $a9f1195cdd0a4fb0$var$_addOptOutCheck(method, getConfigValue) {
    return function() {
        var optedOut = false;
        try {
            var token = getConfigValue.call(this, "token");
            var ignoreDnt = getConfigValue.call(this, "ignore_dnt");
            var persistenceType = getConfigValue.call(this, "opt_out_tracking_persistence_type");
            var persistencePrefix = getConfigValue.call(this, "opt_out_tracking_cookie_prefix");
            var win = getConfigValue.call(this, "window"); // used to override window during browser tests
            if (token) optedOut = $a9f1195cdd0a4fb0$var$hasOptedOut(token, {
                ignoreDnt: ignoreDnt,
                persistenceType: persistenceType,
                persistencePrefix: persistencePrefix,
                window: win
            });
        } catch (err) {
            $a9f1195cdd0a4fb0$var$console.error("Unexpected error when checking tracking opt-out status: " + err);
        }
        if (!optedOut) return method.apply(this, arguments);
        var callback = arguments[arguments.length - 1];
        if (typeof callback === "function") callback(0);
        return;
    };
}
/** @const */ var $a9f1195cdd0a4fb0$var$SET_ACTION = "$set";
/** @const */ var $a9f1195cdd0a4fb0$var$SET_ONCE_ACTION = "$set_once";
/** @const */ var $a9f1195cdd0a4fb0$var$UNSET_ACTION = "$unset";
/** @const */ var $a9f1195cdd0a4fb0$var$ADD_ACTION = "$add";
/** @const */ var $a9f1195cdd0a4fb0$var$APPEND_ACTION = "$append";
/** @const */ var $a9f1195cdd0a4fb0$var$UNION_ACTION = "$union";
/** @const */ var $a9f1195cdd0a4fb0$var$REMOVE_ACTION = "$remove";
/** @const */ var $a9f1195cdd0a4fb0$var$DELETE_ACTION = "$delete";
// Common internal methods for mixpanel.people and mixpanel.group APIs.
// These methods shouldn't involve network I/O.
var $a9f1195cdd0a4fb0$var$apiActions = {
    set_action: function(prop, to) {
        var data = {};
        var $set = {};
        if ($a9f1195cdd0a4fb0$var$_.isObject(prop)) $a9f1195cdd0a4fb0$var$_.each(prop, function(v, k) {
            if (!this._is_reserved_property(k)) $set[k] = v;
        }, this);
        else $set[prop] = to;
        data[$a9f1195cdd0a4fb0$var$SET_ACTION] = $set;
        return data;
    },
    unset_action: function(prop) {
        var data = {};
        var $unset = [];
        if (!$a9f1195cdd0a4fb0$var$_.isArray(prop)) prop = [
            prop
        ];
        $a9f1195cdd0a4fb0$var$_.each(prop, function(k) {
            if (!this._is_reserved_property(k)) $unset.push(k);
        }, this);
        data[$a9f1195cdd0a4fb0$var$UNSET_ACTION] = $unset;
        return data;
    },
    set_once_action: function(prop, to) {
        var data = {};
        var $set_once = {};
        if ($a9f1195cdd0a4fb0$var$_.isObject(prop)) $a9f1195cdd0a4fb0$var$_.each(prop, function(v, k) {
            if (!this._is_reserved_property(k)) $set_once[k] = v;
        }, this);
        else $set_once[prop] = to;
        data[$a9f1195cdd0a4fb0$var$SET_ONCE_ACTION] = $set_once;
        return data;
    },
    union_action: function(list_name, values) {
        var data = {};
        var $union = {};
        if ($a9f1195cdd0a4fb0$var$_.isObject(list_name)) $a9f1195cdd0a4fb0$var$_.each(list_name, function(v, k) {
            if (!this._is_reserved_property(k)) $union[k] = $a9f1195cdd0a4fb0$var$_.isArray(v) ? v : [
                v
            ];
        }, this);
        else $union[list_name] = $a9f1195cdd0a4fb0$var$_.isArray(values) ? values : [
            values
        ];
        data[$a9f1195cdd0a4fb0$var$UNION_ACTION] = $union;
        return data;
    },
    append_action: function(list_name, value) {
        var data = {};
        var $append = {};
        if ($a9f1195cdd0a4fb0$var$_.isObject(list_name)) $a9f1195cdd0a4fb0$var$_.each(list_name, function(v, k) {
            if (!this._is_reserved_property(k)) $append[k] = v;
        }, this);
        else $append[list_name] = value;
        data[$a9f1195cdd0a4fb0$var$APPEND_ACTION] = $append;
        return data;
    },
    remove_action: function(list_name, value) {
        var data = {};
        var $remove = {};
        if ($a9f1195cdd0a4fb0$var$_.isObject(list_name)) $a9f1195cdd0a4fb0$var$_.each(list_name, function(v, k) {
            if (!this._is_reserved_property(k)) $remove[k] = v;
        }, this);
        else $remove[list_name] = value;
        data[$a9f1195cdd0a4fb0$var$REMOVE_ACTION] = $remove;
        return data;
    },
    delete_action: function() {
        var data = {};
        data[$a9f1195cdd0a4fb0$var$DELETE_ACTION] = "";
        return data;
    }
};
/**
 * Mixpanel Group Object
 * @constructor
 */ var $a9f1195cdd0a4fb0$var$MixpanelGroup = function() {};
$a9f1195cdd0a4fb0$var$_.extend($a9f1195cdd0a4fb0$var$MixpanelGroup.prototype, $a9f1195cdd0a4fb0$var$apiActions);
$a9f1195cdd0a4fb0$var$MixpanelGroup.prototype._init = function(mixpanel_instance, group_key, group_id) {
    this._mixpanel = mixpanel_instance;
    this._group_key = group_key;
    this._group_id = group_id;
};
/**
 * Set properties on a group.
 *
 * ### Usage:
 *
 *     mixpanel.get_group('company', 'mixpanel').set('Location', '405 Howard');
 *
 *     // or set multiple properties at once
 *     mixpanel.get_group('company', 'mixpanel').set({
 *          'Location': '405 Howard',
 *          'Founded' : 2009,
 *     });
 *     // properties can be strings, integers, dates, or lists
 *
 * @param {Object|String} prop If a string, this is the name of the property. If an object, this is an associative array of names and values.
 * @param {*} [to] A value to set on the given property name
 * @param {Function} [callback] If provided, the callback will be called after the tracking event
 */ $a9f1195cdd0a4fb0$var$MixpanelGroup.prototype.set = $a9f1195cdd0a4fb0$var$addOptOutCheckMixpanelGroup(function(prop, to, callback) {
    var data = this.set_action(prop, to);
    if ($a9f1195cdd0a4fb0$var$_.isObject(prop)) callback = to;
    return this._send_request(data, callback);
});
/**
 * Set properties on a group, only if they do not yet exist.
 * This will not overwrite previous group property values, unlike
 * group.set().
 *
 * ### Usage:
 *
 *     mixpanel.get_group('company', 'mixpanel').set_once('Location', '405 Howard');
 *
 *     // or set multiple properties at once
 *     mixpanel.get_group('company', 'mixpanel').set_once({
 *          'Location': '405 Howard',
 *          'Founded' : 2009,
 *     });
 *     // properties can be strings, integers, lists or dates
 *
 * @param {Object|String} prop If a string, this is the name of the property. If an object, this is an associative array of names and values.
 * @param {*} [to] A value to set on the given property name
 * @param {Function} [callback] If provided, the callback will be called after the tracking event
 */ $a9f1195cdd0a4fb0$var$MixpanelGroup.prototype.set_once = $a9f1195cdd0a4fb0$var$addOptOutCheckMixpanelGroup(function(prop, to, callback) {
    var data = this.set_once_action(prop, to);
    if ($a9f1195cdd0a4fb0$var$_.isObject(prop)) callback = to;
    return this._send_request(data, callback);
});
/**
 * Unset properties on a group permanently.
 *
 * ### Usage:
 *
 *     mixpanel.get_group('company', 'mixpanel').unset('Founded');
 *
 * @param {String} prop The name of the property.
 * @param {Function} [callback] If provided, the callback will be called after the tracking event
 */ $a9f1195cdd0a4fb0$var$MixpanelGroup.prototype.unset = $a9f1195cdd0a4fb0$var$addOptOutCheckMixpanelGroup(function(prop, callback) {
    var data = this.unset_action(prop);
    return this._send_request(data, callback);
});
/**
 * Merge a given list with a list-valued group property, excluding duplicate values.
 *
 * ### Usage:
 *
 *     // merge a value to a list, creating it if needed
 *     mixpanel.get_group('company', 'mixpanel').union('Location', ['San Francisco', 'London']);
 *
 * @param {String} list_name Name of the property.
 * @param {Array} values Values to merge with the given property
 * @param {Function} [callback] If provided, the callback will be called after the tracking event
 */ $a9f1195cdd0a4fb0$var$MixpanelGroup.prototype.union = $a9f1195cdd0a4fb0$var$addOptOutCheckMixpanelGroup(function(list_name, values, callback) {
    if ($a9f1195cdd0a4fb0$var$_.isObject(list_name)) callback = values;
    var data = this.union_action(list_name, values);
    return this._send_request(data, callback);
});
/**
 * Permanently delete a group.
 *
 * ### Usage:
 *
 *     mixpanel.get_group('company', 'mixpanel').delete();
 *
 * @param {Function} [callback] If provided, the callback will be called after the tracking event
 */ $a9f1195cdd0a4fb0$var$MixpanelGroup.prototype["delete"] = $a9f1195cdd0a4fb0$var$addOptOutCheckMixpanelGroup(function(callback) {
    // bracket notation above prevents a minification error related to reserved words
    var data = this.delete_action();
    return this._send_request(data, callback);
});
/**
 * Remove a property from a group. The value will be ignored if doesn't exist.
 *
 * ### Usage:
 *
 *     mixpanel.get_group('company', 'mixpanel').remove('Location', 'London');
 *
 * @param {String} list_name Name of the property.
 * @param {Object} value Value to remove from the given group property
 * @param {Function} [callback] If provided, the callback will be called after the tracking event
 */ $a9f1195cdd0a4fb0$var$MixpanelGroup.prototype.remove = $a9f1195cdd0a4fb0$var$addOptOutCheckMixpanelGroup(function(list_name, value, callback) {
    var data = this.remove_action(list_name, value);
    return this._send_request(data, callback);
});
$a9f1195cdd0a4fb0$var$MixpanelGroup.prototype._send_request = function(data, callback) {
    data["$group_key"] = this._group_key;
    data["$group_id"] = this._group_id;
    data["$token"] = this._get_config("token");
    var date_encoded_data = $a9f1195cdd0a4fb0$var$_.encodeDates(data);
    return this._mixpanel._track_or_batch({
        type: "groups",
        data: date_encoded_data,
        endpoint: this._get_config("api_host") + "/groups/",
        batcher: this._mixpanel.request_batchers.groups
    }, callback);
};
$a9f1195cdd0a4fb0$var$MixpanelGroup.prototype._is_reserved_property = function(prop) {
    return prop === "$group_key" || prop === "$group_id";
};
$a9f1195cdd0a4fb0$var$MixpanelGroup.prototype._get_config = function(conf) {
    return this._mixpanel.get_config(conf);
};
$a9f1195cdd0a4fb0$var$MixpanelGroup.prototype.toString = function() {
    return this._mixpanel.toString() + ".group." + this._group_key + "." + this._group_id;
};
// MixpanelGroup Exports
$a9f1195cdd0a4fb0$var$MixpanelGroup.prototype["remove"] = $a9f1195cdd0a4fb0$var$MixpanelGroup.prototype.remove;
$a9f1195cdd0a4fb0$var$MixpanelGroup.prototype["set"] = $a9f1195cdd0a4fb0$var$MixpanelGroup.prototype.set;
$a9f1195cdd0a4fb0$var$MixpanelGroup.prototype["set_once"] = $a9f1195cdd0a4fb0$var$MixpanelGroup.prototype.set_once;
$a9f1195cdd0a4fb0$var$MixpanelGroup.prototype["union"] = $a9f1195cdd0a4fb0$var$MixpanelGroup.prototype.union;
$a9f1195cdd0a4fb0$var$MixpanelGroup.prototype["unset"] = $a9f1195cdd0a4fb0$var$MixpanelGroup.prototype.unset;
$a9f1195cdd0a4fb0$var$MixpanelGroup.prototype["toString"] = $a9f1195cdd0a4fb0$var$MixpanelGroup.prototype.toString;
/**
 * Mixpanel People Object
 * @constructor
 */ var $a9f1195cdd0a4fb0$var$MixpanelPeople = function() {};
$a9f1195cdd0a4fb0$var$_.extend($a9f1195cdd0a4fb0$var$MixpanelPeople.prototype, $a9f1195cdd0a4fb0$var$apiActions);
$a9f1195cdd0a4fb0$var$MixpanelPeople.prototype._init = function(mixpanel_instance) {
    this._mixpanel = mixpanel_instance;
};
/*
* Set properties on a user record.
*
* ### Usage:
*
*     mixpanel.people.set('gender', 'm');
*
*     // or set multiple properties at once
*     mixpanel.people.set({
*         'Company': 'Acme',
*         'Plan': 'Premium',
*         'Upgrade date': new Date()
*     });
*     // properties can be strings, integers, dates, or lists
*
* @param {Object|String} prop If a string, this is the name of the property. If an object, this is an associative array of names and values.
* @param {*} [to] A value to set on the given property name
* @param {Function} [callback] If provided, the callback will be called after tracking the event.
*/ $a9f1195cdd0a4fb0$var$MixpanelPeople.prototype.set = $a9f1195cdd0a4fb0$var$addOptOutCheckMixpanelPeople(function(prop, to, callback) {
    var data = this.set_action(prop, to);
    if ($a9f1195cdd0a4fb0$var$_.isObject(prop)) callback = to;
    // make sure that the referrer info has been updated and saved
    if (this._get_config("save_referrer")) this._mixpanel["persistence"].update_referrer_info(document.referrer);
    // update $set object with default people properties
    data[$a9f1195cdd0a4fb0$var$SET_ACTION] = $a9f1195cdd0a4fb0$var$_.extend({}, $a9f1195cdd0a4fb0$var$_.info.people_properties(), this._mixpanel["persistence"].get_referrer_info(), data[$a9f1195cdd0a4fb0$var$SET_ACTION]);
    return this._send_request(data, callback);
});
/*
* Set properties on a user record, only if they do not yet exist.
* This will not overwrite previous people property values, unlike
* people.set().
*
* ### Usage:
*
*     mixpanel.people.set_once('First Login Date', new Date());
*
*     // or set multiple properties at once
*     mixpanel.people.set_once({
*         'First Login Date': new Date(),
*         'Starting Plan': 'Premium'
*     });
*
*     // properties can be strings, integers or dates
*
* @param {Object|String} prop If a string, this is the name of the property. If an object, this is an associative array of names and values.
* @param {*} [to] A value to set on the given property name
* @param {Function} [callback] If provided, the callback will be called after tracking the event.
*/ $a9f1195cdd0a4fb0$var$MixpanelPeople.prototype.set_once = $a9f1195cdd0a4fb0$var$addOptOutCheckMixpanelPeople(function(prop, to, callback) {
    var data = this.set_once_action(prop, to);
    if ($a9f1195cdd0a4fb0$var$_.isObject(prop)) callback = to;
    return this._send_request(data, callback);
});
/*
* Unset properties on a user record (permanently removes the properties and their values from a profile).
*
* ### Usage:
*
*     mixpanel.people.unset('gender');
*
*     // or unset multiple properties at once
*     mixpanel.people.unset(['gender', 'Company']);
*
* @param {Array|String} prop If a string, this is the name of the property. If an array, this is a list of property names.
* @param {Function} [callback] If provided, the callback will be called after tracking the event.
*/ $a9f1195cdd0a4fb0$var$MixpanelPeople.prototype.unset = $a9f1195cdd0a4fb0$var$addOptOutCheckMixpanelPeople(function(prop, callback) {
    var data = this.unset_action(prop);
    return this._send_request(data, callback);
});
/*
* Increment/decrement numeric people analytics properties.
*
* ### Usage:
*
*     mixpanel.people.increment('page_views', 1);
*
*     // or, for convenience, if you're just incrementing a counter by
*     // 1, you can simply do
*     mixpanel.people.increment('page_views');
*
*     // to decrement a counter, pass a negative number
*     mixpanel.people.increment('credits_left', -1);
*
*     // like mixpanel.people.set(), you can increment multiple
*     // properties at once:
*     mixpanel.people.increment({
*         counter1: 1,
*         counter2: 6
*     });
*
* @param {Object|String} prop If a string, this is the name of the property. If an object, this is an associative array of names and numeric values.
* @param {Number} [by] An amount to increment the given property
* @param {Function} [callback] If provided, the callback will be called after tracking the event.
*/ $a9f1195cdd0a4fb0$var$MixpanelPeople.prototype.increment = $a9f1195cdd0a4fb0$var$addOptOutCheckMixpanelPeople(function(prop, by, callback) {
    var data = {};
    var $add = {};
    if ($a9f1195cdd0a4fb0$var$_.isObject(prop)) {
        $a9f1195cdd0a4fb0$var$_.each(prop, function(v, k) {
            if (!this._is_reserved_property(k)) {
                if (isNaN(parseFloat(v))) {
                    $a9f1195cdd0a4fb0$var$console.error("Invalid increment value passed to mixpanel.people.increment - must be a number");
                    return;
                } else $add[k] = v;
            }
        }, this);
        callback = by;
    } else {
        // convenience: mixpanel.people.increment('property'); will
        // increment 'property' by 1
        if ($a9f1195cdd0a4fb0$var$_.isUndefined(by)) by = 1;
        $add[prop] = by;
    }
    data[$a9f1195cdd0a4fb0$var$ADD_ACTION] = $add;
    return this._send_request(data, callback);
});
/*
* Append a value to a list-valued people analytics property.
*
* ### Usage:
*
*     // append a value to a list, creating it if needed
*     mixpanel.people.append('pages_visited', 'homepage');
*
*     // like mixpanel.people.set(), you can append multiple
*     // properties at once:
*     mixpanel.people.append({
*         list1: 'bob',
*         list2: 123
*     });
*
* @param {Object|String} list_name If a string, this is the name of the property. If an object, this is an associative array of names and values.
* @param {*} [value] value An item to append to the list
* @param {Function} [callback] If provided, the callback will be called after tracking the event.
*/ $a9f1195cdd0a4fb0$var$MixpanelPeople.prototype.append = $a9f1195cdd0a4fb0$var$addOptOutCheckMixpanelPeople(function(list_name, value, callback) {
    if ($a9f1195cdd0a4fb0$var$_.isObject(list_name)) callback = value;
    var data = this.append_action(list_name, value);
    return this._send_request(data, callback);
});
/*
* Remove a value from a list-valued people analytics property.
*
* ### Usage:
*
*     mixpanel.people.remove('School', 'UCB');
*
* @param {Object|String} list_name If a string, this is the name of the property. If an object, this is an associative array of names and values.
* @param {*} [value] value Item to remove from the list
* @param {Function} [callback] If provided, the callback will be called after tracking the event.
*/ $a9f1195cdd0a4fb0$var$MixpanelPeople.prototype.remove = $a9f1195cdd0a4fb0$var$addOptOutCheckMixpanelPeople(function(list_name, value, callback) {
    if ($a9f1195cdd0a4fb0$var$_.isObject(list_name)) callback = value;
    var data = this.remove_action(list_name, value);
    return this._send_request(data, callback);
});
/*
* Merge a given list with a list-valued people analytics property,
* excluding duplicate values.
*
* ### Usage:
*
*     // merge a value to a list, creating it if needed
*     mixpanel.people.union('pages_visited', 'homepage');
*
*     // like mixpanel.people.set(), you can append multiple
*     // properties at once:
*     mixpanel.people.union({
*         list1: 'bob',
*         list2: 123
*     });
*
*     // like mixpanel.people.append(), you can append multiple
*     // values to the same list:
*     mixpanel.people.union({
*         list1: ['bob', 'billy']
*     });
*
* @param {Object|String} list_name If a string, this is the name of the property. If an object, this is an associative array of names and values.
* @param {*} [value] Value / values to merge with the given property
* @param {Function} [callback] If provided, the callback will be called after tracking the event.
*/ $a9f1195cdd0a4fb0$var$MixpanelPeople.prototype.union = $a9f1195cdd0a4fb0$var$addOptOutCheckMixpanelPeople(function(list_name, values, callback) {
    if ($a9f1195cdd0a4fb0$var$_.isObject(list_name)) callback = values;
    var data = this.union_action(list_name, values);
    return this._send_request(data, callback);
});
/*
* Record that you have charged the current user a certain amount
* of money. Charges recorded with track_charge() will appear in the
* Mixpanel revenue report.
*
* ### Usage:
*
*     // charge a user $50
*     mixpanel.people.track_charge(50);
*
*     // charge a user $30.50 on the 2nd of january
*     mixpanel.people.track_charge(30.50, {
*         '$time': new Date('jan 1 2012')
*     });
*
* @param {Number} amount The amount of money charged to the current user
* @param {Object} [properties] An associative array of properties associated with the charge
* @param {Function} [callback] If provided, the callback will be called when the server responds
*/ $a9f1195cdd0a4fb0$var$MixpanelPeople.prototype.track_charge = $a9f1195cdd0a4fb0$var$addOptOutCheckMixpanelPeople(function(amount, properties, callback) {
    if (!$a9f1195cdd0a4fb0$var$_.isNumber(amount)) {
        amount = parseFloat(amount);
        if (isNaN(amount)) {
            $a9f1195cdd0a4fb0$var$console.error("Invalid value passed to mixpanel.people.track_charge - must be a number");
            return;
        }
    }
    return this.append("$transactions", $a9f1195cdd0a4fb0$var$_.extend({
        "$amount": amount
    }, properties), callback);
});
/*
* Permanently clear all revenue report transactions from the
* current user's people analytics profile.
*
* ### Usage:
*
*     mixpanel.people.clear_charges();
*
* @param {Function} [callback] If provided, the callback will be called after tracking the event.
*/ $a9f1195cdd0a4fb0$var$MixpanelPeople.prototype.clear_charges = function(callback) {
    return this.set("$transactions", [], callback);
};
/*
* Permanently deletes the current people analytics profile from
* Mixpanel (using the current distinct_id).
*
* ### Usage:
*
*     // remove the all data you have stored about the current user
*     mixpanel.people.delete_user();
*
*/ $a9f1195cdd0a4fb0$var$MixpanelPeople.prototype.delete_user = function() {
    if (!this._identify_called()) {
        $a9f1195cdd0a4fb0$var$console.error("mixpanel.people.delete_user() requires you to call identify() first");
        return;
    }
    var data = {
        "$delete": this._mixpanel.get_distinct_id()
    };
    return this._send_request(data);
};
$a9f1195cdd0a4fb0$var$MixpanelPeople.prototype.toString = function() {
    return this._mixpanel.toString() + ".people";
};
$a9f1195cdd0a4fb0$var$MixpanelPeople.prototype._send_request = function(data, callback) {
    data["$token"] = this._get_config("token");
    data["$distinct_id"] = this._mixpanel.get_distinct_id();
    var device_id = this._mixpanel.get_property("$device_id");
    var user_id = this._mixpanel.get_property("$user_id");
    var had_persisted_distinct_id = this._mixpanel.get_property("$had_persisted_distinct_id");
    if (device_id) data["$device_id"] = device_id;
    if (user_id) data["$user_id"] = user_id;
    if (had_persisted_distinct_id) data["$had_persisted_distinct_id"] = had_persisted_distinct_id;
    var date_encoded_data = $a9f1195cdd0a4fb0$var$_.encodeDates(data);
    if (!this._identify_called()) {
        this._enqueue(data);
        if (!$a9f1195cdd0a4fb0$var$_.isUndefined(callback)) {
            if (this._get_config("verbose")) callback({
                status: -1,
                error: null
            });
            else callback(-1);
        }
        return $a9f1195cdd0a4fb0$var$_.truncate(date_encoded_data, 255);
    }
    return this._mixpanel._track_or_batch({
        type: "people",
        data: date_encoded_data,
        endpoint: this._get_config("api_host") + "/engage/",
        batcher: this._mixpanel.request_batchers.people
    }, callback);
};
$a9f1195cdd0a4fb0$var$MixpanelPeople.prototype._get_config = function(conf_var) {
    return this._mixpanel.get_config(conf_var);
};
$a9f1195cdd0a4fb0$var$MixpanelPeople.prototype._identify_called = function() {
    return this._mixpanel._flags.identify_called === true;
};
// Queue up engage operations if identify hasn't been called yet.
$a9f1195cdd0a4fb0$var$MixpanelPeople.prototype._enqueue = function(data) {
    if ($a9f1195cdd0a4fb0$var$SET_ACTION in data) this._mixpanel["persistence"]._add_to_people_queue($a9f1195cdd0a4fb0$var$SET_ACTION, data);
    else if ($a9f1195cdd0a4fb0$var$SET_ONCE_ACTION in data) this._mixpanel["persistence"]._add_to_people_queue($a9f1195cdd0a4fb0$var$SET_ONCE_ACTION, data);
    else if ($a9f1195cdd0a4fb0$var$UNSET_ACTION in data) this._mixpanel["persistence"]._add_to_people_queue($a9f1195cdd0a4fb0$var$UNSET_ACTION, data);
    else if ($a9f1195cdd0a4fb0$var$ADD_ACTION in data) this._mixpanel["persistence"]._add_to_people_queue($a9f1195cdd0a4fb0$var$ADD_ACTION, data);
    else if ($a9f1195cdd0a4fb0$var$APPEND_ACTION in data) this._mixpanel["persistence"]._add_to_people_queue($a9f1195cdd0a4fb0$var$APPEND_ACTION, data);
    else if ($a9f1195cdd0a4fb0$var$REMOVE_ACTION in data) this._mixpanel["persistence"]._add_to_people_queue($a9f1195cdd0a4fb0$var$REMOVE_ACTION, data);
    else if ($a9f1195cdd0a4fb0$var$UNION_ACTION in data) this._mixpanel["persistence"]._add_to_people_queue($a9f1195cdd0a4fb0$var$UNION_ACTION, data);
    else $a9f1195cdd0a4fb0$var$console.error("Invalid call to _enqueue():", data);
};
$a9f1195cdd0a4fb0$var$MixpanelPeople.prototype._flush_one_queue = function(action, action_method, callback, queue_to_params_fn) {
    var _this = this;
    var queued_data = $a9f1195cdd0a4fb0$var$_.extend({}, this._mixpanel["persistence"]._get_queue(action));
    var action_params = queued_data;
    if (!$a9f1195cdd0a4fb0$var$_.isUndefined(queued_data) && $a9f1195cdd0a4fb0$var$_.isObject(queued_data) && !$a9f1195cdd0a4fb0$var$_.isEmptyObject(queued_data)) {
        _this._mixpanel["persistence"]._pop_from_people_queue(action, queued_data);
        if (queue_to_params_fn) action_params = queue_to_params_fn(queued_data);
        action_method.call(_this, action_params, function(response, data) {
            // on bad response, we want to add it back to the queue
            if (response === 0) _this._mixpanel["persistence"]._add_to_people_queue(action, queued_data);
            if (!$a9f1195cdd0a4fb0$var$_.isUndefined(callback)) callback(response, data);
        });
    }
};
// Flush queued engage operations - order does not matter,
// and there are network level race conditions anyway
$a9f1195cdd0a4fb0$var$MixpanelPeople.prototype._flush = function(_set_callback, _add_callback, _append_callback, _set_once_callback, _union_callback, _unset_callback, _remove_callback) {
    var _this = this;
    var $append_queue = this._mixpanel["persistence"]._get_queue($a9f1195cdd0a4fb0$var$APPEND_ACTION);
    var $remove_queue = this._mixpanel["persistence"]._get_queue($a9f1195cdd0a4fb0$var$REMOVE_ACTION);
    this._flush_one_queue($a9f1195cdd0a4fb0$var$SET_ACTION, this.set, _set_callback);
    this._flush_one_queue($a9f1195cdd0a4fb0$var$SET_ONCE_ACTION, this.set_once, _set_once_callback);
    this._flush_one_queue($a9f1195cdd0a4fb0$var$UNSET_ACTION, this.unset, _unset_callback, function(queue) {
        return $a9f1195cdd0a4fb0$var$_.keys(queue);
    });
    this._flush_one_queue($a9f1195cdd0a4fb0$var$ADD_ACTION, this.increment, _add_callback);
    this._flush_one_queue($a9f1195cdd0a4fb0$var$UNION_ACTION, this.union, _union_callback);
    // we have to fire off each $append individually since there is
    // no concat method server side
    if (!$a9f1195cdd0a4fb0$var$_.isUndefined($append_queue) && $a9f1195cdd0a4fb0$var$_.isArray($append_queue) && $append_queue.length) {
        var $append_item;
        var append_callback = function(response, data) {
            if (response === 0) _this._mixpanel["persistence"]._add_to_people_queue($a9f1195cdd0a4fb0$var$APPEND_ACTION, $append_item);
            if (!$a9f1195cdd0a4fb0$var$_.isUndefined(_append_callback)) _append_callback(response, data);
        };
        for(var i = $append_queue.length - 1; i >= 0; i--){
            $append_item = $append_queue.pop();
            if (!$a9f1195cdd0a4fb0$var$_.isEmptyObject($append_item)) _this.append($append_item, append_callback);
        }
        // Save the shortened append queue
        _this._mixpanel["persistence"].save();
    }
    // same for $remove
    if (!$a9f1195cdd0a4fb0$var$_.isUndefined($remove_queue) && $a9f1195cdd0a4fb0$var$_.isArray($remove_queue) && $remove_queue.length) {
        var $remove_item;
        var remove_callback = function(response, data) {
            if (response === 0) _this._mixpanel["persistence"]._add_to_people_queue($a9f1195cdd0a4fb0$var$REMOVE_ACTION, $remove_item);
            if (!$a9f1195cdd0a4fb0$var$_.isUndefined(_remove_callback)) _remove_callback(response, data);
        };
        for(var j = $remove_queue.length - 1; j >= 0; j--){
            $remove_item = $remove_queue.pop();
            if (!$a9f1195cdd0a4fb0$var$_.isEmptyObject($remove_item)) _this.remove($remove_item, remove_callback);
        }
        _this._mixpanel["persistence"].save();
    }
};
$a9f1195cdd0a4fb0$var$MixpanelPeople.prototype._is_reserved_property = function(prop) {
    return prop === "$distinct_id" || prop === "$token" || prop === "$device_id" || prop === "$user_id" || prop === "$had_persisted_distinct_id";
};
// MixpanelPeople Exports
$a9f1195cdd0a4fb0$var$MixpanelPeople.prototype["set"] = $a9f1195cdd0a4fb0$var$MixpanelPeople.prototype.set;
$a9f1195cdd0a4fb0$var$MixpanelPeople.prototype["set_once"] = $a9f1195cdd0a4fb0$var$MixpanelPeople.prototype.set_once;
$a9f1195cdd0a4fb0$var$MixpanelPeople.prototype["unset"] = $a9f1195cdd0a4fb0$var$MixpanelPeople.prototype.unset;
$a9f1195cdd0a4fb0$var$MixpanelPeople.prototype["increment"] = $a9f1195cdd0a4fb0$var$MixpanelPeople.prototype.increment;
$a9f1195cdd0a4fb0$var$MixpanelPeople.prototype["append"] = $a9f1195cdd0a4fb0$var$MixpanelPeople.prototype.append;
$a9f1195cdd0a4fb0$var$MixpanelPeople.prototype["remove"] = $a9f1195cdd0a4fb0$var$MixpanelPeople.prototype.remove;
$a9f1195cdd0a4fb0$var$MixpanelPeople.prototype["union"] = $a9f1195cdd0a4fb0$var$MixpanelPeople.prototype.union;
$a9f1195cdd0a4fb0$var$MixpanelPeople.prototype["track_charge"] = $a9f1195cdd0a4fb0$var$MixpanelPeople.prototype.track_charge;
$a9f1195cdd0a4fb0$var$MixpanelPeople.prototype["clear_charges"] = $a9f1195cdd0a4fb0$var$MixpanelPeople.prototype.clear_charges;
$a9f1195cdd0a4fb0$var$MixpanelPeople.prototype["delete_user"] = $a9f1195cdd0a4fb0$var$MixpanelPeople.prototype.delete_user;
$a9f1195cdd0a4fb0$var$MixpanelPeople.prototype["toString"] = $a9f1195cdd0a4fb0$var$MixpanelPeople.prototype.toString;
/*
 * Constants
 */ /** @const */ var $a9f1195cdd0a4fb0$var$SET_QUEUE_KEY = "__mps";
/** @const */ var $a9f1195cdd0a4fb0$var$SET_ONCE_QUEUE_KEY = "__mpso";
/** @const */ var $a9f1195cdd0a4fb0$var$UNSET_QUEUE_KEY = "__mpus";
/** @const */ var $a9f1195cdd0a4fb0$var$ADD_QUEUE_KEY = "__mpa";
/** @const */ var $a9f1195cdd0a4fb0$var$APPEND_QUEUE_KEY = "__mpap";
/** @const */ var $a9f1195cdd0a4fb0$var$REMOVE_QUEUE_KEY = "__mpr";
/** @const */ var $a9f1195cdd0a4fb0$var$UNION_QUEUE_KEY = "__mpu";
// This key is deprecated, but we want to check for it to see whether aliasing is allowed.
/** @const */ var $a9f1195cdd0a4fb0$var$PEOPLE_DISTINCT_ID_KEY = "$people_distinct_id";
/** @const */ var $a9f1195cdd0a4fb0$var$ALIAS_ID_KEY = "__alias";
/** @const */ var $a9f1195cdd0a4fb0$var$EVENT_TIMERS_KEY = "__timers";
/** @const */ var $a9f1195cdd0a4fb0$var$RESERVED_PROPERTIES = [
    $a9f1195cdd0a4fb0$var$SET_QUEUE_KEY,
    $a9f1195cdd0a4fb0$var$SET_ONCE_QUEUE_KEY,
    $a9f1195cdd0a4fb0$var$UNSET_QUEUE_KEY,
    $a9f1195cdd0a4fb0$var$ADD_QUEUE_KEY,
    $a9f1195cdd0a4fb0$var$APPEND_QUEUE_KEY,
    $a9f1195cdd0a4fb0$var$REMOVE_QUEUE_KEY,
    $a9f1195cdd0a4fb0$var$UNION_QUEUE_KEY,
    $a9f1195cdd0a4fb0$var$PEOPLE_DISTINCT_ID_KEY,
    $a9f1195cdd0a4fb0$var$ALIAS_ID_KEY,
    $a9f1195cdd0a4fb0$var$EVENT_TIMERS_KEY
];
/**
 * Mixpanel Persistence Object
 * @constructor
 */ var $a9f1195cdd0a4fb0$var$MixpanelPersistence = function(config) {
    this["props"] = {};
    this.campaign_params_saved = false;
    if (config["persistence_name"]) this.name = "mp_" + config["persistence_name"];
    else this.name = "mp_" + config["token"] + "_mixpanel";
    var storage_type = config["persistence"];
    if (storage_type !== "cookie" && storage_type !== "localStorage") {
        $a9f1195cdd0a4fb0$var$console.critical("Unknown persistence type " + storage_type + "; falling back to cookie");
        storage_type = config["persistence"] = "cookie";
    }
    if (storage_type === "localStorage" && $a9f1195cdd0a4fb0$var$_.localStorage.is_supported()) this.storage = $a9f1195cdd0a4fb0$var$_.localStorage;
    else this.storage = $a9f1195cdd0a4fb0$var$_.cookie;
    this.load();
    this.update_config(config);
    this.upgrade(config);
    this.save();
};
$a9f1195cdd0a4fb0$var$MixpanelPersistence.prototype.properties = function() {
    var p = {};
    // Filter out reserved properties
    $a9f1195cdd0a4fb0$var$_.each(this["props"], function(v, k) {
        if (!$a9f1195cdd0a4fb0$var$_.include($a9f1195cdd0a4fb0$var$RESERVED_PROPERTIES, k)) p[k] = v;
    });
    return p;
};
$a9f1195cdd0a4fb0$var$MixpanelPersistence.prototype.load = function() {
    if (this.disabled) return;
    var entry = this.storage.parse(this.name);
    if (entry) this["props"] = $a9f1195cdd0a4fb0$var$_.extend({}, entry);
};
$a9f1195cdd0a4fb0$var$MixpanelPersistence.prototype.upgrade = function(config) {
    var upgrade_from_old_lib = config["upgrade"], old_cookie_name, old_cookie;
    if (upgrade_from_old_lib) {
        old_cookie_name = "mp_super_properties";
        // Case where they had a custom cookie name before.
        if (typeof upgrade_from_old_lib === "string") old_cookie_name = upgrade_from_old_lib;
        old_cookie = this.storage.parse(old_cookie_name);
        // remove the cookie
        this.storage.remove(old_cookie_name);
        this.storage.remove(old_cookie_name, true);
        if (old_cookie) this["props"] = $a9f1195cdd0a4fb0$var$_.extend(this["props"], old_cookie["all"], old_cookie["events"]);
    }
    if (!config["cookie_name"] && config["name"] !== "mixpanel") {
        // special case to handle people with cookies of the form
        // mp_TOKEN_INSTANCENAME from the first release of this library
        old_cookie_name = "mp_" + config["token"] + "_" + config["name"];
        old_cookie = this.storage.parse(old_cookie_name);
        if (old_cookie) {
            this.storage.remove(old_cookie_name);
            this.storage.remove(old_cookie_name, true);
            // Save the prop values that were in the cookie from before -
            // this should only happen once as we delete the old one.
            this.register_once(old_cookie);
        }
    }
    if (this.storage === $a9f1195cdd0a4fb0$var$_.localStorage) {
        old_cookie = $a9f1195cdd0a4fb0$var$_.cookie.parse(this.name);
        $a9f1195cdd0a4fb0$var$_.cookie.remove(this.name);
        $a9f1195cdd0a4fb0$var$_.cookie.remove(this.name, true);
        if (old_cookie) this.register_once(old_cookie);
    }
};
$a9f1195cdd0a4fb0$var$MixpanelPersistence.prototype.save = function() {
    if (this.disabled) return;
    this.storage.set(this.name, $a9f1195cdd0a4fb0$var$_.JSONEncode(this["props"]), this.expire_days, this.cross_subdomain, this.secure, this.cross_site, this.cookie_domain);
};
$a9f1195cdd0a4fb0$var$MixpanelPersistence.prototype.remove = function() {
    // remove both domain and subdomain cookies
    this.storage.remove(this.name, false, this.cookie_domain);
    this.storage.remove(this.name, true, this.cookie_domain);
};
// removes the storage entry and deletes all loaded data
// forced name for tests
$a9f1195cdd0a4fb0$var$MixpanelPersistence.prototype.clear = function() {
    this.remove();
    this["props"] = {};
};
/**
* @param {Object} props
* @param {*=} default_value
* @param {number=} days
*/ $a9f1195cdd0a4fb0$var$MixpanelPersistence.prototype.register_once = function(props, default_value, days) {
    if ($a9f1195cdd0a4fb0$var$_.isObject(props)) {
        if (typeof default_value === "undefined") default_value = "None";
        this.expire_days = typeof days === "undefined" ? this.default_expiry : days;
        $a9f1195cdd0a4fb0$var$_.each(props, function(val, prop) {
            if (!this["props"].hasOwnProperty(prop) || this["props"][prop] === default_value) this["props"][prop] = val;
        }, this);
        this.save();
        return true;
    }
    return false;
};
/**
* @param {Object} props
* @param {number=} days
*/ $a9f1195cdd0a4fb0$var$MixpanelPersistence.prototype.register = function(props, days) {
    if ($a9f1195cdd0a4fb0$var$_.isObject(props)) {
        this.expire_days = typeof days === "undefined" ? this.default_expiry : days;
        $a9f1195cdd0a4fb0$var$_.extend(this["props"], props);
        this.save();
        return true;
    }
    return false;
};
$a9f1195cdd0a4fb0$var$MixpanelPersistence.prototype.unregister = function(prop) {
    if (prop in this["props"]) {
        delete this["props"][prop];
        this.save();
    }
};
$a9f1195cdd0a4fb0$var$MixpanelPersistence.prototype.update_campaign_params = function() {
    if (!this.campaign_params_saved) {
        this.register_once($a9f1195cdd0a4fb0$var$_.info.campaignParams());
        this.campaign_params_saved = true;
    }
};
$a9f1195cdd0a4fb0$var$MixpanelPersistence.prototype.update_search_keyword = function(referrer) {
    this.register($a9f1195cdd0a4fb0$var$_.info.searchInfo(referrer));
};
// EXPORTED METHOD, we test this directly.
$a9f1195cdd0a4fb0$var$MixpanelPersistence.prototype.update_referrer_info = function(referrer) {
    // If referrer doesn't exist, we want to note the fact that it was type-in traffic.
    this.register_once({
        "$initial_referrer": referrer || "$direct",
        "$initial_referring_domain": $a9f1195cdd0a4fb0$var$_.info.referringDomain(referrer) || "$direct"
    }, "");
};
$a9f1195cdd0a4fb0$var$MixpanelPersistence.prototype.get_referrer_info = function() {
    return $a9f1195cdd0a4fb0$var$_.strip_empty_properties({
        "$initial_referrer": this["props"]["$initial_referrer"],
        "$initial_referring_domain": this["props"]["$initial_referring_domain"]
    });
};
// safely fills the passed in object with stored properties,
// does not override any properties defined in both
// returns the passed in object
$a9f1195cdd0a4fb0$var$MixpanelPersistence.prototype.safe_merge = function(props) {
    $a9f1195cdd0a4fb0$var$_.each(this["props"], function(val, prop) {
        if (!(prop in props)) props[prop] = val;
    });
    return props;
};
$a9f1195cdd0a4fb0$var$MixpanelPersistence.prototype.update_config = function(config) {
    this.default_expiry = this.expire_days = config["cookie_expiration"];
    this.set_disabled(config["disable_persistence"]);
    this.set_cookie_domain(config["cookie_domain"]);
    this.set_cross_site(config["cross_site_cookie"]);
    this.set_cross_subdomain(config["cross_subdomain_cookie"]);
    this.set_secure(config["secure_cookie"]);
};
$a9f1195cdd0a4fb0$var$MixpanelPersistence.prototype.set_disabled = function(disabled) {
    this.disabled = disabled;
    if (this.disabled) this.remove();
    else this.save();
};
$a9f1195cdd0a4fb0$var$MixpanelPersistence.prototype.set_cookie_domain = function(cookie_domain) {
    if (cookie_domain !== this.cookie_domain) {
        this.remove();
        this.cookie_domain = cookie_domain;
        this.save();
    }
};
$a9f1195cdd0a4fb0$var$MixpanelPersistence.prototype.set_cross_site = function(cross_site) {
    if (cross_site !== this.cross_site) {
        this.cross_site = cross_site;
        this.remove();
        this.save();
    }
};
$a9f1195cdd0a4fb0$var$MixpanelPersistence.prototype.set_cross_subdomain = function(cross_subdomain) {
    if (cross_subdomain !== this.cross_subdomain) {
        this.cross_subdomain = cross_subdomain;
        this.remove();
        this.save();
    }
};
$a9f1195cdd0a4fb0$var$MixpanelPersistence.prototype.get_cross_subdomain = function() {
    return this.cross_subdomain;
};
$a9f1195cdd0a4fb0$var$MixpanelPersistence.prototype.set_secure = function(secure) {
    if (secure !== this.secure) {
        this.secure = secure ? true : false;
        this.remove();
        this.save();
    }
};
$a9f1195cdd0a4fb0$var$MixpanelPersistence.prototype._add_to_people_queue = function(queue, data) {
    var q_key = this._get_queue_key(queue), q_data = data[queue], set_q = this._get_or_create_queue($a9f1195cdd0a4fb0$var$SET_ACTION), set_once_q = this._get_or_create_queue($a9f1195cdd0a4fb0$var$SET_ONCE_ACTION), unset_q = this._get_or_create_queue($a9f1195cdd0a4fb0$var$UNSET_ACTION), add_q = this._get_or_create_queue($a9f1195cdd0a4fb0$var$ADD_ACTION), union_q = this._get_or_create_queue($a9f1195cdd0a4fb0$var$UNION_ACTION), remove_q = this._get_or_create_queue($a9f1195cdd0a4fb0$var$REMOVE_ACTION, []), append_q = this._get_or_create_queue($a9f1195cdd0a4fb0$var$APPEND_ACTION, []);
    if (q_key === $a9f1195cdd0a4fb0$var$SET_QUEUE_KEY) {
        // Update the set queue - we can override any existing values
        $a9f1195cdd0a4fb0$var$_.extend(set_q, q_data);
        // if there was a pending increment, override it
        // with the set.
        this._pop_from_people_queue($a9f1195cdd0a4fb0$var$ADD_ACTION, q_data);
        // if there was a pending union, override it
        // with the set.
        this._pop_from_people_queue($a9f1195cdd0a4fb0$var$UNION_ACTION, q_data);
        this._pop_from_people_queue($a9f1195cdd0a4fb0$var$UNSET_ACTION, q_data);
    } else if (q_key === $a9f1195cdd0a4fb0$var$SET_ONCE_QUEUE_KEY) {
        // only queue the data if there is not already a set_once call for it.
        $a9f1195cdd0a4fb0$var$_.each(q_data, function(v, k) {
            if (!(k in set_once_q)) set_once_q[k] = v;
        });
        this._pop_from_people_queue($a9f1195cdd0a4fb0$var$UNSET_ACTION, q_data);
    } else if (q_key === $a9f1195cdd0a4fb0$var$UNSET_QUEUE_KEY) $a9f1195cdd0a4fb0$var$_.each(q_data, function(prop) {
        // undo previously-queued actions on this key
        $a9f1195cdd0a4fb0$var$_.each([
            set_q,
            set_once_q,
            add_q,
            union_q
        ], function(enqueued_obj) {
            if (prop in enqueued_obj) delete enqueued_obj[prop];
        });
        $a9f1195cdd0a4fb0$var$_.each(append_q, function(append_obj) {
            if (prop in append_obj) delete append_obj[prop];
        });
        unset_q[prop] = true;
    });
    else if (q_key === $a9f1195cdd0a4fb0$var$ADD_QUEUE_KEY) {
        $a9f1195cdd0a4fb0$var$_.each(q_data, function(v, k) {
            // If it exists in the set queue, increment
            // the value
            if (k in set_q) set_q[k] += v;
            else {
                // If it doesn't exist, update the add
                // queue
                if (!(k in add_q)) add_q[k] = 0;
                add_q[k] += v;
            }
        }, this);
        this._pop_from_people_queue($a9f1195cdd0a4fb0$var$UNSET_ACTION, q_data);
    } else if (q_key === $a9f1195cdd0a4fb0$var$UNION_QUEUE_KEY) {
        $a9f1195cdd0a4fb0$var$_.each(q_data, function(v, k) {
            if ($a9f1195cdd0a4fb0$var$_.isArray(v)) {
                if (!(k in union_q)) union_q[k] = [];
                // We may send duplicates, the server will dedup them.
                union_q[k] = union_q[k].concat(v);
            }
        });
        this._pop_from_people_queue($a9f1195cdd0a4fb0$var$UNSET_ACTION, q_data);
    } else if (q_key === $a9f1195cdd0a4fb0$var$REMOVE_QUEUE_KEY) {
        remove_q.push(q_data);
        this._pop_from_people_queue($a9f1195cdd0a4fb0$var$APPEND_ACTION, q_data);
    } else if (q_key === $a9f1195cdd0a4fb0$var$APPEND_QUEUE_KEY) {
        append_q.push(q_data);
        this._pop_from_people_queue($a9f1195cdd0a4fb0$var$UNSET_ACTION, q_data);
    }
    $a9f1195cdd0a4fb0$var$console.log("MIXPANEL PEOPLE REQUEST (QUEUED, PENDING IDENTIFY):");
    $a9f1195cdd0a4fb0$var$console.log(data);
    this.save();
};
$a9f1195cdd0a4fb0$var$MixpanelPersistence.prototype._pop_from_people_queue = function(queue, data) {
    var q = this._get_queue(queue);
    if (!$a9f1195cdd0a4fb0$var$_.isUndefined(q)) {
        $a9f1195cdd0a4fb0$var$_.each(data, function(v, k) {
            if (queue === $a9f1195cdd0a4fb0$var$APPEND_ACTION || queue === $a9f1195cdd0a4fb0$var$REMOVE_ACTION) // list actions: only remove if both k+v match
            // e.g. remove should not override append in a case like
            // append({foo: 'bar'}); remove({foo: 'qux'})
            $a9f1195cdd0a4fb0$var$_.each(q, function(queued_action) {
                if (queued_action[k] === v) delete queued_action[k];
            });
            else delete q[k];
        }, this);
        this.save();
    }
};
$a9f1195cdd0a4fb0$var$MixpanelPersistence.prototype._get_queue_key = function(queue) {
    if (queue === $a9f1195cdd0a4fb0$var$SET_ACTION) return $a9f1195cdd0a4fb0$var$SET_QUEUE_KEY;
    else if (queue === $a9f1195cdd0a4fb0$var$SET_ONCE_ACTION) return $a9f1195cdd0a4fb0$var$SET_ONCE_QUEUE_KEY;
    else if (queue === $a9f1195cdd0a4fb0$var$UNSET_ACTION) return $a9f1195cdd0a4fb0$var$UNSET_QUEUE_KEY;
    else if (queue === $a9f1195cdd0a4fb0$var$ADD_ACTION) return $a9f1195cdd0a4fb0$var$ADD_QUEUE_KEY;
    else if (queue === $a9f1195cdd0a4fb0$var$APPEND_ACTION) return $a9f1195cdd0a4fb0$var$APPEND_QUEUE_KEY;
    else if (queue === $a9f1195cdd0a4fb0$var$REMOVE_ACTION) return $a9f1195cdd0a4fb0$var$REMOVE_QUEUE_KEY;
    else if (queue === $a9f1195cdd0a4fb0$var$UNION_ACTION) return $a9f1195cdd0a4fb0$var$UNION_QUEUE_KEY;
    else $a9f1195cdd0a4fb0$var$console.error("Invalid queue:", queue);
};
$a9f1195cdd0a4fb0$var$MixpanelPersistence.prototype._get_queue = function(queue) {
    return this["props"][this._get_queue_key(queue)];
};
$a9f1195cdd0a4fb0$var$MixpanelPersistence.prototype._get_or_create_queue = function(queue, default_val) {
    var key = this._get_queue_key(queue);
    default_val = $a9f1195cdd0a4fb0$var$_.isUndefined(default_val) ? {} : default_val;
    return this["props"][key] || (this["props"][key] = default_val);
};
$a9f1195cdd0a4fb0$var$MixpanelPersistence.prototype.set_event_timer = function(event_name, timestamp) {
    var timers = this["props"][$a9f1195cdd0a4fb0$var$EVENT_TIMERS_KEY] || {};
    timers[event_name] = timestamp;
    this["props"][$a9f1195cdd0a4fb0$var$EVENT_TIMERS_KEY] = timers;
    this.save();
};
$a9f1195cdd0a4fb0$var$MixpanelPersistence.prototype.remove_event_timer = function(event_name) {
    var timers = this["props"][$a9f1195cdd0a4fb0$var$EVENT_TIMERS_KEY] || {};
    var timestamp = timers[event_name];
    if (!$a9f1195cdd0a4fb0$var$_.isUndefined(timestamp)) {
        delete this["props"][$a9f1195cdd0a4fb0$var$EVENT_TIMERS_KEY][event_name];
        this.save();
    }
    return timestamp;
};
/*
 * Mixpanel JS Library
 *
 * Copyright 2012, Mixpanel, Inc. All Rights Reserved
 * http://mixpanel.com/
 *
 * Includes portions of Underscore.js
 * http://documentcloud.github.com/underscore/
 * (c) 2011 Jeremy Ashkenas, DocumentCloud Inc.
 * Released under the MIT License.
 */ // ==ClosureCompiler==
// @compilation_level ADVANCED_OPTIMIZATIONS
// @output_file_name mixpanel-2.8.min.js
// ==/ClosureCompiler==
/*
SIMPLE STYLE GUIDE:

this.x === public function
this._x === internal - only use within this file
this.__x === private - only use within the class

Globals should be all caps
*/ var $a9f1195cdd0a4fb0$var$init_type; // MODULE or SNIPPET loader
var $a9f1195cdd0a4fb0$var$mixpanel_master; // main mixpanel instance / object
var $a9f1195cdd0a4fb0$var$INIT_MODULE = 0;
var $a9f1195cdd0a4fb0$var$INIT_SNIPPET = 1;
var $a9f1195cdd0a4fb0$var$IDENTITY_FUNC = function(x) {
    return x;
};
var $a9f1195cdd0a4fb0$var$NOOP_FUNC = function() {};
/** @const */ var $a9f1195cdd0a4fb0$var$PRIMARY_INSTANCE_NAME = "mixpanel";
/** @const */ var $a9f1195cdd0a4fb0$var$PAYLOAD_TYPE_BASE64 = "base64";
/** @const */ var $a9f1195cdd0a4fb0$var$PAYLOAD_TYPE_JSON = "json";
/*
 * Dynamic... constants? Is that an oxymoron?
 */ // http://hacks.mozilla.org/2009/07/cross-site-xmlhttprequest-with-cors/
// https://developer.mozilla.org/en-US/docs/DOM/XMLHttpRequest#withCredentials
var $a9f1195cdd0a4fb0$var$USE_XHR = $a9f1195cdd0a4fb0$var$window$1.XMLHttpRequest && "withCredentials" in new XMLHttpRequest();
// IE<10 does not support cross-origin XHR's but script tags
// with defer won't block window.onload; ENQUEUE_REQUESTS
// should only be true for Opera<12
var $a9f1195cdd0a4fb0$var$ENQUEUE_REQUESTS = !$a9f1195cdd0a4fb0$var$USE_XHR && $a9f1195cdd0a4fb0$var$userAgent.indexOf("MSIE") === -1 && $a9f1195cdd0a4fb0$var$userAgent.indexOf("Mozilla") === -1;
// save reference to navigator.sendBeacon so it can be minified
var $a9f1195cdd0a4fb0$var$sendBeacon = null;
if ($a9f1195cdd0a4fb0$var$navigator["sendBeacon"]) $a9f1195cdd0a4fb0$var$sendBeacon = function() {
    // late reference to navigator.sendBeacon to allow patching/spying
    return $a9f1195cdd0a4fb0$var$navigator["sendBeacon"].apply($a9f1195cdd0a4fb0$var$navigator, arguments);
};
/*
 * Module-level globals
 */ var $a9f1195cdd0a4fb0$var$DEFAULT_CONFIG = {
    "api_host": "https://api-js.mixpanel.com",
    "api_method": "POST",
    "api_transport": "XHR",
    "api_payload_format": $a9f1195cdd0a4fb0$var$PAYLOAD_TYPE_BASE64,
    "app_host": "https://mixpanel.com",
    "cdn": "https://cdn.mxpnl.com",
    "cross_site_cookie": false,
    "cross_subdomain_cookie": true,
    "error_reporter": $a9f1195cdd0a4fb0$var$NOOP_FUNC,
    "persistence": "cookie",
    "persistence_name": "",
    "cookie_domain": "",
    "cookie_name": "",
    "loaded": $a9f1195cdd0a4fb0$var$NOOP_FUNC,
    "store_google": true,
    "save_referrer": true,
    "test": false,
    "verbose": false,
    "img": false,
    "debug": false,
    "track_links_timeout": 300,
    "cookie_expiration": 365,
    "upgrade": false,
    "disable_persistence": false,
    "disable_cookie": false,
    "secure_cookie": false,
    "ip": true,
    "opt_out_tracking_by_default": false,
    "opt_out_persistence_by_default": false,
    "opt_out_tracking_persistence_type": "localStorage",
    "opt_out_tracking_cookie_prefix": null,
    "property_blacklist": [],
    "xhr_headers": {},
    "ignore_dnt": false,
    "batch_requests": true,
    "batch_size": 50,
    "batch_flush_interval_ms": 5000,
    "batch_request_timeout_ms": 90000,
    "batch_autostart": true,
    "hooks": {}
};
var $a9f1195cdd0a4fb0$var$DOM_LOADED = false;
/**
 * Mixpanel Library Object
 * @constructor
 */ var $a9f1195cdd0a4fb0$var$MixpanelLib = function() {};
/**
 * create_mplib(token:string, config:object, name:string)
 *
 * This function is used by the init method of MixpanelLib objects
 * as well as the main initializer at the end of the JSLib (that
 * initializes document.mixpanel as well as any additional instances
 * declared before this file has loaded).
 */ var $a9f1195cdd0a4fb0$var$create_mplib = function(token, config, name) {
    var instance, target = name === $a9f1195cdd0a4fb0$var$PRIMARY_INSTANCE_NAME ? $a9f1195cdd0a4fb0$var$mixpanel_master : $a9f1195cdd0a4fb0$var$mixpanel_master[name];
    if (target && $a9f1195cdd0a4fb0$var$init_type === $a9f1195cdd0a4fb0$var$INIT_MODULE) instance = target;
    else {
        if (target && !$a9f1195cdd0a4fb0$var$_.isArray(target)) {
            $a9f1195cdd0a4fb0$var$console.error("You have already initialized " + name);
            return;
        }
        instance = new $a9f1195cdd0a4fb0$var$MixpanelLib();
    }
    instance._cached_groups = {}; // cache groups in a pool
    instance._init(token, config, name);
    instance["people"] = new $a9f1195cdd0a4fb0$var$MixpanelPeople();
    instance["people"]._init(instance);
    // if any instance on the page has debug = true, we set the
    // global debug to be true
    $a9f1195cdd0a4fb0$var$Config.DEBUG = $a9f1195cdd0a4fb0$var$Config.DEBUG || instance.get_config("debug");
    // if target is not defined, we called init after the lib already
    // loaded, so there won't be an array of things to execute
    if (!$a9f1195cdd0a4fb0$var$_.isUndefined(target) && $a9f1195cdd0a4fb0$var$_.isArray(target)) {
        // Crunch through the people queue first - we queue this data up &
        // flush on identify, so it's better to do all these operations first
        instance._execute_array.call(instance["people"], target["people"]);
        instance._execute_array(target);
    }
    return instance;
};
// Initialization methods
/**
 * This function initializes a new instance of the Mixpanel tracking object.
 * All new instances are added to the main mixpanel object as sub properties (such as
 * mixpanel.library_name) and also returned by this function. To define a
 * second instance on the page, you would call:
 *
 *     mixpanel.init('new token', { your: 'config' }, 'library_name');
 *
 * and use it like so:
 *
 *     mixpanel.library_name.track(...);
 *
 * @param {String} token   Your Mixpanel API token
 * @param {Object} [config]  A dictionary of config options to override. <a href="https://github.com/mixpanel/mixpanel-js/blob/8b2e1f7b/src/mixpanel-core.js#L87-L110">See a list of default config options</a>.
 * @param {String} [name]    The name for the new mixpanel instance that you want created
 */ $a9f1195cdd0a4fb0$var$MixpanelLib.prototype.init = function(token, config, name) {
    if ($a9f1195cdd0a4fb0$var$_.isUndefined(name)) {
        this.report_error("You must name your new library: init(token, config, name)");
        return;
    }
    if (name === $a9f1195cdd0a4fb0$var$PRIMARY_INSTANCE_NAME) {
        this.report_error("You must initialize the main mixpanel object right after you include the Mixpanel js snippet");
        return;
    }
    var instance = $a9f1195cdd0a4fb0$var$create_mplib(token, config, name);
    $a9f1195cdd0a4fb0$var$mixpanel_master[name] = instance;
    instance._loaded();
    return instance;
};
// mixpanel._init(token:string, config:object, name:string)
//
// This function sets up the current instance of the mixpanel
// library.  The difference between this method and the init(...)
// method is this one initializes the actual instance, whereas the
// init(...) method sets up a new library and calls _init on it.
//
$a9f1195cdd0a4fb0$var$MixpanelLib.prototype._init = function(token, config, name) {
    config = config || {};
    this["__loaded"] = true;
    this["config"] = {};
    var variable_features = {};
    // default to JSON payload for standard mixpanel.com API hosts
    if (!("api_payload_format" in config)) {
        var api_host = config["api_host"] || $a9f1195cdd0a4fb0$var$DEFAULT_CONFIG["api_host"];
        if (api_host.match(/\.mixpanel\.com$/)) variable_features["api_payload_format"] = $a9f1195cdd0a4fb0$var$PAYLOAD_TYPE_JSON;
    }
    this.set_config($a9f1195cdd0a4fb0$var$_.extend({}, $a9f1195cdd0a4fb0$var$DEFAULT_CONFIG, variable_features, config, {
        "name": name,
        "token": token,
        "callback_fn": (name === $a9f1195cdd0a4fb0$var$PRIMARY_INSTANCE_NAME ? name : $a9f1195cdd0a4fb0$var$PRIMARY_INSTANCE_NAME + "." + name) + "._jsc"
    }));
    this["_jsc"] = $a9f1195cdd0a4fb0$var$NOOP_FUNC;
    this.__dom_loaded_queue = [];
    this.__request_queue = [];
    this.__disabled_events = [];
    this._flags = {
        "disable_all_events": false,
        "identify_called": false
    };
    // set up request queueing/batching
    this.request_batchers = {};
    this._batch_requests = this.get_config("batch_requests");
    if (this._batch_requests) {
        if (!$a9f1195cdd0a4fb0$var$_.localStorage.is_supported(true) || !$a9f1195cdd0a4fb0$var$USE_XHR) {
            this._batch_requests = false;
            $a9f1195cdd0a4fb0$var$console.log("Turning off Mixpanel request-queueing; needs XHR and localStorage support");
        } else {
            this.init_batchers();
            if ($a9f1195cdd0a4fb0$var$sendBeacon && $a9f1195cdd0a4fb0$var$window$1.addEventListener) {
                // Before page closes or hides (user tabs away etc), attempt to flush any events
                // queued up via navigator.sendBeacon. Since sendBeacon doesn't report success/failure,
                // events will not be removed from the persistent store; if the site is loaded again,
                // the events will be flushed again on startup and deduplicated on the Mixpanel server
                // side.
                // There is no reliable way to capture only page close events, so we lean on the
                // visibilitychange and pagehide events as recommended at
                // https://developer.mozilla.org/en-US/docs/Web/API/Window/unload_event#usage_notes.
                // These events fire when the user clicks away from the current page/tab, so will occur
                // more frequently than page unload, but are the only mechanism currently for capturing
                // this scenario somewhat reliably.
                var flush_on_unload = $a9f1195cdd0a4fb0$var$_.bind(function() {
                    if (!this.request_batchers.events.stopped) this.request_batchers.events.flush({
                        unloading: true
                    });
                }, this);
                $a9f1195cdd0a4fb0$var$window$1.addEventListener("pagehide", function(ev) {
                    if (ev["persisted"]) flush_on_unload();
                });
                $a9f1195cdd0a4fb0$var$window$1.addEventListener("visibilitychange", function() {
                    if ($a9f1195cdd0a4fb0$var$document$1["visibilityState"] === "hidden") flush_on_unload();
                });
            }
        }
    }
    this["persistence"] = this["cookie"] = new $a9f1195cdd0a4fb0$var$MixpanelPersistence(this["config"]);
    this.unpersisted_superprops = {};
    this._gdpr_init();
    var uuid = $a9f1195cdd0a4fb0$var$_.UUID();
    if (!this.get_distinct_id()) // There is no need to set the distinct id
    // or the device id if something was already stored
    // in the persitence
    this.register_once({
        "distinct_id": uuid,
        "$device_id": uuid
    }, "");
};
// Private methods
$a9f1195cdd0a4fb0$var$MixpanelLib.prototype._loaded = function() {
    this.get_config("loaded")(this);
    this._set_default_superprops();
};
// update persistence with info on referrer, UTM params, etc
$a9f1195cdd0a4fb0$var$MixpanelLib.prototype._set_default_superprops = function() {
    this["persistence"].update_search_keyword($a9f1195cdd0a4fb0$var$document$1.referrer);
    if (this.get_config("store_google")) this["persistence"].update_campaign_params();
    if (this.get_config("save_referrer")) this["persistence"].update_referrer_info($a9f1195cdd0a4fb0$var$document$1.referrer);
};
$a9f1195cdd0a4fb0$var$MixpanelLib.prototype._dom_loaded = function() {
    $a9f1195cdd0a4fb0$var$_.each(this.__dom_loaded_queue, function(item) {
        this._track_dom.apply(this, item);
    }, this);
    if (!this.has_opted_out_tracking()) $a9f1195cdd0a4fb0$var$_.each(this.__request_queue, function(item) {
        this._send_request.apply(this, item);
    }, this);
    delete this.__dom_loaded_queue;
    delete this.__request_queue;
};
$a9f1195cdd0a4fb0$var$MixpanelLib.prototype._track_dom = function(DomClass, args) {
    if (this.get_config("img")) {
        this.report_error("You can't use DOM tracking functions with img = true.");
        return false;
    }
    if (!$a9f1195cdd0a4fb0$var$DOM_LOADED) {
        this.__dom_loaded_queue.push([
            DomClass,
            args
        ]);
        return false;
    }
    var dt = new DomClass().init(this);
    return dt.track.apply(dt, args);
};
/**
 * _prepare_callback() should be called by callers of _send_request for use
 * as the callback argument.
 *
 * If there is no callback, this returns null.
 * If we are going to make XHR/XDR requests, this returns a function.
 * If we are going to use script tags, this returns a string to use as the
 * callback GET param.
 */ $a9f1195cdd0a4fb0$var$MixpanelLib.prototype._prepare_callback = function(callback, data) {
    if ($a9f1195cdd0a4fb0$var$_.isUndefined(callback)) return null;
    if ($a9f1195cdd0a4fb0$var$USE_XHR) {
        var callback_function = function(response) {
            callback(response, data);
        };
        return callback_function;
    } else {
        // if the user gives us a callback, we store as a random
        // property on this instances jsc function and update our
        // callback string to reflect that.
        var jsc = this["_jsc"];
        var randomized_cb = "" + Math.floor(Math.random() * 100000000);
        var callback_string = this.get_config("callback_fn") + "[" + randomized_cb + "]";
        jsc[randomized_cb] = function(response) {
            delete jsc[randomized_cb];
            callback(response, data);
        };
        return callback_string;
    }
};
$a9f1195cdd0a4fb0$var$MixpanelLib.prototype._send_request = function(url, data, options, callback) {
    var succeeded = true;
    if ($a9f1195cdd0a4fb0$var$ENQUEUE_REQUESTS) {
        this.__request_queue.push(arguments);
        return succeeded;
    }
    var DEFAULT_OPTIONS = {
        method: this.get_config("api_method"),
        transport: this.get_config("api_transport"),
        verbose: this.get_config("verbose")
    };
    var body_data = null;
    if (!callback && ($a9f1195cdd0a4fb0$var$_.isFunction(options) || typeof options === "string")) {
        callback = options;
        options = null;
    }
    options = $a9f1195cdd0a4fb0$var$_.extend(DEFAULT_OPTIONS, options || {});
    if (!$a9f1195cdd0a4fb0$var$USE_XHR) options.method = "GET";
    var use_post = options.method === "POST";
    var use_sendBeacon = $a9f1195cdd0a4fb0$var$sendBeacon && use_post && options.transport.toLowerCase() === "sendbeacon";
    // needed to correctly format responses
    var verbose_mode = options.verbose;
    if (data["verbose"]) verbose_mode = true;
    if (this.get_config("test")) data["test"] = 1;
    if (verbose_mode) data["verbose"] = 1;
    if (this.get_config("img")) data["img"] = 1;
    if (!$a9f1195cdd0a4fb0$var$USE_XHR) {
        if (callback) data["callback"] = callback;
        else if (verbose_mode || this.get_config("test")) // Verbose output (from verbose mode, or an error in test mode) is a json blob,
        // which by itself is not valid javascript. Without a callback, this verbose output will
        // cause an error when returned via jsonp, so we force a no-op callback param.
        // See the ECMA script spec: http://www.ecma-international.org/ecma-262/5.1/#sec-12.4
        data["callback"] = "(function(){})";
    }
    data["ip"] = this.get_config("ip") ? 1 : 0;
    data["_"] = new Date().getTime().toString();
    if (use_post) {
        body_data = "data=" + encodeURIComponent(data["data"]);
        delete data["data"];
    }
    url += "?" + $a9f1195cdd0a4fb0$var$_.HTTPBuildQuery(data);
    var lib = this;
    if ("img" in data) {
        var img = $a9f1195cdd0a4fb0$var$document$1.createElement("img");
        img.src = url;
        $a9f1195cdd0a4fb0$var$document$1.body.appendChild(img);
    } else if (use_sendBeacon) {
        try {
            succeeded = $a9f1195cdd0a4fb0$var$sendBeacon(url, body_data);
        } catch (e) {
            lib.report_error(e);
            succeeded = false;
        }
        try {
            if (callback) callback(succeeded ? 1 : 0);
        } catch (e) {
            lib.report_error(e);
        }
    } else if ($a9f1195cdd0a4fb0$var$USE_XHR) try {
        var req = new XMLHttpRequest();
        req.open(options.method, url, true);
        var headers = this.get_config("xhr_headers");
        if (use_post) headers["Content-Type"] = "application/x-www-form-urlencoded";
        $a9f1195cdd0a4fb0$var$_.each(headers, function(headerValue, headerName) {
            req.setRequestHeader(headerName, headerValue);
        });
        if (options.timeout_ms && typeof req.timeout !== "undefined") {
            req.timeout = options.timeout_ms;
            var start_time = new Date().getTime();
        }
        // send the mp_optout cookie
        // withCredentials cannot be modified until after calling .open on Android and Mobile Safari
        req.withCredentials = true;
        req.onreadystatechange = function() {
            if (req.readyState === 4) {
                if (req.status === 200) {
                    if (callback) {
                        if (verbose_mode) {
                            var response;
                            try {
                                response = $a9f1195cdd0a4fb0$var$_.JSONDecode(req.responseText);
                            } catch (e) {
                                lib.report_error(e);
                                if (options.ignore_json_errors) response = req.responseText;
                                else return;
                            }
                            callback(response);
                        } else callback(Number(req.responseText));
                    }
                } else {
                    var error;
                    if (req.timeout && !req.status && new Date().getTime() - start_time >= req.timeout) error = "timeout";
                    else error = "Bad HTTP status: " + req.status + " " + req.statusText;
                    lib.report_error(error);
                    if (callback) {
                        if (verbose_mode) callback({
                            status: 0,
                            error: error,
                            xhr_req: req
                        });
                        else callback(0);
                    }
                }
            }
        };
        req.send(body_data);
    } catch (e) {
        lib.report_error(e);
        succeeded = false;
    }
    else {
        var script = $a9f1195cdd0a4fb0$var$document$1.createElement("script");
        script.type = "text/javascript";
        script.async = true;
        script.defer = true;
        script.src = url;
        var s = $a9f1195cdd0a4fb0$var$document$1.getElementsByTagName("script")[0];
        s.parentNode.insertBefore(script, s);
    }
    return succeeded;
};
/**
 * _execute_array() deals with processing any mixpanel function
 * calls that were called before the Mixpanel library were loaded
 * (and are thus stored in an array so they can be called later)
 *
 * Note: we fire off all the mixpanel function calls && user defined
 * functions BEFORE we fire off mixpanel tracking calls. This is so
 * identify/register/set_config calls can properly modify early
 * tracking calls.
 *
 * @param {Array} array
 */ $a9f1195cdd0a4fb0$var$MixpanelLib.prototype._execute_array = function(array) {
    var fn_name, alias_calls = [], other_calls = [], tracking_calls = [];
    $a9f1195cdd0a4fb0$var$_.each(array, function(item) {
        if (item) {
            fn_name = item[0];
            if ($a9f1195cdd0a4fb0$var$_.isArray(fn_name)) tracking_calls.push(item); // chained call e.g. mixpanel.get_group().set()
            else if (typeof item === "function") item.call(this);
            else if ($a9f1195cdd0a4fb0$var$_.isArray(item) && fn_name === "alias") alias_calls.push(item);
            else if ($a9f1195cdd0a4fb0$var$_.isArray(item) && fn_name.indexOf("track") !== -1 && typeof this[fn_name] === "function") tracking_calls.push(item);
            else other_calls.push(item);
        }
    }, this);
    var execute = function(calls, context) {
        $a9f1195cdd0a4fb0$var$_.each(calls, function(item) {
            if ($a9f1195cdd0a4fb0$var$_.isArray(item[0])) {
                // chained call
                var caller = context;
                $a9f1195cdd0a4fb0$var$_.each(item, function(call) {
                    caller = caller[call[0]].apply(caller, call.slice(1));
                });
            } else this[item[0]].apply(this, item.slice(1));
        }, context);
    };
    execute(alias_calls, this);
    execute(other_calls, this);
    execute(tracking_calls, this);
};
// request queueing utils
$a9f1195cdd0a4fb0$var$MixpanelLib.prototype.are_batchers_initialized = function() {
    return !!this.request_batchers.events;
};
$a9f1195cdd0a4fb0$var$MixpanelLib.prototype.init_batchers = function() {
    var token = this.get_config("token");
    if (!this.are_batchers_initialized()) {
        var batcher_for = $a9f1195cdd0a4fb0$var$_.bind(function(attrs) {
            return new $a9f1195cdd0a4fb0$var$RequestBatcher("__mpq_" + token + attrs.queue_suffix, {
                libConfig: this["config"],
                sendRequestFunc: $a9f1195cdd0a4fb0$var$_.bind(function(data, options, cb) {
                    this._send_request(this.get_config("api_host") + attrs.endpoint, this._encode_data_for_request(data), options, this._prepare_callback(cb, data));
                }, this),
                beforeSendHook: $a9f1195cdd0a4fb0$var$_.bind(function(item) {
                    return this._run_hook("before_send_" + attrs.type, item);
                }, this),
                errorReporter: this.get_config("error_reporter"),
                stopAllBatchingFunc: $a9f1195cdd0a4fb0$var$_.bind(this.stop_batch_senders, this)
            });
        }, this);
        this.request_batchers = {
            events: batcher_for({
                type: "events",
                endpoint: "/track/",
                queue_suffix: "_ev"
            }),
            people: batcher_for({
                type: "people",
                endpoint: "/engage/",
                queue_suffix: "_pp"
            }),
            groups: batcher_for({
                type: "groups",
                endpoint: "/groups/",
                queue_suffix: "_gr"
            })
        };
    }
    if (this.get_config("batch_autostart")) this.start_batch_senders();
};
$a9f1195cdd0a4fb0$var$MixpanelLib.prototype.start_batch_senders = function() {
    if (this.are_batchers_initialized()) {
        this._batch_requests = true;
        $a9f1195cdd0a4fb0$var$_.each(this.request_batchers, function(batcher) {
            batcher.start();
        });
    }
};
$a9f1195cdd0a4fb0$var$MixpanelLib.prototype.stop_batch_senders = function() {
    this._batch_requests = false;
    $a9f1195cdd0a4fb0$var$_.each(this.request_batchers, function(batcher) {
        batcher.stop();
        batcher.clear();
    });
};
/**
 * push() keeps the standard async-array-push
 * behavior around after the lib is loaded.
 * This is only useful for external integrations that
 * do not wish to rely on our convenience methods
 * (created in the snippet).
 *
 * ### Usage:
 *     mixpanel.push(['register', { a: 'b' }]);
 *
 * @param {Array} item A [function_name, args...] array to be executed
 */ $a9f1195cdd0a4fb0$var$MixpanelLib.prototype.push = function(item) {
    this._execute_array([
        item
    ]);
};
/**
 * Disable events on the Mixpanel object. If passed no arguments,
 * this function disables tracking of any event. If passed an
 * array of event names, those events will be disabled, but other
 * events will continue to be tracked.
 *
 * Note: this function does not stop other mixpanel functions from
 * firing, such as register() or people.set().
 *
 * @param {Array} [events] An array of event names to disable
 */ $a9f1195cdd0a4fb0$var$MixpanelLib.prototype.disable = function(events) {
    if (typeof events === "undefined") this._flags.disable_all_events = true;
    else this.__disabled_events = this.__disabled_events.concat(events);
};
$a9f1195cdd0a4fb0$var$MixpanelLib.prototype._encode_data_for_request = function(data) {
    var encoded_data = $a9f1195cdd0a4fb0$var$_.JSONEncode(data);
    if (this.get_config("api_payload_format") === $a9f1195cdd0a4fb0$var$PAYLOAD_TYPE_BASE64) encoded_data = $a9f1195cdd0a4fb0$var$_.base64Encode(encoded_data);
    return {
        "data": encoded_data
    };
};
// internal method for handling track vs batch-enqueue logic
$a9f1195cdd0a4fb0$var$MixpanelLib.prototype._track_or_batch = function(options, callback) {
    var truncated_data = $a9f1195cdd0a4fb0$var$_.truncate(options.data, 255);
    var endpoint = options.endpoint;
    var batcher = options.batcher;
    var should_send_immediately = options.should_send_immediately;
    var send_request_options = options.send_request_options || {};
    callback = callback || $a9f1195cdd0a4fb0$var$NOOP_FUNC;
    var request_enqueued_or_initiated = true;
    var send_request_immediately = $a9f1195cdd0a4fb0$var$_.bind(function() {
        if (!send_request_options.skip_hooks) truncated_data = this._run_hook("before_send_" + options.type, truncated_data);
        if (truncated_data) {
            $a9f1195cdd0a4fb0$var$console.log("MIXPANEL REQUEST:");
            $a9f1195cdd0a4fb0$var$console.log(truncated_data);
            return this._send_request(endpoint, this._encode_data_for_request(truncated_data), send_request_options, this._prepare_callback(callback, truncated_data));
        } else return null;
    }, this);
    if (this._batch_requests && !should_send_immediately) batcher.enqueue(truncated_data, function(succeeded) {
        if (succeeded) callback(1, truncated_data);
        else send_request_immediately();
    });
    else request_enqueued_or_initiated = send_request_immediately();
    return request_enqueued_or_initiated && truncated_data;
};
/**
 * Track an event. This is the most important and
 * frequently used Mixpanel function.
 *
 * ### Usage:
 *
 *     // track an event named 'Registered'
 *     mixpanel.track('Registered', {'Gender': 'Male', 'Age': 21});
 *
 *     // track an event using navigator.sendBeacon
 *     mixpanel.track('Left page', {'duration_seconds': 35}, {transport: 'sendBeacon'});
 *
 * To track link clicks or form submissions, see track_links() or track_forms().
 *
 * @param {String} event_name The name of the event. This can be anything the user does - 'Button Click', 'Sign Up', 'Item Purchased', etc.
 * @param {Object} [properties] A set of properties to include with the event you're sending. These describe the user who did the event or details about the event itself.
 * @param {Object} [options] Optional configuration for this track request.
 * @param {String} [options.transport] Transport method for network request ('xhr' or 'sendBeacon').
 * @param {Boolean} [options.send_immediately] Whether to bypass batching/queueing and send track request immediately.
 * @param {Function} [callback] If provided, the callback function will be called after tracking the event.
 * @returns {Boolean|Object} If the tracking request was successfully initiated/queued, an object
 * with the tracking payload sent to the API server is returned; otherwise false.
 */ $a9f1195cdd0a4fb0$var$MixpanelLib.prototype.track = $a9f1195cdd0a4fb0$var$addOptOutCheckMixpanelLib(function(event_name, properties, options, callback) {
    if (!callback && typeof options === "function") {
        callback = options;
        options = null;
    }
    options = options || {};
    var transport = options["transport"]; // external API, don't minify 'transport' prop
    if (transport) options.transport = transport; // 'transport' prop name can be minified internally
    var should_send_immediately = options["send_immediately"];
    if (typeof callback !== "function") callback = $a9f1195cdd0a4fb0$var$NOOP_FUNC;
    if ($a9f1195cdd0a4fb0$var$_.isUndefined(event_name)) {
        this.report_error("No event name provided to mixpanel.track");
        return;
    }
    if (this._event_is_disabled(event_name)) {
        callback(0);
        return;
    }
    // set defaults
    properties = properties || {};
    properties["token"] = this.get_config("token");
    // set $duration if time_event was previously called for this event
    var start_timestamp = this["persistence"].remove_event_timer(event_name);
    if (!$a9f1195cdd0a4fb0$var$_.isUndefined(start_timestamp)) {
        var duration_in_ms = new Date().getTime() - start_timestamp;
        properties["$duration"] = parseFloat((duration_in_ms / 1000).toFixed(3));
    }
    this._set_default_superprops();
    // note: extend writes to the first object, so lets make sure we
    // don't write to the persistence properties object and info
    // properties object by passing in a new object
    // update properties with pageview info and super-properties
    properties = $a9f1195cdd0a4fb0$var$_.extend({}, $a9f1195cdd0a4fb0$var$_.info.properties(), this["persistence"].properties(), this.unpersisted_superprops, properties);
    var property_blacklist = this.get_config("property_blacklist");
    if ($a9f1195cdd0a4fb0$var$_.isArray(property_blacklist)) $a9f1195cdd0a4fb0$var$_.each(property_blacklist, function(blacklisted_prop) {
        delete properties[blacklisted_prop];
    });
    else this.report_error("Invalid value for property_blacklist config: " + property_blacklist);
    var data = {
        "event": event_name,
        "properties": properties
    };
    var ret = this._track_or_batch({
        type: "events",
        data: data,
        endpoint: this.get_config("api_host") + "/track/",
        batcher: this.request_batchers.events,
        should_send_immediately: should_send_immediately,
        send_request_options: options
    }, callback);
    return ret;
});
/**
 * Register the current user into one/many groups.
 *
 * ### Usage:
 *
 *      mixpanel.set_group('company', ['mixpanel', 'google']) // an array of IDs
 *      mixpanel.set_group('company', 'mixpanel')
 *      mixpanel.set_group('company', 128746312)
 *
 * @param {String} group_key Group key
 * @param {Array|String|Number} group_ids An array of group IDs, or a singular group ID
 * @param {Function} [callback] If provided, the callback will be called after tracking the event.
 *
 */ $a9f1195cdd0a4fb0$var$MixpanelLib.prototype.set_group = $a9f1195cdd0a4fb0$var$addOptOutCheckMixpanelLib(function(group_key, group_ids, callback) {
    if (!$a9f1195cdd0a4fb0$var$_.isArray(group_ids)) group_ids = [
        group_ids
    ];
    var prop = {};
    prop[group_key] = group_ids;
    this.register(prop);
    return this["people"].set(group_key, group_ids, callback);
});
/**
 * Add a new group for this user.
 *
 * ### Usage:
 *
 *      mixpanel.add_group('company', 'mixpanel')
 *
 * @param {String} group_key Group key
 * @param {*} group_id A valid Mixpanel property type
 * @param {Function} [callback] If provided, the callback will be called after tracking the event.
 */ $a9f1195cdd0a4fb0$var$MixpanelLib.prototype.add_group = $a9f1195cdd0a4fb0$var$addOptOutCheckMixpanelLib(function(group_key, group_id, callback) {
    var old_values = this.get_property(group_key);
    if (old_values === undefined) {
        var prop = {};
        prop[group_key] = [
            group_id
        ];
        this.register(prop);
    } else if (old_values.indexOf(group_id) === -1) {
        old_values.push(group_id);
        this.register(prop);
    }
    return this["people"].union(group_key, group_id, callback);
});
/**
 * Remove a group from this user.
 *
 * ### Usage:
 *
 *      mixpanel.remove_group('company', 'mixpanel')
 *
 * @param {String} group_key Group key
 * @param {*} group_id A valid Mixpanel property type
 * @param {Function} [callback] If provided, the callback will be called after tracking the event.
 */ $a9f1195cdd0a4fb0$var$MixpanelLib.prototype.remove_group = $a9f1195cdd0a4fb0$var$addOptOutCheckMixpanelLib(function(group_key, group_id, callback) {
    var old_value = this.get_property(group_key);
    // if the value doesn't exist, the persistent store is unchanged
    if (old_value !== undefined) {
        var idx = old_value.indexOf(group_id);
        if (idx > -1) {
            old_value.splice(idx, 1);
            this.register({
                group_key: old_value
            });
        }
        if (old_value.length === 0) this.unregister(group_key);
    }
    return this["people"].remove(group_key, group_id, callback);
});
/**
 * Track an event with specific groups.
 *
 * ### Usage:
 *
 *      mixpanel.track_with_groups('purchase', {'product': 'iphone'}, {'University': ['UCB', 'UCLA']})
 *
 * @param {String} event_name The name of the event (see `mixpanel.track()`)
 * @param {Object=} properties A set of properties to include with the event you're sending (see `mixpanel.track()`)
 * @param {Object=} groups An object mapping group name keys to one or more values
 * @param {Function} [callback] If provided, the callback will be called after tracking the event.
 */ $a9f1195cdd0a4fb0$var$MixpanelLib.prototype.track_with_groups = $a9f1195cdd0a4fb0$var$addOptOutCheckMixpanelLib(function(event_name, properties, groups, callback) {
    var tracking_props = $a9f1195cdd0a4fb0$var$_.extend({}, properties || {});
    $a9f1195cdd0a4fb0$var$_.each(groups, function(v, k) {
        if (v !== null && v !== undefined) tracking_props[k] = v;
    });
    return this.track(event_name, tracking_props, callback);
});
$a9f1195cdd0a4fb0$var$MixpanelLib.prototype._create_map_key = function(group_key, group_id) {
    return group_key + "_" + JSON.stringify(group_id);
};
$a9f1195cdd0a4fb0$var$MixpanelLib.prototype._remove_group_from_cache = function(group_key, group_id) {
    delete this._cached_groups[this._create_map_key(group_key, group_id)];
};
/**
 * Look up reference to a Mixpanel group
 *
 * ### Usage:
 *
 *       mixpanel.get_group(group_key, group_id)
 *
 * @param {String} group_key Group key
 * @param {Object} group_id A valid Mixpanel property type
 * @returns {Object} A MixpanelGroup identifier
 */ $a9f1195cdd0a4fb0$var$MixpanelLib.prototype.get_group = function(group_key, group_id) {
    var map_key = this._create_map_key(group_key, group_id);
    var group = this._cached_groups[map_key];
    if (group === undefined || group._group_key !== group_key || group._group_id !== group_id) {
        group = new $a9f1195cdd0a4fb0$var$MixpanelGroup();
        group._init(this, group_key, group_id);
        this._cached_groups[map_key] = group;
    }
    return group;
};
/**
 * Track mp_page_view event. This is now ignored by the server.
 *
 * @param {String} [page] The url of the page to record. If you don't include this, it defaults to the current url.
 * @deprecated
 */ $a9f1195cdd0a4fb0$var$MixpanelLib.prototype.track_pageview = function(page) {
    if ($a9f1195cdd0a4fb0$var$_.isUndefined(page)) page = $a9f1195cdd0a4fb0$var$document$1.location.href;
    this.track("mp_page_view", $a9f1195cdd0a4fb0$var$_.info.pageviewInfo(page));
};
/**
 * Track clicks on a set of document elements. Selector must be a
 * valid query. Elements must exist on the page at the time track_links is called.
 *
 * ### Usage:
 *
 *     // track click for link id #nav
 *     mixpanel.track_links('#nav', 'Clicked Nav Link');
 *
 * ### Notes:
 *
 * This function will wait up to 300 ms for the Mixpanel
 * servers to respond. If they have not responded by that time
 * it will head to the link without ensuring that your event
 * has been tracked.  To configure this timeout please see the
 * set_config() documentation below.
 *
 * If you pass a function in as the properties argument, the
 * function will receive the DOMElement that triggered the
 * event as an argument.  You are expected to return an object
 * from the function; any properties defined on this object
 * will be sent to mixpanel as event properties.
 *
 * @type {Function}
 * @param {Object|String} query A valid DOM query, element or jQuery-esque list
 * @param {String} event_name The name of the event to track
 * @param {Object|Function} [properties] A properties object or function that returns a dictionary of properties when passed a DOMElement
 */ $a9f1195cdd0a4fb0$var$MixpanelLib.prototype.track_links = function() {
    return this._track_dom.call(this, $a9f1195cdd0a4fb0$var$LinkTracker, arguments);
};
/**
 * Track form submissions. Selector must be a valid query.
 *
 * ### Usage:
 *
 *     // track submission for form id 'register'
 *     mixpanel.track_forms('#register', 'Created Account');
 *
 * ### Notes:
 *
 * This function will wait up to 300 ms for the mixpanel
 * servers to respond, if they have not responded by that time
 * it will head to the link without ensuring that your event
 * has been tracked.  To configure this timeout please see the
 * set_config() documentation below.
 *
 * If you pass a function in as the properties argument, the
 * function will receive the DOMElement that triggered the
 * event as an argument.  You are expected to return an object
 * from the function; any properties defined on this object
 * will be sent to mixpanel as event properties.
 *
 * @type {Function}
 * @param {Object|String} query A valid DOM query, element or jQuery-esque list
 * @param {String} event_name The name of the event to track
 * @param {Object|Function} [properties] This can be a set of properties, or a function that returns a set of properties after being passed a DOMElement
 */ $a9f1195cdd0a4fb0$var$MixpanelLib.prototype.track_forms = function() {
    return this._track_dom.call(this, $a9f1195cdd0a4fb0$var$FormTracker, arguments);
};
/**
 * Time an event by including the time between this call and a
 * later 'track' call for the same event in the properties sent
 * with the event.
 *
 * ### Usage:
 *
 *     // time an event named 'Registered'
 *     mixpanel.time_event('Registered');
 *     mixpanel.track('Registered', {'Gender': 'Male', 'Age': 21});
 *
 * When called for a particular event name, the next track call for that event
 * name will include the elapsed time between the 'time_event' and 'track'
 * calls. This value is stored as seconds in the '$duration' property.
 *
 * @param {String} event_name The name of the event.
 */ $a9f1195cdd0a4fb0$var$MixpanelLib.prototype.time_event = function(event_name) {
    if ($a9f1195cdd0a4fb0$var$_.isUndefined(event_name)) {
        this.report_error("No event name provided to mixpanel.time_event");
        return;
    }
    if (this._event_is_disabled(event_name)) return;
    this["persistence"].set_event_timer(event_name, new Date().getTime());
};
var $a9f1195cdd0a4fb0$var$REGISTER_DEFAULTS = {
    "persistent": true
};
/**
 * Helper to parse options param for register methods, maintaining
 * legacy support for plain "days" param instead of options object
 * @param {Number|Object} [days_or_options] 'days' option (Number), or Options object for register methods
 * @returns {Object} options object
 */ var $a9f1195cdd0a4fb0$var$options_for_register = function(days_or_options) {
    var options;
    if ($a9f1195cdd0a4fb0$var$_.isObject(days_or_options)) options = days_or_options;
    else if (!$a9f1195cdd0a4fb0$var$_.isUndefined(days_or_options)) options = {
        "days": days_or_options
    };
    else options = {};
    return $a9f1195cdd0a4fb0$var$_.extend({}, $a9f1195cdd0a4fb0$var$REGISTER_DEFAULTS, options);
};
/**
 * Register a set of super properties, which are included with all
 * events. This will overwrite previous super property values.
 *
 * ### Usage:
 *
 *     // register 'Gender' as a super property
 *     mixpanel.register({'Gender': 'Female'});
 *
 *     // register several super properties when a user signs up
 *     mixpanel.register({
 *         'Email': 'jdoe@example.com',
 *         'Account Type': 'Free'
 *     });
 *
 *     // register only for the current pageload
 *     mixpanel.register({'Name': 'Pat'}, {persistent: false});
 *
 * @param {Object} properties An associative array of properties to store about the user
 * @param {Number|Object} [days_or_options] Options object or number of days since the user's last visit to store the super properties (only valid for persisted props)
 * @param {boolean} [days_or_options.days] - number of days since the user's last visit to store the super properties (only valid for persisted props)
 * @param {boolean} [days_or_options.persistent=true] - whether to put in persistent storage (cookie/localStorage)
 */ $a9f1195cdd0a4fb0$var$MixpanelLib.prototype.register = function(props, days_or_options) {
    var options = $a9f1195cdd0a4fb0$var$options_for_register(days_or_options);
    if (options["persistent"]) this["persistence"].register(props, options["days"]);
    else $a9f1195cdd0a4fb0$var$_.extend(this.unpersisted_superprops, props);
};
/**
 * Register a set of super properties only once. This will not
 * overwrite previous super property values, unlike register().
 *
 * ### Usage:
 *
 *     // register a super property for the first time only
 *     mixpanel.register_once({
 *         'First Login Date': new Date().toISOString()
 *     });
 *
 *     // register once, only for the current pageload
 *     mixpanel.register_once({
 *         'First interaction time': new Date().toISOString()
 *     }, 'None', {persistent: false});
 *
 * ### Notes:
 *
 * If default_value is specified, current super properties
 * with that value will be overwritten.
 *
 * @param {Object} properties An associative array of properties to store about the user
 * @param {*} [default_value] Value to override if already set in super properties (ex: 'False') Default: 'None'
 * @param {Number|Object} [days_or_options] Options object or number of days since the user's last visit to store the super properties (only valid for persisted props)
 * @param {boolean} [days_or_options.days] - number of days since the user's last visit to store the super properties (only valid for persisted props)
 * @param {boolean} [days_or_options.persistent=true] - whether to put in persistent storage (cookie/localStorage)
 */ $a9f1195cdd0a4fb0$var$MixpanelLib.prototype.register_once = function(props, default_value, days_or_options) {
    var options = $a9f1195cdd0a4fb0$var$options_for_register(days_or_options);
    if (options["persistent"]) this["persistence"].register_once(props, default_value, options["days"]);
    else {
        if (typeof default_value === "undefined") default_value = "None";
        $a9f1195cdd0a4fb0$var$_.each(props, function(val, prop) {
            if (!this.unpersisted_superprops.hasOwnProperty(prop) || this.unpersisted_superprops[prop] === default_value) this.unpersisted_superprops[prop] = val;
        }, this);
    }
};
/**
 * Delete a super property stored with the current user.
 *
 * @param {String} property The name of the super property to remove
 * @param {Object} [options]
 * @param {boolean} [options.persistent=true] - whether to look in persistent storage (cookie/localStorage)
 */ $a9f1195cdd0a4fb0$var$MixpanelLib.prototype.unregister = function(property, options) {
    options = $a9f1195cdd0a4fb0$var$options_for_register(options);
    if (options["persistent"]) this["persistence"].unregister(property);
    else delete this.unpersisted_superprops[property];
};
$a9f1195cdd0a4fb0$var$MixpanelLib.prototype._register_single = function(prop, value) {
    var props = {};
    props[prop] = value;
    this.register(props);
};
/**
 * Identify a user with a unique ID to track user activity across
 * devices, tie a user to their events, and create a user profile.
 * If you never call this method, unique visitors are tracked using
 * a UUID generated the first time they visit the site.
 *
 * Call identify when you know the identity of the current user,
 * typically after login or signup. We recommend against using
 * identify for anonymous visitors to your site.
 *
 * ### Notes:
 * If your project has
 * <a href="https://help.mixpanel.com/hc/en-us/articles/360039133851">ID Merge</a>
 * enabled, the identify method will connect pre- and
 * post-authentication events when appropriate.
 *
 * If your project does not have ID Merge enabled, identify will
 * change the user's local distinct_id to the unique ID you pass.
 * Events tracked prior to authentication will not be connected
 * to the same user identity. If ID Merge is disabled, alias can
 * be used to connect pre- and post-registration events.
 *
 * @param {String} [unique_id] A string that uniquely identifies a user. If not provided, the distinct_id currently in the persistent store (cookie or localStorage) will be used.
 */ $a9f1195cdd0a4fb0$var$MixpanelLib.prototype.identify = function(new_distinct_id, _set_callback, _add_callback, _append_callback, _set_once_callback, _union_callback, _unset_callback, _remove_callback) {
    // Optional Parameters
    //  _set_callback:function  A callback to be run if and when the People set queue is flushed
    //  _add_callback:function  A callback to be run if and when the People add queue is flushed
    //  _append_callback:function  A callback to be run if and when the People append queue is flushed
    //  _set_once_callback:function  A callback to be run if and when the People set_once queue is flushed
    //  _union_callback:function  A callback to be run if and when the People union queue is flushed
    //  _unset_callback:function  A callback to be run if and when the People unset queue is flushed
    var previous_distinct_id = this.get_distinct_id();
    this.register({
        "$user_id": new_distinct_id
    });
    if (!this.get_property("$device_id")) {
        // The persisted distinct id might not actually be a device id at all
        // it might be a distinct id of the user from before
        var device_id = previous_distinct_id;
        this.register_once({
            "$had_persisted_distinct_id": true,
            "$device_id": device_id
        }, "");
    }
    // identify only changes the distinct id if it doesn't match either the existing or the alias;
    // if it's new, blow away the alias as well.
    if (new_distinct_id !== previous_distinct_id && new_distinct_id !== this.get_property($a9f1195cdd0a4fb0$var$ALIAS_ID_KEY)) {
        this.unregister($a9f1195cdd0a4fb0$var$ALIAS_ID_KEY);
        this.register({
            "distinct_id": new_distinct_id
        });
    }
    this._flags.identify_called = true;
    // Flush any queued up people requests
    this["people"]._flush(_set_callback, _add_callback, _append_callback, _set_once_callback, _union_callback, _unset_callback, _remove_callback);
    // send an $identify event any time the distinct_id is changing - logic on the server
    // will determine whether or not to do anything with it.
    if (new_distinct_id !== previous_distinct_id) this.track("$identify", {
        "distinct_id": new_distinct_id,
        "$anon_distinct_id": previous_distinct_id
    }, {
        skip_hooks: true
    });
};
/**
 * Clears super properties and generates a new random distinct_id for this instance.
 * Useful for clearing data when a user logs out.
 */ $a9f1195cdd0a4fb0$var$MixpanelLib.prototype.reset = function() {
    this["persistence"].clear();
    this._flags.identify_called = false;
    var uuid = $a9f1195cdd0a4fb0$var$_.UUID();
    this.register_once({
        "distinct_id": uuid,
        "$device_id": uuid
    }, "");
};
/**
 * Returns the current distinct id of the user. This is either the id automatically
 * generated by the library or the id that has been passed by a call to identify().
 *
 * ### Notes:
 *
 * get_distinct_id() can only be called after the Mixpanel library has finished loading.
 * init() has a loaded function available to handle this automatically. For example:
 *
 *     // set distinct_id after the mixpanel library has loaded
 *     mixpanel.init('YOUR PROJECT TOKEN', {
 *         loaded: function(mixpanel) {
 *             distinct_id = mixpanel.get_distinct_id();
 *         }
 *     });
 */ $a9f1195cdd0a4fb0$var$MixpanelLib.prototype.get_distinct_id = function() {
    return this.get_property("distinct_id");
};
/**
 * The alias method creates an alias which Mixpanel will use to
 * remap one id to another. Multiple aliases can point to the
 * same identifier.
 *
 * The following is a valid use of alias:
 *
 *     mixpanel.alias('new_id', 'existing_id');
 *     // You can add multiple id aliases to the existing ID
 *     mixpanel.alias('newer_id', 'existing_id');
 *
 * Aliases can also be chained - the following is a valid example:
 *
 *     mixpanel.alias('new_id', 'existing_id');
 *     // chain newer_id - new_id - existing_id
 *     mixpanel.alias('newer_id', 'new_id');
 *
 * Aliases cannot point to multiple identifiers - the following
 * example will not work:
 *
 *     mixpanel.alias('new_id', 'existing_id');
 *     // this is invalid as 'new_id' already points to 'existing_id'
 *     mixpanel.alias('new_id', 'newer_id');
 *
 * ### Notes:
 *
 * If your project does not have
 * <a href="https://help.mixpanel.com/hc/en-us/articles/360039133851">ID Merge</a>
 * enabled, the best practice is to call alias once when a unique
 * ID is first created for a user (e.g., when a user first registers
 * for an account). Do not use alias multiple times for a single
 * user without ID Merge enabled.
 *
 * @param {String} alias A unique identifier that you want to use for this user in the future.
 * @param {String} [original] The current identifier being used for this user.
 */ $a9f1195cdd0a4fb0$var$MixpanelLib.prototype.alias = function(alias, original) {
    // If the $people_distinct_id key exists in persistence, there has been a previous
    // mixpanel.people.identify() call made for this user. It is VERY BAD to make an alias with
    // this ID, as it will duplicate users.
    if (alias === this.get_property($a9f1195cdd0a4fb0$var$PEOPLE_DISTINCT_ID_KEY)) {
        this.report_error("Attempting to create alias for existing People user - aborting.");
        return -2;
    }
    var _this = this;
    if ($a9f1195cdd0a4fb0$var$_.isUndefined(original)) original = this.get_distinct_id();
    if (alias !== original) {
        this._register_single($a9f1195cdd0a4fb0$var$ALIAS_ID_KEY, alias);
        return this.track("$create_alias", {
            "alias": alias,
            "distinct_id": original
        }, {
            skip_hooks: true
        }, function() {
            // Flush the people queue
            _this.identify(alias);
        });
    } else {
        this.report_error("alias matches current distinct_id - skipping api call.");
        this.identify(alias);
        return -1;
    }
};
/**
 * Provide a string to recognize the user by. The string passed to
 * this method will appear in the Mixpanel Streams product rather
 * than an automatically generated name. Name tags do not have to
 * be unique.
 *
 * This value will only be included in Streams data.
 *
 * @param {String} name_tag A human readable name for the user
 * @deprecated
 */ $a9f1195cdd0a4fb0$var$MixpanelLib.prototype.name_tag = function(name_tag) {
    this._register_single("mp_name_tag", name_tag);
};
/**
 * Update the configuration of a mixpanel library instance.
 *
 * The default config is:
 *
 *     {
 *       // HTTP method for tracking requests
 *       api_method: 'POST'
 *
 *       // transport for sending requests ('XHR' or 'sendBeacon')
 *       // NB: sendBeacon should only be used for scenarios such as
 *       // page unload where a "best-effort" attempt to send is
 *       // acceptable; the sendBeacon API does not support callbacks
 *       // or any way to know the result of the request. Mixpanel
 *       // tracking via sendBeacon will not support any event-
 *       // batching or retry mechanisms.
 *       api_transport: 'XHR'
 *
 *       // turn on request-batching/queueing/retry
 *       batch_requests: false,
 *
 *       // maximum number of events/updates to send in a single
 *       // network request
 *       batch_size: 50,
 *
 *       // milliseconds to wait between sending batch requests
 *       batch_flush_interval_ms: 5000,
 *
 *       // milliseconds to wait for network responses to batch requests
 *       // before they are considered timed-out and retried
 *       batch_request_timeout_ms: 90000,
 *
 *       // override value for cookie domain, only useful for ensuring
 *       // correct cross-subdomain cookies on unusual domains like
 *       // subdomain.mainsite.avocat.fr; NB this cannot be used to
 *       // set cookies on a different domain than the current origin
 *       cookie_domain: ''
 *
 *       // super properties cookie expiration (in days)
 *       cookie_expiration: 365
 *
 *       // if true, cookie will be set with SameSite=None; Secure
 *       // this is only useful in special situations, like embedded
 *       // 3rd-party iframes that set up a Mixpanel instance
 *       cross_site_cookie: false
 *
 *       // super properties span subdomains
 *       cross_subdomain_cookie: true
 *
 *       // debug mode
 *       debug: false
 *
 *       // if this is true, the mixpanel cookie or localStorage entry
 *       // will be deleted, and no user persistence will take place
 *       disable_persistence: false
 *
 *       // if this is true, Mixpanel will automatically determine
 *       // City, Region and Country data using the IP address of
 *       //the client
 *       ip: true
 *
 *       // opt users out of tracking by this Mixpanel instance by default
 *       opt_out_tracking_by_default: false
 *
 *       // opt users out of browser data storage by this Mixpanel instance by default
 *       opt_out_persistence_by_default: false
 *
 *       // persistence mechanism used by opt-in/opt-out methods - cookie
 *       // or localStorage - falls back to cookie if localStorage is unavailable
 *       opt_out_tracking_persistence_type: 'localStorage'
 *
 *       // customize the name of cookie/localStorage set by opt-in/opt-out methods
 *       opt_out_tracking_cookie_prefix: null
 *
 *       // type of persistent store for super properties (cookie/
 *       // localStorage) if set to 'localStorage', any existing
 *       // mixpanel cookie value with the same persistence_name
 *       // will be transferred to localStorage and deleted
 *       persistence: 'cookie'
 *
 *       // name for super properties persistent store
 *       persistence_name: ''
 *
 *       // names of properties/superproperties which should never
 *       // be sent with track() calls
 *       property_blacklist: []
 *
 *       // if this is true, mixpanel cookies will be marked as
 *       // secure, meaning they will only be transmitted over https
 *       secure_cookie: false
 *
 *       // the amount of time track_links will
 *       // wait for Mixpanel's servers to respond
 *       track_links_timeout: 300
 *
 *       // if you set upgrade to be true, the library will check for
 *       // a cookie from our old js library and import super
 *       // properties from it, then the old cookie is deleted
 *       // The upgrade config option only works in the initialization,
 *       // so make sure you set it when you create the library.
 *       upgrade: false
 *
 *       // extra HTTP request headers to set for each API request, in
 *       // the format {'Header-Name': value}
 *       xhr_headers: {}
 *
 *       // whether to ignore or respect the web browser's Do Not Track setting
 *       ignore_dnt: false
 *     }
 *
 *
 * @param {Object} config A dictionary of new configuration values to update
 */ $a9f1195cdd0a4fb0$var$MixpanelLib.prototype.set_config = function(config) {
    if ($a9f1195cdd0a4fb0$var$_.isObject(config)) {
        $a9f1195cdd0a4fb0$var$_.extend(this["config"], config);
        var new_batch_size = config["batch_size"];
        if (new_batch_size) $a9f1195cdd0a4fb0$var$_.each(this.request_batchers, function(batcher) {
            batcher.resetBatchSize();
        });
        if (!this.get_config("persistence_name")) this["config"]["persistence_name"] = this["config"]["cookie_name"];
        if (!this.get_config("disable_persistence")) this["config"]["disable_persistence"] = this["config"]["disable_cookie"];
        if (this["persistence"]) this["persistence"].update_config(this["config"]);
        $a9f1195cdd0a4fb0$var$Config.DEBUG = $a9f1195cdd0a4fb0$var$Config.DEBUG || this.get_config("debug");
    }
};
/**
 * returns the current config object for the library.
 */ $a9f1195cdd0a4fb0$var$MixpanelLib.prototype.get_config = function(prop_name) {
    return this["config"][prop_name];
};
/**
 * Fetch a hook function from config, with safe default, and run it
 * against the given arguments
 * @param {string} hook_name which hook to retrieve
 * @returns {any|null} return value of user-provided hook, or null if nothing was returned
 */ $a9f1195cdd0a4fb0$var$MixpanelLib.prototype._run_hook = function(hook_name) {
    var ret = (this["config"]["hooks"][hook_name] || $a9f1195cdd0a4fb0$var$IDENTITY_FUNC).apply(this, $a9f1195cdd0a4fb0$var$slice.call(arguments, 1));
    if (typeof ret === "undefined") {
        this.report_error(hook_name + " hook did not return a value");
        ret = null;
    }
    return ret;
};
/**
 * Returns the value of the super property named property_name. If no such
 * property is set, get_property() will return the undefined value.
 *
 * ### Notes:
 *
 * get_property() can only be called after the Mixpanel library has finished loading.
 * init() has a loaded function available to handle this automatically. For example:
 *
 *     // grab value for 'user_id' after the mixpanel library has loaded
 *     mixpanel.init('YOUR PROJECT TOKEN', {
 *         loaded: function(mixpanel) {
 *             user_id = mixpanel.get_property('user_id');
 *         }
 *     });
 *
 * @param {String} property_name The name of the super property you want to retrieve
 */ $a9f1195cdd0a4fb0$var$MixpanelLib.prototype.get_property = function(property_name) {
    return this["persistence"]["props"][property_name];
};
$a9f1195cdd0a4fb0$var$MixpanelLib.prototype.toString = function() {
    var name = this.get_config("name");
    if (name !== $a9f1195cdd0a4fb0$var$PRIMARY_INSTANCE_NAME) name = $a9f1195cdd0a4fb0$var$PRIMARY_INSTANCE_NAME + "." + name;
    return name;
};
$a9f1195cdd0a4fb0$var$MixpanelLib.prototype._event_is_disabled = function(event_name) {
    return $a9f1195cdd0a4fb0$var$_.isBlockedUA($a9f1195cdd0a4fb0$var$userAgent) || this._flags.disable_all_events || $a9f1195cdd0a4fb0$var$_.include(this.__disabled_events, event_name);
};
// perform some housekeeping around GDPR opt-in/out state
$a9f1195cdd0a4fb0$var$MixpanelLib.prototype._gdpr_init = function() {
    var is_localStorage_requested = this.get_config("opt_out_tracking_persistence_type") === "localStorage";
    // try to convert opt-in/out cookies to localStorage if possible
    if (is_localStorage_requested && $a9f1195cdd0a4fb0$var$_.localStorage.is_supported()) {
        if (!this.has_opted_in_tracking() && this.has_opted_in_tracking({
            "persistence_type": "cookie"
        })) this.opt_in_tracking({
            "enable_persistence": false
        });
        if (!this.has_opted_out_tracking() && this.has_opted_out_tracking({
            "persistence_type": "cookie"
        })) this.opt_out_tracking({
            "clear_persistence": false
        });
        this.clear_opt_in_out_tracking({
            "persistence_type": "cookie",
            "enable_persistence": false
        });
    }
    // check whether the user has already opted out - if so, clear & disable persistence
    if (this.has_opted_out_tracking()) this._gdpr_update_persistence({
        "clear_persistence": true
    });
    else if (!this.has_opted_in_tracking() && (this.get_config("opt_out_tracking_by_default") || $a9f1195cdd0a4fb0$var$_.cookie.get("mp_optout"))) {
        $a9f1195cdd0a4fb0$var$_.cookie.remove("mp_optout");
        this.opt_out_tracking({
            "clear_persistence": this.get_config("opt_out_persistence_by_default")
        });
    }
};
/**
 * Enable or disable persistence based on options
 * only enable/disable if persistence is not already in this state
 * @param {boolean} [options.clear_persistence] If true, will delete all data stored by the sdk in persistence and disable it
 * @param {boolean} [options.enable_persistence] If true, will re-enable sdk persistence
 */ $a9f1195cdd0a4fb0$var$MixpanelLib.prototype._gdpr_update_persistence = function(options) {
    var disabled;
    if (options && options["clear_persistence"]) disabled = true;
    else if (options && options["enable_persistence"]) disabled = false;
    else return;
    if (!this.get_config("disable_persistence") && this["persistence"].disabled !== disabled) this["persistence"].set_disabled(disabled);
    if (disabled) $a9f1195cdd0a4fb0$var$_.each(this.request_batchers, function(batcher) {
        batcher.clear();
    });
};
// call a base gdpr function after constructing the appropriate token and options args
$a9f1195cdd0a4fb0$var$MixpanelLib.prototype._gdpr_call_func = function(func, options) {
    options = $a9f1195cdd0a4fb0$var$_.extend({
        "track": $a9f1195cdd0a4fb0$var$_.bind(this.track, this),
        "persistence_type": this.get_config("opt_out_tracking_persistence_type"),
        "cookie_prefix": this.get_config("opt_out_tracking_cookie_prefix"),
        "cookie_expiration": this.get_config("cookie_expiration"),
        "cross_site_cookie": this.get_config("cross_site_cookie"),
        "cross_subdomain_cookie": this.get_config("cross_subdomain_cookie"),
        "cookie_domain": this.get_config("cookie_domain"),
        "secure_cookie": this.get_config("secure_cookie"),
        "ignore_dnt": this.get_config("ignore_dnt")
    }, options);
    // check if localStorage can be used for recording opt out status, fall back to cookie if not
    if (!$a9f1195cdd0a4fb0$var$_.localStorage.is_supported()) options["persistence_type"] = "cookie";
    return func(this.get_config("token"), {
        track: options["track"],
        trackEventName: options["track_event_name"],
        trackProperties: options["track_properties"],
        persistenceType: options["persistence_type"],
        persistencePrefix: options["cookie_prefix"],
        cookieDomain: options["cookie_domain"],
        cookieExpiration: options["cookie_expiration"],
        crossSiteCookie: options["cross_site_cookie"],
        crossSubdomainCookie: options["cross_subdomain_cookie"],
        secureCookie: options["secure_cookie"],
        ignoreDnt: options["ignore_dnt"]
    });
};
/**
 * Opt the user in to data tracking and cookies/localstorage for this Mixpanel instance
 *
 * ### Usage
 *
 *     // opt user in
 *     mixpanel.opt_in_tracking();
 *
 *     // opt user in with specific event name, properties, cookie configuration
 *     mixpanel.opt_in_tracking({
 *         track_event_name: 'User opted in',
 *         track_event_properties: {
 *             'Email': 'jdoe@example.com'
 *         },
 *         cookie_expiration: 30,
 *         secure_cookie: true
 *     });
 *
 * @param {Object} [options] A dictionary of config options to override
 * @param {function} [options.track] Function used for tracking a Mixpanel event to record the opt-in action (default is this Mixpanel instance's track method)
 * @param {string} [options.track_event_name=$opt_in] Event name to be used for tracking the opt-in action
 * @param {Object} [options.track_properties] Set of properties to be tracked along with the opt-in action
 * @param {boolean} [options.enable_persistence=true] If true, will re-enable sdk persistence
 * @param {string} [options.persistence_type=localStorage] Persistence mechanism used - cookie or localStorage - falls back to cookie if localStorage is unavailable
 * @param {string} [options.cookie_prefix=__mp_opt_in_out] Custom prefix to be used in the cookie/localstorage name
 * @param {Number} [options.cookie_expiration] Number of days until the opt-in cookie expires (overrides value specified in this Mixpanel instance's config)
 * @param {string} [options.cookie_domain] Custom cookie domain (overrides value specified in this Mixpanel instance's config)
 * @param {boolean} [options.cross_site_cookie] Whether the opt-in cookie is set as cross-site-enabled (overrides value specified in this Mixpanel instance's config)
 * @param {boolean} [options.cross_subdomain_cookie] Whether the opt-in cookie is set as cross-subdomain or not (overrides value specified in this Mixpanel instance's config)
 * @param {boolean} [options.secure_cookie] Whether the opt-in cookie is set as secure or not (overrides value specified in this Mixpanel instance's config)
 */ $a9f1195cdd0a4fb0$var$MixpanelLib.prototype.opt_in_tracking = function(options) {
    options = $a9f1195cdd0a4fb0$var$_.extend({
        "enable_persistence": true
    }, options);
    this._gdpr_call_func($a9f1195cdd0a4fb0$var$optIn, options);
    this._gdpr_update_persistence(options);
};
/**
 * Opt the user out of data tracking and cookies/localstorage for this Mixpanel instance
 *
 * ### Usage
 *
 *     // opt user out
 *     mixpanel.opt_out_tracking();
 *
 *     // opt user out with different cookie configuration from Mixpanel instance
 *     mixpanel.opt_out_tracking({
 *         cookie_expiration: 30,
 *         secure_cookie: true
 *     });
 *
 * @param {Object} [options] A dictionary of config options to override
 * @param {boolean} [options.delete_user=true] If true, will delete the currently identified user's profile and clear all charges after opting the user out
 * @param {boolean} [options.clear_persistence=true] If true, will delete all data stored by the sdk in persistence
 * @param {string} [options.persistence_type=localStorage] Persistence mechanism used - cookie or localStorage - falls back to cookie if localStorage is unavailable
 * @param {string} [options.cookie_prefix=__mp_opt_in_out] Custom prefix to be used in the cookie/localstorage name
 * @param {Number} [options.cookie_expiration] Number of days until the opt-in cookie expires (overrides value specified in this Mixpanel instance's config)
 * @param {string} [options.cookie_domain] Custom cookie domain (overrides value specified in this Mixpanel instance's config)
 * @param {boolean} [options.cross_site_cookie] Whether the opt-in cookie is set as cross-site-enabled (overrides value specified in this Mixpanel instance's config)
 * @param {boolean} [options.cross_subdomain_cookie] Whether the opt-in cookie is set as cross-subdomain or not (overrides value specified in this Mixpanel instance's config)
 * @param {boolean} [options.secure_cookie] Whether the opt-in cookie is set as secure or not (overrides value specified in this Mixpanel instance's config)
 */ $a9f1195cdd0a4fb0$var$MixpanelLib.prototype.opt_out_tracking = function(options) {
    options = $a9f1195cdd0a4fb0$var$_.extend({
        "clear_persistence": true,
        "delete_user": true
    }, options);
    // delete user and clear charges since these methods may be disabled by opt-out
    if (options["delete_user"] && this["people"] && this["people"]._identify_called()) {
        this["people"].delete_user();
        this["people"].clear_charges();
    }
    this._gdpr_call_func($a9f1195cdd0a4fb0$var$optOut, options);
    this._gdpr_update_persistence(options);
};
/**
 * Check whether the user has opted in to data tracking and cookies/localstorage for this Mixpanel instance
 *
 * ### Usage
 *
 *     var has_opted_in = mixpanel.has_opted_in_tracking();
 *     // use has_opted_in value
 *
 * @param {Object} [options] A dictionary of config options to override
 * @param {string} [options.persistence_type=localStorage] Persistence mechanism used - cookie or localStorage - falls back to cookie if localStorage is unavailable
 * @param {string} [options.cookie_prefix=__mp_opt_in_out] Custom prefix to be used in the cookie/localstorage name
 * @returns {boolean} current opt-in status
 */ $a9f1195cdd0a4fb0$var$MixpanelLib.prototype.has_opted_in_tracking = function(options) {
    return this._gdpr_call_func($a9f1195cdd0a4fb0$var$hasOptedIn, options);
};
/**
 * Check whether the user has opted out of data tracking and cookies/localstorage for this Mixpanel instance
 *
 * ### Usage
 *
 *     var has_opted_out = mixpanel.has_opted_out_tracking();
 *     // use has_opted_out value
 *
 * @param {Object} [options] A dictionary of config options to override
 * @param {string} [options.persistence_type=localStorage] Persistence mechanism used - cookie or localStorage - falls back to cookie if localStorage is unavailable
 * @param {string} [options.cookie_prefix=__mp_opt_in_out] Custom prefix to be used in the cookie/localstorage name
 * @returns {boolean} current opt-out status
 */ $a9f1195cdd0a4fb0$var$MixpanelLib.prototype.has_opted_out_tracking = function(options) {
    return this._gdpr_call_func($a9f1195cdd0a4fb0$var$hasOptedOut, options);
};
/**
 * Clear the user's opt in/out status of data tracking and cookies/localstorage for this Mixpanel instance
 *
 * ### Usage
 *
 *     // clear user's opt-in/out status
 *     mixpanel.clear_opt_in_out_tracking();
 *
 *     // clear user's opt-in/out status with specific cookie configuration - should match
 *     // configuration used when opt_in_tracking/opt_out_tracking methods were called.
 *     mixpanel.clear_opt_in_out_tracking({
 *         cookie_expiration: 30,
 *         secure_cookie: true
 *     });
 *
 * @param {Object} [options] A dictionary of config options to override
 * @param {boolean} [options.enable_persistence=true] If true, will re-enable sdk persistence
 * @param {string} [options.persistence_type=localStorage] Persistence mechanism used - cookie or localStorage - falls back to cookie if localStorage is unavailable
 * @param {string} [options.cookie_prefix=__mp_opt_in_out] Custom prefix to be used in the cookie/localstorage name
 * @param {Number} [options.cookie_expiration] Number of days until the opt-in cookie expires (overrides value specified in this Mixpanel instance's config)
 * @param {string} [options.cookie_domain] Custom cookie domain (overrides value specified in this Mixpanel instance's config)
 * @param {boolean} [options.cross_site_cookie] Whether the opt-in cookie is set as cross-site-enabled (overrides value specified in this Mixpanel instance's config)
 * @param {boolean} [options.cross_subdomain_cookie] Whether the opt-in cookie is set as cross-subdomain or not (overrides value specified in this Mixpanel instance's config)
 * @param {boolean} [options.secure_cookie] Whether the opt-in cookie is set as secure or not (overrides value specified in this Mixpanel instance's config)
 */ $a9f1195cdd0a4fb0$var$MixpanelLib.prototype.clear_opt_in_out_tracking = function(options) {
    options = $a9f1195cdd0a4fb0$var$_.extend({
        "enable_persistence": true
    }, options);
    this._gdpr_call_func($a9f1195cdd0a4fb0$var$clearOptInOut, options);
    this._gdpr_update_persistence(options);
};
$a9f1195cdd0a4fb0$var$MixpanelLib.prototype.report_error = function(msg, err) {
    $a9f1195cdd0a4fb0$var$console.error.apply($a9f1195cdd0a4fb0$var$console.error, arguments);
    try {
        if (!err && !(msg instanceof Error)) msg = new Error(msg);
        this.get_config("error_reporter")(msg, err);
    } catch (err) {
        $a9f1195cdd0a4fb0$var$console.error(err);
    }
};
// EXPORTS (for closure compiler)
// MixpanelLib Exports
$a9f1195cdd0a4fb0$var$MixpanelLib.prototype["init"] = $a9f1195cdd0a4fb0$var$MixpanelLib.prototype.init;
$a9f1195cdd0a4fb0$var$MixpanelLib.prototype["reset"] = $a9f1195cdd0a4fb0$var$MixpanelLib.prototype.reset;
$a9f1195cdd0a4fb0$var$MixpanelLib.prototype["disable"] = $a9f1195cdd0a4fb0$var$MixpanelLib.prototype.disable;
$a9f1195cdd0a4fb0$var$MixpanelLib.prototype["time_event"] = $a9f1195cdd0a4fb0$var$MixpanelLib.prototype.time_event;
$a9f1195cdd0a4fb0$var$MixpanelLib.prototype["track"] = $a9f1195cdd0a4fb0$var$MixpanelLib.prototype.track;
$a9f1195cdd0a4fb0$var$MixpanelLib.prototype["track_links"] = $a9f1195cdd0a4fb0$var$MixpanelLib.prototype.track_links;
$a9f1195cdd0a4fb0$var$MixpanelLib.prototype["track_forms"] = $a9f1195cdd0a4fb0$var$MixpanelLib.prototype.track_forms;
$a9f1195cdd0a4fb0$var$MixpanelLib.prototype["track_pageview"] = $a9f1195cdd0a4fb0$var$MixpanelLib.prototype.track_pageview;
$a9f1195cdd0a4fb0$var$MixpanelLib.prototype["register"] = $a9f1195cdd0a4fb0$var$MixpanelLib.prototype.register;
$a9f1195cdd0a4fb0$var$MixpanelLib.prototype["register_once"] = $a9f1195cdd0a4fb0$var$MixpanelLib.prototype.register_once;
$a9f1195cdd0a4fb0$var$MixpanelLib.prototype["unregister"] = $a9f1195cdd0a4fb0$var$MixpanelLib.prototype.unregister;
$a9f1195cdd0a4fb0$var$MixpanelLib.prototype["identify"] = $a9f1195cdd0a4fb0$var$MixpanelLib.prototype.identify;
$a9f1195cdd0a4fb0$var$MixpanelLib.prototype["alias"] = $a9f1195cdd0a4fb0$var$MixpanelLib.prototype.alias;
$a9f1195cdd0a4fb0$var$MixpanelLib.prototype["name_tag"] = $a9f1195cdd0a4fb0$var$MixpanelLib.prototype.name_tag;
$a9f1195cdd0a4fb0$var$MixpanelLib.prototype["set_config"] = $a9f1195cdd0a4fb0$var$MixpanelLib.prototype.set_config;
$a9f1195cdd0a4fb0$var$MixpanelLib.prototype["get_config"] = $a9f1195cdd0a4fb0$var$MixpanelLib.prototype.get_config;
$a9f1195cdd0a4fb0$var$MixpanelLib.prototype["get_property"] = $a9f1195cdd0a4fb0$var$MixpanelLib.prototype.get_property;
$a9f1195cdd0a4fb0$var$MixpanelLib.prototype["get_distinct_id"] = $a9f1195cdd0a4fb0$var$MixpanelLib.prototype.get_distinct_id;
$a9f1195cdd0a4fb0$var$MixpanelLib.prototype["toString"] = $a9f1195cdd0a4fb0$var$MixpanelLib.prototype.toString;
$a9f1195cdd0a4fb0$var$MixpanelLib.prototype["opt_out_tracking"] = $a9f1195cdd0a4fb0$var$MixpanelLib.prototype.opt_out_tracking;
$a9f1195cdd0a4fb0$var$MixpanelLib.prototype["opt_in_tracking"] = $a9f1195cdd0a4fb0$var$MixpanelLib.prototype.opt_in_tracking;
$a9f1195cdd0a4fb0$var$MixpanelLib.prototype["has_opted_out_tracking"] = $a9f1195cdd0a4fb0$var$MixpanelLib.prototype.has_opted_out_tracking;
$a9f1195cdd0a4fb0$var$MixpanelLib.prototype["has_opted_in_tracking"] = $a9f1195cdd0a4fb0$var$MixpanelLib.prototype.has_opted_in_tracking;
$a9f1195cdd0a4fb0$var$MixpanelLib.prototype["clear_opt_in_out_tracking"] = $a9f1195cdd0a4fb0$var$MixpanelLib.prototype.clear_opt_in_out_tracking;
$a9f1195cdd0a4fb0$var$MixpanelLib.prototype["get_group"] = $a9f1195cdd0a4fb0$var$MixpanelLib.prototype.get_group;
$a9f1195cdd0a4fb0$var$MixpanelLib.prototype["set_group"] = $a9f1195cdd0a4fb0$var$MixpanelLib.prototype.set_group;
$a9f1195cdd0a4fb0$var$MixpanelLib.prototype["add_group"] = $a9f1195cdd0a4fb0$var$MixpanelLib.prototype.add_group;
$a9f1195cdd0a4fb0$var$MixpanelLib.prototype["remove_group"] = $a9f1195cdd0a4fb0$var$MixpanelLib.prototype.remove_group;
$a9f1195cdd0a4fb0$var$MixpanelLib.prototype["track_with_groups"] = $a9f1195cdd0a4fb0$var$MixpanelLib.prototype.track_with_groups;
$a9f1195cdd0a4fb0$var$MixpanelLib.prototype["start_batch_senders"] = $a9f1195cdd0a4fb0$var$MixpanelLib.prototype.start_batch_senders;
$a9f1195cdd0a4fb0$var$MixpanelLib.prototype["stop_batch_senders"] = $a9f1195cdd0a4fb0$var$MixpanelLib.prototype.stop_batch_senders;
// MixpanelPersistence Exports
$a9f1195cdd0a4fb0$var$MixpanelPersistence.prototype["properties"] = $a9f1195cdd0a4fb0$var$MixpanelPersistence.prototype.properties;
$a9f1195cdd0a4fb0$var$MixpanelPersistence.prototype["update_search_keyword"] = $a9f1195cdd0a4fb0$var$MixpanelPersistence.prototype.update_search_keyword;
$a9f1195cdd0a4fb0$var$MixpanelPersistence.prototype["update_referrer_info"] = $a9f1195cdd0a4fb0$var$MixpanelPersistence.prototype.update_referrer_info;
$a9f1195cdd0a4fb0$var$MixpanelPersistence.prototype["get_cross_subdomain"] = $a9f1195cdd0a4fb0$var$MixpanelPersistence.prototype.get_cross_subdomain;
$a9f1195cdd0a4fb0$var$MixpanelPersistence.prototype["clear"] = $a9f1195cdd0a4fb0$var$MixpanelPersistence.prototype.clear;
var $a9f1195cdd0a4fb0$var$instances = {};
var $a9f1195cdd0a4fb0$var$extend_mp = function() {
    // add all the sub mixpanel instances
    $a9f1195cdd0a4fb0$var$_.each($a9f1195cdd0a4fb0$var$instances, function(instance, name) {
        if (name !== $a9f1195cdd0a4fb0$var$PRIMARY_INSTANCE_NAME) $a9f1195cdd0a4fb0$var$mixpanel_master[name] = instance;
    });
    // add private functions as _
    $a9f1195cdd0a4fb0$var$mixpanel_master["_"] = $a9f1195cdd0a4fb0$var$_;
};
var $a9f1195cdd0a4fb0$var$override_mp_init_func = function() {
    // we override the snippets init function to handle the case where a
    // user initializes the mixpanel library after the script loads & runs
    $a9f1195cdd0a4fb0$var$mixpanel_master["init"] = function(token, config, name) {
        if (name) {
            // initialize a sub library
            if (!$a9f1195cdd0a4fb0$var$mixpanel_master[name]) {
                $a9f1195cdd0a4fb0$var$mixpanel_master[name] = $a9f1195cdd0a4fb0$var$instances[name] = $a9f1195cdd0a4fb0$var$create_mplib(token, config, name);
                $a9f1195cdd0a4fb0$var$mixpanel_master[name]._loaded();
            }
            return $a9f1195cdd0a4fb0$var$mixpanel_master[name];
        } else {
            var instance = $a9f1195cdd0a4fb0$var$mixpanel_master;
            if ($a9f1195cdd0a4fb0$var$instances[$a9f1195cdd0a4fb0$var$PRIMARY_INSTANCE_NAME]) // main mixpanel lib already initialized
            instance = $a9f1195cdd0a4fb0$var$instances[$a9f1195cdd0a4fb0$var$PRIMARY_INSTANCE_NAME];
            else if (token) {
                // intialize the main mixpanel lib
                instance = $a9f1195cdd0a4fb0$var$create_mplib(token, config, $a9f1195cdd0a4fb0$var$PRIMARY_INSTANCE_NAME);
                instance._loaded();
                $a9f1195cdd0a4fb0$var$instances[$a9f1195cdd0a4fb0$var$PRIMARY_INSTANCE_NAME] = instance;
            }
            $a9f1195cdd0a4fb0$var$mixpanel_master = instance;
            if ($a9f1195cdd0a4fb0$var$init_type === $a9f1195cdd0a4fb0$var$INIT_SNIPPET) $a9f1195cdd0a4fb0$var$window$1[$a9f1195cdd0a4fb0$var$PRIMARY_INSTANCE_NAME] = $a9f1195cdd0a4fb0$var$mixpanel_master;
            $a9f1195cdd0a4fb0$var$extend_mp();
        }
    };
};
var $a9f1195cdd0a4fb0$var$add_dom_loaded_handler = function() {
    // Cross browser DOM Loaded support
    function dom_loaded_handler() {
        // function flag since we only want to execute this once
        if (dom_loaded_handler.done) return;
        dom_loaded_handler.done = true;
        $a9f1195cdd0a4fb0$var$DOM_LOADED = true;
        $a9f1195cdd0a4fb0$var$ENQUEUE_REQUESTS = false;
        $a9f1195cdd0a4fb0$var$_.each($a9f1195cdd0a4fb0$var$instances, function(inst) {
            inst._dom_loaded();
        });
    }
    function do_scroll_check() {
        try {
            $a9f1195cdd0a4fb0$var$document$1.documentElement.doScroll("left");
        } catch (e) {
            setTimeout(do_scroll_check, 1);
            return;
        }
        dom_loaded_handler();
    }
    if ($a9f1195cdd0a4fb0$var$document$1.addEventListener) {
        if ($a9f1195cdd0a4fb0$var$document$1.readyState === "complete") // safari 4 can fire the DOMContentLoaded event before loading all
        // external JS (including this file). you will see some copypasta
        // on the internet that checks for 'complete' and 'loaded', but
        // 'loaded' is an IE thing
        dom_loaded_handler();
        else $a9f1195cdd0a4fb0$var$document$1.addEventListener("DOMContentLoaded", dom_loaded_handler, false);
    } else if ($a9f1195cdd0a4fb0$var$document$1.attachEvent) {
        // IE
        $a9f1195cdd0a4fb0$var$document$1.attachEvent("onreadystatechange", dom_loaded_handler);
        // check to make sure we arn't in a frame
        var toplevel = false;
        try {
            toplevel = $a9f1195cdd0a4fb0$var$window$1.frameElement === null;
        } catch (e) {
        // noop
        }
        if ($a9f1195cdd0a4fb0$var$document$1.documentElement.doScroll && toplevel) do_scroll_check();
    }
    // fallback handler, always will work
    $a9f1195cdd0a4fb0$var$_.register_event($a9f1195cdd0a4fb0$var$window$1, "load", dom_loaded_handler, true);
};
function $a9f1195cdd0a4fb0$var$init_as_module() {
    $a9f1195cdd0a4fb0$var$init_type = $a9f1195cdd0a4fb0$var$INIT_MODULE;
    $a9f1195cdd0a4fb0$var$mixpanel_master = new $a9f1195cdd0a4fb0$var$MixpanelLib();
    $a9f1195cdd0a4fb0$var$override_mp_init_func();
    $a9f1195cdd0a4fb0$var$mixpanel_master["init"]();
    $a9f1195cdd0a4fb0$var$add_dom_loaded_handler();
    return $a9f1195cdd0a4fb0$var$mixpanel_master;
}
var $a9f1195cdd0a4fb0$var$mixpanel = $a9f1195cdd0a4fb0$var$init_as_module();
module.exports = $a9f1195cdd0a4fb0$var$mixpanel;

});


parcelRegister("h5HRh", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c714eca6b62784f4$export$2e2bcd8739ae039; });

var $RP8BZ = parcelRequire("RP8BZ");
var $c714eca6b62784f4$export$2e2bcd8739ae039 = (0, $RP8BZ.default);

});
parcelRegister("RP8BZ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0a1c9e45e781f34f$export$2e2bcd8739ae039; });

var $ikATC = parcelRequire("ikATC");
var $co7DE = parcelRequire("co7DE");

var $7b1Lp = parcelRequire("7b1Lp");

var $cQNHH = parcelRequire("cQNHH");

var $fsuNT = parcelRequire("fsuNT");

var $bv9EC = parcelRequire("bv9EC");

var $1irrc = parcelRequire("1irrc");

var $kvHhM = parcelRequire("kvHhM");
const $0a1c9e45e781f34f$var$useStyles = (0, $7b1Lp.default)((theme)=>({
        listItem: {
            fontFamily: theme.typography.fontFamily
        }
    }));
function $0a1c9e45e781f34f$var$MdLink({ href: href, ...props }) {
    const target = href.startsWith("mailto:") ? "" : "_blank";
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement((0, $ikATC.default), {
        href: href,
        rel: "noopener noreferrer",
        target: target,
        ...props
    });
}
$0a1c9e45e781f34f$var$MdLink.defaultProps = {
    href: undefined
};
function $0a1c9e45e781f34f$var$Markdown({ children: children, remarkReactComponents: remarkReactComponents, extend: extend, tags: tags }) {
    const classes = $0a1c9e45e781f34f$var$useStyles();
    return(// eslint-disable-next-line react/jsx-no-useless-fragment
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).Fragment, null, (0, (/*@__PURE__*/$parcel$interopDefault($fsuNT)))().use((0, (/*@__PURE__*/$parcel$interopDefault($bv9EC))), {
        remarkReactComponents: remarkReactComponents || {
            h1: (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement((0, $kvHhM.MainHeading), props),
            h2: (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement((0, $co7DE.default), {
                    gutterBottom: true,
                    variant: "h2",
                    ...props
                }),
            h3: (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement((0, $co7DE.default), {
                    gutterBottom: true,
                    variant: "h3",
                    ...props
                }),
            h4: (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement((0, $co7DE.default), {
                    gutterBottom: true,
                    variant: "h4",
                    ...props
                }),
            h5: (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement((0, $co7DE.default), {
                    gutterBottom: true,
                    variant: "h5",
                    ...props
                }),
            h6: (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement((0, $co7DE.default), {
                    gutterBottom: true,
                    variant: "h6",
                    ...props
                }),
            p: (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement((0, $kvHhM.NormalText), props),
            a: (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement($0a1c9e45e781f34f$var$MdLink, props),
            li: (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("li", {
                    ...props,
                    className: classes.listItem
                }),
            ...extend
        }
    }).processSync((0, (/*@__PURE__*/$parcel$interopDefault($1irrc)))(children, tags)).contents));
}
$0a1c9e45e781f34f$var$Markdown.defaultProps = {
    extend: undefined,
    remarkReactComponents: undefined,
    tags: {}
};
var $0a1c9e45e781f34f$export$2e2bcd8739ae039 = $0a1c9e45e781f34f$var$Markdown;

});
parcelRegister("ikATC", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d586b70d67f5b7de$export$2e2bcd8739ae039; });

var $gtn2B = parcelRequire("gtn2B");

var $fsWgf = parcelRequire("fsWgf");

var $cQNHH = parcelRequire("cQNHH");

var $1xEYC = parcelRequire("1xEYC");

var $bKF6r = parcelRequire("bKF6r");

var $5beWR = parcelRequire("5beWR");

var $eyd6T = parcelRequire("eyd6T");

var $hyUPo = parcelRequire("hyUPo");

var $9fjCj = parcelRequire("9fjCj");

var $ge6Tz = parcelRequire("ge6Tz");

var $co7DE = parcelRequire("co7DE");
var $d586b70d67f5b7de$export$9dd6ff9ea0189349 = {
    /* Styles applied to the root element. */ root: {},
    /* Styles applied to the root element if `underline="none"`. */ underlineNone: {
        textDecoration: "none"
    },
    /* Styles applied to the root element if `underline="hover"`. */ underlineHover: {
        textDecoration: "none",
        "&:hover": {
            textDecoration: "underline"
        }
    },
    /* Styles applied to the root element if `underline="always"`. */ underlineAlways: {
        textDecoration: "underline"
    },
    // Same reset as ButtonBase.root
    /* Styles applied to the root element if `component="button"`. */ button: {
        position: "relative",
        WebkitTapHighlightColor: "transparent",
        backgroundColor: "transparent",
        // Reset default value
        // We disable the focus ring for mouse, touch and keyboard users.
        outline: 0,
        border: 0,
        margin: 0,
        // Remove the margin in Safari
        borderRadius: 0,
        padding: 0,
        // Remove the padding in Firefox
        cursor: "pointer",
        userSelect: "none",
        verticalAlign: "middle",
        "-moz-appearance": "none",
        // Reset
        "-webkit-appearance": "none",
        // Reset
        "&::-moz-focus-inner": {
            borderStyle: "none" // Remove Firefox dotted outline.
        },
        "&$focusVisible": {
            outline: "auto"
        }
    },
    /* Pseudo-class applied to the root element if the link is keyboard focused. */ focusVisible: {}
};
var $d586b70d67f5b7de$var$Link = /*#__PURE__*/ $cQNHH.forwardRef(function Link(props, ref) {
    var classes = props.classes, className = props.className, _props$color = props.color, color = _props$color === void 0 ? "primary" : _props$color, _props$component = props.component, component = _props$component === void 0 ? "a" : _props$component, onBlur = props.onBlur, onFocus = props.onFocus, TypographyClasses = props.TypographyClasses, _props$underline = props.underline, underline = _props$underline === void 0 ? "hover" : _props$underline, _props$variant = props.variant, variant = _props$variant === void 0 ? "inherit" : _props$variant, other = (0, $fsWgf.default)(props, [
        "classes",
        "className",
        "color",
        "component",
        "onBlur",
        "onFocus",
        "TypographyClasses",
        "underline",
        "variant"
    ]);
    var _useIsFocusVisible = (0, $9fjCj.default)(), isFocusVisible = _useIsFocusVisible.isFocusVisible, onBlurVisible = _useIsFocusVisible.onBlurVisible, focusVisibleRef = _useIsFocusVisible.ref;
    var _React$useState = $cQNHH.useState(false), focusVisible = _React$useState[0], setFocusVisible = _React$useState[1];
    var handlerRef = (0, $ge6Tz.default)(ref, focusVisibleRef);
    var handleBlur = function handleBlur(event) {
        if (focusVisible) {
            onBlurVisible();
            setFocusVisible(false);
        }
        if (onBlur) onBlur(event);
    };
    var handleFocus = function handleFocus(event) {
        if (isFocusVisible(event)) setFocusVisible(true);
        if (onFocus) onFocus(event);
    };
    return /*#__PURE__*/ $cQNHH.createElement((0, $co7DE.default), (0, $gtn2B.default)({
        className: (0, $bKF6r.default)(classes.root, classes["underline".concat((0, $5beWR.default)(underline))], className, focusVisible && classes.focusVisible, component === "button" && classes.button),
        classes: TypographyClasses,
        color: color,
        component: component,
        onBlur: handleBlur,
        onFocus: handleFocus,
        ref: handlerRef,
        variant: variant
    }, other));
});
$d586b70d67f5b7de$var$Link.propTypes = {
    /**
   * The content of the link.
   */ children: (0, (/*@__PURE__*/$parcel$interopDefault($1xEYC))).node.isRequired,
    /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */ classes: (0, (/*@__PURE__*/$parcel$interopDefault($1xEYC))).object.isRequired,
    /**
   * @ignore
   */ className: (0, (/*@__PURE__*/$parcel$interopDefault($1xEYC))).string,
    /**
   * The color of the link.
   */ color: (0, (/*@__PURE__*/$parcel$interopDefault($1xEYC))).oneOf([
        "initial",
        "inherit",
        "primary",
        "secondary",
        "textPrimary",
        "textSecondary",
        "error"
    ]),
    /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */ component: (0, $hyUPo.default),
    /**
   * @ignore
   */ onBlur: (0, (/*@__PURE__*/$parcel$interopDefault($1xEYC))).func,
    /**
   * @ignore
   */ onFocus: (0, (/*@__PURE__*/$parcel$interopDefault($1xEYC))).func,
    /**
   * `classes` prop applied to the [`Typography`](/api/typography/) element.
   */ TypographyClasses: (0, (/*@__PURE__*/$parcel$interopDefault($1xEYC))).object,
    /**
   * Controls when the link should have an underline.
   */ underline: (0, (/*@__PURE__*/$parcel$interopDefault($1xEYC))).oneOf([
        "none",
        "hover",
        "always"
    ]),
    /**
   * Applies the theme typography styles.
   */ variant: (0, (/*@__PURE__*/$parcel$interopDefault($1xEYC))).string
};
var $d586b70d67f5b7de$export$2e2bcd8739ae039 = (0, $eyd6T.default)($d586b70d67f5b7de$export$9dd6ff9ea0189349, {
    name: "MuiLink"
})($d586b70d67f5b7de$var$Link);

});
parcelRegister("co7DE", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $904da6c53ca8b7ec$export$2e2bcd8739ae039; });

var $gtn2B = parcelRequire("gtn2B");

var $fsWgf = parcelRequire("fsWgf");

var $cQNHH = parcelRequire("cQNHH");

var $1xEYC = parcelRequire("1xEYC");

var $bKF6r = parcelRequire("bKF6r");

var $eyd6T = parcelRequire("eyd6T");

var $5beWR = parcelRequire("5beWR");
var $904da6c53ca8b7ec$export$9dd6ff9ea0189349 = function styles(theme) {
    return {
        /* Styles applied to the root element. */ root: {
            margin: 0
        },
        /* Styles applied to the root element if `variant="body2"`. */ body2: theme.typography.body2,
        /* Styles applied to the root element if `variant="body1"`. */ body1: theme.typography.body1,
        /* Styles applied to the root element if `variant="caption"`. */ caption: theme.typography.caption,
        /* Styles applied to the root element if `variant="button"`. */ button: theme.typography.button,
        /* Styles applied to the root element if `variant="h1"`. */ h1: theme.typography.h1,
        /* Styles applied to the root element if `variant="h2"`. */ h2: theme.typography.h2,
        /* Styles applied to the root element if `variant="h3"`. */ h3: theme.typography.h3,
        /* Styles applied to the root element if `variant="h4"`. */ h4: theme.typography.h4,
        /* Styles applied to the root element if `variant="h5"`. */ h5: theme.typography.h5,
        /* Styles applied to the root element if `variant="h6"`. */ h6: theme.typography.h6,
        /* Styles applied to the root element if `variant="subtitle1"`. */ subtitle1: theme.typography.subtitle1,
        /* Styles applied to the root element if `variant="subtitle2"`. */ subtitle2: theme.typography.subtitle2,
        /* Styles applied to the root element if `variant="overline"`. */ overline: theme.typography.overline,
        /* Styles applied to the root element if `variant="srOnly"`. Only accessible to screen readers. */ srOnly: {
            position: "absolute",
            height: 1,
            width: 1,
            overflow: "hidden"
        },
        /* Styles applied to the root element if `align="left"`. */ alignLeft: {
            textAlign: "left"
        },
        /* Styles applied to the root element if `align="center"`. */ alignCenter: {
            textAlign: "center"
        },
        /* Styles applied to the root element if `align="right"`. */ alignRight: {
            textAlign: "right"
        },
        /* Styles applied to the root element if `align="justify"`. */ alignJustify: {
            textAlign: "justify"
        },
        /* Styles applied to the root element if `nowrap={true}`. */ noWrap: {
            overflow: "hidden",
            textOverflow: "ellipsis",
            whiteSpace: "nowrap"
        },
        /* Styles applied to the root element if `gutterBottom={true}`. */ gutterBottom: {
            marginBottom: "0.35em"
        },
        /* Styles applied to the root element if `paragraph={true}`. */ paragraph: {
            marginBottom: 16
        },
        /* Styles applied to the root element if `color="inherit"`. */ colorInherit: {
            color: "inherit"
        },
        /* Styles applied to the root element if `color="primary"`. */ colorPrimary: {
            color: theme.palette.primary.main
        },
        /* Styles applied to the root element if `color="secondary"`. */ colorSecondary: {
            color: theme.palette.secondary.main
        },
        /* Styles applied to the root element if `color="textPrimary"`. */ colorTextPrimary: {
            color: theme.palette.text.primary
        },
        /* Styles applied to the root element if `color="textSecondary"`. */ colorTextSecondary: {
            color: theme.palette.text.secondary
        },
        /* Styles applied to the root element if `color="error"`. */ colorError: {
            color: theme.palette.error.main
        },
        /* Styles applied to the root element if `display="inline"`. */ displayInline: {
            display: "inline"
        },
        /* Styles applied to the root element if `display="block"`. */ displayBlock: {
            display: "block"
        }
    };
};
var $904da6c53ca8b7ec$var$defaultVariantMapping = {
    h1: "h1",
    h2: "h2",
    h3: "h3",
    h4: "h4",
    h5: "h5",
    h6: "h6",
    subtitle1: "h6",
    subtitle2: "h6",
    body1: "p",
    body2: "p"
};
var $904da6c53ca8b7ec$var$Typography = /*#__PURE__*/ $cQNHH.forwardRef(function Typography(props, ref) {
    var _props$align = props.align, align = _props$align === void 0 ? "inherit" : _props$align, classes = props.classes, className = props.className, _props$color = props.color, color = _props$color === void 0 ? "initial" : _props$color, component = props.component, _props$display = props.display, display = _props$display === void 0 ? "initial" : _props$display, _props$gutterBottom = props.gutterBottom, gutterBottom = _props$gutterBottom === void 0 ? false : _props$gutterBottom, _props$noWrap = props.noWrap, noWrap = _props$noWrap === void 0 ? false : _props$noWrap, _props$paragraph = props.paragraph, paragraph = _props$paragraph === void 0 ? false : _props$paragraph, _props$variant = props.variant, variant = _props$variant === void 0 ? "body1" : _props$variant, _props$variantMapping = props.variantMapping, variantMapping = _props$variantMapping === void 0 ? $904da6c53ca8b7ec$var$defaultVariantMapping : _props$variantMapping, other = (0, $fsWgf.default)(props, [
        "align",
        "classes",
        "className",
        "color",
        "component",
        "display",
        "gutterBottom",
        "noWrap",
        "paragraph",
        "variant",
        "variantMapping"
    ]);
    var Component = component || (paragraph ? "p" : variantMapping[variant] || $904da6c53ca8b7ec$var$defaultVariantMapping[variant]) || "span";
    return /*#__PURE__*/ $cQNHH.createElement(Component, (0, $gtn2B.default)({
        className: (0, $bKF6r.default)(classes.root, className, variant !== "inherit" && classes[variant], color !== "initial" && classes["color".concat((0, $5beWR.default)(color))], noWrap && classes.noWrap, gutterBottom && classes.gutterBottom, paragraph && classes.paragraph, align !== "inherit" && classes["align".concat((0, $5beWR.default)(align))], display !== "initial" && classes["display".concat((0, $5beWR.default)(display))]),
        ref: ref
    }, other));
});
$904da6c53ca8b7ec$var$Typography.propTypes = {
    /**
   * Set the text-align on the component.
   */ align: (0, (/*@__PURE__*/$parcel$interopDefault($1xEYC))).oneOf([
        "inherit",
        "left",
        "center",
        "right",
        "justify"
    ]),
    /**
   * The content of the component.
   */ children: (0, (/*@__PURE__*/$parcel$interopDefault($1xEYC))).node,
    /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */ classes: (0, (/*@__PURE__*/$parcel$interopDefault($1xEYC))).object.isRequired,
    /**
   * @ignore
   */ className: (0, (/*@__PURE__*/$parcel$interopDefault($1xEYC))).string,
    /**
   * The color of the component. It supports those theme colors that make sense for this component.
   */ color: (0, (/*@__PURE__*/$parcel$interopDefault($1xEYC))).oneOf([
        "initial",
        "inherit",
        "primary",
        "secondary",
        "textPrimary",
        "textSecondary",
        "error"
    ]),
    /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   * Overrides the behavior of the `variantMapping` prop.
   */ component: (0, (/*@__PURE__*/$parcel$interopDefault($1xEYC)))/* @typescript-to-proptypes-ignore */ .elementType,
    /**
   * Controls the display type
   */ display: (0, (/*@__PURE__*/$parcel$interopDefault($1xEYC))).oneOf([
        "initial",
        "block",
        "inline"
    ]),
    /**
   * If `true`, the text will have a bottom margin.
   */ gutterBottom: (0, (/*@__PURE__*/$parcel$interopDefault($1xEYC))).bool,
    /**
   * If `true`, the text will not wrap, but instead will truncate with a text overflow ellipsis.
   *
   * Note that text overflow can only happen with block or inline-block level elements
   * (the element needs to have a width in order to overflow).
   */ noWrap: (0, (/*@__PURE__*/$parcel$interopDefault($1xEYC))).bool,
    /**
   * If `true`, the text will have a bottom margin.
   */ paragraph: (0, (/*@__PURE__*/$parcel$interopDefault($1xEYC))).bool,
    /**
   * Applies the theme typography styles.
   */ variant: (0, (/*@__PURE__*/$parcel$interopDefault($1xEYC))).oneOf([
        "h1",
        "h2",
        "h3",
        "h4",
        "h5",
        "h6",
        "subtitle1",
        "subtitle2",
        "body1",
        "body2",
        "caption",
        "button",
        "overline",
        "srOnly",
        "inherit"
    ]),
    /**
   * The component maps the variant prop to a range of different HTML element types.
   * For instance, subtitle1 to `<h6>`.
   * If you wish to change that mapping, you can provide your own.
   * Alternatively, you can use the `component` prop.
   */ variantMapping: (0, (/*@__PURE__*/$parcel$interopDefault($1xEYC))).object
};
var $904da6c53ca8b7ec$export$2e2bcd8739ae039 = (0, $eyd6T.default)($904da6c53ca8b7ec$export$9dd6ff9ea0189349, {
    name: "MuiTypography"
})($904da6c53ca8b7ec$var$Typography);

});


parcelRegister("fsuNT", function(module, exports) {
"use strict";

var $al4fO = parcelRequire("al4fO");

var $PZETB = parcelRequire("PZETB");

var $h6gi9 = parcelRequire("h6gi9");
module.exports = $al4fO().use($PZETB).use($h6gi9).freeze();

});
parcelRegister("al4fO", function(module, exports) {
"use strict";

var $fxuRr = parcelRequire("fxuRr");

var $bZMx7 = parcelRequire("bZMx7");

var $vpVay = parcelRequire("vpVay");

var $7SpAC = parcelRequire("7SpAC");

var $f0IPP = parcelRequire("f0IPP");
// Expose a frozen processor.
module.exports = $786f2a4b21dab975$var$unified().freeze();
var $786f2a4b21dab975$var$slice = [].slice;
var $786f2a4b21dab975$var$own = {}.hasOwnProperty;
// Process pipeline.
var $786f2a4b21dab975$var$pipeline = $7SpAC().use($786f2a4b21dab975$var$pipelineParse).use($786f2a4b21dab975$var$pipelineRun).use($786f2a4b21dab975$var$pipelineStringify);
function $786f2a4b21dab975$var$pipelineParse(p, ctx) {
    ctx.tree = p.parse(ctx.file);
}
function $786f2a4b21dab975$var$pipelineRun(p, ctx, next) {
    p.run(ctx.tree, ctx.file, done);
    function done(err, tree, file) {
        if (err) next(err);
        else {
            ctx.tree = tree;
            ctx.file = file;
            next();
        }
    }
}
function $786f2a4b21dab975$var$pipelineStringify(p, ctx) {
    ctx.file.contents = p.stringify(ctx.tree, ctx.file);
}
// Function to create the first processor.
function $786f2a4b21dab975$var$unified() {
    var attachers = [];
    var transformers = $7SpAC();
    var namespace = {};
    var frozen = false;
    var freezeIndex = -1;
    // Data management.
    processor.data = data;
    // Lock.
    processor.freeze = freeze;
    // Plugins.
    processor.attachers = attachers;
    processor.use = use;
    // API.
    processor.parse = parse;
    processor.stringify = stringify;
    processor.run = run;
    processor.runSync = runSync;
    processor.process = process;
    processor.processSync = processSync;
    // Expose.
    return processor;
    // Create a new processor based on the processor in the current scope.
    function processor() {
        var destination = $786f2a4b21dab975$var$unified();
        var length = attachers.length;
        var index = -1;
        while(++index < length)destination.use.apply(null, attachers[index]);
        destination.data($fxuRr(true, {}, namespace));
        return destination;
    }
    // Freeze: used to signal a processor that has finished configuration.
    //
    // For example, take unified itself: it’s frozen.
    // Plugins should not be added to it.
    // Rather, it should be extended, by invoking it, before modifying it.
    //
    // In essence, always invoke this when exporting a processor.
    function freeze() {
        var values;
        var plugin;
        var options;
        var transformer;
        if (frozen) return processor;
        while(++freezeIndex < attachers.length){
            values = attachers[freezeIndex];
            plugin = values[0];
            options = values[1];
            transformer = null;
            if (options === false) continue;
            if (options === true) values[1] = undefined;
            transformer = plugin.apply(processor, values.slice(1));
            if (typeof transformer === "function") transformers.use(transformer);
        }
        frozen = true;
        freezeIndex = Infinity;
        return processor;
    }
    // Data management.
    // Getter / setter for processor-specific informtion.
    function data(key, value) {
        if (typeof key === "string") {
            // Set `key`.
            if (arguments.length === 2) {
                $786f2a4b21dab975$var$assertUnfrozen("data", frozen);
                namespace[key] = value;
                return processor;
            }
            // Get `key`.
            return $786f2a4b21dab975$var$own.call(namespace, key) && namespace[key] || null;
        }
        // Set space.
        if (key) {
            $786f2a4b21dab975$var$assertUnfrozen("data", frozen);
            namespace = key;
            return processor;
        }
        // Get space.
        return namespace;
    }
    // Plugin management.
    //
    // Pass it:
    // *   an attacher and options,
    // *   a preset,
    // *   a list of presets, attachers, and arguments (list of attachers and
    //     options).
    function use(value) {
        var settings;
        $786f2a4b21dab975$var$assertUnfrozen("use", frozen);
        if (value === null || value === undefined) ;
        else if (typeof value === "function") addPlugin.apply(null, arguments);
        else if (typeof value === "object") {
            if ("length" in value) addList(value);
            else addPreset(value);
        } else throw new Error("Expected usable value, not `" + value + "`");
        if (settings) namespace.settings = $fxuRr(namespace.settings || {}, settings);
        return processor;
        function addPreset(result) {
            addList(result.plugins);
            if (result.settings) settings = $fxuRr(settings || {}, result.settings);
        }
        function add(value) {
            if (typeof value === "function") addPlugin(value);
            else if (typeof value === "object") {
                if ("length" in value) addPlugin.apply(null, value);
                else addPreset(value);
            } else throw new Error("Expected usable value, not `" + value + "`");
        }
        function addList(plugins) {
            var length;
            var index;
            if (plugins === null || plugins === undefined) ;
            else if (typeof plugins === "object" && "length" in plugins) {
                length = plugins.length;
                index = -1;
                while(++index < length)add(plugins[index]);
            } else throw new Error("Expected a list of plugins, not `" + plugins + "`");
        }
        function addPlugin(plugin, value) {
            var entry = find(plugin);
            if (entry) {
                if ($f0IPP(entry[1]) && $f0IPP(value)) value = $fxuRr(entry[1], value);
                entry[1] = value;
            } else attachers.push($786f2a4b21dab975$var$slice.call(arguments));
        }
    }
    function find(plugin) {
        var length = attachers.length;
        var index = -1;
        var entry;
        while(++index < length){
            entry = attachers[index];
            if (entry[0] === plugin) return entry;
        }
    }
    // Parse a file (in string or vfile representation) into a unist node using
    // the `Parser` on the processor.
    function parse(doc) {
        var file = $vpVay(doc);
        var Parser;
        freeze();
        Parser = processor.Parser;
        $786f2a4b21dab975$var$assertParser("parse", Parser);
        if ($786f2a4b21dab975$var$newable(Parser, "parse")) return new Parser(String(file), file).parse();
        return Parser(String(file), file) // eslint-disable-line new-cap
        ;
    }
    // Run transforms on a unist node representation of a file (in string or
    // vfile representation), async.
    function run(node, file, cb) {
        $786f2a4b21dab975$var$assertNode(node);
        freeze();
        if (!cb && typeof file === "function") {
            cb = file;
            file = null;
        }
        if (!cb) return new Promise(executor);
        executor(null, cb);
        function executor(resolve, reject) {
            transformers.run(node, $vpVay(file), done);
            function done(err, tree, file) {
                tree = tree || node;
                if (err) reject(err);
                else if (resolve) resolve(tree);
                else cb(null, tree, file);
            }
        }
    }
    // Run transforms on a unist node representation of a file (in string or
    // vfile representation), sync.
    function runSync(node, file) {
        var complete = false;
        var result;
        run(node, file, done);
        $786f2a4b21dab975$var$assertDone("runSync", "run", complete);
        return result;
        function done(err, tree) {
            complete = true;
            $bZMx7(err);
            result = tree;
        }
    }
    // Stringify a unist node representation of a file (in string or vfile
    // representation) into a string using the `Compiler` on the processor.
    function stringify(node, doc) {
        var file = $vpVay(doc);
        var Compiler;
        freeze();
        Compiler = processor.Compiler;
        $786f2a4b21dab975$var$assertCompiler("stringify", Compiler);
        $786f2a4b21dab975$var$assertNode(node);
        if ($786f2a4b21dab975$var$newable(Compiler, "compile")) return new Compiler(node, file).compile();
        return Compiler(node, file) // eslint-disable-line new-cap
        ;
    }
    // Parse a file (in string or vfile representation) into a unist node using
    // the `Parser` on the processor, then run transforms on that node, and
    // compile the resulting node using the `Compiler` on the processor, and
    // store that result on the vfile.
    function process(doc, cb) {
        freeze();
        $786f2a4b21dab975$var$assertParser("process", processor.Parser);
        $786f2a4b21dab975$var$assertCompiler("process", processor.Compiler);
        if (!cb) return new Promise(executor);
        executor(null, cb);
        function executor(resolve, reject) {
            var file = $vpVay(doc);
            $786f2a4b21dab975$var$pipeline.run(processor, {
                file: file
            }, done);
            function done(err) {
                if (err) reject(err);
                else if (resolve) resolve(file);
                else cb(null, file);
            }
        }
    }
    // Process the given document (in string or vfile representation), sync.
    function processSync(doc) {
        var complete = false;
        var file;
        freeze();
        $786f2a4b21dab975$var$assertParser("processSync", processor.Parser);
        $786f2a4b21dab975$var$assertCompiler("processSync", processor.Compiler);
        file = $vpVay(doc);
        process(file, done);
        $786f2a4b21dab975$var$assertDone("processSync", "process", complete);
        return file;
        function done(err) {
            complete = true;
            $bZMx7(err);
        }
    }
}
// Check if `value` is a constructor.
function $786f2a4b21dab975$var$newable(value, name) {
    return typeof value === "function" && value.prototype && // A function with keys in its prototype is probably a constructor.
    // Classes’ prototype methods are not enumerable, so we check if some value
    // exists in the prototype.
    ($786f2a4b21dab975$var$keys(value.prototype) || name in value.prototype);
}
// Check if `value` is an object with keys.
function $786f2a4b21dab975$var$keys(value) {
    var key;
    for(key in value)return true;
    return false;
}
// Assert a parser is available.
function $786f2a4b21dab975$var$assertParser(name, Parser) {
    if (typeof Parser !== "function") throw new Error("Cannot `" + name + "` without `Parser`");
}
// Assert a compiler is available.
function $786f2a4b21dab975$var$assertCompiler(name, Compiler) {
    if (typeof Compiler !== "function") throw new Error("Cannot `" + name + "` without `Compiler`");
}
// Assert the processor is not frozen.
function $786f2a4b21dab975$var$assertUnfrozen(name, frozen) {
    if (frozen) throw new Error("Cannot invoke `" + name + "` on a frozen processor.\nCreate a new processor first, by invoking it: use `processor()` instead of `processor`.");
}
// Assert `node` is a unist node.
function $786f2a4b21dab975$var$assertNode(node) {
    if (!node || typeof node.type !== "string") throw new Error("Expected node, got `" + node + "`");
}
// Assert that `complete` is `true`.
function $786f2a4b21dab975$var$assertDone(name, asyncName, complete) {
    if (!complete) throw new Error("`" + name + "` finished async. Use `" + asyncName + "` instead");
}

});
parcelRegister("fxuRr", function(module, exports) {
"use strict";
var $b501e06b6b651fe4$var$hasOwn = Object.prototype.hasOwnProperty;
var $b501e06b6b651fe4$var$toStr = Object.prototype.toString;
var $b501e06b6b651fe4$var$defineProperty = Object.defineProperty;
var $b501e06b6b651fe4$var$gOPD = Object.getOwnPropertyDescriptor;
var $b501e06b6b651fe4$var$isArray = function isArray(arr) {
    if (typeof Array.isArray === "function") return Array.isArray(arr);
    return $b501e06b6b651fe4$var$toStr.call(arr) === "[object Array]";
};
var $b501e06b6b651fe4$var$isPlainObject = function isPlainObject(obj) {
    if (!obj || $b501e06b6b651fe4$var$toStr.call(obj) !== "[object Object]") return false;
    var hasOwnConstructor = $b501e06b6b651fe4$var$hasOwn.call(obj, "constructor");
    var hasIsPrototypeOf = obj.constructor && obj.constructor.prototype && $b501e06b6b651fe4$var$hasOwn.call(obj.constructor.prototype, "isPrototypeOf");
    // Not own constructor property must be Object
    if (obj.constructor && !hasOwnConstructor && !hasIsPrototypeOf) return false;
    // Own properties are enumerated firstly, so to speed up,
    // if last one is own, then all properties are own.
    var key;
    for(key in obj);
    return typeof key === "undefined" || $b501e06b6b651fe4$var$hasOwn.call(obj, key);
};
// If name is '__proto__', and Object.defineProperty is available, define __proto__ as an own property on target
var $b501e06b6b651fe4$var$setProperty = function setProperty(target, options) {
    if ($b501e06b6b651fe4$var$defineProperty && options.name === "__proto__") $b501e06b6b651fe4$var$defineProperty(target, options.name, {
        enumerable: true,
        configurable: true,
        value: options.newValue,
        writable: true
    });
    else target[options.name] = options.newValue;
};
// Return undefined instead of __proto__ if '__proto__' is not an own property
var $b501e06b6b651fe4$var$getProperty = function getProperty(obj, name) {
    if (name === "__proto__") {
        if (!$b501e06b6b651fe4$var$hasOwn.call(obj, name)) return void 0;
        else if ($b501e06b6b651fe4$var$gOPD) // In early versions of node, obj['__proto__'] is buggy when obj has
        // __proto__ as an own property. Object.getOwnPropertyDescriptor() works.
        return $b501e06b6b651fe4$var$gOPD(obj, name).value;
    }
    return obj[name];
};
module.exports = function extend() {
    var options, name, src, copy, copyIsArray, clone;
    var target = arguments[0];
    var i = 1;
    var length = arguments.length;
    var deep = false;
    // Handle a deep copy situation
    if (typeof target === "boolean") {
        deep = target;
        target = arguments[1] || {};
        // skip the boolean and the target
        i = 2;
    }
    if (target == null || typeof target !== "object" && typeof target !== "function") target = {};
    for(; i < length; ++i){
        options = arguments[i];
        // Only deal with non-null/undefined values
        if (options != null) // Extend the base object
        for(name in options){
            src = $b501e06b6b651fe4$var$getProperty(target, name);
            copy = $b501e06b6b651fe4$var$getProperty(options, name);
            // Prevent never-ending loop
            if (target !== copy) {
                // Recurse if we're merging plain objects or arrays
                if (deep && copy && ($b501e06b6b651fe4$var$isPlainObject(copy) || (copyIsArray = $b501e06b6b651fe4$var$isArray(copy)))) {
                    if (copyIsArray) {
                        copyIsArray = false;
                        clone = src && $b501e06b6b651fe4$var$isArray(src) ? src : [];
                    } else clone = src && $b501e06b6b651fe4$var$isPlainObject(src) ? src : {};
                    // Never move original objects, clone them
                    $b501e06b6b651fe4$var$setProperty(target, {
                        name: name,
                        newValue: extend(deep, clone, copy)
                    });
                // Don't bring in undefined values
                } else if (typeof copy !== "undefined") $b501e06b6b651fe4$var$setProperty(target, {
                    name: name,
                    newValue: copy
                });
            }
        }
    }
    // Return the modified object
    return target;
};

});

parcelRegister("bZMx7", function(module, exports) {
"use strict";
module.exports = $8bbb09eaf06aca0c$var$bail;
function $8bbb09eaf06aca0c$var$bail(err) {
    if (err) throw err;
}

});

parcelRegister("vpVay", function(module, exports) {
"use strict";

var $bPuwV = parcelRequire("bPuwV");

var $fwwoB = parcelRequire("fwwoB");
module.exports = $fwwoB;
var $05e700c0aeb742be$var$proto = $fwwoB.prototype;
$05e700c0aeb742be$var$proto.message = $05e700c0aeb742be$var$message;
$05e700c0aeb742be$var$proto.info = $05e700c0aeb742be$var$info;
$05e700c0aeb742be$var$proto.fail = $05e700c0aeb742be$var$fail;
// Create a message with `reason` at `position`.
// When an error is passed in as `reason`, copies the stack.
function $05e700c0aeb742be$var$message(reason, position, origin) {
    var filePath = this.path;
    var message = new $bPuwV(reason, position, origin);
    if (filePath) {
        message.name = filePath + ":" + message.name;
        message.file = filePath;
    }
    message.fatal = false;
    this.messages.push(message);
    return message;
}
// Fail: creates a vmessage, associates it with the file, and throws it.
function $05e700c0aeb742be$var$fail() {
    var message = this.message.apply(this, arguments);
    message.fatal = true;
    throw message;
}
// Info: creates a vmessage, associates it with the file, and marks the fatality
// as null.
function $05e700c0aeb742be$var$info() {
    var message = this.message.apply(this, arguments);
    message.fatal = null;
    return message;
}

});
parcelRegister("bPuwV", function(module, exports) {
"use strict";

var $eG7dw = parcelRequire("eG7dw");
module.exports = $89cc23c5335e372f$var$VMessage;
// Inherit from `Error#`.
function $89cc23c5335e372f$var$VMessagePrototype() {}
$89cc23c5335e372f$var$VMessagePrototype.prototype = Error.prototype;
$89cc23c5335e372f$var$VMessage.prototype = new $89cc23c5335e372f$var$VMessagePrototype();
// Message properties.
var $89cc23c5335e372f$var$proto = $89cc23c5335e372f$var$VMessage.prototype;
$89cc23c5335e372f$var$proto.file = "";
$89cc23c5335e372f$var$proto.name = "";
$89cc23c5335e372f$var$proto.reason = "";
$89cc23c5335e372f$var$proto.message = "";
$89cc23c5335e372f$var$proto.stack = "";
$89cc23c5335e372f$var$proto.fatal = null;
$89cc23c5335e372f$var$proto.column = null;
$89cc23c5335e372f$var$proto.line = null;
// Construct a new VMessage.
//
// Note: We cannot invoke `Error` on the created context, as that adds readonly
// `line` and `column` attributes on Safari 9, thus throwing and failing the
// data.
function $89cc23c5335e372f$var$VMessage(reason, position, origin) {
    var parts;
    var range;
    var location;
    if (typeof position === "string") {
        origin = position;
        position = null;
    }
    parts = $89cc23c5335e372f$var$parseOrigin(origin);
    range = $eG7dw(position) || "1:1";
    location = {
        start: {
            line: null,
            column: null
        },
        end: {
            line: null,
            column: null
        }
    };
    // Node.
    if (position && position.position) position = position.position;
    if (position) {
        // Position.
        if (position.start) {
            location = position;
            position = position.start;
        } else // Point.
        location.start = position;
    }
    if (reason.stack) {
        this.stack = reason.stack;
        reason = reason.message;
    }
    this.message = reason;
    this.name = range;
    this.reason = reason;
    this.line = position ? position.line : null;
    this.column = position ? position.column : null;
    this.location = location;
    this.source = parts[0];
    this.ruleId = parts[1];
}
function $89cc23c5335e372f$var$parseOrigin(origin) {
    var result = [
        null,
        null
    ];
    var index;
    if (typeof origin === "string") {
        index = origin.indexOf(":");
        if (index === -1) result[1] = origin;
        else {
            result[0] = origin.slice(0, index);
            result[1] = origin.slice(index + 1);
        }
    }
    return result;
}

});
parcelRegister("eG7dw", function(module, exports) {
"use strict";
var $aafa9619e0b09949$var$own = {}.hasOwnProperty;
module.exports = $aafa9619e0b09949$var$stringify;
function $aafa9619e0b09949$var$stringify(value) {
    // Nothing.
    if (!value || typeof value !== "object") return "";
    // Node.
    if ($aafa9619e0b09949$var$own.call(value, "position") || $aafa9619e0b09949$var$own.call(value, "type")) return $aafa9619e0b09949$var$position(value.position);
    // Position.
    if ($aafa9619e0b09949$var$own.call(value, "start") || $aafa9619e0b09949$var$own.call(value, "end")) return $aafa9619e0b09949$var$position(value);
    // Point.
    if ($aafa9619e0b09949$var$own.call(value, "line") || $aafa9619e0b09949$var$own.call(value, "column")) return $aafa9619e0b09949$var$point(value);
    // ?
    return "";
}
function $aafa9619e0b09949$var$point(point) {
    if (!point || typeof point !== "object") point = {};
    return $aafa9619e0b09949$var$index(point.line) + ":" + $aafa9619e0b09949$var$index(point.column);
}
function $aafa9619e0b09949$var$position(pos) {
    if (!pos || typeof pos !== "object") pos = {};
    return $aafa9619e0b09949$var$point(pos.start) + "-" + $aafa9619e0b09949$var$point(pos.end);
}
function $aafa9619e0b09949$var$index(value) {
    return value && typeof value === "number" ? value : 1;
}

});


parcelRegister("fwwoB", function(module, exports) {

var $7dgut = parcelRequire("7dgut");
"use strict";

var $iOurU = parcelRequire("iOurU");

var $1gN1A = parcelRequire("1gN1A");

var $3eCyv = parcelRequire("3eCyv");
module.exports = $b4d2f94dffc020b9$var$VFile;
var $b4d2f94dffc020b9$var$own = {}.hasOwnProperty;
var $b4d2f94dffc020b9$var$proto = $b4d2f94dffc020b9$var$VFile.prototype;
// Order of setting (least specific to most), we need this because otherwise
// `{stem: 'a', path: '~/b.js'}` would throw, as a path is needed before a
// stem can be set.
var $b4d2f94dffc020b9$var$order = [
    "history",
    "path",
    "basename",
    "stem",
    "extname",
    "dirname"
];
$b4d2f94dffc020b9$var$proto.toString = $b4d2f94dffc020b9$var$toString;
// Access full path (`~/index.min.js`).
Object.defineProperty($b4d2f94dffc020b9$var$proto, "path", {
    get: $b4d2f94dffc020b9$var$getPath,
    set: $b4d2f94dffc020b9$var$setPath
});
// Access parent path (`~`).
Object.defineProperty($b4d2f94dffc020b9$var$proto, "dirname", {
    get: $b4d2f94dffc020b9$var$getDirname,
    set: $b4d2f94dffc020b9$var$setDirname
});
// Access basename (`index.min.js`).
Object.defineProperty($b4d2f94dffc020b9$var$proto, "basename", {
    get: $b4d2f94dffc020b9$var$getBasename,
    set: $b4d2f94dffc020b9$var$setBasename
});
// Access extname (`.js`).
Object.defineProperty($b4d2f94dffc020b9$var$proto, "extname", {
    get: $b4d2f94dffc020b9$var$getExtname,
    set: $b4d2f94dffc020b9$var$setExtname
});
// Access stem (`index.min`).
Object.defineProperty($b4d2f94dffc020b9$var$proto, "stem", {
    get: $b4d2f94dffc020b9$var$getStem,
    set: $b4d2f94dffc020b9$var$setStem
});
// Construct a new file.
function $b4d2f94dffc020b9$var$VFile(options) {
    var prop;
    var index;
    var length;
    if (!options) options = {};
    else if (typeof options === "string" || $3eCyv(options)) options = {
        contents: options
    };
    else if ("message" in options && "messages" in options) return options;
    if (!(this instanceof $b4d2f94dffc020b9$var$VFile)) return new $b4d2f94dffc020b9$var$VFile(options);
    this.data = {};
    this.messages = [];
    this.history = [];
    this.cwd = $7dgut.cwd();
    // Set path related properties in the correct order.
    index = -1;
    length = $b4d2f94dffc020b9$var$order.length;
    while(++index < length){
        prop = $b4d2f94dffc020b9$var$order[index];
        if ($b4d2f94dffc020b9$var$own.call(options, prop)) this[prop] = options[prop];
    }
    // Set non-path related properties.
    for(prop in options)if ($b4d2f94dffc020b9$var$order.indexOf(prop) === -1) this[prop] = options[prop];
}
function $b4d2f94dffc020b9$var$getPath() {
    return this.history[this.history.length - 1];
}
function $b4d2f94dffc020b9$var$setPath(path) {
    $b4d2f94dffc020b9$var$assertNonEmpty(path, "path");
    if (path !== this.path) this.history.push(path);
}
function $b4d2f94dffc020b9$var$getDirname() {
    return typeof this.path === "string" ? $iOurU.dirname(this.path) : undefined;
}
function $b4d2f94dffc020b9$var$setDirname(dirname) {
    $b4d2f94dffc020b9$var$assertPath(this.path, "dirname");
    this.path = $iOurU.join(dirname || "", this.basename);
}
function $b4d2f94dffc020b9$var$getBasename() {
    return typeof this.path === "string" ? $iOurU.basename(this.path) : undefined;
}
function $b4d2f94dffc020b9$var$setBasename(basename) {
    $b4d2f94dffc020b9$var$assertNonEmpty(basename, "basename");
    $b4d2f94dffc020b9$var$assertPart(basename, "basename");
    this.path = $iOurU.join(this.dirname || "", basename);
}
function $b4d2f94dffc020b9$var$getExtname() {
    return typeof this.path === "string" ? $iOurU.extname(this.path) : undefined;
}
function $b4d2f94dffc020b9$var$setExtname(extname) {
    var ext = extname || "";
    $b4d2f94dffc020b9$var$assertPart(ext, "extname");
    $b4d2f94dffc020b9$var$assertPath(this.path, "extname");
    if (ext) {
        if (ext.charAt(0) !== ".") throw new Error("`extname` must start with `.`");
        if (ext.indexOf(".", 1) !== -1) throw new Error("`extname` cannot contain multiple dots");
    }
    this.path = $1gN1A(this.path, ext);
}
function $b4d2f94dffc020b9$var$getStem() {
    return typeof this.path === "string" ? $iOurU.basename(this.path, this.extname) : undefined;
}
function $b4d2f94dffc020b9$var$setStem(stem) {
    $b4d2f94dffc020b9$var$assertNonEmpty(stem, "stem");
    $b4d2f94dffc020b9$var$assertPart(stem, "stem");
    this.path = $iOurU.join(this.dirname || "", stem + (this.extname || ""));
}
// Get the value of the file.
function $b4d2f94dffc020b9$var$toString(encoding) {
    var value = this.contents || "";
    return $3eCyv(value) ? value.toString(encoding) : String(value);
}
// Assert that `part` is not a path (i.e., does not contain `path.sep`).
function $b4d2f94dffc020b9$var$assertPart(part, name) {
    if (part.indexOf($iOurU.sep) !== -1) throw new Error("`" + name + "` cannot be a path: did not expect `" + $iOurU.sep + "`");
}
// Assert that `part` is not empty.
function $b4d2f94dffc020b9$var$assertNonEmpty(part, name) {
    if (!part) throw new Error("`" + name + "` cannot be empty");
}
// Assert `path` exists.
function $b4d2f94dffc020b9$var$assertPath(path, name) {
    if (!path) throw new Error("Setting `" + name + "` requires `path` to be set too");
}

});
parcelRegister("7dgut", function(module, exports) {
// shim for using process in browser
var $540689f746aefe05$var$process = module.exports = {};
// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.
var $540689f746aefe05$var$cachedSetTimeout;
var $540689f746aefe05$var$cachedClearTimeout;
function $540689f746aefe05$var$defaultSetTimout() {
    throw new Error("setTimeout has not been defined");
}
function $540689f746aefe05$var$defaultClearTimeout() {
    throw new Error("clearTimeout has not been defined");
}
(function() {
    try {
        if (typeof setTimeout === "function") $540689f746aefe05$var$cachedSetTimeout = setTimeout;
        else $540689f746aefe05$var$cachedSetTimeout = $540689f746aefe05$var$defaultSetTimout;
    } catch (e) {
        $540689f746aefe05$var$cachedSetTimeout = $540689f746aefe05$var$defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === "function") $540689f746aefe05$var$cachedClearTimeout = clearTimeout;
        else $540689f746aefe05$var$cachedClearTimeout = $540689f746aefe05$var$defaultClearTimeout;
    } catch (e) {
        $540689f746aefe05$var$cachedClearTimeout = $540689f746aefe05$var$defaultClearTimeout;
    }
})();
function $540689f746aefe05$var$runTimeout(fun) {
    if ($540689f746aefe05$var$cachedSetTimeout === setTimeout) //normal enviroments in sane situations
    return setTimeout(fun, 0);
    // if setTimeout wasn't available but was latter defined
    if (($540689f746aefe05$var$cachedSetTimeout === $540689f746aefe05$var$defaultSetTimout || !$540689f746aefe05$var$cachedSetTimeout) && setTimeout) {
        $540689f746aefe05$var$cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $540689f746aefe05$var$cachedSetTimeout(fun, 0);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return $540689f746aefe05$var$cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return $540689f746aefe05$var$cachedSetTimeout.call(this, fun, 0);
        }
    }
}
function $540689f746aefe05$var$runClearTimeout(marker) {
    if ($540689f746aefe05$var$cachedClearTimeout === clearTimeout) //normal enviroments in sane situations
    return clearTimeout(marker);
    // if clearTimeout wasn't available but was latter defined
    if (($540689f746aefe05$var$cachedClearTimeout === $540689f746aefe05$var$defaultClearTimeout || !$540689f746aefe05$var$cachedClearTimeout) && clearTimeout) {
        $540689f746aefe05$var$cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $540689f746aefe05$var$cachedClearTimeout(marker);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return $540689f746aefe05$var$cachedClearTimeout.call(null, marker);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return $540689f746aefe05$var$cachedClearTimeout.call(this, marker);
        }
    }
}
var $540689f746aefe05$var$queue = [];
var $540689f746aefe05$var$draining = false;
var $540689f746aefe05$var$currentQueue;
var $540689f746aefe05$var$queueIndex = -1;
function $540689f746aefe05$var$cleanUpNextTick() {
    if (!$540689f746aefe05$var$draining || !$540689f746aefe05$var$currentQueue) return;
    $540689f746aefe05$var$draining = false;
    if ($540689f746aefe05$var$currentQueue.length) $540689f746aefe05$var$queue = $540689f746aefe05$var$currentQueue.concat($540689f746aefe05$var$queue);
    else $540689f746aefe05$var$queueIndex = -1;
    if ($540689f746aefe05$var$queue.length) $540689f746aefe05$var$drainQueue();
}
function $540689f746aefe05$var$drainQueue() {
    if ($540689f746aefe05$var$draining) return;
    var timeout = $540689f746aefe05$var$runTimeout($540689f746aefe05$var$cleanUpNextTick);
    $540689f746aefe05$var$draining = true;
    var len = $540689f746aefe05$var$queue.length;
    while(len){
        $540689f746aefe05$var$currentQueue = $540689f746aefe05$var$queue;
        $540689f746aefe05$var$queue = [];
        while(++$540689f746aefe05$var$queueIndex < len)if ($540689f746aefe05$var$currentQueue) $540689f746aefe05$var$currentQueue[$540689f746aefe05$var$queueIndex].run();
        $540689f746aefe05$var$queueIndex = -1;
        len = $540689f746aefe05$var$queue.length;
    }
    $540689f746aefe05$var$currentQueue = null;
    $540689f746aefe05$var$draining = false;
    $540689f746aefe05$var$runClearTimeout(timeout);
}
$540689f746aefe05$var$process.nextTick = function(fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    $540689f746aefe05$var$queue.push(new $540689f746aefe05$var$Item(fun, args));
    if ($540689f746aefe05$var$queue.length === 1 && !$540689f746aefe05$var$draining) $540689f746aefe05$var$runTimeout($540689f746aefe05$var$drainQueue);
};
// v8 likes predictible objects
function $540689f746aefe05$var$Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
$540689f746aefe05$var$Item.prototype.run = function() {
    this.fun.apply(null, this.array);
};
$540689f746aefe05$var$process.title = "browser";
$540689f746aefe05$var$process.browser = true;
$540689f746aefe05$var$process.env = {};
$540689f746aefe05$var$process.argv = [];
$540689f746aefe05$var$process.version = ""; // empty string to avoid regexp issues
$540689f746aefe05$var$process.versions = {};
function $540689f746aefe05$var$noop() {}
$540689f746aefe05$var$process.on = $540689f746aefe05$var$noop;
$540689f746aefe05$var$process.addListener = $540689f746aefe05$var$noop;
$540689f746aefe05$var$process.once = $540689f746aefe05$var$noop;
$540689f746aefe05$var$process.off = $540689f746aefe05$var$noop;
$540689f746aefe05$var$process.removeListener = $540689f746aefe05$var$noop;
$540689f746aefe05$var$process.removeAllListeners = $540689f746aefe05$var$noop;
$540689f746aefe05$var$process.emit = $540689f746aefe05$var$noop;
$540689f746aefe05$var$process.prependListener = $540689f746aefe05$var$noop;
$540689f746aefe05$var$process.prependOnceListener = $540689f746aefe05$var$noop;
$540689f746aefe05$var$process.listeners = function(name) {
    return [];
};
$540689f746aefe05$var$process.binding = function(name) {
    throw new Error("process.binding is not supported");
};
$540689f746aefe05$var$process.cwd = function() {
    return "/";
};
$540689f746aefe05$var$process.chdir = function(dir) {
    throw new Error("process.chdir is not supported");
};
$540689f746aefe05$var$process.umask = function() {
    return 0;
};

});

parcelRegister("iOurU", function(module, exports) {
// 'path' module extracted from Node.js v8.11.1 (only the posix part)
// transplited with Babel
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

var $7dgut = parcelRequire("7dgut");
"use strict";
function $db24840fa9c68a9a$var$assertPath(path) {
    if (typeof path !== "string") throw new TypeError("Path must be a string. Received " + JSON.stringify(path));
}
// Resolves . and .. elements in a path with directory names
function $db24840fa9c68a9a$var$normalizeStringPosix(path, allowAboveRoot) {
    var res = "";
    var lastSegmentLength = 0;
    var lastSlash = -1;
    var dots = 0;
    var code;
    for(var i = 0; i <= path.length; ++i){
        if (i < path.length) code = path.charCodeAt(i);
        else if (code === 47 /*/*/ ) break;
        else code = 47 /*/*/ ;
        if (code === 47 /*/*/ ) {
            if (lastSlash === i - 1 || dots === 1) ;
            else if (lastSlash !== i - 1 && dots === 2) {
                if (res.length < 2 || lastSegmentLength !== 2 || res.charCodeAt(res.length - 1) !== 46 /*.*/  || res.charCodeAt(res.length - 2) !== 46 /*.*/ ) {
                    if (res.length > 2) {
                        var lastSlashIndex = res.lastIndexOf("/");
                        if (lastSlashIndex !== res.length - 1) {
                            if (lastSlashIndex === -1) {
                                res = "";
                                lastSegmentLength = 0;
                            } else {
                                res = res.slice(0, lastSlashIndex);
                                lastSegmentLength = res.length - 1 - res.lastIndexOf("/");
                            }
                            lastSlash = i;
                            dots = 0;
                            continue;
                        }
                    } else if (res.length === 2 || res.length === 1) {
                        res = "";
                        lastSegmentLength = 0;
                        lastSlash = i;
                        dots = 0;
                        continue;
                    }
                }
                if (allowAboveRoot) {
                    if (res.length > 0) res += "/..";
                    else res = "..";
                    lastSegmentLength = 2;
                }
            } else {
                if (res.length > 0) res += "/" + path.slice(lastSlash + 1, i);
                else res = path.slice(lastSlash + 1, i);
                lastSegmentLength = i - lastSlash - 1;
            }
            lastSlash = i;
            dots = 0;
        } else if (code === 46 /*.*/  && dots !== -1) ++dots;
        else dots = -1;
    }
    return res;
}
function $db24840fa9c68a9a$var$_format(sep, pathObject) {
    var dir = pathObject.dir || pathObject.root;
    var base = pathObject.base || (pathObject.name || "") + (pathObject.ext || "");
    if (!dir) return base;
    if (dir === pathObject.root) return dir + base;
    return dir + sep + base;
}
var $db24840fa9c68a9a$var$posix = {
    // path.resolve([from ...], to)
    resolve: function resolve() {
        var resolvedPath = "";
        var resolvedAbsolute = false;
        var cwd;
        for(var i = arguments.length - 1; i >= -1 && !resolvedAbsolute; i--){
            var path;
            if (i >= 0) path = arguments[i];
            else {
                if (cwd === undefined) cwd = $7dgut.cwd();
                path = cwd;
            }
            $db24840fa9c68a9a$var$assertPath(path);
            // Skip empty entries
            if (path.length === 0) continue;
            resolvedPath = path + "/" + resolvedPath;
            resolvedAbsolute = path.charCodeAt(0) === 47 /*/*/ ;
        }
        // At this point the path should be resolved to a full absolute path, but
        // handle relative paths to be safe (might happen when process.cwd() fails)
        // Normalize the path
        resolvedPath = $db24840fa9c68a9a$var$normalizeStringPosix(resolvedPath, !resolvedAbsolute);
        if (resolvedAbsolute) {
            if (resolvedPath.length > 0) return "/" + resolvedPath;
            else return "/";
        } else if (resolvedPath.length > 0) return resolvedPath;
        else return ".";
    },
    normalize: function normalize(path) {
        $db24840fa9c68a9a$var$assertPath(path);
        if (path.length === 0) return ".";
        var isAbsolute = path.charCodeAt(0) === 47 /*/*/ ;
        var trailingSeparator = path.charCodeAt(path.length - 1) === 47 /*/*/ ;
        // Normalize the path
        path = $db24840fa9c68a9a$var$normalizeStringPosix(path, !isAbsolute);
        if (path.length === 0 && !isAbsolute) path = ".";
        if (path.length > 0 && trailingSeparator) path += "/";
        if (isAbsolute) return "/" + path;
        return path;
    },
    isAbsolute: function isAbsolute(path) {
        $db24840fa9c68a9a$var$assertPath(path);
        return path.length > 0 && path.charCodeAt(0) === 47 /*/*/ ;
    },
    join: function join() {
        if (arguments.length === 0) return ".";
        var joined;
        for(var i = 0; i < arguments.length; ++i){
            var arg = arguments[i];
            $db24840fa9c68a9a$var$assertPath(arg);
            if (arg.length > 0) {
                if (joined === undefined) joined = arg;
                else joined += "/" + arg;
            }
        }
        if (joined === undefined) return ".";
        return $db24840fa9c68a9a$var$posix.normalize(joined);
    },
    relative: function relative(from, to) {
        $db24840fa9c68a9a$var$assertPath(from);
        $db24840fa9c68a9a$var$assertPath(to);
        if (from === to) return "";
        from = $db24840fa9c68a9a$var$posix.resolve(from);
        to = $db24840fa9c68a9a$var$posix.resolve(to);
        if (from === to) return "";
        // Trim any leading backslashes
        var fromStart = 1;
        for(; fromStart < from.length; ++fromStart){
            if (from.charCodeAt(fromStart) !== 47 /*/*/ ) break;
        }
        var fromEnd = from.length;
        var fromLen = fromEnd - fromStart;
        // Trim any leading backslashes
        var toStart = 1;
        for(; toStart < to.length; ++toStart){
            if (to.charCodeAt(toStart) !== 47 /*/*/ ) break;
        }
        var toEnd = to.length;
        var toLen = toEnd - toStart;
        // Compare paths to find the longest common path from root
        var length = fromLen < toLen ? fromLen : toLen;
        var lastCommonSep = -1;
        var i = 0;
        for(; i <= length; ++i){
            if (i === length) {
                if (toLen > length) {
                    if (to.charCodeAt(toStart + i) === 47 /*/*/ ) // We get here if `from` is the exact base path for `to`.
                    // For example: from='/foo/bar'; to='/foo/bar/baz'
                    return to.slice(toStart + i + 1);
                    else if (i === 0) // We get here if `from` is the root
                    // For example: from='/'; to='/foo'
                    return to.slice(toStart + i);
                } else if (fromLen > length) {
                    if (from.charCodeAt(fromStart + i) === 47 /*/*/ ) // We get here if `to` is the exact base path for `from`.
                    // For example: from='/foo/bar/baz'; to='/foo/bar'
                    lastCommonSep = i;
                    else if (i === 0) // We get here if `to` is the root.
                    // For example: from='/foo'; to='/'
                    lastCommonSep = 0;
                }
                break;
            }
            var fromCode = from.charCodeAt(fromStart + i);
            var toCode = to.charCodeAt(toStart + i);
            if (fromCode !== toCode) break;
            else if (fromCode === 47 /*/*/ ) lastCommonSep = i;
        }
        var out = "";
        // Generate the relative path based on the path difference between `to`
        // and `from`
        for(i = fromStart + lastCommonSep + 1; i <= fromEnd; ++i)if (i === fromEnd || from.charCodeAt(i) === 47 /*/*/ ) {
            if (out.length === 0) out += "..";
            else out += "/..";
        }
        // Lastly, append the rest of the destination (`to`) path that comes after
        // the common path parts
        if (out.length > 0) return out + to.slice(toStart + lastCommonSep);
        else {
            toStart += lastCommonSep;
            if (to.charCodeAt(toStart) === 47 /*/*/ ) ++toStart;
            return to.slice(toStart);
        }
    },
    _makeLong: function _makeLong(path) {
        return path;
    },
    dirname: function dirname(path) {
        $db24840fa9c68a9a$var$assertPath(path);
        if (path.length === 0) return ".";
        var code = path.charCodeAt(0);
        var hasRoot = code === 47 /*/*/ ;
        var end = -1;
        var matchedSlash = true;
        for(var i = path.length - 1; i >= 1; --i){
            code = path.charCodeAt(i);
            if (code === 47 /*/*/ ) {
                if (!matchedSlash) {
                    end = i;
                    break;
                }
            } else // We saw the first non-path separator
            matchedSlash = false;
        }
        if (end === -1) return hasRoot ? "/" : ".";
        if (hasRoot && end === 1) return "//";
        return path.slice(0, end);
    },
    basename: function basename(path, ext) {
        if (ext !== undefined && typeof ext !== "string") throw new TypeError('"ext" argument must be a string');
        $db24840fa9c68a9a$var$assertPath(path);
        var start = 0;
        var end = -1;
        var matchedSlash = true;
        var i;
        if (ext !== undefined && ext.length > 0 && ext.length <= path.length) {
            if (ext.length === path.length && ext === path) return "";
            var extIdx = ext.length - 1;
            var firstNonSlashEnd = -1;
            for(i = path.length - 1; i >= 0; --i){
                var code = path.charCodeAt(i);
                if (code === 47 /*/*/ ) // If we reached a path separator that was not part of a set of path
                // separators at the end of the string, stop now
                {
                    if (!matchedSlash) {
                        start = i + 1;
                        break;
                    }
                } else {
                    if (firstNonSlashEnd === -1) {
                        // We saw the first non-path separator, remember this index in case
                        // we need it if the extension ends up not matching
                        matchedSlash = false;
                        firstNonSlashEnd = i + 1;
                    }
                    if (extIdx >= 0) {
                        // Try to match the explicit extension
                        if (code === ext.charCodeAt(extIdx)) {
                            if (--extIdx === -1) // We matched the extension, so mark this as the end of our path
                            // component
                            end = i;
                        } else {
                            // Extension does not match, so our result is the entire path
                            // component
                            extIdx = -1;
                            end = firstNonSlashEnd;
                        }
                    }
                }
            }
            if (start === end) end = firstNonSlashEnd;
            else if (end === -1) end = path.length;
            return path.slice(start, end);
        } else {
            for(i = path.length - 1; i >= 0; --i){
                if (path.charCodeAt(i) === 47 /*/*/ ) // If we reached a path separator that was not part of a set of path
                // separators at the end of the string, stop now
                {
                    if (!matchedSlash) {
                        start = i + 1;
                        break;
                    }
                } else if (end === -1) {
                    // We saw the first non-path separator, mark this as the end of our
                    // path component
                    matchedSlash = false;
                    end = i + 1;
                }
            }
            if (end === -1) return "";
            return path.slice(start, end);
        }
    },
    extname: function extname(path) {
        $db24840fa9c68a9a$var$assertPath(path);
        var startDot = -1;
        var startPart = 0;
        var end = -1;
        var matchedSlash = true;
        // Track the state of characters (if any) we see before our first dot and
        // after any path separator we find
        var preDotState = 0;
        for(var i = path.length - 1; i >= 0; --i){
            var code = path.charCodeAt(i);
            if (code === 47 /*/*/ ) {
                // If we reached a path separator that was not part of a set of path
                // separators at the end of the string, stop now
                if (!matchedSlash) {
                    startPart = i + 1;
                    break;
                }
                continue;
            }
            if (end === -1) {
                // We saw the first non-path separator, mark this as the end of our
                // extension
                matchedSlash = false;
                end = i + 1;
            }
            if (code === 46 /*.*/ ) {
                // If this is our first dot, mark it as the start of our extension
                if (startDot === -1) startDot = i;
                else if (preDotState !== 1) preDotState = 1;
            } else if (startDot !== -1) // We saw a non-dot and non-path separator before our dot, so we should
            // have a good chance at having a non-empty extension
            preDotState = -1;
        }
        if (startDot === -1 || end === -1 || // We saw a non-dot character immediately before the dot
        preDotState === 0 || // The (right-most) trimmed path component is exactly '..'
        preDotState === 1 && startDot === end - 1 && startDot === startPart + 1) return "";
        return path.slice(startDot, end);
    },
    format: function format(pathObject) {
        if (pathObject === null || typeof pathObject !== "object") throw new TypeError('The "pathObject" argument must be of type Object. Received type ' + typeof pathObject);
        return $db24840fa9c68a9a$var$_format("/", pathObject);
    },
    parse: function parse(path) {
        $db24840fa9c68a9a$var$assertPath(path);
        var ret = {
            root: "",
            dir: "",
            base: "",
            ext: "",
            name: ""
        };
        if (path.length === 0) return ret;
        var code = path.charCodeAt(0);
        var isAbsolute = code === 47 /*/*/ ;
        var start;
        if (isAbsolute) {
            ret.root = "/";
            start = 1;
        } else start = 0;
        var startDot = -1;
        var startPart = 0;
        var end = -1;
        var matchedSlash = true;
        var i = path.length - 1;
        // Track the state of characters (if any) we see before our first dot and
        // after any path separator we find
        var preDotState = 0;
        // Get non-dir info
        for(; i >= start; --i){
            code = path.charCodeAt(i);
            if (code === 47 /*/*/ ) {
                // If we reached a path separator that was not part of a set of path
                // separators at the end of the string, stop now
                if (!matchedSlash) {
                    startPart = i + 1;
                    break;
                }
                continue;
            }
            if (end === -1) {
                // We saw the first non-path separator, mark this as the end of our
                // extension
                matchedSlash = false;
                end = i + 1;
            }
            if (code === 46 /*.*/ ) {
                // If this is our first dot, mark it as the start of our extension
                if (startDot === -1) startDot = i;
                else if (preDotState !== 1) preDotState = 1;
            } else if (startDot !== -1) // We saw a non-dot and non-path separator before our dot, so we should
            // have a good chance at having a non-empty extension
            preDotState = -1;
        }
        if (startDot === -1 || end === -1 || // We saw a non-dot character immediately before the dot
        preDotState === 0 || // The (right-most) trimmed path component is exactly '..'
        preDotState === 1 && startDot === end - 1 && startDot === startPart + 1) {
            if (end !== -1) {
                if (startPart === 0 && isAbsolute) ret.base = ret.name = path.slice(1, end);
                else ret.base = ret.name = path.slice(startPart, end);
            }
        } else {
            if (startPart === 0 && isAbsolute) {
                ret.name = path.slice(1, startDot);
                ret.base = path.slice(1, end);
            } else {
                ret.name = path.slice(startPart, startDot);
                ret.base = path.slice(startPart, end);
            }
            ret.ext = path.slice(startDot, end);
        }
        if (startPart > 0) ret.dir = path.slice(0, startPart - 1);
        else if (isAbsolute) ret.dir = "/";
        return ret;
    },
    sep: "/",
    delimiter: ":",
    win32: null,
    posix: null
};
$db24840fa9c68a9a$var$posix.posix = $db24840fa9c68a9a$var$posix;
module.exports = $db24840fa9c68a9a$var$posix;

});

parcelRegister("1gN1A", function(module, exports) {
"use strict";

var $iOurU = parcelRequire("iOurU");
function $0ecd5055f547f8a4$var$replaceExt(npath, ext) {
    if (typeof npath !== "string") return npath;
    if (npath.length === 0) return npath;
    var nFileName = $iOurU.basename(npath, $iOurU.extname(npath)) + ext;
    return $iOurU.join($iOurU.dirname(npath), nFileName);
}
module.exports = $0ecd5055f547f8a4$var$replaceExt;

});

parcelRegister("3eCyv", function(module, exports) {
/*!
 * Determine if an object is a Buffer
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ module.exports = function isBuffer(obj) {
    return obj != null && obj.constructor != null && typeof obj.constructor.isBuffer === "function" && obj.constructor.isBuffer(obj);
};

});



parcelRegister("7SpAC", function(module, exports) {
"use strict";

var $ihG1m = parcelRequire("ihG1m");
module.exports = $017adc9937679e2f$var$trough;
$017adc9937679e2f$var$trough.wrap = $ihG1m;
var $017adc9937679e2f$var$slice = [].slice;
// Create new middleware.
function $017adc9937679e2f$var$trough() {
    var fns = [];
    var middleware = {};
    middleware.run = run;
    middleware.use = use;
    return middleware;
    // Run `fns`.  Last argument must be a completion handler.
    function run() {
        var index = -1;
        var input = $017adc9937679e2f$var$slice.call(arguments, 0, -1);
        var done = arguments[arguments.length - 1];
        if (typeof done !== "function") throw new Error("Expected function as last argument, not " + done);
        next.apply(null, [
            null
        ].concat(input));
        // Run the next `fn`, if any.
        function next(err) {
            var fn = fns[++index];
            var params = $017adc9937679e2f$var$slice.call(arguments, 0);
            var values = params.slice(1);
            var length = input.length;
            var pos = -1;
            if (err) {
                done(err);
                return;
            }
            // Copy non-nully input into values.
            while(++pos < length)if (values[pos] === null || values[pos] === undefined) values[pos] = input[pos];
            input = values;
            // Next or done.
            if (fn) $ihG1m(fn, next).apply(null, input);
            else done.apply(null, [
                null
            ].concat(input));
        }
    }
    // Add `fn` to the list.
    function use(fn) {
        if (typeof fn !== "function") throw new Error("Expected `fn` to be a function, not " + fn);
        fns.push(fn);
        return middleware;
    }
}

});
parcelRegister("ihG1m", function(module, exports) {
"use strict";
var $d4fa68fd2733e2cf$var$slice = [].slice;
module.exports = $d4fa68fd2733e2cf$var$wrap;
// Wrap `fn`.
// Can be sync or async; return a promise, receive a completion handler, return
// new values and errors.
function $d4fa68fd2733e2cf$var$wrap(fn, callback) {
    var invoked;
    return wrapped;
    function wrapped() {
        var params = $d4fa68fd2733e2cf$var$slice.call(arguments, 0);
        var callback = fn.length > params.length;
        var result;
        if (callback) params.push(done);
        try {
            result = fn.apply(null, params);
        } catch (error) {
            // Well, this is quite the pickle.
            // `fn` received a callback and invoked it (thus continuing the pipeline),
            // but later also threw an error.
            // We’re not about to restart the pipeline again, so the only thing left
            // to do is to throw the thing instead.
            if (callback && invoked) throw error;
            return done(error);
        }
        if (!callback) {
            if (result && typeof result.then === "function") result.then(then, done);
            else if (result instanceof Error) done(result);
            else then(result);
        }
    }
    // Invoke `next`, only once.
    function done() {
        if (!invoked) {
            invoked = true;
            callback.apply(null, arguments);
        }
    }
    // Invoke `done` with one value.
    // Tracks if an error is passed, too.
    function then(value) {
        done(null, value);
    }
}

});


parcelRegister("f0IPP", function(module, exports) {
"use strict";
module.exports = (value)=>{
    if (Object.prototype.toString.call(value) !== "[object Object]") return false;
    const prototype = Object.getPrototypeOf(value);
    return prototype === null || prototype === Object.prototype;
};

});


parcelRegister("PZETB", function(module, exports) {
"use strict";

var $4HYGy = parcelRequire("4HYGy");

var $36bRz = parcelRequire("36bRz");

var $G7B4J = parcelRequire("G7B4J");
module.exports = $09c497a69dbc7da5$var$parse;
$09c497a69dbc7da5$var$parse.Parser = $G7B4J;
function $09c497a69dbc7da5$var$parse(options) {
    var settings = this.data("settings");
    var Local = $4HYGy($G7B4J);
    Local.prototype.options = $36bRz(Local.prototype.options, settings, options);
    this.Parser = Local;
}

});
parcelRegister("4HYGy", function(module, exports) {
"use strict";

var $36bRz = parcelRequire("36bRz");

var $7Q4w4 = parcelRequire("7Q4w4");
module.exports = $36da4070a7384296$var$unherit;
// Create a custom constructor which can be modified without affecting the
// original class.
function $36da4070a7384296$var$unherit(Super) {
    var result;
    var key;
    var value;
    $7Q4w4(Of, Super);
    $7Q4w4(From, Of);
    // Clone values.
    result = Of.prototype;
    for(key in result){
        value = result[key];
        if (value && typeof value === "object") result[key] = "concat" in value ? value.concat() : $36bRz(value);
    }
    return Of;
    // Constructor accepting a single argument, which itself is an `arguments`
    // object.
    function From(parameters) {
        return Super.apply(this, parameters);
    }
    // Constructor accepting variadic arguments.
    function Of() {
        if (!(this instanceof Of)) return new From(arguments);
        return Super.apply(this, arguments);
    }
}

});
parcelRegister("36bRz", function(module, exports) {
module.exports = $241b2260c1f9890b$var$extend;
var $241b2260c1f9890b$var$hasOwnProperty = Object.prototype.hasOwnProperty;
function $241b2260c1f9890b$var$extend() {
    var target = {};
    for(var i = 0; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if ($241b2260c1f9890b$var$hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
}

});

parcelRegister("7Q4w4", function(module, exports) {
if (typeof Object.create === "function") // implementation from standard node.js 'util' module
module.exports = function inherits(ctor, superCtor) {
    if (superCtor) {
        ctor.super_ = superCtor;
        ctor.prototype = Object.create(superCtor.prototype, {
            constructor: {
                value: ctor,
                enumerable: false,
                writable: true,
                configurable: true
            }
        });
    }
};
else // old school shim for old browsers
module.exports = function inherits(ctor, superCtor) {
    if (superCtor) {
        ctor.super_ = superCtor;
        var TempCtor = function() {};
        TempCtor.prototype = superCtor.prototype;
        ctor.prototype = new TempCtor();
        ctor.prototype.constructor = ctor;
    }
};

});


parcelRegister("G7B4J", function(module, exports) {
"use strict";

var $36bRz = parcelRequire("36bRz");

var $2Na8b = parcelRequire("2Na8b");

var $etX82 = parcelRequire("etX82");

var $gVaw4 = parcelRequire("gVaw4");

var $RwGFz = parcelRequire("RwGFz");

var $9H32T = parcelRequire("9H32T");
module.exports = $07e9d0f66f1e1b4a$var$Parser;
function $07e9d0f66f1e1b4a$var$Parser(doc, file) {
    this.file = file;
    this.offset = {};
    this.options = $36bRz(this.options);
    this.setOptions({});
    this.inList = false;
    this.inBlock = false;
    this.inLink = false;
    this.atStart = true;
    this.toOffset = $etX82(file).toOffset;
    this.unescape = $gVaw4(this, "escape");
    this.decode = $RwGFz(this);
}
var $07e9d0f66f1e1b4a$var$proto = $07e9d0f66f1e1b4a$var$Parser.prototype;

// Expose core.
$07e9d0f66f1e1b4a$var$proto.setOptions = (parcelRequire("8A1yv"));

$07e9d0f66f1e1b4a$var$proto.parse = (parcelRequire("gVkoZ"));

// Expose `defaults`.
$07e9d0f66f1e1b4a$var$proto.options = (parcelRequire("2WaU5"));
// Enter and exit helpers.
$07e9d0f66f1e1b4a$var$proto.exitStart = $2Na8b("atStart", true);
$07e9d0f66f1e1b4a$var$proto.enterList = $2Na8b("inList", false);
$07e9d0f66f1e1b4a$var$proto.enterLink = $2Na8b("inLink", false);
$07e9d0f66f1e1b4a$var$proto.enterBlock = $2Na8b("inBlock", false);
// Nodes that can interupt a paragraph:
//
// ```markdown
// A paragraph, followed by a thematic break.
// ___
// ```
//
// In the above example, the thematic break “interupts” the paragraph.
$07e9d0f66f1e1b4a$var$proto.interruptParagraph = [
    [
        "thematicBreak"
    ],
    [
        "atxHeading"
    ],
    [
        "fencedCode"
    ],
    [
        "blockquote"
    ],
    [
        "html"
    ],
    [
        "setextHeading",
        {
            commonmark: false
        }
    ],
    [
        "definition",
        {
            commonmark: false
        }
    ],
    [
        "footnote",
        {
            commonmark: false
        }
    ]
];
// Nodes that can interupt a list:
//
// ```markdown
// - One
// ___
// ```
//
// In the above example, the thematic break “interupts” the list.
$07e9d0f66f1e1b4a$var$proto.interruptList = [
    [
        "atxHeading",
        {
            pedantic: false
        }
    ],
    [
        "fencedCode",
        {
            pedantic: false
        }
    ],
    [
        "thematicBreak",
        {
            pedantic: false
        }
    ],
    [
        "definition",
        {
            commonmark: false
        }
    ],
    [
        "footnote",
        {
            commonmark: false
        }
    ]
];
// Nodes that can interupt a blockquote:
//
// ```markdown
// > A paragraph.
// ___
// ```
//
// In the above example, the thematic break “interupts” the blockquote.
$07e9d0f66f1e1b4a$var$proto.interruptBlockquote = [
    [
        "indentedCode",
        {
            commonmark: true
        }
    ],
    [
        "fencedCode",
        {
            commonmark: true
        }
    ],
    [
        "atxHeading",
        {
            commonmark: true
        }
    ],
    [
        "setextHeading",
        {
            commonmark: true
        }
    ],
    [
        "thematicBreak",
        {
            commonmark: true
        }
    ],
    [
        "html",
        {
            commonmark: true
        }
    ],
    [
        "list",
        {
            commonmark: true
        }
    ],
    [
        "definition",
        {
            commonmark: false
        }
    ],
    [
        "footnote",
        {
            commonmark: false
        }
    ]
];













// Handlers.
$07e9d0f66f1e1b4a$var$proto.blockTokenizers = {
    newline: (parcelRequire("eWCwV")),
    indentedCode: (parcelRequire("g5BkQ")),
    fencedCode: (parcelRequire("8jp8K")),
    blockquote: (parcelRequire("hFW9g")),
    atxHeading: (parcelRequire("2Y1RE")),
    thematicBreak: (parcelRequire("5GZmu")),
    list: (parcelRequire("gMkLN")),
    setextHeading: (parcelRequire("6gCu0")),
    html: (parcelRequire("8EbVz")),
    footnote: (parcelRequire("lRbMn")),
    definition: (parcelRequire("gv9fx")),
    table: (parcelRequire("04Igv")),
    paragraph: (parcelRequire("hfuIQ"))
};












$07e9d0f66f1e1b4a$var$proto.inlineTokenizers = {
    escape: (parcelRequire("fG8Jf")),
    autoLink: (parcelRequire("40HEA")),
    url: (parcelRequire("cXItb")),
    html: (parcelRequire("76c2Q")),
    link: (parcelRequire("4bxc4")),
    reference: (parcelRequire("7Wiug")),
    strong: (parcelRequire("fmNrr")),
    emphasis: (parcelRequire("7yt0a")),
    deletion: (parcelRequire("8NqmE")),
    code: (parcelRequire("kcJCs")),
    break: (parcelRequire("5HxXI")),
    text: (parcelRequire("6Wwq4"))
};
// Expose precedence.
$07e9d0f66f1e1b4a$var$proto.blockMethods = $07e9d0f66f1e1b4a$var$keys($07e9d0f66f1e1b4a$var$proto.blockTokenizers);
$07e9d0f66f1e1b4a$var$proto.inlineMethods = $07e9d0f66f1e1b4a$var$keys($07e9d0f66f1e1b4a$var$proto.inlineTokenizers);
// Tokenizers.
$07e9d0f66f1e1b4a$var$proto.tokenizeBlock = $9H32T("block");
$07e9d0f66f1e1b4a$var$proto.tokenizeInline = $9H32T("inline");
$07e9d0f66f1e1b4a$var$proto.tokenizeFactory = $9H32T;
// Get all keys in `value`.
function $07e9d0f66f1e1b4a$var$keys(value) {
    var result = [];
    var key;
    for(key in value)result.push(key);
    return result;
}

});
parcelRegister("2Na8b", function(module, exports) {
"use strict";
module.exports = $2088042db98445c3$var$factory;
// Construct a state `toggler`: a function which inverses `property` in context
// based on its current value.
// The by `toggler` returned function restores that value.
function $2088042db98445c3$var$factory(key, state, ctx) {
    return enter;
    function enter() {
        var context = ctx || this;
        var current = context[key];
        context[key] = !state;
        return exit;
        function exit() {
            context[key] = current;
        }
    }
}

});

parcelRegister("etX82", function(module, exports) {
"use strict";
module.exports = $a8b1a3d64223ebef$var$factory;
function $a8b1a3d64223ebef$var$factory(file) {
    var contents = $a8b1a3d64223ebef$var$indices(String(file));
    return {
        toPosition: $a8b1a3d64223ebef$var$offsetToPositionFactory(contents),
        toOffset: $a8b1a3d64223ebef$var$positionToOffsetFactory(contents)
    };
}
// Factory to get the line and column-based `position` for `offset` in the bound
// indices.
function $a8b1a3d64223ebef$var$offsetToPositionFactory(indices) {
    return offsetToPosition;
    // Get the line and column-based `position` for `offset` in the bound indices.
    function offsetToPosition(offset) {
        var index = -1;
        var length = indices.length;
        if (offset < 0) return {};
        while(++index < length){
            if (indices[index] > offset) return {
                line: index + 1,
                column: offset - (indices[index - 1] || 0) + 1,
                offset: offset
            };
        }
        return {};
    }
}
// Factory to get the `offset` for a line and column-based `position` in the
// bound indices.
function $a8b1a3d64223ebef$var$positionToOffsetFactory(indices) {
    return positionToOffset;
    // Get the `offset` for a line and column-based `position` in the bound
    // indices.
    function positionToOffset(position) {
        var line = position && position.line;
        var column = position && position.column;
        if (!isNaN(line) && !isNaN(column) && line - 1 in indices) return (indices[line - 2] || 0) + column - 1 || 0;
        return -1;
    }
}
// Get indices of line-breaks in `value`.
function $a8b1a3d64223ebef$var$indices(value) {
    var result = [];
    var index = value.indexOf("\n");
    while(index !== -1){
        result.push(index + 1);
        index = value.indexOf("\n", index + 1);
    }
    result.push(value.length + 1);
    return result;
}

});

parcelRegister("gVaw4", function(module, exports) {
"use strict";
module.exports = $c51a20857cab52c5$var$factory;
var $c51a20857cab52c5$var$backslash = "\\";
// Factory to de-escape a value, based on a list at `key` in `ctx`.
function $c51a20857cab52c5$var$factory(ctx, key) {
    return unescape;
    // De-escape a string using the expression at `key` in `ctx`.
    function unescape(value) {
        var prev = 0;
        var index = value.indexOf($c51a20857cab52c5$var$backslash);
        var escape = ctx[key];
        var queue = [];
        var character;
        while(index !== -1){
            queue.push(value.slice(prev, index));
            prev = index + 1;
            character = value.charAt(prev);
            // If the following character is not a valid escape, add the slash.
            if (!character || escape.indexOf(character) === -1) queue.push($c51a20857cab52c5$var$backslash);
            index = value.indexOf($c51a20857cab52c5$var$backslash, prev + 1);
        }
        queue.push(value.slice(prev));
        return queue.join("");
    }
}

});

parcelRegister("RwGFz", function(module, exports) {
"use strict";

var $36bRz = parcelRequire("36bRz");

var $eUIxU = parcelRequire("eUIxU");
module.exports = $0a0e4e5a2f4c08fc$var$factory;
// Factory to create an entity decoder.
function $0a0e4e5a2f4c08fc$var$factory(ctx) {
    decoder.raw = decodeRaw;
    return decoder;
    // Normalize `position` to add an `indent`.
    function normalize(position) {
        var offsets = ctx.offset;
        var line = position.line;
        var result = [];
        while(++line){
            if (!(line in offsets)) break;
            result.push((offsets[line] || 0) + 1);
        }
        return {
            start: position,
            indent: result
        };
    }
    // Decode `value` (at `position`) into text-nodes.
    function decoder(value, position, handler) {
        $eUIxU(value, {
            position: normalize(position),
            warning: handleWarning,
            text: handler,
            reference: handler,
            textContext: ctx,
            referenceContext: ctx
        });
    }
    // Decode `value` (at `position`) into a string.
    function decodeRaw(value, position, options) {
        return $eUIxU(value, $36bRz(options, {
            position: normalize(position),
            warning: handleWarning
        }));
    }
    // Handle a warning.
    // See <https://github.com/wooorm/parse-entities> for the warnings.
    function handleWarning(reason, position, code) {
        if (code !== 3) ctx.file.message(reason, position);
    }
}

});
parcelRegister("eUIxU", function(module, exports) {
"use strict";

var $9PlhL = parcelRequire("9PlhL");

var $i3t4F = parcelRequire("i3t4F");

var $35IlD = parcelRequire("35IlD");

var $6lhfp = parcelRequire("6lhfp");

var $a278X = parcelRequire("a278X");

var $5IZQE = parcelRequire("5IZQE");
module.exports = $adb8d98d7e693dfc$var$parseEntities;
var $adb8d98d7e693dfc$var$own = {}.hasOwnProperty;
var $adb8d98d7e693dfc$var$fromCharCode = String.fromCharCode;
var $adb8d98d7e693dfc$var$noop = Function.prototype;
// Default settings.
var $adb8d98d7e693dfc$var$defaults = {
    warning: null,
    reference: null,
    text: null,
    warningContext: null,
    referenceContext: null,
    textContext: null,
    position: {},
    additional: null,
    attribute: false,
    nonTerminated: true
};
// Characters.
var $adb8d98d7e693dfc$var$tab = 9 // '\t'
;
var $adb8d98d7e693dfc$var$lineFeed = 10 // '\n'
;
var $adb8d98d7e693dfc$var$formFeed = 12 //  '\f'
;
var $adb8d98d7e693dfc$var$space = 32 // ' '
;
var $adb8d98d7e693dfc$var$ampersand = 38 //  '&'
;
var $adb8d98d7e693dfc$var$semicolon = 59 //  ';'
;
var $adb8d98d7e693dfc$var$lessThan = 60 //  '<'
;
var $adb8d98d7e693dfc$var$equalsTo = 61 //  '='
;
var $adb8d98d7e693dfc$var$numberSign = 35 //  '#'
;
var $adb8d98d7e693dfc$var$uppercaseX = 88 //  'X'
;
var $adb8d98d7e693dfc$var$lowercaseX = 120 //  'x'
;
var $adb8d98d7e693dfc$var$replacementCharacter = 65533 // '�'
;
// Reference types.
var $adb8d98d7e693dfc$var$name = "named";
var $adb8d98d7e693dfc$var$hexa = "hexadecimal";
var $adb8d98d7e693dfc$var$deci = "decimal";
// Map of bases.
var $adb8d98d7e693dfc$var$bases = {};
$adb8d98d7e693dfc$var$bases[$adb8d98d7e693dfc$var$hexa] = 16;
$adb8d98d7e693dfc$var$bases[$adb8d98d7e693dfc$var$deci] = 10;
// Map of types to tests.
// Each type of character reference accepts different characters.
// This test is used to detect whether a reference has ended (as the semicolon
// is not strictly needed).
var $adb8d98d7e693dfc$var$tests = {};
$adb8d98d7e693dfc$var$tests[$adb8d98d7e693dfc$var$name] = $a278X;
$adb8d98d7e693dfc$var$tests[$adb8d98d7e693dfc$var$deci] = $35IlD;
$adb8d98d7e693dfc$var$tests[$adb8d98d7e693dfc$var$hexa] = $6lhfp;
// Warning types.
var $adb8d98d7e693dfc$var$namedNotTerminated = 1;
var $adb8d98d7e693dfc$var$numericNotTerminated = 2;
var $adb8d98d7e693dfc$var$namedEmpty = 3;
var $adb8d98d7e693dfc$var$numericEmpty = 4;
var $adb8d98d7e693dfc$var$namedUnknown = 5;
var $adb8d98d7e693dfc$var$numericDisallowed = 6;
var $adb8d98d7e693dfc$var$numericProhibited = 7;
// Warning messages.
var $adb8d98d7e693dfc$var$messages = {};
$adb8d98d7e693dfc$var$messages[$adb8d98d7e693dfc$var$namedNotTerminated] = "Named character references must be terminated by a semicolon";
$adb8d98d7e693dfc$var$messages[$adb8d98d7e693dfc$var$numericNotTerminated] = "Numeric character references must be terminated by a semicolon";
$adb8d98d7e693dfc$var$messages[$adb8d98d7e693dfc$var$namedEmpty] = "Named character references cannot be empty";
$adb8d98d7e693dfc$var$messages[$adb8d98d7e693dfc$var$numericEmpty] = "Numeric character references cannot be empty";
$adb8d98d7e693dfc$var$messages[$adb8d98d7e693dfc$var$namedUnknown] = "Named character references must be known";
$adb8d98d7e693dfc$var$messages[$adb8d98d7e693dfc$var$numericDisallowed] = "Numeric character references cannot be disallowed";
$adb8d98d7e693dfc$var$messages[$adb8d98d7e693dfc$var$numericProhibited] = "Numeric character references cannot be outside the permissible Unicode range";
// Wrap to ensure clean parameters are given to `parse`.
function $adb8d98d7e693dfc$var$parseEntities(value, options) {
    var settings = {};
    var option;
    var key;
    if (!options) options = {};
    for(key in $adb8d98d7e693dfc$var$defaults){
        option = options[key];
        settings[key] = option === null || option === undefined ? $adb8d98d7e693dfc$var$defaults[key] : option;
    }
    if (settings.position.indent || settings.position.start) {
        settings.indent = settings.position.indent || [];
        settings.position = settings.position.start;
    }
    return $adb8d98d7e693dfc$var$parse(value, settings);
}
// Parse entities.
// eslint-disable-next-line complexity
function $adb8d98d7e693dfc$var$parse(value, settings) {
    var additional = settings.additional;
    var nonTerminated = settings.nonTerminated;
    var handleText = settings.text;
    var handleReference = settings.reference;
    var handleWarning = settings.warning;
    var textContext = settings.textContext;
    var referenceContext = settings.referenceContext;
    var warningContext = settings.warningContext;
    var pos = settings.position;
    var indent = settings.indent || [];
    var length = value.length;
    var index = 0;
    var lines = -1;
    var column = pos.column || 1;
    var line = pos.line || 1;
    var queue = "";
    var result = [];
    var entityCharacters;
    var namedEntity;
    var terminated;
    var characters;
    var character;
    var reference;
    var following;
    var warning;
    var reason;
    var output;
    var entity;
    var begin;
    var start;
    var type;
    var test;
    var prev;
    var next;
    var diff;
    var end;
    if (typeof additional === "string") additional = additional.charCodeAt(0);
    // Cache the current point.
    prev = now();
    // Wrap `handleWarning`.
    warning = handleWarning ? parseError : $adb8d98d7e693dfc$var$noop;
    // Ensure the algorithm walks over the first character and the end (inclusive).
    index--;
    length++;
    while(++index < length){
        // If the previous character was a newline.
        if (character === $adb8d98d7e693dfc$var$lineFeed) column = indent[lines] || 1;
        character = value.charCodeAt(index);
        if (character === $adb8d98d7e693dfc$var$ampersand) {
            following = value.charCodeAt(index + 1);
            // The behaviour depends on the identity of the next character.
            if (following === $adb8d98d7e693dfc$var$tab || following === $adb8d98d7e693dfc$var$lineFeed || following === $adb8d98d7e693dfc$var$formFeed || following === $adb8d98d7e693dfc$var$space || following === $adb8d98d7e693dfc$var$ampersand || following === $adb8d98d7e693dfc$var$lessThan || following !== following || additional && following === additional) {
                // Not a character reference.
                // No characters are consumed, and nothing is returned.
                // This is not an error, either.
                queue += $adb8d98d7e693dfc$var$fromCharCode(character);
                column++;
                continue;
            }
            start = index + 1;
            begin = start;
            end = start;
            if (following === $adb8d98d7e693dfc$var$numberSign) {
                // Numerical entity.
                end = ++begin;
                // The behaviour further depends on the next character.
                following = value.charCodeAt(end);
                if (following === $adb8d98d7e693dfc$var$uppercaseX || following === $adb8d98d7e693dfc$var$lowercaseX) {
                    // ASCII hex digits.
                    type = $adb8d98d7e693dfc$var$hexa;
                    end = ++begin;
                } else // ASCII digits.
                type = $adb8d98d7e693dfc$var$deci;
            } else // Named entity.
            type = $adb8d98d7e693dfc$var$name;
            entityCharacters = "";
            entity = "";
            characters = "";
            test = $adb8d98d7e693dfc$var$tests[type];
            end--;
            while(++end < length){
                following = value.charCodeAt(end);
                if (!test(following)) break;
                characters += $adb8d98d7e693dfc$var$fromCharCode(following);
                // Check if we can match a legacy named reference.
                // If so, we cache that as the last viable named reference.
                // This ensures we do not need to walk backwards later.
                if (type === $adb8d98d7e693dfc$var$name && $adb8d98d7e693dfc$var$own.call($9PlhL, characters)) {
                    entityCharacters = characters;
                    entity = $9PlhL[characters];
                }
            }
            terminated = value.charCodeAt(end) === $adb8d98d7e693dfc$var$semicolon;
            if (terminated) {
                end++;
                namedEntity = type === $adb8d98d7e693dfc$var$name ? $5IZQE(characters) : false;
                if (namedEntity) {
                    entityCharacters = characters;
                    entity = namedEntity;
                }
            }
            diff = 1 + end - start;
            if (!terminated && !nonTerminated) ;
            else if (!characters) // An empty (possible) entity is valid, unless it’s numeric (thus an
            // ampersand followed by an octothorp).
            {
                if (type !== $adb8d98d7e693dfc$var$name) warning($adb8d98d7e693dfc$var$numericEmpty, diff);
            } else if (type === $adb8d98d7e693dfc$var$name) {
                // An ampersand followed by anything unknown, and not terminated, is
                // invalid.
                if (terminated && !entity) warning($adb8d98d7e693dfc$var$namedUnknown, 1);
                else {
                    // If theres something after an entity name which is not known, cap
                    // the reference.
                    if (entityCharacters !== characters) {
                        end = begin + entityCharacters.length;
                        diff = 1 + end - begin;
                        terminated = false;
                    }
                    // If the reference is not terminated, warn.
                    if (!terminated) {
                        reason = entityCharacters ? $adb8d98d7e693dfc$var$namedNotTerminated : $adb8d98d7e693dfc$var$namedEmpty;
                        if (settings.attribute) {
                            following = value.charCodeAt(end);
                            if (following === $adb8d98d7e693dfc$var$equalsTo) {
                                warning(reason, diff);
                                entity = null;
                            } else if ($a278X(following)) entity = null;
                            else warning(reason, diff);
                        } else warning(reason, diff);
                    }
                }
                reference = entity;
            } else {
                if (!terminated) // All non-terminated numeric entities are not rendered, and trigger a
                // warning.
                warning($adb8d98d7e693dfc$var$numericNotTerminated, diff);
                // When terminated and number, parse as either hexadecimal or decimal.
                reference = parseInt(characters, $adb8d98d7e693dfc$var$bases[type]);
                // Trigger a warning when the parsed number is prohibited, and replace
                // with replacement character.
                if ($adb8d98d7e693dfc$var$prohibited(reference)) {
                    warning($adb8d98d7e693dfc$var$numericProhibited, diff);
                    reference = $adb8d98d7e693dfc$var$fromCharCode($adb8d98d7e693dfc$var$replacementCharacter);
                } else if (reference in $i3t4F) {
                    // Trigger a warning when the parsed number is disallowed, and replace
                    // by an alternative.
                    warning($adb8d98d7e693dfc$var$numericDisallowed, diff);
                    reference = $i3t4F[reference];
                } else {
                    // Parse the number.
                    output = "";
                    // Trigger a warning when the parsed number should not be used.
                    if ($adb8d98d7e693dfc$var$disallowed(reference)) warning($adb8d98d7e693dfc$var$numericDisallowed, diff);
                    // Stringify the number.
                    if (reference > 0xffff) {
                        reference -= 0x10000;
                        output += $adb8d98d7e693dfc$var$fromCharCode(reference >>> 10 | 0xd800);
                        reference = 0xdc00 | reference & 0x3ff;
                    }
                    reference = output + $adb8d98d7e693dfc$var$fromCharCode(reference);
                }
            }
            // Found it!
            // First eat the queued characters as normal text, then eat an entity.
            if (reference) {
                flush();
                prev = now();
                index = end - 1;
                column += end - start + 1;
                result.push(reference);
                next = now();
                next.offset++;
                if (handleReference) handleReference.call(referenceContext, reference, {
                    start: prev,
                    end: next
                }, value.slice(start - 1, end));
                prev = next;
            } else {
                // If we could not find a reference, queue the checked characters (as
                // normal characters), and move the pointer to their end.
                // This is possible because we can be certain neither newlines nor
                // ampersands are included.
                characters = value.slice(start - 1, end);
                queue += characters;
                column += characters.length;
                index = end - 1;
            }
        } else {
            // Handle anything other than an ampersand, including newlines and EOF.
            if (character === 10 // Line feed
            ) {
                line++;
                lines++;
                column = 0;
            }
            if (character === character) {
                queue += $adb8d98d7e693dfc$var$fromCharCode(character);
                column++;
            } else flush();
        }
    }
    // Return the reduced nodes, and any possible warnings.
    return result.join("");
    // Get current position.
    function now() {
        return {
            line: line,
            column: column,
            offset: index + (pos.offset || 0)
        };
    }
    // “Throw” a parse-error: a warning.
    function parseError(code, offset) {
        var position = now();
        position.column += offset;
        position.offset += offset;
        handleWarning.call(warningContext, $adb8d98d7e693dfc$var$messages[code], position, code);
    }
    // Flush `queue` (normal text).
    // Macro invoked before each entity and at the end of `value`.
    // Does nothing when `queue` is empty.
    function flush() {
        if (queue) {
            result.push(queue);
            if (handleText) handleText.call(textContext, queue, {
                start: prev,
                end: now()
            });
            queue = "";
        }
    }
}
// Check if `character` is outside the permissible unicode range.
function $adb8d98d7e693dfc$var$prohibited(code) {
    return code >= 0xd800 && code <= 0xdfff || code > 0x10ffff;
}
// Check if `character` is disallowed.
function $adb8d98d7e693dfc$var$disallowed(code) {
    return code >= 0x0001 && code <= 0x0008 || code === 0x000b || code >= 0x000d && code <= 0x001f || code >= 0x007f && code <= 0x009f || code >= 0xfdd0 && code <= 0xfdef || (code & 0xffff) === 0xffff || (code & 0xffff) === 0xfffe;
}

});
parcelRegister("9PlhL", function(module, exports) {
module.exports = JSON.parse('{"AElig":"\xc6","AMP":"&","Aacute":"\xc1","Acirc":"\xc2","Agrave":"\xc0","Aring":"\xc5","Atilde":"\xc3","Auml":"\xc4","COPY":"\xa9","Ccedil":"\xc7","ETH":"\xd0","Eacute":"\xc9","Ecirc":"\xca","Egrave":"\xc8","Euml":"\xcb","GT":">","Iacute":"\xcd","Icirc":"\xce","Igrave":"\xcc","Iuml":"\xcf","LT":"<","Ntilde":"\xd1","Oacute":"\xd3","Ocirc":"\xd4","Ograve":"\xd2","Oslash":"\xd8","Otilde":"\xd5","Ouml":"\xd6","QUOT":"\\"","REG":"\xae","THORN":"\xde","Uacute":"\xda","Ucirc":"\xdb","Ugrave":"\xd9","Uuml":"\xdc","Yacute":"\xdd","aacute":"\xe1","acirc":"\xe2","acute":"\xb4","aelig":"\xe6","agrave":"\xe0","amp":"&","aring":"\xe5","atilde":"\xe3","auml":"\xe4","brvbar":"\xa6","ccedil":"\xe7","cedil":"\xb8","cent":"\xa2","copy":"\xa9","curren":"\xa4","deg":"\xb0","divide":"\xf7","eacute":"\xe9","ecirc":"\xea","egrave":"\xe8","eth":"\xf0","euml":"\xeb","frac12":"\xbd","frac14":"\xbc","frac34":"\xbe","gt":">","iacute":"\xed","icirc":"\xee","iexcl":"\xa1","igrave":"\xec","iquest":"\xbf","iuml":"\xef","laquo":"\xab","lt":"<","macr":"\xaf","micro":"\xb5","middot":"\xb7","nbsp":"\xa0","not":"\xac","ntilde":"\xf1","oacute":"\xf3","ocirc":"\xf4","ograve":"\xf2","ordf":"\xaa","ordm":"\xba","oslash":"\xf8","otilde":"\xf5","ouml":"\xf6","para":"\xb6","plusmn":"\xb1","pound":"\xa3","quot":"\\"","raquo":"\xbb","reg":"\xae","sect":"\xa7","shy":"\xad","sup1":"\xb9","sup2":"\xb2","sup3":"\xb3","szlig":"\xdf","thorn":"\xfe","times":"\xd7","uacute":"\xfa","ucirc":"\xfb","ugrave":"\xf9","uml":"\xa8","uuml":"\xfc","yacute":"\xfd","yen":"\xa5","yuml":"\xff"}');

});

parcelRegister("i3t4F", function(module, exports) {
module.exports = JSON.parse('{"0":"\uFFFD","128":"\u20AC","130":"\u201A","131":"\u0192","132":"\u201E","133":"\u2026","134":"\u2020","135":"\u2021","136":"\u02C6","137":"\u2030","138":"\u0160","139":"\u2039","140":"\u0152","142":"\u017D","145":"\u2018","146":"\u2019","147":"\u201C","148":"\u201D","149":"\u2022","150":"\u2013","151":"\u2014","152":"\u02DC","153":"\u2122","154":"\u0161","155":"\u203A","156":"\u0153","158":"\u017E","159":"\u0178"}');

});

parcelRegister("35IlD", function(module, exports) {
"use strict";
module.exports = $24043d495cb6d5f6$var$decimal;
// Check if the given character code, or the character code at the first
// character, is decimal.
function $24043d495cb6d5f6$var$decimal(character) {
    var code = typeof character === "string" ? character.charCodeAt(0) : character;
    return code >= 48 && code <= 57 /* 0-9 */ ;
}

});

parcelRegister("6lhfp", function(module, exports) {
"use strict";
module.exports = $49e215413186b63c$var$hexadecimal;
// Check if the given character code, or the character code at the first
// character, is hexadecimal.
function $49e215413186b63c$var$hexadecimal(character) {
    var code = typeof character === "string" ? character.charCodeAt(0) : character;
    return code >= 97 /* a */  && code <= 102 || code >= 65 /* A */  && code <= 70 || code >= 48 /* A */  && code <= 57;
}

});

parcelRegister("a278X", function(module, exports) {
"use strict";

var $aDCQv = parcelRequire("aDCQv");

var $35IlD = parcelRequire("35IlD");
module.exports = $74dfa1d6cc46cebe$var$alphanumerical;
// Check if the given character code, or the character code at the first
// character, is alphanumerical.
function $74dfa1d6cc46cebe$var$alphanumerical(character) {
    return $aDCQv(character) || $35IlD(character);
}

});
parcelRegister("aDCQv", function(module, exports) {
"use strict";
module.exports = $7bebade65d61c65b$var$alphabetical;
// Check if the given character code, or the character code at the first
// character, is alphabetical.
function $7bebade65d61c65b$var$alphabetical(character) {
    var code = typeof character === "string" ? character.charCodeAt(0) : character;
    return code >= 97 && code <= 122 || code >= 65 && code <= 90;
}

});


parcelRegister("5IZQE", function(module, exports) {
"use strict";
/* eslint-env browser */ var $42b1099a2e98ac5c$var$el;
var $42b1099a2e98ac5c$var$semicolon = 59 //  ';'
;
module.exports = $42b1099a2e98ac5c$var$decodeEntity;
function $42b1099a2e98ac5c$var$decodeEntity(characters) {
    var entity = "&" + characters + ";";
    var char;
    $42b1099a2e98ac5c$var$el = $42b1099a2e98ac5c$var$el || document.createElement("i");
    $42b1099a2e98ac5c$var$el.innerHTML = entity;
    char = $42b1099a2e98ac5c$var$el.textContent;
    // Some entities do not require the closing semicolon (`&not` - for instance),
    // which leads to situations where parsing the assumed entity of &notit; will
    // result in the string `¬it;`.  When we encounter a trailing semicolon after
    // parsing and the entity to decode was not a semicolon (`&semi;`), we can
    // assume that the matching was incomplete
    if (char.charCodeAt(char.length - 1) === $42b1099a2e98ac5c$var$semicolon && characters !== "semi") return false;
    // If the decoded string is equal to the input, the entity was not valid
    return char === entity ? false : char;
}

});



parcelRegister("9H32T", function(module, exports) {
"use strict";
module.exports = $70ea7e0776c16e6e$var$factory;
// Construct a tokenizer.  This creates both `tokenizeInline` and `tokenizeBlock`.
function $70ea7e0776c16e6e$var$factory(type) {
    return tokenize;
    // Tokenizer for a bound `type`.
    function tokenize(value, location) {
        var self = this;
        var offset = self.offset;
        var tokens = [];
        var methods = self[type + "Methods"];
        var tokenizers = self[type + "Tokenizers"];
        var line = location.line;
        var column = location.column;
        var index;
        var length;
        var method;
        var name;
        var matched;
        var valueLength;
        // Trim white space only lines.
        if (!value) return tokens;
        // Expose on `eat`.
        eat.now = now;
        eat.file = self.file;
        // Sync initial offset.
        updatePosition("");
        // Iterate over `value`, and iterate over all tokenizers.  When one eats
        // something, re-iterate with the remaining value.  If no tokenizer eats,
        // something failed (should not happen) and an exception is thrown.
        while(value){
            index = -1;
            length = methods.length;
            matched = false;
            while(++index < length){
                name = methods[index];
                method = tokenizers[name];
                if (method && /* istanbul ignore next */ (!method.onlyAtStart || self.atStart) && (!method.notInList || !self.inList) && (!method.notInBlock || !self.inBlock) && (!method.notInLink || !self.inLink)) {
                    valueLength = value.length;
                    method.apply(self, [
                        eat,
                        value
                    ]);
                    matched = valueLength !== value.length;
                    if (matched) break;
                }
            }
            /* istanbul ignore if */ if (!matched) self.file.fail(new Error("Infinite loop"), eat.now());
        }
        self.eof = now();
        return tokens;
        // Update line, column, and offset based on `value`.
        function updatePosition(subvalue) {
            var lastIndex = -1;
            var index = subvalue.indexOf("\n");
            while(index !== -1){
                line++;
                lastIndex = index;
                index = subvalue.indexOf("\n", index + 1);
            }
            if (lastIndex === -1) column += subvalue.length;
            else column = subvalue.length - lastIndex;
            if (line in offset) {
                if (lastIndex !== -1) column += offset[line];
                else if (column <= offset[line]) column = offset[line] + 1;
            }
        }
        // Get offset.  Called before the first character is eaten to retrieve the
        // range’s offsets.
        function getOffset() {
            var indentation = [];
            var pos = line + 1;
            // Done.  Called when the last character is eaten to retrieve the range’s
            // offsets.
            return function() {
                var last = line + 1;
                while(pos < last){
                    indentation.push((offset[pos] || 0) + 1);
                    pos++;
                }
                return indentation;
            };
        }
        // Get the current position.
        function now() {
            var pos = {
                line: line,
                column: column
            };
            pos.offset = self.toOffset(pos);
            return pos;
        }
        // Store position information for a node.
        function Position(start) {
            this.start = start;
            this.end = now();
        }
        // Throw when a value is incorrectly eaten.  This shouldn’t happen but will
        // throw on new, incorrect rules.
        function validateEat(subvalue) {
            /* istanbul ignore if */ if (value.slice(0, subvalue.length) !== subvalue) // Capture stack-trace.
            self.file.fail(new Error("Incorrectly eaten value: please report this warning on https://git.io/vg5Ft"), now());
        }
        // Mark position and patch `node.position`.
        function position() {
            var before = now();
            return update;
            // Add the position to a node.
            function update(node, indent) {
                var prev = node.position;
                var start = prev ? prev.start : before;
                var combined = [];
                var n = prev && prev.end.line;
                var l = before.line;
                node.position = new Position(start);
                // If there was already a `position`, this node was merged.  Fixing
                // `start` wasn’t hard, but the indent is different.  Especially
                // because some information, the indent between `n` and `l` wasn’t
                // tracked.  Luckily, that space is (should be?) empty, so we can
                // safely check for it now.
                if (prev && indent && prev.indent) {
                    combined = prev.indent;
                    if (n < l) {
                        while(++n < l)combined.push((offset[n] || 0) + 1);
                        combined.push(before.column);
                    }
                    indent = combined.concat(indent);
                }
                node.position.indent = indent || [];
                return node;
            }
        }
        // Add `node` to `parent`s children or to `tokens`.  Performs merges where
        // possible.
        function add(node, parent) {
            var children = parent ? parent.children : tokens;
            var prev = children[children.length - 1];
            var fn;
            if (prev && node.type === prev.type && (node.type === "text" || node.type === "blockquote") && $70ea7e0776c16e6e$var$mergeable(prev) && $70ea7e0776c16e6e$var$mergeable(node)) {
                fn = node.type === "text" ? $70ea7e0776c16e6e$var$mergeText : $70ea7e0776c16e6e$var$mergeBlockquote;
                node = fn.call(self, prev, node);
            }
            if (node !== prev) children.push(node);
            if (self.atStart && tokens.length !== 0) self.exitStart();
            return node;
        }
        // Remove `subvalue` from `value`.  `subvalue` must be at the start of
        // `value`.
        function eat(subvalue) {
            var indent = getOffset();
            var pos = position();
            var current = now();
            validateEat(subvalue);
            apply.reset = reset;
            reset.test = test;
            apply.test = test;
            value = value.slice(subvalue.length);
            updatePosition(subvalue);
            indent = indent();
            return apply;
            // Add the given arguments, add `position` to the returned node, and
            // return the node.
            function apply(node, parent) {
                return pos(add(pos(node), parent), indent);
            }
            // Functions just like apply, but resets the content: the line and
            // column are reversed, and the eaten value is re-added.   This is
            // useful for nodes with a single type of content, such as lists and
            // tables.  See `apply` above for what parameters are expected.
            function reset() {
                var node = apply.apply(null, arguments);
                line = current.line;
                column = current.column;
                value = subvalue + value;
                return node;
            }
            // Test the position, after eating, and reverse to a not-eaten state.
            function test() {
                var result = pos({});
                line = current.line;
                column = current.column;
                value = subvalue + value;
                return result.position;
            }
        }
    }
}
// Check whether a node is mergeable with adjacent nodes.
function $70ea7e0776c16e6e$var$mergeable(node) {
    var start;
    var end;
    if (node.type !== "text" || !node.position) return true;
    start = node.position.start;
    end = node.position.end;
    // Only merge nodes which occupy the same size as their `value`.
    return start.line !== end.line || end.column - start.column === node.value.length;
}
// Merge two text nodes: `node` into `prev`.
function $70ea7e0776c16e6e$var$mergeText(prev, node) {
    prev.value += node.value;
    return prev;
}
// Merge two blockquotes: `node` into `prev`, unless in CommonMark or gfm modes.
function $70ea7e0776c16e6e$var$mergeBlockquote(prev, node) {
    if (this.options.commonmark || this.options.gfm) return node;
    prev.children = prev.children.concat(node.children);
    return prev;
}

});

parcelRegister("8A1yv", function(module, exports) {
"use strict";

var $36bRz = parcelRequire("36bRz");

var $6lv3b = parcelRequire("6lv3b");

var $2WaU5 = parcelRequire("2WaU5");
module.exports = $63f2e4671f235175$var$setOptions;
function $63f2e4671f235175$var$setOptions(options) {
    var self = this;
    var current = self.options;
    var key;
    var value;
    if (options == null) options = {};
    else if (typeof options === "object") options = $36bRz(options);
    else throw new Error("Invalid value `" + options + "` for setting `options`");
    for(key in $2WaU5){
        value = options[key];
        if (value == null) value = current[key];
        if (key !== "blocks" && typeof value !== "boolean" || key === "blocks" && typeof value !== "object") throw new Error("Invalid value `" + value + "` for setting `options." + key + "`");
        options[key] = value;
    }
    self.options = options;
    self.escape = $6lv3b(options);
    return self;
}

});
parcelRegister("6lv3b", function(module, exports) {
"use strict";
module.exports = $49ecca349270a938$var$escapes;
var $49ecca349270a938$var$defaults = [
    "\\",
    "`",
    "*",
    "{",
    "}",
    "[",
    "]",
    "(",
    ")",
    "#",
    "+",
    "-",
    ".",
    "!",
    "_",
    ">"
];
var $49ecca349270a938$var$gfm = $49ecca349270a938$var$defaults.concat([
    "~",
    "|"
]);
var $49ecca349270a938$var$commonmark = $49ecca349270a938$var$gfm.concat([
    "\n",
    '"',
    "$",
    "%",
    "&",
    "'",
    ",",
    "/",
    ":",
    ";",
    "<",
    "=",
    "?",
    "@",
    "^"
]);
$49ecca349270a938$var$escapes.default = $49ecca349270a938$var$defaults;
$49ecca349270a938$var$escapes.gfm = $49ecca349270a938$var$gfm;
$49ecca349270a938$var$escapes.commonmark = $49ecca349270a938$var$commonmark;
// Get markdown escapes.
function $49ecca349270a938$var$escapes(options) {
    var settings = options || {};
    if (settings.commonmark) return $49ecca349270a938$var$commonmark;
    return settings.gfm ? $49ecca349270a938$var$gfm : $49ecca349270a938$var$defaults;
}

});

parcelRegister("2WaU5", function(module, exports) {
"use strict";

module.exports = {
    position: true,
    gfm: true,
    commonmark: false,
    footnotes: false,
    pedantic: false,
    blocks: (parcelRequire("7FKxk"))
};

});
parcelRegister("7FKxk", function(module, exports) {
"use strict";
module.exports = [
    "address",
    "article",
    "aside",
    "base",
    "basefont",
    "blockquote",
    "body",
    "caption",
    "center",
    "col",
    "colgroup",
    "dd",
    "details",
    "dialog",
    "dir",
    "div",
    "dl",
    "dt",
    "fieldset",
    "figcaption",
    "figure",
    "footer",
    "form",
    "frame",
    "frameset",
    "h1",
    "h2",
    "h3",
    "h4",
    "h5",
    "h6",
    "head",
    "header",
    "hgroup",
    "hr",
    "html",
    "iframe",
    "legend",
    "li",
    "link",
    "main",
    "menu",
    "menuitem",
    "meta",
    "nav",
    "noframes",
    "ol",
    "optgroup",
    "option",
    "p",
    "param",
    "pre",
    "section",
    "source",
    "title",
    "summary",
    "table",
    "tbody",
    "td",
    "tfoot",
    "th",
    "thead",
    "title",
    "tr",
    "track",
    "ul"
];

});



parcelRegister("gVkoZ", function(module, exports) {
"use strict";

var $36bRz = parcelRequire("36bRz");

var $k54iK = parcelRequire("k54iK");
module.exports = $c521cba1cfa0f111$var$parse;
var $c521cba1cfa0f111$var$lineFeed = "\n";
var $c521cba1cfa0f111$var$lineBreaksExpression = /\r\n|\r/g;
// Parse the bound file.
function $c521cba1cfa0f111$var$parse() {
    var self = this;
    var value = String(self.file);
    var start = {
        line: 1,
        column: 1,
        offset: 0
    };
    var content = $36bRz(start);
    var node;
    // Clean non-unix newlines: `\r\n` and `\r` are all changed to `\n`.
    // This should not affect positional information.
    value = value.replace($c521cba1cfa0f111$var$lineBreaksExpression, $c521cba1cfa0f111$var$lineFeed);
    // BOM.
    if (value.charCodeAt(0) === 0xfeff) {
        value = value.slice(1);
        content.column++;
        content.offset++;
    }
    node = {
        type: "root",
        children: self.tokenizeBlock(value, content),
        position: {
            start: start,
            end: self.eof || $36bRz(start)
        }
    };
    if (!self.options.position) $k54iK(node, true);
    return node;
}

});
parcelRegister("k54iK", function(module, exports) {
"use strict";

var $KDBsL = parcelRequire("KDBsL");
module.exports = $e9e79c6ff1696951$var$removePosition;
function $e9e79c6ff1696951$var$removePosition(node, force) {
    $KDBsL(node, force ? $e9e79c6ff1696951$var$hard : $e9e79c6ff1696951$var$soft);
    return node;
}
function $e9e79c6ff1696951$var$hard(node) {
    delete node.position;
}
function $e9e79c6ff1696951$var$soft(node) {
    node.position = undefined;
}

});
parcelRegister("KDBsL", function(module, exports) {
"use strict";
module.exports = $08c3045f17a63617$var$visit;

var $5yqcV = parcelRequire("5yqcV");
var $08c3045f17a63617$var$CONTINUE = $5yqcV.CONTINUE;
var $08c3045f17a63617$var$SKIP = $5yqcV.SKIP;
var $08c3045f17a63617$var$EXIT = $5yqcV.EXIT;
$08c3045f17a63617$var$visit.CONTINUE = $08c3045f17a63617$var$CONTINUE;
$08c3045f17a63617$var$visit.SKIP = $08c3045f17a63617$var$SKIP;
$08c3045f17a63617$var$visit.EXIT = $08c3045f17a63617$var$EXIT;
function $08c3045f17a63617$var$visit(tree, test, visitor, reverse) {
    if (typeof test === "function" && typeof visitor !== "function") {
        reverse = visitor;
        visitor = test;
        test = null;
    }
    $5yqcV(tree, test, overload, reverse);
    function overload(node, parents) {
        var parent = parents[parents.length - 1];
        var index = parent ? parent.children.indexOf(node) : null;
        return visitor(node, index, parent);
    }
}

});
parcelRegister("5yqcV", function(module, exports) {
"use strict";
module.exports = $40b474fa08467108$var$visitParents;

var $3AImh = parcelRequire("3AImh");
var $40b474fa08467108$var$CONTINUE = true;
var $40b474fa08467108$var$SKIP = "skip";
var $40b474fa08467108$var$EXIT = false;
$40b474fa08467108$var$visitParents.CONTINUE = $40b474fa08467108$var$CONTINUE;
$40b474fa08467108$var$visitParents.SKIP = $40b474fa08467108$var$SKIP;
$40b474fa08467108$var$visitParents.EXIT = $40b474fa08467108$var$EXIT;
function $40b474fa08467108$var$visitParents(tree, test, visitor, reverse) {
    var is;
    if (typeof test === "function" && typeof visitor !== "function") {
        reverse = visitor;
        visitor = test;
        test = null;
    }
    is = $3AImh(test);
    one(tree, null, []);
    // Visit a single node.
    function one(node, index, parents) {
        var result = [];
        var subresult;
        if (!test || is(node, index, parents[parents.length - 1] || null)) {
            result = $40b474fa08467108$var$toResult(visitor(node, parents));
            if (result[0] === $40b474fa08467108$var$EXIT) return result;
        }
        if (node.children && result[0] !== $40b474fa08467108$var$SKIP) {
            subresult = $40b474fa08467108$var$toResult(all(node.children, parents.concat(node)));
            return subresult[0] === $40b474fa08467108$var$EXIT ? subresult : result;
        }
        return result;
    }
    // Visit children in `parent`.
    function all(children, parents) {
        var min = -1;
        var step = reverse ? -1 : 1;
        var index = (reverse ? children.length : min) + step;
        var result;
        while(index > min && index < children.length){
            result = one(children[index], index, parents);
            if (result[0] === $40b474fa08467108$var$EXIT) return result;
            index = typeof result[1] === "number" ? result[1] : index + step;
        }
    }
}
function $40b474fa08467108$var$toResult(value) {
    if (value !== null && typeof value === "object" && "length" in value) return value;
    if (typeof value === "number") return [
        $40b474fa08467108$var$CONTINUE,
        value
    ];
    return [
        value
    ];
}

});
parcelRegister("3AImh", function(module, exports) {
"use strict";
module.exports = $29d72484875d47da$var$convert;
function $29d72484875d47da$var$convert(test) {
    if (typeof test === "string") return $29d72484875d47da$var$typeFactory(test);
    if (test === null || test === undefined) return $29d72484875d47da$var$ok;
    if (typeof test === "object") return ("length" in test ? $29d72484875d47da$var$anyFactory : $29d72484875d47da$var$matchesFactory)(test);
    if (typeof test === "function") return test;
    throw new Error("Expected function, string, or object as test");
}
function $29d72484875d47da$var$convertAll(tests) {
    var results = [];
    var length = tests.length;
    var index = -1;
    while(++index < length)results[index] = $29d72484875d47da$var$convert(tests[index]);
    return results;
}
// Utility assert each property in `test` is represented in `node`, and each
// values are strictly equal.
function $29d72484875d47da$var$matchesFactory(test) {
    return matches;
    function matches(node) {
        var key;
        for(key in test){
            if (node[key] !== test[key]) return false;
        }
        return true;
    }
}
function $29d72484875d47da$var$anyFactory(tests) {
    var checks = $29d72484875d47da$var$convertAll(tests);
    var length = checks.length;
    return matches;
    function matches() {
        var index = -1;
        while(++index < length){
            if (checks[index].apply(this, arguments)) return true;
        }
        return false;
    }
}
// Utility to convert a string into a function which checks a given node’s type
// for said string.
function $29d72484875d47da$var$typeFactory(test) {
    return type;
    function type(node) {
        return Boolean(node && node.type === test);
    }
}
// Utility to return true.
function $29d72484875d47da$var$ok() {
    return true;
}

});





parcelRegister("eWCwV", function(module, exports) {
"use strict";

var $kZNgz = parcelRequire("kZNgz");
module.exports = $ae145ebbbe9cda62$var$newline;
var $ae145ebbbe9cda62$var$lineFeed = "\n";
function $ae145ebbbe9cda62$var$newline(eat, value, silent) {
    var character = value.charAt(0);
    var length;
    var subvalue;
    var queue;
    var index;
    if (character !== $ae145ebbbe9cda62$var$lineFeed) return;
    /* istanbul ignore if - never used (yet) */ if (silent) return true;
    index = 1;
    length = value.length;
    subvalue = character;
    queue = "";
    while(index < length){
        character = value.charAt(index);
        if (!$kZNgz(character)) break;
        queue += character;
        if (character === $ae145ebbbe9cda62$var$lineFeed) {
            subvalue += queue;
            queue = "";
        }
        index++;
    }
    eat(subvalue);
}

});
parcelRegister("kZNgz", function(module, exports) {
"use strict";
module.exports = $f48fb86a79611e98$var$whitespace;
var $f48fb86a79611e98$var$fromCode = String.fromCharCode;
var $f48fb86a79611e98$var$re = /\s/;
// Check if the given character code, or the character code at the first
// character, is a whitespace character.
function $f48fb86a79611e98$var$whitespace(character) {
    return $f48fb86a79611e98$var$re.test(typeof character === "number" ? $f48fb86a79611e98$var$fromCode(character) : character.charAt(0));
}

});


parcelRegister("g5BkQ", function(module, exports) {
"use strict";

var $j6axH = parcelRequire("j6axH");

var $5H7vD = parcelRequire("5H7vD");
module.exports = $bb6a12f5361d4ec6$var$indentedCode;
var $bb6a12f5361d4ec6$var$lineFeed = "\n";
var $bb6a12f5361d4ec6$var$tab = "	";
var $bb6a12f5361d4ec6$var$space = " ";
var $bb6a12f5361d4ec6$var$tabSize = 4;
var $bb6a12f5361d4ec6$var$codeIndent = $j6axH($bb6a12f5361d4ec6$var$space, $bb6a12f5361d4ec6$var$tabSize);
function $bb6a12f5361d4ec6$var$indentedCode(eat, value, silent) {
    var index = -1;
    var length = value.length;
    var subvalue = "";
    var content = "";
    var subvalueQueue = "";
    var contentQueue = "";
    var character;
    var blankQueue;
    var indent;
    while(++index < length){
        character = value.charAt(index);
        if (indent) {
            indent = false;
            subvalue += subvalueQueue;
            content += contentQueue;
            subvalueQueue = "";
            contentQueue = "";
            if (character === $bb6a12f5361d4ec6$var$lineFeed) {
                subvalueQueue = character;
                contentQueue = character;
            } else {
                subvalue += character;
                content += character;
                while(++index < length){
                    character = value.charAt(index);
                    if (!character || character === $bb6a12f5361d4ec6$var$lineFeed) {
                        contentQueue = character;
                        subvalueQueue = character;
                        break;
                    }
                    subvalue += character;
                    content += character;
                }
            }
        } else if (character === $bb6a12f5361d4ec6$var$space && value.charAt(index + 1) === character && value.charAt(index + 2) === character && value.charAt(index + 3) === character) {
            subvalueQueue += $bb6a12f5361d4ec6$var$codeIndent;
            index += 3;
            indent = true;
        } else if (character === $bb6a12f5361d4ec6$var$tab) {
            subvalueQueue += character;
            indent = true;
        } else {
            blankQueue = "";
            while(character === $bb6a12f5361d4ec6$var$tab || character === $bb6a12f5361d4ec6$var$space){
                blankQueue += character;
                character = value.charAt(++index);
            }
            if (character !== $bb6a12f5361d4ec6$var$lineFeed) break;
            subvalueQueue += blankQueue + character;
            contentQueue += character;
        }
    }
    if (content) {
        if (silent) return true;
        return eat(subvalue)({
            type: "code",
            lang: null,
            meta: null,
            value: $5H7vD(content)
        });
    }
}

});
parcelRegister("j6axH", function(module, exports) {
/*!
 * repeat-string <https://github.com/jonschlinkert/repeat-string>
 *
 * Copyright (c) 2014-2015, Jon Schlinkert.
 * Licensed under the MIT License.
 */ "use strict";
/**
 * Results cache
 */ var $de76c169196a1fdc$var$res = "";
var $de76c169196a1fdc$var$cache;
/**
 * Expose `repeat`
 */ module.exports = $de76c169196a1fdc$var$repeat;
/**
 * Repeat the given `string` the specified `number`
 * of times.
 *
 * **Example:**
 *
 * ```js
 * var repeat = require('repeat-string');
 * repeat('A', 5);
 * //=> AAAAA
 * ```
 *
 * @param {String} `string` The string to repeat
 * @param {Number} `number` The number of times to repeat the string
 * @return {String} Repeated string
 * @api public
 */ function $de76c169196a1fdc$var$repeat(str, num) {
    if (typeof str !== "string") throw new TypeError("expected a string");
    // cover common, quick use cases
    if (num === 1) return str;
    if (num === 2) return str + str;
    var max = str.length * num;
    if ($de76c169196a1fdc$var$cache !== str || typeof $de76c169196a1fdc$var$cache === "undefined") {
        $de76c169196a1fdc$var$cache = str;
        $de76c169196a1fdc$var$res = "";
    } else if ($de76c169196a1fdc$var$res.length >= max) return $de76c169196a1fdc$var$res.substr(0, max);
    while(max > $de76c169196a1fdc$var$res.length && num > 1){
        if (num & 1) $de76c169196a1fdc$var$res += str;
        num >>= 1;
        str += str;
    }
    $de76c169196a1fdc$var$res += str;
    $de76c169196a1fdc$var$res = $de76c169196a1fdc$var$res.substr(0, max);
    return $de76c169196a1fdc$var$res;
}

});

parcelRegister("5H7vD", function(module, exports) {
"use strict";
module.exports = $4256cb184abd9807$var$trimTrailingLines;
var $4256cb184abd9807$var$line = "\n";
// Remove final newline characters from `value`.
function $4256cb184abd9807$var$trimTrailingLines(value) {
    var val = String(value);
    var index = val.length;
    while(val.charAt(--index) === $4256cb184abd9807$var$line);
    return val.slice(0, index + 1);
}

});


parcelRegister("8jp8K", function(module, exports) {
"use strict";
module.exports = $018fcccbdc17e6da$var$fencedCode;
var $018fcccbdc17e6da$var$lineFeed = "\n";
var $018fcccbdc17e6da$var$tab = "	";
var $018fcccbdc17e6da$var$space = " ";
var $018fcccbdc17e6da$var$tilde = "~";
var $018fcccbdc17e6da$var$graveAccent = "`";
var $018fcccbdc17e6da$var$minFenceCount = 3;
var $018fcccbdc17e6da$var$tabSize = 4;
function $018fcccbdc17e6da$var$fencedCode(eat, value, silent) {
    var self = this;
    var gfm = self.options.gfm;
    var length = value.length + 1;
    var index = 0;
    var subvalue = "";
    var fenceCount;
    var marker;
    var character;
    var flag;
    var lang;
    var meta;
    var queue;
    var content;
    var exdentedContent;
    var closing;
    var exdentedClosing;
    var indent;
    var now;
    if (!gfm) return;
    // Eat initial spacing.
    while(index < length){
        character = value.charAt(index);
        if (character !== $018fcccbdc17e6da$var$space && character !== $018fcccbdc17e6da$var$tab) break;
        subvalue += character;
        index++;
    }
    indent = index;
    // Eat the fence.
    character = value.charAt(index);
    if (character !== $018fcccbdc17e6da$var$tilde && character !== $018fcccbdc17e6da$var$graveAccent) return;
    index++;
    marker = character;
    fenceCount = 1;
    subvalue += character;
    while(index < length){
        character = value.charAt(index);
        if (character !== marker) break;
        subvalue += character;
        fenceCount++;
        index++;
    }
    if (fenceCount < $018fcccbdc17e6da$var$minFenceCount) return;
    // Eat spacing before flag.
    while(index < length){
        character = value.charAt(index);
        if (character !== $018fcccbdc17e6da$var$space && character !== $018fcccbdc17e6da$var$tab) break;
        subvalue += character;
        index++;
    }
    // Eat flag.
    flag = "";
    queue = "";
    while(index < length){
        character = value.charAt(index);
        if (character === $018fcccbdc17e6da$var$lineFeed || marker === $018fcccbdc17e6da$var$graveAccent && character === marker) break;
        if (character === $018fcccbdc17e6da$var$space || character === $018fcccbdc17e6da$var$tab) queue += character;
        else {
            flag += queue + character;
            queue = "";
        }
        index++;
    }
    character = value.charAt(index);
    if (character && character !== $018fcccbdc17e6da$var$lineFeed) return;
    if (silent) return true;
    now = eat.now();
    now.column += subvalue.length;
    now.offset += subvalue.length;
    subvalue += flag;
    flag = self.decode.raw(self.unescape(flag), now);
    if (queue) subvalue += queue;
    queue = "";
    closing = "";
    exdentedClosing = "";
    content = "";
    exdentedContent = "";
    var skip = true;
    // Eat content.
    while(index < length){
        character = value.charAt(index);
        content += closing;
        exdentedContent += exdentedClosing;
        closing = "";
        exdentedClosing = "";
        if (character !== $018fcccbdc17e6da$var$lineFeed) {
            content += character;
            exdentedClosing += character;
            index++;
            continue;
        }
        // The first line feed is ignored. Others aren’t.
        if (skip) {
            subvalue += character;
            skip = false;
        } else {
            closing += character;
            exdentedClosing += character;
        }
        queue = "";
        index++;
        while(index < length){
            character = value.charAt(index);
            if (character !== $018fcccbdc17e6da$var$space) break;
            queue += character;
            index++;
        }
        closing += queue;
        exdentedClosing += queue.slice(indent);
        if (queue.length >= $018fcccbdc17e6da$var$tabSize) continue;
        queue = "";
        while(index < length){
            character = value.charAt(index);
            if (character !== marker) break;
            queue += character;
            index++;
        }
        closing += queue;
        exdentedClosing += queue;
        if (queue.length < fenceCount) continue;
        queue = "";
        while(index < length){
            character = value.charAt(index);
            if (character !== $018fcccbdc17e6da$var$space && character !== $018fcccbdc17e6da$var$tab) break;
            closing += character;
            exdentedClosing += character;
            index++;
        }
        if (!character || character === $018fcccbdc17e6da$var$lineFeed) break;
    }
    subvalue += content + closing;
    // Get lang and meta from the flag.
    index = -1;
    length = flag.length;
    while(++index < length){
        character = flag.charAt(index);
        if (character === $018fcccbdc17e6da$var$space || character === $018fcccbdc17e6da$var$tab) {
            if (!lang) lang = flag.slice(0, index);
        } else if (lang) {
            meta = flag.slice(index);
            break;
        }
    }
    return eat(subvalue)({
        type: "code",
        lang: lang || flag || null,
        meta: meta || null,
        value: exdentedContent
    });
}

});

parcelRegister("hFW9g", function(module, exports) {
"use strict";

var $2Lc6r = parcelRequire("2Lc6r");

var $hIMnZ = parcelRequire("hIMnZ");
module.exports = $cde35f147e4145a8$var$blockquote;
var $cde35f147e4145a8$var$lineFeed = "\n";
var $cde35f147e4145a8$var$tab = "	";
var $cde35f147e4145a8$var$space = " ";
var $cde35f147e4145a8$var$greaterThan = ">";
function $cde35f147e4145a8$var$blockquote(eat, value, silent) {
    var self = this;
    var offsets = self.offset;
    var tokenizers = self.blockTokenizers;
    var interruptors = self.interruptBlockquote;
    var now = eat.now();
    var currentLine = now.line;
    var length = value.length;
    var values = [];
    var contents = [];
    var indents = [];
    var add;
    var index = 0;
    var character;
    var rest;
    var nextIndex;
    var content;
    var line;
    var startIndex;
    var prefixed;
    var exit;
    while(index < length){
        character = value.charAt(index);
        if (character !== $cde35f147e4145a8$var$space && character !== $cde35f147e4145a8$var$tab) break;
        index++;
    }
    if (value.charAt(index) !== $cde35f147e4145a8$var$greaterThan) return;
    if (silent) return true;
    index = 0;
    while(index < length){
        nextIndex = value.indexOf($cde35f147e4145a8$var$lineFeed, index);
        startIndex = index;
        prefixed = false;
        if (nextIndex === -1) nextIndex = length;
        while(index < length){
            character = value.charAt(index);
            if (character !== $cde35f147e4145a8$var$space && character !== $cde35f147e4145a8$var$tab) break;
            index++;
        }
        if (value.charAt(index) === $cde35f147e4145a8$var$greaterThan) {
            index++;
            prefixed = true;
            if (value.charAt(index) === $cde35f147e4145a8$var$space) index++;
        } else index = startIndex;
        content = value.slice(index, nextIndex);
        if (!prefixed && !$2Lc6r(content)) {
            index = startIndex;
            break;
        }
        if (!prefixed) {
            rest = value.slice(index);
            // Check if the following code contains a possible block.
            if ($hIMnZ(interruptors, tokenizers, self, [
                eat,
                rest,
                true
            ])) break;
        }
        line = startIndex === index ? content : value.slice(startIndex, nextIndex);
        indents.push(index - startIndex);
        values.push(line);
        contents.push(content);
        index = nextIndex + 1;
    }
    index = -1;
    length = indents.length;
    add = eat(values.join($cde35f147e4145a8$var$lineFeed));
    while(++index < length){
        offsets[currentLine] = (offsets[currentLine] || 0) + indents[index];
        currentLine++;
    }
    exit = self.enterBlock();
    contents = self.tokenizeBlock(contents.join($cde35f147e4145a8$var$lineFeed), now);
    exit();
    return add({
        type: "blockquote",
        children: contents
    });
}

});
parcelRegister("2Lc6r", function(module, exports) {
exports = module.exports = trim;
function trim(str) {
    return str.replace(/^\s*|\s*$/g, "");
}
exports.left = function(str) {
    return str.replace(/^\s*/, "");
};
exports.right = function(str) {
    return str.replace(/\s*$/, "");
};

});

parcelRegister("hIMnZ", function(module, exports) {
"use strict";
module.exports = $ce6c1424c6567c8c$var$interrupt;
function $ce6c1424c6567c8c$var$interrupt(interruptors, tokenizers, ctx, params) {
    var length = interruptors.length;
    var index = -1;
    var interruptor;
    var config;
    while(++index < length){
        interruptor = interruptors[index];
        config = interruptor[1] || {};
        if (config.pedantic !== undefined && config.pedantic !== ctx.options.pedantic) continue;
        if (config.commonmark !== undefined && config.commonmark !== ctx.options.commonmark) continue;
        if (tokenizers[interruptor[0]].apply(ctx, params)) return true;
    }
    return false;
}

});


parcelRegister("2Y1RE", function(module, exports) {
"use strict";
module.exports = $2292a1942d04c20a$var$atxHeading;
var $2292a1942d04c20a$var$lineFeed = "\n";
var $2292a1942d04c20a$var$tab = "	";
var $2292a1942d04c20a$var$space = " ";
var $2292a1942d04c20a$var$numberSign = "#";
var $2292a1942d04c20a$var$maxFenceCount = 6;
function $2292a1942d04c20a$var$atxHeading(eat, value, silent) {
    var self = this;
    var pedantic = self.options.pedantic;
    var length = value.length + 1;
    var index = -1;
    var now = eat.now();
    var subvalue = "";
    var content = "";
    var character;
    var queue;
    var depth;
    // Eat initial spacing.
    while(++index < length){
        character = value.charAt(index);
        if (character !== $2292a1942d04c20a$var$space && character !== $2292a1942d04c20a$var$tab) {
            index--;
            break;
        }
        subvalue += character;
    }
    // Eat hashes.
    depth = 0;
    while(++index <= length){
        character = value.charAt(index);
        if (character !== $2292a1942d04c20a$var$numberSign) {
            index--;
            break;
        }
        subvalue += character;
        depth++;
    }
    if (depth > $2292a1942d04c20a$var$maxFenceCount) return;
    if (!depth || !pedantic && value.charAt(index + 1) === $2292a1942d04c20a$var$numberSign) return;
    length = value.length + 1;
    // Eat intermediate white-space.
    queue = "";
    while(++index < length){
        character = value.charAt(index);
        if (character !== $2292a1942d04c20a$var$space && character !== $2292a1942d04c20a$var$tab) {
            index--;
            break;
        }
        queue += character;
    }
    // Exit when not in pedantic mode without spacing.
    if (!pedantic && queue.length === 0 && character && character !== $2292a1942d04c20a$var$lineFeed) return;
    if (silent) return true;
    // Eat content.
    subvalue += queue;
    queue = "";
    content = "";
    while(++index < length){
        character = value.charAt(index);
        if (!character || character === $2292a1942d04c20a$var$lineFeed) break;
        if (character !== $2292a1942d04c20a$var$space && character !== $2292a1942d04c20a$var$tab && character !== $2292a1942d04c20a$var$numberSign) {
            content += queue + character;
            queue = "";
            continue;
        }
        while(character === $2292a1942d04c20a$var$space || character === $2292a1942d04c20a$var$tab){
            queue += character;
            character = value.charAt(++index);
        }
        // `#` without a queue is part of the content.
        if (!pedantic && content && !queue && character === $2292a1942d04c20a$var$numberSign) {
            content += character;
            continue;
        }
        while(character === $2292a1942d04c20a$var$numberSign){
            queue += character;
            character = value.charAt(++index);
        }
        while(character === $2292a1942d04c20a$var$space || character === $2292a1942d04c20a$var$tab){
            queue += character;
            character = value.charAt(++index);
        }
        index--;
    }
    now.column += subvalue.length;
    now.offset += subvalue.length;
    subvalue += content + queue;
    return eat(subvalue)({
        type: "heading",
        depth: depth,
        children: self.tokenizeInline(content, now)
    });
}

});

parcelRegister("5GZmu", function(module, exports) {
"use strict";
module.exports = $4250792c50fd3b00$var$thematicBreak;
var $4250792c50fd3b00$var$tab = "	";
var $4250792c50fd3b00$var$lineFeed = "\n";
var $4250792c50fd3b00$var$space = " ";
var $4250792c50fd3b00$var$asterisk = "*";
var $4250792c50fd3b00$var$dash = "-";
var $4250792c50fd3b00$var$underscore = "_";
var $4250792c50fd3b00$var$maxCount = 3;
function $4250792c50fd3b00$var$thematicBreak(eat, value, silent) {
    var index = -1;
    var length = value.length + 1;
    var subvalue = "";
    var character;
    var marker;
    var markerCount;
    var queue;
    while(++index < length){
        character = value.charAt(index);
        if (character !== $4250792c50fd3b00$var$tab && character !== $4250792c50fd3b00$var$space) break;
        subvalue += character;
    }
    if (character !== $4250792c50fd3b00$var$asterisk && character !== $4250792c50fd3b00$var$dash && character !== $4250792c50fd3b00$var$underscore) return;
    marker = character;
    subvalue += character;
    markerCount = 1;
    queue = "";
    while(++index < length){
        character = value.charAt(index);
        if (character === marker) {
            markerCount++;
            subvalue += queue + marker;
            queue = "";
        } else if (character === $4250792c50fd3b00$var$space) queue += character;
        else if (markerCount >= $4250792c50fd3b00$var$maxCount && (!character || character === $4250792c50fd3b00$var$lineFeed)) {
            subvalue += queue;
            if (silent) return true;
            return eat(subvalue)({
                type: "thematicBreak"
            });
        } else return;
    }
}

});

parcelRegister("gMkLN", function(module, exports) {
"use strict";

var $2Lc6r = parcelRequire("2Lc6r");

var $j6axH = parcelRequire("j6axH");

var $35IlD = parcelRequire("35IlD");

var $4EdzQ = parcelRequire("4EdzQ");

var $gi4CN = parcelRequire("gi4CN");

var $hIMnZ = parcelRequire("hIMnZ");
module.exports = $c3713d7ce0443654$var$list;
var $c3713d7ce0443654$var$asterisk = "*";
var $c3713d7ce0443654$var$underscore = "_";
var $c3713d7ce0443654$var$plusSign = "+";
var $c3713d7ce0443654$var$dash = "-";
var $c3713d7ce0443654$var$dot = ".";
var $c3713d7ce0443654$var$space = " ";
var $c3713d7ce0443654$var$lineFeed = "\n";
var $c3713d7ce0443654$var$tab = "	";
var $c3713d7ce0443654$var$rightParenthesis = ")";
var $c3713d7ce0443654$var$lowercaseX = "x";
var $c3713d7ce0443654$var$tabSize = 4;
var $c3713d7ce0443654$var$looseListItemExpression = /\n\n(?!\s*$)/;
var $c3713d7ce0443654$var$taskItemExpression = /^\[([ \t]|x|X)][ \t]/;
var $c3713d7ce0443654$var$bulletExpression = /^([ \t]*)([*+-]|\d+[.)])( {1,4}(?! )| |\t|$|(?=\n))([^\n]*)/;
var $c3713d7ce0443654$var$pedanticBulletExpression = /^([ \t]*)([*+-]|\d+[.)])([ \t]+)/;
var $c3713d7ce0443654$var$initialIndentExpression = /^( {1,4}|\t)?/gm;
function $c3713d7ce0443654$var$list(eat, value, silent) {
    var self = this;
    var commonmark = self.options.commonmark;
    var pedantic = self.options.pedantic;
    var tokenizers = self.blockTokenizers;
    var interuptors = self.interruptList;
    var index = 0;
    var length = value.length;
    var start = null;
    var size = 0;
    var queue;
    var ordered;
    var character;
    var marker;
    var nextIndex;
    var startIndex;
    var prefixed;
    var currentMarker;
    var content;
    var line;
    var prevEmpty;
    var empty;
    var items;
    var allLines;
    var emptyLines;
    var item;
    var enterTop;
    var exitBlockquote;
    var spread = false;
    var node;
    var now;
    var end;
    var indented;
    while(index < length){
        character = value.charAt(index);
        if (character === $c3713d7ce0443654$var$tab) size += $c3713d7ce0443654$var$tabSize - size % $c3713d7ce0443654$var$tabSize;
        else if (character === $c3713d7ce0443654$var$space) size++;
        else break;
        index++;
    }
    if (size >= $c3713d7ce0443654$var$tabSize) return;
    character = value.charAt(index);
    if (character === $c3713d7ce0443654$var$asterisk || character === $c3713d7ce0443654$var$plusSign || character === $c3713d7ce0443654$var$dash) {
        marker = character;
        ordered = false;
    } else {
        ordered = true;
        queue = "";
        while(index < length){
            character = value.charAt(index);
            if (!$35IlD(character)) break;
            queue += character;
            index++;
        }
        character = value.charAt(index);
        if (!queue || !(character === $c3713d7ce0443654$var$dot || commonmark && character === $c3713d7ce0443654$var$rightParenthesis)) return;
        start = parseInt(queue, 10);
        marker = character;
    }
    character = value.charAt(++index);
    if (character !== $c3713d7ce0443654$var$space && character !== $c3713d7ce0443654$var$tab && (pedantic || character !== $c3713d7ce0443654$var$lineFeed && character !== "")) return;
    if (silent) return true;
    index = 0;
    items = [];
    allLines = [];
    emptyLines = [];
    while(index < length){
        nextIndex = value.indexOf($c3713d7ce0443654$var$lineFeed, index);
        startIndex = index;
        prefixed = false;
        indented = false;
        if (nextIndex === -1) nextIndex = length;
        end = index + $c3713d7ce0443654$var$tabSize;
        size = 0;
        while(index < length){
            character = value.charAt(index);
            if (character === $c3713d7ce0443654$var$tab) size += $c3713d7ce0443654$var$tabSize - size % $c3713d7ce0443654$var$tabSize;
            else if (character === $c3713d7ce0443654$var$space) size++;
            else break;
            index++;
        }
        if (size >= $c3713d7ce0443654$var$tabSize) indented = true;
        if (item && size >= item.indent) indented = true;
        character = value.charAt(index);
        currentMarker = null;
        if (!indented) {
            if (character === $c3713d7ce0443654$var$asterisk || character === $c3713d7ce0443654$var$plusSign || character === $c3713d7ce0443654$var$dash) {
                currentMarker = character;
                index++;
                size++;
            } else {
                queue = "";
                while(index < length){
                    character = value.charAt(index);
                    if (!$35IlD(character)) break;
                    queue += character;
                    index++;
                }
                character = value.charAt(index);
                index++;
                if (queue && (character === $c3713d7ce0443654$var$dot || commonmark && character === $c3713d7ce0443654$var$rightParenthesis)) {
                    currentMarker = character;
                    size += queue.length + 1;
                }
            }
            if (currentMarker) {
                character = value.charAt(index);
                if (character === $c3713d7ce0443654$var$tab) {
                    size += $c3713d7ce0443654$var$tabSize - size % $c3713d7ce0443654$var$tabSize;
                    index++;
                } else if (character === $c3713d7ce0443654$var$space) {
                    end = index + $c3713d7ce0443654$var$tabSize;
                    while(index < end){
                        if (value.charAt(index) !== $c3713d7ce0443654$var$space) break;
                        index++;
                        size++;
                    }
                    if (index === end && value.charAt(index) === $c3713d7ce0443654$var$space) {
                        index -= $c3713d7ce0443654$var$tabSize - 1;
                        size -= $c3713d7ce0443654$var$tabSize - 1;
                    }
                } else if (character !== $c3713d7ce0443654$var$lineFeed && character !== "") currentMarker = null;
            }
        }
        if (currentMarker) {
            if (!pedantic && marker !== currentMarker) break;
            prefixed = true;
        } else {
            if (!commonmark && !indented && value.charAt(startIndex) === $c3713d7ce0443654$var$space) indented = true;
            else if (commonmark && item) indented = size >= item.indent || size > $c3713d7ce0443654$var$tabSize;
            prefixed = false;
            index = startIndex;
        }
        line = value.slice(startIndex, nextIndex);
        content = startIndex === index ? line : value.slice(index, nextIndex);
        if (currentMarker === $c3713d7ce0443654$var$asterisk || currentMarker === $c3713d7ce0443654$var$underscore || currentMarker === $c3713d7ce0443654$var$dash) {
            if (tokenizers.thematicBreak.call(self, eat, line, true)) break;
        }
        prevEmpty = empty;
        empty = !prefixed && !$2Lc6r(content).length;
        if (indented && item) {
            item.value = item.value.concat(emptyLines, line);
            allLines = allLines.concat(emptyLines, line);
            emptyLines = [];
        } else if (prefixed) {
            if (emptyLines.length !== 0) {
                spread = true;
                item.value.push("");
                item.trail = emptyLines.concat();
            }
            item = {
                value: [
                    line
                ],
                indent: size,
                trail: []
            };
            items.push(item);
            allLines = allLines.concat(emptyLines, line);
            emptyLines = [];
        } else if (empty) {
            if (prevEmpty && !commonmark) break;
            emptyLines.push(line);
        } else {
            if (prevEmpty) break;
            if ($hIMnZ(interuptors, tokenizers, self, [
                eat,
                line,
                true
            ])) break;
            item.value = item.value.concat(emptyLines, line);
            allLines = allLines.concat(emptyLines, line);
            emptyLines = [];
        }
        index = nextIndex + 1;
    }
    node = eat(allLines.join($c3713d7ce0443654$var$lineFeed)).reset({
        type: "list",
        ordered: ordered,
        start: start,
        spread: spread,
        children: []
    });
    enterTop = self.enterList();
    exitBlockquote = self.enterBlock();
    index = -1;
    length = items.length;
    while(++index < length){
        item = items[index].value.join($c3713d7ce0443654$var$lineFeed);
        now = eat.now();
        eat(item)($c3713d7ce0443654$var$listItem(self, item, now), node);
        item = items[index].trail.join($c3713d7ce0443654$var$lineFeed);
        if (index !== length - 1) item += $c3713d7ce0443654$var$lineFeed;
        eat(item);
    }
    enterTop();
    exitBlockquote();
    return node;
}
function $c3713d7ce0443654$var$listItem(ctx, value, position) {
    var offsets = ctx.offset;
    var fn = ctx.options.pedantic ? $c3713d7ce0443654$var$pedanticListItem : $c3713d7ce0443654$var$normalListItem;
    var checked = null;
    var task;
    var indent;
    value = fn.apply(null, arguments);
    if (ctx.options.gfm) {
        task = value.match($c3713d7ce0443654$var$taskItemExpression);
        if (task) {
            indent = task[0].length;
            checked = task[1].toLowerCase() === $c3713d7ce0443654$var$lowercaseX;
            offsets[position.line] += indent;
            value = value.slice(indent);
        }
    }
    return {
        type: "listItem",
        spread: $c3713d7ce0443654$var$looseListItemExpression.test(value),
        checked: checked,
        children: ctx.tokenizeBlock(value, position)
    };
}
// Create a list-item using overly simple mechanics.
function $c3713d7ce0443654$var$pedanticListItem(ctx, value, position) {
    var offsets = ctx.offset;
    var line = position.line;
    // Remove the list-item’s bullet.
    value = value.replace($c3713d7ce0443654$var$pedanticBulletExpression, replacer);
    // The initial line was also matched by the below, so we reset the `line`.
    line = position.line;
    return value.replace($c3713d7ce0443654$var$initialIndentExpression, replacer);
    // A simple replacer which removed all matches, and adds their length to
    // `offset`.
    function replacer($0) {
        offsets[line] = (offsets[line] || 0) + $0.length;
        line++;
        return "";
    }
}
// Create a list-item using sane mechanics.
function $c3713d7ce0443654$var$normalListItem(ctx, value, position) {
    var offsets = ctx.offset;
    var line = position.line;
    var max;
    var bullet;
    var rest;
    var lines;
    var trimmedLines;
    var index;
    var length;
    // Remove the list-item’s bullet.
    value = value.replace($c3713d7ce0443654$var$bulletExpression, replacer);
    lines = value.split($c3713d7ce0443654$var$lineFeed);
    trimmedLines = $gi4CN(value, $4EdzQ(max).indent).split($c3713d7ce0443654$var$lineFeed);
    // We replaced the initial bullet with something else above, which was used
    // to trick `removeIndentation` into removing some more characters when
    // possible.  However, that could result in the initial line to be stripped
    // more than it should be.
    trimmedLines[0] = rest;
    offsets[line] = (offsets[line] || 0) + bullet.length;
    line++;
    index = 0;
    length = lines.length;
    while(++index < length){
        offsets[line] = (offsets[line] || 0) + lines[index].length - trimmedLines[index].length;
        line++;
    }
    return trimmedLines.join($c3713d7ce0443654$var$lineFeed);
    /* eslint-disable-next-line max-params */ function replacer($0, $1, $2, $3, $4) {
        bullet = $1 + $2 + $3;
        rest = $4;
        // Make sure that the first nine numbered list items can indent with an
        // extra space.  That is, when the bullet did not receive an extra final
        // space.
        if (Number($2) < 10 && bullet.length % 2 === 1) $2 = $c3713d7ce0443654$var$space + $2;
        max = $1 + $j6axH($c3713d7ce0443654$var$space, $2.length) + $3;
        return max + rest;
    }
}

});
parcelRegister("4EdzQ", function(module, exports) {
"use strict";
module.exports = $36256dfe6a4cc2e6$var$indentation;
var $36256dfe6a4cc2e6$var$tab = "	";
var $36256dfe6a4cc2e6$var$space = " ";
var $36256dfe6a4cc2e6$var$spaceSize = 1;
var $36256dfe6a4cc2e6$var$tabSize = 4;
// Gets indentation information for a line.
function $36256dfe6a4cc2e6$var$indentation(value) {
    var index = 0;
    var indent = 0;
    var character = value.charAt(index);
    var stops = {};
    var size;
    while(character === $36256dfe6a4cc2e6$var$tab || character === $36256dfe6a4cc2e6$var$space){
        size = character === $36256dfe6a4cc2e6$var$tab ? $36256dfe6a4cc2e6$var$tabSize : $36256dfe6a4cc2e6$var$spaceSize;
        indent += size;
        if (size > 1) indent = Math.floor(indent / size) * size;
        stops[indent] = index;
        character = value.charAt(++index);
    }
    return {
        indent: indent,
        stops: stops
    };
}

});

parcelRegister("gi4CN", function(module, exports) {
"use strict";

var $2Lc6r = parcelRequire("2Lc6r");

var $j6axH = parcelRequire("j6axH");

var $4EdzQ = parcelRequire("4EdzQ");
module.exports = $bdc1ea2b9c465561$var$indentation;
var $bdc1ea2b9c465561$var$tab = "	";
var $bdc1ea2b9c465561$var$lineFeed = "\n";
var $bdc1ea2b9c465561$var$space = " ";
var $bdc1ea2b9c465561$var$exclamationMark = "!";
// Remove the minimum indent from every line in `value`.  Supports both tab,
// spaced, and mixed indentation (as well as possible).
function $bdc1ea2b9c465561$var$indentation(value, maximum) {
    var values = value.split($bdc1ea2b9c465561$var$lineFeed);
    var position = values.length + 1;
    var minIndent = Infinity;
    var matrix = [];
    var index;
    var indentation;
    var stops;
    var padding;
    values.unshift($j6axH($bdc1ea2b9c465561$var$space, maximum) + $bdc1ea2b9c465561$var$exclamationMark);
    while(position--){
        indentation = $4EdzQ(values[position]);
        matrix[position] = indentation.stops;
        if ($2Lc6r(values[position]).length === 0) continue;
        if (indentation.indent) {
            if (indentation.indent > 0 && indentation.indent < minIndent) minIndent = indentation.indent;
        } else {
            minIndent = Infinity;
            break;
        }
    }
    if (minIndent !== Infinity) {
        position = values.length;
        while(position--){
            stops = matrix[position];
            index = minIndent;
            while(index && !(index in stops))index--;
            if ($2Lc6r(values[position]).length !== 0 && minIndent && index !== minIndent) padding = $bdc1ea2b9c465561$var$tab;
            else padding = "";
            values[position] = padding + values[position].slice(index in stops ? stops[index] + 1 : 0);
        }
    }
    values.shift();
    return values.join($bdc1ea2b9c465561$var$lineFeed);
}

});


parcelRegister("6gCu0", function(module, exports) {
"use strict";
module.exports = $490216a0d03d17d9$var$setextHeading;
var $490216a0d03d17d9$var$lineFeed = "\n";
var $490216a0d03d17d9$var$tab = "	";
var $490216a0d03d17d9$var$space = " ";
var $490216a0d03d17d9$var$equalsTo = "=";
var $490216a0d03d17d9$var$dash = "-";
var $490216a0d03d17d9$var$maxIndent = 3;
var $490216a0d03d17d9$var$equalsToDepth = 1;
var $490216a0d03d17d9$var$dashDepth = 2;
function $490216a0d03d17d9$var$setextHeading(eat, value, silent) {
    var self = this;
    var now = eat.now();
    var length = value.length;
    var index = -1;
    var subvalue = "";
    var content;
    var queue;
    var character;
    var marker;
    var depth;
    // Eat initial indentation.
    while(++index < length){
        character = value.charAt(index);
        if (character !== $490216a0d03d17d9$var$space || index >= $490216a0d03d17d9$var$maxIndent) {
            index--;
            break;
        }
        subvalue += character;
    }
    // Eat content.
    content = "";
    queue = "";
    while(++index < length){
        character = value.charAt(index);
        if (character === $490216a0d03d17d9$var$lineFeed) {
            index--;
            break;
        }
        if (character === $490216a0d03d17d9$var$space || character === $490216a0d03d17d9$var$tab) queue += character;
        else {
            content += queue + character;
            queue = "";
        }
    }
    now.column += subvalue.length;
    now.offset += subvalue.length;
    subvalue += content + queue;
    // Ensure the content is followed by a newline and a valid marker.
    character = value.charAt(++index);
    marker = value.charAt(++index);
    if (character !== $490216a0d03d17d9$var$lineFeed || marker !== $490216a0d03d17d9$var$equalsTo && marker !== $490216a0d03d17d9$var$dash) return;
    subvalue += character;
    // Eat Setext-line.
    queue = marker;
    depth = marker === $490216a0d03d17d9$var$equalsTo ? $490216a0d03d17d9$var$equalsToDepth : $490216a0d03d17d9$var$dashDepth;
    while(++index < length){
        character = value.charAt(index);
        if (character !== marker) {
            if (character !== $490216a0d03d17d9$var$lineFeed) return;
            index--;
            break;
        }
        queue += character;
    }
    if (silent) return true;
    return eat(subvalue + queue)({
        type: "heading",
        depth: depth,
        children: self.tokenizeInline(content, now)
    });
}

});

parcelRegister("8EbVz", function(module, exports) {
"use strict";

var $irnv4 = parcelRequire("irnv4");
var $64bb4fbd32af98c8$require$openCloseTag = $irnv4.openCloseTag;
module.exports = $64bb4fbd32af98c8$var$blockHtml;
var $64bb4fbd32af98c8$var$tab = "	";
var $64bb4fbd32af98c8$var$space = " ";
var $64bb4fbd32af98c8$var$lineFeed = "\n";
var $64bb4fbd32af98c8$var$lessThan = "<";
var $64bb4fbd32af98c8$var$rawOpenExpression = /^<(script|pre|style)(?=(\s|>|$))/i;
var $64bb4fbd32af98c8$var$rawCloseExpression = /<\/(script|pre|style)>/i;
var $64bb4fbd32af98c8$var$commentOpenExpression = /^<!--/;
var $64bb4fbd32af98c8$var$commentCloseExpression = /-->/;
var $64bb4fbd32af98c8$var$instructionOpenExpression = /^<\?/;
var $64bb4fbd32af98c8$var$instructionCloseExpression = /\?>/;
var $64bb4fbd32af98c8$var$directiveOpenExpression = /^<![A-Za-z]/;
var $64bb4fbd32af98c8$var$directiveCloseExpression = />/;
var $64bb4fbd32af98c8$var$cdataOpenExpression = /^<!\[CDATA\[/;
var $64bb4fbd32af98c8$var$cdataCloseExpression = /\]\]>/;
var $64bb4fbd32af98c8$var$elementCloseExpression = /^$/;
var $64bb4fbd32af98c8$var$otherElementOpenExpression = new RegExp($64bb4fbd32af98c8$require$openCloseTag.source + "\\s*$");
function $64bb4fbd32af98c8$var$blockHtml(eat, value, silent) {
    var self = this;
    var blocks = self.options.blocks.join("|");
    var elementOpenExpression = new RegExp("^</?(" + blocks + ")(?=(\\s|/?>|$))", "i");
    var length = value.length;
    var index = 0;
    var next;
    var line;
    var offset;
    var character;
    var count;
    var sequence;
    var subvalue;
    var sequences = [
        [
            $64bb4fbd32af98c8$var$rawOpenExpression,
            $64bb4fbd32af98c8$var$rawCloseExpression,
            true
        ],
        [
            $64bb4fbd32af98c8$var$commentOpenExpression,
            $64bb4fbd32af98c8$var$commentCloseExpression,
            true
        ],
        [
            $64bb4fbd32af98c8$var$instructionOpenExpression,
            $64bb4fbd32af98c8$var$instructionCloseExpression,
            true
        ],
        [
            $64bb4fbd32af98c8$var$directiveOpenExpression,
            $64bb4fbd32af98c8$var$directiveCloseExpression,
            true
        ],
        [
            $64bb4fbd32af98c8$var$cdataOpenExpression,
            $64bb4fbd32af98c8$var$cdataCloseExpression,
            true
        ],
        [
            elementOpenExpression,
            $64bb4fbd32af98c8$var$elementCloseExpression,
            true
        ],
        [
            $64bb4fbd32af98c8$var$otherElementOpenExpression,
            $64bb4fbd32af98c8$var$elementCloseExpression,
            false
        ]
    ];
    // Eat initial spacing.
    while(index < length){
        character = value.charAt(index);
        if (character !== $64bb4fbd32af98c8$var$tab && character !== $64bb4fbd32af98c8$var$space) break;
        index++;
    }
    if (value.charAt(index) !== $64bb4fbd32af98c8$var$lessThan) return;
    next = value.indexOf($64bb4fbd32af98c8$var$lineFeed, index + 1);
    next = next === -1 ? length : next;
    line = value.slice(index, next);
    offset = -1;
    count = sequences.length;
    while(++offset < count)if (sequences[offset][0].test(line)) {
        sequence = sequences[offset];
        break;
    }
    if (!sequence) return;
    if (silent) return sequence[2];
    index = next;
    if (!sequence[1].test(line)) while(index < length){
        next = value.indexOf($64bb4fbd32af98c8$var$lineFeed, index + 1);
        next = next === -1 ? length : next;
        line = value.slice(index + 1, next);
        if (sequence[1].test(line)) {
            if (line) index = next;
            break;
        }
        index = next;
    }
    subvalue = value.slice(0, index);
    return eat(subvalue)({
        type: "html",
        value: subvalue
    });
}

});
parcelRegister("irnv4", function(module, exports) {

$parcel$export(module.exports, "openCloseTag", function () { return $d6ccfa4616af940f$export$a33a5d2984e0051b; }, function (v) { return $d6ccfa4616af940f$export$a33a5d2984e0051b = v; });
$parcel$export(module.exports, "tag", function () { return $d6ccfa4616af940f$export$2b067c6666111485; }, function (v) { return $d6ccfa4616af940f$export$2b067c6666111485 = v; });
var $d6ccfa4616af940f$export$a33a5d2984e0051b;
var $d6ccfa4616af940f$export$2b067c6666111485;
"use strict";
var $d6ccfa4616af940f$var$attributeName = "[a-zA-Z_:][a-zA-Z0-9:._-]*";
var $d6ccfa4616af940f$var$unquoted = "[^\"'=<>`\\u0000-\\u0020]+";
var $d6ccfa4616af940f$var$singleQuoted = "'[^']*'";
var $d6ccfa4616af940f$var$doubleQuoted = '"[^"]*"';
var $d6ccfa4616af940f$var$attributeValue = "(?:" + $d6ccfa4616af940f$var$unquoted + "|" + $d6ccfa4616af940f$var$singleQuoted + "|" + $d6ccfa4616af940f$var$doubleQuoted + ")";
var $d6ccfa4616af940f$var$attribute = "(?:\\s+" + $d6ccfa4616af940f$var$attributeName + "(?:\\s*=\\s*" + $d6ccfa4616af940f$var$attributeValue + ")?)";
var $d6ccfa4616af940f$var$openTag = "<[A-Za-z][A-Za-z0-9\\-]*" + $d6ccfa4616af940f$var$attribute + "*\\s*\\/?>";
var $d6ccfa4616af940f$var$closeTag = "<\\/[A-Za-z][A-Za-z0-9\\-]*\\s*>";
var $d6ccfa4616af940f$var$comment = "<!---->|<!--(?:-?[^>-])(?:-?[^-])*-->";
var $d6ccfa4616af940f$var$processing = "<[?].*?[?]>";
var $d6ccfa4616af940f$var$declaration = "<![A-Za-z]+\\s+[^>]*>";
var $d6ccfa4616af940f$var$cdata = "<!\\[CDATA\\[[\\s\\S]*?\\]\\]>";
$d6ccfa4616af940f$export$a33a5d2984e0051b = new RegExp("^(?:" + $d6ccfa4616af940f$var$openTag + "|" + $d6ccfa4616af940f$var$closeTag + ")");
$d6ccfa4616af940f$export$2b067c6666111485 = new RegExp("^(?:" + $d6ccfa4616af940f$var$openTag + "|" + $d6ccfa4616af940f$var$closeTag + "|" + $d6ccfa4616af940f$var$comment + "|" + $d6ccfa4616af940f$var$processing + "|" + $d6ccfa4616af940f$var$declaration + "|" + $d6ccfa4616af940f$var$cdata + ")");

});


parcelRegister("lRbMn", function(module, exports) {
"use strict";

var $kZNgz = parcelRequire("kZNgz");

var $jmqbX = parcelRequire("jmqbX");
module.exports = $fe97af50c71cf6df$var$footnoteDefinition;
$fe97af50c71cf6df$var$footnoteDefinition.notInList = true;
$fe97af50c71cf6df$var$footnoteDefinition.notInBlock = true;
var $fe97af50c71cf6df$var$backslash = "\\";
var $fe97af50c71cf6df$var$lineFeed = "\n";
var $fe97af50c71cf6df$var$tab = "	";
var $fe97af50c71cf6df$var$space = " ";
var $fe97af50c71cf6df$var$leftSquareBracket = "[";
var $fe97af50c71cf6df$var$rightSquareBracket = "]";
var $fe97af50c71cf6df$var$caret = "^";
var $fe97af50c71cf6df$var$colon = ":";
var $fe97af50c71cf6df$var$EXPRESSION_INITIAL_TAB = /^( {4}|\t)?/gm;
function $fe97af50c71cf6df$var$footnoteDefinition(eat, value, silent) {
    var self = this;
    var offsets = self.offset;
    var index;
    var length;
    var subvalue;
    var now;
    var currentLine;
    var content;
    var queue;
    var subqueue;
    var character;
    var identifier;
    var add;
    var exit;
    if (!self.options.footnotes) return;
    index = 0;
    length = value.length;
    subvalue = "";
    now = eat.now();
    currentLine = now.line;
    while(index < length){
        character = value.charAt(index);
        if (!$kZNgz(character)) break;
        subvalue += character;
        index++;
    }
    if (value.charAt(index) !== $fe97af50c71cf6df$var$leftSquareBracket || value.charAt(index + 1) !== $fe97af50c71cf6df$var$caret) return;
    subvalue += $fe97af50c71cf6df$var$leftSquareBracket + $fe97af50c71cf6df$var$caret;
    index = subvalue.length;
    queue = "";
    while(index < length){
        character = value.charAt(index);
        if (character === $fe97af50c71cf6df$var$rightSquareBracket) break;
        else if (character === $fe97af50c71cf6df$var$backslash) {
            queue += character;
            index++;
            character = value.charAt(index);
        }
        queue += character;
        index++;
    }
    if (!queue || value.charAt(index) !== $fe97af50c71cf6df$var$rightSquareBracket || value.charAt(index + 1) !== $fe97af50c71cf6df$var$colon) return;
    if (silent) return true;
    identifier = queue;
    subvalue += queue + $fe97af50c71cf6df$var$rightSquareBracket + $fe97af50c71cf6df$var$colon;
    index = subvalue.length;
    while(index < length){
        character = value.charAt(index);
        if (character !== $fe97af50c71cf6df$var$tab && character !== $fe97af50c71cf6df$var$space) break;
        subvalue += character;
        index++;
    }
    now.column += subvalue.length;
    now.offset += subvalue.length;
    queue = "";
    content = "";
    subqueue = "";
    while(index < length){
        character = value.charAt(index);
        if (character === $fe97af50c71cf6df$var$lineFeed) {
            subqueue = character;
            index++;
            while(index < length){
                character = value.charAt(index);
                if (character !== $fe97af50c71cf6df$var$lineFeed) break;
                subqueue += character;
                index++;
            }
            queue += subqueue;
            subqueue = "";
            while(index < length){
                character = value.charAt(index);
                if (character !== $fe97af50c71cf6df$var$space) break;
                subqueue += character;
                index++;
            }
            if (subqueue.length === 0) break;
            queue += subqueue;
        }
        if (queue) {
            content += queue;
            queue = "";
        }
        content += character;
        index++;
    }
    subvalue += content;
    content = content.replace($fe97af50c71cf6df$var$EXPRESSION_INITIAL_TAB, function(line) {
        offsets[currentLine] = (offsets[currentLine] || 0) + line.length;
        currentLine++;
        return "";
    });
    add = eat(subvalue);
    exit = self.enterBlock();
    content = self.tokenizeBlock(content, now);
    exit();
    return add({
        type: "footnoteDefinition",
        identifier: $jmqbX(identifier),
        label: identifier,
        children: content
    });
}

});
parcelRegister("jmqbX", function(module, exports) {
"use strict";

var $lcAVc = parcelRequire("lcAVc");
module.exports = $e184638aaf360d75$var$normalize;
// Normalize an identifier.  Collapses multiple white space characters into a
// single space, and removes casing.
function $e184638aaf360d75$var$normalize(value) {
    return $lcAVc(value).toLowerCase();
}

});
parcelRegister("lcAVc", function(module, exports) {
"use strict";
module.exports = $f6f75bd2ad2cfe0a$var$collapse;
// `collapse(' \t\nbar \nbaz\t') // ' bar baz '`
function $f6f75bd2ad2cfe0a$var$collapse(value) {
    return String(value).replace(/\s+/g, " ");
}

});



parcelRegister("gv9fx", function(module, exports) {
"use strict";

var $kZNgz = parcelRequire("kZNgz");

var $jmqbX = parcelRequire("jmqbX");
module.exports = $c036b75b867a35f9$var$definition;
var $c036b75b867a35f9$var$quotationMark = '"';
var $c036b75b867a35f9$var$apostrophe = "'";
var $c036b75b867a35f9$var$backslash = "\\";
var $c036b75b867a35f9$var$lineFeed = "\n";
var $c036b75b867a35f9$var$tab = "	";
var $c036b75b867a35f9$var$space = " ";
var $c036b75b867a35f9$var$leftSquareBracket = "[";
var $c036b75b867a35f9$var$rightSquareBracket = "]";
var $c036b75b867a35f9$var$leftParenthesis = "(";
var $c036b75b867a35f9$var$rightParenthesis = ")";
var $c036b75b867a35f9$var$colon = ":";
var $c036b75b867a35f9$var$lessThan = "<";
var $c036b75b867a35f9$var$greaterThan = ">";
function $c036b75b867a35f9$var$definition(eat, value, silent) {
    var self = this;
    var commonmark = self.options.commonmark;
    var index = 0;
    var length = value.length;
    var subvalue = "";
    var beforeURL;
    var beforeTitle;
    var queue;
    var character;
    var test;
    var identifier;
    var url;
    var title;
    while(index < length){
        character = value.charAt(index);
        if (character !== $c036b75b867a35f9$var$space && character !== $c036b75b867a35f9$var$tab) break;
        subvalue += character;
        index++;
    }
    character = value.charAt(index);
    if (character !== $c036b75b867a35f9$var$leftSquareBracket) return;
    index++;
    subvalue += character;
    queue = "";
    while(index < length){
        character = value.charAt(index);
        if (character === $c036b75b867a35f9$var$rightSquareBracket) break;
        else if (character === $c036b75b867a35f9$var$backslash) {
            queue += character;
            index++;
            character = value.charAt(index);
        }
        queue += character;
        index++;
    }
    if (!queue || value.charAt(index) !== $c036b75b867a35f9$var$rightSquareBracket || value.charAt(index + 1) !== $c036b75b867a35f9$var$colon) return;
    identifier = queue;
    subvalue += queue + $c036b75b867a35f9$var$rightSquareBracket + $c036b75b867a35f9$var$colon;
    index = subvalue.length;
    queue = "";
    while(index < length){
        character = value.charAt(index);
        if (character !== $c036b75b867a35f9$var$tab && character !== $c036b75b867a35f9$var$space && character !== $c036b75b867a35f9$var$lineFeed) break;
        subvalue += character;
        index++;
    }
    character = value.charAt(index);
    queue = "";
    beforeURL = subvalue;
    if (character === $c036b75b867a35f9$var$lessThan) {
        index++;
        while(index < length){
            character = value.charAt(index);
            if (!$c036b75b867a35f9$var$isEnclosedURLCharacter(character)) break;
            queue += character;
            index++;
        }
        character = value.charAt(index);
        if (character === $c036b75b867a35f9$var$isEnclosedURLCharacter.delimiter) {
            subvalue += $c036b75b867a35f9$var$lessThan + queue + character;
            index++;
        } else {
            if (commonmark) return;
            index -= queue.length + 1;
            queue = "";
        }
    }
    if (!queue) {
        while(index < length){
            character = value.charAt(index);
            if (!$c036b75b867a35f9$var$isUnclosedURLCharacter(character)) break;
            queue += character;
            index++;
        }
        subvalue += queue;
    }
    if (!queue) return;
    url = queue;
    queue = "";
    while(index < length){
        character = value.charAt(index);
        if (character !== $c036b75b867a35f9$var$tab && character !== $c036b75b867a35f9$var$space && character !== $c036b75b867a35f9$var$lineFeed) break;
        queue += character;
        index++;
    }
    character = value.charAt(index);
    test = null;
    if (character === $c036b75b867a35f9$var$quotationMark) test = $c036b75b867a35f9$var$quotationMark;
    else if (character === $c036b75b867a35f9$var$apostrophe) test = $c036b75b867a35f9$var$apostrophe;
    else if (character === $c036b75b867a35f9$var$leftParenthesis) test = $c036b75b867a35f9$var$rightParenthesis;
    if (!test) {
        queue = "";
        index = subvalue.length;
    } else if (queue) {
        subvalue += queue + character;
        index = subvalue.length;
        queue = "";
        while(index < length){
            character = value.charAt(index);
            if (character === test) break;
            if (character === $c036b75b867a35f9$var$lineFeed) {
                index++;
                character = value.charAt(index);
                if (character === $c036b75b867a35f9$var$lineFeed || character === test) return;
                queue += $c036b75b867a35f9$var$lineFeed;
            }
            queue += character;
            index++;
        }
        character = value.charAt(index);
        if (character !== test) return;
        beforeTitle = subvalue;
        subvalue += queue + character;
        index++;
        title = queue;
        queue = "";
    } else return;
    while(index < length){
        character = value.charAt(index);
        if (character !== $c036b75b867a35f9$var$tab && character !== $c036b75b867a35f9$var$space) break;
        subvalue += character;
        index++;
    }
    character = value.charAt(index);
    if (!character || character === $c036b75b867a35f9$var$lineFeed) {
        if (silent) return true;
        beforeURL = eat(beforeURL).test().end;
        url = self.decode.raw(self.unescape(url), beforeURL, {
            nonTerminated: false
        });
        if (title) {
            beforeTitle = eat(beforeTitle).test().end;
            title = self.decode.raw(self.unescape(title), beforeTitle);
        }
        return eat(subvalue)({
            type: "definition",
            identifier: $jmqbX(identifier),
            label: identifier,
            title: title || null,
            url: url
        });
    }
}
// Check if `character` can be inside an enclosed URI.
function $c036b75b867a35f9$var$isEnclosedURLCharacter(character) {
    return character !== $c036b75b867a35f9$var$greaterThan && character !== $c036b75b867a35f9$var$leftSquareBracket && character !== $c036b75b867a35f9$var$rightSquareBracket;
}
$c036b75b867a35f9$var$isEnclosedURLCharacter.delimiter = $c036b75b867a35f9$var$greaterThan;
// Check if `character` can be inside an unclosed URI.
function $c036b75b867a35f9$var$isUnclosedURLCharacter(character) {
    return character !== $c036b75b867a35f9$var$leftSquareBracket && character !== $c036b75b867a35f9$var$rightSquareBracket && !$kZNgz(character);
}

});

parcelRegister("04Igv", function(module, exports) {
"use strict";

var $kZNgz = parcelRequire("kZNgz");
module.exports = $00e2b6037037da29$var$table;
var $00e2b6037037da29$var$tab = "	";
var $00e2b6037037da29$var$lineFeed = "\n";
var $00e2b6037037da29$var$space = " ";
var $00e2b6037037da29$var$dash = "-";
var $00e2b6037037da29$var$colon = ":";
var $00e2b6037037da29$var$backslash = "\\";
var $00e2b6037037da29$var$verticalBar = "|";
var $00e2b6037037da29$var$minColumns = 1;
var $00e2b6037037da29$var$minRows = 2;
var $00e2b6037037da29$var$left = "left";
var $00e2b6037037da29$var$center = "center";
var $00e2b6037037da29$var$right = "right";
function $00e2b6037037da29$var$table(eat, value, silent) {
    var self = this;
    var index;
    var alignments;
    var alignment;
    var subvalue;
    var row;
    var length;
    var lines;
    var queue;
    var character;
    var hasDash;
    var align;
    var cell;
    var preamble;
    var now;
    var position;
    var lineCount;
    var line;
    var rows;
    var table;
    var lineIndex;
    var pipeIndex;
    var first;
    // Exit when not in gfm-mode.
    if (!self.options.gfm) return;
    // Get the rows.
    // Detecting tables soon is hard, so there are some checks for performance
    // here, such as the minimum number of rows, and allowed characters in the
    // alignment row.
    index = 0;
    lineCount = 0;
    length = value.length + 1;
    lines = [];
    while(index < length){
        lineIndex = value.indexOf($00e2b6037037da29$var$lineFeed, index);
        pipeIndex = value.indexOf($00e2b6037037da29$var$verticalBar, index + 1);
        if (lineIndex === -1) lineIndex = value.length;
        if (pipeIndex === -1 || pipeIndex > lineIndex) {
            if (lineCount < $00e2b6037037da29$var$minRows) return;
            break;
        }
        lines.push(value.slice(index, lineIndex));
        lineCount++;
        index = lineIndex + 1;
    }
    // Parse the alignment row.
    subvalue = lines.join($00e2b6037037da29$var$lineFeed);
    alignments = lines.splice(1, 1)[0] || [];
    index = 0;
    length = alignments.length;
    lineCount--;
    alignment = false;
    align = [];
    while(index < length){
        character = alignments.charAt(index);
        if (character === $00e2b6037037da29$var$verticalBar) {
            hasDash = null;
            if (alignment === false) {
                if (first === false) return;
            } else {
                align.push(alignment);
                alignment = false;
            }
            first = false;
        } else if (character === $00e2b6037037da29$var$dash) {
            hasDash = true;
            alignment = alignment || null;
        } else if (character === $00e2b6037037da29$var$colon) {
            if (alignment === $00e2b6037037da29$var$left) alignment = $00e2b6037037da29$var$center;
            else if (hasDash && alignment === null) alignment = $00e2b6037037da29$var$right;
            else alignment = $00e2b6037037da29$var$left;
        } else if (!$kZNgz(character)) return;
        index++;
    }
    if (alignment !== false) align.push(alignment);
    // Exit when without enough columns.
    if (align.length < $00e2b6037037da29$var$minColumns) return;
    /* istanbul ignore if - never used (yet) */ if (silent) return true;
    // Parse the rows.
    position = -1;
    rows = [];
    table = eat(subvalue).reset({
        type: "table",
        align: align,
        children: rows
    });
    while(++position < lineCount){
        line = lines[position];
        row = {
            type: "tableRow",
            children: []
        };
        // Eat a newline character when this is not the first row.
        if (position) eat($00e2b6037037da29$var$lineFeed);
        // Eat the row.
        eat(line).reset(row, table);
        length = line.length + 1;
        index = 0;
        queue = "";
        cell = "";
        preamble = true;
        while(index < length){
            character = line.charAt(index);
            if (character === $00e2b6037037da29$var$tab || character === $00e2b6037037da29$var$space) {
                if (cell) queue += character;
                else eat(character);
                index++;
                continue;
            }
            if (character === "" || character === $00e2b6037037da29$var$verticalBar) {
                if (preamble) eat(character);
                else {
                    if ((cell || character) && !preamble) {
                        subvalue = cell;
                        if (queue.length > 1) {
                            if (character) {
                                subvalue += queue.slice(0, queue.length - 1);
                                queue = queue.charAt(queue.length - 1);
                            } else {
                                subvalue += queue;
                                queue = "";
                            }
                        }
                        now = eat.now();
                        eat(subvalue)({
                            type: "tableCell",
                            children: self.tokenizeInline(cell, now)
                        }, row);
                    }
                    eat(queue + character);
                    queue = "";
                    cell = "";
                }
            } else {
                if (queue) {
                    cell += queue;
                    queue = "";
                }
                cell += character;
                if (character === $00e2b6037037da29$var$backslash && index !== length - 2) {
                    cell += line.charAt(index + 1);
                    index++;
                }
            }
            preamble = false;
            index++;
        }
        // Eat the alignment row.
        if (!position) eat($00e2b6037037da29$var$lineFeed + alignments);
    }
    return table;
}

});

parcelRegister("hfuIQ", function(module, exports) {
"use strict";

var $2Lc6r = parcelRequire("2Lc6r");

var $35IlD = parcelRequire("35IlD");

var $5H7vD = parcelRequire("5H7vD");

var $hIMnZ = parcelRequire("hIMnZ");
module.exports = $c8ebab3365122f53$var$paragraph;
var $c8ebab3365122f53$var$tab = "	";
var $c8ebab3365122f53$var$lineFeed = "\n";
var $c8ebab3365122f53$var$space = " ";
var $c8ebab3365122f53$var$tabSize = 4;
// Tokenise paragraph.
function $c8ebab3365122f53$var$paragraph(eat, value, silent) {
    var self = this;
    var settings = self.options;
    var commonmark = settings.commonmark;
    var gfm = settings.gfm;
    var tokenizers = self.blockTokenizers;
    var interruptors = self.interruptParagraph;
    var index = value.indexOf($c8ebab3365122f53$var$lineFeed);
    var length = value.length;
    var position;
    var subvalue;
    var character;
    var size;
    var now;
    while(index < length){
        // Eat everything if there’s no following newline.
        if (index === -1) {
            index = length;
            break;
        }
        // Stop if the next character is NEWLINE.
        if (value.charAt(index + 1) === $c8ebab3365122f53$var$lineFeed) break;
        // In commonmark-mode, following indented lines are part of the paragraph.
        if (commonmark) {
            size = 0;
            position = index + 1;
            while(position < length){
                character = value.charAt(position);
                if (character === $c8ebab3365122f53$var$tab) {
                    size = $c8ebab3365122f53$var$tabSize;
                    break;
                } else if (character === $c8ebab3365122f53$var$space) size++;
                else break;
                position++;
            }
            if (size >= $c8ebab3365122f53$var$tabSize && character !== $c8ebab3365122f53$var$lineFeed) {
                index = value.indexOf($c8ebab3365122f53$var$lineFeed, index + 1);
                continue;
            }
        }
        subvalue = value.slice(index + 1);
        // Check if the following code contains a possible block.
        if ($hIMnZ(interruptors, tokenizers, self, [
            eat,
            subvalue,
            true
        ])) break;
        // Break if the following line starts a list, when already in a list, or
        // when in commonmark, or when in gfm mode and the bullet is *not* numeric.
        if (tokenizers.list.call(self, eat, subvalue, true) && (self.inList || commonmark || gfm && !$35IlD($2Lc6r.left(subvalue).charAt(0)))) break;
        position = index;
        index = value.indexOf($c8ebab3365122f53$var$lineFeed, index + 1);
        if (index !== -1 && $2Lc6r(value.slice(position, index)) === "") {
            index = position;
            break;
        }
    }
    subvalue = value.slice(0, index);
    if ($2Lc6r(subvalue) === "") {
        eat(subvalue);
        return null;
    }
    /* istanbul ignore if - never used (yet) */ if (silent) return true;
    now = eat.now();
    subvalue = $5H7vD(subvalue);
    return eat(subvalue)({
        type: "paragraph",
        children: self.tokenizeInline(subvalue, now)
    });
}

});

parcelRegister("fG8Jf", function(module, exports) {
"use strict";

var $i6Cnu = parcelRequire("i6Cnu");
module.exports = $b6a18ca0d6d7ad52$var$escape;
$b6a18ca0d6d7ad52$var$escape.locator = $i6Cnu;
var $b6a18ca0d6d7ad52$var$lineFeed = "\n";
var $b6a18ca0d6d7ad52$var$backslash = "\\";
function $b6a18ca0d6d7ad52$var$escape(eat, value, silent) {
    var self = this;
    var character;
    var node;
    if (value.charAt(0) === $b6a18ca0d6d7ad52$var$backslash) {
        character = value.charAt(1);
        if (self.escape.indexOf(character) !== -1) {
            /* istanbul ignore if - never used (yet) */ if (silent) return true;
            if (character === $b6a18ca0d6d7ad52$var$lineFeed) node = {
                type: "break"
            };
            else node = {
                type: "text",
                value: character
            };
            return eat($b6a18ca0d6d7ad52$var$backslash + character)(node);
        }
    }
}

});
parcelRegister("i6Cnu", function(module, exports) {
"use strict";
module.exports = $d2e68e981f5ef606$var$locate;
function $d2e68e981f5ef606$var$locate(value, fromIndex) {
    return value.indexOf("\\", fromIndex);
}

});


parcelRegister("40HEA", function(module, exports) {
"use strict";

var $kZNgz = parcelRequire("kZNgz");

var $eUIxU = parcelRequire("eUIxU");

var $2utui = parcelRequire("2utui");
module.exports = $2eb9063277fa9ae9$var$autoLink;
$2eb9063277fa9ae9$var$autoLink.locator = $2utui;
$2eb9063277fa9ae9$var$autoLink.notInLink = true;
var $2eb9063277fa9ae9$var$lessThan = "<";
var $2eb9063277fa9ae9$var$greaterThan = ">";
var $2eb9063277fa9ae9$var$atSign = "@";
var $2eb9063277fa9ae9$var$slash = "/";
var $2eb9063277fa9ae9$var$mailto = "mailto:";
var $2eb9063277fa9ae9$var$mailtoLength = $2eb9063277fa9ae9$var$mailto.length;
function $2eb9063277fa9ae9$var$autoLink(eat, value, silent) {
    var self = this;
    var subvalue = "";
    var length = value.length;
    var index = 0;
    var queue = "";
    var hasAtCharacter = false;
    var link = "";
    var character;
    var now;
    var content;
    var tokenizers;
    var exit;
    if (value.charAt(0) !== $2eb9063277fa9ae9$var$lessThan) return;
    index++;
    subvalue = $2eb9063277fa9ae9$var$lessThan;
    while(index < length){
        character = value.charAt(index);
        if ($kZNgz(character) || character === $2eb9063277fa9ae9$var$greaterThan || character === $2eb9063277fa9ae9$var$atSign || character === ":" && value.charAt(index + 1) === $2eb9063277fa9ae9$var$slash) break;
        queue += character;
        index++;
    }
    if (!queue) return;
    link += queue;
    queue = "";
    character = value.charAt(index);
    link += character;
    index++;
    if (character === $2eb9063277fa9ae9$var$atSign) hasAtCharacter = true;
    else {
        if (character !== ":" || value.charAt(index + 1) !== $2eb9063277fa9ae9$var$slash) return;
        link += $2eb9063277fa9ae9$var$slash;
        index++;
    }
    while(index < length){
        character = value.charAt(index);
        if ($kZNgz(character) || character === $2eb9063277fa9ae9$var$greaterThan) break;
        queue += character;
        index++;
    }
    character = value.charAt(index);
    if (!queue || character !== $2eb9063277fa9ae9$var$greaterThan) return;
    /* istanbul ignore if - never used (yet) */ if (silent) return true;
    link += queue;
    content = link;
    subvalue += link + character;
    now = eat.now();
    now.column++;
    now.offset++;
    if (hasAtCharacter) {
        if (link.slice(0, $2eb9063277fa9ae9$var$mailtoLength).toLowerCase() === $2eb9063277fa9ae9$var$mailto) {
            content = content.slice($2eb9063277fa9ae9$var$mailtoLength);
            now.column += $2eb9063277fa9ae9$var$mailtoLength;
            now.offset += $2eb9063277fa9ae9$var$mailtoLength;
        } else link = $2eb9063277fa9ae9$var$mailto + link;
    }
    // Temporarily remove all tokenizers except text in autolinks.
    tokenizers = self.inlineTokenizers;
    self.inlineTokenizers = {
        text: tokenizers.text
    };
    exit = self.enterLink();
    content = self.tokenizeInline(content, now);
    self.inlineTokenizers = tokenizers;
    exit();
    return eat(subvalue)({
        type: "link",
        title: null,
        url: $eUIxU(link, {
            nonTerminated: false
        }),
        children: content
    });
}

});
parcelRegister("2utui", function(module, exports) {
"use strict";
module.exports = $1d0541bad92d2f9c$var$locate;
function $1d0541bad92d2f9c$var$locate(value, fromIndex) {
    return value.indexOf("<", fromIndex);
}

});


parcelRegister("cXItb", function(module, exports) {
"use strict";

var $eUIxU = parcelRequire("eUIxU");

var $kZNgz = parcelRequire("kZNgz");

var $5PG7O = parcelRequire("5PG7O");
module.exports = $96fd7d785cdb864e$var$url;
$96fd7d785cdb864e$var$url.locator = $5PG7O;
$96fd7d785cdb864e$var$url.notInLink = true;
var $96fd7d785cdb864e$var$quotationMark = '"';
var $96fd7d785cdb864e$var$apostrophe = "'";
var $96fd7d785cdb864e$var$leftParenthesis = "(";
var $96fd7d785cdb864e$var$rightParenthesis = ")";
var $96fd7d785cdb864e$var$comma = ",";
var $96fd7d785cdb864e$var$dot = ".";
var $96fd7d785cdb864e$var$colon = ":";
var $96fd7d785cdb864e$var$semicolon = ";";
var $96fd7d785cdb864e$var$lessThan = "<";
var $96fd7d785cdb864e$var$atSign = "@";
var $96fd7d785cdb864e$var$leftSquareBracket = "[";
var $96fd7d785cdb864e$var$rightSquareBracket = "]";
var $96fd7d785cdb864e$var$http = "http://";
var $96fd7d785cdb864e$var$https = "https://";
var $96fd7d785cdb864e$var$mailto = "mailto:";
var $96fd7d785cdb864e$var$protocols = [
    $96fd7d785cdb864e$var$http,
    $96fd7d785cdb864e$var$https,
    $96fd7d785cdb864e$var$mailto
];
var $96fd7d785cdb864e$var$protocolsLength = $96fd7d785cdb864e$var$protocols.length;
function $96fd7d785cdb864e$var$url(eat, value, silent) {
    var self = this;
    var subvalue;
    var content;
    var character;
    var index;
    var position;
    var protocol;
    var match;
    var length;
    var queue;
    var parenCount;
    var nextCharacter;
    var tokenizers;
    var exit;
    if (!self.options.gfm) return;
    subvalue = "";
    index = -1;
    while(++index < $96fd7d785cdb864e$var$protocolsLength){
        protocol = $96fd7d785cdb864e$var$protocols[index];
        match = value.slice(0, protocol.length);
        if (match.toLowerCase() === protocol) {
            subvalue = match;
            break;
        }
    }
    if (!subvalue) return;
    index = subvalue.length;
    length = value.length;
    queue = "";
    parenCount = 0;
    while(index < length){
        character = value.charAt(index);
        if ($kZNgz(character) || character === $96fd7d785cdb864e$var$lessThan) break;
        if (character === $96fd7d785cdb864e$var$dot || character === $96fd7d785cdb864e$var$comma || character === $96fd7d785cdb864e$var$colon || character === $96fd7d785cdb864e$var$semicolon || character === $96fd7d785cdb864e$var$quotationMark || character === $96fd7d785cdb864e$var$apostrophe || character === $96fd7d785cdb864e$var$rightParenthesis || character === $96fd7d785cdb864e$var$rightSquareBracket) {
            nextCharacter = value.charAt(index + 1);
            if (!nextCharacter || $kZNgz(nextCharacter)) break;
        }
        if (character === $96fd7d785cdb864e$var$leftParenthesis || character === $96fd7d785cdb864e$var$leftSquareBracket) parenCount++;
        if (character === $96fd7d785cdb864e$var$rightParenthesis || character === $96fd7d785cdb864e$var$rightSquareBracket) {
            parenCount--;
            if (parenCount < 0) break;
        }
        queue += character;
        index++;
    }
    if (!queue) return;
    subvalue += queue;
    content = subvalue;
    if (protocol === $96fd7d785cdb864e$var$mailto) {
        position = queue.indexOf($96fd7d785cdb864e$var$atSign);
        if (position === -1 || position === length - 1) return;
        content = content.slice($96fd7d785cdb864e$var$mailto.length);
    }
    /* istanbul ignore if - never used (yet) */ if (silent) return true;
    exit = self.enterLink();
    // Temporarily remove all tokenizers except text in url.
    tokenizers = self.inlineTokenizers;
    self.inlineTokenizers = {
        text: tokenizers.text
    };
    content = self.tokenizeInline(content, eat.now());
    self.inlineTokenizers = tokenizers;
    exit();
    return eat(subvalue)({
        type: "link",
        title: null,
        url: $eUIxU(subvalue, {
            nonTerminated: false
        }),
        children: content
    });
}

});
parcelRegister("5PG7O", function(module, exports) {
"use strict";
module.exports = $43f26451b4436772$var$locate;
var $43f26451b4436772$var$protocols = [
    "https://",
    "http://",
    "mailto:"
];
function $43f26451b4436772$var$locate(value, fromIndex) {
    var length = $43f26451b4436772$var$protocols.length;
    var index = -1;
    var min = -1;
    var position;
    if (!this.options.gfm) return -1;
    while(++index < length){
        position = value.indexOf($43f26451b4436772$var$protocols[index], fromIndex);
        if (position !== -1 && (position < min || min === -1)) min = position;
    }
    return min;
}

});


parcelRegister("76c2Q", function(module, exports) {
"use strict";

var $aDCQv = parcelRequire("aDCQv");

var $2utui = parcelRequire("2utui");

var $irnv4 = parcelRequire("irnv4");
var $52b26fd260680e73$require$tag = $irnv4.tag;
module.exports = $52b26fd260680e73$var$inlineHTML;
$52b26fd260680e73$var$inlineHTML.locator = $2utui;
var $52b26fd260680e73$var$lessThan = "<";
var $52b26fd260680e73$var$questionMark = "?";
var $52b26fd260680e73$var$exclamationMark = "!";
var $52b26fd260680e73$var$slash = "/";
var $52b26fd260680e73$var$htmlLinkOpenExpression = /^<a /i;
var $52b26fd260680e73$var$htmlLinkCloseExpression = /^<\/a>/i;
function $52b26fd260680e73$var$inlineHTML(eat, value, silent) {
    var self = this;
    var length = value.length;
    var character;
    var subvalue;
    if (value.charAt(0) !== $52b26fd260680e73$var$lessThan || length < 3) return;
    character = value.charAt(1);
    if (!$aDCQv(character) && character !== $52b26fd260680e73$var$questionMark && character !== $52b26fd260680e73$var$exclamationMark && character !== $52b26fd260680e73$var$slash) return;
    subvalue = value.match($52b26fd260680e73$require$tag);
    if (!subvalue) return;
    /* istanbul ignore if - not used yet. */ if (silent) return true;
    subvalue = subvalue[0];
    if (!self.inLink && $52b26fd260680e73$var$htmlLinkOpenExpression.test(subvalue)) self.inLink = true;
    else if (self.inLink && $52b26fd260680e73$var$htmlLinkCloseExpression.test(subvalue)) self.inLink = false;
    return eat(subvalue)({
        type: "html",
        value: subvalue
    });
}

});

parcelRegister("4bxc4", function(module, exports) {
"use strict";

var $kZNgz = parcelRequire("kZNgz");

var $79FXg = parcelRequire("79FXg");
module.exports = $30c1f0114b4bfd47$var$link;
$30c1f0114b4bfd47$var$link.locator = $79FXg;
var $30c1f0114b4bfd47$var$lineFeed = "\n";
var $30c1f0114b4bfd47$var$exclamationMark = "!";
var $30c1f0114b4bfd47$var$quotationMark = '"';
var $30c1f0114b4bfd47$var$apostrophe = "'";
var $30c1f0114b4bfd47$var$leftParenthesis = "(";
var $30c1f0114b4bfd47$var$rightParenthesis = ")";
var $30c1f0114b4bfd47$var$lessThan = "<";
var $30c1f0114b4bfd47$var$greaterThan = ">";
var $30c1f0114b4bfd47$var$leftSquareBracket = "[";
var $30c1f0114b4bfd47$var$backslash = "\\";
var $30c1f0114b4bfd47$var$rightSquareBracket = "]";
var $30c1f0114b4bfd47$var$graveAccent = "`";
function $30c1f0114b4bfd47$var$link(eat, value, silent) {
    var self = this;
    var subvalue = "";
    var index = 0;
    var character = value.charAt(0);
    var pedantic = self.options.pedantic;
    var commonmark = self.options.commonmark;
    var gfm = self.options.gfm;
    var closed;
    var count;
    var opening;
    var beforeURL;
    var beforeTitle;
    var subqueue;
    var hasMarker;
    var isImage;
    var content;
    var marker;
    var length;
    var title;
    var depth;
    var queue;
    var url;
    var now;
    var exit;
    var node;
    // Detect whether this is an image.
    if (character === $30c1f0114b4bfd47$var$exclamationMark) {
        isImage = true;
        subvalue = character;
        character = value.charAt(++index);
    }
    // Eat the opening.
    if (character !== $30c1f0114b4bfd47$var$leftSquareBracket) return;
    // Exit when this is a link and we’re already inside a link.
    if (!isImage && self.inLink) return;
    subvalue += character;
    queue = "";
    index++;
    // Eat the content.
    length = value.length;
    now = eat.now();
    depth = 0;
    now.column += index;
    now.offset += index;
    while(index < length){
        character = value.charAt(index);
        subqueue = character;
        if (character === $30c1f0114b4bfd47$var$graveAccent) {
            // Inline-code in link content.
            count = 1;
            while(value.charAt(index + 1) === $30c1f0114b4bfd47$var$graveAccent){
                subqueue += character;
                index++;
                count++;
            }
            if (!opening) opening = count;
            else if (count >= opening) opening = 0;
        } else if (character === $30c1f0114b4bfd47$var$backslash) {
            // Allow brackets to be escaped.
            index++;
            subqueue += value.charAt(index);
        } else if ((!opening || gfm) && character === $30c1f0114b4bfd47$var$leftSquareBracket) // In GFM mode, brackets in code still count.  In all other modes,
        // they don’t.
        depth++;
        else if ((!opening || gfm) && character === $30c1f0114b4bfd47$var$rightSquareBracket) {
            if (depth) depth--;
            else {
                // Allow white-space between content and url in GFM mode.
                if (!pedantic) while(index < length){
                    character = value.charAt(index + 1);
                    if (!$kZNgz(character)) break;
                    subqueue += character;
                    index++;
                }
                if (value.charAt(index + 1) !== $30c1f0114b4bfd47$var$leftParenthesis) return;
                subqueue += $30c1f0114b4bfd47$var$leftParenthesis;
                closed = true;
                index++;
                break;
            }
        }
        queue += subqueue;
        subqueue = "";
        index++;
    }
    // Eat the content closing.
    if (!closed) return;
    content = queue;
    subvalue += queue + subqueue;
    index++;
    // Eat white-space.
    while(index < length){
        character = value.charAt(index);
        if (!$kZNgz(character)) break;
        subvalue += character;
        index++;
    }
    // Eat the URL.
    character = value.charAt(index);
    queue = "";
    beforeURL = subvalue;
    if (character === $30c1f0114b4bfd47$var$lessThan) {
        index++;
        beforeURL += $30c1f0114b4bfd47$var$lessThan;
        while(index < length){
            character = value.charAt(index);
            if (character === $30c1f0114b4bfd47$var$greaterThan) break;
            if (commonmark && character === $30c1f0114b4bfd47$var$lineFeed) return;
            queue += character;
            index++;
        }
        if (value.charAt(index) !== $30c1f0114b4bfd47$var$greaterThan) return;
        subvalue += $30c1f0114b4bfd47$var$lessThan + queue + $30c1f0114b4bfd47$var$greaterThan;
        url = queue;
        index++;
    } else {
        character = null;
        subqueue = "";
        while(index < length){
            character = value.charAt(index);
            if (subqueue && (character === $30c1f0114b4bfd47$var$quotationMark || character === $30c1f0114b4bfd47$var$apostrophe || commonmark && character === $30c1f0114b4bfd47$var$leftParenthesis)) break;
            if ($kZNgz(character)) {
                if (!pedantic) break;
                subqueue += character;
            } else {
                if (character === $30c1f0114b4bfd47$var$leftParenthesis) depth++;
                else if (character === $30c1f0114b4bfd47$var$rightParenthesis) {
                    if (depth === 0) break;
                    depth--;
                }
                queue += subqueue;
                subqueue = "";
                if (character === $30c1f0114b4bfd47$var$backslash) {
                    queue += $30c1f0114b4bfd47$var$backslash;
                    character = value.charAt(++index);
                }
                queue += character;
            }
            index++;
        }
        subvalue += queue;
        url = queue;
        index = subvalue.length;
    }
    // Eat white-space.
    queue = "";
    while(index < length){
        character = value.charAt(index);
        if (!$kZNgz(character)) break;
        queue += character;
        index++;
    }
    character = value.charAt(index);
    subvalue += queue;
    // Eat the title.
    if (queue && (character === $30c1f0114b4bfd47$var$quotationMark || character === $30c1f0114b4bfd47$var$apostrophe || commonmark && character === $30c1f0114b4bfd47$var$leftParenthesis)) {
        index++;
        subvalue += character;
        queue = "";
        marker = character === $30c1f0114b4bfd47$var$leftParenthesis ? $30c1f0114b4bfd47$var$rightParenthesis : character;
        beforeTitle = subvalue;
        // In commonmark-mode, things are pretty easy: the marker cannot occur
        // inside the title.  Non-commonmark does, however, support nested
        // delimiters.
        if (commonmark) {
            while(index < length){
                character = value.charAt(index);
                if (character === marker) break;
                if (character === $30c1f0114b4bfd47$var$backslash) {
                    queue += $30c1f0114b4bfd47$var$backslash;
                    character = value.charAt(++index);
                }
                index++;
                queue += character;
            }
            character = value.charAt(index);
            if (character !== marker) return;
            title = queue;
            subvalue += queue + character;
            index++;
            while(index < length){
                character = value.charAt(index);
                if (!$kZNgz(character)) break;
                subvalue += character;
                index++;
            }
        } else {
            subqueue = "";
            while(index < length){
                character = value.charAt(index);
                if (character === marker) {
                    if (hasMarker) {
                        queue += marker + subqueue;
                        subqueue = "";
                    }
                    hasMarker = true;
                } else if (!hasMarker) queue += character;
                else if (character === $30c1f0114b4bfd47$var$rightParenthesis) {
                    subvalue += queue + marker + subqueue;
                    title = queue;
                    break;
                } else if ($kZNgz(character)) subqueue += character;
                else {
                    queue += marker + subqueue + character;
                    subqueue = "";
                    hasMarker = false;
                }
                index++;
            }
        }
    }
    if (value.charAt(index) !== $30c1f0114b4bfd47$var$rightParenthesis) return;
    /* istanbul ignore if - never used (yet) */ if (silent) return true;
    subvalue += $30c1f0114b4bfd47$var$rightParenthesis;
    url = self.decode.raw(self.unescape(url), eat(beforeURL).test().end, {
        nonTerminated: false
    });
    if (title) {
        beforeTitle = eat(beforeTitle).test().end;
        title = self.decode.raw(self.unescape(title), beforeTitle);
    }
    node = {
        type: isImage ? "image" : "link",
        title: title || null,
        url: url
    };
    if (isImage) node.alt = self.decode.raw(self.unescape(content), now) || null;
    else {
        exit = self.enterLink();
        node.children = self.tokenizeInline(content, now);
        exit();
    }
    return eat(subvalue)(node);
}

});
parcelRegister("79FXg", function(module, exports) {
"use strict";
module.exports = $5359eb03c713b709$var$locate;
function $5359eb03c713b709$var$locate(value, fromIndex) {
    var link = value.indexOf("[", fromIndex);
    var image = value.indexOf("![", fromIndex);
    if (image === -1) return link;
    // Link can never be `-1` if an image is found, so we don’t need to check
    // for that :)
    return link < image ? link : image;
}

});


parcelRegister("7Wiug", function(module, exports) {
"use strict";

var $kZNgz = parcelRequire("kZNgz");

var $79FXg = parcelRequire("79FXg");

var $jmqbX = parcelRequire("jmqbX");
module.exports = $5c7c4a516443d04f$var$reference;
$5c7c4a516443d04f$var$reference.locator = $79FXg;
var $5c7c4a516443d04f$var$link = "link";
var $5c7c4a516443d04f$var$image = "image";
var $5c7c4a516443d04f$var$footnote = "footnote";
var $5c7c4a516443d04f$var$shortcut = "shortcut";
var $5c7c4a516443d04f$var$collapsed = "collapsed";
var $5c7c4a516443d04f$var$full = "full";
var $5c7c4a516443d04f$var$space = " ";
var $5c7c4a516443d04f$var$exclamationMark = "!";
var $5c7c4a516443d04f$var$leftSquareBracket = "[";
var $5c7c4a516443d04f$var$backslash = "\\";
var $5c7c4a516443d04f$var$rightSquareBracket = "]";
var $5c7c4a516443d04f$var$caret = "^";
function $5c7c4a516443d04f$var$reference(eat, value, silent) {
    var self = this;
    var commonmark = self.options.commonmark;
    var footnotes = self.options.footnotes;
    var character = value.charAt(0);
    var index = 0;
    var length = value.length;
    var subvalue = "";
    var intro = "";
    var type = $5c7c4a516443d04f$var$link;
    var referenceType = $5c7c4a516443d04f$var$shortcut;
    var content;
    var identifier;
    var now;
    var node;
    var exit;
    var queue;
    var bracketed;
    var depth;
    // Check whether we’re eating an image.
    if (character === $5c7c4a516443d04f$var$exclamationMark) {
        type = $5c7c4a516443d04f$var$image;
        intro = character;
        character = value.charAt(++index);
    }
    if (character !== $5c7c4a516443d04f$var$leftSquareBracket) return;
    index++;
    intro += character;
    queue = "";
    // Check whether we’re eating a footnote.
    if (footnotes && value.charAt(index) === $5c7c4a516443d04f$var$caret) {
        // Exit if `![^` is found, so the `!` will be seen as text after this,
        // and we’ll enter this function again when `[^` is found.
        if (type === $5c7c4a516443d04f$var$image) return;
        intro += $5c7c4a516443d04f$var$caret;
        index++;
        type = $5c7c4a516443d04f$var$footnote;
    }
    // Eat the text.
    depth = 0;
    while(index < length){
        character = value.charAt(index);
        if (character === $5c7c4a516443d04f$var$leftSquareBracket) {
            bracketed = true;
            depth++;
        } else if (character === $5c7c4a516443d04f$var$rightSquareBracket) {
            if (!depth) break;
            depth--;
        }
        if (character === $5c7c4a516443d04f$var$backslash) {
            queue += $5c7c4a516443d04f$var$backslash;
            character = value.charAt(++index);
        }
        queue += character;
        index++;
    }
    subvalue = queue;
    content = queue;
    character = value.charAt(index);
    if (character !== $5c7c4a516443d04f$var$rightSquareBracket) return;
    index++;
    subvalue += character;
    queue = "";
    if (!commonmark) // The original markdown syntax definition explicitly allows for whitespace
    // between the link text and link label; commonmark departs from this, in
    // part to improve support for shortcut reference links
    while(index < length){
        character = value.charAt(index);
        if (!$kZNgz(character)) break;
        queue += character;
        index++;
    }
    character = value.charAt(index);
    // Inline footnotes cannot have a label.
    // If footnotes are enabled, link labels cannot start with a caret.
    if (type !== $5c7c4a516443d04f$var$footnote && character === $5c7c4a516443d04f$var$leftSquareBracket && (!footnotes || value.charAt(index + 1) !== $5c7c4a516443d04f$var$caret)) {
        identifier = "";
        queue += character;
        index++;
        while(index < length){
            character = value.charAt(index);
            if (character === $5c7c4a516443d04f$var$leftSquareBracket || character === $5c7c4a516443d04f$var$rightSquareBracket) break;
            if (character === $5c7c4a516443d04f$var$backslash) {
                identifier += $5c7c4a516443d04f$var$backslash;
                character = value.charAt(++index);
            }
            identifier += character;
            index++;
        }
        character = value.charAt(index);
        if (character === $5c7c4a516443d04f$var$rightSquareBracket) {
            referenceType = identifier ? $5c7c4a516443d04f$var$full : $5c7c4a516443d04f$var$collapsed;
            queue += identifier + character;
            index++;
        } else identifier = "";
        subvalue += queue;
        queue = "";
    } else {
        if (!content) return;
        identifier = content;
    }
    // Brackets cannot be inside the identifier.
    if (referenceType !== $5c7c4a516443d04f$var$full && bracketed) return;
    subvalue = intro + subvalue;
    if (type === $5c7c4a516443d04f$var$link && self.inLink) return null;
    /* istanbul ignore if - never used (yet) */ if (silent) return true;
    if (type === $5c7c4a516443d04f$var$footnote && content.indexOf($5c7c4a516443d04f$var$space) !== -1) return eat(subvalue)({
        type: $5c7c4a516443d04f$var$footnote,
        children: this.tokenizeInline(content, eat.now())
    });
    now = eat.now();
    now.column += intro.length;
    now.offset += intro.length;
    identifier = referenceType === $5c7c4a516443d04f$var$full ? identifier : content;
    node = {
        type: type + "Reference",
        identifier: $jmqbX(identifier),
        label: identifier
    };
    if (type === $5c7c4a516443d04f$var$link || type === $5c7c4a516443d04f$var$image) node.referenceType = referenceType;
    if (type === $5c7c4a516443d04f$var$link) {
        exit = self.enterLink();
        node.children = self.tokenizeInline(content, now);
        exit();
    } else if (type === $5c7c4a516443d04f$var$image) node.alt = self.decode.raw(self.unescape(content), now) || null;
    return eat(subvalue)(node);
}

});

parcelRegister("fmNrr", function(module, exports) {
"use strict";

var $2Lc6r = parcelRequire("2Lc6r");

var $kZNgz = parcelRequire("kZNgz");

var $iaMhL = parcelRequire("iaMhL");
module.exports = $b2ff4328a7e106a4$var$strong;
$b2ff4328a7e106a4$var$strong.locator = $iaMhL;
var $b2ff4328a7e106a4$var$backslash = "\\";
var $b2ff4328a7e106a4$var$asterisk = "*";
var $b2ff4328a7e106a4$var$underscore = "_";
function $b2ff4328a7e106a4$var$strong(eat, value, silent) {
    var self = this;
    var index = 0;
    var character = value.charAt(index);
    var now;
    var pedantic;
    var marker;
    var queue;
    var subvalue;
    var length;
    var prev;
    if (character !== $b2ff4328a7e106a4$var$asterisk && character !== $b2ff4328a7e106a4$var$underscore || value.charAt(++index) !== character) return;
    pedantic = self.options.pedantic;
    marker = character;
    subvalue = marker + marker;
    length = value.length;
    index++;
    queue = "";
    character = "";
    if (pedantic && $kZNgz(value.charAt(index))) return;
    while(index < length){
        prev = character;
        character = value.charAt(index);
        if (character === marker && value.charAt(index + 1) === marker && (!pedantic || !$kZNgz(prev))) {
            character = value.charAt(index + 2);
            if (character !== marker) {
                if (!$2Lc6r(queue)) return;
                /* istanbul ignore if - never used (yet) */ if (silent) return true;
                now = eat.now();
                now.column += 2;
                now.offset += 2;
                return eat(subvalue + queue + subvalue)({
                    type: "strong",
                    children: self.tokenizeInline(queue, now)
                });
            }
        }
        if (!pedantic && character === $b2ff4328a7e106a4$var$backslash) {
            queue += character;
            character = value.charAt(++index);
        }
        queue += character;
        index++;
    }
}

});
parcelRegister("iaMhL", function(module, exports) {
"use strict";
module.exports = $d3ae9daaee50c876$var$locate;
function $d3ae9daaee50c876$var$locate(value, fromIndex) {
    var asterisk = value.indexOf("**", fromIndex);
    var underscore = value.indexOf("__", fromIndex);
    if (underscore === -1) return asterisk;
    if (asterisk === -1) return underscore;
    return underscore < asterisk ? underscore : asterisk;
}

});


parcelRegister("7yt0a", function(module, exports) {
"use strict";

var $2Lc6r = parcelRequire("2Lc6r");

var $keUlj = parcelRequire("keUlj");

var $kZNgz = parcelRequire("kZNgz");

var $6P8CC = parcelRequire("6P8CC");
module.exports = $5802347f338abf37$var$emphasis;
$5802347f338abf37$var$emphasis.locator = $6P8CC;
var $5802347f338abf37$var$asterisk = "*";
var $5802347f338abf37$var$underscore = "_";
var $5802347f338abf37$var$backslash = "\\";
function $5802347f338abf37$var$emphasis(eat, value, silent) {
    var self = this;
    var index = 0;
    var character = value.charAt(index);
    var now;
    var pedantic;
    var marker;
    var queue;
    var subvalue;
    var length;
    var prev;
    if (character !== $5802347f338abf37$var$asterisk && character !== $5802347f338abf37$var$underscore) return;
    pedantic = self.options.pedantic;
    subvalue = character;
    marker = character;
    length = value.length;
    index++;
    queue = "";
    character = "";
    if (pedantic && $kZNgz(value.charAt(index))) return;
    while(index < length){
        prev = character;
        character = value.charAt(index);
        if (character === marker && (!pedantic || !$kZNgz(prev))) {
            character = value.charAt(++index);
            if (character !== marker) {
                if (!$2Lc6r(queue) || prev === marker) return;
                if (!pedantic && marker === $5802347f338abf37$var$underscore && $keUlj(character)) {
                    queue += marker;
                    continue;
                }
                /* istanbul ignore if - never used (yet) */ if (silent) return true;
                now = eat.now();
                now.column++;
                now.offset++;
                return eat(subvalue + queue + marker)({
                    type: "emphasis",
                    children: self.tokenizeInline(queue, now)
                });
            }
            queue += marker;
        }
        if (!pedantic && character === $5802347f338abf37$var$backslash) {
            queue += character;
            character = value.charAt(++index);
        }
        queue += character;
        index++;
    }
}

});
parcelRegister("keUlj", function(module, exports) {
"use strict";
module.exports = $ebc0d1ed13224092$var$wordCharacter;
var $ebc0d1ed13224092$var$fromCode = String.fromCharCode;
var $ebc0d1ed13224092$var$re = /\w/;
// Check if the given character code, or the character code at the first
// character, is a word character.
function $ebc0d1ed13224092$var$wordCharacter(character) {
    return $ebc0d1ed13224092$var$re.test(typeof character === "number" ? $ebc0d1ed13224092$var$fromCode(character) : character.charAt(0));
}

});

parcelRegister("6P8CC", function(module, exports) {
"use strict";
module.exports = $4f7e31a392f18c4c$var$locate;
function $4f7e31a392f18c4c$var$locate(value, fromIndex) {
    var asterisk = value.indexOf("*", fromIndex);
    var underscore = value.indexOf("_", fromIndex);
    if (underscore === -1) return asterisk;
    if (asterisk === -1) return underscore;
    return underscore < asterisk ? underscore : asterisk;
}

});


parcelRegister("8NqmE", function(module, exports) {
"use strict";

var $kZNgz = parcelRequire("kZNgz");

var $ivEZI = parcelRequire("ivEZI");
module.exports = $667759b94575a5d7$var$strikethrough;
$667759b94575a5d7$var$strikethrough.locator = $ivEZI;
var $667759b94575a5d7$var$tilde = "~";
var $667759b94575a5d7$var$fence = "~~";
function $667759b94575a5d7$var$strikethrough(eat, value, silent) {
    var self = this;
    var character = "";
    var previous = "";
    var preceding = "";
    var subvalue = "";
    var index;
    var length;
    var now;
    if (!self.options.gfm || value.charAt(0) !== $667759b94575a5d7$var$tilde || value.charAt(1) !== $667759b94575a5d7$var$tilde || $kZNgz(value.charAt(2))) return;
    index = 1;
    length = value.length;
    now = eat.now();
    now.column += 2;
    now.offset += 2;
    while(++index < length){
        character = value.charAt(index);
        if (character === $667759b94575a5d7$var$tilde && previous === $667759b94575a5d7$var$tilde && (!preceding || !$kZNgz(preceding))) {
            /* istanbul ignore if - never used (yet) */ if (silent) return true;
            return eat($667759b94575a5d7$var$fence + subvalue + $667759b94575a5d7$var$fence)({
                type: "delete",
                children: self.tokenizeInline(subvalue, now)
            });
        }
        subvalue += previous;
        preceding = previous;
        previous = character;
    }
}

});
parcelRegister("ivEZI", function(module, exports) {
"use strict";
module.exports = $d79aebe61bd873bb$var$locate;
function $d79aebe61bd873bb$var$locate(value, fromIndex) {
    return value.indexOf("~~", fromIndex);
}

});


parcelRegister("kcJCs", function(module, exports) {
"use strict";

var $1WKa9 = parcelRequire("1WKa9");
module.exports = $eb5850b0ca110fa9$var$inlineCode;
$eb5850b0ca110fa9$var$inlineCode.locator = $1WKa9;
var $eb5850b0ca110fa9$var$lineFeed = 10 //  '\n'
;
var $eb5850b0ca110fa9$var$space = 32 // ' '
;
var $eb5850b0ca110fa9$var$graveAccent = 96 //  '`'
;
function $eb5850b0ca110fa9$var$inlineCode(eat, value, silent) {
    var length = value.length;
    var index = 0;
    var openingFenceEnd;
    var closingFenceStart;
    var closingFenceEnd;
    var code;
    var next;
    var found;
    while(index < length){
        if (value.charCodeAt(index) !== $eb5850b0ca110fa9$var$graveAccent) break;
        index++;
    }
    if (index === 0 || index === length) return;
    openingFenceEnd = index;
    next = value.charCodeAt(index);
    while(index < length){
        code = next;
        next = value.charCodeAt(index + 1);
        if (code === $eb5850b0ca110fa9$var$graveAccent) {
            if (closingFenceStart === undefined) closingFenceStart = index;
            closingFenceEnd = index + 1;
            if (next !== $eb5850b0ca110fa9$var$graveAccent && closingFenceEnd - closingFenceStart === openingFenceEnd) {
                found = true;
                break;
            }
        } else if (closingFenceStart !== undefined) {
            closingFenceStart = undefined;
            closingFenceEnd = undefined;
        }
        index++;
    }
    if (!found) return;
    /* istanbul ignore if - never used (yet) */ if (silent) return true;
    // Remove the initial and final space (or line feed), iff they exist and there
    // are non-space characters in the content.
    index = openingFenceEnd;
    length = closingFenceStart;
    code = value.charCodeAt(index);
    next = value.charCodeAt(length - 1);
    found = false;
    if (length - index > 2 && (code === $eb5850b0ca110fa9$var$space || code === $eb5850b0ca110fa9$var$lineFeed) && (next === $eb5850b0ca110fa9$var$space || next === $eb5850b0ca110fa9$var$lineFeed)) {
        index++;
        length--;
        while(index < length){
            code = value.charCodeAt(index);
            if (code !== $eb5850b0ca110fa9$var$space && code !== $eb5850b0ca110fa9$var$lineFeed) {
                found = true;
                break;
            }
            index++;
        }
        if (found === true) {
            openingFenceEnd++;
            closingFenceStart--;
        }
    }
    return eat(value.slice(0, closingFenceEnd))({
        type: "inlineCode",
        value: value.slice(openingFenceEnd, closingFenceStart)
    });
}

});
parcelRegister("1WKa9", function(module, exports) {
"use strict";
module.exports = $16af042dd6844d9d$var$locate;
function $16af042dd6844d9d$var$locate(value, fromIndex) {
    return value.indexOf("`", fromIndex);
}

});


parcelRegister("5HxXI", function(module, exports) {
"use strict";

var $jHUst = parcelRequire("jHUst");
module.exports = $426b5015cf8848a8$var$hardBreak;
$426b5015cf8848a8$var$hardBreak.locator = $jHUst;
var $426b5015cf8848a8$var$space = " ";
var $426b5015cf8848a8$var$lineFeed = "\n";
var $426b5015cf8848a8$var$minBreakLength = 2;
function $426b5015cf8848a8$var$hardBreak(eat, value, silent) {
    var length = value.length;
    var index = -1;
    var queue = "";
    var character;
    while(++index < length){
        character = value.charAt(index);
        if (character === $426b5015cf8848a8$var$lineFeed) {
            if (index < $426b5015cf8848a8$var$minBreakLength) return;
            /* istanbul ignore if - never used (yet) */ if (silent) return true;
            queue += character;
            return eat(queue)({
                type: "break"
            });
        }
        if (character !== $426b5015cf8848a8$var$space) return;
        queue += character;
    }
}

});
parcelRegister("jHUst", function(module, exports) {
"use strict";
module.exports = $e58dd3ec31e2aede$var$locate;
function $e58dd3ec31e2aede$var$locate(value, fromIndex) {
    var index = value.indexOf("\n", fromIndex);
    while(index > fromIndex){
        if (value.charAt(index - 1) !== " ") break;
        index--;
    }
    return index;
}

});


parcelRegister("6Wwq4", function(module, exports) {
"use strict";
module.exports = $50e14eb3180c3348$var$text;
function $50e14eb3180c3348$var$text(eat, value, silent) {
    var self = this;
    var methods;
    var tokenizers;
    var index;
    var length;
    var subvalue;
    var position;
    var tokenizer;
    var name;
    var min;
    var now;
    /* istanbul ignore if - never used (yet) */ if (silent) return true;
    methods = self.inlineMethods;
    length = methods.length;
    tokenizers = self.inlineTokenizers;
    index = -1;
    min = value.length;
    while(++index < length){
        name = methods[index];
        if (name === "text" || !tokenizers[name]) continue;
        tokenizer = tokenizers[name].locator;
        if (!tokenizer) eat.file.fail("Missing locator: `" + name + "`");
        position = tokenizer.call(self, value, 1);
        if (position !== -1 && position < min) min = position;
    }
    subvalue = value.slice(0, min);
    now = eat.now();
    self.decode(subvalue, now, handler);
    function handler(content, position, source) {
        eat(source || content)({
            type: "text",
            value: content
        });
    }
}

});



parcelRegister("h6gi9", function(module, exports) {
"use strict";

var $4HYGy = parcelRequire("4HYGy");

var $36bRz = parcelRequire("36bRz");

var $1oqsf = parcelRequire("1oqsf");
module.exports = $c72fa26a3391e042$var$stringify;
$c72fa26a3391e042$var$stringify.Compiler = $1oqsf;
function $c72fa26a3391e042$var$stringify(options) {
    var Local = $4HYGy($1oqsf);
    Local.prototype.options = $36bRz(Local.prototype.options, this.data("settings"), options);
    this.Compiler = Local;
}

});
parcelRegister("1oqsf", function(module, exports) {
"use strict";

var $36bRz = parcelRequire("36bRz");

var $2Na8b = parcelRequire("2Na8b");
module.exports = $103c8da766b39025$var$Compiler;
// Construct a new compiler.
function $103c8da766b39025$var$Compiler(tree, file) {
    this.inLink = false;
    this.inTable = false;
    this.tree = tree;
    this.file = file;
    this.options = $36bRz(this.options);
    this.setOptions({});
}
var $103c8da766b39025$var$proto = $103c8da766b39025$var$Compiler.prototype;
// Enter and exit helpers. */
$103c8da766b39025$var$proto.enterLink = $2Na8b("inLink", false);
$103c8da766b39025$var$proto.enterTable = $2Na8b("inTable", false);

$103c8da766b39025$var$proto.enterLinkReference = (parcelRequire("eiJud"));

// Configuration.
$103c8da766b39025$var$proto.options = (parcelRequire("4jg49"));

$103c8da766b39025$var$proto.setOptions = (parcelRequire("1qewb"));

$103c8da766b39025$var$proto.compile = (parcelRequire("hUe0Z"));

$103c8da766b39025$var$proto.visit = (parcelRequire("7lWhm"));

$103c8da766b39025$var$proto.all = (parcelRequire("kazMB"));

$103c8da766b39025$var$proto.block = (parcelRequire("lMErl"));

$103c8da766b39025$var$proto.visitOrderedItems = (parcelRequire("2oLUO"));

$103c8da766b39025$var$proto.visitUnorderedItems = (parcelRequire("gCbn3"));

























// Expose visitors.
$103c8da766b39025$var$proto.visitors = {
    root: (parcelRequire("iuJSU")),
    text: (parcelRequire("bHTi6")),
    heading: (parcelRequire("6mcjt")),
    paragraph: (parcelRequire("ktk10")),
    blockquote: (parcelRequire("hstik")),
    list: (parcelRequire("9epcP")),
    listItem: (parcelRequire("9dTPf")),
    inlineCode: (parcelRequire("6EXE0")),
    code: (parcelRequire("h8uBH")),
    html: (parcelRequire("aIhig")),
    thematicBreak: (parcelRequire("k9U2B")),
    strong: (parcelRequire("59ZkP")),
    emphasis: (parcelRequire("6BoPl")),
    break: (parcelRequire("gWhdU")),
    delete: (parcelRequire("1AvTQ")),
    link: (parcelRequire("jErZN")),
    linkReference: (parcelRequire("cAGMu")),
    imageReference: (parcelRequire("jVyJf")),
    definition: (parcelRequire("2sZJo")),
    image: (parcelRequire("2nkQi")),
    footnote: (parcelRequire("ka6AX")),
    footnoteReference: (parcelRequire("4SeIk")),
    footnoteDefinition: (parcelRequire("2qmXc")),
    table: (parcelRequire("fMO6H")),
    tableCell: (parcelRequire("hLNrB"))
};

});
parcelRegister("eiJud", function(module, exports) {
"use strict";

var $1J8rd = parcelRequire("1J8rd");
module.exports = $a69607c9b51a3c1a$var$enter;
// Shortcut and collapsed link references need no escaping and encoding during
// the processing of child nodes (it must be implied from identifier).
//
// This toggler turns encoding and escaping off for shortcut and collapsed
// references.
//
// Implies `enterLink`.
function $a69607c9b51a3c1a$var$enter(compiler, node) {
    var encode = compiler.encode;
    var escape = compiler.escape;
    var exitLink = compiler.enterLink();
    if (node.referenceType !== "shortcut" && node.referenceType !== "collapsed") return exitLink;
    compiler.escape = $1J8rd;
    compiler.encode = $1J8rd;
    return exit;
    function exit() {
        compiler.encode = encode;
        compiler.escape = escape;
        exitLink();
    }
}

});
parcelRegister("1J8rd", function(module, exports) {
"use strict";
module.exports = $14208a0176175815$var$identity;
function $14208a0176175815$var$identity(value) {
    return value;
}

});


parcelRegister("4jg49", function(module, exports) {
"use strict";
module.exports = {
    gfm: true,
    commonmark: false,
    pedantic: false,
    entities: "false",
    setext: false,
    closeAtx: false,
    looseTable: false,
    spacedTable: true,
    paddedTable: true,
    stringLength: $3235661e56601a06$var$stringLength,
    incrementListMarker: true,
    fences: false,
    fence: "`",
    bullet: "-",
    listItemIndent: "tab",
    rule: "*",
    ruleSpaces: true,
    ruleRepetition: 3,
    strong: "*",
    emphasis: "_"
};
function $3235661e56601a06$var$stringLength(value) {
    return value.length;
}

});

parcelRegister("1qewb", function(module, exports) {
"use strict";

var $36bRz = parcelRequire("36bRz");

var $cRpzI = parcelRequire("cRpzI");

var $4jg49 = parcelRequire("4jg49");

var $2broZ = parcelRequire("2broZ");

var $1J8rd = parcelRequire("1J8rd");
module.exports = $10937b28ca4da452$var$setOptions;
// Map of applicable enums.
var $10937b28ca4da452$var$maps = {
    entities: {
        true: true,
        false: true,
        numbers: true,
        escape: true
    },
    bullet: {
        "*": true,
        "-": true,
        "+": true
    },
    rule: {
        "-": true,
        _: true,
        "*": true
    },
    listItemIndent: {
        tab: true,
        mixed: true,
        1: true
    },
    emphasis: {
        _: true,
        "*": true
    },
    strong: {
        _: true,
        "*": true
    },
    fence: {
        "`": true,
        "~": true
    }
};
// Expose `validate`.
var $10937b28ca4da452$var$validate = {
    boolean: $10937b28ca4da452$var$validateBoolean,
    string: $10937b28ca4da452$var$validateString,
    number: $10937b28ca4da452$var$validateNumber,
    function: $10937b28ca4da452$var$validateFunction
};
// Set options.  Does not overwrite previously set options.
function $10937b28ca4da452$var$setOptions(options) {
    var self = this;
    var current = self.options;
    var ruleRepetition;
    var key;
    if (options == null) options = {};
    else if (typeof options === "object") options = $36bRz(options);
    else throw new Error("Invalid value `" + options + "` for setting `options`");
    for(key in $4jg49)$10937b28ca4da452$var$validate[typeof $4jg49[key]](options, key, current[key], $10937b28ca4da452$var$maps[key]);
    ruleRepetition = options.ruleRepetition;
    if (ruleRepetition && ruleRepetition < 3) $10937b28ca4da452$var$raise(ruleRepetition, "options.ruleRepetition");
    self.encode = $10937b28ca4da452$var$encodeFactory(String(options.entities));
    self.escape = $2broZ(options);
    self.options = options;
    return self;
}
// Validate a value to be boolean. Defaults to `def`.  Raises an exception with
// `context[name]` when not a boolean.
function $10937b28ca4da452$var$validateBoolean(context, name, def) {
    var value = context[name];
    if (value == null) value = def;
    if (typeof value !== "boolean") $10937b28ca4da452$var$raise(value, "options." + name);
    context[name] = value;
}
// Validate a value to be boolean. Defaults to `def`.  Raises an exception with
// `context[name]` when not a boolean.
function $10937b28ca4da452$var$validateNumber(context, name, def) {
    var value = context[name];
    if (value == null) value = def;
    if (isNaN(value)) $10937b28ca4da452$var$raise(value, "options." + name);
    context[name] = value;
}
// Validate a value to be in `map`. Defaults to `def`.  Raises an exception
// with `context[name]` when not in `map`.
function $10937b28ca4da452$var$validateString(context, name, def, map) {
    var value = context[name];
    if (value == null) value = def;
    value = String(value);
    if (!(value in map)) $10937b28ca4da452$var$raise(value, "options." + name);
    context[name] = value;
}
// Validate a value to be function. Defaults to `def`.  Raises an exception
// with `context[name]` when not a function.
function $10937b28ca4da452$var$validateFunction(context, name, def) {
    var value = context[name];
    if (value == null) value = def;
    if (typeof value !== "function") $10937b28ca4da452$var$raise(value, "options." + name);
    context[name] = value;
}
// Factory to encode HTML entities.  Creates a no-operation function when
// `type` is `'false'`, a function which encodes using named references when
// `type` is `'true'`, and a function which encodes using numbered references
// when `type` is `'numbers'`.
function $10937b28ca4da452$var$encodeFactory(type) {
    var options = {};
    if (type === "false") return $1J8rd;
    if (type === "true") options.useNamedReferences = true;
    if (type === "escape") {
        options.escapeOnly = true;
        options.useNamedReferences = true;
    }
    return wrapped;
    // Encode HTML entities using the bound options.
    function wrapped(value) {
        return $cRpzI(value, options);
    }
}
// Throw an exception with in its `message` `value` and `name`.
function $10937b28ca4da452$var$raise(value, name) {
    throw new Error("Invalid value `" + value + "` for setting `" + name + "`");
}

});
parcelRegister("cRpzI", function(module, exports) {
"use strict";

var $hZyIS = parcelRequire("hZyIS");

var $9PlhL = parcelRequire("9PlhL");

var $6lhfp = parcelRequire("6lhfp");

var $35IlD = parcelRequire("35IlD");

var $a278X = parcelRequire("a278X");

var $8A1I1 = parcelRequire("8A1I1");
module.exports = $95ce45f8ed6c82e0$var$encode;
$95ce45f8ed6c82e0$var$encode.escape = $95ce45f8ed6c82e0$var$escape;
var $95ce45f8ed6c82e0$var$own = {}.hasOwnProperty;
// List of enforced escapes.
var $95ce45f8ed6c82e0$var$escapes = [
    '"',
    "'",
    "<",
    ">",
    "&",
    "`"
];
// Map of characters to names.
var $95ce45f8ed6c82e0$var$characters = $95ce45f8ed6c82e0$var$construct();
// Default escapes.
var $95ce45f8ed6c82e0$var$defaultEscapes = $95ce45f8ed6c82e0$var$toExpression($95ce45f8ed6c82e0$var$escapes);
// Surrogate pairs.
var $95ce45f8ed6c82e0$var$surrogatePair = /[\uD800-\uDBFF][\uDC00-\uDFFF]/g;
// Non-ASCII characters.
// eslint-disable-next-line no-control-regex, unicorn/no-hex-escape
var $95ce45f8ed6c82e0$var$bmp = /[\x01-\t\x0B\f\x0E-\x1F\x7F\x81\x8D\x8F\x90\x9D\xA0-\uFFFF]/g;
// Encode special characters in `value`.
function $95ce45f8ed6c82e0$var$encode(value, options) {
    var settings = options || {};
    var subset = settings.subset;
    var set = subset ? $95ce45f8ed6c82e0$var$toExpression(subset) : $95ce45f8ed6c82e0$var$defaultEscapes;
    var escapeOnly = settings.escapeOnly;
    var omit = settings.omitOptionalSemicolons;
    value = value.replace(set, replace);
    if (subset || escapeOnly) return value;
    return value.replace($95ce45f8ed6c82e0$var$surrogatePair, replaceSurrogatePair).replace($95ce45f8ed6c82e0$var$bmp, replace);
    function replaceSurrogatePair(pair, pos, val) {
        return $95ce45f8ed6c82e0$var$toHexReference((pair.charCodeAt(0) - 0xd800) * 0x400 + pair.charCodeAt(1) - 0xdc00 + 0x10000, val.charAt(pos + 2), omit);
    }
    function replace(char, pos, val) {
        return $95ce45f8ed6c82e0$var$one(char, val.charAt(pos + 1), settings);
    }
}
// Shortcut to escape special characters in HTML.
function $95ce45f8ed6c82e0$var$escape(value) {
    return $95ce45f8ed6c82e0$var$encode(value, {
        escapeOnly: true,
        useNamedReferences: true
    });
}
// Encode `char` according to `options`.
function $95ce45f8ed6c82e0$var$one(char, next, options) {
    var shortest = options.useShortestReferences;
    var omit = options.omitOptionalSemicolons;
    var named;
    var code;
    var numeric;
    var decimal;
    if ((shortest || options.useNamedReferences) && $95ce45f8ed6c82e0$var$own.call($95ce45f8ed6c82e0$var$characters, char)) named = $95ce45f8ed6c82e0$var$toNamed($95ce45f8ed6c82e0$var$characters[char], next, omit, options.attribute);
    if (shortest || !named) {
        code = char.charCodeAt(0);
        numeric = $95ce45f8ed6c82e0$var$toHexReference(code, next, omit);
        // Use the shortest numeric reference when requested.
        // A simple algorithm would use decimal for all code points under 100, as
        // those are shorter than hexadecimal:
        //
        // * `&#99;` vs `&#x63;` (decimal shorter)
        // * `&#100;` vs `&#x64;` (equal)
        //
        // However, because we take `next` into consideration when `omit` is used,
        // And it would be possible that decimals are shorter on bigger values as
        // well if `next` is hexadecimal but not decimal, we instead compare both.
        if (shortest) {
            decimal = $95ce45f8ed6c82e0$var$toDecimalReference(code, next, omit);
            if (decimal.length < numeric.length) numeric = decimal;
        }
    }
    if (named && (!shortest || named.length < numeric.length)) return named;
    return numeric;
}
// Transform `code` into an entity.
function $95ce45f8ed6c82e0$var$toNamed(name, next, omit, attribute) {
    var value = "&" + name;
    if (omit && $95ce45f8ed6c82e0$var$own.call($9PlhL, name) && $8A1I1.indexOf(name) === -1 && (!attribute || next && next !== "=" && !$a278X(next))) return value;
    return value + ";";
}
// Transform `code` into a hexadecimal character reference.
function $95ce45f8ed6c82e0$var$toHexReference(code, next, omit) {
    var value = "&#x" + code.toString(16).toUpperCase();
    return omit && next && !$6lhfp(next) ? value : value + ";";
}
// Transform `code` into a decimal character reference.
function $95ce45f8ed6c82e0$var$toDecimalReference(code, next, omit) {
    var value = "&#" + String(code);
    return omit && next && !$35IlD(next) ? value : value + ";";
}
// Create an expression for `characters`.
function $95ce45f8ed6c82e0$var$toExpression(characters) {
    return new RegExp("[" + characters.join("") + "]", "g");
}
// Construct the map.
function $95ce45f8ed6c82e0$var$construct() {
    var chars = {};
    var name;
    for(name in $hZyIS)chars[$hZyIS[name]] = name;
    return chars;
}

});
parcelRegister("hZyIS", function(module, exports) {
module.exports = JSON.parse('{"nbsp":"\xa0","iexcl":"\xa1","cent":"\xa2","pound":"\xa3","curren":"\xa4","yen":"\xa5","brvbar":"\xa6","sect":"\xa7","uml":"\xa8","copy":"\xa9","ordf":"\xaa","laquo":"\xab","not":"\xac","shy":"\xad","reg":"\xae","macr":"\xaf","deg":"\xb0","plusmn":"\xb1","sup2":"\xb2","sup3":"\xb3","acute":"\xb4","micro":"\xb5","para":"\xb6","middot":"\xb7","cedil":"\xb8","sup1":"\xb9","ordm":"\xba","raquo":"\xbb","frac14":"\xbc","frac12":"\xbd","frac34":"\xbe","iquest":"\xbf","Agrave":"\xc0","Aacute":"\xc1","Acirc":"\xc2","Atilde":"\xc3","Auml":"\xc4","Aring":"\xc5","AElig":"\xc6","Ccedil":"\xc7","Egrave":"\xc8","Eacute":"\xc9","Ecirc":"\xca","Euml":"\xcb","Igrave":"\xcc","Iacute":"\xcd","Icirc":"\xce","Iuml":"\xcf","ETH":"\xd0","Ntilde":"\xd1","Ograve":"\xd2","Oacute":"\xd3","Ocirc":"\xd4","Otilde":"\xd5","Ouml":"\xd6","times":"\xd7","Oslash":"\xd8","Ugrave":"\xd9","Uacute":"\xda","Ucirc":"\xdb","Uuml":"\xdc","Yacute":"\xdd","THORN":"\xde","szlig":"\xdf","agrave":"\xe0","aacute":"\xe1","acirc":"\xe2","atilde":"\xe3","auml":"\xe4","aring":"\xe5","aelig":"\xe6","ccedil":"\xe7","egrave":"\xe8","eacute":"\xe9","ecirc":"\xea","euml":"\xeb","igrave":"\xec","iacute":"\xed","icirc":"\xee","iuml":"\xef","eth":"\xf0","ntilde":"\xf1","ograve":"\xf2","oacute":"\xf3","ocirc":"\xf4","otilde":"\xf5","ouml":"\xf6","divide":"\xf7","oslash":"\xf8","ugrave":"\xf9","uacute":"\xfa","ucirc":"\xfb","uuml":"\xfc","yacute":"\xfd","thorn":"\xfe","yuml":"\xff","fnof":"\u0192","Alpha":"\u0391","Beta":"\u0392","Gamma":"\u0393","Delta":"\u0394","Epsilon":"\u0395","Zeta":"\u0396","Eta":"\u0397","Theta":"\u0398","Iota":"\u0399","Kappa":"\u039A","Lambda":"\u039B","Mu":"\u039C","Nu":"\u039D","Xi":"\u039E","Omicron":"\u039F","Pi":"\u03A0","Rho":"\u03A1","Sigma":"\u03A3","Tau":"\u03A4","Upsilon":"\u03A5","Phi":"\u03A6","Chi":"\u03A7","Psi":"\u03A8","Omega":"\u03A9","alpha":"\u03B1","beta":"\u03B2","gamma":"\u03B3","delta":"\u03B4","epsilon":"\u03B5","zeta":"\u03B6","eta":"\u03B7","theta":"\u03B8","iota":"\u03B9","kappa":"\u03BA","lambda":"\u03BB","mu":"\u03BC","nu":"\u03BD","xi":"\u03BE","omicron":"\u03BF","pi":"\u03C0","rho":"\u03C1","sigmaf":"\u03C2","sigma":"\u03C3","tau":"\u03C4","upsilon":"\u03C5","phi":"\u03C6","chi":"\u03C7","psi":"\u03C8","omega":"\u03C9","thetasym":"\u03D1","upsih":"\u03D2","piv":"\u03D6","bull":"\u2022","hellip":"\u2026","prime":"\u2032","Prime":"\u2033","oline":"\u203E","frasl":"\u2044","weierp":"\u2118","image":"\u2111","real":"\u211C","trade":"\u2122","alefsym":"\u2135","larr":"\u2190","uarr":"\u2191","rarr":"\u2192","darr":"\u2193","harr":"\u2194","crarr":"\u21B5","lArr":"\u21D0","uArr":"\u21D1","rArr":"\u21D2","dArr":"\u21D3","hArr":"\u21D4","forall":"\u2200","part":"\u2202","exist":"\u2203","empty":"\u2205","nabla":"\u2207","isin":"\u2208","notin":"\u2209","ni":"\u220B","prod":"\u220F","sum":"\u2211","minus":"\u2212","lowast":"\u2217","radic":"\u221A","prop":"\u221D","infin":"\u221E","ang":"\u2220","and":"\u2227","or":"\u2228","cap":"\u2229","cup":"\u222A","int":"\u222B","there4":"\u2234","sim":"\u223C","cong":"\u2245","asymp":"\u2248","ne":"\u2260","equiv":"\u2261","le":"\u2264","ge":"\u2265","sub":"\u2282","sup":"\u2283","nsub":"\u2284","sube":"\u2286","supe":"\u2287","oplus":"\u2295","otimes":"\u2297","perp":"\u22A5","sdot":"\u22C5","lceil":"\u2308","rceil":"\u2309","lfloor":"\u230A","rfloor":"\u230B","lang":"\u2329","rang":"\u232A","loz":"\u25CA","spades":"\u2660","clubs":"\u2663","hearts":"\u2665","diams":"\u2666","quot":"\\"","amp":"&","lt":"<","gt":">","OElig":"\u0152","oelig":"\u0153","Scaron":"\u0160","scaron":"\u0161","Yuml":"\u0178","circ":"\u02C6","tilde":"\u02DC","ensp":"\u2002","emsp":"\u2003","thinsp":"\u2009","zwnj":"\u200C","zwj":"\u200D","lrm":"\u200E","rlm":"\u200F","ndash":"\u2013","mdash":"\u2014","lsquo":"\u2018","rsquo":"\u2019","sbquo":"\u201A","ldquo":"\u201C","rdquo":"\u201D","bdquo":"\u201E","dagger":"\u2020","Dagger":"\u2021","permil":"\u2030","lsaquo":"\u2039","rsaquo":"\u203A","euro":"\u20AC"}');

});

parcelRegister("8A1I1", function(module, exports) {
module.exports = JSON.parse('["cent","copy","divide","gt","lt","not","para","times"]');

});


parcelRegister("2broZ", function(module, exports) {
"use strict";

var $35IlD = parcelRequire("35IlD");

var $3ADVd = parcelRequire("3ADVd");

var $kZNgz = parcelRequire("kZNgz");

var $6lv3b = parcelRequire("6lv3b");

var $hHbQw = parcelRequire("hHbQw");
module.exports = $1971dd560461b20f$var$factory;
var $1971dd560461b20f$var$tab = "	";
var $1971dd560461b20f$var$lineFeed = "\n";
var $1971dd560461b20f$var$space = " ";
var $1971dd560461b20f$var$numberSign = "#";
var $1971dd560461b20f$var$ampersand = "&";
var $1971dd560461b20f$var$leftParenthesis = "(";
var $1971dd560461b20f$var$rightParenthesis = ")";
var $1971dd560461b20f$var$asterisk = "*";
var $1971dd560461b20f$var$plusSign = "+";
var $1971dd560461b20f$var$dash = "-";
var $1971dd560461b20f$var$dot = ".";
var $1971dd560461b20f$var$colon = ":";
var $1971dd560461b20f$var$lessThan = "<";
var $1971dd560461b20f$var$greaterThan = ">";
var $1971dd560461b20f$var$leftSquareBracket = "[";
var $1971dd560461b20f$var$backslash = "\\";
var $1971dd560461b20f$var$rightSquareBracket = "]";
var $1971dd560461b20f$var$underscore = "_";
var $1971dd560461b20f$var$graveAccent = "`";
var $1971dd560461b20f$var$verticalBar = "|";
var $1971dd560461b20f$var$tilde = "~";
var $1971dd560461b20f$var$exclamationMark = "!";
var $1971dd560461b20f$var$entities = {
    "<": "&lt;",
    ":": "&#x3A;",
    "&": "&amp;",
    "|": "&#x7C;",
    "~": "&#x7E;"
};
var $1971dd560461b20f$var$shortcut = "shortcut";
var $1971dd560461b20f$var$mailto = "mailto";
var $1971dd560461b20f$var$https = "https";
var $1971dd560461b20f$var$http = "http";
var $1971dd560461b20f$var$blankExpression = /\n\s*$/;
// Factory to escape characters.
function $1971dd560461b20f$var$factory(options) {
    return escape;
    // Escape punctuation characters in a node’s value.
    function escape(value, node, parent) {
        var self = this;
        var gfm = options.gfm;
        var commonmark = options.commonmark;
        var pedantic = options.pedantic;
        var markers = commonmark ? [
            $1971dd560461b20f$var$dot,
            $1971dd560461b20f$var$rightParenthesis
        ] : [
            $1971dd560461b20f$var$dot
        ];
        var siblings = parent && parent.children;
        var index = siblings && siblings.indexOf(node);
        var prev = siblings && siblings[index - 1];
        var next = siblings && siblings[index + 1];
        var length = value.length;
        var escapable = $6lv3b(options);
        var position = -1;
        var queue = [];
        var escaped = queue;
        var afterNewLine;
        var character;
        var wordCharBefore;
        var wordCharAfter;
        var offset;
        var replace;
        if (prev) afterNewLine = $1971dd560461b20f$var$text(prev) && $1971dd560461b20f$var$blankExpression.test(prev.value);
        else afterNewLine = !parent || parent.type === "root" || parent.type === "paragraph";
        while(++position < length){
            character = value.charAt(position);
            replace = false;
            if (character === "\n") afterNewLine = true;
            else if (character === $1971dd560461b20f$var$backslash || character === $1971dd560461b20f$var$graveAccent || character === $1971dd560461b20f$var$asterisk || character === $1971dd560461b20f$var$leftSquareBracket || character === $1971dd560461b20f$var$lessThan || character === $1971dd560461b20f$var$ampersand && $hHbQw(value.slice(position)) > 0 || character === $1971dd560461b20f$var$rightSquareBracket && self.inLink || gfm && character === $1971dd560461b20f$var$tilde && value.charAt(position + 1) === $1971dd560461b20f$var$tilde || gfm && character === $1971dd560461b20f$var$verticalBar && (self.inTable || $1971dd560461b20f$var$alignment(value, position)) || character === $1971dd560461b20f$var$underscore && // Delegate leading/trailing underscores to the multinode version below.
            position > 0 && position < length - 1 && (pedantic || !$3ADVd(value.charAt(position - 1)) || !$3ADVd(value.charAt(position + 1))) || gfm && !self.inLink && character === $1971dd560461b20f$var$colon && $1971dd560461b20f$var$protocol(queue.join(""))) replace = true;
            else if (afterNewLine) {
                if (character === $1971dd560461b20f$var$greaterThan || character === $1971dd560461b20f$var$numberSign || character === $1971dd560461b20f$var$asterisk || character === $1971dd560461b20f$var$dash || character === $1971dd560461b20f$var$plusSign) replace = true;
                else if ($35IlD(character)) {
                    offset = position + 1;
                    while(offset < length){
                        if (!$35IlD(value.charAt(offset))) break;
                        offset++;
                    }
                    if (markers.indexOf(value.charAt(offset)) !== -1) {
                        next = value.charAt(offset + 1);
                        if (!next || next === $1971dd560461b20f$var$space || next === $1971dd560461b20f$var$tab || next === $1971dd560461b20f$var$lineFeed) {
                            queue.push(value.slice(position, offset));
                            position = offset;
                            character = value.charAt(position);
                            replace = true;
                        }
                    }
                }
            }
            if (afterNewLine && !$kZNgz(character)) afterNewLine = false;
            queue.push(replace ? one(character) : character);
        }
        // Multi-node versions.
        if (siblings && $1971dd560461b20f$var$text(node)) {
            // Check for an opening parentheses after a link-reference (which can be
            // joined by white-space).
            if (prev && prev.referenceType === $1971dd560461b20f$var$shortcut) {
                position = -1;
                length = escaped.length;
                while(++position < length){
                    character = escaped[position];
                    if (character === $1971dd560461b20f$var$space || character === $1971dd560461b20f$var$tab) continue;
                    if (character === $1971dd560461b20f$var$leftParenthesis || character === $1971dd560461b20f$var$colon) escaped[position] = one(character);
                    break;
                }
                // If the current node is all spaces / tabs, preceded by a shortcut,
                // and followed by a text starting with `(`, escape it.
                if ($1971dd560461b20f$var$text(next) && position === length && next.value.charAt(0) === $1971dd560461b20f$var$leftParenthesis) escaped.push($1971dd560461b20f$var$backslash);
            }
            // Ensure non-auto-links are not seen as links.  This pattern needs to
            // check the preceding nodes too.
            if (gfm && !self.inLink && $1971dd560461b20f$var$text(prev) && value.charAt(0) === $1971dd560461b20f$var$colon && $1971dd560461b20f$var$protocol(prev.value.slice(-6))) escaped[0] = one($1971dd560461b20f$var$colon);
            // Escape ampersand if it would otherwise start an entity.
            if ($1971dd560461b20f$var$text(next) && value.charAt(length - 1) === $1971dd560461b20f$var$ampersand && $hHbQw($1971dd560461b20f$var$ampersand + next.value) !== 0) escaped[escaped.length - 1] = one($1971dd560461b20f$var$ampersand);
            // Escape exclamation marks immediately followed by links.
            if (next && next.type === "link" && value.charAt(length - 1) === $1971dd560461b20f$var$exclamationMark) escaped[escaped.length - 1] = one($1971dd560461b20f$var$exclamationMark);
            // Escape double tildes in GFM.
            if (gfm && $1971dd560461b20f$var$text(next) && value.charAt(length - 1) === $1971dd560461b20f$var$tilde && next.value.charAt(0) === $1971dd560461b20f$var$tilde) escaped.splice(escaped.length - 1, 0, $1971dd560461b20f$var$backslash);
            // Escape underscores, but not mid-word (unless in pedantic mode).
            wordCharBefore = $1971dd560461b20f$var$text(prev) && $3ADVd(prev.value.slice(-1));
            wordCharAfter = $1971dd560461b20f$var$text(next) && $3ADVd(next.value.charAt(0));
            if (length === 1) {
                if (value === $1971dd560461b20f$var$underscore && (pedantic || !wordCharBefore || !wordCharAfter)) escaped.unshift($1971dd560461b20f$var$backslash);
            } else {
                if (value.charAt(0) === $1971dd560461b20f$var$underscore && (pedantic || !wordCharBefore || !$3ADVd(value.charAt(1)))) escaped.unshift($1971dd560461b20f$var$backslash);
                if (value.charAt(length - 1) === $1971dd560461b20f$var$underscore && (pedantic || !wordCharAfter || !$3ADVd(value.charAt(length - 2)))) escaped.splice(escaped.length - 1, 0, $1971dd560461b20f$var$backslash);
            }
        }
        return escaped.join("");
        function one(character) {
            return escapable.indexOf(character) === -1 ? $1971dd560461b20f$var$entities[character] : $1971dd560461b20f$var$backslash + character;
        }
    }
}
// Check if `index` in `value` is inside an alignment row.
function $1971dd560461b20f$var$alignment(value, index) {
    var start = value.lastIndexOf($1971dd560461b20f$var$lineFeed, index);
    var end = value.indexOf($1971dd560461b20f$var$lineFeed, index);
    var char;
    end = end === -1 ? value.length : end;
    while(++start < end){
        char = value.charAt(start);
        if (char !== $1971dd560461b20f$var$colon && char !== $1971dd560461b20f$var$dash && char !== $1971dd560461b20f$var$space && char !== $1971dd560461b20f$var$verticalBar) return false;
    }
    return true;
}
// Check if `node` is a text node.
function $1971dd560461b20f$var$text(node) {
    return node && node.type === "text";
}
// Check if `value` ends in a protocol.
function $1971dd560461b20f$var$protocol(value) {
    var val = value.slice(-6).toLowerCase();
    return val === $1971dd560461b20f$var$mailto || val.slice(-5) === $1971dd560461b20f$var$https || val.slice(-4) === $1971dd560461b20f$var$http;
}

});
parcelRegister("3ADVd", function(module, exports) {
"use strict";
module.exports = function(str) {
    if (typeof str !== "string") throw new TypeError("Expected a string");
    return !/[^0-9a-z\xDF-\xFF]/.test(str.toLowerCase());
};

});

parcelRegister("hHbQw", function(module, exports) {
"use strict";

var $eUIxU = parcelRequire("eUIxU");
module.exports = $ce1fa43116c2eefa$var$length;
var $ce1fa43116c2eefa$var$ampersand = "&";
// Returns the length of HTML entity that is a prefix of the given string
// (excluding the ampersand), 0 if it does not start with an entity.
function $ce1fa43116c2eefa$var$length(value) {
    var prefix;
    /* istanbul ignore if - Currently also tested for at implemention, but we
   * keep it here because that’s proper. */ if (value.charAt(0) !== $ce1fa43116c2eefa$var$ampersand) return 0;
    prefix = value.split($ce1fa43116c2eefa$var$ampersand, 2).join($ce1fa43116c2eefa$var$ampersand);
    return prefix.length - $eUIxU(prefix).length;
}

});



parcelRegister("hUe0Z", function(module, exports) {
"use strict";

var $2m6yc = parcelRequire("2m6yc");
module.exports = $d09289b1ba255a6d$var$compile;
// Stringify the given tree.
function $d09289b1ba255a6d$var$compile() {
    return this.visit($2m6yc(this.tree, this.options.commonmark));
}

});
parcelRegister("2m6yc", function(module, exports) {
"use strict";

var $KDBsL = parcelRequire("KDBsL");
module.exports = $1b72b7a679216ff8$var$compact;
// Make an mdast tree compact by merging adjacent text nodes.
function $1b72b7a679216ff8$var$compact(tree, commonmark) {
    $KDBsL(tree, visitor);
    return tree;
    function visitor(child, index, parent) {
        var siblings = parent ? parent.children : [];
        var prev = index && siblings[index - 1];
        if (prev && child.type === prev.type && $1b72b7a679216ff8$var$mergeable(prev, commonmark) && $1b72b7a679216ff8$var$mergeable(child, commonmark)) {
            if (child.value) prev.value += child.value;
            if (child.children) prev.children = prev.children.concat(child.children);
            siblings.splice(index, 1);
            if (prev.position && child.position) prev.position.end = child.position.end;
            return index;
        }
    }
}
function $1b72b7a679216ff8$var$mergeable(node, commonmark) {
    var start;
    var end;
    if (node.type === "text") {
        if (!node.position) return true;
        start = node.position.start;
        end = node.position.end;
        // Only merge nodes which occupy the same size as their `value`.
        return start.line !== end.line || end.column - start.column === node.value.length;
    }
    return commonmark && node.type === "blockquote";
}

});


parcelRegister("7lWhm", function(module, exports) {
"use strict";
module.exports = $55a7b38d389b3e43$var$one;
function $55a7b38d389b3e43$var$one(node, parent) {
    var self = this;
    var visitors = self.visitors;
    // Fail on unknown nodes.
    if (typeof visitors[node.type] !== "function") self.file.fail(new Error("Missing compiler for node of type `" + node.type + "`: `" + node + "`"), node);
    return visitors[node.type].call(self, node, parent);
}

});

parcelRegister("kazMB", function(module, exports) {
"use strict";
module.exports = $eaf07f9409457532$var$all;
// Visit all children of `parent`.
function $eaf07f9409457532$var$all(parent) {
    var self = this;
    var children = parent.children;
    var length = children.length;
    var results = [];
    var index = -1;
    while(++index < length)results[index] = self.visit(children[index], parent);
    return results;
}

});

parcelRegister("lMErl", function(module, exports) {
"use strict";
module.exports = $fdbd73325f2576de$var$block;
var $fdbd73325f2576de$var$lineFeed = "\n";
var $fdbd73325f2576de$var$blank = $fdbd73325f2576de$var$lineFeed + $fdbd73325f2576de$var$lineFeed;
var $fdbd73325f2576de$var$triple = $fdbd73325f2576de$var$blank + $fdbd73325f2576de$var$lineFeed;
var $fdbd73325f2576de$var$comment = $fdbd73325f2576de$var$blank + "<!---->" + $fdbd73325f2576de$var$blank;
// Stringify a block node with block children (e.g., `root` or `blockquote`).
// Knows about code following a list, or adjacent lists with similar bullets,
// and places an extra line feed between them.
function $fdbd73325f2576de$var$block(node) {
    var self = this;
    var options = self.options;
    var fences = options.fences;
    var gap = options.commonmark ? $fdbd73325f2576de$var$comment : $fdbd73325f2576de$var$triple;
    var values = [];
    var children = node.children;
    var length = children.length;
    var index = -1;
    var prev;
    var child;
    while(++index < length){
        prev = child;
        child = children[index];
        if (prev) {
            // A list preceding another list that are equally ordered, or a
            // list preceding an indented code block, need a gap between them,
            // so as not to see them as one list, or content of the list,
            // respectively.
            //
            // In commonmark, only something that breaks both up can do that,
            // so we opt for an empty, invisible comment.  In other flavours,
            // two blank lines are fine.
            if (prev.type === "list" && (child.type === "list" && prev.ordered === child.ordered || child.type === "code" && !child.lang && !fences)) values.push(gap);
            else values.push($fdbd73325f2576de$var$blank);
        }
        values.push(self.visit(child, node));
    }
    return values.join("");
}

});

parcelRegister("2oLUO", function(module, exports) {
"use strict";
module.exports = $1bf2fda37ffa6cbc$var$orderedItems;
var $1bf2fda37ffa6cbc$var$lineFeed = "\n";
var $1bf2fda37ffa6cbc$var$dot = ".";
var $1bf2fda37ffa6cbc$var$blank = $1bf2fda37ffa6cbc$var$lineFeed + $1bf2fda37ffa6cbc$var$lineFeed;
// Visit ordered list items.
//
// Starts the list with
// `node.start` and increments each following list item
// bullet by one:
//
//     2. foo
//     3. bar
//
// In `incrementListMarker: false` mode, does not increment
// each marker and stays on `node.start`:
//
//     1. foo
//     1. bar
function $1bf2fda37ffa6cbc$var$orderedItems(node) {
    var self = this;
    var fn = self.visitors.listItem;
    var increment = self.options.incrementListMarker;
    var values = [];
    var start = node.start;
    var children = node.children;
    var length = children.length;
    var index = -1;
    var bullet;
    start = start == null ? 1 : start;
    while(++index < length){
        bullet = (increment ? start + index : start) + $1bf2fda37ffa6cbc$var$dot;
        values[index] = fn.call(self, children[index], node, index, bullet);
    }
    return values.join(node.spread ? $1bf2fda37ffa6cbc$var$blank : $1bf2fda37ffa6cbc$var$lineFeed);
}

});

parcelRegister("gCbn3", function(module, exports) {
"use strict";
module.exports = $c18903f8fd9d96da$var$unorderedItems;
var $c18903f8fd9d96da$var$lineFeed = "\n";
var $c18903f8fd9d96da$var$blank = $c18903f8fd9d96da$var$lineFeed + $c18903f8fd9d96da$var$lineFeed;
// Visit unordered list items.  Uses `options.bullet` as each item’s bullet.
function $c18903f8fd9d96da$var$unorderedItems(node) {
    var self = this;
    var bullet = self.options.bullet;
    var fn = self.visitors.listItem;
    var children = node.children;
    var length = children.length;
    var index = -1;
    var values = [];
    while(++index < length)values[index] = fn.call(self, children[index], node, index, bullet);
    return values.join(node.spread ? $c18903f8fd9d96da$var$blank : $c18903f8fd9d96da$var$lineFeed);
}

});

parcelRegister("iuJSU", function(module, exports) {
"use strict";
module.exports = $d76e9f0e1880392d$var$root;
var $d76e9f0e1880392d$var$lineFeed = "\n";
// Stringify a root.
// Adds a final newline to ensure valid POSIX files. */
function $d76e9f0e1880392d$var$root(node) {
    var doc = this.block(node);
    if (doc.charAt(doc.length - 1) !== $d76e9f0e1880392d$var$lineFeed) doc += $d76e9f0e1880392d$var$lineFeed;
    return doc;
}

});

parcelRegister("bHTi6", function(module, exports) {
"use strict";
module.exports = $885e997bf5f33a48$var$text;
// Stringify text.
// Supports named entities in `settings.encode: true` mode:
//
// ```markdown
// AT&amp;T
// ```
//
// Supports numbered entities in `settings.encode: numbers` mode:
//
// ```markdown
// AT&#x26;T
// ```
function $885e997bf5f33a48$var$text(node, parent) {
    return this.encode(this.escape(node.value, node, parent), node);
}

});

parcelRegister("6mcjt", function(module, exports) {
"use strict";

var $j6axH = parcelRequire("j6axH");
module.exports = $4a0e593fd7bfb44f$var$heading;
var $4a0e593fd7bfb44f$var$lineFeed = "\n";
var $4a0e593fd7bfb44f$var$space = " ";
var $4a0e593fd7bfb44f$var$numberSign = "#";
var $4a0e593fd7bfb44f$var$dash = "-";
var $4a0e593fd7bfb44f$var$equalsTo = "=";
// Stringify a heading.
//
// In `setext: true` mode and when `depth` is smaller than three, creates a
// setext header:
//
// ```markdown
// Foo
// ===
// ```
//
// Otherwise, an ATX header is generated:
//
// ```markdown
// ### Foo
// ```
//
// In `closeAtx: true` mode, the header is closed with hashes:
//
// ```markdown
// ### Foo ###
// ```
function $4a0e593fd7bfb44f$var$heading(node) {
    var self = this;
    var depth = node.depth;
    var setext = self.options.setext;
    var closeAtx = self.options.closeAtx;
    var content = self.all(node).join("");
    var prefix;
    if (setext && depth < 3) return content + $4a0e593fd7bfb44f$var$lineFeed + $j6axH(depth === 1 ? $4a0e593fd7bfb44f$var$equalsTo : $4a0e593fd7bfb44f$var$dash, content.length);
    prefix = $j6axH($4a0e593fd7bfb44f$var$numberSign, node.depth);
    return prefix + $4a0e593fd7bfb44f$var$space + content + (closeAtx ? $4a0e593fd7bfb44f$var$space + prefix : "");
}

});

parcelRegister("ktk10", function(module, exports) {
"use strict";
module.exports = $ee760ab3715ceac3$var$paragraph;
function $ee760ab3715ceac3$var$paragraph(node) {
    return this.all(node).join("");
}

});

parcelRegister("hstik", function(module, exports) {
"use strict";
module.exports = $cb5bc67872618751$var$blockquote;
var $cb5bc67872618751$var$lineFeed = "\n";
var $cb5bc67872618751$var$space = " ";
var $cb5bc67872618751$var$greaterThan = ">";
function $cb5bc67872618751$var$blockquote(node) {
    var values = this.block(node).split($cb5bc67872618751$var$lineFeed);
    var result = [];
    var length = values.length;
    var index = -1;
    var value;
    while(++index < length){
        value = values[index];
        result[index] = (value ? $cb5bc67872618751$var$space : "") + value;
    }
    return $cb5bc67872618751$var$greaterThan + result.join($cb5bc67872618751$var$lineFeed + $cb5bc67872618751$var$greaterThan);
}

});

parcelRegister("9epcP", function(module, exports) {
"use strict";
module.exports = $6b88f93b11ad4cf6$var$list;
function $6b88f93b11ad4cf6$var$list(node) {
    var fn = node.ordered ? this.visitOrderedItems : this.visitUnorderedItems;
    return fn.call(this, node);
}

});

parcelRegister("9dTPf", function(module, exports) {
"use strict";

var $j6axH = parcelRequire("j6axH");

var $76VEg = parcelRequire("76VEg");
module.exports = $6b70a1c64b9e2d0b$var$listItem;
var $6b70a1c64b9e2d0b$var$lineFeed = "\n";
var $6b70a1c64b9e2d0b$var$space = " ";
var $6b70a1c64b9e2d0b$var$leftSquareBracket = "[";
var $6b70a1c64b9e2d0b$var$rightSquareBracket = "]";
var $6b70a1c64b9e2d0b$var$lowercaseX = "x";
var $6b70a1c64b9e2d0b$var$ceil = Math.ceil;
var $6b70a1c64b9e2d0b$var$blank = $6b70a1c64b9e2d0b$var$lineFeed + $6b70a1c64b9e2d0b$var$lineFeed;
var $6b70a1c64b9e2d0b$var$tabSize = 4;
// Stringify a list item.
//
// Prefixes the content with a checked checkbox when `checked: true`:
//
// ```markdown
// [x] foo
// ```
//
// Prefixes the content with an unchecked checkbox when `checked: false`:
//
// ```markdown
// [ ] foo
// ```
function $6b70a1c64b9e2d0b$var$listItem(node, parent, position, bullet) {
    var self = this;
    var style = self.options.listItemIndent;
    var marker = bullet || self.options.bullet;
    var spread = node.spread == null ? true : node.spread;
    var checked = node.checked;
    var children = node.children;
    var length = children.length;
    var values = [];
    var index = -1;
    var value;
    var indent;
    var spacing;
    while(++index < length)values[index] = self.visit(children[index], node);
    value = values.join(spread ? $6b70a1c64b9e2d0b$var$blank : $6b70a1c64b9e2d0b$var$lineFeed);
    if (typeof checked === "boolean") // Note: I’d like to be able to only add the space between the check and
    // the value, but unfortunately github does not support empty list-items
    // with a checkbox :(
    value = $6b70a1c64b9e2d0b$var$leftSquareBracket + (checked ? $6b70a1c64b9e2d0b$var$lowercaseX : $6b70a1c64b9e2d0b$var$space) + $6b70a1c64b9e2d0b$var$rightSquareBracket + $6b70a1c64b9e2d0b$var$space + value;
    if (style === "1" || style === "mixed" && value.indexOf($6b70a1c64b9e2d0b$var$lineFeed) === -1) {
        indent = marker.length + 1;
        spacing = $6b70a1c64b9e2d0b$var$space;
    } else {
        indent = $6b70a1c64b9e2d0b$var$ceil((marker.length + 1) / $6b70a1c64b9e2d0b$var$tabSize) * $6b70a1c64b9e2d0b$var$tabSize;
        spacing = $j6axH($6b70a1c64b9e2d0b$var$space, indent - marker.length);
    }
    return value ? marker + spacing + $76VEg(value, indent / $6b70a1c64b9e2d0b$var$tabSize).slice(indent) : marker;
}

});
parcelRegister("76VEg", function(module, exports) {
"use strict";

var $j6axH = parcelRequire("j6axH");
module.exports = $52d5cfb9a3a7225e$var$pad;
var $52d5cfb9a3a7225e$var$lineFeed = "\n";
var $52d5cfb9a3a7225e$var$space = " ";
var $52d5cfb9a3a7225e$var$tabSize = 4;
// Pad `value` with `level * tabSize` spaces.  Respects lines.  Ignores empty
// lines.
function $52d5cfb9a3a7225e$var$pad(value, level) {
    var values = value.split($52d5cfb9a3a7225e$var$lineFeed);
    var index = values.length;
    var padding = $j6axH($52d5cfb9a3a7225e$var$space, level * $52d5cfb9a3a7225e$var$tabSize);
    while(index--)if (values[index].length !== 0) values[index] = padding + values[index];
    return values.join($52d5cfb9a3a7225e$var$lineFeed);
}

});


parcelRegister("6EXE0", function(module, exports) {
"use strict";

var $2BG1N = parcelRequire("2BG1N");

var $j6axH = parcelRequire("j6axH");
module.exports = $4d94be9fb538b0f7$var$inlineCode;
var $4d94be9fb538b0f7$var$graveAccentChar = "`";
var $4d94be9fb538b0f7$var$lineFeed = 10 //  '\n'
;
var $4d94be9fb538b0f7$var$space = 32 // ' '
;
var $4d94be9fb538b0f7$var$graveAccent = 96 //  '`'
;
// Stringify inline code.
//
// Knows about internal ticks (`\``), and ensures one more tick is used to
// enclose the inline code:
//
// ````markdown
// ```foo ``bar`` baz```
// ````
//
// Even knows about inital and final ticks:
//
// ``markdown
// `` `foo ``
// `` foo` ``
// ```
function $4d94be9fb538b0f7$var$inlineCode(node) {
    var value = node.value;
    var ticks = $j6axH($4d94be9fb538b0f7$var$graveAccentChar, $2BG1N(value, $4d94be9fb538b0f7$var$graveAccentChar) + 1);
    var start = ticks;
    var end = ticks;
    var head = value.charCodeAt(0);
    var tail = value.charCodeAt(value.length - 1);
    var wrap = false;
    var index;
    var length;
    if (head === $4d94be9fb538b0f7$var$graveAccent || tail === $4d94be9fb538b0f7$var$graveAccent) wrap = true;
    else if (value.length > 2 && $4d94be9fb538b0f7$var$ws(head) && $4d94be9fb538b0f7$var$ws(tail)) {
        index = 1;
        length = value.length - 1;
        while(++index < length)if (!$4d94be9fb538b0f7$var$ws(value.charCodeAt(index))) {
            wrap = true;
            break;
        }
    }
    if (wrap) {
        start += " ";
        end = " " + end;
    }
    return start + value + end;
}
function $4d94be9fb538b0f7$var$ws(code) {
    return code === $4d94be9fb538b0f7$var$lineFeed || code === $4d94be9fb538b0f7$var$space;
}

});
parcelRegister("2BG1N", function(module, exports) {
"use strict";
module.exports = $1e5fa35dbdacaf71$var$longestStreak;
// Get the count of the longest repeating streak of `character` in `value`.
function $1e5fa35dbdacaf71$var$longestStreak(value, character) {
    var count = 0;
    var maximum = 0;
    var expected;
    var index;
    if (typeof character !== "string" || character.length !== 1) throw new Error("Expected character");
    value = String(value);
    index = value.indexOf(character);
    expected = index;
    while(index !== -1){
        count++;
        if (index === expected) {
            if (count > maximum) maximum = count;
        } else count = 1;
        expected = index + 1;
        index = value.indexOf(character, expected);
    }
    return maximum;
}

});


parcelRegister("h8uBH", function(module, exports) {
"use strict";

var $2BG1N = parcelRequire("2BG1N");

var $j6axH = parcelRequire("j6axH");

var $76VEg = parcelRequire("76VEg");
module.exports = $c79aecee8034dfd0$var$code;
var $c79aecee8034dfd0$var$lineFeed = "\n";
var $c79aecee8034dfd0$var$space = " ";
var $c79aecee8034dfd0$var$tilde = "~";
var $c79aecee8034dfd0$var$graveAccent = "`";
// Stringify code.
// Creates indented code when:
//
// - No language tag exists
// - Not in `fences: true` mode
// - A non-empty value exists
//
// Otherwise, GFM fenced code is created:
//
// ````markdown
// ```js
// foo();
// ```
// ````
//
// When in ``fence: `~` `` mode, uses tildes as fences:
//
// ```markdown
// ~~~js
// foo();
// ~~~
// ```
//
// Knows about internal fences:
//
// `````markdown
// ````markdown
// ```javascript
// foo();
// ```
// ````
// `````
function $c79aecee8034dfd0$var$code(node, parent) {
    var self = this;
    var value = node.value;
    var options = self.options;
    var marker = options.fence;
    var info = node.lang || "";
    var fence;
    if (info && node.meta) info += $c79aecee8034dfd0$var$space + node.meta;
    info = self.encode(self.escape(info, node));
    // Without (needed) fences.
    if (!info && !options.fences && value && value.charAt(0) !== $c79aecee8034dfd0$var$lineFeed && value.charAt(value.length - 1) !== $c79aecee8034dfd0$var$lineFeed) {
        // Throw when pedantic, in a list item which isn’t compiled using a tab.
        if (parent && parent.type === "listItem" && options.listItemIndent !== "tab" && options.pedantic) self.file.fail("Cannot indent code properly. See https://git.io/fxKR8", node.position);
        return $76VEg(value, 1);
    }
    // Backticks in the info string don’t work with backtick fenced code.
    // Backticks (and tildes) are fine in tilde fenced code.
    if (marker === $c79aecee8034dfd0$var$graveAccent && info.indexOf($c79aecee8034dfd0$var$graveAccent) !== -1) marker = $c79aecee8034dfd0$var$tilde;
    fence = $j6axH(marker, Math.max($2BG1N(value, marker) + 1, 3));
    return fence + info + $c79aecee8034dfd0$var$lineFeed + value + $c79aecee8034dfd0$var$lineFeed + fence;
}

});

parcelRegister("aIhig", function(module, exports) {
"use strict";
module.exports = $7ccb6d94089a221e$var$html;
function $7ccb6d94089a221e$var$html(node) {
    return node.value;
}

});

parcelRegister("k9U2B", function(module, exports) {
"use strict";

var $j6axH = parcelRequire("j6axH");
module.exports = $ead01e7d07399c23$var$thematic;
var $ead01e7d07399c23$var$space = " ";
// Stringify a `thematic-break`.
// The character used is configurable through `rule`: (`'_'`):
//
// ```markdown
// ___
// ```
//
// The number of repititions is defined through `ruleRepetition` (`6`):
//
// ```markdown
// ******
// ```
//
// Whether spaces delimit each character, is configured through `ruleSpaces`
// (`true`):
// ```markdown
// * * *
// ```
function $ead01e7d07399c23$var$thematic() {
    var options = this.options;
    var rule = $j6axH(options.rule, options.ruleRepetition);
    return options.ruleSpaces ? rule.split("").join($ead01e7d07399c23$var$space) : rule;
}

});

parcelRegister("59ZkP", function(module, exports) {
"use strict";

var $j6axH = parcelRequire("j6axH");
module.exports = $3c1d5ed671948a47$var$strong;
// Stringify a `strong`.
//
// The marker used is configurable by `strong`, which defaults to an asterisk
// (`'*'`) but also accepts an underscore (`'_'`):
//
// ```markdown
// __foo__
// ```
function $3c1d5ed671948a47$var$strong(node) {
    var marker = $j6axH(this.options.strong, 2);
    return marker + this.all(node).join("") + marker;
}

});

parcelRegister("6BoPl", function(module, exports) {
"use strict";
module.exports = $4ce974f1fdcaa67e$var$emphasis;
var $4ce974f1fdcaa67e$var$underscore = "_";
var $4ce974f1fdcaa67e$var$asterisk = "*";
// Stringify an `emphasis`.
//
// The marker used is configurable through `emphasis`, which defaults to an
// underscore (`'_'`) but also accepts an asterisk (`'*'`):
//
// ```markdown
// *foo*
// ```
//
// In `pedantic` mode, text which itself contains an underscore will cause the
// marker to default to an asterisk instead:
//
// ```markdown
// *foo_bar*
// ```
function $4ce974f1fdcaa67e$var$emphasis(node) {
    var marker = this.options.emphasis;
    var content = this.all(node).join("");
    // When in pedantic mode, prevent using underscore as the marker when there
    // are underscores in the content.
    if (this.options.pedantic && marker === $4ce974f1fdcaa67e$var$underscore && content.indexOf(marker) !== -1) marker = $4ce974f1fdcaa67e$var$asterisk;
    return marker + content + marker;
}

});

parcelRegister("gWhdU", function(module, exports) {
"use strict";
module.exports = $c54f6c4c454c4b38$var$lineBreak;
var $c54f6c4c454c4b38$var$backslash = "\\";
var $c54f6c4c454c4b38$var$lineFeed = "\n";
var $c54f6c4c454c4b38$var$space = " ";
var $c54f6c4c454c4b38$var$commonmark = $c54f6c4c454c4b38$var$backslash + $c54f6c4c454c4b38$var$lineFeed;
var $c54f6c4c454c4b38$var$normal = $c54f6c4c454c4b38$var$space + $c54f6c4c454c4b38$var$space + $c54f6c4c454c4b38$var$lineFeed;
function $c54f6c4c454c4b38$var$lineBreak() {
    return this.options.commonmark ? $c54f6c4c454c4b38$var$commonmark : $c54f6c4c454c4b38$var$normal;
}

});

parcelRegister("1AvTQ", function(module, exports) {
"use strict";
module.exports = $1281e5e0c3f7617f$var$strikethrough;
var $1281e5e0c3f7617f$var$tilde = "~";
var $1281e5e0c3f7617f$var$fence = $1281e5e0c3f7617f$var$tilde + $1281e5e0c3f7617f$var$tilde;
function $1281e5e0c3f7617f$var$strikethrough(node) {
    return $1281e5e0c3f7617f$var$fence + this.all(node).join("") + $1281e5e0c3f7617f$var$fence;
}

});

parcelRegister("jErZN", function(module, exports) {
"use strict";

var $1RMhw = parcelRequire("1RMhw");

var $gUBoX = parcelRequire("gUBoX");
module.exports = $e4e7781a32f5dc7b$var$link;
var $e4e7781a32f5dc7b$var$space = " ";
var $e4e7781a32f5dc7b$var$leftSquareBracket = "[";
var $e4e7781a32f5dc7b$var$rightSquareBracket = "]";
var $e4e7781a32f5dc7b$var$leftParenthesis = "(";
var $e4e7781a32f5dc7b$var$rightParenthesis = ")";
// Expression for a protocol:
// See <https://en.wikipedia.org/wiki/Uniform_Resource_Identifier#Generic_syntax>.
var $e4e7781a32f5dc7b$var$protocol = /^[a-z][a-z+.-]+:\/?/i;
// Stringify a link.
//
// When no title exists, the compiled `children` equal `url`, and `url` starts
// with a protocol, an auto link is created:
//
// ```markdown
// <http://example.com>
// ```
//
// Otherwise, is smart about enclosing `url` (see `encloseURI()`) and `title`
// (see `encloseTitle()`).
// ```
//
// ```markdown
// [foo](<foo at bar dot com> 'An "example" e-mail')
// ```
//
// Supports named entities in the `url` and `title` when in `settings.encode`
// mode.
function $e4e7781a32f5dc7b$var$link(node) {
    var self = this;
    var content = self.encode(node.url || "", node);
    var exit = self.enterLink();
    var escaped = self.encode(self.escape(node.url || "", node));
    var value = self.all(node).join("");
    exit();
    if (node.title == null && $e4e7781a32f5dc7b$var$protocol.test(content) && escaped === value) // Backslash escapes do not work in autolinks, so we do not escape.
    return $1RMhw(self.encode(node.url), true);
    content = $1RMhw(content);
    if (node.title) content += $e4e7781a32f5dc7b$var$space + $gUBoX(self.encode(self.escape(node.title, node), node));
    return $e4e7781a32f5dc7b$var$leftSquareBracket + value + $e4e7781a32f5dc7b$var$rightSquareBracket + $e4e7781a32f5dc7b$var$leftParenthesis + content + $e4e7781a32f5dc7b$var$rightParenthesis;
}

});
parcelRegister("1RMhw", function(module, exports) {
"use strict";

var $ggJb9 = parcelRequire("ggJb9");
module.exports = $15c03168be7e3636$var$enclose;
var $15c03168be7e3636$var$leftParenthesis = "(";
var $15c03168be7e3636$var$rightParenthesis = ")";
var $15c03168be7e3636$var$lessThan = "<";
var $15c03168be7e3636$var$greaterThan = ">";
var $15c03168be7e3636$var$expression = /\s/;
// Wrap `url` in angle brackets when needed, or when
// forced.
// In links, images, and definitions, the URL part needs
// to be enclosed when it:
//
// - has a length of `0`
// - contains white-space
// - has more or less opening than closing parentheses
function $15c03168be7e3636$var$enclose(uri, always) {
    if (always || uri.length === 0 || $15c03168be7e3636$var$expression.test(uri) || $ggJb9(uri, $15c03168be7e3636$var$leftParenthesis) !== $ggJb9(uri, $15c03168be7e3636$var$rightParenthesis)) return $15c03168be7e3636$var$lessThan + uri + $15c03168be7e3636$var$greaterThan;
    return uri;
}

});
parcelRegister("ggJb9", function(module, exports) {
"use strict";
module.exports = $bd812f917a96fba8$var$ccount;
function $bd812f917a96fba8$var$ccount(value, character) {
    var val = String(value);
    var count = 0;
    var index;
    if (typeof character !== "string" || character.length !== 1) throw new Error("Expected character");
    index = val.indexOf(character);
    while(index !== -1){
        count++;
        index = val.indexOf(character, index + 1);
    }
    return count;
}

});


parcelRegister("gUBoX", function(module, exports) {
"use strict";
module.exports = $c4fee37c91a6bb2d$var$enclose;
var $c4fee37c91a6bb2d$var$quotationMark = '"';
var $c4fee37c91a6bb2d$var$apostrophe = "'";
// There is currently no way to support nested delimiters across Markdown.pl,
// CommonMark, and GitHub (RedCarpet).  The following code supports Markdown.pl
// and GitHub.
// CommonMark is not supported when mixing double- and single quotes inside a
// title.
function $c4fee37c91a6bb2d$var$enclose(title) {
    var delimiter = title.indexOf($c4fee37c91a6bb2d$var$quotationMark) === -1 ? $c4fee37c91a6bb2d$var$quotationMark : $c4fee37c91a6bb2d$var$apostrophe;
    return delimiter + title + delimiter;
}

});


parcelRegister("cAGMu", function(module, exports) {
"use strict";

var $8vDWa = parcelRequire("8vDWa");

var $copSG = parcelRequire("copSG");
module.exports = $92aa0847c0f26e6b$var$linkReference;
var $92aa0847c0f26e6b$var$leftSquareBracket = "[";
var $92aa0847c0f26e6b$var$rightSquareBracket = "]";
var $92aa0847c0f26e6b$var$shortcut = "shortcut";
var $92aa0847c0f26e6b$var$collapsed = "collapsed";
function $92aa0847c0f26e6b$var$linkReference(node) {
    var self = this;
    var type = node.referenceType;
    var exit = self.enterLinkReference(self, node);
    var value = self.all(node).join("");
    exit();
    if (type === $92aa0847c0f26e6b$var$shortcut || type === $92aa0847c0f26e6b$var$collapsed) value = $8vDWa(value, node.label || node.identifier);
    return $92aa0847c0f26e6b$var$leftSquareBracket + value + $92aa0847c0f26e6b$var$rightSquareBracket + $copSG(node);
}

});
parcelRegister("8vDWa", function(module, exports) {
"use strict";

var $hHbQw = parcelRequire("hHbQw");
module.exports = $632032abf37cfa7b$var$copy;
var $632032abf37cfa7b$var$ampersand = "&";
var $632032abf37cfa7b$var$punctuationExppresion = /[-!"#$%&'()*+,./:;<=>?@[\\\]^`{|}~_]/;
// For shortcut and collapsed reference links, the contents is also an
// identifier, so we need to restore the original encoding and escaping
// that were present in the source string.
//
// This function takes the unescaped & unencoded value from shortcut’s
// child nodes and the identifier and encodes the former according to
// the latter.
function $632032abf37cfa7b$var$copy(value, identifier) {
    var length = value.length;
    var count = identifier.length;
    var result = [];
    var position = 0;
    var index = 0;
    var start;
    while(index < length){
        // Take next non-punctuation characters from `value`.
        start = index;
        while(index < length && !$632032abf37cfa7b$var$punctuationExppresion.test(value.charAt(index)))index += 1;
        result.push(value.slice(start, index));
        // Advance `position` to the next punctuation character.
        while(position < count && !$632032abf37cfa7b$var$punctuationExppresion.test(identifier.charAt(position)))position += 1;
        // Take next punctuation characters from `identifier`.
        start = position;
        while(position < count && $632032abf37cfa7b$var$punctuationExppresion.test(identifier.charAt(position))){
            if (identifier.charAt(position) === $632032abf37cfa7b$var$ampersand) position += $hHbQw(identifier.slice(position));
            position += 1;
        }
        result.push(identifier.slice(start, position));
        // Advance `index` to the next non-punctuation character.
        while(index < length && $632032abf37cfa7b$var$punctuationExppresion.test(value.charAt(index)))index += 1;
    }
    return result.join("");
}

});

parcelRegister("copSG", function(module, exports) {
"use strict";
module.exports = $905bcd5e95700a8a$var$label;
var $905bcd5e95700a8a$var$leftSquareBracket = "[";
var $905bcd5e95700a8a$var$rightSquareBracket = "]";
var $905bcd5e95700a8a$var$shortcut = "shortcut";
var $905bcd5e95700a8a$var$collapsed = "collapsed";
// Stringify a reference label.
// Because link references are easily, mistakingly, created (for example,
// `[foo]`), reference nodes have an extra property depicting how it looked in
// the original document, so stringification can cause minimal changes.
function $905bcd5e95700a8a$var$label(node) {
    var type = node.referenceType;
    if (type === $905bcd5e95700a8a$var$shortcut) return "";
    return $905bcd5e95700a8a$var$leftSquareBracket + (type === $905bcd5e95700a8a$var$collapsed ? "" : node.label || node.identifier) + $905bcd5e95700a8a$var$rightSquareBracket;
}

});


parcelRegister("jVyJf", function(module, exports) {
"use strict";

var $copSG = parcelRequire("copSG");
module.exports = $e81e479779c3b958$var$imageReference;
var $e81e479779c3b958$var$leftSquareBracket = "[";
var $e81e479779c3b958$var$rightSquareBracket = "]";
var $e81e479779c3b958$var$exclamationMark = "!";
function $e81e479779c3b958$var$imageReference(node) {
    return $e81e479779c3b958$var$exclamationMark + $e81e479779c3b958$var$leftSquareBracket + (this.encode(node.alt, node) || "") + $e81e479779c3b958$var$rightSquareBracket + $copSG(node);
}

});

parcelRegister("2sZJo", function(module, exports) {
"use strict";

var $1RMhw = parcelRequire("1RMhw");

var $gUBoX = parcelRequire("gUBoX");
module.exports = $1cbe14d533bad5a8$var$definition;
var $1cbe14d533bad5a8$var$space = " ";
var $1cbe14d533bad5a8$var$colon = ":";
var $1cbe14d533bad5a8$var$leftSquareBracket = "[";
var $1cbe14d533bad5a8$var$rightSquareBracket = "]";
// Stringify an URL definition.
//
// Is smart about enclosing `url` (see `encloseURI()`) and `title` (see
// `encloseTitle()`).
//
// ```markdown
// [foo]: <foo at bar dot com> 'An "example" e-mail'
// ```
function $1cbe14d533bad5a8$var$definition(node) {
    var content = $1RMhw(node.url);
    if (node.title) content += $1cbe14d533bad5a8$var$space + $gUBoX(node.title);
    return $1cbe14d533bad5a8$var$leftSquareBracket + (node.label || node.identifier) + $1cbe14d533bad5a8$var$rightSquareBracket + $1cbe14d533bad5a8$var$colon + $1cbe14d533bad5a8$var$space + content;
}

});

parcelRegister("2nkQi", function(module, exports) {
"use strict";

var $1RMhw = parcelRequire("1RMhw");

var $gUBoX = parcelRequire("gUBoX");
module.exports = $1bade5a2cf9acf3e$var$image;
var $1bade5a2cf9acf3e$var$space = " ";
var $1bade5a2cf9acf3e$var$leftParenthesis = "(";
var $1bade5a2cf9acf3e$var$rightParenthesis = ")";
var $1bade5a2cf9acf3e$var$leftSquareBracket = "[";
var $1bade5a2cf9acf3e$var$rightSquareBracket = "]";
var $1bade5a2cf9acf3e$var$exclamationMark = "!";
// Stringify an image.
//
// Is smart about enclosing `url` (see `encloseURI()`) and `title` (see
// `encloseTitle()`).
//
// ```markdown
// ![foo](</fav icon.png> 'My "favourite" icon')
// ```
//
// Supports named entities in `url`, `alt`, and `title` when in
// `settings.encode` mode.
function $1bade5a2cf9acf3e$var$image(node) {
    var self = this;
    var content = $1RMhw(self.encode(node.url || "", node));
    var exit = self.enterLink();
    var alt = self.encode(self.escape(node.alt || "", node));
    exit();
    if (node.title) content += $1bade5a2cf9acf3e$var$space + $gUBoX(self.encode(node.title, node));
    return $1bade5a2cf9acf3e$var$exclamationMark + $1bade5a2cf9acf3e$var$leftSquareBracket + alt + $1bade5a2cf9acf3e$var$rightSquareBracket + $1bade5a2cf9acf3e$var$leftParenthesis + content + $1bade5a2cf9acf3e$var$rightParenthesis;
}

});

parcelRegister("ka6AX", function(module, exports) {
"use strict";
module.exports = $ead9db7d8d64f80d$var$footnote;
var $ead9db7d8d64f80d$var$leftSquareBracket = "[";
var $ead9db7d8d64f80d$var$rightSquareBracket = "]";
var $ead9db7d8d64f80d$var$caret = "^";
function $ead9db7d8d64f80d$var$footnote(node) {
    return $ead9db7d8d64f80d$var$leftSquareBracket + $ead9db7d8d64f80d$var$caret + this.all(node).join("") + $ead9db7d8d64f80d$var$rightSquareBracket;
}

});

parcelRegister("4SeIk", function(module, exports) {
"use strict";
module.exports = $38c79e7955686b20$var$footnoteReference;
var $38c79e7955686b20$var$leftSquareBracket = "[";
var $38c79e7955686b20$var$rightSquareBracket = "]";
var $38c79e7955686b20$var$caret = "^";
function $38c79e7955686b20$var$footnoteReference(node) {
    return $38c79e7955686b20$var$leftSquareBracket + $38c79e7955686b20$var$caret + (node.label || node.identifier) + $38c79e7955686b20$var$rightSquareBracket;
}

});

parcelRegister("2qmXc", function(module, exports) {
"use strict";

var $j6axH = parcelRequire("j6axH");
var $1c3fd0a1995aea1d$var$lineFeed = "\n";
var $1c3fd0a1995aea1d$var$space = " ";
var $1c3fd0a1995aea1d$var$colon = ":";
var $1c3fd0a1995aea1d$var$leftSquareBracket = "[";
var $1c3fd0a1995aea1d$var$rightSquareBracket = "]";
var $1c3fd0a1995aea1d$var$caret = "^";
var $1c3fd0a1995aea1d$var$tabSize = 4;
var $1c3fd0a1995aea1d$var$blank = $1c3fd0a1995aea1d$var$lineFeed + $1c3fd0a1995aea1d$var$lineFeed;
var $1c3fd0a1995aea1d$var$indent = $j6axH($1c3fd0a1995aea1d$var$space, $1c3fd0a1995aea1d$var$tabSize);
module.exports = $1c3fd0a1995aea1d$var$footnoteDefinition;
function $1c3fd0a1995aea1d$var$footnoteDefinition(node) {
    var content = this.all(node).join($1c3fd0a1995aea1d$var$blank + $1c3fd0a1995aea1d$var$indent);
    return $1c3fd0a1995aea1d$var$leftSquareBracket + $1c3fd0a1995aea1d$var$caret + (node.label || node.identifier) + $1c3fd0a1995aea1d$var$rightSquareBracket + $1c3fd0a1995aea1d$var$colon + $1c3fd0a1995aea1d$var$space + content;
}

});

parcelRegister("fMO6H", function(module, exports) {
"use strict";

var $7E0li = parcelRequire("7E0li");
module.exports = $b7e234ecd59a74b5$var$table;
var $b7e234ecd59a74b5$var$space = " ";
var $b7e234ecd59a74b5$var$verticalBar = "|";
// Stringify table.
//
// Creates a fenced table by default, but not in `looseTable: true` mode:
//
// ```markdown
//  Foo | Bar
// :-: | ---
// Baz | Qux
//
// NOTE: Be careful with `looseTable: true` mode, as a loose table inside an
// indented code block on GitHub renders as an actual table!
//
// Creates a spaced table by default, but not in `spacedTable: false`:
//
// ```markdown
// |Foo|Bar|
// |:-:|---|
// |Baz|Qux|
// ```
function $b7e234ecd59a74b5$var$table(node) {
    var self = this;
    var options = self.options;
    var loose = options.looseTable;
    var spaced = options.spacedTable;
    var pad = options.paddedTable;
    var stringLength = options.stringLength;
    var rows = node.children;
    var index = rows.length;
    var exit = self.enterTable();
    var result = [];
    var start;
    var end;
    while(index--)result[index] = self.all(rows[index]);
    exit();
    if (loose) {
        start = "";
        end = "";
    } else if (spaced) {
        start = $b7e234ecd59a74b5$var$verticalBar + $b7e234ecd59a74b5$var$space;
        end = $b7e234ecd59a74b5$var$space + $b7e234ecd59a74b5$var$verticalBar;
    } else {
        start = $b7e234ecd59a74b5$var$verticalBar;
        end = $b7e234ecd59a74b5$var$verticalBar;
    }
    return $7E0li(result, {
        align: node.align,
        pad: pad,
        start: start,
        end: end,
        stringLength: stringLength,
        delimiter: spaced ? $b7e234ecd59a74b5$var$space + $b7e234ecd59a74b5$var$verticalBar + $b7e234ecd59a74b5$var$space : $b7e234ecd59a74b5$var$verticalBar
    });
}

});
parcelRegister("7E0li", function(module, exports) {
"use strict";
module.exports = $590c88d877a7d17f$var$markdownTable;
var $590c88d877a7d17f$var$dotRe = /\./;
var $590c88d877a7d17f$var$lastDotRe = /\.[^.]*$/;
// Characters.
var $590c88d877a7d17f$var$space = " ";
var $590c88d877a7d17f$var$lineFeed = "\n";
var $590c88d877a7d17f$var$dash = "-";
var $590c88d877a7d17f$var$dot = ".";
var $590c88d877a7d17f$var$colon = ":";
var $590c88d877a7d17f$var$lowercaseC = "c";
var $590c88d877a7d17f$var$lowercaseL = "l";
var $590c88d877a7d17f$var$lowercaseR = "r";
var $590c88d877a7d17f$var$verticalBar = "|";
var $590c88d877a7d17f$var$minCellSize = 3;
// Create a table from a matrix of strings.
function $590c88d877a7d17f$var$markdownTable(table, options) {
    var settings = options || {};
    var delimiter = settings.delimiter;
    var start = settings.start;
    var end = settings.end;
    var alignment = settings.align;
    var calculateStringLength = settings.stringLength || $590c88d877a7d17f$var$lengthNoop;
    var cellCount = 0;
    var rowIndex = -1;
    var rowLength = table.length;
    var sizes = [];
    var align;
    var rule;
    var rows;
    var row;
    var cells;
    var index;
    var position;
    var size;
    var value;
    var spacing;
    var before;
    var after;
    alignment = alignment ? alignment.concat() : [];
    if (delimiter === null || delimiter === undefined) delimiter = $590c88d877a7d17f$var$space + $590c88d877a7d17f$var$verticalBar + $590c88d877a7d17f$var$space;
    if (start === null || start === undefined) start = $590c88d877a7d17f$var$verticalBar + $590c88d877a7d17f$var$space;
    if (end === null || end === undefined) end = $590c88d877a7d17f$var$space + $590c88d877a7d17f$var$verticalBar;
    while(++rowIndex < rowLength){
        row = table[rowIndex];
        index = -1;
        if (row.length > cellCount) cellCount = row.length;
        while(++index < cellCount){
            position = row[index] ? $590c88d877a7d17f$var$dotindex(row[index]) : null;
            if (!sizes[index]) sizes[index] = $590c88d877a7d17f$var$minCellSize;
            if (position > sizes[index]) sizes[index] = position;
        }
    }
    if (typeof alignment === "string") alignment = $590c88d877a7d17f$var$pad(cellCount, alignment).split("");
    // Make sure only valid alignments are used.
    index = -1;
    while(++index < cellCount){
        align = alignment[index];
        if (typeof align === "string") align = align.charAt(0).toLowerCase();
        if (align !== $590c88d877a7d17f$var$lowercaseL && align !== $590c88d877a7d17f$var$lowercaseR && align !== $590c88d877a7d17f$var$lowercaseC && align !== $590c88d877a7d17f$var$dot) align = "";
        alignment[index] = align;
    }
    rowIndex = -1;
    rows = [];
    while(++rowIndex < rowLength){
        row = table[rowIndex];
        index = -1;
        cells = [];
        while(++index < cellCount){
            value = row[index];
            value = $590c88d877a7d17f$var$stringify(value);
            if (alignment[index] === $590c88d877a7d17f$var$dot) {
                position = $590c88d877a7d17f$var$dotindex(value);
                size = sizes[index] + ($590c88d877a7d17f$var$dotRe.test(value) ? 0 : 1) - (calculateStringLength(value) - position);
                cells[index] = value + $590c88d877a7d17f$var$pad(size - 1);
            } else cells[index] = value;
        }
        rows[rowIndex] = cells;
    }
    sizes = [];
    rowIndex = -1;
    while(++rowIndex < rowLength){
        cells = rows[rowIndex];
        index = -1;
        while(++index < cellCount){
            value = cells[index];
            if (!sizes[index]) sizes[index] = $590c88d877a7d17f$var$minCellSize;
            size = calculateStringLength(value);
            if (size > sizes[index]) sizes[index] = size;
        }
    }
    rowIndex = -1;
    while(++rowIndex < rowLength){
        cells = rows[rowIndex];
        index = -1;
        if (settings.pad !== false) while(++index < cellCount){
            value = cells[index];
            position = sizes[index] - (calculateStringLength(value) || 0);
            spacing = $590c88d877a7d17f$var$pad(position);
            if (alignment[index] === $590c88d877a7d17f$var$lowercaseR || alignment[index] === $590c88d877a7d17f$var$dot) value = spacing + value;
            else if (alignment[index] === $590c88d877a7d17f$var$lowercaseC) {
                position /= 2;
                if (position % 1 === 0) {
                    before = position;
                    after = position;
                } else {
                    before = position + 0.5;
                    after = position - 0.5;
                }
                value = $590c88d877a7d17f$var$pad(before) + value + $590c88d877a7d17f$var$pad(after);
            } else value += spacing;
            cells[index] = value;
        }
        rows[rowIndex] = cells.join(delimiter);
    }
    if (settings.rule !== false) {
        index = -1;
        rule = [];
        while(++index < cellCount){
            // When `pad` is false, make the rule the same size as the first row.
            if (settings.pad === false) {
                value = table[0][index];
                spacing = calculateStringLength($590c88d877a7d17f$var$stringify(value));
                spacing = spacing > $590c88d877a7d17f$var$minCellSize ? spacing : $590c88d877a7d17f$var$minCellSize;
            } else spacing = sizes[index];
            align = alignment[index];
            // When `align` is left, don't add colons.
            value = align === $590c88d877a7d17f$var$lowercaseR || align === "" ? $590c88d877a7d17f$var$dash : $590c88d877a7d17f$var$colon;
            value += $590c88d877a7d17f$var$pad(spacing - 2, $590c88d877a7d17f$var$dash);
            value += align !== $590c88d877a7d17f$var$lowercaseL && align !== "" ? $590c88d877a7d17f$var$colon : $590c88d877a7d17f$var$dash;
            rule[index] = value;
        }
        rows.splice(1, 0, rule.join(delimiter));
    }
    return start + rows.join(end + $590c88d877a7d17f$var$lineFeed + start) + end;
}
function $590c88d877a7d17f$var$stringify(value) {
    return value === null || value === undefined ? "" : String(value);
}
// Get the length of `value`.
function $590c88d877a7d17f$var$lengthNoop(value) {
    return String(value).length;
}
// Get a string consisting of `length` `character`s.
function $590c88d877a7d17f$var$pad(length, character) {
    return new Array(length + 1).join(character || $590c88d877a7d17f$var$space);
}
// Get the position of the last dot in `value`.
function $590c88d877a7d17f$var$dotindex(value) {
    var match = $590c88d877a7d17f$var$lastDotRe.exec(value);
    return match ? match.index + 1 : value.length;
}

});


parcelRegister("hLNrB", function(module, exports) {
"use strict";
module.exports = $cefd2e0c5b7fade6$var$tableCell;
var $cefd2e0c5b7fade6$var$lineFeed = /\r?\n/g;
function $cefd2e0c5b7fade6$var$tableCell(node) {
    return this.all(node).join("").replace($cefd2e0c5b7fade6$var$lineFeed, " ");
}

});




parcelRegister("bv9EC", function(module, exports) {
"use strict";
module.exports = $85fa1417fdc98180$var$react;

var $cPqzE = parcelRequire("cPqzE");

var $6qkoA = parcelRequire("6qkoA");

var $1gsXp = parcelRequire("1gsXp");

var $6GMPt = parcelRequire("6GMPt");
var $85fa1417fdc98180$var$globalReact;
var $85fa1417fdc98180$var$globalCreateElement;
var $85fa1417fdc98180$var$globalFragment;

/* istanbul ignore next - Hard to test */ try {
    $85fa1417fdc98180$var$globalReact = (parcelRequire("cQNHH"));
    $85fa1417fdc98180$var$globalCreateElement = $85fa1417fdc98180$var$globalReact.createElement;
    $85fa1417fdc98180$var$globalFragment = $85fa1417fdc98180$var$globalReact.Fragment;
} catch (error) {}
var $85fa1417fdc98180$var$own = {}.hasOwnProperty;
var $85fa1417fdc98180$var$tableElements = [
    "table",
    "thead",
    "tbody",
    "tfoot",
    "tr"
];
function $85fa1417fdc98180$var$react(options) {
    var settings = options || {};
    var createElement = settings.createElement || $85fa1417fdc98180$var$globalCreateElement;
    var Fragment = settings.fragment || $85fa1417fdc98180$var$globalFragment;
    var clean = settings.sanitize !== false;
    var scheme = clean && typeof settings.sanitize !== "boolean" ? settings.sanitize : null;
    var toHastOptions = settings.toHast || {};
    var components = settings.remarkReactComponents || {};
    this.Compiler = compile;
    // Wrapper around `createElement` to pass components in.
    function h(name, props, children) {
        // Currently, a warning is triggered by react for *any* white space in
        // tables.
        // So we remove the pretty lines for now.
        // See: <https://github.com/facebook/react/pull/7081>.
        // See: <https://github.com/facebook/react/pull/7515>.
        // See: <https://github.com/remarkjs/remark-react/issues/64>.
        if (children && $85fa1417fdc98180$var$tableElements.indexOf(name) !== -1) children = children.filter(function(child) {
            return child !== "\n";
        });
        return createElement($85fa1417fdc98180$var$own.call(components, name) ? components[name] : name, props, children);
    }
    // Compile mdast to React.
    function compile(node) {
        var tree = $cPqzE(node, toHastOptions);
        var root;
        if (clean) tree = $6qkoA(tree, scheme);
        root = $1gsXp(h, $6GMPt(tree), settings.prefix);
        // If this compiled to a `<div>`, but fragment are possible, use those.
        if (root.type === "div" && Fragment) root = createElement(Fragment, {}, root.props.children);
        return root;
    }
}

});
parcelRegister("cPqzE", function(module, exports) {
"use strict";

module.exports = (parcelRequire("dnwOf"));

});
parcelRegister("dnwOf", function(module, exports) {
"use strict";
module.exports = $9bd6dfa2f24ac709$var$toHast;

var $36bRz = parcelRequire("36bRz");

var $iliNM = parcelRequire("iliNM");

var $KDBsL = parcelRequire("KDBsL");

var $i1zwa = parcelRequire("i1zwa");

var $2EMTP = parcelRequire("2EMTP");

var $lBwlE = parcelRequire("lBwlE");

var $3ZT5R = parcelRequire("3ZT5R");

var $57ODx = parcelRequire("57ODx");

var $8d6xV = parcelRequire("8d6xV");
var $9bd6dfa2f24ac709$var$own = {}.hasOwnProperty;
// Factory to transform.
function $9bd6dfa2f24ac709$var$factory(tree, options) {
    var settings = options || {};
    var dangerous = settings.allowDangerousHTML;
    var footnoteById = {};
    h.dangerous = dangerous;
    h.definition = $lBwlE(tree, settings);
    h.footnoteById = footnoteById;
    h.footnoteOrder = [];
    h.augment = augment;
    h.handlers = $36bRz($8d6xV, settings.handlers || {});
    $KDBsL(tree, "footnoteDefinition", onfootnotedefinition);
    return h;
    // Finalise the created `right`, a hast node, from `left`, an mdast node.
    function augment(left, right) {
        var data;
        var ctx;
        // Handle `data.hName`, `data.hProperties, `data.hChildren`.
        if (left && "data" in left) {
            data = left.data;
            if (right.type === "element" && data.hName) right.tagName = data.hName;
            if (right.type === "element" && data.hProperties) right.properties = $36bRz(right.properties, data.hProperties);
            if (right.children && data.hChildren) right.children = data.hChildren;
        }
        ctx = left && left.position ? left : {
            position: left
        };
        if (!$2EMTP(ctx)) right.position = {
            start: $i1zwa.start(ctx),
            end: $i1zwa.end(ctx)
        };
        return right;
    }
    // Create an element for `node`.
    function h(node, tagName, props, children) {
        if ((children === undefined || children === null) && typeof props === "object" && "length" in props) {
            children = props;
            props = {};
        }
        return augment(node, {
            type: "element",
            tagName: tagName,
            properties: props || {},
            children: children || []
        });
    }
    function onfootnotedefinition(definition) {
        var id = String(definition.identifier).toUpperCase();
        // Mimick CM behavior of link definitions.
        // See: <https://github.com/syntax-tree/mdast-util-definitions/blob/8d48e57/index.js#L26>.
        if (!$9bd6dfa2f24ac709$var$own.call(footnoteById, id)) footnoteById[id] = definition;
    }
}
// Transform `tree`, which is an mdast node, to a hast node.
function $9bd6dfa2f24ac709$var$toHast(tree, options) {
    var h = $9bd6dfa2f24ac709$var$factory(tree, options);
    var node = $3ZT5R(h, tree);
    var foot = $57ODx(h);
    if (foot) node.children = node.children.concat($iliNM("text", "\n"), foot);
    return node;
}

});
parcelRegister("iliNM", function(module, exports) {
"use strict";

var $bDppX = parcelRequire("bDppX");
module.exports = $d5a8c5d1ffc9b864$var$u;
function $d5a8c5d1ffc9b864$var$u(type, props, value) {
    var node;
    if ((value === null || value === undefined) && (typeof props !== "object" || Array.isArray(props))) {
        value = props;
        props = {};
    }
    node = $bDppX({
        type: String(type)
    }, props);
    if (Array.isArray(value)) node.children = value;
    else if (value !== null && value !== undefined) node.value = String(value);
    return node;
}

});

parcelRegister("i1zwa", function(module, exports) {
"use strict";
var $d1f3df11cf77dc6e$var$start = $d1f3df11cf77dc6e$var$factory("start");
var $d1f3df11cf77dc6e$var$end = $d1f3df11cf77dc6e$var$factory("end");
module.exports = $d1f3df11cf77dc6e$var$position;
$d1f3df11cf77dc6e$var$position.start = $d1f3df11cf77dc6e$var$start;
$d1f3df11cf77dc6e$var$position.end = $d1f3df11cf77dc6e$var$end;
function $d1f3df11cf77dc6e$var$position(node) {
    return {
        start: $d1f3df11cf77dc6e$var$start(node),
        end: $d1f3df11cf77dc6e$var$end(node)
    };
}
function $d1f3df11cf77dc6e$var$factory(type) {
    point.displayName = type;
    return point;
    function point(node) {
        var point = node && node.position && node.position[type] || {};
        return {
            line: point.line || null,
            column: point.column || null,
            offset: isNaN(point.offset) ? null : point.offset
        };
    }
}

});

parcelRegister("2EMTP", function(module, exports) {
"use strict";
module.exports = $1ef53fa30fd5e7dc$var$generated;
function $1ef53fa30fd5e7dc$var$generated(node) {
    var position = $1ef53fa30fd5e7dc$var$optional($1ef53fa30fd5e7dc$var$optional(node).position);
    var start = $1ef53fa30fd5e7dc$var$optional(position.start);
    var end = $1ef53fa30fd5e7dc$var$optional(position.end);
    return !start.line || !start.column || !end.line || !end.column;
}
function $1ef53fa30fd5e7dc$var$optional(value) {
    return value && typeof value === "object" ? value : {};
}

});

parcelRegister("lBwlE", function(module, exports) {
"use strict";

var $KDBsL = parcelRequire("KDBsL");
module.exports = $fba62559b2947c6e$var$getDefinitionFactory;
var $fba62559b2947c6e$var$own = {}.hasOwnProperty;
// Get a definition in `node` by `identifier`.
function $fba62559b2947c6e$var$getDefinitionFactory(node, options) {
    return $fba62559b2947c6e$var$getterFactory($fba62559b2947c6e$var$gather(node, options));
}
// Gather all definitions in `node`
function $fba62559b2947c6e$var$gather(node, options) {
    var cache = {};
    if (!node || !node.type) throw new Error("mdast-util-definitions expected node");
    $KDBsL(node, "definition", options && options.commonmark ? commonmark : normal);
    return cache;
    function commonmark(definition) {
        var id = $fba62559b2947c6e$var$normalise(definition.identifier);
        if (!$fba62559b2947c6e$var$own.call(cache, id)) cache[id] = definition;
    }
    function normal(definition) {
        cache[$fba62559b2947c6e$var$normalise(definition.identifier)] = definition;
    }
}
// Factory to get a node from the given definition-cache.
function $fba62559b2947c6e$var$getterFactory(cache) {
    return getter;
    // Get a node from the bound definition-cache.
    function getter(identifier) {
        var id = identifier && $fba62559b2947c6e$var$normalise(identifier);
        return id && $fba62559b2947c6e$var$own.call(cache, id) ? cache[id] : null;
    }
}
function $fba62559b2947c6e$var$normalise(identifier) {
    return identifier.toUpperCase();
}

});

parcelRegister("3ZT5R", function(module, exports) {
"use strict";
module.exports = $2e91ce06fb183c5e$var$one;

var $iliNM = parcelRequire("iliNM");

var $a3nRR = parcelRequire("a3nRR");
var $2e91ce06fb183c5e$var$own = {}.hasOwnProperty;
// Transform an unknown node.
function $2e91ce06fb183c5e$var$unknown(h, node) {
    if ($2e91ce06fb183c5e$var$text(node)) return h.augment(node, $iliNM("text", node.value));
    return h(node, "div", $a3nRR(h, node));
}
// Visit a node.
function $2e91ce06fb183c5e$var$one(h, node, parent) {
    var type = node && node.type;
    var fn = $2e91ce06fb183c5e$var$own.call(h.handlers, type) ? h.handlers[type] : null;
    // Fail on non-nodes.
    if (!type) throw new Error("Expected node, got `" + node + "`");
    return (typeof fn === "function" ? fn : $2e91ce06fb183c5e$var$unknown)(h, node, parent);
}
// Check if the node should be renderered as a text node.
function $2e91ce06fb183c5e$var$text(node) {
    var data = node.data || {};
    if ($2e91ce06fb183c5e$var$own.call(data, "hName") || $2e91ce06fb183c5e$var$own.call(data, "hProperties") || $2e91ce06fb183c5e$var$own.call(data, "hChildren")) return false;
    return "value" in node;
}

});
parcelRegister("a3nRR", function(module, exports) {
"use strict";
module.exports = $751cb2d759c7ebc8$var$all;

var $2Lc6r = parcelRequire("2Lc6r");

var $3ZT5R = parcelRequire("3ZT5R");
function $751cb2d759c7ebc8$var$all(h, parent) {
    var nodes = parent.children || [];
    var length = nodes.length;
    var values = [];
    var index = -1;
    var result;
    var head;
    while(++index < length){
        result = $3ZT5R(h, nodes[index], parent);
        if (result) {
            if (index && nodes[index - 1].type === "break") {
                if (result.value) result.value = $2Lc6r.left(result.value);
                head = result.children && result.children[0];
                if (head && head.value) head.value = $2Lc6r.left(head.value);
            }
            values = values.concat(result);
        }
    }
    return values;
}

});


parcelRegister("57ODx", function(module, exports) {
"use strict";
module.exports = $3bb4e2980a9f3e75$var$generateFootnotes;

var $jYimF = parcelRequire("jYimF");

var $bRwBF = parcelRequire("bRwBF");

var $8W6At = parcelRequire("8W6At");
function $3bb4e2980a9f3e75$var$generateFootnotes(h) {
    var footnoteById = h.footnoteById;
    var footnoteOrder = h.footnoteOrder;
    var length = footnoteOrder.length;
    var index = -1;
    var listItems = [];
    var def;
    var backReference;
    var content;
    var tail;
    while(++index < length){
        def = footnoteById[footnoteOrder[index].toUpperCase()];
        if (!def) continue;
        content = def.children.concat();
        tail = content[content.length - 1];
        backReference = {
            type: "link",
            url: "#fnref-" + def.identifier,
            data: {
                hProperties: {
                    className: [
                        "footnote-backref"
                    ]
                }
            },
            children: [
                {
                    type: "text",
                    value: "\u21A9"
                }
            ]
        };
        if (!tail || tail.type !== "paragraph") {
            tail = {
                type: "paragraph",
                children: []
            };
            content.push(tail);
        }
        tail.children.push(backReference);
        listItems.push({
            type: "listItem",
            data: {
                hProperties: {
                    id: "fn-" + def.identifier
                }
            },
            children: content,
            position: def.position
        });
    }
    if (listItems.length === 0) return null;
    return h(null, "div", {
        className: [
            "footnotes"
        ]
    }, $8W6At([
        $jYimF(h),
        $bRwBF(h, {
            type: "list",
            ordered: true,
            children: listItems
        })
    ], true));
}

});
parcelRegister("jYimF", function(module, exports) {
"use strict";
module.exports = $e8a1ddc0e56354ce$var$thematicBreak;
function $e8a1ddc0e56354ce$var$thematicBreak(h, node) {
    return h(node, "hr");
}

});

parcelRegister("bRwBF", function(module, exports) {
"use strict";
module.exports = $8a2deff15c2dea79$var$list;

var $8W6At = parcelRequire("8W6At");

var $a3nRR = parcelRequire("a3nRR");
function $8a2deff15c2dea79$var$list(h, node) {
    var props = {};
    var name = node.ordered ? "ol" : "ul";
    var items;
    var index = -1;
    var length;
    if (typeof node.start === "number" && node.start !== 1) props.start = node.start;
    items = $a3nRR(h, node);
    length = items.length;
    // Like GitHub, add a class for custom styling.
    while(++index < length)if (items[index].properties.className && items[index].properties.className.indexOf("task-list-item") !== -1) {
        props.className = [
            "contains-task-list"
        ];
        break;
    }
    return h(node, name, props, $8W6At(items, true));
}

});
parcelRegister("8W6At", function(module, exports) {
"use strict";
module.exports = $6818d99a9c9efdfb$var$wrap;

var $iliNM = parcelRequire("iliNM");
// Wrap `nodes` with line feeds between each entry.
// Optionally adds line feeds at the start and end.
function $6818d99a9c9efdfb$var$wrap(nodes, loose) {
    var result = [];
    var index = -1;
    var length = nodes.length;
    if (loose) result.push($iliNM("text", "\n"));
    while(++index < length){
        if (index) result.push($iliNM("text", "\n"));
        result.push(nodes[index]);
    }
    if (loose && nodes.length !== 0) result.push($iliNM("text", "\n"));
    return result;
}

});



parcelRegister("8d6xV", function(module, exports) {
"use strict";






















module.exports = {
    blockquote: (parcelRequire("ePoGc")),
    break: (parcelRequire("9Zqab")),
    code: (parcelRequire("c4HiZ")),
    delete: (parcelRequire("and8S")),
    emphasis: (parcelRequire("1otWW")),
    footnoteReference: (parcelRequire("79UvT")),
    footnote: (parcelRequire("0warK")),
    heading: (parcelRequire("iKrST")),
    html: (parcelRequire("kZQ0f")),
    imageReference: (parcelRequire("bHi1A")),
    image: (parcelRequire("wIsZY")),
    inlineCode: (parcelRequire("gT8Qg")),
    linkReference: (parcelRequire("6o8rq")),
    link: (parcelRequire("giPxz")),
    listItem: (parcelRequire("4Cw3I")),
    list: (parcelRequire("bRwBF")),
    paragraph: (parcelRequire("bv3yS")),
    root: (parcelRequire("8smh5")),
    strong: (parcelRequire("7SWrt")),
    table: (parcelRequire("8QBhZ")),
    text: (parcelRequire("1oKFc")),
    thematicBreak: (parcelRequire("jYimF")),
    toml: $5fa49d8f19a44066$var$ignore,
    yaml: $5fa49d8f19a44066$var$ignore,
    definition: $5fa49d8f19a44066$var$ignore,
    footnoteDefinition: $5fa49d8f19a44066$var$ignore
};
// Return nothing for nodes that are ignored.
function $5fa49d8f19a44066$var$ignore() {
    return null;
}

});
parcelRegister("ePoGc", function(module, exports) {
"use strict";
module.exports = $acb8f8f29cb01c01$var$blockquote;

var $8W6At = parcelRequire("8W6At");

var $a3nRR = parcelRequire("a3nRR");
function $acb8f8f29cb01c01$var$blockquote(h, node) {
    return h(node, "blockquote", $8W6At($a3nRR(h, node), true));
}

});

parcelRegister("9Zqab", function(module, exports) {
"use strict";
module.exports = $745e1b0f3119219e$var$hardBreak;

var $iliNM = parcelRequire("iliNM");
function $745e1b0f3119219e$var$hardBreak(h, node) {
    return [
        h(node, "br"),
        $iliNM("text", "\n")
    ];
}

});

parcelRegister("c4HiZ", function(module, exports) {
"use strict";
module.exports = $8ca7734b07b99517$var$code;

var $lMy0e = parcelRequire("lMy0e");

var $iliNM = parcelRequire("iliNM");
function $8ca7734b07b99517$var$code(h, node) {
    var value = node.value ? $lMy0e(node.value + "\n") : "";
    var lang = node.lang && node.lang.match(/^[^ \t]+(?=[ \t]|$)/);
    var props = {};
    if (lang) props.className = [
        "language-" + lang
    ];
    return h(node.position, "pre", [
        h(node, "code", props, [
            $iliNM("text", value)
        ])
    ]);
}

});
parcelRegister("lMy0e", function(module, exports) {
"use strict";
module.exports = $fdb874e8b5fd731e$var$detab;

var $j6axH = parcelRequire("j6axH");
var $fdb874e8b5fd731e$var$tab = 0x09;
var $fdb874e8b5fd731e$var$lineFeed = 0x0a;
var $fdb874e8b5fd731e$var$carriageReturn = 0x0d;
// Replace tabs with spaces, being smart about which column the tab is at and
// which size should be used.
function $fdb874e8b5fd731e$var$detab(value, size) {
    var string = typeof value === "string";
    var length = string && value.length;
    var start = 0;
    var index = -1;
    var column = -1;
    var tabSize = size || 4;
    var results = [];
    var code;
    var add;
    if (!string) throw new Error("detab expected string");
    while(++index < length){
        code = value.charCodeAt(index);
        if (code === $fdb874e8b5fd731e$var$tab) {
            add = tabSize - (column + 1) % tabSize;
            column += add;
            results.push(value.slice(start, index) + $j6axH(" ", add));
            start = index + 1;
        } else if (code === $fdb874e8b5fd731e$var$lineFeed || code === $fdb874e8b5fd731e$var$carriageReturn) column = -1;
        else column++;
    }
    results.push(value.slice(start));
    return results.join("");
}

});


parcelRegister("and8S", function(module, exports) {
"use strict";
module.exports = $78d63f1f549b1766$var$strikethrough;

var $a3nRR = parcelRequire("a3nRR");
function $78d63f1f549b1766$var$strikethrough(h, node) {
    return h(node, "del", $a3nRR(h, node));
}

});

parcelRegister("1otWW", function(module, exports) {
"use strict";
module.exports = $103f43bb41337f98$var$emphasis;

var $a3nRR = parcelRequire("a3nRR");
function $103f43bb41337f98$var$emphasis(h, node) {
    return h(node, "em", $a3nRR(h, node));
}

});

parcelRegister("79UvT", function(module, exports) {
"use strict";
module.exports = $5365360aa73b58ac$var$footnoteReference;

var $iliNM = parcelRequire("iliNM");
function $5365360aa73b58ac$var$footnoteReference(h, node) {
    var footnoteOrder = h.footnoteOrder;
    var identifier = String(node.identifier);
    if (footnoteOrder.indexOf(identifier) === -1) footnoteOrder.push(identifier);
    return h(node.position, "sup", {
        id: "fnref-" + identifier
    }, [
        h(node, "a", {
            href: "#fn-" + identifier,
            className: [
                "footnote-ref"
            ]
        }, [
            $iliNM("text", node.label || identifier)
        ])
    ]);
}

});

parcelRegister("0warK", function(module, exports) {
"use strict";
module.exports = $0018f3fed8c9a22a$var$footnote;

var $79UvT = parcelRequire("79UvT");
function $0018f3fed8c9a22a$var$footnote(h, node) {
    var footnoteById = h.footnoteById;
    var footnoteOrder = h.footnoteOrder;
    var identifier = 1;
    while(identifier in footnoteById)identifier++;
    identifier = String(identifier);
    // No need to check if `identifier` exists in `footnoteOrder`, it’s guaranteed
    // to not exist because we just generated it.
    footnoteOrder.push(identifier);
    footnoteById[identifier] = {
        type: "footnoteDefinition",
        identifier: identifier,
        children: [
            {
                type: "paragraph",
                children: node.children
            }
        ],
        position: node.position
    };
    return $79UvT(h, {
        type: "footnoteReference",
        identifier: identifier,
        position: node.position
    });
}

});

parcelRegister("iKrST", function(module, exports) {
"use strict";
module.exports = $da622725bb586ac6$var$heading;

var $a3nRR = parcelRequire("a3nRR");
function $da622725bb586ac6$var$heading(h, node) {
    return h(node, "h" + node.depth, $a3nRR(h, node));
}

});

parcelRegister("kZQ0f", function(module, exports) {
"use strict";
module.exports = $f491d7dd6da6a2ae$var$html;

var $iliNM = parcelRequire("iliNM");
// Return either a `raw` node in dangerous mode, otherwise nothing.
function $f491d7dd6da6a2ae$var$html(h, node) {
    return h.dangerous ? h.augment(node, $iliNM("raw", node.value)) : null;
}

});

parcelRegister("bHi1A", function(module, exports) {
"use strict";
module.exports = $8841b12b75664b81$var$imageReference;

var $fgOwe = parcelRequire("fgOwe");

var $fpvQ7 = parcelRequire("fpvQ7");
function $8841b12b75664b81$var$imageReference(h, node) {
    var def = h.definition(node.identifier);
    var props;
    if (!def) return $fpvQ7(h, node);
    props = {
        src: $fgOwe(def.url || ""),
        alt: node.alt
    };
    if (def.title !== null && def.title !== undefined) props.title = def.title;
    return h(node, "img", props);
}

});
parcelRegister("fgOwe", function(module, exports) {
"use strict";
var $b1df89a559ade814$var$encodeCache = {};
// Create a lookup array where anything but characters in `chars` string
// and alphanumeric chars is percent-encoded.
//
function $b1df89a559ade814$var$getEncodeCache(exclude) {
    var i, ch, cache = $b1df89a559ade814$var$encodeCache[exclude];
    if (cache) return cache;
    cache = $b1df89a559ade814$var$encodeCache[exclude] = [];
    for(i = 0; i < 128; i++){
        ch = String.fromCharCode(i);
        if (/^[0-9a-z]$/i.test(ch)) // always allow unencoded alphanumeric characters
        cache.push(ch);
        else cache.push("%" + ("0" + i.toString(16).toUpperCase()).slice(-2));
    }
    for(i = 0; i < exclude.length; i++)cache[exclude.charCodeAt(i)] = exclude[i];
    return cache;
}
// Encode unsafe characters with percent-encoding, skipping already
// encoded sequences.
//
//  - string       - string to encode
//  - exclude      - list of characters to ignore (in addition to a-zA-Z0-9)
//  - keepEscaped  - don't encode '%' in a correct escape sequence (default: true)
//
function $b1df89a559ade814$var$encode(string, exclude, keepEscaped) {
    var i, l, code, nextCode, cache, result = "";
    if (typeof exclude !== "string") {
        // encode(string, keepEscaped)
        keepEscaped = exclude;
        exclude = $b1df89a559ade814$var$encode.defaultChars;
    }
    if (typeof keepEscaped === "undefined") keepEscaped = true;
    cache = $b1df89a559ade814$var$getEncodeCache(exclude);
    for(i = 0, l = string.length; i < l; i++){
        code = string.charCodeAt(i);
        if (keepEscaped && code === 0x25 /* % */  && i + 2 < l) {
            if (/^[0-9a-f]{2}$/i.test(string.slice(i + 1, i + 3))) {
                result += string.slice(i, i + 3);
                i += 2;
                continue;
            }
        }
        if (code < 128) {
            result += cache[code];
            continue;
        }
        if (code >= 0xD800 && code <= 0xDFFF) {
            if (code >= 0xD800 && code <= 0xDBFF && i + 1 < l) {
                nextCode = string.charCodeAt(i + 1);
                if (nextCode >= 0xDC00 && nextCode <= 0xDFFF) {
                    result += encodeURIComponent(string[i] + string[i + 1]);
                    i++;
                    continue;
                }
            }
            result += "%EF%BF%BD";
            continue;
        }
        result += encodeURIComponent(string[i]);
    }
    return result;
}
$b1df89a559ade814$var$encode.defaultChars = ";/?:@&=+$,-_.!~*'()#";
$b1df89a559ade814$var$encode.componentChars = "-_.!~*'()";
module.exports = $b1df89a559ade814$var$encode;

});

parcelRegister("fpvQ7", function(module, exports) {
"use strict";
module.exports = $b381e37f8b3f7cb8$var$revert;

var $iliNM = parcelRequire("iliNM");

var $a3nRR = parcelRequire("a3nRR");
// Return the content of a reference without definition as Markdown.
function $b381e37f8b3f7cb8$var$revert(h, node) {
    var subtype = node.referenceType;
    var suffix = "]";
    var contents;
    var head;
    var tail;
    if (subtype === "collapsed") suffix += "[]";
    else if (subtype === "full") suffix += "[" + (node.label || node.identifier) + "]";
    if (node.type === "imageReference") return $iliNM("text", "![" + node.alt + suffix);
    contents = $a3nRR(h, node);
    head = contents[0];
    if (head && head.type === "text") head.value = "[" + head.value;
    else contents.unshift($iliNM("text", "["));
    tail = contents[contents.length - 1];
    if (tail && tail.type === "text") tail.value += suffix;
    else contents.push($iliNM("text", suffix));
    return contents;
}

});


parcelRegister("wIsZY", function(module, exports) {
"use strict";

var $fgOwe = parcelRequire("fgOwe");
module.exports = $06257b6ffc6725d9$var$image;
function $06257b6ffc6725d9$var$image(h, node) {
    var props = {
        src: $fgOwe(node.url),
        alt: node.alt
    };
    if (node.title !== null && node.title !== undefined) props.title = node.title;
    return h(node, "img", props);
}

});

parcelRegister("gT8Qg", function(module, exports) {
"use strict";
module.exports = $c4b8a434bfabab2a$var$inlineCode;

var $lcAVc = parcelRequire("lcAVc");

var $iliNM = parcelRequire("iliNM");
function $c4b8a434bfabab2a$var$inlineCode(h, node) {
    return h(node, "code", [
        $iliNM("text", $lcAVc(node.value))
    ]);
}

});

parcelRegister("6o8rq", function(module, exports) {
"use strict";
module.exports = $4a6b8839d3897a9d$var$linkReference;

var $fgOwe = parcelRequire("fgOwe");

var $fpvQ7 = parcelRequire("fpvQ7");

var $a3nRR = parcelRequire("a3nRR");
function $4a6b8839d3897a9d$var$linkReference(h, node) {
    var def = h.definition(node.identifier);
    var props;
    if (!def) return $fpvQ7(h, node);
    props = {
        href: $fgOwe(def.url || "")
    };
    if (def.title !== null && def.title !== undefined) props.title = def.title;
    return h(node, "a", props, $a3nRR(h, node));
}

});

parcelRegister("giPxz", function(module, exports) {
"use strict";

var $fgOwe = parcelRequire("fgOwe");

var $a3nRR = parcelRequire("a3nRR");
module.exports = $bde64ea9a906a15d$var$link;
function $bde64ea9a906a15d$var$link(h, node) {
    var props = {
        href: $fgOwe(node.url)
    };
    if (node.title !== null && node.title !== undefined) props.title = node.title;
    return h(node, "a", props, $a3nRR(h, node));
}

});

parcelRegister("4Cw3I", function(module, exports) {
"use strict";
module.exports = $35d39440511cc9a4$var$listItem;

var $iliNM = parcelRequire("iliNM");

var $8W6At = parcelRequire("8W6At");

var $a3nRR = parcelRequire("a3nRR");
function $35d39440511cc9a4$var$listItem(h, node, parent) {
    var children = node.children;
    var head = children[0];
    var raw = $a3nRR(h, node);
    var loose = parent ? $35d39440511cc9a4$var$listLoose(parent) : $35d39440511cc9a4$var$listItemLoose(node);
    var props = {};
    var result;
    var container;
    var index;
    var length;
    var child;
    // Tight lists should not render `paragraph` nodes as `p` elements.
    if (loose) result = raw;
    else {
        result = [];
        length = raw.length;
        index = -1;
        while(++index < length){
            child = raw[index];
            if (child.tagName === "p") result = result.concat(child.children);
            else result.push(child);
        }
    }
    if (typeof node.checked === "boolean") {
        if (loose && (!head || head.type !== "paragraph")) result.unshift(h(null, "p", []));
        container = loose ? result[0].children : result;
        if (container.length !== 0) container.unshift($iliNM("text", " "));
        container.unshift(h(null, "input", {
            type: "checkbox",
            checked: node.checked,
            disabled: true
        }));
        // According to github-markdown-css, this class hides bullet.
        // See: <https://github.com/sindresorhus/github-markdown-css>.
        props.className = [
            "task-list-item"
        ];
    }
    if (loose && result.length !== 0) result = $8W6At(result, true);
    return h(node, "li", props, result);
}
function $35d39440511cc9a4$var$listLoose(node) {
    var loose = node.spread;
    var children = node.children;
    var length = children.length;
    var index = -1;
    while(!loose && ++index < length)loose = $35d39440511cc9a4$var$listItemLoose(children[index]);
    return loose;
}
function $35d39440511cc9a4$var$listItemLoose(node) {
    var spread = node.spread;
    return spread === undefined || spread === null ? node.children.length > 1 : spread;
}

});

parcelRegister("bv3yS", function(module, exports) {
"use strict";
module.exports = $85f55a2f0191e3a2$var$paragraph;

var $a3nRR = parcelRequire("a3nRR");
function $85f55a2f0191e3a2$var$paragraph(h, node) {
    return h(node, "p", $a3nRR(h, node));
}

});

parcelRegister("8smh5", function(module, exports) {
"use strict";
module.exports = $62823780429ed901$var$root;

var $iliNM = parcelRequire("iliNM");

var $8W6At = parcelRequire("8W6At");

var $a3nRR = parcelRequire("a3nRR");
function $62823780429ed901$var$root(h, node) {
    return h.augment(node, $iliNM("root", $8W6At($a3nRR(h, node))));
}

});

parcelRegister("7SWrt", function(module, exports) {
"use strict";
module.exports = $5bdae8f59f38b55f$var$strong;

var $a3nRR = parcelRequire("a3nRR");
function $5bdae8f59f38b55f$var$strong(h, node) {
    return h(node, "strong", $a3nRR(h, node));
}

});

parcelRegister("8QBhZ", function(module, exports) {
"use strict";
module.exports = $67101ae5d3955a13$var$table;

var $i1zwa = parcelRequire("i1zwa");

var $8W6At = parcelRequire("8W6At");

var $a3nRR = parcelRequire("a3nRR");
function $67101ae5d3955a13$var$table(h, node) {
    var rows = node.children;
    var index = rows.length;
    var align = node.align;
    var alignLength = align.length;
    var result = [];
    var pos;
    var row;
    var out;
    var name;
    var cell;
    while(index--){
        row = rows[index].children;
        name = index === 0 ? "th" : "td";
        pos = alignLength;
        out = [];
        while(pos--){
            cell = row[pos];
            out[pos] = h(cell, name, {
                align: align[pos]
            }, cell ? $a3nRR(h, cell) : []);
        }
        result[index] = h(rows[index], "tr", $8W6At(out, true));
    }
    return h(node, "table", $8W6At([
        h(result[0].position, "thead", $8W6At([
            result[0]
        ], true)),
        h({
            start: $i1zwa.start(result[1]),
            end: $i1zwa.end(result[result.length - 1])
        }, "tbody", $8W6At(result.slice(1), true))
    ], true));
}

});

parcelRegister("1oKFc", function(module, exports) {
"use strict";
module.exports = $104c3abbfb5fc142$var$text;

var $iliNM = parcelRequire("iliNM");

var $jE3YM = parcelRequire("jE3YM");
function $104c3abbfb5fc142$var$text(h, node) {
    return h.augment(node, $iliNM("text", $jE3YM(node.value)));
}

});
parcelRegister("jE3YM", function(module, exports) {
"use strict";
module.exports = $e4d4d6f72706816a$var$trimLines;
var $e4d4d6f72706816a$var$ws = /[ \t]*\n+[ \t]*/g;
var $e4d4d6f72706816a$var$newline = "\n";
function $e4d4d6f72706816a$var$trimLines(value) {
    return String(value).replace($e4d4d6f72706816a$var$ws, $e4d4d6f72706816a$var$newline);
}

});





parcelRegister("6qkoA", function(module, exports) {
"use strict";

module.exports = (parcelRequire("7MUP2"));

});
parcelRegister("7MUP2", function(module, exports) {
"use strict";

var $36bRz = parcelRequire("36bRz");

var $gOAtn = parcelRequire("gOAtn");
module.exports = $5ab917c89cbe7984$var$wrapper;
var $5ab917c89cbe7984$var$own = {}.hasOwnProperty;
var $5ab917c89cbe7984$var$allData = "data*";
var $5ab917c89cbe7984$var$commentEnd = "-->";
var $5ab917c89cbe7984$var$nodeSchema = {
    root: {
        children: $5ab917c89cbe7984$var$all
    },
    doctype: $5ab917c89cbe7984$var$handleDoctype,
    comment: $5ab917c89cbe7984$var$handleComment,
    element: {
        tagName: $5ab917c89cbe7984$var$handleTagName,
        properties: $5ab917c89cbe7984$var$handleProperties,
        children: $5ab917c89cbe7984$var$all
    },
    text: {
        value: $5ab917c89cbe7984$var$handleValue
    },
    "*": {
        data: $5ab917c89cbe7984$var$allow,
        position: $5ab917c89cbe7984$var$allow
    }
};
// Sanitize `node`, according to `schema`.
function $5ab917c89cbe7984$var$wrapper(node, schema) {
    var ctx = {
        type: "root",
        children: []
    };
    var replace;
    if (!node || typeof node !== "object" || !node.type) return ctx;
    replace = $5ab917c89cbe7984$var$one($36bRz($gOAtn, schema || {}), node, []);
    if (!replace) return ctx;
    if ("length" in replace) {
        if (replace.length === 1) return replace[0];
        ctx.children = replace;
        return ctx;
    }
    return replace;
}
// Sanitize `node`.
function $5ab917c89cbe7984$var$one(schema, node, stack) {
    var type = node && node.type;
    var replacement = {
        type: node.type
    };
    var replace = true;
    var definition;
    var allowed;
    var result;
    var key;
    if (!$5ab917c89cbe7984$var$own.call($5ab917c89cbe7984$var$nodeSchema, type)) replace = false;
    else {
        definition = $5ab917c89cbe7984$var$nodeSchema[type];
        if (typeof definition === "function") definition = definition(schema, node);
        if (!definition) replace = false;
        else {
            allowed = $36bRz(definition, $5ab917c89cbe7984$var$nodeSchema["*"]);
            for(key in allowed){
                result = allowed[key](schema, node[key], node, stack);
                if (result === false) {
                    replace = false;
                    // Set the non-safe value.
                    replacement[key] = node[key];
                } else if (result !== null && result !== undefined) replacement[key] = result;
            }
        }
    }
    if (!replace) {
        if (!replacement.children || replacement.children.length === 0 || schema.strip.indexOf(replacement.tagName) !== -1) return null;
        return replacement.children;
    }
    return replacement;
}
// Sanitize `children`.
function $5ab917c89cbe7984$var$all(schema, children, node, stack) {
    var nodes = children || [];
    var length = nodes.length || 0;
    var results = [];
    var index = -1;
    var result;
    stack = stack.concat(node.tagName);
    while(++index < length){
        result = $5ab917c89cbe7984$var$one(schema, nodes[index], stack);
        if (result) {
            if ("length" in result) results = results.concat(result);
            else results.push(result);
        }
    }
    return results;
}
// Sanitize `properties`.
function $5ab917c89cbe7984$var$handleProperties(schema, properties, node, stack) {
    var name = $5ab917c89cbe7984$var$handleTagName(schema, node.tagName, node, stack);
    var attrs = schema.attributes;
    var reqs = schema.required || /* istanbul ignore next */ {};
    var props = properties || {};
    var result = {};
    var allowed;
    var required;
    var definition;
    var prop;
    var value;
    allowed = $36bRz($5ab917c89cbe7984$var$toPropertyValueMap(attrs["*"]), $5ab917c89cbe7984$var$toPropertyValueMap($5ab917c89cbe7984$var$own.call(attrs, name) ? attrs[name] : []));
    for(prop in props){
        value = props[prop];
        if ($5ab917c89cbe7984$var$own.call(allowed, prop)) definition = allowed[prop];
        else if ($5ab917c89cbe7984$var$data(prop) && $5ab917c89cbe7984$var$own.call(allowed, $5ab917c89cbe7984$var$allData)) definition = allowed[$5ab917c89cbe7984$var$allData];
        else continue;
        if (value && typeof value === "object" && "length" in value) value = $5ab917c89cbe7984$var$handlePropertyValues(schema, value, prop, definition);
        else value = $5ab917c89cbe7984$var$handlePropertyValue(schema, value, prop, definition);
        if (value !== null && value !== undefined) result[prop] = value;
    }
    required = $5ab917c89cbe7984$var$own.call(reqs, name) ? reqs[name] : {};
    for(prop in required)if (!$5ab917c89cbe7984$var$own.call(result, prop)) result[prop] = required[prop];
    return result;
}
// Sanitize a property value which is a list.
function $5ab917c89cbe7984$var$handlePropertyValues(schema, values, prop, definition) {
    var length = values.length;
    var result = [];
    var index = -1;
    var value;
    while(++index < length){
        value = $5ab917c89cbe7984$var$handlePropertyValue(schema, values[index], prop, definition);
        if (value !== null && value !== undefined) result.push(value);
    }
    return result;
}
// Sanitize a property value.
function $5ab917c89cbe7984$var$handlePropertyValue(schema, value, prop, definition) {
    if (typeof value !== "boolean" && typeof value !== "number" && typeof value !== "string") return null;
    if (!$5ab917c89cbe7984$var$handleProtocol(schema, value, prop)) return null;
    if (definition.length !== 0 && definition.indexOf(value) === -1) return null;
    if (schema.clobber.indexOf(prop) !== -1) value = schema.clobberPrefix + value;
    return value;
}
// Check whether `value` is a safe URL.
function $5ab917c89cbe7984$var$handleProtocol(schema, value, prop) {
    var protocols = schema.protocols;
    var protocol;
    var first;
    var colon;
    var length;
    var index;
    protocols = $5ab917c89cbe7984$var$own.call(protocols, prop) ? protocols[prop].concat() : [];
    if (protocols.length === 0) return true;
    value = String(value);
    first = value.charAt(0);
    if (first === "#" || first === "/") return true;
    colon = value.indexOf(":");
    if (colon === -1) return true;
    length = protocols.length;
    index = -1;
    while(++index < length){
        protocol = protocols[index];
        if (colon === protocol.length && value.slice(0, protocol.length) === protocol) return true;
    }
    index = value.indexOf("?");
    if (index !== -1 && colon > index) return true;
    index = value.indexOf("#");
    if (index !== -1 && colon > index) return true;
    return false;
}
// Always return a valid HTML5 doctype.
function $5ab917c89cbe7984$var$handleDoctypeName() {
    return "html";
}
// Sanitize `tagName`.
function $5ab917c89cbe7984$var$handleTagName(schema, tagName, node, stack) {
    var name = typeof tagName === "string" ? tagName : null;
    var ancestors = schema.ancestors;
    var length;
    var index;
    if (!name || name === "*" || schema.tagNames.indexOf(name) === -1) return false;
    ancestors = $5ab917c89cbe7984$var$own.call(ancestors, name) ? ancestors[name] : [];
    // Some nodes can break out of their context if they don’t have a certain
    // ancestor.
    if (ancestors.length !== 0) {
        length = ancestors.length + 1;
        index = -1;
        while(++index < length){
            if (!ancestors[index]) return false;
            if (stack.indexOf(ancestors[index]) !== -1) break;
        }
    }
    return name;
}
function $5ab917c89cbe7984$var$handleDoctype(schema) {
    return schema.allowDoctypes ? {
        name: $5ab917c89cbe7984$var$handleDoctypeName
    } : null;
}
function $5ab917c89cbe7984$var$handleComment(schema) {
    return schema.allowComments ? {
        value: $5ab917c89cbe7984$var$handleCommentValue
    } : null;
}
// See <https://html.spec.whatwg.org/multipage/parsing.html#serialising-html-fragments>
function $5ab917c89cbe7984$var$handleCommentValue(schema, value) {
    var result = typeof value === "string" ? value : "";
    var index = result.indexOf($5ab917c89cbe7984$var$commentEnd);
    return index === -1 ? result : result.slice(0, index);
}
// Sanitize `value`.
function $5ab917c89cbe7984$var$handleValue(schema, value) {
    return typeof value === "string" ? value : "";
}
// Create a map from a list of props or a list of properties and values.
function $5ab917c89cbe7984$var$toPropertyValueMap(values) {
    var result = {};
    var length = values.length;
    var index = -1;
    var value;
    while(++index < length){
        value = values[index];
        if (value && typeof value === "object" && "length" in value) result[value[0]] = value.slice(1);
        else result[value] = [];
    }
    return result;
}
// Allow `value`.
function $5ab917c89cbe7984$var$allow(schema, value) {
    return value;
}
// Check if `prop` is a data property.
function $5ab917c89cbe7984$var$data(prop) {
    return prop.length > 4 && prop.slice(0, 4).toLowerCase() === "data";
}

});
parcelRegister("gOAtn", function(module, exports) {
module.exports = JSON.parse('{"strip":["script"],"clobberPrefix":"user-content-","clobber":["name","id"],"ancestors":{"tbody":["table"],"tfoot":["table"],"thead":["table"],"td":["table"],"th":["table"],"tr":["table"]},"protocols":{"href":["http","https","mailto","xmpp","irc","ircs"],"cite":["http","https"],"src":["http","https"],"longDesc":["http","https"]},"tagNames":["h1","h2","h3","h4","h5","h6","br","b","i","strong","em","a","pre","code","img","tt","div","ins","del","sup","sub","p","ol","ul","table","thead","tbody","tfoot","blockquote","dl","dt","dd","kbd","q","samp","var","hr","ruby","rt","rp","li","tr","td","th","s","strike","summary","details","caption","figure","figcaption","abbr","bdo","cite","dfn","mark","small","span","time","wbr","input"],"attributes":{"a":["href"],"img":["src","longDesc"],"input":[["type","checkbox"],["disabled",true]],"li":[["className","task-list-item"]],"div":["itemScope","itemType"],"blockquote":["cite"],"del":["cite"],"ins":["cite"],"q":["cite"],"*":["abbr","accept","acceptCharset","accessKey","action","align","alt","ariaDescribedBy","ariaHidden","ariaLabel","ariaLabelledBy","axis","border","cellPadding","cellSpacing","char","charOff","charSet","checked","clear","cols","colSpan","color","compact","coords","dateTime","dir","disabled","encType","htmlFor","frame","headers","height","hrefLang","hSpace","isMap","id","label","lang","maxLength","media","method","multiple","name","noHref","noShade","noWrap","open","prompt","readOnly","rel","rev","rows","rowSpan","rules","scope","selected","shape","size","span","start","summary","tabIndex","target","title","type","useMap","vAlign","value","vSpace","width","itemProp"]},"required":{"input":{"type":"checkbox","disabled":true}}}');

});



parcelRegister("1gsXp", function(module, exports) {
"use strict";

var $9ovh3 = parcelRequire("9ovh3");

var $gSyAZ = parcelRequire("gSyAZ");

var $ffG6I = parcelRequire("ffG6I");

var $6pKpX = parcelRequire("6pKpX");

var $dxv4b = parcelRequire("dxv4b");

var $ll02G = parcelRequire("ll02G");

var $b9hO3 = parcelRequire("b9hO3");

var $aM3Le = parcelRequire("aM3Le");

var $3AImh = parcelRequire("3AImh");
var $0ebdbf6245b5a3b9$var$root = $3AImh("root");
var $0ebdbf6245b5a3b9$var$element = $3AImh("element");
var $0ebdbf6245b5a3b9$var$text = $3AImh("text");
var $0ebdbf6245b5a3b9$var$dashes = /-([a-z])/g;
module.exports = $0ebdbf6245b5a3b9$var$wrapper;
function $0ebdbf6245b5a3b9$var$wrapper(h, node, options) {
    var settings = options || {};
    var prefix;
    var r;
    var v;
    var vd;
    if (typeof h !== "function") throw new Error("h is not a function");
    if (typeof settings === "string" || typeof settings === "boolean") {
        prefix = settings;
        settings = {};
    } else prefix = settings.prefix;
    r = $0ebdbf6245b5a3b9$var$react(h);
    v = $0ebdbf6245b5a3b9$var$vue(h);
    vd = $0ebdbf6245b5a3b9$var$vdom(h);
    if (prefix === null || prefix === undefined) prefix = r === true || v === true || vd === true ? "h-" : false;
    if ($0ebdbf6245b5a3b9$var$root(node)) {
        if (node.children.length === 1 && $0ebdbf6245b5a3b9$var$element(node.children[0])) node = node.children[0];
        else node = {
            type: "element",
            tagName: "div",
            properties: {},
            children: node.children
        };
    } else if (!$0ebdbf6245b5a3b9$var$element(node)) throw new Error("Expected root or element, not `" + (node && node.type || node) + "`");
    return $0ebdbf6245b5a3b9$var$toH(h, node, {
        schema: settings.space === "svg" ? $gSyAZ : $9ovh3,
        prefix: prefix,
        key: 0,
        react: r,
        vue: v,
        vdom: vd,
        hyperscript: $0ebdbf6245b5a3b9$var$hyperscript(h)
    });
}
// Transform a hast node through a hyperscript interface to *anything*!
function $0ebdbf6245b5a3b9$var$toH(h, node, ctx) {
    var parentSchema = ctx.schema;
    var schema = parentSchema;
    var name = node.tagName;
    var properties;
    var attributes;
    var children;
    var property;
    var elements;
    var length;
    var index;
    var value;
    var result;
    if (parentSchema.space === "html" && name.toLowerCase() === "svg") {
        schema = $gSyAZ;
        ctx.schema = schema;
    }
    if (ctx.vdom === true && schema.space === "html") name = name.toUpperCase();
    properties = node.properties;
    attributes = {};
    for(property in properties)$0ebdbf6245b5a3b9$var$addAttribute(attributes, property, properties[property], ctx);
    if (typeof attributes.style === "string" && (ctx.vdom === true || ctx.vue === true || ctx.react === true)) // VDOM, Vue, and React accept `style` as object.
    attributes.style = $0ebdbf6245b5a3b9$var$parseStyle(attributes.style, name);
    if (ctx.prefix) {
        ctx.key++;
        attributes.key = ctx.prefix + ctx.key;
    }
    if (ctx.vdom && schema.space !== "html") attributes.namespace = $aM3Le[schema.space];
    elements = [];
    children = node.children;
    length = children ? children.length : 0;
    index = -1;
    while(++index < length){
        value = children[index];
        if ($0ebdbf6245b5a3b9$var$element(value)) elements.push($0ebdbf6245b5a3b9$var$toH(h, value, ctx));
        else if ($0ebdbf6245b5a3b9$var$text(value)) elements.push(value.value);
    }
    // Ensure no React warnings are triggered for void elements having children
    // passed in.
    result = elements.length === 0 ? h(name, attributes) : h(name, attributes, elements);
    // Restore parent schema.
    ctx.schema = parentSchema;
    return result;
}
function $0ebdbf6245b5a3b9$var$addAttribute(props, prop, value, ctx) {
    var hyperlike = ctx.hyperscript || ctx.vdom || ctx.vue;
    var schema = ctx.schema;
    var info = $ffG6I(schema, prop);
    var subprop;
    // Ignore nully and `NaN` values.
    // Ignore `false` and falsey known booleans for hyperlike DSLs.
    if (value === null || value === undefined || value !== value || hyperlike && value === false || hyperlike && info.boolean && !value) return;
    if (value !== null && typeof value === "object" && "length" in value) // Accept `array`.
    // Most props are space-separated.
    value = (info.commaSeparated ? $ll02G : $dxv4b).stringify(value);
    // Treat `true` and truthy known booleans.
    if (info.boolean && ctx.hyperscript === true) value = "";
    if (ctx.vue) {
        if (prop !== "style") subprop = "attrs";
    } else if (!info.mustUseProperty) {
        if (ctx.vdom === true) subprop = "attributes";
        else if (ctx.hyperscript === true) subprop = "attrs";
    }
    if (subprop) {
        if (props[subprop] === undefined) props[subprop] = {};
        props[subprop][info.attribute] = value;
    } else if (ctx.react && info.space) props[$6pKpX[info.property] || info.property] = value;
    else props[info.attribute] = value;
}
// Check if `h` is `react.createElement`.
function $0ebdbf6245b5a3b9$var$react(h) {
    var node = h && h("div");
    return Boolean(node && ("_owner" in node || "_store" in node) && node.key === null);
}
// Check if `h` is `hyperscript`.
function $0ebdbf6245b5a3b9$var$hyperscript(h) {
    return Boolean(h && h.context && h.cleanup);
}
// Check if `h` is `virtual-dom/h`.
function $0ebdbf6245b5a3b9$var$vdom(h) {
    return h && h("div").type === "VirtualNode";
}
function $0ebdbf6245b5a3b9$var$vue(h) {
    var node = h && h("div");
    return Boolean(node && node.context && node.context._isVue);
}
function $0ebdbf6245b5a3b9$var$parseStyle(value, tagName) {
    var result = {};
    try {
        $b9hO3(value, iterator);
    } catch (error) {
        error.message = tagName + "[style]" + error.message.slice(9);
        throw error;
    }
    return result;
    function iterator(name, value) {
        result[$0ebdbf6245b5a3b9$var$styleCase(name)] = value;
    }
}
function $0ebdbf6245b5a3b9$var$styleCase(val) {
    if (val.slice(0, 4) === "-ms-") val = "ms-" + val.slice(4);
    return val.replace($0ebdbf6245b5a3b9$var$dashes, $0ebdbf6245b5a3b9$var$styleReplacer);
}
function $0ebdbf6245b5a3b9$var$styleReplacer($0, $1) {
    return $1.toUpperCase();
}

});
parcelRegister("9ovh3", function(module, exports) {
"use strict";

var $5B5Uy = parcelRequire("5B5Uy");

var $fOaV0 = parcelRequire("fOaV0");

var $66rZX = parcelRequire("66rZX");

var $5vUqY = parcelRequire("5vUqY");

var $7PmIb = parcelRequire("7PmIb");

var $hjKxW = parcelRequire("hjKxW");
module.exports = $5B5Uy([
    $66rZX,
    $fOaV0,
    $5vUqY,
    $7PmIb,
    $hjKxW
]);

});
parcelRegister("5B5Uy", function(module, exports) {
"use strict";

var $36bRz = parcelRequire("36bRz");

var $g2TdU = parcelRequire("g2TdU");
module.exports = $4134fe45309c0213$var$merge;
function $4134fe45309c0213$var$merge(definitions) {
    var length = definitions.length;
    var property = [];
    var normal = [];
    var index = -1;
    var info;
    var space;
    while(++index < length){
        info = definitions[index];
        property.push(info.property);
        normal.push(info.normal);
        space = info.space;
    }
    return new $g2TdU($36bRz.apply(null, property), $36bRz.apply(null, normal), space);
}

});
parcelRegister("g2TdU", function(module, exports) {
"use strict";
module.exports = $bae7ab714200f9b4$var$Schema;
var $bae7ab714200f9b4$var$proto = $bae7ab714200f9b4$var$Schema.prototype;
$bae7ab714200f9b4$var$proto.space = null;
$bae7ab714200f9b4$var$proto.normal = {};
$bae7ab714200f9b4$var$proto.property = {};
function $bae7ab714200f9b4$var$Schema(property, normal, space) {
    this.property = property;
    this.normal = normal;
    if (space) this.space = space;
}

});


parcelRegister("fOaV0", function(module, exports) {
"use strict";

var $ieLB3 = parcelRequire("ieLB3");
module.exports = $ieLB3({
    space: "xlink",
    transform: $b823feb1374d23bd$var$xlinkTransform,
    properties: {
        xLinkActuate: null,
        xLinkArcRole: null,
        xLinkHref: null,
        xLinkRole: null,
        xLinkShow: null,
        xLinkTitle: null,
        xLinkType: null
    }
});
function $b823feb1374d23bd$var$xlinkTransform(_, prop) {
    return "xlink:" + prop.slice(5).toLowerCase();
}

});
parcelRegister("ieLB3", function(module, exports) {
"use strict";

var $1j0Kh = parcelRequire("1j0Kh");

var $g2TdU = parcelRequire("g2TdU");

var $6rS13 = parcelRequire("6rS13");
module.exports = $d46e747ab4f2b22e$var$create;
function $d46e747ab4f2b22e$var$create(definition) {
    var space = definition.space;
    var mustUseProperty = definition.mustUseProperty || [];
    var attributes = definition.attributes || {};
    var props = definition.properties;
    var transform = definition.transform;
    var property = {};
    var normal = {};
    var prop;
    var info;
    for(prop in props){
        info = new $6rS13(prop, transform(attributes, prop), props[prop], space);
        if (mustUseProperty.indexOf(prop) !== -1) info.mustUseProperty = true;
        property[prop] = info;
        normal[$1j0Kh(prop)] = prop;
        normal[$1j0Kh(info.attribute)] = prop;
    }
    return new $g2TdU(property, normal, space);
}

});
parcelRegister("1j0Kh", function(module, exports) {
"use strict";
module.exports = $0f3824cd0a6551b1$var$normalize;
function $0f3824cd0a6551b1$var$normalize(value) {
    return value.toLowerCase();
}

});

parcelRegister("6rS13", function(module, exports) {
"use strict";

var $3W6gM = parcelRequire("3W6gM");

var $8cx7u = parcelRequire("8cx7u");
module.exports = $4b1f2a1f219d5ad5$var$DefinedInfo;
$4b1f2a1f219d5ad5$var$DefinedInfo.prototype = new $3W6gM();
$4b1f2a1f219d5ad5$var$DefinedInfo.prototype.defined = true;
var $4b1f2a1f219d5ad5$var$checks = [
    "boolean",
    "booleanish",
    "overloadedBoolean",
    "number",
    "commaSeparated",
    "spaceSeparated",
    "commaOrSpaceSeparated"
];
var $4b1f2a1f219d5ad5$var$checksLength = $4b1f2a1f219d5ad5$var$checks.length;
function $4b1f2a1f219d5ad5$var$DefinedInfo(property, attribute, mask, space) {
    var index = -1;
    var check;
    $4b1f2a1f219d5ad5$var$mark(this, "space", space);
    $3W6gM.call(this, property, attribute);
    while(++index < $4b1f2a1f219d5ad5$var$checksLength){
        check = $4b1f2a1f219d5ad5$var$checks[index];
        $4b1f2a1f219d5ad5$var$mark(this, check, (mask & $8cx7u[check]) === $8cx7u[check]);
    }
}
function $4b1f2a1f219d5ad5$var$mark(values, key, value) {
    if (value) values[key] = value;
}

});
parcelRegister("3W6gM", function(module, exports) {
"use strict";
module.exports = $2ddba6e5ecc0780e$var$Info;
var $2ddba6e5ecc0780e$var$proto = $2ddba6e5ecc0780e$var$Info.prototype;
$2ddba6e5ecc0780e$var$proto.space = null;
$2ddba6e5ecc0780e$var$proto.attribute = null;
$2ddba6e5ecc0780e$var$proto.property = null;
$2ddba6e5ecc0780e$var$proto.boolean = false;
$2ddba6e5ecc0780e$var$proto.booleanish = false;
$2ddba6e5ecc0780e$var$proto.overloadedBoolean = false;
$2ddba6e5ecc0780e$var$proto.number = false;
$2ddba6e5ecc0780e$var$proto.commaSeparated = false;
$2ddba6e5ecc0780e$var$proto.spaceSeparated = false;
$2ddba6e5ecc0780e$var$proto.commaOrSpaceSeparated = false;
$2ddba6e5ecc0780e$var$proto.mustUseProperty = false;
$2ddba6e5ecc0780e$var$proto.defined = false;
function $2ddba6e5ecc0780e$var$Info(property, attribute) {
    this.property = property;
    this.attribute = attribute;
}

});

parcelRegister("8cx7u", function(module, exports) {

$parcel$export(module.exports, "boolean", function () { return $5f8922a1b1e2a2b3$export$4a21f16c33752377; }, function (v) { return $5f8922a1b1e2a2b3$export$4a21f16c33752377 = v; });
$parcel$export(module.exports, "booleanish", function () { return $5f8922a1b1e2a2b3$export$55e9e1fbc638dc8f; }, function (v) { return $5f8922a1b1e2a2b3$export$55e9e1fbc638dc8f = v; });
$parcel$export(module.exports, "overloadedBoolean", function () { return $5f8922a1b1e2a2b3$export$242ac3d3042558aa; }, function (v) { return $5f8922a1b1e2a2b3$export$242ac3d3042558aa = v; });
$parcel$export(module.exports, "number", function () { return $5f8922a1b1e2a2b3$export$98e628dec113755e; }, function (v) { return $5f8922a1b1e2a2b3$export$98e628dec113755e = v; });
$parcel$export(module.exports, "spaceSeparated", function () { return $5f8922a1b1e2a2b3$export$ab8645c862eb5a3e; }, function (v) { return $5f8922a1b1e2a2b3$export$ab8645c862eb5a3e = v; });
$parcel$export(module.exports, "commaSeparated", function () { return $5f8922a1b1e2a2b3$export$9c8d678629b3d3; }, function (v) { return $5f8922a1b1e2a2b3$export$9c8d678629b3d3 = v; });
$parcel$export(module.exports, "commaOrSpaceSeparated", function () { return $5f8922a1b1e2a2b3$export$2ad25cfebf36cacd; }, function (v) { return $5f8922a1b1e2a2b3$export$2ad25cfebf36cacd = v; });
var $5f8922a1b1e2a2b3$export$4a21f16c33752377;
var $5f8922a1b1e2a2b3$export$55e9e1fbc638dc8f;
var $5f8922a1b1e2a2b3$export$242ac3d3042558aa;
var $5f8922a1b1e2a2b3$export$98e628dec113755e;
var $5f8922a1b1e2a2b3$export$ab8645c862eb5a3e;
var $5f8922a1b1e2a2b3$export$9c8d678629b3d3;
var $5f8922a1b1e2a2b3$export$2ad25cfebf36cacd;
"use strict";
var $5f8922a1b1e2a2b3$var$powers = 0;
$5f8922a1b1e2a2b3$export$4a21f16c33752377 = $5f8922a1b1e2a2b3$var$increment();
$5f8922a1b1e2a2b3$export$55e9e1fbc638dc8f = $5f8922a1b1e2a2b3$var$increment();
$5f8922a1b1e2a2b3$export$242ac3d3042558aa = $5f8922a1b1e2a2b3$var$increment();
$5f8922a1b1e2a2b3$export$98e628dec113755e = $5f8922a1b1e2a2b3$var$increment();
$5f8922a1b1e2a2b3$export$ab8645c862eb5a3e = $5f8922a1b1e2a2b3$var$increment();
$5f8922a1b1e2a2b3$export$9c8d678629b3d3 = $5f8922a1b1e2a2b3$var$increment();
$5f8922a1b1e2a2b3$export$2ad25cfebf36cacd = $5f8922a1b1e2a2b3$var$increment();
function $5f8922a1b1e2a2b3$var$increment() {
    return Math.pow(2, ++$5f8922a1b1e2a2b3$var$powers);
}

});




parcelRegister("66rZX", function(module, exports) {
"use strict";

var $ieLB3 = parcelRequire("ieLB3");
module.exports = $ieLB3({
    space: "xml",
    transform: $4719057e6e3f18c1$var$xmlTransform,
    properties: {
        xmlLang: null,
        xmlBase: null,
        xmlSpace: null
    }
});
function $4719057e6e3f18c1$var$xmlTransform(_, prop) {
    return "xml:" + prop.slice(3).toLowerCase();
}

});

parcelRegister("5vUqY", function(module, exports) {
"use strict";

var $ieLB3 = parcelRequire("ieLB3");

var $hLCV5 = parcelRequire("hLCV5");
module.exports = $ieLB3({
    space: "xmlns",
    attributes: {
        xmlnsxlink: "xmlns:xlink"
    },
    transform: $hLCV5,
    properties: {
        xmlns: null,
        xmlnsXLink: null
    }
});

});
parcelRegister("hLCV5", function(module, exports) {
"use strict";

var $5ktOm = parcelRequire("5ktOm");
module.exports = $cef504212d1ed016$var$caseInsensitiveTransform;
function $cef504212d1ed016$var$caseInsensitiveTransform(attributes, property) {
    return $5ktOm(attributes, property.toLowerCase());
}

});
parcelRegister("5ktOm", function(module, exports) {
"use strict";
module.exports = $3e15f1ecea332a93$var$caseSensitiveTransform;
function $3e15f1ecea332a93$var$caseSensitiveTransform(attributes, attribute) {
    return attribute in attributes ? attributes[attribute] : attribute;
}

});



parcelRegister("7PmIb", function(module, exports) {
"use strict";

var $8cx7u = parcelRequire("8cx7u");

var $ieLB3 = parcelRequire("ieLB3");
var $5b2ee9ddc12efb82$var$booleanish = $8cx7u.booleanish;
var $5b2ee9ddc12efb82$var$number = $8cx7u.number;
var $5b2ee9ddc12efb82$var$spaceSeparated = $8cx7u.spaceSeparated;
module.exports = $ieLB3({
    transform: $5b2ee9ddc12efb82$var$ariaTransform,
    properties: {
        ariaActiveDescendant: null,
        ariaAtomic: $5b2ee9ddc12efb82$var$booleanish,
        ariaAutoComplete: null,
        ariaBusy: $5b2ee9ddc12efb82$var$booleanish,
        ariaChecked: $5b2ee9ddc12efb82$var$booleanish,
        ariaColCount: $5b2ee9ddc12efb82$var$number,
        ariaColIndex: $5b2ee9ddc12efb82$var$number,
        ariaColSpan: $5b2ee9ddc12efb82$var$number,
        ariaControls: $5b2ee9ddc12efb82$var$spaceSeparated,
        ariaCurrent: null,
        ariaDescribedBy: $5b2ee9ddc12efb82$var$spaceSeparated,
        ariaDetails: null,
        ariaDisabled: $5b2ee9ddc12efb82$var$booleanish,
        ariaDropEffect: $5b2ee9ddc12efb82$var$spaceSeparated,
        ariaErrorMessage: null,
        ariaExpanded: $5b2ee9ddc12efb82$var$booleanish,
        ariaFlowTo: $5b2ee9ddc12efb82$var$spaceSeparated,
        ariaGrabbed: $5b2ee9ddc12efb82$var$booleanish,
        ariaHasPopup: null,
        ariaHidden: $5b2ee9ddc12efb82$var$booleanish,
        ariaInvalid: null,
        ariaKeyShortcuts: null,
        ariaLabel: null,
        ariaLabelledBy: $5b2ee9ddc12efb82$var$spaceSeparated,
        ariaLevel: $5b2ee9ddc12efb82$var$number,
        ariaLive: null,
        ariaModal: $5b2ee9ddc12efb82$var$booleanish,
        ariaMultiLine: $5b2ee9ddc12efb82$var$booleanish,
        ariaMultiSelectable: $5b2ee9ddc12efb82$var$booleanish,
        ariaOrientation: null,
        ariaOwns: $5b2ee9ddc12efb82$var$spaceSeparated,
        ariaPlaceholder: null,
        ariaPosInSet: $5b2ee9ddc12efb82$var$number,
        ariaPressed: $5b2ee9ddc12efb82$var$booleanish,
        ariaReadOnly: $5b2ee9ddc12efb82$var$booleanish,
        ariaRelevant: null,
        ariaRequired: $5b2ee9ddc12efb82$var$booleanish,
        ariaRoleDescription: $5b2ee9ddc12efb82$var$spaceSeparated,
        ariaRowCount: $5b2ee9ddc12efb82$var$number,
        ariaRowIndex: $5b2ee9ddc12efb82$var$number,
        ariaRowSpan: $5b2ee9ddc12efb82$var$number,
        ariaSelected: $5b2ee9ddc12efb82$var$booleanish,
        ariaSetSize: $5b2ee9ddc12efb82$var$number,
        ariaSort: null,
        ariaValueMax: $5b2ee9ddc12efb82$var$number,
        ariaValueMin: $5b2ee9ddc12efb82$var$number,
        ariaValueNow: $5b2ee9ddc12efb82$var$number,
        ariaValueText: null,
        role: null
    }
});
function $5b2ee9ddc12efb82$var$ariaTransform(_, prop) {
    return prop === "role" ? prop : "aria-" + prop.slice(4).toLowerCase();
}

});

parcelRegister("hjKxW", function(module, exports) {
"use strict";

var $8cx7u = parcelRequire("8cx7u");

var $ieLB3 = parcelRequire("ieLB3");

var $hLCV5 = parcelRequire("hLCV5");
var $c9b8512c43c3ea70$var$boolean = $8cx7u.boolean;
var $c9b8512c43c3ea70$var$overloadedBoolean = $8cx7u.overloadedBoolean;
var $c9b8512c43c3ea70$var$booleanish = $8cx7u.booleanish;
var $c9b8512c43c3ea70$var$number = $8cx7u.number;
var $c9b8512c43c3ea70$var$spaceSeparated = $8cx7u.spaceSeparated;
var $c9b8512c43c3ea70$var$commaSeparated = $8cx7u.commaSeparated;
module.exports = $ieLB3({
    space: "html",
    attributes: {
        acceptcharset: "accept-charset",
        classname: "class",
        htmlfor: "for",
        httpequiv: "http-equiv"
    },
    transform: $hLCV5,
    mustUseProperty: [
        "checked",
        "multiple",
        "muted",
        "selected"
    ],
    properties: {
        // Standard Properties.
        abbr: null,
        accept: $c9b8512c43c3ea70$var$commaSeparated,
        acceptCharset: $c9b8512c43c3ea70$var$spaceSeparated,
        accessKey: $c9b8512c43c3ea70$var$spaceSeparated,
        action: null,
        allow: null,
        allowFullScreen: $c9b8512c43c3ea70$var$boolean,
        allowPaymentRequest: $c9b8512c43c3ea70$var$boolean,
        allowUserMedia: $c9b8512c43c3ea70$var$boolean,
        alt: null,
        as: null,
        async: $c9b8512c43c3ea70$var$boolean,
        autoCapitalize: null,
        autoComplete: $c9b8512c43c3ea70$var$spaceSeparated,
        autoFocus: $c9b8512c43c3ea70$var$boolean,
        autoPlay: $c9b8512c43c3ea70$var$boolean,
        capture: $c9b8512c43c3ea70$var$boolean,
        charSet: null,
        checked: $c9b8512c43c3ea70$var$boolean,
        cite: null,
        className: $c9b8512c43c3ea70$var$spaceSeparated,
        cols: $c9b8512c43c3ea70$var$number,
        colSpan: null,
        content: null,
        contentEditable: $c9b8512c43c3ea70$var$booleanish,
        controls: $c9b8512c43c3ea70$var$boolean,
        controlsList: $c9b8512c43c3ea70$var$spaceSeparated,
        coords: $c9b8512c43c3ea70$var$number | $c9b8512c43c3ea70$var$commaSeparated,
        crossOrigin: null,
        data: null,
        dateTime: null,
        decoding: null,
        default: $c9b8512c43c3ea70$var$boolean,
        defer: $c9b8512c43c3ea70$var$boolean,
        dir: null,
        dirName: null,
        disabled: $c9b8512c43c3ea70$var$boolean,
        download: $c9b8512c43c3ea70$var$overloadedBoolean,
        draggable: $c9b8512c43c3ea70$var$booleanish,
        encType: null,
        enterKeyHint: null,
        form: null,
        formAction: null,
        formEncType: null,
        formMethod: null,
        formNoValidate: $c9b8512c43c3ea70$var$boolean,
        formTarget: null,
        headers: $c9b8512c43c3ea70$var$spaceSeparated,
        height: $c9b8512c43c3ea70$var$number,
        hidden: $c9b8512c43c3ea70$var$boolean,
        high: $c9b8512c43c3ea70$var$number,
        href: null,
        hrefLang: null,
        htmlFor: $c9b8512c43c3ea70$var$spaceSeparated,
        httpEquiv: $c9b8512c43c3ea70$var$spaceSeparated,
        id: null,
        imageSizes: null,
        imageSrcSet: $c9b8512c43c3ea70$var$commaSeparated,
        inputMode: null,
        integrity: null,
        is: null,
        isMap: $c9b8512c43c3ea70$var$boolean,
        itemId: null,
        itemProp: $c9b8512c43c3ea70$var$spaceSeparated,
        itemRef: $c9b8512c43c3ea70$var$spaceSeparated,
        itemScope: $c9b8512c43c3ea70$var$boolean,
        itemType: $c9b8512c43c3ea70$var$spaceSeparated,
        kind: null,
        label: null,
        lang: null,
        language: null,
        list: null,
        loop: $c9b8512c43c3ea70$var$boolean,
        low: $c9b8512c43c3ea70$var$number,
        manifest: null,
        max: null,
        maxLength: $c9b8512c43c3ea70$var$number,
        media: null,
        method: null,
        min: null,
        minLength: $c9b8512c43c3ea70$var$number,
        multiple: $c9b8512c43c3ea70$var$boolean,
        muted: $c9b8512c43c3ea70$var$boolean,
        name: null,
        nonce: null,
        noModule: $c9b8512c43c3ea70$var$boolean,
        noValidate: $c9b8512c43c3ea70$var$boolean,
        onAbort: null,
        onAfterPrint: null,
        onAuxClick: null,
        onBeforePrint: null,
        onBeforeUnload: null,
        onBlur: null,
        onCancel: null,
        onCanPlay: null,
        onCanPlayThrough: null,
        onChange: null,
        onClick: null,
        onClose: null,
        onContextMenu: null,
        onCopy: null,
        onCueChange: null,
        onCut: null,
        onDblClick: null,
        onDrag: null,
        onDragEnd: null,
        onDragEnter: null,
        onDragExit: null,
        onDragLeave: null,
        onDragOver: null,
        onDragStart: null,
        onDrop: null,
        onDurationChange: null,
        onEmptied: null,
        onEnded: null,
        onError: null,
        onFocus: null,
        onFormData: null,
        onHashChange: null,
        onInput: null,
        onInvalid: null,
        onKeyDown: null,
        onKeyPress: null,
        onKeyUp: null,
        onLanguageChange: null,
        onLoad: null,
        onLoadedData: null,
        onLoadedMetadata: null,
        onLoadEnd: null,
        onLoadStart: null,
        onMessage: null,
        onMessageError: null,
        onMouseDown: null,
        onMouseEnter: null,
        onMouseLeave: null,
        onMouseMove: null,
        onMouseOut: null,
        onMouseOver: null,
        onMouseUp: null,
        onOffline: null,
        onOnline: null,
        onPageHide: null,
        onPageShow: null,
        onPaste: null,
        onPause: null,
        onPlay: null,
        onPlaying: null,
        onPopState: null,
        onProgress: null,
        onRateChange: null,
        onRejectionHandled: null,
        onReset: null,
        onResize: null,
        onScroll: null,
        onSecurityPolicyViolation: null,
        onSeeked: null,
        onSeeking: null,
        onSelect: null,
        onSlotChange: null,
        onStalled: null,
        onStorage: null,
        onSubmit: null,
        onSuspend: null,
        onTimeUpdate: null,
        onToggle: null,
        onUnhandledRejection: null,
        onUnload: null,
        onVolumeChange: null,
        onWaiting: null,
        onWheel: null,
        open: $c9b8512c43c3ea70$var$boolean,
        optimum: $c9b8512c43c3ea70$var$number,
        pattern: null,
        ping: $c9b8512c43c3ea70$var$spaceSeparated,
        placeholder: null,
        playsInline: $c9b8512c43c3ea70$var$boolean,
        poster: null,
        preload: null,
        readOnly: $c9b8512c43c3ea70$var$boolean,
        referrerPolicy: null,
        rel: $c9b8512c43c3ea70$var$spaceSeparated,
        required: $c9b8512c43c3ea70$var$boolean,
        reversed: $c9b8512c43c3ea70$var$boolean,
        rows: $c9b8512c43c3ea70$var$number,
        rowSpan: $c9b8512c43c3ea70$var$number,
        sandbox: $c9b8512c43c3ea70$var$spaceSeparated,
        scope: null,
        scoped: $c9b8512c43c3ea70$var$boolean,
        seamless: $c9b8512c43c3ea70$var$boolean,
        selected: $c9b8512c43c3ea70$var$boolean,
        shape: null,
        size: $c9b8512c43c3ea70$var$number,
        sizes: null,
        slot: null,
        span: $c9b8512c43c3ea70$var$number,
        spellCheck: $c9b8512c43c3ea70$var$booleanish,
        src: null,
        srcDoc: null,
        srcLang: null,
        srcSet: $c9b8512c43c3ea70$var$commaSeparated,
        start: $c9b8512c43c3ea70$var$number,
        step: null,
        style: null,
        tabIndex: $c9b8512c43c3ea70$var$number,
        target: null,
        title: null,
        translate: null,
        type: null,
        typeMustMatch: $c9b8512c43c3ea70$var$boolean,
        useMap: null,
        value: $c9b8512c43c3ea70$var$booleanish,
        width: $c9b8512c43c3ea70$var$number,
        wrap: null,
        // Legacy.
        // See: https://html.spec.whatwg.org/#other-elements,-attributes-and-apis
        align: null,
        aLink: null,
        archive: $c9b8512c43c3ea70$var$spaceSeparated,
        axis: null,
        background: null,
        bgColor: null,
        border: $c9b8512c43c3ea70$var$number,
        borderColor: null,
        bottomMargin: $c9b8512c43c3ea70$var$number,
        cellPadding: null,
        cellSpacing: null,
        char: null,
        charOff: null,
        classId: null,
        clear: null,
        code: null,
        codeBase: null,
        codeType: null,
        color: null,
        compact: $c9b8512c43c3ea70$var$boolean,
        declare: $c9b8512c43c3ea70$var$boolean,
        event: null,
        face: null,
        frame: null,
        frameBorder: null,
        hSpace: $c9b8512c43c3ea70$var$number,
        leftMargin: $c9b8512c43c3ea70$var$number,
        link: null,
        longDesc: null,
        lowSrc: null,
        marginHeight: $c9b8512c43c3ea70$var$number,
        marginWidth: $c9b8512c43c3ea70$var$number,
        noResize: $c9b8512c43c3ea70$var$boolean,
        noHref: $c9b8512c43c3ea70$var$boolean,
        noShade: $c9b8512c43c3ea70$var$boolean,
        noWrap: $c9b8512c43c3ea70$var$boolean,
        object: null,
        profile: null,
        prompt: null,
        rev: null,
        rightMargin: $c9b8512c43c3ea70$var$number,
        rules: null,
        scheme: null,
        scrolling: $c9b8512c43c3ea70$var$booleanish,
        standby: null,
        summary: null,
        text: null,
        topMargin: $c9b8512c43c3ea70$var$number,
        valueType: null,
        version: null,
        vAlign: null,
        vLink: null,
        vSpace: $c9b8512c43c3ea70$var$number,
        // Non-standard Properties.
        allowTransparency: null,
        autoCorrect: null,
        autoSave: null,
        disablePictureInPicture: $c9b8512c43c3ea70$var$boolean,
        disableRemotePlayback: $c9b8512c43c3ea70$var$boolean,
        prefix: null,
        property: null,
        results: $c9b8512c43c3ea70$var$number,
        security: null,
        unselectable: null
    }
});

});


parcelRegister("gSyAZ", function(module, exports) {
"use strict";

var $5B5Uy = parcelRequire("5B5Uy");

var $fOaV0 = parcelRequire("fOaV0");

var $66rZX = parcelRequire("66rZX");

var $5vUqY = parcelRequire("5vUqY");

var $7PmIb = parcelRequire("7PmIb");

var $hzJz8 = parcelRequire("hzJz8");
module.exports = $5B5Uy([
    $66rZX,
    $fOaV0,
    $5vUqY,
    $7PmIb,
    $hzJz8
]);

});
parcelRegister("hzJz8", function(module, exports) {
"use strict";

var $8cx7u = parcelRequire("8cx7u");

var $ieLB3 = parcelRequire("ieLB3");

var $5ktOm = parcelRequire("5ktOm");
var $ccb90cf397990efb$var$boolean = $8cx7u.boolean;
var $ccb90cf397990efb$var$number = $8cx7u.number;
var $ccb90cf397990efb$var$spaceSeparated = $8cx7u.spaceSeparated;
var $ccb90cf397990efb$var$commaSeparated = $8cx7u.commaSeparated;
var $ccb90cf397990efb$var$commaOrSpaceSeparated = $8cx7u.commaOrSpaceSeparated;
module.exports = $ieLB3({
    space: "svg",
    attributes: {
        accentHeight: "accent-height",
        alignmentBaseline: "alignment-baseline",
        arabicForm: "arabic-form",
        baselineShift: "baseline-shift",
        capHeight: "cap-height",
        className: "class",
        clipPath: "clip-path",
        clipRule: "clip-rule",
        colorInterpolation: "color-interpolation",
        colorInterpolationFilters: "color-interpolation-filters",
        colorProfile: "color-profile",
        colorRendering: "color-rendering",
        crossOrigin: "crossorigin",
        dataType: "datatype",
        dominantBaseline: "dominant-baseline",
        enableBackground: "enable-background",
        fillOpacity: "fill-opacity",
        fillRule: "fill-rule",
        floodColor: "flood-color",
        floodOpacity: "flood-opacity",
        fontFamily: "font-family",
        fontSize: "font-size",
        fontSizeAdjust: "font-size-adjust",
        fontStretch: "font-stretch",
        fontStyle: "font-style",
        fontVariant: "font-variant",
        fontWeight: "font-weight",
        glyphName: "glyph-name",
        glyphOrientationHorizontal: "glyph-orientation-horizontal",
        glyphOrientationVertical: "glyph-orientation-vertical",
        hrefLang: "hreflang",
        horizAdvX: "horiz-adv-x",
        horizOriginX: "horiz-origin-x",
        horizOriginY: "horiz-origin-y",
        imageRendering: "image-rendering",
        letterSpacing: "letter-spacing",
        lightingColor: "lighting-color",
        markerEnd: "marker-end",
        markerMid: "marker-mid",
        markerStart: "marker-start",
        navDown: "nav-down",
        navDownLeft: "nav-down-left",
        navDownRight: "nav-down-right",
        navLeft: "nav-left",
        navNext: "nav-next",
        navPrev: "nav-prev",
        navRight: "nav-right",
        navUp: "nav-up",
        navUpLeft: "nav-up-left",
        navUpRight: "nav-up-right",
        onAbort: "onabort",
        onActivate: "onactivate",
        onAfterPrint: "onafterprint",
        onBeforePrint: "onbeforeprint",
        onBegin: "onbegin",
        onCancel: "oncancel",
        onCanPlay: "oncanplay",
        onCanPlayThrough: "oncanplaythrough",
        onChange: "onchange",
        onClick: "onclick",
        onClose: "onclose",
        onCopy: "oncopy",
        onCueChange: "oncuechange",
        onCut: "oncut",
        onDblClick: "ondblclick",
        onDrag: "ondrag",
        onDragEnd: "ondragend",
        onDragEnter: "ondragenter",
        onDragExit: "ondragexit",
        onDragLeave: "ondragleave",
        onDragOver: "ondragover",
        onDragStart: "ondragstart",
        onDrop: "ondrop",
        onDurationChange: "ondurationchange",
        onEmptied: "onemptied",
        onEnd: "onend",
        onEnded: "onended",
        onError: "onerror",
        onFocus: "onfocus",
        onFocusIn: "onfocusin",
        onFocusOut: "onfocusout",
        onHashChange: "onhashchange",
        onInput: "oninput",
        onInvalid: "oninvalid",
        onKeyDown: "onkeydown",
        onKeyPress: "onkeypress",
        onKeyUp: "onkeyup",
        onLoad: "onload",
        onLoadedData: "onloadeddata",
        onLoadedMetadata: "onloadedmetadata",
        onLoadStart: "onloadstart",
        onMessage: "onmessage",
        onMouseDown: "onmousedown",
        onMouseEnter: "onmouseenter",
        onMouseLeave: "onmouseleave",
        onMouseMove: "onmousemove",
        onMouseOut: "onmouseout",
        onMouseOver: "onmouseover",
        onMouseUp: "onmouseup",
        onMouseWheel: "onmousewheel",
        onOffline: "onoffline",
        onOnline: "ononline",
        onPageHide: "onpagehide",
        onPageShow: "onpageshow",
        onPaste: "onpaste",
        onPause: "onpause",
        onPlay: "onplay",
        onPlaying: "onplaying",
        onPopState: "onpopstate",
        onProgress: "onprogress",
        onRateChange: "onratechange",
        onRepeat: "onrepeat",
        onReset: "onreset",
        onResize: "onresize",
        onScroll: "onscroll",
        onSeeked: "onseeked",
        onSeeking: "onseeking",
        onSelect: "onselect",
        onShow: "onshow",
        onStalled: "onstalled",
        onStorage: "onstorage",
        onSubmit: "onsubmit",
        onSuspend: "onsuspend",
        onTimeUpdate: "ontimeupdate",
        onToggle: "ontoggle",
        onUnload: "onunload",
        onVolumeChange: "onvolumechange",
        onWaiting: "onwaiting",
        onZoom: "onzoom",
        overlinePosition: "overline-position",
        overlineThickness: "overline-thickness",
        paintOrder: "paint-order",
        panose1: "panose-1",
        pointerEvents: "pointer-events",
        referrerPolicy: "referrerpolicy",
        renderingIntent: "rendering-intent",
        shapeRendering: "shape-rendering",
        stopColor: "stop-color",
        stopOpacity: "stop-opacity",
        strikethroughPosition: "strikethrough-position",
        strikethroughThickness: "strikethrough-thickness",
        strokeDashArray: "stroke-dasharray",
        strokeDashOffset: "stroke-dashoffset",
        strokeLineCap: "stroke-linecap",
        strokeLineJoin: "stroke-linejoin",
        strokeMiterLimit: "stroke-miterlimit",
        strokeOpacity: "stroke-opacity",
        strokeWidth: "stroke-width",
        tabIndex: "tabindex",
        textAnchor: "text-anchor",
        textDecoration: "text-decoration",
        textRendering: "text-rendering",
        typeOf: "typeof",
        underlinePosition: "underline-position",
        underlineThickness: "underline-thickness",
        unicodeBidi: "unicode-bidi",
        unicodeRange: "unicode-range",
        unitsPerEm: "units-per-em",
        vAlphabetic: "v-alphabetic",
        vHanging: "v-hanging",
        vIdeographic: "v-ideographic",
        vMathematical: "v-mathematical",
        vectorEffect: "vector-effect",
        vertAdvY: "vert-adv-y",
        vertOriginX: "vert-origin-x",
        vertOriginY: "vert-origin-y",
        wordSpacing: "word-spacing",
        writingMode: "writing-mode",
        xHeight: "x-height",
        // These were camelcased in Tiny. Now lowercased in SVG 2
        playbackOrder: "playbackorder",
        timelineBegin: "timelinebegin"
    },
    transform: $5ktOm,
    properties: {
        about: $ccb90cf397990efb$var$commaOrSpaceSeparated,
        accentHeight: $ccb90cf397990efb$var$number,
        accumulate: null,
        additive: null,
        alignmentBaseline: null,
        alphabetic: $ccb90cf397990efb$var$number,
        amplitude: $ccb90cf397990efb$var$number,
        arabicForm: null,
        ascent: $ccb90cf397990efb$var$number,
        attributeName: null,
        attributeType: null,
        azimuth: $ccb90cf397990efb$var$number,
        bandwidth: null,
        baselineShift: null,
        baseFrequency: null,
        baseProfile: null,
        bbox: null,
        begin: null,
        bias: $ccb90cf397990efb$var$number,
        by: null,
        calcMode: null,
        capHeight: $ccb90cf397990efb$var$number,
        className: $ccb90cf397990efb$var$spaceSeparated,
        clip: null,
        clipPath: null,
        clipPathUnits: null,
        clipRule: null,
        color: null,
        colorInterpolation: null,
        colorInterpolationFilters: null,
        colorProfile: null,
        colorRendering: null,
        content: null,
        contentScriptType: null,
        contentStyleType: null,
        crossOrigin: null,
        cursor: null,
        cx: null,
        cy: null,
        d: null,
        dataType: null,
        defaultAction: null,
        descent: $ccb90cf397990efb$var$number,
        diffuseConstant: $ccb90cf397990efb$var$number,
        direction: null,
        display: null,
        dur: null,
        divisor: $ccb90cf397990efb$var$number,
        dominantBaseline: null,
        download: $ccb90cf397990efb$var$boolean,
        dx: null,
        dy: null,
        edgeMode: null,
        editable: null,
        elevation: $ccb90cf397990efb$var$number,
        enableBackground: null,
        end: null,
        event: null,
        exponent: $ccb90cf397990efb$var$number,
        externalResourcesRequired: null,
        fill: null,
        fillOpacity: $ccb90cf397990efb$var$number,
        fillRule: null,
        filter: null,
        filterRes: null,
        filterUnits: null,
        floodColor: null,
        floodOpacity: null,
        focusable: null,
        focusHighlight: null,
        fontFamily: null,
        fontSize: null,
        fontSizeAdjust: null,
        fontStretch: null,
        fontStyle: null,
        fontVariant: null,
        fontWeight: null,
        format: null,
        fr: null,
        from: null,
        fx: null,
        fy: null,
        g1: $ccb90cf397990efb$var$commaSeparated,
        g2: $ccb90cf397990efb$var$commaSeparated,
        glyphName: $ccb90cf397990efb$var$commaSeparated,
        glyphOrientationHorizontal: null,
        glyphOrientationVertical: null,
        glyphRef: null,
        gradientTransform: null,
        gradientUnits: null,
        handler: null,
        hanging: $ccb90cf397990efb$var$number,
        hatchContentUnits: null,
        hatchUnits: null,
        height: null,
        href: null,
        hrefLang: null,
        horizAdvX: $ccb90cf397990efb$var$number,
        horizOriginX: $ccb90cf397990efb$var$number,
        horizOriginY: $ccb90cf397990efb$var$number,
        id: null,
        ideographic: $ccb90cf397990efb$var$number,
        imageRendering: null,
        initialVisibility: null,
        in: null,
        in2: null,
        intercept: $ccb90cf397990efb$var$number,
        k: $ccb90cf397990efb$var$number,
        k1: $ccb90cf397990efb$var$number,
        k2: $ccb90cf397990efb$var$number,
        k3: $ccb90cf397990efb$var$number,
        k4: $ccb90cf397990efb$var$number,
        kernelMatrix: $ccb90cf397990efb$var$commaOrSpaceSeparated,
        kernelUnitLength: null,
        keyPoints: null,
        keySplines: null,
        keyTimes: null,
        kerning: null,
        lang: null,
        lengthAdjust: null,
        letterSpacing: null,
        lightingColor: null,
        limitingConeAngle: $ccb90cf397990efb$var$number,
        local: null,
        markerEnd: null,
        markerMid: null,
        markerStart: null,
        markerHeight: null,
        markerUnits: null,
        markerWidth: null,
        mask: null,
        maskContentUnits: null,
        maskUnits: null,
        mathematical: null,
        max: null,
        media: null,
        mediaCharacterEncoding: null,
        mediaContentEncodings: null,
        mediaSize: $ccb90cf397990efb$var$number,
        mediaTime: null,
        method: null,
        min: null,
        mode: null,
        name: null,
        navDown: null,
        navDownLeft: null,
        navDownRight: null,
        navLeft: null,
        navNext: null,
        navPrev: null,
        navRight: null,
        navUp: null,
        navUpLeft: null,
        navUpRight: null,
        numOctaves: null,
        observer: null,
        offset: null,
        onAbort: null,
        onActivate: null,
        onAfterPrint: null,
        onBeforePrint: null,
        onBegin: null,
        onCancel: null,
        onCanPlay: null,
        onCanPlayThrough: null,
        onChange: null,
        onClick: null,
        onClose: null,
        onCopy: null,
        onCueChange: null,
        onCut: null,
        onDblClick: null,
        onDrag: null,
        onDragEnd: null,
        onDragEnter: null,
        onDragExit: null,
        onDragLeave: null,
        onDragOver: null,
        onDragStart: null,
        onDrop: null,
        onDurationChange: null,
        onEmptied: null,
        onEnd: null,
        onEnded: null,
        onError: null,
        onFocus: null,
        onFocusIn: null,
        onFocusOut: null,
        onHashChange: null,
        onInput: null,
        onInvalid: null,
        onKeyDown: null,
        onKeyPress: null,
        onKeyUp: null,
        onLoad: null,
        onLoadedData: null,
        onLoadedMetadata: null,
        onLoadStart: null,
        onMessage: null,
        onMouseDown: null,
        onMouseEnter: null,
        onMouseLeave: null,
        onMouseMove: null,
        onMouseOut: null,
        onMouseOver: null,
        onMouseUp: null,
        onMouseWheel: null,
        onOffline: null,
        onOnline: null,
        onPageHide: null,
        onPageShow: null,
        onPaste: null,
        onPause: null,
        onPlay: null,
        onPlaying: null,
        onPopState: null,
        onProgress: null,
        onRateChange: null,
        onRepeat: null,
        onReset: null,
        onResize: null,
        onScroll: null,
        onSeeked: null,
        onSeeking: null,
        onSelect: null,
        onShow: null,
        onStalled: null,
        onStorage: null,
        onSubmit: null,
        onSuspend: null,
        onTimeUpdate: null,
        onToggle: null,
        onUnload: null,
        onVolumeChange: null,
        onWaiting: null,
        onZoom: null,
        opacity: null,
        operator: null,
        order: null,
        orient: null,
        orientation: null,
        origin: null,
        overflow: null,
        overlay: null,
        overlinePosition: $ccb90cf397990efb$var$number,
        overlineThickness: $ccb90cf397990efb$var$number,
        paintOrder: null,
        panose1: null,
        path: null,
        pathLength: $ccb90cf397990efb$var$number,
        patternContentUnits: null,
        patternTransform: null,
        patternUnits: null,
        phase: null,
        ping: $ccb90cf397990efb$var$spaceSeparated,
        pitch: null,
        playbackOrder: null,
        pointerEvents: null,
        points: null,
        pointsAtX: $ccb90cf397990efb$var$number,
        pointsAtY: $ccb90cf397990efb$var$number,
        pointsAtZ: $ccb90cf397990efb$var$number,
        preserveAlpha: null,
        preserveAspectRatio: null,
        primitiveUnits: null,
        propagate: null,
        property: $ccb90cf397990efb$var$commaOrSpaceSeparated,
        r: null,
        radius: null,
        referrerPolicy: null,
        refX: null,
        refY: null,
        rel: $ccb90cf397990efb$var$commaOrSpaceSeparated,
        rev: $ccb90cf397990efb$var$commaOrSpaceSeparated,
        renderingIntent: null,
        repeatCount: null,
        repeatDur: null,
        requiredExtensions: $ccb90cf397990efb$var$commaOrSpaceSeparated,
        requiredFeatures: $ccb90cf397990efb$var$commaOrSpaceSeparated,
        requiredFonts: $ccb90cf397990efb$var$commaOrSpaceSeparated,
        requiredFormats: $ccb90cf397990efb$var$commaOrSpaceSeparated,
        resource: null,
        restart: null,
        result: null,
        rotate: null,
        rx: null,
        ry: null,
        scale: null,
        seed: null,
        shapeRendering: null,
        side: null,
        slope: null,
        snapshotTime: null,
        specularConstant: $ccb90cf397990efb$var$number,
        specularExponent: $ccb90cf397990efb$var$number,
        spreadMethod: null,
        spacing: null,
        startOffset: null,
        stdDeviation: null,
        stemh: null,
        stemv: null,
        stitchTiles: null,
        stopColor: null,
        stopOpacity: null,
        strikethroughPosition: $ccb90cf397990efb$var$number,
        strikethroughThickness: $ccb90cf397990efb$var$number,
        string: null,
        stroke: null,
        strokeDashArray: $ccb90cf397990efb$var$commaOrSpaceSeparated,
        strokeDashOffset: null,
        strokeLineCap: null,
        strokeLineJoin: null,
        strokeMiterLimit: $ccb90cf397990efb$var$number,
        strokeOpacity: $ccb90cf397990efb$var$number,
        strokeWidth: null,
        style: null,
        surfaceScale: $ccb90cf397990efb$var$number,
        syncBehavior: null,
        syncBehaviorDefault: null,
        syncMaster: null,
        syncTolerance: null,
        syncToleranceDefault: null,
        systemLanguage: $ccb90cf397990efb$var$commaOrSpaceSeparated,
        tabIndex: $ccb90cf397990efb$var$number,
        tableValues: null,
        target: null,
        targetX: $ccb90cf397990efb$var$number,
        targetY: $ccb90cf397990efb$var$number,
        textAnchor: null,
        textDecoration: null,
        textRendering: null,
        textLength: null,
        timelineBegin: null,
        title: null,
        transformBehavior: null,
        type: null,
        typeOf: $ccb90cf397990efb$var$commaOrSpaceSeparated,
        to: null,
        transform: null,
        u1: null,
        u2: null,
        underlinePosition: $ccb90cf397990efb$var$number,
        underlineThickness: $ccb90cf397990efb$var$number,
        unicode: null,
        unicodeBidi: null,
        unicodeRange: null,
        unitsPerEm: $ccb90cf397990efb$var$number,
        values: null,
        vAlphabetic: $ccb90cf397990efb$var$number,
        vMathematical: $ccb90cf397990efb$var$number,
        vectorEffect: null,
        vHanging: $ccb90cf397990efb$var$number,
        vIdeographic: $ccb90cf397990efb$var$number,
        version: null,
        vertAdvY: $ccb90cf397990efb$var$number,
        vertOriginX: $ccb90cf397990efb$var$number,
        vertOriginY: $ccb90cf397990efb$var$number,
        viewBox: null,
        viewTarget: null,
        visibility: null,
        width: null,
        widths: null,
        wordSpacing: null,
        writingMode: null,
        x: null,
        x1: null,
        x2: null,
        xChannelSelector: null,
        xHeight: $ccb90cf397990efb$var$number,
        y: null,
        y1: null,
        y2: null,
        yChannelSelector: null,
        z: null,
        zoomAndPan: null
    }
});

});


parcelRegister("ffG6I", function(module, exports) {
"use strict";

var $1j0Kh = parcelRequire("1j0Kh");

var $6rS13 = parcelRequire("6rS13");

var $3W6gM = parcelRequire("3W6gM");
var $b1a8eb5e87daf454$var$data = "data";
module.exports = $b1a8eb5e87daf454$var$find;
var $b1a8eb5e87daf454$var$valid = /^data[-\w.:]+$/i;
var $b1a8eb5e87daf454$var$dash = /-[a-z]/g;
var $b1a8eb5e87daf454$var$cap = /[A-Z]/g;
function $b1a8eb5e87daf454$var$find(schema, value) {
    var normal = $1j0Kh(value);
    var prop = value;
    var Type = $3W6gM;
    if (normal in schema.normal) return schema.property[schema.normal[normal]];
    if (normal.length > 4 && normal.slice(0, 4) === $b1a8eb5e87daf454$var$data && $b1a8eb5e87daf454$var$valid.test(value)) {
        // Attribute or property.
        if (value.charAt(4) === "-") prop = $b1a8eb5e87daf454$var$datasetToProperty(value);
        else value = $b1a8eb5e87daf454$var$datasetToAttribute(value);
        Type = $6rS13;
    }
    return new Type(prop, value);
}
function $b1a8eb5e87daf454$var$datasetToProperty(attribute) {
    var value = attribute.slice(5).replace($b1a8eb5e87daf454$var$dash, $b1a8eb5e87daf454$var$camelcase);
    return $b1a8eb5e87daf454$var$data + value.charAt(0).toUpperCase() + value.slice(1);
}
function $b1a8eb5e87daf454$var$datasetToAttribute(property) {
    var value = property.slice(4);
    if ($b1a8eb5e87daf454$var$dash.test(value)) return property;
    value = value.replace($b1a8eb5e87daf454$var$cap, $b1a8eb5e87daf454$var$kebab);
    if (value.charAt(0) !== "-") value = "-" + value;
    return $b1a8eb5e87daf454$var$data + value;
}
function $b1a8eb5e87daf454$var$kebab($0) {
    return "-" + $0.toLowerCase();
}
function $b1a8eb5e87daf454$var$camelcase($0) {
    return $0.charAt(1).toUpperCase();
}

});

parcelRegister("6pKpX", function(module, exports) {
module.exports = JSON.parse('{"classId":"classID","dataType":"datatype","itemId":"itemID","strokeDashArray":"strokeDasharray","strokeDashOffset":"strokeDashoffset","strokeLineCap":"strokeLinecap","strokeLineJoin":"strokeLinejoin","strokeMiterLimit":"strokeMiterlimit","typeOf":"typeof","xLinkActuate":"xlinkActuate","xLinkArcRole":"xlinkArcrole","xLinkHref":"xlinkHref","xLinkRole":"xlinkRole","xLinkShow":"xlinkShow","xLinkTitle":"xlinkTitle","xLinkType":"xlinkType","xmlnsXLink":"xmlnsXlink"}');

});

parcelRegister("dxv4b", function(module, exports) {

$parcel$export(module.exports, "parse", function () { return $9db6749ae4e98b85$export$98e6a39c04603d36; }, function (v) { return $9db6749ae4e98b85$export$98e6a39c04603d36 = v; });
$parcel$export(module.exports, "stringify", function () { return $9db6749ae4e98b85$export$fac44ee5b035f737; }, function (v) { return $9db6749ae4e98b85$export$fac44ee5b035f737 = v; });
var $9db6749ae4e98b85$export$98e6a39c04603d36;
var $9db6749ae4e98b85$export$fac44ee5b035f737;
"use strict";
$9db6749ae4e98b85$export$98e6a39c04603d36 = $9db6749ae4e98b85$var$parse;
$9db6749ae4e98b85$export$fac44ee5b035f737 = $9db6749ae4e98b85$var$stringify;
var $9db6749ae4e98b85$var$empty = "";
var $9db6749ae4e98b85$var$space = " ";
var $9db6749ae4e98b85$var$whiteSpace = /[ \t\n\r\f]+/g;
function $9db6749ae4e98b85$var$parse(value) {
    var input = String(value || $9db6749ae4e98b85$var$empty).trim();
    return input === $9db6749ae4e98b85$var$empty ? [] : input.split($9db6749ae4e98b85$var$whiteSpace);
}
function $9db6749ae4e98b85$var$stringify(values) {
    return values.join($9db6749ae4e98b85$var$space).trim();
}

});

parcelRegister("ll02G", function(module, exports) {

$parcel$export(module.exports, "parse", function () { return $f88b978602bb666f$export$98e6a39c04603d36; }, function (v) { return $f88b978602bb666f$export$98e6a39c04603d36 = v; });
$parcel$export(module.exports, "stringify", function () { return $f88b978602bb666f$export$fac44ee5b035f737; }, function (v) { return $f88b978602bb666f$export$fac44ee5b035f737 = v; });
var $f88b978602bb666f$export$98e6a39c04603d36;
var $f88b978602bb666f$export$fac44ee5b035f737;
"use strict";
$f88b978602bb666f$export$98e6a39c04603d36 = $f88b978602bb666f$var$parse;
$f88b978602bb666f$export$fac44ee5b035f737 = $f88b978602bb666f$var$stringify;
var $f88b978602bb666f$var$comma = ",";
var $f88b978602bb666f$var$space = " ";
var $f88b978602bb666f$var$empty = "";
// Parse comma-separated tokens to an array.
function $f88b978602bb666f$var$parse(value) {
    var values = [];
    var input = String(value || $f88b978602bb666f$var$empty);
    var index = input.indexOf($f88b978602bb666f$var$comma);
    var lastIndex = 0;
    var end = false;
    var val;
    while(!end){
        if (index === -1) {
            index = input.length;
            end = true;
        }
        val = input.slice(lastIndex, index).trim();
        if (val || !end) values.push(val);
        lastIndex = index + 1;
        index = input.indexOf($f88b978602bb666f$var$comma, lastIndex);
    }
    return values;
}
// Compile an array to comma-separated tokens.
// `options.padLeft` (default: `true`) pads a space left of each token, and
// `options.padRight` (default: `false`) pads a space to the right of each token.
function $f88b978602bb666f$var$stringify(values, options) {
    var settings = options || {};
    var left = settings.padLeft === false ? $f88b978602bb666f$var$empty : $f88b978602bb666f$var$space;
    var right = settings.padRight ? $f88b978602bb666f$var$space : $f88b978602bb666f$var$empty;
    // Ensure the last empty entry is seen.
    if (values[values.length - 1] === $f88b978602bb666f$var$empty) values = values.concat($f88b978602bb666f$var$empty);
    return values.join(right + $f88b978602bb666f$var$comma + left).trim();
}

});

parcelRegister("b9hO3", function(module, exports) {

var $kXXGL = parcelRequire("kXXGL");
/**
 * Parses inline style to object.
 *
 * @example
 * // returns { 'line-height': '42' }
 * StyleToObject('line-height: 42;');
 *
 * @param  {String}      style      - The inline style.
 * @param  {Function}    [iterator] - The iterator function.
 * @return {null|Object}
 */ function $81de58eebb75200f$var$StyleToObject(style, iterator) {
    var output = null;
    if (!style || typeof style !== "string") return output;
    var declaration;
    var declarations = $kXXGL(style);
    var hasIterator = typeof iterator === "function";
    var property;
    var value;
    for(var i = 0, len = declarations.length; i < len; i++){
        declaration = declarations[i];
        property = declaration.property;
        value = declaration.value;
        if (hasIterator) iterator(property, value, declaration);
        else if (value) {
            output || (output = {});
            output[property] = value;
        }
    }
    return output;
}
module.exports = $81de58eebb75200f$var$StyleToObject;

});
parcelRegister("kXXGL", function(module, exports) {
// http://www.w3.org/TR/CSS21/grammar.html
// https://github.com/visionmedia/css-parse/pull/49#issuecomment-30088027
var $f4379e4a25d88a25$var$COMMENT_REGEX = /\/\*[^*]*\*+([^/*][^*]*\*+)*\//g;
var $f4379e4a25d88a25$var$NEWLINE_REGEX = /\n/g;
var $f4379e4a25d88a25$var$WHITESPACE_REGEX = /^\s*/;
// declaration
var $f4379e4a25d88a25$var$PROPERTY_REGEX = /^(\*?[-#/*\\\w]+(\[[0-9a-z_-]+\])?)\s*/;
var $f4379e4a25d88a25$var$COLON_REGEX = /^:\s*/;
var $f4379e4a25d88a25$var$VALUE_REGEX = /^((?:'(?:\\'|.)*?'|"(?:\\"|.)*?"|\([^)]*?\)|[^};])+)/;
var $f4379e4a25d88a25$var$SEMICOLON_REGEX = /^[;\s]*/;
// https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/String/Trim#Polyfill
var $f4379e4a25d88a25$var$TRIM_REGEX = /^\s+|\s+$/g;
// strings
var $f4379e4a25d88a25$var$NEWLINE = "\n";
var $f4379e4a25d88a25$var$FORWARD_SLASH = "/";
var $f4379e4a25d88a25$var$ASTERISK = "*";
var $f4379e4a25d88a25$var$EMPTY_STRING = "";
// types
var $f4379e4a25d88a25$var$TYPE_COMMENT = "comment";
var $f4379e4a25d88a25$var$TYPE_DECLARATION = "declaration";
/**
 * @param {String} style
 * @param {Object} [options]
 * @return {Object[]}
 * @throws {TypeError}
 * @throws {Error}
 */ module.exports = function(style, options) {
    if (typeof style !== "string") throw new TypeError("First argument must be a string");
    if (!style) return [];
    options = options || {};
    /**
   * Positional.
   */ var lineno = 1;
    var column = 1;
    /**
   * Update lineno and column based on `str`.
   *
   * @param {String} str
   */ function updatePosition(str) {
        var lines = str.match($f4379e4a25d88a25$var$NEWLINE_REGEX);
        if (lines) lineno += lines.length;
        var i = str.lastIndexOf($f4379e4a25d88a25$var$NEWLINE);
        column = ~i ? str.length - i : column + str.length;
    }
    /**
   * Mark position and patch `node.position`.
   *
   * @return {Function}
   */ function position() {
        var start = {
            line: lineno,
            column: column
        };
        return function(node) {
            node.position = new Position(start);
            whitespace();
            return node;
        };
    }
    /**
   * Store position information for a node.
   *
   * @constructor
   * @property {Object} start
   * @property {Object} end
   * @property {undefined|String} source
   */ function Position(start) {
        this.start = start;
        this.end = {
            line: lineno,
            column: column
        };
        this.source = options.source;
    }
    /**
   * Non-enumerable source string.
   */ Position.prototype.content = style;
    var errorsList = [];
    /**
   * Error `msg`.
   *
   * @param {String} msg
   * @throws {Error}
   */ function error(msg) {
        var err = new Error(options.source + ":" + lineno + ":" + column + ": " + msg);
        err.reason = msg;
        err.filename = options.source;
        err.line = lineno;
        err.column = column;
        err.source = style;
        if (options.silent) errorsList.push(err);
        else throw err;
    }
    /**
   * Match `re` and return captures.
   *
   * @param {RegExp} re
   * @return {undefined|Array}
   */ function match(re) {
        var m = re.exec(style);
        if (!m) return;
        var str = m[0];
        updatePosition(str);
        style = style.slice(str.length);
        return m;
    }
    /**
   * Parse whitespace.
   */ function whitespace() {
        match($f4379e4a25d88a25$var$WHITESPACE_REGEX);
    }
    /**
   * Parse comments.
   *
   * @param {Object[]} [rules]
   * @return {Object[]}
   */ function comments(rules) {
        var c;
        rules = rules || [];
        while(c = comment())if (c !== false) rules.push(c);
        return rules;
    }
    /**
   * Parse comment.
   *
   * @return {Object}
   * @throws {Error}
   */ function comment() {
        var pos = position();
        if ($f4379e4a25d88a25$var$FORWARD_SLASH != style.charAt(0) || $f4379e4a25d88a25$var$ASTERISK != style.charAt(1)) return;
        var i = 2;
        while($f4379e4a25d88a25$var$EMPTY_STRING != style.charAt(i) && ($f4379e4a25d88a25$var$ASTERISK != style.charAt(i) || $f4379e4a25d88a25$var$FORWARD_SLASH != style.charAt(i + 1)))++i;
        i += 2;
        if ($f4379e4a25d88a25$var$EMPTY_STRING === style.charAt(i - 1)) return error("End of comment missing");
        var str = style.slice(2, i - 2);
        column += 2;
        updatePosition(str);
        style = style.slice(i);
        column += 2;
        return pos({
            type: $f4379e4a25d88a25$var$TYPE_COMMENT,
            comment: str
        });
    }
    /**
   * Parse declaration.
   *
   * @return {Object}
   * @throws {Error}
   */ function declaration() {
        var pos = position();
        // prop
        var prop = match($f4379e4a25d88a25$var$PROPERTY_REGEX);
        if (!prop) return;
        comment();
        // :
        if (!match($f4379e4a25d88a25$var$COLON_REGEX)) return error("property missing ':'");
        // val
        var val = match($f4379e4a25d88a25$var$VALUE_REGEX);
        var ret = pos({
            type: $f4379e4a25d88a25$var$TYPE_DECLARATION,
            property: $f4379e4a25d88a25$var$trim(prop[0].replace($f4379e4a25d88a25$var$COMMENT_REGEX, $f4379e4a25d88a25$var$EMPTY_STRING)),
            value: val ? $f4379e4a25d88a25$var$trim(val[0].replace($f4379e4a25d88a25$var$COMMENT_REGEX, $f4379e4a25d88a25$var$EMPTY_STRING)) : $f4379e4a25d88a25$var$EMPTY_STRING
        });
        // ;
        match($f4379e4a25d88a25$var$SEMICOLON_REGEX);
        return ret;
    }
    /**
   * Parse declarations.
   *
   * @return {Object[]}
   */ function declarations() {
        var decls = [];
        comments(decls);
        // declarations
        var decl;
        while(decl = declaration())if (decl !== false) {
            decls.push(decl);
            comments(decls);
        }
        return decls;
    }
    whitespace();
    return declarations();
};
/**
 * Trim `str`.
 *
 * @param {String} str
 * @return {String}
 */ function $f4379e4a25d88a25$var$trim(str) {
    return str ? str.replace($f4379e4a25d88a25$var$TRIM_REGEX, $f4379e4a25d88a25$var$EMPTY_STRING) : $f4379e4a25d88a25$var$EMPTY_STRING;
}

});


parcelRegister("aM3Le", function(module, exports) {
module.exports = JSON.parse('{"html":"http://www.w3.org/1999/xhtml","mathml":"http://www.w3.org/1998/Math/MathML","svg":"http://www.w3.org/2000/svg","xlink":"http://www.w3.org/1999/xlink","xml":"http://www.w3.org/XML/1998/namespace","xmlns":"http://www.w3.org/2000/xmlns/"}');

});


parcelRegister("6GMPt", function(module, exports) {
"use strict";

var $KDBsL = parcelRequire("KDBsL");
var $4dec8acf1bacf0c4$var$hasOwnProperty = Object.prototype.hasOwnProperty;
var $4dec8acf1bacf0c4$var$hastCssPropertyMap = {
    align: "text-align",
    valign: "vertical-align",
    height: "height",
    width: "width"
};
module.exports = function tableCellStyle(node) {
    $KDBsL(node, "element", $4dec8acf1bacf0c4$var$visitor);
    return node;
};
function $4dec8acf1bacf0c4$var$visitor(node) {
    if (node.tagName !== "tr" && node.tagName !== "td" && node.tagName !== "th") return;
    var hastName;
    var cssName;
    for(hastName in $4dec8acf1bacf0c4$var$hastCssPropertyMap){
        if (!$4dec8acf1bacf0c4$var$hasOwnProperty.call($4dec8acf1bacf0c4$var$hastCssPropertyMap, hastName) || node.properties[hastName] === undefined) continue;
        cssName = $4dec8acf1bacf0c4$var$hastCssPropertyMap[hastName];
        $4dec8acf1bacf0c4$var$appendStyle(node, cssName, node.properties[hastName]);
        delete node.properties[hastName];
    }
}
function $4dec8acf1bacf0c4$var$appendStyle(node, property, value) {
    var prevStyle = (node.properties.style || "").trim();
    if (prevStyle && !/;\s*/.test(prevStyle)) prevStyle += ";";
    if (prevStyle) prevStyle += " ";
    var nextStyle = prevStyle + property + ": " + value + ";";
    node.properties.style = nextStyle;
}

});


parcelRegister("1irrc", function(module, exports) {
var $0f1cc16d68d0414a$var$cache = {};
function $0f1cc16d68d0414a$var$escapeRegExp(str) {
    return str.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, "\\$&");
}
/**
 * Replaces variable placeholders inside a string with any given data. Each key
 * in `data` corresponds to a variable placeholder name in `str`.
 *
 * Usage:
 * {{{
 * template('My name is ${name} and I am ${age} years old.', { name: 'Bob', age: '65' });
 * }}}
 *
 * @param  String str     A string containing variable place-holders.
 * @param  Object data    A key, value array where each key stands for a place-holder variable
 *                        name to be replaced with value.
 * @param  Object options Available options are:
 *                        - `'before'`: The character or string in front of the name of the variable
 *                          place-holder (defaults to `'${'`).
 *                        - `'after'`: The character or string after the name of the variable
 *                          place-holder (defaults to `}`).
 *                        - `'escape'`: The character or string used to escape the before character or string
 *                          (defaults to `'\\'`).
 *                        - `'clean'`: A boolean or array with instructions for cleaning.
 * @return String
 */ function $0f1cc16d68d0414a$var$template(str, data, options) {
    var data = data || {};
    var options = options || {};
    var keys = Array.isArray(data) ? Array.apply(null, {
        length: data.length
    }).map(Number.call, Number) : Object.keys(data);
    var len = keys.length;
    if (!len) return str;
    var before = options.before !== undefined ? options.before : "${";
    var after = options.after !== undefined ? options.after : "}";
    var escape = options.escape !== undefined ? options.escape : "\\";
    var clean = options.clean !== undefined ? options.clean : false;
    $0f1cc16d68d0414a$var$cache[escape] = $0f1cc16d68d0414a$var$cache[escape] || $0f1cc16d68d0414a$var$escapeRegExp(escape);
    $0f1cc16d68d0414a$var$cache[before] = $0f1cc16d68d0414a$var$cache[before] || $0f1cc16d68d0414a$var$escapeRegExp(before);
    $0f1cc16d68d0414a$var$cache[after] = $0f1cc16d68d0414a$var$cache[after] || $0f1cc16d68d0414a$var$escapeRegExp(after);
    var begin = escape ? "(" + $0f1cc16d68d0414a$var$cache[escape] + ")?" + $0f1cc16d68d0414a$var$cache[before] : $0f1cc16d68d0414a$var$cache[before];
    var end = $0f1cc16d68d0414a$var$cache[after];
    for(var i = 0; i < len; i++)str = str.replace(new RegExp(begin + String(keys[i]) + end, "g"), function(match, behind) {
        return behind ? match : String(data[keys[i]]);
    });
    if (escape) str = str.replace(new RegExp($0f1cc16d68d0414a$var$escapeRegExp(escape) + $0f1cc16d68d0414a$var$escapeRegExp(before), "g"), before);
    return clean ? $0f1cc16d68d0414a$var$template.clean(str, options) : str;
}
/**
 * Cleans up a formatted string with given `options` depending
 * on the `'clean'` option. The goal of this function is to replace all whitespace
 * and unneeded mark-up around place-holders that did not get replaced by `Text::insert()`.
 *
 * @param  String str     The string to clean.
 * @param  Object options Available options are:
 *                        - `'before'`: characters marking the start of targeted substring.
 *                        - `'after'`: characters marking the end of targeted substring.
 *                        - `'escape'`: The character or string used to escape the before character or string
 *                          (defaults to `'\\'`).
 *                        - `'gap'`: Regular expression matching gaps.
 *                        - `'word'`: Regular expression matching words.
 *                        - `'replacement'`: String to use for cleaned substrings (defaults to `''`).
 * @return String         The cleaned string.
 */ $0f1cc16d68d0414a$var$template.clean = function(str, options) {
    var options = options || {};
    var before = options.before !== undefined ? options.before : "${";
    var after = options.after !== undefined ? options.after : "}";
    var escape = options.escape !== undefined ? options.escape : "\\";
    var word = options.word !== undefined ? options.word : "[\\w,.]+";
    var gap = options.gap !== undefined ? options.gap : "(\\s*(?:(?:and|or|,)\\s*)?)";
    var replacement = options.replacement !== undefined ? options.replacement : "";
    $0f1cc16d68d0414a$var$cache[escape] = $0f1cc16d68d0414a$var$cache[escape] || $0f1cc16d68d0414a$var$escapeRegExp(escape);
    $0f1cc16d68d0414a$var$cache[before] = $0f1cc16d68d0414a$var$cache[before] || $0f1cc16d68d0414a$var$escapeRegExp(before);
    $0f1cc16d68d0414a$var$cache[after] = $0f1cc16d68d0414a$var$cache[after] || $0f1cc16d68d0414a$var$escapeRegExp(after);
    var begin = escape ? "(" + $0f1cc16d68d0414a$var$cache[escape] + ")?" + $0f1cc16d68d0414a$var$cache[before] : $0f1cc16d68d0414a$var$cache[before];
    var end = $0f1cc16d68d0414a$var$cache[after];
    str = str.replace(new RegExp(gap + begin + word + end + gap, "g"), function(match, before, behind, after) {
        if (behind) return match;
        if (before && after && before.trim() === after.trim()) {
            if (before.trim() || before && after) return before + replacement;
        }
        return replacement;
    });
    if (escape) str = str.replace(new RegExp($0f1cc16d68d0414a$var$escapeRegExp(escape) + $0f1cc16d68d0414a$var$escapeRegExp(before)), before);
    return str;
};
module.exports = $0f1cc16d68d0414a$var$template;

});

parcelRegister("kvHhM", function(module, exports) {

$parcel$export(module.exports, "Title", function () { return $eee84788f0a161e2$export$f99233281efd08a0; });
$parcel$export(module.exports, "MainHeading", function () { return $eee84788f0a161e2$export$b8da7edf2c95385a; });
$parcel$export(module.exports, "MainHeadingSmaller", function () { return $eee84788f0a161e2$export$63f51c2867992028; });
$parcel$export(module.exports, "SectionHeading", function () { return $eee84788f0a161e2$export$72d7ca7a5d1d4807; });
$parcel$export(module.exports, "NormalText", function () { return $eee84788f0a161e2$export$c68ad5affd687b01; });
$parcel$export(module.exports, "SubtleText", function () { return $eee84788f0a161e2$export$474d9b539a9b2a24; });

var $co7DE = parcelRequire("co7DE");

var $7b1Lp = parcelRequire("7b1Lp");

var $cQNHH = parcelRequire("cQNHH");
parcelRequire("8u8eZ");
function $eee84788f0a161e2$export$f99233281efd08a0(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement((0, $co7DE.default), {
        ...props,
        variant: "h1"
    });
}
function $eee84788f0a161e2$export$b8da7edf2c95385a({ noUnderline: noUnderline, ...props }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement((0, $co7DE.default), {
        ...props,
        underline: noUnderline ? "false" : "true",
        variant: "h2"
    });
}
$eee84788f0a161e2$export$b8da7edf2c95385a.defaultProps = {
    noUnderline: false
};
const $eee84788f0a161e2$var$useHeadingSmallerStyles = (0, $7b1Lp.default)({
    root: {
        fontWeight: 600,
        fontSize: 16,
        marginBottom: 20,
        marginTop: 20,
        lineHeight: "22px"
    }
});
const $eee84788f0a161e2$export$63f51c2867992028 = function MainHeadingSmaller({ align: align, ...props }) {
    const classes = $eee84788f0a161e2$var$useHeadingSmallerStyles();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement((0, $co7DE.default), {
        ...props,
        classes: classes,
        style: {
            textAlign: align
        },
        variant: "h2"
    });
};
$eee84788f0a161e2$export$63f51c2867992028.defaultProps = {
    align: "left"
};
function $eee84788f0a161e2$export$72d7ca7a5d1d4807(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement((0, $co7DE.default), {
        ...props,
        variant: "h3"
    });
}
function $eee84788f0a161e2$export$c68ad5affd687b01(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement((0, $co7DE.default), {
        ...props,
        variant: "body1"
    });
}
function $eee84788f0a161e2$export$474d9b539a9b2a24(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement((0, $co7DE.default), {
        ...props,
        variant: "body2"
    });
}

});



parcelRegister("8p3P7", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $61e39fd0ab6b61a2$export$2e2bcd8739ae039; });

var $cQNHH = parcelRequire("cQNHH");
parcelRequire("8u8eZ");

var $8mLXY = parcelRequire("8mLXY");
function $61e39fd0ab6b61a2$var$LazyLoading({ children: children }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement((0, $cQNHH.Suspense), {
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement((0, $8mLXY.default), {
            dark: true
        })
    }, children);
}
var $61e39fd0ab6b61a2$export$2e2bcd8739ae039 = $61e39fd0ab6b61a2$var$LazyLoading;

});

parcelRegister("aJjY6", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7cfd98a9e1965a4c$export$2e2bcd8739ae039; });

var $fsWgf = parcelRequire("fsWgf");

var $gtn2B = parcelRequire("gtn2B");

var $cQNHH = parcelRequire("cQNHH");

var $1xEYC = parcelRequire("1xEYC");

var $bKF6r = parcelRequire("bKF6r");

var $eyd6T = parcelRequire("eyd6T");

var $fekDk = parcelRequire("fekDk");

var $hhBX2 = parcelRequire("hhBX2");
var $7cfd98a9e1965a4c$var$SPACINGS = [
    0,
    1,
    2,
    3,
    4,
    5,
    6,
    7,
    8,
    9,
    10
];
var $7cfd98a9e1965a4c$var$GRID_SIZES = [
    "auto",
    true,
    1,
    2,
    3,
    4,
    5,
    6,
    7,
    8,
    9,
    10,
    11,
    12
];
function $7cfd98a9e1965a4c$var$generateGrid(globalStyles, theme, breakpoint) {
    var styles = {};
    $7cfd98a9e1965a4c$var$GRID_SIZES.forEach(function(size) {
        var key = "grid-".concat(breakpoint, "-").concat(size);
        if (size === true) {
            // For the auto layouting
            styles[key] = {
                flexBasis: 0,
                flexGrow: 1,
                maxWidth: "100%"
            };
            return;
        }
        if (size === "auto") {
            styles[key] = {
                flexBasis: "auto",
                flexGrow: 0,
                maxWidth: "none"
            };
            return;
        } // Keep 7 significant numbers.
        var width = "".concat(Math.round(size / 12 * 10e7) / 10e5, "%"); // Close to the bootstrap implementation:
        // https://github.com/twbs/bootstrap/blob/8fccaa2439e97ec72a4b7dc42ccc1f649790adb0/scss/mixins/_grid.scss#L41
        styles[key] = {
            flexBasis: width,
            flexGrow: 0,
            maxWidth: width
        };
    }); // No need for a media query for the first size.
    if (breakpoint === "xs") (0, $gtn2B.default)(globalStyles, styles);
    else globalStyles[theme.breakpoints.up(breakpoint)] = styles;
}
function $7cfd98a9e1965a4c$var$getOffset(val) {
    var div = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
    var parse = parseFloat(val);
    return "".concat(parse / div).concat(String(val).replace(String(parse), "") || "px");
}
function $7cfd98a9e1965a4c$var$generateGutter(theme, breakpoint) {
    var styles = {};
    $7cfd98a9e1965a4c$var$SPACINGS.forEach(function(spacing) {
        var themeSpacing = theme.spacing(spacing);
        if (themeSpacing === 0) return;
        styles["spacing-".concat(breakpoint, "-").concat(spacing)] = {
            margin: "-".concat($7cfd98a9e1965a4c$var$getOffset(themeSpacing, 2)),
            width: "calc(100% + ".concat($7cfd98a9e1965a4c$var$getOffset(themeSpacing), ")"),
            "& > $item": {
                padding: $7cfd98a9e1965a4c$var$getOffset(themeSpacing, 2)
            }
        };
    });
    return styles;
} // Default CSS values
var $7cfd98a9e1965a4c$export$9dd6ff9ea0189349 = function styles(theme) {
    return (0, $gtn2B.default)({
        /* Styles applied to the root element. */ root: {},
        /* Styles applied to the root element if `container={true}`. */ container: {
            boxSizing: "border-box",
            display: "flex",
            flexWrap: "wrap",
            width: "100%"
        },
        /* Styles applied to the root element if `item={true}`. */ item: {
            boxSizing: "border-box",
            margin: "0" // For instance, it's useful when used with a `figure` element.
        },
        /* Styles applied to the root element if `zeroMinWidth={true}`. */ zeroMinWidth: {
            minWidth: 0
        },
        /* Styles applied to the root element if `direction="column"`. */ "direction-xs-column": {
            flexDirection: "column"
        },
        /* Styles applied to the root element if `direction="column-reverse"`. */ "direction-xs-column-reverse": {
            flexDirection: "column-reverse"
        },
        /* Styles applied to the root element if `direction="row-reverse"`. */ "direction-xs-row-reverse": {
            flexDirection: "row-reverse"
        },
        /* Styles applied to the root element if `wrap="nowrap"`. */ "wrap-xs-nowrap": {
            flexWrap: "nowrap"
        },
        /* Styles applied to the root element if `wrap="reverse"`. */ "wrap-xs-wrap-reverse": {
            flexWrap: "wrap-reverse"
        },
        /* Styles applied to the root element if `alignItems="center"`. */ "align-items-xs-center": {
            alignItems: "center"
        },
        /* Styles applied to the root element if `alignItems="flex-start"`. */ "align-items-xs-flex-start": {
            alignItems: "flex-start"
        },
        /* Styles applied to the root element if `alignItems="flex-end"`. */ "align-items-xs-flex-end": {
            alignItems: "flex-end"
        },
        /* Styles applied to the root element if `alignItems="baseline"`. */ "align-items-xs-baseline": {
            alignItems: "baseline"
        },
        /* Styles applied to the root element if `alignContent="center"`. */ "align-content-xs-center": {
            alignContent: "center"
        },
        /* Styles applied to the root element if `alignContent="flex-start"`. */ "align-content-xs-flex-start": {
            alignContent: "flex-start"
        },
        /* Styles applied to the root element if `alignContent="flex-end"`. */ "align-content-xs-flex-end": {
            alignContent: "flex-end"
        },
        /* Styles applied to the root element if `alignContent="space-between"`. */ "align-content-xs-space-between": {
            alignContent: "space-between"
        },
        /* Styles applied to the root element if `alignContent="space-around"`. */ "align-content-xs-space-around": {
            alignContent: "space-around"
        },
        /* Styles applied to the root element if `justifyContent="center"`. */ "justify-content-xs-center": {
            justifyContent: "center"
        },
        /* Styles applied to the root element if `justifyContent="flex-end"`. */ "justify-content-xs-flex-end": {
            justifyContent: "flex-end"
        },
        /* Styles applied to the root element if `justifyContent="space-between"`. */ "justify-content-xs-space-between": {
            justifyContent: "space-between"
        },
        /* Styles applied to the root element if `justifyContent="space-around"`. */ "justify-content-xs-space-around": {
            justifyContent: "space-around"
        },
        /* Styles applied to the root element if `justifyContent="space-evenly"`. */ "justify-content-xs-space-evenly": {
            justifyContent: "space-evenly"
        }
    }, $7cfd98a9e1965a4c$var$generateGutter(theme, "xs"), theme.breakpoints.keys.reduce(function(accumulator, key) {
        // Use side effect over immutability for better performance.
        $7cfd98a9e1965a4c$var$generateGrid(accumulator, theme, key);
        return accumulator;
    }, {}));
};
var $7cfd98a9e1965a4c$var$Grid = /*#__PURE__*/ $cQNHH.forwardRef(function Grid(props, ref) {
    var _props$alignContent = props.alignContent, alignContent = _props$alignContent === void 0 ? "stretch" : _props$alignContent, _props$alignItems = props.alignItems, alignItems = _props$alignItems === void 0 ? "stretch" : _props$alignItems, classes = props.classes, classNameProp = props.className, _props$component = props.component, Component = _props$component === void 0 ? "div" : _props$component, _props$container = props.container, container = _props$container === void 0 ? false : _props$container, _props$direction = props.direction, direction = _props$direction === void 0 ? "row" : _props$direction, _props$item = props.item, item = _props$item === void 0 ? false : _props$item, justify = props.justify, _props$justifyContent = props.justifyContent, justifyContent = _props$justifyContent === void 0 ? "flex-start" : _props$justifyContent, _props$lg = props.lg, lg = _props$lg === void 0 ? false : _props$lg, _props$md = props.md, md = _props$md === void 0 ? false : _props$md, _props$sm = props.sm, sm = _props$sm === void 0 ? false : _props$sm, _props$spacing = props.spacing, spacing = _props$spacing === void 0 ? 0 : _props$spacing, _props$wrap = props.wrap, wrap = _props$wrap === void 0 ? "wrap" : _props$wrap, _props$xl = props.xl, xl = _props$xl === void 0 ? false : _props$xl, _props$xs = props.xs, xs = _props$xs === void 0 ? false : _props$xs, _props$zeroMinWidth = props.zeroMinWidth, zeroMinWidth = _props$zeroMinWidth === void 0 ? false : _props$zeroMinWidth, other = (0, $fsWgf.default)(props, [
        "alignContent",
        "alignItems",
        "classes",
        "className",
        "component",
        "container",
        "direction",
        "item",
        "justify",
        "justifyContent",
        "lg",
        "md",
        "sm",
        "spacing",
        "wrap",
        "xl",
        "xs",
        "zeroMinWidth"
    ]);
    var className = (0, $bKF6r.default)(classes.root, classNameProp, container && [
        classes.container,
        spacing !== 0 && classes["spacing-xs-".concat(String(spacing))]
    ], item && classes.item, zeroMinWidth && classes.zeroMinWidth, direction !== "row" && classes["direction-xs-".concat(String(direction))], wrap !== "wrap" && classes["wrap-xs-".concat(String(wrap))], alignItems !== "stretch" && classes["align-items-xs-".concat(String(alignItems))], alignContent !== "stretch" && classes["align-content-xs-".concat(String(alignContent))], (justify || justifyContent) !== "flex-start" && classes["justify-content-xs-".concat(String(justify || justifyContent))], xs !== false && classes["grid-xs-".concat(String(xs))], sm !== false && classes["grid-sm-".concat(String(sm))], md !== false && classes["grid-md-".concat(String(md))], lg !== false && classes["grid-lg-".concat(String(lg))], xl !== false && classes["grid-xl-".concat(String(xl))]);
    return /*#__PURE__*/ $cQNHH.createElement(Component, (0, $gtn2B.default)({
        className: className,
        ref: ref
    }, other));
});
$7cfd98a9e1965a4c$var$Grid.propTypes = {
    /**
   * Defines the `align-content` style property.
   * It's applied for all screen sizes.
   */ alignContent: (0, (/*@__PURE__*/$parcel$interopDefault($1xEYC))).oneOf([
        "stretch",
        "center",
        "flex-start",
        "flex-end",
        "space-between",
        "space-around"
    ]),
    /**
   * Defines the `align-items` style property.
   * It's applied for all screen sizes.
   */ alignItems: (0, (/*@__PURE__*/$parcel$interopDefault($1xEYC))).oneOf([
        "flex-start",
        "center",
        "flex-end",
        "stretch",
        "baseline"
    ]),
    /**
   * The content of the component.
   */ children: (0, (/*@__PURE__*/$parcel$interopDefault($1xEYC))).node,
    /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */ classes: (0, (/*@__PURE__*/$parcel$interopDefault($1xEYC))).object.isRequired,
    /**
   * @ignore
   */ className: (0, (/*@__PURE__*/$parcel$interopDefault($1xEYC))).string,
    /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */ component: (0, (/*@__PURE__*/$parcel$interopDefault($1xEYC)))/* @typescript-to-proptypes-ignore */ .elementType,
    /**
   * If `true`, the component will have the flex *container* behavior.
   * You should be wrapping *items* with a *container*.
   */ container: (0, (/*@__PURE__*/$parcel$interopDefault($1xEYC))).bool,
    /**
   * Defines the `flex-direction` style property.
   * It is applied for all screen sizes.
   */ direction: (0, (/*@__PURE__*/$parcel$interopDefault($1xEYC))).oneOf([
        "row",
        "row-reverse",
        "column",
        "column-reverse"
    ]),
    /**
   * If `true`, the component will have the flex *item* behavior.
   * You should be wrapping *items* with a *container*.
   */ item: (0, (/*@__PURE__*/$parcel$interopDefault($1xEYC))).bool,
    /**
   * Defines the `justify-content` style property.
   * It is applied for all screen sizes.
   * @deprecated Use `justifyContent` instead, the prop was renamed
   */ justify: (0, $hhBX2.default)((0, (/*@__PURE__*/$parcel$interopDefault($1xEYC))).oneOf([
        "flex-start",
        "center",
        "flex-end",
        "space-between",
        "space-around",
        "space-evenly"
    ]), "Use `justifyContent` instead, the prop was renamed."),
    /**
   * Defines the `justify-content` style property.
   * It is applied for all screen sizes.
   */ justifyContent: (0, (/*@__PURE__*/$parcel$interopDefault($1xEYC))).oneOf([
        "flex-start",
        "center",
        "flex-end",
        "space-between",
        "space-around",
        "space-evenly"
    ]),
    /**
   * Defines the number of grids the component is going to use.
   * It's applied for the `lg` breakpoint and wider screens if not overridden.
   */ lg: (0, (/*@__PURE__*/$parcel$interopDefault($1xEYC))).oneOf([
        false,
        "auto",
        true,
        1,
        2,
        3,
        4,
        5,
        6,
        7,
        8,
        9,
        10,
        11,
        12
    ]),
    /**
   * Defines the number of grids the component is going to use.
   * It's applied for the `md` breakpoint and wider screens if not overridden.
   */ md: (0, (/*@__PURE__*/$parcel$interopDefault($1xEYC))).oneOf([
        false,
        "auto",
        true,
        1,
        2,
        3,
        4,
        5,
        6,
        7,
        8,
        9,
        10,
        11,
        12
    ]),
    /**
   * Defines the number of grids the component is going to use.
   * It's applied for the `sm` breakpoint and wider screens if not overridden.
   */ sm: (0, (/*@__PURE__*/$parcel$interopDefault($1xEYC))).oneOf([
        false,
        "auto",
        true,
        1,
        2,
        3,
        4,
        5,
        6,
        7,
        8,
        9,
        10,
        11,
        12
    ]),
    /**
   * Defines the space between the type `item` component.
   * It can only be used on a type `container` component.
   */ spacing: (0, (/*@__PURE__*/$parcel$interopDefault($1xEYC))).oneOf($7cfd98a9e1965a4c$var$SPACINGS),
    /**
   * Defines the `flex-wrap` style property.
   * It's applied for all screen sizes.
   */ wrap: (0, (/*@__PURE__*/$parcel$interopDefault($1xEYC))).oneOf([
        "nowrap",
        "wrap",
        "wrap-reverse"
    ]),
    /**
   * Defines the number of grids the component is going to use.
   * It's applied for the `xl` breakpoint and wider screens.
   */ xl: (0, (/*@__PURE__*/$parcel$interopDefault($1xEYC))).oneOf([
        false,
        "auto",
        true,
        1,
        2,
        3,
        4,
        5,
        6,
        7,
        8,
        9,
        10,
        11,
        12
    ]),
    /**
   * Defines the number of grids the component is going to use.
   * It's applied for all the screen sizes with the lowest priority.
   */ xs: (0, (/*@__PURE__*/$parcel$interopDefault($1xEYC))).oneOf([
        false,
        "auto",
        true,
        1,
        2,
        3,
        4,
        5,
        6,
        7,
        8,
        9,
        10,
        11,
        12
    ]),
    /**
   * If `true`, it sets `min-width: 0` on the item.
   * Refer to the limitations section of the documentation to better understand the use case.
   */ zeroMinWidth: (0, (/*@__PURE__*/$parcel$interopDefault($1xEYC))).bool
};
var $7cfd98a9e1965a4c$var$StyledGrid = (0, $eyd6T.default)($7cfd98a9e1965a4c$export$9dd6ff9ea0189349, {
    name: "MuiGrid"
})($7cfd98a9e1965a4c$var$Grid);
var $7cfd98a9e1965a4c$var$requireProp = (0, $fekDk.default)("Grid");
$7cfd98a9e1965a4c$var$StyledGrid.propTypes = (0, $gtn2B.default)({}, $7cfd98a9e1965a4c$var$StyledGrid.propTypes, {
    alignContent: $7cfd98a9e1965a4c$var$requireProp("container"),
    alignItems: $7cfd98a9e1965a4c$var$requireProp("container"),
    direction: $7cfd98a9e1965a4c$var$requireProp("container"),
    justifyContent: $7cfd98a9e1965a4c$var$requireProp("container"),
    lg: $7cfd98a9e1965a4c$var$requireProp("item"),
    md: $7cfd98a9e1965a4c$var$requireProp("item"),
    sm: $7cfd98a9e1965a4c$var$requireProp("item"),
    spacing: $7cfd98a9e1965a4c$var$requireProp("container"),
    wrap: $7cfd98a9e1965a4c$var$requireProp("container"),
    xs: $7cfd98a9e1965a4c$var$requireProp("item"),
    zeroMinWidth: $7cfd98a9e1965a4c$var$requireProp("item")
});
var $7cfd98a9e1965a4c$export$2e2bcd8739ae039 = $7cfd98a9e1965a4c$var$StyledGrid;

});
parcelRegister("fekDk", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b1682b2ac966c22c$export$2e2bcd8739ae039; });
function $b1682b2ac966c22c$export$2e2bcd8739ae039(componentNameInError) {
    var requireProp = function requireProp(requiredProp) {
        return function(props, propName, componentName, location, propFullName) {
            var propFullNameSafe = propFullName || propName;
            if (typeof props[propName] !== "undefined" && !props[requiredProp]) return new Error("The prop `".concat(propFullNameSafe, "` of ") + "`".concat(componentNameInError, "` must be used on `").concat(requiredProp, "`."));
            return null;
        };
    };
    return requireProp;
}

});


parcelRegister("bIgYU", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8870f9ed15d7c62a$export$2e2bcd8739ae039; });

var $gtn2B = parcelRequire("gtn2B");

var $fsWgf = parcelRequire("fsWgf");

var $cQNHH = parcelRequire("cQNHH");

var $1xEYC = parcelRequire("1xEYC");

var $bKF6r = parcelRequire("bKF6r");

var $dcECW = parcelRequire("dcECW");

var $eyd6T = parcelRequire("eyd6T");

var $80wVS = parcelRequire("80wVS");

var $6apHB = parcelRequire("6apHB");

var $5beWR = parcelRequire("5beWR");
var $8870f9ed15d7c62a$export$9dd6ff9ea0189349 = function styles(theme) {
    return {
        /* Styles applied to the root element. */ root: {
            textAlign: "center",
            flex: "0 0 auto",
            fontSize: theme.typography.pxToRem(24),
            padding: 12,
            borderRadius: "50%",
            overflow: "visible",
            // Explicitly set the default value to solve a bug on IE 11.
            color: theme.palette.action.active,
            transition: theme.transitions.create("background-color", {
                duration: theme.transitions.duration.shortest
            }),
            "&:hover": {
                backgroundColor: (0, $80wVS.alpha)(theme.palette.action.active, theme.palette.action.hoverOpacity),
                // Reset on touch devices, it doesn't add specificity
                "@media (hover: none)": {
                    backgroundColor: "transparent"
                }
            },
            "&$disabled": {
                backgroundColor: "transparent",
                color: theme.palette.action.disabled
            }
        },
        /* Styles applied to the root element if `edge="start"`. */ edgeStart: {
            marginLeft: -12,
            "$sizeSmall&": {
                marginLeft: -3
            }
        },
        /* Styles applied to the root element if `edge="end"`. */ edgeEnd: {
            marginRight: -12,
            "$sizeSmall&": {
                marginRight: -3
            }
        },
        /* Styles applied to the root element if `color="inherit"`. */ colorInherit: {
            color: "inherit"
        },
        /* Styles applied to the root element if `color="primary"`. */ colorPrimary: {
            color: theme.palette.primary.main,
            "&:hover": {
                backgroundColor: (0, $80wVS.alpha)(theme.palette.primary.main, theme.palette.action.hoverOpacity),
                // Reset on touch devices, it doesn't add specificity
                "@media (hover: none)": {
                    backgroundColor: "transparent"
                }
            }
        },
        /* Styles applied to the root element if `color="secondary"`. */ colorSecondary: {
            color: theme.palette.secondary.main,
            "&:hover": {
                backgroundColor: (0, $80wVS.alpha)(theme.palette.secondary.main, theme.palette.action.hoverOpacity),
                // Reset on touch devices, it doesn't add specificity
                "@media (hover: none)": {
                    backgroundColor: "transparent"
                }
            }
        },
        /* Pseudo-class applied to the root element if `disabled={true}`. */ disabled: {},
        /* Styles applied to the root element if `size="small"`. */ sizeSmall: {
            padding: 3,
            fontSize: theme.typography.pxToRem(18)
        },
        /* Styles applied to the children container element. */ label: {
            width: "100%",
            display: "flex",
            alignItems: "inherit",
            justifyContent: "inherit"
        }
    };
};
/**
 * Refer to the [Icons](/components/icons/) section of the documentation
 * regarding the available icon options.
 */ var $8870f9ed15d7c62a$var$IconButton = /*#__PURE__*/ $cQNHH.forwardRef(function IconButton(props, ref) {
    var _props$edge = props.edge, edge = _props$edge === void 0 ? false : _props$edge, children = props.children, classes = props.classes, className = props.className, _props$color = props.color, color = _props$color === void 0 ? "default" : _props$color, _props$disabled = props.disabled, disabled = _props$disabled === void 0 ? false : _props$disabled, _props$disableFocusRi = props.disableFocusRipple, disableFocusRipple = _props$disableFocusRi === void 0 ? false : _props$disableFocusRi, _props$size = props.size, size = _props$size === void 0 ? "medium" : _props$size, other = (0, $fsWgf.default)(props, [
        "edge",
        "children",
        "classes",
        "className",
        "color",
        "disabled",
        "disableFocusRipple",
        "size"
    ]);
    return /*#__PURE__*/ $cQNHH.createElement((0, $6apHB.default), (0, $gtn2B.default)({
        className: (0, $bKF6r.default)(classes.root, className, color !== "default" && classes["color".concat((0, $5beWR.default)(color))], disabled && classes.disabled, size === "small" && classes["size".concat((0, $5beWR.default)(size))], {
            "start": classes.edgeStart,
            "end": classes.edgeEnd
        }[edge]),
        centerRipple: true,
        focusRipple: !disableFocusRipple,
        disabled: disabled,
        ref: ref
    }, other), /*#__PURE__*/ $cQNHH.createElement("span", {
        className: classes.label
    }, children));
});
$8870f9ed15d7c62a$var$IconButton.propTypes = {
    /**
   * The icon element.
   */ children: (0, $dcECW.default)((0, (/*@__PURE__*/$parcel$interopDefault($1xEYC))).node, function(props) {
        var found = $cQNHH.Children.toArray(props.children).some(function(child) {
            return /*#__PURE__*/ $cQNHH.isValidElement(child) && child.props.onClick;
        });
        if (found) return new Error([
            "Material-UI: You are providing an onClick event listener to a child of a button element.",
            "Firefox will never trigger the event.",
            "You should move the onClick listener to the parent button element.",
            "https://github.com/mui-org/material-ui/issues/13957"
        ].join("\n"));
        return null;
    }),
    /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */ classes: (0, (/*@__PURE__*/$parcel$interopDefault($1xEYC))).object.isRequired,
    /**
   * @ignore
   */ className: (0, (/*@__PURE__*/$parcel$interopDefault($1xEYC))).string,
    /**
   * The color of the component. It supports those theme colors that make sense for this component.
   */ color: (0, (/*@__PURE__*/$parcel$interopDefault($1xEYC))).oneOf([
        "default",
        "inherit",
        "primary",
        "secondary"
    ]),
    /**
   * If `true`, the button will be disabled.
   */ disabled: (0, (/*@__PURE__*/$parcel$interopDefault($1xEYC))).bool,
    /**
   * If `true`, the  keyboard focus ripple will be disabled.
   */ disableFocusRipple: (0, (/*@__PURE__*/$parcel$interopDefault($1xEYC))).bool,
    /**
   * If `true`, the ripple effect will be disabled.
   */ disableRipple: (0, (/*@__PURE__*/$parcel$interopDefault($1xEYC))).bool,
    /**
   * If given, uses a negative margin to counteract the padding on one
   * side (this is often helpful for aligning the left or right
   * side of the icon with content above or below, without ruining the border
   * size and shape).
   */ edge: (0, (/*@__PURE__*/$parcel$interopDefault($1xEYC))).oneOf([
        "start",
        "end",
        false
    ]),
    /**
   * The size of the button.
   * `small` is equivalent to the dense button styling.
   */ size: (0, (/*@__PURE__*/$parcel$interopDefault($1xEYC))).oneOf([
        "small",
        "medium"
    ])
};
var $8870f9ed15d7c62a$export$2e2bcd8739ae039 = (0, $eyd6T.default)($8870f9ed15d7c62a$export$9dd6ff9ea0189349, {
    name: "MuiIconButton"
})($8870f9ed15d7c62a$var$IconButton);

});

parcelRegister("97AH2", function(module, exports) {
"use strict";

var $kFrsj = parcelRequire("kFrsj");

var $8jEx7 = parcelRequire("8jEx7");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $6a413afb14e941e1$var$React = $8jEx7((parcelRequire("cQNHH")));

var $6a413afb14e941e1$var$_createSvgIcon = $kFrsj((parcelRequire("bXzXC")));
var $6a413afb14e941e1$var$_default = (0, $6a413afb14e941e1$var$_createSvgIcon.default)(/*#__PURE__*/ $6a413afb14e941e1$var$React.createElement("path", {
    d: "M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
}), "Close");
module.exports.default = $6a413afb14e941e1$var$_default;

});
parcelRegister("kFrsj", function(module, exports) {
function $f0bcef155f16a61d$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
module.exports = $f0bcef155f16a61d$var$_interopRequireDefault;
module.exports["default"] = module.exports, module.exports.__esModule = true;

});

parcelRegister("8jEx7", function(module, exports) {

var $dvB3a = parcelRequire("dvB3a");
var $60df8a21ceea9678$var$_typeof = $dvB3a.default;
function $60df8a21ceea9678$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($60df8a21ceea9678$var$_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $60df8a21ceea9678$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || $60df8a21ceea9678$var$_typeof(obj) !== "object" && typeof obj !== "function") return {
        "default": obj
    };
    var cache = $60df8a21ceea9678$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj["default"] = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
module.exports = $60df8a21ceea9678$var$_interopRequireWildcard;
module.exports["default"] = module.exports, module.exports.__esModule = true;

});
parcelRegister("dvB3a", function(module, exports) {
function $9d5ae8f6bd5defcb$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
        module.exports = $9d5ae8f6bd5defcb$var$_typeof = function _typeof(obj) {
            return typeof obj;
        };
        module.exports["default"] = module.exports, module.exports.__esModule = true;
    } else {
        module.exports = $9d5ae8f6bd5defcb$var$_typeof = function _typeof(obj) {
            return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
        };
        module.exports["default"] = module.exports, module.exports.__esModule = true;
    }
    return $9d5ae8f6bd5defcb$var$_typeof(obj);
}
module.exports = $9d5ae8f6bd5defcb$var$_typeof;
module.exports["default"] = module.exports, module.exports.__esModule = true;

});


parcelRegister("bXzXC", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function get() {
        return $c1Uiz.default;
    }
});

var $c1Uiz = parcelRequire("c1Uiz");

});
parcelRegister("c1Uiz", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8c213fc20d89d4f3$export$2e2bcd8739ae039; });

var $gtn2B = parcelRequire("gtn2B");

var $cQNHH = parcelRequire("cQNHH");

var $g03v7 = parcelRequire("g03v7");
function $8c213fc20d89d4f3$export$2e2bcd8739ae039(path, displayName) {
    var Component = function Component(props, ref) {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement((0, $g03v7.default), (0, $gtn2B.default)({
            ref: ref
        }, props), path);
    };
    // Need to set `displayName` on the inner component for React.memo.
    // React prior to 16.14 ignores `displayName` on the wrapper.
    Component.displayName = "".concat(displayName, "Icon");
    Component.muiName = (0, $g03v7.default).muiName;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).memo(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).forwardRef(Component));
}

});
parcelRegister("g03v7", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ba5f5ca4c3950e3f$export$2e2bcd8739ae039; });

var $gtn2B = parcelRequire("gtn2B");

var $fsWgf = parcelRequire("fsWgf");

var $cQNHH = parcelRequire("cQNHH");

var $1xEYC = parcelRequire("1xEYC");

var $bKF6r = parcelRequire("bKF6r");

var $dcECW = parcelRequire("dcECW");

var $eyd6T = parcelRequire("eyd6T");

var $5beWR = parcelRequire("5beWR");
var $ba5f5ca4c3950e3f$export$9dd6ff9ea0189349 = function styles(theme) {
    return {
        /* Styles applied to the root element. */ root: {
            userSelect: "none",
            width: "1em",
            height: "1em",
            display: "inline-block",
            fill: "currentColor",
            flexShrink: 0,
            fontSize: theme.typography.pxToRem(24),
            transition: theme.transitions.create("fill", {
                duration: theme.transitions.duration.shorter
            })
        },
        /* Styles applied to the root element if `color="primary"`. */ colorPrimary: {
            color: theme.palette.primary.main
        },
        /* Styles applied to the root element if `color="secondary"`. */ colorSecondary: {
            color: theme.palette.secondary.main
        },
        /* Styles applied to the root element if `color="action"`. */ colorAction: {
            color: theme.palette.action.active
        },
        /* Styles applied to the root element if `color="error"`. */ colorError: {
            color: theme.palette.error.main
        },
        /* Styles applied to the root element if `color="disabled"`. */ colorDisabled: {
            color: theme.palette.action.disabled
        },
        /* Styles applied to the root element if `fontSize="inherit"`. */ fontSizeInherit: {
            fontSize: "inherit"
        },
        /* Styles applied to the root element if `fontSize="small"`. */ fontSizeSmall: {
            fontSize: theme.typography.pxToRem(20)
        },
        /* Styles applied to the root element if `fontSize="large"`. */ fontSizeLarge: {
            fontSize: theme.typography.pxToRem(35)
        }
    };
};
var $ba5f5ca4c3950e3f$var$SvgIcon = /*#__PURE__*/ $cQNHH.forwardRef(function SvgIcon(props, ref) {
    var children = props.children, classes = props.classes, className = props.className, _props$color = props.color, color = _props$color === void 0 ? "inherit" : _props$color, _props$component = props.component, Component = _props$component === void 0 ? "svg" : _props$component, _props$fontSize = props.fontSize, fontSize = _props$fontSize === void 0 ? "medium" : _props$fontSize, htmlColor = props.htmlColor, titleAccess = props.titleAccess, _props$viewBox = props.viewBox, viewBox = _props$viewBox === void 0 ? "0 0 24 24" : _props$viewBox, other = (0, $fsWgf.default)(props, [
        "children",
        "classes",
        "className",
        "color",
        "component",
        "fontSize",
        "htmlColor",
        "titleAccess",
        "viewBox"
    ]);
    return /*#__PURE__*/ $cQNHH.createElement(Component, (0, $gtn2B.default)({
        className: (0, $bKF6r.default)(classes.root, className, color !== "inherit" && classes["color".concat((0, $5beWR.default)(color))], fontSize !== "default" && fontSize !== "medium" && classes["fontSize".concat((0, $5beWR.default)(fontSize))]),
        focusable: "false",
        viewBox: viewBox,
        color: htmlColor,
        "aria-hidden": titleAccess ? undefined : true,
        role: titleAccess ? "img" : undefined,
        ref: ref
    }, other), children, titleAccess ? /*#__PURE__*/ $cQNHH.createElement("title", null, titleAccess) : null);
});
$ba5f5ca4c3950e3f$var$SvgIcon.propTypes = {
    // ----------------------------- Warning --------------------------------
    // | These PropTypes are generated from the TypeScript type definitions |
    // |     To update them edit the d.ts file and run "yarn proptypes"     |
    // ----------------------------------------------------------------------
    /**
   * Node passed into the SVG element.
   */ children: (0, (/*@__PURE__*/$parcel$interopDefault($1xEYC))).node,
    /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */ classes: (0, (/*@__PURE__*/$parcel$interopDefault($1xEYC))).object,
    /**
   * @ignore
   */ className: (0, (/*@__PURE__*/$parcel$interopDefault($1xEYC))).string,
    /**
   * The color of the component. It supports those theme colors that make sense for this component.
   * You can use the `htmlColor` prop to apply a color attribute to the SVG element.
   */ color: (0, (/*@__PURE__*/$parcel$interopDefault($1xEYC))).oneOf([
        "action",
        "disabled",
        "error",
        "inherit",
        "primary",
        "secondary"
    ]),
    /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */ component: (0, (/*@__PURE__*/$parcel$interopDefault($1xEYC)))/* @typescript-to-proptypes-ignore */ .elementType,
    /**
   * The fontSize applied to the icon. Defaults to 24px, but can be configure to inherit font size.
   */ fontSize: (0, $dcECW.default)((0, (/*@__PURE__*/$parcel$interopDefault($1xEYC))).oneOf([
        "default",
        "inherit",
        "large",
        "medium",
        "small"
    ]), function(props) {
        var fontSize = props.fontSize;
        if (fontSize === "default") throw new Error('Material-UI: `fontSize="default"` is deprecated. Use `fontSize="medium"` instead.');
        return null;
    }),
    /**
   * Applies a color attribute to the SVG element.
   */ htmlColor: (0, (/*@__PURE__*/$parcel$interopDefault($1xEYC))).string,
    /**
   * The shape-rendering attribute. The behavior of the different options is described on the
   * [MDN Web Docs](https://developer.mozilla.org/en-US/docs/Web/SVG/Attribute/shape-rendering).
   * If you are having issues with blurry icons you should investigate this property.
   */ shapeRendering: (0, (/*@__PURE__*/$parcel$interopDefault($1xEYC))).string,
    /**
   * Provides a human-readable title for the element that contains it.
   * https://www.w3.org/TR/SVG-access/#Equivalent
   */ titleAccess: (0, (/*@__PURE__*/$parcel$interopDefault($1xEYC))).string,
    /**
   * Allows you to redefine what the coordinates without units mean inside an SVG element.
   * For example, if the SVG element is 500 (width) by 200 (height),
   * and you pass viewBox="0 0 50 20",
   * this means that the coordinates inside the SVG will go from the top left corner (0,0)
   * to bottom right (50,20) and each unit will be worth 10px.
   */ viewBox: (0, (/*@__PURE__*/$parcel$interopDefault($1xEYC))).string
};
$ba5f5ca4c3950e3f$var$SvgIcon.muiName = "SvgIcon";
var $ba5f5ca4c3950e3f$export$2e2bcd8739ae039 = (0, $eyd6T.default)($ba5f5ca4c3950e3f$export$9dd6ff9ea0189349, {
    name: "MuiSvgIcon"
})($ba5f5ca4c3950e3f$var$SvgIcon);

});




parcelRegister("c4XSV", function(module, exports) {

$parcel$export(module.exports, "defineMessages", function () { return $8cb44fa200269a5f$export$1adfeb024f5185b; });
$parcel$export(module.exports, "FormattedDate", function () { return $8cb44fa200269a5f$export$40ae3194919d16b; });

var $1DZj1 = parcelRequire("1DZj1");

var $szrnD = parcelRequire("szrnD");

var $4uhmr = parcelRequire("4uhmr");

var $IPPAR = parcelRequire("IPPAR");



var $kV13H = parcelRequire("kV13H");


function $8cb44fa200269a5f$export$1adfeb024f5185b(msgs) {
    return msgs;
}
function $8cb44fa200269a5f$export$747d244ee58120dd(msg) {
    return msg;
}
var $8cb44fa200269a5f$export$40ae3194919d16b = (0, $1DZj1.createFormattedComponent)("formatDate");
var $8cb44fa200269a5f$export$5b390a54f8a846f7 = (0, $1DZj1.createFormattedComponent)("formatTime");
var $8cb44fa200269a5f$export$db80edc1e6b2f63d = (0, $1DZj1.createFormattedComponent)("formatNumber");
var $8cb44fa200269a5f$export$f52b44e459e6e71d = (0, $1DZj1.createFormattedComponent)("formatList");
var $8cb44fa200269a5f$export$c2336ea5aaab92fa = (0, $1DZj1.createFormattedComponent)("formatDisplayName");
var $8cb44fa200269a5f$export$7fdc7d2c91ce149b = (0, $1DZj1.createFormattedDateTimePartsComponent)("formatDate");
var $8cb44fa200269a5f$export$ec35873761676c2a = (0, $1DZj1.createFormattedDateTimePartsComponent)("formatTime");

});
parcelRegister("1DZj1", function(module, exports) {

$parcel$export(module.exports, "createFormattedDateTimePartsComponent", function () { return $1328fd0886f23ed9$export$7448277f6036d2ab; });
$parcel$export(module.exports, "createFormattedComponent", function () { return $1328fd0886f23ed9$export$b37e14176d001dec; });

var $gb4K1 = parcelRequire("gb4K1");

var $cQNHH = parcelRequire("cQNHH");

var $4uhmr = parcelRequire("4uhmr");
var $1328fd0886f23ed9$var$DisplayName;
(function(DisplayName) {
    DisplayName["formatDate"] = "FormattedDate";
    DisplayName["formatTime"] = "FormattedTime";
    DisplayName["formatNumber"] = "FormattedNumber";
    DisplayName["formatList"] = "FormattedList";
    // Note that this DisplayName is the locale display name, not to be confused with
    // the name of the enum, which is for React component display name in dev tools.
    DisplayName["formatDisplayName"] = "FormattedDisplayName";
})($1328fd0886f23ed9$var$DisplayName || ($1328fd0886f23ed9$var$DisplayName = {}));
var $1328fd0886f23ed9$var$DisplayNameParts;
(function(DisplayNameParts) {
    DisplayNameParts["formatDate"] = "FormattedDateParts";
    DisplayNameParts["formatTime"] = "FormattedTimeParts";
    DisplayNameParts["formatNumber"] = "FormattedNumberParts";
    DisplayNameParts["formatList"] = "FormattedListParts";
})($1328fd0886f23ed9$var$DisplayNameParts || ($1328fd0886f23ed9$var$DisplayNameParts = {}));
var $1328fd0886f23ed9$export$54d4989ed3eea1ea = function(props) {
    var intl = (0, $4uhmr.default)();
    var value = props.value, children = props.children, formatProps = (0, $gb4K1.__rest)(props, [
        "value",
        "children"
    ]);
    return children(intl.formatNumberToParts(value, formatProps));
};
$1328fd0886f23ed9$export$54d4989ed3eea1ea.displayName = "FormattedNumberParts";
var $1328fd0886f23ed9$export$5ac259c7da6d2188 = function(props) {
    var intl = (0, $4uhmr.default)();
    var value = props.value, children = props.children, formatProps = (0, $gb4K1.__rest)(props, [
        "value",
        "children"
    ]);
    return children(intl.formatListToParts(value, formatProps));
};
$1328fd0886f23ed9$export$54d4989ed3eea1ea.displayName = "FormattedNumberParts";
function $1328fd0886f23ed9$export$7448277f6036d2ab(name) {
    var ComponentParts = function(props) {
        var intl = (0, $4uhmr.default)();
        var value = props.value, children = props.children, formatProps = (0, $gb4K1.__rest)(props, [
            "value",
            "children"
        ]);
        var date = typeof value === "string" ? new Date(value || 0) : value;
        var formattedParts = name === "formatDate" ? intl.formatDateToParts(date, formatProps) : intl.formatTimeToParts(date, formatProps);
        return children(formattedParts);
    };
    ComponentParts.displayName = $1328fd0886f23ed9$var$DisplayNameParts[name];
    return ComponentParts;
}
function $1328fd0886f23ed9$export$b37e14176d001dec(name) {
    var Component = function(props) {
        var intl = (0, $4uhmr.default)();
        var value = props.value, children = props.children, formatProps = (0, $gb4K1.__rest)(props, [
            "value",
            "children"
        ]);
        // TODO: fix TS type definition for localeMatcher upstream
        var formattedValue = intl[name](value, formatProps);
        if (typeof children === "function") return children(formattedValue);
        var Text = intl.textComponent || $cQNHH.Fragment;
        return $cQNHH.createElement(Text, null, formattedValue);
    };
    Component.displayName = $1328fd0886f23ed9$var$DisplayName[name];
    return Component;
}

});

parcelRegister("IPPAR", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $086c50c3452d74d7$export$2e2bcd8739ae039; });
/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */ 
var $gb4K1 = parcelRequire("gb4K1");

var $c5cmP = parcelRequire("c5cmP");
var $5VJfG = parcelRequire("5VJfG");
var $aKj9Z = parcelRequire("aKj9Z");

var $cQNHH = parcelRequire("cQNHH");

var $2KDk6 = parcelRequire("2KDk6");

var $szrnD = parcelRequire("szrnD");

var $9FMnG = parcelRequire("9FMnG");
function $086c50c3452d74d7$var$processIntlConfig(config) {
    return {
        locale: config.locale,
        timeZone: config.timeZone,
        fallbackOnEmptyString: config.fallbackOnEmptyString,
        formats: config.formats,
        textComponent: config.textComponent,
        messages: config.messages,
        defaultLocale: config.defaultLocale,
        defaultFormats: config.defaultFormats,
        onError: config.onError,
        onWarn: config.onWarn,
        wrapRichTextChunksInFragment: config.wrapRichTextChunksInFragment,
        defaultRichTextElements: config.defaultRichTextElements
    };
}
function $086c50c3452d74d7$var$assignUniqueKeysToFormatXMLElementFnArgument(values) {
    if (!values) return values;
    return Object.keys(values).reduce(function(acc, k) {
        var v = values[k];
        acc[k] = (0, $9FMnG.isFormatXMLElementFn)(v) ? (0, $2KDk6.assignUniqueKeysToParts)(v) : v;
        return acc;
    }, {});
}
var $086c50c3452d74d7$var$formatMessage = function(config, formatters, descriptor, rawValues) {
    var rest = [];
    for(var _i = 4; _i < arguments.length; _i++)rest[_i - 4] = arguments[_i];
    var values = $086c50c3452d74d7$var$assignUniqueKeysToFormatXMLElementFnArgument(rawValues);
    var chunks = (0, $aKj9Z.formatMessage).apply(void 0, (0, $gb4K1.__spreadArray)([
        config,
        formatters,
        descriptor,
        values
    ], rest, false));
    if (Array.isArray(chunks)) return $cQNHH.Children.toArray(chunks);
    return chunks;
};
var $086c50c3452d74d7$export$7e4cbedfdd7b4c0d = function(_a, cache) {
    var rawDefaultRichTextElements = _a.defaultRichTextElements, config = (0, $gb4K1.__rest)(_a, [
        "defaultRichTextElements"
    ]);
    var defaultRichTextElements = $086c50c3452d74d7$var$assignUniqueKeysToFormatXMLElementFnArgument(rawDefaultRichTextElements);
    var coreIntl = (0, $c5cmP.createIntl)((0, $gb4K1.__assign)((0, $gb4K1.__assign)((0, $gb4K1.__assign)({}, (0, $2KDk6.DEFAULT_INTL_CONFIG)), config), {
        defaultRichTextElements: defaultRichTextElements
    }), cache);
    var resolvedConfig = {
        locale: coreIntl.locale,
        timeZone: coreIntl.timeZone,
        fallbackOnEmptyString: coreIntl.fallbackOnEmptyString,
        formats: coreIntl.formats,
        defaultLocale: coreIntl.defaultLocale,
        defaultFormats: coreIntl.defaultFormats,
        messages: coreIntl.messages,
        onError: coreIntl.onError,
        defaultRichTextElements: defaultRichTextElements
    };
    return (0, $gb4K1.__assign)((0, $gb4K1.__assign)({}, coreIntl), {
        formatMessage: $086c50c3452d74d7$var$formatMessage.bind(null, resolvedConfig, // @ts-expect-error fix this
        coreIntl.formatters),
        // @ts-expect-error fix this
        $t: $086c50c3452d74d7$var$formatMessage.bind(null, resolvedConfig, coreIntl.formatters)
    });
};
var $086c50c3452d74d7$var$IntlProvider = /** @class */ function(_super) {
    (0, $gb4K1.__extends)(IntlProvider, _super);
    function IntlProvider() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.cache = (0, $5VJfG.createIntlCache)();
        _this.state = {
            cache: _this.cache,
            intl: $086c50c3452d74d7$export$7e4cbedfdd7b4c0d($086c50c3452d74d7$var$processIntlConfig(_this.props), _this.cache),
            prevConfig: $086c50c3452d74d7$var$processIntlConfig(_this.props)
        };
        return _this;
    }
    IntlProvider.getDerivedStateFromProps = function(props, _a) {
        var prevConfig = _a.prevConfig, cache = _a.cache;
        var config = $086c50c3452d74d7$var$processIntlConfig(props);
        if (!(0, $2KDk6.shallowEqual)(prevConfig, config)) return {
            intl: $086c50c3452d74d7$export$7e4cbedfdd7b4c0d(config, cache),
            prevConfig: config
        };
        return null;
    };
    IntlProvider.prototype.render = function() {
        (0, $2KDk6.invariantIntlContext)(this.state.intl);
        return $cQNHH.createElement((0, $szrnD.Provider), {
            value: this.state.intl
        }, this.props.children);
    };
    IntlProvider.displayName = "IntlProvider";
    IntlProvider.defaultProps = (0, $2KDk6.DEFAULT_INTL_CONFIG);
    return IntlProvider;
}($cQNHH.PureComponent);
var $086c50c3452d74d7$export$2e2bcd8739ae039 = $086c50c3452d74d7$var$IntlProvider;

});
parcelRegister("c5cmP", function(module, exports) {

$parcel$export(module.exports, "createIntl", function () { return $8cbf8b8978d1b273$export$7e4cbedfdd7b4c0d; });

var $gb4K1 = parcelRequire("gb4K1");

var $5VJfG = parcelRequire("5VJfG");

var $dCg2n = parcelRequire("dCg2n");

var $bEHO0 = parcelRequire("bEHO0");

var $4I0Ba = parcelRequire("4I0Ba");

var $4xOmy = parcelRequire("4xOmy");

var $fWzDy = parcelRequire("fWzDy");

var $aKj9Z = parcelRequire("aKj9Z");

var $7Huld = parcelRequire("7Huld");

var $1mQHj = parcelRequire("1mQHj");
function $8cbf8b8978d1b273$var$messagesContainString(messages) {
    var firstMessage = messages ? messages[Object.keys(messages)[0]] : undefined;
    return typeof firstMessage === "string";
}
function $8cbf8b8978d1b273$var$verifyConfigMessages(config) {
    if (config.onWarn && config.defaultRichTextElements && $8cbf8b8978d1b273$var$messagesContainString(config.messages || {})) config.onWarn('[@formatjs/intl] "defaultRichTextElements" was specified but "message" was not pre-compiled. \nPlease consider using "@formatjs/cli" to pre-compile your messages for performance.\nFor more details see https://formatjs.io/docs/getting-started/message-distribution');
}
function $8cbf8b8978d1b273$export$7e4cbedfdd7b4c0d(config, cache) {
    var formatters = (0, $5VJfG.createFormatters)(cache);
    var resolvedConfig = (0, $gb4K1.__assign)((0, $gb4K1.__assign)({}, (0, $5VJfG.DEFAULT_INTL_CONFIG)), config);
    var locale = resolvedConfig.locale, defaultLocale = resolvedConfig.defaultLocale, onError = resolvedConfig.onError;
    if (!locale) {
        if (onError) onError(new (0, $dCg2n.InvalidConfigError)('"locale" was not configured, using "'.concat(defaultLocale, '" as fallback. See https://formatjs.io/docs/react-intl/api#intlshape for more details')));
        // Since there's no registered locale data for `locale`, this will
        // fallback to the `defaultLocale` to make sure things can render.
        // The `messages` are overridden to the `defaultProps` empty object
        // to maintain referential equality across re-renders. It's assumed
        // each <FormattedMessage> contains a `defaultMessage` prop.
        resolvedConfig.locale = resolvedConfig.defaultLocale || "en";
    } else if (!Intl.NumberFormat.supportedLocalesOf(locale).length && onError) onError(new (0, $dCg2n.MissingDataError)('Missing locale data for locale: "'.concat(locale, '" in Intl.NumberFormat. Using default locale: "').concat(defaultLocale, '" as fallback. See https://formatjs.io/docs/react-intl#runtime-requirements for more details')));
    else if (!Intl.DateTimeFormat.supportedLocalesOf(locale).length && onError) onError(new (0, $dCg2n.MissingDataError)('Missing locale data for locale: "'.concat(locale, '" in Intl.DateTimeFormat. Using default locale: "').concat(defaultLocale, '" as fallback. See https://formatjs.io/docs/react-intl#runtime-requirements for more details')));
    $8cbf8b8978d1b273$var$verifyConfigMessages(resolvedConfig);
    return (0, $gb4K1.__assign)((0, $gb4K1.__assign)({}, resolvedConfig), {
        formatters: formatters,
        formatNumber: (0, $bEHO0.formatNumber).bind(null, resolvedConfig, formatters.getNumberFormat),
        formatNumberToParts: (0, $bEHO0.formatNumberToParts).bind(null, resolvedConfig, formatters.getNumberFormat),
        formatRelativeTime: (0, $4I0Ba.formatRelativeTime).bind(null, resolvedConfig, formatters.getRelativeTimeFormat),
        formatDate: (0, $4xOmy.formatDate).bind(null, resolvedConfig, formatters.getDateTimeFormat),
        formatDateToParts: (0, $4xOmy.formatDateToParts).bind(null, resolvedConfig, formatters.getDateTimeFormat),
        formatTime: (0, $4xOmy.formatTime).bind(null, resolvedConfig, formatters.getDateTimeFormat),
        formatDateTimeRange: (0, $4xOmy.formatDateTimeRange).bind(null, resolvedConfig, formatters.getDateTimeFormat),
        formatTimeToParts: (0, $4xOmy.formatTimeToParts).bind(null, resolvedConfig, formatters.getDateTimeFormat),
        formatPlural: (0, $fWzDy.formatPlural).bind(null, resolvedConfig, formatters.getPluralRules),
        // @ts-expect-error TODO: will get to this later
        formatMessage: (0, $aKj9Z.formatMessage).bind(null, resolvedConfig, formatters),
        // @ts-expect-error TODO: will get to this later
        $t: (0, $aKj9Z.formatMessage).bind(null, resolvedConfig, formatters),
        formatList: (0, $7Huld.formatList).bind(null, resolvedConfig, formatters.getListFormat),
        formatListToParts: (0, $7Huld.formatListToParts).bind(null, resolvedConfig, formatters.getListFormat),
        formatDisplayName: (0, $1mQHj.formatDisplayName).bind(null, resolvedConfig, formatters.getDisplayNames)
    });
}

});
parcelRegister("bEHO0", function(module, exports) {

$parcel$export(module.exports, "formatNumber", function () { return $87c568fc21c9ea21$export$f5dd818bff069720; });
$parcel$export(module.exports, "formatNumberToParts", function () { return $87c568fc21c9ea21$export$6871080848f10b2f; });

var $5VJfG = parcelRequire("5VJfG");

var $dCg2n = parcelRequire("dCg2n");
var $87c568fc21c9ea21$var$NUMBER_FORMAT_OPTIONS = [
    "style",
    "currency",
    "currencyDisplay",
    "unit",
    "unitDisplay",
    "useGrouping",
    "minimumIntegerDigits",
    "minimumFractionDigits",
    "maximumFractionDigits",
    "minimumSignificantDigits",
    "maximumSignificantDigits",
    // ES2020 NumberFormat
    "compactDisplay",
    "currencyDisplay",
    "currencySign",
    "notation",
    "signDisplay",
    "unit",
    "unitDisplay",
    "numberingSystem"
];
function $87c568fc21c9ea21$export$a7f9565e3c81cd54(_a, getNumberFormat, options) {
    var locale = _a.locale, formats = _a.formats, onError = _a.onError;
    if (options === void 0) options = {};
    var format = options.format;
    var defaults = format && (0, $5VJfG.getNamedFormat)(formats, "number", format, onError) || {};
    var filteredOptions = (0, $5VJfG.filterProps)(options, $87c568fc21c9ea21$var$NUMBER_FORMAT_OPTIONS, defaults);
    return getNumberFormat(locale, filteredOptions);
}
function $87c568fc21c9ea21$export$f5dd818bff069720(config, getNumberFormat, value, options) {
    if (options === void 0) options = {};
    try {
        return $87c568fc21c9ea21$export$a7f9565e3c81cd54(config, getNumberFormat, options).format(value);
    } catch (e) {
        config.onError(new (0, $dCg2n.IntlFormatError)("Error formatting number.", config.locale, e));
    }
    return String(value);
}
function $87c568fc21c9ea21$export$6871080848f10b2f(config, getNumberFormat, value, options) {
    if (options === void 0) options = {};
    try {
        return $87c568fc21c9ea21$export$a7f9565e3c81cd54(config, getNumberFormat, options).formatToParts(value);
    } catch (e) {
        config.onError(new (0, $dCg2n.IntlFormatError)("Error formatting number.", config.locale, e));
    }
    return [];
}

});

parcelRegister("4I0Ba", function(module, exports) {

$parcel$export(module.exports, "formatRelativeTime", function () { return $36dbbc55570f9232$export$b4ea3b48dcf921f6; });

var $5VJfG = parcelRequire("5VJfG");

var $8RUL4 = parcelRequire("8RUL4");

var $dCg2n = parcelRequire("dCg2n");
var $36dbbc55570f9232$var$RELATIVE_TIME_FORMAT_OPTIONS = [
    "numeric",
    "style"
];
function $36dbbc55570f9232$var$getFormatter(_a, getRelativeTimeFormat, options) {
    var locale = _a.locale, formats = _a.formats, onError = _a.onError;
    if (options === void 0) options = {};
    var format = options.format;
    var defaults = !!format && (0, $5VJfG.getNamedFormat)(formats, "relative", format, onError) || {};
    var filteredOptions = (0, $5VJfG.filterProps)(options, $36dbbc55570f9232$var$RELATIVE_TIME_FORMAT_OPTIONS, defaults);
    return getRelativeTimeFormat(locale, filteredOptions);
}
function $36dbbc55570f9232$export$b4ea3b48dcf921f6(config, getRelativeTimeFormat, value, unit, options) {
    if (options === void 0) options = {};
    if (!unit) unit = "second";
    var RelativeTimeFormat = Intl.RelativeTimeFormat;
    if (!RelativeTimeFormat) config.onError(new (0, $8RUL4.FormatError)('Intl.RelativeTimeFormat is not available in this environment.\nTry polyfilling it using "@formatjs/intl-relativetimeformat"\n', (0, $8RUL4.ErrorCode).MISSING_INTL_API));
    try {
        return $36dbbc55570f9232$var$getFormatter(config, getRelativeTimeFormat, options).format(value, unit);
    } catch (e) {
        config.onError(new (0, $dCg2n.IntlFormatError)("Error formatting relative time.", config.locale, e));
    }
    return String(value);
}

});

parcelRegister("4xOmy", function(module, exports) {

$parcel$export(module.exports, "formatDate", function () { return $34f14f7f43e8af49$export$3ae94a2503e890a1; });
$parcel$export(module.exports, "formatTime", function () { return $34f14f7f43e8af49$export$3203edd9e5edd663; });
$parcel$export(module.exports, "formatDateTimeRange", function () { return $34f14f7f43e8af49$export$a7fc3a91cb2ec376; });
$parcel$export(module.exports, "formatDateToParts", function () { return $34f14f7f43e8af49$export$dc1f059bce486b1; });
$parcel$export(module.exports, "formatTimeToParts", function () { return $34f14f7f43e8af49$export$af6e5d7a5c73edeb; });

var $gb4K1 = parcelRequire("gb4K1");

var $5VJfG = parcelRequire("5VJfG");

var $dCg2n = parcelRequire("dCg2n");
var $34f14f7f43e8af49$var$DATE_TIME_FORMAT_OPTIONS = [
    "formatMatcher",
    "timeZone",
    "hour12",
    "weekday",
    "era",
    "year",
    "month",
    "day",
    "hour",
    "minute",
    "second",
    "timeZoneName",
    "hourCycle",
    "dateStyle",
    "timeStyle",
    "calendar",
    // 'dayPeriod',
    "numberingSystem",
    "fractionalSecondDigits"
];
function $34f14f7f43e8af49$export$a7f9565e3c81cd54(_a, type, getDateTimeFormat, options) {
    var locale = _a.locale, formats = _a.formats, onError = _a.onError, timeZone = _a.timeZone;
    if (options === void 0) options = {};
    var format = options.format;
    var defaults = (0, $gb4K1.__assign)((0, $gb4K1.__assign)({}, timeZone && {
        timeZone: timeZone
    }), format && (0, $5VJfG.getNamedFormat)(formats, type, format, onError));
    var filteredOptions = (0, $5VJfG.filterProps)(options, $34f14f7f43e8af49$var$DATE_TIME_FORMAT_OPTIONS, defaults);
    if (type === "time" && !filteredOptions.hour && !filteredOptions.minute && !filteredOptions.second && !filteredOptions.timeStyle && !filteredOptions.dateStyle) // Add default formatting options if hour, minute, or second isn't defined.
    filteredOptions = (0, $gb4K1.__assign)((0, $gb4K1.__assign)({}, filteredOptions), {
        hour: "numeric",
        minute: "numeric"
    });
    return getDateTimeFormat(locale, filteredOptions);
}
function $34f14f7f43e8af49$export$3ae94a2503e890a1(config, getDateTimeFormat) {
    var _a = [];
    for(var _i = 2; _i < arguments.length; _i++)_a[_i - 2] = arguments[_i];
    var value = _a[0], _b = _a[1], options = _b === void 0 ? {} : _b;
    var date = typeof value === "string" ? new Date(value || 0) : value;
    try {
        return $34f14f7f43e8af49$export$a7f9565e3c81cd54(config, "date", getDateTimeFormat, options).format(date);
    } catch (e) {
        config.onError(new (0, $dCg2n.IntlFormatError)("Error formatting date.", config.locale, e));
    }
    return String(date);
}
function $34f14f7f43e8af49$export$3203edd9e5edd663(config, getDateTimeFormat) {
    var _a = [];
    for(var _i = 2; _i < arguments.length; _i++)_a[_i - 2] = arguments[_i];
    var value = _a[0], _b = _a[1], options = _b === void 0 ? {} : _b;
    var date = typeof value === "string" ? new Date(value || 0) : value;
    try {
        return $34f14f7f43e8af49$export$a7f9565e3c81cd54(config, "time", getDateTimeFormat, options).format(date);
    } catch (e) {
        config.onError(new (0, $dCg2n.IntlFormatError)("Error formatting time.", config.locale, e));
    }
    return String(date);
}
function $34f14f7f43e8af49$export$a7fc3a91cb2ec376(config, getDateTimeFormat) {
    var _a = [];
    for(var _i = 2; _i < arguments.length; _i++)_a[_i - 2] = arguments[_i];
    var from = _a[0], to = _a[1], _b = _a[2], options = _b === void 0 ? {} : _b;
    var timeZone = config.timeZone, locale = config.locale, onError = config.onError;
    var filteredOptions = (0, $5VJfG.filterProps)(options, $34f14f7f43e8af49$var$DATE_TIME_FORMAT_OPTIONS, timeZone ? {
        timeZone: timeZone
    } : {});
    try {
        return getDateTimeFormat(locale, filteredOptions).formatRange(from, to);
    } catch (e) {
        onError(new (0, $dCg2n.IntlFormatError)("Error formatting date time range.", config.locale, e));
    }
    return String(from);
}
function $34f14f7f43e8af49$export$dc1f059bce486b1(config, getDateTimeFormat) {
    var _a = [];
    for(var _i = 2; _i < arguments.length; _i++)_a[_i - 2] = arguments[_i];
    var value = _a[0], _b = _a[1], options = _b === void 0 ? {} : _b;
    var date = typeof value === "string" ? new Date(value || 0) : value;
    try {
        return $34f14f7f43e8af49$export$a7f9565e3c81cd54(config, "date", getDateTimeFormat, options).formatToParts(date); // TODO: remove this when https://github.com/microsoft/TypeScript/pull/50402 is merged
    } catch (e) {
        config.onError(new (0, $dCg2n.IntlFormatError)("Error formatting date.", config.locale, e));
    }
    return [];
}
function $34f14f7f43e8af49$export$af6e5d7a5c73edeb(config, getDateTimeFormat) {
    var _a = [];
    for(var _i = 2; _i < arguments.length; _i++)_a[_i - 2] = arguments[_i];
    var value = _a[0], _b = _a[1], options = _b === void 0 ? {} : _b;
    var date = typeof value === "string" ? new Date(value || 0) : value;
    try {
        return $34f14f7f43e8af49$export$a7f9565e3c81cd54(config, "time", getDateTimeFormat, options).formatToParts(date); // TODO: remove this when https://github.com/microsoft/TypeScript/pull/50402 is merged
    } catch (e) {
        config.onError(new (0, $dCg2n.IntlFormatError)("Error formatting time.", config.locale, e));
    }
    return [];
}

});

parcelRegister("fWzDy", function(module, exports) {

$parcel$export(module.exports, "formatPlural", function () { return $b9b7ea8e1febf9cf$export$bbbd05c900f3568d; });

var $5VJfG = parcelRequire("5VJfG");

var $dCg2n = parcelRequire("dCg2n");

var $8RUL4 = parcelRequire("8RUL4");
var $b9b7ea8e1febf9cf$var$PLURAL_FORMAT_OPTIONS = [
    "type"
];
function $b9b7ea8e1febf9cf$export$bbbd05c900f3568d(_a, getPluralRules, value, options) {
    var locale = _a.locale, onError = _a.onError;
    if (options === void 0) options = {};
    if (!Intl.PluralRules) onError(new (0, $8RUL4.FormatError)('Intl.PluralRules is not available in this environment.\nTry polyfilling it using "@formatjs/intl-pluralrules"\n', (0, $8RUL4.ErrorCode).MISSING_INTL_API));
    var filteredOptions = (0, $5VJfG.filterProps)(options, $b9b7ea8e1febf9cf$var$PLURAL_FORMAT_OPTIONS);
    try {
        return getPluralRules(locale, filteredOptions).select(value);
    } catch (e) {
        onError(new (0, $dCg2n.IntlFormatError)("Error formatting plural.", locale, e));
    }
    return "other";
}

});

parcelRegister("aKj9Z", function(module, exports) {

$parcel$export(module.exports, "formatMessage", function () { return $7d2d1014377ab8c5$export$25868d1e8e76735f; });

var $gb4K1 = parcelRequire("gb4K1");

var $gvCUa = parcelRequire("gvCUa");
parcelRequire("iTKsw");
var $4kwTT = parcelRequire("4kwTT");

var $dCg2n = parcelRequire("dCg2n");
parcelRequire("b4svv");
var $a5i87 = parcelRequire("a5i87");
function $7d2d1014377ab8c5$var$setTimeZoneInOptions(opts, timeZone) {
    return Object.keys(opts).reduce(function(all, k) {
        all[k] = (0, $gb4K1.__assign)({
            timeZone: timeZone
        }, opts[k]);
        return all;
    }, {});
}
function $7d2d1014377ab8c5$var$deepMergeOptions(opts1, opts2) {
    var keys = Object.keys((0, $gb4K1.__assign)((0, $gb4K1.__assign)({}, opts1), opts2));
    return keys.reduce(function(all, k) {
        all[k] = (0, $gb4K1.__assign)((0, $gb4K1.__assign)({}, opts1[k] || {}), opts2[k] || {});
        return all;
    }, {});
}
function $7d2d1014377ab8c5$var$deepMergeFormatsAndSetTimeZone(f1, timeZone) {
    if (!timeZone) return f1;
    var mfFormats = (0, $4kwTT.IntlMessageFormat).formats;
    return (0, $gb4K1.__assign)((0, $gb4K1.__assign)((0, $gb4K1.__assign)({}, mfFormats), f1), {
        date: $7d2d1014377ab8c5$var$deepMergeOptions($7d2d1014377ab8c5$var$setTimeZoneInOptions(mfFormats.date, timeZone), $7d2d1014377ab8c5$var$setTimeZoneInOptions(f1.date || {}, timeZone)),
        time: $7d2d1014377ab8c5$var$deepMergeOptions($7d2d1014377ab8c5$var$setTimeZoneInOptions(mfFormats.time, timeZone), $7d2d1014377ab8c5$var$setTimeZoneInOptions(f1.time || {}, timeZone))
    });
}
var $7d2d1014377ab8c5$export$25868d1e8e76735f = function(_a, state, messageDescriptor, values, opts) {
    var locale = _a.locale, formats = _a.formats, messages = _a.messages, defaultLocale = _a.defaultLocale, defaultFormats = _a.defaultFormats, fallbackOnEmptyString = _a.fallbackOnEmptyString, onError = _a.onError, timeZone = _a.timeZone, defaultRichTextElements = _a.defaultRichTextElements;
    if (messageDescriptor === void 0) messageDescriptor = {
        id: ""
    };
    var msgId = messageDescriptor.id, defaultMessage = messageDescriptor.defaultMessage;
    // `id` is a required field of a Message Descriptor.
    (0, $gvCUa.invariant)(!!msgId, "[@formatjs/intl] An `id` must be provided to format a message. You can either:\n1. Configure your build toolchain with [babel-plugin-formatjs](https://formatjs.io/docs/tooling/babel-plugin)\nor [@formatjs/ts-transformer](https://formatjs.io/docs/tooling/ts-transformer) OR\n2. Configure your `eslint` config to include [eslint-plugin-formatjs](https://formatjs.io/docs/tooling/linter#enforce-id)\nto autofix this issue");
    var id = String(msgId);
    var message = // In case messages is Object.create(null)
    // e.g import('foo.json') from webpack)
    // See https://github.com/formatjs/formatjs/issues/1914
    messages && Object.prototype.hasOwnProperty.call(messages, id) && messages[id];
    // IMPORTANT: Hot path if `message` is AST with a single literal node
    if (Array.isArray(message) && message.length === 1 && message[0].type === (0, $a5i87.TYPE).literal) return message[0].value;
    // IMPORTANT: Hot path straight lookup for performance
    if (!values && message && typeof message === "string" && !defaultRichTextElements) return message.replace(/'\{(.*?)\}'/gi, "{$1}");
    values = (0, $gb4K1.__assign)((0, $gb4K1.__assign)({}, defaultRichTextElements), values || {});
    formats = $7d2d1014377ab8c5$var$deepMergeFormatsAndSetTimeZone(formats, timeZone);
    defaultFormats = $7d2d1014377ab8c5$var$deepMergeFormatsAndSetTimeZone(defaultFormats, timeZone);
    if (!message) {
        if (fallbackOnEmptyString === false && message === "") return message;
        if (!defaultMessage || locale && locale.toLowerCase() !== defaultLocale.toLowerCase()) // This prevents warnings from littering the console in development
        // when no `messages` are passed into the <IntlProvider> for the
        // default locale.
        onError(new (0, $dCg2n.MissingTranslationError)(messageDescriptor, locale));
        if (defaultMessage) try {
            var formatter = state.getMessageFormat(defaultMessage, defaultLocale, defaultFormats, opts);
            return formatter.format(values);
        } catch (e) {
            onError(new (0, $dCg2n.MessageFormatError)('Error formatting default message for: "'.concat(id, '", rendering default message verbatim'), locale, messageDescriptor, e));
            return typeof defaultMessage === "string" ? defaultMessage : id;
        }
        return id;
    }
    // We have the translated message
    try {
        var formatter = state.getMessageFormat(message, locale, formats, (0, $gb4K1.__assign)({
            formatters: state
        }, opts || {}));
        return formatter.format(values);
    } catch (e) {
        onError(new (0, $dCg2n.MessageFormatError)('Error formatting message: "'.concat(id, '", using ').concat(defaultMessage ? "default message" : "id", " as fallback."), locale, messageDescriptor, e));
    }
    if (defaultMessage) try {
        var formatter = state.getMessageFormat(defaultMessage, defaultLocale, defaultFormats, opts);
        return formatter.format(values);
    } catch (e) {
        onError(new (0, $dCg2n.MessageFormatError)('Error formatting the default message for: "'.concat(id, '", rendering message verbatim'), locale, messageDescriptor, e));
    }
    if (typeof message === "string") return message;
    if (typeof defaultMessage === "string") return defaultMessage;
    return id;
};

});

parcelRegister("7Huld", function(module, exports) {

$parcel$export(module.exports, "formatList", function () { return $59b415acb7c7c3b5$export$e8b8be48b45905bb; });
$parcel$export(module.exports, "formatListToParts", function () { return $59b415acb7c7c3b5$export$6f284aad1934db69; });

var $gb4K1 = parcelRequire("gb4K1");

var $5VJfG = parcelRequire("5VJfG");

var $8RUL4 = parcelRequire("8RUL4");

var $dCg2n = parcelRequire("dCg2n");
var $59b415acb7c7c3b5$var$LIST_FORMAT_OPTIONS = [
    "type",
    "style"
];
var $59b415acb7c7c3b5$var$now = Date.now();
function $59b415acb7c7c3b5$var$generateToken(i) {
    return "".concat($59b415acb7c7c3b5$var$now, "_").concat(i, "_").concat($59b415acb7c7c3b5$var$now);
}
function $59b415acb7c7c3b5$export$e8b8be48b45905bb(opts, getListFormat, values, options) {
    if (options === void 0) options = {};
    var results = $59b415acb7c7c3b5$export$6f284aad1934db69(opts, getListFormat, values, options).reduce(function(all, el) {
        var val = el.value;
        if (typeof val !== "string") all.push(val);
        else if (typeof all[all.length - 1] === "string") all[all.length - 1] += val;
        else all.push(val);
        return all;
    }, []);
    return results.length === 1 ? results[0] : results.length === 0 ? "" : results;
}
function $59b415acb7c7c3b5$export$6f284aad1934db69(_a, getListFormat, values, options) {
    var locale = _a.locale, onError = _a.onError;
    if (options === void 0) options = {};
    var ListFormat = Intl.ListFormat;
    if (!ListFormat) onError(new (0, $8RUL4.FormatError)('Intl.ListFormat is not available in this environment.\nTry polyfilling it using "@formatjs/intl-listformat"\n', (0, $8RUL4.ErrorCode).MISSING_INTL_API));
    var filteredOptions = (0, $5VJfG.filterProps)(options, $59b415acb7c7c3b5$var$LIST_FORMAT_OPTIONS);
    try {
        var richValues_1 = {};
        var serializedValues = values.map(function(v, i) {
            if (typeof v === "object") {
                var id = $59b415acb7c7c3b5$var$generateToken(i);
                richValues_1[id] = v;
                return id;
            }
            return String(v);
        });
        return getListFormat(locale, filteredOptions).formatToParts(serializedValues).map(function(part) {
            return part.type === "literal" ? part : (0, $gb4K1.__assign)((0, $gb4K1.__assign)({}, part), {
                value: richValues_1[part.value] || part.value
            });
        });
    } catch (e) {
        onError(new (0, $dCg2n.IntlFormatError)("Error formatting list.", locale, e));
    }
    // @ts-ignore
    return values;
}

});

parcelRegister("1mQHj", function(module, exports) {

$parcel$export(module.exports, "formatDisplayName", function () { return $0ff0b927fde01746$export$62fe1a4d9e891fa2; });

var $5VJfG = parcelRequire("5VJfG");

var $8RUL4 = parcelRequire("8RUL4");

var $dCg2n = parcelRequire("dCg2n");
var $0ff0b927fde01746$var$DISPLAY_NAMES_OPTONS = [
    "style",
    "type",
    "fallback",
    "languageDisplay"
];
function $0ff0b927fde01746$export$62fe1a4d9e891fa2(_a, getDisplayNames, value, options) {
    var locale = _a.locale, onError = _a.onError;
    var DisplayNames = Intl.DisplayNames;
    if (!DisplayNames) onError(new (0, $8RUL4.FormatError)('Intl.DisplayNames is not available in this environment.\nTry polyfilling it using "@formatjs/intl-displaynames"\n', (0, $8RUL4.ErrorCode).MISSING_INTL_API));
    var filteredOptions = (0, $5VJfG.filterProps)(options, $0ff0b927fde01746$var$DISPLAY_NAMES_OPTONS);
    try {
        return getDisplayNames(locale, filteredOptions).of(value);
    } catch (e) {
        onError(new (0, $dCg2n.IntlFormatError)("Error formatting display name.", locale, e));
    }
}

});




parcelRegister("53xQg", function(module, exports) {

$parcel$export(module.exports, "SUPPORT_EMAIL", function () { return $3ae77be0b9196b9a$export$fc5cbb021d0697ad; });
/* eslint-disable import/prefer-default-export */ const $3ae77be0b9196b9a$export$fc5cbb021d0697ad = "support@trialbee.com";

});

parcelRegister("2Hhgv", function(module, exports) {

$parcel$export(module.exports, "subscribeMetrics", function () { return $1f6cfd70a6026f23$export$67af0da6a41789e4; });
$parcel$export(module.exports, "unsubscribeMetrics", function () { return $1f6cfd70a6026f23$export$32e6bda1c181c045; });
$parcel$export(module.exports, "submitMetric", function () { return $1f6cfd70a6026f23$export$fc3d95e08c10def0; });
$parcel$export(module.exports, "metricsDataFromState", function () { return $1f6cfd70a6026f23$export$f4930abe3d1aecb1; });
const $1f6cfd70a6026f23$var$subscribers = [];
function $1f6cfd70a6026f23$export$67af0da6a41789e4(callback) {
    $1f6cfd70a6026f23$var$subscribers.push(callback);
}
function $1f6cfd70a6026f23$export$32e6bda1c181c045(callback) {
    $1f6cfd70a6026f23$var$subscribers.splice($1f6cfd70a6026f23$var$subscribers.findIndex((c)=>c === callback), 1);
}
function $1f6cfd70a6026f23$export$fc3d95e08c10def0(action) {
    $1f6cfd70a6026f23$var$subscribers.forEach((subscriber)=>subscriber(action));
}
function $1f6cfd70a6026f23$export$f4930abe3d1aecb1({ pageName: pageName, ...state }) {
    const metricsData = {
        currentPage: pageName,
        subPage: state[pageName].subPage || null
    };
    if (state.questionnaire && state.sessionInfo.questions) metricsData.questionnaire = {
        questionsAnswered: Object.keys(state.questionnaire.answers || {}).map((id)=>{
            const [question, index] = state.sessionInfo.questions.map((value, i)=>[
                    value,
                    i + 1
                ]).find(([{ id: questionId }])=>questionId === id);
            return {
                index: index,
                key: question.key
            };
        })
    };
    if (state.clinicForm) metricsData.clinicForm = {
        siteIsSelected: Boolean(state.clinicForm.selectedSite)
    };
    if (state.contactDetails) metricsData.contactDetailsForm = {
        enteredFields: Object.entries(state.contactDetails.fieldValues || {}).filter((entry)=>entry[1].value).map(([key])=>key),
        fieldsWithErrors: Object.entries(state.contactDetails.fieldValues || {}).filter((entry)=>entry[1].errors && entry[1].errors.length).map(([key])=>key),
        hasConsented: state.contactDetails.consented
    };
    return metricsData;
}

});

parcelRegister("aeuny", function(module, exports) {

$parcel$export(module.exports, "CloseConfirmationProvider", function () { return $7732c6caa7a63e8d$export$9efa4137e8c31f94; });
$parcel$export(module.exports, "useCloseConfirmation", function () { return $7732c6caa7a63e8d$export$3feac60ccf59e145; });
$parcel$export(module.exports, "useIsLocked", function () { return $7732c6caa7a63e8d$export$2ae0e5727802c39e; });

var $cQNHH = parcelRequire("cQNHH");
parcelRequire("8u8eZ");
const $7732c6caa7a63e8d$var$CloseConfirmationContext = /*#__PURE__*/ (0, $cQNHH.createContext)();
function $7732c6caa7a63e8d$export$9efa4137e8c31f94({ children: children }) {
    const [{ lockCount: lockCount }, dispatch] = (0, $cQNHH.useReducer)((state, action)=>{
        if (action.type === "add") return {
            lockCount: state.lockCount + 1
        };
        else if (action.type === "remove") return {
            lockCount: state.lockCount - 1
        };
        return state;
    }, {
        lockCount: 0
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement($7732c6caa7a63e8d$var$CloseConfirmationContext.Provider, {
        // eslint-disable-next-line react/jsx-no-constructed-context-values
        value: {
            lockCount: lockCount,
            dispatch: dispatch
        }
    }, children);
}
function $7732c6caa7a63e8d$export$3feac60ccf59e145(enable = true) {
    const { dispatch: dispatch } = (0, $cQNHH.useContext)($7732c6caa7a63e8d$var$CloseConfirmationContext);
    (0, $cQNHH.useEffect)(()=>{
        if (enable) {
            dispatch({
                type: "add"
            });
            return ()=>dispatch({
                    type: "remove"
                });
        }
        return ()=>{};
    }, [
        enable
    ]);
}
function $7732c6caa7a63e8d$export$2ae0e5727802c39e() {
    const { lockCount: lockCount } = (0, $cQNHH.useContext)($7732c6caa7a63e8d$var$CloseConfirmationContext);
    return lockCount > 0;
}

});

parcelRegister("hgf0k", function(module, exports) {

$parcel$export(module.exports, "GlobalStateProvider", function () { return $c90f91d60b9576d3$export$262181a5dfabf1e3; });
$parcel$export(module.exports, "useGlobalScope", function () { return $c90f91d60b9576d3$export$d2cda2dad07d1c1; });
$parcel$export(module.exports, "useFullGlobalState", function () { return $c90f91d60b9576d3$export$a1ece1599f2c55ec; });

var $cQNHH = parcelRequire("cQNHH");
parcelRequire("8u8eZ");
function $c90f91d60b9576d3$var$set(obj, path, value) {
    const paths = path.split(".");
    let current = obj;
    for(let i = 0; i < paths.length - 1; i += 1){
        current[paths[i]] = current[paths[i]] || {};
        current = current[paths[i]];
    }
    current[paths[paths.length - 1]] = value;
}
const $c90f91d60b9576d3$var$StateContext = /*#__PURE__*/ (0, $cQNHH.createContext)();
function $c90f91d60b9576d3$export$262181a5dfabf1e3({ initialKeys: initialKeys, children: children }) {
    // Used to force rerender
    const [b, setB] = (0, $cQNHH.useState)(0);
    const initialState = (0, $cQNHH.useMemo)(()=>initialKeys.reduce((acc, key)=>({
                ...acc,
                [key]: {}
            }), {}));
    const state = (0, $cQNHH.useRef)(initialState);
    const setQueue = (0, $cQNHH.useRef)([]);
    const setState = (path, value, skipRerender)=>{
        if (!skipRerender) {
            setQueue.current.push([
                path,
                value
            ]);
            while(setQueue.current.length > 0){
                const [queuedPath, queuedValue] = setQueue.current.shift();
                $c90f91d60b9576d3$var$set(state.current, queuedPath, queuedValue);
            }
            setB(b + 1); // Forces a rerender
        } else $c90f91d60b9576d3$var$set(state.current, path, value);
    };
    return(// eslint-disable-next-line react/jsx-no-constructed-context-values
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement($c90f91d60b9576d3$var$StateContext.Provider, {
        value: {
            state: state.current,
            setState: setState
        }
    }, children));
}
$c90f91d60b9576d3$export$262181a5dfabf1e3.defaultProps = {
    initialKeys: []
};
function $c90f91d60b9576d3$export$d2cda2dad07d1c1(scope) {
    const { state: state, setState: setState } = (0, $cQNHH.useContext)($c90f91d60b9576d3$var$StateContext);
    const localState = state[scope] || {};
    // Works almost exactly the same as useState.
    // Returns [value, setter, propertySetter]
    // The `propertySetter` can be used to set nested properties. `propertySetter('foo.bar', 'baz');`
    // would result in `scope.property.foo.bar` being equal to baz.
    const useGlobalState = (property, defaultValue)=>{
        let value = localState[property];
        if (!Object.prototype.hasOwnProperty.call(localState, property)) {
            if (typeof defaultValue === "function") value = defaultValue();
            else value = defaultValue || null;
            setState(`${scope}.${property}`, value, true);
        }
        return [
            value,
            (newValue)=>setState(`${scope}.${property}`, newValue),
            (path, newValue)=>setState(`${scope}.${property}.${path}`, newValue)
        ];
    };
    return useGlobalState;
}
function $c90f91d60b9576d3$export$a1ece1599f2c55ec() {
    const { state: state, setState: setState } = (0, $cQNHH.useContext)($c90f91d60b9576d3$var$StateContext);
    return [
        state,
        setState
    ];
}

});

parcelRegister("7lOcN", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $55a170522605d2d5$export$2e2bcd8739ae039; });

var $cQNHH = parcelRequire("cQNHH");
let $55a170522605d2d5$var$counter = 0;
function $55a170522605d2d5$export$2e2bcd8739ae039(prefix = "tb") {
    const hasRun = (0, $cQNHH.useRef)(false);
    const value = (0, $cQNHH.useRef)($55a170522605d2d5$var$counter);
    if (!hasRun.current) {
        hasRun.current = true;
        $55a170522605d2d5$var$counter += 1;
    }
    return `${prefix}-${value.current}`;
}

});

parcelRegister("iTDkM", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $dc1be00365ac69a7$export$2e2bcd8739ae039; });

var $cQNHH = parcelRequire("cQNHH");
parcelRequire("8u8eZ");

var $i2fgf = parcelRequire("i2fgf");

var $iN8hK = parcelRequire("iN8hK");

var $dHJvE = parcelRequire("dHJvE");
function $dc1be00365ac69a7$var$EligibilityPage({ title: title, text: text, buttonText: buttonText, onButtonClick: onButtonClick, isEligible: isEligible, showButton: showButton, subText: subText, noIcon: noIcon, customPage: customPage }) {
    let icon = null;
    if (!noIcon) icon = isEligible ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement((0, $iN8hK.default), null) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement((0, $i2fgf.default), null);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement((0, $dHJvE.default), {
        buttonText: buttonText,
        customPage: customPage,
        icon: icon,
        onButtonClick: onButtonClick,
        showButton: showButton,
        subText: subText,
        text: text,
        title: title
    });
}
$dc1be00365ac69a7$var$EligibilityPage.defaultProps = {
    buttonText: undefined,
    customPage: {},
    isEligible: false,
    noIcon: false,
    onButtonClick: undefined,
    showButton: false,
    subText: undefined,
    text: undefined,
    title: undefined
};
var $dc1be00365ac69a7$export$2e2bcd8739ae039 = $dc1be00365ac69a7$var$EligibilityPage;

});
parcelRegister("i2fgf", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d2144070faf4ef3a$export$2e2bcd8739ae039; });

var $cQNHH = parcelRequire("cQNHH");
function $d2144070faf4ef3a$export$2e2bcd8739ae039() {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("svg", {
        viewBox: "0 0 258 158",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("path", {
        d: "M2.09 3.79L1.075 2.777.73 3.12l1.36 1.36 2.92-2.92-.343-.342z",
        id: "a"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("path", {
        d: "M2.09 3.79L1.075 2.777.73 3.12l1.36 1.36 2.92-2.92-.343-.342z",
        id: "c"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("path", {
        d: "M4.623 1.56l-.343-.343-1.36 1.36-1.36-1.36-.343.343 1.36 1.36-1.36 1.36.343.343 1.36-1.36 1.36 1.36.343-.343-1.36-1.36z",
        id: "e"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("path", {
        d: "M2.09 3.79L1.075 2.777.73 3.12l1.36 1.36 2.92-2.92-.343-.342z",
        id: "g"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("path", {
        d: "M17.032 2.839c-7.835 0-14.193 6.358-14.193 14.193 0 7.834 6.358 14.193 14.193 14.193 7.834 0 14.193-6.359 14.193-14.193 0-7.835-6.359-14.193-14.193-14.193zm1.419 21.29h-2.839v-2.84h2.839v2.84zm0-5.678h-2.839V9.935h2.839v8.516z",
        id: "i"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("g", {
        fill: "none",
        fillRule: "evenodd"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("ellipse", {
        cx: "129.197",
        cy: "149.222",
        fill: "#F0F1F1",
        rx: "59.124",
        ry: "8.778"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("g", {
        fill: "#BABFC0"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("g", {
        transform: "rotate(-180 98.175 34.014)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("ellipse", {
        cx: "2.92",
        cy: "38.037",
        rx: "2.92",
        ry: "2.926"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("path", {
        d: "M13.148 0h6.56v8.778h-6.56a4.389 4.389 0 0 1 0-8.778zM11.685 35.111h8.023v5.852h-8.023a2.926 2.926 0 1 1 0-5.852z"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("g", {
        transform: "translate(0 27.065)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("ellipse", {
        cx: "2.92",
        cy: "2.926",
        rx: "2.92",
        ry: "2.926"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("ellipse", {
        cx: "64.964",
        cy: "64.37",
        rx: "2.92",
        ry: "2.926"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("ellipse", {
        cx: "43.796",
        cy: "20.481",
        rx: "2.92",
        ry: "2.926"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("path", {
        d: "M20.444 0h61.308v5.852H20.444a2.926 2.926 0 1 1 0-5.852zM75.192 26.333h6.56v8.778h-6.56a4.389 4.389 0 0 1 0-8.778zM73.729 61.444h8.023v5.852h-8.023a2.926 2.926 0 0 1 0-5.852zM58.394 35.111h23.358v17.556H58.394a8.76 8.76 0 0 1-8.759-8.76v-.037a8.76 8.76 0 0 1 8.76-8.759z"
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("g", {
        transform: "translate(81.752)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("rect", {
        fill: "#BABFC0",
        height: "122.889",
        rx: "5.839",
        width: "94.891"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("rect", {
        fill: "#FFF",
        height: "111.185",
        rx: "2.92",
        width: "83.212",
        x: "5.839",
        y: "5.852"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("path", {
        d: "M29.197 99.481h48.175v5.852H29.197z",
        fill: "#F0F1F1"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("g", {
        transform: "translate(17.518 99.481)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("path", {
        d: "M0 0h5.84v5.84H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("mask", {
        fill: "#fff",
        id: "b"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("use", {
        xlinkHref: "#a"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("use", {
        fill: "#000",
        fillRule: "nonzero",
        xlinkHref: "#a"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("g", {
        fill: "#005B86",
        mask: "url(#b)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("path", {
        d: "M0 0h6.002v6.006H0z"
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("path", {
        d: "M29.197 87.777h48.175v5.852H29.197z",
        fill: "#F0F1F1"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("g", {
        transform: "translate(17.518 87.778)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("path", {
        d: "M0 0h5.84v5.84H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("mask", {
        fill: "#fff",
        id: "d"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("use", {
        xlinkHref: "#c"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("use", {
        fill: "#000",
        fillRule: "nonzero",
        xlinkHref: "#c"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("g", {
        fill: "#005B86",
        mask: "url(#d)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("path", {
        d: "M0 0h6.002v6.006H0z"
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("path", {
        d: "M29.197 76.074h48.175v5.852H29.197z",
        fill: "#F0F1F1"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("g", {
        transform: "translate(17.518 76.074)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("path", {
        d: "M0 0h5.84v5.84H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("mask", {
        fill: "#fff",
        id: "f"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("use", {
        xlinkHref: "#e"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("use", {
        fill: "#193159",
        fillRule: "nonzero",
        xlinkHref: "#e"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("g", {
        fill: "#FA6428",
        mask: "url(#f)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("path", {
        d: "M0 0h6.002v6.006H0z"
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("path", {
        d: "M29.197 64.37h48.175v5.852H29.197z",
        fill: "#F0F1F1"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("g", {
        transform: "translate(17.518 64.37)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("path", {
        d: "M0 0h5.84v5.84H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("mask", {
        fill: "#fff",
        id: "h"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("use", {
        xlinkHref: "#g"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("use", {
        fill: "#000",
        fillRule: "nonzero",
        xlinkHref: "#g"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("g", {
        fill: "#005B86",
        mask: "url(#h)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("path", {
        d: "M0 0h6.002v6.006H0z"
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("g", {
        transform: "translate(29.927 17.556)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("path", {
        d: "M0 0h34.063v34.063H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("mask", {
        fill: "#fff",
        id: "j"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("use", {
        xlinkHref: "#i"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("use", {
        fill: "#FFF",
        fillRule: "nonzero",
        transform: "matrix(1 0 0 -1 0 34.063)",
        xlinkHref: "#i"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("g", {
        fill: "#FA6428",
        mask: "url(#j)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("path", {
        d: "M0 0h34.009v34.035H0z"
    }))))));
}

});

parcelRegister("iN8hK", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $dae33adfe9479f38$export$2e2bcd8739ae039; });

var $cQNHH = parcelRequire("cQNHH");
function $dae33adfe9479f38$export$2e2bcd8739ae039() {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("svg", {
        viewBox: "0 0 258 158",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("path", {
        d: "M47.032 47.302l-2.058-1.873c-7.31-6.629-12.135-11-12.135-16.365 0-4.371 3.434-7.806 7.806-7.806 2.47 0 4.84 1.15 6.387 2.966 1.547-1.816 3.917-2.966 6.386-2.966 4.372 0 7.807 3.435 7.807 7.806 0 5.365-4.826 9.736-12.135 16.379l-2.058 1.86z",
        id: "a"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("g", {
        fill: "none",
        fillRule: "evenodd"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("ellipse", {
        cx: "129.197",
        cy: "148.278",
        fill: "#F0F1F1",
        rx: "59.124",
        ry: "8.722"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("g", {
        fill: "#BABFC0"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("g", {
        transform: "rotate(-180 98.175 33.799)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("ellipse", {
        cx: "2.92",
        cy: "37.796",
        rx: "2.92",
        ry: "2.907"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("path", {
        d: "M13.12 0h6.588v8.722H13.12a4.361 4.361 0 1 1 0-8.722zM11.667 34.889h8.041v5.815h-8.041a2.907 2.907 0 1 1 0-5.815z"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("g", {
        transform: "translate(0 26.894)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("ellipse", {
        cx: "2.92",
        cy: "2.907",
        rx: "2.92",
        ry: "2.907"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("ellipse", {
        cx: "64.964",
        cy: "63.963",
        rx: "2.92",
        ry: "2.907"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("ellipse", {
        cx: "43.796",
        cy: "20.352",
        rx: "2.92",
        ry: "2.907"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("path", {
        d: "M20.426 0h61.326v5.815H20.426a2.907 2.907 0 1 1 0-5.815zM75.164 26.167h6.588v8.722h-6.588a4.361 4.361 0 0 1 0-8.722zM73.71 61.056h8.042v5.814H73.71a2.907 2.907 0 1 1 0-5.815z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("path", {
        d: "M58.357 34.889h23.395v17.444H58.357a8.722 8.722 0 0 1 0-17.444z"
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("g", {
        transform: "translate(81.752)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("rect", {
        fill: "#BABFC0",
        height: "122.111",
        rx: "5.839",
        width: "94.891"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("rect", {
        fill: "#FFF",
        height: "110.481",
        rx: "2.92",
        width: "83.212",
        x: "5.839",
        y: "5.815"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("g", {
        fill: "#F0F1F1"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("path", {
        d: "M23.358 98.852h48.175v5.815H23.358zM23.358 87.222h48.175v5.815H23.358zM23.358 75.593h48.175v5.815H23.358zM23.358 63.963h48.175v5.815H23.358z"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("path", {
        d: "M30 17h34.063v34.063H30z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("use", {
        fill: "#DC143C",
        fillRule: "nonzero",
        xlinkHref: "#a"
    }))));
}

});

parcelRegister("dHJvE", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9fa297bbb7a7eb1a$export$2e2bcd8739ae039; });

var $7YYXE = parcelRequire("7YYXE");

var $7b1Lp = parcelRequire("7b1Lp");

var $cQNHH = parcelRequire("cQNHH");
parcelRequire("8u8eZ");

var $1YSJM = parcelRequire("1YSJM");

var $h5HRh = parcelRequire("h5HRh");

var $kvHhM = parcelRequire("kvHhM");
const $9fa297bbb7a7eb1a$var$useStyles = (0, $7b1Lp.default)((theme)=>({
        root: {
            display: "flex",
            flexGrow: 1,
            overflow: "auto"
        },
        container: {
            flexGrow: 1,
            width: "100%",
            maxWidth: 750,
            margin: "auto",
            textAlign: "center",
            padding: "0 30px",
            [theme.breakpoints.down("sm")]: {
                padding: "20px 10px"
            },
            "& > *": {
                marginBottom: 28,
                "&:first-child": {
                    marginTop: 56,
                    [theme.breakpoints.down("xs")]: {
                        marginTop: 28
                    }
                },
                "&:last-child": {
                    marginBottom: 56
                }
            }
        },
        iconContainer: {
            maxWidth: "100%",
            maxHeight: 200,
            height: "100%",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            flexShrink: 0,
            [theme.breakpoints.down("sm")]: {
                height: 100
            },
            "& svg": {
                height: "100%"
            }
        }
    }));
function $9fa297bbb7a7eb1a$var$Md(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement((0, $h5HRh.default), {
        ...props,
        overrideComponents: {
            p: (elProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("div", elProps)
        }
    });
}
function $9fa297bbb7a7eb1a$var$MessagePage({ icon: icon, title: title, text: text, showButton: showButton, buttonText: buttonText, onButtonClick: onButtonClick, subText: subText, customPage: customPage }) {
    const aria = (0, $1YSJM.default)();
    const classes = $9fa297bbb7a7eb1a$var$useStyles();
    const _text = customPage.text ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement($9fa297bbb7a7eb1a$var$Md, {
        tags: customPage.tags
    }, customPage.text) : text;
    const _subText = customPage.subText ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement($9fa297bbb7a7eb1a$var$Md, {
        tags: customPage.tags
    }, customPage.subText) : subText;
    const buttonClickHandler = ()=>onButtonClick(customPage.buttonAction);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("div", {
        className: classes.root,
        ...aria
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("div", {
        className: classes.container
    }, icon && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("div", {
        "aria-hidden": "true",
        className: classes.iconContainer
    }, icon), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement((0, $kvHhM.MainHeading), {
        noUnderline: !_text && !_subText
    }, customPage.title || title), _text && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement((0, $kvHhM.NormalText), null, _text), _subText && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement((0, $kvHhM.SubtleText), {
        variant: "subtitle1"
    }, _subText), showButton && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement((0, $7YYXE.default), {
        color: "primary",
        onClick: buttonClickHandler,
        variant: "contained"
    }, customPage.buttonText || buttonText)));
}
$9fa297bbb7a7eb1a$var$MessagePage.defaultProps = {
    buttonText: undefined,
    customPage: {},
    icon: null,
    onButtonClick: undefined,
    showButton: false,
    subText: undefined,
    text: undefined
};
var $9fa297bbb7a7eb1a$export$2e2bcd8739ae039 = $9fa297bbb7a7eb1a$var$MessagePage;

});


parcelRegister("ki4tF", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ec58f63519aad129$export$2e2bcd8739ae039; });

var $6WDy5 = parcelRequire("6WDy5");

var $cQNHH = parcelRequire("cQNHH");

var $8dv03 = parcelRequire("8dv03");
function $ec58f63519aad129$export$2e2bcd8739ae039() {
    var theme = (0, $6WDy5.default)() || (0, $8dv03.default);
    // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).useDebugValue(theme);
    return theme;
}

});

parcelRegister("fpN3t", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b38f3e2033a8b759$export$2e2bcd8739ae039; });

var $gtn2B = parcelRequire("gtn2B");

var $cQNHH = parcelRequire("cQNHH");

var $jB5O2 = parcelRequire("jB5O2");
var $6WDy5 = parcelRequire("6WDy5");
function $b38f3e2033a8b759$export$2e2bcd8739ae039(queryInput) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var theme = (0, $6WDy5.default)();
    var props = (0, $jB5O2.default)({
        theme: theme,
        name: "MuiUseMediaQuery",
        props: {}
    });
    if (typeof queryInput === "function" && theme === null) console.error([
        "Material-UI: The `query` argument provided is invalid.",
        "You are providing a function without a theme in the context.",
        "One of the parent elements needs to use a ThemeProvider."
    ].join("\n"));
    var query = typeof queryInput === "function" ? queryInput(theme) : queryInput;
    query = query.replace(/^@media( ?)/m, ""); // Wait for jsdom to support the match media feature.
    // All the browsers Material-UI support have this built-in.
    // This defensive check is here for simplicity.
    // Most of the time, the match media logic isn't central to people tests.
    var supportMatchMedia = typeof window !== "undefined" && typeof window.matchMedia !== "undefined";
    var _props$options = (0, $gtn2B.default)({}, props, options), _props$options$defaul = _props$options.defaultMatches, defaultMatches = _props$options$defaul === void 0 ? false : _props$options$defaul, _props$options$matchM = _props$options.matchMedia, matchMedia = _props$options$matchM === void 0 ? supportMatchMedia ? window.matchMedia : null : _props$options$matchM, _props$options$noSsr = _props$options.noSsr, noSsr = _props$options$noSsr === void 0 ? false : _props$options$noSsr, _props$options$ssrMat = _props$options.ssrMatchMedia, ssrMatchMedia = _props$options$ssrMat === void 0 ? null : _props$options$ssrMat;
    var _React$useState = $cQNHH.useState(function() {
        if (noSsr && supportMatchMedia) return matchMedia(query).matches;
        if (ssrMatchMedia) return ssrMatchMedia(query).matches;
         // Once the component is mounted, we rely on the
        // event listeners to return the correct matches value.
        return defaultMatches;
    }), match = _React$useState[0], setMatch = _React$useState[1];
    $cQNHH.useEffect(function() {
        var active = true;
        if (!supportMatchMedia) return undefined;
        var queryList = matchMedia(query);
        var updateMatch = function updateMatch() {
            // Workaround Safari wrong implementation of matchMedia
            // TODO can we remove it?
            // https://github.com/mui-org/material-ui/pull/17315#issuecomment-528286677
            if (active) setMatch(queryList.matches);
        };
        updateMatch();
        queryList.addListener(updateMatch);
        return function() {
            active = false;
            queryList.removeListener(updateMatch);
        };
    }, [
        query,
        matchMedia,
        supportMatchMedia
    ]);
    // eslint-disable-next-line react-hooks/rules-of-hooks
    $cQNHH.useDebugValue({
        query: query,
        match: match
    });
    return match;
}

});

parcelRegister("ioHzT", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d64c4587dc185195$export$2e2bcd8739ae039; });

var $7YYXE = parcelRequire("7YYXE");

var $gqYIj = parcelRequire("gqYIj");

var $fG0QW = parcelRequire("fG0QW");

var $7b1Lp = parcelRequire("7b1Lp");
var $6WDy5 = parcelRequire("6WDy5");

var $cQNHH = parcelRequire("cQNHH");
parcelRequire("8u8eZ");
const $d64c4587dc185195$var$useStyles = (0, $7b1Lp.default)((theme)=>({
        root: {
            maxWidth: 290,
            width: "100%",
            textTransform: "none",
            [theme.breakpoints.down("xs")]: {
                maxWidth: "100%"
            },
            "& > span > :not(:last-child)": {
                marginRight: theme.direction === "ltr" && "10px",
                marginLeft: theme.direction === "rtl" && "10px"
            }
        },
        filler: {
            flex: "0 1 24px",
            display: "block"
        },
        childContainer: {
            flexGrow: 1
        },
        arrowLeft: {
            left: 5
        },
        arrowRight: {
            right: 5
        }
    }));
function $d64c4587dc185195$var$ButtonWithArrow({ children: children, arrowSide: arrowSide, compact: compact, hideText: hideText, ...buttonProps }) {
    const classes = $d64c4587dc185195$var$useStyles();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement((0, $7YYXE.default), {
        className: classes.root,
        ...buttonProps
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement($d64c4587dc185195$var$ArrowSide, {
        arrowSide: arrowSide,
        compact: compact,
        hideText: hideText
    }, children));
}
function $d64c4587dc185195$var$ArrowSide({ arrowSide: arrowSide, compact: compact, hideText: hideText, children: children }) {
    const classes = $d64c4587dc185195$var$useStyles();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).Fragment, null, arrowSide === "left" ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement($d64c4587dc185195$var$ArrowSideLeft, null) : !compact && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("span", {
        className: classes.filler
    }), !hideText && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("div", {
        className: classes.childContainer
    }, children), arrowSide === "right" ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement($d64c4587dc185195$var$ArrowSideRight, null) : !compact && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("span", {
        className: classes.filler
    }));
}
function $d64c4587dc185195$var$ArrowSideLeft() {
    const classes = $d64c4587dc185195$var$useStyles();
    const theme = (0, $6WDy5.default)();
    return theme.direction === "rtl" ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fG0QW))), {
        className: classes.arrowRight
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gqYIj))), {
        className: classes.arrowLeft
    });
}
function $d64c4587dc185195$var$ArrowSideRight() {
    const classes = $d64c4587dc185195$var$useStyles();
    const theme = (0, $6WDy5.default)();
    return theme.direction === "rtl" ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gqYIj))), {
        className: classes.arrowLeft
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fG0QW))), {
        className: classes.arrowRight
    });
}
$d64c4587dc185195$var$ArrowSide.defaultProps = {
    arrowSide: "right",
    compact: false,
    hideText: false
};
$d64c4587dc185195$var$ButtonWithArrow.defaultProps = {
    arrowSide: "right",
    color: "inherit",
    compact: false,
    hideText: false
};
var $d64c4587dc185195$export$2e2bcd8739ae039 = $d64c4587dc185195$var$ButtonWithArrow;

});
parcelRegister("gqYIj", function(module, exports) {
"use strict";

var $kFrsj = parcelRequire("kFrsj");

var $8jEx7 = parcelRequire("8jEx7");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $bf6e2b8988242713$var$React = $8jEx7((parcelRequire("cQNHH")));

var $bf6e2b8988242713$var$_createSvgIcon = $kFrsj((parcelRequire("bXzXC")));
var $bf6e2b8988242713$var$_default = (0, $bf6e2b8988242713$var$_createSvgIcon.default)(/*#__PURE__*/ $bf6e2b8988242713$var$React.createElement("path", {
    d: "M20 11H7.83l5.59-5.59L12 4l-8 8 8 8 1.41-1.41L7.83 13H20v-2z"
}), "ArrowBack");
module.exports.default = $bf6e2b8988242713$var$_default;

});

parcelRegister("fG0QW", function(module, exports) {
"use strict";

var $kFrsj = parcelRequire("kFrsj");

var $8jEx7 = parcelRequire("8jEx7");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $b69b70a505936db5$var$React = $8jEx7((parcelRequire("cQNHH")));

var $b69b70a505936db5$var$_createSvgIcon = $kFrsj((parcelRequire("bXzXC")));
var $b69b70a505936db5$var$_default = (0, $b69b70a505936db5$var$_createSvgIcon.default)(/*#__PURE__*/ $b69b70a505936db5$var$React.createElement("path", {
    d: "M12 4l-1.41 1.41L16.17 11H4v2h12.17l-5.58 5.59L12 20l8-8z"
}), "ArrowForward");
module.exports.default = $b69b70a505936db5$var$_default;

});


parcelRegister("k4Dr6", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e9d2c58d5a97a323$export$2e2bcd8739ae039; });

var $lHE6I = parcelRequire("lHE6I");

var $ki4tF = parcelRequire("ki4tF");

var $fpN3t = parcelRequire("fpN3t");

var $7b1Lp = parcelRequire("7b1Lp");

var $cQNHH = parcelRequire("cQNHH");

var $kV13H = parcelRequire("kV13H");
parcelRequire("8u8eZ");

var $jge0r = parcelRequire("jge0r");

var $ioHzT = parcelRequire("ioHzT");
const $e9d2c58d5a97a323$var$useStyles = (0, $7b1Lp.default)((theme)=>({
        root: {
            width: "100%",
            backgroundColor: "white",
            boxShadow: "0px 0px 10px rgba(0, 0, 0, 0.15)",
            zIndex: 100,
            display: "flex",
            flex: "0 0 auto",
            [theme.breakpoints.down("xs")]: {
                flexDirection: "column",
                justifyContent: "space-around"
            },
            "@media print": {
                display: "none"
            }
        },
        children: {
            flexGrow: 1,
            padding: "7px 16px",
            display: "flex",
            alignItems: "center"
        },
        buttons: {
            display: "flex",
            flexGrow: 1,
            "& > *": {
                padding: "7px 16px",
                display: "flex",
                alignItems: "center"
            }
        },
        spacer: {
            flexGrow: 1,
            padding: 0
        },
        backButton: {
            color: theme.palette.grey[600],
            "& > *": {
                minWidth: 0
            },
            [theme.breakpoints.down("xs")]: {
                minWidth: "48px",
                paddingRight: 0
            }
        },
        warningButton: {
            paddingRight: 0,
            color: theme.palette.warning.main
        },
        continueButton: {
            minWidth: 200,
            "& > *": {
                width: "100%"
            },
            [theme.breakpoints.down("xs")]: {
                width: "100%"
            }
        }
    }));
function $e9d2c58d5a97a323$var$Footer({ children: children, formIsComplete: formIsComplete, onBackClick: onBackClick, onContinueClick: onContinueClick, footerText: footerText, loading: loading, liveRegionId: liveRegionId, warning: warning, nextPageName: nextPageName, prevPageName: prevPageName }) {
    const theme = (0, $ki4tF.default)();
    const small = (0, $fpN3t.default)(theme.breakpoints.down("xs"));
    const classes = $e9d2c58d5a97a323$var$useStyles();
    const isSubmitPage = nextPageName === "completed";
    const nextBtnText = footerText || (isSubmitPage ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement((0, $kV13H.default), {
        defaultMessage: "Submit",
        id: "Footer.submit"
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement((0, $kV13H.default), {
        defaultMessage: "Next",
        id: "Footer.next"
    }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("footer", {
        className: classes.root
    }, children && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("div", {
        className: classes.children
    }, children), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("div", {
        className: classes.buttons
    }, onBackClick && prevPageName && prevPageName !== "questionnaire" && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("div", {
        className: classes.backButton
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement((0, $ioHzT.default), {
        "data-testid": "back-button",
        "aria-controls": liveRegionId,
        arrowSide: "left",
        compact: true,
        hideText: small,
        onClick: onBackClick
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement((0, $kV13H.default), {
        defaultMessage: "Back",
        id: "Footer.back"
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("span", {
        className: classes.spacer
    }), warning && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("div", {
        className: classes.warningButton
    }, warning), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("div", {
        className: classes.continueButton
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement((0, $ioHzT.default), {
        "data-testid": "continue-button",
        "aria-controls": liveRegionId,
        color: "primary",
        compact: true,
        disabled: !formIsComplete || loading,
        onClick: ()=>{
            if (isSubmitPage && formIsComplete) (0, $jge0r.userMetrics).track("Submit button pressed");
            onContinueClick();
        },
        variant: "contained"
    }, loading ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement((0, $lHE6I.default), {
        size: 28
    }) : nextBtnText))));
}
$e9d2c58d5a97a323$var$Footer.defaultProps = {
    children: undefined,
    loading: false,
    nextPageName: undefined,
    onBackClick: undefined,
    prevPageName: undefined,
    warning: undefined
};
var $e9d2c58d5a97a323$export$2e2bcd8739ae039 = $e9d2c58d5a97a323$var$Footer;

});

parcelRegister("4pYia", function(module, exports) {

var $iWqN5 = parcelRequire("iWqN5");
module.exports = Promise.all([
    $iWqN5("kYxDn"),
    $iWqN5("4Ks7K")
]).then(()=>parcelRequire("7kKfH"));

});
parcelRegister("iWqN5", function(module, exports) {
"use strict";

function $dca26cdb128fd356$var$load(id) {
    // eslint-disable-next-line no-undef
    return import((parcelRequire("c5HCY")).resolve(id));
}
module.exports = $dca26cdb128fd356$var$load;

});


parcelRegister("XF2by", function(module, exports) {

var $iWqN5 = parcelRequire("iWqN5");
module.exports = Promise.all([
    $iWqN5("hUWfe"),
    $iWqN5("7ADK3")
]).then(()=>parcelRequire("fSdGL"));

});

parcelRegister("3JUnY", function(module, exports) {

var $iWqN5 = parcelRequire("iWqN5");
module.exports = Promise.all([
    $iWqN5("hUWfe"),
    $iWqN5("kYxDn"),
    $iWqN5("dJ5dO")
]).then(()=>parcelRequire("hvptt"));

});

parcelRegister("7VhxQ", function(module, exports) {

var $iWqN5 = parcelRequire("iWqN5");
module.exports = $iWqN5("fRSG6").then(()=>parcelRequire("dhDqy"));

});

parcelRegister("1rrDX", function(module, exports) {
/**
 * Lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright OpenJS Foundation and other contributors <https://openjsf.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */ /** Used as the size to enable large array optimizations. */ var LARGE_ARRAY_SIZE = 200;
/** Used to stand-in for `undefined` hash values. */ var HASH_UNDEFINED = "__lodash_hash_undefined__";
/** Used to detect hot functions by number of calls within a span of milliseconds. */ var HOT_COUNT = 800, HOT_SPAN = 16;
/** Used as references for various `Number` constants. */ var MAX_SAFE_INTEGER = 9007199254740991;
/** `Object#toString` result references. */ var argsTag = "[object Arguments]", arrayTag = "[object Array]", asyncTag = "[object AsyncFunction]", boolTag = "[object Boolean]", dateTag = "[object Date]", errorTag = "[object Error]", funcTag = "[object Function]", genTag = "[object GeneratorFunction]", mapTag = "[object Map]", numberTag = "[object Number]", nullTag = "[object Null]", objectTag = "[object Object]", proxyTag = "[object Proxy]", regexpTag = "[object RegExp]", setTag = "[object Set]", stringTag = "[object String]", undefinedTag = "[object Undefined]", weakMapTag = "[object WeakMap]";
var arrayBufferTag = "[object ArrayBuffer]", dataViewTag = "[object DataView]", float32Tag = "[object Float32Array]", float64Tag = "[object Float64Array]", int8Tag = "[object Int8Array]", int16Tag = "[object Int16Array]", int32Tag = "[object Int32Array]", uint8Tag = "[object Uint8Array]", uint8ClampedTag = "[object Uint8ClampedArray]", uint16Tag = "[object Uint16Array]", uint32Tag = "[object Uint32Array]";
/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */ var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
/** Used to detect host constructors (Safari). */ var reIsHostCtor = /^\[object .+?Constructor\]$/;
/** Used to detect unsigned integer values. */ var reIsUint = /^(?:0|[1-9]\d*)$/;
/** Used to identify `toStringTag` values of typed arrays. */ var typedArrayTags = {};
typedArrayTags[float32Tag] = typedArrayTags[float64Tag] = typedArrayTags[int8Tag] = typedArrayTags[int16Tag] = typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] = typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] = typedArrayTags[uint32Tag] = true;
typedArrayTags[argsTag] = typedArrayTags[arrayTag] = typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] = typedArrayTags[dataViewTag] = typedArrayTags[dateTag] = typedArrayTags[errorTag] = typedArrayTags[funcTag] = typedArrayTags[mapTag] = typedArrayTags[numberTag] = typedArrayTags[objectTag] = typedArrayTags[regexpTag] = typedArrayTags[setTag] = typedArrayTags[stringTag] = typedArrayTags[weakMapTag] = false;
/** Detect free variable `global` from Node.js. */ var freeGlobal = typeof $parcel$global == "object" && $parcel$global && $parcel$global.Object === Object && $parcel$global;
/** Detect free variable `self`. */ var freeSelf = typeof self == "object" && self && self.Object === Object && self;
/** Used as a reference to the global object. */ var root = freeGlobal || freeSelf || Function("return this")();
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Detect free variable `process` from Node.js. */ var freeProcess = moduleExports && freeGlobal.process;
/** Used to access faster Node.js helpers. */ var nodeUtil = function() {
    try {
        // Use `util.types` for Node.js 10+.
        var types = freeModule && freeModule.require && freeModule.require("util").types;
        if (types) return types;
        // Legacy `process.binding('util')` for Node.js < 10.
        return freeProcess && freeProcess.binding && freeProcess.binding("util");
    } catch (e) {}
}();
/* Node.js helper references. */ var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
/**
 * A faster alternative to `Function#apply`, this function invokes `func`
 * with the `this` binding of `thisArg` and the arguments of `args`.
 *
 * @private
 * @param {Function} func The function to invoke.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {Array} args The arguments to invoke `func` with.
 * @returns {*} Returns the result of `func`.
 */ function apply(func, thisArg, args) {
    switch(args.length){
        case 0:
            return func.call(thisArg);
        case 1:
            return func.call(thisArg, args[0]);
        case 2:
            return func.call(thisArg, args[0], args[1]);
        case 3:
            return func.call(thisArg, args[0], args[1], args[2]);
    }
    return func.apply(thisArg, args);
}
/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */ function baseTimes(n, iteratee) {
    var index = -1, result = Array(n);
    while(++index < n)result[index] = iteratee(index);
    return result;
}
/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */ function baseUnary(func) {
    return function(value) {
        return func(value);
    };
}
/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */ function getValue(object, key) {
    return object == null ? undefined : object[key];
}
/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */ function overArg(func, transform) {
    return function(arg) {
        return func(transform(arg));
    };
}
/** Used for built-in method references. */ var arrayProto = Array.prototype, funcProto = Function.prototype, objectProto = Object.prototype;
/** Used to detect overreaching core-js shims. */ var coreJsData = root["__core-js_shared__"];
/** Used to resolve the decompiled source of functions. */ var funcToString = funcProto.toString;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/** Used to detect methods masquerading as native. */ var maskSrcKey = function() {
    var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || "");
    return uid ? "Symbol(src)_1." + uid : "";
}();
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var nativeObjectToString = objectProto.toString;
/** Used to infer the `Object` constructor. */ var objectCtorString = funcToString.call(Object);
/** Used to detect if a method is native. */ var reIsNative = RegExp("^" + funcToString.call(hasOwnProperty).replace(reRegExpChar, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$");
/** Built-in value references. */ var Buffer = moduleExports ? root.Buffer : undefined, Symbol = root.Symbol, Uint8Array = root.Uint8Array, allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined, getPrototype = overArg(Object.getPrototypeOf, Object), objectCreate = Object.create, propertyIsEnumerable = objectProto.propertyIsEnumerable, splice = arrayProto.splice, symToStringTag = Symbol ? Symbol.toStringTag : undefined;
var defineProperty = function() {
    try {
        var func = getNative(Object, "defineProperty");
        func({}, "", {});
        return func;
    } catch (e) {}
}();
/* Built-in method references for those with the same name as other `lodash` methods. */ var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined, nativeMax = Math.max, nativeNow = Date.now;
/* Built-in method references that are verified to be native. */ var Map = getNative(root, "Map"), nativeCreate = getNative(Object, "create");
/**
 * The base implementation of `_.create` without support for assigning
 * properties to the created object.
 *
 * @private
 * @param {Object} proto The object to inherit from.
 * @returns {Object} Returns the new object.
 */ var baseCreate = function() {
    function object() {}
    return function(proto) {
        if (!isObject(proto)) return {};
        if (objectCreate) return objectCreate(proto);
        object.prototype = proto;
        var result = new object;
        object.prototype = undefined;
        return result;
    };
}();
/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function Hash(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */ function hashClear() {
    this.__data__ = nativeCreate ? nativeCreate(null) : {};
    this.size = 0;
}
/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function hashDelete(key) {
    var result = this.has(key) && delete this.__data__[key];
    this.size -= result ? 1 : 0;
    return result;
}
/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function hashGet(key) {
    var data = this.__data__;
    if (nativeCreate) {
        var result = data[key];
        return result === HASH_UNDEFINED ? undefined : result;
    }
    return hasOwnProperty.call(data, key) ? data[key] : undefined;
}
/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function hashHas(key) {
    var data = this.__data__;
    return nativeCreate ? data[key] !== undefined : hasOwnProperty.call(data, key);
}
/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */ function hashSet(key, value) {
    var data = this.__data__;
    this.size += this.has(key) ? 0 : 1;
    data[key] = nativeCreate && value === undefined ? HASH_UNDEFINED : value;
    return this;
}
// Add methods to `Hash`.
Hash.prototype.clear = hashClear;
Hash.prototype["delete"] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;
/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function ListCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */ function listCacheClear() {
    this.__data__ = [];
    this.size = 0;
}
/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function listCacheDelete(key) {
    var data = this.__data__, index = assocIndexOf(data, key);
    if (index < 0) return false;
    var lastIndex = data.length - 1;
    if (index == lastIndex) data.pop();
    else splice.call(data, index, 1);
    --this.size;
    return true;
}
/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function listCacheGet(key) {
    var data = this.__data__, index = assocIndexOf(data, key);
    return index < 0 ? undefined : data[index][1];
}
/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function listCacheHas(key) {
    return assocIndexOf(this.__data__, key) > -1;
}
/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */ function listCacheSet(key, value) {
    var data = this.__data__, index = assocIndexOf(data, key);
    if (index < 0) {
        ++this.size;
        data.push([
            key,
            value
        ]);
    } else data[index][1] = value;
    return this;
}
// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype["delete"] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;
/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function MapCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */ function mapCacheClear() {
    this.size = 0;
    this.__data__ = {
        "hash": new Hash,
        "map": new (Map || ListCache),
        "string": new Hash
    };
}
/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function mapCacheDelete(key) {
    var result = getMapData(this, key)["delete"](key);
    this.size -= result ? 1 : 0;
    return result;
}
/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function mapCacheGet(key) {
    return getMapData(this, key).get(key);
}
/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function mapCacheHas(key) {
    return getMapData(this, key).has(key);
}
/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */ function mapCacheSet(key, value) {
    var data = getMapData(this, key), size = data.size;
    data.set(key, value);
    this.size += data.size == size ? 0 : 1;
    return this;
}
// Add methods to `MapCache`.
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype["delete"] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;
/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function Stack(entries) {
    var data = this.__data__ = new ListCache(entries);
    this.size = data.size;
}
/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */ function stackClear() {
    this.__data__ = new ListCache;
    this.size = 0;
}
/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function stackDelete(key) {
    var data = this.__data__, result = data["delete"](key);
    this.size = data.size;
    return result;
}
/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function stackGet(key) {
    return this.__data__.get(key);
}
/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function stackHas(key) {
    return this.__data__.has(key);
}
/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */ function stackSet(key, value) {
    var data = this.__data__;
    if (data instanceof ListCache) {
        var pairs = data.__data__;
        if (!Map || pairs.length < LARGE_ARRAY_SIZE - 1) {
            pairs.push([
                key,
                value
            ]);
            this.size = ++data.size;
            return this;
        }
        data = this.__data__ = new MapCache(pairs);
    }
    data.set(key, value);
    this.size = data.size;
    return this;
}
// Add methods to `Stack`.
Stack.prototype.clear = stackClear;
Stack.prototype["delete"] = stackDelete;
Stack.prototype.get = stackGet;
Stack.prototype.has = stackHas;
Stack.prototype.set = stackSet;
/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */ function arrayLikeKeys(value, inherited) {
    var isArr = isArray(value), isArg = !isArr && isArguments(value), isBuff = !isArr && !isArg && isBuffer(value), isType = !isArr && !isArg && !isBuff && isTypedArray(value), skipIndexes = isArr || isArg || isBuff || isType, result = skipIndexes ? baseTimes(value.length, String) : [], length = result.length;
    for(var key in value)if ((inherited || hasOwnProperty.call(value, key)) && !(skipIndexes && // Safari 9 has enumerable `arguments.length` in strict mode.
    (key == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
    isBuff && (key == "offset" || key == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
    isType && (key == "buffer" || key == "byteLength" || key == "byteOffset") || // Skip index properties.
    isIndex(key, length)))) result.push(key);
    return result;
}
/**
 * This function is like `assignValue` except that it doesn't assign
 * `undefined` values.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */ function assignMergeValue(object, key, value) {
    if (value !== undefined && !eq(object[key], value) || value === undefined && !(key in object)) baseAssignValue(object, key, value);
}
/**
 * Assigns `value` to `key` of `object` if the existing value is not equivalent
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */ function assignValue(object, key, value) {
    var objValue = object[key];
    if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) || value === undefined && !(key in object)) baseAssignValue(object, key, value);
}
/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function assocIndexOf(array, key) {
    var length = array.length;
    while(length--){
        if (eq(array[length][0], key)) return length;
    }
    return -1;
}
/**
 * The base implementation of `assignValue` and `assignMergeValue` without
 * value checks.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */ function baseAssignValue(object, key, value) {
    if (key == "__proto__" && defineProperty) defineProperty(object, key, {
        "configurable": true,
        "enumerable": true,
        "value": value,
        "writable": true
    });
    else object[key] = value;
}
/**
 * The base implementation of `baseForOwn` which iterates over `object`
 * properties returned by `keysFunc` and invokes `iteratee` for each property.
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @returns {Object} Returns `object`.
 */ var baseFor = createBaseFor();
/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ function baseGetTag(value) {
    if (value == null) return value === undefined ? undefinedTag : nullTag;
    return symToStringTag && symToStringTag in Object(value) ? getRawTag(value) : objectToString(value);
}
/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */ function baseIsArguments(value) {
    return isObjectLike(value) && baseGetTag(value) == argsTag;
}
/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */ function baseIsNative(value) {
    if (!isObject(value) || isMasked(value)) return false;
    var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
    return pattern.test(toSource(value));
}
/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */ function baseIsTypedArray(value) {
    return isObjectLike(value) && isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
}
/**
 * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function baseKeysIn(object) {
    if (!isObject(object)) return nativeKeysIn(object);
    var isProto = isPrototype(object), result = [];
    for(var key in object)if (!(key == "constructor" && (isProto || !hasOwnProperty.call(object, key)))) result.push(key);
    return result;
}
/**
 * The base implementation of `_.merge` without support for multiple sources.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @param {number} srcIndex The index of `source`.
 * @param {Function} [customizer] The function to customize merged values.
 * @param {Object} [stack] Tracks traversed source values and their merged
 *  counterparts.
 */ function baseMerge(object, source, srcIndex, customizer, stack) {
    if (object === source) return;
    baseFor(source, function(srcValue, key) {
        stack || (stack = new Stack);
        if (isObject(srcValue)) baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
        else {
            var newValue = customizer ? customizer(safeGet(object, key), srcValue, key + "", object, source, stack) : undefined;
            if (newValue === undefined) newValue = srcValue;
            assignMergeValue(object, key, newValue);
        }
    }, keysIn);
}
/**
 * A specialized version of `baseMerge` for arrays and objects which performs
 * deep merges and tracks traversed objects enabling objects with circular
 * references to be merged.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @param {string} key The key of the value to merge.
 * @param {number} srcIndex The index of `source`.
 * @param {Function} mergeFunc The function to merge values.
 * @param {Function} [customizer] The function to customize assigned values.
 * @param {Object} [stack] Tracks traversed source values and their merged
 *  counterparts.
 */ function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
    var objValue = safeGet(object, key), srcValue = safeGet(source, key), stacked = stack.get(srcValue);
    if (stacked) {
        assignMergeValue(object, key, stacked);
        return;
    }
    var newValue = customizer ? customizer(objValue, srcValue, key + "", object, source, stack) : undefined;
    var isCommon = newValue === undefined;
    if (isCommon) {
        var isArr = isArray(srcValue), isBuff = !isArr && isBuffer(srcValue), isTyped = !isArr && !isBuff && isTypedArray(srcValue);
        newValue = srcValue;
        if (isArr || isBuff || isTyped) {
            if (isArray(objValue)) newValue = objValue;
            else if (isArrayLikeObject(objValue)) newValue = copyArray(objValue);
            else if (isBuff) {
                isCommon = false;
                newValue = cloneBuffer(srcValue, true);
            } else if (isTyped) {
                isCommon = false;
                newValue = cloneTypedArray(srcValue, true);
            } else newValue = [];
        } else if (isPlainObject(srcValue) || isArguments(srcValue)) {
            newValue = objValue;
            if (isArguments(objValue)) newValue = toPlainObject(objValue);
            else if (!isObject(objValue) || isFunction(objValue)) newValue = initCloneObject(srcValue);
        } else isCommon = false;
    }
    if (isCommon) {
        // Recursively merge objects and arrays (susceptible to call stack limits).
        stack.set(srcValue, newValue);
        mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
        stack["delete"](srcValue);
    }
    assignMergeValue(object, key, newValue);
}
/**
 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @returns {Function} Returns the new function.
 */ function baseRest(func, start) {
    return setToString(overRest(func, start, identity), func + "");
}
/**
 * The base implementation of `setToString` without support for hot loop shorting.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */ var baseSetToString = !defineProperty ? identity : function(func, string) {
    return defineProperty(func, "toString", {
        "configurable": true,
        "enumerable": false,
        "value": constant(string),
        "writable": true
    });
};
/**
 * Creates a clone of  `buffer`.
 *
 * @private
 * @param {Buffer} buffer The buffer to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Buffer} Returns the cloned buffer.
 */ function cloneBuffer(buffer, isDeep) {
    if (isDeep) return buffer.slice();
    var length = buffer.length, result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);
    buffer.copy(result);
    return result;
}
/**
 * Creates a clone of `arrayBuffer`.
 *
 * @private
 * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
 * @returns {ArrayBuffer} Returns the cloned array buffer.
 */ function cloneArrayBuffer(arrayBuffer) {
    var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
    new Uint8Array(result).set(new Uint8Array(arrayBuffer));
    return result;
}
/**
 * Creates a clone of `typedArray`.
 *
 * @private
 * @param {Object} typedArray The typed array to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned typed array.
 */ function cloneTypedArray(typedArray, isDeep) {
    var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
    return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
}
/**
 * Copies the values of `source` to `array`.
 *
 * @private
 * @param {Array} source The array to copy values from.
 * @param {Array} [array=[]] The array to copy values to.
 * @returns {Array} Returns `array`.
 */ function copyArray(source, array) {
    var index = -1, length = source.length;
    array || (array = Array(length));
    while(++index < length)array[index] = source[index];
    return array;
}
/**
 * Copies properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy properties from.
 * @param {Array} props The property identifiers to copy.
 * @param {Object} [object={}] The object to copy properties to.
 * @param {Function} [customizer] The function to customize copied values.
 * @returns {Object} Returns `object`.
 */ function copyObject(source, props, object, customizer) {
    var isNew = !object;
    object || (object = {});
    var index = -1, length = props.length;
    while(++index < length){
        var key = props[index];
        var newValue = customizer ? customizer(object[key], source[key], key, object, source) : undefined;
        if (newValue === undefined) newValue = source[key];
        if (isNew) baseAssignValue(object, key, newValue);
        else assignValue(object, key, newValue);
    }
    return object;
}
/**
 * Creates a function like `_.assign`.
 *
 * @private
 * @param {Function} assigner The function to assign values.
 * @returns {Function} Returns the new assigner function.
 */ function createAssigner(assigner) {
    return baseRest(function(object, sources) {
        var index = -1, length = sources.length, customizer = length > 1 ? sources[length - 1] : undefined, guard = length > 2 ? sources[2] : undefined;
        customizer = assigner.length > 3 && typeof customizer == "function" ? (length--, customizer) : undefined;
        if (guard && isIterateeCall(sources[0], sources[1], guard)) {
            customizer = length < 3 ? undefined : customizer;
            length = 1;
        }
        object = Object(object);
        while(++index < length){
            var source = sources[index];
            if (source) assigner(object, source, index, customizer);
        }
        return object;
    });
}
/**
 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */ function createBaseFor(fromRight) {
    return function(object, iteratee, keysFunc) {
        var index = -1, iterable = Object(object), props = keysFunc(object), length = props.length;
        while(length--){
            var key = props[fromRight ? length : ++index];
            if (iteratee(iterable[key], key, iterable) === false) break;
        }
        return object;
    };
}
/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */ function getMapData(map, key) {
    var data = map.__data__;
    return isKeyable(key) ? data[typeof key == "string" ? "string" : "hash"] : data.map;
}
/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */ function getNative(object, key) {
    var value = getValue(object, key);
    return baseIsNative(value) ? value : undefined;
}
/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */ function getRawTag(value) {
    var isOwn = hasOwnProperty.call(value, symToStringTag), tag = value[symToStringTag];
    try {
        value[symToStringTag] = undefined;
        var unmasked = true;
    } catch (e) {}
    var result = nativeObjectToString.call(value);
    if (unmasked) {
        if (isOwn) value[symToStringTag] = tag;
        else delete value[symToStringTag];
    }
    return result;
}
/**
 * Initializes an object clone.
 *
 * @private
 * @param {Object} object The object to clone.
 * @returns {Object} Returns the initialized clone.
 */ function initCloneObject(object) {
    return typeof object.constructor == "function" && !isPrototype(object) ? baseCreate(getPrototype(object)) : {};
}
/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */ function isIndex(value, length) {
    var type = typeof value;
    length = length == null ? MAX_SAFE_INTEGER : length;
    return !!length && (type == "number" || type != "symbol" && reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
}
/**
 * Checks if the given arguments are from an iteratee call.
 *
 * @private
 * @param {*} value The potential iteratee value argument.
 * @param {*} index The potential iteratee index or key argument.
 * @param {*} object The potential iteratee object argument.
 * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
 *  else `false`.
 */ function isIterateeCall(value, index, object) {
    if (!isObject(object)) return false;
    var type = typeof index;
    if (type == "number" ? isArrayLike(object) && isIndex(index, object.length) : type == "string" && index in object) return eq(object[index], value);
    return false;
}
/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */ function isKeyable(value) {
    var type = typeof value;
    return type == "string" || type == "number" || type == "symbol" || type == "boolean" ? value !== "__proto__" : value === null;
}
/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */ function isMasked(func) {
    return !!maskSrcKey && maskSrcKey in func;
}
/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */ function isPrototype(value) {
    var Ctor = value && value.constructor, proto = typeof Ctor == "function" && Ctor.prototype || objectProto;
    return value === proto;
}
/**
 * This function is like
 * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * except that it includes inherited enumerable properties.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function nativeKeysIn(object) {
    var result = [];
    if (object != null) for(var key in Object(object))result.push(key);
    return result;
}
/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */ function objectToString(value) {
    return nativeObjectToString.call(value);
}
/**
 * A specialized version of `baseRest` which transforms the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @param {Function} transform The rest array transform.
 * @returns {Function} Returns the new function.
 */ function overRest(func, start, transform) {
    start = nativeMax(start === undefined ? func.length - 1 : start, 0);
    return function() {
        var args = arguments, index = -1, length = nativeMax(args.length - start, 0), array = Array(length);
        while(++index < length)array[index] = args[start + index];
        index = -1;
        var otherArgs = Array(start + 1);
        while(++index < start)otherArgs[index] = args[index];
        otherArgs[start] = transform(array);
        return apply(func, this, otherArgs);
    };
}
/**
 * Gets the value at `key`, unless `key` is "__proto__" or "constructor".
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */ function safeGet(object, key) {
    if (key === "constructor" && typeof object[key] === "function") return;
    if (key == "__proto__") return;
    return object[key];
}
/**
 * Sets the `toString` method of `func` to return `string`.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */ var setToString = shortOut(baseSetToString);
/**
 * Creates a function that'll short out and invoke `identity` instead
 * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
 * milliseconds.
 *
 * @private
 * @param {Function} func The function to restrict.
 * @returns {Function} Returns the new shortable function.
 */ function shortOut(func) {
    var count = 0, lastCalled = 0;
    return function() {
        var stamp = nativeNow(), remaining = HOT_SPAN - (stamp - lastCalled);
        lastCalled = stamp;
        if (remaining > 0) {
            if (++count >= HOT_COUNT) return arguments[0];
        } else count = 0;
        return func.apply(undefined, arguments);
    };
}
/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */ function toSource(func) {
    if (func != null) {
        try {
            return funcToString.call(func);
        } catch (e) {}
        try {
            return func + "";
        } catch (e) {}
    }
    return "";
}
/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */ function eq(value, other) {
    return value === other || value !== value && other !== other;
}
/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */ var isArguments = baseIsArguments(function() {
    return arguments;
}()) ? baseIsArguments : function(value) {
    return isObjectLike(value) && hasOwnProperty.call(value, "callee") && !propertyIsEnumerable.call(value, "callee");
};
/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */ var isArray = Array.isArray;
/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */ function isArrayLike(value) {
    return value != null && isLength(value.length) && !isFunction(value);
}
/**
 * This method is like `_.isArrayLike` except that it also checks if `value`
 * is an object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array-like object,
 *  else `false`.
 * @example
 *
 * _.isArrayLikeObject([1, 2, 3]);
 * // => true
 *
 * _.isArrayLikeObject(document.body.children);
 * // => true
 *
 * _.isArrayLikeObject('abc');
 * // => false
 *
 * _.isArrayLikeObject(_.noop);
 * // => false
 */ function isArrayLikeObject(value) {
    return isObjectLike(value) && isArrayLike(value);
}
/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */ var isBuffer = nativeIsBuffer || stubFalse;
/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */ function isFunction(value) {
    if (!isObject(value)) return false;
    // The use of `Object#toString` avoids issues with the `typeof` operator
    // in Safari 9 which returns 'object' for typed arrays and other constructors.
    var tag = baseGetTag(value);
    return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
}
/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */ function isLength(value) {
    return typeof value == "number" && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */ function isObject(value) {
    var type = typeof value;
    return value != null && (type == "object" || type == "function");
}
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function isObjectLike(value) {
    return value != null && typeof value == "object";
}
/**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * @static
 * @memberOf _
 * @since 0.8.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */ function isPlainObject(value) {
    if (!isObjectLike(value) || baseGetTag(value) != objectTag) return false;
    var proto = getPrototype(value);
    if (proto === null) return true;
    var Ctor = hasOwnProperty.call(proto, "constructor") && proto.constructor;
    return typeof Ctor == "function" && Ctor instanceof Ctor && funcToString.call(Ctor) == objectCtorString;
}
/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */ var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
/**
 * Converts `value` to a plain object flattening inherited enumerable string
 * keyed properties of `value` to own properties of the plain object.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {Object} Returns the converted plain object.
 * @example
 *
 * function Foo() {
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.assign({ 'a': 1 }, new Foo);
 * // => { 'a': 1, 'b': 2 }
 *
 * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
 * // => { 'a': 1, 'b': 2, 'c': 3 }
 */ function toPlainObject(value) {
    return copyObject(value, keysIn(value));
}
/**
 * Creates an array of the own and inherited enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keysIn(new Foo);
 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
 */ function keysIn(object) {
    return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
}
/**
 * This method is like `_.assign` except that it recursively merges own and
 * inherited enumerable string keyed properties of source objects into the
 * destination object. Source properties that resolve to `undefined` are
 * skipped if a destination value exists. Array and plain object properties
 * are merged recursively. Other objects and value types are overridden by
 * assignment. Source objects are applied from left to right. Subsequent
 * sources overwrite property assignments of previous sources.
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @memberOf _
 * @since 0.5.0
 * @category Object
 * @param {Object} object The destination object.
 * @param {...Object} [sources] The source objects.
 * @returns {Object} Returns `object`.
 * @example
 *
 * var object = {
 *   'a': [{ 'b': 2 }, { 'd': 4 }]
 * };
 *
 * var other = {
 *   'a': [{ 'c': 3 }, { 'e': 5 }]
 * };
 *
 * _.merge(object, other);
 * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
 */ var merge = createAssigner(function(object, source, srcIndex) {
    baseMerge(object, source, srcIndex);
});
/**
 * Creates a function that returns `value`.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {*} value The value to return from the new function.
 * @returns {Function} Returns the new constant function.
 * @example
 *
 * var objects = _.times(2, _.constant({ 'a': 1 }));
 *
 * console.log(objects);
 * // => [{ 'a': 1 }, { 'a': 1 }]
 *
 * console.log(objects[0] === objects[1]);
 * // => true
 */ function constant(value) {
    return function() {
        return value;
    };
}
/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */ function identity(value) {
    return value;
}
/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */ function stubFalse() {
    return false;
}
module.exports = merge;

});

parcelRegister("lCfIL", function(module, exports) {

$parcel$export(module.exports, "useRequest", function () { return $fbc95774681ad017$export$7fba1a658e28476a; });
$parcel$export(module.exports, "useAPI", function () { return $fbc95774681ad017$export$67a65489846e51f3; });
$parcel$export(module.exports, "initSession", function () { return $fbc95774681ad017$export$403ed9a23f6abb2d; });

var $cQNHH = parcelRequire("cQNHH");

var $5dlN6 = parcelRequire("5dlN6");
/**
 * Checks if a network request came back fine, and throws an error if not
 *
 * @param  {object} response   A response from a network request
 *
 * @return {object|undefined} Returns either the response, or throws an error
 */ function $fbc95774681ad017$var$checkStatus(response) {
    if (response.status >= 200 && response.status < 300) return response;
    // TODO: ensure backend renders 404 when studyId/locale is missing
    // https://app.bugsnag.com/trialbee/self-assessment/errors/6475360bfecaf70008d4989f?event_id=65a50b4600d0018894110000&i=wh&m=nw
    const error = new Error(response.statusText || `Status: ${response.status}`);
    error.response = response;
    throw error;
}
/**
 * Parses the JSON returned by a network request
 *
 * @param  {object} response A response from a network request
 *
 * @return {object}          The parsed JSON from the request
 */ function $fbc95774681ad017$var$parseJSON(response) {
    if (response.status === 204 || response.status === 205) return null;
    return response.json();
}
async function $fbc95774681ad017$var$makeRequest({ config: config, method: method, url: url, body: body, sessionToken: sessionToken }) {
    let receivedToken = sessionToken;
    try {
        const headers = {
            "Content-Type": "application/json"
        };
        if (sessionToken) headers["TB-Session-Token"] = sessionToken;
        const res = await fetch(`${config.baseURI}${url}`, {
            method: method,
            credentials: "include",
            mode: "cors",
            body: body ? JSON.stringify(body) : undefined,
            headers: new Headers(headers)
        });
        $fbc95774681ad017$var$checkStatus(res);
        const json = await $fbc95774681ad017$var$parseJSON(res);
        /**
     * HACK: This is stored mainly because of Safari handling cookies in an iframe poorly. See more in
     * the `osa` rest endpoint in external-api-service.
     */ if (res.headers.has("TB-Session-Token")) receivedToken = res.headers.get("TB-Session-Token");
        return [
            json,
            receivedToken
        ];
    } catch (error) {
        (0, $5dlN6.notifyError)({
            error: error,
            body: body
        });
        let errorCode = "unknownError";
        if (error instanceof Error) errorCode = error;
        else if (error instanceof Object) ({ errorCode: errorCode } = error);
        return [
            null,
            receivedToken,
            errorCode
        ];
    }
}
function $fbc95774681ad017$export$7fba1a658e28476a(request, ...params) {
    const [result, setResult] = (0, $cQNHH.useState)(null);
    (0, $cQNHH.useEffect)(()=>{
        request(...params).then((res)=>setResult(res));
    }, [
        ...params
    ]);
    return [
        result === null,
        result
    ];
}
function $fbc95774681ad017$export$67a65489846e51f3(config, sessionToken) {
    const [error, setError] = (0, $cQNHH.useState)(null);
    const api = (0, $cQNHH.useMemo)(()=>{
        async function _makeRequest(method, url, body) {
            const [json, _, errorCode] = await $fbc95774681ad017$var$makeRequest({
                config: config,
                method: method,
                url: url,
                body: body,
                sessionToken: sessionToken
            });
            setError(errorCode);
            return json;
        }
        return {
            submitQuestion (id, answer) {
                return _makeRequest("PUT", `/question/${id}`, {
                    answer: answer
                });
            },
            getQuestionnaireResults () {
                return _makeRequest("GET", "/questionnaireResults");
            },
            submitSite ({ id: id, studyId: studyId }) {
                return _makeRequest("PUT", "/site", {
                    siteId: id,
                    studyId: studyId
                });
            },
            submitContactDetails (contactDetails) {
                return _makeRequest("PUT", "/contactDetails", contactDetails);
            },
            dropoutCandidate () {
                return _makeRequest("PUT", "/dropout");
            },
            finalizeSession () {
                return _makeRequest("POST", "/finalize");
            }
        };
    }, [
        config.baseURI,
        config.studyId,
        config.locale,
        sessionToken
    ]);
    return [
        api,
        error
    ];
}
async function $fbc95774681ad017$export$403ed9a23f6abb2d(config) {
    const { studyId: studyId, ...body } = config;
    const [json, receivedToken, errorCode] = await $fbc95774681ad017$var$makeRequest({
        config: config,
        method: "POST",
        url: `/init/${studyId}`,
        body: body
    });
    if (errorCode) throw String(errorCode);
    return [
        json,
        receivedToken
    ];
}

});
parcelRegister("5dlN6", function(module, exports) {

$parcel$export(module.exports, "startBugSnag", function () { return $3cbf11e213b2f990$export$7cb39e07eacf6673; });
$parcel$export(module.exports, "notifyError", function () { return $3cbf11e213b2f990$export$740944ffd2f8d33e; });
$parcel$export(module.exports, "ErrorBoundary", function () { return $3cbf11e213b2f990$export$e926676385687eaf; });

var $d1bFm = parcelRequire("d1bFm");

var $7xuSA = parcelRequire("7xuSA");

var $cQNHH = parcelRequire("cQNHH");

var $4ScnI = parcelRequire("4ScnI");
const $3cbf11e213b2f990$var$getEnvironment = (url)=>{
    try {
        if (url.includes("app.trialbee.com")) return "preview";
        else if (url.includes("trialbee.com")) return "production";
        else if (url.includes("stage.trialbee.xyz")) return "stage";
        else if (url.includes("dev.trialbee.xyz")) return "dev";
        else if (url.includes("local.trialbee.xyz")) return "local";
    } catch (_) {}
    return "unknown";
};
const $3cbf11e213b2f990$export$7cb39e07eacf6673 = (config)=>{
    const { studyId: studyId, locale: locale, baseURI: baseURI, landingPage: landingPage } = config;
    (0, (/*@__PURE__*/$parcel$interopDefault($d1bFm))).start({
        apiKey: "2da0f97bc911d81177881caf1438a7e0",
        plugins: [
            new (0, (/*@__PURE__*/$parcel$interopDefault($7xuSA)))()
        ],
        releaseStage: $3cbf11e213b2f990$var$getEnvironment(window.location.hostname),
        enabledReleaseStages: [
            "production",
            "stage",
            "dev",
            "unknown",
            "preview"
        ],
        appType: "react",
        appVersion: (0, $4ScnI.version) || "unknown",
        metadata: {
            baseURI: baseURI,
            studyId: studyId,
            locale: locale,
            landingPage: landingPage,
            version: $4ScnI.version
        }
    });
};
const $3cbf11e213b2f990$export$740944ffd2f8d33e = ({ error: error, body: body })=>{
    (0, (/*@__PURE__*/$parcel$interopDefault($d1bFm))).notify(error, {
        request: body
    });
};
function $3cbf11e213b2f990$export$e926676385687eaf(props) {
    const ReactErrorBoundary = (0, $cQNHH.useMemo)(()=>(0, (/*@__PURE__*/$parcel$interopDefault($d1bFm))).getPlugin("react").createErrorBoundary((0, (/*@__PURE__*/$parcel$interopDefault($cQNHH)))), [
        (0, (/*@__PURE__*/$parcel$interopDefault($d1bFm))),
        (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH)))
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement(ReactErrorBoundary, props);
}

});
parcelRegister("d1bFm", function(module, exports) {

module.exports = (parcelRequire("iUAyZ"));

});

parcelRegister("7xuSA", function(module, exports) {
(function(f) {
    var g;
    module.exports = f();
})(function() {
    var define, module1, exports;
    var _$src_1 = {};
    function _extends() {
        _extends = Object.assign || function(target) {
            for(var i = 1; i < arguments.length; i++){
                var source = arguments[i];
                for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
            }
            return target;
        };
        return _extends.apply(this, arguments);
    }
    function _assertThisInitialized(self) {
        if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return self;
    }
    function _inheritsLoose(subClass, superClass) {
        subClass.prototype = Object.create(superClass.prototype);
        subClass.prototype.constructor = subClass;
        _setPrototypeOf(subClass, superClass);
    }
    function _setPrototypeOf(o, p) {
        _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
            o.__proto__ = p;
            return o;
        };
        return _setPrototypeOf(o, p);
    }
    _$src_1 = /*#__PURE__*/ function() {
        function BugsnagPluginReact() {
            // Fetch React from the window object, if it exists
            var globalReact = typeof window !== "undefined" && window.React;
            this.name = "react";
            this.lazy = arguments.length === 0 && !globalReact;
            if (!this.lazy) {
                this.React = (arguments.length <= 0 ? undefined : arguments[0]) || globalReact;
                if (!this.React) throw new Error("@bugsnag/plugin-react reference to `React` was undefined");
            }
        }
        var _proto = BugsnagPluginReact.prototype;
        _proto.load = function load(client) {
            if (!this.lazy) {
                var ErrorBoundary = createClass(this.React, client);
                ErrorBoundary.createErrorBoundary = function() {
                    return ErrorBoundary;
                };
                return ErrorBoundary;
            }
            var BugsnagPluginReactLazyInitializer = function() {
                throw new Error("@bugsnag/plugin-react was used incorrectly. Valid usage is as follows:\nPass React to the plugin constructor\n\n  `Bugsnag.start({ plugins: [new BugsnagPluginReact(React)] })`\nand then call `const ErrorBoundary = Bugsnag.getPlugin('react').createErrorBoundary()`\n\nOr if React is not available until after Bugsnag has started,\nconstruct the plugin with no arguments\n  `Bugsnag.start({ plugins: [new BugsnagPluginReact()] })`,\nthen pass in React when available to construct your error boundary\n  `const ErrorBoundary = Bugsnag.getPlugin('react').createErrorBoundary(React)`");
            };
            BugsnagPluginReactLazyInitializer.createErrorBoundary = function(React) {
                if (!React) throw new Error("@bugsnag/plugin-react reference to `React` was undefined");
                return createClass(React, client);
            };
            return BugsnagPluginReactLazyInitializer;
        };
        return BugsnagPluginReact;
    }();
    var formatComponentStack = function(str) {
        var lines = str.split(/\s*\n\s*/g);
        var ret = "";
        for(var line = 0, len = lines.length; line < len; line++)if (lines[line].length) ret += "" + (ret.length ? "\n" : "") + lines[line];
        return ret;
    };
    var createClass = function(React, client) {
        return /*#__PURE__*/ function(_React$Component) {
            _inheritsLoose(ErrorBoundary, _React$Component);
            function ErrorBoundary(props) {
                var _this;
                _this = _React$Component.call(this, props) || this;
                _this.state = {
                    error: null,
                    info: null
                };
                _this.handleClearError = _this.handleClearError.bind(_assertThisInitialized(_this));
                return _this;
            }
            var _proto2 = ErrorBoundary.prototype;
            _proto2.handleClearError = function handleClearError() {
                this.setState({
                    error: null,
                    info: null
                });
            };
            _proto2.componentDidCatch = function componentDidCatch(error, info) {
                var onError = this.props.onError;
                var handledState = {
                    severity: "error",
                    unhandled: true,
                    severityReason: {
                        type: "unhandledException"
                    }
                };
                var event = client.Event.create(error, true, handledState, 1);
                if (info && info.componentStack) info.componentStack = formatComponentStack(info.componentStack);
                event.addMetadata("react", info);
                client._notify(event, onError);
                this.setState({
                    error: error,
                    info: info
                });
            };
            _proto2.render = function render() {
                var error = this.state.error;
                if (error) {
                    var FallbackComponent = this.props.FallbackComponent;
                    if (FallbackComponent) return React.createElement(FallbackComponent, _extends({}, this.state, {
                        clearError: this.handleClearError
                    }));
                    return null;
                }
                return this.props.children;
            };
            return ErrorBoundary;
        }(React.Component);
    };
    _$src_1.formatComponentStack = formatComponentStack;
    _$src_1["default"] = _$src_1;
    return _$src_1;
});

});

parcelRegister("4ScnI", function(module, exports) {
module.exports = JSON.parse('{"name":"trialbee-self-assessment","version":"1.26.1","private":true,"api":"dist/prescreener.js","targets":{"api":{"source":"src/prescreener/prescreener.js","distDir":"./dist","engines":{"browsers":"> 0.25%, not dead"}},"app":{"source":"src/prescreener/selfAssessment.html","distDir":"./dist","engines":{"browsers":"> 0.25%, not dead"}}},"engines":{"node":">=18.16.0"},"scripts":{"dev":"echo \'\uD83D\uDEA8 Please use super-honey instead - `dev-frontend up widget`\'","dev:docker":"npm-run-all -p dev:docker:*","dev:docker:parcel":"parcel --host 0.0.0.0 --no-cache --hmr-port 1236 --hmr-host 127.0.0.1  --no-hmr","dev:docker:caddy":"caddy run --watch --config /code/Caddyfile","build":"parcel build --no-cache","clean":"rm -rf dist/ .parcel-cache","start":"node dist/server.js","build_local":"npm-run-all -p build_local:replace:*","lint":"eslint src","test":"echo Disabled jest","test:size":"SIZE_LIMIT_CONFIG=\\"prescreener\\" size-limit --no-running-time","test:watch":"jest --watch","translations:pull":"mkdir -p ./dist/locale; npx poeditor-ci pull","translations:expand":"babel-node --experimental-modules ./common/scripts/expandLanguages.mjs","translations:clean":"babel-node ./common/scripts/cleanLanguages.js"},"dependencies":{"@babel/polyfill":"^7.12.1","@babel/runtime":"^7.22.3","@bugsnag/browser":"^7.20.0","@bugsnag/js":"^7.20.0","@bugsnag/plugin-react":"^7.19.0","@formatjs/intl-pluralrules":"^1.5.2","@formatjs/intl-relativetimeformat":"^4.5.9","@material-ui/core":"^4.12.3","@material-ui/icons":"^4.11.2","@material-ui/styles":"^4.11.4","@trialbee/eligibility-validator":"0.1.6","body-scroll-lock":"^2.6.4","classnames":"^2.2.6","color":"^3.1.2","core-js":"^3.6.4","cors":"^2.8.5","debounce":"^1.2.0","express":"^4.17.1","gherkin-lint":"^4.2.4","google-map-react":"^1.1.6","jexl":"^2.2.2","jss":"^10.8.2","jss-rtl":"^0.3.0","libphonenumber-js":"^1.7.40","lodash.get":"^4.4.2","lodash.merge":"^4.6.2","lodash.mergewith":"^4.6.2","mixpanel-browser":"^2.45.0","path":"^0.12.7","prop-types":"^15.7.2","react":"^16.12.0","react-dom":"^16.12.0","react-intl":"^6.5.5","react-phone-input-2":"^2.11.0","remark":"^11.0.2","remark-react":"^6.0.0","smoothscroll-polyfill":"^0.4.4","string-placeholder":"^1.0.2","validate.js":"^0.13.1"},"devDependencies":{"@babel/cli":"^7.23.4","@babel/core":"^7.23.7","@babel/eslint-parser":"^7.23.3","@babel/node":"^7.22.19","@babel/plugin-proposal-class-properties":"^7.18.6","@babel/plugin-syntax-dynamic-import":"^7.8.3","@babel/plugin-syntax-jsx":"^7.23.3","@babel/plugin-transform-runtime":"^7.23.7","@babel/preset-env":"^7.23.8","@babel/preset-react":"^7.23.3","babel-eslint":"^10.1.0","babel-plugin-add-module-exports":"^1.0.2","babel-plugin-react-intl":"^7.5.18","babel-plugin-transform-react-remove-prop-types":"^0.4.24","bugsnag-sourcemaps":"^1.3.0","eslint":"^8.56.0","eslint-config-airbnb":"^19.0.4","eslint-config-prettier":"^9.1.0","eslint-plugin-import":"^2.29.1","eslint-plugin-jest":"^27.6.3","eslint-plugin-json":"^3.1.0","eslint-plugin-jsx-a11y":"^6.8.0","eslint-plugin-prettier":"^5.1.3","eslint-plugin-react":"^7.33.2","eslint-plugin-react-hooks":"^4.6.0","events":"^3.1.0","get-port":"^5.1.1","jest":"^24","nodemon":"^3.0.3","npm-run-all":"^4.1.5","parcel":"^2.11.0","path-browserify":"^1.0.1","prettier":"3.1.1","size-limit":"^11.0.2"},"eslintConfig":{"extends":"react-app"},"packageManager":"yarn@1.22.22+sha512.a6b2f7906b721bba3d67d4aff083df04dad64c399707841b7acf00f6b133b7ac24255f2652fa22ae3534329dc6180534e98d17432037ff6fd140556e2bb3137e"}');

});




var $815Xb = parcelRequire("815Xb");

var $cQNHH = parcelRequire("cQNHH");

var $1xEYC = parcelRequire("1xEYC");

var $jf4OJ = parcelRequire("jf4OJ");

var $2FoLs = parcelRequire("2FoLs");

var $6WDy5 = parcelRequire("6WDy5");

var $49sgH = parcelRequire("49sgH");
function $2bb9b1e646170ca5$var$mergeOuterLocalTheme(outerTheme, localTheme) {
    if (typeof localTheme === "function") {
        var mergedTheme = localTheme(outerTheme);
        if (!mergedTheme) console.error([
            "Material-UI: You should return an object from your theme function, i.e.",
            "<ThemeProvider theme={() => ({})} />"
        ].join("\n"));
        return mergedTheme;
    }
    return (0, $815Xb.default)({}, outerTheme, localTheme);
}
/**
 * This component takes a `theme` prop.
 * It makes the `theme` available down the React tree thanks to React context.
 * This component should preferably be used at **the root of your component tree**.
 */ function $2bb9b1e646170ca5$var$ThemeProvider(props) {
    var children = props.children, localTheme = props.theme;
    var outerTheme = (0, $6WDy5.default)();
    if (outerTheme === null && typeof localTheme === "function") console.error([
        "Material-UI: You are providing a theme function prop to the ThemeProvider component:",
        "<ThemeProvider theme={outerTheme => outerTheme} />",
        "",
        "However, no outer theme is present.",
        "Make sure a theme is already injected higher in the React tree or provide a theme object."
    ].join("\n"));
    var theme = (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).useMemo(function() {
        var output = outerTheme === null ? localTheme : $2bb9b1e646170ca5$var$mergeOuterLocalTheme(outerTheme, localTheme);
        if (output != null) output[0, $49sgH.default] = outerTheme !== null;
        return output;
    }, [
        localTheme,
        outerTheme
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement((0, $2FoLs.default).Provider, {
        value: theme
    }, children);
}
$2bb9b1e646170ca5$var$ThemeProvider.propTypes = {
    /**
   * Your component tree.
   */ children: (0, (/*@__PURE__*/$parcel$interopDefault($1xEYC))).node.isRequired,
    /**
   * A theme object. You can provide a function to extend the outer theme.
   */ theme: (0, (/*@__PURE__*/$parcel$interopDefault($1xEYC))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($1xEYC))).object,
        (0, (/*@__PURE__*/$parcel$interopDefault($1xEYC))).func
    ]).isRequired
};
$2bb9b1e646170ca5$var$ThemeProvider.propTypes = (0, $jf4OJ.default)($2bb9b1e646170ca5$var$ThemeProvider.propTypes);
var $2bb9b1e646170ca5$export$2e2bcd8739ae039 = $2bb9b1e646170ca5$var$ThemeProvider;



var $cQNHH = parcelRequire("cQNHH");

var $dLwnG = parcelRequire("dLwnG");
var $649299cff7f987fa$exports = {};
/* smoothscroll v0.4.4 - 2019 - Dustan Kasten, Jeremias Menichelli - MIT License */ (function() {
    "use strict";
    // polyfill
    function polyfill() {
        // aliases
        var w = window;
        var d = document;
        // return if scroll behavior is supported and polyfill is not forced
        if ("scrollBehavior" in d.documentElement.style && w.__forceSmoothScrollPolyfill__ !== true) return;
        // globals
        var Element = w.HTMLElement || w.Element;
        var SCROLL_TIME = 468;
        // object gathering original scroll methods
        var original = {
            scroll: w.scroll || w.scrollTo,
            scrollBy: w.scrollBy,
            elementScroll: Element.prototype.scroll || scrollElement,
            scrollIntoView: Element.prototype.scrollIntoView
        };
        // define timing method
        var now = w.performance && w.performance.now ? w.performance.now.bind(w.performance) : Date.now;
        /**
     * indicates if a the current browser is made by Microsoft
     * @method isMicrosoftBrowser
     * @param {String} userAgent
     * @returns {Boolean}
     */ function isMicrosoftBrowser(userAgent) {
            var userAgentPatterns = [
                "MSIE ",
                "Trident/",
                "Edge/"
            ];
            return new RegExp(userAgentPatterns.join("|")).test(userAgent);
        }
        /*
     * IE has rounding bug rounding down clientHeight and clientWidth and
     * rounding up scrollHeight and scrollWidth causing false positives
     * on hasScrollableSpace
     */ var ROUNDING_TOLERANCE = isMicrosoftBrowser(w.navigator.userAgent) ? 1 : 0;
        /**
     * changes scroll position inside an element
     * @method scrollElement
     * @param {Number} x
     * @param {Number} y
     * @returns {undefined}
     */ function scrollElement(x, y) {
            this.scrollLeft = x;
            this.scrollTop = y;
        }
        /**
     * returns result of applying ease math function to a number
     * @method ease
     * @param {Number} k
     * @returns {Number}
     */ function ease(k) {
            return 0.5 * (1 - Math.cos(Math.PI * k));
        }
        /**
     * indicates if a smooth behavior should be applied
     * @method shouldBailOut
     * @param {Number|Object} firstArg
     * @returns {Boolean}
     */ function shouldBailOut(firstArg) {
            if (firstArg === null || typeof firstArg !== "object" || firstArg.behavior === undefined || firstArg.behavior === "auto" || firstArg.behavior === "instant") // first argument is not an object/null
            // or behavior is auto, instant or undefined
            return true;
            if (typeof firstArg === "object" && firstArg.behavior === "smooth") // first argument is an object and behavior is smooth
            return false;
            // throw error when behavior is not supported
            throw new TypeError("behavior member of ScrollOptions " + firstArg.behavior + " is not a valid value for enumeration ScrollBehavior.");
        }
        /**
     * indicates if an element has scrollable space in the provided axis
     * @method hasScrollableSpace
     * @param {Node} el
     * @param {String} axis
     * @returns {Boolean}
     */ function hasScrollableSpace(el, axis) {
            if (axis === "Y") return el.clientHeight + ROUNDING_TOLERANCE < el.scrollHeight;
            if (axis === "X") return el.clientWidth + ROUNDING_TOLERANCE < el.scrollWidth;
        }
        /**
     * indicates if an element has a scrollable overflow property in the axis
     * @method canOverflow
     * @param {Node} el
     * @param {String} axis
     * @returns {Boolean}
     */ function canOverflow(el, axis) {
            var overflowValue = w.getComputedStyle(el, null)["overflow" + axis];
            return overflowValue === "auto" || overflowValue === "scroll";
        }
        /**
     * indicates if an element can be scrolled in either axis
     * @method isScrollable
     * @param {Node} el
     * @param {String} axis
     * @returns {Boolean}
     */ function isScrollable(el) {
            var isScrollableY = hasScrollableSpace(el, "Y") && canOverflow(el, "Y");
            var isScrollableX = hasScrollableSpace(el, "X") && canOverflow(el, "X");
            return isScrollableY || isScrollableX;
        }
        /**
     * finds scrollable parent of an element
     * @method findScrollableParent
     * @param {Node} el
     * @returns {Node} el
     */ function findScrollableParent(el) {
            while(el !== d.body && isScrollable(el) === false)el = el.parentNode || el.host;
            return el;
        }
        /**
     * self invoked function that, given a context, steps through scrolling
     * @method step
     * @param {Object} context
     * @returns {undefined}
     */ function step(context) {
            var time = now();
            var value;
            var currentX;
            var currentY;
            var elapsed = (time - context.startTime) / SCROLL_TIME;
            // avoid elapsed times higher than one
            elapsed = elapsed > 1 ? 1 : elapsed;
            // apply easing to elapsed time
            value = ease(elapsed);
            currentX = context.startX + (context.x - context.startX) * value;
            currentY = context.startY + (context.y - context.startY) * value;
            context.method.call(context.scrollable, currentX, currentY);
            // scroll more if we have not reached our destination
            if (currentX !== context.x || currentY !== context.y) w.requestAnimationFrame(step.bind(w, context));
        }
        /**
     * scrolls window or element with a smooth behavior
     * @method smoothScroll
     * @param {Object|Node} el
     * @param {Number} x
     * @param {Number} y
     * @returns {undefined}
     */ function smoothScroll(el, x, y) {
            var scrollable;
            var startX;
            var startY;
            var method;
            var startTime = now();
            // define scroll context
            if (el === d.body) {
                scrollable = w;
                startX = w.scrollX || w.pageXOffset;
                startY = w.scrollY || w.pageYOffset;
                method = original.scroll;
            } else {
                scrollable = el;
                startX = el.scrollLeft;
                startY = el.scrollTop;
                method = scrollElement;
            }
            // scroll looping over a frame
            step({
                scrollable: scrollable,
                method: method,
                startTime: startTime,
                startX: startX,
                startY: startY,
                x: x,
                y: y
            });
        }
        // ORIGINAL METHODS OVERRIDES
        // w.scroll and w.scrollTo
        w.scroll = w.scrollTo = function() {
            // avoid action when no arguments are passed
            if (arguments[0] === undefined) return;
            // avoid smooth behavior if not required
            if (shouldBailOut(arguments[0]) === true) {
                original.scroll.call(w, arguments[0].left !== undefined ? arguments[0].left : typeof arguments[0] !== "object" ? arguments[0] : w.scrollX || w.pageXOffset, // use top prop, second argument if present or fallback to scrollY
                arguments[0].top !== undefined ? arguments[0].top : arguments[1] !== undefined ? arguments[1] : w.scrollY || w.pageYOffset);
                return;
            }
            // LET THE SMOOTHNESS BEGIN!
            smoothScroll.call(w, d.body, arguments[0].left !== undefined ? ~~arguments[0].left : w.scrollX || w.pageXOffset, arguments[0].top !== undefined ? ~~arguments[0].top : w.scrollY || w.pageYOffset);
        };
        // w.scrollBy
        w.scrollBy = function() {
            // avoid action when no arguments are passed
            if (arguments[0] === undefined) return;
            // avoid smooth behavior if not required
            if (shouldBailOut(arguments[0])) {
                original.scrollBy.call(w, arguments[0].left !== undefined ? arguments[0].left : typeof arguments[0] !== "object" ? arguments[0] : 0, arguments[0].top !== undefined ? arguments[0].top : arguments[1] !== undefined ? arguments[1] : 0);
                return;
            }
            // LET THE SMOOTHNESS BEGIN!
            smoothScroll.call(w, d.body, ~~arguments[0].left + (w.scrollX || w.pageXOffset), ~~arguments[0].top + (w.scrollY || w.pageYOffset));
        };
        // Element.prototype.scroll and Element.prototype.scrollTo
        Element.prototype.scroll = Element.prototype.scrollTo = function() {
            // avoid action when no arguments are passed
            if (arguments[0] === undefined) return;
            // avoid smooth behavior if not required
            if (shouldBailOut(arguments[0]) === true) {
                // if one number is passed, throw error to match Firefox implementation
                if (typeof arguments[0] === "number" && arguments[1] === undefined) throw new SyntaxError("Value could not be converted");
                original.elementScroll.call(this, // use left prop, first number argument or fallback to scrollLeft
                arguments[0].left !== undefined ? ~~arguments[0].left : typeof arguments[0] !== "object" ? ~~arguments[0] : this.scrollLeft, // use top prop, second argument or fallback to scrollTop
                arguments[0].top !== undefined ? ~~arguments[0].top : arguments[1] !== undefined ? ~~arguments[1] : this.scrollTop);
                return;
            }
            var left = arguments[0].left;
            var top = arguments[0].top;
            // LET THE SMOOTHNESS BEGIN!
            smoothScroll.call(this, this, typeof left === "undefined" ? this.scrollLeft : ~~left, typeof top === "undefined" ? this.scrollTop : ~~top);
        };
        // Element.prototype.scrollBy
        Element.prototype.scrollBy = function() {
            // avoid action when no arguments are passed
            if (arguments[0] === undefined) return;
            // avoid smooth behavior if not required
            if (shouldBailOut(arguments[0]) === true) {
                original.elementScroll.call(this, arguments[0].left !== undefined ? ~~arguments[0].left + this.scrollLeft : ~~arguments[0] + this.scrollLeft, arguments[0].top !== undefined ? ~~arguments[0].top + this.scrollTop : ~~arguments[1] + this.scrollTop);
                return;
            }
            this.scroll({
                left: ~~arguments[0].left + this.scrollLeft,
                top: ~~arguments[0].top + this.scrollTop,
                behavior: arguments[0].behavior
            });
        };
        // Element.prototype.scrollIntoView
        Element.prototype.scrollIntoView = function() {
            // avoid smooth behavior if not required
            if (shouldBailOut(arguments[0]) === true) {
                original.scrollIntoView.call(this, arguments[0] === undefined ? true : arguments[0]);
                return;
            }
            // LET THE SMOOTHNESS BEGIN!
            var scrollableParent = findScrollableParent(this);
            var parentRects = scrollableParent.getBoundingClientRect();
            var clientRects = this.getBoundingClientRect();
            if (scrollableParent !== d.body) {
                // reveal element inside parent
                smoothScroll.call(this, scrollableParent, scrollableParent.scrollLeft + clientRects.left - parentRects.left, scrollableParent.scrollTop + clientRects.top - parentRects.top);
                // reveal parent in viewport unless is fixed
                if (w.getComputedStyle(scrollableParent).position !== "fixed") w.scrollBy({
                    left: parentRects.left,
                    top: parentRects.top,
                    behavior: "smooth"
                });
            } else // reveal element in viewport
            w.scrollBy({
                left: clientRects.left,
                top: clientRects.top,
                behavior: "smooth"
            });
        };
    }
    // commonjs
    $649299cff7f987fa$exports = {
        polyfill: polyfill
    };
})();



var $5dlN6 = parcelRequire("5dlN6");
function $134249fea87571b9$export$a587e606f93a3767(userAgent) {
    return userAgent.match(/(?:MSIE|Trident)/);
}
function $134249fea87571b9$export$f357a97864275ebe(callback) {
    const el = document.createElement("div");
    // Styling
    el.style.position = "fixed";
    el.style.top = "0";
    el.style.right = "0";
    el.style.bottom = "0";
    el.style.left = "0";
    el.style.backgroundColor = "#000000";
    el.style.width = "100%";
    el.style.height = "100%";
    // Click to close
    el.onclick = ()=>{
        el.parentNode.removeChild(el);
        callback();
    };
    // Content
    const content = document.createElement("span");
    content.style.color = "#fff";
    content.style.textAlign = "center";
    content.style.width = "100%";
    content.style.display = "block";
    content.style.padding = "20%";
    content.style.boxSizing = "border-box";
    content.innerHTML = "Your web browser is out of date. Please switch to another browser to continue with signing up for the study. Click anywhere on this page to close this warning.";
    el.appendChild(content);
    return el;
}



var $hFJEF = parcelRequire("hFJEF");
// Default config for both self-assessment
const $0ed8d10c3555ce9e$var$DEFAULT_CONFIG = {
    locale: "en_US",
    colorMain: "#005B86",
    fontFamily: "Poppins, sans-serif",
    fontInclude: "https://fonts.googleapis.com/css?family=Poppins:400,600&display=swap",
    autoScroll: false
};
function $0ed8d10c3555ce9e$var$customizer(objValue, srcValue, key) {
    if (!srcValue) return objValue;
    if (key === "contactForm" || key === "steps") return srcValue;
    return undefined;
}
function $0ed8d10c3555ce9e$var$mergeConfigs(...configs) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($hFJEF)))({}, $0ed8d10c3555ce9e$var$DEFAULT_CONFIG, ...configs, $0ed8d10c3555ce9e$var$customizer);
}
var $0ed8d10c3555ce9e$export$2e2bcd8739ae039 = $0ed8d10c3555ce9e$var$mergeConfigs;



var $elwbS = parcelRequire("elwbS");
var $366d7e75857fe306$exports = {};
"use strict";
var $c49a0977e70d9aa3$exports = {};
/* MIT license */ var $0716198b0a558eb3$exports = {};
"use strict";
$0716198b0a558eb3$exports = {
    "aliceblue": [
        240,
        248,
        255
    ],
    "antiquewhite": [
        250,
        235,
        215
    ],
    "aqua": [
        0,
        255,
        255
    ],
    "aquamarine": [
        127,
        255,
        212
    ],
    "azure": [
        240,
        255,
        255
    ],
    "beige": [
        245,
        245,
        220
    ],
    "bisque": [
        255,
        228,
        196
    ],
    "black": [
        0,
        0,
        0
    ],
    "blanchedalmond": [
        255,
        235,
        205
    ],
    "blue": [
        0,
        0,
        255
    ],
    "blueviolet": [
        138,
        43,
        226
    ],
    "brown": [
        165,
        42,
        42
    ],
    "burlywood": [
        222,
        184,
        135
    ],
    "cadetblue": [
        95,
        158,
        160
    ],
    "chartreuse": [
        127,
        255,
        0
    ],
    "chocolate": [
        210,
        105,
        30
    ],
    "coral": [
        255,
        127,
        80
    ],
    "cornflowerblue": [
        100,
        149,
        237
    ],
    "cornsilk": [
        255,
        248,
        220
    ],
    "crimson": [
        220,
        20,
        60
    ],
    "cyan": [
        0,
        255,
        255
    ],
    "darkblue": [
        0,
        0,
        139
    ],
    "darkcyan": [
        0,
        139,
        139
    ],
    "darkgoldenrod": [
        184,
        134,
        11
    ],
    "darkgray": [
        169,
        169,
        169
    ],
    "darkgreen": [
        0,
        100,
        0
    ],
    "darkgrey": [
        169,
        169,
        169
    ],
    "darkkhaki": [
        189,
        183,
        107
    ],
    "darkmagenta": [
        139,
        0,
        139
    ],
    "darkolivegreen": [
        85,
        107,
        47
    ],
    "darkorange": [
        255,
        140,
        0
    ],
    "darkorchid": [
        153,
        50,
        204
    ],
    "darkred": [
        139,
        0,
        0
    ],
    "darksalmon": [
        233,
        150,
        122
    ],
    "darkseagreen": [
        143,
        188,
        143
    ],
    "darkslateblue": [
        72,
        61,
        139
    ],
    "darkslategray": [
        47,
        79,
        79
    ],
    "darkslategrey": [
        47,
        79,
        79
    ],
    "darkturquoise": [
        0,
        206,
        209
    ],
    "darkviolet": [
        148,
        0,
        211
    ],
    "deeppink": [
        255,
        20,
        147
    ],
    "deepskyblue": [
        0,
        191,
        255
    ],
    "dimgray": [
        105,
        105,
        105
    ],
    "dimgrey": [
        105,
        105,
        105
    ],
    "dodgerblue": [
        30,
        144,
        255
    ],
    "firebrick": [
        178,
        34,
        34
    ],
    "floralwhite": [
        255,
        250,
        240
    ],
    "forestgreen": [
        34,
        139,
        34
    ],
    "fuchsia": [
        255,
        0,
        255
    ],
    "gainsboro": [
        220,
        220,
        220
    ],
    "ghostwhite": [
        248,
        248,
        255
    ],
    "gold": [
        255,
        215,
        0
    ],
    "goldenrod": [
        218,
        165,
        32
    ],
    "gray": [
        128,
        128,
        128
    ],
    "green": [
        0,
        128,
        0
    ],
    "greenyellow": [
        173,
        255,
        47
    ],
    "grey": [
        128,
        128,
        128
    ],
    "honeydew": [
        240,
        255,
        240
    ],
    "hotpink": [
        255,
        105,
        180
    ],
    "indianred": [
        205,
        92,
        92
    ],
    "indigo": [
        75,
        0,
        130
    ],
    "ivory": [
        255,
        255,
        240
    ],
    "khaki": [
        240,
        230,
        140
    ],
    "lavender": [
        230,
        230,
        250
    ],
    "lavenderblush": [
        255,
        240,
        245
    ],
    "lawngreen": [
        124,
        252,
        0
    ],
    "lemonchiffon": [
        255,
        250,
        205
    ],
    "lightblue": [
        173,
        216,
        230
    ],
    "lightcoral": [
        240,
        128,
        128
    ],
    "lightcyan": [
        224,
        255,
        255
    ],
    "lightgoldenrodyellow": [
        250,
        250,
        210
    ],
    "lightgray": [
        211,
        211,
        211
    ],
    "lightgreen": [
        144,
        238,
        144
    ],
    "lightgrey": [
        211,
        211,
        211
    ],
    "lightpink": [
        255,
        182,
        193
    ],
    "lightsalmon": [
        255,
        160,
        122
    ],
    "lightseagreen": [
        32,
        178,
        170
    ],
    "lightskyblue": [
        135,
        206,
        250
    ],
    "lightslategray": [
        119,
        136,
        153
    ],
    "lightslategrey": [
        119,
        136,
        153
    ],
    "lightsteelblue": [
        176,
        196,
        222
    ],
    "lightyellow": [
        255,
        255,
        224
    ],
    "lime": [
        0,
        255,
        0
    ],
    "limegreen": [
        50,
        205,
        50
    ],
    "linen": [
        250,
        240,
        230
    ],
    "magenta": [
        255,
        0,
        255
    ],
    "maroon": [
        128,
        0,
        0
    ],
    "mediumaquamarine": [
        102,
        205,
        170
    ],
    "mediumblue": [
        0,
        0,
        205
    ],
    "mediumorchid": [
        186,
        85,
        211
    ],
    "mediumpurple": [
        147,
        112,
        219
    ],
    "mediumseagreen": [
        60,
        179,
        113
    ],
    "mediumslateblue": [
        123,
        104,
        238
    ],
    "mediumspringgreen": [
        0,
        250,
        154
    ],
    "mediumturquoise": [
        72,
        209,
        204
    ],
    "mediumvioletred": [
        199,
        21,
        133
    ],
    "midnightblue": [
        25,
        25,
        112
    ],
    "mintcream": [
        245,
        255,
        250
    ],
    "mistyrose": [
        255,
        228,
        225
    ],
    "moccasin": [
        255,
        228,
        181
    ],
    "navajowhite": [
        255,
        222,
        173
    ],
    "navy": [
        0,
        0,
        128
    ],
    "oldlace": [
        253,
        245,
        230
    ],
    "olive": [
        128,
        128,
        0
    ],
    "olivedrab": [
        107,
        142,
        35
    ],
    "orange": [
        255,
        165,
        0
    ],
    "orangered": [
        255,
        69,
        0
    ],
    "orchid": [
        218,
        112,
        214
    ],
    "palegoldenrod": [
        238,
        232,
        170
    ],
    "palegreen": [
        152,
        251,
        152
    ],
    "paleturquoise": [
        175,
        238,
        238
    ],
    "palevioletred": [
        219,
        112,
        147
    ],
    "papayawhip": [
        255,
        239,
        213
    ],
    "peachpuff": [
        255,
        218,
        185
    ],
    "peru": [
        205,
        133,
        63
    ],
    "pink": [
        255,
        192,
        203
    ],
    "plum": [
        221,
        160,
        221
    ],
    "powderblue": [
        176,
        224,
        230
    ],
    "purple": [
        128,
        0,
        128
    ],
    "rebeccapurple": [
        102,
        51,
        153
    ],
    "red": [
        255,
        0,
        0
    ],
    "rosybrown": [
        188,
        143,
        143
    ],
    "royalblue": [
        65,
        105,
        225
    ],
    "saddlebrown": [
        139,
        69,
        19
    ],
    "salmon": [
        250,
        128,
        114
    ],
    "sandybrown": [
        244,
        164,
        96
    ],
    "seagreen": [
        46,
        139,
        87
    ],
    "seashell": [
        255,
        245,
        238
    ],
    "sienna": [
        160,
        82,
        45
    ],
    "silver": [
        192,
        192,
        192
    ],
    "skyblue": [
        135,
        206,
        235
    ],
    "slateblue": [
        106,
        90,
        205
    ],
    "slategray": [
        112,
        128,
        144
    ],
    "slategrey": [
        112,
        128,
        144
    ],
    "snow": [
        255,
        250,
        250
    ],
    "springgreen": [
        0,
        255,
        127
    ],
    "steelblue": [
        70,
        130,
        180
    ],
    "tan": [
        210,
        180,
        140
    ],
    "teal": [
        0,
        128,
        128
    ],
    "thistle": [
        216,
        191,
        216
    ],
    "tomato": [
        255,
        99,
        71
    ],
    "turquoise": [
        64,
        224,
        208
    ],
    "violet": [
        238,
        130,
        238
    ],
    "wheat": [
        245,
        222,
        179
    ],
    "white": [
        255,
        255,
        255
    ],
    "whitesmoke": [
        245,
        245,
        245
    ],
    "yellow": [
        255,
        255,
        0
    ],
    "yellowgreen": [
        154,
        205,
        50
    ]
};


var $0a96f3f09beefc56$exports = {};
"use strict";
var $162f7e076b4294b5$exports = {};
$162f7e076b4294b5$exports = function isArrayish(obj) {
    if (!obj || typeof obj === "string") return false;
    return obj instanceof Array || Array.isArray(obj) || obj.length >= 0 && (obj.splice instanceof Function || Object.getOwnPropertyDescriptor(obj, obj.length - 1) && obj.constructor.name !== "String");
};


var $0a96f3f09beefc56$var$concat = Array.prototype.concat;
var $0a96f3f09beefc56$var$slice = Array.prototype.slice;
var $0a96f3f09beefc56$var$swizzle = $0a96f3f09beefc56$exports = function swizzle(args) {
    var results = [];
    for(var i = 0, len = args.length; i < len; i++){
        var arg = args[i];
        if ($162f7e076b4294b5$exports(arg)) // http://jsperf.com/javascript-array-concat-vs-push/98
        results = $0a96f3f09beefc56$var$concat.call(results, $0a96f3f09beefc56$var$slice.call(arg));
        else results.push(arg);
    }
    return results;
};
$0a96f3f09beefc56$var$swizzle.wrap = function(fn) {
    return function() {
        return fn($0a96f3f09beefc56$var$swizzle(arguments));
    };
};


var $c49a0977e70d9aa3$var$reverseNames = {};
// create a list of reverse color names
for(var $c49a0977e70d9aa3$var$name in $0716198b0a558eb3$exports)if ($0716198b0a558eb3$exports.hasOwnProperty($c49a0977e70d9aa3$var$name)) $c49a0977e70d9aa3$var$reverseNames[$0716198b0a558eb3$exports[$c49a0977e70d9aa3$var$name]] = $c49a0977e70d9aa3$var$name;
var $c49a0977e70d9aa3$var$cs = $c49a0977e70d9aa3$exports = {
    to: {},
    get: {}
};
$c49a0977e70d9aa3$var$cs.get = function(string) {
    var prefix = string.substring(0, 3).toLowerCase();
    var val;
    var model;
    switch(prefix){
        case "hsl":
            val = $c49a0977e70d9aa3$var$cs.get.hsl(string);
            model = "hsl";
            break;
        case "hwb":
            val = $c49a0977e70d9aa3$var$cs.get.hwb(string);
            model = "hwb";
            break;
        default:
            val = $c49a0977e70d9aa3$var$cs.get.rgb(string);
            model = "rgb";
            break;
    }
    if (!val) return null;
    return {
        model: model,
        value: val
    };
};
$c49a0977e70d9aa3$var$cs.get.rgb = function(string) {
    if (!string) return null;
    var abbr = /^#([a-f0-9]{3,4})$/i;
    var hex = /^#([a-f0-9]{6})([a-f0-9]{2})?$/i;
    var rgba = /^rgba?\(\s*([+-]?\d+)\s*,\s*([+-]?\d+)\s*,\s*([+-]?\d+)\s*(?:,\s*([+-]?[\d\.]+)\s*)?\)$/;
    var per = /^rgba?\(\s*([+-]?[\d\.]+)\%\s*,\s*([+-]?[\d\.]+)\%\s*,\s*([+-]?[\d\.]+)\%\s*(?:,\s*([+-]?[\d\.]+)\s*)?\)$/;
    var keyword = /(\D+)/;
    var rgb = [
        0,
        0,
        0,
        1
    ];
    var match;
    var i;
    var hexAlpha;
    if (match = string.match(hex)) {
        hexAlpha = match[2];
        match = match[1];
        for(i = 0; i < 3; i++){
            // https://jsperf.com/slice-vs-substr-vs-substring-methods-long-string/19
            var i2 = i * 2;
            rgb[i] = parseInt(match.slice(i2, i2 + 2), 16);
        }
        if (hexAlpha) rgb[3] = Math.round(parseInt(hexAlpha, 16) / 255 * 100) / 100;
    } else if (match = string.match(abbr)) {
        match = match[1];
        hexAlpha = match[3];
        for(i = 0; i < 3; i++)rgb[i] = parseInt(match[i] + match[i], 16);
        if (hexAlpha) rgb[3] = Math.round(parseInt(hexAlpha + hexAlpha, 16) / 255 * 100) / 100;
    } else if (match = string.match(rgba)) {
        for(i = 0; i < 3; i++)rgb[i] = parseInt(match[i + 1], 0);
        if (match[4]) rgb[3] = parseFloat(match[4]);
    } else if (match = string.match(per)) {
        for(i = 0; i < 3; i++)rgb[i] = Math.round(parseFloat(match[i + 1]) * 2.55);
        if (match[4]) rgb[3] = parseFloat(match[4]);
    } else if (match = string.match(keyword)) {
        if (match[1] === "transparent") return [
            0,
            0,
            0,
            0
        ];
        rgb = $0716198b0a558eb3$exports[match[1]];
        if (!rgb) return null;
        rgb[3] = 1;
        return rgb;
    } else return null;
    for(i = 0; i < 3; i++)rgb[i] = $c49a0977e70d9aa3$var$clamp(rgb[i], 0, 255);
    rgb[3] = $c49a0977e70d9aa3$var$clamp(rgb[3], 0, 1);
    return rgb;
};
$c49a0977e70d9aa3$var$cs.get.hsl = function(string) {
    if (!string) return null;
    var hsl = /^hsla?\(\s*([+-]?(?:\d*\.)?\d+)(?:deg)?\s*,\s*([+-]?[\d\.]+)%\s*,\s*([+-]?[\d\.]+)%\s*(?:,\s*([+-]?[\d\.]+)\s*)?\)$/;
    var match = string.match(hsl);
    if (match) {
        var alpha = parseFloat(match[4]);
        var h = (parseFloat(match[1]) + 360) % 360;
        var s = $c49a0977e70d9aa3$var$clamp(parseFloat(match[2]), 0, 100);
        var l = $c49a0977e70d9aa3$var$clamp(parseFloat(match[3]), 0, 100);
        var a = $c49a0977e70d9aa3$var$clamp(isNaN(alpha) ? 1 : alpha, 0, 1);
        return [
            h,
            s,
            l,
            a
        ];
    }
    return null;
};
$c49a0977e70d9aa3$var$cs.get.hwb = function(string) {
    if (!string) return null;
    var hwb = /^hwb\(\s*([+-]?\d*[\.]?\d+)(?:deg)?\s*,\s*([+-]?[\d\.]+)%\s*,\s*([+-]?[\d\.]+)%\s*(?:,\s*([+-]?[\d\.]+)\s*)?\)$/;
    var match = string.match(hwb);
    if (match) {
        var alpha = parseFloat(match[4]);
        var h = (parseFloat(match[1]) % 360 + 360) % 360;
        var w = $c49a0977e70d9aa3$var$clamp(parseFloat(match[2]), 0, 100);
        var b = $c49a0977e70d9aa3$var$clamp(parseFloat(match[3]), 0, 100);
        var a = $c49a0977e70d9aa3$var$clamp(isNaN(alpha) ? 1 : alpha, 0, 1);
        return [
            h,
            w,
            b,
            a
        ];
    }
    return null;
};
$c49a0977e70d9aa3$var$cs.to.hex = function() {
    var rgba = $0a96f3f09beefc56$exports(arguments);
    return "#" + $c49a0977e70d9aa3$var$hexDouble(rgba[0]) + $c49a0977e70d9aa3$var$hexDouble(rgba[1]) + $c49a0977e70d9aa3$var$hexDouble(rgba[2]) + (rgba[3] < 1 ? $c49a0977e70d9aa3$var$hexDouble(Math.round(rgba[3] * 255)) : "");
};
$c49a0977e70d9aa3$var$cs.to.rgb = function() {
    var rgba = $0a96f3f09beefc56$exports(arguments);
    return rgba.length < 4 || rgba[3] === 1 ? "rgb(" + Math.round(rgba[0]) + ", " + Math.round(rgba[1]) + ", " + Math.round(rgba[2]) + ")" : "rgba(" + Math.round(rgba[0]) + ", " + Math.round(rgba[1]) + ", " + Math.round(rgba[2]) + ", " + rgba[3] + ")";
};
$c49a0977e70d9aa3$var$cs.to.rgb.percent = function() {
    var rgba = $0a96f3f09beefc56$exports(arguments);
    var r = Math.round(rgba[0] / 255 * 100);
    var g = Math.round(rgba[1] / 255 * 100);
    var b = Math.round(rgba[2] / 255 * 100);
    return rgba.length < 4 || rgba[3] === 1 ? "rgb(" + r + "%, " + g + "%, " + b + "%)" : "rgba(" + r + "%, " + g + "%, " + b + "%, " + rgba[3] + ")";
};
$c49a0977e70d9aa3$var$cs.to.hsl = function() {
    var hsla = $0a96f3f09beefc56$exports(arguments);
    return hsla.length < 4 || hsla[3] === 1 ? "hsl(" + hsla[0] + ", " + hsla[1] + "%, " + hsla[2] + "%)" : "hsla(" + hsla[0] + ", " + hsla[1] + "%, " + hsla[2] + "%, " + hsla[3] + ")";
};
// hwb is a bit different than rgb(a) & hsl(a) since there is no alpha specific syntax
// (hwb have alpha optional & 1 is default value)
$c49a0977e70d9aa3$var$cs.to.hwb = function() {
    var hwba = $0a96f3f09beefc56$exports(arguments);
    var a = "";
    if (hwba.length >= 4 && hwba[3] !== 1) a = ", " + hwba[3];
    return "hwb(" + hwba[0] + ", " + hwba[1] + "%, " + hwba[2] + "%" + a + ")";
};
$c49a0977e70d9aa3$var$cs.to.keyword = function(rgb) {
    return $c49a0977e70d9aa3$var$reverseNames[rgb.slice(0, 3)];
};
// helpers
function $c49a0977e70d9aa3$var$clamp(num, min, max) {
    return Math.min(Math.max(min, num), max);
}
function $c49a0977e70d9aa3$var$hexDouble(num) {
    var str = num.toString(16).toUpperCase();
    return str.length < 2 ? "0" + str : str;
}


var $0f497461630e3c95$exports = {};
var $d472b51d48917ca4$exports = {};
/* MIT license */ var $7c9a8b0cdbbe0cb5$exports = {};
"use strict";
$7c9a8b0cdbbe0cb5$exports = {
    "aliceblue": [
        240,
        248,
        255
    ],
    "antiquewhite": [
        250,
        235,
        215
    ],
    "aqua": [
        0,
        255,
        255
    ],
    "aquamarine": [
        127,
        255,
        212
    ],
    "azure": [
        240,
        255,
        255
    ],
    "beige": [
        245,
        245,
        220
    ],
    "bisque": [
        255,
        228,
        196
    ],
    "black": [
        0,
        0,
        0
    ],
    "blanchedalmond": [
        255,
        235,
        205
    ],
    "blue": [
        0,
        0,
        255
    ],
    "blueviolet": [
        138,
        43,
        226
    ],
    "brown": [
        165,
        42,
        42
    ],
    "burlywood": [
        222,
        184,
        135
    ],
    "cadetblue": [
        95,
        158,
        160
    ],
    "chartreuse": [
        127,
        255,
        0
    ],
    "chocolate": [
        210,
        105,
        30
    ],
    "coral": [
        255,
        127,
        80
    ],
    "cornflowerblue": [
        100,
        149,
        237
    ],
    "cornsilk": [
        255,
        248,
        220
    ],
    "crimson": [
        220,
        20,
        60
    ],
    "cyan": [
        0,
        255,
        255
    ],
    "darkblue": [
        0,
        0,
        139
    ],
    "darkcyan": [
        0,
        139,
        139
    ],
    "darkgoldenrod": [
        184,
        134,
        11
    ],
    "darkgray": [
        169,
        169,
        169
    ],
    "darkgreen": [
        0,
        100,
        0
    ],
    "darkgrey": [
        169,
        169,
        169
    ],
    "darkkhaki": [
        189,
        183,
        107
    ],
    "darkmagenta": [
        139,
        0,
        139
    ],
    "darkolivegreen": [
        85,
        107,
        47
    ],
    "darkorange": [
        255,
        140,
        0
    ],
    "darkorchid": [
        153,
        50,
        204
    ],
    "darkred": [
        139,
        0,
        0
    ],
    "darksalmon": [
        233,
        150,
        122
    ],
    "darkseagreen": [
        143,
        188,
        143
    ],
    "darkslateblue": [
        72,
        61,
        139
    ],
    "darkslategray": [
        47,
        79,
        79
    ],
    "darkslategrey": [
        47,
        79,
        79
    ],
    "darkturquoise": [
        0,
        206,
        209
    ],
    "darkviolet": [
        148,
        0,
        211
    ],
    "deeppink": [
        255,
        20,
        147
    ],
    "deepskyblue": [
        0,
        191,
        255
    ],
    "dimgray": [
        105,
        105,
        105
    ],
    "dimgrey": [
        105,
        105,
        105
    ],
    "dodgerblue": [
        30,
        144,
        255
    ],
    "firebrick": [
        178,
        34,
        34
    ],
    "floralwhite": [
        255,
        250,
        240
    ],
    "forestgreen": [
        34,
        139,
        34
    ],
    "fuchsia": [
        255,
        0,
        255
    ],
    "gainsboro": [
        220,
        220,
        220
    ],
    "ghostwhite": [
        248,
        248,
        255
    ],
    "gold": [
        255,
        215,
        0
    ],
    "goldenrod": [
        218,
        165,
        32
    ],
    "gray": [
        128,
        128,
        128
    ],
    "green": [
        0,
        128,
        0
    ],
    "greenyellow": [
        173,
        255,
        47
    ],
    "grey": [
        128,
        128,
        128
    ],
    "honeydew": [
        240,
        255,
        240
    ],
    "hotpink": [
        255,
        105,
        180
    ],
    "indianred": [
        205,
        92,
        92
    ],
    "indigo": [
        75,
        0,
        130
    ],
    "ivory": [
        255,
        255,
        240
    ],
    "khaki": [
        240,
        230,
        140
    ],
    "lavender": [
        230,
        230,
        250
    ],
    "lavenderblush": [
        255,
        240,
        245
    ],
    "lawngreen": [
        124,
        252,
        0
    ],
    "lemonchiffon": [
        255,
        250,
        205
    ],
    "lightblue": [
        173,
        216,
        230
    ],
    "lightcoral": [
        240,
        128,
        128
    ],
    "lightcyan": [
        224,
        255,
        255
    ],
    "lightgoldenrodyellow": [
        250,
        250,
        210
    ],
    "lightgray": [
        211,
        211,
        211
    ],
    "lightgreen": [
        144,
        238,
        144
    ],
    "lightgrey": [
        211,
        211,
        211
    ],
    "lightpink": [
        255,
        182,
        193
    ],
    "lightsalmon": [
        255,
        160,
        122
    ],
    "lightseagreen": [
        32,
        178,
        170
    ],
    "lightskyblue": [
        135,
        206,
        250
    ],
    "lightslategray": [
        119,
        136,
        153
    ],
    "lightslategrey": [
        119,
        136,
        153
    ],
    "lightsteelblue": [
        176,
        196,
        222
    ],
    "lightyellow": [
        255,
        255,
        224
    ],
    "lime": [
        0,
        255,
        0
    ],
    "limegreen": [
        50,
        205,
        50
    ],
    "linen": [
        250,
        240,
        230
    ],
    "magenta": [
        255,
        0,
        255
    ],
    "maroon": [
        128,
        0,
        0
    ],
    "mediumaquamarine": [
        102,
        205,
        170
    ],
    "mediumblue": [
        0,
        0,
        205
    ],
    "mediumorchid": [
        186,
        85,
        211
    ],
    "mediumpurple": [
        147,
        112,
        219
    ],
    "mediumseagreen": [
        60,
        179,
        113
    ],
    "mediumslateblue": [
        123,
        104,
        238
    ],
    "mediumspringgreen": [
        0,
        250,
        154
    ],
    "mediumturquoise": [
        72,
        209,
        204
    ],
    "mediumvioletred": [
        199,
        21,
        133
    ],
    "midnightblue": [
        25,
        25,
        112
    ],
    "mintcream": [
        245,
        255,
        250
    ],
    "mistyrose": [
        255,
        228,
        225
    ],
    "moccasin": [
        255,
        228,
        181
    ],
    "navajowhite": [
        255,
        222,
        173
    ],
    "navy": [
        0,
        0,
        128
    ],
    "oldlace": [
        253,
        245,
        230
    ],
    "olive": [
        128,
        128,
        0
    ],
    "olivedrab": [
        107,
        142,
        35
    ],
    "orange": [
        255,
        165,
        0
    ],
    "orangered": [
        255,
        69,
        0
    ],
    "orchid": [
        218,
        112,
        214
    ],
    "palegoldenrod": [
        238,
        232,
        170
    ],
    "palegreen": [
        152,
        251,
        152
    ],
    "paleturquoise": [
        175,
        238,
        238
    ],
    "palevioletred": [
        219,
        112,
        147
    ],
    "papayawhip": [
        255,
        239,
        213
    ],
    "peachpuff": [
        255,
        218,
        185
    ],
    "peru": [
        205,
        133,
        63
    ],
    "pink": [
        255,
        192,
        203
    ],
    "plum": [
        221,
        160,
        221
    ],
    "powderblue": [
        176,
        224,
        230
    ],
    "purple": [
        128,
        0,
        128
    ],
    "rebeccapurple": [
        102,
        51,
        153
    ],
    "red": [
        255,
        0,
        0
    ],
    "rosybrown": [
        188,
        143,
        143
    ],
    "royalblue": [
        65,
        105,
        225
    ],
    "saddlebrown": [
        139,
        69,
        19
    ],
    "salmon": [
        250,
        128,
        114
    ],
    "sandybrown": [
        244,
        164,
        96
    ],
    "seagreen": [
        46,
        139,
        87
    ],
    "seashell": [
        255,
        245,
        238
    ],
    "sienna": [
        160,
        82,
        45
    ],
    "silver": [
        192,
        192,
        192
    ],
    "skyblue": [
        135,
        206,
        235
    ],
    "slateblue": [
        106,
        90,
        205
    ],
    "slategray": [
        112,
        128,
        144
    ],
    "slategrey": [
        112,
        128,
        144
    ],
    "snow": [
        255,
        250,
        250
    ],
    "springgreen": [
        0,
        255,
        127
    ],
    "steelblue": [
        70,
        130,
        180
    ],
    "tan": [
        210,
        180,
        140
    ],
    "teal": [
        0,
        128,
        128
    ],
    "thistle": [
        216,
        191,
        216
    ],
    "tomato": [
        255,
        99,
        71
    ],
    "turquoise": [
        64,
        224,
        208
    ],
    "violet": [
        238,
        130,
        238
    ],
    "wheat": [
        245,
        222,
        179
    ],
    "white": [
        255,
        255,
        255
    ],
    "whitesmoke": [
        245,
        245,
        245
    ],
    "yellow": [
        255,
        255,
        0
    ],
    "yellowgreen": [
        154,
        205,
        50
    ]
};


// NOTE: conversions should only return primitive values (i.e. arrays, or
//       values that give correct `typeof` results).
//       do not use box values types (i.e. Number(), String(), etc.)
var $d472b51d48917ca4$var$reverseKeywords = {};
for(var $d472b51d48917ca4$var$key in $7c9a8b0cdbbe0cb5$exports)if ($7c9a8b0cdbbe0cb5$exports.hasOwnProperty($d472b51d48917ca4$var$key)) $d472b51d48917ca4$var$reverseKeywords[$7c9a8b0cdbbe0cb5$exports[$d472b51d48917ca4$var$key]] = $d472b51d48917ca4$var$key;
var $d472b51d48917ca4$var$convert = $d472b51d48917ca4$exports = {
    rgb: {
        channels: 3,
        labels: "rgb"
    },
    hsl: {
        channels: 3,
        labels: "hsl"
    },
    hsv: {
        channels: 3,
        labels: "hsv"
    },
    hwb: {
        channels: 3,
        labels: "hwb"
    },
    cmyk: {
        channels: 4,
        labels: "cmyk"
    },
    xyz: {
        channels: 3,
        labels: "xyz"
    },
    lab: {
        channels: 3,
        labels: "lab"
    },
    lch: {
        channels: 3,
        labels: "lch"
    },
    hex: {
        channels: 1,
        labels: [
            "hex"
        ]
    },
    keyword: {
        channels: 1,
        labels: [
            "keyword"
        ]
    },
    ansi16: {
        channels: 1,
        labels: [
            "ansi16"
        ]
    },
    ansi256: {
        channels: 1,
        labels: [
            "ansi256"
        ]
    },
    hcg: {
        channels: 3,
        labels: [
            "h",
            "c",
            "g"
        ]
    },
    apple: {
        channels: 3,
        labels: [
            "r16",
            "g16",
            "b16"
        ]
    },
    gray: {
        channels: 1,
        labels: [
            "gray"
        ]
    }
};
// hide .channels and .labels properties
for(var $d472b51d48917ca4$var$model in $d472b51d48917ca4$var$convert)if ($d472b51d48917ca4$var$convert.hasOwnProperty($d472b51d48917ca4$var$model)) {
    if (!("channels" in $d472b51d48917ca4$var$convert[$d472b51d48917ca4$var$model])) throw new Error("missing channels property: " + $d472b51d48917ca4$var$model);
    if (!("labels" in $d472b51d48917ca4$var$convert[$d472b51d48917ca4$var$model])) throw new Error("missing channel labels property: " + $d472b51d48917ca4$var$model);
    if ($d472b51d48917ca4$var$convert[$d472b51d48917ca4$var$model].labels.length !== $d472b51d48917ca4$var$convert[$d472b51d48917ca4$var$model].channels) throw new Error("channel and label counts mismatch: " + $d472b51d48917ca4$var$model);
    var $d472b51d48917ca4$var$channels = $d472b51d48917ca4$var$convert[$d472b51d48917ca4$var$model].channels;
    var $d472b51d48917ca4$var$labels = $d472b51d48917ca4$var$convert[$d472b51d48917ca4$var$model].labels;
    delete $d472b51d48917ca4$var$convert[$d472b51d48917ca4$var$model].channels;
    delete $d472b51d48917ca4$var$convert[$d472b51d48917ca4$var$model].labels;
    Object.defineProperty($d472b51d48917ca4$var$convert[$d472b51d48917ca4$var$model], "channels", {
        value: $d472b51d48917ca4$var$channels
    });
    Object.defineProperty($d472b51d48917ca4$var$convert[$d472b51d48917ca4$var$model], "labels", {
        value: $d472b51d48917ca4$var$labels
    });
}
$d472b51d48917ca4$var$convert.rgb.hsl = function(rgb) {
    var r = rgb[0] / 255;
    var g = rgb[1] / 255;
    var b = rgb[2] / 255;
    var min = Math.min(r, g, b);
    var max = Math.max(r, g, b);
    var delta = max - min;
    var h;
    var s;
    var l;
    if (max === min) h = 0;
    else if (r === max) h = (g - b) / delta;
    else if (g === max) h = 2 + (b - r) / delta;
    else if (b === max) h = 4 + (r - g) / delta;
    h = Math.min(h * 60, 360);
    if (h < 0) h += 360;
    l = (min + max) / 2;
    if (max === min) s = 0;
    else if (l <= 0.5) s = delta / (max + min);
    else s = delta / (2 - max - min);
    return [
        h,
        s * 100,
        l * 100
    ];
};
$d472b51d48917ca4$var$convert.rgb.hsv = function(rgb) {
    var rdif;
    var gdif;
    var bdif;
    var h;
    var s;
    var r = rgb[0] / 255;
    var g = rgb[1] / 255;
    var b = rgb[2] / 255;
    var v = Math.max(r, g, b);
    var diff = v - Math.min(r, g, b);
    var diffc = function(c) {
        return (v - c) / 6 / diff + 0.5;
    };
    if (diff === 0) h = s = 0;
    else {
        s = diff / v;
        rdif = diffc(r);
        gdif = diffc(g);
        bdif = diffc(b);
        if (r === v) h = bdif - gdif;
        else if (g === v) h = 1 / 3 + rdif - bdif;
        else if (b === v) h = 2 / 3 + gdif - rdif;
        if (h < 0) h += 1;
        else if (h > 1) h -= 1;
    }
    return [
        h * 360,
        s * 100,
        v * 100
    ];
};
$d472b51d48917ca4$var$convert.rgb.hwb = function(rgb) {
    var r = rgb[0];
    var g = rgb[1];
    var b = rgb[2];
    var h = $d472b51d48917ca4$var$convert.rgb.hsl(rgb)[0];
    var w = 1 / 255 * Math.min(r, Math.min(g, b));
    b = 1 - 1 / 255 * Math.max(r, Math.max(g, b));
    return [
        h,
        w * 100,
        b * 100
    ];
};
$d472b51d48917ca4$var$convert.rgb.cmyk = function(rgb) {
    var r = rgb[0] / 255;
    var g = rgb[1] / 255;
    var b = rgb[2] / 255;
    var c;
    var m;
    var y;
    var k;
    k = Math.min(1 - r, 1 - g, 1 - b);
    c = (1 - r - k) / (1 - k) || 0;
    m = (1 - g - k) / (1 - k) || 0;
    y = (1 - b - k) / (1 - k) || 0;
    return [
        c * 100,
        m * 100,
        y * 100,
        k * 100
    ];
};
/**
 * See https://en.m.wikipedia.org/wiki/Euclidean_distance#Squared_Euclidean_distance
 * */ function $d472b51d48917ca4$var$comparativeDistance(x, y) {
    return Math.pow(x[0] - y[0], 2) + Math.pow(x[1] - y[1], 2) + Math.pow(x[2] - y[2], 2);
}
$d472b51d48917ca4$var$convert.rgb.keyword = function(rgb) {
    var reversed = $d472b51d48917ca4$var$reverseKeywords[rgb];
    if (reversed) return reversed;
    var currentClosestDistance = Infinity;
    var currentClosestKeyword;
    for(var keyword in $7c9a8b0cdbbe0cb5$exports)if ($7c9a8b0cdbbe0cb5$exports.hasOwnProperty(keyword)) {
        var value = $7c9a8b0cdbbe0cb5$exports[keyword];
        // Compute comparative distance
        var distance = $d472b51d48917ca4$var$comparativeDistance(rgb, value);
        // Check if its less, if so set as closest
        if (distance < currentClosestDistance) {
            currentClosestDistance = distance;
            currentClosestKeyword = keyword;
        }
    }
    return currentClosestKeyword;
};
$d472b51d48917ca4$var$convert.keyword.rgb = function(keyword) {
    return $7c9a8b0cdbbe0cb5$exports[keyword];
};
$d472b51d48917ca4$var$convert.rgb.xyz = function(rgb) {
    var r = rgb[0] / 255;
    var g = rgb[1] / 255;
    var b = rgb[2] / 255;
    // assume sRGB
    r = r > 0.04045 ? Math.pow((r + 0.055) / 1.055, 2.4) : r / 12.92;
    g = g > 0.04045 ? Math.pow((g + 0.055) / 1.055, 2.4) : g / 12.92;
    b = b > 0.04045 ? Math.pow((b + 0.055) / 1.055, 2.4) : b / 12.92;
    var x = r * 0.4124 + g * 0.3576 + b * 0.1805;
    var y = r * 0.2126 + g * 0.7152 + b * 0.0722;
    var z = r * 0.0193 + g * 0.1192 + b * 0.9505;
    return [
        x * 100,
        y * 100,
        z * 100
    ];
};
$d472b51d48917ca4$var$convert.rgb.lab = function(rgb) {
    var xyz = $d472b51d48917ca4$var$convert.rgb.xyz(rgb);
    var x = xyz[0];
    var y = xyz[1];
    var z = xyz[2];
    var l;
    var a;
    var b;
    x /= 95.047;
    y /= 100;
    z /= 108.883;
    x = x > 0.008856 ? Math.pow(x, 1 / 3) : 7.787 * x + 16 / 116;
    y = y > 0.008856 ? Math.pow(y, 1 / 3) : 7.787 * y + 16 / 116;
    z = z > 0.008856 ? Math.pow(z, 1 / 3) : 7.787 * z + 16 / 116;
    l = 116 * y - 16;
    a = 500 * (x - y);
    b = 200 * (y - z);
    return [
        l,
        a,
        b
    ];
};
$d472b51d48917ca4$var$convert.hsl.rgb = function(hsl) {
    var h = hsl[0] / 360;
    var s = hsl[1] / 100;
    var l = hsl[2] / 100;
    var t1;
    var t2;
    var t3;
    var rgb;
    var val;
    if (s === 0) {
        val = l * 255;
        return [
            val,
            val,
            val
        ];
    }
    if (l < 0.5) t2 = l * (1 + s);
    else t2 = l + s - l * s;
    t1 = 2 * l - t2;
    rgb = [
        0,
        0,
        0
    ];
    for(var i = 0; i < 3; i++){
        t3 = h + 1 / 3 * -(i - 1);
        if (t3 < 0) t3++;
        if (t3 > 1) t3--;
        if (6 * t3 < 1) val = t1 + (t2 - t1) * 6 * t3;
        else if (2 * t3 < 1) val = t2;
        else if (3 * t3 < 2) val = t1 + (t2 - t1) * (2 / 3 - t3) * 6;
        else val = t1;
        rgb[i] = val * 255;
    }
    return rgb;
};
$d472b51d48917ca4$var$convert.hsl.hsv = function(hsl) {
    var h = hsl[0];
    var s = hsl[1] / 100;
    var l = hsl[2] / 100;
    var smin = s;
    var lmin = Math.max(l, 0.01);
    var sv;
    var v;
    l *= 2;
    s *= l <= 1 ? l : 2 - l;
    smin *= lmin <= 1 ? lmin : 2 - lmin;
    v = (l + s) / 2;
    sv = l === 0 ? 2 * smin / (lmin + smin) : 2 * s / (l + s);
    return [
        h,
        sv * 100,
        v * 100
    ];
};
$d472b51d48917ca4$var$convert.hsv.rgb = function(hsv) {
    var h = hsv[0] / 60;
    var s = hsv[1] / 100;
    var v = hsv[2] / 100;
    var hi = Math.floor(h) % 6;
    var f = h - Math.floor(h);
    var p = 255 * v * (1 - s);
    var q = 255 * v * (1 - s * f);
    var t = 255 * v * (1 - s * (1 - f));
    v *= 255;
    switch(hi){
        case 0:
            return [
                v,
                t,
                p
            ];
        case 1:
            return [
                q,
                v,
                p
            ];
        case 2:
            return [
                p,
                v,
                t
            ];
        case 3:
            return [
                p,
                q,
                v
            ];
        case 4:
            return [
                t,
                p,
                v
            ];
        case 5:
            return [
                v,
                p,
                q
            ];
    }
};
$d472b51d48917ca4$var$convert.hsv.hsl = function(hsv) {
    var h = hsv[0];
    var s = hsv[1] / 100;
    var v = hsv[2] / 100;
    var vmin = Math.max(v, 0.01);
    var lmin;
    var sl;
    var l;
    l = (2 - s) * v;
    lmin = (2 - s) * vmin;
    sl = s * vmin;
    sl /= lmin <= 1 ? lmin : 2 - lmin;
    sl = sl || 0;
    l /= 2;
    return [
        h,
        sl * 100,
        l * 100
    ];
};
// http://dev.w3.org/csswg/css-color/#hwb-to-rgb
$d472b51d48917ca4$var$convert.hwb.rgb = function(hwb) {
    var h = hwb[0] / 360;
    var wh = hwb[1] / 100;
    var bl = hwb[2] / 100;
    var ratio = wh + bl;
    var i;
    var v;
    var f;
    var n;
    // wh + bl cant be > 1
    if (ratio > 1) {
        wh /= ratio;
        bl /= ratio;
    }
    i = Math.floor(6 * h);
    v = 1 - bl;
    f = 6 * h - i;
    if ((i & 0x01) !== 0) f = 1 - f;
    n = wh + f * (v - wh); // linear interpolation
    var r;
    var g;
    var b;
    switch(i){
        default:
        case 6:
        case 0:
            r = v;
            g = n;
            b = wh;
            break;
        case 1:
            r = n;
            g = v;
            b = wh;
            break;
        case 2:
            r = wh;
            g = v;
            b = n;
            break;
        case 3:
            r = wh;
            g = n;
            b = v;
            break;
        case 4:
            r = n;
            g = wh;
            b = v;
            break;
        case 5:
            r = v;
            g = wh;
            b = n;
            break;
    }
    return [
        r * 255,
        g * 255,
        b * 255
    ];
};
$d472b51d48917ca4$var$convert.cmyk.rgb = function(cmyk) {
    var c = cmyk[0] / 100;
    var m = cmyk[1] / 100;
    var y = cmyk[2] / 100;
    var k = cmyk[3] / 100;
    var r;
    var g;
    var b;
    r = 1 - Math.min(1, c * (1 - k) + k);
    g = 1 - Math.min(1, m * (1 - k) + k);
    b = 1 - Math.min(1, y * (1 - k) + k);
    return [
        r * 255,
        g * 255,
        b * 255
    ];
};
$d472b51d48917ca4$var$convert.xyz.rgb = function(xyz) {
    var x = xyz[0] / 100;
    var y = xyz[1] / 100;
    var z = xyz[2] / 100;
    var r;
    var g;
    var b;
    r = x * 3.2406 + y * -1.5372 + z * -0.4986;
    g = x * -0.9689 + y * 1.8758 + z * 0.0415;
    b = x * 0.0557 + y * -0.204 + z * 1.0570;
    // assume sRGB
    r = r > 0.0031308 ? 1.055 * Math.pow(r, 1.0 / 2.4) - 0.055 : r * 12.92;
    g = g > 0.0031308 ? 1.055 * Math.pow(g, 1.0 / 2.4) - 0.055 : g * 12.92;
    b = b > 0.0031308 ? 1.055 * Math.pow(b, 1.0 / 2.4) - 0.055 : b * 12.92;
    r = Math.min(Math.max(0, r), 1);
    g = Math.min(Math.max(0, g), 1);
    b = Math.min(Math.max(0, b), 1);
    return [
        r * 255,
        g * 255,
        b * 255
    ];
};
$d472b51d48917ca4$var$convert.xyz.lab = function(xyz) {
    var x = xyz[0];
    var y = xyz[1];
    var z = xyz[2];
    var l;
    var a;
    var b;
    x /= 95.047;
    y /= 100;
    z /= 108.883;
    x = x > 0.008856 ? Math.pow(x, 1 / 3) : 7.787 * x + 16 / 116;
    y = y > 0.008856 ? Math.pow(y, 1 / 3) : 7.787 * y + 16 / 116;
    z = z > 0.008856 ? Math.pow(z, 1 / 3) : 7.787 * z + 16 / 116;
    l = 116 * y - 16;
    a = 500 * (x - y);
    b = 200 * (y - z);
    return [
        l,
        a,
        b
    ];
};
$d472b51d48917ca4$var$convert.lab.xyz = function(lab) {
    var l = lab[0];
    var a = lab[1];
    var b = lab[2];
    var x;
    var y;
    var z;
    y = (l + 16) / 116;
    x = a / 500 + y;
    z = y - b / 200;
    var y2 = Math.pow(y, 3);
    var x2 = Math.pow(x, 3);
    var z2 = Math.pow(z, 3);
    y = y2 > 0.008856 ? y2 : (y - 16 / 116) / 7.787;
    x = x2 > 0.008856 ? x2 : (x - 16 / 116) / 7.787;
    z = z2 > 0.008856 ? z2 : (z - 16 / 116) / 7.787;
    x *= 95.047;
    y *= 100;
    z *= 108.883;
    return [
        x,
        y,
        z
    ];
};
$d472b51d48917ca4$var$convert.lab.lch = function(lab) {
    var l = lab[0];
    var a = lab[1];
    var b = lab[2];
    var hr;
    var h;
    var c;
    hr = Math.atan2(b, a);
    h = hr * 360 / 2 / Math.PI;
    if (h < 0) h += 360;
    c = Math.sqrt(a * a + b * b);
    return [
        l,
        c,
        h
    ];
};
$d472b51d48917ca4$var$convert.lch.lab = function(lch) {
    var l = lch[0];
    var c = lch[1];
    var h = lch[2];
    var a;
    var b;
    var hr;
    hr = h / 360 * 2 * Math.PI;
    a = c * Math.cos(hr);
    b = c * Math.sin(hr);
    return [
        l,
        a,
        b
    ];
};
$d472b51d48917ca4$var$convert.rgb.ansi16 = function(args) {
    var r = args[0];
    var g = args[1];
    var b = args[2];
    var value = 1 in arguments ? arguments[1] : $d472b51d48917ca4$var$convert.rgb.hsv(args)[2]; // hsv -> ansi16 optimization
    value = Math.round(value / 50);
    if (value === 0) return 30;
    var ansi = 30 + (Math.round(b / 255) << 2 | Math.round(g / 255) << 1 | Math.round(r / 255));
    if (value === 2) ansi += 60;
    return ansi;
};
$d472b51d48917ca4$var$convert.hsv.ansi16 = function(args) {
    // optimization here; we already know the value and don't need to get
    // it converted for us.
    return $d472b51d48917ca4$var$convert.rgb.ansi16($d472b51d48917ca4$var$convert.hsv.rgb(args), args[2]);
};
$d472b51d48917ca4$var$convert.rgb.ansi256 = function(args) {
    var r = args[0];
    var g = args[1];
    var b = args[2];
    // we use the extended greyscale palette here, with the exception of
    // black and white. normal palette only has 4 greyscale shades.
    if (r === g && g === b) {
        if (r < 8) return 16;
        if (r > 248) return 231;
        return Math.round((r - 8) / 247 * 24) + 232;
    }
    var ansi = 16 + 36 * Math.round(r / 255 * 5) + 6 * Math.round(g / 255 * 5) + Math.round(b / 255 * 5);
    return ansi;
};
$d472b51d48917ca4$var$convert.ansi16.rgb = function(args) {
    var color = args % 10;
    // handle greyscale
    if (color === 0 || color === 7) {
        if (args > 50) color += 3.5;
        color = color / 10.5 * 255;
        return [
            color,
            color,
            color
        ];
    }
    var mult = (~~(args > 50) + 1) * 0.5;
    var r = (color & 1) * mult * 255;
    var g = (color >> 1 & 1) * mult * 255;
    var b = (color >> 2 & 1) * mult * 255;
    return [
        r,
        g,
        b
    ];
};
$d472b51d48917ca4$var$convert.ansi256.rgb = function(args) {
    // handle greyscale
    if (args >= 232) {
        var c = (args - 232) * 10 + 8;
        return [
            c,
            c,
            c
        ];
    }
    args -= 16;
    var rem;
    var r = Math.floor(args / 36) / 5 * 255;
    var g = Math.floor((rem = args % 36) / 6) / 5 * 255;
    var b = rem % 6 / 5 * 255;
    return [
        r,
        g,
        b
    ];
};
$d472b51d48917ca4$var$convert.rgb.hex = function(args) {
    var integer = ((Math.round(args[0]) & 0xFF) << 16) + ((Math.round(args[1]) & 0xFF) << 8) + (Math.round(args[2]) & 0xFF);
    var string = integer.toString(16).toUpperCase();
    return "000000".substring(string.length) + string;
};
$d472b51d48917ca4$var$convert.hex.rgb = function(args) {
    var match = args.toString(16).match(/[a-f0-9]{6}|[a-f0-9]{3}/i);
    if (!match) return [
        0,
        0,
        0
    ];
    var colorString = match[0];
    if (match[0].length === 3) colorString = colorString.split("").map(function(char) {
        return char + char;
    }).join("");
    var integer = parseInt(colorString, 16);
    var r = integer >> 16 & 0xFF;
    var g = integer >> 8 & 0xFF;
    var b = integer & 0xFF;
    return [
        r,
        g,
        b
    ];
};
$d472b51d48917ca4$var$convert.rgb.hcg = function(rgb) {
    var r = rgb[0] / 255;
    var g = rgb[1] / 255;
    var b = rgb[2] / 255;
    var max = Math.max(Math.max(r, g), b);
    var min = Math.min(Math.min(r, g), b);
    var chroma = max - min;
    var grayscale;
    var hue;
    if (chroma < 1) grayscale = min / (1 - chroma);
    else grayscale = 0;
    if (chroma <= 0) hue = 0;
    else if (max === r) hue = (g - b) / chroma % 6;
    else if (max === g) hue = 2 + (b - r) / chroma;
    else hue = 4 + (r - g) / chroma + 4;
    hue /= 6;
    hue %= 1;
    return [
        hue * 360,
        chroma * 100,
        grayscale * 100
    ];
};
$d472b51d48917ca4$var$convert.hsl.hcg = function(hsl) {
    var s = hsl[1] / 100;
    var l = hsl[2] / 100;
    var c = 1;
    var f = 0;
    if (l < 0.5) c = 2.0 * s * l;
    else c = 2.0 * s * (1.0 - l);
    if (c < 1.0) f = (l - 0.5 * c) / (1.0 - c);
    return [
        hsl[0],
        c * 100,
        f * 100
    ];
};
$d472b51d48917ca4$var$convert.hsv.hcg = function(hsv) {
    var s = hsv[1] / 100;
    var v = hsv[2] / 100;
    var c = s * v;
    var f = 0;
    if (c < 1.0) f = (v - c) / (1 - c);
    return [
        hsv[0],
        c * 100,
        f * 100
    ];
};
$d472b51d48917ca4$var$convert.hcg.rgb = function(hcg) {
    var h = hcg[0] / 360;
    var c = hcg[1] / 100;
    var g = hcg[2] / 100;
    if (c === 0.0) return [
        g * 255,
        g * 255,
        g * 255
    ];
    var pure = [
        0,
        0,
        0
    ];
    var hi = h % 1 * 6;
    var v = hi % 1;
    var w = 1 - v;
    var mg = 0;
    switch(Math.floor(hi)){
        case 0:
            pure[0] = 1;
            pure[1] = v;
            pure[2] = 0;
            break;
        case 1:
            pure[0] = w;
            pure[1] = 1;
            pure[2] = 0;
            break;
        case 2:
            pure[0] = 0;
            pure[1] = 1;
            pure[2] = v;
            break;
        case 3:
            pure[0] = 0;
            pure[1] = w;
            pure[2] = 1;
            break;
        case 4:
            pure[0] = v;
            pure[1] = 0;
            pure[2] = 1;
            break;
        default:
            pure[0] = 1;
            pure[1] = 0;
            pure[2] = w;
    }
    mg = (1.0 - c) * g;
    return [
        (c * pure[0] + mg) * 255,
        (c * pure[1] + mg) * 255,
        (c * pure[2] + mg) * 255
    ];
};
$d472b51d48917ca4$var$convert.hcg.hsv = function(hcg) {
    var c = hcg[1] / 100;
    var g = hcg[2] / 100;
    var v = c + g * (1.0 - c);
    var f = 0;
    if (v > 0.0) f = c / v;
    return [
        hcg[0],
        f * 100,
        v * 100
    ];
};
$d472b51d48917ca4$var$convert.hcg.hsl = function(hcg) {
    var c = hcg[1] / 100;
    var g = hcg[2] / 100;
    var l = g * (1.0 - c) + 0.5 * c;
    var s = 0;
    if (l > 0.0 && l < 0.5) s = c / (2 * l);
    else if (l >= 0.5 && l < 1.0) s = c / (2 * (1 - l));
    return [
        hcg[0],
        s * 100,
        l * 100
    ];
};
$d472b51d48917ca4$var$convert.hcg.hwb = function(hcg) {
    var c = hcg[1] / 100;
    var g = hcg[2] / 100;
    var v = c + g * (1.0 - c);
    return [
        hcg[0],
        (v - c) * 100,
        (1 - v) * 100
    ];
};
$d472b51d48917ca4$var$convert.hwb.hcg = function(hwb) {
    var w = hwb[1] / 100;
    var b = hwb[2] / 100;
    var v = 1 - b;
    var c = v - w;
    var g = 0;
    if (c < 1) g = (v - c) / (1 - c);
    return [
        hwb[0],
        c * 100,
        g * 100
    ];
};
$d472b51d48917ca4$var$convert.apple.rgb = function(apple) {
    return [
        apple[0] / 65535 * 255,
        apple[1] / 65535 * 255,
        apple[2] / 65535 * 255
    ];
};
$d472b51d48917ca4$var$convert.rgb.apple = function(rgb) {
    return [
        rgb[0] / 255 * 65535,
        rgb[1] / 255 * 65535,
        rgb[2] / 255 * 65535
    ];
};
$d472b51d48917ca4$var$convert.gray.rgb = function(args) {
    return [
        args[0] / 100 * 255,
        args[0] / 100 * 255,
        args[0] / 100 * 255
    ];
};
$d472b51d48917ca4$var$convert.gray.hsl = $d472b51d48917ca4$var$convert.gray.hsv = function(args) {
    return [
        0,
        0,
        args[0]
    ];
};
$d472b51d48917ca4$var$convert.gray.hwb = function(gray) {
    return [
        0,
        100,
        gray[0]
    ];
};
$d472b51d48917ca4$var$convert.gray.cmyk = function(gray) {
    return [
        0,
        0,
        0,
        gray[0]
    ];
};
$d472b51d48917ca4$var$convert.gray.lab = function(gray) {
    return [
        gray[0],
        0,
        0
    ];
};
$d472b51d48917ca4$var$convert.gray.hex = function(gray) {
    var val = Math.round(gray[0] / 100 * 255) & 0xFF;
    var integer = (val << 16) + (val << 8) + val;
    var string = integer.toString(16).toUpperCase();
    return "000000".substring(string.length) + string;
};
$d472b51d48917ca4$var$convert.rgb.gray = function(rgb) {
    var val = (rgb[0] + rgb[1] + rgb[2]) / 3;
    return [
        val / 255 * 100
    ];
};


var $a29b8262ef492f6d$exports = {};

/*
	this function routes a model to all other models.

	all functions that are routed have a property `.conversion` attached
	to the returned synthetic function. This property is an array
	of strings, each with the steps in between the 'from' and 'to'
	color models (inclusive).

	conversions that are not possible simply are not included.
*/ function $a29b8262ef492f6d$var$buildGraph() {
    var graph = {};
    // https://jsperf.com/object-keys-vs-for-in-with-closure/3
    var models = Object.keys($d472b51d48917ca4$exports);
    for(var len = models.length, i = 0; i < len; i++)graph[models[i]] = {
        // http://jsperf.com/1-vs-infinity
        // micro-opt, but this is simple.
        distance: -1,
        parent: null
    };
    return graph;
}
// https://en.wikipedia.org/wiki/Breadth-first_search
function $a29b8262ef492f6d$var$deriveBFS(fromModel) {
    var graph = $a29b8262ef492f6d$var$buildGraph();
    var queue = [
        fromModel
    ]; // unshift -> queue -> pop
    graph[fromModel].distance = 0;
    while(queue.length){
        var current = queue.pop();
        var adjacents = Object.keys($d472b51d48917ca4$exports[current]);
        for(var len = adjacents.length, i = 0; i < len; i++){
            var adjacent = adjacents[i];
            var node = graph[adjacent];
            if (node.distance === -1) {
                node.distance = graph[current].distance + 1;
                node.parent = current;
                queue.unshift(adjacent);
            }
        }
    }
    return graph;
}
function $a29b8262ef492f6d$var$link(from, to) {
    return function(args) {
        return to(from(args));
    };
}
function $a29b8262ef492f6d$var$wrapConversion(toModel, graph) {
    var path = [
        graph[toModel].parent,
        toModel
    ];
    var fn = $d472b51d48917ca4$exports[graph[toModel].parent][toModel];
    var cur = graph[toModel].parent;
    while(graph[cur].parent){
        path.unshift(graph[cur].parent);
        fn = $a29b8262ef492f6d$var$link($d472b51d48917ca4$exports[graph[cur].parent][cur], fn);
        cur = graph[cur].parent;
    }
    fn.conversion = path;
    return fn;
}
$a29b8262ef492f6d$exports = function(fromModel) {
    var graph = $a29b8262ef492f6d$var$deriveBFS(fromModel);
    var conversion = {};
    var models = Object.keys(graph);
    for(var len = models.length, i = 0; i < len; i++){
        var toModel = models[i];
        var node = graph[toModel];
        if (node.parent === null) continue;
        conversion[toModel] = $a29b8262ef492f6d$var$wrapConversion(toModel, graph);
    }
    return conversion;
};


var $0f497461630e3c95$var$convert = {};
var $0f497461630e3c95$var$models = Object.keys($d472b51d48917ca4$exports);
function $0f497461630e3c95$var$wrapRaw(fn) {
    var wrappedFn = function(args) {
        if (args === undefined || args === null) return args;
        if (arguments.length > 1) args = Array.prototype.slice.call(arguments);
        return fn(args);
    };
    // preserve .conversion property if there is one
    if ("conversion" in fn) wrappedFn.conversion = fn.conversion;
    return wrappedFn;
}
function $0f497461630e3c95$var$wrapRounded(fn) {
    var wrappedFn = function(args) {
        if (args === undefined || args === null) return args;
        if (arguments.length > 1) args = Array.prototype.slice.call(arguments);
        var result = fn(args);
        // we're assuming the result is an array here.
        // see notice in conversions.js; don't use box types
        // in conversion functions.
        if (typeof result === "object") for(var len = result.length, i = 0; i < len; i++)result[i] = Math.round(result[i]);
        return result;
    };
    // preserve .conversion property if there is one
    if ("conversion" in fn) wrappedFn.conversion = fn.conversion;
    return wrappedFn;
}
$0f497461630e3c95$var$models.forEach(function(fromModel) {
    $0f497461630e3c95$var$convert[fromModel] = {};
    Object.defineProperty($0f497461630e3c95$var$convert[fromModel], "channels", {
        value: $d472b51d48917ca4$exports[fromModel].channels
    });
    Object.defineProperty($0f497461630e3c95$var$convert[fromModel], "labels", {
        value: $d472b51d48917ca4$exports[fromModel].labels
    });
    var routes = $a29b8262ef492f6d$exports(fromModel);
    var routeModels = Object.keys(routes);
    routeModels.forEach(function(toModel) {
        var fn = routes[toModel];
        $0f497461630e3c95$var$convert[fromModel][toModel] = $0f497461630e3c95$var$wrapRounded(fn);
        $0f497461630e3c95$var$convert[fromModel][toModel].raw = $0f497461630e3c95$var$wrapRaw(fn);
    });
});
$0f497461630e3c95$exports = $0f497461630e3c95$var$convert;


var $366d7e75857fe306$var$_slice = [].slice;
var $366d7e75857fe306$var$skippedModels = [
    // to be honest, I don't really feel like keyword belongs in color convert, but eh.
    "keyword",
    // gray conflicts with some method names, and has its own method defined.
    "gray",
    // shouldn't really be in color-convert either...
    "hex"
];
var $366d7e75857fe306$var$hashedModelKeys = {};
Object.keys($0f497461630e3c95$exports).forEach(function(model) {
    $366d7e75857fe306$var$hashedModelKeys[$366d7e75857fe306$var$_slice.call($0f497461630e3c95$exports[model].labels).sort().join("")] = model;
});
var $366d7e75857fe306$var$limiters = {};
function $366d7e75857fe306$var$Color(obj, model) {
    if (!(this instanceof $366d7e75857fe306$var$Color)) return new $366d7e75857fe306$var$Color(obj, model);
    if (model && model in $366d7e75857fe306$var$skippedModels) model = null;
    if (model && !(model in $0f497461630e3c95$exports)) throw new Error("Unknown model: " + model);
    var i;
    var channels;
    if (obj == null) {
        this.model = "rgb";
        this.color = [
            0,
            0,
            0
        ];
        this.valpha = 1;
    } else if (obj instanceof $366d7e75857fe306$var$Color) {
        this.model = obj.model;
        this.color = obj.color.slice();
        this.valpha = obj.valpha;
    } else if (typeof obj === "string") {
        var result = $c49a0977e70d9aa3$exports.get(obj);
        if (result === null) throw new Error("Unable to parse color from string: " + obj);
        this.model = result.model;
        channels = $0f497461630e3c95$exports[this.model].channels;
        this.color = result.value.slice(0, channels);
        this.valpha = typeof result.value[channels] === "number" ? result.value[channels] : 1;
    } else if (obj.length) {
        this.model = model || "rgb";
        channels = $0f497461630e3c95$exports[this.model].channels;
        var newArr = $366d7e75857fe306$var$_slice.call(obj, 0, channels);
        this.color = $366d7e75857fe306$var$zeroArray(newArr, channels);
        this.valpha = typeof obj[channels] === "number" ? obj[channels] : 1;
    } else if (typeof obj === "number") {
        // this is always RGB - can be converted later on.
        obj &= 0xFFFFFF;
        this.model = "rgb";
        this.color = [
            obj >> 16 & 0xFF,
            obj >> 8 & 0xFF,
            obj & 0xFF
        ];
        this.valpha = 1;
    } else {
        this.valpha = 1;
        var keys = Object.keys(obj);
        if ("alpha" in obj) {
            keys.splice(keys.indexOf("alpha"), 1);
            this.valpha = typeof obj.alpha === "number" ? obj.alpha : 0;
        }
        var hashedKeys = keys.sort().join("");
        if (!(hashedKeys in $366d7e75857fe306$var$hashedModelKeys)) throw new Error("Unable to parse color from object: " + JSON.stringify(obj));
        this.model = $366d7e75857fe306$var$hashedModelKeys[hashedKeys];
        var labels = $0f497461630e3c95$exports[this.model].labels;
        var color = [];
        for(i = 0; i < labels.length; i++)color.push(obj[labels[i]]);
        this.color = $366d7e75857fe306$var$zeroArray(color);
    }
    // perform limitations (clamping, etc.)
    if ($366d7e75857fe306$var$limiters[this.model]) {
        channels = $0f497461630e3c95$exports[this.model].channels;
        for(i = 0; i < channels; i++){
            var limit = $366d7e75857fe306$var$limiters[this.model][i];
            if (limit) this.color[i] = limit(this.color[i]);
        }
    }
    this.valpha = Math.max(0, Math.min(1, this.valpha));
    if (Object.freeze) Object.freeze(this);
}
$366d7e75857fe306$var$Color.prototype = {
    toString: function() {
        return this.string();
    },
    toJSON: function() {
        return this[this.model]();
    },
    string: function(places) {
        var self = this.model in $c49a0977e70d9aa3$exports.to ? this : this.rgb();
        self = self.round(typeof places === "number" ? places : 1);
        var args = self.valpha === 1 ? self.color : self.color.concat(this.valpha);
        return $c49a0977e70d9aa3$exports.to[self.model](args);
    },
    percentString: function(places) {
        var self = this.rgb().round(typeof places === "number" ? places : 1);
        var args = self.valpha === 1 ? self.color : self.color.concat(this.valpha);
        return $c49a0977e70d9aa3$exports.to.rgb.percent(args);
    },
    array: function() {
        return this.valpha === 1 ? this.color.slice() : this.color.concat(this.valpha);
    },
    object: function() {
        var result = {};
        var channels = $0f497461630e3c95$exports[this.model].channels;
        var labels = $0f497461630e3c95$exports[this.model].labels;
        for(var i = 0; i < channels; i++)result[labels[i]] = this.color[i];
        if (this.valpha !== 1) result.alpha = this.valpha;
        return result;
    },
    unitArray: function() {
        var rgb = this.rgb().color;
        rgb[0] /= 255;
        rgb[1] /= 255;
        rgb[2] /= 255;
        if (this.valpha !== 1) rgb.push(this.valpha);
        return rgb;
    },
    unitObject: function() {
        var rgb = this.rgb().object();
        rgb.r /= 255;
        rgb.g /= 255;
        rgb.b /= 255;
        if (this.valpha !== 1) rgb.alpha = this.valpha;
        return rgb;
    },
    round: function(places) {
        places = Math.max(places || 0, 0);
        return new $366d7e75857fe306$var$Color(this.color.map($366d7e75857fe306$var$roundToPlace(places)).concat(this.valpha), this.model);
    },
    alpha: function(val) {
        if (arguments.length) return new $366d7e75857fe306$var$Color(this.color.concat(Math.max(0, Math.min(1, val))), this.model);
        return this.valpha;
    },
    // rgb
    red: $366d7e75857fe306$var$getset("rgb", 0, $366d7e75857fe306$var$maxfn(255)),
    green: $366d7e75857fe306$var$getset("rgb", 1, $366d7e75857fe306$var$maxfn(255)),
    blue: $366d7e75857fe306$var$getset("rgb", 2, $366d7e75857fe306$var$maxfn(255)),
    hue: $366d7e75857fe306$var$getset([
        "hsl",
        "hsv",
        "hsl",
        "hwb",
        "hcg"
    ], 0, function(val) {
        return (val % 360 + 360) % 360;
    }),
    saturationl: $366d7e75857fe306$var$getset("hsl", 1, $366d7e75857fe306$var$maxfn(100)),
    lightness: $366d7e75857fe306$var$getset("hsl", 2, $366d7e75857fe306$var$maxfn(100)),
    saturationv: $366d7e75857fe306$var$getset("hsv", 1, $366d7e75857fe306$var$maxfn(100)),
    value: $366d7e75857fe306$var$getset("hsv", 2, $366d7e75857fe306$var$maxfn(100)),
    chroma: $366d7e75857fe306$var$getset("hcg", 1, $366d7e75857fe306$var$maxfn(100)),
    gray: $366d7e75857fe306$var$getset("hcg", 2, $366d7e75857fe306$var$maxfn(100)),
    white: $366d7e75857fe306$var$getset("hwb", 1, $366d7e75857fe306$var$maxfn(100)),
    wblack: $366d7e75857fe306$var$getset("hwb", 2, $366d7e75857fe306$var$maxfn(100)),
    cyan: $366d7e75857fe306$var$getset("cmyk", 0, $366d7e75857fe306$var$maxfn(100)),
    magenta: $366d7e75857fe306$var$getset("cmyk", 1, $366d7e75857fe306$var$maxfn(100)),
    yellow: $366d7e75857fe306$var$getset("cmyk", 2, $366d7e75857fe306$var$maxfn(100)),
    black: $366d7e75857fe306$var$getset("cmyk", 3, $366d7e75857fe306$var$maxfn(100)),
    x: $366d7e75857fe306$var$getset("xyz", 0, $366d7e75857fe306$var$maxfn(100)),
    y: $366d7e75857fe306$var$getset("xyz", 1, $366d7e75857fe306$var$maxfn(100)),
    z: $366d7e75857fe306$var$getset("xyz", 2, $366d7e75857fe306$var$maxfn(100)),
    l: $366d7e75857fe306$var$getset("lab", 0, $366d7e75857fe306$var$maxfn(100)),
    a: $366d7e75857fe306$var$getset("lab", 1),
    b: $366d7e75857fe306$var$getset("lab", 2),
    keyword: function(val) {
        if (arguments.length) return new $366d7e75857fe306$var$Color(val);
        return $0f497461630e3c95$exports[this.model].keyword(this.color);
    },
    hex: function(val) {
        if (arguments.length) return new $366d7e75857fe306$var$Color(val);
        return $c49a0977e70d9aa3$exports.to.hex(this.rgb().round().color);
    },
    rgbNumber: function() {
        var rgb = this.rgb().color;
        return (rgb[0] & 0xFF) << 16 | (rgb[1] & 0xFF) << 8 | rgb[2] & 0xFF;
    },
    luminosity: function() {
        // http://www.w3.org/TR/WCAG20/#relativeluminancedef
        var rgb = this.rgb().color;
        var lum = [];
        for(var i = 0; i < rgb.length; i++){
            var chan = rgb[i] / 255;
            lum[i] = chan <= 0.03928 ? chan / 12.92 : Math.pow((chan + 0.055) / 1.055, 2.4);
        }
        return 0.2126 * lum[0] + 0.7152 * lum[1] + 0.0722 * lum[2];
    },
    contrast: function(color2) {
        // http://www.w3.org/TR/WCAG20/#contrast-ratiodef
        var lum1 = this.luminosity();
        var lum2 = color2.luminosity();
        if (lum1 > lum2) return (lum1 + 0.05) / (lum2 + 0.05);
        return (lum2 + 0.05) / (lum1 + 0.05);
    },
    level: function(color2) {
        var contrastRatio = this.contrast(color2);
        if (contrastRatio >= 7.1) return "AAA";
        return contrastRatio >= 4.5 ? "AA" : "";
    },
    isDark: function() {
        // YIQ equation from http://24ways.org/2010/calculating-color-contrast
        var rgb = this.rgb().color;
        var yiq = (rgb[0] * 299 + rgb[1] * 587 + rgb[2] * 114) / 1000;
        return yiq < 128;
    },
    isLight: function() {
        return !this.isDark();
    },
    negate: function() {
        var rgb = this.rgb();
        for(var i = 0; i < 3; i++)rgb.color[i] = 255 - rgb.color[i];
        return rgb;
    },
    lighten: function(ratio) {
        var hsl = this.hsl();
        hsl.color[2] += hsl.color[2] * ratio;
        return hsl;
    },
    darken: function(ratio) {
        var hsl = this.hsl();
        hsl.color[2] -= hsl.color[2] * ratio;
        return hsl;
    },
    saturate: function(ratio) {
        var hsl = this.hsl();
        hsl.color[1] += hsl.color[1] * ratio;
        return hsl;
    },
    desaturate: function(ratio) {
        var hsl = this.hsl();
        hsl.color[1] -= hsl.color[1] * ratio;
        return hsl;
    },
    whiten: function(ratio) {
        var hwb = this.hwb();
        hwb.color[1] += hwb.color[1] * ratio;
        return hwb;
    },
    blacken: function(ratio) {
        var hwb = this.hwb();
        hwb.color[2] += hwb.color[2] * ratio;
        return hwb;
    },
    grayscale: function() {
        // http://en.wikipedia.org/wiki/Grayscale#Converting_color_to_grayscale
        var rgb = this.rgb().color;
        var val = rgb[0] * 0.3 + rgb[1] * 0.59 + rgb[2] * 0.11;
        return $366d7e75857fe306$var$Color.rgb(val, val, val);
    },
    fade: function(ratio) {
        return this.alpha(this.valpha - this.valpha * ratio);
    },
    opaquer: function(ratio) {
        return this.alpha(this.valpha + this.valpha * ratio);
    },
    rotate: function(degrees) {
        var hsl = this.hsl();
        var hue = hsl.color[0];
        hue = (hue + degrees) % 360;
        hue = hue < 0 ? 360 + hue : hue;
        hsl.color[0] = hue;
        return hsl;
    },
    mix: function(mixinColor, weight) {
        // ported from sass implementation in C
        // https://github.com/sass/libsass/blob/0e6b4a2850092356aa3ece07c6b249f0221caced/functions.cpp#L209
        if (!mixinColor || !mixinColor.rgb) throw new Error('Argument to "mix" was not a Color instance, but rather an instance of ' + typeof mixinColor);
        var color1 = mixinColor.rgb();
        var color2 = this.rgb();
        var p = weight === undefined ? 0.5 : weight;
        var w = 2 * p - 1;
        var a = color1.alpha() - color2.alpha();
        var w1 = ((w * a === -1 ? w : (w + a) / (1 + w * a)) + 1) / 2.0;
        var w2 = 1 - w1;
        return $366d7e75857fe306$var$Color.rgb(w1 * color1.red() + w2 * color2.red(), w1 * color1.green() + w2 * color2.green(), w1 * color1.blue() + w2 * color2.blue(), color1.alpha() * p + color2.alpha() * (1 - p));
    }
};
// model conversion methods and static constructors
Object.keys($0f497461630e3c95$exports).forEach(function(model) {
    if ($366d7e75857fe306$var$skippedModels.indexOf(model) !== -1) return;
    var channels = $0f497461630e3c95$exports[model].channels;
    // conversion methods
    $366d7e75857fe306$var$Color.prototype[model] = function() {
        if (this.model === model) return new $366d7e75857fe306$var$Color(this);
        if (arguments.length) return new $366d7e75857fe306$var$Color(arguments, model);
        var newAlpha = typeof arguments[channels] === "number" ? channels : this.valpha;
        return new $366d7e75857fe306$var$Color($366d7e75857fe306$var$assertArray($0f497461630e3c95$exports[this.model][model].raw(this.color)).concat(newAlpha), model);
    };
    // 'static' construction methods
    $366d7e75857fe306$var$Color[model] = function(color) {
        if (typeof color === "number") color = $366d7e75857fe306$var$zeroArray($366d7e75857fe306$var$_slice.call(arguments), channels);
        return new $366d7e75857fe306$var$Color(color, model);
    };
});
function $366d7e75857fe306$var$roundTo(num, places) {
    return Number(num.toFixed(places));
}
function $366d7e75857fe306$var$roundToPlace(places) {
    return function(num) {
        return $366d7e75857fe306$var$roundTo(num, places);
    };
}
function $366d7e75857fe306$var$getset(model, channel, modifier) {
    model = Array.isArray(model) ? model : [
        model
    ];
    model.forEach(function(m) {
        ($366d7e75857fe306$var$limiters[m] || ($366d7e75857fe306$var$limiters[m] = []))[channel] = modifier;
    });
    model = model[0];
    return function(val) {
        var result;
        if (arguments.length) {
            if (modifier) val = modifier(val);
            result = this[model]();
            result.color[channel] = val;
            return result;
        }
        result = this[model]().color[channel];
        if (modifier) result = modifier(result);
        return result;
    };
}
function $366d7e75857fe306$var$maxfn(max) {
    return function(v) {
        return Math.max(0, Math.min(max, v));
    };
}
function $366d7e75857fe306$var$assertArray(val) {
    return Array.isArray(val) ? val : [
        val
    ];
}
function $366d7e75857fe306$var$zeroArray(arr, length) {
    for(var i = 0; i < length; i++)if (typeof arr[i] !== "number") arr[i] = 0;
    return arr;
}
$366d7e75857fe306$exports = $366d7e75857fe306$var$Color;


function $03fa2a80882ee47c$export$2e2bcd8739ae039({ colorMain: colorMain, colorLight: colorLight, fontFamily: fontFamily, textDirection: textDirection }) {
    const greyscale = {
        50: "#FAFAFA",
        100: "#F7F7F7",
        200: "#EEEEEE",
        300: "#DFDFDF",
        350: "#BABFC0",
        400: "#939393",
        500: "#7F7F7F",
        600: "#6B6B6B",
        700: "#525252",
        800: "#393939",
        900: "#1C1C1C"
    };
    const clearSky = {
        main: "#00A8EE"
    };
    const autumn = {
        main: "#FF4E4E"
    };
    const summer = {
        main: "#FEBE36",
        extraLight: "#FFF8E8"
    };
    const spring = {
        main: "#6FC922"
    };
    const primaryColor = (0, (/*@__PURE__*/$parcel$interopDefault($366d7e75857fe306$exports)))(colorMain).hex();
    const primaryColorLight = colorLight ? (0, (/*@__PURE__*/$parcel$interopDefault($366d7e75857fe306$exports)))(colorLight).hex() : (0, (/*@__PURE__*/$parcel$interopDefault($366d7e75857fe306$exports)))(primaryColor).lighten(2.6).desaturate(0.3).hex();
    const primaryPalette = {
        main: primaryColor,
        extraLight: primaryColorLight
    };
    return (0, $elwbS.default)({
        direction: textDirection,
        palette: {
            white: "#ffffff",
            grey: greyscale,
            primary: {
                main: primaryPalette.main,
                extraLight: primaryPalette.extraLight
            },
            secondary: clearSky,
            error: autumn,
            success: spring,
            warning: summer
        },
        breakpoints: {
            values: {
                xs: 0,
                sm: 600,
                md: 930,
                xl: 1280
            }
        },
        spacing: 10,
        typography: {
            fontFamily: fontFamily,
            h1: {
                fontWeight: 600,
                fontSize: 16,
                color: greyscale[700],
                lineHeight: "22px"
            },
            h2: {
                color: greyscale[700],
                fontWeight: 600,
                fontSize: 26,
                lineHeight: "36px",
                marginBottom: 28,
                position: "relative",
                textAlign: "center",
                '&[underline="true"]': {
                    paddingBottom: 28,
                    "&:after": {
                        display: "block",
                        content: '""',
                        position: "absolute",
                        width: 96,
                        height: 4,
                        borderRadius: 2,
                        backgroundColor: primaryPalette.main,
                        left: 0,
                        right: 0,
                        bottom: 0,
                        margin: "0 auto"
                    }
                }
            },
            h3: {
                fontWeight: 400,
                fontSize: 16,
                color: greyscale[800],
                lineHeight: 1.8
            },
            h4: {
                fontWeight: 500,
                fontSize: 16,
                marginBottom: 50,
                color: greyscale[800],
                lineHeight: 1.6
            },
            h5: {
                fontWeight: 400,
                fontSize: 16,
                color: greyscale[700],
                lineHeight: "16px"
            },
            body1: {
                fontSize: 16,
                marginBottom: 20
            },
            body2: {
                fontWeight: 500,
                fontSize: 13,
                color: greyscale[600],
                lineHeight: 1.6
            }
        },
        overrides: {
            MuiButton: {
                root: {
                    fontSize: 16,
                    margin: "5px 0",
                    minHeight: "48px",
                    minWidth: "100px",
                    borderRadius: "4px",
                    textTransform: "none",
                    "&$disabled": {
                        borderColor: "#eee",
                        backgroundColor: "#eee",
                        color: greyscale[400]
                    },
                    "&:hover": {
                        "background-color": primaryPalette.extraLight
                    }
                },
                text: {
                    color: primaryPalette.main,
                    backgroundColor: "transparent",
                    "&:focus": {
                        backgroundColor: primaryPalette.extraLight
                    }
                },
                outlined: {
                    border: `1px solid ${primaryPalette.main}`,
                    backgroundColor: "transparent"
                },
                contained: {
                    backgroundColor: "white",
                    color: greyscale[600],
                    boxShadow: "0 1px 2px 0 rgba(0,0,0,0.24)"
                },
                containedPrimary: {
                    color: "white",
                    backgroundColor: primaryPalette.main,
                    "@media (hover: none)": {
                        "&:hover": {
                            backgroundColor: "inherit"
                        }
                    }
                },
                sizeSmall: {
                    padding: "8px 12px",
                    fontWeight: 600,
                    margin: 0,
                    minHeight: 0,
                    "& svg": {
                        fontSize: "20px"
                    }
                },
                disabled: {}
            },
            MuiLinearProgress: {
                root: {
                    width: "100%",
                    backgroundColor: primaryPalette.extraLight,
                    "border-radius": "5px",
                    "box-shadow": "inset 0px 2px 0px rgba(0,0,0,0.1)",
                    height: "10px"
                },
                bar: {
                    backgroundColor: primaryPalette.main,
                    "border-radius": "5px"
                }
            },
            MuiListItem: {
                root: {
                    backgroundColor: "#fff"
                },
                divider: {
                    borderBottom: "1px solid rgb(223, 222, 222)"
                },
                button: {
                    "&:hover": {
                        backgroundColor: greyscale[100]
                    }
                }
            },
            MuiInput: {
                root: {
                    "&:after, &:before": {
                        display: "none"
                    }
                }
            },
            MuiInputBase: {
                root: {
                    lineHeight: "24px",
                    "&$disabled": {
                        boxShadow: "none !important"
                    },
                    "&$error": {
                        borderColor: `${autumn.main} !important`
                    }
                },
                input: {
                    boxSizing: "border-box"
                }
            },
            MuiSelect: {
                root: {
                    height: "100%"
                },
                selectMenu: {
                    height: "100%",
                    display: "flex",
                    alignItems: "center",
                    padding: 16
                },
                select: {
                    width: "100%",
                    height: "100%",
                    paddingLeft: 16
                }
            },
            MuiRadio: {
                colorSecondary: {
                    color: primaryPalette.main,
                    "&.Mui-checked": {
                        color: primaryPalette.main
                    }
                }
            },
            MuiCheckbox: {
                colorSecondary: {
                    color: primaryPalette.main,
                    "&.Mui-checked": {
                        color: primaryPalette.main
                    }
                }
            },
            MuiFormControl: {
                root: {
                    width: "100%",
                    "& > div:not(label)": {
                        // This is essentially just the input component inside the `FromControl`.
                        marginTop: "24px",
                        border: `1px solid ${greyscale[350]}`,
                        borderRadius: 4,
                        height: 48,
                        overflow: "hidden",
                        "& > input": {
                            width: "100%",
                            height: "100%",
                            padding: "0 16px",
                            border: "none",
                            background: "transparent",
                            "&:focus": {
                                background: "rgba(0, 0, 0, 0.05)"
                            }
                        }
                    },
                    "& > label": {
                        color: `${greyscale[700]} !important`,
                        width: "130%"
                    }
                }
            },
            MuiFormHelperText: {
                root: {
                    color: autumn.main,
                    marginTop: -15
                }
            },
            MuiTypography: {
                gutterBottom: {
                    marginBottom: "1em"
                }
            }
        }
    });
}



var $7b1Lp = parcelRequire("7b1Lp");

var $cQNHH = parcelRequire("cQNHH");

var $IPPAR = parcelRequire("IPPAR");
/* eslint-disable react/prop-types */ 
var $iCH0W = parcelRequire("iCH0W");
var $1krVc = parcelRequire("1krVc");

var $ipwm3 = parcelRequire("ipwm3");
var $cbcf587276a09605$exports = {};
"use strict";
Object.defineProperty($cbcf587276a09605$exports, "__esModule", {
    value: true
});
var $5633fe0b92143340$exports = {};

$parcel$defineInteropFlag($5633fe0b92143340$exports);

$parcel$export($5633fe0b92143340$exports, "default", function () { return $5633fe0b92143340$export$2e2bcd8739ae039; });
/**
 * Takes an array of [keyValue1, keyValue2] pairs and creates an object of {keyValue1: keyValue2, keyValue2: keyValue1}
 * @param {Array} array the array of pairs
 * @return {Object} the {key, value} pair object
 */ function $1a7d5cdda8bc4e95$export$2d1720544b23b823(array) {
    return array.reduce(function(obj, _ref) {
        var prop1 = _ref[0], prop2 = _ref[1];
        obj[prop1] = prop2;
        obj[prop2] = prop1;
        return obj;
    }, {});
}
function $1a7d5cdda8bc4e95$export$953cecd6e717a553(val) {
    return typeof val === "boolean";
}
function $1a7d5cdda8bc4e95$export$7ccc53e8f1e7dfc5(val) {
    return typeof val === "function";
}
function $1a7d5cdda8bc4e95$export$9e5f44173e64f162(val) {
    return typeof val === "number";
}
function $1a7d5cdda8bc4e95$export$ae1af26003f05816(val) {
    return val === null || typeof val === "undefined";
}
function $1a7d5cdda8bc4e95$export$43caf9889c228507(val) {
    return val && typeof val === "object";
}
function $1a7d5cdda8bc4e95$export$2408f22a0fab9ae5(val) {
    return typeof val === "string";
}
function $1a7d5cdda8bc4e95$export$882b5998b3b9117c(inclusive, inclusee) {
    return inclusive.indexOf(inclusee) !== -1;
}
/**
 * Flip the sign of a CSS value, possibly with a unit.
 *
 * We can't just negate the value with unary minus due to the units.
 *
 * @private
 * @param {String} value - the original value (for example 77%)
 * @return {String} the result (for example -77%)
 */ function $1a7d5cdda8bc4e95$export$35e795649ee09318(value) {
    if (parseFloat(value) === 0) // Don't mangle zeroes
    return value;
    if (value[0] === "-") return value.slice(1);
    return "-" + value;
}
function $1a7d5cdda8bc4e95$export$23f2a1d2818174ef(match, prefix, offset, suffix) {
    return prefix + $1a7d5cdda8bc4e95$export$35e795649ee09318(offset) + suffix;
}
/**
 * Takes a percentage for background position and inverts it.
 * This was copied and modified from CSSJanus:
 * https://github.com/cssjanus/cssjanus/blob/4245f834365f6cfb0239191a151432fb85abab23/src/cssjanus.js#L152-L175
 * @param {String} value - the original value (for example 77%)
 * @return {String} the result (for example 23%)
 */ function $1a7d5cdda8bc4e95$export$dda1d9f60106f0e9(value) {
    var idx = value.indexOf(".");
    if (idx === -1) value = 100 - parseFloat(value) + "%";
    else {
        // Two off, one for the "%" at the end, one for the dot itself
        var len = value.length - idx - 2;
        value = 100 - parseFloat(value);
        value = value.toFixed(len) + "%";
    }
    return value;
}
/**
 * This takes a list of CSS values and converts it to an array
 * @param {String} value - something like `1px`, `1px 2em`, or `3pt rgb(150, 230, 550) 40px calc(100% - 5px)`
 * @return {Array} the split values (for example: `['3pt', 'rgb(150, 230, 550)', '40px', 'calc(100% - 5px)']`)
 */ function $1a7d5cdda8bc4e95$export$625550452a3fa3ec(value) {
    return value.replace(/ +/g, " ") // remove all extraneous spaces
    .split(" ").map(function(i) {
        return i.trim();
    }) // get rid of extra space before/after each item
    .filter(Boolean) // get rid of empty strings
    // join items which are within parenthese
    // luckily `calc (100% - 5px)` is invalid syntax and it must be `calc(100% - 5px)`, otherwise this would be even more complex
    .reduce(function(_ref2, item) {
        var list = _ref2.list, state = _ref2.state;
        var openParansCount = (item.match(/\(/g) || []).length;
        var closedParansCount = (item.match(/\)/g) || []).length;
        if (state.parensDepth > 0) list[list.length - 1] = list[list.length - 1] + " " + item;
        else list.push(item);
        state.parensDepth += openParansCount - closedParansCount;
        return {
            list: list,
            state: state
        };
    }, {
        list: [],
        state: {
            parensDepth: 0
        }
    }).list;
}
/**
 * This is intended for properties that are `top right bottom left` and will switch them to `top left bottom right`
 * @param {String} value - `1px 2px 3px 4px` for example, but also handles cases where there are too few/too many and
 * simply returns the value in those cases (which is the correct behavior)
 * @return {String} the result - `1px 4px 3px 2px` for example.
 */ function $1a7d5cdda8bc4e95$export$342063e11d6c3cad(value) {
    var splitValues = $1a7d5cdda8bc4e95$export$625550452a3fa3ec(value);
    if (splitValues.length <= 3 || splitValues.length > 4) return value;
    var top = splitValues[0], right = splitValues[1], bottom = splitValues[2], left = splitValues[3];
    return [
        top,
        left,
        bottom,
        right
    ].join(" ");
}
var $1a7d5cdda8bc4e95$export$ffb5f4729a158638 = {
    padding: function padding(_ref) {
        var value = _ref.value;
        if ($1a7d5cdda8bc4e95$export$9e5f44173e64f162(value)) return value;
        return $1a7d5cdda8bc4e95$export$342063e11d6c3cad(value);
    },
    textShadow: function textShadow(_ref2) {
        var value = _ref2.value;
        // intentionally leaving off the `g` flag here because we only want to change the first number (which is the offset-x)
        return value.replace(/(-*)([.|\d]+)/, function(match, negative, number) {
            if (number === "0") return match;
            var doubleNegative = negative === "" ? "-" : "";
            return "" + doubleNegative + number;
        });
    },
    borderColor: function borderColor(_ref3) {
        var value = _ref3.value;
        return $1a7d5cdda8bc4e95$export$342063e11d6c3cad(value);
    },
    borderRadius: function borderRadius(_ref4) {
        var value = _ref4.value;
        if ($1a7d5cdda8bc4e95$export$9e5f44173e64f162(value)) return value;
        if ($1a7d5cdda8bc4e95$export$882b5998b3b9117c(value, "/")) {
            var _value$split = value.split("/"), radius1 = _value$split[0], radius2 = _value$split[1];
            var convertedRadius1 = $1a7d5cdda8bc4e95$export$ffb5f4729a158638.borderRadius({
                value: radius1.trim()
            });
            var convertedRadius2 = $1a7d5cdda8bc4e95$export$ffb5f4729a158638.borderRadius({
                value: radius2.trim()
            });
            return convertedRadius1 + " / " + convertedRadius2;
        }
        var splitValues = $1a7d5cdda8bc4e95$export$625550452a3fa3ec(value);
        switch(splitValues.length){
            case 2:
                return splitValues.reverse().join(" ");
            case 4:
                var topLeft = splitValues[0], topRight = splitValues[1], bottomRight = splitValues[2], bottomLeft = splitValues[3];
                return [
                    topRight,
                    topLeft,
                    bottomLeft,
                    bottomRight
                ].join(" ");
            default:
                return value;
        }
    },
    background: function background(_ref5) {
        var value = _ref5.value, valuesToConvert = _ref5.valuesToConvert, isRtl = _ref5.isRtl, bgImgDirectionRegex = _ref5.bgImgDirectionRegex, bgPosDirectionRegex = _ref5.bgPosDirectionRegex;
        if ($1a7d5cdda8bc4e95$export$9e5f44173e64f162(value)) return value;
         // Yeah, this is in need of a refactor 🙃...
        // but this property is a tough cookie 🍪
        // get the backgroundPosition out of the string by removing everything that couldn't be the backgroundPosition value
        var backgroundPositionValue = value.replace(/(url\(.*?\))|(rgba?\(.*?\))|(hsl\(.*?\))|(#[a-fA-F0-9]+)|((^| )(\D)+( |$))/g, "").trim(); // replace that backgroundPosition value with the converted version
        value = value.replace(backgroundPositionValue, $1a7d5cdda8bc4e95$export$ffb5f4729a158638.backgroundPosition({
            value: backgroundPositionValue,
            valuesToConvert: valuesToConvert,
            isRtl: isRtl,
            bgPosDirectionRegex: bgPosDirectionRegex
        })); // do the backgroundImage value replacing on the whole value (because why not?)
        return $1a7d5cdda8bc4e95$export$ffb5f4729a158638.backgroundImage({
            value: value,
            valuesToConvert: valuesToConvert,
            bgImgDirectionRegex: bgImgDirectionRegex
        });
    },
    backgroundImage: function backgroundImage(_ref6) {
        var value = _ref6.value, valuesToConvert = _ref6.valuesToConvert, bgImgDirectionRegex = _ref6.bgImgDirectionRegex;
        if (!$1a7d5cdda8bc4e95$export$882b5998b3b9117c(value, "url(") && !$1a7d5cdda8bc4e95$export$882b5998b3b9117c(value, "linear-gradient(")) return value;
        return value.replace(bgImgDirectionRegex, function(match, g1, group2) {
            return match.replace(group2, valuesToConvert[group2]);
        });
    },
    backgroundPosition: function backgroundPosition(_ref7) {
        var value = _ref7.value, valuesToConvert = _ref7.valuesToConvert, isRtl = _ref7.isRtl, bgPosDirectionRegex = _ref7.bgPosDirectionRegex;
        return value // intentionally only grabbing the first instance of this because that represents `left`
        .replace(isRtl ? /^((-|\d|\.)+%)/ : null, function(match, group) {
            return $1a7d5cdda8bc4e95$export$dda1d9f60106f0e9(group);
        }).replace(bgPosDirectionRegex, function(match) {
            return valuesToConvert[match];
        });
    },
    backgroundPositionX: function backgroundPositionX(_ref8) {
        var value = _ref8.value, valuesToConvert = _ref8.valuesToConvert, isRtl = _ref8.isRtl, bgPosDirectionRegex = _ref8.bgPosDirectionRegex;
        if ($1a7d5cdda8bc4e95$export$9e5f44173e64f162(value)) return value;
        return $1a7d5cdda8bc4e95$export$ffb5f4729a158638.backgroundPosition({
            value: value,
            valuesToConvert: valuesToConvert,
            isRtl: isRtl,
            bgPosDirectionRegex: bgPosDirectionRegex
        });
    },
    transition: function transition(_ref9) {
        var value = _ref9.value, propertiesToConvert = _ref9.propertiesToConvert;
        return value.split(/,\s*/g).map(function(transition) {
            var values = transition.split(" "); // Property is always defined first
            values[0] = propertiesToConvert[values[0]] || values[0];
            return values.join(" ");
        }).join(", ");
    },
    transitionProperty: function transitionProperty(_ref10) {
        var value = _ref10.value, propertiesToConvert = _ref10.propertiesToConvert;
        return value.split(/,\s*/g).map(function(prop) {
            return propertiesToConvert[prop] || prop;
        }).join(", ");
    },
    transform: function transform(_ref11) {
        var value = _ref11.value;
        // This was copied and modified from CSSJanus:
        // https://github.com/cssjanus/cssjanus/blob/4a40f001b1ba35567112d8b8e1d9d95eda4234c3/src/cssjanus.js#L152-L153
        var nonAsciiPattern = "[^\\u0020-\\u007e]";
        var escapePattern = "(?:(?:(?:\\[0-9a-f]{1,6})(?:\\r\\n|\\s)?)|\\\\[^\\r\\n\\f0-9a-f])";
        var signedQuantPattern = "((?:-?" + ("(?:[0-9]*\\.[0-9]+|[0-9]+)(?:\\s*(?:em|ex|px|cm|mm|in|pt|pc|deg|rad|grad|ms|s|hz|khz|%)|" + ("-?" + ("(?:[_a-z]|" + nonAsciiPattern + "|" + escapePattern + ")") + ("(?:[_a-z0-9-]|" + nonAsciiPattern + "|" + escapePattern + ")") + "*") + ")?") + ")|(?:inherit|auto))";
        var translateXRegExp = new RegExp("(translateX\\s*\\(\\s*)" + signedQuantPattern + "(\\s*\\))", "gi");
        var translateRegExp = new RegExp("(translate\\s*\\(\\s*)" + signedQuantPattern + "((?:\\s*,\\s*" + signedQuantPattern + "){0,1}\\s*\\))", "gi");
        var translate3dRegExp = new RegExp("(translate3d\\s*\\(\\s*)" + signedQuantPattern + "((?:\\s*,\\s*" + signedQuantPattern + "){0,2}\\s*\\))", "gi");
        var rotateRegExp = new RegExp("(rotate[ZY]?\\s*\\(\\s*)" + signedQuantPattern + "(\\s*\\))", "gi");
        return value.replace(translateXRegExp, $1a7d5cdda8bc4e95$export$23f2a1d2818174ef).replace(translateRegExp, $1a7d5cdda8bc4e95$export$23f2a1d2818174ef).replace(translate3dRegExp, $1a7d5cdda8bc4e95$export$23f2a1d2818174ef).replace(rotateRegExp, $1a7d5cdda8bc4e95$export$23f2a1d2818174ef);
    }
};
$1a7d5cdda8bc4e95$export$ffb5f4729a158638.objectPosition = $1a7d5cdda8bc4e95$export$ffb5f4729a158638.backgroundPosition;
$1a7d5cdda8bc4e95$export$ffb5f4729a158638.margin = $1a7d5cdda8bc4e95$export$ffb5f4729a158638.padding;
$1a7d5cdda8bc4e95$export$ffb5f4729a158638.borderWidth = $1a7d5cdda8bc4e95$export$ffb5f4729a158638.padding;
$1a7d5cdda8bc4e95$export$ffb5f4729a158638.boxShadow = $1a7d5cdda8bc4e95$export$ffb5f4729a158638.textShadow;
$1a7d5cdda8bc4e95$export$ffb5f4729a158638.webkitBoxShadow = $1a7d5cdda8bc4e95$export$ffb5f4729a158638.boxShadow;
$1a7d5cdda8bc4e95$export$ffb5f4729a158638.mozBoxShadow = $1a7d5cdda8bc4e95$export$ffb5f4729a158638.boxShadow;
$1a7d5cdda8bc4e95$export$ffb5f4729a158638.WebkitBoxShadow = $1a7d5cdda8bc4e95$export$ffb5f4729a158638.boxShadow;
$1a7d5cdda8bc4e95$export$ffb5f4729a158638.MozBoxShadow = $1a7d5cdda8bc4e95$export$ffb5f4729a158638.boxShadow;
$1a7d5cdda8bc4e95$export$ffb5f4729a158638.borderStyle = $1a7d5cdda8bc4e95$export$ffb5f4729a158638.borderColor;
$1a7d5cdda8bc4e95$export$ffb5f4729a158638.webkitTransform = $1a7d5cdda8bc4e95$export$ffb5f4729a158638.transform;
$1a7d5cdda8bc4e95$export$ffb5f4729a158638.mozTransform = $1a7d5cdda8bc4e95$export$ffb5f4729a158638.transform;
$1a7d5cdda8bc4e95$export$ffb5f4729a158638.WebkitTransform = $1a7d5cdda8bc4e95$export$ffb5f4729a158638.transform;
$1a7d5cdda8bc4e95$export$ffb5f4729a158638.MozTransform = $1a7d5cdda8bc4e95$export$ffb5f4729a158638.transform;
$1a7d5cdda8bc4e95$export$ffb5f4729a158638.transformOrigin = $1a7d5cdda8bc4e95$export$ffb5f4729a158638.backgroundPosition;
$1a7d5cdda8bc4e95$export$ffb5f4729a158638.webkitTransformOrigin = $1a7d5cdda8bc4e95$export$ffb5f4729a158638.transformOrigin;
$1a7d5cdda8bc4e95$export$ffb5f4729a158638.mozTransformOrigin = $1a7d5cdda8bc4e95$export$ffb5f4729a158638.transformOrigin;
$1a7d5cdda8bc4e95$export$ffb5f4729a158638.WebkitTransformOrigin = $1a7d5cdda8bc4e95$export$ffb5f4729a158638.transformOrigin;
$1a7d5cdda8bc4e95$export$ffb5f4729a158638.MozTransformOrigin = $1a7d5cdda8bc4e95$export$ffb5f4729a158638.transformOrigin;
$1a7d5cdda8bc4e95$export$ffb5f4729a158638.webkitTransition = $1a7d5cdda8bc4e95$export$ffb5f4729a158638.transition;
$1a7d5cdda8bc4e95$export$ffb5f4729a158638.mozTransition = $1a7d5cdda8bc4e95$export$ffb5f4729a158638.transition;
$1a7d5cdda8bc4e95$export$ffb5f4729a158638.WebkitTransition = $1a7d5cdda8bc4e95$export$ffb5f4729a158638.transition;
$1a7d5cdda8bc4e95$export$ffb5f4729a158638.MozTransition = $1a7d5cdda8bc4e95$export$ffb5f4729a158638.transition;
$1a7d5cdda8bc4e95$export$ffb5f4729a158638.webkitTransitionProperty = $1a7d5cdda8bc4e95$export$ffb5f4729a158638.transitionProperty;
$1a7d5cdda8bc4e95$export$ffb5f4729a158638.mozTransitionProperty = $1a7d5cdda8bc4e95$export$ffb5f4729a158638.transitionProperty;
$1a7d5cdda8bc4e95$export$ffb5f4729a158638.WebkitTransitionProperty = $1a7d5cdda8bc4e95$export$ffb5f4729a158638.transitionProperty;
$1a7d5cdda8bc4e95$export$ffb5f4729a158638.MozTransitionProperty = $1a7d5cdda8bc4e95$export$ffb5f4729a158638.transitionProperty; // kebab-case versions
$1a7d5cdda8bc4e95$export$ffb5f4729a158638["text-shadow"] = $1a7d5cdda8bc4e95$export$ffb5f4729a158638.textShadow;
$1a7d5cdda8bc4e95$export$ffb5f4729a158638["border-color"] = $1a7d5cdda8bc4e95$export$ffb5f4729a158638.borderColor;
$1a7d5cdda8bc4e95$export$ffb5f4729a158638["border-radius"] = $1a7d5cdda8bc4e95$export$ffb5f4729a158638.borderRadius;
$1a7d5cdda8bc4e95$export$ffb5f4729a158638["background-image"] = $1a7d5cdda8bc4e95$export$ffb5f4729a158638.backgroundImage;
$1a7d5cdda8bc4e95$export$ffb5f4729a158638["background-position"] = $1a7d5cdda8bc4e95$export$ffb5f4729a158638.backgroundPosition;
$1a7d5cdda8bc4e95$export$ffb5f4729a158638["background-position-x"] = $1a7d5cdda8bc4e95$export$ffb5f4729a158638.backgroundPositionX;
$1a7d5cdda8bc4e95$export$ffb5f4729a158638["object-position"] = $1a7d5cdda8bc4e95$export$ffb5f4729a158638.objectPosition;
$1a7d5cdda8bc4e95$export$ffb5f4729a158638["border-width"] = $1a7d5cdda8bc4e95$export$ffb5f4729a158638.padding;
$1a7d5cdda8bc4e95$export$ffb5f4729a158638["box-shadow"] = $1a7d5cdda8bc4e95$export$ffb5f4729a158638.textShadow;
$1a7d5cdda8bc4e95$export$ffb5f4729a158638["-webkit-box-shadow"] = $1a7d5cdda8bc4e95$export$ffb5f4729a158638.textShadow;
$1a7d5cdda8bc4e95$export$ffb5f4729a158638["-moz-box-shadow"] = $1a7d5cdda8bc4e95$export$ffb5f4729a158638.textShadow;
$1a7d5cdda8bc4e95$export$ffb5f4729a158638["border-style"] = $1a7d5cdda8bc4e95$export$ffb5f4729a158638.borderColor;
$1a7d5cdda8bc4e95$export$ffb5f4729a158638["-webkit-transform"] = $1a7d5cdda8bc4e95$export$ffb5f4729a158638.transform;
$1a7d5cdda8bc4e95$export$ffb5f4729a158638["-moz-transform"] = $1a7d5cdda8bc4e95$export$ffb5f4729a158638.transform;
$1a7d5cdda8bc4e95$export$ffb5f4729a158638["transform-origin"] = $1a7d5cdda8bc4e95$export$ffb5f4729a158638.transformOrigin;
$1a7d5cdda8bc4e95$export$ffb5f4729a158638["-webkit-transform-origin"] = $1a7d5cdda8bc4e95$export$ffb5f4729a158638.transformOrigin;
$1a7d5cdda8bc4e95$export$ffb5f4729a158638["-moz-transform-origin"] = $1a7d5cdda8bc4e95$export$ffb5f4729a158638.transformOrigin;
$1a7d5cdda8bc4e95$export$ffb5f4729a158638["-webkit-transition"] = $1a7d5cdda8bc4e95$export$ffb5f4729a158638.transition;
$1a7d5cdda8bc4e95$export$ffb5f4729a158638["-moz-transition"] = $1a7d5cdda8bc4e95$export$ffb5f4729a158638.transition;
$1a7d5cdda8bc4e95$export$ffb5f4729a158638["transition-property"] = $1a7d5cdda8bc4e95$export$ffb5f4729a158638.transitionProperty;
$1a7d5cdda8bc4e95$export$ffb5f4729a158638["-webkit-transition-property"] = $1a7d5cdda8bc4e95$export$ffb5f4729a158638.transitionProperty;
$1a7d5cdda8bc4e95$export$ffb5f4729a158638["-moz-transition-property"] = $1a7d5cdda8bc4e95$export$ffb5f4729a158638.transitionProperty;
var $1a7d5cdda8bc4e95$export$407448d2b89b1813 = $1a7d5cdda8bc4e95$export$2d1720544b23b823([
    [
        "paddingLeft",
        "paddingRight"
    ],
    [
        "marginLeft",
        "marginRight"
    ],
    [
        "left",
        "right"
    ],
    [
        "borderLeft",
        "borderRight"
    ],
    [
        "borderLeftColor",
        "borderRightColor"
    ],
    [
        "borderLeftStyle",
        "borderRightStyle"
    ],
    [
        "borderLeftWidth",
        "borderRightWidth"
    ],
    [
        "borderTopLeftRadius",
        "borderTopRightRadius"
    ],
    [
        "borderBottomLeftRadius",
        "borderBottomRightRadius"
    ],
    [
        "padding-left",
        "padding-right"
    ],
    [
        "margin-left",
        "margin-right"
    ],
    [
        "border-left",
        "border-right"
    ],
    [
        "border-left-color",
        "border-right-color"
    ],
    [
        "border-left-style",
        "border-right-style"
    ],
    [
        "border-left-width",
        "border-right-width"
    ],
    [
        "border-top-left-radius",
        "border-top-right-radius"
    ],
    [
        "border-bottom-left-radius",
        "border-bottom-right-radius"
    ]
]);
var $1a7d5cdda8bc4e95$export$8b22cf2602fb60ce = [
    "content"
]; // this is the same as the propertiesToConvert except for values
var $1a7d5cdda8bc4e95$export$90a7f3efeed30595 = $1a7d5cdda8bc4e95$export$2d1720544b23b823([
    [
        "ltr",
        "rtl"
    ],
    [
        "left",
        "right"
    ],
    [
        "w-resize",
        "e-resize"
    ],
    [
        "sw-resize",
        "se-resize"
    ],
    [
        "nw-resize",
        "ne-resize"
    ]
]); // Sorry for the regex 😞, but basically thisis used to replace _every_ instance of
// `ltr`, `rtl`, `right`, and `left` in `backgroundimage` with the corresponding opposite.
// A situation we're accepting here:
// url('/left/right/rtl/ltr.png') will be changed to url('/right/left/ltr/rtl.png')
// Definite trade-offs here, but I think it's a good call.
var $1a7d5cdda8bc4e95$var$bgImgDirectionRegex = new RegExp("(^|\\W|_)((ltr)|(rtl)|(left)|(right))(\\W|_|$)", "g");
var $1a7d5cdda8bc4e95$var$bgPosDirectionRegex = new RegExp("(left)|(right)");
/**
 * converts properties and values in the CSS in JS object to their corresponding RTL values
 * @param {Object} object the CSS in JS object
 * @return {Object} the RTL converted object
 */ function $1a7d5cdda8bc4e95$export$db3b6bfb95261072(object) {
    return Object.keys(object).reduce(function(newObj, originalKey) {
        var originalValue = object[originalKey];
        if ($1a7d5cdda8bc4e95$export$2408f22a0fab9ae5(originalValue)) // you're welcome to later code 😺
        originalValue = originalValue.trim();
         // Some properties should never be transformed
        if ($1a7d5cdda8bc4e95$export$882b5998b3b9117c($1a7d5cdda8bc4e95$export$8b22cf2602fb60ce, originalKey)) {
            newObj[originalKey] = originalValue;
            return newObj;
        }
        var _convertProperty = $1a7d5cdda8bc4e95$export$4368d992c4eafac0(originalKey, originalValue), key = _convertProperty.key, value = _convertProperty.value;
        newObj[key] = value;
        return newObj;
    }, Array.isArray(object) ? [] : {});
}
/**
 * Converts a property and its value to the corresponding RTL key and value
 * @param {String} originalKey the original property key
 * @param {Number|String|Object} originalValue the original css property value
 * @return {Object} the new {key, value} pair
 */ function $1a7d5cdda8bc4e95$export$4368d992c4eafac0(originalKey, originalValue) {
    var isNoFlip = /\/\*\s?@noflip\s?\*\//.test(originalValue);
    var key = isNoFlip ? originalKey : $1a7d5cdda8bc4e95$export$39b482c5e57630a8(originalKey);
    var value = isNoFlip ? originalValue : $1a7d5cdda8bc4e95$export$f1e1789686576879(key, originalValue);
    return {
        key: key,
        value: value
    };
}
/**
 * This gets the RTL version of the given property if it has a corresponding RTL property
 * @param {String} property the name of the property
 * @return {String} the name of the RTL property
 */ function $1a7d5cdda8bc4e95$export$39b482c5e57630a8(property) {
    return $1a7d5cdda8bc4e95$export$407448d2b89b1813[property] || property;
}
/**
 * This converts the given value to the RTL version of that value based on the key
 * @param {String} key this is the key (note: this should be the RTL version of the originalKey)
 * @param {String|Number|Object} originalValue the original css property value. If it's an object, then we'll convert that as well
 * @return {String|Number|Object} the converted value
 */ function $1a7d5cdda8bc4e95$export$f1e1789686576879(key, originalValue) {
    /* eslint complexity:[2, 10] */ // let's try to keep the complexity down... If we have to do this much more, let's break this up
    if ($1a7d5cdda8bc4e95$export$ae1af26003f05816(originalValue) || $1a7d5cdda8bc4e95$export$953cecd6e717a553(originalValue)) return originalValue;
    if ($1a7d5cdda8bc4e95$export$43caf9889c228507(originalValue)) return $1a7d5cdda8bc4e95$export$db3b6bfb95261072(originalValue); // recurssion 🌀
    var isNum = $1a7d5cdda8bc4e95$export$9e5f44173e64f162(originalValue);
    var isFunc = $1a7d5cdda8bc4e95$export$7ccc53e8f1e7dfc5(originalValue);
    var importantlessValue = isNum || isFunc ? originalValue : originalValue.replace(/ !important.*?$/, "");
    var isImportant = !isNum && importantlessValue.length !== originalValue.length;
    var valueConverter = $1a7d5cdda8bc4e95$export$ffb5f4729a158638[key];
    var newValue;
    if (valueConverter) newValue = valueConverter({
        value: importantlessValue,
        valuesToConvert: $1a7d5cdda8bc4e95$export$90a7f3efeed30595,
        propertiesToConvert: $1a7d5cdda8bc4e95$export$407448d2b89b1813,
        isRtl: true,
        bgImgDirectionRegex: $1a7d5cdda8bc4e95$var$bgImgDirectionRegex,
        bgPosDirectionRegex: $1a7d5cdda8bc4e95$var$bgPosDirectionRegex
    });
    else newValue = $1a7d5cdda8bc4e95$export$90a7f3efeed30595[importantlessValue] || importantlessValue;
    if (isImportant) return newValue + " !important";
    return newValue;
}


var $5633fe0b92143340$export$2e2bcd8739ae039 = (0, $1a7d5cdda8bc4e95$export$db3b6bfb95261072);


var $cbcf587276a09605$var$convert = $5633fe0b92143340$exports["default"] || $5633fe0b92143340$exports;
function $cbcf587276a09605$var$jssRTL(_a) {
    var _b = _a === void 0 ? {} : _a, _c = _b.enabled, enabled = _c === void 0 ? true : _c, _d = _b.opt, opt = _d === void 0 ? "out" : _d;
    return {
        onProcessStyle: function(style, rule, sheet) {
            if (rule.type === "font-face") return style;
            if (!enabled) {
                if (typeof style.flip === "boolean") delete style.flip;
                return style;
            }
            var flip = opt === "out"; // If it's set to opt-out, then it should flip by default
            if (typeof sheet.options.flip === "boolean") flip = sheet.options.flip;
            if (typeof style.flip === "boolean") {
                flip = style.flip;
                delete style.flip;
            }
            if (!flip) return style;
            return $cbcf587276a09605$var$convert(typeof rule.toJSON === "function" ? rule.toJSON() : style);
        }
    };
}
$cbcf587276a09605$exports.default = $cbcf587276a09605$var$jssRTL;



var $cQNHH = parcelRequire("cQNHH");
// Configure JSS
const $b93edc1652573c86$var$jss = (0, $ipwm3.create)({
    plugins: [
        ...(0, $iCH0W.default)().plugins,
        (0, (/*@__PURE__*/$parcel$interopDefault($cbcf587276a09605$exports)))()
    ]
});
function $b93edc1652573c86$export$2e2bcd8739ae039(props) {
    const { children: children } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement((0, $1krVc.default), {
        jss: $b93edc1652573c86$var$jss
    }, children);
}


var $8be7ad1126c1e5b2$export$2e2bcd8739ae039 = (0, $b93edc1652573c86$export$2e2bcd8739ae039);



var $8mLXY = parcelRequire("8mLXY");

var $7b1Lp = parcelRequire("7b1Lp");
var $c9fdafd6c40a8204$exports = {};
/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */ /** Used as the `TypeError` message for "Functions" methods. */ var $c9fdafd6c40a8204$var$FUNC_ERROR_TEXT = "Expected a function";
/** Used to stand-in for `undefined` hash values. */ var $c9fdafd6c40a8204$var$HASH_UNDEFINED = "__lodash_hash_undefined__";
/** Used as references for various `Number` constants. */ var $c9fdafd6c40a8204$var$INFINITY = 1 / 0;
/** `Object#toString` result references. */ var $c9fdafd6c40a8204$var$funcTag = "[object Function]", $c9fdafd6c40a8204$var$genTag = "[object GeneratorFunction]", $c9fdafd6c40a8204$var$symbolTag = "[object Symbol]";
/** Used to match property names within property paths. */ var $c9fdafd6c40a8204$var$reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, $c9fdafd6c40a8204$var$reIsPlainProp = /^\w*$/, $c9fdafd6c40a8204$var$reLeadingDot = /^\./, $c9fdafd6c40a8204$var$rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */ var $c9fdafd6c40a8204$var$reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
/** Used to match backslashes in property paths. */ var $c9fdafd6c40a8204$var$reEscapeChar = /\\(\\)?/g;
/** Used to detect host constructors (Safari). */ var $c9fdafd6c40a8204$var$reIsHostCtor = /^\[object .+?Constructor\]$/;
/** Detect free variable `global` from Node.js. */ var $c9fdafd6c40a8204$var$freeGlobal = typeof $parcel$global == "object" && $parcel$global && $parcel$global.Object === Object && $parcel$global;
/** Detect free variable `self`. */ var $c9fdafd6c40a8204$var$freeSelf = typeof self == "object" && self && self.Object === Object && self;
/** Used as a reference to the global object. */ var $c9fdafd6c40a8204$var$root = $c9fdafd6c40a8204$var$freeGlobal || $c9fdafd6c40a8204$var$freeSelf || Function("return this")();
/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */ function $c9fdafd6c40a8204$var$getValue(object, key) {
    return object == null ? undefined : object[key];
}
/**
 * Checks if `value` is a host object in IE < 9.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a host object, else `false`.
 */ function $c9fdafd6c40a8204$var$isHostObject(value) {
    // Many host objects are `Object` objects that can coerce to strings
    // despite having improperly defined `toString` methods.
    var result = false;
    if (value != null && typeof value.toString != "function") try {
        result = !!(value + "");
    } catch (e) {}
    return result;
}
/** Used for built-in method references. */ var $c9fdafd6c40a8204$var$arrayProto = Array.prototype, $c9fdafd6c40a8204$var$funcProto = Function.prototype, $c9fdafd6c40a8204$var$objectProto = Object.prototype;
/** Used to detect overreaching core-js shims. */ var $c9fdafd6c40a8204$var$coreJsData = $c9fdafd6c40a8204$var$root["__core-js_shared__"];
/** Used to detect methods masquerading as native. */ var $c9fdafd6c40a8204$var$maskSrcKey = function() {
    var uid = /[^.]+$/.exec($c9fdafd6c40a8204$var$coreJsData && $c9fdafd6c40a8204$var$coreJsData.keys && $c9fdafd6c40a8204$var$coreJsData.keys.IE_PROTO || "");
    return uid ? "Symbol(src)_1." + uid : "";
}();
/** Used to resolve the decompiled source of functions. */ var $c9fdafd6c40a8204$var$funcToString = $c9fdafd6c40a8204$var$funcProto.toString;
/** Used to check objects for own properties. */ var $c9fdafd6c40a8204$var$hasOwnProperty = $c9fdafd6c40a8204$var$objectProto.hasOwnProperty;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $c9fdafd6c40a8204$var$objectToString = $c9fdafd6c40a8204$var$objectProto.toString;
/** Used to detect if a method is native. */ var $c9fdafd6c40a8204$var$reIsNative = RegExp("^" + $c9fdafd6c40a8204$var$funcToString.call($c9fdafd6c40a8204$var$hasOwnProperty).replace($c9fdafd6c40a8204$var$reRegExpChar, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$");
/** Built-in value references. */ var $c9fdafd6c40a8204$var$Symbol = $c9fdafd6c40a8204$var$root.Symbol, $c9fdafd6c40a8204$var$splice = $c9fdafd6c40a8204$var$arrayProto.splice;
/* Built-in method references that are verified to be native. */ var $c9fdafd6c40a8204$var$Map = $c9fdafd6c40a8204$var$getNative($c9fdafd6c40a8204$var$root, "Map"), $c9fdafd6c40a8204$var$nativeCreate = $c9fdafd6c40a8204$var$getNative(Object, "create");
/** Used to convert symbols to primitives and strings. */ var $c9fdafd6c40a8204$var$symbolProto = $c9fdafd6c40a8204$var$Symbol ? $c9fdafd6c40a8204$var$Symbol.prototype : undefined, $c9fdafd6c40a8204$var$symbolToString = $c9fdafd6c40a8204$var$symbolProto ? $c9fdafd6c40a8204$var$symbolProto.toString : undefined;
/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $c9fdafd6c40a8204$var$Hash(entries) {
    var index = -1, length = entries ? entries.length : 0;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */ function $c9fdafd6c40a8204$var$hashClear() {
    this.__data__ = $c9fdafd6c40a8204$var$nativeCreate ? $c9fdafd6c40a8204$var$nativeCreate(null) : {};
}
/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $c9fdafd6c40a8204$var$hashDelete(key) {
    return this.has(key) && delete this.__data__[key];
}
/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $c9fdafd6c40a8204$var$hashGet(key) {
    var data = this.__data__;
    if ($c9fdafd6c40a8204$var$nativeCreate) {
        var result = data[key];
        return result === $c9fdafd6c40a8204$var$HASH_UNDEFINED ? undefined : result;
    }
    return $c9fdafd6c40a8204$var$hasOwnProperty.call(data, key) ? data[key] : undefined;
}
/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $c9fdafd6c40a8204$var$hashHas(key) {
    var data = this.__data__;
    return $c9fdafd6c40a8204$var$nativeCreate ? data[key] !== undefined : $c9fdafd6c40a8204$var$hasOwnProperty.call(data, key);
}
/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */ function $c9fdafd6c40a8204$var$hashSet(key, value) {
    var data = this.__data__;
    data[key] = $c9fdafd6c40a8204$var$nativeCreate && value === undefined ? $c9fdafd6c40a8204$var$HASH_UNDEFINED : value;
    return this;
}
// Add methods to `Hash`.
$c9fdafd6c40a8204$var$Hash.prototype.clear = $c9fdafd6c40a8204$var$hashClear;
$c9fdafd6c40a8204$var$Hash.prototype["delete"] = $c9fdafd6c40a8204$var$hashDelete;
$c9fdafd6c40a8204$var$Hash.prototype.get = $c9fdafd6c40a8204$var$hashGet;
$c9fdafd6c40a8204$var$Hash.prototype.has = $c9fdafd6c40a8204$var$hashHas;
$c9fdafd6c40a8204$var$Hash.prototype.set = $c9fdafd6c40a8204$var$hashSet;
/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $c9fdafd6c40a8204$var$ListCache(entries) {
    var index = -1, length = entries ? entries.length : 0;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */ function $c9fdafd6c40a8204$var$listCacheClear() {
    this.__data__ = [];
}
/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $c9fdafd6c40a8204$var$listCacheDelete(key) {
    var data = this.__data__, index = $c9fdafd6c40a8204$var$assocIndexOf(data, key);
    if (index < 0) return false;
    var lastIndex = data.length - 1;
    if (index == lastIndex) data.pop();
    else $c9fdafd6c40a8204$var$splice.call(data, index, 1);
    return true;
}
/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $c9fdafd6c40a8204$var$listCacheGet(key) {
    var data = this.__data__, index = $c9fdafd6c40a8204$var$assocIndexOf(data, key);
    return index < 0 ? undefined : data[index][1];
}
/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $c9fdafd6c40a8204$var$listCacheHas(key) {
    return $c9fdafd6c40a8204$var$assocIndexOf(this.__data__, key) > -1;
}
/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */ function $c9fdafd6c40a8204$var$listCacheSet(key, value) {
    var data = this.__data__, index = $c9fdafd6c40a8204$var$assocIndexOf(data, key);
    if (index < 0) data.push([
        key,
        value
    ]);
    else data[index][1] = value;
    return this;
}
// Add methods to `ListCache`.
$c9fdafd6c40a8204$var$ListCache.prototype.clear = $c9fdafd6c40a8204$var$listCacheClear;
$c9fdafd6c40a8204$var$ListCache.prototype["delete"] = $c9fdafd6c40a8204$var$listCacheDelete;
$c9fdafd6c40a8204$var$ListCache.prototype.get = $c9fdafd6c40a8204$var$listCacheGet;
$c9fdafd6c40a8204$var$ListCache.prototype.has = $c9fdafd6c40a8204$var$listCacheHas;
$c9fdafd6c40a8204$var$ListCache.prototype.set = $c9fdafd6c40a8204$var$listCacheSet;
/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $c9fdafd6c40a8204$var$MapCache(entries) {
    var index = -1, length = entries ? entries.length : 0;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */ function $c9fdafd6c40a8204$var$mapCacheClear() {
    this.__data__ = {
        "hash": new $c9fdafd6c40a8204$var$Hash,
        "map": new ($c9fdafd6c40a8204$var$Map || $c9fdafd6c40a8204$var$ListCache),
        "string": new $c9fdafd6c40a8204$var$Hash
    };
}
/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $c9fdafd6c40a8204$var$mapCacheDelete(key) {
    return $c9fdafd6c40a8204$var$getMapData(this, key)["delete"](key);
}
/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $c9fdafd6c40a8204$var$mapCacheGet(key) {
    return $c9fdafd6c40a8204$var$getMapData(this, key).get(key);
}
/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $c9fdafd6c40a8204$var$mapCacheHas(key) {
    return $c9fdafd6c40a8204$var$getMapData(this, key).has(key);
}
/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */ function $c9fdafd6c40a8204$var$mapCacheSet(key, value) {
    $c9fdafd6c40a8204$var$getMapData(this, key).set(key, value);
    return this;
}
// Add methods to `MapCache`.
$c9fdafd6c40a8204$var$MapCache.prototype.clear = $c9fdafd6c40a8204$var$mapCacheClear;
$c9fdafd6c40a8204$var$MapCache.prototype["delete"] = $c9fdafd6c40a8204$var$mapCacheDelete;
$c9fdafd6c40a8204$var$MapCache.prototype.get = $c9fdafd6c40a8204$var$mapCacheGet;
$c9fdafd6c40a8204$var$MapCache.prototype.has = $c9fdafd6c40a8204$var$mapCacheHas;
$c9fdafd6c40a8204$var$MapCache.prototype.set = $c9fdafd6c40a8204$var$mapCacheSet;
/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function $c9fdafd6c40a8204$var$assocIndexOf(array, key) {
    var length = array.length;
    while(length--){
        if ($c9fdafd6c40a8204$var$eq(array[length][0], key)) return length;
    }
    return -1;
}
/**
 * The base implementation of `_.get` without support for default values.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @returns {*} Returns the resolved value.
 */ function $c9fdafd6c40a8204$var$baseGet(object, path) {
    path = $c9fdafd6c40a8204$var$isKey(path, object) ? [
        path
    ] : $c9fdafd6c40a8204$var$castPath(path);
    var index = 0, length = path.length;
    while(object != null && index < length)object = object[$c9fdafd6c40a8204$var$toKey(path[index++])];
    return index && index == length ? object : undefined;
}
/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */ function $c9fdafd6c40a8204$var$baseIsNative(value) {
    if (!$c9fdafd6c40a8204$var$isObject(value) || $c9fdafd6c40a8204$var$isMasked(value)) return false;
    var pattern = $c9fdafd6c40a8204$var$isFunction(value) || $c9fdafd6c40a8204$var$isHostObject(value) ? $c9fdafd6c40a8204$var$reIsNative : $c9fdafd6c40a8204$var$reIsHostCtor;
    return pattern.test($c9fdafd6c40a8204$var$toSource(value));
}
/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */ function $c9fdafd6c40a8204$var$baseToString(value) {
    // Exit early for strings to avoid a performance hit in some environments.
    if (typeof value == "string") return value;
    if ($c9fdafd6c40a8204$var$isSymbol(value)) return $c9fdafd6c40a8204$var$symbolToString ? $c9fdafd6c40a8204$var$symbolToString.call(value) : "";
    var result = value + "";
    return result == "0" && 1 / value == -$c9fdafd6c40a8204$var$INFINITY ? "-0" : result;
}
/**
 * Casts `value` to a path array if it's not one.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {Array} Returns the cast property path array.
 */ function $c9fdafd6c40a8204$var$castPath(value) {
    return $c9fdafd6c40a8204$var$isArray(value) ? value : $c9fdafd6c40a8204$var$stringToPath(value);
}
/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */ function $c9fdafd6c40a8204$var$getMapData(map, key) {
    var data = map.__data__;
    return $c9fdafd6c40a8204$var$isKeyable(key) ? data[typeof key == "string" ? "string" : "hash"] : data.map;
}
/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */ function $c9fdafd6c40a8204$var$getNative(object, key) {
    var value = $c9fdafd6c40a8204$var$getValue(object, key);
    return $c9fdafd6c40a8204$var$baseIsNative(value) ? value : undefined;
}
/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */ function $c9fdafd6c40a8204$var$isKey(value, object) {
    if ($c9fdafd6c40a8204$var$isArray(value)) return false;
    var type = typeof value;
    if (type == "number" || type == "symbol" || type == "boolean" || value == null || $c9fdafd6c40a8204$var$isSymbol(value)) return true;
    return $c9fdafd6c40a8204$var$reIsPlainProp.test(value) || !$c9fdafd6c40a8204$var$reIsDeepProp.test(value) || object != null && value in Object(object);
}
/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */ function $c9fdafd6c40a8204$var$isKeyable(value) {
    var type = typeof value;
    return type == "string" || type == "number" || type == "symbol" || type == "boolean" ? value !== "__proto__" : value === null;
}
/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */ function $c9fdafd6c40a8204$var$isMasked(func) {
    return !!$c9fdafd6c40a8204$var$maskSrcKey && $c9fdafd6c40a8204$var$maskSrcKey in func;
}
/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */ var $c9fdafd6c40a8204$var$stringToPath = $c9fdafd6c40a8204$var$memoize(function(string) {
    string = $c9fdafd6c40a8204$var$toString(string);
    var result = [];
    if ($c9fdafd6c40a8204$var$reLeadingDot.test(string)) result.push("");
    string.replace($c9fdafd6c40a8204$var$rePropName, function(match, number, quote, string) {
        result.push(quote ? string.replace($c9fdafd6c40a8204$var$reEscapeChar, "$1") : number || match);
    });
    return result;
});
/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */ function $c9fdafd6c40a8204$var$toKey(value) {
    if (typeof value == "string" || $c9fdafd6c40a8204$var$isSymbol(value)) return value;
    var result = value + "";
    return result == "0" && 1 / value == -$c9fdafd6c40a8204$var$INFINITY ? "-0" : result;
}
/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to process.
 * @returns {string} Returns the source code.
 */ function $c9fdafd6c40a8204$var$toSource(func) {
    if (func != null) {
        try {
            return $c9fdafd6c40a8204$var$funcToString.call(func);
        } catch (e) {}
        try {
            return func + "";
        } catch (e) {}
    }
    return "";
}
/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */ function $c9fdafd6c40a8204$var$memoize(func, resolver) {
    if (typeof func != "function" || resolver && typeof resolver != "function") throw new TypeError($c9fdafd6c40a8204$var$FUNC_ERROR_TEXT);
    var memoized = function() {
        var args = arguments, key = resolver ? resolver.apply(this, args) : args[0], cache = memoized.cache;
        if (cache.has(key)) return cache.get(key);
        var result = func.apply(this, args);
        memoized.cache = cache.set(key, result);
        return result;
    };
    memoized.cache = new ($c9fdafd6c40a8204$var$memoize.Cache || $c9fdafd6c40a8204$var$MapCache);
    return memoized;
}
// Assign cache to `_.memoize`.
$c9fdafd6c40a8204$var$memoize.Cache = $c9fdafd6c40a8204$var$MapCache;
/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */ function $c9fdafd6c40a8204$var$eq(value, other) {
    return value === other || value !== value && other !== other;
}
/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */ var $c9fdafd6c40a8204$var$isArray = Array.isArray;
/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */ function $c9fdafd6c40a8204$var$isFunction(value) {
    // The use of `Object#toString` avoids issues with the `typeof` operator
    // in Safari 8-9 which returns 'object' for typed array and other constructors.
    var tag = $c9fdafd6c40a8204$var$isObject(value) ? $c9fdafd6c40a8204$var$objectToString.call(value) : "";
    return tag == $c9fdafd6c40a8204$var$funcTag || tag == $c9fdafd6c40a8204$var$genTag;
}
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */ function $c9fdafd6c40a8204$var$isObject(value) {
    var type = typeof value;
    return !!value && (type == "object" || type == "function");
}
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function $c9fdafd6c40a8204$var$isObjectLike(value) {
    return !!value && typeof value == "object";
}
/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */ function $c9fdafd6c40a8204$var$isSymbol(value) {
    return typeof value == "symbol" || $c9fdafd6c40a8204$var$isObjectLike(value) && $c9fdafd6c40a8204$var$objectToString.call(value) == $c9fdafd6c40a8204$var$symbolTag;
}
/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */ function $c9fdafd6c40a8204$var$toString(value) {
    return value == null ? "" : $c9fdafd6c40a8204$var$baseToString(value);
}
/**
 * Gets the value at `path` of `object`. If the resolved value is
 * `undefined`, the `defaultValue` is returned in its place.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
 * @returns {*} Returns the resolved value.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.get(object, 'a[0].b.c');
 * // => 3
 *
 * _.get(object, ['a', '0', 'b', 'c']);
 * // => 3
 *
 * _.get(object, 'a.b.c', 'default');
 * // => 'default'
 */ function $c9fdafd6c40a8204$var$get(object, path, defaultValue) {
    var result = object == null ? undefined : $c9fdafd6c40a8204$var$baseGet(object, path);
    return result === undefined ? defaultValue : result;
}
$c9fdafd6c40a8204$exports = $c9fdafd6c40a8204$var$get;



var $cQNHH = parcelRequire("cQNHH");

var $7YYXE = parcelRequire("7YYXE");

var $7b1Lp = parcelRequire("7b1Lp");

var $cQNHH = parcelRequire("cQNHH");

var $kV13H = parcelRequire("kV13H");
parcelRequire("8u8eZ");

var $1YSJM = parcelRequire("1YSJM");

var $jge0r = parcelRequire("jge0r");

var $h5HRh = parcelRequire("h5HRh");

var $kvHhM = parcelRequire("kvHhM");
const $9ba70814ad158a5d$var$useStyles = (0, $7b1Lp.default)((theme)=>({
        content: {
            flexGrow: 1,
            display: "flex",
            flexDirection: "column",
            overflow: "hidden"
        },
        closeText: {
            flexGrow: 1,
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            textAlign: "center",
            margin: `0 ${theme.spacing(1)}px`,
            "& > *": {
                margin: `${theme.spacing(1)}px 0`
            }
        },
        closeButtons: {
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            marginBottom: theme.spacing(2),
            "& > *": {
                margin: `0 ${theme.spacing(1)}px`
            }
        }
    }));
function $9ba70814ad158a5d$var$ClosePrompt({ onCancel: onCancel, onClose: onClose, customPage: customPage }) {
    const aria = (0, $1YSJM.default)();
    const classes = $9ba70814ad158a5d$var$useStyles();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("div", {
        className: classes.content,
        ...aria
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("div", {
        className: classes.closeText
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement((0, $kvHhM.MainHeading), {
        variant: "h1"
    }, customPage.title || /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement((0, $kV13H.default), {
        defaultMessage: "Are you sure you want to leave?",
        id: "Modal.closePrompt"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement((0, $kvHhM.NormalText), null, customPage.text ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement((0, $h5HRh.default), {
        tags: customPage.tags
    }, customPage.text) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement((0, $kV13H.default), {
        defaultMessage: "Any information you have entered will not be saved.",
        id: "Modal.closeDescription"
    })), customPage.subText && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement((0, $kvHhM.SubtleText), {
        variant: "subtitle1"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement((0, $h5HRh.default), {
        tags: customPage.tags
    }, customPage.subText))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("div", {
        className: classes.closeButtons
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement((0, $7YYXE.default), {
        onClick: ()=>{
            (0, $jge0r.userMetrics).track("Leave button pressed");
            onClose(customPage.buttonAction);
        }
    }, customPage.buttonText || /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement((0, $kV13H.default), {
        defaultMessage: "Leave",
        id: "Modal.closeButton"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement((0, $7YYXE.default), {
        color: "primary",
        onClick: onCancel,
        variant: "contained"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement((0, $kV13H.default), {
        defaultMessage: "Go back",
        id: "Modal.closeCancel"
    }))));
}
$9ba70814ad158a5d$var$ClosePrompt.defaultProps = {
    customPage: {}
};
var $9ba70814ad158a5d$export$2e2bcd8739ae039 = $9ba70814ad158a5d$var$ClosePrompt;



var $8p3P7 = parcelRequire("8p3P7");

var $aJjY6 = parcelRequire("aJjY6");

var $bIgYU = parcelRequire("bIgYU");

var $97AH2 = parcelRequire("97AH2");

var $7b1Lp = parcelRequire("7b1Lp");

var $cQNHH = parcelRequire("cQNHH");

var $c4XSV = parcelRequire("c4XSV");
var $kV13H = parcelRequire("kV13H");
var $szrnD = parcelRequire("szrnD");
parcelRequire("8u8eZ");

var $kvHhM = parcelRequire("kvHhM");

var $aJjY6 = parcelRequire("aJjY6");
var $b2b5f4d7507bba09$exports = {};
"use strict";

var $kFrsj = parcelRequire("kFrsj");

var $8jEx7 = parcelRequire("8jEx7");
Object.defineProperty($b2b5f4d7507bba09$exports, "__esModule", {
    value: true
});
$b2b5f4d7507bba09$exports.default = void 0;

var $b2b5f4d7507bba09$var$React = $8jEx7((parcelRequire("cQNHH")));

var $b2b5f4d7507bba09$var$_createSvgIcon = $kFrsj((parcelRequire("bXzXC")));
var $b2b5f4d7507bba09$var$_default = (0, $b2b5f4d7507bba09$var$_createSvgIcon.default)(/*#__PURE__*/ $b2b5f4d7507bba09$var$React.createElement("path", {
    d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z"
}), "CheckCircle");
$b2b5f4d7507bba09$exports.default = $b2b5f4d7507bba09$var$_default;



var $7b1Lp = parcelRequire("7b1Lp");

var $1GRlU = parcelRequire("1GRlU");

var $cQNHH = parcelRequire("cQNHH");
parcelRequire("8u8eZ");
const $3be2f3118331ca5d$var$useStyles = (0, $7b1Lp.default)((theme)=>({
        root: {
            backgroundColor: "white",
            flex: "33.33%",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            fontSize: "11px",
            color: theme.palette.grey[600],
            textTransform: "uppercase",
            letterSpacing: "0.05em",
            lineHeight: "24px",
            fontFamily: theme.typography.fontFamily,
            "&:not(:last-of-type)": {
                borderRight: "1px solid #ccc"
            }
        },
        complete: {
            backgroundColor: theme.palette.primary.extraLight,
            color: theme.palette.primary.main,
            opacity: "0.5"
        },
        active: {
            backgroundColor: theme.palette.primary.main,
            color: "#fff",
            fontWeight: "bold"
        },
        default: {
            backgroundColor: "white"
        },
        icon: {
            marginLeft: 8,
            fontSize: 16,
            color: theme.palette.primary.main
        }
    }));
function $3be2f3118331ca5d$var$NavigationProgressItem({ item: item, progress: progress, index: index }) {
    const classes = $3be2f3118331ca5d$var$useStyles();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement((0, $aJjY6.default), {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($1GRlU)))(classes.root, {
            [classes.active]: progress === index
        }, {
            [classes.complete]: progress > index
        }, {
            [classes.default]: progress < index
        }),
        item: true
    }, item, progress > index && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($b2b5f4d7507bba09$exports))), {
        className: classes.icon
    }));
}
var $3be2f3118331ca5d$export$2e2bcd8739ae039 = $3be2f3118331ca5d$var$NavigationProgressItem;


const $01e80fff3c31a4e4$var$messages = (0, $c4XSV.defineMessages)({
    closeDialog: {
        "id": "Modal.CloseDialog",
        "defaultMessage": "Close dialog"
    }
});
const $01e80fff3c31a4e4$var$useStyles = (0, $7b1Lp.default)((theme)=>({
        root: {
            zIndex: 1000,
            backgroundColor: "white",
            "@media print": {
                display: "none"
            }
        },
        upper: {
            borderBottom: "1px solid #ccc",
            textTransform: "uppercase",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            position: "relative",
            height: 72,
            [theme.breakpoints.down("xs")]: {
                height: 40
            }
        },
        closeButton: {
            position: "absolute",
            right: 16,
            color: "black",
            [theme.breakpoints.down("xs")]: {
                right: 0
            }
        },
        lower: {
            borderBottom: "1px solid #ccc"
        }
    }));
function $01e80fff3c31a4e4$var$NavigationProgress({ progress: progress, handleModalClose: handleModalClose, navItems: navItems, isHidden: isHidden, showCloseButton: showCloseButton, titleId: titleId, intl: { formatMessage: formatMessage } }) {
    const classes = $01e80fff3c31a4e4$var$useStyles();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("div", {
        className: classes.root
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("div", {
        className: classes.upper
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement((0, $kvHhM.Title), {
        id: titleId,
        variant: "h4"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement((0, $kV13H.default), {
        defaultMessage: "Sign up for study",
        id: "NavigationProgress.SignUp"
    })), showCloseButton && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement((0, $bIgYU.default), {
        "aria-label": formatMessage($01e80fff3c31a4e4$var$messages.closeDialog),
        className: classes.closeButton,
        onClick: handleModalClose
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($97AH2))), null))), !isHidden && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("div", {
        "aria-hidden": "true",
        className: classes.lower
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement((0, $aJjY6.default), {
        container: true,
        direction: "row"
    }, navItems && navItems.map(({ label: label, index: index })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement((0, $3be2f3118331ca5d$export$2e2bcd8739ae039), {
            key: label.key,
            index: index,
            item: label,
            progress: progress
        })))));
}
$01e80fff3c31a4e4$var$NavigationProgress.defaultProps = {
    isHidden: false
};
var $01e80fff3c31a4e4$export$2e2bcd8739ae039 = (0, $szrnD.default)($01e80fff3c31a4e4$var$NavigationProgress);



var $53xQg = parcelRequire("53xQg");

var $2Hhgv = parcelRequire("2Hhgv");
parcelRequire("8u8eZ");
/* eslint-disable no-use-before-define */ 
var $cQNHH = parcelRequire("cQNHH");

var $kV13H = parcelRequire("kV13H");
const $d2dddf4e60313517$var$getParams = window.location.search.substr(1).split("&").reduce((acc, keyValue)=>{
    const match = keyValue.match(/^(.+?)=(.+?)$/);
    if (!match) return acc;
    return {
        ...acc,
        [match[1]]: match[2]
    };
}, {});
function $d2dddf4e60313517$export$1cde898c5f939e7d(defaultValue, overrideName) {
    return defaultValue;
}


const $abbc1a8fae73e46a$export$302911c449e17ea4 = ({ steps: steps, sites: sites })=>{
    const [stepIndex, setStepIndex] = (0, $cQNHH.useState)((0, $d2dddf4e60313517$export$1cde898c5f939e7d)(0, "stepIndex"));
    const nextIndex = $abbc1a8fae73e46a$export$55a8ee9f13137bb1(stepIndex, 1, steps, sites);
    const previousIndex = $abbc1a8fae73e46a$export$55a8ee9f13137bb1(stepIndex, -1, steps, sites);
    const toNextPage = (updatedSites)=>{
        const actualSites = Array.isArray(updatedSites) ? updatedSites : sites;
        setStepIndex($abbc1a8fae73e46a$export$55a8ee9f13137bb1(stepIndex, 1, steps, actualSites));
    };
    const toPreviousPage = (updatedSites)=>{
        const actualSites = Array.isArray(updatedSites) ? updatedSites : sites;
        setStepIndex($abbc1a8fae73e46a$export$55a8ee9f13137bb1(stepIndex, -1, steps, actualSites));
    };
    const navItems = steps.map((step, index)=>{
        switch(step){
            case "questionnaire":
                return {
                    index: index,
                    label: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement((0, $kV13H.default), {
                        key: "questions",
                        defaultMessage: "Questions",
                        id: "Modal.NavProgressStudyQuestions"
                    })
                };
            case "clinicForm":
                return {
                    index: index,
                    label: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement((0, $kV13H.default), {
                        key: "location",
                        defaultMessage: "Location",
                        id: "Modal.LocationPreference"
                    })
                };
            case "contactDetails":
                return {
                    index: index,
                    label: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement((0, $kV13H.default), {
                        key: "contact",
                        defaultMessage: "Contact",
                        id: "Modal.NavProgressContactDetails"
                    })
                };
            default:
                return null;
        }
    }).filter(Boolean);
    return {
        stepIndex: stepIndex,
        navItems: navItems,
        toNextPage: toNextPage,
        toPreviousPage: toPreviousPage,
        nextIndex: nextIndex,
        previousIndex: previousIndex,
        pageName: steps[stepIndex],
        hasNextPage: nextIndex < steps.length
    };
};
const $abbc1a8fae73e46a$export$55a8ee9f13137bb1 = (index, direction, steps, sites)=>{
    let newIndex = index + direction;
    const skippable = [
        "clinicForm",
        "questionnaire.eligible"
    ];
    while(skippable.includes(steps[newIndex])){
        if (steps[newIndex] === "clinicForm" && (sites === null || sites === void 0 ? void 0 : sites.length) <= 1) newIndex += direction;
        else if (steps[newIndex] === "questionnaire.eligible") newIndex += direction;
        else break;
    }
    return newIndex;
};



var $aeuny = parcelRequire("aeuny");

var $hgf0k = parcelRequire("hgf0k");

var $7lOcN = parcelRequire("7lOcN");

var $1YSJM = parcelRequire("1YSJM");

var $ikATC = parcelRequire("ikATC");

var $cQNHH = parcelRequire("cQNHH");

var $c4XSV = parcelRequire("c4XSV");
var $kV13H = parcelRequire("kV13H");

var $iTDkM = parcelRequire("iTDkM");

var $cQNHH = parcelRequire("cQNHH");

var $kV13H = parcelRequire("kV13H");
parcelRequire("8u8eZ");

var $cQNHH = parcelRequire("cQNHH");
function $67fa45b3f289bd4d$export$2e2bcd8739ae039() {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("svg", {
        viewBox: "0 0 258 158",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("path", {
        d: "M27.25 4.542c-12.535 0-22.708 10.173-22.708 22.709 0 12.535 10.173 22.708 22.709 22.708 12.535 0 22.708-10.173 22.708-22.708 0-12.536-10.173-22.71-22.708-22.71zm0 26.202l-7.86 7.861-3.494-3.494 7.86-7.86-7.86-7.861 3.494-3.494 7.86 7.86 7.861-7.86 3.494 3.494-7.86 7.86 7.86 7.861-3.494 3.494-7.86-7.86z",
        id: "a"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("g", {
        fill: "none",
        fillRule: "evenodd"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("ellipse", {
        cx: "129.124",
        cy: "148.778",
        fill: "#F0F1F1",
        rx: "59.124",
        ry: "8.778"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("g", {
        fill: "#BABFC0"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("g", {
        transform: "rotate(-180 98.175 34.014)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("ellipse", {
        cx: "2.92",
        cy: "37.926",
        rx: "2.92",
        ry: "2.926"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("path", {
        d: "M13.389 0h6.56v8.778h-6.56a4.389 4.389 0 0 1 0-8.778zM11.926 35h8.023v5.852h-8.023a2.926 2.926 0 0 1 0-5.852z"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("g", {
        transform: "translate(0 27.065)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("ellipse", {
        cx: "2.92",
        cy: "2.926",
        rx: "2.92",
        ry: "2.926"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("ellipse", {
        cx: "64.92",
        cy: "63.926",
        rx: "2.92",
        ry: "2.926"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("ellipse", {
        cx: "43.92",
        cy: "19.926",
        rx: "2.92",
        ry: "2.926"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("path", {
        d: "M20.926 0h61.308v5.852H20.926a2.926 2.926 0 0 1 0-5.852zM75.389 26h6.56v8.778h-6.56a4.389 4.389 0 0 1 0-8.778zM73.926 61h8.023v5.852h-8.023a2.926 2.926 0 0 1 0-5.852zM58.76 35h23.357v17.556H58.759A8.76 8.76 0 0 1 50 43.796v-.037A8.76 8.76 0 0 1 58.76 35z"
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("g", {
        transform: "translate(81.752)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("rect", {
        fill: "#BABFC0",
        height: "122.889",
        rx: "5.839",
        width: "94.891"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("rect", {
        fill: "#FFF",
        height: "111.185",
        rx: "2.92",
        width: "83.212",
        x: "6",
        y: "6"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("g", {
        transform: "translate(19 32)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("path", {
        d: "M0 0h54.501v54.501H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("mask", {
        fill: "#fff",
        id: "b"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("use", {
        xlinkHref: "#a"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("use", {
        fill: "#FFF",
        fillRule: "nonzero",
        transform: "matrix(1 0 0 -1 0 54.501)",
        xlinkHref: "#a"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("g", {
        fill: "#FA6428",
        mask: "url(#b)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("path", {
        d: "M0 0h55.015v55.057H0z"
    }))))));
}



var $dHJvE = parcelRequire("dHJvE");
function $aef71df54ffafd47$var$Error({ text: text, title: title, onButtonClick: onButtonClick }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement((0, $dHJvE.default), {
        buttonText: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement((0, $kV13H.default), {
            defaultMessage: "Close",
            id: "Error.CloseModal"
        }),
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement((0, $67fa45b3f289bd4d$export$2e2bcd8739ae039), {
            height: "46",
            width: "46"
        }),
        onButtonClick: onButtonClick,
        showButton: Boolean(onButtonClick),
        text: text,
        title: title
    });
}
var $aef71df54ffafd47$export$2e2bcd8739ae039 = $aef71df54ffafd47$var$Error;



var $53xQg = parcelRequire("53xQg");
parcelRequire("8u8eZ");

var $jge0r = parcelRequire("jge0r");
function $1ffcf997f1a52a21$var$PleaseTryAgain() {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement((0, $kV13H.default), {
        defaultMessage: "Please try again later",
        id: "Error.PleaseTryAgain"
    });
}
function $1ffcf997f1a52a21$var$ErrorWrapper(props) {
    const { errorCode: errorCode, onButtonClick: onButtonClick } = props;
    (0, $cQNHH.useEffect)(()=>{
        (0, $jge0r.userMetrics).track("Error screen loaded");
    }, []);
    if (errorCode === "noToken") return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement((0, $aef71df54ffafd47$export$2e2bcd8739ae039), {
        onButtonClick: onButtonClick,
        text: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement((0, $kV13H.default), {
            defaultMessage: "Please contact support {email}",
            id: "Error.NoToken",
            values: {
                email: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("a", {
                    href: `mailto:${(0, $53xQg.SUPPORT_EMAIL)}`
                }, (0, $53xQg.SUPPORT_EMAIL))
            }
        }),
        title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement((0, $kV13H.default), {
            defaultMessage: "Token is missing or invalid",
            id: "Error.NoTokenTitle"
        })
    });
    if (errorCode === "noSession") return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement((0, $aef71df54ffafd47$export$2e2bcd8739ae039), {
        onButtonClick: onButtonClick,
        text: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement((0, $kV13H.default), {
            defaultMessage: "The signup process has ended due to inactivity. Please restart the sign-up process.",
            id: "Error.SessionTimedOut"
        }),
        title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement((0, $kV13H.default), {
            defaultMessage: "Your session has expired",
            id: "Error.SessionTimedOutTitle"
        })
    });
    if (errorCode === "notActive") {
        const { createdAt: createdAt, status: status, startsIn: startsIn, endsIn: endsIn } = props;
        const subText = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement((0, $kV13H.default), {
            defaultMessage: "Should you have any questions or concerns, please email us at {email}.",
            id: "RegistrationComplete.ContactUs",
            values: {
                email: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement((0, $ikATC.default), {
                    href: `mailto:${(0, $53xQg.SUPPORT_EMAIL)}`
                }, (0, $53xQg.SUPPORT_EMAIL))
            }
        });
        if (createdAt) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement((0, $iTDkM.default), {
            isEligible: true,
            subText: subText,
            text: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement((0, $kV13H.default), {
                defaultMessage: "This survey was already completed on {completedAt}",
                id: "SurveyComplete.AlreadyCompleted",
                values: {
                    completedAt: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement((0, $c4XSV.FormattedDate), {
                        value: new Date(createdAt)
                    })
                }
            }),
            title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement((0, $kV13H.default), {
                defaultMessage: "Already completed",
                id: "SurveyComplete.AlreadyCompletedTitle"
            })
        });
        const time = new Date().getTime();
        let title = `${status}`;
        let text = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement((0, $kV13H.default), {
            defaultMessage: "This survey is {status}",
            id: "SurveyInactive.Status",
            values: {
                status: status
            }
        });
        if (startsIn < 1) {
            title = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement((0, $kV13H.default), {
                defaultMessage: "Survey not started",
                id: "SurveyInactive.NotStartedTitle"
            });
            text = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement((0, $kV13H.default), {
                defaultMessage: "This survey will start on {date}",
                id: "SurveyInactive.NotStarted",
                values: {
                    date: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement((0, $c4XSV.FormattedDate), {
                        value: new Date(time - startsIn * 60000)
                    })
                }
            });
        } else if (endsIn < 0) {
            title = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement((0, $kV13H.default), {
                defaultMessage: "Survey closed",
                id: "SurveyInactive.EndedTitle"
            });
            text = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement((0, $kV13H.default), {
                defaultMessage: "This survey ended on {date}",
                id: "SurveyInactive.Ended",
                values: {
                    date: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement((0, $c4XSV.FormattedDate), {
                        value: new Date(time + endsIn * 60000)
                    })
                }
            });
        }
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement((0, $iTDkM.default), {
            subText: subText,
            text: text,
            title: title
        });
    }
    if (errorCode === "offline" || errorCode === "disconnected") return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement((0, $aef71df54ffafd47$export$2e2bcd8739ae039), {
        onButtonClick: onButtonClick,
        text: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement($1ffcf997f1a52a21$var$PleaseTryAgain, null),
        title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement((0, $kV13H.default), {
            defaultMessage: "No response from server",
            id: "Error.NoResponse"
        })
    });
    if (errorCode === "locale") return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement((0, $aef71df54ffafd47$export$2e2bcd8739ae039), {
        onButtonClick: onButtonClick,
        title: "Language not supported"
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement((0, $aef71df54ffafd47$export$2e2bcd8739ae039), {
        onButtonClick: onButtonClick,
        text: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement($1ffcf997f1a52a21$var$PleaseTryAgain, null),
        title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement((0, $kV13H.default), {
            defaultMessage: "An unknown error occurred",
            id: "Error.UnknownError"
        })
    });
}
$1ffcf997f1a52a21$var$ErrorWrapper.defaultProps = {
    createdAt: undefined,
    endsIn: undefined,
    errorCode: undefined,
    startsIn: undefined,
    status: undefined
};
var $1ffcf997f1a52a21$export$2e2bcd8739ae039 = $1ffcf997f1a52a21$var$ErrorWrapper;


/* eslint-disable react/jsx-props-no-spreading */ 
var $ki4tF = parcelRequire("ki4tF");

var $fpN3t = parcelRequire("fpN3t");

var $7b1Lp = parcelRequire("7b1Lp");

var $cQNHH = parcelRequire("cQNHH");

var $kV13H = parcelRequire("kV13H");

var $ioHzT = parcelRequire("ioHzT");

var $k4Dr6 = parcelRequire("k4Dr6");

var $h5HRh = parcelRequire("h5HRh");

var $kvHhM = parcelRequire("kvHhM");
parcelRequire("8u8eZ");

var $7lOcN = parcelRequire("7lOcN");

var $1YSJM = parcelRequire("1YSJM");
const $d0fa50b587ce357e$var$useStyles = (0, $7b1Lp.default)((theme)=>({
        root: {
            flexGrow: 1,
            overflowY: "auto"
        },
        container: {
            display: "flex",
            flexDirection: "column",
            alignItems: "center"
        },
        image: {
            width: "100%",
            height: 260,
            flexShrink: 0,
            backgroundSize: "cover",
            backgroundPosition: "center",
            [theme.breakpoints.down("xs")]: {
                height: 120
            }
        },
        content: {
            display: "flex",
            flexDirection: "column",
            flexGrow: 1,
            width: 600,
            maxWidth: "90%",
            textAlign: "center",
            marginBottom: theme.spacing(2)
        },
        header: {
            marginTop: theme.spacing(3)
        },
        buttonContainer: {
            flexGrow: 1,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            margin: theme.spacing(5),
            marginBottom: 0
        }
    }));
function $d0fa50b587ce357e$var$ParticipateText() {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement((0, $kV13H.default), {
        defaultMessage: "I want to participate",
        id: "Welcome.Participate"
    });
}
function $d0fa50b587ce357e$var$Welcome({ navigateModal: navigateModal, closeModal: closeModal, welcomeImage: welcomeImage, contentId: contentId, customPages: { welcome: customPage = {} } }) {
    const clipPathId = (0, $7lOcN.default)();
    const aria = (0, $1YSJM.default)({
        noFocus: true
    });
    const theme = (0, $ki4tF.default)();
    const footer = (0, $fpN3t.default)(theme.breakpoints.down("sm"));
    const classes = $d0fa50b587ce357e$var$useStyles();
    const buttonText = customPage.buttonText || /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement($d0fa50b587ce357e$var$ParticipateText, null);
    const onClickHandler = ()=>customPage.buttonAction ? closeModal(customPage.buttonAction) : navigateModal({
            forward: true
        });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("svg", {
        height: "0",
        width: "0"
    }, "tagstags", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("clipPath", {
        clipPathUnits: "objectBoundingBox",
        id: clipPathId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("path", {
        d: "m 0,-8e-8 v 0.9455507 C 0,0.94555062 0.22434471,1 0.50025839,1 0.77617207,1 1,0.94555062 1,0.94555062 V -8e-8 Z"
    })))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("div", {
        className: classes.root,
        ...aria
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("div", {
        className: classes.container
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("div", {
        className: classes.image,
        style: {
            backgroundImage: `url(${welcomeImage})`,
            clipPath: `url(#${clipPathId})`
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("div", {
        className: classes.content
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement((0, $kvHhM.MainHeading), {
        className: classes.header,
        underline: "true",
        variant: "h2"
    }, customPage.title || /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement((0, $kV13H.default), {
        defaultMessage: "Find out if this study is a match for you",
        id: "Welcome.FindOutIfQualify"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement((0, $kvHhM.NormalText), null, customPage.text ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement((0, $h5HRh.default), {
        tags: customPage.tags
    }, customPage.text) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement((0, $kV13H.default), {
        defaultMessage: "To sign up for this study, please answer a few questions and let us know which clinic you would like to visit during the study.",
        id: "Welcome.ToSignUp"
    })), customPage.subText && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement((0, $kvHhM.SubtleText), {
        variant: "subtitle1"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement((0, $h5HRh.default), {
        tags: customPage.tags
    }, customPage.subText)), !footer && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("div", {
        className: classes.buttonContainer
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement((0, $ioHzT.default), {
        "aria-controls": contentId,
        color: "primary",
        onClick: onClickHandler,
        variant: "contained"
    }, buttonText))))), footer && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement((0, $k4Dr6.default), {
        formIsComplete: true,
        footerText: buttonText,
        onContinueClick: onClickHandler
    }));
}
$d0fa50b587ce357e$var$Welcome.defaultProps = {
    customPages: {},
    welcomeImage: undefined
};
var $d0fa50b587ce357e$export$2e2bcd8739ae039 = $d0fa50b587ce357e$var$Welcome;



const $fe5ad4779f0e9155$var$questionnaireImport = (parcelRequire("4pYia"));

const $fe5ad4779f0e9155$var$clinicFormImport = (parcelRequire("XF2by"));

const $fe5ad4779f0e9155$var$contactDetailsImport = (parcelRequire("3JUnY"));

const $fe5ad4779f0e9155$var$registrationCompletedImport = (parcelRequire("7VhxQ"));
const $fe5ad4779f0e9155$var$Questionnaire = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).lazy(()=>$fe5ad4779f0e9155$var$questionnaireImport);
const $fe5ad4779f0e9155$var$ClinicForm = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).lazy(()=>$fe5ad4779f0e9155$var$clinicFormImport);
const $fe5ad4779f0e9155$var$ContactDetails = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).lazy(()=>$fe5ad4779f0e9155$var$contactDetailsImport);
const $fe5ad4779f0e9155$var$RegistrationCompleted = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).lazy(()=>$fe5ad4779f0e9155$var$registrationCompletedImport);
const $fe5ad4779f0e9155$var$useStyles = (0, $7b1Lp.default)((theme)=>({
        root: {
            backgroundColor: "white",
            margin: "0 auto",
            borderRadius: "6px",
            overflow: "hidden",
            transition: "all .3s ease-in",
            position: "relative",
            width: "calc(100% - 20px)",
            height: "calc(100% - 20px)",
            zIndex: 9999,
            maxWidth: "930px",
            maxHeight: "720px",
            boxShadow: "0 0 24px 0 rgba(0, 0, 0, 0.36)",
            display: "flex",
            flexDirection: "column",
            [theme.breakpoints.down("sm")]: {
                maxWidth: "unset",
                maxHeight: "unset"
            },
            "@media print": {
                display: "block",
                boxShadow: "none",
                maxHeight: "unset",
                width: "100%",
                height: "auto"
            }
        },
        content: {
            flexGrow: 1,
            display: "flex",
            flexDirection: "column",
            overflow: "hidden",
            "@media print": {
                display: "block",
                overflow: "auto"
            }
        }
    }));
const $fe5ad4779f0e9155$var$defaultContactFields = [
    {
        name: "name",
        type: "name"
    },
    {
        name: "email",
        type: "email",
        confirm: true
    },
    {
        name: "phone",
        type: "phone"
    },
    {
        name: "preferredContactHours",
        type: "select",
        options: [
            "8-20",
            "8-12",
            "12-16",
            "16-20"
        ],
        defaultValue: "8-20"
    }
];
const $fe5ad4779f0e9155$var$pageToComponent = {
    welcome: (0, $d0fa50b587ce357e$export$2e2bcd8739ae039),
    questionnaire: $fe5ad4779f0e9155$var$Questionnaire,
    clinicForm: $fe5ad4779f0e9155$var$ClinicForm,
    contactDetails: $fe5ad4779f0e9155$var$ContactDetails,
    completed: $fe5ad4779f0e9155$var$RegistrationCompleted
};
const $fe5ad4779f0e9155$var$getCustomPages = ({ config: { customPages: customPages = {} } = {}, sessionInfo: { study: study } = {}, fullState: { clinicForm: clinicForm, contactDetails: contactDetails } = {} })=>{
    const tags = {
        name: (0, (/*@__PURE__*/$parcel$interopDefault($c9fdafd6c40a8204$exports)))(contactDetails, "fieldValues.name.value", ""),
        email: (0, (/*@__PURE__*/$parcel$interopDefault($c9fdafd6c40a8204$exports)))(contactDetails, "fieldValues.email.value", ""),
        phone: (0, (/*@__PURE__*/$parcel$interopDefault($c9fdafd6c40a8204$exports)))(contactDetails, "fieldValues.phone.value", ""),
        siteName: (0, (/*@__PURE__*/$parcel$interopDefault($c9fdafd6c40a8204$exports)))(clinicForm, "selectedSite.name", ""),
        siteAddress: (0, (/*@__PURE__*/$parcel$interopDefault($c9fdafd6c40a8204$exports)))(clinicForm, "selectedSite.address", ""),
        inboundProxyNumber: (0, (/*@__PURE__*/$parcel$interopDefault($c9fdafd6c40a8204$exports)))(clinicForm, "selectedSite.inboundProxyNumber", ""),
        publicStudyName: (0, (/*@__PURE__*/$parcel$interopDefault($c9fdafd6c40a8204$exports)))(study, "publicStudyName", ""),
        supportEmail: `[${(0, $53xQg.SUPPORT_EMAIL)}](mailto:${(0, $53xQg.SUPPORT_EMAIL)})`
    };
    const customPagesWithTags = {
        ...customPages
    };
    Object.keys(customPages).forEach((key)=>{
        customPagesWithTags[key].tags = tags;
    });
    return customPagesWithTags;
};
function $fe5ad4779f0e9155$var$Modal({ onAction: onAction, sessionInfo: sessionInfo, config: config, api: api, errorCode: errorCode, onClose: onClose }) {
    const { defaultSiteId: defaultSiteId, questions: questions, googleApiKey: googleApiKey, consent: consent } = sessionInfo;
    const { steps: steps, contactForm: contactForm, ...otherConfig } = config;
    const titleId = (0, $7lOcN.default)();
    const contentId = (0, $7lOcN.default)();
    const aria = (0, $1YSJM.default)();
    const [sites, setSites] = (0, $cQNHH.useState)();
    const { navItems: navItems, pageName: pageName, hasNextPage: hasNextPage, toPreviousPage: toPreviousPage, toNextPage: toNextPage, nextIndex: nextIndex, previousIndex: previousIndex, stepIndex: stepIndex } = (0, $abbc1a8fae73e46a$export$302911c449e17ea4)({
        steps: steps,
        sites: sites
    });
    const [showClosePrompt, setShowClosePrompt] = (0, $cQNHH.useState)(false);
    const enableClosePrompt = (0, $aeuny.useIsLocked)();
    const [fullState, setGlobalState] = (0, $hgf0k.useFullGlobalState)();
    const actions = (0, $cQNHH.useRef)([]);
    const processActions = ()=>{
        while(actions.current.length){
            const action = actions.current.shift();
            const metrics = (0, $2Hhgv.metricsDataFromState)({
                ...fullState,
                sessionInfo: sessionInfo,
                pageName: pageName
            });
            onAction(action, metrics);
        }
    };
    processActions();
    (0, $cQNHH.useEffect)(()=>{
        const callback = (action)=>{
            actions.current.push(action);
            processActions();
        };
        (0, $2Hhgv.subscribeMetrics)(callback);
        return ()=>(0, $2Hhgv.unsubscribeMetrics)(callback);
    }, [
        fullState,
        sessionInfo,
        stepIndex
    ]);
    (0, $cQNHH.useEffect)(()=>(0, $2Hhgv.submitMetric)("pageOpened"), [
        stepIndex,
        fullState[pageName].subPage || null
    ]);
    (0, $cQNHH.useEffect)(()=>{
        if (defaultSiteId) setGlobalState("clinicForm.selectedSite", defaultSiteId);
    }, [
        defaultSiteId
    ]);
    const customPages = $fe5ad4779f0e9155$var$getCustomPages({
        config: config,
        sessionInfo: sessionInfo,
        fullState: fullState
    });
    const navigate = ({ forward: forward, sites: updatedSites })=>{
        if (forward && !hasNextPage) onClose(customPages[pageName] && customPages[pageName].buttonAction);
        else if (forward) toNextPage(updatedSites);
        else toPreviousPage(updatedSites);
    };
    const closeModal = (redirectUrl)=>{
        const close = ()=>{
            if (showClosePrompt) {
                (0, $2Hhgv.submitMetric)("dropout");
                api.dropoutCandidate();
            } else (0, $2Hhgv.submitMetric)("closed");
            onClose(redirectUrl);
        };
        if (enableClosePrompt && !showClosePrompt) setShowClosePrompt(redirectUrl || true);
        else close();
    };
    const getPageProps = ()=>{
        const nextPageName = nextIndex < steps.length ? steps[nextIndex] : null;
        const prevPageName = previousIndex >= 0 ? steps[previousIndex] : null;
        return {
            ...otherConfig,
            api: api,
            questions: questions,
            navigateModal: navigate,
            sites: sites,
            setSites: setSites,
            googleApiKey: googleApiKey,
            consent: consent,
            closeModal: closeModal,
            pageName: pageName,
            prevPageName: prevPageName,
            nextPageName: nextPageName,
            contentId: contentId,
            fields: contactForm || $fe5ad4779f0e9155$var$defaultContactFields,
            customPages: customPages,
            steps: steps
        };
    };
    const getStepContent = ()=>{
        const PageElement = $fe5ad4779f0e9155$var$pageToComponent[pageName];
        if (errorCode || !PageElement) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement((0, $1ffcf997f1a52a21$export$2e2bcd8739ae039), {
            errorCode: errorCode,
            onButtonClick: closeModal
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement((0, $8p3P7.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement(PageElement, getPageProps()));
    };
    const getContent = ()=>{
        if (showClosePrompt) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement((0, $9ba70814ad158a5d$export$2e2bcd8739ae039), {
            customPage: customPages.leave,
            onCancel: ()=>setShowClosePrompt(false),
            onClose: closeModal
        });
        return getStepContent();
    };
    const classes = $fe5ad4779f0e9155$var$useStyles();
    // TODO: Role on the root div?
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("div", {
        "aria-labelledby": titleId,
        className: classes.root,
        ...aria
    }, !errorCode && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement((0, $01e80fff3c31a4e4$export$2e2bcd8739ae039), {
        handleModalClose: ()=>closeModal(),
        isHidden: pageName === "welcome",
        navItems: navItems,
        progress: stepIndex,
        showCloseButton: !showClosePrompt,
        titleId: titleId
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("div", {
        "aria-live": "polite",
        className: classes.content,
        id: contentId,
        name: "tb-sa-content"
    }, getContent()));
}
$fe5ad4779f0e9155$var$Modal.defaultProps = {
    errorCode: null,
    sessionInfo: {
        consent: [],
        googleApiKey: "",
        questionnaire: []
    }
};
var $fe5ad4779f0e9155$export$2e2bcd8739ae039 = $fe5ad4779f0e9155$var$Modal;
function $fe5ad4779f0e9155$export$23ec8986ee72eea6({ handleModalClose: handleModalClose }) {
    const classes = $fe5ad4779f0e9155$var$useStyles();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("div", {
        className: classes.root
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("div", {
        className: classes.content
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement((0, $1ffcf997f1a52a21$export$2e2bcd8739ae039), {
        errorCode: "unknown",
        onButtonClick: handleModalClose
    })));
}


parcelRequire("8u8eZ");

var $aeuny = parcelRequire("aeuny");

var $hgf0k = parcelRequire("hgf0k");
/**
 * This file only exist to cover up for parcel not having the ability to do lazy importing based on
 * a glob. In the future, the big object could essentially be replaced with this:
 *
 * ```js
 * function getLanguage(locale) {
 *   const language = locale.match(/^(.+?)_.+?$/)[1];
 *
 *   return Promise.all([
 *     import(`react-intl/locale-data/${language}`),
 *     import(`./locales/${locale}.json`),
 *   ]);
 * }
 * ```
 *
 * The parcel issue in question can be found here:
 * https://github.com/parcel-bundler/parcel/issues/125
 */ 
var $1rrDX = parcelRequire("1rrDX");

var $cQNHH = parcelRequire("cQNHH");
var $f54519d442a89b55$exports = {};
$f54519d442a89b55$exports = JSON.parse('{"Terms.print":"Print","ClinicForm.mapsLookup":"Look up on Google maps","Modal.closePrompt":"Are you sure you want to leave?","Modal.closeDescription":"Any information you have entered will not be saved.","Modal.closeButton":"Leave","Modal.closeCancel":"Go back","Footer.back":"Back","Footer.next":"Next","Footer.submit":"Submit","phoneInput.countryOfOrigin":"Phone country of origin","ClinicForm.SelectedClinic":"Selected research centre","Error.CloseModal":"Close","Modal.CloseDialog":"Close dialog","NavigationProgress.SignUp":"See if you pre-qualify","Questionnaire.BMI.Height":"Height","Questionnaire.BMI.Weight":"Weight","Questionnaire.BMI.units.metric":"metric","Questionnaire.BMI.units.imperial":"imperial","Questionnaire.BMI.useStones":"Use stones","Questionnaire.BMI.centimeters":"Centimeters","Questionnaire.BMI.kilograms":"Kilograms","Questionnaire.BMI.feet":"Feet","Questionnaire.BMI.inches":"Inches","Questionnaire.BMI.pounds":"Pounds","Questionnaire.BMI.stone":"Stones","NavigationControls.Questionnaire.select.placeholder":"Select an answer","NavigationControls.NavigationControlsYes":"Yes","NavigationControls.NavigationControlsNo":"No","Questionnaire.QuestionTitle":"Question {number}. {questionText}","Survey.StartButton":"Start","Survey.ContinueButton":"Continue","Intro.caption":"Complete the survey before {date}","RegistrationComplete.ContactUs":"Should you have any questions or concerns, please email us at {email}.","SurveyComplete.ThankYou":"Thank you for taking the time to complete this survey.","SurveyComplete.CompletedTitle":"Survey completed","Terms.back":"Back","Terms.termsOfAgreement":"Terms of Agreement","Terms.recaptchaNotice":"This questionnaire is protected by reCAPTCHA and the Google {privacy} and {terms} apply.","Terms.recaptchaNoticePrivacy":"Privacy Policy","Terms.recaptchaNoticeTerms":"Terms of Service","ClinicForm.SelectClinic":"Select a preferred research centre you would like to visit if you were to take part in the study","ClinicForm.FindNearestClinic":"Find nearest research centre","Footer.FooterNoClinicSelected":"No research centre selected","ContactDetails.prompt":"Please enter your contact details and preferred time of contact so that the study medical team can reach you to discuss study participation.","ContactDetails.PromptNotice":"Submitting your contact details does not mean you have to join the study. That is your decision to make if you are fully eligible for the study.","ContactDetails.privacyDisclaimer":"Your personal information and your answers to the study questions are only used for the purposes of determining if the clinical study is suitable for you. You can at any time withdraw your consent and have your personal data removed.","Elegible.ChooseClinic":"Next","Elegible.SelectPreferedClinic":"In the next step you will select a research centre that you would like to visit during the study if you are eligible and would like to take part.","Elegible.EnterContactDetails":"In the next step you will enter your contact details so that the study medical team can reach you.","Elegible.YouAreElegible":"Based on your responses, you may be suitable for the study.","Error.PleaseTryAgain":"Please try again later","Error.NoToken":"Please contact support {email}","Error.NoTokenTitle":"Token is missing or invalid","Error.SessionTimedOut":"The signup process has ended due to inactivity. Please restart the sign-up process.","Error.SessionTimedOutTitle":"Your session has expired","SurveyComplete.AlreadyCompleted":"This survey was already completed on {completedAt}","SurveyComplete.AlreadyCompletedTitle":"Already completed","SurveyInactive.Status":"This survey is {status}","SurveyInactive.NotStartedTitle":"Survey not started","SurveyInactive.NotStarted":"This survey will start on {date}","SurveyInactive.EndedTitle":"Survey closed","SurveyInactive.Ended":"This survey ended on {date}","Error.NoResponse":"No response from server","Error.UnknownError":"An unknown error occurred","ContactDetails.name":"Name","ContactDetails.namePlaceholder":"Your name","ContactDetails.email":"Email address","ContactDetails.emailPlaceholder":"Your email address","ContactDetails.emailConfirm":"Confirm email address","ContactDetails.emailConfirmPlaceholder":"Confirm email address","ContactDetails.phone":"Phone number","ContactDetails.phonePlaceholder":"Your phone number","ContactDetails.phoneConfirm":"Confirm phone number","ContactDetails.phoneConfirmPlaceholder":"Confirm phone number","FormSelect.preferred_contact_way":"Preferred way to be contacted","ContactDetails.preferred_contact_wayPlaceholder":"Choose preferred method","FormSelect.availability_slots":"Preferred time to be contacted","ContactDetails.availability_slotsPlaceholder":"Choose time","Error.MinimumCharacters":"Please enter your whole name","Error.MaximumCharacters":"Please enter a shorter version of your name","Error.NotValidEmail":"Please enter a valid email","Error.NonEqualEmail":"The email addresses do not match","Error.PleaseSelectAvailabilitySlot":"Please select a timeslot for preferred contact","Error.PleaseSelectContactWay":"Please select a preferred way to be contacted","Error.NotValidPhoneNumber":"Please enter a valid phone number","Error.NotEqualPhoneNumber":"The phone numbers do not match","Error.YouMustConsent":"You cannot proceed without consenting. If you do not wish to consent, you can close the window in the upper right corner.","ContactTimes.8-20":"Anytime","ContactTimes.8-12":"8:00 am - 12:00 noon","ContactTimes.12-16":"12:00 noon - 4:00 pm","ContactTimes.16-20":"4:00 pm - 8:00 pm","Modal.NavProgressStudyQuestions":"Questions","Modal.LocationPreference":"Location","Modal.NavProgressContactDetails":"Contact","NotEligible.CloseButton":"Close","NotEligible.NotEligible":"Sorry, the study is not suitable for you at this time","Questionnaire.Progress":"{questionsAnswered} of {totalQuestions} answered","Warning.SkippedQuestions":"{count} questions skipped","Questionnaire.Prompt":"Please answer the following questions to find out if you are suitable for the study.","RegistrationComplete.Done":"Done","Registration.RegistrationNowFinished":"Thank you for your interest. An email has been sent to {email}. You will be contacted by the study medical team shortly to talk about the study.","Registration.RegistrationComplete":"Registration completed!","Welcome.Participate":"I want to participate","Welcome.FindOutIfQualify":"Find out if this study is a match for you","Welcome.ToSignUp":"Please answer a few questions to see if you may qualify for the study.","Countries.AF":"Afghanistan","Countries.AX":"\xc5land Islands","Countries.AL":"Albania","Countries.DZ":"Algeria","Countries.AS":"American Samoa","Countries.AD":"Andorra","Countries.AO":"Angola","Countries.AI":"Anguilla","Countries.AQ":"Antarctica","Countries.AG":"Antigua and Barbuda","Countries.AR":"Argentina","Countries.AM":"Armenia","Countries.AW":"Aruba","Countries.AU":"Australia","Countries.AT":"Austria","Countries.AZ":"Azerbaijan","Countries.BS":"Bahamas","Countries.BH":"Bahrain","Countries.BD":"Bangladesh","Countries.BB":"Barbados","Countries.BY":"Belarus","Countries.BE":"Belgium","Countries.BZ":"Belize","Countries.BJ":"Benin","Countries.BM":"Bermuda","Countries.BT":"Bhutan","Countries.BO":"Bolivia (Plurinational State of)","Countries.BQ":"Bonaire, Sint Eustatius and Saba","Countries.BA":"Bosnia and Herzegovina","Countries.BW":"Botswana","Countries.BV":"Bouvet Island","Countries.BR":"Brazil","Countries.IO":"British Indian Ocean Territory","Countries.UM":"United States Minor Outlying Islands","Countries.VG":"Virgin Islands (British)","Countries.VI":"Virgin Islands (U.S.)","Countries.BN":"Brunei Darussalam","Countries.BG":"Bulgaria","Countries.BF":"Burkina Faso","Countries.BI":"Burundi","Countries.KH":"Cambodia","Countries.CM":"Cameroon","Countries.CA":"Canada","Countries.CV":"Cabo Verde","Countries.KY":"Cayman Islands","Countries.CF":"Central African Republic","Countries.TD":"Chad","Countries.CL":"Chile","Countries.CN":"China","Countries.CX":"Christmas Island","Countries.CC":"Cocos (Keeling) Islands","Countries.CO":"Colombia","Countries.KM":"Comoros","Countries.CG":"Congo","Countries.CD":"Congo (Democratic Republic of the)","Countries.CK":"Cook Islands","Countries.CR":"Costa Rica","Countries.HR":"Croatia","Countries.CU":"Cuba","Countries.CW":"Cura\xe7ao","Countries.CY":"Cyprus","Countries.CZ":"Czech Republic","Countries.DK":"Denmark","Countries.DJ":"Djibouti","Countries.DM":"Dominica","Countries.DO":"Dominican Republic","Countries.EC":"Ecuador","Countries.EG":"Egypt","Countries.SV":"El Salvador","Countries.GQ":"Equatorial Guinea","Countries.ER":"Eritrea","Countries.EE":"Estonia","Countries.ET":"Ethiopia","Countries.FK":"Falkland Islands (Malvinas)","Countries.FO":"Faroe Islands","Countries.FJ":"Fiji","Countries.FI":"Finland","Countries.FR":"France","Countries.GF":"French Guiana","Countries.PF":"French Polynesia","Countries.TF":"French Southern Territories","Countries.GA":"Gabon","Countries.GM":"Gambia","Countries.GE":"Georgia","Countries.DE":"Germany","Countries.GH":"Ghana","Countries.GI":"Gibraltar","Countries.GR":"Greece","Countries.GL":"Greenland","Countries.GD":"Grenada","Countries.GP":"Guadeloupe","Countries.GU":"Guam","Countries.GT":"Guatemala","Countries.GG":"Guernsey","Countries.GN":"Guinea","Countries.GW":"Guinea-Bissau","Countries.GY":"Guyana","Countries.HT":"Haiti","Countries.HM":"Heard Island and McDonald Islands","Countries.VA":"Holy See","Countries.HN":"Honduras","Countries.HK":"Hong Kong","Countries.HU":"Hungary","Countries.IS":"Iceland","Countries.IN":"India","Countries.ID":"Indonesia","Countries.CI":"C\xf4te d\'Ivoire","Countries.IR":"Iran (Islamic Republic of)","Countries.IQ":"Iraq","Countries.IE":"Ireland","Countries.IM":"Isle of Man","Countries.IL":"Israel","Countries.IT":"Italy","Countries.JM":"Jamaica","Countries.JP":"Japan","Countries.JE":"Jersey","Countries.JO":"Jordan","Countries.KZ":"Kazakhstan","Countries.KE":"Kenya","Countries.KI":"Kiribati","Countries.KW":"Kuwait","Countries.KG":"Kyrgyzstan","Countries.LA":"Lao People\'s Democratic Republic","Countries.LV":"Latvia","Countries.LB":"Lebanon","Countries.LS":"Lesotho","Countries.LR":"Liberia","Countries.LY":"Libya","Countries.LI":"Liechtenstein","Countries.LT":"Lithuania","Countries.LU":"Luxembourg","Countries.MO":"Macao","Countries.MK":"Macedonia (the former Yugoslav Republic of)","Countries.MG":"Madagascar","Countries.MW":"Malawi","Countries.MY":"Malaysia","Countries.MV":"Maldives","Countries.ML":"Mali","Countries.MT":"Malta","Countries.MH":"Marshall Islands","Countries.MQ":"Martinique","Countries.MR":"Mauritania","Countries.MU":"Mauritius","Countries.YT":"Mayotte","Countries.MX":"Mexico","Countries.FM":"Micronesia (Federated States of)","Countries.MD":"Moldova (Republic of)","Countries.MC":"Monaco","Countries.MN":"Mongolia","Countries.ME":"Montenegro","Countries.MS":"Montserrat","Countries.MA":"Morocco","Countries.MZ":"Mozambique","Countries.MM":"Myanmar","Countries.NA":"Namibia","Countries.NR":"Nauru","Countries.NP":"Nepal","Countries.NL":"Netherlands","Countries.NC":"New Caledonia","Countries.NZ":"New Zealand","Countries.NI":"Nicaragua","Countries.NE":"Niger","Countries.NG":"Nigeria","Countries.NU":"Niue","Countries.NF":"Norfolk Island","Countries.KP":"Korea (Democratic People\'s Republic of)","Countries.MP":"Northern Mariana Islands","Countries.NO":"Norway","Countries.OM":"Oman","Countries.PK":"Pakistan","Countries.PW":"Palau","Countries.PS":"Palestine, State of","Countries.PA":"Panama","Countries.PG":"Papua New Guinea","Countries.PY":"Paraguay","Countries.PE":"Peru","Countries.PH":"Philippines","Countries.PN":"Pitcairn","Countries.PL":"Poland","Countries.PT":"Portugal","Countries.PR":"Puerto Rico","Countries.QA":"Qatar","Countries.XK":"Republic of Kosovo","Countries.RE":"R\xe9union","Countries.RO":"Romania","Countries.RU":"Russian Federation","Countries.RW":"Rwanda","Countries.BL":"Saint Barth\xe9lemy","Countries.SH":"Saint Helena, Ascension and Tristan da Cunha","Countries.KN":"Saint Kitts and Nevis","Countries.LC":"Saint Lucia","Countries.MF":"Saint Martin (French part)","Countries.PM":"Saint Pierre and Miquelon","Countries.VC":"Saint Vincent and the Grenadines","Countries.WS":"Samoa","Countries.SM":"San Marino","Countries.ST":"Sao Tome and Principe","Countries.SA":"Saudi Arabia","Countries.SN":"Senegal","Countries.RS":"Serbia","Countries.SC":"Seychelles","Countries.SL":"Sierra Leone","Countries.SG":"Singapore","Countries.SX":"Sint Maarten (Dutch part)","Countries.SK":"Slovakia","Countries.SI":"Slovenia","Countries.SB":"Solomon Islands","Countries.SO":"Somalia","Countries.ZA":"South Africa","Countries.GS":"South Georgia and the South Sandwich Islands","Countries.KR":"Korea (Republic of)","Countries.SS":"South Sudan","Countries.ES":"Spain","Countries.LK":"Sri Lanka","Countries.SD":"Sudan","Countries.SR":"Suriname","Countries.SJ":"Svalbard and Jan Mayen","Countries.SZ":"Swaziland","Countries.SE":"Sweden","Countries.CH":"Switzerland","Countries.SY":"Syrian Arab Republic","Countries.TW":"Taiwan","Countries.TJ":"Tajikistan","Countries.TZ":"Tanzania, United Republic of","Countries.TH":"Thailand","Countries.TL":"Timor-Leste","Countries.TG":"Togo","Countries.TK":"Tokelau","Countries.TO":"Tonga","Countries.TT":"Trinidad and Tobago","Countries.TN":"Tunisia","Countries.TR":"Turkey","Countries.TM":"Turkmenistan","Countries.TC":"Turks and Caicos Islands","Countries.TV":"Tuvalu","Countries.UG":"Uganda","Countries.UA":"Ukraine","Countries.AE":"United Arab Emirates","Countries.GB":"United Kingdom of Great Britain and Northern Ireland","Countries.US":"United States of America","Countries.UY":"Uruguay","Countries.UZ":"Uzbekistan","Countries.VU":"Vanuatu","Countries.VE":"Venezuela (Bolivarian Republic of)","Countries.VN":"Viet Nam","Countries.WF":"Wallis and Futuna","Countries.EH":"Western Sahara","Countries.YE":"Yemen","Countries.ZM":"Zambia","Countries.ZW":"Zimbabwe","ContactDetails.phone_option_placeholder":"Phone call","ContactDetails.sms_option_placeholder":"SMS","ContactDetails.email_option_placeholder":"Email","Consent.SeeFullVersionLink":"Full version","ContactDetails.PostalCode":"Postal code","ContactDetails.PostalCodePlaceholder":"Your postal code","Error.NotValidPostalCode":"Please enter a valid postal code"}');


/*
1. get language by locale (en-US.json)
2. if fail, extract first part of locale (en.json)
3. get language by language (en.json)
*/ async function $41cd20df18931d30$var$getLanguage(locale) {
    return fetch(`/locale/${locale}.json`).then((response)=>response.json()).catch((error)=>{
        throw error;
    });
}
/*
1. load prescreener
2. figure out the system language to use based on locale [94]
3. fetch system language from s3 (en-US.json, not en-US.213xzvb.js) [95]
3b. cache issues??
4. fetch languages from API, overlay the system languages from S3 [96]
*/ /**
 * Returns [loading, messages]
 */ function $41cd20df18931d30$var$useMessages(locale, customMessages) {
    const [messages, setMessages] = (0, $cQNHH.useState)(null);
    const [error, setError] = (0, $cQNHH.useState)(null);
    (0, $cQNHH.useEffect)(()=>{
        if (messages !== null) setMessages(null);
        try {
            $41cd20df18931d30$var$getLanguage(locale).then((translations)=>setMessages((0, (/*@__PURE__*/$parcel$interopDefault($1rrDX)))({}, translations, customMessages))).catch(()=>setMessages(customMessages));
            setError(null);
        } catch (err) {
            setError({
                errorCode: "locale",
                error: `Locale ${locale} not supported`
            });
        }
    }, [
        locale,
        customMessages
    ]);
    return {
        msg: messages,
        msgLoading: messages === null,
        msgErrorCode: error ? error.errorCode : false,
        msgError: error
    };
}
var $41cd20df18931d30$export$2e2bcd8739ae039 = $41cd20df18931d30$var$useMessages;



var $jge0r = parcelRequire("jge0r");

var $lCfIL = parcelRequire("lCfIL");
const $5ccd9f6f5dcc94a5$var$useStyles = (0, $7b1Lp.default)({
    root: {
        "& *": {
            boxSizing: "border-box",
            "-webkit-overflow-scrolling": "touch",
            "-webkit-text-size-adjust": "none",
            "-ms-text-size-adjust": "none",
            "text-size-adjust": "none"
        },
        height: "100%",
        width: "100%",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        zIndex: 1,
        position: "fixed",
        top: 0,
        right: 0,
        bottom: 0,
        left: 0,
        "@media print": {
            display: "block",
            position: "absolute",
            height: "auto",
            bottom: "auto"
        },
        "&:before": {
            content: '""',
            display: "block",
            position: "fixed",
            top: 0,
            right: 0,
            bottom: 0,
            left: 0,
            backgroundColor: "#1C1C1C",
            opacity: 0.42,
            zIndex: 0,
            "@media print": {
                display: "none"
            }
        }
    }
});
function $5ccd9f6f5dcc94a5$var$setDocumentTitle(msg) {
    if (msg) document.title = msg["NavigationProgress.SignUp"];
}
function $5ccd9f6f5dcc94a5$var$App(props) {
    const { loading: loading, errorCode: errorCode, sessionInfo: sessionInfo, sessionToken: sessionToken, config: config, onClose: onClose } = props;
    const { locale: locale, language: language, messages: messages, steps: steps, studyId: studyId } = config;
    (0, $cQNHH.useEffect)(()=>{
        (0, $jge0r.userMetrics).register({
            studyId: studyId,
            locale: locale
        });
        (0, $jge0r.userMetrics).track("Prescreener opened");
    }, []);
    const [api, apiErrorCode] = (0, $lCfIL.useAPI)(config, sessionToken);
    const { msg: msg, msgLoading: msgLoading, msgErrorCode: msgErrorCode } = (0, $41cd20df18931d30$export$2e2bcd8739ae039)(locale, messages);
    const classes = $5ccd9f6f5dcc94a5$var$useStyles();
    if (!apiErrorCode && !errorCode && !msgErrorCode && (loading || msgLoading)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("div", {
        className: classes.root
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement((0, $8mLXY.default), null));
    $5ccd9f6f5dcc94a5$var$setDocumentTitle(msg);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement((0, $IPPAR.default), {
        locale: language === null || language === void 0 ? void 0 : language.substring(0, 3),
        messages: msg
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement((0, $hgf0k.GlobalStateProvider), {
        initialKeys: steps
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement((0, $aeuny.CloseConfirmationProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("div", {
        className: classes.root
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement((0, $8be7ad1126c1e5b2$export$2e2bcd8739ae039), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement((0, $fe5ad4779f0e9155$export$2e2bcd8739ae039), {
        ...props,
        api: api,
        errorCode: apiErrorCode || errorCode || msgErrorCode,
        handleModalClose: ()=>onClose(props),
        sessionInfo: sessionInfo
    }))))));
}
$5ccd9f6f5dcc94a5$var$App.defaultProps = {
    errorCode: undefined,
    sessionInfo: undefined,
    sessionToken: undefined
};
var $5ccd9f6f5dcc94a5$export$2e2bcd8739ae039 = $5ccd9f6f5dcc94a5$var$App;
function $5ccd9f6f5dcc94a5$export$a996741116394418({ config: { locale: locale, language: language, messages: messages }, onClose: onClose }) {
    const { msg: msg } = (0, $41cd20df18931d30$export$2e2bcd8739ae039)(locale, messages);
    const classes = $5ccd9f6f5dcc94a5$var$useStyles();
    const messagesWithFallback = {
        "Modal.UnknownError": "An unknown error occurred",
        "Error.PleaseTryAgain": "Please try again later",
        "Error.CloseModal": "Close",
        ...msg
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement((0, $IPPAR.default), {
        locale: language,
        messages: messagesWithFallback
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("div", {
        className: classes.root
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement((0, $fe5ad4779f0e9155$export$23ec8986ee72eea6), {
        handleModalClose: ()=>onClose()
    })));
}



var $lCfIL = parcelRequire("lCfIL");
(0, (/*@__PURE__*/$parcel$interopDefault($649299cff7f987fa$exports))).polyfill();
// Used for verifying the parent API window origin.
let $263fb9b3900bc812$var$currentOrigin;
// Default config for self-assessment
const $263fb9b3900bc812$var$DEFAULT_CONFIG = {
    baseURI: new URL("/api/osa", window.location).href,
    locale: "en_US",
    steps: [
        "questionnaire",
        "clinicForm",
        "contactDetails",
        "completed"
    ]
};
const $263fb9b3900bc812$var$RTL_LANGUAGES = [
    "he",
    "ar",
    "dv",
    "fa",
    "ha",
    "ks",
    "ku",
    "ps",
    "ur",
    "yi"
];
// Used to send messages to the parent API. Remember to NEVER send sensitive data back as callbacks.
const $263fb9b3900bc812$var$postMessage = (type, options)=>{
    window.parent.postMessage(JSON.stringify({
        type: type,
        options: options
    }), $263fb9b3900bc812$var$currentOrigin);
};
const $263fb9b3900bc812$var$getRootElement = ()=>document.getElementById("root");
const $263fb9b3900bc812$var$onClose = (redirectUrl)=>{
    $263fb9b3900bc812$var$postMessage("close", {
        redirectUrl: redirectUrl
    });
    $263fb9b3900bc812$var$currentOrigin = undefined;
    (0, (/*@__PURE__*/$parcel$interopDefault($dLwnG))).unmountComponentAtNode($263fb9b3900bc812$var$getRootElement());
};
// Renders the self-assessment with the specified config.
const $263fb9b3900bc812$var$render = ({ config: config, loading: loading, errorCode: errorCode, sessionInfo: sessionInfo, sessionToken: sessionToken })=>{
    (0, (/*@__PURE__*/$parcel$interopDefault($dLwnG))).render(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement((0, $2bb9b1e646170ca5$export$2e2bcd8739ae039), {
        theme: (0, $03fa2a80882ee47c$export$2e2bcd8739ae039)(config)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement((0, $5dlN6.ErrorBoundary), {
        FallbackComponent: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement((0, $5ccd9f6f5dcc94a5$export$a996741116394418), {
                config: config,
                onClose: ()=>$263fb9b3900bc812$var$onClose(),
                root: $263fb9b3900bc812$var$getRootElement()
            })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement((0, $5ccd9f6f5dcc94a5$export$2e2bcd8739ae039), {
        config: config,
        errorCode: errorCode,
        loading: loading,
        onAction: (action, metrics)=>{
            $263fb9b3900bc812$var$postMessage("action", {
                action: action,
                values: metrics
            });
        },
        onClose: (redirectUrl)=>$263fb9b3900bc812$var$onClose(redirectUrl),
        sessionInfo: sessionInfo,
        sessionToken: sessionToken
    }))), $263fb9b3900bc812$var$getRootElement());
};
function $263fb9b3900bc812$var$buildConfig({ baseURI: baseURI = $263fb9b3900bc812$var$DEFAULT_CONFIG.baseURI, locale: locale = $263fb9b3900bc812$var$DEFAULT_CONFIG.locale, ...restConfig } = {}) {
    const localeMatch = locale.match(/^([a-z]{2,})[_-]([A-Z]{2,})$/);
    if (!localeMatch) return [
        {},
        "Invalid locale format"
    ];
    const language = localeMatch[1].toLowerCase();
    const country = localeMatch[2].toLowerCase();
    const textDirection = $263fb9b3900bc812$var$RTL_LANGUAGES.includes(language) ? "rtl" : undefined;
    const uriMatch = baseURI.match(/^(https?:\/\/.+?)\/?$/);
    if (!uriMatch) return [
        {},
        "Invalid base URI format"
    ];
    return [
        {
            baseURI: `${uriMatch[1]}`,
            locale: locale,
            language: language,
            country: country,
            textDirection: textDirection,
            ...restConfig
        }
    ];
}
// All functions of the public API.
// Remember to add new functions to the functions array in `api.js`.
// All functions need to follow the signature of `f(callbackId, options)` and they need to post a message
// with either `error` or `done` together with the `callbackId`.
const $263fb9b3900bc812$var$api = {
    /**
   * Opens the self-assessment.
   *
   * @param {Object} config - The configuration to use when opening the self-assessment.
   * @param {string} config.locale - The locale code (`en_US`, `sv_SE`, ...).
   * @param {string} config.language - The ISO 639-1 language code (`en`, `sv`, ...).
   * @param {string} config.country - The country code (`us`, `se`, ...).
   * @param {string} config.studyId - The Trialbee Study ID.
   * @param {string} config.referrer - The URL that the candidate was referred from.
   * @param {string} config.referrerToken - The token as an open string eg: `Trialbee`.
   * @param {string} config.welcomeImage - The banner image to show on the introduction page.
   * @param {string} [config.baseURI] - The base URI for API calls.
   * @param {string} [config.googleApiKey] - A Google API key used for accessing the Google Maps API.
   * @param {string} [config.colorMain] - The theme color to use. Defaults to Trialbee blue.
   * @param {string} [config.colorLight] - The light theme color to use. Defaults to lightenand desaturated `colorMain`.
   * @param {string} [config.fontFamily] - The font to use.
   * @param {string} [config.fontInclude] - An url to CSS with `font-face` to be included.
   */ open (callbackId, partialConfig) {
        if ((0, $134249fea87571b9$export$a587e606f93a3767)(window.navigator.userAgent)) {
            const el = (0, $134249fea87571b9$export$f357a97864275ebe)(()=>{
                $263fb9b3900bc812$var$postMessage("close");
            });
            $263fb9b3900bc812$var$getRootElement().appendChild(el);
            $263fb9b3900bc812$var$postMessage("open");
            return undefined;
        }
        const sendError = (message)=>{
            $263fb9b3900bc812$var$postMessage("error", {
                fatal: true,
                message: message,
                callbackId: callbackId
            });
            $263fb9b3900bc812$var$currentOrigin = null;
        };
        const [config, error] = $263fb9b3900bc812$var$buildConfig(partialConfig);
        if (error) return sendError(error);
        (0, $5dlN6.startBugSnag)(config);
        $263fb9b3900bc812$var$render({
            config: config,
            loading: true
        });
        $263fb9b3900bc812$var$postMessage("open");
        return (0, $lCfIL.initSession)(config).then(([sessionInfo, sessionToken])=>{
            const merged = (0, $0ed8d10c3555ce9e$export$2e2bcd8739ae039)($263fb9b3900bc812$var$DEFAULT_CONFIG, sessionInfo.config, {
                textDirection: sessionInfo.textDirection
            }, config);
            // Apply custom fonts style
            if (merged.fontInclude) {
                const link = document.createElement("link");
                link.rel = "stylesheet";
                link.href = merged.fontInclude;
                document.head.appendChild(link);
            }
            document.body.setAttribute("dir", merged.textDirection);
            document.documentElement.setAttribute("lang", merged.language);
            return $263fb9b3900bc812$var$render({
                sessionInfo: sessionInfo,
                sessionToken: sessionToken,
                config: merged
            });
        }).catch((errorCode)=>{
            const errorConfig = (0, $0ed8d10c3555ce9e$export$2e2bcd8739ae039)($263fb9b3900bc812$var$DEFAULT_CONFIG, config);
            $263fb9b3900bc812$var$render({
                config: errorConfig,
                errorCode: errorCode
            });
        }).finally(()=>$263fb9b3900bc812$var$postMessage("done", {
                callbackId: callbackId
            }));
    },
    getHeight (callbackId) {
        try {
            const content = document.getElementsByName("tb-sa-content")[0];
            content.style.display = "block";
            content.style.overflow = "scroll";
            $263fb9b3900bc812$var$postMessage("setHeight", {
                scrollHeight: content.scrollHeight,
                callbackId: callbackId
            });
            content.style.overflow = null;
            content.style.display = null;
        } catch (err) {
            $263fb9b3900bc812$var$postMessage("error", {
                message: `${err}`,
                callbackId: callbackId
            });
        }
    }
};
// Listens for messages from the parent API.
window.addEventListener("message", (e)=>{
    if (typeof e.data !== "string") return;
    if ($263fb9b3900bc812$var$currentOrigin && e.origin !== $263fb9b3900bc812$var$currentOrigin) return;
    try {
        const { f: f, callbackId: callbackId, options: options } = JSON.parse(e.data);
        if (f === "open") {
            // The dialog must already be opened so we ignore this event.
            if ($263fb9b3900bc812$var$currentOrigin) return;
            // We set the current origin here to verify the top level API later for callbacks and such.
            $263fb9b3900bc812$var$currentOrigin = e.origin;
        }
        $263fb9b3900bc812$var$api[f](callbackId, options);
    } catch (err) {
    // We don't really care about this error since it probably means some sort of attack is going on.
    }
});


//# sourceMappingURL=selfAssessment.3a131184.js.map
